function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e11) { throw _e11; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e12) { didErr = true; err = _e12; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import Vue from 'vue';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var Reflect$1;

(function (Reflect) {
  // Metadata Proposal
  // https://rbuckton.github.io/reflect-metadata/
  (function (factory) {
    var root = _typeof(commonjsGlobal) === "object" ? commonjsGlobal : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : _typeof(this) === "object" ? this : Function("return this;")();
    var exporter = makeExporter(Reflect);

    if (typeof root.Reflect === "undefined") {
      root.Reflect = Reflect;
    } else {
      exporter = makeExporter(root.Reflect, exporter);
    }

    factory(exporter);

    function makeExporter(target, previous) {
      return function (key, value) {
        if (typeof target[key] !== "function") {
          Object.defineProperty(target, key, {
            configurable: true,
            writable: true,
            value: value
          });
        }

        if (previous) previous(key, value);
      };
    }
  })(function (exporter) {
    var hasOwn = Object.prototype.hasOwnProperty; // feature test for Symbol support

    var supportsSymbol = typeof Symbol === "function";
    var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
    var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
    var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support

    var supportsProto = {
      __proto__: []
    } instanceof Array; // feature test for __proto__ support

    var downLevel = !supportsCreate && !supportsProto;
    var HashMap = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: supportsCreate ? function () {
        return MakeDictionary(Object.create(null));
      } : supportsProto ? function () {
        return MakeDictionary({
          __proto__: null
        });
      } : function () {
        return MakeDictionary({});
      },
      has: downLevel ? function (map, key) {
        return hasOwn.call(map, key);
      } : function (map, key) {
        return key in map;
      },
      get: downLevel ? function (map, key) {
        return hasOwn.call(map, key) ? map[key] : undefined;
      } : function (map, key) {
        return map[key];
      }
    }; // Load global or shim versions of Map, Set, and WeakMap

    var functionPrototype = Object.getPrototypeOf(Function);
    var usePolyfill = (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";

    var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();

    var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();

    var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill(); // [[Metadata]] internal slot
    // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots


    var Metadata = new _WeakMap();
    /**
     * Applies a set of decorators to a property of a target object.
     * @param decorators An array of decorators.
     * @param target The target object.
     * @param propertyKey (Optional) The property key to decorate.
     * @param attributes (Optional) The property descriptor for the target key.
     * @remarks Decorators are applied in reverse order.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     Example = Reflect.decorate(decoratorsArray, Example);
     *
     *     // property (on constructor)
     *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
     *
     *     // property (on prototype)
     *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
     *
     *     // method (on constructor)
     *     Object.defineProperty(Example, "staticMethod",
     *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
     *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
     *
     *     // method (on prototype)
     *     Object.defineProperty(Example.prototype, "method",
     *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
     *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
     *
     */

    function decorate(decorators, target, propertyKey, attributes) {
      if (!IsUndefined(propertyKey)) {
        if (!IsArray(decorators)) throw new TypeError();
        if (!IsObject(target)) throw new TypeError();
        if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
        if (IsNull(attributes)) attributes = undefined;
        propertyKey = ToPropertyKey(propertyKey);
        return DecorateProperty(decorators, target, propertyKey, attributes);
      } else {
        if (!IsArray(decorators)) throw new TypeError();
        if (!IsConstructor(target)) throw new TypeError();
        return DecorateConstructor(decorators, target);
      }
    }

    exporter("decorate", decorate); // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
    // https://rbuckton.github.io/reflect-metadata/#reflect.metadata

    /**
     * A default metadata decorator factory that can be used on a class, class member, or parameter.
     * @param metadataKey The key for the metadata entry.
     * @param metadataValue The value for the metadata entry.
     * @returns A decorator function.
     * @remarks
     * If `metadataKey` is already defined for the target and target key, the
     * metadataValue for that key will be overwritten.
     * @example
     *
     *     // constructor
     *     @Reflect.metadata(key, value)
     *     class Example {
     *     }
     *
     *     // property (on constructor, TypeScript only)
     *     class Example {
     *         @Reflect.metadata(key, value)
     *         static staticProperty;
     *     }
     *
     *     // property (on prototype, TypeScript only)
     *     class Example {
     *         @Reflect.metadata(key, value)
     *         property;
     *     }
     *
     *     // method (on constructor)
     *     class Example {
     *         @Reflect.metadata(key, value)
     *         static staticMethod() { }
     *     }
     *
     *     // method (on prototype)
     *     class Example {
     *         @Reflect.metadata(key, value)
     *         method() { }
     *     }
     *
     */

    function metadata(metadataKey, metadataValue) {
      function decorator(target, propertyKey) {
        if (!IsObject(target)) throw new TypeError();
        if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
        OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
      }

      return decorator;
    }

    exporter("metadata", metadata);
    /**
     * Define a unique metadata entry on the target.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param metadataValue A value that contains attached metadata.
     * @param target The target object on which to define metadata.
     * @param propertyKey (Optional) The property key for the target.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     Reflect.defineMetadata("custom:annotation", options, Example);
     *
     *     // property (on constructor)
     *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
     *
     *     // property (on prototype)
     *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
     *
     *     // method (on constructor)
     *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
     *
     *     // method (on prototype)
     *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
     *
     *     // decorator factory as metadata-producing annotation.
     *     function MyAnnotation(options): Decorator {
     *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
     *     }
     *
     */

    function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
    }

    exporter("defineMetadata", defineMetadata);
    /**
     * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.hasMetadata("custom:annotation", Example);
     *
     *     // property (on constructor)
     *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
     *
     */

    function hasMetadata(metadataKey, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryHasMetadata(metadataKey, target, propertyKey);
    }

    exporter("hasMetadata", hasMetadata);
    /**
     * Gets a value indicating whether the target object has the provided metadata key defined.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
     *
     *     // property (on constructor)
     *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
     *
     */

    function hasOwnMetadata(metadataKey, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
    }

    exporter("hasOwnMetadata", hasOwnMetadata);
    /**
     * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.getMetadata("custom:annotation", Example);
     *
     *     // property (on constructor)
     *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
     *
     */

    function getMetadata(metadataKey, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryGetMetadata(metadataKey, target, propertyKey);
    }

    exporter("getMetadata", getMetadata);
    /**
     * Gets the metadata value for the provided metadata key on the target object.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.getOwnMetadata("custom:annotation", Example);
     *
     *     // property (on constructor)
     *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
     *
     */

    function getOwnMetadata(metadataKey, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
    }

    exporter("getOwnMetadata", getOwnMetadata);
    /**
     * Gets the metadata keys defined on the target object or its prototype chain.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns An array of unique metadata keys.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.getMetadataKeys(Example);
     *
     *     // property (on constructor)
     *     result = Reflect.getMetadataKeys(Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.getMetadataKeys(Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.getMetadataKeys(Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.getMetadataKeys(Example.prototype, "method");
     *
     */

    function getMetadataKeys(target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryMetadataKeys(target, propertyKey);
    }

    exporter("getMetadataKeys", getMetadataKeys);
    /**
     * Gets the unique metadata keys defined on the target object.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns An array of unique metadata keys.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.getOwnMetadataKeys(Example);
     *
     *     // property (on constructor)
     *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
     *
     */

    function getOwnMetadataKeys(target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      return OrdinaryOwnMetadataKeys(target, propertyKey);
    }

    exporter("getOwnMetadataKeys", getOwnMetadataKeys);
    /**
     * Deletes the metadata entry from the target object with the provided key.
     * @param metadataKey A key used to store and retrieve metadata.
     * @param target The target object on which the metadata is defined.
     * @param propertyKey (Optional) The property key for the target.
     * @returns `true` if the metadata entry was found and deleted; otherwise, false.
     * @example
     *
     *     class Example {
     *         // property declarations are not part of ES6, though they are valid in TypeScript:
     *         // static staticProperty;
     *         // property;
     *
     *         constructor(p) { }
     *         static staticMethod(p) { }
     *         method(p) { }
     *     }
     *
     *     // constructor
     *     result = Reflect.deleteMetadata("custom:annotation", Example);
     *
     *     // property (on constructor)
     *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
     *
     *     // property (on prototype)
     *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
     *
     *     // method (on constructor)
     *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
     *
     *     // method (on prototype)
     *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
     *
     */

    function deleteMetadata(metadataKey, target, propertyKey) {
      if (!IsObject(target)) throw new TypeError();
      if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
      var metadataMap = GetOrCreateMetadataMap(target, propertyKey,
      /*Create*/
      false);
      if (IsUndefined(metadataMap)) return false;
      if (!metadataMap["delete"](metadataKey)) return false;
      if (metadataMap.size > 0) return true;
      var targetMetadata = Metadata.get(target);
      targetMetadata["delete"](propertyKey);
      if (targetMetadata.size > 0) return true;
      Metadata["delete"](target);
      return true;
    }

    exporter("deleteMetadata", deleteMetadata);

    function DecorateConstructor(decorators, target) {
      for (var i = decorators.length - 1; i >= 0; --i) {
        var decorator = decorators[i];
        var decorated = decorator(target);

        if (!IsUndefined(decorated) && !IsNull(decorated)) {
          if (!IsConstructor(decorated)) throw new TypeError();
          target = decorated;
        }
      }

      return target;
    }

    function DecorateProperty(decorators, target, propertyKey, descriptor) {
      for (var i = decorators.length - 1; i >= 0; --i) {
        var decorator = decorators[i];
        var decorated = decorator(target, propertyKey, descriptor);

        if (!IsUndefined(decorated) && !IsNull(decorated)) {
          if (!IsObject(decorated)) throw new TypeError();
          descriptor = decorated;
        }
      }

      return descriptor;
    }

    function GetOrCreateMetadataMap(O, P, Create) {
      var targetMetadata = Metadata.get(O);

      if (IsUndefined(targetMetadata)) {
        if (!Create) return undefined;
        targetMetadata = new _Map();
        Metadata.set(O, targetMetadata);
      }

      var metadataMap = targetMetadata.get(P);

      if (IsUndefined(metadataMap)) {
        if (!Create) return undefined;
        metadataMap = new _Map();
        targetMetadata.set(P, metadataMap);
      }

      return metadataMap;
    } // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata


    function OrdinaryHasMetadata(MetadataKey, O, P) {
      var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
      if (hasOwn) return true;
      var parent = OrdinaryGetPrototypeOf(O);
      if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
      return false;
    } // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata


    function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
      var metadataMap = GetOrCreateMetadataMap(O, P,
      /*Create*/
      false);
      if (IsUndefined(metadataMap)) return false;
      return ToBoolean(metadataMap.has(MetadataKey));
    } // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata


    function OrdinaryGetMetadata(MetadataKey, O, P) {
      var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
      if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
      var parent = OrdinaryGetPrototypeOf(O);
      if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
      return undefined;
    } // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata


    function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
      var metadataMap = GetOrCreateMetadataMap(O, P,
      /*Create*/
      false);
      if (IsUndefined(metadataMap)) return undefined;
      return metadataMap.get(MetadataKey);
    } // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata


    function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
      var metadataMap = GetOrCreateMetadataMap(O, P,
      /*Create*/
      true);
      metadataMap.set(MetadataKey, MetadataValue);
    } // 3.1.6.1 OrdinaryMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys


    function OrdinaryMetadataKeys(O, P) {
      var ownKeys = OrdinaryOwnMetadataKeys(O, P);
      var parent = OrdinaryGetPrototypeOf(O);
      if (parent === null) return ownKeys;
      var parentKeys = OrdinaryMetadataKeys(parent, P);
      if (parentKeys.length <= 0) return ownKeys;
      if (ownKeys.length <= 0) return parentKeys;
      var set = new _Set();
      var keys = [];

      for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
        var key = ownKeys_1[_i];
        var hasKey = set.has(key);

        if (!hasKey) {
          set.add(key);
          keys.push(key);
        }
      }

      for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
        var key = parentKeys_1[_a];
        var hasKey = set.has(key);

        if (!hasKey) {
          set.add(key);
          keys.push(key);
        }
      }

      return keys;
    } // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys


    function OrdinaryOwnMetadataKeys(O, P) {
      var keys = [];
      var metadataMap = GetOrCreateMetadataMap(O, P,
      /*Create*/
      false);
      if (IsUndefined(metadataMap)) return keys;
      var keysObj = metadataMap.keys();
      var iterator = GetIterator(keysObj);
      var k = 0;

      while (true) {
        var next = IteratorStep(iterator);

        if (!next) {
          keys.length = k;
          return keys;
        }

        var nextValue = IteratorValue(next);

        try {
          keys[k] = nextValue;
        } catch (e) {
          try {
            IteratorClose(iterator);
          } finally {
            throw e;
          }
        }

        k++;
      }
    } // 6 ECMAScript Data Typ0es and Values
    // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values


    function Type(x) {
      if (x === null) return 1
      /* Null */
      ;

      switch (_typeof(x)) {
        case "undefined":
          return 0
          /* Undefined */
          ;

        case "boolean":
          return 2
          /* Boolean */
          ;

        case "string":
          return 3
          /* String */
          ;

        case "symbol":
          return 4
          /* Symbol */
          ;

        case "number":
          return 5
          /* Number */
          ;

        case "object":
          return x === null ? 1
          /* Null */
          : 6
          /* Object */
          ;

        default:
          return 6
          /* Object */
          ;
      }
    } // 6.1.1 The Undefined Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type


    function IsUndefined(x) {
      return x === undefined;
    } // 6.1.2 The Null Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type


    function IsNull(x) {
      return x === null;
    } // 6.1.5 The Symbol Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type


    function IsSymbol(x) {
      return _typeof(x) === "symbol";
    } // 6.1.7 The Object Type
    // https://tc39.github.io/ecma262/#sec-object-type


    function IsObject(x) {
      return _typeof(x) === "object" ? x !== null : typeof x === "function";
    } // 7.1 Type Conversion
    // https://tc39.github.io/ecma262/#sec-type-conversion
    // 7.1.1 ToPrimitive(input [, PreferredType])
    // https://tc39.github.io/ecma262/#sec-toprimitive


    function ToPrimitive(input, PreferredType) {
      switch (Type(input)) {
        case 0
        /* Undefined */
        :
          return input;

        case 1
        /* Null */
        :
          return input;

        case 2
        /* Boolean */
        :
          return input;

        case 3
        /* String */
        :
          return input;

        case 4
        /* Symbol */
        :
          return input;

        case 5
        /* Number */
        :
          return input;
      }

      var hint = PreferredType === 3
      /* String */
      ? "string" : PreferredType === 5
      /* Number */
      ? "number" : "default";
      var exoticToPrim = GetMethod(input, toPrimitiveSymbol);

      if (exoticToPrim !== undefined) {
        var result = exoticToPrim.call(input, hint);
        if (IsObject(result)) throw new TypeError();
        return result;
      }

      return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
    } // 7.1.1.1 OrdinaryToPrimitive(O, hint)
    // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive


    function OrdinaryToPrimitive(O, hint) {
      if (hint === "string") {
        var toString_1 = O.toString;

        if (IsCallable(toString_1)) {
          var result = toString_1.call(O);
          if (!IsObject(result)) return result;
        }

        var valueOf = O.valueOf;

        if (IsCallable(valueOf)) {
          var result = valueOf.call(O);
          if (!IsObject(result)) return result;
        }
      } else {
        var valueOf = O.valueOf;

        if (IsCallable(valueOf)) {
          var result = valueOf.call(O);
          if (!IsObject(result)) return result;
        }

        var toString_2 = O.toString;

        if (IsCallable(toString_2)) {
          var result = toString_2.call(O);
          if (!IsObject(result)) return result;
        }
      }

      throw new TypeError();
    } // 7.1.2 ToBoolean(argument)
    // https://tc39.github.io/ecma262/2016/#sec-toboolean


    function ToBoolean(argument) {
      return !!argument;
    } // 7.1.12 ToString(argument)
    // https://tc39.github.io/ecma262/#sec-tostring


    function ToString(argument) {
      return "" + argument;
    } // 7.1.14 ToPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-topropertykey


    function ToPropertyKey(argument) {
      var key = ToPrimitive(argument, 3
      /* String */
      );
      if (IsSymbol(key)) return key;
      return ToString(key);
    } // 7.2 Testing and Comparison Operations
    // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
    // 7.2.2 IsArray(argument)
    // https://tc39.github.io/ecma262/#sec-isarray


    function IsArray(argument) {
      return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
    } // 7.2.3 IsCallable(argument)
    // https://tc39.github.io/ecma262/#sec-iscallable


    function IsCallable(argument) {
      // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
      return typeof argument === "function";
    } // 7.2.4 IsConstructor(argument)
    // https://tc39.github.io/ecma262/#sec-isconstructor


    function IsConstructor(argument) {
      // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
      return typeof argument === "function";
    } // 7.2.7 IsPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-ispropertykey


    function IsPropertyKey(argument) {
      switch (Type(argument)) {
        case 3
        /* String */
        :
          return true;

        case 4
        /* Symbol */
        :
          return true;

        default:
          return false;
      }
    } // 7.3 Operations on Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-objects
    // 7.3.9 GetMethod(V, P)
    // https://tc39.github.io/ecma262/#sec-getmethod


    function GetMethod(V, P) {
      var func = V[P];
      if (func === undefined || func === null) return undefined;
      if (!IsCallable(func)) throw new TypeError();
      return func;
    } // 7.4 Operations on Iterator Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects


    function GetIterator(obj) {
      var method = GetMethod(obj, iteratorSymbol);
      if (!IsCallable(method)) throw new TypeError(); // from Call

      var iterator = method.call(obj);
      if (!IsObject(iterator)) throw new TypeError();
      return iterator;
    } // 7.4.4 IteratorValue(iterResult)
    // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue


    function IteratorValue(iterResult) {
      return iterResult.value;
    } // 7.4.5 IteratorStep(iterator)
    // https://tc39.github.io/ecma262/#sec-iteratorstep


    function IteratorStep(iterator) {
      var result = iterator.next();
      return result.done ? false : result;
    } // 7.4.6 IteratorClose(iterator, completion)
    // https://tc39.github.io/ecma262/#sec-iteratorclose


    function IteratorClose(iterator) {
      var f = iterator["return"];
      if (f) f.call(iterator);
    } // 9.1 Ordinary Object Internal Methods and Internal Slots
    // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
    // 9.1.1.1 OrdinaryGetPrototypeOf(O)
    // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof


    function OrdinaryGetPrototypeOf(O) {
      var proto = Object.getPrototypeOf(O);
      if (typeof O !== "function" || O === functionPrototype) return proto; // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
      // Try to determine the superclass constructor. Compatible implementations
      // must either set __proto__ on a subclass constructor to the superclass constructor,
      // or ensure each class has a valid `constructor` property on its prototype that
      // points back to the constructor.
      // If this is not the same as Function.[[Prototype]], then this is definately inherited.
      // This is the case when in ES6 or when using __proto__ in a compatible browser.

      if (proto !== functionPrototype) return proto; // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.

      var prototype = O.prototype;
      var prototypeProto = prototype && Object.getPrototypeOf(prototype);
      if (prototypeProto == null || prototypeProto === Object.prototype) return proto; // If the constructor was not a function, then we cannot determine the heritage.

      var constructor = prototypeProto.constructor;
      if (typeof constructor !== "function") return proto; // If we have some kind of self-reference, then we cannot determine the heritage.

      if (constructor === O) return proto; // we have a pretty good guess at the heritage.

      return constructor;
    } // naive Map shim


    function CreateMapPolyfill() {
      var cacheSentinel = {};
      var arraySentinel = [];

      var MapIterator = function () {
        function MapIterator(keys, values, selector) {
          this._index = 0;
          this._keys = keys;
          this._values = values;
          this._selector = selector;
        }

        MapIterator.prototype["@@iterator"] = function () {
          return this;
        };

        MapIterator.prototype[iteratorSymbol] = function () {
          return this;
        };

        MapIterator.prototype.next = function () {
          var index = this._index;

          if (index >= 0 && index < this._keys.length) {
            var result = this._selector(this._keys[index], this._values[index]);

            if (index + 1 >= this._keys.length) {
              this._index = -1;
              this._keys = arraySentinel;
              this._values = arraySentinel;
            } else {
              this._index++;
            }

            return {
              value: result,
              done: false
            };
          }

          return {
            value: undefined,
            done: true
          };
        };

        MapIterator.prototype["throw"] = function (error) {
          if (this._index >= 0) {
            this._index = -1;
            this._keys = arraySentinel;
            this._values = arraySentinel;
          }

          throw error;
        };

        MapIterator.prototype["return"] = function (value) {
          if (this._index >= 0) {
            this._index = -1;
            this._keys = arraySentinel;
            this._values = arraySentinel;
          }

          return {
            value: value,
            done: true
          };
        };

        return MapIterator;
      }();

      return function () {
        function Map() {
          this._keys = [];
          this._values = [];
          this._cacheKey = cacheSentinel;
          this._cacheIndex = -2;
        }

        Object.defineProperty(Map.prototype, "size", {
          get: function get() {
            return this._keys.length;
          },
          enumerable: true,
          configurable: true
        });

        Map.prototype.has = function (key) {
          return this._find(key,
          /*insert*/
          false) >= 0;
        };

        Map.prototype.get = function (key) {
          var index = this._find(key,
          /*insert*/
          false);

          return index >= 0 ? this._values[index] : undefined;
        };

        Map.prototype.set = function (key, value) {
          var index = this._find(key,
          /*insert*/
          true);

          this._values[index] = value;
          return this;
        };

        Map.prototype["delete"] = function (key) {
          var index = this._find(key,
          /*insert*/
          false);

          if (index >= 0) {
            var size = this._keys.length;

            for (var i = index + 1; i < size; i++) {
              this._keys[i - 1] = this._keys[i];
              this._values[i - 1] = this._values[i];
            }

            this._keys.length--;
            this._values.length--;

            if (key === this._cacheKey) {
              this._cacheKey = cacheSentinel;
              this._cacheIndex = -2;
            }

            return true;
          }

          return false;
        };

        Map.prototype.clear = function () {
          this._keys.length = 0;
          this._values.length = 0;
          this._cacheKey = cacheSentinel;
          this._cacheIndex = -2;
        };

        Map.prototype.keys = function () {
          return new MapIterator(this._keys, this._values, getKey);
        };

        Map.prototype.values = function () {
          return new MapIterator(this._keys, this._values, getValue);
        };

        Map.prototype.entries = function () {
          return new MapIterator(this._keys, this._values, getEntry);
        };

        Map.prototype["@@iterator"] = function () {
          return this.entries();
        };

        Map.prototype[iteratorSymbol] = function () {
          return this.entries();
        };

        Map.prototype._find = function (key, insert) {
          if (this._cacheKey !== key) {
            this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
          }

          if (this._cacheIndex < 0 && insert) {
            this._cacheIndex = this._keys.length;

            this._keys.push(key);

            this._values.push(undefined);
          }

          return this._cacheIndex;
        };

        return Map;
      }();

      function getKey(key, _) {
        return key;
      }

      function getValue(_, value) {
        return value;
      }

      function getEntry(key, value) {
        return [key, value];
      }
    } // naive Set shim


    function CreateSetPolyfill() {
      return function () {
        function Set() {
          this._map = new _Map();
        }

        Object.defineProperty(Set.prototype, "size", {
          get: function get() {
            return this._map.size;
          },
          enumerable: true,
          configurable: true
        });

        Set.prototype.has = function (value) {
          return this._map.has(value);
        };

        Set.prototype.add = function (value) {
          return this._map.set(value, value), this;
        };

        Set.prototype["delete"] = function (value) {
          return this._map["delete"](value);
        };

        Set.prototype.clear = function () {
          this._map.clear();
        };

        Set.prototype.keys = function () {
          return this._map.keys();
        };

        Set.prototype.values = function () {
          return this._map.values();
        };

        Set.prototype.entries = function () {
          return this._map.entries();
        };

        Set.prototype["@@iterator"] = function () {
          return this.keys();
        };

        Set.prototype[iteratorSymbol] = function () {
          return this.keys();
        };

        return Set;
      }();
    } // naive WeakMap shim


    function CreateWeakMapPolyfill() {
      var UUID_SIZE = 16;
      var keys = HashMap.create();
      var rootKey = CreateUniqueKey();
      return function () {
        function WeakMap() {
          this._key = CreateUniqueKey();
        }

        WeakMap.prototype.has = function (target) {
          var table = GetOrCreateWeakMapTable(target,
          /*create*/
          false);
          return table !== undefined ? HashMap.has(table, this._key) : false;
        };

        WeakMap.prototype.get = function (target) {
          var table = GetOrCreateWeakMapTable(target,
          /*create*/
          false);
          return table !== undefined ? HashMap.get(table, this._key) : undefined;
        };

        WeakMap.prototype.set = function (target, value) {
          var table = GetOrCreateWeakMapTable(target,
          /*create*/
          true);
          table[this._key] = value;
          return this;
        };

        WeakMap.prototype["delete"] = function (target) {
          var table = GetOrCreateWeakMapTable(target,
          /*create*/
          false);
          return table !== undefined ? delete table[this._key] : false;
        };

        WeakMap.prototype.clear = function () {
          // NOTE: not a real clear, just makes the previous data unreachable
          this._key = CreateUniqueKey();
        };

        return WeakMap;
      }();

      function CreateUniqueKey() {
        var key;

        do {
          key = "@@WeakMap@@" + CreateUUID();
        } while (HashMap.has(keys, key));

        keys[key] = true;
        return key;
      }

      function GetOrCreateWeakMapTable(target, create) {
        if (!hasOwn.call(target, rootKey)) {
          if (!create) return undefined;
          Object.defineProperty(target, rootKey, {
            value: HashMap.create()
          });
        }

        return target[rootKey];
      }

      function FillRandomBytes(buffer, size) {
        for (var i = 0; i < size; ++i) {
          buffer[i] = Math.random() * 0xff | 0;
        }

        return buffer;
      }

      function GenRandomBytes(size) {
        if (typeof Uint8Array === "function") {
          if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
          if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
          return FillRandomBytes(new Uint8Array(size), size);
        }

        return FillRandomBytes(new Array(size), size);
      }

      function CreateUUID() {
        var data = GenRandomBytes(UUID_SIZE); // mark as random - RFC 4122 § 4.4

        data[6] = data[6] & 0x4f | 0x40;
        data[8] = data[8] & 0xbf | 0x80;
        var result = "";

        for (var offset = 0; offset < UUID_SIZE; ++offset) {
          var _byte = data[offset];
          if (offset === 4 || offset === 6 || offset === 8) result += "-";
          if (_byte < 16) result += "0";
          result += _byte.toString(16).toLowerCase();
        }

        return result;
      }
    } // uses a heuristic used by v8 and chakra to force an object into dictionary mode.


    function MakeDictionary(obj) {
      obj.__ = undefined;
      delete obj.__;
      return obj;
    }
  });
})(Reflect$1 || (Reflect$1 = {}));

var script$E = Vue.extend({
  name: 'ParentRow',
  props: {
    instance: Object
  },
  computed: {
    shouldShowBadge: function shouldShowBadge() {
      return typeof this.instance.badge === 'number';
    }
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function __vue_render__$E() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-parent-row flex items-center justify-between cursor-pointer py-1 px-3 text-blue hover:text-black",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.instance.clicked(_vm.instance);
      }
    }
  }, [_c("span", {
    staticClass: "font-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.instance.label) + "\n\n    "), _vm.shouldShowBadge ? _c("span", {
    staticClass: "selected-badge"
  }, [_vm._v("\n      " + _vm._s(_vm.instance.badge) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c("fai", {
    attrs: {
      icon: ["fas", "chevron-right"]
    }
  })], 1);
};

var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;
/* style */

var __vue_inject_styles__$E = undefined;
/* scoped */

var __vue_scope_id__$E = undefined;
/* module identifier */

var __vue_module_identifier__$E = undefined;
/* functional template */

var __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

var script$D = Vue.extend({
  name: 'QueryRow',
  props: {
    instance: Object
  },
  methods: {
    updated: function updated(event) {
      var value = event.target.value;
      this.instance.value = value;
      this.instance.updated && this.instance.updated(value, this.instance);
    },
    clickedClear: function clickedClear() {
      this.instance.value = '';
      this.instance.cleared && this.instance.cleared(this.instance);
    }
  }
});
/* script */

var __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function __vue_render__$D() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-query-row py-1 px-3"
  }, [_c("input", {
    staticClass: "sb-input focus:transition-border w-full",
    attrs: {
      placeholder: "search"
    },
    domProps: {
      value: _vm.instance.value
    },
    on: {
      input: _vm.updated
    }
  }), _vm._v(" "), _vm.instance.clear && _vm.instance.value ? _c("div", {
    staticClass: " text-subtitle cursor-pointer",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedClear.apply(null, arguments);
      }
    }
  }, [_vm._v("\n    clear search\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;
/* style */

var __vue_inject_styles__$D = undefined;
/* scoped */

var __vue_scope_id__$D = undefined;
/* module identifier */

var __vue_module_identifier__$D = undefined;
/* functional template */

var __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var script$C = Vue.extend({
  name: 'Checkbox',
  props: {
    checked: Boolean
  }
});
/* script */

var __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function __vue_render__$C() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "inline-block border border-solid rounded-md w-4 h-4",
    "class": {
      "bg-blue": _vm.checked
    },
    on: {
      click: function click($event) {
        return _vm.$emit("update:checked", !_vm.checked);
      }
    }
  });
};

var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;
/* style */

var __vue_inject_styles__$C = undefined;
/* scoped */

var __vue_scope_id__$C = undefined;
/* module identifier */

var __vue_module_identifier__$C = undefined;
/* functional template */

var __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

var script$B = Vue.extend({
  name: 'MultiSelectRow',
  components: {
    Checkbox: __vue_component__$C
  },
  props: {
    instance: Object
  },
  methods: {
    clickedRow: function clickedRow() {
      this.instance.selected = !this.instance.selected;
      this.instance.updated(this.instance.selected, this.instance);
    }
  }
});
/* script */

var __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function __vue_render__$B() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-multiselect-row cursor-pointer py-1 px-3 flex flex-row flex-nowrap items-center hover:text-blue",
    "class": {
      selected: _vm.instance.selected
    },
    on: {
      click: _vm.clickedRow
    }
  }, [_c("checkbox", {
    staticClass: "mr-2",
    attrs: {
      checked: _vm.instance.selected
    }
  }), _vm._v(" "), _c("section", {
    staticClass: "flex flex-col "
  }, [_c("div", [_vm._v(_vm._s(_vm.instance.label))]), _vm._v(" "), _vm.instance.subtext ? _c("div", {
    staticClass: "text-subtitle text-black"
  }, [_vm._v("\n      " + _vm._s(_vm.instance.subtext) + "\n    ")]) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;
/* style */

var __vue_inject_styles__$B = undefined;
/* scoped */

var __vue_scope_id__$B = undefined;
/* module identifier */

var __vue_module_identifier__$B = undefined;
/* functional template */

var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

var script$A = Vue.extend({
  name: 'SelectRow',
  props: {
    instance: Object
  },
  methods: {
    clickedRow: function clickedRow() {
      if (!this.instance.disabled) this.instance.onSelect(this.instance);
    }
  },
  computed: {
    isSelected: function isSelected() {
      if (typeof this.instance.isSelected === 'function') {
        return this.instance.isSelected(this.instance);
      } else {
        return !!this.instance.isSelected;
      }
    }
  }
});
/* script */

var __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function __vue_render__$A() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-select-row cursor-pointer py-1 px-3 text-blue",
    "class": {
      selected: _vm.isSelected,
      disabled: _vm.instance.disabled
    },
    on: {
      click: _vm.clickedRow
    }
  }, [_vm._v("\n  " + _vm._s(_vm.instance.label) + "\n")]);
};

var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;
/* style */

var __vue_inject_styles__$A = undefined;
/* scoped */

var __vue_scope_id__$A = undefined;
/* module identifier */

var __vue_module_identifier__$A = undefined;
/* functional template */

var __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var script$z = Vue.extend({
  name: 'BackRow',
  props: {
    instance: Object
  }
});
/* script */

var __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function __vue_render__$z() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-back-row py-1 px-3 text-blue flex flex-row items-center whitespace-nowrap"
  }, [_c("div", {
    staticClass: "cursor-pointer hover:text-black ",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.instance.clicked(_vm.instance);
      }
    }
  }, [_c("fai", {
    staticClass: "mr-2",
    attrs: {
      icon: ["fas", "chevron-left"]
    }
  }), _vm._v("\n    back\n  ")], 1), _vm._v(" "), _c("div", {
    staticClass: "sb-back-row-label ml-auto text-black font-secondary font-bold"
  }, [_vm._v("\n    " + _vm._s(_vm.instance.label) + "\n  ")])]);
};

var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;
/* style */

var __vue_inject_styles__$z = undefined;
/* scoped */

var __vue_scope_id__$z = undefined;
/* module identifier */

var __vue_module_identifier__$z = undefined;
/* functional template */

var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
var defaults$2 = {
  _disable: [],
  allowInput: false,
  allowInvalidPreload: false,
  altFormat: "F j, Y",
  altInput: false,
  altInputClass: "form-control input",
  animate: (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: true,
  clickOpens: true,
  closeOnSelect: true,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: false,
  enableSeconds: false,
  enableTime: false,
  errorHandler: function errorHandler(err) {
    return typeof console !== "undefined" && console.warn(err);
  },
  getWeek: function getWeek(givenDate) {
    var date = new Date(givenDate.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: false,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: false,
  now: new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: undefined,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: false,
  showMonths: 1,
  "static": false,
  time_24hr: false,
  weekNumbers: false,
  wrap: false
};
var english = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  months: {
    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function ordinal(nth) {
    var s = nth % 100;
    if (s > 3 && s < 21) return "th";

    switch (s % 10) {
      case 1:
        return "st";

      case 2:
        return "nd";

      case 3:
        return "rd";

      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: false
};

var pad = function pad(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return "000".concat(number).slice(length * -1);
};

var _int = function _int(bool) {
  return bool === true ? 1 : 0;
};

function debounce$1(fn, wait) {
  var t;
  return function () {
    var _arguments = arguments,
        _this2 = this;

    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this2, _arguments);
    }, wait);
  };
}

var arrayify = function arrayify(obj) {
  return obj instanceof Array ? obj : [obj];
};

function toggleClass$1(elem, className, bool) {
  if (bool === true) return elem.classList.add(className);
  elem.classList.remove(className);
}

function createElement(tag, className, content) {
  var e = window.document.createElement(tag);
  className = className || "";
  content = content || "";
  e.className = className;
  if (content !== undefined) e.textContent = content;
  return e;
}

function clearNode(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}

function findParent(node, condition) {
  if (condition(node)) return node;else if (node.parentNode) return findParent(node.parentNode, condition);
  return undefined;
}

function createNumberInput(inputClassName, opts) {
  var wrapper = createElement("div", "numInputWrapper"),
      numInput = createElement("input", "numInput " + inputClassName),
      arrowUp = createElement("span", "arrowUp"),
      arrowDown = createElement("span", "arrowDown");

  if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
    numInput.type = "number";
  } else {
    numInput.type = "text";
    numInput.pattern = "\\d*";
  }

  if (opts !== undefined) for (var key in opts) {
    numInput.setAttribute(key, opts[key]);
  }
  wrapper.appendChild(numInput);
  wrapper.appendChild(arrowUp);
  wrapper.appendChild(arrowDown);
  return wrapper;
}

function getEventTarget(event) {
  try {
    if (typeof event.composedPath === "function") {
      var path = event.composedPath();
      return path[0];
    }

    return event.target;
  } catch (error) {
    return event.target;
  }
}

var doNothing = function doNothing() {
  return undefined;
};

var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
  return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};

var revFormat = {
  D: doNothing,
  F: function F(dateObj, monthName, locale) {
    dateObj.setMonth(locale.months.longhand.indexOf(monthName));
  },
  G: function G(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  H: function H(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  J: function J(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  K: function K(dateObj, amPM, locale) {
    dateObj.setHours(dateObj.getHours() % 12 + 12 * _int(new RegExp(locale.amPM[1], "i").test(amPM)));
  },
  M: function M(dateObj, shortMonth, locale) {
    dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
  },
  S: function S(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  U: function U(_, unixSeconds) {
    return new Date(parseFloat(unixSeconds) * 1000);
  },
  W: function W(dateObj, weekNum, locale) {
    var weekNumber = parseInt(weekNum);
    var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
    return date;
  },
  Y: function Y(dateObj, year) {
    dateObj.setFullYear(parseFloat(year));
  },
  Z: function Z(_, ISODate) {
    return new Date(ISODate);
  },
  d: function d(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  h: function h(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  i: function i(dateObj, minutes) {
    dateObj.setMinutes(parseFloat(minutes));
  },
  j: function j(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  l: doNothing,
  m: function m(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  n: function n(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  s: function s(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  u: function u(_, unixMillSeconds) {
    return new Date(parseFloat(unixMillSeconds));
  },
  w: doNothing,
  y: function y(dateObj, year) {
    dateObj.setFullYear(2000 + parseFloat(year));
  }
};
var tokenRegex = {
  D: "(\\w+)",
  F: "(\\w+)",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "(\\w+)",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "(\\w+)",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
};
var formats = {
  Z: function Z(date) {
    return date.toISOString();
  },
  D: function D(date, locale, options) {
    return locale.weekdays.shorthand[formats.w(date, locale, options)];
  },
  F: function F(date, locale, options) {
    return monthToStr(formats.n(date, locale, options) - 1, false, locale);
  },
  G: function G(date, locale, options) {
    return pad(formats.h(date, locale, options));
  },
  H: function H(date) {
    return pad(date.getHours());
  },
  J: function J(date, locale) {
    return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
  },
  K: function K(date, locale) {
    return locale.amPM[_int(date.getHours() > 11)];
  },
  M: function M(date, locale) {
    return monthToStr(date.getMonth(), true, locale);
  },
  S: function S(date) {
    return pad(date.getSeconds());
  },
  U: function U(date) {
    return date.getTime() / 1000;
  },
  W: function W(date, _, options) {
    return options.getWeek(date);
  },
  Y: function Y(date) {
    return pad(date.getFullYear(), 4);
  },
  d: function d(date) {
    return pad(date.getDate());
  },
  h: function h(date) {
    return date.getHours() % 12 ? date.getHours() % 12 : 12;
  },
  i: function i(date) {
    return pad(date.getMinutes());
  },
  j: function j(date) {
    return date.getDate();
  },
  l: function l(date, locale) {
    return locale.weekdays.longhand[date.getDay()];
  },
  m: function m(date) {
    return pad(date.getMonth() + 1);
  },
  n: function n(date) {
    return date.getMonth() + 1;
  },
  s: function s(date) {
    return date.getSeconds();
  },
  u: function u(date) {
    return date.getTime();
  },
  w: function w(date) {
    return date.getDay();
  },
  y: function y(date) {
    return String(date.getFullYear()).substring(2);
  }
};

var createDateFormatter = function createDateFormatter(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? defaults$2 : _ref$config,
      _ref$l10n = _ref.l10n,
      l10n = _ref$l10n === void 0 ? english : _ref$l10n,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  return function (dateObj, frmt, overrideLocale) {
    var locale = overrideLocale || l10n;

    if (config.formatDate !== undefined && !isMobile) {
      return config.formatDate(dateObj, frmt, locale);
    }

    return frmt.split("").map(function (c, i, arr) {
      return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
    }).join("");
  };
};

var createDateParser = function createDateParser(_ref2) {
  var _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? defaults$2 : _ref2$config,
      _ref2$l10n = _ref2.l10n,
      l10n = _ref2$l10n === void 0 ? english : _ref2$l10n;
  return function (date, givenFormat, timeless, customLocale) {
    if (date !== 0 && !date) return undefined;
    var locale = customLocale || l10n;
    var parsedDate;
    var dateOrig = date;
    if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);else if (typeof date === "string") {
      var _format = givenFormat || (config || defaults$2).dateFormat;

      var datestr = String(date).trim();

      if (datestr === "today") {
        parsedDate = new Date();
        timeless = true;
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);else if (config && config.parseDate) parsedDate = config.parseDate(date, _format);else {
        parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
        var matched,
            ops = [];

        for (var i = 0, matchIndex = 0, regexStr = ""; i < _format.length; i++) {
          var token = _format[i];
          var isBackSlash = token === "\\";
          var escaped = _format[i - 1] === "\\" || isBackSlash;

          if (tokenRegex[token] && !escaped) {
            regexStr += tokenRegex[token];

            var _match = new RegExp(regexStr).exec(date);

            if (_match && (matched = true)) {
              ops[token !== "Y" ? "push" : "unshift"]({
                fn: revFormat[token],
                val: _match[++matchIndex]
              });
            }
          } else if (!isBackSlash) regexStr += ".";

          ops.forEach(function (_ref3) {
            var fn = _ref3.fn,
                val = _ref3.val;
            return parsedDate = fn(parsedDate, val, locale) || parsedDate;
          });
        }

        parsedDate = matched ? parsedDate : undefined;
      }
    }

    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      config.errorHandler(new Error("Invalid date provided: ".concat(dateOrig)));
      return undefined;
    }

    if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  };
};

function compareDates(date1, date2) {
  var timeless = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (timeless !== false) {
    return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
  }

  return date1.getTime() - date2.getTime();
}

var isBetween = function isBetween(ts, ts1, ts2) {
  return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};

var duration = {
  DAY: 86400000
};

function getDefaultHours(config) {
  var hours = config.defaultHour;
  var minutes = config.defaultMinute;
  var seconds = config.defaultSeconds;

  if (config.minDate !== undefined) {
    var minHour = config.minDate.getHours();
    var minMinutes = config.minDate.getMinutes();
    var minSeconds = config.minDate.getSeconds();

    if (hours < minHour) {
      hours = minHour;
    }

    if (hours === minHour && minutes < minMinutes) {
      minutes = minMinutes;
    }

    if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
  }

  if (config.maxDate !== undefined) {
    var maxHr = config.maxDate.getHours();
    var maxMinutes = config.maxDate.getMinutes();
    hours = Math.min(hours, maxHr);
    if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
    if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

if (typeof Object.assign !== "function") {
  Object.assign = function (target) {
    if (!target) {
      throw TypeError("Cannot convert undefined or null to object");
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _loop2 = function _loop2() {
      var source = _args2[_i2];

      if (source) {
        Object.keys(source).forEach(function (key) {
          return target[key] = source[key];
        });
      }
    };

    for (var _i2 = 0, _args2 = args; _i2 < _args2.length; _i2++) {
      _loop2();
    }

    return target;
  };
}

var DEBOUNCED_CHANGE_MS = 300;

function FlatpickrInstance(element, instanceConfig) {
  var self = {
    config: Object.assign(Object.assign({}, defaults$2), flatpickr.defaultConfig),
    l10n: english
  };
  self.parseDate = createDateParser({
    config: self.config,
    l10n: self.l10n
  });
  self._handlers = [];
  self.pluginElements = [];
  self.loadedPlugins = [];
  self._bind = bind;
  self._setHoursFromDate = setHoursFromDate;
  self._positionCalendar = positionCalendar;
  self.changeMonth = changeMonth;
  self.changeYear = changeYear;
  self.clear = clear;
  self.close = close;
  self._createElement = createElement;
  self.destroy = destroy;
  self.isEnabled = isEnabled;
  self.jumpToDate = jumpToDate;
  self.open = open;
  self.redraw = redraw;
  self.set = set;
  self.setDate = setDate;
  self.toggle = toggle;

  function setupHelperFunctions() {
    self.utils = {
      getDaysInMonth: function getDaysInMonth() {
        var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.currentMonth;
        var yr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.currentYear;
        if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
        return self.l10n.daysInMonth[month];
      }
    };
  }

  function init() {
    self.element = self.input = element;
    self.isOpen = false;
    parseConfig();
    setupLocale();
    setupInputs();
    setupDates();
    setupHelperFunctions();
    if (!self.isMobile) build();
    bindEvents();

    if (self.selectedDates.length || self.config.noCalendar) {
      if (self.config.enableTime) {
        setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
      }

      updateValue(false);
    }

    setCalendarWidth();
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!self.isMobile && isSafari) {
      positionCalendar();
    }

    triggerEvent("onReady");
  }

  function bindToInstance(fn) {
    return fn.bind(self);
  }

  function setCalendarWidth() {
    var config = self.config;

    if (config.weekNumbers === false && config.showMonths === 1) {
      return;
    } else if (config.noCalendar !== true) {
      window.requestAnimationFrame(function () {
        if (self.calendarContainer !== undefined) {
          self.calendarContainer.style.visibility = "hidden";
          self.calendarContainer.style.display = "block";
        }

        if (self.daysContainer !== undefined) {
          var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
          self.daysContainer.style.width = daysWidth + "px";
          self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
          self.calendarContainer.style.removeProperty("visibility");
          self.calendarContainer.style.removeProperty("display");
        }
      });
    }
  }

  function updateTime(e) {
    if (self.selectedDates.length === 0) {
      var defaultDate = self.config.minDate === undefined || compareDates(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());

      var _defaults = getDefaultHours(self.config);

      defaultDate.setHours(_defaults.hours, _defaults.minutes, _defaults.seconds, defaultDate.getMilliseconds());
      self.selectedDates = [defaultDate];
      self.latestSelectedDateObj = defaultDate;
    }

    if (e !== undefined && e.type !== "blur") {
      timeWrapper(e);
    }

    var prevValue = self._input.value;
    setHoursFromInputs();
    updateValue();

    if (self._input.value !== prevValue) {
      self._debouncedChange();
    }
  }

  function ampm2military(hour, amPM) {
    return hour % 12 + 12 * _int(amPM === self.l10n.amPM[1]);
  }

  function military2ampm(hour) {
    switch (hour % 24) {
      case 0:
      case 12:
        return 12;

      default:
        return hour % 12;
    }
  }

  function setHoursFromInputs() {
    if (self.hourElement === undefined || self.minuteElement === undefined) return;
    var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
        minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
        seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;

    if (self.amPM !== undefined) {
      hours = ampm2military(hours, self.amPM.textContent);
    }

    var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
    var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;

    if (limitMaxHours) {
      var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
      hours = Math.min(hours, maxTime.getHours());
      if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
      if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
    }

    if (limitMinHours) {
      var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
      hours = Math.max(hours, minTime.getHours());
      if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
      if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
    }

    setHours(hours, minutes, seconds);
  }

  function setHoursFromDate(dateObj) {
    var date = dateObj || self.latestSelectedDateObj;

    if (date) {
      setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }

  function setHours(hours, minutes, seconds) {
    if (self.latestSelectedDateObj !== undefined) {
      self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
    }

    if (!self.hourElement || !self.minuteElement || self.isMobile) return;
    self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * _int(hours % 12 === 0) : hours);
    self.minuteElement.value = pad(minutes);
    if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[_int(hours >= 12)];
    if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
  }

  function onYearInput(event) {
    var eventTarget = getEventTarget(event);
    var year = parseInt(eventTarget.value) + (event.delta || 0);

    if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
      changeYear(year);
    }
  }

  function bind(element, event, handler, options) {
    if (event instanceof Array) return event.forEach(function (ev) {
      return bind(element, ev, handler, options);
    });
    if (element instanceof Array) return element.forEach(function (el) {
      return bind(el, event, handler, options);
    });
    element.addEventListener(event, handler, options);

    self._handlers.push({
      remove: function remove() {
        return element.removeEventListener(event, handler);
      }
    });
  }

  function triggerChange() {
    triggerEvent("onChange");
  }

  function bindEvents() {
    if (self.config.wrap) {
      ["open", "close", "toggle", "clear"].forEach(function (evt) {
        Array.prototype.forEach.call(self.element.querySelectorAll("[data-".concat(evt, "]")), function (el) {
          return bind(el, "click", self[evt]);
        });
      });
    }

    if (self.isMobile) {
      setupMobile();
      return;
    }

    var debouncedResize = debounce$1(onResize, 50);
    self._debouncedChange = debounce$1(triggerChange, DEBOUNCED_CHANGE_MS);
    if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function (e) {
      if (self.config.mode === "range") onMouseOver(getEventTarget(e));
    });
    bind(window.document.body, "keydown", onKeyDown);
    if (!self.config.inline && !self.config["static"]) bind(window, "resize", debouncedResize);
    if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);else bind(window.document, "mousedown", documentClick);
    bind(window.document, "focus", documentClick, {
      capture: true
    });

    if (self.config.clickOpens === true) {
      bind(self._input, "focus", self.open);
      bind(self._input, "click", self.open);
    }

    if (self.daysContainer !== undefined) {
      bind(self.monthNav, "click", onMonthNavClick);
      bind(self.monthNav, ["keyup", "increment"], onYearInput);
      bind(self.daysContainer, "click", selectDate);
    }

    if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
      var selText = function selText(e) {
        return getEventTarget(e).select();
      };

      bind(self.timeContainer, ["increment"], updateTime);
      bind(self.timeContainer, "blur", updateTime, {
        capture: true
      });
      bind(self.timeContainer, "click", timeIncrement);
      bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
      if (self.secondElement !== undefined) bind(self.secondElement, "focus", function () {
        return self.secondElement && self.secondElement.select();
      });

      if (self.amPM !== undefined) {
        bind(self.amPM, "click", function (e) {
          updateTime(e);
          triggerChange();
        });
      }
    }

    if (self.config.allowInput) {
      bind(self._input, "blur", onBlur);
    }
  }

  function jumpToDate(jumpDate, triggerChange) {
    var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
    var oldYear = self.currentYear;
    var oldMonth = self.currentMonth;

    try {
      if (jumpTo !== undefined) {
        self.currentYear = jumpTo.getFullYear();
        self.currentMonth = jumpTo.getMonth();
      }
    } catch (e) {
      e.message = "Invalid date supplied: " + jumpTo;
      self.config.errorHandler(e);
    }

    if (triggerChange && self.currentYear !== oldYear) {
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
      triggerEvent("onMonthChange");
    }

    self.redraw();
  }

  function timeIncrement(e) {
    var eventTarget = getEventTarget(e);
    if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
  }

  function incrementNumInput(e, delta, inputElem) {
    var target = e && getEventTarget(e);
    var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
    var event = createEvent("increment");
    event.delta = delta;
    input && input.dispatchEvent(event);
  }

  function build() {
    var fragment = window.document.createDocumentFragment();
    self.calendarContainer = createElement("div", "flatpickr-calendar");
    self.calendarContainer.tabIndex = -1;

    if (!self.config.noCalendar) {
      fragment.appendChild(buildMonthNav());
      self.innerContainer = createElement("div", "flatpickr-innerContainer");

      if (self.config.weekNumbers) {
        var _buildWeeks = buildWeeks(),
            weekWrapper = _buildWeeks.weekWrapper,
            weekNumbers = _buildWeeks.weekNumbers;

        self.innerContainer.appendChild(weekWrapper);
        self.weekNumbers = weekNumbers;
        self.weekWrapper = weekWrapper;
      }

      self.rContainer = createElement("div", "flatpickr-rContainer");
      self.rContainer.appendChild(buildWeekdays());

      if (!self.daysContainer) {
        self.daysContainer = createElement("div", "flatpickr-days");
        self.daysContainer.tabIndex = -1;
      }

      buildDays();
      self.rContainer.appendChild(self.daysContainer);
      self.innerContainer.appendChild(self.rContainer);
      fragment.appendChild(self.innerContainer);
    }

    if (self.config.enableTime) {
      fragment.appendChild(buildTime());
    }

    toggleClass$1(self.calendarContainer, "rangeMode", self.config.mode === "range");
    toggleClass$1(self.calendarContainer, "animate", self.config.animate === true);
    toggleClass$1(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
    self.calendarContainer.appendChild(fragment);
    var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;

    if (self.config.inline || self.config["static"]) {
      self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");

      if (self.config.inline) {
        if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
      }

      if (self.config["static"]) {
        var wrapper = createElement("div", "flatpickr-wrapper");
        if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
        wrapper.appendChild(self.element);
        if (self.altInput) wrapper.appendChild(self.altInput);
        wrapper.appendChild(self.calendarContainer);
      }
    }

    if (!self.config["static"] && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
  }

  function createDay(className, date, dayNumber, i) {
    var dateIsEnabled = isEnabled(date, true),
        dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
    dayElement.dateObj = date;
    dayElement.$i = i;
    dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));

    if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
      self.todayDateElem = dayElement;
      dayElement.classList.add("today");
      dayElement.setAttribute("aria-current", "date");
    }

    if (dateIsEnabled) {
      dayElement.tabIndex = -1;

      if (isDateSelected(date)) {
        dayElement.classList.add("selected");
        self.selectedDateElem = dayElement;

        if (self.config.mode === "range") {
          toggleClass$1(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
          toggleClass$1(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
          if (className === "nextMonthDay") dayElement.classList.add("inRange");
        }
      }
    } else {
      dayElement.classList.add("flatpickr-disabled");
    }

    if (self.config.mode === "range") {
      if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
    }

    if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) {
      self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
    }

    triggerEvent("onDayCreate", dayElement);
    return dayElement;
  }

  function focusOnDayElem(targetNode) {
    targetNode.focus();
    if (self.config.mode === "range") onMouseOver(targetNode);
  }

  function getFirstAvailableDay(delta) {
    var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
    var endMonth = delta > 0 ? self.config.showMonths : -1;

    for (var m = startMonth; m != endMonth; m += delta) {
      var month = self.daysContainer.children[m];
      var startIndex = delta > 0 ? 0 : month.children.length - 1;
      var endIndex = delta > 0 ? month.children.length : -1;

      for (var i = startIndex; i != endIndex; i += delta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
      }
    }

    return undefined;
  }

  function getNextAvailableDay(current, delta) {
    var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
    var endMonth = delta > 0 ? self.config.showMonths : -1;
    var loopDelta = delta > 0 ? 1 : -1;

    for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
      var month = self.daysContainer.children[m];
      var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
      var numMonthDays = month.children.length;

      for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
      }
    }

    self.changeMonth(loopDelta);
    focusOnDay(getFirstAvailableDay(loopDelta), 0);
    return undefined;
  }

  function focusOnDay(current, offset) {
    var dayFocused = isInView(document.activeElement || document.body);
    var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);

    if (startElem === undefined) {
      self._input.focus();
    } else if (!dayFocused) {
      focusOnDayElem(startElem);
    } else {
      getNextAvailableDay(startElem, offset);
    }
  }

  function buildMonthDays(year, month) {
    var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
    var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
    var daysInMonth = self.utils.getDaysInMonth(month, year),
        days = window.document.createDocumentFragment(),
        isMultiMonth = self.config.showMonths > 1,
        prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
        nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
    var dayNumber = prevMonthDays + 1 - firstOfMonth,
        dayIndex = 0;

    for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
      days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
    }

    for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
      days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
    }

    for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
      days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
    }

    var dayContainer = createElement("div", "dayContainer");
    dayContainer.appendChild(days);
    return dayContainer;
  }

  function buildDays() {
    if (self.daysContainer === undefined) {
      return;
    }

    clearNode(self.daysContainer);
    if (self.weekNumbers) clearNode(self.weekNumbers);
    var frag = document.createDocumentFragment();

    for (var i = 0; i < self.config.showMonths; i++) {
      var d = new Date(self.currentYear, self.currentMonth, 1);
      d.setMonth(self.currentMonth + i);
      frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
    }

    self.daysContainer.appendChild(frag);
    self.days = self.daysContainer.firstChild;

    if (self.config.mode === "range" && self.selectedDates.length === 1) {
      onMouseOver();
    }
  }

  function buildMonthSwitch() {
    if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;

    var shouldBuildMonth = function shouldBuildMonth(month) {
      if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) {
        return false;
      }

      return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
    };

    self.monthsDropdownContainer.tabIndex = -1;
    self.monthsDropdownContainer.innerHTML = "";

    for (var i = 0; i < 12; i++) {
      if (!shouldBuildMonth(i)) continue;
      var month = createElement("option", "flatpickr-monthDropdown-month");
      month.value = new Date(self.currentYear, i).getMonth().toString();
      month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
      month.tabIndex = -1;

      if (self.currentMonth === i) {
        month.selected = true;
      }

      self.monthsDropdownContainer.appendChild(month);
    }
  }

  function buildMonth() {
    var container = createElement("div", "flatpickr-month");
    var monthNavFragment = window.document.createDocumentFragment();
    var monthElement;

    if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
      monthElement = createElement("span", "cur-month");
    } else {
      self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
      self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
      bind(self.monthsDropdownContainer, "change", function (e) {
        var target = getEventTarget(e);
        var selectedMonth = parseInt(target.value, 10);
        self.changeMonth(selectedMonth - self.currentMonth);
        triggerEvent("onMonthChange");
      });
      buildMonthSwitch();
      monthElement = self.monthsDropdownContainer;
    }

    var yearInput = createNumberInput("cur-year", {
      tabindex: "-1"
    });
    var yearElement = yearInput.getElementsByTagName("input")[0];
    yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);

    if (self.config.minDate) {
      yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
    }

    if (self.config.maxDate) {
      yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
      yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
    }

    var currentMonth = createElement("div", "flatpickr-current-month");
    currentMonth.appendChild(monthElement);
    currentMonth.appendChild(yearInput);
    monthNavFragment.appendChild(currentMonth);
    container.appendChild(monthNavFragment);
    return {
      container: container,
      yearElement: yearElement,
      monthElement: monthElement
    };
  }

  function buildMonths() {
    clearNode(self.monthNav);
    self.monthNav.appendChild(self.prevMonthNav);

    if (self.config.showMonths) {
      self.yearElements = [];
      self.monthElements = [];
    }

    for (var m = self.config.showMonths; m--;) {
      var month = buildMonth();
      self.yearElements.push(month.yearElement);
      self.monthElements.push(month.monthElement);
      self.monthNav.appendChild(month.container);
    }

    self.monthNav.appendChild(self.nextMonthNav);
  }

  function buildMonthNav() {
    self.monthNav = createElement("div", "flatpickr-months");
    self.yearElements = [];
    self.monthElements = [];
    self.prevMonthNav = createElement("span", "flatpickr-prev-month");
    self.prevMonthNav.innerHTML = self.config.prevArrow;
    self.nextMonthNav = createElement("span", "flatpickr-next-month");
    self.nextMonthNav.innerHTML = self.config.nextArrow;
    buildMonths();
    Object.defineProperty(self, "_hidePrevMonthArrow", {
      get: function get() {
        return self.__hidePrevMonthArrow;
      },
      set: function set(bool) {
        if (self.__hidePrevMonthArrow !== bool) {
          toggleClass$1(self.prevMonthNav, "flatpickr-disabled", bool);
          self.__hidePrevMonthArrow = bool;
        }
      }
    });
    Object.defineProperty(self, "_hideNextMonthArrow", {
      get: function get() {
        return self.__hideNextMonthArrow;
      },
      set: function set(bool) {
        if (self.__hideNextMonthArrow !== bool) {
          toggleClass$1(self.nextMonthNav, "flatpickr-disabled", bool);
          self.__hideNextMonthArrow = bool;
        }
      }
    });
    self.currentYearElement = self.yearElements[0];
    updateNavigationCurrentMonth();
    return self.monthNav;
  }

  function buildTime() {
    self.calendarContainer.classList.add("hasTime");
    if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
    var defaults = getDefaultHours(self.config);
    self.timeContainer = createElement("div", "flatpickr-time");
    self.timeContainer.tabIndex = -1;
    var separator = createElement("span", "flatpickr-time-separator", ":");
    var hourInput = createNumberInput("flatpickr-hour", {
      "aria-label": self.l10n.hourAriaLabel
    });
    self.hourElement = hourInput.getElementsByTagName("input")[0];
    var minuteInput = createNumberInput("flatpickr-minute", {
      "aria-label": self.l10n.minuteAriaLabel
    });
    self.minuteElement = minuteInput.getElementsByTagName("input")[0];
    self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
    self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
    self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
    self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
    self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
    self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
    self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
    self.hourElement.setAttribute("maxlength", "2");
    self.minuteElement.setAttribute("min", "0");
    self.minuteElement.setAttribute("max", "59");
    self.minuteElement.setAttribute("maxlength", "2");
    self.timeContainer.appendChild(hourInput);
    self.timeContainer.appendChild(separator);
    self.timeContainer.appendChild(minuteInput);
    if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");

    if (self.config.enableSeconds) {
      self.timeContainer.classList.add("hasSeconds");
      var secondInput = createNumberInput("flatpickr-second");
      self.secondElement = secondInput.getElementsByTagName("input")[0];
      self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
      self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
      self.secondElement.setAttribute("min", "0");
      self.secondElement.setAttribute("max", "59");
      self.secondElement.setAttribute("maxlength", "2");
      self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
      self.timeContainer.appendChild(secondInput);
    }

    if (!self.config.time_24hr) {
      self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[_int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
      self.amPM.title = self.l10n.toggleTitle;
      self.amPM.tabIndex = -1;
      self.timeContainer.appendChild(self.amPM);
    }

    return self.timeContainer;
  }

  function buildWeekdays() {
    if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");else clearNode(self.weekdayContainer);

    for (var i = self.config.showMonths; i--;) {
      var container = createElement("div", "flatpickr-weekdaycontainer");
      self.weekdayContainer.appendChild(container);
    }

    updateWeekdays();
    return self.weekdayContainer;
  }

  function updateWeekdays() {
    if (!self.weekdayContainer) {
      return;
    }

    var firstDayOfWeek = self.l10n.firstDayOfWeek;

    var weekdays = _toConsumableArray(self.l10n.weekdays.shorthand);

    if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
      weekdays = [].concat(_toConsumableArray(weekdays.splice(firstDayOfWeek, weekdays.length)), _toConsumableArray(weekdays.splice(0, firstDayOfWeek)));
    }

    for (var i = self.config.showMonths; i--;) {
      self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        ".concat(weekdays.join("</span><span class='flatpickr-weekday'>"), "\n      </span>\n      ");
    }
  }

  function buildWeeks() {
    self.calendarContainer.classList.add("hasWeeks");
    var weekWrapper = createElement("div", "flatpickr-weekwrapper");
    weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
    var weekNumbers = createElement("div", "flatpickr-weeks");
    weekWrapper.appendChild(weekNumbers);
    return {
      weekWrapper: weekWrapper,
      weekNumbers: weekNumbers
    };
  }

  function changeMonth(value) {
    var isOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var delta = isOffset ? value : value - self.currentMonth;
    if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
    self.currentMonth += delta;

    if (self.currentMonth < 0 || self.currentMonth > 11) {
      self.currentYear += self.currentMonth > 11 ? 1 : -1;
      self.currentMonth = (self.currentMonth + 12) % 12;
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }

    buildDays();
    triggerEvent("onMonthChange");
    updateNavigationCurrentMonth();
  }

  function clear() {
    var triggerChangeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var toInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    self.input.value = "";
    if (self.altInput !== undefined) self.altInput.value = "";
    if (self.mobileInput !== undefined) self.mobileInput.value = "";
    self.selectedDates = [];
    self.latestSelectedDateObj = undefined;

    if (toInitial === true) {
      self.currentYear = self._initialDate.getFullYear();
      self.currentMonth = self._initialDate.getMonth();
    }

    if (self.config.enableTime === true) {
      var _getDefaultHours = getDefaultHours(self.config),
          hours = _getDefaultHours.hours,
          minutes = _getDefaultHours.minutes,
          seconds = _getDefaultHours.seconds;

      setHours(hours, minutes, seconds);
    }

    self.redraw();
    if (triggerChangeEvent) triggerEvent("onChange");
  }

  function close() {
    self.isOpen = false;

    if (!self.isMobile) {
      if (self.calendarContainer !== undefined) {
        self.calendarContainer.classList.remove("open");
      }

      if (self._input !== undefined) {
        self._input.classList.remove("active");
      }
    }

    triggerEvent("onClose");
  }

  function destroy() {
    if (self.config !== undefined) triggerEvent("onDestroy");

    for (var i = self._handlers.length; i--;) {
      self._handlers[i].remove();
    }

    self._handlers = [];

    if (self.mobileInput) {
      if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
      self.mobileInput = undefined;
    } else if (self.calendarContainer && self.calendarContainer.parentNode) {
      if (self.config["static"] && self.calendarContainer.parentNode) {
        var wrapper = self.calendarContainer.parentNode;
        wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);

        if (wrapper.parentNode) {
          while (wrapper.firstChild) {
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          }

          wrapper.parentNode.removeChild(wrapper);
        }
      } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
    }

    if (self.altInput) {
      self.input.type = "text";
      if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
      delete self.altInput;
    }

    if (self.input) {
      self.input.type = self.input._type;
      self.input.classList.remove("flatpickr-input");
      self.input.removeAttribute("readonly");
    }

    ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
      try {
        delete self[k];
      } catch (_) {}
    });
  }

  function isCalendarElem(elem) {
    if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
    return self.calendarContainer.contains(elem);
  }

  function documentClick(e) {
    if (self.isOpen && !self.config.inline) {
      var eventTarget = getEventTarget(e);
      var isCalendarElement = isCalendarElem(eventTarget);
      var isInput = eventTarget === self.input || eventTarget === self.altInput || self.element.contains(eventTarget) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
      var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
      var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
        return elem.contains(eventTarget);
      });

      if (lostFocus && isIgnored) {
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) {
          updateTime();
        }

        self.close();

        if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) {
          self.clear(false);
          self.redraw();
        }
      }
    }
  }

  function changeYear(newYear) {
    if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
    var newYearNum = newYear,
        isNewYear = self.currentYear !== newYearNum;
    self.currentYear = newYearNum || self.currentYear;

    if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
      self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
    } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
      self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
    }

    if (isNewYear) {
      self.redraw();
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
  }

  function isEnabled(date) {
    var timeless = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var _a;

    var dateToCheck = self.parseDate(date, undefined, timeless);
    if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
    if (!self.config.enable && self.config.disable.length === 0) return true;
    if (dateToCheck === undefined) return false;
    var bool = !!self.config.enable,
        array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;

    for (var i = 0, d; i < array.length; i++) {
      d = array[i];
      if (typeof d === "function" && d(dateToCheck)) return bool;else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;else if (typeof d === "string") {
        var parsed = self.parseDate(d, undefined, true);
        return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
      } else if (_typeof(d) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
    }

    return !bool;
  }

  function isInView(elem) {
    if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
    return false;
  }

  function onBlur(e) {
    var isInput = e.target === self._input;

    if (isInput && (self.selectedDates.length > 0 || self._input.value.length > 0) && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
      self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
  }

  function onKeyDown(e) {
    var eventTarget = getEventTarget(e);
    var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
    var allowInput = self.config.allowInput;
    var allowKeydown = self.isOpen && (!allowInput || !isInput);
    var allowInlineKeydown = self.config.inline && isInput && !allowInput;

    if (e.keyCode === 13 && isInput) {
      if (allowInput) {
        self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
        return eventTarget.blur();
      } else {
        self.open();
      }
    } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
      var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);

      switch (e.keyCode) {
        case 13:
          if (isTimeObj) {
            e.preventDefault();
            updateTime();
            focusAndClose();
          } else selectDate(e);

          break;

        case 27:
          e.preventDefault();
          focusAndClose();
          break;

        case 8:
        case 46:
          if (isInput && !self.config.allowInput) {
            e.preventDefault();
            self.clear();
          }

          break;

        case 37:
        case 39:
          if (!isTimeObj && !isInput) {
            e.preventDefault();

            if (self.daysContainer !== undefined && (allowInput === false || document.activeElement && isInView(document.activeElement))) {
              var _delta = e.keyCode === 39 ? 1 : -1;

              if (!e.ctrlKey) focusOnDay(undefined, _delta);else {
                e.stopPropagation();
                changeMonth(_delta);
                focusOnDay(getFirstAvailableDay(1), 0);
              }
            }
          } else if (self.hourElement) self.hourElement.focus();

          break;

        case 38:
        case 40:
          e.preventDefault();
          var delta = e.keyCode === 40 ? 1 : -1;

          if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
            if (e.ctrlKey) {
              e.stopPropagation();
              changeYear(self.currentYear - delta);
              focusOnDay(getFirstAvailableDay(1), 0);
            } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
          } else if (eventTarget === self.currentYearElement) {
            changeYear(self.currentYear - delta);
          } else if (self.config.enableTime) {
            if (!isTimeObj && self.hourElement) self.hourElement.focus();
            updateTime(e);

            self._debouncedChange();
          }

          break;

        case 9:
          if (isTimeObj) {
            var elems = [self.hourElement, self.minuteElement, self.secondElement, self.amPM].concat(self.pluginElements).filter(function (x) {
              return x;
            });
            var i = elems.indexOf(eventTarget);

            if (i !== -1) {
              var target = elems[i + (e.shiftKey ? -1 : 1)];
              e.preventDefault();

              (target || self._input).focus();
            }
          } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
            e.preventDefault();

            self._input.focus();
          }

          break;
      }
    }

    if (self.amPM !== undefined && eventTarget === self.amPM) {
      switch (e.key) {
        case self.l10n.amPM[0].charAt(0):
        case self.l10n.amPM[0].charAt(0).toLowerCase():
          self.amPM.textContent = self.l10n.amPM[0];
          setHoursFromInputs();
          updateValue();
          break;

        case self.l10n.amPM[1].charAt(0):
        case self.l10n.amPM[1].charAt(0).toLowerCase():
          self.amPM.textContent = self.l10n.amPM[1];
          setHoursFromInputs();
          updateValue();
          break;
      }
    }

    if (isInput || isCalendarElem(eventTarget)) {
      triggerEvent("onKeyDown", e);
    }
  }

  function onMouseOver(elem) {
    if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("flatpickr-disabled"))) return;
    var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(),
        initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(),
        rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()),
        rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
    var containsDisabled = false;
    var minRange = 0,
        maxRange = 0;

    for (var _t2 = rangeStartDate; _t2 < rangeEndDate; _t2 += duration.DAY) {
      if (!isEnabled(new Date(_t2), true)) {
        containsDisabled = containsDisabled || _t2 > rangeStartDate && _t2 < rangeEndDate;
        if (_t2 < initialDate && (!minRange || _t2 > minRange)) minRange = _t2;else if (_t2 > initialDate && (!maxRange || _t2 < maxRange)) maxRange = _t2;
      }
    }

    for (var m = 0; m < self.config.showMonths; m++) {
      var month = self.daysContainer.children[m];

      var _loop3 = function _loop3(i, l) {
        var dayElem = month.children[i],
            date = dayElem.dateObj;
        var timestamp = date.getTime();
        var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;

        if (outOfRange) {
          dayElem.classList.add("notAllowed");
          ["inRange", "startRange", "endRange"].forEach(function (c) {
            dayElem.classList.remove(c);
          });
          return "continue";
        } else if (containsDisabled && !outOfRange) return "continue";

        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
          dayElem.classList.remove(c);
        });

        if (elem !== undefined) {
          elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
          if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
          if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
        }
      };

      for (var i = 0, l = month.children.length; i < l; i++) {
        var _ret = _loop3(i, l);

        if (_ret === "continue") continue;
      }
    }
  }

  function onResize() {
    if (self.isOpen && !self.config["static"] && !self.config.inline) positionCalendar();
  }

  function open(e) {
    var positionElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self._positionElement;

    if (self.isMobile === true) {
      if (e) {
        e.preventDefault();
        var eventTarget = getEventTarget(e);

        if (eventTarget) {
          eventTarget.blur();
        }
      }

      if (self.mobileInput !== undefined) {
        self.mobileInput.focus();
        self.mobileInput.click();
      }

      triggerEvent("onOpen");
      return;
    } else if (self._input.disabled || self.config.inline) {
      return;
    }

    var wasOpen = self.isOpen;
    self.isOpen = true;

    if (!wasOpen) {
      self.calendarContainer.classList.add("open");

      self._input.classList.add("active");

      triggerEvent("onOpen");
      positionCalendar(positionElement);
    }

    if (self.config.enableTime === true && self.config.noCalendar === true) {
      if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) {
        setTimeout(function () {
          return self.hourElement.select();
        }, 50);
      }
    }
  }

  function minMaxDateSetter(type) {
    return function (date) {
      var dateObj = self.config["_".concat(type, "Date")] = self.parseDate(date, self.config.dateFormat);
      var inverseDateObj = self.config["_".concat(type === "min" ? "max" : "min", "Date")];

      if (dateObj !== undefined) {
        self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
      }

      if (self.selectedDates) {
        self.selectedDates = self.selectedDates.filter(function (d) {
          return isEnabled(d);
        });
        if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
        updateValue();
      }

      if (self.daysContainer) {
        redraw();
        if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();else self.currentYearElement.removeAttribute(type);
        self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
      }
    };
  }

  function parseConfig() {
    var boolOpts = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
    var userConfig = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
    var formats = {};
    self.config.parseDate = userConfig.parseDate;
    self.config.formatDate = userConfig.formatDate;
    Object.defineProperty(self.config, "enable", {
      get: function get() {
        return self.config._enable;
      },
      set: function set(dates) {
        self.config._enable = parseDateRules(dates);
      }
    });
    Object.defineProperty(self.config, "disable", {
      get: function get() {
        return self.config._disable;
      },
      set: function set(dates) {
        self.config._disable = parseDateRules(dates);
      }
    });
    var timeMode = userConfig.mode === "time";

    if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults$2.dateFormat;
      formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
    }

    if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
      var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults$2.altFormat;
      formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + " h:i".concat(userConfig.enableSeconds ? ":S" : "", " K");
    }

    Object.defineProperty(self.config, "minDate", {
      get: function get() {
        return self.config._minDate;
      },
      set: minMaxDateSetter("min")
    });
    Object.defineProperty(self.config, "maxDate", {
      get: function get() {
        return self.config._maxDate;
      },
      set: minMaxDateSetter("max")
    });

    var minMaxTimeSetter = function minMaxTimeSetter(type) {
      return function (val) {
        self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
      };
    };

    Object.defineProperty(self.config, "minTime", {
      get: function get() {
        return self.config._minTime;
      },
      set: minMaxTimeSetter("min")
    });
    Object.defineProperty(self.config, "maxTime", {
      get: function get() {
        return self.config._maxTime;
      },
      set: minMaxTimeSetter("max")
    });

    if (userConfig.mode === "time") {
      self.config.noCalendar = true;
      self.config.enableTime = true;
    }

    Object.assign(self.config, formats, userConfig);

    for (var i = 0; i < boolOpts.length; i++) {
      self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
    }

    HOOKS.filter(function (hook) {
      return self.config[hook] !== undefined;
    }).forEach(function (hook) {
      self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
    });
    self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    for (var _i3 = 0; _i3 < self.config.plugins.length; _i3++) {
      var pluginConf = self.config.plugins[_i3](self) || {};

      for (var key in pluginConf) {
        if (HOOKS.indexOf(key) > -1) {
          self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
        } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
      }
    }

    if (!userConfig.altInputClass) {
      self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
    }

    triggerEvent("onParseConfig");
  }

  function getInputElem() {
    return self.config.wrap ? element.querySelector("[data-input]") : element;
  }

  function setupLocale() {
    if (_typeof(self.config.locale) !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale ".concat(self.config.locale)));
    self.l10n = Object.assign(Object.assign({}, flatpickr.l10ns["default"]), _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
    tokenRegex.K = "(".concat(self.l10n.amPM[0], "|").concat(self.l10n.amPM[1], "|").concat(self.l10n.amPM[0].toLowerCase(), "|").concat(self.l10n.amPM[1].toLowerCase(), ")");
    var userConfig = Object.assign(Object.assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));

    if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) {
      self.config.time_24hr = self.l10n.time_24hr;
    }

    self.formatDate = createDateFormatter(self);
    self.parseDate = createDateParser({
      config: self.config,
      l10n: self.l10n
    });
  }

  function positionCalendar(customPositionElement) {
    if (typeof self.config.position === "function") {
      return void self.config.position(self, customPositionElement);
    }

    if (self.calendarContainer === undefined) return;
    triggerEvent("onPreCalendarPosition");
    var positionElement = customPositionElement || self._positionElement;
    var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function (acc, child) {
      return acc + child.offsetHeight;
    }, 0),
        calendarWidth = self.calendarContainer.offsetWidth,
        configPos = self.config.position.split(" "),
        configPosVertical = configPos[0],
        configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
        inputBounds = positionElement.getBoundingClientRect(),
        distanceFromBottom = window.innerHeight - inputBounds.bottom,
        showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
    var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
    toggleClass$1(self.calendarContainer, "arrowTop", !showOnTop);
    toggleClass$1(self.calendarContainer, "arrowBottom", showOnTop);
    if (self.config.inline) return;
    var left = window.pageXOffset + inputBounds.left;
    var isCenter = false;
    var isRight = false;

    if (configPosHorizontal === "center") {
      left -= (calendarWidth - inputBounds.width) / 2;
      isCenter = true;
    } else if (configPosHorizontal === "right") {
      left -= calendarWidth - inputBounds.width;
      isRight = true;
    }

    toggleClass$1(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
    toggleClass$1(self.calendarContainer, "arrowCenter", isCenter);
    toggleClass$1(self.calendarContainer, "arrowRight", isRight);
    var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
    var rightMost = left + calendarWidth > window.document.body.offsetWidth;
    var centerMost = right + calendarWidth > window.document.body.offsetWidth;
    toggleClass$1(self.calendarContainer, "rightMost", rightMost);
    if (self.config["static"]) return;
    self.calendarContainer.style.top = "".concat(top, "px");

    if (!rightMost) {
      self.calendarContainer.style.left = "".concat(left, "px");
      self.calendarContainer.style.right = "auto";
    } else if (!centerMost) {
      self.calendarContainer.style.left = "auto";
      self.calendarContainer.style.right = "".concat(right, "px");
    } else {
      var _doc = getDocumentStyleSheet();

      if (_doc === undefined) return;
      var bodyWidth = window.document.body.offsetWidth;
      var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
      var centerBefore = ".flatpickr-calendar.centerMost:before";
      var centerAfter = ".flatpickr-calendar.centerMost:after";
      var centerIndex = _doc.cssRules.length;
      var centerStyle = "{left:".concat(inputBounds.left, "px;right:auto;}");
      toggleClass$1(self.calendarContainer, "rightMost", false);
      toggleClass$1(self.calendarContainer, "centerMost", true);

      _doc.insertRule("".concat(centerBefore, ",").concat(centerAfter).concat(centerStyle), centerIndex);

      self.calendarContainer.style.left = "".concat(centerLeft, "px");
      self.calendarContainer.style.right = "auto";
    }
  }

  function getDocumentStyleSheet() {
    var editableSheet = null;

    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet = document.styleSheets[i];

      try {
        sheet.cssRules;
      } catch (err) {
        continue;
      }

      editableSheet = sheet;
      break;
    }

    return editableSheet != null ? editableSheet : createStyleSheet();
  }

  function createStyleSheet() {
    var style = document.createElement("style");
    document.head.appendChild(style);
    return style.sheet;
  }

  function redraw() {
    if (self.config.noCalendar || self.isMobile) return;
    buildMonthSwitch();
    updateNavigationCurrentMonth();
    buildDays();
  }

  function focusAndClose() {
    self._input.focus();

    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
      setTimeout(self.close, 0);
    } else {
      self.close();
    }
  }

  function selectDate(e) {
    e.preventDefault();
    e.stopPropagation();

    var isSelectable = function isSelectable(day) {
      return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
    };

    var t = findParent(getEventTarget(e), isSelectable);
    if (t === undefined) return;
    var target = t;
    var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
    var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
    self.selectedDateElem = target;
    if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
      var selectedIndex = isDateSelected(selectedDate);
      if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);else self.selectedDates.push(selectedDate);
    } else if (self.config.mode === "range") {
      if (self.selectedDates.length === 2) {
        self.clear(false, false);
      }

      self.latestSelectedDateObj = selectedDate;
      self.selectedDates.push(selectedDate);
      if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
    }
    setHoursFromInputs();

    if (shouldChangeMonth) {
      var isNewYear = self.currentYear !== selectedDate.getFullYear();
      self.currentYear = selectedDate.getFullYear();
      self.currentMonth = selectedDate.getMonth();

      if (isNewYear) {
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }

      triggerEvent("onMonthChange");
    }

    updateNavigationCurrentMonth();
    buildDays();
    updateValue();
    if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);else if (self.selectedDateElem !== undefined && self.hourElement === undefined) {
      self.selectedDateElem && self.selectedDateElem.focus();
    }
    if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();

    if (self.config.closeOnSelect) {
      var single = self.config.mode === "single" && !self.config.enableTime;
      var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;

      if (single || range) {
        focusAndClose();
      }
    }

    triggerChange();
  }

  var CALLBACKS = {
    locale: [setupLocale, updateWeekdays],
    showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
    minDate: [jumpToDate],
    maxDate: [jumpToDate],
    clickOpens: [function () {
      if (self.config.clickOpens === true) {
        bind(self._input, "focus", self.open);
        bind(self._input, "click", self.open);
      } else {
        self._input.removeEventListener("focus", self.open);

        self._input.removeEventListener("click", self.open);
      }
    }]
  };

  function set(option, value) {
    if (option !== null && _typeof(option) === "object") {
      Object.assign(self.config, option);

      for (var key in option) {
        if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function (x) {
          return x();
        });
      }
    } else {
      self.config[option] = value;
      if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function (x) {
        return x();
      });else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
    }

    self.redraw();
    updateValue(true);
  }

  function setSelectedDate(inputDate, format) {
    var dates = [];
    if (inputDate instanceof Array) dates = inputDate.map(function (d) {
      return self.parseDate(d, format);
    });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
      switch (self.config.mode) {
        case "single":
        case "time":
          dates = [self.parseDate(inputDate, format)];
          break;

        case "multiple":
          dates = inputDate.split(self.config.conjunction).map(function (date) {
            return self.parseDate(date, format);
          });
          break;

        case "range":
          dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
            return self.parseDate(date, format);
          });
          break;
      }
    } else self.config.errorHandler(new Error("Invalid date supplied: ".concat(JSON.stringify(inputDate))));
    self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function (d) {
      return d instanceof Date && isEnabled(d, false);
    });
    if (self.config.mode === "range") self.selectedDates.sort(function (a, b) {
      return a.getTime() - b.getTime();
    });
  }

  function setDate(date) {
    var triggerChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : self.config.dateFormat;
    if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
    setSelectedDate(date, format);
    self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
    self.redraw();
    jumpToDate(undefined, triggerChange);
    setHoursFromDate();

    if (self.selectedDates.length === 0) {
      self.clear(false);
    }

    updateValue(triggerChange);
    if (triggerChange) triggerEvent("onChange");
  }

  function parseDateRules(arr) {
    return arr.slice().map(function (rule) {
      if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
        return self.parseDate(rule, undefined, true);
      } else if (rule && _typeof(rule) === "object" && rule.from && rule.to) return {
        from: self.parseDate(rule.from, undefined),
        to: self.parseDate(rule.to, undefined)
      };

      return rule;
    }).filter(function (x) {
      return x;
    });
  }

  function setupDates() {
    self.selectedDates = [];
    self.now = self.parseDate(self.config.now) || new Date();
    var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
    if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
    self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
    self.currentYear = self._initialDate.getFullYear();
    self.currentMonth = self._initialDate.getMonth();
    if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
    if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
    if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
    self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
    self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
  }

  function setupInputs() {
    self.input = getInputElem();

    if (!self.input) {
      self.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }

    self.input._type = self.input.type;
    self.input.type = "text";
    self.input.classList.add("flatpickr-input");
    self._input = self.input;

    if (self.config.altInput) {
      self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
      self._input = self.altInput;
      self.altInput.placeholder = self.input.placeholder;
      self.altInput.disabled = self.input.disabled;
      self.altInput.required = self.input.required;
      self.altInput.tabIndex = self.input.tabIndex;
      self.altInput.type = "text";
      self.input.setAttribute("type", "hidden");
      if (!self.config["static"] && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
    }

    if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
    self._positionElement = self.config.positionElement || self._input;
  }

  function setupMobile() {
    var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
    self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
    self.mobileInput.tabIndex = 1;
    self.mobileInput.type = inputType;
    self.mobileInput.disabled = self.input.disabled;
    self.mobileInput.required = self.input.required;
    self.mobileInput.placeholder = self.input.placeholder;
    self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";

    if (self.selectedDates.length > 0) {
      self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
    }

    if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
    if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
    if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
    self.input.type = "hidden";
    if (self.altInput !== undefined) self.altInput.type = "hidden";

    try {
      if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
    } catch (_a) {}

    bind(self.mobileInput, "change", function (e) {
      self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
      triggerEvent("onChange");
      triggerEvent("onClose");
    });
  }

  function toggle(e) {
    if (self.isOpen === true) return self.close();
    self.open(e);
  }

  function triggerEvent(event, data) {
    if (self.config === undefined) return;
    var hooks = self.config[event];

    if (hooks !== undefined && hooks.length > 0) {
      for (var i = 0; hooks[i] && i < hooks.length; i++) {
        hooks[i](self.selectedDates, self.input.value, self, data);
      }
    }

    if (event === "onChange") {
      self.input.dispatchEvent(createEvent("change"));
      self.input.dispatchEvent(createEvent("input"));
    }
  }

  function createEvent(name) {
    var e = document.createEvent("Event");
    e.initEvent(name, true, true);
    return e;
  }

  function isDateSelected(date) {
    for (var i = 0; i < self.selectedDates.length; i++) {
      if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
    }

    return false;
  }

  function isDateInRange(date) {
    if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
    return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
  }

  function updateNavigationCurrentMonth() {
    if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
    self.yearElements.forEach(function (yearElement, i) {
      var d = new Date(self.currentYear, self.currentMonth, 1);
      d.setMonth(self.currentMonth + i);

      if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") {
        self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
      } else {
        self.monthsDropdownContainer.value = d.getMonth().toString();
      }

      yearElement.value = d.getFullYear().toString();
    });
    self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
    self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
  }

  function getDateStr(format) {
    return self.selectedDates.map(function (dObj) {
      return self.formatDate(dObj, format);
    }).filter(function (d, i, arr) {
      return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
    }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
  }

  function updateValue() {
    var triggerChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (self.mobileInput !== undefined && self.mobileFormatStr) {
      self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
    }

    self.input.value = getDateStr(self.config.dateFormat);

    if (self.altInput !== undefined) {
      self.altInput.value = getDateStr(self.config.altFormat);
    }

    if (triggerChange !== false) triggerEvent("onValueUpdate");
  }

  function onMonthNavClick(e) {
    var eventTarget = getEventTarget(e);
    var isPrevMonth = self.prevMonthNav.contains(eventTarget);
    var isNextMonth = self.nextMonthNav.contains(eventTarget);

    if (isPrevMonth || isNextMonth) {
      changeMonth(isPrevMonth ? -1 : 1);
    } else if (self.yearElements.indexOf(eventTarget) >= 0) {
      eventTarget.select();
    } else if (eventTarget.classList.contains("arrowUp")) {
      self.changeYear(self.currentYear + 1);
    } else if (eventTarget.classList.contains("arrowDown")) {
      self.changeYear(self.currentYear - 1);
    }
  }

  function timeWrapper(e) {
    e.preventDefault();
    var isKeyDown = e.type === "keydown",
        eventTarget = getEventTarget(e),
        input = eventTarget;

    if (self.amPM !== undefined && eventTarget === self.amPM) {
      self.amPM.textContent = self.l10n.amPM[_int(self.amPM.textContent === self.l10n.amPM[0])];
    }

    var min = parseFloat(input.getAttribute("min")),
        max = parseFloat(input.getAttribute("max")),
        step = parseFloat(input.getAttribute("step")),
        curValue = parseInt(input.value, 10),
        delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
    var newValue = curValue + step * delta;

    if (typeof input.value !== "undefined" && input.value.length === 2) {
      var isHourElem = input === self.hourElement,
          isMinuteElem = input === self.minuteElement;

      if (newValue < min) {
        newValue = max + newValue + _int(!isHourElem) + (_int(isHourElem) && _int(!self.amPM));
        if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
      } else if (newValue > max) {
        newValue = input === self.hourElement ? newValue - max - _int(!self.amPM) : min;
        if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
      }

      if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
        self.amPM.textContent = self.l10n.amPM[_int(self.amPM.textContent === self.l10n.amPM[0])];
      }

      input.value = pad(newValue);
    }
  }

  init();
  return self;
}

function _flatpickr(nodeList, config) {
  var nodes = Array.prototype.slice.call(nodeList).filter(function (x) {
    return x instanceof HTMLElement;
  });
  var instances = [];

  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];

    try {
      if (node.getAttribute("data-fp-omit") !== null) continue;

      if (node._flatpickr !== undefined) {
        node._flatpickr.destroy();

        node._flatpickr = undefined;
      }

      node._flatpickr = FlatpickrInstance(node, config || {});
      instances.push(node._flatpickr);
    } catch (e) {
      console.error(e);
    }
  }

  return instances.length === 1 ? instances[0] : instances;
}

if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
  HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
    return _flatpickr(this, config);
  };

  HTMLElement.prototype.flatpickr = function (config) {
    return _flatpickr([this], config);
  };
}

var flatpickr = function flatpickr(selector, config) {
  if (typeof selector === "string") {
    return _flatpickr(window.document.querySelectorAll(selector), config);
  } else if (selector instanceof Node) {
    return _flatpickr([selector], config);
  } else {
    return _flatpickr(selector, config);
  }
};

flatpickr.defaultConfig = {};
flatpickr.l10ns = {
  en: Object.assign({}, english),
  "default": Object.assign({}, english)
};

flatpickr.localize = function (l10n) {
  flatpickr.l10ns["default"] = Object.assign(Object.assign({}, flatpickr.l10ns["default"]), l10n);
};

flatpickr.setDefaults = function (config) {
  flatpickr.defaultConfig = Object.assign(Object.assign({}, flatpickr.defaultConfig), config);
};

flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;

if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
  jQuery.fn.flatpickr = function (config) {
    return _flatpickr(this, config);
  };
}

Date.prototype.fp_incr = function (days) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};

if (typeof window !== "undefined") {
  window.flatpickr = flatpickr;
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */


function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */


function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */


function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */


function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  "long": 'MMMM do, y',
  medium: 'MMM d, y',
  "short": 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  "long": 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  "short": 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  "long": "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  "short": '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  "short": ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  "short": /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */


var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
} // See issue: https://github.com/date-fns/date-fns/issues/376


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
} // See issue: https://github.com/date-fns/date-fns/issues/376


function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
} // See issue: https://github.com/date-fns/date-fns/issues/376


function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
} // See issue: https://github.com/date-fns/date-fns/issues/376


function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
} // See issue: https://github.com/date-fns/date-fns/issues/376


function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
} // See issue: https://github.com/date-fns/date-fns/issues/376


function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters$1 = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$2.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$2.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$2.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$2.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$2.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$2.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$2.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$2.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];

function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}

function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}

function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
} // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps


var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var script$y = Vue.extend({
  name: 'DateRange',
  props: {
    format: {
      type: String,
      "default": "Y-M-d"
    },
    placeholder: {
      type: String,
      "default": "select date range"
    },
    flatConfig: {
      type: Object
    },
    start: Date,
    end: Date,
    min: Date,
    max: Date
  },
  data: function data() {
    return {
      flatPickr: null
    };
  },
  methods: {
    clickedDisplay: function clickedDisplay() {
      this.flatPickr.open();
    }
  },
  computed: {
    selectedDates: function selectedDates() {
      if (this.start && this.end) {
        return [this.start, this.end];
      } else if (this.start) {
        return [this.start];
      } else {
        return [];
      }
    },
    startStr: function startStr() {
      return this.start ? format(this.start, this.format) : null;
    },
    endStr: function endStr() {
      return this.end ? format(this.end, this.format) : null;
    },
    config: function config() {
      var _this3 = this;

      return _objectSpread({
        mode: "range",
        format: this.format,
        positionElement: this.$refs["calendar-container"],
        minDate: this.min,
        maxDate: this.max,
        onClose: function onClose(newDates) {
          if (newDates[0] == null || newDates[1] == null) return;

          _this3.$emit("update:start", newDates[0]);

          _this3.$emit("update:end", newDates[1]);

          _this3.$emit("update:range", {
            start: newDates[0],
            end: newDates[1]
          });
        }
      }, this.flatConfig);
    }
  },
  watch: {
    selectedDates: {
      handler: function handler(dates) {
        this.flatPickr.setDate(dates);
      }
    }
  },
  mounted: function mounted() {
    var container = this.$refs['calendar-container'];
    this.flatPickr = flatpickr(container, this.config);
    this.flatPickr.setDate(this.selectedDates);
  },
  destroyed: function destroyed() {
    this.flatPickr.destroy();
  }
});
/* script */

var __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function __vue_render__$y() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedDisplay();
      }
    }
  }, [_c("div", {
    ref: "calendar-container",
    staticClass: "sb-input text-center"
  }, [_vm._t("label", function () {
    return [_vm.start && _vm.end ? [_c("span", {
      staticClass: "start-str"
    }, [_vm._v(_vm._s(_vm.startStr))]), _vm._v("\n        to\n        "), _c("span", {
      staticClass: "end-str"
    }, [_vm._v(_vm._s(_vm.endStr))])] : _vm.start ? [_vm._v("\n        " + _vm._s(_vm.startStr) + "\n      ")] : [_c("span", {
      staticClass: "text-subtitle"
    }, [_vm._v(_vm._s(_vm.placeholder))])]];
  }, {
    start: _vm.start,
    end: _vm.end
  })], 2)]);
};

var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;
/* style */

var __vue_inject_styles__$y = undefined;
/* scoped */

var __vue_scope_id__$y = undefined;
/* module identifier */

var __vue_module_identifier__$y = undefined;
/* functional template */

var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var script$x = Vue.extend({
  name: 'DateRangeRow',
  components: {
    DateRange: __vue_component__$y
  },
  props: {
    instance: Object
  },
  methods: {
    updatedRange: function updatedRange(range) {
      this.instance.start = range.start;
      this.instance.end = range.end;
      this.instance.updated(this.instance);
    }
  }
});
/* script */

var __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function __vue_render__$x() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-date-row py-1 px-3"
  }, [_c("div", {
    staticClass: "mb-2 font-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.instance.label) + "\n  ")]), _vm._v(" "), _c("date-range", {
    staticClass: "sb-date-range",
    attrs: {
      start: _vm.instance.start,
      end: _vm.instance.end,
      min: _vm.instance.min,
      max: _vm.instance.max
    },
    on: {
      "update:start": function updateStart($event) {
        return _vm.$set(_vm.instance, "start", $event);
      },
      "update:end": function updateEnd($event) {
        return _vm.$set(_vm.instance, "end", $event);
      },
      "update:range": _vm.updatedRange
    }
  })], 1);
};

var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;
/* style */

var __vue_inject_styles__$x = undefined;
/* scoped */

var __vue_scope_id__$x = undefined;
/* module identifier */

var __vue_module_identifier__$x = undefined;
/* functional template */

var __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var script$w = Vue.extend({
  name: 'TextRow',
  props: {
    instance: Object
  }
});
/* script */

var __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function __vue_render__$w() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-text-row cursor-pointer py-1 px-3 text-black text-center"
  }, [_vm._v("\n  " + _vm._s(_vm.instance.label) + "\n")]);
};

var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;
/* style */

var __vue_inject_styles__$w = undefined;
/* scoped */

var __vue_scope_id__$w = undefined;
/* module identifier */

var __vue_module_identifier__$w = undefined;
/* functional template */

var __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var script$v = Vue.extend({
  name: 'LineBreakRow',
  props: {
    instance: Object
  }
});
/* script */

var __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function __vue_render__$v() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("hr", {
    staticClass: "sb-line-break-row mx-3 my-1 h-0 text-black opacity-70 bg-blue"
  });
};

var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;
/* style */

var __vue_inject_styles__$v = undefined;
/* scoped */

var __vue_scope_id__$v = undefined;
/* module identifier */

var __vue_module_identifier__$v = undefined;
/* functional template */

var __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var script$u = Vue.extend({
  name: "loading-icon"
});
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles$1 = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles$1[group] || (styles$1[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var _index = style.ids.size - 1;

      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[_index]) style.element.removeChild(nodes[_index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[_index]);else style.element.appendChild(textNode);
    }
  }
}
/* script */


var __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function __vue_render__$u() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-loading-icon fill-current"
  }, [_c("svg", {
    staticClass: "loading-icon-svg text-blue",
    attrs: {
      version: "1.1",
      viewBox: "0 0 405 405",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c("g", {
    staticClass: "loading-icon-leaf-wrapper-outer",
    attrs: {
      "data-animator-group": "true",
      "data-animator-type": "1"
    }
  }, [_c("g", {
    staticClass: "loading-icon-leaf-wrapper-inner",
    attrs: {
      "data-animator-group": "true",
      "data-animator-type": "2"
    }
  }, [_c("path", {
    staticClass: "loading-icon-leaf",
    attrs: {
      d: "M368.899,272.314c-25.39-16.037-54.678-24.514-84.697-24.514c-1.054,0-2.108,0.016-3.162,0.037\n      c34.507-27.094,59.146-65.556,68.972-108.692c0.495-2.175-0.159-4.451-1.732-6.031c-1.575-1.581-3.853-2.244-6.024-1.756\n      c-35.557,7.956-67.984,25.74-93.773,51.428c-1.952,1.942-3.858,3.933-5.727,5.961c1.675-11.418,2.532-22.99,2.532-34.637\n      c0-45.082-12.726-89.056-36.802-127.169c-1.19-1.886-3.265-3.029-5.495-3.029s-4.305,1.143-5.495,3.029\n      c-24.076,38.114-36.802,82.088-36.802,127.169c0,11.648,0.857,23.22,2.532,34.638c-1.869-2.027-3.775-4.018-5.726-5.959\n      c-25.791-25.69-58.218-43.475-93.775-51.431c-2.172-0.488-4.45,0.175-6.024,1.756c-1.573,1.58-2.228,3.856-1.732,6.031\n      c9.826,43.136,34.464,81.598,68.972,108.692c-1.054-0.021-2.107-0.037-3.161-0.037c-30.02,0-59.308,8.477-84.697,24.514\n      c-1.886,1.191-3.029,3.266-3.029,5.496s1.144,4.305,3.029,5.496c24.396,15.409,51.878,23.719,80.344,24.451\n      c-6.288,6.974-11.662,14.731-16.053,23.201c-1.027,1.98-0.966,4.35,0.16,6.275c1.127,1.925,3.163,3.138,5.393,3.213\n      c1.221,0.041,2.437,0.061,3.653,0.061c33.486-0.001,65.127-15.431,85.913-40.998v63.615c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5\n      v-63.612c20.785,25.567,52.422,40.996,85.911,40.996c1.215,0,2.435-0.021,3.653-0.061c2.229-0.075,4.266-1.288,5.392-3.213\n      c1.127-1.925,1.188-4.294,0.161-6.274c-4.396-8.482-9.78-16.251-16.08-23.233c28.343-0.821,56.358-9.252,80.371-24.419\n      c1.886-1.191,3.029-3.266,3.029-5.496S370.784,273.505,368.899,272.314z M257.654,192c21.49-21.405,47.921-36.924,76.961-45.278\n      c-12.816,43.752-42.149,81.468-81.713,104.586c-11.487,6.71-23.648,12.095-36.299,16.099c8.715-16.101,15.513-33.082,20.298-50.624\n      C243.038,207.942,250.01,199.605,257.654,192z M202.99,43.056c19.198,33.835,29.297,72.005,29.297,111.054\n      c0,39.048-10.099,77.218-29.297,111.054c-19.198-33.836-29.297-72.006-29.297-111.054\n      C173.693,115.061,183.792,76.891,202.99,43.056z M71.364,146.722c29.04,8.354,55.472,23.873,76.963,45.281\n      c7.639,7.601,14.612,15.937,20.753,24.782c4.785,17.541,11.583,34.522,20.298,50.623c-12.652-4.004-24.813-9.389-36.3-16.1\n      C113.513,228.19,84.18,190.474,71.364,146.722z M121.777,260.801c8.666,0,17.331,0.787,25.776,2.322\n      c12.137,6.99,24.961,12.614,38.293,16.802c-16.325,7.99-34.096,12.927-52.17,14.394c-0.131,0.01-0.262,0.025-0.392,0.044\n      c-27.949,2.211-55.314-3.494-79.804-16.549C74.477,266.656,97.875,260.801,121.777,260.801z M118.713,327.163\n      c5.064-7.51,11.136-14.228,18.119-20.089c15.745-1.494,31.248-5.388,45.872-11.469C166.226,313.627,143.311,325.08,118.713,327.163\n      z M223.277,295.606c14.623,6.081,30.125,9.974,45.869,11.469c6.983,5.861,13.056,12.579,18.119,20.089\n      C262.671,325.079,239.755,313.626,223.277,295.606z M272.697,294.364c-0.131-0.019-0.264-0.034-0.396-0.044\n      c-18.075-1.468-35.845-6.404-52.169-14.394c13.332-4.188,26.156-9.812,38.294-16.802c8.444-1.536,17.109-2.322,25.776-2.322\n      c23.902,0,47.301,5.855,68.296,17.014C328.009,290.869,300.646,296.57,272.697,294.364z"
    }
  })])]), _vm._v(" "), _c("g", {
    staticClass: "loading-icon-circle-wrapper",
    attrs: {
      "data-animator-group": "true",
      "data-animator-type": "2"
    }
  }, [_c("path", {
    staticClass: "loading-icon-circle",
    attrs: {
      d: "M202.99,0C91.061,0,0,91.061,0,202.99s91.061,202.99,202.99,202.99s202.99-91.061,202.99-202.99S314.92,0,202.99,0z\n     M202.99,392.98C98.229,392.98,13,307.751,13,202.99S98.229,13,202.99,13s189.99,85.229,189.99,189.99\n    S307.751,392.98,202.99,392.98z"
    }
  })])])]);
};

var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;
/* style */

var __vue_inject_styles__$u = function __vue_inject_styles__$u(inject) {
  if (!inject) return;
  inject("data-v-93e338fe_0", {
    source: "@-webkit-keyframes spin {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n@-moz-keyframes spin {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n@-o-keyframes spin {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n@keyframes spin {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n@-webkit-keyframes shrink_animation {\n0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n}\n@-moz-keyframes shrink_animation {\n0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n}\n@-o-keyframes shrink_animation {\n0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n}\n@keyframes shrink_animation {\n0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n}\n80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n}\n@-webkit-keyframes rotate_animation {\n4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@-moz-keyframes rotate_animation {\n4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@-o-keyframes rotate_animation {\n4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@keyframes rotate_animation {\n4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@-webkit-keyframes fade_away_animation {\n4% {\n    opacity: 0.4;\n}\n30.67% {\n    opacity: 1;\n}\n52% {\n    opacity: 1;\n}\n72% {\n    opacity: 0;\n}\n0% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 0;\n}\n}\n@-moz-keyframes fade_away_animation {\n4% {\n    opacity: 0.4;\n}\n30.67% {\n    opacity: 1;\n}\n52% {\n    opacity: 1;\n}\n72% {\n    opacity: 0;\n}\n0% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 0;\n}\n}\n@-o-keyframes fade_away_animation {\n4% {\n    opacity: 0.4;\n}\n30.67% {\n    opacity: 1;\n}\n52% {\n    opacity: 1;\n}\n72% {\n    opacity: 0;\n}\n0% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes fade_away_animation {\n4% {\n    opacity: 0.4;\n}\n30.67% {\n    opacity: 1;\n}\n52% {\n    opacity: 1;\n}\n72% {\n    opacity: 0;\n}\n0% {\n    opacity: 0.4;\n}\n100% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes leaf_shrink_animation {\n0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n}\n40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@-moz-keyframes leaf_shrink_animation {\n0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n}\n40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@-o-keyframes leaf_shrink_animation {\n0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n}\n40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n@keyframes leaf_shrink_animation {\n0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n}\n40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n}\n72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n}\n.slide-enter-active {\n  -moz-transition-duration: 0.3s;\n  -webkit-transition-duration: 0.3s;\n  -o-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -moz-transition-timing-function: ease-in;\n  -webkit-transition-timing-function: ease-in;\n  -o-transition-timing-function: ease-in;\n  transition-timing-function: ease-in;\n}\n.slide-leave-active {\n  -moz-transition-duration: 0.3s;\n  -webkit-transition-duration: 0.3s;\n  -o-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n}\n.slide-enter-to,\n.slide-leave {\n  max-height: 15vh;\n  overflow: hidden;\n}\n.slide-enter,\n.slide-leave-to {\n  overflow: hidden;\n  max-height: 0;\n}\n.sb-loading-icon {\n  width: 50px;\n}\n.loading-icon-leaf-wrapper-inner {\n  -webkit-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n.loading-icon-leaf {\n  -webkit-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  opacity: 0;\n}\n.loading-icon-leaf-wrapper-outer {\n  -webkit-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -moz-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -o-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n.loading-icon-circle-wrapper {\n  -webkit-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n\n/*# sourceMappingURL=LoadingIcon.vue.map */",
    map: {
      "version": 3,
      "sources": ["LoadingIcon.vue", "/home/raf/docker_dev/repos/sb-components/src/components/icons/LoadingIcon.vue"],
      "names": [],
      "mappings": "AAAA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;AACE;IACE,wHAAwH;AAC1H;AACA;IACE,oHAAoH;AACtH;AACA;IACE,oHAAoH;AACtH;AACA;IACE,wHAAwH;AAC1H;AACA;IACE,wHAAwH;AAC1H;AACF;AACA;AACE;IACE,wHAAwH;AAC1H;AACA;IACE,oHAAoH;AACtH;AACA;IACE,oHAAoH;AACtH;AACA;IACE,wHAAwH;AAC1H;AACA;IACE,wHAAwH;AAC1H;AACF;AACA;AACE;IACE,wHAAwH;AAC1H;AACA;IACE,oHAAoH;AACtH;AACA;IACE,oHAAoH;AACtH;AACA;IACE,wHAAwH;AAC1H;AACA;IACE,wHAAwH;AAC1H;AACF;AACA;AACE;IACE,wHAAwH;AAC1H;AACA;IACE,oHAAoH;AACtH;AACA;IACE,oHAAoH;AACtH;AACA;IACE,wHAAwH;AAC1H;AACA;IACE,wHAAwH;AAC1H;AACF;AACA;AACE;IACE,qHAAqH;AACvH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACF;AACA;AACE;IACE,qHAAqH;AACvH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACF;AACA;AACE;IACE,qHAAqH;AACvH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACF;AACA;AACE;IACE,qHAAqH;AACvH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,uHAAuH;AACzH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACA;IACE,qHAAqH;AACvH;AACF;AACA;AACE;IACE,YAAY;AACd;AC3GF;ID6GI,UAAU;AACZ;AC3GF;ID6GI,UAAU;AACZ;AC3GF;IACA,UAAA;AD6GE;AC3GF;IACA,YAAA;AD6GE;AACA;IC3GF,UAAA;AD6GE;AACF;AACA;AACE;IACE,YAAY;AACd;AC/HF;IDiII,UAAU;AACZ;AC/HF;IDiII,UAAU;AACZ;AC/HF;IACA,UAAA;ADiIE;AC/HF;IACA,YAAA;ADiIE;AACA;IC/HF,UAAA;ADiIE;AACF;AACA;AACE;IACE,YAAY;AACd;ACnJF;IDqJI,UAAU;AACZ;ACnJF;IDqJI,UAAU;AACZ;ACnJF;IACA,UAAA;ADqJE;ACnJF;IACA,YAAA;ADqJE;AACA;ICnJF,UAAA;ADqJE;AACF;AACA;AACE;IACE,YAAY;AACd;ACvKF;IDyKI,UAAU;AACZ;ACvKF;IDyKI,UAAU;AACZ;ACvKF;IACA,UAAA;ADyKE;ACvKF;IACA,YAAA;ADyKE;AACA;ICvKF,UAAA;ADyKE;AACF;AACA;ACvKA;IDyKI,gIAAgI;ICvKpI,wHAAA;ADyKE;ACvKF;IACA,gIAAA;IACA,wHAAA;ADyKE;AACA;ICvKF,4HAAA;IACA,oHAAA;ADyKE;ACvKF;IACA,4HAAA;IACA,oHAAA;ADyKE;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACF;AACA;ACjMA;IDmMI,gIAAgI;ICjMpI,wHAAA;ADmME;ACjMF;IACA,gIAAA;IACA,wHAAA;ADmME;AACA;ICjMF,4HAAA;IACA,oHAAA;ADmME;ACjMF;IACA,4HAAA;IACA,oHAAA;ADmME;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACF;AACA;AC3NA;ID6NI,gIAAgI;IC3NpI,wHAAA;AD6NE;AC3NF;IACA,gIAAA;IACA,wHAAA;AD6NE;AACA;IC3NF,4HAAA;IACA,oHAAA;AD6NE;AC3NF;IACA,4HAAA;IACA,oHAAA;AD6NE;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACF;AACA;ACrPA;IDuPI,gIAAgI;ICrPpI,wHAAA;ADuPE;ACrPF;IACA,gIAAA;IACA,wHAAA;ADuPE;AACA;ICrPF,4HAAA;IACA,oHAAA;ADuPE;ACrPF;IACA,4HAAA;IACA,oHAAA;ADuPE;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACA;IACE,gIAAgI;IAChI,wHAAwH;AAC1H;AACF;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;EACxC,2CAA2C;EAC3C,sCAAsC;EACtC,mCAAmC;AACrC;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,2DAA2D;EAC3D,8DAA8D;EAC9D,yDAAyD;EACzD,sDAAsD;AACxD;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;AC9TA;EACA,WAAA;ADiUA;AC9TA;EDiUE,kFAAkF;EAClF,+EAA+E;EAC/E,6EAA6E;EAC7E,0EAA0E;EChU5E,gIAAA;EACA,wHAAA;ADkUA;AChUA;EDmUE,gFAAgF;EAChF,6EAA6E;EAC7E,2EAA2E;EAC3E,wEAAwE;EClU1E,UAAA;ADoUA;AClUA;EDqUE,gFAAgF;EAChF,6EAA6E;EAC7E,2EAA2E;EAC3E,wEAAwE;ECpU1E,6HAAA;EACA,qHAAA;ADsUA;ACpUA;EDuUE,6EAA6E;EAC7E,0EAA0E;EAC1E,wEAAwE;EACxE,qEAAqE;ECtUvE,gIAAA;EACA,wHAAA;ADwUA;;AAEA,0CAA0C",
      "file": "LoadingIcon.vue",
      "sourcesContent": ["@-webkit-keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes shrink_animation {\n  0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n}\n@-moz-keyframes shrink_animation {\n  0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n}\n@-o-keyframes shrink_animation {\n  0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n}\n@keyframes shrink_animation {\n  0% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  20% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  60% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(1, 1) translate(-202.9900054932px, -202.9900054932px);\n  }\n  80% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n  100% {\n    transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  }\n}\n@-webkit-keyframes rotate_animation {\n  4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@-moz-keyframes rotate_animation {\n  4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@-o-keyframes rotate_animation {\n  4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@keyframes rotate_animation {\n  4% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  20% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(360deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  0% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@-webkit-keyframes fade_away_animation {\n  4% {\n    opacity: 0.4;\n  }\n  30.67% {\n    opacity: 1;\n  }\n  52% {\n    opacity: 1;\n  }\n  72% {\n    opacity: 0;\n  }\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@-moz-keyframes fade_away_animation {\n  4% {\n    opacity: 0.4;\n  }\n  30.67% {\n    opacity: 1;\n  }\n  52% {\n    opacity: 1;\n  }\n  72% {\n    opacity: 0;\n  }\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@-o-keyframes fade_away_animation {\n  4% {\n    opacity: 0.4;\n  }\n  30.67% {\n    opacity: 1;\n  }\n  52% {\n    opacity: 1;\n  }\n  72% {\n    opacity: 0;\n  }\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fade_away_animation {\n  4% {\n    opacity: 0.4;\n  }\n  30.67% {\n    opacity: 1;\n  }\n  52% {\n    opacity: 1;\n  }\n  72% {\n    opacity: 0;\n  }\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes leaf_shrink_animation {\n  0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n  }\n  40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@-moz-keyframes leaf_shrink_animation {\n  0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n  }\n  40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@-o-keyframes leaf_shrink_animation {\n  0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n  }\n  40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n@keyframes leaf_shrink_animation {\n  0% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  12% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.6, 0.6) translate(-202.9920425415px, -196.7679748535px);\n  }\n  40% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  52% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(1, 1) translate(-202.9920425415px, -196.7679748535px);\n  }\n  72% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n  100% {\n    -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n    transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  }\n}\n.slide-enter-active {\n  -moz-transition-duration: 0.3s;\n  -webkit-transition-duration: 0.3s;\n  -o-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -moz-transition-timing-function: ease-in;\n  -webkit-transition-timing-function: ease-in;\n  -o-transition-timing-function: ease-in;\n  transition-timing-function: ease-in;\n}\n\n.slide-leave-active {\n  -moz-transition-duration: 0.3s;\n  -webkit-transition-duration: 0.3s;\n  -o-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n}\n\n.slide-enter-to,\n.slide-leave {\n  max-height: 15vh;\n  overflow: hidden;\n}\n\n.slide-enter,\n.slide-leave-to {\n  overflow: hidden;\n  max-height: 0;\n}\n\n.sb-loading-icon {\n  width: 50px;\n}\n\n.loading-icon-leaf-wrapper-inner {\n  -webkit-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n  transform: translate(202.9920425415px, 196.7679748535px) scale(0.8, 0.8) translate(-202.9920425415px, -196.7679748535px);\n}\n\n.loading-icon-leaf {\n  -webkit-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  opacity: 0;\n}\n\n.loading-icon-leaf-wrapper-outer {\n  -webkit-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -moz-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -o-animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  animation: rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n  transform: translate(202.9920425415px, 196.7679748535px) rotate(0deg) translate(-202.9920425415px, -196.7679748535px);\n}\n\n.loading-icon-circle-wrapper {\n  -webkit-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -moz-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -o-animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  animation: shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite;\n  -webkit-transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n  transform: translate(202.9900054932px, 202.9900054932px) scale(0.8, 0.8) translate(-202.9900054932px, -202.9900054932px);\n}\n\n/*# sourceMappingURL=LoadingIcon.vue.map */", "<template>\n  <main class=\"sb-loading-icon fill-current\">\n    <svg\n      version=\"1.1\"\n      class=\"loading-icon-svg text-blue\"\n      viewBox=\"0 0 405 405\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      xml:space=\"preserve\"\n    >\n      <g\n        class=\"loading-icon-leaf-wrapper-outer\"\n        data-animator-group=\"true\"\n        data-animator-type=\"1\"\n      >\n        <g\n          class=\"loading-icon-leaf-wrapper-inner\"\n          data-animator-group=\"true\"\n          data-animator-type=\"2\"\n        >\n          <path\n            class=\"loading-icon-leaf\"\n            d=\"M368.899,272.314c-25.39-16.037-54.678-24.514-84.697-24.514c-1.054,0-2.108,0.016-3.162,0.037\n        c34.507-27.094,59.146-65.556,68.972-108.692c0.495-2.175-0.159-4.451-1.732-6.031c-1.575-1.581-3.853-2.244-6.024-1.756\n        c-35.557,7.956-67.984,25.74-93.773,51.428c-1.952,1.942-3.858,3.933-5.727,5.961c1.675-11.418,2.532-22.99,2.532-34.637\n        c0-45.082-12.726-89.056-36.802-127.169c-1.19-1.886-3.265-3.029-5.495-3.029s-4.305,1.143-5.495,3.029\n        c-24.076,38.114-36.802,82.088-36.802,127.169c0,11.648,0.857,23.22,2.532,34.638c-1.869-2.027-3.775-4.018-5.726-5.959\n        c-25.791-25.69-58.218-43.475-93.775-51.431c-2.172-0.488-4.45,0.175-6.024,1.756c-1.573,1.58-2.228,3.856-1.732,6.031\n        c9.826,43.136,34.464,81.598,68.972,108.692c-1.054-0.021-2.107-0.037-3.161-0.037c-30.02,0-59.308,8.477-84.697,24.514\n        c-1.886,1.191-3.029,3.266-3.029,5.496s1.144,4.305,3.029,5.496c24.396,15.409,51.878,23.719,80.344,24.451\n        c-6.288,6.974-11.662,14.731-16.053,23.201c-1.027,1.98-0.966,4.35,0.16,6.275c1.127,1.925,3.163,3.138,5.393,3.213\n        c1.221,0.041,2.437,0.061,3.653,0.061c33.486-0.001,65.127-15.431,85.913-40.998v63.615c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5\n        v-63.612c20.785,25.567,52.422,40.996,85.911,40.996c1.215,0,2.435-0.021,3.653-0.061c2.229-0.075,4.266-1.288,5.392-3.213\n        c1.127-1.925,1.188-4.294,0.161-6.274c-4.396-8.482-9.78-16.251-16.08-23.233c28.343-0.821,56.358-9.252,80.371-24.419\n        c1.886-1.191,3.029-3.266,3.029-5.496S370.784,273.505,368.899,272.314z M257.654,192c21.49-21.405,47.921-36.924,76.961-45.278\n        c-12.816,43.752-42.149,81.468-81.713,104.586c-11.487,6.71-23.648,12.095-36.299,16.099c8.715-16.101,15.513-33.082,20.298-50.624\n        C243.038,207.942,250.01,199.605,257.654,192z M202.99,43.056c19.198,33.835,29.297,72.005,29.297,111.054\n        c0,39.048-10.099,77.218-29.297,111.054c-19.198-33.836-29.297-72.006-29.297-111.054\n        C173.693,115.061,183.792,76.891,202.99,43.056z M71.364,146.722c29.04,8.354,55.472,23.873,76.963,45.281\n        c7.639,7.601,14.612,15.937,20.753,24.782c4.785,17.541,11.583,34.522,20.298,50.623c-12.652-4.004-24.813-9.389-36.3-16.1\n        C113.513,228.19,84.18,190.474,71.364,146.722z M121.777,260.801c8.666,0,17.331,0.787,25.776,2.322\n        c12.137,6.99,24.961,12.614,38.293,16.802c-16.325,7.99-34.096,12.927-52.17,14.394c-0.131,0.01-0.262,0.025-0.392,0.044\n        c-27.949,2.211-55.314-3.494-79.804-16.549C74.477,266.656,97.875,260.801,121.777,260.801z M118.713,327.163\n        c5.064-7.51,11.136-14.228,18.119-20.089c15.745-1.494,31.248-5.388,45.872-11.469C166.226,313.627,143.311,325.08,118.713,327.163\n        z M223.277,295.606c14.623,6.081,30.125,9.974,45.869,11.469c6.983,5.861,13.056,12.579,18.119,20.089\n        C262.671,325.079,239.755,313.626,223.277,295.606z M272.697,294.364c-0.131-0.019-0.264-0.034-0.396-0.044\n        c-18.075-1.468-35.845-6.404-52.169-14.394c13.332-4.188,26.156-9.812,38.294-16.802c8.444-1.536,17.109-2.322,25.776-2.322\n        c23.902,0,47.301,5.855,68.296,17.014C328.009,290.869,300.646,296.57,272.697,294.364z\"\n          ></path>\n        </g>\n      </g>\n      <g\n        class=\"loading-icon-circle-wrapper\"\n        data-animator-group=\"true\"\n        data-animator-type=\"2\"\n      >\n        <path\n          class=\"loading-icon-circle\"\n          d=\"M202.99,0C91.061,0,0,91.061,0,202.99s91.061,202.99,202.99,202.99s202.99-91.061,202.99-202.99S314.92,0,202.99,0z\n       M202.99,392.98C98.229,392.98,13,307.751,13,202.99S98.229,13,202.99,13s189.99,85.229,189.99,189.99\n      S307.751,392.98,202.99,392.98z\"\n        ></path>\n      </g>\n    </svg>\n  </main>\n</template>\n\n<script lang=\"ts\">\n  import Vue from \"vue\";\n\n  export default Vue.extend({\n    name: \"loading-icon\"\n  });\n</script>\n\n<style lang=\"sass\">\n@import '../../styles/animations.scss'\n\n.sb-loading-icon\n  width: 50px\n\n// loading icon styles / animations\n.loading-icon-leaf-wrapper-inner\n  @include animation('leaf_shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite')\n  //animation-name: leaf_shrink_animation\n  //animation-timing-function: cubic-bezier(0, 0, 0.58, 1)\n  -webkit-transform: translate(202.9920425415039px, 196.76797485351562px) scale(0.8, 0.8) translate(-202.9920425415039px, -196.76797485351562px)\n  transform: translate(202.9920425415039px, 196.76797485351562px) scale(0.8, 0.8) translate(-202.9920425415039px, -196.76797485351562px)\n\n.loading-icon-leaf\n  @include animation('fade_away_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite')\n  //animation-name: fade_away_animation\n  //animation-timing-function: cubic-bezier(0, 0, 0.58, 1)\n  opacity: 0\n\n.loading-icon-leaf-wrapper-outer\n  @include animation('rotate_animation 2.5s cubic-bezier(0.42, 0, 0.58, 1) infinite')\n  //animation-name: rotate_animation\n  //animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1)\n  -webkit-transform: translate(202.9920425415039px, 196.76797485351562px) rotate(0deg) translate(-202.9920425415039px, -196.76797485351562px)\n  transform: translate(202.9920425415039px, 196.76797485351562px) rotate(0deg) translate(-202.9920425415039px, -196.76797485351562px)\n\n.loading-icon-circle-wrapper\n  @include animation('shrink_animation 2.5s cubic-bezier(0, 0, 0.58, 1) infinite')\n  //animation-name: shrink_animation\n  //animation-timing-function: cubic-bezier(0, 0, 0.58, 1)\n  -webkit-transform: translate(202.99000549316406px, 202.99000549316406px) scale(0.8, 0.8) translate(-202.99000549316406px, -202.99000549316406px)\n  transform: translate(202.99000549316406px, 202.99000549316406px) scale(0.8, 0.8) translate(-202.99000549316406px, -202.99000549316406px)\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$u = undefined;
/* module identifier */

var __vue_module_identifier__$u = undefined;
/* functional template */

var __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);

var script$t = Vue.extend({
  name: 'LoadingRow',
  components: {
    LoadingIcon: __vue_component__$u
  },
  props: {
    instance: Object
  }
});
/* script */

var __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function __vue_render__$t() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-loading-row flex flex-row justify-center text-blue fill-current py-3"
  }, [_c("loading-icon")], 1);
};

var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;
/* style */

var __vue_inject_styles__$t = undefined;
/* scoped */

var __vue_scope_id__$t = undefined;
/* module identifier */

var __vue_module_identifier__$t = undefined;
/* functional template */

var __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var script$s = Vue.extend({
  name: 'Pagination',
  props: {
    page: Number,
    pages: Number,
    gap: Number,
    offset: {
      type: Number,
      "default": 1
    },
    variant: {
      type: String,
      "default": 'none'
    }
  },
  methods: {
    clickedBack: function clickedBack() {
      if (this.page > 0) {
        this.$emit('update:page', this.page - 1);
      }
    },
    clickedIndex: function clickedIndex(index) {
      this.$emit('update:page', this.range.start + index);
    },
    clickedNext: function clickedNext() {
      if (this.page < this.pages - 1) {
        this.$emit('update:page', this.page + 1);
      }
    },
    clickedLast: function clickedLast() {
      if (this.page < this.pages - 1) {
        this.$emit('update:page', this.pages - 1);
      }
    },
    clickedFirst: function clickedFirst() {
      if (this.page > 0) {
        this.$emit('update:page', 0);
      }
    }
  },
  computed: {
    range: function range() {
      var length = Number(this.gap * 2 + 1 > this.pages ? this.pages : this.gap * 2 + 1);

      if (this.page <= this.gap) {
        return {
          start: 0,
          length: length
        };
      }

      if (this.page >= this.pages - this.gap) {
        return {
          start: this.pages - length,
          length: length
        };
      }

      return {
        start: this.page - this.gap,
        length: length
      };
    }
  }
});
/* script */

var __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function __vue_render__$s() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "flex flex-row items-center justify-between",
    "class": {
      "text-base": _vm.variant !== "dotted"
    }
  }, [_vm.variant === "dotted" ? _c("div", {
    staticClass: "cursor-pointer py-1 px-2 text-blue",
    "class": {
      "sb-disabled": _vm.page === 0
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedBack.apply(null, arguments);
      }
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fas", "chevron-left"]
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.variant !== "dotted" && _vm.page !== 0 ? [_c("div", {
    staticClass: "cursor-pointer py-1 px-2.5 transition-all duration-200 text-black-light hover:bg-blue hover:text-white",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedFirst.apply(null, arguments);
      }
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "chevrons-left"]
    }
  }), _vm._v("\n      first\n    ")], 1), _vm._v(" "), _c("div", {
    staticClass: "cursor-pointer py-1 px-2.5 transition-all duration-200 text-black-light hover:bg-blue hover:text-white",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedBack.apply(null, arguments);
      }
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "chevron-left"]
    }
  }), _vm._v("\n      prev\n    ")], 1)] : _vm._e(), _vm._v(" "), _vm._l(_vm.range.length, function (_, index) {
    return [_c("div", {
      key: index,
      staticClass: "cursor-pointer py-1 px-2.5 transition-all duration-200",
      "class": {
        "text-blue text-xs": _vm.variant === "dotted",
        "text-black-light": _vm.variant !== "dotted",
        "bg-blue bg-opacity-15": _vm.page === _vm.range.start + index && _vm.variant !== "dotted",
        "hover:bg-blue": _vm.variant !== "dotted",
        "hover:text-white": _vm.variant !== "dotted",
        "text-xl": _vm.page === _vm.range.start + index && _vm.variant === "dotted"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.clickedIndex(index);
        }
      }
    }, [_vm.variant === "none" ? _c("span", [_vm._v(_vm._s(index + _vm.range.start + _vm.offset))]) : _vm._e(), _vm._v(" "), _vm.variant === "dotted" ? _c("fai", {
      attrs: {
        icon: ["fas", "circle"]
      }
    }) : _vm._e()], 1)];
  }), _vm._v(" "), _vm.variant !== "dotted" && _vm.page < _vm.pages - 1 ? [_c("div", {
    staticClass: "cursor-pointer py-1 px-2.5 transition-all duration-200 text-black-light hover:bg-blue hover:text-white",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedNext.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      next\n      "), _c("fai", {
    attrs: {
      icon: ["fal", "chevron-right"]
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "cursor-pointer py-1 px-2.5 transition-all duration-200 text-black-light hover:bg-blue hover:text-white",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedLast.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      last\n      "), _c("fai", {
    attrs: {
      icon: ["fal", "chevrons-right"]
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm.variant === "dotted" ? _c("div", {
    staticClass: "cursor-pointer py-1 px-2 text-blue",
    "class": {
      "sb-disabled": _vm.page === _vm.pages - 1
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.clickedNext.apply(null, arguments);
      }
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fas", "chevron-right"]
    }
  })], 1) : _vm._e()], 2);
};

var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;
/* style */

var __vue_inject_styles__$s = undefined;
/* scoped */

var __vue_scope_id__$s = undefined;
/* module identifier */

var __vue_module_identifier__$s = undefined;
/* functional template */

var __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var script$r = Vue.extend({
  name: 'PaginationRow',
  components: {
    Pagination: __vue_component__$s
  },
  props: {
    instance: Object
  },
  methods: {
    updatePage: function updatePage(page) {
      this.instance.page = page;
      this.instance.updated(page, this.instance);
    }
  }
});
/* script */

var __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function __vue_render__$r() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("pagination", {
    staticClass: "sb-pagination-row",
    attrs: {
      page: _vm.instance.page,
      pages: _vm.instance.pages,
      gap: _vm.instance.gap,
      variant: _vm.instance.variant
    },
    on: {
      "update:page": _vm.updatePage
    }
  });
};

var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;
/* style */

var __vue_inject_styles__$r = undefined;
/* scoped */

var __vue_scope_id__$r = undefined;
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var ClickHandlers = new Map();
var ClickOutside = {
  bind: function bind(el, binding) {
    ClickHandlers.set(el, function (event) {
      if (!el.contains(event.target)) {
        binding.value();
      }
    });
    window.addEventListener("click", ClickHandlers.get(el));
  },
  unbind: function unbind(el) {
    window.removeEventListener("click", ClickHandlers.get(el));
    ClickHandlers["delete"](el);
  }
};
var Lifecycle;

(function (Lifecycle) {
  Lifecycle[Lifecycle["Transient"] = 0] = "Transient";
  Lifecycle[Lifecycle["Singleton"] = 1] = "Singleton";
  Lifecycle[Lifecycle["ResolutionScoped"] = 2] = "ResolutionScoped";
  Lifecycle[Lifecycle["ContainerScoped"] = 3] = "ContainerScoped";
})(Lifecycle || (Lifecycle = {}));

var Lifecycle$1 = Lifecycle;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

function isClassProvider(provider) {
  return !!provider.useClass;
}

function isFactoryProvider(provider) {
  return !!provider.useFactory;
}

var DelayedConstructor = function () {
  function DelayedConstructor(wrap) {
    this.wrap = wrap;
    this.reflectMethods = ["get", "getPrototypeOf", "setPrototypeOf", "getOwnPropertyDescriptor", "defineProperty", "has", "set", "deleteProperty", "apply", "construct", "ownKeys"];
  }

  DelayedConstructor.prototype.createProxy = function (createObject) {
    var _this = this;

    var target = {};
    var init = false;
    var value;

    var delayedObject = function delayedObject() {
      if (!init) {
        value = createObject(_this.wrap());
        init = true;
      }

      return value;
    };

    return new Proxy(target, this.createHandler(delayedObject));
  };

  DelayedConstructor.prototype.createHandler = function (delayedObject) {
    var handler = {};

    var install = function install(name) {
      handler[name] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        args[0] = delayedObject();
        var method = Reflect[name];
        return method.apply(void 0, __spread(args));
      };
    };

    this.reflectMethods.forEach(install);
    return handler;
  };

  return DelayedConstructor;
}();

function isNormalToken(token) {
  return typeof token === "string" || _typeof(token) === "symbol";
}

function isTokenDescriptor(descriptor) {
  return _typeof(descriptor) === "object" && "token" in descriptor && "multiple" in descriptor;
}

function isTransformDescriptor(descriptor) {
  return _typeof(descriptor) === "object" && "token" in descriptor && "transform" in descriptor;
}

function isConstructorToken(token) {
  return typeof token === "function" || token instanceof DelayedConstructor;
}

function isTokenProvider(provider) {
  return !!provider.useToken;
}

function isValueProvider(provider) {
  return provider.useValue != undefined;
}

function isProvider(provider) {
  return isClassProvider(provider) || isValueProvider(provider) || isTokenProvider(provider) || isFactoryProvider(provider);
}

var RegistryBase = function () {
  function RegistryBase() {
    this._registryMap = new Map();
  }

  RegistryBase.prototype.entries = function () {
    return this._registryMap.entries();
  };

  RegistryBase.prototype.getAll = function (key) {
    this.ensure(key);
    return this._registryMap.get(key);
  };

  RegistryBase.prototype.get = function (key) {
    this.ensure(key);

    var value = this._registryMap.get(key);

    return value[value.length - 1] || null;
  };

  RegistryBase.prototype.set = function (key, value) {
    this.ensure(key);

    this._registryMap.get(key).push(value);
  };

  RegistryBase.prototype.setAll = function (key, value) {
    this._registryMap.set(key, value);
  };

  RegistryBase.prototype.has = function (key) {
    this.ensure(key);
    return this._registryMap.get(key).length > 0;
  };

  RegistryBase.prototype.clear = function () {
    this._registryMap.clear();
  };

  RegistryBase.prototype.ensure = function (key) {
    if (!this._registryMap.has(key)) {
      this._registryMap.set(key, []);
    }
  };

  return RegistryBase;
}();

var Registry$1 = function (_super) {
  __extends(Registry, _super);

  function Registry() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return Registry;
}(RegistryBase);

var ResolutionContext = function () {
  function ResolutionContext() {
    this.scopedResolutions = new Map();
  }

  return ResolutionContext;
}();

function formatDependency(params, idx) {
  if (params === null) {
    return "at position #" + idx;
  }

  var argName = params.split(",")[idx].trim();
  return "\"" + argName + "\" at position #" + idx;
}

function composeErrorMessage(msg, e, indent) {
  if (indent === void 0) {
    indent = "    ";
  }

  return __spread([msg], e.message.split("\n").map(function (l) {
    return indent + l;
  })).join("\n");
}

function formatErrorCtor(ctor, paramIdx, error) {
  var _a = __read(ctor.toString().match(/constructor\(([\w, ]+)\)/) || [], 2),
      _b = _a[1],
      params = _b === void 0 ? null : _b;

  var dep = formatDependency(params, paramIdx);
  return composeErrorMessage("Cannot inject the dependency " + dep + " of \"" + ctor.name + "\" constructor. Reason:", error);
}

var PreResolutionInterceptors = function (_super) {
  __extends(PreResolutionInterceptors, _super);

  function PreResolutionInterceptors() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return PreResolutionInterceptors;
}(RegistryBase);

var PostResolutionInterceptors = function (_super) {
  __extends(PostResolutionInterceptors, _super);

  function PostResolutionInterceptors() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return PostResolutionInterceptors;
}(RegistryBase);

var Interceptors = function () {
  function Interceptors() {
    this.preResolution = new PreResolutionInterceptors();
    this.postResolution = new PostResolutionInterceptors();
  }

  return Interceptors;
}();

var typeInfo = new Map();

var InternalDependencyContainer = function () {
  function InternalDependencyContainer(parent) {
    this.parent = parent;
    this._registry = new Registry$1();
    this.interceptors = new Interceptors();
  }

  InternalDependencyContainer.prototype.register = function (token, providerOrConstructor, options) {
    if (options === void 0) {
      options = {
        lifecycle: Lifecycle$1.Transient
      };
    }

    var provider;

    if (!isProvider(providerOrConstructor)) {
      provider = {
        useClass: providerOrConstructor
      };
    } else {
      provider = providerOrConstructor;
    }

    if (isTokenProvider(provider)) {
      var path = [token];
      var tokenProvider = provider;

      while (tokenProvider != null) {
        var currentToken = tokenProvider.useToken;

        if (path.includes(currentToken)) {
          throw new Error("Token registration cycle detected! " + __spread(path, [currentToken]).join(" -> "));
        }

        path.push(currentToken);

        var registration = this._registry.get(currentToken);

        if (registration && isTokenProvider(registration.provider)) {
          tokenProvider = registration.provider;
        } else {
          tokenProvider = null;
        }
      }
    }

    if (options.lifecycle === Lifecycle$1.Singleton || options.lifecycle == Lifecycle$1.ContainerScoped || options.lifecycle == Lifecycle$1.ResolutionScoped) {
      if (isValueProvider(provider) || isFactoryProvider(provider)) {
        throw new Error("Cannot use lifecycle \"" + Lifecycle$1[options.lifecycle] + "\" with ValueProviders or FactoryProviders");
      }
    }

    this._registry.set(token, {
      provider: provider,
      options: options
    });

    return this;
  };

  InternalDependencyContainer.prototype.registerType = function (from, to) {
    if (isNormalToken(to)) {
      return this.register(from, {
        useToken: to
      });
    }

    return this.register(from, {
      useClass: to
    });
  };

  InternalDependencyContainer.prototype.registerInstance = function (token, instance) {
    return this.register(token, {
      useValue: instance
    });
  };

  InternalDependencyContainer.prototype.registerSingleton = function (from, to) {
    if (isNormalToken(from)) {
      if (isNormalToken(to)) {
        return this.register(from, {
          useToken: to
        }, {
          lifecycle: Lifecycle$1.Singleton
        });
      } else if (to) {
        return this.register(from, {
          useClass: to
        }, {
          lifecycle: Lifecycle$1.Singleton
        });
      }

      throw new Error('Cannot register a type name as a singleton without a "to" token');
    }

    var useClass = from;

    if (to && !isNormalToken(to)) {
      useClass = to;
    }

    return this.register(from, {
      useClass: useClass
    }, {
      lifecycle: Lifecycle$1.Singleton
    });
  };

  InternalDependencyContainer.prototype.resolve = function (token, context) {
    if (context === void 0) {
      context = new ResolutionContext();
    }

    var registration = this.getRegistration(token);

    if (!registration && isNormalToken(token)) {
      throw new Error("Attempted to resolve unregistered dependency token: \"" + token.toString() + "\"");
    }

    this.executePreResolutionInterceptor(token, "Single");

    if (registration) {
      var result = this.resolveRegistration(registration, context);
      this.executePostResolutionInterceptor(token, result, "Single");
      return result;
    }

    if (isConstructorToken(token)) {
      var result = this.construct(token, context);
      this.executePostResolutionInterceptor(token, result, "Single");
      return result;
    }

    throw new Error("Attempted to construct an undefined constructor. Could mean a circular dependency problem. Try using `delay` function.");
  };

  InternalDependencyContainer.prototype.executePreResolutionInterceptor = function (token, resolutionType) {
    var e_1, _a;

    if (this.interceptors.preResolution.has(token)) {
      var remainingInterceptors = [];

      try {
        for (var _b = __values(this.interceptors.preResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var interceptor = _c.value;

          if (interceptor.options.frequency != "Once") {
            remainingInterceptors.push(interceptor);
          }

          interceptor.callback(token, resolutionType);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      this.interceptors.preResolution.setAll(token, remainingInterceptors);
    }
  };

  InternalDependencyContainer.prototype.executePostResolutionInterceptor = function (token, result, resolutionType) {
    var e_2, _a;

    if (this.interceptors.postResolution.has(token)) {
      var remainingInterceptors = [];

      try {
        for (var _b = __values(this.interceptors.postResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var interceptor = _c.value;

          if (interceptor.options.frequency != "Once") {
            remainingInterceptors.push(interceptor);
          }

          interceptor.callback(token, result, resolutionType);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      this.interceptors.postResolution.setAll(token, remainingInterceptors);
    }
  };

  InternalDependencyContainer.prototype.resolveRegistration = function (registration, context) {
    if (registration.options.lifecycle === Lifecycle$1.ResolutionScoped && context.scopedResolutions.has(registration)) {
      return context.scopedResolutions.get(registration);
    }

    var isSingleton = registration.options.lifecycle === Lifecycle$1.Singleton;
    var isContainerScoped = registration.options.lifecycle === Lifecycle$1.ContainerScoped;
    var returnInstance = isSingleton || isContainerScoped;
    var resolved;

    if (isValueProvider(registration.provider)) {
      resolved = registration.provider.useValue;
    } else if (isTokenProvider(registration.provider)) {
      resolved = returnInstance ? registration.instance || (registration.instance = this.resolve(registration.provider.useToken, context)) : this.resolve(registration.provider.useToken, context);
    } else if (isClassProvider(registration.provider)) {
      resolved = returnInstance ? registration.instance || (registration.instance = this.construct(registration.provider.useClass, context)) : this.construct(registration.provider.useClass, context);
    } else if (isFactoryProvider(registration.provider)) {
      resolved = registration.provider.useFactory(this);
    } else {
      resolved = this.construct(registration.provider, context);
    }

    if (registration.options.lifecycle === Lifecycle$1.ResolutionScoped) {
      context.scopedResolutions.set(registration, resolved);
    }

    return resolved;
  };

  InternalDependencyContainer.prototype.resolveAll = function (token, context) {
    var _this = this;

    if (context === void 0) {
      context = new ResolutionContext();
    }

    var registrations = this.getAllRegistrations(token);

    if (!registrations && isNormalToken(token)) {
      throw new Error("Attempted to resolve unregistered dependency token: \"" + token.toString() + "\"");
    }

    this.executePreResolutionInterceptor(token, "All");

    if (registrations) {
      var result_1 = registrations.map(function (item) {
        return _this.resolveRegistration(item, context);
      });
      this.executePostResolutionInterceptor(token, result_1, "All");
      return result_1;
    }

    var result = [this.construct(token, context)];
    this.executePostResolutionInterceptor(token, result, "All");
    return result;
  };

  InternalDependencyContainer.prototype.isRegistered = function (token, recursive) {
    if (recursive === void 0) {
      recursive = false;
    }

    return this._registry.has(token) || recursive && (this.parent || false) && this.parent.isRegistered(token, true);
  };

  InternalDependencyContainer.prototype.reset = function () {
    this._registry.clear();

    this.interceptors.preResolution.clear();
    this.interceptors.postResolution.clear();
  };

  InternalDependencyContainer.prototype.clearInstances = function () {
    var e_3, _a;

    try {
      for (var _b = __values(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read(_c.value, 2),
            token = _d[0],
            registrations = _d[1];

        this._registry.setAll(token, registrations.filter(function (registration) {
          return !isValueProvider(registration.provider);
        }).map(function (registration) {
          registration.instance = undefined;
          return registration;
        }));
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };

  InternalDependencyContainer.prototype.createChildContainer = function () {
    var e_4, _a;

    var childContainer = new InternalDependencyContainer(this);

    try {
      for (var _b = __values(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read(_c.value, 2),
            token = _d[0],
            registrations = _d[1];

        if (registrations.some(function (_a) {
          var options = _a.options;
          return options.lifecycle === Lifecycle$1.ContainerScoped;
        })) {
          childContainer._registry.setAll(token, registrations.map(function (registration) {
            if (registration.options.lifecycle === Lifecycle$1.ContainerScoped) {
              return {
                provider: registration.provider,
                options: registration.options
              };
            }

            return registration;
          }));
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    return childContainer;
  };

  InternalDependencyContainer.prototype.beforeResolution = function (token, callback, options) {
    if (options === void 0) {
      options = {
        frequency: "Always"
      };
    }

    this.interceptors.preResolution.set(token, {
      callback: callback,
      options: options
    });
  };

  InternalDependencyContainer.prototype.afterResolution = function (token, callback, options) {
    if (options === void 0) {
      options = {
        frequency: "Always"
      };
    }

    this.interceptors.postResolution.set(token, {
      callback: callback,
      options: options
    });
  };

  InternalDependencyContainer.prototype.getRegistration = function (token) {
    if (this.isRegistered(token)) {
      return this._registry.get(token);
    }

    if (this.parent) {
      return this.parent.getRegistration(token);
    }

    return null;
  };

  InternalDependencyContainer.prototype.getAllRegistrations = function (token) {
    if (this.isRegistered(token)) {
      return this._registry.getAll(token);
    }

    if (this.parent) {
      return this.parent.getAllRegistrations(token);
    }

    return null;
  };

  InternalDependencyContainer.prototype.construct = function (ctor, context) {
    var _this = this;

    if (ctor instanceof DelayedConstructor) {
      return ctor.createProxy(function (target) {
        return _this.resolve(target, context);
      });
    }

    var paramInfo = typeInfo.get(ctor);

    if (!paramInfo || paramInfo.length === 0) {
      if (ctor.length === 0) {
        return new ctor();
      } else {
        throw new Error("TypeInfo not known for \"" + ctor.name + "\"");
      }
    }

    var params = paramInfo.map(this.resolveParams(context, ctor));
    return new (ctor.bind.apply(ctor, __spread([void 0], params)))();
  };

  InternalDependencyContainer.prototype.resolveParams = function (context, ctor) {
    var _this = this;

    return function (param, idx) {
      var _a, _b, _c;

      try {
        if (isTokenDescriptor(param)) {
          if (isTransformDescriptor(param)) {
            return param.multiple ? (_a = _this.resolve(param.transform)).transform.apply(_a, __spread([_this.resolveAll(param.token)], param.transformArgs)) : (_b = _this.resolve(param.transform)).transform.apply(_b, __spread([_this.resolve(param.token, context)], param.transformArgs));
          } else {
            return param.multiple ? _this.resolveAll(param.token) : _this.resolve(param.token, context);
          }
        } else if (isTransformDescriptor(param)) {
          return (_c = _this.resolve(param.transform, context)).transform.apply(_c, __spread([_this.resolve(param.token, context)], param.transformArgs));
        }

        return _this.resolve(param, context);
      } catch (e) {
        throw new Error(formatErrorCtor(ctor, idx, e));
      }
    };
  };

  return InternalDependencyContainer;
}();

var instance = new InternalDependencyContainer();

if (typeof Reflect === "undefined" || !Reflect.getMetadata) {
  throw new Error("tsyringe requires a reflect polyfill. Please add 'import \"reflect-metadata\"' to the top of your entry point.");
}

var tokens = {
  store: Symbol('store'),
  rollbar: Symbol('rollbar')
};
var Unsubscribers$1 = new Map();
var Touch = {
  bind: function bind(el, binding) {
    var store = instance.resolve(tokens.store);
    var field = binding.arg;

    if (!field) {
      throw new Error('Must specify a field as an arg in Touch directive');
    }

    if (!store.getters.touched(field)) {
      var handler = function handler() {
        store.dispatch('TOUCH_FIELDS', [field]);
        el.classList.add('touched');
        el.removeEventListener("focusout", handler);
      };

      el.addEventListener("focusout", handler);
      var unsubscriber = store.watch(function (_, getters) {
        return getters.touched(field);
      }, function () {
        el.classList.add('touched');
        unsubscriber();
        Unsubscribers$1["delete"](el);
      });
      Unsubscribers$1.set(el, unsubscriber);
    }
  },
  unbind: function unbind(el) {
    if (Unsubscribers$1.has(el)) {
      var unsubscriber = Unsubscribers$1.get(el);
      unsubscriber();
      Unsubscribers$1["delete"](el);
    }
  }
};
var Unsubscribers = new Map();
var HasError = {
  bind: function bind(el, binding) {
    var store = instance.resolve(tokens.store);
    var field = binding.arg;

    if (!field) {
      throw new Error('Must specify a field as an arg in HasError directive');
    }
    /**
     * Watch for errors and apply error class
     */


    var unsubscriber = store.watch(function (_, getters) {
      return getters.touchedAndErrored(field);
    }, function (hasError) {
      if (hasError) {
        el.classList.add('has-error');
      } else {
        el.classList.remove('has-error');
      }

      if (typeof binding.value === 'function') {
        binding.value(store.state.validation[field]);
      }
    }, {
      immediate: true
    });
    Unsubscribers.set(el, unsubscriber);
  },
  update: function update(el, binding) {
    var store = instance.resolve(tokens.store);
    var field = binding.arg;
    /**
     * Since this class is added outside of Vue, we need to make sure it stays by checking it on updates
     */

    if (store.getters.touchedAndErrored(field) && !el.classList.contains('has-error')) {
      el.classList.add('has-error');
    }
  },
  unbind: function unbind(el) {
    var unsubscriber = Unsubscribers.get(el);
    unsubscriber();
    Unsubscribers["delete"](el);
  }
};
var script$q = Vue.extend({
  directives: {
    ClickOutside: ClickOutside
  },
  components: {
    BackRow: __vue_component__$z,
    ParentRow: __vue_component__$E,
    QueryRow: __vue_component__$D,
    MultiSelectRow: __vue_component__$B,
    SelectRow: __vue_component__$A,
    DateRangeRow: __vue_component__$x,
    TextRow: __vue_component__$w,
    LineBreakRow: __vue_component__$v,
    LoadingRow: __vue_component__$t,
    PaginationRow: __vue_component__$r
  },
  name: 'dropdown',
  methods: {
    clickedTab: function clickedTab(tab) {
      this.$emit('update:selected', tab);
    }
  },
  props: {
    focused: Boolean,
    rows: Array,
    headerRows: Array,
    footerRows: Array,
    variant: {
      type: String,
      "default": 'default'
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    truncateLabel: {
      type: Boolean,
      "default": true
    },
    hideArrow: {
      type: Boolean,
      "default": false
    }
  }
});
/* script */

var __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function __vue_render__$q() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: function value() {
        _vm.focused && _vm.$emit("update:focused", false);
      },
      expression: "() => { focused && $emit('update:focused', false) }"
    }],
    staticClass: "sb-dropdown relative flex flex-col flex-inline items-stretch rounded",
    "class": ["variant-" + _vm.variant, {
      focused: _vm.focused,
      disabled: _vm.disabled
    }]
  }, [_vm._t("sb-label-container", function () {
    return [_c("section", {
      staticClass: "sb-label-container h-full",
      on: {
        click: function click($event) {
          !_vm.disabled && _vm.$emit("update:focused", !_vm.focused);
        }
      }
    }, [_c("div", {
      staticClass: "sb-label-wrapper rounded cursor-pointer h-full flex flex-row items-center justify-between",
      "class": {
        "rounded-b-none": _vm.focused,
        "primary-div": _vm.variant === "button"
      }
    }, [_c("span", {
      staticClass: "sb-dropdown-label",
      "class": {
        truncate: _vm.truncateLabel
      }
    }, [_vm._t("label", function () {
      return [_vm._v("\n            No slot defined for #label\n          ")];
    })], 2), _vm._v(" "), !_vm.hideArrow ? _c("fai", {
      staticClass: "sb-dropdown-arrow ml-2",
      "class": _vm.focused ? "sb-chevron-up" : "sb-chevron-down",
      attrs: {
        icon: ["fal", "chevron-up"]
      }
    }) : _vm._e()], 1)])];
  }), _vm._v(" "), _c("section", {
    staticClass: "sb-rows relative w-full"
  }, [_vm.focused ? _c("div", {
    staticClass: "sb-rows-container bg-white border border-solid rounded rounded-t-none border-t-0 box-border absolute left-0 right-0 py-3"
  }, [_vm._l([{
    rows: _vm.headerRows,
    sectionClass: "header-rows"
  }, {
    rows: _vm.rows,
    sectionClass: "body-rows"
  }, {
    rows: _vm.footerRows,
    sectionClass: "footer-rows"
  }], function (ref) {
    var rows = ref.rows;
    var sectionClass = ref.sectionClass;
    return [rows ? _c("section", {
      "class": sectionClass
    }, [_vm._l(rows, function (row, index) {
      return [_typeof(row) === "object" && typeof row.slot !== "string" && _typeof(row.state) !== "object" ? _c(row.component, {
        key: index + " - " + row.component,
        tag: "component",
        attrs: {
          instance: row
        }
      }) : _vm._e(), _vm._v(" "), _typeof(row) === "object" && typeof row.slot === "string" && _typeof(row.state) === "object" ? _vm._t(row.slot, null, {
        state: row.state
      }) : _vm._e(), _vm._v(" "), typeof row === "string" ? _vm._t(row) : _vm._e()];
    })], 2) : _vm._e()];
  })], 2) : _vm._e()])], 2);
};

var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;
/* style */

var __vue_inject_styles__$q = function __vue_inject_styles__$q(inject) {
  if (!inject) return;
  inject("data-v-6f6684fa_0", {
    source: ".sb-rows-container[data-v-6f6684fa] {\n  z-index: 11;\n  white-space: normal;\n}\n.variant-default .sb-label-container > div[data-v-6f6684fa] {\n  padding: 0.5rem 0.75rem;\n  color: #128ff9;\n  border: 1px solid #128ff9;\n  background-color: #fff;\n}\n.variant-contained .sb-label-container > div[data-v-6f6684fa] {\n  padding: 0.5rem 0.75rem;\n  color: #fff;\n  background-color: #128ff9;\n}\n.variant-outlined .sb-label-container > div[data-v-6f6684fa] {\n  padding: 0.5rem 0.75rem;\n  color: #128ff9;\n  border: 1px solid #128ff9;\n  background-color: #fff;\n}\n.variant-outlined.focused .sb-label-container > div[data-v-6f6684fa] {\n  border-bottom-color: transparent;\n}\n.variant-outlined.focused .sb-rows-container[data-v-6f6684fa] {\n  padding-top: 0;\n}\n.variant-inline[data-v-6f6684fa] {\n  display: inline-block;\n  margin: 0;\n}\n.variant-inline.disabled .sb-label-container > div[data-v-6f6684fa] {\n  border: none;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n.variant-inline .sb-rows-container[data-v-6f6684fa] {\n  text-align: left;\n  width: 250px;\n  /* min-width: auto; */\n  left: calc(50% - 125px);\n  border-radius: 8px;\n  border-top-width: 1px;\n  margin-top: 5px;\n}\n.variant-button .sb-label-container > div[data-v-6f6684fa] {\n  justify-content: center;\n}\n.disabled > .sb-label-container > div[data-v-6f6684fa] {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  color: #adadad;\n  cursor: not-allowed;\n}\n.sb-chevron-down[data-v-6f6684fa] {\n  transform: rotate(180deg);\n}\n.sb-dropdown-arrow[data-v-6f6684fa] {\n  transition: transform 0.2s;\n  font-size: 1.2rem;\n}\n.sb-rows-container .sb-select-row.disabled[data-v-6f6684fa] {\n  color: #aaa;\n  cursor: default;\n}\n\n/*# sourceMappingURL=Dropdown.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/dropdown/Dropdown.vue", "Dropdown.vue"],
      "names": [],
      "mappings": "AA+HA;EACA,WAAA;EACA,mBAAA;AC9HA;ADiIA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AC9HA;ADkIA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AC/HA;ADmIA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AChIA;ADmIA;EACA,gCAAA;ACjIA;ADmIA;EACA,cAAA;ACjIA;ADqIA;EACA,qBAAA;EACA,SAAA;AClIA;ADmIA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;ACjIA;ADmIA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;ACjIA;ADqIA;EACA,uBAAA;AClIA;ADqIA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AClIA;ADoIA;EACA,yBAAA;ACjIA;ADmIA;EACA,0BAAA;EACA,iBAAA;AChIA;ADmIA;EACA,WAAA;EACA,eAAA;AChIA;;AAEA,uCAAuC",
      "file": "Dropdown.vue",
      "sourcesContent": ["<template>\n  <main class=\"sb-dropdown relative flex flex-col flex-inline items-stretch rounded\" :class=\"[`variant-${variant}`, {focused, disabled}]\" v-click-outside=\"() => { focused && $emit('update:focused', false) }\">\n    <slot name=\"sb-label-container\">\n      <section class=\"sb-label-container h-full\" @click=\"!disabled && $emit('update:focused', !focused)\">\n        <div\n          class=\"sb-label-wrapper rounded cursor-pointer h-full flex flex-row items-center justify-between\"\n          :class=\"{\n            'rounded-b-none': focused,\n            'primary-div': variant === 'button'\n          }\"\n        >\n          <span class=\"sb-dropdown-label\" :class=\"{truncate: truncateLabel}\">\n            <slot name=\"label\">\n              No slot defined for #label\n            </slot>\n          </span>\n\n          <fai v-if=\"!hideArrow\" \n               :icon=\"['fal', 'chevron-up']\"\n               :class=\"focused ? 'sb-chevron-up' : 'sb-chevron-down'\"\n               class=\"sb-dropdown-arrow ml-2\" \n          />\n        </div>\n      </section>\n    </slot>\n    \n    <section class='sb-rows relative w-full'>\n      <div v-if=\"focused\" class=\"sb-rows-container bg-white border border-solid rounded rounded-t-none border-t-0 box-border absolute left-0 right-0 py-3\">\n        <template v-for=\"{rows, sectionClass} in [\n            {rows:headerRows, sectionClass:'header-rows'},\n            {rows, sectionClass:'body-rows'},\n            {rows:footerRows, sectionClass:'footer-rows'}\n          ]\"\n        >\n          <section :class=\"sectionClass\" v-if=\"rows\">\n            <template v-for=\"(row, index) in rows\">\n              <component\n                  v-if=\"typeof row === 'object' && typeof row.slot !== 'string' && typeof row.state !== 'object'\"\n                  :is=\"row.component\"\n                  :instance=\"row\"\n                  :key=\"index + ' - ' + row.component\"\n              />\n              <slot\n                  v-if=\"typeof row === 'object' && typeof row.slot === 'string' && typeof row.state === 'object'\"\n                  :name=\"row.slot\"\n                  :state=\"row.state\"\n              />\n              <slot\n                  v-if=\"typeof row === 'string'\"\n                  :name=\"row\"\n              />\n            </template>\n          </section>\n        </template>\n      </div>\n    </section>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue, { PropType } from \"vue\";\n\nimport ParentRow from \"./slots/ParentRow.vue\";\nimport QueryRow from \"./slots/QueryRow.vue\";\nimport MultiSelectRow from \"./slots/MultiSelectRow.vue\";\nimport SelectRow from \"./slots/SelectRow.vue\";\nimport BackRow from \"./slots/BackRow.vue\";\nimport DateRangeRow from \"./slots/DateRangeRow.vue\";\nimport TextRow from \"./slots/TextRow.vue\";\nimport LineBreakRow from \"./slots/LineBreakRow.vue\";\nimport LoadingRow from \"./slots/LoadingRow.vue\";\nimport PaginationRow from \"./slots/PaginationRow.vue\";\nimport {DropdownVariants} from \"@/types\";\n\nimport { ClickOutside } from \"@/directives\";\n\nexport interface Tab {\n  label: string;\n  key: string;\n}\n\nexport default Vue.extend({\n  directives: { ClickOutside },\n  components: {\n    BackRow, \n    ParentRow, \n    QueryRow, \n    MultiSelectRow, \n    SelectRow, \n    DateRangeRow, \n    TextRow, \n    LineBreakRow, \n    LoadingRow, \n    PaginationRow \n  },\n  name: 'dropdown',\n  methods: {\n    clickedTab(tab: Tab) {\n      this.$emit('update:selected', tab);\n    }\n  },\n  props: {\n    focused: Boolean,\n    rows: Array as PropType<Array<any>>,\n    headerRows: Array as PropType<Array<any>>,\n    footerRows: Array as PropType<Array<any>>,\n    variant: {\n      type: String as PropType<DropdownVariants>,\n      default: 'default'\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    truncateLabel: {\n      type: Boolean,\n      default: true\n    },\n    hideArrow: {\n      type: Boolean,\n      default: false\n    }\n  }\n});\n</script>\n\n<style lang=\"scss\" scoped>\n.sb-rows-container {\n  z-index: 11;\n  white-space: normal;\n}\n.variant-default {\n  .sb-label-container > div {\n    padding: .5rem .75rem;\n    color: #128ff9;\n    border: 1px solid #128ff9;\n    background-color: #fff;\n  }\n}\n.variant-contained {\n  .sb-label-container > div {\n    padding: .5rem .75rem;\n    color: #fff;\n    background-color: #128ff9;\n  }\n}\n.variant-outlined {\n  .sb-label-container > div {\n    padding: .5rem .75rem;\n    color: #128ff9;\n    border: 1px solid #128ff9;\n    background-color: #fff;\n  }\n  &.focused {\n    .sb-label-container > div {\n      border-bottom-color: transparent;\n    }\n    .sb-rows-container {\n      padding-top: 0;\n    }\n  }\n}\n.variant-inline {\n  display: inline-block;\n  margin: 0;\n  &.disabled .sb-label-container > div {\n    border: none;\n    background-color: transparent;\n    cursor: not-allowed;\n  }\n  .sb-rows-container {\n    text-align: left;\n    width: 250px;\n    /* min-width: auto; */\n    left: calc(50% - 125px);\n    border-radius: 8px;\n    border-top-width: 1px;\n    margin-top: 5px;\n  }\n}\n.variant-button {\n  .sb-label-container > div {\n    justify-content: center;\n  }\n}\n.disabled > .sb-label-container > div {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  color: #adadad;\n  cursor: not-allowed;\n}\n.sb-chevron-down {\n  transform: rotate(180deg);\n}\n.sb-dropdown-arrow {\n  transition: transform .2s;\n  font-size: 1.2rem;\n}\n.sb-rows-container {\n  .sb-select-row.disabled {\n    color: #aaa;\n    cursor: default;\n  }\n}\n</style>", ".sb-rows-container {\n  z-index: 11;\n  white-space: normal;\n}\n\n.variant-default .sb-label-container > div {\n  padding: 0.5rem 0.75rem;\n  color: #128ff9;\n  border: 1px solid #128ff9;\n  background-color: #fff;\n}\n\n.variant-contained .sb-label-container > div {\n  padding: 0.5rem 0.75rem;\n  color: #fff;\n  background-color: #128ff9;\n}\n\n.variant-outlined .sb-label-container > div {\n  padding: 0.5rem 0.75rem;\n  color: #128ff9;\n  border: 1px solid #128ff9;\n  background-color: #fff;\n}\n.variant-outlined.focused .sb-label-container > div {\n  border-bottom-color: transparent;\n}\n.variant-outlined.focused .sb-rows-container {\n  padding-top: 0;\n}\n\n.variant-inline {\n  display: inline-block;\n  margin: 0;\n}\n.variant-inline.disabled .sb-label-container > div {\n  border: none;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n.variant-inline .sb-rows-container {\n  text-align: left;\n  width: 250px;\n  /* min-width: auto; */\n  left: calc(50% - 125px);\n  border-radius: 8px;\n  border-top-width: 1px;\n  margin-top: 5px;\n}\n\n.variant-button .sb-label-container > div {\n  justify-content: center;\n}\n\n.disabled > .sb-label-container > div {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  color: #adadad;\n  cursor: not-allowed;\n}\n\n.sb-chevron-down {\n  transform: rotate(180deg);\n}\n\n.sb-dropdown-arrow {\n  transition: transform 0.2s;\n  font-size: 1.2rem;\n}\n\n.sb-rows-container .sb-select-row.disabled {\n  color: #aaa;\n  cursor: default;\n}\n\n/*# sourceMappingURL=Dropdown.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$q = "data-v-6f6684fa";
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ParentRow = function ParentRow(state) {
  _classCallCheck(this, ParentRow);

  _defineProperty(this, "component", "ParentRow");

  Object.assign(this, state);
};

var QueryRow = function QueryRow(state) {
  _classCallCheck(this, QueryRow);

  _defineProperty(this, "component", "QueryRow");

  Object.assign(this, state);
};

var MultiSelectRow = function MultiSelectRow(state) {
  _classCallCheck(this, MultiSelectRow);

  _defineProperty(this, "component", "MultiSelectRow");

  Object.assign(this, state);
};

var SelectRow = function SelectRow(state) {
  _classCallCheck(this, SelectRow);

  _defineProperty(this, "component", "SelectRow");

  _defineProperty(this, "isSelected", false);

  Object.assign(this, state);
};

var BackRow = function BackRow(state) {
  _classCallCheck(this, BackRow);

  _defineProperty(this, "component", 'BackRow');

  Object.assign(this, state);
};

var DateRangeRow = function DateRangeRow(state) {
  _classCallCheck(this, DateRangeRow);

  _defineProperty(this, "component", "DateRangeRow");

  _defineProperty(this, "label", 'select date range');

  Object.assign(this, state);
};

var TextRow = function TextRow(state) {
  _classCallCheck(this, TextRow);

  _defineProperty(this, "component", "TextRow");

  Object.assign(this, state);
};

var LineBreakRow = function LineBreakRow() {
  _classCallCheck(this, LineBreakRow);

  _defineProperty(this, "component", "LineBreakRow");
};

var LoadingRow = function LoadingRow() {
  _classCallCheck(this, LoadingRow);

  _defineProperty(this, "component", "LoadingRow");
};

var PaginationRow = function PaginationRow(state) {
  _classCallCheck(this, PaginationRow);

  _defineProperty(this, "component", "PaginationRow");

  Object.assign(this, state);
};

var script$p = Vue.extend({
  name: 'SelectDropdown',
  components: {
    Dropdown: __vue_component__$q
  },
  props: {
    values: {
      type: Array,
      required: true
    },
    selected: {
      type: [String, Number, Array, Object, Boolean],
      "default": null
    },
    variant: {
      type: String,
      "default": 'default'
    },
    label: {
      type: String,
      "default": null
    },
    placeholder: {
      type: String,
      "default": null
    },
    hideSelectedItem: {
      type: Boolean,
      "default": false
    },
    hideArrow: {
      type: Boolean,
      "default": false
    },
    truncateLabel: {
      type: Boolean,
      "default": true
    },
    enableSearch: {
      type: Boolean,
      "default": false
    },
    pagination: {
      type: Object,
      "default": null
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    isLoading: {
      type: Boolean,
      "default": false
    },
    renderLabel: Function
  },
  data: function data() {
    return {
      focused: false,
      searchString: ''
    };
  },
  computed: {
    computedLabel: function computedLabel() {
      var _this4 = this;

      var label;
      var selectedValue = this.values.find(function (value) {
        return JSON.stringify(value.value != null ? value.value : value) === JSON.stringify(_this4.selected);
      });

      if (selectedValue != null) {
        var _selectedValue$label;

        label = (_selectedValue$label = selectedValue.label) !== null && _selectedValue$label !== void 0 ? _selectedValue$label : selectedValue;
      }

      return this.label || label && this.render(label) || this.placeholder || ' ';
    },
    computedValues: function computedValues() {
      var _this5 = this;

      if (!this.values.length) return [];
      var values = this.values;
      if (this.hideSelectedItem) values = values.filter(function (value) {
        return (value.value != null ? value.value : value) !== _this5.selected;
      });
      values = values.map(function (v) {
        var _v$label;

        var values = {
          value: v.value != null ? v.value : v,
          label: v.label != null ? (_v$label = v.label) !== null && _v$label !== void 0 ? _v$label : ' ' : v
        };

        if (_typeof(v) === 'object') {
          values = _objectSpread(_objectSpread({}, v), values);
        }

        return values;
      });
      return values;
    },
    bodyRows: function bodyRows() {
      var _this6 = this;

      if (this.isLoading) return [new LoadingRow()];
      return this.computedValues.map(function (value) {
        return new SelectRow({
          value: value.value,
          label: value.label,
          disabled: value.disabled === true,
          isSelected: function isSelected(row) {
            return _this6.selected === row.label;
          },
          onSelect: function onSelect(row) {
            _this6.onFocusChange(false);

            _this6.$emit('update:selected', row.value, _this6.render(row.label));

            _this6.$emit('update:label', _this6.render(row.label));
          }
        });
      });
    },
    headerRows: function headerRows() {
      var _this7 = this;

      var headerRows = [];
      if (this.enableSearch) headerRows.push(new QueryRow({
        value: this.searchString,
        updated: function updated(newValue) {
          _this7.searchString = newValue;

          _this7.$emit('search', newValue);
        },
        cleared: function cleared() {
          _this7.clearSearch();
        }
      }));
      return headerRows;
    },
    footerRows: function footerRows() {
      var _this$pagination;

      var footerRows = [];
      if ((_this$pagination = this.pagination) !== null && _this$pagination !== void 0 && _this$pagination.pages && this.pagination.pages > 1) footerRows.push(new PaginationRow(this.pagination));
      return footerRows;
    }
  },
  created: function created() {
    if (this.selected !== null) {
      this.$emit('update:label', this.render(this.selected));
    }
  },
  methods: {
    render: function render(value) {
      return this.renderLabel && value ? this.renderLabel(value) : value;
    },
    clearSearch: function clearSearch() {
      this.searchString = '';
      this.$emit('search', '');
    },
    onFocusChange: function onFocusChange(hasFocus) {
      if (!hasFocus) {
        this.clearSearch();
      }

      this.focused = hasFocus;
      this.$emit('focused', hasFocus);
    }
  }
});
/* script */

var __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function __vue_render__$p() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("dropdown", {
    attrs: {
      rows: _vm.bodyRows,
      headerRows: _vm.headerRows,
      footerRows: _vm.footerRows,
      focused: _vm.focused,
      variant: _vm.variant,
      disabled: _vm.disabled,
      hideArrow: _vm.hideArrow,
      truncateLabel: _vm.truncateLabel
    },
    on: {
      "update:focused": [function ($event) {
        _vm.focused = $event;
      }, _vm.onFocusChange]
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._t("label", function () {
          return [_vm._v("\n    " + _vm._s(_vm.computedLabel) + "\n    ")];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;
/* style */

var __vue_inject_styles__$p = undefined;
/* scoped */

var __vue_scope_id__$p = undefined;
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);
/**
 * SSR Window 2.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 12, 2020
 */

/* eslint-disable no-param-reassign */


function isObject$1(obj) {
  return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend(target, src) {
  if (target === void 0) {
    target = {};
  }

  if (src === void 0) {
    src = {};
  }

  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

var doc = typeof document !== 'undefined' ? document : {};
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
extend(doc, ssrDocument);
var win = typeof window !== 'undefined' ? window : {};
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  }
};
extend(win, ssrWindow);
/**
 * Dom7 2.1.5
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: May 15, 2020
 */

var Dom7 = function Dom7(arr) {
  _classCallCheck(this, Dom7);

  var self = this; // Create array-like object

  for (var i = 0; i < arr.length; i += 1) {
    self[i] = arr[i];
  }

  self.length = arr.length; // Return collection with methods

  return this;
};

function $(selector, context) {
  var arr = [];
  var i = 0;

  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }

  if (selector) {
    // String
    if (typeof selector === 'string') {
      var els;
      var tempParent;

      var _html = selector.trim();

      if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (_html.indexOf('<li') === 0) toCreate = 'ul';
        if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
        if (_html.indexOf('<tbody') === 0) toCreate = 'table';
        if (_html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = doc.createElement(toCreate);
        tempParent.innerHTML = _html;

        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [doc.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || doc).querySelectorAll(selector.trim());
        }

        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === win || selector === doc) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }

  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
} // Classes and attributes


function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }

  var classes = className.split(' ');

  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }

  return this;
}

function removeClass(className) {
  var classes = className.split(' ');

  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }

  return this;
}

function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}

function toggleClass(className) {
  var classes = className.split(' ');

  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }

  return this;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
} // eslint-disable-next-line


function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function data(key, value) {
  var el;

  if (typeof value === 'undefined') {
    el = this[0]; // Get value

    if (el) {
      if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
        return el.dom7ElementDataStorage[key];
      }

      var dataKey = el.getAttribute("data-".concat(key));

      if (dataKey) {
        return dataKey;
      }

      return undefined;
    }

    return undefined;
  } // Set value


  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
} // Transforms
// eslint-disable-next-line


function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  if (typeof duration !== 'string') {
    duration = "".concat(duration, "ms"); // eslint-disable-line
  }

  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }

  return this;
} // Events


function on() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var evt = void 0;

      try {
        evt = new win.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
      } catch (e) {
        evt = doc.createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      } // eslint-disable-next-line


      el.dom7EventData = args.filter(function (data, dataIndex) {
        return dataIndex > 0;
      });
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  var events = ['webkitTransitionEnd', 'transitionend'];
  var dom = this;
  var i;

  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);

    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }

  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = doc.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === win ? win.scrollY : el.scrollTop;
    var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  if (this[0]) return win.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (var prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
} // Iterate over the collection passing elements to `callback`


function each$1(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this; // Iterate over the current collection

  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  } // Return `this` to allow chained DOM operations


  return this;
}

function filter(callback) {
  var matchedItems = [];
  var dom = this;

  for (var i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }

  return new Dom7(matchedItems);
} // eslint-disable-next-line


function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
} // eslint-disable-next-line


function text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }

    return null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is$1(selector) {
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  } else if (selector === doc) return el === doc;else if (selector === win) return el === win;

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index$1() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
} // eslint-disable-next-line


function eq$1(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;
  var returnIndex;

  if (index > length - 1) {
    return new Dom7([]);
  }

  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }

  return new Dom7([this[index]]);
}

function append() {
  var newChild;

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = doc.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }

      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }

  return new Dom7([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return new Dom7(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }

      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }

  return new Dom7([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return new Dom7(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(unique(parents));
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(unique(parents));
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return new Dom7(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].childNodes;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return new Dom7(unique(children));
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function add() {
  var dom = this;
  var i;
  var j;

  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  for (i = 0; i < args.length; i += 1) {
    var toAdd = $(args[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }

  return dom;
}
/**
 * Swiper 5.4.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 16, 2020
 */


var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  data: data,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  offset: offset,
  css: css,
  each: each$1,
  html: html,
  text: text,
  is: is$1,
  index: index$1,
  eq: eq$1,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove,
  add: add,
  styles: styles
};
Object.keys(Methods).forEach(function (methodName) {
  $.fn[methodName] = $.fn[methodName] || Methods[methodName];
});
var Utils = {
  deleteProps: function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {// no getter for object
      }

      try {
        delete object[key];
      } catch (e) {// something got wrong
      }
    });
  },
  nextTick: function nextTick(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return setTimeout(callback, delay);
  },
  now: function now() {
    return Date.now();
  },
  getTranslate: function getTranslate(el) {
    var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = win.getComputedStyle(el, null);

    if (win.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;

      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      } // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case


      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
    }

    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
    }

    return curTransform || 0;
  },
  parseUrlQuery: function parseUrlQuery(url) {
    var query = {};
    var urlToParse = url || win.location.href;
    var i;
    var params;
    var param;
    var length;

    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter(function (paramsPart) {
        return paramsPart !== '';
      });
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }

    return query;
  },
  isObject: function isObject(o) {
    return _typeof(o) === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend: function extend() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);

    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));

        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }

    return to;
  }
};

var Support = function Support() {
  return {
    touch: !!('ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch),
    pointerEvents: !!win.PointerEvent && 'maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        win.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in win;
    }()
  };
}();

var SwiperClass = /*#__PURE__*/function () {
  function SwiperClass() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SwiperClass);

    var self = this;
    self.params = params; // Events

    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  _createClass(SwiperClass, [{
    key: "on",
    value: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    }
  }, {
    key: "once",
    value: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;

      function onceHandler() {
        self.off(events, onceHandler);

        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }

        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        handler.apply(self, args);
      }

      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    }
  }, {
    key: "off",
    value: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    }
  }, {
    key: "emit",
    value: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events;
      var data;
      var context;

      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }

      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  }, {
    key: "useModulesParams",
    value: function useModulesParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName]; // Extend params

        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    }
  }, {
    key: "useModules",
    value: function useModules() {
      var modulesParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {}; // Extend instance methods and props

        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];

            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        } // Add event listeners


        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        } // Module create callback


        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  }], [{
    key: "components",
    set: function set(components) {
      var Class = this;
      if (!Class.use) return;
      Class.use(components);
    }
  }, {
    key: "installModule",
    value: function installModule(module) {
      var Class = this;
      if (!Class.prototype.modules) Class.prototype.modules = {};
      var name = module.name || "".concat(Object.keys(Class.prototype.modules).length, "_").concat(Utils.now());
      Class.prototype.modules[name] = module; // Prototype

      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      } // Class


      if (module["static"]) {
        Object.keys(module["static"]).forEach(function (key) {
          Class[key] = module["static"][key];
        });
      } // Callback


      if (module.install) {
        for (var _len8 = arguments.length, params = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          params[_key8 - 1] = arguments[_key8];
        }

        module.install.apply(Class, params);
      }

      return Class;
    }
  }, {
    key: "use",
    value: function use(module) {
      var Class = this;

      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }

      for (var _len9 = arguments.length, params = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        params[_key9 - 1] = arguments[_key9];
      }

      return Class.installModule.apply(Class, [module].concat(params));
    }
  }]);

  return SwiperClass;
}();

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
  Utils.extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];

  function slidesForMargin(slideIndex) {
    if (!params.cssMode) return true;

    if (slideIndex === slides.length - 1) {
      return false;
    }

    return true;
  }

  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.snapGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;

    var _slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;

        _slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      _slide.css("margin-".concat(swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && "".concat(params.spaceBetween, "px"));
    }

    if (_slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = win.getComputedStyle(_slide[0], null);
      var currentTransform = _slide[0].style.transform;
      var currentWebKitTransform = _slide[0].style.webkitTransform;

      if (currentTransform) {
        _slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? _slide.outerWidth(true) : _slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        if (swiper.isHorizontal()) {
          var width = parseFloat(slideStyles.getPropertyValue('width'));
          var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
          var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
          var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
          var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
          var boxSizing = slideStyles.getPropertyValue('box-sizing');

          if (boxSizing && boxSizing === 'border-box') {
            slideSize = width + marginLeft + marginRight;
          } else {
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
          }
        } else {
          var height = parseFloat(slideStyles.getPropertyValue('height'));
          var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
          var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
          var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
          var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));

          var _boxSizing = slideStyles.getPropertyValue('box-sizing');

          if (_boxSizing && _boxSizing === 'border-box') {
            slideSize = height + marginTop + marginBottom;
          } else {
            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
          }
        }
      }

      if (currentTransform) {
        _slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = "".concat(slideSize, "px");
        } else {
          slides[i].style.height = "".concat(slideSize, "px");
        }
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }

  if (params.setWrapperSize) {
    if (swiper.isHorizontal()) $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });else $wrapperEl.css({
      height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });else $wrapperEl.css({
      height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i4 = 0; _i4 < snapGrid.length; _i4 += 1) {
        var slidesGridItem = snapGrid[_i4];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i4] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i5 = 0; _i5 < snapGrid.length; _i5 += 1) {
      var _slidesGridItem = snapGrid[_i5];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i5] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) slides.filter(slidesForMargin).css({
        marginLeft: "".concat(spaceBetween, "px")
      });else slides.filter(slidesForMargin).css({
        marginRight: "".concat(spaceBetween, "px")
      });
    } else slides.filter(slidesForMargin).css({
      marginBottom: "".concat(spaceBetween, "px")
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Utils.extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  } // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (index, slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var _index2 = swiper.activeIndex + i;

        if (_index2 > swiper.slides.length) break;
        activeSlides.push(swiper.slides.eq(_index2)[0]);
      }
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;
  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var _slide2 = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - _slide2.swiperSlideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - _slide2.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(_slide2);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    _slide2.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Utils.extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(activeIndex, "\"]"));
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var _skip2 = Math.min(params.slidesPerGroupSkip, activeIndex);

    snapIndex = _skip2 + Math.floor((activeIndex - _skip2) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Utils.extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest(".".concat(params.slideClass))[0];
  var slideFound = false;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) slideFound = true;
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = $(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getTranslate() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';
  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var translateBounds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var internal = arguments.length > 4 ? arguments[4] : undefined;
  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty2(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty2(_wrapperEl$scrollTo, "behavior", 'smooth'), _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments.length > 1 ? arguments[1] : undefined;
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments.length > 1 ? arguments[1] : undefined;
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments.length > 3 ? arguments[3] : undefined;
  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    var _t3 = -translate;

    if (rtl) {
      _t3 = wrapperEl.scrollWidth - wrapperEl.offsetWidth - _t3;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = _t3;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo2;

        wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty2(_wrapperEl$scrollTo2, isH ? 'left' : 'top', _t3), _defineProperty2(_wrapperEl$scrollTo2, "behavior", 'smooth'), _wrapperEl$scrollTo2));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = _t3;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments.length > 3 ? arguments[3] : undefined;
  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideNext() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slidePrev() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  slidesGrid.map(function (val) {
    return normalize(val);
  });
  snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideReset() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideToClosest() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments.length > 2 ? arguments[2] : undefined;
  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
      Utils.nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
  var slides = $wrapperEl.children(".".concat(params.slideClass));

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(doc.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children(".".concat(params.slideClass));
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (index, el) {
    var slide = $(el);
    if (index < swiper.loopedSlides) appendSlides.push(el);
    if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i6 = 0; _i6 < appendSlides.length; _i6 += 1) {
    $wrapperEl.append($(appendSlides[_i6].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i7 = prependSlides.length - 1; _i7 >= 0; _i7 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i7].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;
  if (Support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (_typeof(slides) === 'object' && 'length' in slides) {
    for (var _i8 = 0; _i8 < slides.length; _i8 += 1) {
      if (slides[_i8]) $wrapperEl.append(slides[_i8]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i9 = 0; _i9 < slidesBuffer.length; _i9 += 1) {
    $wrapperEl.append(slidesBuffer[_i9]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

var Device = function Device() {
  var platform = win.navigator.platform;
  var ua = win.navigator.userAgent;
  var device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    iphone: false,
    ipod: false,
    ipad: false,
    edge: false,
    ie: false,
    firefox: false,
    macos: false,
    windows: false,
    cordova: !!(win.cordova || win.phonegap),
    phonegap: !!(win.cordova || win.phonegap),
    electron: false
  };
  var screenWidth = win.screen.width;
  var screenHeight = win.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
  var edge = ua.indexOf('Edge/') >= 0;
  var firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
  var windows = platform === 'Win32';
  var electron = ua.toLowerCase().indexOf('electron') >= 0;
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  if (!ipad && macos && Support.touch && (screenWidth === 1024 && screenHeight === 1366 || screenWidth === 834 && screenHeight === 1194 // Pro 11
  || screenWidth === 834 && screenHeight === 1112 // Pro 10.5
  || screenWidth === 768 && screenHeight === 1024 // other
  )) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    macos = false;
  }

  device.ie = ie;
  device.edge = edge;
  device.firefox = firefox; // Android

  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // iOS


  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }

  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }

  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.ipod = true;
  } // iOS 8+ changed UA


  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  } // Webview


  device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone)) || win.matchMedia && win.matchMedia('(display-mode: standalone)').matches;
  device.webview = device.webView;
  device.standalone = device.webView; // Desktop

  device.desktop = !(device.ios || device.android) || electron;

  if (device.desktop) {
    device.electron = electron;
    device.macos = macos;
    device.windows = windows;

    if (device.macos) {
      device.os = 'macos';
    }

    if (device.windows) {
      device.os = 'windows';
    }
  } // Pixel Ratio


  device.pixelRatio = win.devicePixelRatio || 1; // Export object

  return device;
}();

function onTouchStart(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass))[0]) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
    return;
  }

  Utils.extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.formElements)) preventDefault = false;

    if (doc.activeElement && $(doc.activeElement).is(data.formElements) && doc.activeElement !== $targetEl[0]) {
      doc.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if (params.touchStartForcePreventDefault || shouldPreventDefault) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = Utils.now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && doc.activeElement) {
    if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = Utils.now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = Utils.now();
  Utils.nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!Support.touch && Support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (Support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        doc.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      doc.addEventListener('mousemove', swiper.onTouchMove, capture);
      doc.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;
  var capture = !!params.nested; // Touch Events

  if (!Support.touch && Support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (Support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
      doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints);

  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams) {
      ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;

        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
          breakpointOnlyParams[param] = 'auto';
        } else if (param === 'slidesPerView') {
          breakpointOnlyParams[param] = parseFloat(paramValue);
        } else {
          breakpointOnlyParams[param] = parseInt(paramValue, 10);
        }
      });
    }

    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = params.slidesPerColumn > 1;
    var isMultiRow = breakpointParams.slidesPerColumn > 1;

    if (wasMultiRow && !isMultiRow) {
      $el.removeClass("".concat(params.containerModifierClass, "multirow ").concat(params.containerModifierClass, "multirow-column"));
    } else if (!wasMultiRow && isMultiRow) {
      $el.addClass("".concat(params.containerModifierClass, "multirow"));

      if (breakpointParams.slidesPerColumnFill === 'column') {
        $el.addClass("".concat(params.containerModifierClass, "multirow-column"));
      }
    }

    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

    if (directionChanged && initialized) {
      swiper.changeDirection();
    }

    Utils.extend(swiper.params, breakpointParams);
    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });
    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }

    swiper.emit('breakpoint', breakpointParams);
  }
}

function getBreakpoint(breakpoints) {
  // Get breakpoint for window width
  if (!breakpoints) return undefined;
  var breakpoint = false;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = win.innerHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (value <= win.innerWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el;
  var suffixes = [];
  suffixes.push('initialized');
  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }

  if (params.autoHeight) {
    suffixes.push('autoheight');
  }

  if (rtl) {
    suffixes.push('rtl');
  }

  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');

    if (params.slidesPerColumnFill === 'column') {
      suffixes.push('multirow-column');
    }
  }

  if (Device.android) {
    suffixes.push('android');
  }

  if (Device.ios) {
    suffixes.push('ios');
  }

  if (params.cssMode) {
    suffixes.push('css-mode');
  }

  suffixes.forEach(function (suffix) {
    classNames.push(params.containerModifierClass + suffix);
  });
  $el.addClass(classNames.join(' '));
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new win.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};
var defaults$1 = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  //
  preventInteractionOnTransition: false,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true
};
/* eslint no-param-reassign: "off" */

var prototypes = {
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper$1 = /*#__PURE__*/function (_SwiperClass) {
  _inherits(Swiper$1, _SwiperClass);

  var _super2 = _createSuper(Swiper$1);

  function Swiper$1() {
    var _this8;

    _classCallCheck(this, Swiper$1);

    var el;
    var params;

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = Utils.extend({}, params);
    if (el && !params.el) params.el = el;
    _this8 = _super2.call(this, params);
    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        if (!Swiper$1.prototype[protoMethod]) {
          Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    }); // Swiper Instance

    var swiper = _assertThisInitialized(_this8);

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (_typeof(moduleParams) !== 'object' || moduleParams === null) return;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = Utils.extend({}, defaults$1);
    swiper.useModulesParams(swiperParams); // Extend defaults with passed params

    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params); // Save Dom lib

    swiper.$ = $; // Find el

    var $el = $(swiper.params.el);
    el = $el[0];

    if (!el) {
      return _possibleConstructorReturn(_this8, undefined);
    }

    if ($el.length > 1) {
      var swipers = [];
      $el.each(function (index, containerEl) {
        var newParams = Utils.extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper$1(newParams));
      });
      return _possibleConstructorReturn(_this8, swipers);
    }

    el.swiper = swiper;
    $el.data('swiper', swiper); // Find Wrapper

    var $wrapperEl;

    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
      $wrapperEl = $(el.shadowRoot.querySelector(".".concat(swiper.params.wrapperClass))); // Children needs to return slot items

      $wrapperEl.children = function (options) {
        return $el.children(options);
      };
    } else {
      $wrapperEl = $el.children(".".concat(swiper.params.wrapperClass));
    } // Extend Swiper


    Utils.extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video, label',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules(); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return _possibleConstructorReturn(_this8, swiper);
  }

  _createClass(Swiper$1, [{
    key: "slidesPerViewDynamic",
    value: function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;
      var spv = 1;

      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;

        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }

        for (var _i10 = activeIndex - 1; _i10 >= 0; _i10 -= 1) {
          if (slides[_i10] && !breakLoop) {
            slideSize += slides[_i10].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i11 = activeIndex + 1; _i11 < slides.length; _i11 += 1) {
          if (slidesGrid[_i11] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }

      return spv;
    }
  }, {
    key: "update",
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      var translated;

      if (swiper.params.freeMode) {
        setTranslate();

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }

        if (!translated) {
          setTranslate();
        }
      }

      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }

      swiper.emit('update');
    }
  }, {
    key: "changeDirection",
    value: function changeDirection(newDirection) {
      var needUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swiper = this;
      var currentDirection = swiper.params.direction;

      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }

      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
      swiper.params.direction = newDirection;
      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    }
  }, {
    key: "init",
    value: function init() {
      var swiper = this;
      if (swiper.initialized) return;
      swiper.emit('beforeInit'); // Set breakpoint

      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      } // Add Classes


      swiper.addClasses(); // Create loop

      if (swiper.params.loop) {
        swiper.loopCreate();
      } // Update size


      swiper.updateSize(); // Update slides

      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      } // Set Grab Cursor


      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      } // Slide To Initial Slide


      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      } // Attach events


      swiper.attachEvents(); // Init Flag

      swiper.initialized = true; // Emit

      swiper.emit('init');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy'); // Init Flag

      swiper.initialized = false; // Detach events

      swiper.detachEvents(); // Destroy loop

      if (params.loop) {
        swiper.loopDestroy();
      } // Cleanup styles


      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');

        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
      }

      swiper.emit('destroy'); // Detach emitter events

      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }

      swiper.destroyed = true;
      return null;
    }
  }], [{
    key: "extendDefaults",
    value: function extendDefaults(newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    }
  }, {
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults$1;
    }
  }, {
    key: "Class",
    get: function get() {
      return SwiperClass;
    }
  }, {
    key: "$",
    get: function get() {
      return $;
    }
  }]);

  return Swiper$1;
}(SwiperClass);

var Device$1 = {
  name: 'device',
  proto: {
    device: Device
  },
  "static": {
    device: Device
  }
};
var Support$1 = {
  name: 'support',
  proto: {
    support: Support
  },
  "static": {
    support: Support
  }
};

var Browser = function Browser() {
  function isSafari() {
    var ua = win.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!win.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
  };
}();

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser
  },
  "static": {
    browser: Browser
  }
};
var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this; // Emit resize

      win.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy() {
      var swiper = this;
      win.removeEventListener('resize', swiper.resize.resizeHandler);
      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};
var Observer = {
  func: win.MutationObserver || win.WebkitMutationObserver,
  attach: function attach(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var swiper = this;
    var ObserverFunc = Observer.func;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (win.requestAnimationFrame) {
        win.requestAnimationFrame(observerUpdate);
      } else {
        win.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!Support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: []
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.observer.init();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.destroy();
    }
  }
};
var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;
    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;
    var offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    var slidesAfter;
    var slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
      slidesBefore = slidesPerGroup + addSlidesAfter;
    }

    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Utils.extend(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, "".concat(offset, "px"));
      }

      swiper.updateProgress();
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];

          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });
      onRendered();
      return;
    }

    var prependIndexes = [];
    var appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]")).remove();
        }
      }
    }

    for (var _i12 = 0; _i12 < slides.length; _i12 += 1) {
      if (_i12 >= from && _i12 <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i12);
        } else {
          if (_i12 > previousTo) appendIndexes.push(_i12);
          if (_i12 < previousFrom) prependIndexes.push(_i12);
        }
      }
    }

    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, "".concat(offset, "px"));
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"".concat(swiper.params.slideClass, "\" data-swiper-slide-index=\"").concat(index, "\">").concat(slide, "</div>"));
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slides) {
    var swiper = this;

    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slides) {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      var _cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(_cache).forEach(function (cachedIndex) {
        var $cachedEl = _cache[cachedIndex];
        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide: function removeSlide(slidesIndexes) {
    var swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides: function removeAllSlides() {
    var swiper = this;
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  }
};
var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        removeSlide: Virtual.removeSlide.bind(swiper),
        removeAllSlides: Virtual.removeAllSlides.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {}
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
      var overwriteParams = {
        watchSlidesProgress: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
};
var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var kc = e.keyCode || e.charCode;
    var pageUpDown = swiper.params.keyboard.pageUpDown;
    var isPageUp = pageUpDown && kc === 33;
    var isPageDown = pageUpDown && kc === 34;
    var isArrowLeft = kc === 37;
    var isArrowRight = kc === 39;
    var isArrowUp = kc === 38;
    var isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      var inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) {
        return undefined;
      }

      var windowWidth = win.innerWidth;
      var windowHeight = win.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    if (swiper.keyboard.enabled) return;
    $(doc).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    if (!swiper.keyboard.enabled) return;
    $(doc).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  }
};
var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper)
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    }
  }
};

function isEventSupported() {
  var eventName = 'onwheel';
  var isSupported = (eventName in doc);

  if (!isSupported) {
    var element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && doc.implementation && doc.implementation.hasFeature // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  && doc.implementation.hasFeature('', '') !== true) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

var Mousewheel = {
  lastScrollTime: Utils.now(),
  lastEventBeforeSnap: undefined,
  recentWheelEvents: [],
  event: function event() {
    if (win.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  },
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;
    var sX = 0;
    var sY = 0; // spinX, spinY

    var pX = 0;
    var pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
    var data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta;

    if (!swiper.params.freeMode) {
      // Register the new event in a variable which stores the relevant data
      var newEvent = {
        time: Utils.now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      var recentWheelEvents = swiper.mousewheel.recentWheelEvents;

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          swiper.mousewheel.animateSlider(newEvent);
        }
      } else {
        swiper.mousewheel.animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (swiper.mousewheel.releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      var _newEvent = {
        time: Utils.now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
      var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        swiper.mousewheel.lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        var position = swiper.getTranslate() + delta * params.sensitivity;
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = undefined;
          var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;

          if (_recentWheelEvents.length >= 15) {
            _recentWheelEvents.shift(); // only store the last N events

          }

          var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;

          var firstEvent = _recentWheelEvents[0];

          _recentWheelEvents.push(_newEvent);

          if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            _recentWheelEvents.splice(0);
          } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            var snapToThreshold = delta > 0 ? 0.8 : 0.2;
            swiper.mousewheel.lastEventBeforeSnap = _newEvent;

            _recentWheelEvents.splice(0);

            swiper.mousewheel.timeout = Utils.nextTick(function () {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!swiper.mousewheel.timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            swiper.mousewheel.timeout = Utils.nextTick(function () {
              var snapToThreshold = 0.5;
              swiper.mousewheel.lastEventBeforeSnap = _newEvent;

              _recentWheelEvents.splice(0);

              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  },
  animateSlider: function animateSlider(newEvent) {
    var swiper = this; // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).

    if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        swiper.emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      swiper.emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    swiper.mousewheel.lastScrollTime = new win.Date().getTime(); // Return false as a default

    return false;
  },
  releaseScroll: function releaseScroll(newEvent) {
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  },
  enable: function enable() {
    var swiper = this;
    var event = Mousewheel.event();

    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
      return true;
    }

    if (!event) return false;
    if (swiper.mousewheel.enabled) return false;
    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }

    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    var event = Mousewheel.event();

    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
      return true;
    }

    if (!event) return false;
    if (!swiper.mousewheel.enabled) return false;
    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }

    target.off(event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  }
};
var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        animateSlider: Mousewheel.animateSlider.bind(swiper),
        releaseScroll: Mousewheel.releaseScroll.bind(swiper),
        lastScrollTime: Utils.now(),
        lastEventBeforeSnap: undefined,
        recentWheelEvents: []
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
        swiper.mousewheel.disable();
      }

      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.params.cssMode) {
        swiper.mousewheel.enable();
      }

      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    }
  }
};
var Navigation = {
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }

      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }

      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = $(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = $(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    Utils.extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper),
        onNextClick: Navigation.onNextClick.bind(swiper),
        onPrevClick: Navigation.onPrevClick.bind(swiper)
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.navigation.destroy();
    },
    click: function click(e) {
      var swiper = this;
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow', swiper);
        } else {
          swiper.emit('navigationHide', swiper);
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};
var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', "".concat(swiper.pagination.bulletSize * (params.dynamicMainBullets + 4), "px"));

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass("".concat(params.bulletActiveClass, " ").concat(params.bulletActiveClass, "-next ").concat(params.bulletActiveClass, "-next-next ").concat(params.bulletActiveClass, "-prev ").concat(params.bulletActiveClass, "-prev-prev ").concat(params.bulletActiveClass, "-main"));

      if ($el.length > 1) {
        bullets.each(function (index, bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i13 = params.dynamicMainBullets; _i13 >= 0; _i13 -= 1) {
                bullets.eq(bullets.length - _i13).addClass("".concat(params.bulletActiveClass, "-main"));
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
            } else {
              $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
              $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
            }
          } else {
            $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
            $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', "".concat(bulletsOffset, "px"));
      }
    }

    if (params.type === 'fraction') {
      $el.find(".".concat(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(".".concat(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(".".concat(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }

    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<".concat(params.bulletElement, " class=\"").concat(params.bulletClass, "\"></").concat(params.bulletElement, ">");
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(".".concat(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.currentClass, "\"></span>") + ' / ' + "<span class=\"".concat(params.totalClass, "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.progressbarFillClass, "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', ".".concat(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Utils.extend(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', ".".concat(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange() {
      var swiper = this;

      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange() {
      var swiper = this;

      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange() {
      var swiper = this;

      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange() {
      var swiper = this;

      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.pagination.destroy();
    },
    click: function click(e) {
      var swiper = this;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow', swiper);
        } else {
          swiper.emit('paginationHide', swiper);
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};
var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
      $dragEl[0].style.width = "".concat(newSize, "px");
    } else {
      $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
      $dragEl[0].style.height = "".concat(newSize, "px");
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = "".concat(dragSize, "px");
    } else {
      $dragEl[0].style.height = "".concat(dragSize, "px");
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    Utils.extend(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;

    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    swiper.emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (!Support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (!Support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
    var params = swiper.params.scrollbar;
    var $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));

    if ($dragEl.length === 0) {
      $dragEl = $("<div class=\"".concat(swiper.params.scrollbar.dragClass, "\"></div>"));
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};
var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize: function resize() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.destroy();
    }
  }
};
var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;
    var $el = $(el);
    var rtlFactor = rtl ? -1 : 1;
    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
    } else {
      x = "".concat(x * progress * rtlFactor, "px");
    }

    if (y.indexOf('%') >= 0) {
      y = "".concat(parseInt(y, 10) * progress, "%");
    } else {
      y = "".concat(y * progress, "px");
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
      swiper.parallax.setTransform(el, progress);
    });
    slides.each(function (slideIndex, slideEl) {
      var slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
        swiper.parallax.setTransform(el, slideProgress);
      });
    });
  },
  setTransition: function setTransition() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
    var swiper = this;
    var $el = swiper.$el;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
      var $parallaxEl = $(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  }
};
var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTransition(duration);
    }
  }
};
var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  },
  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;

    if (!Support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(".".concat(swiper.params.slideClass));
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (Support.gestures) {
      zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }

    gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
        return;
      }

      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (Device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);

      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    } // Define if we need image drag


    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  },
  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom["in"](e);
    }
  },
  "in": function _in(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
    var touchX;
    var touchY;
    var offsetX;
    var offsetY;
    var diffX;
    var diffY;
    var translateX;
    var translateY;
    var imageWidth;
    var imageHeight;
    var scaledWidth;
    var scaledHeight;
    var translateMinX;
    var translateMinY;
    var translateMaxX;
    var translateMaxY;
    var slideWidth;
    var slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
    gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
  },
  out: function out() {
    var swiper = this;
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
    gesture.$slideEl = undefined;
  },
  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    var activeListenerWithCapture = Support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    var slideSelector = ".".concat(swiper.params.slideClass); // Scale image

    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;
    swiper.zoom.enabled = false;
    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    var activeListenerWithCapture = Support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    var slideSelector = ".".concat(swiper.params.slideClass); // Scale image

    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
  }
};
var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  },
  create: function create() {
    var swiper = this;
    var zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
      }
    };
    'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom: zoom
    });
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
      get: function get() {
        return scale;
      },
      set: function set(value) {
        if (scale !== value) {
          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
          swiper.emit('zoomChange', value, imageEl, slideEl);
        }

        scale = value;
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.zoom.disable();
    },
    touchStart: function touchStart(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(e) {
      var swiper = this;

      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;

      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    },
    slideChange: function slideChange() {
      var swiper = this;

      if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
        swiper.zoom.onTransitionEnd();
      }
    }
  }
};
var Lazy = {
  loadInSlide: function loadInSlide(index) {
    var loadInDuplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")) : swiper.slides.eq(index);
    var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(function (imageIndex, imageEl) {
      var $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');
      var $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', "url(\"".concat(background, "\")"));
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(function (sourceIndex, sourceEl) {
              var $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(".".concat(params.preloaderClass)).remove();

        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(slideOriginalIndex, "\"]:not(.").concat(swiper.params.slideDuplicateClass, ")"));
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(slideOriginalIndex, "\"]"));
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }

        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;
    var slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(".".concat(swiperParams.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;

    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function (elIndex, slideEl) {
        var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (var _i14 = activeIndex + slidesPerView; _i14 < maxIndex; _i14 += 1) {
          if (slideExist(_i14)) swiper.lazy.loadInSlide(_i14);
        } // Prev Slides


        for (var _i15 = minIndex; _i15 < activeIndex; _i15 += 1) {
          if (slideExist(_i15)) swiper.lazy.loadInSlide(_i15);
        }
      } else {
        var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
        var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  }
};
var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;

      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init() {
      var swiper = this;

      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll: function scroll() {
      var swiper = this;

      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize: function resize() {
      var swiper = this;

      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove: function scrollbarDragMove() {
      var swiper = this;

      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart() {
      var swiper = this;

      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;

      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    },
    slideChange: function slideChange() {
      var swiper = this;

      if (swiper.params.lazy.enabled && swiper.params.cssMode) {
        swiper.lazy.load();
      }
    }
  }
};
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex;
      var minIndex;
      var guess;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    var i1;
    var i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;

    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier;
    var controlledTranslate;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper$1) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper$1 && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          Utils.nextTick(function () {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper$1) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper$1 && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper)
      }
    });
  },
  on: {
    update: function update() {
      var swiper = this;
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(translate, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
};
var a11y = {
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable: function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey: function onEnterKey(e) {
    var swiper = this;
    var params = swiper.params.a11y;
    if (e.keyCode !== 13) return;
    var $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(".".concat(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;
    if (swiper.params.loop || !swiper.navigation) return;
    var _swiper$navigation4 = swiper.navigation,
        $nextEl = _swiper$navigation4.$nextEl,
        $prevEl = _swiper$navigation4.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;

    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
        var $bulletEl = $(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
      });
    }
  },
  init: function init() {
    var swiper = this;
    swiper.$el.append(swiper.a11y.liveRegion); // Navigation

    var params = swiper.params.a11y;
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }

    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
    }
  }
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: $("<span class=\"".concat(swiper.params.a11y.notificationClass, "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>"))
      }
    });
    Object.keys(a11y).forEach(function (methodName) {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
};
var History = {
  init: function init() {
    var swiper = this;
    if (!swiper.params.history) return;

    if (!win.history || !win.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      win.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;

    if (!swiper.params.history.replaceState) {
      win.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues() {
    var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) {
      return part !== '';
    });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return {
      key: key,
      value: value
    };
  },
  setHistory: function setHistory(key, index) {
    var swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    var slide = swiper.slides.eq(index);
    var value = History.slugify(slide.attr('data-history'));

    if (!win.location.pathname.includes(key)) {
      value = "".concat(key, "/").concat(value);
    }

    var currentState = win.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      win.history.replaceState({
        value: value
      }, null, value);
    } else {
      win.history.pushState({
        value: value
      }, null, value);
    }
  },
  slugify: function slugify(text) {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;

    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide3 = swiper.slides.eq(i);

        var slideHistory = History.slugify(_slide3.attr('data-history'));

        if (slideHistory === value && !_slide3.hasClass(swiper.params.slideDuplicateClass)) {
          var _index3 = _slide3.index();

          swiper.slideTo(_index3, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  }
};
var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper)
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;

      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    },
    slideChange: function slideChange() {
      var swiper = this;

      if (swiper.history.initialized && swiper.params.cssMode) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    }
  }
};
var HashNavigation = {
  onHashCange: function onHashCange() {
    var swiper = this;
    swiper.emit('hashChange');
    var newHash = doc.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-hash=\"").concat(newHash, "\"]")).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  },
  setHash: function setHash() {
    var swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
      win.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr('data-hash')) || '');
      swiper.emit('hashSet');
    } else {
      var _slide4 = swiper.slides.eq(swiper.activeIndex);

      var hash = _slide4.attr('data-hash') || _slide4.attr('data-history');

      doc.location.hash = hash || '';
      swiper.emit('hashSet');
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    swiper.hashNavigation.initialized = true;
    var hash = doc.location.hash.replace('#', '');

    if (hash) {
      var speed = 0;

      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide5 = swiper.slides.eq(i);

        var slideHash = _slide5.attr('data-hash') || _slide5.attr('data-history');

        if (slideHash === hash && !_slide5.hasClass(swiper.params.slideDuplicateClass)) {
          var _index4 = _slide5.index();

          swiper.slideTo(_index4, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      $(win).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy: function destroy() {
    var swiper = this;

    if (swiper.params.hashNavigation.watchState) {
      $(win).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  }
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper)
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;

      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    },
    slideChange: function slideChange() {
      var swiper = this;

      if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
        swiper.hashNavigation.setHash();
      }
    }
  }
};
/* eslint no-underscore-dangle: "off" */

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = Utils.nextTick(function () {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
    }
  }
};
var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
        onVisibilityChange: function onVisibilityChange() {
          if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
            swiper.autoplay.pause();
          }

          if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            swiper.autoplay.run();
            swiper.autoplay.paused = false;
          }
        },
        onTransitionEnd: function onTransitionEnd(e) {
          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
          swiper.autoplay.paused = false;

          if (!swiper.autoplay.running) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.run();
          }
        }
      }
    });
  },
  on: {
    init: function init() {
      var swiper = this;

      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      }
    },
    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
      var swiper = this;

      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove() {
      var swiper = this;

      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd() {
      var swiper = this;

      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy() {
      var swiper = this;

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
};
var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var _offset = $slideEl[0].swiperSlideOffset;
      var tx = -_offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "fade"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};
var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size;
    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: "".concat(swiperWidth, "px")
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      var slideAngle = slideIndex * 90;

      var _round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        _round = Math.floor(-slideAngle / 360);
      }

      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -_round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -_round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + _round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * _round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var _transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(_transform);

      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top', "\"></div>"));
          $slideEl.append(shadowBefore);
        }

        if (shadowAfter.length === 0) {
          shadowAfter = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom', "\"></div>"));
          $slideEl.append(shadowAfter);
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
      '-moz-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
      '-ms-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
      'transform-origin': "50% 50% -".concat(swiperSize / 2, "px")
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var _offset2 = params.shadowOffset;
        $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + _offset2, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
      }
    }

    var zFactor = Browser.isSafari || Browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  }
};
var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "cube"));
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    }
  }
};
var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      var _offset3 = $slideEl[0].swiperSlideOffset;

      var _rotate = -180 * progress;

      var rotateY = _rotate;
      var rotateX = 0;
      var tx = -_offset3;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = $("<div class=\"swiper-slide-shadow-".concat(swiper.isHorizontal() ? 'left' : 'top', "\"></div>"));
          $slideEl.append(shadowBefore);
        }

        if (shadowAfter.length === 0) {
          shadowAfter = $("<div class=\"swiper-slide-shadow-".concat(swiper.isHorizontal() ? 'right' : 'bottom', "\"></div>"));
          $slideEl.append(shadowAfter);
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }

      $slideEl.transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)"));
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false; // eslint-disable-next-line

      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;

        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "flip"));
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    }
  }
};
var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl,
        slidesSizesGrid = swiper.slidesSizesGrid;
    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth; // Each slide offset from center

    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      var translateZ = -translate * Math.abs(offsetMultiplier);
      var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top', "\"></div>"));
          $slideEl.append($shadowBeforeEl);
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = $("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom', "\"></div>"));
          $slideEl.append($shadowAfterEl);
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    } // Set correct perspective for IE10


    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      var ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = "".concat(center, "px 50%");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  }
};
var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "coverflow"));
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    }
  }
};
var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;
    var SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Utils.extend(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Utils.extend(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (Utils.isObject(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex;
      var direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();
        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex) {
          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(swiper.realIndex + i, "\"]")).addClass(thumbActiveClass);
      }
    } else {
      for (var _i16 = 0; _i16 < thumbsToActivate; _i16 += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i16).addClass(thumbActiveClass);
      }
    }
  }
};
var Thumbs$1 = {
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      thumbs: {
        swiper: null,
        init: Thumbs.init.bind(swiper),
        update: Thumbs.update.bind(swiper),
        onThumbClick: Thumbs.onThumbClick.bind(swiper)
      }
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      var thumbs = swiper.params.thumbs;
      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;

      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
}; // Swiper Class

var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

if (typeof Swiper$1.use === 'undefined') {
  Swiper$1.use = Swiper$1.Class.use;
  Swiper$1.installModule = Swiper$1.Class.installModule;
}

Swiper$1.use(components);
/**
 * @file vue-awesome-swiper
 * @module constants
 * @author Surmon <https://github.com/surmon-china>
 */

var CoreNames;

(function (CoreNames) {
  CoreNames["SwiperComponent"] = "Swiper";
  CoreNames["SwiperSlideComponent"] = "SwiperSlide";
  CoreNames["SwiperDirective"] = "swiper";
  CoreNames["SwiperInstance"] = "$swiper";
})(CoreNames || (CoreNames = {}));

var DEFAULT_CLASSES = Object.freeze({
  containerClass: 'swiper-container',
  wrapperClass: 'swiper-wrapper',
  slideClass: 'swiper-slide'
});
var ComponentEvents;

(function (ComponentEvents) {
  ComponentEvents["Ready"] = "ready";
  ComponentEvents["ClickSlide"] = "clickSlide";
})(ComponentEvents || (ComponentEvents = {}));

var ComponentPropNames;

(function (ComponentPropNames) {
  ComponentPropNames["AutoUpdate"] = "autoUpdate";
  ComponentPropNames["AutoDestroy"] = "autoDestroy";
  ComponentPropNames["DeleteInstanceOnDestroy"] = "deleteInstanceOnDestroy";
  ComponentPropNames["CleanupStylesOnDestroy"] = "cleanupStylesOnDestroy";
})(ComponentPropNames || (ComponentPropNames = {})); // https://swiperjs.com/api/#events


var SWIPER_EVENTS = ['init', 'beforeDestroy', 'slideChange', 'slideChangeTransitionStart', 'slideChangeTransitionEnd', 'slideNextTransitionStart', 'slideNextTransitionEnd', 'slidePrevTransitionStart', 'slidePrevTransitionEnd', 'transitionStart', 'transitionEnd', 'touchStart', 'touchMove', 'touchMoveOpposite', 'sliderMove', 'touchEnd', 'click', 'tap', 'doubleTap', 'imagesReady', 'progress', 'reachBeginning', 'reachEnd', 'fromEdge', 'setTranslate', 'setTransition', 'resize', 'observerUpdate', 'beforeLoopFix', 'loopFix'];
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}
/**
 * @file vue-awesome-swiper
 * @module utils
 * @author Surmon <https://github.com/surmon-china>
 */


var kebabcase = function kebabcase(string) {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
};
/**
 * @file vue-awesome-swiper
 * @module event
 * @author Surmon <https://github.com/surmon-china>
 */


var handleClickSlideEvent = function handleClickSlideEvent(swiper, event, emit) {
  var _a, _b, _c;

  if (swiper && !swiper.destroyed) {
    var eventPath = ((_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)) || event.path;

    if ((event === null || event === void 0 ? void 0 : event.target) && eventPath) {
      var slides_1 = Array.from(swiper.slides);
      var paths = Array.from(eventPath); // Click slide || slide[children]

      if (slides_1.includes(event.target) || paths.some(function (item) {
        return slides_1.includes(item);
      })) {
        var clickedIndex = swiper.clickedIndex;
        var reallyIndex = Number((_c = (_b = swiper.clickedSlide) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c.swiperSlideIndex);
        var reallyIndexValue = Number.isInteger(reallyIndex) ? reallyIndex : null;
        emit(ComponentEvents.ClickSlide, clickedIndex, reallyIndexValue);
        emit(kebabcase(ComponentEvents.ClickSlide), clickedIndex, reallyIndexValue);
      }
    }
  }
};

var bindSwiperEvents = function bindSwiperEvents(swiper, emit) {
  SWIPER_EVENTS.forEach(function (eventName) {
    swiper.on(eventName, function () {
      var arguments$1 = arguments;
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments$1[_i];
      }

      emit.apply(void 0, __spreadArrays([eventName], args));
      var kebabcaseName = kebabcase(eventName);

      if (kebabcaseName !== eventName) {
        emit.apply(void 0, __spreadArrays([kebabcaseName], args));
      }
    });
  });
};
/**
 * @file vue-awesome-swiper
 * @module directive
 * @author Surmon <https://github.com/surmon-china>
 */


var INSTANCE_NAME_KEY = 'instanceName';

function getDirective(SwiperClass, globalOptions) {
  var getStandardisedOptionByAttrs = function getStandardisedOptionByAttrs(vnode, key) {
    var _a, _b, _c, _d;

    var value = (_b = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b[key];
    return value !== undefined ? value : (_d = (_c = vnode.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d[kebabcase(key)];
  }; // Get swiper instace name in directive


  var getSwiperInstanceName = function getSwiperInstanceName(element, binding, vnode) {
    return binding.arg || getStandardisedOptionByAttrs(vnode, INSTANCE_NAME_KEY) || element.id || CoreNames.SwiperInstance;
  };

  var getSwiperInstance = function getSwiperInstance(element, binding, vnode) {
    var instanceName = getSwiperInstanceName(element, binding, vnode);
    return vnode.context[instanceName] || null;
  };

  var getSwipeOptions = function getSwipeOptions(binding) {
    return binding.value || globalOptions;
  };

  var getBooleanValueByInput = function getBooleanValueByInput(input) {
    return [true, undefined, null, ''].includes(input);
  }; // Emit event in Vue directive


  var getEventEmiter = function getEventEmiter(vnode) {
    var _a, _b;

    var handlers = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.on) || ((_b = vnode.componentOptions) === null || _b === void 0 ? void 0 : _b.listeners);
    return function (name) {
      var arguments$1 = arguments;
      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments$1[_i];
      }

      var _a;

      var handle = (_a = handlers) === null || _a === void 0 ? void 0 : _a[name];

      if (handle) {
        handle.fns.apply(handle, args);
      }
    };
  };

  return {
    // Init
    bind: function bind(element, binding, vnode) {
      // auto class name
      if (element.className.indexOf(DEFAULT_CLASSES.containerClass) === -1) {
        element.className += (element.className ? ' ' : '') + DEFAULT_CLASSES.containerClass;
      } // bind click event


      element.addEventListener('click', function (event) {
        var emitEvent = getEventEmiter(vnode);
        var swiper = getSwiperInstance(element, binding, vnode);
        handleClickSlideEvent(swiper, event, emitEvent);
      });
    },
    // DOM inserted
    inserted: function inserted(element, binding, vnode) {
      var context = vnode.context;
      var swiperOptions = getSwipeOptions(binding);
      var instanceName = getSwiperInstanceName(element, binding, vnode);
      var emitEvent = getEventEmiter(vnode);
      var vueContext = context;
      var swiper = vueContext === null || vueContext === void 0 ? void 0 : vueContext[instanceName]; // Swiper will destroy but not delete instance, when used <keep-alive>

      if (!swiper || swiper.destroyed) {
        swiper = new SwiperClass(element, swiperOptions);
        vueContext[instanceName] = swiper;
        bindSwiperEvents(swiper, emitEvent);
        emitEvent(ComponentEvents.Ready, swiper); // MARK: Reinstance when the nexttick with <keep-alive>
        // Vue.nextTick(instancing) | setTimeout(instancing)
      }
    },
    // On options changed or DOM updated
    componentUpdated: function componentUpdated(element, binding, vnode) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

      var autoUpdate = getStandardisedOptionByAttrs(vnode, ComponentPropNames.AutoUpdate);

      if (getBooleanValueByInput(autoUpdate)) {
        var swiper = getSwiperInstance(element, binding, vnode);

        if (swiper) {
          var swiperOptions = getSwipeOptions(binding);
          var isLoop = swiperOptions.loop;

          if (isLoop) {
            (_b = (_a = swiper) === null || _a === void 0 ? void 0 : _a.loopDestroy) === null || _b === void 0 ? void 0 : _b.call(_a);
          }

          (_c = swiper === null || swiper === void 0 ? void 0 : swiper.update) === null || _c === void 0 ? void 0 : _c.call(swiper);
          (_e = (_d = swiper.navigation) === null || _d === void 0 ? void 0 : _d.update) === null || _e === void 0 ? void 0 : _e.call(_d);
          (_g = (_f = swiper.pagination) === null || _f === void 0 ? void 0 : _f.render) === null || _g === void 0 ? void 0 : _g.call(_f);
          (_j = (_h = swiper.pagination) === null || _h === void 0 ? void 0 : _h.update) === null || _j === void 0 ? void 0 : _j.call(_h);

          if (isLoop) {
            (_l = (_k = swiper) === null || _k === void 0 ? void 0 : _k.loopCreate) === null || _l === void 0 ? void 0 : _l.call(_k);
            (_m = swiper === null || swiper === void 0 ? void 0 : swiper.update) === null || _m === void 0 ? void 0 : _m.call(swiper);
          }
        }
      }
    },
    // Destroy this directive
    unbind: function unbind(element, binding, vnode) {
      var _a;

      var autoDestroy = getStandardisedOptionByAttrs(vnode, ComponentPropNames.AutoDestroy);

      if (getBooleanValueByInput(autoDestroy)) {
        var swiper = getSwiperInstance(element, binding, vnode);

        if (swiper && swiper.initialized) {
          (_a = swiper === null || swiper === void 0 ? void 0 : swiper.destroy) === null || _a === void 0 ? void 0 : _a.call(swiper, getBooleanValueByInput(getStandardisedOptionByAttrs(vnode, ComponentPropNames.DeleteInstanceOnDestroy)), getBooleanValueByInput(getStandardisedOptionByAttrs(vnode, ComponentPropNames.CleanupStylesOnDestroy)));
        }
      }
    }
  };
}
/**
 * @file vue-awesome-swiper
 * @module SwiperComponent
 * @author Surmon <https://github.com/surmon-china>
 */


var SlotNames;

(function (SlotNames) {
  SlotNames["ParallaxBg"] = "parallax-bg";
  SlotNames["Pagination"] = "pagination";
  SlotNames["Scrollbar"] = "scrollbar";
  SlotNames["PrevButton"] = "button-prev";
  SlotNames["NextButton"] = "button-next";
})(SlotNames || (SlotNames = {}));

function getSwiperComponent(SwiperClass) {
  var _a;

  return Vue.extend({
    name: CoreNames.SwiperComponent,
    props: (_a = {
      defaultOptions: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      },
      // eslint-disable-next-line vue/require-default-prop
      options: {
        type: Object,
        required: false
      }
    }, _a[ComponentPropNames.AutoUpdate] = {
      type: Boolean,
      "default": true
    }, // https://github.com/surmon-china/vue-awesome-swiper/pull/550/files
    _a[ComponentPropNames.AutoDestroy] = {
      type: Boolean,
      "default": true
    }, // https://github.com/surmon-china/vue-awesome-swiper/pull/388
    _a[ComponentPropNames.DeleteInstanceOnDestroy] = {
      type: Boolean,
      required: false,
      "default": true
    }, _a[ComponentPropNames.CleanupStylesOnDestroy] = {
      type: Boolean,
      required: false,
      "default": true
    }, _a),
    data: function data() {
      var _a;

      return _a = {}, _a[CoreNames.SwiperInstance] = null, _a;
    },
    computed: {
      swiperInstance: {
        cache: false,
        set: function set(swiper) {
          this[CoreNames.SwiperInstance] = swiper;
        },
        get: function get() {
          return this[CoreNames.SwiperInstance];
        }
      },
      swiperOptions: function swiperOptions() {
        return this.options || this.defaultOptions;
      },
      wrapperClass: function wrapperClass() {
        return this.swiperOptions.wrapperClass || DEFAULT_CLASSES.wrapperClass;
      }
    },
    methods: {
      // Feature: click event
      handleSwiperClick: function handleSwiperClick(event) {
        handleClickSlideEvent(this.swiperInstance, event, this.$emit.bind(this));
      },
      autoReLoopSwiper: function autoReLoopSwiper() {
        var _a, _b;

        if (this.swiperInstance && this.swiperOptions.loop) {
          // https://github.com/surmon-china/vue-awesome-swiper/issues/593
          // https://github.com/surmon-china/vue-awesome-swiper/issues/544
          // https://github.com/surmon-china/vue-awesome-swiper/pull/545/files
          var swiper = this.swiperInstance;
          (_a = swiper === null || swiper === void 0 ? void 0 : swiper.loopDestroy) === null || _a === void 0 ? void 0 : _a.call(swiper);
          (_b = swiper === null || swiper === void 0 ? void 0 : swiper.loopCreate) === null || _b === void 0 ? void 0 : _b.call(swiper);
        }
      },
      updateSwiper: function updateSwiper() {
        var _a, _b, _c, _d, _e, _f, _g, _h;

        if (this[ComponentPropNames.AutoUpdate] && this.swiperInstance) {
          this.autoReLoopSwiper();
          (_b = (_a = this.swiperInstance) === null || _a === void 0 ? void 0 : _a.update) === null || _b === void 0 ? void 0 : _b.call(_a);
          (_d = (_c = this.swiperInstance.navigation) === null || _c === void 0 ? void 0 : _c.update) === null || _d === void 0 ? void 0 : _d.call(_c);
          (_f = (_e = this.swiperInstance.pagination) === null || _e === void 0 ? void 0 : _e.render) === null || _f === void 0 ? void 0 : _f.call(_e);
          (_h = (_g = this.swiperInstance.pagination) === null || _g === void 0 ? void 0 : _g.update) === null || _h === void 0 ? void 0 : _h.call(_g);
        }
      },
      destroySwiper: function destroySwiper() {
        var _a, _b;

        if (this[ComponentPropNames.AutoDestroy] && this.swiperInstance) {
          // https://github.com/surmon-china/vue-awesome-swiper/pull/341
          // https://github.com/surmon-china/vue-awesome-swiper/issues/340
          if (this.swiperInstance.initialized) {
            (_b = (_a = this.swiperInstance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a, this[ComponentPropNames.DeleteInstanceOnDestroy], this[ComponentPropNames.CleanupStylesOnDestroy]);
          }
        }
      },
      initSwiper: function initSwiper() {
        this.swiperInstance = new SwiperClass(this.$el, this.swiperOptions);
        bindSwiperEvents(this.swiperInstance, this.$emit.bind(this));
        this.$emit(ComponentEvents.Ready, this.swiperInstance);
      }
    },
    mounted: function mounted() {
      if (!this.swiperInstance) {
        this.initSwiper();
      }
    },
    // Update swiper when the parent component activated with `keep-alive`.
    activated: function activated() {
      this.updateSwiper();
    },
    updated: function updated() {
      this.updateSwiper();
    },
    beforeDestroy: function beforeDestroy() {
      // https://github.com/surmon-china/vue-awesome-swiper/commit/2924a9d4d3d1cf51c0d46076410b1f804b2b8a43#diff-7f4e0261ac562c0f354cb91a1ca8864f
      this.$nextTick(this.destroySwiper);
    },
    render: function render(createElement) {
      return createElement('div', {
        staticClass: DEFAULT_CLASSES.containerClass,
        on: {
          click: this.handleSwiperClick
        }
      }, [this.$slots[SlotNames.ParallaxBg], createElement('div', {
        "class": this.wrapperClass
      }, this.$slots["default"]), this.$slots[SlotNames.Pagination], this.$slots[SlotNames.PrevButton], this.$slots[SlotNames.NextButton], this.$slots[SlotNames.Scrollbar]]);
    }
  });
}
/**
 * @file vue-awesome-swiper
 * @module SwiperSlideComponent
 * @author Surmon <https://github.com/surmon-china>
 */


var SwiperSlideComponent = Vue.extend({
  name: CoreNames.SwiperSlideComponent,
  computed: {
    slideClass: function slideClass() {
      var _a, _b;

      return ((_b = (_a = this.$parent) === null || _a === void 0 ? void 0 : _a.swiperOptions) === null || _b === void 0 ? void 0 : _b.slideClass) || DEFAULT_CLASSES.slideClass;
    }
  },
  methods: {
    update: function update() {
      var _a;

      var parent = this.$parent; // https://github.com/surmon-china/vue-awesome-swiper/issues/632

      if (parent[ComponentPropNames.AutoUpdate]) {
        (_a = parent === null || parent === void 0 ? void 0 : parent.swiperInstance) === null || _a === void 0 ? void 0 : _a.update();
      }
    }
  },
  mounted: function mounted() {
    this.update();
  },
  updated: function updated() {
    this.update();
  },
  render: function render(createElement) {
    return createElement('div', {
      "class": this.slideClass
    }, this.$slots["default"]);
  }
});
/**
 * @file vue-awesome-swiper
 * @module exporter
 * @author Surmon <https://github.com/surmon-china>
 */

var getInstaller = function getInstaller(SwiperClass) {
  var install = function install(Vue, globalOptions) {
    if (install.installed) {
      return;
    }

    var SwiperComponent = getSwiperComponent(SwiperClass);

    if (globalOptions) {
      SwiperComponent.options.props.defaultOptions["default"] = function () {
        return globalOptions;
      };
    }

    Vue.component(CoreNames.SwiperComponent, SwiperComponent);
    Vue.component(CoreNames.SwiperSlideComponent, SwiperSlideComponent);
    Vue.directive(CoreNames.SwiperDirective, getDirective(SwiperClass, globalOptions));
    install.installed = true;
  };

  return install;
};

function exporter(SwiperClass) {
  var _a;

  return _a = {
    version: '4.1.1',
    install: getInstaller(SwiperClass),
    directive: getDirective(SwiperClass)
  }, _a[CoreNames.SwiperComponent] = getSwiperComponent(SwiperClass), _a[CoreNames.SwiperSlideComponent] = SwiperSlideComponent, _a;
}
/**
 * @file vue-awesome-swiper
 * @module default-export
 * @author Surmon <https://github.com/surmon-china>
 */


var VueAwesomeSwiper = exporter(Swiper$1);
VueAwesomeSwiper.version;
VueAwesomeSwiper.install;
VueAwesomeSwiper.directive;
var Swiper = VueAwesomeSwiper.Swiper;
var SwiperSlide = VueAwesomeSwiper.SwiperSlide;
var script$o = Vue.extend({
  name: 'Carousel',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  props: {
    slides: Array,
    swiperOptions: {
      type: Object,
      required: true
    }
  },
  computed: {
    swiper: function swiper() {
      var _this$$refs;

      var swiperEl = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.mySwiper;
      return swiperEl === null || swiperEl === void 0 ? void 0 : swiperEl.$swiper;
    }
  }
});
/* script */

var __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function __vue_render__$o() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("swiper", {
    ref: "mySwiper",
    attrs: {
      options: _vm.swiperOptions
    },
    on: {
      slideChange: function slideChange($event) {
        return _vm.$emit("update:slide-change", _vm.swiper);
      }
    }
  }, [_vm._l(_vm.slides, function (slide, index) {
    return _c("swiper-slide", {
      key: index,
      staticClass: "text-center"
    }, [_vm._t("swiper-slide-content", null, {
      slide: slide,
      index: index
    })], 2);
  }), _vm._v(" "), _c("div", {
    staticClass: "swiper-button-prev",
    attrs: {
      slot: "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c("div", {
    staticClass: "swiper-button-next",
    attrs: {
      slot: "button-next"
    },
    slot: "button-next"
  }), _vm._v(" "), _c("div", {
    staticClass: "swiper-pagination",
    attrs: {
      slot: "pagination"
    },
    slot: "pagination"
  })], 2);
};

var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;
/* style */

var __vue_inject_styles__$o = undefined;
/* scoped */

var __vue_scope_id__$o = undefined;
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var previousColumnsWidth = 0;
var script$n = Vue.extend({
  name: 'sb-custom-table',
  props: {
    columns: {
      type: Array,
      "default": []
    },
    rows: {
      type: Array,
      "default": []
    },
    sortable: {
      type: Boolean,
      "default": false
    },
    defaultSortColumn: {
      type: String,
      "default": ''
    },
    defaultSort: {
      type: String,
      "default": 'desc'
    },
    disableTableSort: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      order: {
        column: '',
        sorting: 'asc'
      },
      sortedColumns: []
    };
  },
  created: function created() {
    var _columns$;

    var columns = this.columns.sort(function (column1, column2) {
      if ((column1 === null || column1 === void 0 ? void 0 : column1.fixed) === (column2 === null || column2 === void 0 ? void 0 : column2.fixed)) return 0;
      return column1 !== null && column1 !== void 0 && column1.fixed ? -1 : 1;
    });
    this.order = {
      column: this.defaultSortColumn || (columns === null || columns === void 0 ? void 0 : (_columns$ = columns[0]) === null || _columns$ === void 0 ? void 0 : _columns$.key),
      sorting: this.defaultSort
    };
    this.sortedColumns = columns;
  },
  computed: {
    getRows: function getRows() {
      if (!this.disableTableSort) {
        return this.sortRows(this.order.column, this.order.sorting);
      }

      return this.rows;
    }
  },
  methods: {
    sortRows: function sortRows(column) {
      var sorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
      return this.rows.sort(function (a, b) {
        if (a[column] < b[column]) {
          return sorting === 'asc' ? -1 : 1;
        }

        if (a[column] > b[column]) {
          return sorting === 'asc' ? 1 : -1;
        }

        return 0;
      });
    },
    setSortOrder: function setSortOrder(column) {
      if (this.order.column === column.key && this.order.sorting === 'asc') {
        this.order = {
          column: column.key,
          sorting: 'desc'
        };
      } else {
        this.order = {
          column: column.key,
          sorting: 'asc'
        };
      }
    },
    getIsOrderSelected: function getIsOrderSelected(columnKey, order) {
      return this.order.column === columnKey && this.order.sorting === order;
    },
    isColumnSortable: function isColumnSortable(column) {
      return this.sortable && (!column.hasOwnProperty('sortable') || column.sortable) || !this.sortable && column.sortable;
    },
    getLeftOffset: function getLeftOffset(index) {
      var previousColumnWidth = index === 0 ? 0 : this.sortedColumns[index - 1].width || 120;
      previousColumnsWidth += previousColumnWidth;
      if (index + 1 === this.sortedColumns.length) previousColumnsWidth = 0; // considering x-padding of td(20px) if column.width is not null

      return "".concat(previousColumnWidth > 120 ? previousColumnsWidth + 20 : previousColumnsWidth, "px");
    }
  },
  watch: {
    order: function order(value) {
      this.$emit('sortChange', value);
    }
  }
});
/* script */

var __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function __vue_render__$n() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "w-full overflow-x-auto box-content"
  }, [_c("table", {
    staticClass: "w-full text-left border-none border-collapse",
    attrs: {
      border: "0"
    }
  }, [_c("thead", [_c("tr", _vm._l(_vm.sortedColumns, function (column, index) {
    return _c("th", {
      key: column.key,
      staticClass: "py-4 px-2.5 font-bold text-center z-10 bg-white",
      "class": {
        "cursor-pointer": _vm.isColumnSortable(column),
        "pointer-events-none": !_vm.isColumnSortable(column),
        "lg:sticky": column.fixed
      },
      style: {
        width: column.width ? column.width + "px" : "auto",
        minWidth: column.width ? column.width + "px" : "100px",
        left: _vm.getLeftOffset(index)
      },
      on: {
        click: function click($event) {
          return _vm.setSortOrder(column);
        }
      }
    }, [_c("span", {
      staticClass: "sb-table__head-item relative",
      "class": {
        sortable: _vm.isColumnSortable(column)
      }
    }, [_c("span", [_vm._v(_vm._s(column.value))]), _vm._v(" "), _vm.isColumnSortable(column) ? _c("div", {
      staticClass: "absolute -right-3 bottom-0"
    }, [!_vm.getIsOrderSelected(column.key, "desc") ? _c("div", {
      staticClass: "sb-table__head-item__arrow text-gray-light cursor-pointer",
      "class": {
        "text-blue": _vm.getIsOrderSelected(column.key, "asc"),
        "mt-1": _vm.getIsOrderSelected(column.key, "asc")
      }
    }, [_vm._v("\n                ▲\n              ")]) : _vm._e(), _vm._v(" "), !_vm.getIsOrderSelected(column.key, "asc") ? _c("div", {
      staticClass: "sb-table__head-item__arrow text-gray-light cursor-pointer",
      "class": {
        "text-blue": _vm.getIsOrderSelected(column.key, "desc"),
        "mt-1.5": _vm.getIsOrderSelected(column.key, "desc")
      }
    }, [_vm._v("\n                ▼\n              ")]) : _vm._e()]) : _vm._e()])]);
  }), 0)]), _vm._v(" "), _c("tbody", _vm._l(_vm.getRows, function (row, rowIndex) {
    return _c("tr", {
      key: rowIndex,
      staticClass: "transition-all duration-200 bg-white"
    }, _vm._l(_vm.sortedColumns, function (column, index) {
      return _c("td", {
        key: column.key,
        staticClass: "p-2.5 text-center break-words z-10",
        "class": {
          "lg:sticky": column.fixed,
          "bg-white": column.fixed
        },
        style: {
          left: _vm.getLeftOffset(index)
        }
      }, [_vm._t(column.key, function () {
        return [_vm._v("\n            " + _vm._s(row[column.key]) + "\n          ")];
      }, {
        column: column,
        row: row
      })], 2);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;
/* style */

var __vue_inject_styles__$n = function __vue_inject_styles__$n(inject) {
  if (!inject) return;
  inject("data-v-7f1444f1_0", {
    source: ".sb-table__head-item__arrow[data-v-7f1444f1] {\n  font-size: 0.5rem;\n  line-height: 0.55rem;\n}\n\n/*# sourceMappingURL=CustomTable.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CustomTable.vue", "CustomTable.vue"],
      "names": [],
      "mappings": "AA2NA;EACA,iBAAA;EACA,oBAAA;AC1NA;;AAEA,0CAA0C",
      "file": "CustomTable.vue",
      "sourcesContent": ["<template>\n  <div class=\"w-full overflow-x-auto box-content\">\n    <table\n      class=\"w-full text-left border-none border-collapse\"\n      border=\"0\"\n    >\n      <thead>\n        <tr>\n          <th\n            v-for=\"(column, index) in sortedColumns\"\n            :class=\"{\n              'cursor-pointer': isColumnSortable(column),\n              'pointer-events-none': !isColumnSortable(column),\n              'lg:sticky': column.fixed,\n            }\"\n            :style=\"{\n              width: column.width ? `${column.width}px` : 'auto',\n              minWidth: column.width ? `${column.width}px` : '100px',\n              left: getLeftOffset(index)\n            }\"\n            class=\"py-4 px-2.5 font-bold text-center z-10 bg-white\"\n            @click=\"setSortOrder(column)\"\n            :key=\"column.key\"\n          >\n            <span\n              :class=\"{\n                'sortable': isColumnSortable(column),\n              }\"\n              class=\"sb-table__head-item relative\"\n            >\n              <span>{{column.value}}</span>\n              <div v-if=\"isColumnSortable(column)\" class=\"absolute -right-3 bottom-0\">\n                <div\n                  v-if=\"!(getIsOrderSelected(column.key, 'desc'))\"\n                  v-bind:class=\"{\n                    'text-blue': getIsOrderSelected(column.key, 'asc'),\n                    'mt-1': getIsOrderSelected(column.key, 'asc'),\n                  }\"\n                  class=\"sb-table__head-item__arrow text-gray-light cursor-pointer\"\n                >\n                  ▲\n                </div>\n                <div\n                  v-if=\"!(getIsOrderSelected(column.key, 'asc'))\"\n                  v-bind:class=\"{\n                    'text-blue': getIsOrderSelected(column.key, 'desc'),\n                    'mt-1.5': getIsOrderSelected(column.key, 'desc'),\n                  }\"\n                  class=\"sb-table__head-item__arrow text-gray-light cursor-pointer\"\n                >\n                  ▼\n                </div>\n              </div>\n            </span>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr\n          v-for=\"(row, rowIndex) in getRows\"\n          :key=\"rowIndex\"\n          class=\"transition-all duration-200 bg-white\"\n        >\n          <td\n            v-for=\"(column, index) in sortedColumns\"\n            :key=\"column.key\"\n            :style=\"{\n              left: getLeftOffset(index),\n            }\"\n            :class=\"{\n              'lg:sticky': column.fixed,\n              'bg-white': column.fixed,\n            }\"\n            class=\"p-2.5 text-center break-words z-10\"\n          >\n            <slot\n              :name=\"column.key\"\n              :column=\"column\"\n              :row=\"row\"\n            >\n              {{row[column.key]}}\n            </slot>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</template>\n<script lang=\"ts\">\nimport Vue, { PropType } from 'vue';\n\nvar previousColumnsWidth:number = 0;\n\ntype Row = {\n  [key in string | number]: string;\n}\n\ntype SortDirection = 'asc' | 'desc';\n\ninterface Column {\n  key: string;\n  sorting: SortDirection;\n  value: string;\n  sortable?: boolean;\n  fixed?: boolean;\n  width?: number;\n}\ninterface Order {\n  column: string;\n  sorting: SortDirection;\n}\n\nexport default Vue.extend({\n  name: 'sb-custom-table',\n  props: {\n    columns: {\n      type: Array as PropType<Array<Column>>,\n      default: [],\n    },\n    rows: {\n      type: Array as PropType<Array<Row>>,\n      default: []\n    },\n    sortable: {\n      type: Boolean,\n      default: false,\n    },\n    defaultSortColumn: {\n      type: String,\n      default: '',\n    },\n    defaultSort: {\n      type: String as PropType<SortDirection>,\n      default: 'desc',\n    },\n    disableTableSort: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data(): { order: Order, sortedColumns: Column[] } {\n    return {\n      order: {\n        column: '',\n        sorting: 'asc',\n      },\n      sortedColumns: [],\n    }\n  },\n  created() {\n    const columns = this.columns.sort((column1, column2) => {\n      if (column1?.fixed === column2?.fixed) return 0;\n      return column1?.fixed ? -1 : 1;\n    });\n    this.order = {\n      column: this.defaultSortColumn || columns?.[0]?.key,\n      sorting: this.defaultSort,\n    } as Order;\n    this.sortedColumns = columns;\n  },\n  computed: {\n    getRows(): Row[] {\n      if (!this.disableTableSort) {\n        return this.sortRows(this.order.column, this.order.sorting);\n      }\n      return this.rows;\n    }\n  },\n  methods: {\n    sortRows(column: string | number, sorting = 'asc'): Row[] {\n      return this.rows.sort((a: Row, b: Row) => {\n        if (a[column] < b[column]){\n          return sorting === 'asc' ? -1 : 1;\n        }\n        if (a[column] > b[column]){\n          return sorting === 'asc' ? 1 : -1;\n        }\n        return 0;\n      });\n    },\n    setSortOrder(column: Column): void {\n      if (\n        this.order.column === column.key &&\n        this.order.sorting === 'asc'\n      ) {\n        this.order = {\n          column: column.key,\n          sorting: 'desc',\n        };\n      } else {\n        this.order = {\n          column: column.key,\n          sorting: 'asc',\n        };\n      }\n    },\n    getIsOrderSelected(columnKey: string, order: SortDirection): boolean {\n      return this.order.column === columnKey && this.order.sorting === order;\n    },\n    isColumnSortable(column: Column) {\n      return this.sortable && (!column.hasOwnProperty('sortable') || column.sortable)\n        || !this.sortable && column.sortable;\n    },\n    getLeftOffset(index: number) {\n      const previousColumnWidth = index === 0 ? 0 : this.sortedColumns[index-1].width || 120;\n      previousColumnsWidth += previousColumnWidth;\n      if(index + 1 === this.sortedColumns.length) previousColumnsWidth = 0;\n      // considering x-padding of td(20px) if column.width is not null\n      return `${previousColumnWidth > 120 ?  previousColumnsWidth + 20 : previousColumnsWidth}px`;\n    }\n  },\n  watch: {\n    order(value: Column): void {\n      this.$emit('sortChange', value);\n    }\n  }\n})\n</script>\n<style lang=\"scss\" scoped>\n  .sb-table__head-item__arrow {\n    font-size: 0.5rem;\n    line-height: 0.55rem;\n  }\n</style>\n", ".sb-table__head-item__arrow {\n  font-size: 0.5rem;\n  line-height: 0.55rem;\n}\n\n/*# sourceMappingURL=CustomTable.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$n = "data-v-7f1444f1";
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var script$m = Vue.extend({
  name: "VideoPlayer",
  props: {
    src: {
      type: String,
      required: true
    },
    uniqID: {
      type: String,
      "default": 'video_player'
    },
    allowFullscreen: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      videoToggle: false
    };
  },
  methods: {
    playVideo: function playVideo() {
      this.videoToggle = !this.videoToggle;
      var el = document.getElementById(this.uniqID);
      if (el) el.play();
    },
    pauseVideo: function pauseVideo() {
      this.videoToggle = !this.videoToggle;
      var el = document.getElementById(this.uniqID);
      if (el) el.pause();
    },
    openFullscreen: function openFullscreen() {
      var el = document.getElementById(this.uniqID);
      if (el) el.requestFullscreen();
    }
  }
});
/* script */

var __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function __vue_render__$m() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "relative video-wrapper"
  }, [_c("video", {
    staticClass: "w-full",
    attrs: {
      id: _vm.uniqID,
      src: _vm.src
    },
    on: {
      click: function click($event) {
        _vm.allowFullscreen ? _vm.openFullscreen() : null;
      }
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "video-controls opacity-0 transition ease-in-out duration-500 hover:opacity-100"
  }, [!_vm.videoToggle ? _c("fai", {
    staticClass: "absolute top-1/2 left-1/2 cursor-pointer",
    attrs: {
      icon: ["far", "fa-circle-play"],
      size: "5x"
    },
    on: {
      click: _vm.playVideo
    }
  }) : _c("fai", {
    staticClass: "absolute top-1/2 left-1/2 cursor-pointer",
    attrs: {
      icon: ["far", "fa-circle-pause"],
      size: "5x"
    },
    on: {
      click: _vm.pauseVideo
    }
  })], 1)]);
};

var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;
/* style */

var __vue_inject_styles__$m = function __vue_inject_styles__$m(inject) {
  if (!inject) return;
  inject("data-v-4003c2e6_0", {
    source: ".video-wrapper video:hover + .video-controls[data-v-4003c2e6] {\n  opacity: 1;\n}\n.video-wrapper .video-controls svg[data-v-4003c2e6] {\n  width: 100px;\n  height: 100px;\n  transform: translate(-50%, -50%);\n}\n.video-wrapper .video-controls svg path[data-v-4003c2e6] {\n  fill: white;\n}\n\n/*# sourceMappingURL=VideoPlayer.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/VideoPlayer.vue", "VideoPlayer.vue"],
      "names": [],
      "mappings": "AAyDA;EACA,UAAA;ACxDA;AD+DA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AC7DA;AD+DA;EACA,WAAA;AC7DA;;AAEA,0CAA0C",
      "file": "VideoPlayer.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"relative video-wrapper\">\r\n    <video :id=\"uniqID\" :src=\"src\" class=\"w-full\" @click=\"allowFullscreen ? openFullscreen(): null\"/>\r\n    <div class=\"video-controls opacity-0 transition ease-in-out duration-500 hover:opacity-100\">\r\n      <fai v-if=\"!videoToggle\" class=\"absolute top-1/2 left-1/2 cursor-pointer\" :icon=\"['far', 'fa-circle-play']\" @click=\"playVideo\" size=\"5x\"/>\r\n      <fai v-else class=\"absolute top-1/2 left-1/2 cursor-pointer\" :icon=\"['far', 'fa-circle-pause']\" @click=\"pauseVideo\" size=\"5x\"/>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script lang=\"ts\">\r\nimport Vue from 'vue';\r\n\r\nexport default Vue.extend({\r\n  name: \"VideoPlayer\",\r\n  props: {\r\n    src: {\r\n      type: String,\r\n      required: true\r\n    },\r\n    uniqID: {\r\n      type: String,\r\n      default: 'video_player'\r\n    },\r\n    allowFullscreen : {\r\n      type: Boolean,\r\n      default: false\r\n    }\r\n  },\r\n  data() {\r\n    return {\r\n      videoToggle: false\r\n    }\r\n  },\r\n  methods: {\r\n    playVideo() {\r\n      this.videoToggle = !this.videoToggle\r\n      const el = document.getElementById(this.uniqID) as HTMLVideoElement\r\n      if (el) el.play()\r\n    },\r\n    pauseVideo() {\r\n      this.videoToggle = !this.videoToggle\r\n      const el = document.getElementById(this.uniqID) as HTMLVideoElement\r\n      if (el) el.pause()\r\n    },\r\n    openFullscreen() {\r\n      const el = document.getElementById(this.uniqID) as HTMLVideoElement\r\n      if (el) el.requestFullscreen()\r\n    }\r\n  }\r\n})\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n.video-wrapper {\r\n  video {\r\n    &:hover {\r\n      + .video-controls {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n\r\n  .video-controls {\r\n\r\n    svg {\r\n      width: 100px;\r\n      height: 100px;\r\n      transform: translate(-50%, -50%);\r\n\r\n      path {\r\n        fill: white;\r\n      }\r\n    }\r\n  }\r\n}\r\n</style>", ".video-wrapper video:hover + .video-controls {\n  opacity: 1;\n}\n.video-wrapper .video-controls svg {\n  width: 100px;\n  height: 100px;\n  transform: translate(-50%, -50%);\n}\n.video-wrapper .video-controls svg path {\n  fill: white;\n}\n\n/*# sourceMappingURL=VideoPlayer.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$m = "data-v-4003c2e6";
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var script$l = Vue.extend({
  name: 'CarouselCampaign',
  props: {
    slides: Array
  },
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    VideoPlayer: __vue_component__$m
  },
  data: function data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.next-btn-campaign-carousel',
          prevEl: '.prev-btn-campaign-carousel'
        },
        pagination: {
          el: ".swiper-pagination-campaign",
          type: "fraction"
        },
        grabCursor: true,
        centeredSlides: false
      }
    };
  },
  computed: {
    swiper: function swiper() {
      var _this$$refs;

      var el = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.mySwiper;
      return el.$swiper;
    }
  },
  mounted: function mounted() {
    this.swiper.slideTo(this.slides.length, 0);
  },
  watch: {
    slides: function slides(newSlides) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this9.swiper;

              case 2:
                _this9.swiper.slideTo(newSlides.length, 0);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  methods: {
    slideChange: function slideChange() {
      this.$emit('slide-change', this.swiper);
    },
    videoSlide: function videoSlide(slide) {
      return slide.includes('www.youtube.com') || slide.includes('.mp4');
    },
    stopAllVideo: function stopAllVideo() {
      var _this10 = this;

      var videos = document.querySelectorAll('.campaign-video > video');

      if (videos) {
        videos.forEach(function (el) {
          var id = el.getAttribute('id') || '';
          var ref = _this10.$refs[id];
          ref[0].pauseVideo();
          ref[0]._data.videoToggle = false;
        });
      }
    }
  }
});
/* script */

var __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function __vue_render__$l() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "carousel-campaign"
  }, [_c("swiper", {
    ref: "mySwiper",
    attrs: {
      options: _vm.swiperOptions
    },
    on: {
      slideChange: _vm.slideChange
    }
  }, _vm._l(_vm.slides, function (slide, index) {
    return _c("swiper-slide", {
      key: index,
      staticClass: "w-8/12",
      "class": {
        "w-full": _vm.slides.length === 1
      }
    }, [_vm.videoSlide(slide) ? _c("div", {
      staticClass: "img-container m-0 w-full pb-2 flex items-end justify-center w-full"
    }, [_c("div", {
      staticClass: "counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around absolute top-1 right-1 z-10"
    }, [_c("div", {
      staticClass: "icon text-blue cursor-pointer prev-btn-campaign-carousel",
      on: {
        click: _vm.stopAllVideo
      }
    }, [_c("fai", {
      attrs: {
        icon: ["fas", "chevron-left"]
      }
    })], 1), _vm._v(" "), _c("div", {
      staticClass: "number text-xs px-1"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c("div", {
      staticClass: "icon text-blue cursor-pointer next-btn-campaign-carousel",
      on: {
        click: _vm.stopAllVideo
      }
    }, [_c("fai", {
      attrs: {
        icon: ["fas", "chevron-right"]
      }
    })], 1)]), _vm._v(" "), slide.includes("www.youtube.com") ? _c("iframe", {
      staticClass: "w-full min-h-full absolute",
      attrs: {
        src: slide,
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      }
    }) : slide.includes(".mp4") ? _c("div", {
      staticClass: "video"
    }, [_c("video-player", {
      ref: "campaign-video-preview_" + index,
      refInFor: true,
      staticClass: "campaign-video",
      attrs: {
        uniqID: "campaign-video-preview_" + index,
        src: slide
      }
    })], 1) : _vm._e(), _vm._v(" "), _c("div", {
      staticClass: "remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer block absolute left-1/2 z-10",
      on: {
        click: function click($event) {
          return _vm.$emit("remove-slide", slide);
        }
      }
    }, [_vm._v("remove\n        ")])]) : _c("div", {
      staticClass: "img-container m-0 w-full bg-cover bg-center bg-no-repeat flex items-end justify-center pb-2",
      style: "background-image: url(" + slide + ")"
    }, [_c("div", {
      staticClass: "counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around"
    }, [_c("div", {
      staticClass: "icon text-blue cursor-pointer prev-btn-campaign-carousel",
      on: {
        click: _vm.stopAllVideo
      }
    }, [_c("fai", {
      attrs: {
        icon: ["fas", "chevron-left"]
      }
    })], 1), _vm._v(" "), _c("div", {
      staticClass: "number text-xs px-1"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c("div", {
      staticClass: "icon text-blue cursor-pointer next-btn-campaign-carousel",
      on: {
        click: _vm.stopAllVideo
      }
    }, [_c("fai", {
      attrs: {
        icon: ["fas", "chevron-right"]
      }
    })], 1)]), _vm._v(" "), _c("div", {
      staticClass: "remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer",
      on: {
        click: function click($event) {
          return _vm.$emit("remove-slide", slide);
        }
      }
    }, [_vm._v("remove\n        ")])])]);
  }), 1)], 1);
};

var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;
/* style */

var __vue_inject_styles__$l = function __vue_inject_styles__$l(inject) {
  if (!inject) return;
  inject("data-v-270ccf1e_0", {
    source: "\n.img-container[data-v-270ccf1e] {\r\n  height: 350px;\n}\n.remove-action[data-v-270ccf1e] {\r\n  transform: translateX(-50%);\n}\n.counter[data-v-270ccf1e] {\r\n  width: 40px;\r\n  height: 40px;\n}\n.icon svg[data-v-270ccf1e] {\r\n  width: 6px;\n}\n.swiper-button-disabled[data-v-270ccf1e] {\r\n  opacity: 0.25;\r\n  pointer-events: none;\r\n  display: block !important;\n}\r\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CarouselCampaign.vue"],
      "names": [],
      "mappings": ";AAyIA;EACA,aAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;AACA",
      "file": "CarouselCampaign.vue",
      "sourcesContent": ["<template>\r\n  <main class=\"carousel-campaign\">\r\n    <swiper ref=\"mySwiper\"\r\n            :options=\"swiperOptions\"\r\n            @slideChange=\"slideChange\">\r\n      <swiper-slide :key=\"index\"\r\n                    class=\"w-8/12\"\r\n                    :class=\"{'w-full': slides.length === 1}\"\r\n                    v-for=\"(slide, index) of slides\">\r\n        <!--video slide-->\r\n        <div class=\"img-container m-0 w-full pb-2 flex items-end justify-center w-full\" v-if=\"videoSlide(slide)\">\r\n          <div\r\n              class=\"counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around absolute top-1 right-1 z-10\">\r\n            <div class=\"icon text-blue cursor-pointer prev-btn-campaign-carousel\" @click=\"stopAllVideo\">\r\n              <fai :icon=\"['fas', 'chevron-left']\"/>\r\n            </div>\r\n            <div class=\"number text-xs px-1\">\r\n              {{ index + 1 }}\r\n            </div>\r\n            <div class=\"icon text-blue cursor-pointer next-btn-campaign-carousel\" @click=\"stopAllVideo\">\r\n              <fai :icon=\"['fas', 'chevron-right']\"/>\r\n            </div>\r\n          </div>\r\n          <!--your tube Iframe-->\r\n          <iframe v-if=\"slide.includes('www.youtube.com')\"\r\n                  :src=\"slide\"\r\n                  class=\"w-full min-h-full absolute\"\r\n                  frameborder=\"0\"\r\n                  allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\r\n                  allowfullscreen></iframe>\r\n          <!--custom player-->\r\n          <div v-else-if=\"slide.includes('.mp4')\"\r\n               class=\"video\">\r\n            <video-player\r\n                class=\"campaign-video\"\r\n                :uniqID=\"`campaign-video-preview_${index}`\"\r\n                :ref=\"`campaign-video-preview_${index}`\"\r\n                :src=\"slide\"/>\r\n          </div>\r\n          <div\r\n              class=\"remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer block absolute left-1/2 z-10\"\r\n              @click=\"$emit('remove-slide', slide)\">remove\r\n          </div>\r\n        </div>\r\n        <!--image container -->\r\n        <div class=\"img-container m-0 w-full bg-cover bg-center bg-no-repeat flex items-end justify-center pb-2\"\r\n             v-else\r\n             :style=\"`background-image: url(${slide})`\">\r\n          <div\r\n              class=\"counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around\">\r\n            <div class=\"icon text-blue cursor-pointer prev-btn-campaign-carousel\" @click=\"stopAllVideo\">\r\n              <fai :icon=\"['fas', 'chevron-left']\"/>\r\n            </div>\r\n            <div class=\"number text-xs px-1\">\r\n              {{ index + 1 }}\r\n            </div>\r\n            <div class=\"icon text-blue cursor-pointer next-btn-campaign-carousel\" @click=\"stopAllVideo\">\r\n              <fai :icon=\"['fas', 'chevron-right']\"/>\r\n            </div>\r\n          </div>\r\n          <div class=\"remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer\"\r\n               @click=\"$emit('remove-slide', slide)\">remove\r\n          </div>\r\n        </div>\r\n      </swiper-slide>\r\n    </swiper>\r\n  </main>\r\n</template>\r\n\r\n<script lang=\"ts\">\r\nimport Vue from 'vue';\r\nimport {Swiper, SwiperSlide} from \"vue-awesome-swiper\";\r\nimport VideoPlayer from \"@/components/blocks/VideoPlayer.vue\";\r\n\r\nexport default Vue.extend({\r\n  name: 'CarouselCampaign',\r\n  props: {\r\n    slides: Array\r\n  },\r\n  components: {\r\n    Swiper, SwiperSlide, VideoPlayer\r\n  },\r\n  data: () => ({\r\n    swiperOptions: {\r\n      slidesPerView: 'auto',\r\n      navigation: {\r\n        nextEl: '.next-btn-campaign-carousel',\r\n        prevEl: '.prev-btn-campaign-carousel'\r\n      },\r\n      pagination: {\r\n        el: \".swiper-pagination-campaign\",\r\n        type: \"fraction\",\r\n      },\r\n      grabCursor: true,\r\n      centeredSlides: false,\r\n    },\r\n  }),\r\n  computed: {\r\n    swiper() {\r\n      const el = this.$refs?.mySwiper as any\r\n      return el.$swiper\r\n    }\r\n  },\r\n  mounted() {\r\n    this.swiper.slideTo(this.slides.length, 0)\r\n  },\r\n  watch: {\r\n    async slides(newSlides) {\r\n      await this.swiper;\r\n      this.swiper.slideTo(newSlides.length, 0)\r\n    }\r\n  },\r\n  methods: {\r\n    slideChange() {\r\n      this.$emit('slide-change', this.swiper)\r\n    },\r\n    videoSlide(slide: string): boolean {\r\n      return slide.includes('www.youtube.com') ||\r\n          slide.includes('.mp4');\r\n    },\r\n\r\n    stopAllVideo() {\r\n      const videos = document.querySelectorAll('.campaign-video > video')\r\n      if (videos) {\r\n        videos.forEach(el => {\r\n          const id = el.getAttribute('id') || ''\r\n          const ref = this.$refs[id]! as any\r\n          ref[0].pauseVideo()\r\n          ref[0]._data.videoToggle = false\r\n        })\r\n      }\r\n    }\r\n  }\r\n});\r\n</script>\r\n\r\n<style lang=\"postcss\" scoped>\r\n.img-container {\r\n  height: 350px;\r\n}\r\n\r\n.remove-action {\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.counter {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.icon svg {\r\n  width: 6px;\r\n}\r\n\r\n.swiper-button-disabled {\r\n  opacity: 0.25;\r\n  pointer-events: none;\r\n  display: block !important;\r\n}\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$l = "data-v-270ccf1e";
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var script$k = Vue.extend({
  name: 'ErrorBanner',
  data: function data() {
    return {
      mountedInModal: false
    };
  },
  created: function created() {
    if (!!this.$store.getters.modal) {
      this.mountedInModal = true;
    }
  },
  computed: {
    errors: function errors() {
      return this.mountedInModal ? this.$store.getters.displayableModalErrors : this.$store.getters.displayableErrors;
    },
    messages: function messages() {
      var messages = new Set();
      this.errors.forEach(function (error) {
        return messages.add(error.message);
      });
      return Array.from(messages);
    }
  }
});
/* script */

var __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function __vue_render__$k() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.messages.length > 0 ? _c("main", {
    staticClass: "error-banner text-white bg-red"
  }, _vm._l(_vm.messages, function (message) {
    return _c("div", [_vm._v("\n    " + _vm._s(message) + "\n  ")]);
  }), 0) : _vm._e();
};

var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;
/* style */

var __vue_inject_styles__$k = function __vue_inject_styles__$k(inject) {
  if (!inject) return;
  inject("data-v-7c63758e_0", {
    source: "\n.error-banner {\n  padding: 0.5em 1em;\n  border-radius: 8px;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/ErrorBanner.vue"],
      "names": [],
      "mappings": ";AAuCA;EACA,kBAAA;EACA,kBAAA;AACA",
      "file": "ErrorBanner.vue",
      "sourcesContent": ["<template>\n  <main class=\"error-banner text-white bg-red\" v-if=\"messages.length > 0\">\n    <div v-for=\"message in messages\">\n      {{ message }}\n    </div>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\nimport { AppError } from '@/models';\n\nexport default Vue.extend({\n  name: 'ErrorBanner',\n\n  data: () => ({\n    mountedInModal: false\n  }),\n\n  created() {\n    if(!!this.$store.getters.modal) {\n      this.mountedInModal = true;\n    }\n  },\n\n  computed: {\n    errors() {\n      return this.mountedInModal ? this.$store.getters.displayableModalErrors : this.$store.getters.displayableErrors;\n    },\n    messages() {\n      const messages = new Set();\n      this.errors.forEach((error: AppError) => messages.add(error.message));\n      return Array.from(messages);\n    }\n  }\n});\n</script>\n\n<style lang=\"postcss\">\n  .error-banner {\n    padding: 0.5em 1em;\n    border-radius: 8px;\n  }\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$k = undefined;
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$j = Vue.extend({
  name: 'dropdown-with-preview',
  components: {
    dropdown: __vue_component__$q
  },
  props: {
    focused: Boolean,
    rows: Array,
    headerRows: Array,
    footerRows: Array,
    enableCloseButton: {
      type: Boolean,
      "default": false
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  }
});
/* script */

var __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function __vue_render__$j() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-dropdown-with-preview flex flex-row items-stretch",
    "class": {
      focused: _vm.focused
    }
  }, [_c("dropdown", {
    attrs: {
      variant: "button",
      rows: _vm.rows,
      headerRows: _vm.headerRows,
      footerRows: _vm.footerRows,
      focused: _vm.focused,
      enableCloseButton: _vm.enableCloseButton,
      disabled: _vm.disabled
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close", $event);
      },
      "update:focused": function updateFocused($event) {
        return _vm.$emit("update:focused", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._t("label")];
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _c("section", {
    staticClass: "dropdown-preview bg-white w-full border border-solid rounded rounded-l-none p-2 overflow-y-auto flex-grow-0",
    "class": {
      disabled: _vm.disabled
    }
  }, [_vm._t("preview")], 2)], 1);
};

var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;
/* style */

var __vue_inject_styles__$j = function __vue_inject_styles__$j(inject) {
  if (!inject) return;
  inject("data-v-0d746464_0", {
    source: "\n.sb-dropdown-with-preview[data-v-0d746464] .primary-div {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sb-dropdown-with-preview[data-v-0d746464]:hover .close-dropdown-btn {\n  display: block;\n}\n.dropdown-preview.disabled[data-v-0d746464] {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  border-left:none;\n  color: #adadad;\n  cursor: not-allowed;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/DropdownWithPreview.vue"],
      "names": [],
      "mappings": ";AAkDA;EACA,0BAAA;EACA,6BAAA;AACA;AACA;EACA,cAAA;AACA;AACA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACA",
      "file": "DropdownWithPreview.vue",
      "sourcesContent": ["<template>\n  <main class='sb-dropdown-with-preview flex flex-row items-stretch' :class=\"{ focused }\">\n    <dropdown variant=\"button\"\n              :rows=\"rows\" \n              :headerRows=\"headerRows\" \n              :footerRows=\"footerRows\" \n              :focused=\"focused\"\n              :enableCloseButton=\"enableCloseButton\"\n              :disabled=\"disabled\"\n              @close=\"$emit('close', $event)\"\n              @update:focused=\"$emit('update:focused', $event)\"\n    >\n      <template #label>\n        <slot name=\"label\" />\n      </template>\n    </dropdown>\n\n    <section class=\"dropdown-preview bg-white w-full border border-solid rounded rounded-l-none p-2 overflow-y-auto flex-grow-0\" :class=\"{disabled}\">\n      <slot name=\"preview\" />\n    </section>\n  </main>\n</template>\n\n<script lang=\"ts\">\n  import Vue, { PropType } from \"vue\";\n  import dropdown from \"./dropdown/Dropdown.vue\";\n\n  export default Vue.extend({\n    name: 'dropdown-with-preview',\n    components: {\n      dropdown\n    },\n    props: {\n      focused: Boolean,\n      rows: Array as PropType<Array<Object>>,\n      headerRows: Array as PropType<Array<any>>,\n      footerRows: Array as PropType<Array<any>>,\n      enableCloseButton: {\n        type: Boolean,\n        default: false\n      },\n      disabled: {\n        type: Boolean,\n        default: false\n      },\n    }\n  })\n</script>\n\n<style scoped lang=\"postcss\">\n.sb-dropdown-with-preview >>> .primary-div {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sb-dropdown-with-preview:hover >>> .close-dropdown-btn {\n  display: block;\n}\n.dropdown-preview.disabled {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  border-left:none;\n  color: #adadad;\n  cursor: not-allowed;\n}\n</style>"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$j = "data-v-0d746464";
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var script$i = Vue.extend({
  props: {
    resolveText: {
      type: String,
      "default": "save"
    },
    rejectText: {
      type: String,
      "default": "cancel"
    }
  },
  name: "fullscreen-view",
  methods: {
    rejected: function rejected() {
      this.$emit('rejected');
    },
    resolved: function resolved() {
      this.$emit('resolved');
    }
  }
});
/* script */

var __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function __vue_render__$i() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-fullscreen-view"
  }, [_c("header", {
    staticClass: "header"
  }, [_vm._t("header", function () {
    return [_c("button", {
      staticClass: "sb-button mr-4",
      on: {
        click: _vm.resolved
      }
    }, [_vm._v(_vm._s(_vm.resolveText))]), _vm._v(" "), _c("button", {
      staticClass: "sb-button",
      on: {
        click: _vm.rejected
      }
    }, [_vm._v(_vm._s(_vm.rejectText))])];
  })], 2), _vm._v(" "), _c("section", {
    staticClass: "content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c("footer", [_vm._t("footer")], 2)]);
};

var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;
/* style */

var __vue_inject_styles__$i = function __vue_inject_styles__$i(inject) {
  if (!inject) return;
  inject("data-v-70d68186_0", {
    source: "\n.sb-fullscreen-view[data-v-70d68186]{\n  background-color: white;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: space-between;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n.sb-fullscreen-view .header[data-v-70d68186] {\n  background-color: #A6D4FC;\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1.5rem;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/FullscreenView.vue"],
      "names": [],
      "mappings": ";AA8CA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;AACA;AAEA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AACA",
      "file": "FullscreenView.vue",
      "sourcesContent": ["<template>\n  <main class=\"sb-fullscreen-view\">\n    <header class=\"header\">\n      <slot name=\"header\">\n        <button class=\"sb-button mr-4\" @click=\"resolved\">{{ resolveText }}</button>\n        <button class=\"sb-button\" @click=\"rejected\">{{ rejectText }}</button>\n      </slot>\n    </header>\n    <section class=\"content\">\n      <slot name=\"content\" />\n    </section>\n    <footer>\n      <slot name=\"footer\" />\n    </footer>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\n\nexport default Vue.extend({\n  props: {\n    resolveText: {\n      type: String,\n      default: \"save\"\n    },\n    rejectText: {\n      type: String,\n      default: \"cancel\"\n    }\n  },\n\n  name: \"fullscreen-view\",\n\n  methods: {\n    rejected(){\n      this.$emit('rejected');\n    },\n    resolved(){\n      this.$emit('resolved');\n    }\n  }\n})\n</script>\n\n<style scoped>\n.sb-fullscreen-view{\n  background-color: white;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: space-between;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n\n.sb-fullscreen-view .header {\n  background-color: #A6D4FC;\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1.5rem;\n}\n</style>"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$i = "data-v-70d68186";
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var script$h = Vue.extend({
  name: 'CarouselActions',
  props: {
    slides: Array
  },
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  data: function data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        centeredSlides: false
      }
    };
  },
  computed: {
    swiper: function swiper() {
      var _this$$refs;

      var el = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.mySwiper;
      return el.$swiper;
    }
  },
  watch: {
    slides: function slides(newSlides) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this11.swiper;

              case 2:
                _this11.swiper.slideTo(newSlides.length, 0);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  methods: {
    slideChange: function slideChange() {
      this.$emit('slide-change', this.swiper);
    }
  }
});
/* script */

var __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function __vue_render__$h() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "carousel-actions"
  }, [_c("swiper", {
    ref: "mySwiper",
    attrs: {
      options: _vm.swiperOptions
    },
    on: {
      slideChange: _vm.slideChange
    }
  }, _vm._l(_vm.slides, function (slide, index) {
    return _c("swiper-slide", {
      key: index,
      "class": {
        "w-100": _vm.slides.length === 1
      }
    }, [_c("div", {
      staticClass: "img-container w-full bg-cover bg-center bg-no-repeat m-0",
      style: "background-image: url(" + slide + ")"
    })]);
  }), 1), _vm._v(" "), _c("div", {
    staticClass: "bottom-control p-4 border-t-1 border-0 border-solid",
    "class": {
      "flex justify-center": _vm.slides.length === 1
    }
  }, [_c("div", {
    staticClass: "action flex items-center justify-between"
  }, [_vm.slides.length > 1 ? _c("div", {
    staticClass: "swiper-button swiper-button-prev static border border-solid rounded-full mt-0",
    attrs: {
      slot: "button-prev"
    },
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "remove-action border border-solid py-2 px-3 rounded cursor-pointer",
    on: {
      click: function click($event) {
        return _vm.$emit("remove-slide", _vm.swiper.snapIndex);
      }
    }
  }, [_vm._v("remove")]), _vm._v(" "), _vm.slides.length > 1 ? _c("div", {
    staticClass: "swiper-button swiper-button-next static border border-solid rounded-full mt-0",
    attrs: {
      slot: "button-next"
    },
    slot: "button-next"
  }) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;
/* style */

var __vue_inject_styles__$h = function __vue_inject_styles__$h(inject) {
  if (!inject) return;
  inject("data-v-c67c6a18_0", {
    source: ".swiper-slide[data-v-c67c6a18] {\n  width: 85%;\n}\n.swiper-slide.w-100[data-v-c67c6a18] {\n  width: 100%;\n}\n.img-container[data-v-c67c6a18] {\n  height: 250px;\n}\n.swiper-button[data-v-c67c6a18] {\n  width: 20px;\n  height: 20px;\n}\n.swiper-button[data-v-c67c6a18]:after {\n  font-size: 14px;\n}\n.swiper-button-disabled[data-v-c67c6a18] {\n  display: flex !important;\n}\n\n/*# sourceMappingURL=CarouselActions.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CarouselActions.vue", "CarouselActions.vue"],
      "names": [],
      "mappings": "AA0EA;EACA,UAAA;ACzEA;AD0EA;EACA,WAAA;ACxEA;AD4EA;EACA,aAAA;ACzEA;AD4EA;EACA,WAAA;EACA,YAAA;ACzEA;AD2EA;EACA,eAAA;ACzEA;AD6EA;EACA,wBAAA;AC1EA;;AAEA,8CAA8C",
      "file": "CarouselActions.vue",
      "sourcesContent": ["<template>\n  <main class=\"carousel-actions\">\n    <swiper ref=\"mySwiper\"\n            :options=\"swiperOptions\"\n            @slideChange=\"slideChange\">\n      <swiper-slide :key=\"index\"\n                    :class=\"{'w-100': slides.length === 1}\"\n                    v-for=\"(slide, index) of slides\">\n        <div class=\"img-container w-full bg-cover bg-center bg-no-repeat m-0\" :style=\"`background-image: url(${slide})`\">\n        </div>\n      </swiper-slide>\n    </swiper>\n    <div class=\"bottom-control p-4 border-t-1 border-0 border-solid\"\n         :class=\"{'flex justify-center': slides.length === 1}\">\n      <div class=\"action flex items-center justify-between\">\n        <div class=\"swiper-button swiper-button-prev static border border-solid rounded-full mt-0\"\n             v-if=\"slides.length > 1\"\n             slot=\"button-prev\"/>\n        <div class=\"remove-action border border-solid py-2 px-3 rounded cursor-pointer\" @click=\"$emit('remove-slide', swiper.snapIndex)\">remove</div>\n        <div class=\"swiper-button swiper-button-next static border border-solid rounded-full mt-0\"\n             v-if=\"slides.length > 1\"\n             slot=\"button-next\"/>\n      </div>\n    </div>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\nimport {Swiper, SwiperSlide} from \"vue-awesome-swiper\";\n\nexport default Vue.extend({\n  name: 'CarouselActions',\n  props: {\n    slides: Array\n  },\n  components: {\n    Swiper, SwiperSlide\n  },\n  data: () => ({\n    swiperOptions: {\n      slidesPerView: 'auto',\n      navigation: {\n        nextEl: '.swiper-button-next',\n        prevEl: '.swiper-button-prev'\n      },\n      pagination: {\n        el: \".swiper-pagination\",\n        type: \"fraction\",\n      },\n      centeredSlides: false,\n    }\n  }),\n  computed:{\n    swiper() {\n      const el = this.$refs?.mySwiper as any\n      return el.$swiper\n    }\n  },\n  watch: {\n    async slides(newSlides) {\n      await this.swiper;\n      this.swiper.slideTo(newSlides.length, 0)\n    }\n  },\n  methods: {\n    slideChange() {\n      this.$emit('slide-change', this.swiper)\n    }\n  }\n});\n</script>\n\n<style lang=\"scss\" scoped>\n.swiper-slide {\n  width: 85%;\n  &.w-100 {\n    width: 100%;\n  }\n}\n\n.img-container {\n  height: 250px;\n}\n\n.swiper-button {\n  width: 20px;\n  height: 20px;\n\n  &:after {\n    font-size: 14px;\n  }\n}\n\n.swiper-button-disabled {\n  display: flex !important;\n}\n</style>\n", ".swiper-slide {\n  width: 85%;\n}\n.swiper-slide.w-100 {\n  width: 100%;\n}\n\n.img-container {\n  height: 250px;\n}\n\n.swiper-button {\n  width: 20px;\n  height: 20px;\n}\n.swiper-button:after {\n  font-size: 14px;\n}\n\n.swiper-button-disabled {\n  display: flex !important;\n}\n\n/*# sourceMappingURL=CarouselActions.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$h = "data-v-c67c6a18";
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);
/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */
// Defaults


var defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: 'normal',
  autoplay: true,
  timelineOffset: 0
};
var defaultTweenSettings = {
  duration: 1000,
  delay: 0,
  endDelay: 0,
  easing: 'easeOutElastic(1, .5)',
  round: 0
};
var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective', 'matrix', 'matrix3d']; // Caching

var cache = {
  CSS: {},
  springs: {}
}; // Utils

function minMax(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

function stringContains(str, text) {
  return str.indexOf(text) > -1;
}

function applyArguments(func, args) {
  return func.apply(null, args);
}

var is = {
  arr: function arr(a) {
    return Array.isArray(a);
  },
  obj: function obj(a) {
    return stringContains(Object.prototype.toString.call(a), 'Object');
  },
  pth: function pth(a) {
    return is.obj(a) && a.hasOwnProperty('totalLength');
  },
  svg: function svg(a) {
    return a instanceof SVGElement;
  },
  inp: function inp(a) {
    return a instanceof HTMLInputElement;
  },
  dom: function dom(a) {
    return a.nodeType || is.svg(a);
  },
  str: function str(a) {
    return typeof a === 'string';
  },
  fnc: function fnc(a) {
    return typeof a === 'function';
  },
  und: function und(a) {
    return typeof a === 'undefined';
  },
  nil: function nil(a) {
    return is.und(a) || a === null;
  },
  hex: function hex(a) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
  },
  rgb: function rgb(a) {
    return /^rgb/.test(a);
  },
  hsl: function hsl(a) {
    return /^hsl/.test(a);
  },
  col: function col(a) {
    return is.hex(a) || is.rgb(a) || is.hsl(a);
  },
  key: function key(a) {
    return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes';
  }
}; // Easings

function parseEasingParameters(string) {
  var match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(',').map(function (p) {
    return parseFloat(p);
  }) : [];
} // Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js


function spring(string, duration) {
  var params = parseEasingParameters(string);
  var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
  var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
  var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
  var velocity = minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
  var w0 = Math.sqrt(stiffness / mass);
  var zeta = damping / (2 * Math.sqrt(stiffness * mass));
  var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  var a = 1;
  var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;

  function solver(t) {
    var progress = duration ? duration * t / 1000 : t;

    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }

    if (t === 0 || t === 1) {
      return t;
    }

    return 1 - progress;
  }

  function getDuration() {
    var cached = cache.springs[string];

    if (cached) {
      return cached;
    }

    var frame = 1 / 6;
    var elapsed = 0;
    var rest = 0;

    while (true) {
      elapsed += frame;

      if (solver(elapsed) === 1) {
        rest++;

        if (rest >= 16) {
          break;
        }
      } else {
        rest = 0;
      }
    }

    var duration = elapsed * frame * 1000;
    cache.springs[string] = duration;
    return duration;
  }

  return duration ? solver : getDuration;
} // Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function


function steps(steps) {
  if (steps === void 0) steps = 10;
  return function (t) {
    return Math.ceil(minMax(t, 0.000001, 1) * steps) * (1 / steps);
  };
} // BezierEasing https://github.com/gre/bezier-easing


var bezier = function () {
  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
  }

  function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
  }

  function C(aA1) {
    return 3.0 * aA1;
  }

  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }

  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
        currentT,
        i = 0;

    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;

      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > 0.0000001 && ++i < 10);

    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);

      if (currentSlope === 0.0) {
        return aGuessT;
      }

      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }

    return aGuessT;
  }

  function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
      return;
    }

    var sampleValues = new Float32Array(kSplineTableSize);

    if (mX1 !== mY1 || mX2 !== mY2) {
      for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }

    function getTForX(aX) {
      var intervalStart = 0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample;
      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= 0.001) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }

    return function (x) {
      if (mX1 === mY1 && mX2 === mY2) {
        return x;
      }

      if (x === 0 || x === 1) {
        return x;
      }

      return calcBezier(getTForX(x), mY1, mY2);
    };
  }

  return bezier;
}();

var penner = function () {
  // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
  var eases = {
    linear: function linear() {
      return function (t) {
        return t;
      };
    }
  };
  var functionEasings = {
    Sine: function Sine() {
      return function (t) {
        return 1 - Math.cos(t * Math.PI / 2);
      };
    },
    Circ: function Circ() {
      return function (t) {
        return 1 - Math.sqrt(1 - t * t);
      };
    },
    Back: function Back() {
      return function (t) {
        return t * t * (3 * t - 2);
      };
    },
    Bounce: function Bounce() {
      return function (t) {
        var pow2,
            b = 4;

        while (t < ((pow2 = Math.pow(2, --b)) - 1) / 11) {}

        return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
      };
    },
    Elastic: function Elastic(amplitude, period) {
      if (amplitude === void 0) amplitude = 1;
      if (period === void 0) period = .5;
      var a = minMax(amplitude, 1, 10);
      var p = minMax(period, .1, 2);
      return function (t) {
        return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
      };
    }
  };
  var baseEasings = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
  baseEasings.forEach(function (name, i) {
    functionEasings[name] = function () {
      return function (t) {
        return Math.pow(t, i + 2);
      };
    };
  });
  Object.keys(functionEasings).forEach(function (name) {
    var easeIn = functionEasings[name];
    eases['easeIn' + name] = easeIn;

    eases['easeOut' + name] = function (a, b) {
      return function (t) {
        return 1 - easeIn(a, b)(1 - t);
      };
    };

    eases['easeInOut' + name] = function (a, b) {
      return function (t) {
        return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
      };
    };

    eases['easeOutIn' + name] = function (a, b) {
      return function (t) {
        return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
      };
    };
  });
  return eases;
}();

function parseEasings(easing, duration) {
  if (is.fnc(easing)) {
    return easing;
  }

  var name = easing.split('(')[0];
  var ease = penner[name];
  var args = parseEasingParameters(easing);

  switch (name) {
    case 'spring':
      return spring(easing, duration);

    case 'cubicBezier':
      return applyArguments(bezier, args);

    case 'steps':
      return applyArguments(steps, args);

    default:
      return applyArguments(ease, args);
  }
} // Strings


function selectString(str) {
  try {
    var nodes = document.querySelectorAll(str);
    return nodes;
  } catch (e) {
    return;
  }
} // Arrays


function filterArray(arr, callback) {
  var len = arr.length;
  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  var result = [];

  for (var i = 0; i < len; i++) {
    if (i in arr) {
      var val = arr[i];

      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }

  return result;
}

function flattenArray(arr) {
  return arr.reduce(function (a, b) {
    return a.concat(is.arr(b) ? flattenArray(b) : b);
  }, []);
}

function toArray(o) {
  if (is.arr(o)) {
    return o;
  }

  if (is.str(o)) {
    o = selectString(o) || o;
  }

  if (o instanceof NodeList || o instanceof HTMLCollection) {
    return [].slice.call(o);
  }

  return [o];
}

function arrayContains(arr, val) {
  return arr.some(function (a) {
    return a === val;
  });
} // Objects


function cloneObject(o) {
  var clone = {};

  for (var p in o) {
    clone[p] = o[p];
  }

  return clone;
}

function replaceObjectProps(o1, o2) {
  var o = cloneObject(o1);

  for (var p in o1) {
    o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
  }

  return o;
}

function mergeObjects(o1, o2) {
  var o = cloneObject(o1);

  for (var p in o2) {
    o[p] = is.und(o1[p]) ? o2[p] : o1[p];
  }

  return o;
} // Colors


function rgbToRgba(rgbValue) {
  var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}

function hexToRgba(hexValue) {
  var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = hexValue.replace(rgx, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var r = parseInt(rgb[1], 16);
  var g = parseInt(rgb[2], 16);
  var b = parseInt(rgb[3], 16);
  return "rgba(" + r + "," + g + "," + b + ",1)";
}

function hslToRgba(hslValue) {
  var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  var h = parseInt(hsl[1], 10) / 360;
  var s = parseInt(hsl[2], 10) / 100;
  var l = parseInt(hsl[3], 10) / 100;
  var a = hsl[4] || 1;

  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }

    if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }

    if (t < 1 / 2) {
      return q;
    }

    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }

    return p;
  }

  var r, g, b;

  if (s == 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}

function colorToRgb(val) {
  if (is.rgb(val)) {
    return rgbToRgba(val);
  }

  if (is.hex(val)) {
    return hexToRgba(val);
  }

  if (is.hsl(val)) {
    return hslToRgba(val);
  }
} // Units


function getUnit(val) {
  var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);

  if (split) {
    return split[1];
  }
}

function getTransformUnit(propName) {
  if (stringContains(propName, 'translate') || propName === 'perspective') {
    return 'px';
  }

  if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) {
    return 'deg';
  }
} // Values


function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) {
    return val;
  }

  return val(animatable.target, animatable.id, animatable.total);
}

function getAttribute(el, prop) {
  return el.getAttribute(prop);
}

function convertPxToUnit(el, value, unit) {
  var valueUnit = getUnit(value);

  if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) {
    return value;
  }

  var cached = cache.CSS[value + unit];

  if (!is.und(cached)) {
    return cached;
  }

  var baseline = 100;
  var tempEl = document.createElement(el.tagName);
  var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = 'absolute';
  tempEl.style.width = baseline + unit;
  var factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  var convertedUnit = factor * parseFloat(value);
  cache.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}

function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}

function getAnimationType(el, prop) {
  if (is.dom(el) && !is.inp(el) && (!is.nil(getAttribute(el, prop)) || is.svg(el) && el[prop])) {
    return 'attribute';
  }

  if (is.dom(el) && arrayContains(validTransforms, prop)) {
    return 'transform';
  }

  if (is.dom(el) && prop !== 'transform' && getCSSValue(el, prop)) {
    return 'css';
  }

  if (el[prop] != null) {
    return 'object';
  }
}

function getElementTransforms(el) {
  if (!is.dom(el)) {
    return;
  }

  var str = el.style.transform || '';
  var reg = /(\w+)\(([^)]*)\)/g;
  var transforms = new Map();
  var m;

  while (m = reg.exec(str)) {
    transforms.set(m[1], m[2]);
  }

  return transforms;
}

function getTransformValue(el, propName, animatable, unit) {
  var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
  var value = getElementTransforms(el).get(propName) || defaultVal;

  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms['last'] = propName;
  }

  return unit ? convertPxToUnit(el, value, unit) : value;
}

function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case 'transform':
      return getTransformValue(target, propName, animatable, unit);

    case 'css':
      return getCSSValue(target, propName, unit);

    case 'attribute':
      return getAttribute(target, propName);

    default:
      return target[propName] || 0;
  }
}

function getRelativeValue(to, from) {
  var operator = /^(\*=|\+=|-=)/.exec(to);

  if (!operator) {
    return to;
  }

  var u = getUnit(to) || 0;
  var x = parseFloat(from);
  var y = parseFloat(to.replace(operator[0], ''));

  switch (operator[0][0]) {
    case '+':
      return x + y + u;

    case '-':
      return x - y + u;

    case '*':
      return x * y + u;
  }
}

function validateValue(val, unit) {
  if (is.col(val)) {
    return colorToRgb(val);
  }

  if (/\s/g.test(val)) {
    return val;
  }

  var originalUnit = getUnit(val);
  var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;

  if (unit) {
    return unitLess + unit;
  }

  return unitLess;
} // getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744


function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, 'r');
}

function getRectLength(el) {
  return getAttribute(el, 'width') * 2 + getAttribute(el, 'height') * 2;
}

function getLineLength(el) {
  return getDistance({
    x: getAttribute(el, 'x1'),
    y: getAttribute(el, 'y1')
  }, {
    x: getAttribute(el, 'x2'),
    y: getAttribute(el, 'y2')
  });
}

function getPolylineLength(el) {
  var points = el.points;
  var totalLength = 0;
  var previousPos;

  for (var i = 0; i < points.numberOfItems; i++) {
    var currentPos = points.getItem(i);

    if (i > 0) {
      totalLength += getDistance(previousPos, currentPos);
    }

    previousPos = currentPos;
  }

  return totalLength;
}

function getPolygonLength(el) {
  var points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
} // Path animation


function getTotalLength(el) {
  if (el.getTotalLength) {
    return el.getTotalLength();
  }

  switch (el.tagName.toLowerCase()) {
    case 'circle':
      return getCircleLength(el);

    case 'rect':
      return getRectLength(el);

    case 'line':
      return getLineLength(el);

    case 'polyline':
      return getPolylineLength(el);

    case 'polygon':
      return getPolygonLength(el);
  }
}

function setDashoffset(el) {
  var pathLength = getTotalLength(el);
  el.setAttribute('stroke-dasharray', pathLength);
  return pathLength;
} // Motion path


function getParentSvgEl(el) {
  var parentEl = el.parentNode;

  while (is.svg(parentEl)) {
    if (!is.svg(parentEl.parentNode)) {
      break;
    }

    parentEl = parentEl.parentNode;
  }

  return parentEl;
}

function getParentSvg(pathEl, svgData) {
  var svg = svgData || {};
  var parentSvgEl = svg.el || getParentSvgEl(pathEl);
  var rect = parentSvgEl.getBoundingClientRect();
  var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
  var width = rect.width;
  var height = rect.height;
  var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox: viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width,
    h: height,
    vW: viewBox[2],
    vH: viewBox[3]
  };
}

function getPath(path, percent) {
  var pathEl = is.str(path) ? selectString(path)[0] : path;
  var p = percent || 100;
  return function (property) {
    return {
      property: property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    };
  };
}

function getPathProgress(path, progress, isPathTargetInsideSVG) {
  function point(offset) {
    if (offset === void 0) offset = 0;
    var l = progress + offset >= 1 ? progress + offset : 0;
    return path.el.getPointAtLength(l);
  }

  var svg = getParentSvg(path.el, path.svg);
  var p = point();
  var p0 = point(-1);
  var p1 = point(+1);
  var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
  var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;

  switch (path.property) {
    case 'x':
      return (p.x - svg.x) * scaleX;

    case 'y':
      return (p.y - svg.y) * scaleY;

    case 'angle':
      return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
} // Decompose value


function decomposeValue(val, unit) {
  // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
  // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
  var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation

  var value = validateValue(is.pth(val) ? val.totalLength : val, unit) + '';
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: is.str(val) || unit ? value.split(rgx) : []
  };
} // Animatables


function parseTargets(targets) {
  var targetsArray = targets ? flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets)) : [];
  return filterArray(targetsArray, function (item, pos, self) {
    return self.indexOf(item) === pos;
  });
}

function getAnimatables(targets) {
  var parsed = parseTargets(targets);
  return parsed.map(function (t, i) {
    return {
      target: t,
      id: i,
      total: parsed.length,
      transforms: {
        list: getElementTransforms(t)
      }
    };
  });
} // Properties


function normalizePropertyTweens(prop, tweenSettings) {
  var settings = cloneObject(tweenSettings); // Override duration if easing is a spring

  if (/^spring/.test(settings.easing)) {
    settings.duration = spring(settings.easing);
  }

  if (is.arr(prop)) {
    var l = prop.length;
    var isFromTo = l === 2 && !is.obj(prop[0]);

    if (!isFromTo) {
      // Duration divided by the number of tweens
      if (!is.fnc(tweenSettings.duration)) {
        settings.duration = tweenSettings.duration / l;
      }
    } else {
      // Transform [from, to] values shorthand to a valid tween value
      prop = {
        value: prop
      };
    }
  }

  var propArray = is.arr(prop) ? prop : [prop];
  return propArray.map(function (v, i) {
    var obj = is.obj(v) && !is.pth(v) ? v : {
      value: v
    }; // Default delay value should only be applied to the first tween

    if (is.und(obj.delay)) {
      obj.delay = !i ? tweenSettings.delay : 0;
    } // Default endDelay value should only be applied to the last tween


    if (is.und(obj.endDelay)) {
      obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
    }

    return obj;
  }).map(function (k) {
    return mergeObjects(k, settings);
  });
}

function flattenKeyframes(keyframes) {
  var propertyNames = filterArray(flattenArray(keyframes.map(function (key) {
    return Object.keys(key);
  })), function (p) {
    return is.key(p);
  }).reduce(function (a, b) {
    if (a.indexOf(b) < 0) {
      a.push(b);
    }

    return a;
  }, []);
  var properties = {};

  var loop = function loop(i) {
    var propName = propertyNames[i];
    properties[propName] = keyframes.map(function (key) {
      var newKey = {};

      for (var p in key) {
        if (is.key(p)) {
          if (p == propName) {
            newKey.value = key[p];
          }
        } else {
          newKey[p] = key[p];
        }
      }

      return newKey;
    });
  };

  for (var i = 0; i < propertyNames.length; i++) {
    loop(i);
  }

  return properties;
}

function getProperties(tweenSettings, params) {
  var properties = [];
  var keyframes = params.keyframes;

  if (keyframes) {
    params = mergeObjects(flattenKeyframes(keyframes), params);
  }

  for (var p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }

  return properties;
} // Tweens


function normalizeTweenValues(tween, animatable) {
  var t = {};

  for (var p in tween) {
    var value = getFunctionValue(tween[p], animatable);

    if (is.arr(value)) {
      value = value.map(function (v) {
        return getFunctionValue(v, animatable);
      });

      if (value.length === 1) {
        value = value[0];
      }
    }

    t[p] = value;
  }

  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}

function normalizeTweens(prop, animatable) {
  var previousTween;
  return prop.tweens.map(function (t) {
    var tween = normalizeTweenValues(t, animatable);
    var tweenValue = tween.value;
    var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    var toUnit = getUnit(to);
    var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    var previousValue = previousTween ? previousTween.to.original : originalValue;
    var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    var fromUnit = getUnit(from) || getUnit(originalValue);
    var unit = toUnit || fromUnit;

    if (is.und(to)) {
      to = previousValue;
    }

    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
    tween.isColor = is.col(tween.from.original);

    if (tween.isColor) {
      tween.round = 1;
    }

    previousTween = tween;
    return tween;
  });
} // Tween progress


var setProgressValue = {
  css: function css(t, p, v) {
    return t.style[p] = v;
  },
  attribute: function attribute(t, p, v) {
    return t.setAttribute(p, v);
  },
  object: function object(t, p, v) {
    return t[p] = v;
  },
  transform: function transform(t, p, v, transforms, manual) {
    transforms.list.set(p, v);

    if (p === transforms.last || manual) {
      var str = '';
      transforms.list.forEach(function (value, prop) {
        str += prop + "(" + value + ") ";
      });
      t.style.transform = str;
    }
  }
}; // Set Value helper

function setTargetsValue(targets, properties) {
  var animatables = getAnimatables(targets);
  animatables.forEach(function (animatable) {
    for (var property in properties) {
      var value = getFunctionValue(properties[property], animatable);
      var target = animatable.target;
      var valueUnit = getUnit(value);
      var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      var unit = valueUnit || getUnit(originalValue);
      var to = getRelativeValue(validateValue(value, unit), originalValue);
      var animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
} // Animations


function createAnimation(animatable, prop) {
  var animType = getAnimationType(animatable.target, prop.name);

  if (animType) {
    var tweens = normalizeTweens(prop, animatable);
    var lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable: animatable,
      tweens: tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    };
  }
}

function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map(function (animatable) {
    return properties.map(function (prop) {
      return createAnimation(animatable, prop);
    });
  })), function (a) {
    return !is.und(a);
  });
} // Create Instance


function getInstanceTimings(animations, tweenSettings) {
  var animLength = animations.length;

  var getTlOffset = function getTlOffset(anim) {
    return anim.timelineOffset ? anim.timelineOffset : 0;
  };

  var timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) {
    return getTlOffset(anim) + anim.duration;
  })) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) {
    return getTlOffset(anim) + anim.delay;
  })) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) {
    return getTlOffset(anim) + anim.duration - anim.endDelay;
  })) : tweenSettings.endDelay;
  return timings;
}

var instanceID = 0;

function createNewInstance(params) {
  var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  var properties = getProperties(tweenSettings, params);
  var animatables = getAnimatables(params.targets);
  var animations = getAnimations(animatables, properties);
  var timings = getInstanceTimings(animations, tweenSettings);
  var id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id: id,
    children: [],
    animatables: animatables,
    animations: animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
} // Core


var activeInstances = [];

var engine = function () {
  var raf;

  function play() {
    if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) {
      raf = requestAnimationFrame(step);
    }
  }

  function step(t) {
    // memo on algorithm issue:
    // dangerous iteration over mutable `activeInstances`
    // (that collection may be updated from within callbacks of `tick`-ed animation instances)
    var activeInstancesLength = activeInstances.length;
    var i = 0;

    while (i < activeInstancesLength) {
      var activeInstance = activeInstances[i];

      if (!activeInstance.paused) {
        activeInstance.tick(t);
        i++;
      } else {
        activeInstances.splice(i, 1);
        activeInstancesLength--;
      }
    }

    raf = i > 0 ? requestAnimationFrame(step) : undefined;
  }

  function handleVisibilityChange() {
    if (!anime.suspendWhenDocumentHidden) {
      return;
    }

    if (isDocumentHidden()) {
      // suspend ticks
      raf = cancelAnimationFrame(raf);
    } else {
      // is back to active tab
      // first adjust animations to consider the time that ticks were suspended
      activeInstances.forEach(function (instance) {
        return instance._onDocumentVisibility();
      });
      engine();
    }
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleVisibilityChange);
  }

  return play;
}();

function isDocumentHidden() {
  return !!document && document.hidden;
} // Public Instance


function anime(params) {
  if (params === void 0) params = {};
  var startTime = 0,
      lastTime = 0,
      now = 0;
  var children,
      childrenLength = 0;
  var resolve = null;

  function makePromise(instance) {
    var promise = window.Promise && new Promise(function (_resolve) {
      return resolve = _resolve;
    });
    instance.finished = promise;
    return promise;
  }

  var instance = createNewInstance(params);
  makePromise(instance);

  function toggleInstanceDirection() {
    var direction = instance.direction;

    if (direction !== 'alternate') {
      instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
    }

    instance.reversed = !instance.reversed;
    children.forEach(function (child) {
      return child.reversed = instance.reversed;
    });
  }

  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }

  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }

  function seekChild(time, child) {
    if (child) {
      child.seek(time - child.timelineOffset);
    }
  }

  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (var i = 0; i < childrenLength; i++) {
        seekChild(time, children[i]);
      }
    } else {
      for (var i$1 = childrenLength; i$1--;) {
        seekChild(time, children[i$1]);
      }
    }
  }

  function setAnimationsProgress(insTime) {
    var i = 0;
    var animations = instance.animations;
    var animationsLength = animations.length;

    while (i < animationsLength) {
      var anim = animations[i];
      var animatable = anim.animatable;
      var tweens = anim.tweens;
      var tweenLength = tweens.length - 1;
      var tween = tweens[tweenLength]; // Only check for keyframes if there is more than one tween

      if (tweenLength) {
        tween = filterArray(tweens, function (t) {
          return insTime < t.end;
        })[0] || tween;
      }

      var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      var strings = tween.to.strings;
      var round = tween.round;
      var numbers = [];
      var toNumbersLength = tween.to.numbers.length;
      var progress = void 0;

      for (var n = 0; n < toNumbersLength; n++) {
        var value = void 0;
        var toNumber = tween.to.numbers[n];
        var fromNumber = tween.from.numbers[n] || 0;

        if (!tween.isPath) {
          value = fromNumber + eased * (toNumber - fromNumber);
        } else {
          value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
        }

        if (round) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round) / round;
          }
        }

        numbers.push(value);
      } // Manual Array.reduce for better performances


      var stringsLength = strings.length;

      if (!stringsLength) {
        progress = numbers[0];
      } else {
        progress = strings[0];

        for (var s = 0; s < stringsLength; s++) {
          strings[s];
          var b = strings[s + 1];
          var n$1 = numbers[s];

          if (!isNaN(n$1)) {
            if (!b) {
              progress += n$1 + ' ';
            } else {
              progress += n$1 + b;
            }
          }
        }
      }

      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }

  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) {
      instance[cb](instance);
    }
  }

  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }

  function setInstanceProgress(engineTime) {
    var insDuration = instance.duration;
    var insDelay = instance.delay;
    var insEndDelay = insDuration - instance.endDelay;
    var insTime = adjustTime(engineTime);
    instance.progress = minMax(insTime / insDuration * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;

    if (children) {
      syncInstanceChildren(insTime);
    }

    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback('begin');
    }

    if (!instance.loopBegan && instance.currentTime > 0) {
      instance.loopBegan = true;
      setCallback('loopBegin');
    }

    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }

    if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) {
      setAnimationsProgress(insDuration);
    }

    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback('changeBegin');
      }

      setCallback('change');
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback('changeComplete');
      }
    }

    instance.currentTime = minMax(insTime, 0, insDuration);

    if (instance.began) {
      setCallback('update');
    }

    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();

      if (!instance.remaining) {
        instance.paused = true;

        if (!instance.completed) {
          instance.completed = true;
          setCallback('loopComplete');
          setCallback('complete');

          if (!instance.passThrough && 'Promise' in window) {
            resolve();
            makePromise(instance);
          }
        }
      } else {
        startTime = now;
        setCallback('loopComplete');
        instance.loopBegan = false;

        if (instance.direction === 'alternate') {
          toggleInstanceDirection();
        }
      }
    }
  }

  instance.reset = function () {
    var direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.loopBegan = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === 'reverse';
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;

    for (var i = childrenLength; i--;) {
      instance.children[i].reset();
    }

    if (instance.reversed && instance.loop !== true || direction === 'alternate' && instance.loop === 1) {
      instance.remaining++;
    }

    setAnimationsProgress(instance.reversed ? instance.duration : 0);
  }; // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)


  instance._onDocumentVisibility = resetTime; // Set Value helper

  instance.set = function (targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };

  instance.tick = function (t) {
    now = t;

    if (!startTime) {
      startTime = now;
    }

    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };

  instance.seek = function (time) {
    setInstanceProgress(adjustTime(time));
  };

  instance.pause = function () {
    instance.paused = true;
    resetTime();
  };

  instance.play = function () {
    if (!instance.paused) {
      return;
    }

    if (instance.completed) {
      instance.reset();
    }

    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    engine();
  };

  instance.reverse = function () {
    toggleInstanceDirection();
    instance.completed = instance.reversed ? false : true;
    resetTime();
  };

  instance.restart = function () {
    instance.reset();
    instance.play();
  };

  instance.remove = function (targets) {
    var targetsArray = parseTargets(targets);
    removeTargetsFromInstance(targetsArray, instance);
  };

  instance.reset();

  if (instance.autoplay) {
    instance.play();
  }

  return instance;
} // Remove targets from animation


function removeTargetsFromAnimations(targetsArray, animations) {
  for (var a = animations.length; a--;) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}

function removeTargetsFromInstance(targetsArray, instance) {
  var animations = instance.animations;
  var children = instance.children;
  removeTargetsFromAnimations(targetsArray, animations);

  for (var c = children.length; c--;) {
    var child = children[c];
    var childAnimations = child.animations;
    removeTargetsFromAnimations(targetsArray, childAnimations);

    if (!childAnimations.length && !child.children.length) {
      children.splice(c, 1);
    }
  }

  if (!animations.length && !children.length) {
    instance.pause();
  }
}

function removeTargetsFromActiveInstances(targets) {
  var targetsArray = parseTargets(targets);

  for (var i = activeInstances.length; i--;) {
    var instance = activeInstances[i];
    removeTargetsFromInstance(targetsArray, instance);
  }
} // Stagger helpers


function stagger(val, params) {
  if (params === void 0) params = {};
  var direction = params.direction || 'normal';
  var easing = params.easing ? parseEasings(params.easing) : null;
  var grid = params.grid;
  var axis = params.axis;
  var fromIndex = params.from || 0;
  var fromFirst = fromIndex === 'first';
  var fromCenter = fromIndex === 'center';
  var fromLast = fromIndex === 'last';
  var isRange = is.arr(val);
  var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  var val2 = isRange ? parseFloat(val[1]) : 0;
  var unit = getUnit(isRange ? val[1] : val) || 0;
  var start = params.start || 0 + (isRange ? val1 : 0);
  var values = [];
  var maxValue = 0;
  return function (el, i, t) {
    if (fromFirst) {
      fromIndex = 0;
    }

    if (fromCenter) {
      fromIndex = (t - 1) / 2;
    }

    if (fromLast) {
      fromIndex = t - 1;
    }

    if (!values.length) {
      for (var index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
          var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
          var toX = index % grid[0];
          var toY = Math.floor(index / grid[0]);
          var distanceX = fromX - toX;
          var distanceY = fromY - toY;
          var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

          if (axis === 'x') {
            value = -distanceX;
          }

          if (axis === 'y') {
            value = -distanceY;
          }

          values.push(value);
        }

        maxValue = Math.max.apply(Math, values);
      }

      if (easing) {
        values = values.map(function (val) {
          return easing(val / maxValue) * maxValue;
        });
      }

      if (direction === 'reverse') {
        values = values.map(function (val) {
          return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
        });
      }
    }

    var spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
  };
} // Timeline


function timeline(params) {
  if (params === void 0) params = {};
  var tl = anime(params);
  tl.duration = 0;

  tl.add = function (instanceParams, timelineOffset) {
    var tlIndex = activeInstances.indexOf(tl);
    var children = tl.children;

    if (tlIndex > -1) {
      activeInstances.splice(tlIndex, 1);
    }

    function passThrough(ins) {
      ins.passThrough = true;
    }

    for (var i = 0; i < children.length; i++) {
      passThrough(children[i]);
    }

    var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    var tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    var ins = anime(insParams);
    passThrough(ins);
    children.push(ins);
    var timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();

    if (tl.autoplay) {
      tl.play();
    }

    return tl;
  };

  return tl;
}

anime.version = '3.2.1';
anime.speed = 1; // TODO:#review: naming, documentation

anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;

anime.random = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

var script$g = Vue.extend({
  name: 'CollapsibleFixedFooter',
  props: {
    expanded: Boolean
  },
  methods: {
    clickedToggle: function clickedToggle() {
      this.$emit('update:expanded', !this.expanded);
      this.doAnimation(!this.expanded);
    },
    doAnimation: function doAnimation(expanded) {
      var container = this.$refs['content-container'];
      var animation = expanded ? anime({
        targets: ".collapsible-display",
        bottom: 0,
        duration: 250,
        easing: 'easeInOutCubic'
      }) : anime({
        targets: ".collapsible-display",
        bottom: -container.clientHeight,
        duration: 250,
        easing: 'easeInOutCubic'
      });
      return animation.finished;
    }
  }
});
/* script */

var __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function __vue_render__$g() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "collapsible-display fixed flex flex-col z-50 w-full left-0 bottom-0",
    "class": {
      expanded: _vm.expanded
    }
  }, [_c("button", {
    staticClass: "open-button font-primary block self-end h-8 z-0 px-4 m-0 mr-2 border-solid border-blue border-1 border-b-0 rounded-t-full text-lg cursor-pointer transition-all duration-300",
    "class": [_vm.expanded ? "pt-1 bg-white text-blue" : "bg-blue text-white"],
    staticStyle: {
      "margin-bottom": "-1px"
    },
    on: {
      click: _vm.clickedToggle
    }
  }, [_vm.expanded ? _c("span", [_c("fai", {
    attrs: {
      icon: ["fal", "chevron-down"]
    }
  }), _vm._v(" "), _vm._t("collapse-button-label", function () {
    return [_vm._v("\n        hide\n      ")];
  })], 2) : _c("span", [_c("fai", {
    attrs: {
      icon: ["fal", "chevron-up"]
    }
  }), _vm._v(" "), _vm._t("expand-button-label", function () {
    return [_vm._v("\n        open\n      ")];
  })], 2)]), _vm._v(" "), _c("section", {
    ref: "content-container",
    staticClass: "content-container border-solid border-blue border-0 border-t-1 bg-white"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;
/* style */

var __vue_inject_styles__$g = function __vue_inject_styles__$g(inject) {
  if (!inject) return;
  inject("data-v-7d6736f6_0", {
    source: ".collapsible-display:not(.expanded) .content-container[data-v-7d6736f6] {\n  overflow-x: hidden;\n}\n.collapsible-display .content-container[data-v-7d6736f6] {\n  overflow-x: auto;\n}\n\n/*# sourceMappingURL=CollapsibleFixedFooter.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CollapsibleFixedFooter.vue", "CollapsibleFixedFooter.vue"],
      "names": [],
      "mappings": "AAkEA;EACA,kBAAA;ACjEA;ADmEA;EACA,gBAAA;ACjEA;;AAEA,qDAAqD",
      "file": "CollapsibleFixedFooter.vue",
      "sourcesContent": ["<template>\r\n  <main class=\"collapsible-display fixed flex flex-col z-50 w-full left-0 bottom-0\" :class=\"{expanded}\">\r\n    \r\n    <button\r\n        @click=\"clickedToggle\"\r\n        class=\"open-button font-primary block self-end h-8 z-0 px-4 m-0 mr-2 border-solid border-blue border-1 border-b-0 rounded-t-full text-lg cursor-pointer transition-all duration-300\"\r\n        :class=\"[expanded ? 'pt-1 bg-white text-blue' : 'bg-blue text-white']\"\r\n        style=\"margin-bottom:-1px\"\r\n    >\r\n      <span v-if=\"expanded\">\r\n        <fai :icon=\"['fal', 'chevron-down']\" />\r\n        <slot name=\"collapse-button-label\">\r\n          hide\r\n        </slot>\r\n      </span>\r\n      <span v-else>\r\n        <fai :icon=\"['fal', 'chevron-up']\" />\r\n        <slot name=\"expand-button-label\">\r\n          open\r\n        </slot>\r\n      </span>\r\n    </button>\r\n\r\n    <section ref=\"content-container\" class=\"content-container border-solid border-blue border-0 border-t-1 bg-white\">\r\n      <slot class=\"content\"></slot>\r\n    </section>\r\n    \r\n  </main>\r\n</template>\r\n\r\n<script lang=\"ts\">\r\n  import Vue from 'vue';\r\n  import anime from \"animejs\";\r\n\r\n  export default Vue.extend({\r\n    name: 'CollapsibleFixedFooter',\r\n    props: {\r\n      expanded: Boolean,\r\n    },\r\n    methods: {\r\n      clickedToggle() {\r\n        this.$emit('update:expanded', !this.expanded)\r\n        this.doAnimation(!this.expanded);\r\n      },\r\n      doAnimation(expanded: boolean) {\r\n        const container = this.$refs['content-container']! as HTMLElement;\r\n        const animation = expanded ? anime({\r\n          targets: \".collapsible-display\",\r\n          bottom: 0,\r\n          duration: 250,\r\n          easing: 'easeInOutCubic'\r\n        }) : anime({\r\n          targets: \".collapsible-display\",\r\n          bottom: -container.clientHeight,\r\n          duration: 250,\r\n          easing: 'easeInOutCubic'\r\n        })\r\n\r\n        return animation.finished\r\n      }\r\n    }\r\n  });\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  .collapsible-display {\r\n    &:not(.expanded) .content-container {\r\n      overflow-x: hidden;\r\n    }\r\n    .content-container {\r\n      overflow-x: auto;\r\n    }\r\n  }\r\n</style>", ".collapsible-display:not(.expanded) .content-container {\n  overflow-x: hidden;\n}\n.collapsible-display .content-container {\n  overflow-x: auto;\n}\n\n/*# sourceMappingURL=CollapsibleFixedFooter.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$g = "data-v-7d6736f6";
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var script$f = Vue.extend({
  name: 'CollapsibleSection',
  props: {
    title: String,
    expanded: Boolean
  },
  mounted: function mounted() {
    this.collapsingContainer.style.height = String(this.expanded ? this.contentContainer.offsetHeight : 0);
    if (this.expanded) this.collapsingContainer.classList.add("expanded");
  },
  computed: {
    collapsingContainer: function collapsingContainer() {
      return this.$refs['collapsing-container'];
    },
    contentContainer: function contentContainer() {
      return this.$refs['content-container'];
    }
  },
  methods: {
    clickedToggle: function clickedToggle() {
      if (this.expanded) {
        this.collapsingContainer.style.height = this.contentContainer.offsetHeight + 'px';
        this.collapsingContainer.classList.remove("expanded");
      }

      this.$emit('update:expanded', !this.expanded);
      this.doAnimation(!this.expanded);
    },
    doAnimation: function doAnimation(expanded) {
      var _this12 = this;

      var animation = expanded ? anime({
        targets: this.collapsingContainer,
        height: this.contentContainer.offsetHeight,
        duration: 250,
        easing: 'easeOutExpo',
        complete: function complete() {
          _this12.collapsingContainer.style.height = 'auto';

          _this12.collapsingContainer.classList.add("expanded");
        }
      }) : anime({
        targets: this.collapsingContainer,
        height: 0,
        duration: 250,
        easing: 'easeInQuart'
      });
      return animation.finished;
    }
  }
});
/* script */

var __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function __vue_render__$f() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", [_c("header", {
    staticClass: "border-0 border-b-1 border-blue-light border-solid cursor-pointer text-xl",
    on: {
      click: _vm.clickedToggle
    }
  }, [_c("span", {
    staticClass: "text-blue mr-1"
  }, [!_vm.expanded ? _c("span", [_c("fai", {
    attrs: {
      icon: ["fal", "chevron-down"]
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.expanded ? _c("span", [_c("fai", {
    attrs: {
      icon: ["fal", "chevron-up"]
    }
  })], 1) : _vm._e()]), _vm._v("\n\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c("section", {
    ref: "collapsing-container",
    staticClass: "collapsing-container overflow-hidden"
  }, [_c("section", {
    ref: "content-container",
    staticClass: "content-container m-auto"
  }, [_vm._t("default")], 2)])]);
};

var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;
/* style */

var __vue_inject_styles__$f = function __vue_inject_styles__$f(inject) {
  if (!inject) return;
  inject("data-v-4262dbe7_0", {
    source: "\n.collapsing-container.expanded[data-v-4262dbe7] {\n  overflow: visible;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CollapsibleSection.vue"],
      "names": [],
      "mappings": ";AA+EA;EACA,iBAAA;AACA",
      "file": "CollapsibleSection.vue",
      "sourcesContent": ["<template>\n  <main>\n    <header @click=\"clickedToggle\" class=\"border-0 border-b-1 border-blue-light border-solid cursor-pointer text-xl\">\n      <span class=\"text-blue mr-1\">\n        <span v-if=\"!expanded\">\n          <fai :icon=\"['fal', 'chevron-down']\" />\n        </span>\n\n        <span v-if=\"expanded\">\n          <fai :icon=\"['fal', 'chevron-up']\" />\n        </span>\n      </span>\n\n      {{ title }}\n    </header>\n\n    <section ref=\"collapsing-container\" class=\"collapsing-container overflow-hidden\">\n      <section ref=\"content-container\" class=\"content-container m-auto\">\n        <slot />\n      </section>\n    </section>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\nimport anime from \"animejs\";\n\nexport default Vue.extend({\n  name: 'CollapsibleSection',\n  props: {\n    title: String,\n    expanded: Boolean,\n  },\n  mounted() {\n    this.collapsingContainer.style.height = String(this.expanded ? this.contentContainer.offsetHeight : 0);\n    if(this.expanded) this.collapsingContainer.classList.add(\"expanded\");\n  },\n  computed: {\n    collapsingContainer(): HTMLElement {\n      return this.$refs['collapsing-container']! as HTMLElement;\n    },\n    contentContainer(): HTMLElement {\n      return this.$refs['content-container']! as HTMLElement;\n    }\n  },\n  methods: {\n    clickedToggle() {\n      if(this.expanded) {\n        this.collapsingContainer.style.height = this.contentContainer.offsetHeight+'px';\n        this.collapsingContainer.classList.remove(\"expanded\");\n      }\n      this.$emit('update:expanded', !this.expanded)\n      this.doAnimation(!this.expanded);\n    },\n    doAnimation(expanded: boolean) {\n      const animation = expanded ? anime({\n        targets: this.collapsingContainer,\n        height: this.contentContainer.offsetHeight,\n        duration: 250,\n        easing: 'easeOutExpo',\n        complete: () => {\n          this.collapsingContainer.style.height = 'auto';\n          this.collapsingContainer.classList.add(\"expanded\");\n        }\n      }) : anime({\n        targets: this.collapsingContainer,\n        height: 0,\n        duration: 250,\n        easing: 'easeInQuart'\n      })\n\n      return animation.finished\n    }\n  }\n});\n</script>\n\n<style scoped>\n.collapsing-container.expanded {\n  overflow: visible;\n}\n</style>"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$f = "data-v-4262dbe7";
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined); //


var script$e = Vue.extend({
  name: 'ProgressBar',
  props: {
    progress: 0
  },
  computed: {
    width: function width() {
      return this.progress * 100 + '%';
    }
  }
});
/* script */

var __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function __vue_render__$e() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "progress-bar relative h-4 rounded-full overflow-hidden box-content border-1 border-solid border-blue-200 bg-white"
  }, [_c("div", {
    staticClass: "fill absolute top-0 left-0 h-4 bg-blue-200 transition-all duration-500",
    style: {
      width: _vm.width
    }
  })]);
};

var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;
/* style */

var __vue_inject_styles__$e = undefined;
/* scoped */

var __vue_scope_id__$e = undefined;
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$d = Vue.extend({
  name: "swipe-pagination",
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  props: {
    columns: {
      type: Array,
      "default": []
    }
  },
  data: function data() {
    return {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    };
  },
  methods: {
    renderBullet: function renderBullet(index, className) {
      return "<div class=\"".concat(className, " swiper-pagination-bullet-custom flex flex-col justify-center items-center w-auto h-auto text-negative opacity-100\">\n                <span class=\"mb-1\">").concat(this.columns[index].label, "</span>\n                <span class=\"bullet w-4 h-4 rounded-full text-center opacity-20\"></span>\n              </div>");
    }
  },
  computed: {
    swipePaginationOption: function swipePaginationOption() {
      return this.columns && this.columns.length ? {
        pagination: {
          el: ".swiper-pagination-container",
          clickable: true,
          renderBullet: this.renderBullet
        },
        navigation: this.navigation
      } : null;
    }
  }
});
/* script */

var __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function __vue_render__$d() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.swipePaginationOption ? _c("main", {
    staticClass: "w-full"
  }, [_c("swiper", {
    staticClass: "swipe-pagination w-full",
    attrs: {
      options: _vm.swipePaginationOption
    }
  }, _vm._l(_vm.columns, function (column, index) {
    return _c("swiper-slide", {
      key: index,
      staticClass: "flex justify-center"
    }, [_vm._t("swipe-pagination-content", null, {
      column: column,
      index: index
    })], 2);
  }), 1), _vm._v(" "), _c("div", {
    staticClass: "swiper-controls flex flex-row justify-center relative mt-5"
  }, [_c("div", {
    staticClass: "swiper-button-prev flex relative w-10 h-10 rounded-full mt-3",
    attrs: {
      slot: "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c("div", {
    staticClass: "swiper-pagination-container swiper-pagination-bullets\n        flex flex-1\n        h-10\n        justify-evenly\n        items-center\n        relative\n      ",
    attrs: {
      slot: "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c("div", {
    staticClass: "swiper-button-next flex relative w-10 h-10 rounded-full mt-3",
    attrs: {
      slot: "button-next"
    },
    slot: "button-next"
  })])], 1) : _vm._e();
};

var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;
/* style */

var __vue_inject_styles__$d = function __vue_inject_styles__$d(inject) {
  if (!inject) return;
  inject("data-v-a61fe298_0", {
    source: ".swipe-pagination[data-v-a61fe298] {\n  cursor: grab;\n}\n.swiper-controls .swiper-pagination-container[data-v-a61fe298] .swiper-pagination-bullet-custom {\n  background: unset;\n  outline: none;\n}\n.swiper-controls .swiper-pagination-container[data-v-a61fe298] .swiper-pagination-bullet-custom .bullet {\n  background: #128ff9;\n}\n.swiper-controls .swiper-pagination-container[data-v-a61fe298] .swiper-pagination-bullet-custom.swiper-pagination-bullet-active .bullet {\n  opacity: 1;\n}\n.swiper-controls .swiper-button-prev[data-v-a61fe298],\n.swiper-controls .swiper-button-next[data-v-a61fe298] {\n  border: 1px solid #128ff9;\n  outline: none;\n}\n.swiper-controls .swiper-button-prev[data-v-a61fe298]::after,\n.swiper-controls .swiper-button-next[data-v-a61fe298]::after {\n  font-size: 1.75rem;\n}\n\n/*# sourceMappingURL=SwipePagination.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/SwipePagination.vue", "SwipePagination.vue"],
      "names": [],
      "mappings": "AAyFA;EACA,YAAA;ACxFA;AD4FA;EACA,iBAAA;EACA,aAAA;ACzFA;AD0FA;EACA,mBAAA;ACxFA;AD4FA;EACA,UAAA;AC1FA;AD+FA;;EAEA,yBAAA;EACA,aAAA;AC7FA;AD8FA;;EACA,kBAAA;AC3FA;;AAEA,8CAA8C",
      "file": "SwipePagination.vue",
      "sourcesContent": ["<template>\n  <main class=\"w-full\" v-if=\"swipePaginationOption\">\n    <swiper class=\"swipe-pagination w-full\" :options=\"swipePaginationOption\">\n      <swiper-slide\n        :key=\"index\"\n        class=\"flex justify-center\"\n        v-for=\"(column, index) of columns\"\n      >\n        <slot name=\"swipe-pagination-content\" :column=\"column\" :index=\"index\" />\n      </swiper-slide>\n    </swiper>\n    <div class=\"swiper-controls flex flex-row justify-center relative mt-5\">\n      <div\n        class=\"swiper-button-prev flex relative w-10 h-10 rounded-full mt-3\"\n        slot=\"button-prev\"\n      ></div>\n      <div\n        class=\"swiper-pagination-container swiper-pagination-bullets\n          flex flex-1\n          h-10\n          justify-evenly\n          items-center\n          relative\n        \"\n        slot=\"pagination\"\n      ></div>\n      <div\n        class=\"swiper-button-next flex relative w-10 h-10 rounded-full mt-3\"\n        slot=\"button-next\"\n      ></div>\n    </div>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue, { PropType } from \"vue\";\nimport { Swiper, SwiperSlide } from \"vue-awesome-swiper\";\n\ninterface Column {\n  label: string;\n  content: string;\n}\n\nexport default Vue.extend({\n  name: \"swipe-pagination\",\n  components: {\n    Swiper,\n    SwiperSlide,\n  },\n  props: {\n    columns: {\n      type: Array as PropType<Column[]>,\n      default: [],\n    },\n  },\n  data() {\n    return {\n      navigation: {\n        nextEl: \".swiper-button-next\",\n        prevEl: \".swiper-button-prev\",\n      }\n    }\n  },\n  methods: {\n    renderBullet(index: number, className: string) {\n      return `<div class=\"${className} swiper-pagination-bullet-custom flex flex-col justify-center items-center w-auto h-auto text-negative opacity-100\">\n                <span class=\"mb-1\">${this.columns[index].label}</span>\n                <span class=\"bullet w-4 h-4 rounded-full text-center opacity-20\"></span>\n              </div>`\n    }\n  },\n  computed: {\n    swipePaginationOption(): Object | null {\n      return this.columns && this.columns.length\n        ? {\n            pagination: {\n              el: \".swiper-pagination-container\",\n              clickable: true,\n              renderBullet: this.renderBullet,\n            },\n            navigation: this.navigation\n          }\n        : null;\n    },\n  },\n});\n</script>\n\n<style lang=\"scss\" scoped>\n.swipe-pagination {\n  cursor: grab;\n}\n.swiper-controls {\n  .swiper-pagination-container::v-deep {\n    .swiper-pagination-bullet-custom {\n      background: unset;\n      outline: none;\n      .bullet {\n        background: #128ff9;\n      }\n\n      &.swiper-pagination-bullet-active {\n        .bullet {\n          opacity: 1;\n        }\n      }\n    }\n  }\n  .swiper-button-prev,\n  .swiper-button-next {\n    border: 1px solid #128ff9;\n    outline: none;\n    &::after {\n      font-size: 1.75rem;\n    }\n  }\n}\n</style>", ".swipe-pagination {\n  cursor: grab;\n}\n\n.swiper-controls .swiper-pagination-container::v-deep .swiper-pagination-bullet-custom {\n  background: unset;\n  outline: none;\n}\n.swiper-controls .swiper-pagination-container::v-deep .swiper-pagination-bullet-custom .bullet {\n  background: #128ff9;\n}\n.swiper-controls .swiper-pagination-container::v-deep .swiper-pagination-bullet-custom.swiper-pagination-bullet-active .bullet {\n  opacity: 1;\n}\n.swiper-controls .swiper-button-prev,\n.swiper-controls .swiper-button-next {\n  border: 1px solid #128ff9;\n  outline: none;\n}\n.swiper-controls .swiper-button-prev::after,\n.swiper-controls .swiper-button-next::after {\n  font-size: 1.75rem;\n}\n\n/*# sourceMappingURL=SwipePagination.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$d = "data-v-a61fe298";
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var script$c = Vue.extend({
  name: 'custom-image',
  props: {
    image: [Object, String],
    loadingIconSize: {
      "default": '20%',
      type: String
    }
  },
  components: {
    LoadingIcon: __vue_component__$u
  },
  data: function data() {
    return {
      isImageLoading: true,
      isImageLoaded: false
    };
  },
  computed: {
    imageUrl: function imageUrl() {
      var _this$image;

      return _typeof(this.image) === 'object' ? (_this$image = this.image) === null || _this$image === void 0 ? void 0 : _this$image.url : this.image;
    }
  },
  methods: {
    imageLoaded: function imageLoaded() {
      this.isImageLoading = false;
      this.isImageLoaded = true;
    },
    imageClicked: function imageClicked() {
      this.$emit('imageClicked', this.image);
    }
  }
});
/* script */

var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__$c() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "flex justify-center items-center",
    on: {
      click: _vm.imageClicked
    }
  }, [_vm.isImageLoading ? _c("loading-icon", {
    style: {
      width: _vm.loadingIconSize
    }
  }) : _vm._e(), _vm._v(" "), _c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isImageLoaded,
      expression: "isImageLoaded"
    }],
    attrs: {
      src: _vm.imageUrl,
      alt: "image"
    },
    on: {
      load: _vm.imageLoaded
    }
  })], 1);
};

var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;
/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);
/*!
 * Chart.js v3.8.0
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */


var requestAnimFrame = function () {
  if (typeof window === 'undefined') {
    return function (callback) {
      return callback();
    };
  }

  return window.requestAnimationFrame;
}();

function throttled(fn, thisArg, updateFn) {
  var updateArgs = updateFn || function (args) {
    return Array.prototype.slice.call(args);
  };

  var ticking = false;
  var args = [];
  return function () {
    for (var _len11 = arguments.length, rest = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      rest[_key11] = arguments[_key11];
    }

    args = updateArgs(rest);

    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, function () {
        ticking = false;
        fn.apply(thisArg, args);
      });
    }
  };
}

function debounce(fn, delay) {
  var timeout;
  return function () {
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }

    return delay;
  };
}

var _toLeftRightCenter = function _toLeftRightCenter(align) {
  return align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
};

var _alignStartEnd = function _alignStartEnd(align, start, end) {
  return align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
};

var _textX = function _textX(align, left, right, rtl) {
  var check = rtl ? 'left' : 'right';
  return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};

function noop() {}

var uid = function () {
  var id = 0;
  return function () {
    return id++;
  };
}();

function isNullOrUndef(value) {
  return value === null || typeof value === 'undefined';
}

function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }

  var type = Object.prototype.toString.call(value);

  if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
    return true;
  }

  return false;
}

function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}

var isNumberFinite = function isNumberFinite(value) {
  return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
};

function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}

function valueOrDefault(value, defaultValue) {
  return typeof value === 'undefined' ? defaultValue : value;
}

var toPercentage = function toPercentage(value, dimension) {
  return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : value / dimension;
};

var toDimension = function toDimension(value, dimension) {
  return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
};

function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === 'function') {
    return fn.apply(thisArg, args);
  }
}

function each(loopable, fn, thisArg, reverse) {
  var i, len, keys;

  if (isArray(loopable)) {
    len = loopable.length;

    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;

    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}

function _elementsEqual(a0, a1) {
  var i, ilen, v0, v1;

  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }

  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];

    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }

  return true;
}

function clone$1(source) {
  if (isArray(source)) {
    return source.map(clone$1);
  }

  if (isObject(source)) {
    var target = Object.create(null);
    var keys = Object.keys(source);
    var klen = keys.length;
    var k = 0;

    for (; k < klen; ++k) {
      target[keys[k]] = clone$1(source[keys[k]]);
    }

    return target;
  }

  return source;
}

function isValidKey(key) {
  return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }

  var tval = target[key];
  var sval = source[key];

  if (isObject(tval) && isObject(sval)) {
    merge(tval, sval, options);
  } else {
    target[key] = clone$1(sval);
  }
}

function merge(target, source, options) {
  var sources = isArray(source) ? source : [source];
  var ilen = sources.length;

  if (!isObject(target)) {
    return target;
  }

  options = options || {};
  var merger = options.merger || _merger;

  for (var i = 0; i < ilen; ++i) {
    source = sources[i];

    if (!isObject(source)) {
      continue;
    }

    var keys = Object.keys(source);

    for (var k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, source, options);
    }
  }

  return target;
}

function mergeIf(target, source) {
  return merge(target, source, {
    merger: _mergerIf
  });
}

function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }

  var tval = target[key];
  var sval = source[key];

  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$1(sval);
  }
}

var emptyString = '';
var dot = '.';

function indexOfDotOrLength(key, start) {
  var idx = key.indexOf(dot, start);
  return idx === -1 ? key.length : idx;
}

function resolveObjectKey(obj, key) {
  if (key === emptyString) {
    return obj;
  }

  var pos = 0;
  var idx = indexOfDotOrLength(key, pos);

  while (obj && idx > pos) {
    obj = obj[key.slice(pos, idx)];
    pos = idx + 1;
    idx = indexOfDotOrLength(key, pos);
  }

  return obj;
}

function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var defined = function defined(value) {
  return typeof value !== 'undefined';
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var setsEqual = function setsEqual(a, b) {
  if (a.size !== b.size) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (!b.has(item)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

function _isClickEvent(e) {
  return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

var PI = Math.PI;
var TAU = 2 * PI;
var PITAU = TAU + PI;
var INFINITY = Number.POSITIVE_INFINITY;
var RAD_PER_DEG = PI / 180;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;
var log10 = Math.log10;
var sign = Math.sign;

function niceNum(range) {
  var roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
  var niceRange = Math.pow(10, Math.floor(log10(range)));
  var fraction = range / niceRange;
  var niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}

function _factorize(value) {
  var result = [];
  var sqrt = Math.sqrt(value);
  var i;

  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }

  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }

  result.sort(function (a, b) {
    return a - b;
  }).pop();
  return result;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}

function almostWhole(x, epsilon) {
  var rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}

function _setMinAndMaxByKey(array, target, property) {
  var i, ilen, value;

  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];

    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}

function toRadians(degrees) {
  return degrees * (PI / 180);
}

function toDegrees(radians) {
  return radians * (180 / PI);
}

function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }

  var e = 1;
  var p = 0;

  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }

  return p;
}

function getAngleFromPoint(centrePoint, anglePoint) {
  var distanceFromXCenter = anglePoint.x - centrePoint.x;
  var distanceFromYCenter = anglePoint.y - centrePoint.y;
  var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

  if (angle < -0.5 * PI) {
    angle += TAU;
  }

  return {
    angle: angle,
    distance: radialDistanceFromCenter
  };
}

function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}

function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}

function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}

function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  var a = _normalizeAngle(angle);

  var s = _normalizeAngle(start);

  var e = _normalizeAngle(end);

  var angleToStart = _normalizeAngle(s - a);

  var angleToEnd = _normalizeAngle(e - a);

  var startToAngle = _normalizeAngle(a - s);

  var endToAngle = _normalizeAngle(a - e);

  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}

function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}

function _isBetween(value, start, end) {
  var epsilon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1e-6;
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}

var atEdge = function atEdge(t) {
  return t === 0 || t === 1;
};

var elasticIn = function elasticIn(t, s, p) {
  return -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
};

var elasticOut = function elasticOut(t, s, p) {
  return Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
};

var effects = {
  linear: function linear(t) {
    return t;
  },
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  easeOutQuad: function easeOutQuad(t) {
    return -t * (t - 2);
  },
  easeInOutQuad: function easeInOutQuad(t) {
    return (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1);
  },
  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },
  easeOutCubic: function easeOutCubic(t) {
    return (t -= 1) * t * t + 1;
  },
  easeInOutCubic: function easeInOutCubic(t) {
    return (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2);
  },
  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },
  easeOutQuart: function easeOutQuart(t) {
    return -((t -= 1) * t * t * t - 1);
  },
  easeInOutQuart: function easeInOutQuart(t) {
    return (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
  },
  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },
  easeOutQuint: function easeOutQuint(t) {
    return (t -= 1) * t * t * t * t + 1;
  },
  easeInOutQuint: function easeInOutQuint(t) {
    return (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
  },
  easeInSine: function easeInSine(t) {
    return -Math.cos(t * HALF_PI) + 1;
  },
  easeOutSine: function easeOutSine(t) {
    return Math.sin(t * HALF_PI);
  },
  easeInOutSine: function easeInOutSine(t) {
    return -0.5 * (Math.cos(PI * t) - 1);
  },
  easeInExpo: function easeInExpo(t) {
    return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
  },
  easeOutExpo: function easeOutExpo(t) {
    return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
  },
  easeInOutExpo: function easeInOutExpo(t) {
    return atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2);
  },
  easeInCirc: function easeInCirc(t) {
    return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1);
  },
  easeOutCirc: function easeOutCirc(t) {
    return Math.sqrt(1 - (t -= 1) * t);
  },
  easeInOutCirc: function easeInOutCirc(t) {
    return (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
  },
  easeInElastic: function easeInElastic(t) {
    return atEdge(t) ? t : elasticIn(t, 0.075, 0.3);
  },
  easeOutElastic: function easeOutElastic(t) {
    return atEdge(t) ? t : elasticOut(t, 0.075, 0.3);
  },
  easeInOutElastic: function easeInOutElastic(t) {
    var s = 0.1125;
    var p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack: function easeInBack(t) {
    var s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack: function easeOutBack(t) {
    var s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack: function easeInOutBack(t) {
    var s = 1.70158;

    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }

    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: function easeInBounce(t) {
    return 1 - effects.easeOutBounce(1 - t);
  },
  easeOutBounce: function easeOutBounce(t) {
    var m = 7.5625;
    var d = 2.75;

    if (t < 1 / d) {
      return m * t * t;
    }

    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }

    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }

    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: function easeInOutBounce(t) {
    return t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
  }
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */

function round(v) {
  return v + 0.5 | 0;
}

var lim = function lim(v, l, h) {
  return Math.max(Math.min(v, h), l);
};

function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}

function n2b(v) {
  return lim(round(v * 255), 0, 255);
}

function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}

function n2p(v) {
  return lim(round(v * 100), 0, 100);
}

var map$1 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  a: 10,
  b: 11,
  c: 12,
  d: 13,
  e: 14,
  f: 15
};

var hex = _toConsumableArray('0123456789ABCDEF');

var h1 = function h1(b) {
  return hex[b & 0xF];
};

var h2 = function h2(b) {
  return hex[(b & 0xF0) >> 4] + hex[b & 0xF];
};

var eq = function eq(b) {
  return (b & 0xF0) >> 4 === (b & 0xF);
};

var isShort = function isShort(v) {
  return eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
};

function hexParse(str) {
  var len = str.length;
  var ret;

  if (str[0] === '#') {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }

  return ret;
}

var alpha = function alpha(a, f) {
  return a < 255 ? f(a) : '';
};

function _hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}

var HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;

function hsl2rgbn(h, s, l) {
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  return [f(0), f(8), f(4)];
}

function hsv2rgbn(h, s, v) {
  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 60) % 6;
    return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  };

  return [f(5), f(3), f(1)];
}

function hwb2rgbn(h, w, b) {
  var rgb = hsl2rgbn(h, 1, 0.5);
  var i;

  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }

  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }

  return rgb;
}

function hueValue(r, g, b, d, max) {
  if (r === max) {
    return (g - b) / d + (g < b ? 6 : 0);
  }

  if (g === max) {
    return (b - r) / d + 2;
  }

  return (r - g) / d + 4;
}

function rgb2hsl(v) {
  var range = 255;
  var r = v.r / range;
  var g = v.g / range;
  var b = v.b / range;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var l = (max + min) / 2;
  var h, s, d;

  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }

  return [h | 0, s || 0, l];
}

function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}

function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}

function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}

function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}

function hue(h) {
  return (h % 360 + 360) % 360;
}

function hueParse(str) {
  var m = HUE_RE.exec(str);
  var a = 255;
  var v;

  if (!m) {
    return;
  }

  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }

  var h = hue(+m[2]);
  var p1 = +m[3] / 100;
  var p2 = +m[4] / 100;

  if (m[1] === 'hwb') {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === 'hsv') {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }

  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a
  };
}

function _rotate2(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}

function _hslString(v) {
  if (!v) {
    return;
  }

  var a = rgb2hsl(v);
  var h = a[0];
  var s = n2p(a[1]);
  var l = n2p(a[2]);
  return v.a < 255 ? "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(b2n(v.a), ")") : "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
}

var map$2 = {
  x: 'dark',
  Z: 'light',
  Y: 're',
  X: 'blu',
  W: 'gr',
  V: 'medium',
  U: 'slate',
  A: 'ee',
  T: 'ol',
  S: 'or',
  B: 'ra',
  C: 'lateg',
  D: 'ights',
  R: 'in',
  Q: 'turquois',
  E: 'hi',
  P: 'ro',
  O: 'al',
  N: 'le',
  M: 'de',
  L: 'yello',
  F: 'en',
  K: 'ch',
  G: 'arks',
  H: 'ea',
  I: 'ightg',
  J: 'wh'
};
var names$1 = {
  OiceXe: 'f0f8ff',
  antiquewEte: 'faebd7',
  aqua: 'ffff',
  aquamarRe: '7fffd4',
  azuY: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '0',
  blanKedOmond: 'ffebcd',
  Xe: 'ff',
  XeviTet: '8a2be2',
  bPwn: 'a52a2a',
  burlywood: 'deb887',
  caMtXe: '5f9ea0',
  KartYuse: '7fff00',
  KocTate: 'd2691e',
  cSO: 'ff7f50',
  cSnflowerXe: '6495ed',
  cSnsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: 'ffff',
  xXe: '8b',
  xcyan: '8b8b',
  xgTMnPd: 'b8860b',
  xWay: 'a9a9a9',
  xgYF: '6400',
  xgYy: 'a9a9a9',
  xkhaki: 'bdb76b',
  xmagFta: '8b008b',
  xTivegYF: '556b2f',
  xSange: 'ff8c00',
  xScEd: '9932cc',
  xYd: '8b0000',
  xsOmon: 'e9967a',
  xsHgYF: '8fbc8f',
  xUXe: '483d8b',
  xUWay: '2f4f4f',
  xUgYy: '2f4f4f',
  xQe: 'ced1',
  xviTet: '9400d3',
  dAppRk: 'ff1493',
  dApskyXe: 'bfff',
  dimWay: '696969',
  dimgYy: '696969',
  dodgerXe: '1e90ff',
  fiYbrick: 'b22222',
  flSOwEte: 'fffaf0',
  foYstWAn: '228b22',
  fuKsia: 'ff00ff',
  gaRsbSo: 'dcdcdc',
  ghostwEte: 'f8f8ff',
  gTd: 'ffd700',
  gTMnPd: 'daa520',
  Way: '808080',
  gYF: '8000',
  gYFLw: 'adff2f',
  gYy: '808080',
  honeyMw: 'f0fff0',
  hotpRk: 'ff69b4',
  RdianYd: 'cd5c5c',
  Rdigo: '4b0082',
  ivSy: 'fffff0',
  khaki: 'f0e68c',
  lavFMr: 'e6e6fa',
  lavFMrXsh: 'fff0f5',
  lawngYF: '7cfc00',
  NmoncEffon: 'fffacd',
  ZXe: 'add8e6',
  ZcSO: 'f08080',
  Zcyan: 'e0ffff',
  ZgTMnPdLw: 'fafad2',
  ZWay: 'd3d3d3',
  ZgYF: '90ee90',
  ZgYy: 'd3d3d3',
  ZpRk: 'ffb6c1',
  ZsOmon: 'ffa07a',
  ZsHgYF: '20b2aa',
  ZskyXe: '87cefa',
  ZUWay: '778899',
  ZUgYy: '778899',
  ZstAlXe: 'b0c4de',
  ZLw: 'ffffe0',
  lime: 'ff00',
  limegYF: '32cd32',
  lRF: 'faf0e6',
  magFta: 'ff00ff',
  maPon: '800000',
  VaquamarRe: '66cdaa',
  VXe: 'cd',
  VScEd: 'ba55d3',
  VpurpN: '9370db',
  VsHgYF: '3cb371',
  VUXe: '7b68ee',
  VsprRggYF: 'fa9a',
  VQe: '48d1cc',
  VviTetYd: 'c71585',
  midnightXe: '191970',
  mRtcYam: 'f5fffa',
  mistyPse: 'ffe4e1',
  moccasR: 'ffe4b5',
  navajowEte: 'ffdead',
  navy: '80',
  Tdlace: 'fdf5e6',
  Tive: '808000',
  TivedBb: '6b8e23',
  Sange: 'ffa500',
  SangeYd: 'ff4500',
  ScEd: 'da70d6',
  pOegTMnPd: 'eee8aa',
  pOegYF: '98fb98',
  pOeQe: 'afeeee',
  pOeviTetYd: 'db7093',
  papayawEp: 'ffefd5',
  pHKpuff: 'ffdab9',
  peru: 'cd853f',
  pRk: 'ffc0cb',
  plum: 'dda0dd',
  powMrXe: 'b0e0e6',
  purpN: '800080',
  YbeccapurpN: '663399',
  Yd: 'ff0000',
  Psybrown: 'bc8f8f',
  PyOXe: '4169e1',
  saddNbPwn: '8b4513',
  sOmon: 'fa8072',
  sandybPwn: 'f4a460',
  sHgYF: '2e8b57',
  sHshell: 'fff5ee',
  siFna: 'a0522d',
  silver: 'c0c0c0',
  skyXe: '87ceeb',
  UXe: '6a5acd',
  UWay: '708090',
  UgYy: '708090',
  snow: 'fffafa',
  sprRggYF: 'ff7f',
  stAlXe: '4682b4',
  tan: 'd2b48c',
  teO: '8080',
  tEstN: 'd8bfd8',
  tomato: 'ff6347',
  Qe: '40e0d0',
  viTet: 'ee82ee',
  JHt: 'f5deb3',
  wEte: 'ffffff',
  wEtesmoke: 'f5f5f5',
  Lw: 'ffff00',
  LwgYF: '9acd32'
};

function unpack() {
  var unpacked = {};
  var keys = Object.keys(names$1);
  var tkeys = Object.keys(map$2);
  var i, j, k, ok, nk;

  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];

    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map$2[k]);
    }

    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
  }

  return unpacked;
}

var names;

function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }

  var a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}

var RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;

function rgbParse(str) {
  var m = RGB_RE.exec(str);
  var a = 255;
  var r, g, b;

  if (!m) {
    return;
  }

  if (m[7] !== r) {
    var v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }

  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}

function _rgbString(v) {
  return v && (v.a < 255 ? "rgba(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ", ").concat(b2n(v.a), ")") : "rgb(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ")"));
}

var to = function to(v) {
  return v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
};

var from = function from(v) {
  return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
};

function interpolate$1(rgb1, rgb2, t) {
  var r = from(b2n(rgb1.r));
  var g = from(b2n(rgb1.g));
  var b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}

function modHSL(v, i, ratio) {
  if (v) {
    var tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}

function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}

function fromObject(input) {
  var v = {
    r: 0,
    g: 0,
    b: 0,
    a: 255
  };

  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = {
        r: input[0],
        g: input[1],
        b: input[2],
        a: 255
      };

      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    });
    v.a = n2b(v.a);
  }

  return v;
}

function functionParse(str) {
  if (str.charAt(0) === 'r') {
    return rgbParse(str);
  }

  return hueParse(str);
}

var Color = /*#__PURE__*/function () {
  function Color(input) {
    _classCallCheck(this, Color);

    if (input instanceof Color) {
      return input;
    }

    var type = _typeof(input);

    var v;

    if (type === 'object') {
      v = fromObject(input);
    } else if (type === 'string') {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }

    this._rgb = v;
    this._valid = !!v;
  }

  _createClass(Color, [{
    key: "valid",
    get: function get() {
      return this._valid;
    }
  }, {
    key: "rgb",
    get: function get() {
      var v = clone(this._rgb);

      if (v) {
        v.a = b2n(v.a);
      }

      return v;
    },
    set: function set(obj) {
      this._rgb = fromObject(obj);
    }
  }, {
    key: "rgbString",
    value: function rgbString() {
      return this._valid ? _rgbString(this._rgb) : undefined;
    }
  }, {
    key: "hexString",
    value: function hexString() {
      return this._valid ? _hexString(this._rgb) : undefined;
    }
  }, {
    key: "hslString",
    value: function hslString() {
      return this._valid ? _hslString(this._rgb) : undefined;
    }
  }, {
    key: "mix",
    value: function mix(color, weight) {
      if (color) {
        var c1 = this.rgb;
        var c2 = color.rgb;
        var w2;
        var p = weight === w2 ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = c1.a - c2.a;
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        w2 = 1 - w1;
        c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
        c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
        c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
        c1.a = p * c1.a + (1 - p) * c2.a;
        this.rgb = c1;
      }

      return this;
    }
  }, {
    key: "interpolate",
    value: function interpolate(color, t) {
      if (color) {
        this._rgb = interpolate$1(this._rgb, color._rgb, t);
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Color(this.rgb);
    }
  }, {
    key: "alpha",
    value: function alpha(a) {
      this._rgb.a = n2b(a);
      return this;
    }
  }, {
    key: "clearer",
    value: function clearer(ratio) {
      var rgb = this._rgb;
      rgb.a *= 1 - ratio;
      return this;
    }
  }, {
    key: "greyscale",
    value: function greyscale() {
      var rgb = this._rgb;
      var val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
      rgb.r = rgb.g = rgb.b = val;
      return this;
    }
  }, {
    key: "opaquer",
    value: function opaquer(ratio) {
      var rgb = this._rgb;
      rgb.a *= 1 + ratio;
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      var v = this._rgb;
      v.r = 255 - v.r;
      v.g = 255 - v.g;
      v.b = 255 - v.b;
      return this;
    }
  }, {
    key: "lighten",
    value: function lighten(ratio) {
      modHSL(this._rgb, 2, ratio);
      return this;
    }
  }, {
    key: "darken",
    value: function darken(ratio) {
      modHSL(this._rgb, 2, -ratio);
      return this;
    }
  }, {
    key: "saturate",
    value: function saturate(ratio) {
      modHSL(this._rgb, 1, ratio);
      return this;
    }
  }, {
    key: "desaturate",
    value: function desaturate(ratio) {
      modHSL(this._rgb, 1, -ratio);
      return this;
    }
  }, {
    key: "rotate",
    value: function rotate(deg) {
      _rotate2(this._rgb, deg);

      return this;
    }
  }]);

  return Color;
}();

function index_esm(input) {
  return new Color(input);
}

function isPatternOrGradient(value) {
  if (value && _typeof(value) === 'object') {
    var type = value.toString();
    return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
  }

  return false;
}

function _color(value) {
  return isPatternOrGradient(value) ? value : index_esm(value);
}

function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : index_esm(value).saturate(0.5).darken(0.1).hexString();
}

var overrides = Object.create(null);
var descriptors = Object.create(null);

function getScope$1(node, key) {
  if (!key) {
    return node;
  }

  var keys = key.split('.');

  for (var i = 0, _n2 = keys.length; i < _n2; ++i) {
    var k = keys[i];
    node = node[k] || (node[k] = Object.create(null));
  }

  return node;
}

function _set(root, scope, values) {
  if (typeof scope === 'string') {
    return merge(getScope$1(root, scope), values);
  }

  return merge(getScope$1(root, ''), scope);
}

var Defaults = /*#__PURE__*/function () {
  function Defaults(_descriptors) {
    _classCallCheck(this, Defaults);

    this.animation = undefined;
    this.backgroundColor = 'rgba(0,0,0,0.1)';
    this.borderColor = 'rgba(0,0,0,0.1)';
    this.color = '#666';
    this.datasets = {};

    this.devicePixelRatio = function (context) {
      return context.chart.platform.getDevicePixelRatio();
    };

    this.elements = {};
    this.events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: 'normal',
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};

    this.hoverBackgroundColor = function (ctx, options) {
      return getHoverColor(options.backgroundColor);
    };

    this.hoverBorderColor = function (ctx, options) {
      return getHoverColor(options.borderColor);
    };

    this.hoverColor = function (ctx, options) {
      return getHoverColor(options.color);
    };

    this.indexAxis = 'x';
    this.interaction = {
      mode: 'nearest',
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = undefined;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors);
  }

  _createClass(Defaults, [{
    key: "set",
    value: function set(scope, values) {
      return _set(this, scope, values);
    }
  }, {
    key: "get",
    value: function get(scope) {
      return getScope$1(this, scope);
    }
  }, {
    key: "describe",
    value: function describe(scope, values) {
      return _set(descriptors, scope, values);
    }
  }, {
    key: "override",
    value: function override(scope, values) {
      return _set(overrides, scope, values);
    }
  }, {
    key: "route",
    value: function route(scope, name, targetScope, targetName) {
      var _Object$definePropert;

      var scopeObject = getScope$1(this, scope);
      var targetScopeObject = getScope$1(this, targetScope);
      var privateName = '_' + name;
      Object.defineProperties(scopeObject, (_Object$definePropert = {}, _defineProperty2(_Object$definePropert, privateName, {
        value: scopeObject[name],
        writable: true
      }), _defineProperty2(_Object$definePropert, name, {
        enumerable: true,
        get: function get() {
          var local = this[privateName];
          var target = targetScopeObject[targetName];

          if (isObject(local)) {
            return Object.assign({}, target, local);
          }

          return valueOrDefault(local, target);
        },
        set: function set(value) {
          this[privateName] = value;
        }
      }), _Object$definePropert));
    }
  }]);

  return Defaults;
}();

var defaults = new Defaults({
  _scriptable: function _scriptable(name) {
    return !name.startsWith('on');
  },
  _indexable: function _indexable(name) {
    return name !== 'events';
  },
  hover: {
    _fallback: 'interaction'
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
});

function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }

  return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}

function _measureText(ctx, data, gc, longest, string) {
  var textWidth = data[string];

  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }

  if (textWidth > longest) {
    longest = textWidth;
  }

  return longest;
}

function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  var data = cache.data = cache.data || {};
  var gc = cache.garbageCollect = cache.garbageCollect || [];

  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }

  ctx.save();
  ctx.font = font;
  var longest = 0;
  var ilen = arrayOfThings.length;
  var i, j, jlen, thing, nestedThing;

  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];

    if (thing !== undefined && thing !== null && isArray(thing) !== true) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];

        if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }

  ctx.restore();
  var gcLen = gc.length / 2;

  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }

    gc.splice(0, gcLen);
  }

  return longest;
}

function _alignPixel(chart, pixel, width) {
  var devicePixelRatio = chart.currentDevicePixelRatio;
  var halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}

function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext('2d');
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}

function drawPoint(ctx, options, x, y) {
  var type, xOffset, yOffset, size, cornerRadius;
  var style = options.pointStyle;
  var rotation = options.rotation;
  var radius = options.radius;
  var rad = (rotation || 0) * RAD_PER_DEG;

  if (style && _typeof(style) === 'object') {
    type = style.toString();

    if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }

  if (isNaN(radius) || radius <= 0) {
    return;
  }

  ctx.beginPath();

  switch (style) {
    default:
      ctx.arc(x, y, radius, 0, TAU);
      ctx.closePath();
      break;

    case 'triangle':
      ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;

    case 'rectRounded':
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;

    case 'rect':
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        ctx.rect(x - size, y - size, 2 * size, 2 * size);
        break;
      }

      rad += QUARTER_PI;

    case 'rectRot':
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + yOffset, y - xOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      ctx.closePath();
      break;

    case 'crossRot':
      rad += QUARTER_PI;

    case 'cross':
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      break;

    case 'star':
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      rad += QUARTER_PI;
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      break;

    case 'line':
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;

    case 'dash':
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
      break;
  }

  ctx.fill();

  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}

function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}

function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}

function unclipArea(ctx) {
  ctx.restore();
}

function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }

  if (mode === 'middle') {
    var midpoint = (previous.x + target.x) / 2.0;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === 'after' !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }

  ctx.lineTo(target.x, target.y);
}

function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }

  ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}

function renderText(ctx, text, x, y, font) {
  var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var lines = isArray(text) ? text : [text];
  var stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
  var i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);

  for (i = 0; i < lines.length; ++i) {
    line = lines[i];

    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }

      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }

      ctx.strokeText(line, x, y, opts.maxWidth);
    }

    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += font.lineHeight;
  }

  ctx.restore();
}

function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }

  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }

  if (opts.color) {
    ctx.fillStyle = opts.color;
  }

  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }

  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}

function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    var metrics = ctx.measureText(line);
    var left = x - metrics.actualBoundingBoxLeft;
    var right = x + metrics.actualBoundingBoxRight;
    var top = y - metrics.actualBoundingBoxAscent;
    var bottom = y + metrics.actualBoundingBoxDescent;
    var yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}

function addRoundedRectPath(ctx, rect) {
  var x = rect.x,
      y = rect.y,
      w = rect.w,
      h = rect.h,
      radius = rect.radius;
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -HALF_PI, PI, true);
  ctx.lineTo(x, y + h - radius.bottomLeft);
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x + w, y + radius.topRight);
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x + radius.topLeft, y);
}

var LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
var FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);

function toLineHeight(value, size) {
  var matches = ('' + value).match(LINE_HEIGHT);

  if (!matches || matches[1] === 'normal') {
    return size * 1.2;
  }

  value = +matches[2];

  switch (matches[3]) {
    case 'px':
      return value;

    case '%':
      value /= 100;
      break;
  }

  return size * value;
}

var numberOrZero = function numberOrZero(v) {
  return +v || 0;
};

function _readValueToProps(value, props) {
  var ret = {};
  var objProps = isObject(props);
  var keys = objProps ? Object.keys(props) : props;
  var read = isObject(value) ? objProps ? function (prop) {
    return valueOrDefault(value[prop], value[props[prop]]);
  } : function (prop) {
    return value[prop];
  } : function () {
    return value;
  };

  var _iterator2 = _createForOfIteratorHelper(keys),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var prop = _step2.value;
      ret[prop] = numberOrZero(read(prop));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return ret;
}

function toTRBL(value) {
  return _readValueToProps(value, {
    top: 'y',
    right: 'x',
    bottom: 'y',
    left: 'x'
  });
}

function toTRBLCorners(value) {
  return _readValueToProps(value, ['topLeft', 'topRight', 'bottomLeft', 'bottomRight']);
}

function toPadding(value) {
  var obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}

function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults.font;
  var size = valueOrDefault(options.size, fallback.size);

  if (typeof size === 'string') {
    size = parseInt(size, 10);
  }

  var style = valueOrDefault(options.style, fallback.style);

  if (style && !('' + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = '';
  }

  var font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size: size,
    style: style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ''
  };
  font.string = toFontString(font);
  return font;
}

function resolve(inputs, context, index, info) {
  var cacheable = true;
  var i, ilen, value;

  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];

    if (value === undefined) {
      continue;
    }

    if (context !== undefined && typeof value === 'function') {
      value = value(context);
      cacheable = false;
    }

    if (index !== undefined && isArray(value)) {
      value = value[index % value.length];
      cacheable = false;
    }

    if (value !== undefined) {
      if (info && !cacheable) {
        info.cacheable = false;
      }

      return value;
    }
  }
}

function _addGrace(minmax, grace, beginAtZero) {
  var min = minmax.min,
      max = minmax.max;
  var change = toDimension(grace, (max - min) / 2);

  var keepZero = function keepZero(value, add) {
    return beginAtZero && value === 0 ? 0 : value + add;
  };

  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}

function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}

function _lookup(table, value, cmp) {
  cmp = cmp || function (index) {
    return table[index] < value;
  };

  var hi = table.length - 1;
  var lo = 0;
  var mid;

  while (hi - lo > 1) {
    mid = lo + hi >> 1;

    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }

  return {
    lo: lo,
    hi: hi
  };
}

var _lookupByKey = function _lookupByKey(table, key, value) {
  return _lookup(table, value, function (index) {
    return table[index][key] < value;
  });
};

var _rlookupByKey = function _rlookupByKey(table, key, value) {
  return _lookup(table, value, function (index) {
    return table[index][key] >= value;
  });
};

function _filterBetween(values, min, max) {
  var start = 0;
  var end = values.length;

  while (start < end && values[start] < min) {
    start++;
  }

  while (end > start && values[end - 1] > max) {
    end--;
  }

  return start > 0 || end < values.length ? values.slice(start, end) : values;
}

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);

    return;
  }

  Object.defineProperty(array, '_chartjs', {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach(function (key) {
    var method = '_onData' + _capitalize(key);

    var base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value: function value() {
        for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          args[_key13] = arguments[_key13];
        }

        var res = base.apply(this, args);

        array._chartjs.listeners.forEach(function (object) {
          if (typeof object[method] === 'function') {
            object[method].apply(object, args);
          }
        });

        return res;
      }
    });
  });
}

function unlistenArrayEvents(array, listener) {
  var stub = array._chartjs;

  if (!stub) {
    return;
  }

  var listeners = stub.listeners;
  var index = listeners.indexOf(listener);

  if (index !== -1) {
    listeners.splice(index, 1);
  }

  if (listeners.length > 0) {
    return;
  }

  arrayEvents.forEach(function (key) {
    delete array[key];
  });
  delete array._chartjs;
}

function _arrayUnique(items) {
  var set = new Set();
  var i, ilen;

  for (i = 0, ilen = items.length; i < ilen; ++i) {
    set.add(items[i]);
  }

  if (set.size === ilen) {
    return items;
  }

  return Array.from(set);
}

function _createResolver(scopes) {
  var _cache2;

  var prefixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [''];
  var rootScopes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : scopes;
  var fallback = arguments.length > 3 ? arguments[3] : undefined;
  var getTarget = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return scopes[0];
  };

  if (!defined(fallback)) {
    fallback = _resolve('_fallback', scopes);
  }

  var cache = (_cache2 = {}, _defineProperty2(_cache2, Symbol.toStringTag, 'Object'), _defineProperty2(_cache2, "_cacheable", true), _defineProperty2(_cache2, "_scopes", scopes), _defineProperty2(_cache2, "_rootScopes", rootScopes), _defineProperty2(_cache2, "_fallback", fallback), _defineProperty2(_cache2, "_getTarget", getTarget), _defineProperty2(_cache2, "override", function override(scope) {
    return _createResolver([scope].concat(_toConsumableArray(scopes)), prefixes, rootScopes, fallback);
  }), _cache2);
  return new Proxy(cache, {
    deleteProperty: function deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    get: function get(target, prop) {
      return _cached(target, prop, function () {
        return _resolveWithPrefixes(prop, prefixes, scopes, target);
      });
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    getPrototypeOf: function getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    has: function has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    ownKeys: function ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    set: function set(target, prop, value) {
      var storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}

function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  var cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: function setContext(ctx) {
      return _attachContext(proxy, ctx, subProxy, descriptorDefaults);
    },
    override: function override(scope) {
      return _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults);
    }
  };
  return new Proxy(cache, {
    deleteProperty: function deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    get: function get(target, prop, receiver) {
      return _cached(target, prop, function () {
        return _resolveWithContext(target, prop, receiver);
      });
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    getPrototypeOf: function getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    has: function has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    ownKeys: function ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    set: function set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}

function _descriptors(proxy) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    scriptable: true,
    indexable: true
  };

  var _proxy$_scriptable = proxy._scriptable,
      _scriptable = _proxy$_scriptable === void 0 ? defaults.scriptable : _proxy$_scriptable,
      _proxy$_indexable = proxy._indexable,
      _indexable = _proxy$_indexable === void 0 ? defaults.indexable : _proxy$_indexable,
      _proxy$_allKeys = proxy._allKeys,
      _allKeys = _proxy$_allKeys === void 0 ? defaults.allKeys : _proxy$_allKeys;

  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : function () {
      return _scriptable;
    },
    isIndexable: isFunction(_indexable) ? _indexable : function () {
      return _indexable;
    }
  };
}

var readKey = function readKey(prefix, name) {
  return prefix ? prefix + _capitalize(name) : name;
};

var needsSubResolver = function needsSubResolver(prop, value) {
  return isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
};

function _cached(target, prop, resolve) {
  if (Object.prototype.hasOwnProperty.call(target, prop)) {
    return target[prop];
  }

  var value = resolve();
  target[prop] = value;
  return value;
}

function _resolveWithContext(target, prop, receiver) {
  var _proxy = target._proxy,
      _context = target._context,
      _subProxy = target._subProxy,
      descriptors = target._descriptors;
  var value = _proxy[prop];

  if (isFunction(value) && descriptors.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }

  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors.isIndexable);
  }

  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
  }

  return value;
}

function _resolveScriptable(prop, value, target, receiver) {
  var _proxy = target._proxy,
      _context = target._context,
      _subProxy = target._subProxy,
      _stack = target._stack;

  if (_stack.has(prop)) {
    throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
  }

  _stack.add(prop);

  value = value(_context, _subProxy || receiver);

  _stack["delete"](prop);

  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }

  return value;
}

function _resolveArray(prop, value, target, isIndexable) {
  var _proxy = target._proxy,
      _context = target._context,
      _subProxy = target._subProxy,
      descriptors = target._descriptors;

  if (defined(_context.index) && isIndexable(prop)) {
    value = value[_context.index % value.length];
  } else if (isObject(value[0])) {
    var arr = value;

    var scopes = _proxy._scopes.filter(function (s) {
      return s !== arr;
    });

    value = [];

    var _iterator3 = _createForOfIteratorHelper(arr),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        var resolver = createSubResolver(scopes, _proxy, prop, item);
        value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return value;
}

function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}

var getScope = function getScope(key, parent) {
  return key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
};

function addScopes(set, parentScopes, key, parentFallback, value) {
  var _iterator4 = _createForOfIteratorHelper(parentScopes),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _parent2 = _step4.value;
      var scope = getScope(key, _parent2);

      if (scope) {
        set.add(scope);
        var fallback = resolveFallback(scope._fallback, key, value);

        if (defined(fallback) && fallback !== key && fallback !== parentFallback) {
          return fallback;
        }
      } else if (scope === false && defined(parentFallback) && key !== parentFallback) {
        return null;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return false;
}

function createSubResolver(parentScopes, resolver, prop, value) {
  var rootScopes = resolver._rootScopes;
  var fallback = resolveFallback(resolver._fallback, prop, value);
  var allScopes = [].concat(_toConsumableArray(parentScopes), _toConsumableArray(rootScopes));
  var set = new Set();
  set.add(value);
  var key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);

  if (key === null) {
    return false;
  }

  if (defined(fallback) && fallback !== prop) {
    key = addScopesFromKey(set, allScopes, fallback, key, value);

    if (key === null) {
      return false;
    }
  }

  return _createResolver(Array.from(set), [''], rootScopes, fallback, function () {
    return subGetTarget(resolver, prop, value);
  });
}

function addScopesFromKey(set, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set, allScopes, key, fallback, item);
  }

  return key;
}

function subGetTarget(resolver, prop, value) {
  var parent = resolver._getTarget();

  if (!(prop in parent)) {
    parent[prop] = {};
  }

  var target = parent[prop];

  if (isArray(target) && isObject(value)) {
    return value;
  }

  return target;
}

function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  var value;

  var _iterator5 = _createForOfIteratorHelper(prefixes),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var prefix = _step5.value;
      value = _resolve(readKey(prefix, prop), scopes);

      if (defined(value)) {
        return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}

function _resolve(key, scopes) {
  var _iterator6 = _createForOfIteratorHelper(scopes),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var scope = _step6.value;

      if (!scope) {
        continue;
      }

      var value = scope[key];

      if (defined(value)) {
        return value;
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}

function getKeysFromAllScopes(target) {
  var keys = target._keys;

  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }

  return keys;
}

function resolveKeysFromAllScopes(scopes) {
  var set = new Set();

  var _iterator7 = _createForOfIteratorHelper(scopes),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var scope = _step7.value;

      var _iterator8 = _createForOfIteratorHelper(Object.keys(scope).filter(function (k) {
        return !k.startsWith('_');
      })),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var key = _step8.value;
          set.add(key);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return Array.from(set);
}

function _parseObjectDataRadialScale(meta, data, start, count) {
  var iScale = meta.iScale;
  var _this$_parsing$key = this._parsing.key,
      key = _this$_parsing$key === void 0 ? 'r' : _this$_parsing$key;
  var parsed = new Array(count);
  var i, ilen, index, item;

  for (i = 0, ilen = count; i < ilen; ++i) {
    index = i + start;
    item = data[index];
    parsed[i] = {
      r: iScale.parse(resolveObjectKey(item, key), index)
    };
  }

  return parsed;
}

var EPSILON = Number.EPSILON || 1e-14;

var getPoint = function getPoint(points, i) {
  return i < points.length && !points[i].skip && points[i];
};

var getValueAxis = function getValueAxis(indexAxis) {
  return indexAxis === 'x' ? 'y' : 'x';
};

function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  var previous = firstPoint.skip ? middlePoint : firstPoint;
  var current = middlePoint;
  var next = afterPoint.skip ? middlePoint : afterPoint;
  var d01 = distanceBetweenPoints(current, previous);
  var d12 = distanceBetweenPoints(next, current);
  var s01 = d01 / (d01 + d12);
  var s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  var fa = t * s01;
  var fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}

function monotoneAdjust(points, deltaK, mK) {
  var pointsLen = points.length;
  var alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  var pointAfter = getPoint(points, 0);

  for (var i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);

    if (!pointCurrent || !pointAfter) {
      continue;
    }

    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }

    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);

    if (squaredMagnitude <= 9) {
      continue;
    }

    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}

function monotoneCompute(points, mK) {
  var indexAxis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var valueAxis = getValueAxis(indexAxis);
  var pointsLen = points.length;
  var delta, pointBefore, pointCurrent;
  var pointAfter = getPoint(points, 0);

  for (var i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);

    if (!pointCurrent) {
      continue;
    }

    var iPixel = pointCurrent[indexAxis];
    var vPixel = pointCurrent[valueAxis];

    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent["cp1".concat(indexAxis)] = iPixel - delta;
      pointCurrent["cp1".concat(valueAxis)] = vPixel - delta * mK[i];
    }

    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent["cp2".concat(indexAxis)] = iPixel + delta;
      pointCurrent["cp2".concat(valueAxis)] = vPixel + delta * mK[i];
    }
  }
}

function splineCurveMonotone(points) {
  var indexAxis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var valueAxis = getValueAxis(indexAxis);
  var pointsLen = points.length;
  var deltaK = Array(pointsLen).fill(0);
  var mK = Array(pointsLen);
  var i, pointBefore, pointCurrent;
  var pointAfter = getPoint(points, 0);

  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);

    if (!pointCurrent) {
      continue;
    }

    if (pointAfter) {
      var slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }

    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }

  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}

function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}

function capBezierPoints(points, area) {
  var i, ilen, point, inArea, inAreaPrev;

  var inAreaNext = _isPointInArea(points[0], area);

  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);

    if (!inArea) {
      continue;
    }

    point = points[i];

    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }

    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}

function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  var i, ilen, point, controlPoints;

  if (options.spanGaps) {
    points = points.filter(function (pt) {
      return !pt.skip;
    });
  }

  if (options.cubicInterpolationMode === 'monotone') {
    splineCurveMonotone(points, indexAxis);
  } else {
    var _prev2 = loop ? points[points.length - 1] : points[0];

    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(_prev2, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      _prev2 = point;
    }
  }

  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}

function _isDomSupported() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function _getParentNode(domNode) {
  var parent = domNode.parentNode;

  if (parent && parent.toString() === '[object ShadowRoot]') {
    parent = parent.host;
  }

  return parent;
}

function parseMaxStyle(styleValue, node, parentProperty) {
  var valueInPixels;

  if (typeof styleValue === 'string') {
    valueInPixels = parseInt(styleValue, 10);

    if (styleValue.indexOf('%') !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }

  return valueInPixels;
}

var getComputedStyle$1 = function getComputedStyle$1(element) {
  return window.getComputedStyle(element, null);
};

function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}

var positions = ['top', 'right', 'bottom', 'left'];

function getPositionedStyle(styles, style, suffix) {
  var result = {};
  suffix = suffix ? '-' + suffix : '';

  for (var i = 0; i < 4; i++) {
    var pos = positions[i];
    result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
  }

  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}

var useOffsetPos = function useOffsetPos(x, y, target) {
  return (x > 0 || y > 0) && (!target || !target.shadowRoot);
};

function getCanvasPosition(e, canvas) {
  var touches = e.touches;
  var source = touches && touches.length ? touches[0] : e;
  var offsetX = source.offsetX,
      offsetY = source.offsetY;
  var box = false;
  var x, y;

  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    var rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }

  return {
    x: x,
    y: y,
    box: box
  };
}

function getRelativePosition(evt, chart) {
  if ('native' in evt) {
    return evt;
  }

  var canvas = chart.canvas,
      currentDevicePixelRatio = chart.currentDevicePixelRatio;
  var style = getComputedStyle$1(canvas);
  var borderBox = style.boxSizing === 'border-box';
  var paddings = getPositionedStyle(style, 'padding');
  var borders = getPositionedStyle(style, 'border', 'width');

  var _getCanvasPosition = getCanvasPosition(evt, canvas),
      x = _getCanvasPosition.x,
      y = _getCanvasPosition.y,
      box = _getCanvasPosition.box;

  var xOffset = paddings.left + (box && borders.left);
  var yOffset = paddings.top + (box && borders.top);
  var width = chart.width,
      height = chart.height;

  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }

  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}

function getContainerSize(canvas, width, height) {
  var maxWidth, maxHeight;

  if (width === undefined || height === undefined) {
    var container = _getParentNode(canvas);

    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      var rect = container.getBoundingClientRect();
      var containerStyle = getComputedStyle$1(container);
      var containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
      var containerPadding = getPositionedStyle(containerStyle, 'padding');
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
    }
  }

  return {
    width: width,
    height: height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}

var round1 = function round1(v) {
  return Math.round(v * 10) / 10;
};

function _getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  var style = getComputedStyle$1(canvas);
  var margins = getPositionedStyle(style, 'margin');
  var maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
  var maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
  var containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  var width = containerSize.width,
      height = containerSize.height;

  if (style.boxSizing === 'content-box') {
    var borders = getPositionedStyle(style, 'border', 'width');
    var paddings = getPositionedStyle(style, 'padding');
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }

  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));

  if (width && !height) {
    height = round1(width / 2);
  }

  return {
    width: width,
    height: height
  };
}

function retinaScale(chart, forceRatio, forceStyle) {
  var pixelRatio = forceRatio || 1;
  var deviceHeight = Math.floor(chart.height * pixelRatio);
  var deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = deviceHeight / pixelRatio;
  chart.width = deviceWidth / pixelRatio;
  var canvas = chart.canvas;

  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = "".concat(chart.height, "px");
    canvas.style.width = "".concat(chart.width, "px");
  }

  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }

  return false;
}

var supportsEventListenerOptions = function () {
  var passiveSupported = false;

  try {
    var options = {
      get passive() {
        passiveSupported = true;
        return false;
      }

    };
    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch (e) {}

  return passiveSupported;
}();

function readUsedSize(element, property) {
  var value = getStyle(element, property);
  var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : undefined;
}

function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}

function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}

function _bezierInterpolation(p1, p2, t, mode) {
  var cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  var cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };

  var a = _pointInLine(p1, cp1, t);

  var b = _pointInLine(cp1, cp2, t);

  var c = _pointInLine(cp2, p2, t);

  var d = _pointInLine(a, b, t);

  var e = _pointInLine(b, c, t);

  return _pointInLine(d, e, t);
}

var intlCache = new Map();

function getNumberFormat(locale, options) {
  options = options || {};
  var cacheKey = locale + JSON.stringify(options);
  var formatter = intlCache.get(cacheKey);

  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }

  return formatter;
}

function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}

var getRightToLeftAdapter = function getRightToLeftAdapter(rectX, width) {
  return {
    x: function x(_x2) {
      return rectX + rectX + width - _x2;
    },
    setWidth: function setWidth(w) {
      width = w;
    },
    textAlign: function textAlign(align) {
      if (align === 'center') {
        return align;
      }

      return align === 'right' ? 'left' : 'right';
    },
    xPlus: function xPlus(x, value) {
      return x - value;
    },
    leftForLtr: function leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};

var getLeftToRightAdapter = function getLeftToRightAdapter() {
  return {
    x: function x(_x3) {
      return _x3;
    },
    setWidth: function setWidth(w) {},
    textAlign: function textAlign(align) {
      return align;
    },
    xPlus: function xPlus(x, value) {
      return x + value;
    },
    leftForLtr: function leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};

function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}

function overrideTextDirection(ctx, direction) {
  var style, original;

  if (direction === 'ltr' || direction === 'rtl') {
    style = ctx.canvas.style;
    original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
    style.setProperty('direction', direction, 'important');
    ctx.prevTextDirection = original;
  }
}

function restoreTextDirection(ctx, original) {
  if (original !== undefined) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty('direction', original[0], original[1]);
  }
}

function propertyFn(property) {
  if (property === 'angle') {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }

  return {
    between: _isBetween,
    compare: function compare(a, b) {
      return a - b;
    },
    normalize: function normalize(x) {
      return x;
    }
  };
}

function normalizeSegment(_ref4) {
  var start = _ref4.start,
      end = _ref4.end,
      count = _ref4.count,
      loop = _ref4.loop,
      style = _ref4.style;
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style: style
  };
}

function getSegment(segment, points, bounds) {
  var property = bounds.property,
      startBound = bounds.start,
      endBound = bounds.end;

  var _propertyFn = propertyFn(property),
      between = _propertyFn.between,
      normalize = _propertyFn.normalize;

  var count = points.length;
  var start = segment.start,
      end = segment.end,
      loop = segment.loop;
  var i, ilen;

  if (loop) {
    start += count;
    end += count;

    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }

      start--;
      end--;
    }

    start %= count;
    end %= count;
  }

  if (end < start) {
    end += count;
  }

  return {
    start: start,
    end: end,
    loop: loop,
    style: segment.style
  };
}

function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }

  var property = bounds.property,
      startBound = bounds.start,
      endBound = bounds.end;
  var count = points.length;

  var _propertyFn2 = propertyFn(property),
      compare = _propertyFn2.compare,
      between = _propertyFn2.between,
      normalize = _propertyFn2.normalize;

  var _getSegment = getSegment(segment, points, bounds),
      start = _getSegment.start,
      end = _getSegment.end,
      loop = _getSegment.loop,
      style = _getSegment.style;

  var result = [];
  var inside = false;
  var subStart = null;
  var value, point, prevValue;

  var startIsBefore = function startIsBefore() {
    return between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  };

  var endIsBefore = function endIsBefore() {
    return compare(endBound, value) === 0 || between(endBound, prevValue, value);
  };

  var shouldStart = function shouldStart() {
    return inside || startIsBefore();
  };

  var shouldStop = function shouldStop() {
    return !inside || endIsBefore();
  };

  for (var i = start, _prev3 = start; i <= end; ++i) {
    point = points[i % count];

    if (point.skip) {
      continue;
    }

    value = normalize(point[property]);

    if (value === prevValue) {
      continue;
    }

    inside = between(value, startBound, endBound);

    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : _prev3;
    }

    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop: loop,
        count: count,
        style: style
      }));
      subStart = null;
    }

    _prev3 = i;
    prevValue = value;
  }

  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end: end,
      loop: loop,
      count: count,
      style: style
    }));
  }

  return result;
}

function _boundSegments(line, bounds) {
  var result = [];
  var segments = line.segments;

  for (var i = 0; i < segments.length; i++) {
    var sub = _boundSegment(segments[i], line.points, bounds);

    if (sub.length) {
      result.push.apply(result, _toConsumableArray(sub));
    }
  }

  return result;
}

function findStartAndEnd(points, count, loop, spanGaps) {
  var start = 0;
  var end = count - 1;

  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }

  while (start < count && points[start].skip) {
    start++;
  }

  start %= count;

  if (loop) {
    end += start;
  }

  while (end > start && points[end % count].skip) {
    end--;
  }

  end %= count;
  return {
    start: start,
    end: end
  };
}

function solidSegments(points, start, max, loop) {
  var count = points.length;
  var result = [];
  var last = start;
  var prev = points[start];
  var end;

  for (end = start + 1; end <= max; ++end) {
    var cur = points[end % count];

    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop: loop
        });
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;

      if (prev.skip) {
        start = end;
      }
    }

    prev = cur;
  }

  if (last !== null) {
    result.push({
      start: start % count,
      end: last % count,
      loop: loop
    });
  }

  return result;
}

function _computeSegments(line, segmentOptions) {
  var points = line.points;
  var spanGaps = line.options.spanGaps;
  var count = points.length;

  if (!count) {
    return [];
  }

  var loop = !!line._loop;

  var _findStartAndEnd = findStartAndEnd(points, count, loop, spanGaps),
      start = _findStartAndEnd.start,
      end = _findStartAndEnd.end;

  if (spanGaps === true) {
    return splitByStyles(line, [{
      start: start,
      end: end,
      loop: loop
    }], points, segmentOptions);
  }

  var max = end < start ? end + count : end;
  var completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}

function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }

  return doSplitByStyles(line, segments, points, segmentOptions);
}

function doSplitByStyles(line, segments, points, segmentOptions) {
  var chartContext = line._chart.getContext();

  var baseStyle = readStyle(line.options);
  var datasetIndex = line._datasetIndex,
      spanGaps = line.options.spanGaps;
  var count = points.length;
  var result = [];
  var prevStyle = baseStyle;
  var start = segments[0].start;
  var i = start;

  function addStyle(s, e, l, st) {
    var dir = spanGaps ? -1 : 1;

    if (s === e) {
      return;
    }

    s += count;

    while (points[s % count].skip) {
      s -= dir;
    }

    while (points[e % count].skip) {
      e += dir;
    }

    if (s % count !== e % count) {
      result.push({
        start: s % count,
        end: e % count,
        loop: l,
        style: st
      });
      prevStyle = st;
      start = e % count;
    }
  }

  var _iterator9 = _createForOfIteratorHelper(segments),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var segment = _step9.value;
      start = spanGaps ? start : segment.start;
      var _prev4 = points[start % count];
      var style = void 0;

      for (i = start + 1; i <= segment.end; i++) {
        var pt = points[i % count];
        style = readStyle(segmentOptions.setContext(createContext(chartContext, {
          type: 'segment',
          p0: _prev4,
          p1: pt,
          p0DataIndex: (i - 1) % count,
          p1DataIndex: i % count,
          datasetIndex: datasetIndex
        })));

        if (styleChanged(style, prevStyle)) {
          addStyle(start, i - 1, segment.loop, prevStyle);
        }

        _prev4 = pt;
        prevStyle = style;
      }

      if (start < i - 1) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return result;
}

function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}

function styleChanged(style, prevStyle) {
  return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}
/*!
 * Chart.js v3.8.0
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */


var Animator = /*#__PURE__*/function () {
  function Animator() {
    _classCallCheck(this, Animator);

    this._request = null;
    this._charts = new Map();
    this._running = false;
    this._lastDate = undefined;
  }

  _createClass(Animator, [{
    key: "_notify",
    value: function _notify(chart, anims, date, type) {
      var callbacks = anims.listeners[type];
      var numSteps = anims.duration;
      callbacks.forEach(function (fn) {
        return fn({
          chart: chart,
          initial: anims.initial,
          numSteps: numSteps,
          currentStep: Math.min(date - anims.start, numSteps)
        });
      });
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var _this13 = this;

      if (this._request) {
        return;
      }

      this._running = true;
      this._request = requestAnimFrame.call(window, function () {
        _this13._update();

        _this13._request = null;

        if (_this13._running) {
          _this13._refresh();
        }
      });
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this14 = this;

      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      var remaining = 0;

      this._charts.forEach(function (anims, chart) {
        if (!anims.running || !anims.items.length) {
          return;
        }

        var items = anims.items;
        var i = items.length - 1;
        var draw = false;
        var item;

        for (; i >= 0; --i) {
          item = items[i];

          if (item._active) {
            if (item._total > anims.duration) {
              anims.duration = item._total;
            }

            item.tick(date);
            draw = true;
          } else {
            items[i] = items[items.length - 1];
            items.pop();
          }
        }

        if (draw) {
          chart.draw();

          _this14._notify(chart, anims, date, 'progress');
        }

        if (!items.length) {
          anims.running = false;

          _this14._notify(chart, anims, date, 'complete');

          anims.initial = false;
        }

        remaining += items.length;
      });

      this._lastDate = date;

      if (remaining === 0) {
        this._running = false;
      }
    }
  }, {
    key: "_getAnims",
    value: function _getAnims(chart) {
      var charts = this._charts;
      var anims = charts.get(chart);

      if (!anims) {
        anims = {
          running: false,
          initial: true,
          items: [],
          listeners: {
            complete: [],
            progress: []
          }
        };
        charts.set(chart, anims);
      }

      return anims;
    }
  }, {
    key: "listen",
    value: function listen(chart, event, cb) {
      this._getAnims(chart).listeners[event].push(cb);
    }
  }, {
    key: "add",
    value: function add(chart, items) {
      var _this$_getAnims$items;

      if (!items || !items.length) {
        return;
      }

      (_this$_getAnims$items = this._getAnims(chart).items).push.apply(_this$_getAnims$items, _toConsumableArray(items));
    }
  }, {
    key: "has",
    value: function has(chart) {
      return this._getAnims(chart).items.length > 0;
    }
  }, {
    key: "start",
    value: function start(chart) {
      var anims = this._charts.get(chart);

      if (!anims) {
        return;
      }

      anims.running = true;
      anims.start = Date.now();
      anims.duration = anims.items.reduce(function (acc, cur) {
        return Math.max(acc, cur._duration);
      }, 0);

      this._refresh();
    }
  }, {
    key: "running",
    value: function running(chart) {
      if (!this._running) {
        return false;
      }

      var anims = this._charts.get(chart);

      if (!anims || !anims.running || !anims.items.length) {
        return false;
      }

      return true;
    }
  }, {
    key: "stop",
    value: function stop(chart) {
      var anims = this._charts.get(chart);

      if (!anims || !anims.items.length) {
        return;
      }

      var items = anims.items;
      var i = items.length - 1;

      for (; i >= 0; --i) {
        items[i].cancel();
      }

      anims.items = [];

      this._notify(chart, anims, Date.now(), 'complete');
    }
  }, {
    key: "remove",
    value: function remove(chart) {
      return this._charts["delete"](chart);
    }
  }]);

  return Animator;
}();

var animator = new Animator();
var transparent = 'transparent';
var interpolators = {
  "boolean": function boolean(from, to, factor) {
    return factor > 0.5 ? to : from;
  },
  color: function color(from, to, factor) {
    var c0 = _color(from || transparent);

    var c1 = c0.valid && _color(to || transparent);

    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
  },
  number: function number(from, to, factor) {
    return from + (to - from) * factor;
  }
};

var Animation = /*#__PURE__*/function () {
  function Animation(cfg, target, prop, to) {
    _classCallCheck(this, Animation);

    var currentValue = target[prop];
    to = resolve([cfg.to, to, currentValue, cfg.from]);
    var from = resolve([cfg.from, currentValue, to]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || _typeof(from)];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from;
    this._to = to;
    this._promises = undefined;
  }

  _createClass(Animation, [{
    key: "active",
    value: function active() {
      return this._active;
    }
  }, {
    key: "update",
    value: function update(cfg, to, date) {
      if (this._active) {
        this._notify(false);

        var currentValue = this._target[this._prop];
        var elapsed = date - this._start;
        var remain = this._duration - elapsed;
        this._start = date;
        this._duration = Math.floor(Math.max(remain, cfg.duration));
        this._total += elapsed;
        this._loop = !!cfg.loop;
        this._to = resolve([cfg.to, to, currentValue, cfg.from]);
        this._from = resolve([cfg.from, currentValue, to]);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this._active) {
        this.tick(Date.now());
        this._active = false;

        this._notify(false);
      }
    }
  }, {
    key: "tick",
    value: function tick(date) {
      var elapsed = date - this._start;
      var duration = this._duration;
      var prop = this._prop;
      var from = this._from;
      var loop = this._loop;
      var to = this._to;
      var factor;
      this._active = from !== to && (loop || elapsed < duration);

      if (!this._active) {
        this._target[prop] = to;

        this._notify(true);

        return;
      }

      if (elapsed < 0) {
        this._target[prop] = from;
        return;
      }

      factor = elapsed / duration % 2;
      factor = loop && factor > 1 ? 2 - factor : factor;
      factor = this._easing(Math.min(1, Math.max(0, factor)));
      this._target[prop] = this._fn(from, to, factor);
    }
  }, {
    key: "wait",
    value: function wait() {
      var promises = this._promises || (this._promises = []);
      return new Promise(function (res, rej) {
        promises.push({
          res: res,
          rej: rej
        });
      });
    }
  }, {
    key: "_notify",
    value: function _notify(resolved) {
      var method = resolved ? 'res' : 'rej';
      var promises = this._promises || [];

      for (var i = 0; i < promises.length; i++) {
        promises[i][method]();
      }
    }
  }]);

  return Animation;
}();

var numbers = ['x', 'y', 'borderWidth', 'radius', 'tension'];
var colors = ['color', 'borderColor', 'backgroundColor'];
defaults.set('animation', {
  delay: undefined,
  duration: 1000,
  easing: 'easeOutQuart',
  fn: undefined,
  from: undefined,
  loop: undefined,
  to: undefined,
  type: undefined
});
var animationOptions = Object.keys(defaults.animation);
defaults.describe('animation', {
  _fallback: false,
  _indexable: false,
  _scriptable: function _scriptable(name) {
    return name !== 'onProgress' && name !== 'onComplete' && name !== 'fn';
  }
});
defaults.set('animations', {
  colors: {
    type: 'color',
    properties: colors
  },
  numbers: {
    type: 'number',
    properties: numbers
  }
});
defaults.describe('animations', {
  _fallback: 'animation'
});
defaults.set('transitions', {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: 'transparent'
      },
      visible: {
        type: 'boolean',
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: 'transparent'
      },
      visible: {
        type: 'boolean',
        easing: 'linear',
        fn: function fn(v) {
          return v | 0;
        }
      }
    }
  }
});

var Animations = /*#__PURE__*/function () {
  function Animations(chart, config) {
    _classCallCheck(this, Animations);

    this._chart = chart;
    this._properties = new Map();
    this.configure(config);
  }

  _createClass(Animations, [{
    key: "configure",
    value: function configure(config) {
      if (!isObject(config)) {
        return;
      }

      var animatedProps = this._properties;
      Object.getOwnPropertyNames(config).forEach(function (key) {
        var cfg = config[key];

        if (!isObject(cfg)) {
          return;
        }

        var resolved = {};

        var _iterator10 = _createForOfIteratorHelper(animationOptions),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var option = _step10.value;
            resolved[option] = cfg[option];
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        (isArray(cfg.properties) && cfg.properties || [key]).forEach(function (prop) {
          if (prop === key || !animatedProps.has(prop)) {
            animatedProps.set(prop, resolved);
          }
        });
      });
    }
  }, {
    key: "_animateOptions",
    value: function _animateOptions(target, values) {
      var newOptions = values.options;
      var options = resolveTargetOptions(target, newOptions);

      if (!options) {
        return [];
      }

      var animations = this._createAnimations(options, newOptions);

      if (newOptions.$shared) {
        awaitAll(target.options.$animations, newOptions).then(function () {
          target.options = newOptions;
        }, function () {});
      }

      return animations;
    }
  }, {
    key: "_createAnimations",
    value: function _createAnimations(target, values) {
      var animatedProps = this._properties;
      var animations = [];
      var running = target.$animations || (target.$animations = {});
      var props = Object.keys(values);
      var date = Date.now();
      var i;

      for (i = props.length - 1; i >= 0; --i) {
        var prop = props[i];

        if (prop.charAt(0) === '$') {
          continue;
        }

        if (prop === 'options') {
          animations.push.apply(animations, _toConsumableArray(this._animateOptions(target, values)));
          continue;
        }

        var value = values[prop];
        var animation = running[prop];
        var cfg = animatedProps.get(prop);

        if (animation) {
          if (cfg && animation.active()) {
            animation.update(cfg, value, date);
            continue;
          } else {
            animation.cancel();
          }
        }

        if (!cfg || !cfg.duration) {
          target[prop] = value;
          continue;
        }

        running[prop] = animation = new Animation(cfg, target, prop, value);
        animations.push(animation);
      }

      return animations;
    }
  }, {
    key: "update",
    value: function update(target, values) {
      if (this._properties.size === 0) {
        Object.assign(target, values);
        return;
      }

      var animations = this._createAnimations(target, values);

      if (animations.length) {
        animator.add(this._chart, animations);
        return true;
      }
    }
  }]);

  return Animations;
}();

function awaitAll(animations, properties) {
  var running = [];
  var keys = Object.keys(properties);

  for (var i = 0; i < keys.length; i++) {
    var anim = animations[keys[i]];

    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }

  return Promise.all(running);
}

function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }

  var options = target.options;

  if (!options) {
    target.options = newOptions;
    return;
  }

  if (options.$shared) {
    target.options = options = Object.assign({}, options, {
      $shared: false,
      $animations: {}
    });
  }

  return options;
}

function scaleClip(scale, allowedOverflow) {
  var opts = scale && scale.options || {};
  var reverse = opts.reverse;
  var min = opts.min === undefined ? allowedOverflow : 0;
  var max = opts.max === undefined ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}

function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }

  var x = scaleClip(xScale, allowedOverflow);
  var y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}

function toClip(value) {
  var t, r, b, l;

  if (isObject(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }

  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}

function getSortedDatasetIndices(chart, filterVisible) {
  var keys = [];

  var metasets = chart._getSortedDatasetMetas(filterVisible);

  var i, ilen;

  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }

  return keys;
}

function _applyStack(stack, value, dsIndex) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var keys = stack.keys;
  var singleMode = options.mode === 'single';
  var i, ilen, datasetIndex, otherValue;

  if (value === null) {
    return;
  }

  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];

    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }

      break;
    }

    otherValue = stack.values[datasetIndex];

    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }

  return value;
}

function convertObjectDataToArray(data) {
  var keys = Object.keys(data);
  var adata = new Array(keys.length);
  var i, ilen, key;

  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      x: key,
      y: data[key]
    };
  }

  return adata;
}

function isStacked(scale, meta) {
  var stacked = scale && scale.options.stacked;
  return stacked || stacked === undefined && meta.stack !== undefined;
}

function getStackKey(indexScale, valueScale, meta) {
  return "".concat(indexScale.id, ".").concat(valueScale.id, ".").concat(meta.stack || meta.type);
}

function getUserBounds(scale) {
  var _scale$getUserBounds = scale.getUserBounds(),
      min = _scale$getUserBounds.min,
      max = _scale$getUserBounds.max,
      minDefined = _scale$getUserBounds.minDefined,
      maxDefined = _scale$getUserBounds.maxDefined;

  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}

function getOrCreateStack(stacks, stackKey, indexValue) {
  var subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}

function getLastIndexInStack(stack, vScale, positive, type) {
  var _iterator11 = _createForOfIteratorHelper(vScale.getMatchingVisibleMetas(type).reverse()),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var meta = _step11.value;
      var value = stack[meta.index];

      if (positive && value > 0 || !positive && value < 0) {
        return meta.index;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return null;
}

function updateStacks(controller, parsed) {
  var chart = controller.chart,
      meta = controller._cachedMeta;
  var stacks = chart._stacks || (chart._stacks = {});
  var iScale = meta.iScale,
      vScale = meta.vScale,
      datasetIndex = meta.index;
  var iAxis = iScale.axis;
  var vAxis = vScale.axis;
  var key = getStackKey(iScale, vScale, meta);
  var ilen = parsed.length;
  var stack;

  for (var i = 0; i < ilen; ++i) {
    var item = parsed[i];
    var _index5 = item[iAxis],
        value = item[vAxis];
    var itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, _index5);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
  }
}

function getFirstScaleId(chart, axis) {
  var scales = chart.scales;
  return Object.keys(scales).filter(function (key) {
    return scales[key].axis === axis;
  }).shift();
}

function createDatasetContext(parent, index) {
  return createContext(parent, {
    active: false,
    dataset: undefined,
    datasetIndex: index,
    index: index,
    mode: 'default',
    type: 'dataset'
  });
}

function createDataContext(parent, index, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index,
    parsed: undefined,
    raw: undefined,
    element: element,
    index: index,
    mode: 'default',
    type: 'data'
  });
}

function clearStacks(meta, items) {
  var datasetIndex = meta.controller.index;
  var axis = meta.vScale && meta.vScale.axis;

  if (!axis) {
    return;
  }

  items = items || meta._parsed;

  var _iterator12 = _createForOfIteratorHelper(items),
      _step12;

  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var parsed = _step12.value;
      var stacks = parsed._stacks;

      if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
        return;
      }

      delete stacks[axis][datasetIndex];
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
}

var isDirectUpdateMode = function isDirectUpdateMode(mode) {
  return mode === 'reset' || mode === 'none';
};

var cloneIfNotShared = function cloneIfNotShared(cached, shared) {
  return shared ? cached : Object.assign({}, cached);
};

var createStack = function createStack(canStack, meta, chart) {
  return canStack && !meta.hidden && meta._stacked && {
    keys: getSortedDatasetIndices(chart, true),
    values: null
  };
};

var DatasetController = /*#__PURE__*/function () {
  function DatasetController(chart, datasetIndex) {
    _classCallCheck(this, DatasetController);

    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = undefined;
    this._parsing = false;
    this._data = undefined;
    this._objectData = undefined;
    this._sharedOptions = undefined;
    this._drawStart = undefined;
    this._drawCount = undefined;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = undefined;
    this._syncList = [];
    this.initialize();
  }

  _createClass(DatasetController, [{
    key: "initialize",
    value: function initialize() {
      var meta = this._cachedMeta;
      this.configure();
      this.linkScales();
      meta._stacked = isStacked(meta.vScale, meta);
      this.addElements();
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(datasetIndex) {
      if (this.index !== datasetIndex) {
        clearStacks(this._cachedMeta);
      }

      this.index = datasetIndex;
    }
  }, {
    key: "linkScales",
    value: function linkScales() {
      var chart = this.chart;
      var meta = this._cachedMeta;
      var dataset = this.getDataset();

      var chooseId = function chooseId(axis, x, y, r) {
        return axis === 'x' ? x : axis === 'r' ? r : y;
      };

      var xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
      var yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
      var rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
      var indexAxis = meta.indexAxis;
      var iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
      var vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
      meta.xScale = this.getScaleForId(xid);
      meta.yScale = this.getScaleForId(yid);
      meta.rScale = this.getScaleForId(rid);
      meta.iScale = this.getScaleForId(iid);
      meta.vScale = this.getScaleForId(vid);
    }
  }, {
    key: "getDataset",
    value: function getDataset() {
      return this.chart.data.datasets[this.index];
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      return this.chart.getDatasetMeta(this.index);
    }
  }, {
    key: "getScaleForId",
    value: function getScaleForId(scaleID) {
      return this.chart.scales[scaleID];
    }
  }, {
    key: "_getOtherScale",
    value: function _getOtherScale(scale) {
      var meta = this._cachedMeta;
      return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._update('reset');
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      var meta = this._cachedMeta;

      if (this._data) {
        unlistenArrayEvents(this._data, this);
      }

      if (meta._stacked) {
        clearStacks(meta);
      }
    }
  }, {
    key: "_dataCheck",
    value: function _dataCheck() {
      var dataset = this.getDataset();
      var data = dataset.data || (dataset.data = []);
      var _data = this._data;

      if (isObject(data)) {
        this._data = convertObjectDataToArray(data);
      } else if (_data !== data) {
        if (_data) {
          unlistenArrayEvents(_data, this);
          var meta = this._cachedMeta;
          clearStacks(meta);
          meta._parsed = [];
        }

        if (data && Object.isExtensible(data)) {
          listenArrayEvents(data, this);
        }

        this._syncList = [];
        this._data = data;
      }
    }
  }, {
    key: "addElements",
    value: function addElements() {
      var meta = this._cachedMeta;

      this._dataCheck();

      if (this.datasetElementType) {
        meta.dataset = new this.datasetElementType();
      }
    }
  }, {
    key: "buildOrUpdateElements",
    value: function buildOrUpdateElements(resetNewElements) {
      var meta = this._cachedMeta;
      var dataset = this.getDataset();
      var stackChanged = false;

      this._dataCheck();

      var oldStacked = meta._stacked;
      meta._stacked = isStacked(meta.vScale, meta);

      if (meta.stack !== dataset.stack) {
        stackChanged = true;
        clearStacks(meta);
        meta.stack = dataset.stack;
      }

      this._resyncElements(resetNewElements);

      if (stackChanged || oldStacked !== meta._stacked) {
        updateStacks(this, meta._parsed);
      }
    }
  }, {
    key: "configure",
    value: function configure() {
      var config = this.chart.config;
      var scopeKeys = config.datasetScopeKeys(this._type);
      var scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
      this.options = config.createResolver(scopes, this.getContext());
      this._parsing = this.options.parsing;
      this._cachedDataOpts = {};
    }
  }, {
    key: "parse",
    value: function parse(start, count) {
      var meta = this._cachedMeta,
          data = this._data;
      var iScale = meta.iScale,
          _stacked = meta._stacked;
      var iAxis = iScale.axis;
      var sorted = start === 0 && count === data.length ? true : meta._sorted;
      var prev = start > 0 && meta._parsed[start - 1];
      var i, cur, parsed;

      if (this._parsing === false) {
        meta._parsed = data;
        meta._sorted = true;
        parsed = data;
      } else {
        if (isArray(data[start])) {
          parsed = this.parseArrayData(meta, data, start, count);
        } else if (isObject(data[start])) {
          parsed = this.parseObjectData(meta, data, start, count);
        } else {
          parsed = this.parsePrimitiveData(meta, data, start, count);
        }

        var isNotInOrderComparedToPrev = function isNotInOrderComparedToPrev() {
          return cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
        };

        for (i = 0; i < count; ++i) {
          meta._parsed[i + start] = cur = parsed[i];

          if (sorted) {
            if (isNotInOrderComparedToPrev()) {
              sorted = false;
            }

            prev = cur;
          }
        }

        meta._sorted = sorted;
      }

      if (_stacked) {
        updateStacks(this, parsed);
      }
    }
  }, {
    key: "parsePrimitiveData",
    value: function parsePrimitiveData(meta, data, start, count) {
      var iScale = meta.iScale,
          vScale = meta.vScale;
      var iAxis = iScale.axis;
      var vAxis = vScale.axis;
      var labels = iScale.getLabels();
      var singleScale = iScale === vScale;
      var parsed = new Array(count);
      var i, ilen, index;

      for (i = 0, ilen = count; i < ilen; ++i) {
        var _parsed$i;

        index = i + start;
        parsed[i] = (_parsed$i = {}, _defineProperty2(_parsed$i, iAxis, singleScale || iScale.parse(labels[index], index)), _defineProperty2(_parsed$i, vAxis, vScale.parse(data[index], index)), _parsed$i);
      }

      return parsed;
    }
  }, {
    key: "parseArrayData",
    value: function parseArrayData(meta, data, start, count) {
      var xScale = meta.xScale,
          yScale = meta.yScale;
      var parsed = new Array(count);
      var i, ilen, index, item;

      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i + start;
        item = data[index];
        parsed[i] = {
          x: xScale.parse(item[0], index),
          y: yScale.parse(item[1], index)
        };
      }

      return parsed;
    }
  }, {
    key: "parseObjectData",
    value: function parseObjectData(meta, data, start, count) {
      var xScale = meta.xScale,
          yScale = meta.yScale;
      var _this$_parsing = this._parsing,
          _this$_parsing$xAxisK = _this$_parsing.xAxisKey,
          xAxisKey = _this$_parsing$xAxisK === void 0 ? 'x' : _this$_parsing$xAxisK,
          _this$_parsing$yAxisK = _this$_parsing.yAxisKey,
          yAxisKey = _this$_parsing$yAxisK === void 0 ? 'y' : _this$_parsing$yAxisK;
      var parsed = new Array(count);
      var i, ilen, index, item;

      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i + start;
        item = data[index];
        parsed[i] = {
          x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
          y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
        };
      }

      return parsed;
    }
  }, {
    key: "getParsed",
    value: function getParsed(index) {
      return this._cachedMeta._parsed[index];
    }
  }, {
    key: "getDataElement",
    value: function getDataElement(index) {
      return this._cachedMeta.data[index];
    }
  }, {
    key: "applyStack",
    value: function applyStack(scale, parsed, mode) {
      var chart = this.chart;
      var meta = this._cachedMeta;
      var value = parsed[scale.axis];
      var stack = {
        keys: getSortedDatasetIndices(chart, true),
        values: parsed._stacks[scale.axis]
      };
      return _applyStack(stack, value, meta.index, {
        mode: mode
      });
    }
  }, {
    key: "updateRangeFromParsed",
    value: function updateRangeFromParsed(range, scale, parsed, stack) {
      var parsedValue = parsed[scale.axis];
      var value = parsedValue === null ? NaN : parsedValue;
      var values = stack && parsed._stacks[scale.axis];

      if (stack && values) {
        stack.values = values;
        value = _applyStack(stack, parsedValue, this._cachedMeta.index);
      }

      range.min = Math.min(range.min, value);
      range.max = Math.max(range.max, value);
    }
  }, {
    key: "getMinMax",
    value: function getMinMax(scale, canStack) {
      var meta = this._cachedMeta;
      var _parsed = meta._parsed;
      var sorted = meta._sorted && scale === meta.iScale;
      var ilen = _parsed.length;

      var otherScale = this._getOtherScale(scale);

      var stack = createStack(canStack, meta, this.chart);
      var range = {
        min: Number.POSITIVE_INFINITY,
        max: Number.NEGATIVE_INFINITY
      };

      var _getUserBounds = getUserBounds(otherScale),
          otherMin = _getUserBounds.min,
          otherMax = _getUserBounds.max;

      var i, parsed;

      function _skip() {
        parsed = _parsed[i];
        var otherValue = parsed[otherScale.axis];
        return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
      }

      for (i = 0; i < ilen; ++i) {
        if (_skip()) {
          continue;
        }

        this.updateRangeFromParsed(range, scale, parsed, stack);

        if (sorted) {
          break;
        }
      }

      if (sorted) {
        for (i = ilen - 1; i >= 0; --i) {
          if (_skip()) {
            continue;
          }

          this.updateRangeFromParsed(range, scale, parsed, stack);
          break;
        }
      }

      return range;
    }
  }, {
    key: "getAllParsedValues",
    value: function getAllParsedValues(scale) {
      var parsed = this._cachedMeta._parsed;
      var values = [];
      var i, ilen, value;

      for (i = 0, ilen = parsed.length; i < ilen; ++i) {
        value = parsed[i][scale.axis];

        if (isNumberFinite(value)) {
          values.push(value);
        }
      }

      return values;
    }
  }, {
    key: "getMaxOverflow",
    value: function getMaxOverflow() {
      return false;
    }
  }, {
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var meta = this._cachedMeta;
      var iScale = meta.iScale;
      var vScale = meta.vScale;
      var parsed = this.getParsed(index);
      return {
        label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
        value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
      };
    }
  }, {
    key: "_update",
    value: function _update(mode) {
      var meta = this._cachedMeta;
      this.update(mode || 'default');
      meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
  }, {
    key: "update",
    value: function update(mode) {}
  }, {
    key: "draw",
    value: function draw() {
      var ctx = this._ctx;
      var chart = this.chart;
      var meta = this._cachedMeta;
      var elements = meta.data || [];
      var area = chart.chartArea;
      var active = [];
      var start = this._drawStart || 0;
      var count = this._drawCount || elements.length - start;
      var drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
      var i;

      if (meta.dataset) {
        meta.dataset.draw(ctx, area, start, count);
      }

      for (i = start; i < start + count; ++i) {
        var element = elements[i];

        if (element.hidden) {
          continue;
        }

        if (element.active && drawActiveElementsOnTop) {
          active.push(element);
        } else {
          element.draw(ctx, area);
        }
      }

      for (i = 0; i < active.length; ++i) {
        active[i].draw(ctx, area);
      }
    }
  }, {
    key: "getStyle",
    value: function getStyle(index, active) {
      var mode = active ? 'active' : 'default';
      return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
  }, {
    key: "getContext",
    value: function getContext(index, active, mode) {
      var dataset = this.getDataset();
      var context;

      if (index >= 0 && index < this._cachedMeta.data.length) {
        var element = this._cachedMeta.data[index];
        context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
        context.parsed = this.getParsed(index);
        context.raw = dataset.data[index];
        context.index = context.dataIndex = index;
      } else {
        context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
        context.dataset = dataset;
        context.index = context.datasetIndex = this.index;
      }

      context.active = !!active;
      context.mode = mode;
      return context;
    }
  }, {
    key: "resolveDatasetElementOptions",
    value: function resolveDatasetElementOptions(mode) {
      return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
  }, {
    key: "resolveDataElementOptions",
    value: function resolveDataElementOptions(index, mode) {
      return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
  }, {
    key: "_resolveElementOptions",
    value: function _resolveElementOptions(elementType) {
      var _this15 = this;

      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var active = mode === 'active';
      var cache = this._cachedDataOpts;
      var cacheKey = elementType + '-' + mode;
      var cached = cache[cacheKey];
      var sharing = this.enableOptionSharing && defined(index);

      if (cached) {
        return cloneIfNotShared(cached, sharing);
      }

      var config = this.chart.config;
      var scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
      var prefixes = active ? ["".concat(elementType, "Hover"), 'hover', elementType, ''] : [elementType, ''];
      var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      var names = Object.keys(defaults.elements[elementType]);

      var context = function context() {
        return _this15.getContext(index, active);
      };

      var values = config.resolveNamedOptions(scopes, names, context, prefixes);

      if (values.$shared) {
        values.$shared = sharing;
        cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
      }

      return values;
    }
  }, {
    key: "_resolveAnimations",
    value: function _resolveAnimations(index, transition, active) {
      var chart = this.chart;
      var cache = this._cachedDataOpts;
      var cacheKey = "animation-".concat(transition);
      var cached = cache[cacheKey];

      if (cached) {
        return cached;
      }

      var options;

      if (chart.options.animation !== false) {
        var config = this.chart.config;
        var scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
        var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        options = config.createResolver(scopes, this.getContext(index, active, transition));
      }

      var animations = new Animations(chart, options && options.animations);

      if (options && options._cacheable) {
        cache[cacheKey] = Object.freeze(animations);
      }

      return animations;
    }
  }, {
    key: "getSharedOptions",
    value: function getSharedOptions(options) {
      if (!options.$shared) {
        return;
      }

      return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
  }, {
    key: "includeOptions",
    value: function includeOptions(mode, sharedOptions) {
      return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
  }, {
    key: "updateElement",
    value: function updateElement(element, index, properties, mode) {
      if (isDirectUpdateMode(mode)) {
        Object.assign(element, properties);
      } else {
        this._resolveAnimations(index, mode).update(element, properties);
      }
    }
  }, {
    key: "updateSharedOptions",
    value: function updateSharedOptions(sharedOptions, mode, newOptions) {
      if (sharedOptions && !isDirectUpdateMode(mode)) {
        this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
      }
    }
  }, {
    key: "_setStyle",
    value: function _setStyle(element, index, mode, active) {
      element.active = active;
      var options = this.getStyle(index, active);

      this._resolveAnimations(index, mode, active).update(element, {
        options: !active && this.getSharedOptions(options) || options
      });
    }
  }, {
    key: "removeHoverStyle",
    value: function removeHoverStyle(element, datasetIndex, index) {
      this._setStyle(element, index, 'active', false);
    }
  }, {
    key: "setHoverStyle",
    value: function setHoverStyle(element, datasetIndex, index) {
      this._setStyle(element, index, 'active', true);
    }
  }, {
    key: "_removeDatasetHoverStyle",
    value: function _removeDatasetHoverStyle() {
      var element = this._cachedMeta.dataset;

      if (element) {
        this._setStyle(element, undefined, 'active', false);
      }
    }
  }, {
    key: "_setDatasetHoverStyle",
    value: function _setDatasetHoverStyle() {
      var element = this._cachedMeta.dataset;

      if (element) {
        this._setStyle(element, undefined, 'active', true);
      }
    }
  }, {
    key: "_resyncElements",
    value: function _resyncElements(resetNewElements) {
      var data = this._data;
      var elements = this._cachedMeta.data;

      var _iterator13 = _createForOfIteratorHelper(this._syncList),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _step13$value = _slicedToArray(_step13.value, 3),
              method = _step13$value[0],
              arg1 = _step13$value[1],
              arg2 = _step13$value[2];

          this[method](arg1, arg2);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      this._syncList = [];
      var numMeta = elements.length;
      var numData = data.length;
      var count = Math.min(numData, numMeta);

      if (count) {
        this.parse(0, count);
      }

      if (numData > numMeta) {
        this._insertElements(numMeta, numData - numMeta, resetNewElements);
      } else if (numData < numMeta) {
        this._removeElements(numData, numMeta - numData);
      }
    }
  }, {
    key: "_insertElements",
    value: function _insertElements(start, count) {
      var resetNewElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var meta = this._cachedMeta;
      var data = meta.data;
      var end = start + count;
      var i;

      var move = function move(arr) {
        arr.length += count;

        for (i = arr.length - 1; i >= end; i--) {
          arr[i] = arr[i - count];
        }
      };

      move(data);

      for (i = start; i < end; ++i) {
        data[i] = new this.dataElementType();
      }

      if (this._parsing) {
        move(meta._parsed);
      }

      this.parse(start, count);

      if (resetNewElements) {
        this.updateElements(data, start, count, 'reset');
      }
    }
  }, {
    key: "updateElements",
    value: function updateElements(element, start, count, mode) {}
  }, {
    key: "_removeElements",
    value: function _removeElements(start, count) {
      var meta = this._cachedMeta;

      if (this._parsing) {
        var removed = meta._parsed.splice(start, count);

        if (meta._stacked) {
          clearStacks(meta, removed);
        }
      }

      meta.data.splice(start, count);
    }
  }, {
    key: "_sync",
    value: function _sync(args) {
      if (this._parsing) {
        this._syncList.push(args);
      } else {
        var _args5 = _slicedToArray(args, 3),
            method = _args5[0],
            arg1 = _args5[1],
            arg2 = _args5[2];

        this[method](arg1, arg2);
      }

      this.chart._dataChanges.push([this.index].concat(_toConsumableArray(args)));
    }
  }, {
    key: "_onDataPush",
    value: function _onDataPush() {
      var count = arguments.length;

      this._sync(['_insertElements', this.getDataset().data.length - count, count]);
    }
  }, {
    key: "_onDataPop",
    value: function _onDataPop() {
      this._sync(['_removeElements', this._cachedMeta.data.length - 1, 1]);
    }
  }, {
    key: "_onDataShift",
    value: function _onDataShift() {
      this._sync(['_removeElements', 0, 1]);
    }
  }, {
    key: "_onDataSplice",
    value: function _onDataSplice(start, count) {
      if (count) {
        this._sync(['_removeElements', start, count]);
      }

      var newCount = arguments.length - 2;

      if (newCount) {
        this._sync(['_insertElements', start, newCount]);
      }
    }
  }, {
    key: "_onDataUnshift",
    value: function _onDataUnshift() {
      this._sync(['_insertElements', 0, arguments.length]);
    }
  }]);

  return DatasetController;
}();

DatasetController.defaults = {};
DatasetController.prototype.datasetElementType = null;
DatasetController.prototype.dataElementType = null;

function getAllScaleValues(scale, type) {
  if (!scale._cache.$bar) {
    var visibleMetas = scale.getMatchingVisibleMetas(type);
    var values = [];

    for (var i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
    }

    scale._cache.$bar = _arrayUnique(values.sort(function (a, b) {
      return a - b;
    }));
  }

  return scale._cache.$bar;
}

function computeMinSampleSize(meta) {
  var scale = meta.iScale;
  var values = getAllScaleValues(scale, meta.type);
  var min = scale._length;
  var i, ilen, curr, prev;

  var updateMinAndPrev = function updateMinAndPrev() {
    if (curr === 32767 || curr === -32768) {
      return;
    }

    if (defined(prev)) {
      min = Math.min(min, Math.abs(curr - prev) || min);
    }

    prev = curr;
  };

  for (i = 0, ilen = values.length; i < ilen; ++i) {
    curr = scale.getPixelForValue(values[i]);
    updateMinAndPrev();
  }

  prev = undefined;

  for (i = 0, ilen = scale.ticks.length; i < ilen; ++i) {
    curr = scale.getPixelForTick(i);
    updateMinAndPrev();
  }

  return min;
}

function computeFitCategoryTraits(index, ruler, options, stackCount) {
  var thickness = options.barThickness;
  var size, ratio;

  if (isNullOrUndef(thickness)) {
    size = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size = thickness * stackCount;
    ratio = 1;
  }

  return {
    chunk: size / stackCount,
    ratio: ratio,
    start: ruler.pixels[index] - size / 2
  };
}

function computeFlexCategoryTraits(index, ruler, options, stackCount) {
  var pixels = ruler.pixels;
  var curr = pixels[index];
  var prev = index > 0 ? pixels[index - 1] : null;
  var next = index < pixels.length - 1 ? pixels[index + 1] : null;
  var percent = options.categoryPercentage;

  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }

  if (next === null) {
    next = curr + curr - prev;
  }

  var start = curr - (curr - Math.min(prev, next)) / 2 * percent;
  var size = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size / stackCount,
    ratio: options.barPercentage,
    start: start
  };
}

function parseFloatBar(entry, item, vScale, i) {
  var startValue = vScale.parse(entry[0], i);
  var endValue = vScale.parse(entry[1], i);
  var min = Math.min(startValue, endValue);
  var max = Math.max(startValue, endValue);
  var barStart = min;
  var barEnd = max;

  if (Math.abs(min) > Math.abs(max)) {
    barStart = max;
    barEnd = min;
  }

  item[vScale.axis] = barEnd;
  item._custom = {
    barStart: barStart,
    barEnd: barEnd,
    start: startValue,
    end: endValue,
    min: min,
    max: max
  };
}

function parseValue(entry, item, vScale, i) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }

  return item;
}

function parseArrayOrPrimitive(meta, data, start, count) {
  var iScale = meta.iScale;
  var vScale = meta.vScale;
  var labels = iScale.getLabels();
  var singleScale = iScale === vScale;
  var parsed = [];
  var i, ilen, item, entry;

  for (i = start, ilen = start + count; i < ilen; ++i) {
    entry = data[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }

  return parsed;
}

function isFloatBar(custom) {
  return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}

function barSign(size, vScale, actualBase) {
  if (size !== 0) {
    return sign(size);
  }

  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}

function borderProps(properties) {
  var reverse, start, end, top, bottom;

  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = 'left';
    end = 'right';
  } else {
    reverse = properties.base < properties.y;
    start = 'bottom';
    end = 'top';
  }

  if (reverse) {
    top = 'end';
    bottom = 'start';
  } else {
    top = 'start';
    bottom = 'end';
  }

  return {
    start: start,
    end: end,
    reverse: reverse,
    top: top,
    bottom: bottom
  };
}

function setBorderSkipped(properties, options, stack, index) {
  var edge = options.borderSkipped;
  var res = {};

  if (!edge) {
    properties.borderSkipped = res;
    return;
  }

  var _borderProps = borderProps(properties),
      start = _borderProps.start,
      end = _borderProps.end,
      reverse = _borderProps.reverse,
      top = _borderProps.top,
      bottom = _borderProps.bottom;

  if (edge === 'middle' && stack) {
    properties.enableBorderRadius = true;

    if ((stack._top || 0) === index) {
      edge = top;
    } else if ((stack._bottom || 0) === index) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }

  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}

function parseEdge(edge, a, b, reverse) {
  if (reverse) {
    edge = swap(edge, a, b);
    edge = startEnd(edge, b, a);
  } else {
    edge = startEnd(edge, a, b);
  }

  return edge;
}

function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function startEnd(v, start, end) {
  return v === 'start' ? start : v === 'end' ? end : v;
}

function setInflateAmount(properties, _ref5, ratio) {
  var inflateAmount = _ref5.inflateAmount;
  properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}

var BarController = /*#__PURE__*/function (_DatasetController) {
  _inherits(BarController, _DatasetController);

  var _super3 = _createSuper(BarController);

  function BarController() {
    _classCallCheck(this, BarController);

    return _super3.apply(this, arguments);
  }

  _createClass(BarController, [{
    key: "parsePrimitiveData",
    value: function parsePrimitiveData(meta, data, start, count) {
      return parseArrayOrPrimitive(meta, data, start, count);
    }
  }, {
    key: "parseArrayData",
    value: function parseArrayData(meta, data, start, count) {
      return parseArrayOrPrimitive(meta, data, start, count);
    }
  }, {
    key: "parseObjectData",
    value: function parseObjectData(meta, data, start, count) {
      var iScale = meta.iScale,
          vScale = meta.vScale;
      var _this$_parsing2 = this._parsing,
          _this$_parsing2$xAxis = _this$_parsing2.xAxisKey,
          xAxisKey = _this$_parsing2$xAxis === void 0 ? 'x' : _this$_parsing2$xAxis,
          _this$_parsing2$yAxis = _this$_parsing2.yAxisKey,
          yAxisKey = _this$_parsing2$yAxis === void 0 ? 'y' : _this$_parsing2$yAxis;
      var iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
      var vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
      var parsed = [];
      var i, ilen, item, obj;

      for (i = start, ilen = start + count; i < ilen; ++i) {
        obj = data[i];
        item = {};
        item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
        parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
      }

      return parsed;
    }
  }, {
    key: "updateRangeFromParsed",
    value: function updateRangeFromParsed(range, scale, parsed, stack) {
      _get(_getPrototypeOf(BarController.prototype), "updateRangeFromParsed", this).call(this, range, scale, parsed, stack);

      var custom = parsed._custom;

      if (custom && scale === this._cachedMeta.vScale) {
        range.min = Math.min(range.min, custom.min);
        range.max = Math.max(range.max, custom.max);
      }
    }
  }, {
    key: "getMaxOverflow",
    value: function getMaxOverflow() {
      return 0;
    }
  }, {
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var meta = this._cachedMeta;
      var iScale = meta.iScale,
          vScale = meta.vScale;
      var parsed = this.getParsed(index);
      var custom = parsed._custom;
      var value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
      return {
        label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
        value: value
      };
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.enableOptionSharing = true;

      _get(_getPrototypeOf(BarController.prototype), "initialize", this).call(this);

      var meta = this._cachedMeta;
      meta.stack = this.getDataset().stack;
    }
  }, {
    key: "update",
    value: function update(mode) {
      var meta = this._cachedMeta;
      this.updateElements(meta.data, 0, meta.data.length, mode);
    }
  }, {
    key: "updateElements",
    value: function updateElements(bars, start, count, mode) {
      var reset = mode === 'reset';
      var index = this.index,
          vScale = this._cachedMeta.vScale;
      var base = vScale.getBasePixel();
      var horizontal = vScale.isHorizontal();

      var ruler = this._getRuler();

      var firstOpts = this.resolveDataElementOptions(start, mode);
      var sharedOptions = this.getSharedOptions(firstOpts);
      var includeOptions = this.includeOptions(mode, sharedOptions);
      this.updateSharedOptions(sharedOptions, mode, firstOpts);

      for (var i = start; i < start + count; i++) {
        var parsed = this.getParsed(i);
        var vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
          base: base,
          head: base
        } : this._calculateBarValuePixels(i);

        var ipixels = this._calculateBarIndexPixels(i, ruler);

        var stack = (parsed._stacks || {})[vScale.axis];
        var properties = {
          horizontal: horizontal,
          base: vpixels.base,
          enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
          x: horizontal ? vpixels.head : ipixels.center,
          y: horizontal ? ipixels.center : vpixels.head,
          height: horizontal ? ipixels.size : Math.abs(vpixels.size),
          width: horizontal ? Math.abs(vpixels.size) : ipixels.size
        };

        if (includeOptions) {
          properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
        }

        var options = properties.options || bars[i].options;
        setBorderSkipped(properties, options, stack, index);
        setInflateAmount(properties, options, ruler.ratio);
        this.updateElement(bars[i], i, properties, mode);
      }
    }
  }, {
    key: "_getStacks",
    value: function _getStacks(last, dataIndex) {
      var meta = this._cachedMeta;
      var iScale = meta.iScale;
      var metasets = iScale.getMatchingVisibleMetas(this._type);
      var stacked = iScale.options.stacked;
      var ilen = metasets.length;
      var stacks = [];
      var i, item;

      for (i = 0; i < ilen; ++i) {
        item = metasets[i];

        if (!item.controller.options.grouped) {
          continue;
        }

        if (typeof dataIndex !== 'undefined') {
          var val = item.controller.getParsed(dataIndex)[item.controller._cachedMeta.vScale.axis];

          if (isNullOrUndef(val) || isNaN(val)) {
            continue;
          }
        }

        if (stacked === false || stacks.indexOf(item.stack) === -1 || stacked === undefined && item.stack === undefined) {
          stacks.push(item.stack);
        }

        if (item.index === last) {
          break;
        }
      }

      if (!stacks.length) {
        stacks.push(undefined);
      }

      return stacks;
    }
  }, {
    key: "_getStackCount",
    value: function _getStackCount(index) {
      return this._getStacks(undefined, index).length;
    }
  }, {
    key: "_getStackIndex",
    value: function _getStackIndex(datasetIndex, name, dataIndex) {
      var stacks = this._getStacks(datasetIndex, dataIndex);

      var index = name !== undefined ? stacks.indexOf(name) : -1;
      return index === -1 ? stacks.length - 1 : index;
    }
  }, {
    key: "_getRuler",
    value: function _getRuler() {
      var opts = this.options;
      var meta = this._cachedMeta;
      var iScale = meta.iScale;
      var pixels = [];
      var i, ilen;

      for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
        pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
      }

      var barThickness = opts.barThickness;
      var min = barThickness || computeMinSampleSize(meta);
      return {
        min: min,
        pixels: pixels,
        start: iScale._startPixel,
        end: iScale._endPixel,
        stackCount: this._getStackCount(),
        scale: iScale,
        grouped: opts.grouped,
        ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
      };
    }
  }, {
    key: "_calculateBarValuePixels",
    value: function _calculateBarValuePixels(index) {
      var _this$_cachedMeta = this._cachedMeta,
          vScale = _this$_cachedMeta.vScale,
          _stacked = _this$_cachedMeta._stacked,
          _this$options = this.options,
          baseValue = _this$options.base,
          minBarLength = _this$options.minBarLength;
      var actualBase = baseValue || 0;
      var parsed = this.getParsed(index);
      var custom = parsed._custom;
      var floating = isFloatBar(custom);
      var value = parsed[vScale.axis];
      var start = 0;
      var length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
      var head, size;

      if (length !== value) {
        start = length - value;
        length = value;
      }

      if (floating) {
        value = custom.barStart;
        length = custom.barEnd - custom.barStart;

        if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
          start = 0;
        }

        start += value;
      }

      var startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
      var base = vScale.getPixelForValue(startValue);

      if (this.chart.getDataVisibility(index)) {
        head = vScale.getPixelForValue(start + length);
      } else {
        head = base;
      }

      size = head - base;

      if (Math.abs(size) < minBarLength) {
        size = barSign(size, vScale, actualBase) * minBarLength;

        if (value === actualBase) {
          base -= size / 2;
        }

        var startPixel = vScale.getPixelForDecimal(0);
        var endPixel = vScale.getPixelForDecimal(1);
        var min = Math.min(startPixel, endPixel);
        var max = Math.max(startPixel, endPixel);
        base = Math.max(Math.min(base, max), min);
        head = base + size;
      }

      if (base === vScale.getPixelForValue(actualBase)) {
        var halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
        base += halfGrid;
        size -= halfGrid;
      }

      return {
        size: size,
        base: base,
        head: head,
        center: head + size / 2
      };
    }
  }, {
    key: "_calculateBarIndexPixels",
    value: function _calculateBarIndexPixels(index, ruler) {
      var scale = ruler.scale;
      var options = this.options;
      var skipNull = options.skipNull;
      var maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
      var center, size;

      if (ruler.grouped) {
        var stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);

        var stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);

        center = range.start + range.chunk * stackIndex + range.chunk / 2;
        size = Math.min(maxBarThickness, range.chunk * range.ratio);
      } else {
        center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
        size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
      }

      return {
        base: center - size / 2,
        head: center + size / 2,
        center: center,
        size: size
      };
    }
  }, {
    key: "draw",
    value: function draw() {
      var meta = this._cachedMeta;
      var vScale = meta.vScale;
      var rects = meta.data;
      var ilen = rects.length;
      var i = 0;

      for (; i < ilen; ++i) {
        if (this.getParsed(i)[vScale.axis] !== null) {
          rects[i].draw(this._ctx);
        }
      }
    }
  }]);

  return BarController;
}(DatasetController);

BarController.id = 'bar';
BarController.defaults = {
  datasetElementType: false,
  dataElementType: 'bar',
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'base', 'width', 'height']
    }
  }
};
BarController.overrides = {
  scales: {
    _index_: {
      type: 'category',
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: 'linear',
      beginAtZero: true
    }
  }
};

var BubbleController = /*#__PURE__*/function (_DatasetController2) {
  _inherits(BubbleController, _DatasetController2);

  var _super4 = _createSuper(BubbleController);

  function BubbleController() {
    _classCallCheck(this, BubbleController);

    return _super4.apply(this, arguments);
  }

  _createClass(BubbleController, [{
    key: "initialize",
    value: function initialize() {
      this.enableOptionSharing = true;

      _get(_getPrototypeOf(BubbleController.prototype), "initialize", this).call(this);
    }
  }, {
    key: "parsePrimitiveData",
    value: function parsePrimitiveData(meta, data, start, count) {
      var parsed = _get(_getPrototypeOf(BubbleController.prototype), "parsePrimitiveData", this).call(this, meta, data, start, count);

      for (var i = 0; i < parsed.length; i++) {
        parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
      }

      return parsed;
    }
  }, {
    key: "parseArrayData",
    value: function parseArrayData(meta, data, start, count) {
      var parsed = _get(_getPrototypeOf(BubbleController.prototype), "parseArrayData", this).call(this, meta, data, start, count);

      for (var i = 0; i < parsed.length; i++) {
        var item = data[start + i];
        parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
      }

      return parsed;
    }
  }, {
    key: "parseObjectData",
    value: function parseObjectData(meta, data, start, count) {
      var parsed = _get(_getPrototypeOf(BubbleController.prototype), "parseObjectData", this).call(this, meta, data, start, count);

      for (var i = 0; i < parsed.length; i++) {
        var item = data[start + i];
        parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
      }

      return parsed;
    }
  }, {
    key: "getMaxOverflow",
    value: function getMaxOverflow() {
      var data = this._cachedMeta.data;
      var max = 0;

      for (var i = data.length - 1; i >= 0; --i) {
        max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
      }

      return max > 0 && max;
    }
  }, {
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var meta = this._cachedMeta;
      var xScale = meta.xScale,
          yScale = meta.yScale;
      var parsed = this.getParsed(index);
      var x = xScale.getLabelForValue(parsed.x);
      var y = yScale.getLabelForValue(parsed.y);
      var r = parsed._custom;
      return {
        label: meta.label,
        value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
      };
    }
  }, {
    key: "update",
    value: function update(mode) {
      var points = this._cachedMeta.data;
      this.updateElements(points, 0, points.length, mode);
    }
  }, {
    key: "updateElements",
    value: function updateElements(points, start, count, mode) {
      var reset = mode === 'reset';
      var _this$_cachedMeta2 = this._cachedMeta,
          iScale = _this$_cachedMeta2.iScale,
          vScale = _this$_cachedMeta2.vScale;
      var firstOpts = this.resolveDataElementOptions(start, mode);
      var sharedOptions = this.getSharedOptions(firstOpts);
      var includeOptions = this.includeOptions(mode, sharedOptions);
      var iAxis = iScale.axis;
      var vAxis = vScale.axis;

      for (var i = start; i < start + count; i++) {
        var point = points[i];
        var parsed = !reset && this.getParsed(i);
        var properties = {};
        var iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
        var vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
        properties.skip = isNaN(iPixel) || isNaN(vPixel);

        if (includeOptions) {
          properties.options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);

          if (reset) {
            properties.options.radius = 0;
          }
        }

        this.updateElement(point, i, properties, mode);
      }

      this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
  }, {
    key: "resolveDataElementOptions",
    value: function resolveDataElementOptions(index, mode) {
      var parsed = this.getParsed(index);

      var values = _get(_getPrototypeOf(BubbleController.prototype), "resolveDataElementOptions", this).call(this, index, mode);

      if (values.$shared) {
        values = Object.assign({}, values, {
          $shared: false
        });
      }

      var radius = values.radius;

      if (mode !== 'active') {
        values.radius = 0;
      }

      values.radius += valueOrDefault(parsed && parsed._custom, radius);
      return values;
    }
  }]);

  return BubbleController;
}(DatasetController);

BubbleController.id = 'bubble';
BubbleController.defaults = {
  datasetElementType: false,
  dataElementType: 'point',
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'borderWidth', 'radius']
    }
  }
};
BubbleController.overrides = {
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title: function title() {
          return '';
        }
      }
    }
  }
};

function getRatioAndOffset(rotation, circumference, cutout) {
  var ratioX = 1;
  var ratioY = 1;
  var offsetX = 0;
  var offsetY = 0;

  if (circumference < TAU) {
    var startAngle = rotation;
    var endAngle = startAngle + circumference;
    var startX = Math.cos(startAngle);
    var startY = Math.sin(startAngle);
    var endX = Math.cos(endAngle);
    var endY = Math.sin(endAngle);

    var calcMax = function calcMax(angle, a, b) {
      return _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
    };

    var calcMin = function calcMin(angle, a, b) {
      return _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
    };

    var maxX = calcMax(0, startX, endX);
    var maxY = calcMax(HALF_PI, startY, endY);
    var minX = calcMin(PI, startX, endX);
    var minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }

  return {
    ratioX: ratioX,
    ratioY: ratioY,
    offsetX: offsetX,
    offsetY: offsetY
  };
}

var DoughnutController = /*#__PURE__*/function (_DatasetController3) {
  _inherits(DoughnutController, _DatasetController3);

  var _super5 = _createSuper(DoughnutController);

  function DoughnutController(chart, datasetIndex) {
    var _this16;

    _classCallCheck(this, DoughnutController);

    _this16 = _super5.call(this, chart, datasetIndex);
    _this16.enableOptionSharing = true;
    _this16.innerRadius = undefined;
    _this16.outerRadius = undefined;
    _this16.offsetX = undefined;
    _this16.offsetY = undefined;
    return _this16;
  }

  _createClass(DoughnutController, [{
    key: "linkScales",
    value: function linkScales() {}
  }, {
    key: "parse",
    value: function parse(start, count) {
      var data = this.getDataset().data;
      var meta = this._cachedMeta;

      if (this._parsing === false) {
        meta._parsed = data;
      } else {
        var getter = function getter(i) {
          return +data[i];
        };

        if (isObject(data[start])) {
          var _this$_parsing$key2 = this._parsing.key,
              key = _this$_parsing$key2 === void 0 ? 'value' : _this$_parsing$key2;

          getter = function getter(i) {
            return +resolveObjectKey(data[i], key);
          };
        }

        var i, ilen;

        for (i = start, ilen = start + count; i < ilen; ++i) {
          meta._parsed[i] = getter(i);
        }
      }
    }
  }, {
    key: "_getRotation",
    value: function _getRotation() {
      return toRadians(this.options.rotation - 90);
    }
  }, {
    key: "_getCircumference",
    value: function _getCircumference() {
      return toRadians(this.options.circumference);
    }
  }, {
    key: "_getRotationExtents",
    value: function _getRotationExtents() {
      var min = TAU;
      var max = -TAU;

      for (var i = 0; i < this.chart.data.datasets.length; ++i) {
        if (this.chart.isDatasetVisible(i)) {
          var controller = this.chart.getDatasetMeta(i).controller;

          var rotation = controller._getRotation();

          var circumference = controller._getCircumference();

          min = Math.min(min, rotation);
          max = Math.max(max, rotation + circumference);
        }
      }

      return {
        rotation: min,
        circumference: max - min
      };
    }
  }, {
    key: "update",
    value: function update(mode) {
      var chart = this.chart;
      var chartArea = chart.chartArea;
      var meta = this._cachedMeta;
      var arcs = meta.data;
      var spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
      var maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
      var cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);

      var chartWeight = this._getRingWeight(this.index);

      var _this$_getRotationExt = this._getRotationExtents(),
          circumference = _this$_getRotationExt.circumference,
          rotation = _this$_getRotationExt.rotation;

      var _getRatioAndOffset = getRatioAndOffset(rotation, circumference, cutout),
          ratioX = _getRatioAndOffset.ratioX,
          ratioY = _getRatioAndOffset.ratioY,
          offsetX = _getRatioAndOffset.offsetX,
          offsetY = _getRatioAndOffset.offsetY;

      var maxWidth = (chartArea.width - spacing) / ratioX;
      var maxHeight = (chartArea.height - spacing) / ratioY;
      var maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
      var outerRadius = toDimension(this.options.radius, maxRadius);
      var innerRadius = Math.max(outerRadius * cutout, 0);

      var radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();

      this.offsetX = offsetX * outerRadius;
      this.offsetY = offsetY * outerRadius;
      meta.total = this.calculateTotal();
      this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
      this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
      this.updateElements(arcs, 0, arcs.length, mode);
    }
  }, {
    key: "_circumference",
    value: function _circumference(i, reset) {
      var opts = this.options;
      var meta = this._cachedMeta;

      var circumference = this._getCircumference();

      if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
        return 0;
      }

      return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
    }
  }, {
    key: "updateElements",
    value: function updateElements(arcs, start, count, mode) {
      var reset = mode === 'reset';
      var chart = this.chart;
      var chartArea = chart.chartArea;
      var opts = chart.options;
      var animationOpts = opts.animation;
      var centerX = (chartArea.left + chartArea.right) / 2;
      var centerY = (chartArea.top + chartArea.bottom) / 2;
      var animateScale = reset && animationOpts.animateScale;
      var innerRadius = animateScale ? 0 : this.innerRadius;
      var outerRadius = animateScale ? 0 : this.outerRadius;
      var firstOpts = this.resolveDataElementOptions(start, mode);
      var sharedOptions = this.getSharedOptions(firstOpts);
      var includeOptions = this.includeOptions(mode, sharedOptions);

      var startAngle = this._getRotation();

      var i;

      for (i = 0; i < start; ++i) {
        startAngle += this._circumference(i, reset);
      }

      for (i = start; i < start + count; ++i) {
        var circumference = this._circumference(i, reset);

        var arc = arcs[i];
        var properties = {
          x: centerX + this.offsetX,
          y: centerY + this.offsetY,
          startAngle: startAngle,
          endAngle: startAngle + circumference,
          circumference: circumference,
          outerRadius: outerRadius,
          innerRadius: innerRadius
        };

        if (includeOptions) {
          properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
        }

        startAngle += circumference;
        this.updateElement(arc, i, properties, mode);
      }

      this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var meta = this._cachedMeta;
      var metaData = meta.data;
      var total = 0;
      var i;

      for (i = 0; i < metaData.length; i++) {
        var value = meta._parsed[i];

        if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
          total += Math.abs(value);
        }
      }

      return total;
    }
  }, {
    key: "calculateCircumference",
    value: function calculateCircumference(value) {
      var total = this._cachedMeta.total;

      if (total > 0 && !isNaN(value)) {
        return TAU * (Math.abs(value) / total);
      }

      return 0;
    }
  }, {
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var meta = this._cachedMeta;
      var chart = this.chart;
      var labels = chart.data.labels || [];
      var value = formatNumber(meta._parsed[index], chart.options.locale);
      return {
        label: labels[index] || '',
        value: value
      };
    }
  }, {
    key: "getMaxBorderWidth",
    value: function getMaxBorderWidth(arcs) {
      var max = 0;
      var chart = this.chart;
      var i, ilen, meta, controller, options;

      if (!arcs) {
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            arcs = meta.data;
            controller = meta.controller;
            break;
          }
        }
      }

      if (!arcs) {
        return 0;
      }

      for (i = 0, ilen = arcs.length; i < ilen; ++i) {
        options = controller.resolveDataElementOptions(i);

        if (options.borderAlign !== 'inner') {
          max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
      }

      return max;
    }
  }, {
    key: "getMaxOffset",
    value: function getMaxOffset(arcs) {
      var max = 0;

      for (var i = 0, ilen = arcs.length; i < ilen; ++i) {
        var options = this.resolveDataElementOptions(i);
        max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
      }

      return max;
    }
  }, {
    key: "_getRingWeightOffset",
    value: function _getRingWeightOffset(datasetIndex) {
      var ringWeightOffset = 0;

      for (var i = 0; i < datasetIndex; ++i) {
        if (this.chart.isDatasetVisible(i)) {
          ringWeightOffset += this._getRingWeight(i);
        }
      }

      return ringWeightOffset;
    }
  }, {
    key: "_getRingWeight",
    value: function _getRingWeight(datasetIndex) {
      return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
  }, {
    key: "_getVisibleDatasetWeightTotal",
    value: function _getVisibleDatasetWeightTotal() {
      return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
  }]);

  return DoughnutController;
}(DatasetController);

DoughnutController.id = 'doughnut';
DoughnutController.defaults = {
  datasetElementType: false,
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['circumference', 'endAngle', 'innerRadius', 'outerRadius', 'startAngle', 'x', 'y', 'offset', 'borderWidth', 'spacing']
    }
  },
  cutout: '50%',
  rotation: 0,
  circumference: 360,
  radius: '100%',
  spacing: 0,
  indexAxis: 'r'
};
DoughnutController.descriptors = {
  _scriptable: function _scriptable(name) {
    return name !== 'spacing';
  },
  _indexable: function _indexable(name) {
    return name !== 'spacing';
  }
};
DoughnutController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels: function generateLabels(chart) {
          var data = chart.data;

          if (data.labels.length && data.datasets.length) {
            var pointStyle = chart.legend.options.labels.pointStyle;
            return data.labels.map(function (label, i) {
              var meta = chart.getDatasetMeta(0);
              var style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }

          return [];
        }
      },
      onClick: function onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title: function title() {
          return '';
        },
        label: function label(tooltipItem) {
          var dataLabel = tooltipItem.label;
          var value = ': ' + tooltipItem.formattedValue;

          if (isArray(dataLabel)) {
            dataLabel = dataLabel.slice();
            dataLabel[0] += value;
          } else {
            dataLabel += value;
          }

          return dataLabel;
        }
      }
    }
  }
};

var LineController = /*#__PURE__*/function (_DatasetController4) {
  _inherits(LineController, _DatasetController4);

  var _super6 = _createSuper(LineController);

  function LineController() {
    _classCallCheck(this, LineController);

    return _super6.apply(this, arguments);
  }

  _createClass(LineController, [{
    key: "initialize",
    value: function initialize() {
      this.enableOptionSharing = true;
      this.supportsDecimation = true;

      _get(_getPrototypeOf(LineController.prototype), "initialize", this).call(this);
    }
  }, {
    key: "update",
    value: function update(mode) {
      var meta = this._cachedMeta;
      var line = meta.dataset,
          _meta$data = meta.data,
          points = _meta$data === void 0 ? [] : _meta$data,
          _dataset = meta._dataset;
      var animationsDisabled = this.chart._animationsDisabled;

      var _getStartAndCountOfVi = getStartAndCountOfVisiblePoints(meta, points, animationsDisabled),
          start = _getStartAndCountOfVi.start,
          count = _getStartAndCountOfVi.count;

      this._drawStart = start;
      this._drawCount = count;

      if (scaleRangesChanged(meta)) {
        start = 0;
        count = points.length;
      }

      line._chart = this.chart;
      line._datasetIndex = this.index;
      line._decimated = !!_dataset._decimated;
      line.points = points;
      var options = this.resolveDatasetElementOptions(mode);

      if (!this.options.showLine) {
        options.borderWidth = 0;
      }

      options.segment = this.options.segment;
      this.updateElement(line, undefined, {
        animated: !animationsDisabled,
        options: options
      }, mode);
      this.updateElements(points, start, count, mode);
    }
  }, {
    key: "updateElements",
    value: function updateElements(points, start, count, mode) {
      var reset = mode === 'reset';
      var _this$_cachedMeta3 = this._cachedMeta,
          iScale = _this$_cachedMeta3.iScale,
          vScale = _this$_cachedMeta3.vScale,
          _stacked = _this$_cachedMeta3._stacked,
          _dataset = _this$_cachedMeta3._dataset;
      var firstOpts = this.resolveDataElementOptions(start, mode);
      var sharedOptions = this.getSharedOptions(firstOpts);
      var includeOptions = this.includeOptions(mode, sharedOptions);
      var iAxis = iScale.axis;
      var vAxis = vScale.axis;
      var _this$options2 = this.options,
          spanGaps = _this$options2.spanGaps,
          segment = _this$options2.segment;
      var maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
      var directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
      var prevParsed = start > 0 && this.getParsed(start - 1);

      for (var i = start; i < start + count; ++i) {
        var point = points[i];
        var parsed = this.getParsed(i);
        var properties = directUpdate ? point : {};
        var nullData = isNullOrUndef(parsed[vAxis]);
        var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
        var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
        properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
        properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;

        if (segment) {
          properties.parsed = parsed;
          properties.raw = _dataset.data[i];
        }

        if (includeOptions) {
          properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
        }

        if (!directUpdate) {
          this.updateElement(point, i, properties, mode);
        }

        prevParsed = parsed;
      }

      this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
  }, {
    key: "getMaxOverflow",
    value: function getMaxOverflow() {
      var meta = this._cachedMeta;
      var dataset = meta.dataset;
      var border = dataset.options && dataset.options.borderWidth || 0;
      var data = meta.data || [];

      if (!data.length) {
        return border;
      }

      var firstPoint = data[0].size(this.resolveDataElementOptions(0));
      var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
      return Math.max(border, firstPoint, lastPoint) / 2;
    }
  }, {
    key: "draw",
    value: function draw() {
      var meta = this._cachedMeta;
      meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);

      _get(_getPrototypeOf(LineController.prototype), "draw", this).call(this);
    }
  }]);

  return LineController;
}(DatasetController);

LineController.id = 'line';
LineController.defaults = {
  datasetElementType: 'line',
  dataElementType: 'point',
  showLine: true,
  spanGaps: false
};
LineController.overrides = {
  scales: {
    _index_: {
      type: 'category'
    },
    _value_: {
      type: 'linear'
    }
  }
};

function getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  var pointCount = points.length;
  var start = 0;
  var count = pointCount;

  if (meta._sorted) {
    var iScale = meta.iScale,
        _parsed = meta._parsed;
    var axis = iScale.axis;

    var _iScale$getUserBounds = iScale.getUserBounds(),
        min = _iScale$getUserBounds.min,
        max = _iScale$getUserBounds.max,
        minDefined = _iScale$getUserBounds.minDefined,
        maxDefined = _iScale$getUserBounds.maxDefined;

    if (minDefined) {
      start = _limitValue(Math.min(_lookupByKey(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
    }

    if (maxDefined) {
      count = _limitValue(Math.max(_lookupByKey(_parsed, iScale.axis, max).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max)).hi + 1), start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }

  return {
    start: start,
    count: count
  };
}

function scaleRangesChanged(meta) {
  var xScale = meta.xScale,
      yScale = meta.yScale,
      _scaleRanges = meta._scaleRanges;
  var newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };

  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }

  var changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}

var PolarAreaController = /*#__PURE__*/function (_DatasetController5) {
  _inherits(PolarAreaController, _DatasetController5);

  var _super7 = _createSuper(PolarAreaController);

  function PolarAreaController(chart, datasetIndex) {
    var _this17;

    _classCallCheck(this, PolarAreaController);

    _this17 = _super7.call(this, chart, datasetIndex);
    _this17.innerRadius = undefined;
    _this17.outerRadius = undefined;
    return _this17;
  }

  _createClass(PolarAreaController, [{
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var meta = this._cachedMeta;
      var chart = this.chart;
      var labels = chart.data.labels || [];
      var value = formatNumber(meta._parsed[index].r, chart.options.locale);
      return {
        label: labels[index] || '',
        value: value
      };
    }
  }, {
    key: "parseObjectData",
    value: function parseObjectData(meta, data, start, count) {
      return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
  }, {
    key: "update",
    value: function update(mode) {
      var arcs = this._cachedMeta.data;

      this._updateRadius();

      this.updateElements(arcs, 0, arcs.length, mode);
    }
  }, {
    key: "getMinMax",
    value: function getMinMax() {
      var _this18 = this;

      var meta = this._cachedMeta;
      var range = {
        min: Number.POSITIVE_INFINITY,
        max: Number.NEGATIVE_INFINITY
      };
      meta.data.forEach(function (element, index) {
        var parsed = _this18.getParsed(index).r;

        if (!isNaN(parsed) && _this18.chart.getDataVisibility(index)) {
          if (parsed < range.min) {
            range.min = parsed;
          }

          if (parsed > range.max) {
            range.max = parsed;
          }
        }
      });
      return range;
    }
  }, {
    key: "_updateRadius",
    value: function _updateRadius() {
      var chart = this.chart;
      var chartArea = chart.chartArea;
      var opts = chart.options;
      var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
      var outerRadius = Math.max(minSize / 2, 0);
      var innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
      var radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
      this.outerRadius = outerRadius - radiusLength * this.index;
      this.innerRadius = this.outerRadius - radiusLength;
    }
  }, {
    key: "updateElements",
    value: function updateElements(arcs, start, count, mode) {
      var reset = mode === 'reset';
      var chart = this.chart;
      var opts = chart.options;
      var animationOpts = opts.animation;
      var scale = this._cachedMeta.rScale;
      var centerX = scale.xCenter;
      var centerY = scale.yCenter;
      var datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
      var angle = datasetStartAngle;
      var i;
      var defaultAngle = 360 / this.countVisibleElements();

      for (i = 0; i < start; ++i) {
        angle += this._computeAngle(i, mode, defaultAngle);
      }

      for (i = start; i < start + count; i++) {
        var arc = arcs[i];
        var startAngle = angle;

        var endAngle = angle + this._computeAngle(i, mode, defaultAngle);

        var outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
        angle = endAngle;

        if (reset) {
          if (animationOpts.animateScale) {
            outerRadius = 0;
          }

          if (animationOpts.animateRotate) {
            startAngle = endAngle = datasetStartAngle;
          }
        }

        var properties = {
          x: centerX,
          y: centerY,
          innerRadius: 0,
          outerRadius: outerRadius,
          startAngle: startAngle,
          endAngle: endAngle,
          options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
        };
        this.updateElement(arc, i, properties, mode);
      }
    }
  }, {
    key: "countVisibleElements",
    value: function countVisibleElements() {
      var _this19 = this;

      var meta = this._cachedMeta;
      var count = 0;
      meta.data.forEach(function (element, index) {
        if (!isNaN(_this19.getParsed(index).r) && _this19.chart.getDataVisibility(index)) {
          count++;
        }
      });
      return count;
    }
  }, {
    key: "_computeAngle",
    value: function _computeAngle(index, mode, defaultAngle) {
      return this.chart.getDataVisibility(index) ? toRadians(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
  }]);

  return PolarAreaController;
}(DatasetController);

PolarAreaController.id = 'polarArea';
PolarAreaController.defaults = {
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius']
    }
  },
  indexAxis: 'r',
  startAngle: 0
};
PolarAreaController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels: function generateLabels(chart) {
          var data = chart.data;

          if (data.labels.length && data.datasets.length) {
            var pointStyle = chart.legend.options.labels.pointStyle;
            return data.labels.map(function (label, i) {
              var meta = chart.getDatasetMeta(0);
              var style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }

          return [];
        }
      },
      onClick: function onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title: function title() {
          return '';
        },
        label: function label(context) {
          return context.chart.data.labels[context.dataIndex] + ': ' + context.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: 'radialLinear',
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
};

var PieController = /*#__PURE__*/function (_DoughnutController) {
  _inherits(PieController, _DoughnutController);

  var _super8 = _createSuper(PieController);

  function PieController() {
    _classCallCheck(this, PieController);

    return _super8.apply(this, arguments);
  }

  return PieController;
}(DoughnutController);

PieController.id = 'pie';
PieController.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: '100%'
};

var RadarController = /*#__PURE__*/function (_DatasetController6) {
  _inherits(RadarController, _DatasetController6);

  var _super9 = _createSuper(RadarController);

  function RadarController() {
    _classCallCheck(this, RadarController);

    return _super9.apply(this, arguments);
  }

  _createClass(RadarController, [{
    key: "getLabelAndValue",
    value: function getLabelAndValue(index) {
      var vScale = this._cachedMeta.vScale;
      var parsed = this.getParsed(index);
      return {
        label: vScale.getLabels()[index],
        value: '' + vScale.getLabelForValue(parsed[vScale.axis])
      };
    }
  }, {
    key: "parseObjectData",
    value: function parseObjectData(meta, data, start, count) {
      return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
  }, {
    key: "update",
    value: function update(mode) {
      var meta = this._cachedMeta;
      var line = meta.dataset;
      var points = meta.data || [];
      var labels = meta.iScale.getLabels();
      line.points = points;

      if (mode !== 'resize') {
        var options = this.resolveDatasetElementOptions(mode);

        if (!this.options.showLine) {
          options.borderWidth = 0;
        }

        var properties = {
          _loop: true,
          _fullLoop: labels.length === points.length,
          options: options
        };
        this.updateElement(line, undefined, properties, mode);
      }

      this.updateElements(points, 0, points.length, mode);
    }
  }, {
    key: "updateElements",
    value: function updateElements(points, start, count, mode) {
      var scale = this._cachedMeta.rScale;
      var reset = mode === 'reset';

      for (var i = start; i < start + count; i++) {
        var point = points[i];
        var options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
        var pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        var properties = {
          x: x,
          y: y,
          angle: pointPosition.angle,
          skip: isNaN(x) || isNaN(y),
          options: options
        };
        this.updateElement(point, i, properties, mode);
      }
    }
  }]);

  return RadarController;
}(DatasetController);

RadarController.id = 'radar';
RadarController.defaults = {
  datasetElementType: 'line',
  dataElementType: 'point',
  indexAxis: 'r',
  showLine: true,
  elements: {
    line: {
      fill: 'start'
    }
  }
};
RadarController.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: 'radialLinear'
    }
  }
};

var ScatterController = /*#__PURE__*/function (_LineController) {
  _inherits(ScatterController, _LineController);

  var _super10 = _createSuper(ScatterController);

  function ScatterController() {
    _classCallCheck(this, ScatterController);

    return _super10.apply(this, arguments);
  }

  return ScatterController;
}(LineController);

ScatterController.id = 'scatter';
ScatterController.defaults = {
  showLine: false,
  fill: false
};
ScatterController.overrides = {
  interaction: {
    mode: 'point'
  },
  plugins: {
    tooltip: {
      callbacks: {
        title: function title() {
          return '';
        },
        label: function label(item) {
          return '(' + item.label + ', ' + item.formattedValue + ')';
        }
      }
    }
  },
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  }
};
var controllers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BarController: BarController,
  BubbleController: BubbleController,
  DoughnutController: DoughnutController,
  LineController: LineController,
  PolarAreaController: PolarAreaController,
  PieController: PieController,
  RadarController: RadarController,
  ScatterController: ScatterController
});

function _abstract() {
  throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}

var DateAdapter = /*#__PURE__*/function () {
  function DateAdapter(options) {
    _classCallCheck(this, DateAdapter);

    this.options = options || {};
  }

  _createClass(DateAdapter, [{
    key: "formats",
    value: function formats() {
      return _abstract();
    }
  }, {
    key: "parse",
    value: function parse(value, format) {
      return _abstract();
    }
  }, {
    key: "format",
    value: function format(timestamp, _format2) {
      return _abstract();
    }
  }, {
    key: "add",
    value: function add(timestamp, amount, unit) {
      return _abstract();
    }
  }, {
    key: "diff",
    value: function diff(a, b, unit) {
      return _abstract();
    }
  }, {
    key: "startOf",
    value: function startOf(timestamp, unit, weekday) {
      return _abstract();
    }
  }, {
    key: "endOf",
    value: function endOf(timestamp, unit) {
      return _abstract();
    }
  }]);

  return DateAdapter;
}();

DateAdapter.override = function (members) {
  Object.assign(DateAdapter.prototype, members);
};

var adapters = {
  _date: DateAdapter
};

function binarySearch(metaset, axis, value, intersect) {
  var controller = metaset.controller,
      data = metaset.data,
      _sorted = metaset._sorted;
  var iScale = controller._cachedMeta.iScale;

  if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
    var lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;

    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      var el = data[0];
      var range = typeof el.getRange === 'function' && el.getRange(axis);

      if (range) {
        var start = lookupMethod(data, axis, value - range);
        var end = lookupMethod(data, axis, value + range);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }

  return {
    lo: 0,
    hi: data.length - 1
  };
}

function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  var metasets = chart.getSortedVisibleDatasetMetas();
  var value = position[axis];

  for (var i = 0, ilen = metasets.length; i < ilen; ++i) {
    var _metasets$i = metasets[i],
        _index6 = _metasets$i.index,
        _data2 = _metasets$i.data;

    var _binarySearch = binarySearch(metasets[i], axis, value, intersect),
        lo = _binarySearch.lo,
        hi = _binarySearch.hi;

    for (var j = lo; j <= hi; ++j) {
      var element = _data2[j];

      if (!element.skip) {
        handler(element, _index6, j);
      }
    }
  }
}

function getDistanceMetricForAxis(axis) {
  var useX = axis.indexOf('x') !== -1;
  var useY = axis.indexOf('y') !== -1;
  return function (pt1, pt2) {
    var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}

function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  var items = [];

  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }

  var evaluationFunc = function evaluationFunc(element, datasetIndex, index) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }

    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({
        element: element,
        datasetIndex: datasetIndex,
        index: index
      });
    }
  };

  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}

function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  var items = [];

  function evaluationFunc(element, datasetIndex, index) {
    var _element$getProps = element.getProps(['startAngle', 'endAngle'], useFinalPosition),
        startAngle = _element$getProps.startAngle,
        endAngle = _element$getProps.endAngle;

    var _getAngleFromPoint = getAngleFromPoint(element, {
      x: position.x,
      y: position.y
    }),
        angle = _getAngleFromPoint.angle;

    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element: element,
        datasetIndex: datasetIndex,
        index: index
      });
    }
  }

  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}

function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  var items = [];
  var distanceMetric = getDistanceMetricForAxis(axis);
  var minDistance = Number.POSITIVE_INFINITY;

  function evaluationFunc(element, datasetIndex, index) {
    var inRange = element.inRange(position.x, position.y, useFinalPosition);

    if (intersect && !inRange) {
      return;
    }

    var center = element.getCenterPoint(useFinalPosition);
    var pointInArea = !!includeInvisible || chart.isPointInArea(center);

    if (!pointInArea && !inRange) {
      return;
    }

    var distance = distanceMetric(position, center);

    if (distance < minDistance) {
      items = [{
        element: element,
        datasetIndex: datasetIndex,
        index: index
      }];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({
        element: element,
        datasetIndex: datasetIndex,
        index: index
      });
    }
  }

  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}

function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }

  return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}

function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  var items = [];
  var rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
  var intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, function (element, datasetIndex, index) {
    if (element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({
        element: element,
        datasetIndex: datasetIndex,
        index: index
      });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });

  if (intersect && !intersectsItem) {
    return [];
  }

  return items;
}

var Interaction = {
  evaluateInteractionItems: evaluateInteractionItems,
  modes: {
    index: function index(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      var axis = options.axis || 'x';
      var includeInvisible = options.includeInvisible || false;
      var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      var elements = [];

      if (!items.length) {
        return [];
      }

      chart.getSortedVisibleDatasetMetas().forEach(function (meta) {
        var index = items[0].index;
        var element = meta.data[index];

        if (element && !element.skip) {
          elements.push({
            element: element,
            datasetIndex: meta.index,
            index: index
          });
        }
      });
      return elements;
    },
    dataset: function dataset(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      var axis = options.axis || 'xy';
      var includeInvisible = options.includeInvisible || false;
      var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);

      if (items.length > 0) {
        var datasetIndex = items[0].datasetIndex;
        var _data3 = chart.getDatasetMeta(datasetIndex).data;
        items = [];

        for (var i = 0; i < _data3.length; ++i) {
          items.push({
            element: _data3[i],
            datasetIndex: datasetIndex,
            index: i
          });
        }
      }

      return items;
    },
    point: function point(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      var axis = options.axis || 'xy';
      var includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest: function nearest(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      var axis = options.axis || 'xy';
      var includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x: function x(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
    },
    y: function y(chart, e, options, useFinalPosition) {
      var position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
    }
  }
};
var STATIC_POSITIONS = ['left', 'top', 'right', 'bottom'];

function filterByPosition(array, position) {
  return array.filter(function (v) {
    return v.pos === position;
  });
}

function filterDynamicPositionByAxis(array, axis) {
  return array.filter(function (v) {
    return STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis;
  });
}

function sortByWeight(array, reverse) {
  return array.sort(function (a, b) {
    var v0 = reverse ? b : a;
    var v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}

function wrapBoxes(boxes) {
  var layoutBoxes = [];
  var i, ilen, box, pos, stack, stackWeight;

  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    var _box = box;
    pos = _box.position;
    var _box$options = _box.options;
    stack = _box$options.stack;
    var _box$options$stackWei = _box$options.stackWeight;
    stackWeight = _box$options$stackWei === void 0 ? 1 : _box$options$stackWei;
    layoutBoxes.push({
      index: i,
      box: box,
      pos: pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight: stackWeight
    });
  }

  return layoutBoxes;
}

function buildStacks(layouts) {
  var stacks = {};

  var _iterator14 = _createForOfIteratorHelper(layouts),
      _step14;

  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var wrap = _step14.value;
      var stack = wrap.stack,
          pos = wrap.pos,
          stackWeight = wrap.stackWeight;

      if (!stack || !STATIC_POSITIONS.includes(pos)) {
        continue;
      }

      var _stack = stacks[stack] || (stacks[stack] = {
        count: 0,
        placed: 0,
        weight: 0,
        size: 0
      });

      _stack.count++;
      _stack.weight += stackWeight;
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }

  return stacks;
}

function setLayoutDims(layouts, params) {
  var stacks = buildStacks(layouts);
  var vBoxMaxWidth = params.vBoxMaxWidth,
      hBoxMaxHeight = params.hBoxMaxHeight;
  var i, ilen, layout;

  for (i = 0, ilen = layouts.length; i < ilen; ++i) {
    layout = layouts[i];
    var fullSize = layout.box.fullSize;
    var stack = stacks[layout.stack];
    var factor = stack && layout.stackWeight / stack.weight;

    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }

  return stacks;
}

function buildLayoutBoxes(boxes) {
  var layoutBoxes = wrapBoxes(boxes);
  var fullSize = sortByWeight(layoutBoxes.filter(function (wrap) {
    return wrap.box.fullSize;
  }), true);
  var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
  var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
  var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
  var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
  var centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
  var centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
  return {
    fullSize: fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, 'chartArea'),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}

function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}

function updateDims(chartArea, params, layout, stacks) {
  var pos = layout.pos,
      box = layout.box;
  var maxPadding = chartArea.maxPadding;

  if (!isObject(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }

    var stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }

  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }

  var newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
  var newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
  var widthChanged = newWidth !== chartArea.w;
  var heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}

function handleMaxPadding(chartArea) {
  var maxPadding = chartArea.maxPadding;

  function updatePos(pos) {
    var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }

  chartArea.y += updatePos('top');
  chartArea.x += updatePos('left');
  updatePos('right');
  updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
  var maxPadding = chartArea.maxPadding;

  function marginForPositions(positions) {
    var margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions.forEach(function (pos) {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }

  return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params, stacks) {
  var refitBoxes = [];
  var i, ilen, layout, box, refit, changed;

  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));

    var _updateDims = updateDims(chartArea, params, layout, stacks),
        same = _updateDims.same,
        other = _updateDims.other;

    refit |= same && refitBoxes.length;
    changed = changed || other;

    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }

  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}

function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}

function placeBoxes(boxes, chartArea, params, stacks) {
  var userPadding = params.padding;
  var x = chartArea.x,
      y = chartArea.y;

  var _iterator15 = _createForOfIteratorHelper(boxes),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var layout = _step15.value;
      var box = layout.box;
      var stack = stacks[layout.stack] || {
        count: 1,
        placed: 0,
        weight: 1
      };
      var weight = layout.stackWeight / stack.weight || 1;

      if (layout.horizontal) {
        var width = chartArea.w * weight;
        var height = stack.size || box.height;

        if (defined(stack.start)) {
          y = stack.start;
        }

        if (box.fullSize) {
          setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
        } else {
          setBoxDims(box, chartArea.left + stack.placed, y, width, height);
        }

        stack.start = y;
        stack.placed += width;
        y = box.bottom;
      } else {
        var _height = chartArea.h * weight;

        var _width2 = stack.size || box.width;

        if (defined(stack.start)) {
          x = stack.start;
        }

        if (box.fullSize) {
          setBoxDims(box, x, userPadding.top, _width2, params.outerHeight - userPadding.bottom - userPadding.top);
        } else {
          setBoxDims(box, x, chartArea.top + stack.placed, _width2, _height);
        }

        stack.start = x;
        stack.placed += _height;
        x = box.right;
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }

  chartArea.x = x;
  chartArea.y = y;
}

defaults.set('layout', {
  autoPadding: true,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var layouts = {
  addBox: function addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }

    item.fullSize = item.fullSize || false;
    item.position = item.position || 'top';
    item.weight = item.weight || 0;

    item._layers = item._layers || function () {
      return [{
        z: 0,
        draw: function draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };

    chart.boxes.push(item);
  },
  removeBox: function removeBox(chart, layoutItem) {
    var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;

    if (index !== -1) {
      chart.boxes.splice(index, 1);
    }
  },
  configure: function configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update: function update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }

    var padding = toPadding(chart.options.layout.padding);
    var availableWidth = Math.max(width - padding.width, 0);
    var availableHeight = Math.max(height - padding.height, 0);
    var boxes = buildLayoutBoxes(chart.boxes);
    var verticalBoxes = boxes.vertical;
    var horizontalBoxes = boxes.horizontal;
    each(chart.boxes, function (box) {
      if (typeof box.beforeLayout === 'function') {
        box.beforeLayout();
      }
    });
    var visibleVerticalBoxCount = verticalBoxes.reduce(function (total, wrap) {
      return wrap.box.options && wrap.box.options.display === false ? total : total + 1;
    }, 0) || 1;
    var params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding: padding,
      availableWidth: availableWidth,
      availableHeight: availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    var maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    var chartArea = Object.assign({
      maxPadding: maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    var stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);

    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }

    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, function (layout) {
      var box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};

var BasePlatform = /*#__PURE__*/function () {
  function BasePlatform() {
    _classCallCheck(this, BasePlatform);
  }

  _createClass(BasePlatform, [{
    key: "acquireContext",
    value: function acquireContext(canvas, aspectRatio) {}
  }, {
    key: "releaseContext",
    value: function releaseContext(context) {
      return false;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(chart, type, listener) {}
  }, {
    key: "removeEventListener",
    value: function removeEventListener(chart, type, listener) {}
  }, {
    key: "getDevicePixelRatio",
    value: function getDevicePixelRatio() {
      return 1;
    }
  }, {
    key: "getMaximumSize",
    value: function getMaximumSize(element, width, height, aspectRatio) {
      width = Math.max(0, width || element.width);
      height = height || element.height;
      return {
        width: width,
        height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
      };
    }
  }, {
    key: "isAttached",
    value: function isAttached(canvas) {
      return true;
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {}
  }]);

  return BasePlatform;
}();

var BasicPlatform = /*#__PURE__*/function (_BasePlatform) {
  _inherits(BasicPlatform, _BasePlatform);

  var _super11 = _createSuper(BasicPlatform);

  function BasicPlatform() {
    _classCallCheck(this, BasicPlatform);

    return _super11.apply(this, arguments);
  }

  _createClass(BasicPlatform, [{
    key: "acquireContext",
    value: function acquireContext(item) {
      return item && item.getContext && item.getContext('2d') || null;
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      config.options.animation = false;
    }
  }]);

  return BasicPlatform;
}(BasePlatform);

var EXPANDO_KEY = '$chartjs';
var EVENT_TYPES = {
  touchstart: 'mousedown',
  touchmove: 'mousemove',
  touchend: 'mouseup',
  pointerenter: 'mouseenter',
  pointerdown: 'mousedown',
  pointermove: 'mousemove',
  pointerup: 'mouseup',
  pointerleave: 'mouseout',
  pointerout: 'mouseout'
};

var isNullOrEmpty = function isNullOrEmpty(value) {
  return value === null || value === '';
};

function initCanvas(canvas, aspectRatio) {
  var style = canvas.style;
  var renderHeight = canvas.getAttribute('height');
  var renderWidth = canvas.getAttribute('width');
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || 'block';
  style.boxSizing = style.boxSizing || 'border-box';

  if (isNullOrEmpty(renderWidth)) {
    var displayWidth = readUsedSize(canvas, 'width');

    if (displayWidth !== undefined) {
      canvas.width = displayWidth;
    }
  }

  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === '') {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      var displayHeight = readUsedSize(canvas, 'height');

      if (displayHeight !== undefined) {
        canvas.height = displayHeight;
      }
    }
  }

  return canvas;
}

var eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;

function addListener(node, type, listener) {
  node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(chart, type, listener) {
  chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}

function fromNativeEvent(event, chart) {
  var type = EVENT_TYPES[event.type] || event.type;

  var _getRelativePosition = getRelativePosition(event, chart),
      x = _getRelativePosition.x,
      y = _getRelativePosition.y;

  return {
    type: type,
    chart: chart,
    "native": event,
    x: x !== undefined ? x : null,
    y: y !== undefined ? y : null
  };
}

function nodeListContains(nodeList, canvas) {
  var _iterator16 = _createForOfIteratorHelper(nodeList),
      _step16;

  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var node = _step16.value;

      if (node === canvas || node.contains(canvas)) {
        return true;
      }
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
}

function createAttachObserver(chart, type, listener) {
  var canvas = chart.canvas;
  var observer = new MutationObserver(function (entries) {
    var trigger = false;

    var _iterator17 = _createForOfIteratorHelper(entries),
        _step17;

    try {
      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
        var entry = _step17.value;
        trigger = trigger || nodeListContains(entry.addedNodes, canvas);
        trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }

    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}

function createDetachObserver(chart, type, listener) {
  var canvas = chart.canvas;
  var observer = new MutationObserver(function (entries) {
    var trigger = false;

    var _iterator18 = _createForOfIteratorHelper(entries),
        _step18;

    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var entry = _step18.value;
        trigger = trigger || nodeListContains(entry.removedNodes, canvas);
        trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }

    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}

var drpListeningCharts = new Map();
var oldDevicePixelRatio = 0;

function onWindowResize() {
  var dpr = window.devicePixelRatio;

  if (dpr === oldDevicePixelRatio) {
    return;
  }

  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach(function (resize, chart) {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}

function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener('resize', onWindowResize);
  }

  drpListeningCharts.set(chart, resize);
}

function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts["delete"](chart);

  if (!drpListeningCharts.size) {
    window.removeEventListener('resize', onWindowResize);
  }
}

function createResizeObserver(chart, type, listener) {
  var canvas = chart.canvas;

  var container = canvas && _getParentNode(canvas);

  if (!container) {
    return;
  }

  var resize = throttled(function (width, height) {
    var w = container.clientWidth;
    listener(width, height);

    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  var observer = new ResizeObserver(function (entries) {
    var entry = entries[0];
    var width = entry.contentRect.width;
    var height = entry.contentRect.height;

    if (width === 0 && height === 0) {
      return;
    }

    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}

function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }

  if (type === 'resize') {
    unlistenDevicePixelRatioChanges(chart);
  }
}

function createProxyAndListen(chart, type, listener) {
  var canvas = chart.canvas;
  var proxy = throttled(function (event) {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart, function (args) {
    var event = args[0];
    return [event, event.offsetX, event.offsetY];
  });
  addListener(canvas, type, proxy);
  return proxy;
}

var DomPlatform = /*#__PURE__*/function (_BasePlatform2) {
  _inherits(DomPlatform, _BasePlatform2);

  var _super12 = _createSuper(DomPlatform);

  function DomPlatform() {
    _classCallCheck(this, DomPlatform);

    return _super12.apply(this, arguments);
  }

  _createClass(DomPlatform, [{
    key: "acquireContext",
    value: function acquireContext(canvas, aspectRatio) {
      var context = canvas && canvas.getContext && canvas.getContext('2d');

      if (context && context.canvas === canvas) {
        initCanvas(canvas, aspectRatio);
        return context;
      }

      return null;
    }
  }, {
    key: "releaseContext",
    value: function releaseContext(context) {
      var canvas = context.canvas;

      if (!canvas[EXPANDO_KEY]) {
        return false;
      }

      var initial = canvas[EXPANDO_KEY].initial;
      ['height', 'width'].forEach(function (prop) {
        var value = initial[prop];

        if (isNullOrUndef(value)) {
          canvas.removeAttribute(prop);
        } else {
          canvas.setAttribute(prop, value);
        }
      });
      var style = initial.style || {};
      Object.keys(style).forEach(function (key) {
        canvas.style[key] = style[key];
      });
      canvas.width = canvas.width;
      delete canvas[EXPANDO_KEY];
      return true;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(chart, type, listener) {
      this.removeEventListener(chart, type);
      var proxies = chart.$proxies || (chart.$proxies = {});
      var handlers = {
        attach: createAttachObserver,
        detach: createDetachObserver,
        resize: createResizeObserver
      };
      var handler = handlers[type] || createProxyAndListen;
      proxies[type] = handler(chart, type, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(chart, type) {
      var proxies = chart.$proxies || (chart.$proxies = {});
      var proxy = proxies[type];

      if (!proxy) {
        return;
      }

      var handlers = {
        attach: releaseObserver,
        detach: releaseObserver,
        resize: releaseObserver
      };
      var handler = handlers[type] || removeListener;
      handler(chart, type, proxy);
      proxies[type] = undefined;
    }
  }, {
    key: "getDevicePixelRatio",
    value: function getDevicePixelRatio() {
      return window.devicePixelRatio;
    }
  }, {
    key: "getMaximumSize",
    value: function getMaximumSize(canvas, width, height, aspectRatio) {
      return _getMaximumSize(canvas, width, height, aspectRatio);
    }
  }, {
    key: "isAttached",
    value: function isAttached(canvas) {
      var container = _getParentNode(canvas);

      return !!(container && container.isConnected);
    }
  }]);

  return DomPlatform;
}(BasePlatform);

function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }

  return DomPlatform;
}

var Element = /*#__PURE__*/function () {
  function Element() {
    _classCallCheck(this, Element);

    this.x = undefined;
    this.y = undefined;
    this.active = false;
    this.options = undefined;
    this.$animations = undefined;
  }

  _createClass(Element, [{
    key: "tooltipPosition",
    value: function tooltipPosition(useFinalPosition) {
      var _this$getProps = this.getProps(['x', 'y'], useFinalPosition),
          x = _this$getProps.x,
          y = _this$getProps.y;

      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      return isNumber(this.x) && isNumber(this.y);
    }
  }, {
    key: "getProps",
    value: function getProps(props, _final) {
      var _this20 = this;

      var anims = this.$animations;

      if (!_final || !anims) {
        return this;
      }

      var ret = {};
      props.forEach(function (prop) {
        ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : _this20[prop];
      });
      return ret;
    }
  }]);

  return Element;
}();

Element.defaults = {};
Element.defaultRoutes = undefined;
var formatters = {
  values: function values(value) {
    return isArray(value) ? value : '' + value;
  },
  numeric: function numeric(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }

    var locale = this.chart.options.locale;
    var notation;
    var delta = tickValue;

    if (ticks.length > 1) {
      var maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));

      if (maxTick < 1e-4 || maxTick > 1e+15) {
        notation = 'scientific';
      }

      delta = calculateDelta(tickValue, ticks);
    }

    var logDelta = log10(Math.abs(delta));
    var numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    var options = {
      notation: notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic: function logarithmic(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }

    var remain = tickValue / Math.pow(10, Math.floor(log10(tickValue)));

    if (remain === 1 || remain === 2 || remain === 5) {
      return formatters.numeric.call(this, tickValue, index, ticks);
    }

    return '';
  }
};

function calculateDelta(tickValue, ticks) {
  var delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;

  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }

  return delta;
}

var Ticks = {
  formatters: formatters
};
defaults.set('scale', {
  display: true,
  offset: false,
  reverse: false,
  beginAtZero: false,
  bounds: 'ticks',
  grace: 0,
  grid: {
    display: true,
    lineWidth: 1,
    drawBorder: true,
    drawOnChartArea: true,
    drawTicks: true,
    tickLength: 8,
    tickWidth: function tickWidth(_ctx, options) {
      return options.lineWidth;
    },
    tickColor: function tickColor(_ctx, options) {
      return options.color;
    },
    offset: false,
    borderDash: [],
    borderDashOffset: 0.0,
    borderWidth: 1
  },
  title: {
    display: false,
    text: '',
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: false,
    textStrokeWidth: 0,
    textStrokeColor: '',
    padding: 3,
    display: true,
    autoSkip: true,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Ticks.formatters.values,
    minor: {},
    major: {},
    align: 'center',
    crossAlign: 'near',
    showLabelBackdrop: false,
    backdropColor: 'rgba(255, 255, 255, 0.75)',
    backdropPadding: 2
  }
});
defaults.route('scale.ticks', 'color', '', 'color');
defaults.route('scale.grid', 'color', '', 'borderColor');
defaults.route('scale.grid', 'borderColor', '', 'borderColor');
defaults.route('scale.title', 'color', '', 'color');
defaults.describe('scale', {
  _fallback: false,
  _scriptable: function _scriptable(name) {
    return !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser';
  },
  _indexable: function _indexable(name) {
    return name !== 'borderDash' && name !== 'tickBorderDash';
  }
});
defaults.describe('scales', {
  _fallback: 'scale'
});
defaults.describe('scale.ticks', {
  _scriptable: function _scriptable(name) {
    return name !== 'backdropPadding' && name !== 'callback';
  },
  _indexable: function _indexable(name) {
    return name !== 'backdropPadding';
  }
});

function autoSkip(scale, ticks) {
  var tickOpts = scale.options.ticks;
  var ticksLimit = tickOpts.maxTicksLimit || determineMaxTicks(scale);
  var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  var numMajorIndices = majorIndices.length;
  var first = majorIndices[0];
  var last = majorIndices[numMajorIndices - 1];
  var newTicks = [];

  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }

  var spacing = calculateSpacing(majorIndices, ticks, ticksLimit);

  if (numMajorIndices > 0) {
    var i, ilen;
    var avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);

    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }

    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }

  skip(ticks, newTicks, spacing);
  return newTicks;
}

function determineMaxTicks(scale) {
  var offset = scale.options.offset;

  var tickLength = scale._tickSize();

  var maxScale = scale._length / tickLength + (offset ? 0 : 1);
  var maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}

function calculateSpacing(majorIndices, ticks, ticksLimit) {
  var evenMajorSpacing = getEvenSpacing(majorIndices);
  var spacing = ticks.length / ticksLimit;

  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }

  var factors = _factorize(evenMajorSpacing);

  for (var i = 0, ilen = factors.length - 1; i < ilen; i++) {
    var factor = factors[i];

    if (factor > spacing) {
      return factor;
    }
  }

  return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
  var result = [];
  var i, ilen;

  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }

  return result;
}

function skipMajors(ticks, newTicks, majorIndices, spacing) {
  var count = 0;
  var next = majorIndices[0];
  var i;
  spacing = Math.ceil(spacing);

  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}

function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  var start = valueOrDefault(majorStart, 0);
  var end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  var count = 0;
  var length, i, next;
  spacing = Math.ceil(spacing);

  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }

  next = start;

  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }

  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}

function getEvenSpacing(arr) {
  var len = arr.length;
  var i, diff;

  if (len < 2) {
    return false;
  }

  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }

  return diff;
}

var reverseAlign = function reverseAlign(align) {
  return align === 'left' ? 'right' : align === 'right' ? 'left' : align;
};

var offsetFromEdge = function offsetFromEdge(scale, edge, offset) {
  return edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
};

function sample(arr, numItems) {
  var result = [];
  var increment = arr.length / numItems;
  var len = arr.length;
  var i = 0;

  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }

  return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
  var length = scale.ticks.length;
  var validIndex = Math.min(index, length - 1);
  var start = scale._startPixel;
  var end = scale._endPixel;
  var epsilon = 1e-6;
  var lineValue = scale.getPixelForTick(validIndex);
  var offset;

  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
    }

    lineValue += validIndex < index ? offset : -offset;

    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }

  return lineValue;
}

function garbageCollect(caches, length) {
  each(caches, function (cache) {
    var gc = cache.gc;
    var gcLen = gc.length / 2;
    var i;

    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }

      gc.splice(0, gcLen);
    }
  });
}

function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}

function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }

  var font = toFont(options.font, fallback);
  var padding = toPadding(options.padding);
  var lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}

function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale: scale,
    type: 'scale'
  });
}

function createTickContext(parent, index, tick) {
  return createContext(parent, {
    tick: tick,
    index: index,
    type: 'tick'
  });
}

function titleAlign(align, position, reverse) {
  var ret = _toLeftRightCenter(align);

  if (reverse && position !== 'right' || !reverse && position === 'right') {
    ret = reverseAlign(ret);
  }

  return ret;
}

function titleArgs(scale, offset, position, align) {
  var top = scale.top,
      left = scale.left,
      bottom = scale.bottom,
      right = scale.right,
      chart = scale.chart;
  var chartArea = chart.chartArea,
      scales = chart.scales;
  var rotation = 0;
  var maxWidth, titleX, titleY;
  var height = bottom - top;
  var width = right - left;

  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);

    if (isObject(position)) {
      var positionAxisID = Object.keys(position)[0];
      var value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === 'center') {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }

    maxWidth = right - left;
  } else {
    if (isObject(position)) {
      var _positionAxisID = Object.keys(position)[0];
      var _value = position[_positionAxisID];
      titleX = scales[_positionAxisID].getPixelForValue(_value) - width + offset;
    } else if (position === 'center') {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }

    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === 'left' ? -HALF_PI : HALF_PI;
  }

  return {
    titleX: titleX,
    titleY: titleY,
    maxWidth: maxWidth,
    rotation: rotation
  };
}

var Scale = /*#__PURE__*/function (_Element) {
  _inherits(Scale, _Element);

  var _super13 = _createSuper(Scale);

  function Scale(cfg) {
    var _this21;

    _classCallCheck(this, Scale);

    _this21 = _super13.call(this);
    _this21.id = cfg.id;
    _this21.type = cfg.type;
    _this21.options = undefined;
    _this21.ctx = cfg.ctx;
    _this21.chart = cfg.chart;
    _this21.top = undefined;
    _this21.bottom = undefined;
    _this21.left = undefined;
    _this21.right = undefined;
    _this21.width = undefined;
    _this21.height = undefined;
    _this21._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    _this21.maxWidth = undefined;
    _this21.maxHeight = undefined;
    _this21.paddingTop = undefined;
    _this21.paddingBottom = undefined;
    _this21.paddingLeft = undefined;
    _this21.paddingRight = undefined;
    _this21.axis = undefined;
    _this21.labelRotation = undefined;
    _this21.min = undefined;
    _this21.max = undefined;
    _this21._range = undefined;
    _this21.ticks = [];
    _this21._gridLineItems = null;
    _this21._labelItems = null;
    _this21._labelSizes = null;
    _this21._length = 0;
    _this21._maxLength = 0;
    _this21._longestTextCache = {};
    _this21._startPixel = undefined;
    _this21._endPixel = undefined;
    _this21._reversePixels = false;
    _this21._userMax = undefined;
    _this21._userMin = undefined;
    _this21._suggestedMax = undefined;
    _this21._suggestedMin = undefined;
    _this21._ticksLength = 0;
    _this21._borderValue = 0;
    _this21._cache = {};
    _this21._dataLimitsCached = false;
    _this21.$context = undefined;
    return _this21;
  }

  _createClass(Scale, [{
    key: "init",
    value: function init(options) {
      this.options = options.setContext(this.getContext());
      this.axis = options.axis;
      this._userMin = this.parse(options.min);
      this._userMax = this.parse(options.max);
      this._suggestedMin = this.parse(options.suggestedMin);
      this._suggestedMax = this.parse(options.suggestedMax);
    }
  }, {
    key: "parse",
    value: function parse(raw, index) {
      return raw;
    }
  }, {
    key: "getUserBounds",
    value: function getUserBounds() {
      var _userMin = this._userMin,
          _userMax = this._userMax,
          _suggestedMin = this._suggestedMin,
          _suggestedMax = this._suggestedMax;
      _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
      _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
      _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
      _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
      return {
        min: finiteOrDefault(_userMin, _suggestedMin),
        max: finiteOrDefault(_userMax, _suggestedMax),
        minDefined: isNumberFinite(_userMin),
        maxDefined: isNumberFinite(_userMax)
      };
    }
  }, {
    key: "getMinMax",
    value: function getMinMax(canStack) {
      var _this$getUserBounds = this.getUserBounds(),
          min = _this$getUserBounds.min,
          max = _this$getUserBounds.max,
          minDefined = _this$getUserBounds.minDefined,
          maxDefined = _this$getUserBounds.maxDefined;

      var range;

      if (minDefined && maxDefined) {
        return {
          min: min,
          max: max
        };
      }

      var metas = this.getMatchingVisibleMetas();

      for (var i = 0, ilen = metas.length; i < ilen; ++i) {
        range = metas[i].controller.getMinMax(this, canStack);

        if (!minDefined) {
          min = Math.min(min, range.min);
        }

        if (!maxDefined) {
          max = Math.max(max, range.max);
        }
      }

      min = maxDefined && min > max ? max : min;
      max = minDefined && min > max ? min : max;
      return {
        min: finiteOrDefault(min, finiteOrDefault(max, min)),
        max: finiteOrDefault(max, finiteOrDefault(min, max))
      };
    }
  }, {
    key: "getPadding",
    value: function getPadding() {
      return {
        left: this.paddingLeft || 0,
        top: this.paddingTop || 0,
        right: this.paddingRight || 0,
        bottom: this.paddingBottom || 0
      };
    }
  }, {
    key: "getTicks",
    value: function getTicks() {
      return this.ticks;
    }
  }, {
    key: "getLabels",
    value: function getLabels() {
      var data = this.chart.data;
      return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
  }, {
    key: "beforeLayout",
    value: function beforeLayout() {
      this._cache = {};
      this._dataLimitsCached = false;
    }
  }, {
    key: "beforeUpdate",
    value: function beforeUpdate() {
      callback(this.options.beforeUpdate, [this]);
    }
  }, {
    key: "update",
    value: function update(maxWidth, maxHeight, margins) {
      var _this$options3 = this.options,
          beginAtZero = _this$options3.beginAtZero,
          grace = _this$options3.grace,
          tickOpts = _this$options3.ticks;
      var sampleSize = tickOpts.sampleSize;
      this.beforeUpdate();
      this.maxWidth = maxWidth;
      this.maxHeight = maxHeight;
      this._margins = margins = Object.assign({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, margins);
      this.ticks = null;
      this._labelSizes = null;
      this._gridLineItems = null;
      this._labelItems = null;
      this.beforeSetDimensions();
      this.setDimensions();
      this.afterSetDimensions();
      this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;

      if (!this._dataLimitsCached) {
        this.beforeDataLimits();
        this.determineDataLimits();
        this.afterDataLimits();
        this._range = _addGrace(this, grace, beginAtZero);
        this._dataLimitsCached = true;
      }

      this.beforeBuildTicks();
      this.ticks = this.buildTicks() || [];
      this.afterBuildTicks();
      var samplingEnabled = sampleSize < this.ticks.length;

      this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);

      this.configure();
      this.beforeCalculateLabelRotation();
      this.calculateLabelRotation();
      this.afterCalculateLabelRotation();

      if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
        this.ticks = autoSkip(this, this.ticks);
        this._labelSizes = null;
        this.afterAutoSkip();
      }

      if (samplingEnabled) {
        this._convertTicksToLabels(this.ticks);
      }

      this.beforeFit();
      this.fit();
      this.afterFit();
      this.afterUpdate();
    }
  }, {
    key: "configure",
    value: function configure() {
      var reversePixels = this.options.reverse;
      var startPixel, endPixel;

      if (this.isHorizontal()) {
        startPixel = this.left;
        endPixel = this.right;
      } else {
        startPixel = this.top;
        endPixel = this.bottom;
        reversePixels = !reversePixels;
      }

      this._startPixel = startPixel;
      this._endPixel = endPixel;
      this._reversePixels = reversePixels;
      this._length = endPixel - startPixel;
      this._alignToPixels = this.options.alignToPixels;
    }
  }, {
    key: "afterUpdate",
    value: function afterUpdate() {
      callback(this.options.afterUpdate, [this]);
    }
  }, {
    key: "beforeSetDimensions",
    value: function beforeSetDimensions() {
      callback(this.options.beforeSetDimensions, [this]);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions() {
      if (this.isHorizontal()) {
        this.width = this.maxWidth;
        this.left = 0;
        this.right = this.width;
      } else {
        this.height = this.maxHeight;
        this.top = 0;
        this.bottom = this.height;
      }

      this.paddingLeft = 0;
      this.paddingTop = 0;
      this.paddingRight = 0;
      this.paddingBottom = 0;
    }
  }, {
    key: "afterSetDimensions",
    value: function afterSetDimensions() {
      callback(this.options.afterSetDimensions, [this]);
    }
  }, {
    key: "_callHooks",
    value: function _callHooks(name) {
      this.chart.notifyPlugins(name, this.getContext());
      callback(this.options[name], [this]);
    }
  }, {
    key: "beforeDataLimits",
    value: function beforeDataLimits() {
      this._callHooks('beforeDataLimits');
    }
  }, {
    key: "determineDataLimits",
    value: function determineDataLimits() {}
  }, {
    key: "afterDataLimits",
    value: function afterDataLimits() {
      this._callHooks('afterDataLimits');
    }
  }, {
    key: "beforeBuildTicks",
    value: function beforeBuildTicks() {
      this._callHooks('beforeBuildTicks');
    }
  }, {
    key: "buildTicks",
    value: function buildTicks() {
      return [];
    }
  }, {
    key: "afterBuildTicks",
    value: function afterBuildTicks() {
      this._callHooks('afterBuildTicks');
    }
  }, {
    key: "beforeTickToLabelConversion",
    value: function beforeTickToLabelConversion() {
      callback(this.options.beforeTickToLabelConversion, [this]);
    }
  }, {
    key: "generateTickLabels",
    value: function generateTickLabels(ticks) {
      var tickOpts = this.options.ticks;
      var i, ilen, tick;

      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        tick = ticks[i];
        tick.label = callback(tickOpts.callback, [tick.value, i, ticks], this);
      }
    }
  }, {
    key: "afterTickToLabelConversion",
    value: function afterTickToLabelConversion() {
      callback(this.options.afterTickToLabelConversion, [this]);
    }
  }, {
    key: "beforeCalculateLabelRotation",
    value: function beforeCalculateLabelRotation() {
      callback(this.options.beforeCalculateLabelRotation, [this]);
    }
  }, {
    key: "calculateLabelRotation",
    value: function calculateLabelRotation() {
      var options = this.options;
      var tickOpts = options.ticks;
      var numTicks = this.ticks.length;
      var minRotation = tickOpts.minRotation || 0;
      var maxRotation = tickOpts.maxRotation;
      var labelRotation = minRotation;
      var tickWidth, maxHeight, maxLabelDiagonal;

      if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
        this.labelRotation = minRotation;
        return;
      }

      var labelSizes = this._getLabelSizes();

      var maxLabelWidth = labelSizes.widest.width;
      var maxLabelHeight = labelSizes.highest.height;

      var maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);

      tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);

      if (maxLabelWidth + 6 > tickWidth) {
        tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
        maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
        maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
        labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
        labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
      }

      this.labelRotation = labelRotation;
    }
  }, {
    key: "afterCalculateLabelRotation",
    value: function afterCalculateLabelRotation() {
      callback(this.options.afterCalculateLabelRotation, [this]);
    }
  }, {
    key: "afterAutoSkip",
    value: function afterAutoSkip() {}
  }, {
    key: "beforeFit",
    value: function beforeFit() {
      callback(this.options.beforeFit, [this]);
    }
  }, {
    key: "fit",
    value: function fit() {
      var minSize = {
        width: 0,
        height: 0
      };
      var chart = this.chart,
          _this$options4 = this.options,
          tickOpts = _this$options4.ticks,
          titleOpts = _this$options4.title,
          gridOpts = _this$options4.grid;

      var display = this._isVisible();

      var isHorizontal = this.isHorizontal();

      if (display) {
        var titleHeight = getTitleHeight(titleOpts, chart.options.font);

        if (isHorizontal) {
          minSize.width = this.maxWidth;
          minSize.height = getTickMarkLength(gridOpts) + titleHeight;
        } else {
          minSize.height = this.maxHeight;
          minSize.width = getTickMarkLength(gridOpts) + titleHeight;
        }

        if (tickOpts.display && this.ticks.length) {
          var _this$_getLabelSizes = this._getLabelSizes(),
              first = _this$_getLabelSizes.first,
              last = _this$_getLabelSizes.last,
              widest = _this$_getLabelSizes.widest,
              highest = _this$_getLabelSizes.highest;

          var tickPadding = tickOpts.padding * 2;
          var angleRadians = toRadians(this.labelRotation);
          var cos = Math.cos(angleRadians);
          var sin = Math.sin(angleRadians);

          if (isHorizontal) {
            var labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
            minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
          } else {
            var labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
            minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
          }

          this._calculatePadding(first, last, sin, cos);
        }
      }

      this._handleMargins();

      if (isHorizontal) {
        this.width = this._length = chart.width - this._margins.left - this._margins.right;
        this.height = minSize.height;
      } else {
        this.width = minSize.width;
        this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
      }
    }
  }, {
    key: "_calculatePadding",
    value: function _calculatePadding(first, last, sin, cos) {
      var _this$options5 = this.options,
          _this$options5$ticks = _this$options5.ticks,
          align = _this$options5$ticks.align,
          padding = _this$options5$ticks.padding,
          position = _this$options5.position;
      var isRotated = this.labelRotation !== 0;
      var labelsBelowTicks = position !== 'top' && this.axis === 'x';

      if (this.isHorizontal()) {
        var offsetLeft = this.getPixelForTick(0) - this.left;
        var offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
        var paddingLeft = 0;
        var paddingRight = 0;

        if (isRotated) {
          if (labelsBelowTicks) {
            paddingLeft = cos * first.width;
            paddingRight = sin * last.height;
          } else {
            paddingLeft = sin * first.height;
            paddingRight = cos * last.width;
          }
        } else if (align === 'start') {
          paddingRight = last.width;
        } else if (align === 'end') {
          paddingLeft = first.width;
        } else if (align !== 'inner') {
          paddingLeft = first.width / 2;
          paddingRight = last.width / 2;
        }

        this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
        this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
      } else {
        var paddingTop = last.height / 2;
        var paddingBottom = first.height / 2;

        if (align === 'start') {
          paddingTop = 0;
          paddingBottom = first.height;
        } else if (align === 'end') {
          paddingTop = last.height;
          paddingBottom = 0;
        }

        this.paddingTop = paddingTop + padding;
        this.paddingBottom = paddingBottom + padding;
      }
    }
  }, {
    key: "_handleMargins",
    value: function _handleMargins() {
      if (this._margins) {
        this._margins.left = Math.max(this.paddingLeft, this._margins.left);
        this._margins.top = Math.max(this.paddingTop, this._margins.top);
        this._margins.right = Math.max(this.paddingRight, this._margins.right);
        this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
      }
    }
  }, {
    key: "afterFit",
    value: function afterFit() {
      callback(this.options.afterFit, [this]);
    }
  }, {
    key: "isHorizontal",
    value: function isHorizontal() {
      var _this$options6 = this.options,
          axis = _this$options6.axis,
          position = _this$options6.position;
      return position === 'top' || position === 'bottom' || axis === 'x';
    }
  }, {
    key: "isFullSize",
    value: function isFullSize() {
      return this.options.fullSize;
    }
  }, {
    key: "_convertTicksToLabels",
    value: function _convertTicksToLabels(ticks) {
      this.beforeTickToLabelConversion();
      this.generateTickLabels(ticks);
      var i, ilen;

      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (isNullOrUndef(ticks[i].label)) {
          ticks.splice(i, 1);
          ilen--;
          i--;
        }
      }

      this.afterTickToLabelConversion();
    }
  }, {
    key: "_getLabelSizes",
    value: function _getLabelSizes() {
      var labelSizes = this._labelSizes;

      if (!labelSizes) {
        var sampleSize = this.options.ticks.sampleSize;
        var ticks = this.ticks;

        if (sampleSize < ticks.length) {
          ticks = sample(ticks, sampleSize);
        }

        this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
      }

      return labelSizes;
    }
  }, {
    key: "_computeLabelSizes",
    value: function _computeLabelSizes(ticks, length) {
      var ctx = this.ctx,
          caches = this._longestTextCache;
      var widths = [];
      var heights = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;

      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = this._resolveTickFontOptions(i);
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;

        if (!isNullOrUndef(label) && !isArray(label)) {
          width = _measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];

            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }

        widths.push(width);
        heights.push(height);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }

      garbageCollect(caches, length);
      var widest = widths.indexOf(widestLabelSize);
      var highest = heights.indexOf(highestLabelSize);

      var valueAt = function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0
        };
      };

      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest),
        widths: widths,
        heights: heights
      };
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value) {
      return value;
    }
  }, {
    key: "getPixelForValue",
    value: function getPixelForValue(value, index) {
      return NaN;
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {}
  }, {
    key: "getPixelForTick",
    value: function getPixelForTick(index) {
      var ticks = this.ticks;

      if (index < 0 || index > ticks.length - 1) {
        return null;
      }

      return this.getPixelForValue(ticks[index].value);
    }
  }, {
    key: "getPixelForDecimal",
    value: function getPixelForDecimal(decimal) {
      if (this._reversePixels) {
        decimal = 1 - decimal;
      }

      var pixel = this._startPixel + decimal * this._length;
      return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
    }
  }, {
    key: "getDecimalForPixel",
    value: function getDecimalForPixel(pixel) {
      var decimal = (pixel - this._startPixel) / this._length;
      return this._reversePixels ? 1 - decimal : decimal;
    }
  }, {
    key: "getBasePixel",
    value: function getBasePixel() {
      return this.getPixelForValue(this.getBaseValue());
    }
  }, {
    key: "getBaseValue",
    value: function getBaseValue() {
      var min = this.min,
          max = this.max;
      return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
  }, {
    key: "getContext",
    value: function getContext(index) {
      var ticks = this.ticks || [];

      if (index >= 0 && index < ticks.length) {
        var tick = ticks[index];
        return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
      }

      return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
  }, {
    key: "_tickSize",
    value: function _tickSize() {
      var optionTicks = this.options.ticks;
      var rot = toRadians(this.labelRotation);
      var cos = Math.abs(Math.cos(rot));
      var sin = Math.abs(Math.sin(rot));

      var labelSizes = this._getLabelSizes();

      var padding = optionTicks.autoSkipPadding || 0;
      var w = labelSizes ? labelSizes.widest.width + padding : 0;
      var h = labelSizes ? labelSizes.highest.height + padding : 0;
      return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var display = this.options.display;

      if (display !== 'auto') {
        return !!display;
      }

      return this.getMatchingVisibleMetas().length > 0;
    }
  }, {
    key: "_computeGridLineItems",
    value: function _computeGridLineItems(chartArea) {
      var axis = this.axis;
      var chart = this.chart;
      var options = this.options;
      var grid = options.grid,
          position = options.position;
      var offset = grid.offset;
      var isHorizontal = this.isHorizontal();
      var ticks = this.ticks;
      var ticksLength = ticks.length + (offset ? 1 : 0);
      var tl = getTickMarkLength(grid);
      var items = [];
      var borderOpts = grid.setContext(this.getContext());
      var axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
      var axisHalfWidth = axisWidth / 2;

      var alignBorderValue = function alignBorderValue(pixel) {
        return _alignPixel(chart, pixel, axisWidth);
      };

      var borderValue, i, lineValue, alignedLineValue;
      var tx1, ty1, tx2, ty2, x1, y1, x2, y2;

      if (position === 'top') {
        borderValue = alignBorderValue(this.bottom);
        ty1 = this.bottom - tl;
        ty2 = borderValue - axisHalfWidth;
        y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
        y2 = chartArea.bottom;
      } else if (position === 'bottom') {
        borderValue = alignBorderValue(this.top);
        y1 = chartArea.top;
        y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
        ty1 = borderValue + axisHalfWidth;
        ty2 = this.top + tl;
      } else if (position === 'left') {
        borderValue = alignBorderValue(this.right);
        tx1 = this.right - tl;
        tx2 = borderValue - axisHalfWidth;
        x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
        x2 = chartArea.right;
      } else if (position === 'right') {
        borderValue = alignBorderValue(this.left);
        x1 = chartArea.left;
        x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
        tx1 = borderValue + axisHalfWidth;
        tx2 = this.left + tl;
      } else if (axis === 'x') {
        if (position === 'center') {
          borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
        } else if (isObject(position)) {
          var positionAxisID = Object.keys(position)[0];
          var value = position[positionAxisID];
          borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
        }

        y1 = chartArea.top;
        y2 = chartArea.bottom;
        ty1 = borderValue + axisHalfWidth;
        ty2 = ty1 + tl;
      } else if (axis === 'y') {
        if (position === 'center') {
          borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
        } else if (isObject(position)) {
          var _positionAxisID2 = Object.keys(position)[0];
          var _value2 = position[_positionAxisID2];
          borderValue = alignBorderValue(this.chart.scales[_positionAxisID2].getPixelForValue(_value2));
        }

        tx1 = borderValue - axisHalfWidth;
        tx2 = tx1 - tl;
        x1 = chartArea.left;
        x2 = chartArea.right;
      }

      var limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
      var step = Math.max(1, Math.ceil(ticksLength / limit));

      for (i = 0; i < ticksLength; i += step) {
        var optsAtIndex = grid.setContext(this.getContext(i));
        var lineWidth = optsAtIndex.lineWidth;
        var lineColor = optsAtIndex.color;
        var borderDash = grid.borderDash || [];
        var borderDashOffset = optsAtIndex.borderDashOffset;
        var tickWidth = optsAtIndex.tickWidth;
        var tickColor = optsAtIndex.tickColor;
        var tickBorderDash = optsAtIndex.tickBorderDash || [];
        var tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
        lineValue = getPixelForGridLine(this, i, offset);

        if (lineValue === undefined) {
          continue;
        }

        alignedLineValue = _alignPixel(chart, lineValue, lineWidth);

        if (isHorizontal) {
          tx1 = tx2 = x1 = x2 = alignedLineValue;
        } else {
          ty1 = ty2 = y1 = y2 = alignedLineValue;
        }

        items.push({
          tx1: tx1,
          ty1: ty1,
          tx2: tx2,
          ty2: ty2,
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          width: lineWidth,
          color: lineColor,
          borderDash: borderDash,
          borderDashOffset: borderDashOffset,
          tickWidth: tickWidth,
          tickColor: tickColor,
          tickBorderDash: tickBorderDash,
          tickBorderDashOffset: tickBorderDashOffset
        });
      }

      this._ticksLength = ticksLength;
      this._borderValue = borderValue;
      return items;
    }
  }, {
    key: "_computeLabelItems",
    value: function _computeLabelItems(chartArea) {
      var axis = this.axis;
      var options = this.options;
      var position = options.position,
          optionTicks = options.ticks;
      var isHorizontal = this.isHorizontal();
      var ticks = this.ticks;
      var align = optionTicks.align,
          crossAlign = optionTicks.crossAlign,
          padding = optionTicks.padding,
          mirror = optionTicks.mirror;
      var tl = getTickMarkLength(options.grid);
      var tickAndPadding = tl + padding;
      var hTickAndPadding = mirror ? -padding : tickAndPadding;
      var rotation = -toRadians(this.labelRotation);
      var items = [];
      var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
      var textBaseline = 'middle';

      if (position === 'top') {
        y = this.bottom - hTickAndPadding;
        textAlign = this._getXAxisLabelAlignment();
      } else if (position === 'bottom') {
        y = this.top + hTickAndPadding;
        textAlign = this._getXAxisLabelAlignment();
      } else if (position === 'left') {
        var ret = this._getYAxisLabelAlignment(tl);

        textAlign = ret.textAlign;
        x = ret.x;
      } else if (position === 'right') {
        var _ret2 = this._getYAxisLabelAlignment(tl);

        textAlign = _ret2.textAlign;
        x = _ret2.x;
      } else if (axis === 'x') {
        if (position === 'center') {
          y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
        } else if (isObject(position)) {
          var positionAxisID = Object.keys(position)[0];
          var value = position[positionAxisID];
          y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
        }

        textAlign = this._getXAxisLabelAlignment();
      } else if (axis === 'y') {
        if (position === 'center') {
          x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
        } else if (isObject(position)) {
          var _positionAxisID3 = Object.keys(position)[0];
          var _value3 = position[_positionAxisID3];
          x = this.chart.scales[_positionAxisID3].getPixelForValue(_value3);
        }

        textAlign = this._getYAxisLabelAlignment(tl).textAlign;
      }

      if (axis === 'y') {
        if (align === 'start') {
          textBaseline = 'top';
        } else if (align === 'end') {
          textBaseline = 'bottom';
        }
      }

      var labelSizes = this._getLabelSizes();

      for (i = 0, ilen = ticks.length; i < ilen; ++i) {
        tick = ticks[i];
        label = tick.label;
        var optsAtIndex = optionTicks.setContext(this.getContext(i));
        pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
        font = this._resolveTickFontOptions(i);
        lineHeight = font.lineHeight;
        lineCount = isArray(label) ? label.length : 1;
        var halfCount = lineCount / 2;
        var color = optsAtIndex.color;
        var strokeColor = optsAtIndex.textStrokeColor;
        var strokeWidth = optsAtIndex.textStrokeWidth;
        var tickTextAlign = textAlign;

        if (isHorizontal) {
          x = pixel;

          if (textAlign === 'inner') {
            if (i === ilen - 1) {
              tickTextAlign = !this.options.reverse ? 'right' : 'left';
            } else if (i === 0) {
              tickTextAlign = !this.options.reverse ? 'left' : 'right';
            } else {
              tickTextAlign = 'center';
            }
          }

          if (position === 'top') {
            if (crossAlign === 'near' || rotation !== 0) {
              textOffset = -lineCount * lineHeight + lineHeight / 2;
            } else if (crossAlign === 'center') {
              textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
            } else {
              textOffset = -labelSizes.highest.height + lineHeight / 2;
            }
          } else {
            if (crossAlign === 'near' || rotation !== 0) {
              textOffset = lineHeight / 2;
            } else if (crossAlign === 'center') {
              textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
            } else {
              textOffset = labelSizes.highest.height - lineCount * lineHeight;
            }
          }

          if (mirror) {
            textOffset *= -1;
          }
        } else {
          y = pixel;
          textOffset = (1 - lineCount) * lineHeight / 2;
        }

        var backdrop = void 0;

        if (optsAtIndex.showLabelBackdrop) {
          var labelPadding = toPadding(optsAtIndex.backdropPadding);
          var height = labelSizes.heights[i];
          var width = labelSizes.widths[i];
          var top = y + textOffset - labelPadding.top;
          var left = x - labelPadding.left;

          switch (textBaseline) {
            case 'middle':
              top -= height / 2;
              break;

            case 'bottom':
              top -= height;
              break;
          }

          switch (textAlign) {
            case 'center':
              left -= width / 2;
              break;

            case 'right':
              left -= width;
              break;
          }

          backdrop = {
            left: left,
            top: top,
            width: width + labelPadding.width,
            height: height + labelPadding.height,
            color: optsAtIndex.backdropColor
          };
        }

        items.push({
          rotation: rotation,
          label: label,
          font: font,
          color: color,
          strokeColor: strokeColor,
          strokeWidth: strokeWidth,
          textOffset: textOffset,
          textAlign: tickTextAlign,
          textBaseline: textBaseline,
          translation: [x, y],
          backdrop: backdrop
        });
      }

      return items;
    }
  }, {
    key: "_getXAxisLabelAlignment",
    value: function _getXAxisLabelAlignment() {
      var _this$options7 = this.options,
          position = _this$options7.position,
          ticks = _this$options7.ticks;
      var rotation = -toRadians(this.labelRotation);

      if (rotation) {
        return position === 'top' ? 'left' : 'right';
      }

      var align = 'center';

      if (ticks.align === 'start') {
        align = 'left';
      } else if (ticks.align === 'end') {
        align = 'right';
      } else if (ticks.align === 'inner') {
        align = 'inner';
      }

      return align;
    }
  }, {
    key: "_getYAxisLabelAlignment",
    value: function _getYAxisLabelAlignment(tl) {
      var _this$options8 = this.options,
          position = _this$options8.position,
          _this$options8$ticks = _this$options8.ticks,
          crossAlign = _this$options8$ticks.crossAlign,
          mirror = _this$options8$ticks.mirror,
          padding = _this$options8$ticks.padding;

      var labelSizes = this._getLabelSizes();

      var tickAndPadding = tl + padding;
      var widest = labelSizes.widest.width;
      var textAlign;
      var x;

      if (position === 'left') {
        if (mirror) {
          x = this.right + padding;

          if (crossAlign === 'near') {
            textAlign = 'left';
          } else if (crossAlign === 'center') {
            textAlign = 'center';
            x += widest / 2;
          } else {
            textAlign = 'right';
            x += widest;
          }
        } else {
          x = this.right - tickAndPadding;

          if (crossAlign === 'near') {
            textAlign = 'right';
          } else if (crossAlign === 'center') {
            textAlign = 'center';
            x -= widest / 2;
          } else {
            textAlign = 'left';
            x = this.left;
          }
        }
      } else if (position === 'right') {
        if (mirror) {
          x = this.left + padding;

          if (crossAlign === 'near') {
            textAlign = 'right';
          } else if (crossAlign === 'center') {
            textAlign = 'center';
            x -= widest / 2;
          } else {
            textAlign = 'left';
            x -= widest;
          }
        } else {
          x = this.left + tickAndPadding;

          if (crossAlign === 'near') {
            textAlign = 'left';
          } else if (crossAlign === 'center') {
            textAlign = 'center';
            x += widest / 2;
          } else {
            textAlign = 'right';
            x = this.right;
          }
        }
      } else {
        textAlign = 'right';
      }

      return {
        textAlign: textAlign,
        x: x
      };
    }
  }, {
    key: "_computeLabelArea",
    value: function _computeLabelArea() {
      if (this.options.ticks.mirror) {
        return;
      }

      var chart = this.chart;
      var position = this.options.position;

      if (position === 'left' || position === 'right') {
        return {
          top: 0,
          left: this.left,
          bottom: chart.height,
          right: this.right
        };
      }

      if (position === 'top' || position === 'bottom') {
        return {
          top: this.top,
          left: 0,
          bottom: this.bottom,
          right: chart.width
        };
      }
    }
  }, {
    key: "drawBackground",
    value: function drawBackground() {
      var ctx = this.ctx,
          backgroundColor = this.options.backgroundColor,
          left = this.left,
          top = this.top,
          width = this.width,
          height = this.height;

      if (backgroundColor) {
        ctx.save();
        ctx.fillStyle = backgroundColor;
        ctx.fillRect(left, top, width, height);
        ctx.restore();
      }
    }
  }, {
    key: "getLineWidthForValue",
    value: function getLineWidthForValue(value) {
      var grid = this.options.grid;

      if (!this._isVisible() || !grid.display) {
        return 0;
      }

      var ticks = this.ticks;
      var index = ticks.findIndex(function (t) {
        return t.value === value;
      });

      if (index >= 0) {
        var opts = grid.setContext(this.getContext(index));
        return opts.lineWidth;
      }

      return 0;
    }
  }, {
    key: "drawGrid",
    value: function drawGrid(chartArea) {
      var grid = this.options.grid;
      var ctx = this.ctx;

      var items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));

      var i, ilen;

      var drawLine = function drawLine(p1, p2, style) {
        if (!style.width || !style.color) {
          return;
        }

        ctx.save();
        ctx.lineWidth = style.width;
        ctx.strokeStyle = style.color;
        ctx.setLineDash(style.borderDash || []);
        ctx.lineDashOffset = style.borderDashOffset;
        ctx.beginPath();
        ctx.moveTo(p1.x, p1.y);
        ctx.lineTo(p2.x, p2.y);
        ctx.stroke();
        ctx.restore();
      };

      if (grid.display) {
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          var item = items[i];

          if (grid.drawOnChartArea) {
            drawLine({
              x: item.x1,
              y: item.y1
            }, {
              x: item.x2,
              y: item.y2
            }, item);
          }

          if (grid.drawTicks) {
            drawLine({
              x: item.tx1,
              y: item.ty1
            }, {
              x: item.tx2,
              y: item.ty2
            }, {
              color: item.tickColor,
              width: item.tickWidth,
              borderDash: item.tickBorderDash,
              borderDashOffset: item.tickBorderDashOffset
            });
          }
        }
      }
    }
  }, {
    key: "drawBorder",
    value: function drawBorder() {
      var chart = this.chart,
          ctx = this.ctx,
          grid = this.options.grid;
      var borderOpts = grid.setContext(this.getContext());
      var axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;

      if (!axisWidth) {
        return;
      }

      var lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
      var borderValue = this._borderValue;
      var x1, x2, y1, y2;

      if (this.isHorizontal()) {
        x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
        x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
        y1 = y2 = borderValue;
      } else {
        y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
        y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
        x1 = x2 = borderValue;
      }

      ctx.save();
      ctx.lineWidth = borderOpts.borderWidth;
      ctx.strokeStyle = borderOpts.borderColor;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.restore();
    }
  }, {
    key: "drawLabels",
    value: function drawLabels(chartArea) {
      var optionTicks = this.options.ticks;

      if (!optionTicks.display) {
        return;
      }

      var ctx = this.ctx;

      var area = this._computeLabelArea();

      if (area) {
        clipArea(ctx, area);
      }

      var items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));

      var i, ilen;

      for (i = 0, ilen = items.length; i < ilen; ++i) {
        var item = items[i];
        var tickFont = item.font;
        var label = item.label;

        if (item.backdrop) {
          ctx.fillStyle = item.backdrop.color;
          ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
        }

        var y = item.textOffset;
        renderText(ctx, label, 0, y, tickFont, item);
      }

      if (area) {
        unclipArea(ctx);
      }
    }
  }, {
    key: "drawTitle",
    value: function drawTitle() {
      var ctx = this.ctx,
          _this$options9 = this.options,
          position = _this$options9.position,
          title = _this$options9.title,
          reverse = _this$options9.reverse;

      if (!title.display) {
        return;
      }

      var font = toFont(title.font);
      var padding = toPadding(title.padding);
      var align = title.align;
      var offset = font.lineHeight / 2;

      if (position === 'bottom' || position === 'center' || isObject(position)) {
        offset += padding.bottom;

        if (isArray(title.text)) {
          offset += font.lineHeight * (title.text.length - 1);
        }
      } else {
        offset += padding.top;
      }

      var _titleArgs = titleArgs(this, offset, position, align),
          titleX = _titleArgs.titleX,
          titleY = _titleArgs.titleY,
          maxWidth = _titleArgs.maxWidth,
          rotation = _titleArgs.rotation;

      renderText(ctx, title.text, 0, 0, font, {
        color: title.color,
        maxWidth: maxWidth,
        rotation: rotation,
        textAlign: titleAlign(align, position, reverse),
        textBaseline: 'middle',
        translation: [titleX, titleY]
      });
    }
  }, {
    key: "draw",
    value: function draw(chartArea) {
      if (!this._isVisible()) {
        return;
      }

      this.drawBackground();
      this.drawGrid(chartArea);
      this.drawBorder();
      this.drawTitle();
      this.drawLabels(chartArea);
    }
  }, {
    key: "_layers",
    value: function _layers() {
      var _this22 = this;

      var opts = this.options;
      var tz = opts.ticks && opts.ticks.z || 0;
      var gz = valueOrDefault(opts.grid && opts.grid.z, -1);

      if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
        return [{
          z: tz,
          draw: function draw(chartArea) {
            _this22.draw(chartArea);
          }
        }];
      }

      return [{
        z: gz,
        draw: function draw(chartArea) {
          _this22.drawBackground();

          _this22.drawGrid(chartArea);

          _this22.drawTitle();
        }
      }, {
        z: gz + 1,
        draw: function draw() {
          _this22.drawBorder();
        }
      }, {
        z: tz,
        draw: function draw(chartArea) {
          _this22.drawLabels(chartArea);
        }
      }];
    }
  }, {
    key: "getMatchingVisibleMetas",
    value: function getMatchingVisibleMetas(type) {
      var metas = this.chart.getSortedVisibleDatasetMetas();
      var axisID = this.axis + 'AxisID';
      var result = [];
      var i, ilen;

      for (i = 0, ilen = metas.length; i < ilen; ++i) {
        var meta = metas[i];

        if (meta[axisID] === this.id && (!type || meta.type === type)) {
          result.push(meta);
        }
      }

      return result;
    }
  }, {
    key: "_resolveTickFontOptions",
    value: function _resolveTickFontOptions(index) {
      var opts = this.options.ticks.setContext(this.getContext(index));
      return toFont(opts.font);
    }
  }, {
    key: "_maxDigits",
    value: function _maxDigits() {
      var fontSize = this._resolveTickFontOptions(0).lineHeight;

      return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
  }]);

  return Scale;
}(Element);

var TypedRegistry = /*#__PURE__*/function () {
  function TypedRegistry(type, scope, override) {
    _classCallCheck(this, TypedRegistry);

    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = Object.create(null);
  }

  _createClass(TypedRegistry, [{
    key: "isForType",
    value: function isForType(type) {
      return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
  }, {
    key: "register",
    value: function register(item) {
      var proto = Object.getPrototypeOf(item);
      var parentScope;

      if (isIChartComponent(proto)) {
        parentScope = this.register(proto);
      }

      var items = this.items;
      var id = item.id;
      var scope = this.scope + '.' + id;

      if (!id) {
        throw new Error('class does not have id: ' + item);
      }

      if (id in items) {
        return scope;
      }

      items[id] = item;
      registerDefaults(item, scope, parentScope);

      if (this.override) {
        defaults.override(item.id, item.overrides);
      }

      return scope;
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.items[id];
    }
  }, {
    key: "unregister",
    value: function unregister(item) {
      var items = this.items;
      var id = item.id;
      var scope = this.scope;

      if (id in items) {
        delete items[id];
      }

      if (scope && id in defaults[scope]) {
        delete defaults[scope][id];

        if (this.override) {
          delete overrides[id];
        }
      }
    }
  }]);

  return TypedRegistry;
}();

function registerDefaults(item, scope, parentScope) {
  var itemDefaults = merge(Object.create(null), [parentScope ? defaults.get(parentScope) : {}, defaults.get(scope), item.defaults]);
  defaults.set(scope, itemDefaults);

  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }

  if (item.descriptors) {
    defaults.describe(scope, item.descriptors);
  }
}

function routeDefaults(scope, routes) {
  Object.keys(routes).forEach(function (property) {
    var propertyParts = property.split('.');
    var sourceName = propertyParts.pop();
    var sourceScope = [scope].concat(propertyParts).join('.');
    var parts = routes[property].split('.');
    var targetName = parts.pop();
    var targetScope = parts.join('.');
    defaults.route(sourceScope, sourceName, targetScope, targetName);
  });
}

function isIChartComponent(proto) {
  return 'id' in proto && 'defaults' in proto;
}

var Registry = /*#__PURE__*/function () {
  function Registry() {
    _classCallCheck(this, Registry);

    this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
    this.elements = new TypedRegistry(Element, 'elements');
    this.plugins = new TypedRegistry(Object, 'plugins');
    this.scales = new TypedRegistry(Scale, 'scales');
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }

  _createClass(Registry, [{
    key: "add",
    value: function add() {
      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }

      this._each('register', args);
    }
  }, {
    key: "remove",
    value: function remove() {
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }

      this._each('unregister', args);
    }
  }, {
    key: "addControllers",
    value: function addControllers() {
      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      this._each('register', args, this.controllers);
    }
  }, {
    key: "addElements",
    value: function addElements() {
      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }

      this._each('register', args, this.elements);
    }
  }, {
    key: "addPlugins",
    value: function addPlugins() {
      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }

      this._each('register', args, this.plugins);
    }
  }, {
    key: "addScales",
    value: function addScales() {
      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }

      this._each('register', args, this.scales);
    }
  }, {
    key: "getController",
    value: function getController(id) {
      return this._get(id, this.controllers, 'controller');
    }
  }, {
    key: "getElement",
    value: function getElement(id) {
      return this._get(id, this.elements, 'element');
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(id) {
      return this._get(id, this.plugins, 'plugin');
    }
  }, {
    key: "getScale",
    value: function getScale(id) {
      return this._get(id, this.scales, 'scale');
    }
  }, {
    key: "removeControllers",
    value: function removeControllers() {
      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }

      this._each('unregister', args, this.controllers);
    }
  }, {
    key: "removeElements",
    value: function removeElements() {
      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        args[_key21] = arguments[_key21];
      }

      this._each('unregister', args, this.elements);
    }
  }, {
    key: "removePlugins",
    value: function removePlugins() {
      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
        args[_key22] = arguments[_key22];
      }

      this._each('unregister', args, this.plugins);
    }
  }, {
    key: "removeScales",
    value: function removeScales() {
      for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
        args[_key23] = arguments[_key23];
      }

      this._each('unregister', args, this.scales);
    }
  }, {
    key: "_each",
    value: function _each(method, args, typedRegistry) {
      var _this23 = this;

      _toConsumableArray(args).forEach(function (arg) {
        var reg = typedRegistry || _this23._getRegistryForType(arg);

        if (typedRegistry || reg.isForType(arg) || reg === _this23.plugins && arg.id) {
          _this23._exec(method, reg, arg);
        } else {
          each(arg, function (item) {
            var itemReg = typedRegistry || _this23._getRegistryForType(item);

            _this23._exec(method, itemReg, item);
          });
        }
      });
    }
  }, {
    key: "_exec",
    value: function _exec(method, registry, component) {
      var camelMethod = _capitalize(method);

      callback(component['before' + camelMethod], [], component);
      registry[method](component);
      callback(component['after' + camelMethod], [], component);
    }
  }, {
    key: "_getRegistryForType",
    value: function _getRegistryForType(type) {
      for (var i = 0; i < this._typedRegistries.length; i++) {
        var reg = this._typedRegistries[i];

        if (reg.isForType(type)) {
          return reg;
        }
      }

      return this.plugins;
    }
  }, {
    key: "_get",
    value: function _get(id, typedRegistry, type) {
      var item = typedRegistry.get(id);

      if (item === undefined) {
        throw new Error('"' + id + '" is not a registered ' + type + '.');
      }

      return item;
    }
  }]);

  return Registry;
}();

var registry = new Registry();

var PluginService = /*#__PURE__*/function () {
  function PluginService() {
    _classCallCheck(this, PluginService);

    this._init = [];
  }

  _createClass(PluginService, [{
    key: "notify",
    value: function notify(chart, hook, args, filter) {
      if (hook === 'beforeInit') {
        this._init = this._createDescriptors(chart, true);

        this._notify(this._init, chart, 'install');
      }

      var descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);

      var result = this._notify(descriptors, chart, hook, args);

      if (hook === 'afterDestroy') {
        this._notify(descriptors, chart, 'stop');

        this._notify(this._init, chart, 'uninstall');
      }

      return result;
    }
  }, {
    key: "_notify",
    value: function _notify(descriptors, chart, hook, args) {
      args = args || {};

      var _iterator19 = _createForOfIteratorHelper(descriptors),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var descriptor = _step19.value;
          var plugin = descriptor.plugin;
          var method = plugin[hook];
          var params = [chart, args, descriptor.options];

          if (callback(method, params, plugin) === false && args.cancelable) {
            return false;
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      return true;
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      if (!isNullOrUndef(this._cache)) {
        this._oldCache = this._cache;
        this._cache = undefined;
      }
    }
  }, {
    key: "_descriptors",
    value: function _descriptors(chart) {
      if (this._cache) {
        return this._cache;
      }

      var descriptors = this._cache = this._createDescriptors(chart);

      this._notifyStateChanges(chart);

      return descriptors;
    }
  }, {
    key: "_createDescriptors",
    value: function _createDescriptors(chart, all) {
      var config = chart && chart.config;
      var options = valueOrDefault(config.options && config.options.plugins, {});
      var plugins = allPlugins(config);
      return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
  }, {
    key: "_notifyStateChanges",
    value: function _notifyStateChanges(chart) {
      var previousDescriptors = this._oldCache || [];
      var descriptors = this._cache;

      var diff = function diff(a, b) {
        return a.filter(function (x) {
          return !b.some(function (y) {
            return x.plugin.id === y.plugin.id;
          });
        });
      };

      this._notify(diff(previousDescriptors, descriptors), chart, 'stop');

      this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
  }]);

  return PluginService;
}();

function allPlugins(config) {
  var plugins = [];
  var keys = Object.keys(registry.plugins.items);

  for (var i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }

  var local = config.plugins || [];

  for (var _i17 = 0; _i17 < local.length; _i17++) {
    var plugin = local[_i17];

    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
    }
  }

  return plugins;
}

function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }

  if (options === true) {
    return {};
  }

  return options;
}

function createDescriptors(chart, plugins, options, all) {
  var result = [];
  var context = chart.getContext();

  for (var i = 0; i < plugins.length; i++) {
    var plugin = plugins[i];
    var id = plugin.id;
    var opts = getOpts(options[id], all);

    if (opts === null) {
      continue;
    }

    result.push({
      plugin: plugin,
      options: pluginOpts(chart.config, plugin, opts, context)
    });
  }

  return result;
}

function pluginOpts(config, plugin, opts, context) {
  var keys = config.pluginScopeKeys(plugin);
  var scopes = config.getOptionScopes(opts, keys);
  return config.createResolver(scopes, context, [''], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}

function getIndexAxis(type, options) {
  var datasetDefaults = defaults.datasets[type] || {};
  var datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}

function getAxisFromDefaultScaleID(id, indexAxis) {
  var axis = id;

  if (id === '_index_') {
    axis = indexAxis;
  } else if (id === '_value_') {
    axis = indexAxis === 'x' ? 'y' : 'x';
  }

  return axis;
}

function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? '_index_' : '_value_';
}

function axisFromPosition(position) {
  if (position === 'top' || position === 'bottom') {
    return 'x';
  }

  if (position === 'left' || position === 'right') {
    return 'y';
  }
}

function determineAxis(id, scaleOptions) {
  if (id === 'x' || id === 'y') {
    return id;
  }

  return scaleOptions.axis || axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}

function mergeScaleConfig(config, options) {
  var chartDefaults = overrides[config.type] || {
    scales: {}
  };
  var configScales = options.scales || {};
  var chartIndexAxis = getIndexAxis(config.type, options);
  var firstIDs = Object.create(null);
  var scales = Object.create(null);
  Object.keys(configScales).forEach(function (id) {
    var scaleConf = configScales[id];

    if (!isObject(scaleConf)) {
      return console.error("Invalid scale configuration for scale: ".concat(id));
    }

    if (scaleConf._proxy) {
      return console.warn("Ignoring resolver passed as options for scale: ".concat(id));
    }

    var axis = determineAxis(id, scaleConf);
    var defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    var defaultScaleOptions = chartDefaults.scales || {};
    firstIDs[axis] = firstIDs[axis] || id;
    scales[id] = mergeIf(Object.create(null), [{
      axis: axis
    }, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach(function (dataset) {
    var type = dataset.type || config.type;
    var indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    var datasetDefaults = overrides[type] || {};
    var defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach(function (defaultID) {
      var axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      var id = dataset[axis + 'AxisID'] || firstIDs[axis] || axis;
      scales[id] = scales[id] || Object.create(null);
      mergeIf(scales[id], [{
        axis: axis
      }, configScales[id], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales).forEach(function (key) {
    var scale = scales[key];
    mergeIf(scale, [defaults.scales[scale.type], defaults.scale]);
  });
  return scales;
}

function initOptions(config) {
  var options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}

function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}

function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}

var keyCache = new Map();
var keysCached = new Set();

function cachedKeys(cacheKey, generate) {
  var keys = keyCache.get(cacheKey);

  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }

  return keys;
}

var addIfFound = function addIfFound(set, obj, key) {
  var opts = resolveObjectKey(obj, key);

  if (opts !== undefined) {
    set.add(opts);
  }
};

var Config = /*#__PURE__*/function () {
  function Config(config) {
    _classCallCheck(this, Config);

    this._config = initConfig(config);
    this._scopeCache = new Map();
    this._resolverCache = new Map();
  }

  _createClass(Config, [{
    key: "platform",
    get: function get() {
      return this._config.platform;
    }
  }, {
    key: "type",
    get: function get() {
      return this._config.type;
    },
    set: function set(type) {
      this._config.type = type;
    }
  }, {
    key: "data",
    get: function get() {
      return this._config.data;
    },
    set: function set(data) {
      this._config.data = initData(data);
    }
  }, {
    key: "options",
    get: function get() {
      return this._config.options;
    },
    set: function set(options) {
      this._config.options = options;
    }
  }, {
    key: "plugins",
    get: function get() {
      return this._config.plugins;
    }
  }, {
    key: "update",
    value: function update() {
      var config = this._config;
      this.clearCache();
      initOptions(config);
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this._scopeCache.clear();

      this._resolverCache.clear();
    }
  }, {
    key: "datasetScopeKeys",
    value: function datasetScopeKeys(datasetType) {
      return cachedKeys(datasetType, function () {
        return [["datasets.".concat(datasetType), '']];
      });
    }
  }, {
    key: "datasetAnimationScopeKeys",
    value: function datasetAnimationScopeKeys(datasetType, transition) {
      return cachedKeys("".concat(datasetType, ".transition.").concat(transition), function () {
        return [["datasets.".concat(datasetType, ".transitions.").concat(transition), "transitions.".concat(transition)], ["datasets.".concat(datasetType), '']];
      });
    }
  }, {
    key: "datasetElementScopeKeys",
    value: function datasetElementScopeKeys(datasetType, elementType) {
      return cachedKeys("".concat(datasetType, "-").concat(elementType), function () {
        return [["datasets.".concat(datasetType, ".elements.").concat(elementType), "datasets.".concat(datasetType), "elements.".concat(elementType), '']];
      });
    }
  }, {
    key: "pluginScopeKeys",
    value: function pluginScopeKeys(plugin) {
      var id = plugin.id;
      var type = this.type;
      return cachedKeys("".concat(type, "-plugin-").concat(id), function () {
        return [["plugins.".concat(id)].concat(_toConsumableArray(plugin.additionalOptionScopes || []))];
      });
    }
  }, {
    key: "_cachedScopes",
    value: function _cachedScopes(mainScope, resetCache) {
      var _scopeCache = this._scopeCache;

      var cache = _scopeCache.get(mainScope);

      if (!cache || resetCache) {
        cache = new Map();

        _scopeCache.set(mainScope, cache);
      }

      return cache;
    }
  }, {
    key: "getOptionScopes",
    value: function getOptionScopes(mainScope, keyLists, resetCache) {
      var options = this.options,
          type = this.type;

      var cache = this._cachedScopes(mainScope, resetCache);

      var cached = cache.get(keyLists);

      if (cached) {
        return cached;
      }

      var scopes = new Set();
      keyLists.forEach(function (keys) {
        if (mainScope) {
          scopes.add(mainScope);
          keys.forEach(function (key) {
            return addIfFound(scopes, mainScope, key);
          });
        }

        keys.forEach(function (key) {
          return addIfFound(scopes, options, key);
        });
        keys.forEach(function (key) {
          return addIfFound(scopes, overrides[type] || {}, key);
        });
        keys.forEach(function (key) {
          return addIfFound(scopes, defaults, key);
        });
        keys.forEach(function (key) {
          return addIfFound(scopes, descriptors, key);
        });
      });
      var array = Array.from(scopes);

      if (array.length === 0) {
        array.push(Object.create(null));
      }

      if (keysCached.has(keyLists)) {
        cache.set(keyLists, array);
      }

      return array;
    }
  }, {
    key: "chartOptionScopes",
    value: function chartOptionScopes() {
      var options = this.options,
          type = this.type;
      return [options, overrides[type] || {}, defaults.datasets[type] || {}, {
        type: type
      }, defaults, descriptors];
    }
  }, {
    key: "resolveNamedOptions",
    value: function resolveNamedOptions(scopes, names, context) {
      var prefixes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [''];
      var result = {
        $shared: true
      };

      var _getResolver = getResolver(this._resolverCache, scopes, prefixes),
          resolver = _getResolver.resolver,
          subPrefixes = _getResolver.subPrefixes;

      var options = resolver;

      if (needContext(resolver, names)) {
        result.$shared = false;
        context = isFunction(context) ? context() : context;
        var subResolver = this.createResolver(scopes, context, subPrefixes);
        options = _attachContext(resolver, context, subResolver);
      }

      var _iterator20 = _createForOfIteratorHelper(names),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var prop = _step20.value;
          result[prop] = options[prop];
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      return result;
    }
  }, {
    key: "createResolver",
    value: function createResolver(scopes, context) {
      var prefixes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [''];
      var descriptorDefaults = arguments.length > 3 ? arguments[3] : undefined;

      var _getResolver2 = getResolver(this._resolverCache, scopes, prefixes),
          resolver = _getResolver2.resolver;

      return isObject(context) ? _attachContext(resolver, context, undefined, descriptorDefaults) : resolver;
    }
  }]);

  return Config;
}();

function getResolver(resolverCache, scopes, prefixes) {
  var cache = resolverCache.get(scopes);

  if (!cache) {
    cache = new Map();
    resolverCache.set(scopes, cache);
  }

  var cacheKey = prefixes.join();
  var cached = cache.get(cacheKey);

  if (!cached) {
    var resolver = _createResolver(scopes, prefixes);

    cached = {
      resolver: resolver,
      subPrefixes: prefixes.filter(function (p) {
        return !p.toLowerCase().includes('hover');
      })
    };
    cache.set(cacheKey, cached);
  }

  return cached;
}

var hasFunction = function hasFunction(value) {
  return isObject(value) && Object.getOwnPropertyNames(value).reduce(function (acc, key) {
    return acc || isFunction(value[key]);
  }, false);
};

function needContext(proxy, names) {
  var _descriptors2 = _descriptors(proxy),
      isScriptable = _descriptors2.isScriptable,
      isIndexable = _descriptors2.isIndexable;

  var _iterator21 = _createForOfIteratorHelper(names),
      _step21;

  try {
    for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
      var prop = _step21.value;
      var scriptable = isScriptable(prop);
      var indexable = isIndexable(prop);
      var value = (indexable || scriptable) && proxy[prop];

      if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
        return true;
      }
    }
  } catch (err) {
    _iterator21.e(err);
  } finally {
    _iterator21.f();
  }

  return false;
}

var version = "3.8.0";
var KNOWN_POSITIONS = ['top', 'bottom', 'left', 'right', 'chartArea'];

function positionIsHorizontal(position, axis) {
  return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}

function compare2Level(l1, l2) {
  return function (a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}

function onAnimationsComplete(context) {
  var chart = context.chart;
  var animationOptions = chart.options.animation;
  chart.notifyPlugins('afterRender');
  callback(animationOptions && animationOptions.onComplete, [context], chart);
}

function onAnimationProgress(context) {
  var chart = context.chart;
  var animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [context], chart);
}

function getCanvas(item) {
  if (_isDomSupported() && typeof item === 'string') {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }

  if (item && item.canvas) {
    item = item.canvas;
  }

  return item;
}

var instances = {};

var getChart = function getChart(key) {
  var canvas = getCanvas(key);
  return Object.values(instances).filter(function (c) {
    return c.canvas === canvas;
  }).pop();
};

function moveNumericKeys(obj, start, move) {
  var keys = Object.keys(obj);

  for (var _i18 = 0, _keys = keys; _i18 < _keys.length; _i18++) {
    var key = _keys[_i18];
    var intKey = +key;

    if (intKey >= start) {
      var value = obj[key];
      delete obj[key];

      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}

function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === 'mouseout') {
    return null;
  }

  if (isClick) {
    return lastEvent;
  }

  return e;
}

var Chart = /*#__PURE__*/function () {
  function Chart(item, userConfig) {
    var _this24 = this;

    _classCallCheck(this, Chart);

    var config = this.config = new Config(userConfig);
    var initialCanvas = getCanvas(item);
    var existingChart = getChart(initialCanvas);

    if (existingChart) {
      throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas can be reused.');
    }

    var options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    var context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    var canvas = context && context.canvas;
    var height = canvas && canvas.height;
    var width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = undefined;
    this.boxes = [];
    this.currentDevicePixelRatio = undefined;
    this.chartArea = undefined;
    this._active = [];
    this._lastEvent = undefined;
    this._listeners = {};
    this._responsiveListeners = undefined;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = undefined;
    this.$context = undefined;
    this._doResize = debounce(function (mode) {
      return _this24.update(mode);
    }, options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;

    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }

    animator.listen(this, 'complete', onAnimationsComplete);
    animator.listen(this, 'progress', onAnimationProgress);

    this._initialize();

    if (this.attached) {
      this.update();
    }
  }

  _createClass(Chart, [{
    key: "aspectRatio",
    get: function get() {
      var _this$options10 = this.options,
          aspectRatio = _this$options10.aspectRatio,
          maintainAspectRatio = _this$options10.maintainAspectRatio,
          width = this.width,
          height = this.height,
          _aspectRatio = this._aspectRatio;

      if (!isNullOrUndef(aspectRatio)) {
        return aspectRatio;
      }

      if (maintainAspectRatio && _aspectRatio) {
        return _aspectRatio;
      }

      return height ? width / height : null;
    }
  }, {
    key: "data",
    get: function get() {
      return this.config.data;
    },
    set: function set(data) {
      this.config.data = data;
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    },
    set: function set(options) {
      this.config.options = options;
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      this.notifyPlugins('beforeInit');

      if (this.options.responsive) {
        this.resize();
      } else {
        retinaScale(this, this.options.devicePixelRatio);
      }

      this.bindEvents();
      this.notifyPlugins('afterInit');
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      clearCanvas(this.canvas, this.ctx);
      return this;
    }
  }, {
    key: "stop",
    value: function stop() {
      animator.stop(this);
      return this;
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      if (!animator.running(this)) {
        this._resize(width, height);
      } else {
        this._resizeBeforeDraw = {
          width: width,
          height: height
        };
      }
    }
  }, {
    key: "_resize",
    value: function _resize(width, height) {
      var options = this.options;
      var canvas = this.canvas;
      var aspectRatio = options.maintainAspectRatio && this.aspectRatio;
      var newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
      var newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
      var mode = this.width ? 'resize' : 'attach';
      this.width = newSize.width;
      this.height = newSize.height;
      this._aspectRatio = this.aspectRatio;

      if (!retinaScale(this, newRatio, true)) {
        return;
      }

      this.notifyPlugins('resize', {
        size: newSize
      });
      callback(options.onResize, [this, newSize], this);

      if (this.attached) {
        if (this._doResize(mode)) {
          this.render();
        }
      }
    }
  }, {
    key: "ensureScalesHaveIDs",
    value: function ensureScalesHaveIDs() {
      var options = this.options;
      var scalesOptions = options.scales || {};
      each(scalesOptions, function (axisOptions, axisID) {
        axisOptions.id = axisID;
      });
    }
  }, {
    key: "buildOrUpdateScales",
    value: function buildOrUpdateScales() {
      var _this25 = this;

      var options = this.options;
      var scaleOpts = options.scales;
      var scales = this.scales;
      var updated = Object.keys(scales).reduce(function (obj, id) {
        obj[id] = false;
        return obj;
      }, {});
      var items = [];

      if (scaleOpts) {
        items = items.concat(Object.keys(scaleOpts).map(function (id) {
          var scaleOptions = scaleOpts[id];
          var axis = determineAxis(id, scaleOptions);
          var isRadial = axis === 'r';
          var isHorizontal = axis === 'x';
          return {
            options: scaleOptions,
            dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
            dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
          };
        }));
      }

      each(items, function (item) {
        var scaleOptions = item.options;
        var id = scaleOptions.id;
        var axis = determineAxis(id, scaleOptions);
        var scaleType = valueOrDefault(scaleOptions.type, item.dtype);

        if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
          scaleOptions.position = item.dposition;
        }

        updated[id] = true;
        var scale = null;

        if (id in scales && scales[id].type === scaleType) {
          scale = scales[id];
        } else {
          var scaleClass = registry.getScale(scaleType);
          scale = new scaleClass({
            id: id,
            type: scaleType,
            ctx: _this25.ctx,
            chart: _this25
          });
          scales[scale.id] = scale;
        }

        scale.init(scaleOptions, options);
      });
      each(updated, function (hasUpdated, id) {
        if (!hasUpdated) {
          delete scales[id];
        }
      });
      each(scales, function (scale) {
        layouts.configure(_this25, scale, scale.options);
        layouts.addBox(_this25, scale);
      });
    }
  }, {
    key: "_updateMetasets",
    value: function _updateMetasets() {
      var metasets = this._metasets;
      var numData = this.data.datasets.length;
      var numMeta = metasets.length;
      metasets.sort(function (a, b) {
        return a.index - b.index;
      });

      if (numMeta > numData) {
        for (var i = numData; i < numMeta; ++i) {
          this._destroyDatasetMeta(i);
        }

        metasets.splice(numData, numMeta - numData);
      }

      this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
  }, {
    key: "_removeUnreferencedMetasets",
    value: function _removeUnreferencedMetasets() {
      var _this26 = this;

      var metasets = this._metasets,
          datasets = this.data.datasets;

      if (metasets.length > datasets.length) {
        delete this._stacks;
      }

      metasets.forEach(function (meta, index) {
        if (datasets.filter(function (x) {
          return x === meta._dataset;
        }).length === 0) {
          _this26._destroyDatasetMeta(index);
        }
      });
    }
  }, {
    key: "buildOrUpdateControllers",
    value: function buildOrUpdateControllers() {
      var newControllers = [];
      var datasets = this.data.datasets;
      var i, ilen;

      this._removeUnreferencedMetasets();

      for (i = 0, ilen = datasets.length; i < ilen; i++) {
        var dataset = datasets[i];
        var meta = this.getDatasetMeta(i);
        var type = dataset.type || this.config.type;

        if (meta.type && meta.type !== type) {
          this._destroyDatasetMeta(i);

          meta = this.getDatasetMeta(i);
        }

        meta.type = type;
        meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
        meta.order = dataset.order || 0;
        meta.index = i;
        meta.label = '' + dataset.label;
        meta.visible = this.isDatasetVisible(i);

        if (meta.controller) {
          meta.controller.updateIndex(i);
          meta.controller.linkScales();
        } else {
          var ControllerClass = registry.getController(type);
          var _defaults$datasets$ty = defaults.datasets[type],
              datasetElementType = _defaults$datasets$ty.datasetElementType,
              dataElementType = _defaults$datasets$ty.dataElementType;
          Object.assign(ControllerClass.prototype, {
            dataElementType: registry.getElement(dataElementType),
            datasetElementType: datasetElementType && registry.getElement(datasetElementType)
          });
          meta.controller = new ControllerClass(this, i);
          newControllers.push(meta.controller);
        }
      }

      this._updateMetasets();

      return newControllers;
    }
  }, {
    key: "_resetElements",
    value: function _resetElements() {
      var _this27 = this;

      each(this.data.datasets, function (dataset, datasetIndex) {
        _this27.getDatasetMeta(datasetIndex).controller.reset();
      }, this);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._resetElements();

      this.notifyPlugins('reset');
    }
  }, {
    key: "update",
    value: function update(mode) {
      var config = this.config;
      config.update();
      var options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
      var animsDisabled = this._animationsDisabled = !options.animation;

      this._updateScales();

      this._checkEventBindings();

      this._updateHiddenIndices();

      this._plugins.invalidate();

      if (this.notifyPlugins('beforeUpdate', {
        mode: mode,
        cancelable: true
      }) === false) {
        return;
      }

      var newControllers = this.buildOrUpdateControllers();
      this.notifyPlugins('beforeElementsUpdate');
      var minPadding = 0;

      for (var i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
        var _this$getDatasetMeta = this.getDatasetMeta(i),
            controller = _this$getDatasetMeta.controller;

        var reset = !animsDisabled && newControllers.indexOf(controller) === -1;
        controller.buildOrUpdateElements(reset);
        minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
      }

      minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;

      this._updateLayout(minPadding);

      if (!animsDisabled) {
        each(newControllers, function (controller) {
          controller.reset();
        });
      }

      this._updateDatasets(mode);

      this.notifyPlugins('afterUpdate', {
        mode: mode
      });

      this._layers.sort(compare2Level('z', '_idx'));

      var _active = this._active,
          _lastEvent = this._lastEvent;

      if (_lastEvent) {
        this._eventHandler(_lastEvent, true);
      } else if (_active.length) {
        this._updateHoverStyles(_active, _active, true);
      }

      this.render();
    }
  }, {
    key: "_updateScales",
    value: function _updateScales() {
      var _this28 = this;

      each(this.scales, function (scale) {
        layouts.removeBox(_this28, scale);
      });
      this.ensureScalesHaveIDs();
      this.buildOrUpdateScales();
    }
  }, {
    key: "_checkEventBindings",
    value: function _checkEventBindings() {
      var options = this.options;
      var existingEvents = new Set(Object.keys(this._listeners));
      var newEvents = new Set(options.events);

      if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
        this.unbindEvents();
        this.bindEvents();
      }
    }
  }, {
    key: "_updateHiddenIndices",
    value: function _updateHiddenIndices() {
      var _hiddenIndices = this._hiddenIndices;
      var changes = this._getUniformDataChanges() || [];

      var _iterator22 = _createForOfIteratorHelper(changes),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _step22$value = _step22.value,
              method = _step22$value.method,
              start = _step22$value.start,
              count = _step22$value.count;
          var move = method === '_removeElements' ? -count : count;
          moveNumericKeys(_hiddenIndices, start, move);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }
  }, {
    key: "_getUniformDataChanges",
    value: function _getUniformDataChanges() {
      var _dataChanges = this._dataChanges;

      if (!_dataChanges || !_dataChanges.length) {
        return;
      }

      this._dataChanges = [];
      var datasetCount = this.data.datasets.length;

      var makeSet = function makeSet(idx) {
        return new Set(_dataChanges.filter(function (c) {
          return c[0] === idx;
        }).map(function (c, i) {
          return i + ',' + c.splice(1).join(',');
        }));
      };

      var changeSet = makeSet(0);

      for (var i = 1; i < datasetCount; i++) {
        if (!setsEqual(changeSet, makeSet(i))) {
          return;
        }
      }

      return Array.from(changeSet).map(function (c) {
        return c.split(',');
      }).map(function (a) {
        return {
          method: a[1],
          start: +a[2],
          count: +a[3]
        };
      });
    }
  }, {
    key: "_updateLayout",
    value: function _updateLayout(minPadding) {
      var _this29 = this;

      if (this.notifyPlugins('beforeLayout', {
        cancelable: true
      }) === false) {
        return;
      }

      layouts.update(this, this.width, this.height, minPadding);
      var area = this.chartArea;
      var noArea = area.width <= 0 || area.height <= 0;
      this._layers = [];
      each(this.boxes, function (box) {
        var _this29$_layers;

        if (noArea && box.position === 'chartArea') {
          return;
        }

        if (box.configure) {
          box.configure();
        }

        (_this29$_layers = _this29._layers).push.apply(_this29$_layers, _toConsumableArray(box._layers()));
      }, this);

      this._layers.forEach(function (item, index) {
        item._idx = index;
      });

      this.notifyPlugins('afterLayout');
    }
  }, {
    key: "_updateDatasets",
    value: function _updateDatasets(mode) {
      if (this.notifyPlugins('beforeDatasetsUpdate', {
        mode: mode,
        cancelable: true
      }) === false) {
        return;
      }

      for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
        this.getDatasetMeta(i).controller.configure();
      }

      for (var _i19 = 0, _ilen = this.data.datasets.length; _i19 < _ilen; ++_i19) {
        this._updateDataset(_i19, isFunction(mode) ? mode({
          datasetIndex: _i19
        }) : mode);
      }

      this.notifyPlugins('afterDatasetsUpdate', {
        mode: mode
      });
    }
  }, {
    key: "_updateDataset",
    value: function _updateDataset(index, mode) {
      var meta = this.getDatasetMeta(index);
      var args = {
        meta: meta,
        index: index,
        mode: mode,
        cancelable: true
      };

      if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
        return;
      }

      meta.controller._update(mode);

      args.cancelable = false;
      this.notifyPlugins('afterDatasetUpdate', args);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.notifyPlugins('beforeRender', {
        cancelable: true
      }) === false) {
        return;
      }

      if (animator.has(this)) {
        if (this.attached && !animator.running(this)) {
          animator.start(this);
        }
      } else {
        this.draw();
        onAnimationsComplete({
          chart: this
        });
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var i;

      if (this._resizeBeforeDraw) {
        var _this$_resizeBeforeDr = this._resizeBeforeDraw,
            width = _this$_resizeBeforeDr.width,
            height = _this$_resizeBeforeDr.height;

        this._resize(width, height);

        this._resizeBeforeDraw = null;
      }

      this.clear();

      if (this.width <= 0 || this.height <= 0) {
        return;
      }

      if (this.notifyPlugins('beforeDraw', {
        cancelable: true
      }) === false) {
        return;
      }

      var layers = this._layers;

      for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
        layers[i].draw(this.chartArea);
      }

      this._drawDatasets();

      for (; i < layers.length; ++i) {
        layers[i].draw(this.chartArea);
      }

      this.notifyPlugins('afterDraw');
    }
  }, {
    key: "_getSortedDatasetMetas",
    value: function _getSortedDatasetMetas(filterVisible) {
      var metasets = this._sortedMetasets;
      var result = [];
      var i, ilen;

      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        var meta = metasets[i];

        if (!filterVisible || meta.visible) {
          result.push(meta);
        }
      }

      return result;
    }
  }, {
    key: "getSortedVisibleDatasetMetas",
    value: function getSortedVisibleDatasetMetas() {
      return this._getSortedDatasetMetas(true);
    }
  }, {
    key: "_drawDatasets",
    value: function _drawDatasets() {
      if (this.notifyPlugins('beforeDatasetsDraw', {
        cancelable: true
      }) === false) {
        return;
      }

      var metasets = this.getSortedVisibleDatasetMetas();

      for (var i = metasets.length - 1; i >= 0; --i) {
        this._drawDataset(metasets[i]);
      }

      this.notifyPlugins('afterDatasetsDraw');
    }
  }, {
    key: "_drawDataset",
    value: function _drawDataset(meta) {
      var ctx = this.ctx;
      var clip = meta._clip;
      var useClip = !clip.disabled;
      var area = this.chartArea;
      var args = {
        meta: meta,
        index: meta.index,
        cancelable: true
      };

      if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
        return;
      }

      if (useClip) {
        clipArea(ctx, {
          left: clip.left === false ? 0 : area.left - clip.left,
          right: clip.right === false ? this.width : area.right + clip.right,
          top: clip.top === false ? 0 : area.top - clip.top,
          bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
      }

      meta.controller.draw();

      if (useClip) {
        unclipArea(ctx);
      }

      args.cancelable = false;
      this.notifyPlugins('afterDatasetDraw', args);
    }
  }, {
    key: "isPointInArea",
    value: function isPointInArea(point) {
      return _isPointInArea(point, this.chartArea, this._minPadding);
    }
  }, {
    key: "getElementsAtEventForMode",
    value: function getElementsAtEventForMode(e, mode, options, useFinalPosition) {
      var method = Interaction.modes[mode];

      if (typeof method === 'function') {
        return method(this, e, options, useFinalPosition);
      }

      return [];
    }
  }, {
    key: "getDatasetMeta",
    value: function getDatasetMeta(datasetIndex) {
      var dataset = this.data.datasets[datasetIndex];
      var metasets = this._metasets;
      var meta = metasets.filter(function (x) {
        return x && x._dataset === dataset;
      }).pop();

      if (!meta) {
        meta = {
          type: null,
          data: [],
          dataset: null,
          controller: null,
          hidden: null,
          xAxisID: null,
          yAxisID: null,
          order: dataset && dataset.order || 0,
          index: datasetIndex,
          _dataset: dataset,
          _parsed: [],
          _sorted: false
        };
        metasets.push(meta);
      }

      return meta;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.$context || (this.$context = createContext(null, {
        chart: this,
        type: 'chart'
      }));
    }
  }, {
    key: "getVisibleDatasetCount",
    value: function getVisibleDatasetCount() {
      return this.getSortedVisibleDatasetMetas().length;
    }
  }, {
    key: "isDatasetVisible",
    value: function isDatasetVisible(datasetIndex) {
      var dataset = this.data.datasets[datasetIndex];

      if (!dataset) {
        return false;
      }

      var meta = this.getDatasetMeta(datasetIndex);
      return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
  }, {
    key: "setDatasetVisibility",
    value: function setDatasetVisibility(datasetIndex, visible) {
      var meta = this.getDatasetMeta(datasetIndex);
      meta.hidden = !visible;
    }
  }, {
    key: "toggleDataVisibility",
    value: function toggleDataVisibility(index) {
      this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
  }, {
    key: "getDataVisibility",
    value: function getDataVisibility(index) {
      return !this._hiddenIndices[index];
    }
  }, {
    key: "_updateVisibility",
    value: function _updateVisibility(datasetIndex, dataIndex, visible) {
      var mode = visible ? 'show' : 'hide';
      var meta = this.getDatasetMeta(datasetIndex);

      var anims = meta.controller._resolveAnimations(undefined, mode);

      if (defined(dataIndex)) {
        meta.data[dataIndex].hidden = !visible;
        this.update();
      } else {
        this.setDatasetVisibility(datasetIndex, visible);
        anims.update(meta, {
          visible: visible
        });
        this.update(function (ctx) {
          return ctx.datasetIndex === datasetIndex ? mode : undefined;
        });
      }
    }
  }, {
    key: "hide",
    value: function hide(datasetIndex, dataIndex) {
      this._updateVisibility(datasetIndex, dataIndex, false);
    }
  }, {
    key: "show",
    value: function show(datasetIndex, dataIndex) {
      this._updateVisibility(datasetIndex, dataIndex, true);
    }
  }, {
    key: "_destroyDatasetMeta",
    value: function _destroyDatasetMeta(datasetIndex) {
      var meta = this._metasets[datasetIndex];

      if (meta && meta.controller) {
        meta.controller._destroy();
      }

      delete this._metasets[datasetIndex];
    }
  }, {
    key: "_stop",
    value: function _stop() {
      var i, ilen;
      this.stop();
      animator.remove(this);

      for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
        this._destroyDatasetMeta(i);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.notifyPlugins('beforeDestroy');
      var canvas = this.canvas,
          ctx = this.ctx;

      this._stop();

      this.config.clearCache();

      if (canvas) {
        this.unbindEvents();
        clearCanvas(canvas, ctx);
        this.platform.releaseContext(ctx);
        this.canvas = null;
        this.ctx = null;
      }

      this.notifyPlugins('destroy');
      delete instances[this.id];
      this.notifyPlugins('afterDestroy');
    }
  }, {
    key: "toBase64Image",
    value: function toBase64Image() {
      var _this$canvas;

      return (_this$canvas = this.canvas).toDataURL.apply(_this$canvas, arguments);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.bindUserEvents();

      if (this.options.responsive) {
        this.bindResponsiveEvents();
      } else {
        this.attached = true;
      }
    }
  }, {
    key: "bindUserEvents",
    value: function bindUserEvents() {
      var _this30 = this;

      var listeners = this._listeners;
      var platform = this.platform;

      var _add = function _add(type, listener) {
        platform.addEventListener(_this30, type, listener);
        listeners[type] = listener;
      };

      var listener = function listener(e, x, y) {
        e.offsetX = x;
        e.offsetY = y;

        _this30._eventHandler(e);
      };

      each(this.options.events, function (type) {
        return _add(type, listener);
      });
    }
  }, {
    key: "bindResponsiveEvents",
    value: function bindResponsiveEvents() {
      var _this31 = this;

      if (!this._responsiveListeners) {
        this._responsiveListeners = {};
      }

      var listeners = this._responsiveListeners;
      var platform = this.platform;

      var _add = function _add(type, listener) {
        platform.addEventListener(_this31, type, listener);
        listeners[type] = listener;
      };

      var _remove = function _remove(type, listener) {
        if (listeners[type]) {
          platform.removeEventListener(_this31, type, listener);
          delete listeners[type];
        }
      };

      var listener = function listener(width, height) {
        if (_this31.canvas) {
          _this31.resize(width, height);
        }
      };

      var detached;

      var attached = function attached() {
        _remove('attach', attached);

        _this31.attached = true;

        _this31.resize();

        _add('resize', listener);

        _add('detach', detached);
      };

      detached = function detached() {
        _this31.attached = false;

        _remove('resize', listener);

        _this31._stop();

        _this31._resize(0, 0);

        _add('attach', attached);
      };

      if (platform.isAttached(this.canvas)) {
        attached();
      } else {
        detached();
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var _this32 = this;

      each(this._listeners, function (listener, type) {
        _this32.platform.removeEventListener(_this32, type, listener);
      });
      this._listeners = {};
      each(this._responsiveListeners, function (listener, type) {
        _this32.platform.removeEventListener(_this32, type, listener);
      });
      this._responsiveListeners = undefined;
    }
  }, {
    key: "updateHoverStyle",
    value: function updateHoverStyle(items, mode, enabled) {
      var prefix = enabled ? 'set' : 'remove';
      var meta, item, i, ilen;

      if (mode === 'dataset') {
        meta = this.getDatasetMeta(items[0].datasetIndex);
        meta.controller['_' + prefix + 'DatasetHoverStyle']();
      }

      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        var controller = item && this.getDatasetMeta(item.datasetIndex).controller;

        if (controller) {
          controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
      }
    }
  }, {
    key: "getActiveElements",
    value: function getActiveElements() {
      return this._active || [];
    }
  }, {
    key: "setActiveElements",
    value: function setActiveElements(activeElements) {
      var _this33 = this;

      var lastActive = this._active || [];
      var active = activeElements.map(function (_ref6) {
        var datasetIndex = _ref6.datasetIndex,
            index = _ref6.index;

        var meta = _this33.getDatasetMeta(datasetIndex);

        if (!meta) {
          throw new Error('No dataset found at index ' + datasetIndex);
        }

        return {
          datasetIndex: datasetIndex,
          element: meta.data[index],
          index: index
        };
      });
      var changed = !_elementsEqual(active, lastActive);

      if (changed) {
        this._active = active;
        this._lastEvent = null;

        this._updateHoverStyles(active, lastActive);
      }
    }
  }, {
    key: "notifyPlugins",
    value: function notifyPlugins(hook, args, filter) {
      return this._plugins.notify(this, hook, args, filter);
    }
  }, {
    key: "_updateHoverStyles",
    value: function _updateHoverStyles(active, lastActive, replay) {
      var hoverOptions = this.options.hover;

      var diff = function diff(a, b) {
        return a.filter(function (x) {
          return !b.some(function (y) {
            return x.datasetIndex === y.datasetIndex && x.index === y.index;
          });
        });
      };

      var deactivated = diff(lastActive, active);
      var activated = replay ? active : diff(active, lastActive);

      if (deactivated.length) {
        this.updateHoverStyle(deactivated, hoverOptions.mode, false);
      }

      if (activated.length && hoverOptions.mode) {
        this.updateHoverStyle(activated, hoverOptions.mode, true);
      }
    }
  }, {
    key: "_eventHandler",
    value: function _eventHandler(e, replay) {
      var _this34 = this;

      var args = {
        event: e,
        replay: replay,
        cancelable: true,
        inChartArea: this.isPointInArea(e)
      };

      var eventFilter = function eventFilter(plugin) {
        return (plugin.options.events || _this34.options.events).includes(e["native"].type);
      };

      if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
        return;
      }

      var changed = this._handleEvent(e, replay, args.inChartArea);

      args.cancelable = false;
      this.notifyPlugins('afterEvent', args, eventFilter);

      if (changed || args.changed) {
        this.render();
      }

      return this;
    }
  }, {
    key: "_handleEvent",
    value: function _handleEvent(e, replay, inChartArea) {
      var _this$_active = this._active,
          lastActive = _this$_active === void 0 ? [] : _this$_active,
          options = this.options;
      var useFinalPosition = replay;

      var active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);

      var isClick = _isClickEvent(e);

      var lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);

      if (inChartArea) {
        this._lastEvent = null;
        callback(options.onHover, [e, active, this], this);

        if (isClick) {
          callback(options.onClick, [e, active, this], this);
        }
      }

      var changed = !_elementsEqual(active, lastActive);

      if (changed || replay) {
        this._active = active;

        this._updateHoverStyles(active, lastActive, replay);
      }

      this._lastEvent = lastEvent;
      return changed;
    }
  }, {
    key: "_getActiveElements",
    value: function _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
      if (e.type === 'mouseout') {
        return [];
      }

      if (!inChartArea) {
        return lastActive;
      }

      var hoverOptions = this.options.hover;
      return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
  }]);

  return Chart;
}();

var invalidatePlugins = function invalidatePlugins() {
  return each(Chart.instances, function (chart) {
    return chart._plugins.invalidate();
  });
};

var enumerable = true;
Object.defineProperties(Chart, {
  defaults: {
    enumerable: enumerable,
    value: defaults
  },
  instances: {
    enumerable: enumerable,
    value: instances
  },
  overrides: {
    enumerable: enumerable,
    value: overrides
  },
  registry: {
    enumerable: enumerable,
    value: registry
  },
  version: {
    enumerable: enumerable,
    value: version
  },
  getChart: {
    enumerable: enumerable,
    value: getChart
  },
  register: {
    enumerable: enumerable,
    value: function value() {
      registry.add.apply(registry, arguments);
      invalidatePlugins();
    }
  },
  unregister: {
    enumerable: enumerable,
    value: function value() {
      registry.remove.apply(registry, arguments);
      invalidatePlugins();
    }
  }
});

function clipArc(ctx, element, endAngle) {
  var startAngle = element.startAngle,
      pixelMargin = element.pixelMargin,
      x = element.x,
      y = element.y,
      outerRadius = element.outerRadius,
      innerRadius = element.innerRadius;
  var angleMargin = pixelMargin / outerRadius;
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);

  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }

  ctx.closePath();
  ctx.clip();
}

function toRadiusCorners(value) {
  return _readValueToProps(value, ['outerStart', 'outerEnd', 'innerStart', 'innerEnd']);
}

function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  var o = toRadiusCorners(arc.options.borderRadius);
  var halfThickness = (outerRadius - innerRadius) / 2;
  var innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);

  var computeOuterLimit = function computeOuterLimit(val) {
    var outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };

  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
  };
}

function rThetaToXY(r, theta, x, y) {
  return {
    x: x + r * Math.cos(theta),
    y: y + r * Math.sin(theta)
  };
}

function pathArc(ctx, element, offset, spacing, end) {
  var x = element.x,
      y = element.y,
      start = element.startAngle,
      pixelMargin = element.pixelMargin,
      innerR = element.innerRadius;
  var outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
  var innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
  var spacingOffset = 0;
  var alpha = end - start;

  if (spacing) {
    var noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    var noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    var avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    var adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
    spacingOffset = (alpha - adjustedAngle) / 2;
  }

  var beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
  var angleOffset = (alpha - beta) / 2;
  var startAngle = start + angleOffset + spacingOffset;
  var endAngle = end - angleOffset - spacingOffset;

  var _parseBorderRadius$ = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle),
      outerStart = _parseBorderRadius$.outerStart,
      outerEnd = _parseBorderRadius$.outerEnd,
      innerStart = _parseBorderRadius$.innerStart,
      innerEnd = _parseBorderRadius$.innerEnd;

  var outerStartAdjustedRadius = outerRadius - outerStart;
  var outerEndAdjustedRadius = outerRadius - outerEnd;
  var outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  var outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  var innerStartAdjustedRadius = innerRadius + innerStart;
  var innerEndAdjustedRadius = innerRadius + innerEnd;
  var innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  var innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);

  if (outerEnd > 0) {
    var pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
    ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
  }

  var p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
  ctx.lineTo(p4.x, p4.y);

  if (innerEnd > 0) {
    var _pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);

    ctx.arc(_pCenter.x, _pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
  }

  ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);

  if (innerStart > 0) {
    var _pCenter2 = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);

    ctx.arc(_pCenter2.x, _pCenter2.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
  }

  var p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
  ctx.lineTo(p8.x, p8.y);

  if (outerStart > 0) {
    var _pCenter3 = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);

    ctx.arc(_pCenter3.x, _pCenter3.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
  }

  ctx.closePath();
}

function drawArc(ctx, element, offset, spacing) {
  var fullCircles = element.fullCircles,
      startAngle = element.startAngle,
      circumference = element.circumference;
  var endAngle = element.endAngle;

  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, startAngle + TAU);

    for (var i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }

    if (!isNaN(circumference)) {
      endAngle = startAngle + circumference % TAU;

      if (circumference % TAU === 0) {
        endAngle += TAU;
      }
    }
  }

  pathArc(ctx, element, offset, spacing, endAngle);
  ctx.fill();
  return endAngle;
}

function drawFullCircleBorders(ctx, element, inner) {
  var x = element.x,
      y = element.y,
      startAngle = element.startAngle,
      pixelMargin = element.pixelMargin,
      fullCircles = element.fullCircles;
  var outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
  var innerRadius = element.innerRadius + pixelMargin;
  var i;

  if (inner) {
    clipArc(ctx, element, startAngle + TAU);
  }

  ctx.beginPath();
  ctx.arc(x, y, innerRadius, startAngle + TAU, startAngle, true);

  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }

  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle, startAngle + TAU);

  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }
}

function drawBorder(ctx, element, offset, spacing, endAngle) {
  var options = element.options;
  var borderWidth = options.borderWidth,
      borderJoinStyle = options.borderJoinStyle;
  var inner = options.borderAlign === 'inner';

  if (!borderWidth) {
    return;
  }

  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || 'round';
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || 'bevel';
  }

  if (element.fullCircles) {
    drawFullCircleBorders(ctx, element, inner);
  }

  if (inner) {
    clipArc(ctx, element, endAngle);
  }

  pathArc(ctx, element, offset, spacing, endAngle);
  ctx.stroke();
}

var ArcElement = /*#__PURE__*/function (_Element2) {
  _inherits(ArcElement, _Element2);

  var _super14 = _createSuper(ArcElement);

  function ArcElement(cfg) {
    var _this35;

    _classCallCheck(this, ArcElement);

    _this35 = _super14.call(this);
    _this35.options = undefined;
    _this35.circumference = undefined;
    _this35.startAngle = undefined;
    _this35.endAngle = undefined;
    _this35.innerRadius = undefined;
    _this35.outerRadius = undefined;
    _this35.pixelMargin = 0;
    _this35.fullCircles = 0;

    if (cfg) {
      Object.assign(_assertThisInitialized(_this35), cfg);
    }

    return _this35;
  }

  _createClass(ArcElement, [{
    key: "inRange",
    value: function inRange(chartX, chartY, useFinalPosition) {
      var point = this.getProps(['x', 'y'], useFinalPosition);

      var _getAngleFromPoint2 = getAngleFromPoint(point, {
        x: chartX,
        y: chartY
      }),
          angle = _getAngleFromPoint2.angle,
          distance = _getAngleFromPoint2.distance;

      var _this$getProps2 = this.getProps(['startAngle', 'endAngle', 'innerRadius', 'outerRadius', 'circumference'], useFinalPosition),
          startAngle = _this$getProps2.startAngle,
          endAngle = _this$getProps2.endAngle,
          innerRadius = _this$getProps2.innerRadius,
          outerRadius = _this$getProps2.outerRadius,
          circumference = _this$getProps2.circumference;

      var rAdjust = this.options.spacing / 2;

      var _circumference = valueOrDefault(circumference, endAngle - startAngle);

      var betweenAngles = _circumference >= TAU || _angleBetween(angle, startAngle, endAngle);

      var withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);

      return betweenAngles && withinRadius;
    }
  }, {
    key: "getCenterPoint",
    value: function getCenterPoint(useFinalPosition) {
      var _this$getProps3 = this.getProps(['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius', 'circumference'], useFinalPosition),
          x = _this$getProps3.x,
          y = _this$getProps3.y,
          startAngle = _this$getProps3.startAngle,
          endAngle = _this$getProps3.endAngle,
          innerRadius = _this$getProps3.innerRadius,
          outerRadius = _this$getProps3.outerRadius;

      var _this$options11 = this.options,
          offset = _this$options11.offset,
          spacing = _this$options11.spacing;
      var halfAngle = (startAngle + endAngle) / 2;
      var halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
      return {
        x: x + Math.cos(halfAngle) * halfRadius,
        y: y + Math.sin(halfAngle) * halfRadius
      };
    }
  }, {
    key: "tooltipPosition",
    value: function tooltipPosition(useFinalPosition) {
      return this.getCenterPoint(useFinalPosition);
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      var options = this.options,
          circumference = this.circumference;
      var offset = (options.offset || 0) / 2;
      var spacing = (options.spacing || 0) / 2;
      this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
      this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;

      if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
        return;
      }

      ctx.save();
      var radiusOffset = 0;

      if (offset) {
        radiusOffset = offset / 2;
        var halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);

        if (this.circumference >= PI) {
          radiusOffset = offset;
        }
      }

      ctx.fillStyle = options.backgroundColor;
      ctx.strokeStyle = options.borderColor;
      var endAngle = drawArc(ctx, this, radiusOffset, spacing);
      drawBorder(ctx, this, radiusOffset, spacing, endAngle);
      ctx.restore();
    }
  }]);

  return ArcElement;
}(Element);

ArcElement.id = 'arc';
ArcElement.defaults = {
  borderAlign: 'center',
  borderColor: '#fff',
  borderJoinStyle: undefined,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: undefined
};
ArcElement.defaultRoutes = {
  backgroundColor: 'backgroundColor'
};

function setStyle(ctx, options) {
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : options;
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}

function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}

function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }

  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierCurveTo;
  }

  return lineTo;
}

function pathVars(points, segment) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var count = points.length;
  var _params$start = params.start,
      paramsStart = _params$start === void 0 ? 0 : _params$start,
      _params$end = params.end,
      paramsEnd = _params$end === void 0 ? count - 1 : _params$end;
  var segmentStart = segment.start,
      segmentEnd = segment.end;
  var start = Math.max(paramsStart, segmentStart);
  var end = Math.min(paramsEnd, segmentEnd);
  var outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count: count,
    start: start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}

function pathSegment(ctx, line, segment, params) {
  var points = line.points,
      options = line.options;

  var _pathVars = pathVars(points, segment, params),
      count = _pathVars.count,
      start = _pathVars.start,
      loop = _pathVars.loop,
      ilen = _pathVars.ilen;

  var lineMethod = getLineMethod(options);

  var _ref7 = params || {},
      _ref7$move = _ref7.move,
      move = _ref7$move === void 0 ? true : _ref7$move,
      reverse = _ref7.reverse;

  var i, point, prev;

  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];

    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }

    prev = point;
  }

  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }

  return !!loop;
}

function fastPathSegment(ctx, line, segment, params) {
  var points = line.points;

  var _pathVars2 = pathVars(points, segment, params),
      count = _pathVars2.count,
      start = _pathVars2.start,
      ilen = _pathVars2.ilen;

  var _ref8 = params || {},
      _ref8$move = _ref8.move,
      move = _ref8$move === void 0 ? true : _ref8$move,
      reverse = _ref8.reverse;

  var avgX = 0;
  var countX = 0;
  var i, point, prevX, minY, maxY, lastY;

  var pointIndex = function pointIndex(index) {
    return (start + (reverse ? ilen - index : index)) % count;
  };

  var drawX = function drawX() {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };

  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }

  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];

    if (point.skip) {
      continue;
    }

    var x = point.x;
    var y = point.y;
    var truncX = x | 0;

    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }

      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }

    lastY = y;
  }

  drawX();
}

function _getSegmentMethod(line) {
  var opts = line.options;
  var borderDash = opts.borderDash && opts.borderDash.length;
  var useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}

function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }

  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierInterpolation;
  }

  return _pointInLine;
}

function strokePathWithCache(ctx, line, start, count) {
  var path = line._path;

  if (!path) {
    path = line._path = new Path2D();

    if (line.path(path, start, count)) {
      path.closePath();
    }
  }

  setStyle(ctx, line.options);
  ctx.stroke(path);
}

function strokePathDirect(ctx, line, start, count) {
  var segments = line.segments,
      options = line.options;

  var segmentMethod = _getSegmentMethod(line);

  var _iterator23 = _createForOfIteratorHelper(segments),
      _step23;

  try {
    for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
      var segment = _step23.value;
      setStyle(ctx, options, segment.style);
      ctx.beginPath();

      if (segmentMethod(ctx, line, segment, {
        start: start,
        end: start + count - 1
      })) {
        ctx.closePath();
      }

      ctx.stroke();
    }
  } catch (err) {
    _iterator23.e(err);
  } finally {
    _iterator23.f();
  }
}

var usePath2D = typeof Path2D === 'function';

function _draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}

var LineElement = /*#__PURE__*/function (_Element3) {
  _inherits(LineElement, _Element3);

  var _super15 = _createSuper(LineElement);

  function LineElement(cfg) {
    var _this36;

    _classCallCheck(this, LineElement);

    _this36 = _super15.call(this);
    _this36.animated = true;
    _this36.options = undefined;
    _this36._chart = undefined;
    _this36._loop = undefined;
    _this36._fullLoop = undefined;
    _this36._path = undefined;
    _this36._points = undefined;
    _this36._segments = undefined;
    _this36._decimated = false;
    _this36._pointsUpdated = false;
    _this36._datasetIndex = undefined;

    if (cfg) {
      Object.assign(_assertThisInitialized(_this36), cfg);
    }

    return _this36;
  }

  _createClass(LineElement, [{
    key: "updateControlPoints",
    value: function updateControlPoints(chartArea, indexAxis) {
      var options = this.options;

      if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
        var _loop4 = options.spanGaps ? this._loop : this._fullLoop;

        _updateBezierControlPoints(this._points, options, chartArea, _loop4, indexAxis);

        this._pointsUpdated = true;
      }
    }
  }, {
    key: "points",
    get: function get() {
      return this._points;
    },
    set: function set(points) {
      this._points = points;
      delete this._segments;
      delete this._path;
      this._pointsUpdated = false;
    }
  }, {
    key: "segments",
    get: function get() {
      return this._segments || (this._segments = _computeSegments(this, this.options.segment));
    }
  }, {
    key: "first",
    value: function first() {
      var segments = this.segments;
      var points = this.points;
      return segments.length && points[segments[0].start];
    }
  }, {
    key: "last",
    value: function last() {
      var segments = this.segments;
      var points = this.points;
      var count = segments.length;
      return count && points[segments[count - 1].end];
    }
  }, {
    key: "interpolate",
    value: function interpolate(point, property) {
      var options = this.options;
      var value = point[property];
      var points = this.points;

      var segments = _boundSegments(this, {
        property: property,
        start: value,
        end: value
      });

      if (!segments.length) {
        return;
      }

      var result = [];

      var _interpolate = _getInterpolationMethod(options);

      var i, ilen;

      for (i = 0, ilen = segments.length; i < ilen; ++i) {
        var _segments$i = segments[i],
            start = _segments$i.start,
            end = _segments$i.end;
        var p1 = points[start];
        var p2 = points[end];

        if (p1 === p2) {
          result.push(p1);
          continue;
        }

        var _t4 = Math.abs((value - p1[property]) / (p2[property] - p1[property]));

        var interpolated = _interpolate(p1, p2, _t4, options.stepped);

        interpolated[property] = point[property];
        result.push(interpolated);
      }

      return result.length === 1 ? result[0] : result;
    }
  }, {
    key: "pathSegment",
    value: function pathSegment(ctx, segment, params) {
      var segmentMethod = _getSegmentMethod(this);

      return segmentMethod(ctx, this, segment, params);
    }
  }, {
    key: "path",
    value: function path(ctx, start, count) {
      var segments = this.segments;

      var segmentMethod = _getSegmentMethod(this);

      var loop = this._loop;
      start = start || 0;
      count = count || this.points.length - start;

      var _iterator24 = _createForOfIteratorHelper(segments),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var segment = _step24.value;
          loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
          });
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      return !!loop;
    }
  }, {
    key: "draw",
    value: function draw(ctx, chartArea, start, count) {
      var options = this.options || {};
      var points = this.points || [];

      if (points.length && options.borderWidth) {
        ctx.save();

        _draw(ctx, this, start, count);

        ctx.restore();
      }

      if (this.animated) {
        this._pointsUpdated = false;
        this._path = undefined;
      }
    }
  }]);

  return LineElement;
}(Element);

LineElement.id = 'line';
LineElement.defaults = {
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: 'miter',
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: 'default',
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0
};
LineElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};
LineElement.descriptors = {
  _scriptable: true,
  _indexable: function _indexable(name) {
    return name !== 'borderDash' && name !== 'fill';
  }
};

function inRange$1(el, pos, axis, useFinalPosition) {
  var options = el.options;

  var _el$getProps = el.getProps([axis], useFinalPosition),
      value = _el$getProps[axis];

  return Math.abs(pos - value) < options.radius + options.hitRadius;
}

var PointElement = /*#__PURE__*/function (_Element4) {
  _inherits(PointElement, _Element4);

  var _super16 = _createSuper(PointElement);

  function PointElement(cfg) {
    var _this37;

    _classCallCheck(this, PointElement);

    _this37 = _super16.call(this);
    _this37.options = undefined;
    _this37.parsed = undefined;
    _this37.skip = undefined;
    _this37.stop = undefined;

    if (cfg) {
      Object.assign(_assertThisInitialized(_this37), cfg);
    }

    return _this37;
  }

  _createClass(PointElement, [{
    key: "inRange",
    value: function inRange(mouseX, mouseY, useFinalPosition) {
      var options = this.options;

      var _this$getProps4 = this.getProps(['x', 'y'], useFinalPosition),
          x = _this$getProps4.x,
          y = _this$getProps4.y;

      return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
  }, {
    key: "inXRange",
    value: function inXRange(mouseX, useFinalPosition) {
      return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
  }, {
    key: "inYRange",
    value: function inYRange(mouseY, useFinalPosition) {
      return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
  }, {
    key: "getCenterPoint",
    value: function getCenterPoint(useFinalPosition) {
      var _this$getProps5 = this.getProps(['x', 'y'], useFinalPosition),
          x = _this$getProps5.x,
          y = _this$getProps5.y;

      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "size",
    value: function size(options) {
      options = options || this.options || {};
      var radius = options.radius || 0;
      radius = Math.max(radius, radius && options.hoverRadius || 0);
      var borderWidth = radius && options.borderWidth || 0;
      return (radius + borderWidth) * 2;
    }
  }, {
    key: "draw",
    value: function draw(ctx, area) {
      var options = this.options;

      if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
        return;
      }

      ctx.strokeStyle = options.borderColor;
      ctx.lineWidth = options.borderWidth;
      ctx.fillStyle = options.backgroundColor;
      drawPoint(ctx, options, this.x, this.y);
    }
  }, {
    key: "getRange",
    value: function getRange() {
      var options = this.options || {};
      return options.radius + options.hitRadius;
    }
  }]);

  return PointElement;
}(Element);

PointElement.id = 'point';
PointElement.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: 'circle',
  radius: 3,
  rotation: 0
};
PointElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};

function getBarBounds(bar, useFinalPosition) {
  var _bar$getProps = bar.getProps(['x', 'y', 'base', 'width', 'height'], useFinalPosition),
      x = _bar$getProps.x,
      y = _bar$getProps.y,
      base = _bar$getProps.base,
      width = _bar$getProps.width,
      height = _bar$getProps.height;

  var left, right, top, bottom, half;

  if (bar.horizontal) {
    half = height / 2;
    left = Math.min(x, base);
    right = Math.max(x, base);
    top = y - half;
    bottom = y + half;
  } else {
    half = width / 2;
    left = x - half;
    right = x + half;
    top = Math.min(y, base);
    bottom = Math.max(y, base);
  }

  return {
    left: left,
    top: top,
    right: right,
    bottom: bottom
  };
}

function skipOrLimit(skip, value, min, max) {
  return skip ? 0 : _limitValue(value, min, max);
}

function parseBorderWidth(bar, maxW, maxH) {
  var value = bar.options.borderWidth;
  var skip = bar.borderSkipped;
  var o = toTRBL(value);
  return {
    t: skipOrLimit(skip.top, o.top, 0, maxH),
    r: skipOrLimit(skip.right, o.right, 0, maxW),
    b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip.left, o.left, 0, maxW)
  };
}

function parseBorderRadius(bar, maxW, maxH) {
  var _bar$getProps2 = bar.getProps(['enableBorderRadius']),
      enableBorderRadius = _bar$getProps2.enableBorderRadius;

  var value = bar.options.borderRadius;
  var o = toTRBLCorners(value);
  var maxR = Math.min(maxW, maxH);
  var skip = bar.borderSkipped;
  var enableBorder = enableBorderRadius || isObject(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
  };
}

function boundingRects(bar) {
  var bounds = getBarBounds(bar);
  var width = bounds.right - bounds.left;
  var height = bounds.bottom - bounds.top;
  var border = parseBorderWidth(bar, width / 2, height / 2);
  var radius = parseBorderRadius(bar, width / 2, height / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height,
      radius: radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}

function _inRange(bar, x, y, useFinalPosition) {
  var skipX = x === null;
  var skipY = y === null;
  var skipBoth = skipX && skipY;
  var bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}

function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}

function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}

function inflateRect(rect, amount) {
  var refRect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var x = rect.x !== refRect.x ? -amount : 0;
  var y = rect.y !== refRect.y ? -amount : 0;
  var w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
  var h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
  return {
    x: rect.x + x,
    y: rect.y + y,
    w: rect.w + w,
    h: rect.h + h,
    radius: rect.radius
  };
}

var BarElement = /*#__PURE__*/function (_Element5) {
  _inherits(BarElement, _Element5);

  var _super17 = _createSuper(BarElement);

  function BarElement(cfg) {
    var _this38;

    _classCallCheck(this, BarElement);

    _this38 = _super17.call(this);
    _this38.options = undefined;
    _this38.horizontal = undefined;
    _this38.base = undefined;
    _this38.width = undefined;
    _this38.height = undefined;
    _this38.inflateAmount = undefined;

    if (cfg) {
      Object.assign(_assertThisInitialized(_this38), cfg);
    }

    return _this38;
  }

  _createClass(BarElement, [{
    key: "draw",
    value: function draw(ctx) {
      var inflateAmount = this.inflateAmount,
          _this$options12 = this.options,
          borderColor = _this$options12.borderColor,
          backgroundColor = _this$options12.backgroundColor;

      var _boundingRects = boundingRects(this),
          inner = _boundingRects.inner,
          outer = _boundingRects.outer;

      var addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
      ctx.save();

      if (outer.w !== inner.w || outer.h !== inner.h) {
        ctx.beginPath();
        addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
        ctx.clip();
        addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
        ctx.fillStyle = borderColor;
        ctx.fill('evenodd');
      }

      ctx.beginPath();
      addRectPath(ctx, inflateRect(inner, inflateAmount));
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }, {
    key: "inRange",
    value: function inRange(mouseX, mouseY, useFinalPosition) {
      return _inRange(this, mouseX, mouseY, useFinalPosition);
    }
  }, {
    key: "inXRange",
    value: function inXRange(mouseX, useFinalPosition) {
      return _inRange(this, mouseX, null, useFinalPosition);
    }
  }, {
    key: "inYRange",
    value: function inYRange(mouseY, useFinalPosition) {
      return _inRange(this, null, mouseY, useFinalPosition);
    }
  }, {
    key: "getCenterPoint",
    value: function getCenterPoint(useFinalPosition) {
      var _this$getProps6 = this.getProps(['x', 'y', 'base', 'horizontal'], useFinalPosition),
          x = _this$getProps6.x,
          y = _this$getProps6.y,
          base = _this$getProps6.base,
          horizontal = _this$getProps6.horizontal;

      return {
        x: horizontal ? (x + base) / 2 : x,
        y: horizontal ? y : (y + base) / 2
      };
    }
  }, {
    key: "getRange",
    value: function getRange(axis) {
      return axis === 'x' ? this.width / 2 : this.height / 2;
    }
  }]);

  return BarElement;
}(Element);

BarElement.id = 'bar';
BarElement.defaults = {
  borderSkipped: 'start',
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: 'auto',
  pointStyle: undefined
};
BarElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};
var elements = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ArcElement: ArcElement,
  LineElement: LineElement,
  PointElement: PointElement,
  BarElement: BarElement
});

function lttbDecimation(data, start, count, availableWidth, options) {
  var samples = options.samples || availableWidth;

  if (samples >= count) {
    return data.slice(start, start + count);
  }

  var decimated = [];
  var bucketWidth = (count - 2) / (samples - 2);
  var sampledIndex = 0;
  var endIndex = start + count - 1;
  var a = start;
  var i, maxAreaPoint, maxArea, area, nextA;
  decimated[sampledIndex++] = data[a];

  for (i = 0; i < samples - 2; i++) {
    var avgX = 0;
    var avgY = 0;
    var j = void 0;
    var avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
    var avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
    var avgRangeLength = avgRangeEnd - avgRangeStart;

    for (j = avgRangeStart; j < avgRangeEnd; j++) {
      avgX += data[j].x;
      avgY += data[j].y;
    }

    avgX /= avgRangeLength;
    avgY /= avgRangeLength;
    var rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
    var rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
    var _data$a = data[a],
        pointAx = _data$a.x,
        pointAy = _data$a.y;
    maxArea = area = -1;

    for (j = rangeOffs; j < rangeTo; j++) {
      area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));

      if (area > maxArea) {
        maxArea = area;
        maxAreaPoint = data[j];
        nextA = j;
      }
    }

    decimated[sampledIndex++] = maxAreaPoint;
    a = nextA;
  }

  decimated[sampledIndex++] = data[endIndex];
  return decimated;
}

function minMaxDecimation(data, start, count, availableWidth) {
  var avgX = 0;
  var countX = 0;
  var i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
  var decimated = [];
  var endIndex = start + count - 1;
  var xMin = data[start].x;
  var xMax = data[endIndex].x;
  var dx = xMax - xMin;

  for (i = start; i < start + count; ++i) {
    point = data[i];
    x = (point.x - xMin) / dx * availableWidth;
    y = point.y;
    var truncX = x | 0;

    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
        minIndex = i;
      } else if (y > maxY) {
        maxY = y;
        maxIndex = i;
      }

      avgX = (countX * avgX + point.x) / ++countX;
    } else {
      var lastIndex = i - 1;

      if (!isNullOrUndef(minIndex) && !isNullOrUndef(maxIndex)) {
        var intermediateIndex1 = Math.min(minIndex, maxIndex);
        var intermediateIndex2 = Math.max(minIndex, maxIndex);

        if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) {
          decimated.push(_objectSpread(_objectSpread({}, data[intermediateIndex1]), {}, {
            x: avgX
          }));
        }

        if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) {
          decimated.push(_objectSpread(_objectSpread({}, data[intermediateIndex2]), {}, {
            x: avgX
          }));
        }
      }

      if (i > 0 && lastIndex !== startIndex) {
        decimated.push(data[lastIndex]);
      }

      decimated.push(point);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
      minIndex = maxIndex = startIndex = i;
    }
  }

  return decimated;
}

function cleanDecimatedDataset(dataset) {
  if (dataset._decimated) {
    var _data4 = dataset._data;
    delete dataset._decimated;
    delete dataset._data;
    Object.defineProperty(dataset, 'data', {
      value: _data4
    });
  }
}

function cleanDecimatedData(chart) {
  chart.data.datasets.forEach(function (dataset) {
    cleanDecimatedDataset(dataset);
  });
}

function getStartAndCountOfVisiblePointsSimplified(meta, points) {
  var pointCount = points.length;
  var start = 0;
  var count;
  var iScale = meta.iScale;

  var _iScale$getUserBounds2 = iScale.getUserBounds(),
      min = _iScale$getUserBounds2.min,
      max = _iScale$getUserBounds2.max,
      minDefined = _iScale$getUserBounds2.minDefined,
      maxDefined = _iScale$getUserBounds2.maxDefined;

  if (minDefined) {
    start = _limitValue(_lookupByKey(points, iScale.axis, min).lo, 0, pointCount - 1);
  }

  if (maxDefined) {
    count = _limitValue(_lookupByKey(points, iScale.axis, max).hi + 1, start, pointCount) - start;
  } else {
    count = pointCount - start;
  }

  return {
    start: start,
    count: count
  };
}

var plugin_decimation = {
  id: 'decimation',
  defaults: {
    algorithm: 'min-max',
    enabled: false
  },
  beforeElementsUpdate: function beforeElementsUpdate(chart, args, options) {
    if (!options.enabled) {
      cleanDecimatedData(chart);
      return;
    }

    var availableWidth = chart.width;
    chart.data.datasets.forEach(function (dataset, datasetIndex) {
      var _data = dataset._data,
          indexAxis = dataset.indexAxis;
      var meta = chart.getDatasetMeta(datasetIndex);
      var data = _data || dataset.data;

      if (resolve([indexAxis, chart.options.indexAxis]) === 'y') {
        return;
      }

      if (!meta.controller.supportsDecimation) {
        return;
      }

      var xAxis = chart.scales[meta.xAxisID];

      if (xAxis.type !== 'linear' && xAxis.type !== 'time') {
        return;
      }

      if (chart.options.parsing) {
        return;
      }

      var _getStartAndCountOfVi2 = getStartAndCountOfVisiblePointsSimplified(meta, data),
          start = _getStartAndCountOfVi2.start,
          count = _getStartAndCountOfVi2.count;

      var threshold = options.threshold || 4 * availableWidth;

      if (count <= threshold) {
        cleanDecimatedDataset(dataset);
        return;
      }

      if (isNullOrUndef(_data)) {
        dataset._data = data;
        delete dataset.data;
        Object.defineProperty(dataset, 'data', {
          configurable: true,
          enumerable: true,
          get: function get() {
            return this._decimated;
          },
          set: function set(d) {
            this._data = d;
          }
        });
      }

      var decimated;

      switch (options.algorithm) {
        case 'lttb':
          decimated = lttbDecimation(data, start, count, availableWidth, options);
          break;

        case 'min-max':
          decimated = minMaxDecimation(data, start, count, availableWidth);
          break;

        default:
          throw new Error("Unsupported decimation algorithm '".concat(options.algorithm, "'"));
      }

      dataset._decimated = decimated;
    });
  },
  destroy: function destroy(chart) {
    cleanDecimatedData(chart);
  }
};

function _segments(line, target, property) {
  var segments = line.segments;
  var points = line.points;
  var tpoints = target.points;
  var parts = [];

  var _iterator25 = _createForOfIteratorHelper(segments),
      _step25;

  try {
    for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
      var segment = _step25.value;
      var start = segment.start,
          end = segment.end;
      end = _findSegmentEnd(start, end, points);

      var bounds = _getBounds(property, points[start], points[end], segment.loop);

      if (!target.segments) {
        parts.push({
          source: segment,
          target: bounds,
          start: points[start],
          end: points[end]
        });
        continue;
      }

      var targetSegments = _boundSegments(target, bounds);

      var _iterator26 = _createForOfIteratorHelper(targetSegments),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var tgt = _step26.value;

          var subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);

          var fillSources = _boundSegment(segment, points, subBounds);

          var _iterator27 = _createForOfIteratorHelper(fillSources),
              _step27;

          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var fillSource = _step27.value;
              parts.push({
                source: fillSource,
                target: tgt,
                start: _defineProperty2({}, property, _getEdge(bounds, subBounds, 'start', Math.max)),
                end: _defineProperty2({}, property, _getEdge(bounds, subBounds, 'end', Math.min))
              });
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  } catch (err) {
    _iterator25.e(err);
  } finally {
    _iterator25.f();
  }

  return parts;
}

function _getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }

  var start = first[property];
  var end = last[property];

  if (property === 'angle') {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }

  return {
    property: property,
    start: start,
    end: end
  };
}

function _pointsFromSegments(boundary, line) {
  var _ref9 = boundary || {},
      _ref9$x = _ref9.x,
      x = _ref9$x === void 0 ? null : _ref9$x,
      _ref9$y = _ref9.y,
      y = _ref9$y === void 0 ? null : _ref9$y;

  var linePoints = line.points;
  var points = [];
  line.segments.forEach(function (_ref10) {
    var start = _ref10.start,
        end = _ref10.end;
    end = _findSegmentEnd(start, end, linePoints);
    var first = linePoints[start];
    var last = linePoints[end];

    if (y !== null) {
      points.push({
        x: first.x,
        y: y
      });
      points.push({
        x: last.x,
        y: y
      });
    } else if (x !== null) {
      points.push({
        x: x,
        y: first.y
      });
      points.push({
        x: x,
        y: last.y
      });
    }
  });
  return points;
}

function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    var point = points[end];

    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }

  return end;
}

function _getEdge(a, b, prop, fn) {
  if (a && b) {
    return fn(a[prop], b[prop]);
  }

  return a ? a[prop] : b ? b[prop] : 0;
}

function _createBoundaryLine(boundary, line) {
  var points = [];
  var _loop = false;

  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }

  return points.length ? new LineElement({
    points: points,
    options: {
      tension: 0
    },
    _loop: _loop,
    _fullLoop: _loop
  }) : null;
}

function _resolveTarget(sources, index, propagate) {
  var source = sources[index];
  var fill = source.fill;
  var visited = [index];
  var target;

  if (!propagate) {
    return fill;
  }

  while (fill !== false && visited.indexOf(fill) === -1) {
    if (!isNumberFinite(fill)) {
      return fill;
    }

    target = sources[fill];

    if (!target) {
      return false;
    }

    if (target.visible) {
      return fill;
    }

    visited.push(fill);
    fill = target.fill;
  }

  return false;
}

function _decodeFill(line, index, count) {
  var fill = parseFillOption(line);

  if (isObject(fill)) {
    return isNaN(fill.value) ? false : fill;
  }

  var target = parseFloat(fill);

  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill[0], index, target, count);
  }

  return ['origin', 'start', 'end', 'stack', 'shape'].indexOf(fill) >= 0 && fill;
}

function decodeTargetIndex(firstCh, index, target, count) {
  if (firstCh === '-' || firstCh === '+') {
    target = index + target;
  }

  if (target === index || target < 0 || target >= count) {
    return false;
  }

  return target;
}

function _getTargetPixel(fill, scale) {
  var pixel = null;

  if (fill === 'start') {
    pixel = scale.bottom;
  } else if (fill === 'end') {
    pixel = scale.top;
  } else if (isObject(fill)) {
    pixel = scale.getPixelForValue(fill.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }

  return pixel;
}

function _getTargetValue(fill, scale, startValue) {
  var value;

  if (fill === 'start') {
    value = startValue;
  } else if (fill === 'end') {
    value = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject(fill)) {
    value = fill.value;
  } else {
    value = scale.getBaseValue();
  }

  return value;
}

function parseFillOption(line) {
  var options = line.options;
  var fillOption = options.fill;
  var fill = valueOrDefault(fillOption && fillOption.target, fillOption);

  if (fill === undefined) {
    fill = !!options.backgroundColor;
  }

  if (fill === false || fill === null) {
    return false;
  }

  if (fill === true) {
    return 'origin';
  }

  return fill;
}

function _buildStackLine(source) {
  var scale = source.scale,
      index = source.index,
      line = source.line;
  var points = [];
  var segments = line.segments;
  var sourcePoints = line.points;
  var linesBelow = getLinesBelow(scale, index);
  linesBelow.push(_createBoundaryLine({
    x: null,
    y: scale.bottom
  }, line));

  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];

    for (var j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }

  return new LineElement({
    points: points,
    options: {}
  });
}

function getLinesBelow(scale, index) {
  var below = [];
  var metas = scale.getMatchingVisibleMetas('line');

  for (var i = 0; i < metas.length; i++) {
    var meta = metas[i];

    if (meta.index === index) {
      break;
    }

    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }

  return below;
}

function addPointsBelow(points, sourcePoint, linesBelow) {
  var postponed = [];

  for (var j = 0; j < linesBelow.length; j++) {
    var line = linesBelow[j];

    var _findPoint = findPoint(line, sourcePoint, 'x'),
        first = _findPoint.first,
        last = _findPoint.last,
        point = _findPoint.point;

    if (!point || first && last) {
      continue;
    }

    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);

      if (!last) {
        break;
      }
    }
  }

  points.push.apply(points, postponed);
}

function findPoint(line, sourcePoint, property) {
  var point = line.interpolate(sourcePoint, property);

  if (!point) {
    return {};
  }

  var pointValue = point[property];
  var segments = line.segments;
  var linePoints = line.points;
  var first = false;
  var last = false;

  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    var firstValue = linePoints[segment.start][property];
    var lastValue = linePoints[segment.end][property];

    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }

  return {
    first: first,
    last: last,
    point: point
  };
}

var simpleArc = /*#__PURE__*/function () {
  function simpleArc(opts) {
    _classCallCheck(this, simpleArc);

    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }

  _createClass(simpleArc, [{
    key: "pathSegment",
    value: function pathSegment(ctx, bounds, opts) {
      var x = this.x,
          y = this.y,
          radius = this.radius;
      bounds = bounds || {
        start: 0,
        end: TAU
      };
      ctx.arc(x, y, radius, bounds.end, bounds.start, true);
      return !opts.bounds;
    }
  }, {
    key: "interpolate",
    value: function interpolate(point) {
      var x = this.x,
          y = this.y,
          radius = this.radius;
      var angle = point.angle;
      return {
        x: x + Math.cos(angle) * radius,
        y: y + Math.sin(angle) * radius,
        angle: angle
      };
    }
  }]);

  return simpleArc;
}();

function _getTarget(source) {
  var chart = source.chart,
      fill = source.fill,
      line = source.line;

  if (isNumberFinite(fill)) {
    return getLineByIndex(chart, fill);
  }

  if (fill === 'stack') {
    return _buildStackLine(source);
  }

  if (fill === 'shape') {
    return true;
  }

  var boundary = computeBoundary(source);

  if (boundary instanceof simpleArc) {
    return boundary;
  }

  return _createBoundaryLine(boundary, line);
}

function getLineByIndex(chart, index) {
  var meta = chart.getDatasetMeta(index);
  var visible = meta && chart.isDatasetVisible(index);
  return visible ? meta.dataset : null;
}

function computeBoundary(source) {
  var scale = source.scale || {};

  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }

  return computeLinearBoundary(source);
}

function computeLinearBoundary(source) {
  var _source$scale = source.scale,
      scale = _source$scale === void 0 ? {} : _source$scale,
      fill = source.fill;

  var pixel = _getTargetPixel(fill, scale);

  if (isNumberFinite(pixel)) {
    var horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }

  return null;
}

function computeCircularBoundary(source) {
  var scale = source.scale,
      fill = source.fill;
  var options = scale.options;
  var length = scale.getLabels().length;
  var start = options.reverse ? scale.max : scale.min;

  var value = _getTargetValue(fill, scale, start);

  var target = [];

  if (options.grid.circular) {
    var center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }

  for (var i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }

  return target;
}

function _drawfill(ctx, source, area) {
  var target = _getTarget(source);

  var line = source.line,
      scale = source.scale,
      axis = source.axis;
  var lineOpts = line.options;
  var fillOption = lineOpts.fill;
  var color = lineOpts.backgroundColor;

  var _ref11 = fillOption || {},
      _ref11$above = _ref11.above,
      above = _ref11$above === void 0 ? color : _ref11$above,
      _ref11$below = _ref11.below,
      below = _ref11$below === void 0 ? color : _ref11$below;

  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {
      line: line,
      target: target,
      above: above,
      below: below,
      area: area,
      scale: scale,
      axis: axis
    });
    unclipArea(ctx);
  }
}

function doFill(ctx, cfg) {
  var line = cfg.line,
      target = cfg.target,
      above = cfg.above,
      below = cfg.below,
      area = cfg.area,
      scale = cfg.scale;
  var property = line._loop ? 'angle' : cfg.axis;
  ctx.save();

  if (property === 'x' && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, {
      line: line,
      target: target,
      color: above,
      scale: scale,
      property: property
    });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }

  fill(ctx, {
    line: line,
    target: target,
    color: below,
    scale: scale,
    property: property
  });
  ctx.restore();
}

function clipVertical(ctx, target, clipY) {
  var segments = target.segments,
      points = target.points;
  var first = true;
  var lineLoop = false;
  ctx.beginPath();

  var _iterator28 = _createForOfIteratorHelper(segments),
      _step28;

  try {
    for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
      var segment = _step28.value;
      var start = segment.start,
          end = segment.end;
      var firstPoint = points[start];

      var lastPoint = points[_findSegmentEnd(start, end, points)];

      if (first) {
        ctx.moveTo(firstPoint.x, firstPoint.y);
        first = false;
      } else {
        ctx.lineTo(firstPoint.x, clipY);
        ctx.lineTo(firstPoint.x, firstPoint.y);
      }

      lineLoop = !!target.pathSegment(ctx, segment, {
        move: lineLoop
      });

      if (lineLoop) {
        ctx.closePath();
      } else {
        ctx.lineTo(lastPoint.x, clipY);
      }
    }
  } catch (err) {
    _iterator28.e(err);
  } finally {
    _iterator28.f();
  }

  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}

function fill(ctx, cfg) {
  var line = cfg.line,
      target = cfg.target,
      property = cfg.property,
      color = cfg.color,
      scale = cfg.scale;

  var segments = _segments(line, target, property);

  var _iterator29 = _createForOfIteratorHelper(segments),
      _step29;

  try {
    for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
      var _step29$value = _step29.value,
          src = _step29$value.source,
          tgt = _step29$value.target,
          start = _step29$value.start,
          end = _step29$value.end;
      var _src$style = src.style;
      _src$style = _src$style === void 0 ? {} : _src$style;
      var _src$style$background = _src$style.backgroundColor,
          backgroundColor = _src$style$background === void 0 ? color : _src$style$background;
      var notShape = target !== true;
      ctx.save();
      ctx.fillStyle = backgroundColor;
      clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
      ctx.beginPath();
      var lineLoop = !!line.pathSegment(ctx, src);

      var _loop5 = void 0;

      if (notShape) {
        if (lineLoop) {
          ctx.closePath();
        } else {
          interpolatedLineTo(ctx, target, end, property);
        }

        var targetLoop = !!target.pathSegment(ctx, tgt, {
          move: lineLoop,
          reverse: true
        });
        _loop5 = lineLoop && targetLoop;

        if (!_loop5) {
          interpolatedLineTo(ctx, target, start, property);
        }
      }

      ctx.closePath();
      ctx.fill(_loop5 ? 'evenodd' : 'nonzero');
      ctx.restore();
    }
  } catch (err) {
    _iterator29.e(err);
  } finally {
    _iterator29.f();
  }
}

function clipBounds(ctx, scale, bounds) {
  var _scale$chart$chartAre = scale.chart.chartArea,
      top = _scale$chart$chartAre.top,
      bottom = _scale$chart$chartAre.bottom;

  var _ref12 = bounds || {},
      property = _ref12.property,
      start = _ref12.start,
      end = _ref12.end;

  if (property === 'x') {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}

function interpolatedLineTo(ctx, target, point, property) {
  var interpolatedPoint = target.interpolate(point, property);

  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}

var index = {
  id: 'filler',
  afterDatasetsUpdate: function afterDatasetsUpdate(chart, _args, options) {
    var count = (chart.data.datasets || []).length;
    var sources = [];
    var meta, i, line, source;

    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;

      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line, i, count),
          chart: chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line: line
        };
      }

      meta.$filler = source;
      sources.push(source);
    }

    for (i = 0; i < count; ++i) {
      source = sources[i];

      if (!source || source.fill === false) {
        continue;
      }

      source.fill = _resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw: function beforeDraw(chart, _args, options) {
    var draw = options.drawTime === 'beforeDraw';
    var metasets = chart.getSortedVisibleDatasetMetas();
    var area = chart.chartArea;

    for (var i = metasets.length - 1; i >= 0; --i) {
      var source = metasets[i].$filler;

      if (!source) {
        continue;
      }

      source.line.updateControlPoints(area, source.axis);

      if (draw) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw: function beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== 'beforeDatasetsDraw') {
      return;
    }

    var metasets = chart.getSortedVisibleDatasetMetas();

    for (var i = metasets.length - 1; i >= 0; --i) {
      var source = metasets[i].$filler;

      if (source) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw: function beforeDatasetDraw(chart, args, options) {
    var source = args.meta.$filler;

    if (!source || source.fill === false || options.drawTime !== 'beforeDatasetDraw') {
      return;
    }

    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: 'beforeDatasetDraw'
  }
};

var getBoxSize = function getBoxSize(labelOpts, fontSize) {
  var _labelOpts$boxHeight = labelOpts.boxHeight,
      boxHeight = _labelOpts$boxHeight === void 0 ? fontSize : _labelOpts$boxHeight,
      _labelOpts$boxWidth = labelOpts.boxWidth,
      boxWidth = _labelOpts$boxWidth === void 0 ? fontSize : _labelOpts$boxWidth;

  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = Math.min(boxWidth, fontSize);
  }

  return {
    boxWidth: boxWidth,
    boxHeight: boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};

var itemsEqual = function itemsEqual(a, b) {
  return a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
};

var Legend = /*#__PURE__*/function (_Element6) {
  _inherits(Legend, _Element6);

  var _super18 = _createSuper(Legend);

  function Legend(config) {
    var _this39;

    _classCallCheck(this, Legend);

    _this39 = _super18.call(this);
    _this39._added = false;
    _this39.legendHitBoxes = [];
    _this39._hoveredItem = null;
    _this39.doughnutMode = false;
    _this39.chart = config.chart;
    _this39.options = config.options;
    _this39.ctx = config.ctx;
    _this39.legendItems = undefined;
    _this39.columnSizes = undefined;
    _this39.lineWidths = undefined;
    _this39.maxHeight = undefined;
    _this39.maxWidth = undefined;
    _this39.top = undefined;
    _this39.bottom = undefined;
    _this39.left = undefined;
    _this39.right = undefined;
    _this39.height = undefined;
    _this39.width = undefined;
    _this39._margins = undefined;
    _this39.position = undefined;
    _this39.weight = undefined;
    _this39.fullSize = undefined;
    return _this39;
  }

  _createClass(Legend, [{
    key: "update",
    value: function update(maxWidth, maxHeight, margins) {
      this.maxWidth = maxWidth;
      this.maxHeight = maxHeight;
      this._margins = margins;
      this.setDimensions();
      this.buildLabels();
      this.fit();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions() {
      if (this.isHorizontal()) {
        this.width = this.maxWidth;
        this.left = this._margins.left;
        this.right = this.width;
      } else {
        this.height = this.maxHeight;
        this.top = this._margins.top;
        this.bottom = this.height;
      }
    }
  }, {
    key: "buildLabels",
    value: function buildLabels() {
      var _this40 = this;

      var labelOpts = this.options.labels || {};
      var legendItems = callback(labelOpts.generateLabels, [this.chart], this) || [];

      if (labelOpts.filter) {
        legendItems = legendItems.filter(function (item) {
          return labelOpts.filter(item, _this40.chart.data);
        });
      }

      if (labelOpts.sort) {
        legendItems = legendItems.sort(function (a, b) {
          return labelOpts.sort(a, b, _this40.chart.data);
        });
      }

      if (this.options.reverse) {
        legendItems.reverse();
      }

      this.legendItems = legendItems;
    }
  }, {
    key: "fit",
    value: function fit() {
      var options = this.options,
          ctx = this.ctx;

      if (!options.display) {
        this.width = this.height = 0;
        return;
      }

      var labelOpts = options.labels;
      var labelFont = toFont(labelOpts.font);
      var fontSize = labelFont.size;

      var titleHeight = this._computeTitleHeight();

      var _getBoxSize = getBoxSize(labelOpts, fontSize),
          boxWidth = _getBoxSize.boxWidth,
          itemHeight = _getBoxSize.itemHeight;

      var width, height;
      ctx.font = labelFont.string;

      if (this.isHorizontal()) {
        width = this.maxWidth;
        height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
      } else {
        height = this.maxHeight;
        width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
      }

      this.width = Math.min(width, options.maxWidth || this.maxWidth);
      this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
  }, {
    key: "_fitRows",
    value: function _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
      var ctx = this.ctx,
          maxWidth = this.maxWidth,
          padding = this.options.labels.padding;
      var hitboxes = this.legendHitBoxes = [];
      var lineWidths = this.lineWidths = [0];
      var lineHeight = itemHeight + padding;
      var totalHeight = titleHeight;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      var row = -1;
      var top = -lineHeight;
      this.legendItems.forEach(function (legendItem, i) {
        var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

        if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
          totalHeight += lineHeight;
          lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
          top += lineHeight;
          row++;
        }

        hitboxes[i] = {
          left: 0,
          top: top,
          row: row,
          width: itemWidth,
          height: itemHeight
        };
        lineWidths[lineWidths.length - 1] += itemWidth + padding;
      });
      return totalHeight;
    }
  }, {
    key: "_fitCols",
    value: function _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
      var ctx = this.ctx,
          maxHeight = this.maxHeight,
          padding = this.options.labels.padding;
      var hitboxes = this.legendHitBoxes = [];
      var columnSizes = this.columnSizes = [];
      var heightLimit = maxHeight - titleHeight;
      var totalWidth = padding;
      var currentColWidth = 0;
      var currentColHeight = 0;
      var left = 0;
      var col = 0;
      this.legendItems.forEach(function (legendItem, i) {
        var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

        if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
          totalWidth += currentColWidth + padding;
          columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
          });
          left += currentColWidth + padding;
          col++;
          currentColWidth = currentColHeight = 0;
        }

        hitboxes[i] = {
          left: left,
          top: currentColHeight,
          col: col,
          width: itemWidth,
          height: itemHeight
        };
        currentColWidth = Math.max(currentColWidth, itemWidth);
        currentColHeight += itemHeight + padding;
      });
      totalWidth += currentColWidth;
      columnSizes.push({
        width: currentColWidth,
        height: currentColHeight
      });
      return totalWidth;
    }
  }, {
    key: "adjustHitBoxes",
    value: function adjustHitBoxes() {
      if (!this.options.display) {
        return;
      }

      var titleHeight = this._computeTitleHeight();

      var hitboxes = this.legendHitBoxes,
          _this$options13 = this.options,
          align = _this$options13.align,
          padding = _this$options13.labels.padding,
          rtl = _this$options13.rtl;
      var rtlHelper = getRtlAdapter(rtl, this.left, this.width);

      if (this.isHorizontal()) {
        var row = 0;

        var left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);

        var _iterator30 = _createForOfIteratorHelper(hitboxes),
            _step30;

        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var hitbox = _step30.value;

            if (row !== hitbox.row) {
              row = hitbox.row;
              left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
            }

            hitbox.top += this.top + titleHeight + padding;
            hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
            left += hitbox.width + padding;
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
      } else {
        var col = 0;

        var top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);

        var _iterator31 = _createForOfIteratorHelper(hitboxes),
            _step31;

        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _hitbox = _step31.value;

            if (_hitbox.col !== col) {
              col = _hitbox.col;
              top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            }

            _hitbox.top = top;
            _hitbox.left += this.left + padding;
            _hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(_hitbox.left), _hitbox.width);
            top += _hitbox.height + padding;
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
      }
    }
  }, {
    key: "isHorizontal",
    value: function isHorizontal() {
      return this.options.position === 'top' || this.options.position === 'bottom';
    }
  }, {
    key: "draw",
    value: function draw() {
      if (this.options.display) {
        var ctx = this.ctx;
        clipArea(ctx, this);

        this._draw();

        unclipArea(ctx);
      }
    }
  }, {
    key: "_draw",
    value: function _draw() {
      var _this41 = this;

      var opts = this.options,
          columnSizes = this.columnSizes,
          lineWidths = this.lineWidths,
          ctx = this.ctx;
      var align = opts.align,
          labelOpts = opts.labels;
      var defaultColor = defaults.color;
      var rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
      var labelFont = toFont(labelOpts.font);
      var fontColor = labelOpts.color,
          padding = labelOpts.padding;
      var fontSize = labelFont.size;
      var halfFontSize = fontSize / 2;
      var cursor;
      this.drawTitle();
      ctx.textAlign = rtlHelper.textAlign('left');
      ctx.textBaseline = 'middle';
      ctx.lineWidth = 0.5;
      ctx.font = labelFont.string;

      var _getBoxSize2 = getBoxSize(labelOpts, fontSize),
          boxWidth = _getBoxSize2.boxWidth,
          boxHeight = _getBoxSize2.boxHeight,
          itemHeight = _getBoxSize2.itemHeight;

      var drawLegendBox = function drawLegendBox(x, y, legendItem) {
        if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
          return;
        }

        ctx.save();
        var lineWidth = valueOrDefault(legendItem.lineWidth, 1);
        ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
        ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
        ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
        ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
        ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));

        if (labelOpts.usePointStyle) {
          var drawOptions = {
            radius: boxWidth * Math.SQRT2 / 2,
            pointStyle: legendItem.pointStyle,
            rotation: legendItem.rotation,
            borderWidth: lineWidth
          };
          var centerX = rtlHelper.xPlus(x, boxWidth / 2);
          var centerY = y + halfFontSize;
          drawPoint(ctx, drawOptions, centerX, centerY);
        } else {
          var yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
          var xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
          var borderRadius = toTRBLCorners(legendItem.borderRadius);
          ctx.beginPath();

          if (Object.values(borderRadius).some(function (v) {
            return v !== 0;
          })) {
            addRoundedRectPath(ctx, {
              x: xBoxLeft,
              y: yBoxTop,
              w: boxWidth,
              h: boxHeight,
              radius: borderRadius
            });
          } else {
            ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
          }

          ctx.fill();

          if (lineWidth !== 0) {
            ctx.stroke();
          }
        }

        ctx.restore();
      };

      var fillText = function fillText(x, y, legendItem) {
        renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
          strikethrough: legendItem.hidden,
          textAlign: rtlHelper.textAlign(legendItem.textAlign)
        });
      };

      var isHorizontal = this.isHorizontal();

      var titleHeight = this._computeTitleHeight();

      if (isHorizontal) {
        cursor = {
          x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
          y: this.top + padding + titleHeight,
          line: 0
        };
      } else {
        cursor = {
          x: this.left + padding,
          y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
          line: 0
        };
      }

      overrideTextDirection(this.ctx, opts.textDirection);
      var lineHeight = itemHeight + padding;
      this.legendItems.forEach(function (legendItem, i) {
        ctx.strokeStyle = legendItem.fontColor || fontColor;
        ctx.fillStyle = legendItem.fontColor || fontColor;
        var textWidth = ctx.measureText(legendItem.text).width;
        var textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
        var width = boxWidth + halfFontSize + textWidth;
        var x = cursor.x;
        var y = cursor.y;
        rtlHelper.setWidth(_this41.width);

        if (isHorizontal) {
          if (i > 0 && x + width + padding > _this41.right) {
            y = cursor.y += lineHeight;
            cursor.line++;
            x = cursor.x = _alignStartEnd(align, _this41.left + padding, _this41.right - lineWidths[cursor.line]);
          }
        } else if (i > 0 && y + lineHeight > _this41.bottom) {
          x = cursor.x = x + columnSizes[cursor.line].width + padding;
          cursor.line++;
          y = cursor.y = _alignStartEnd(align, _this41.top + titleHeight + padding, _this41.bottom - columnSizes[cursor.line].height);
        }

        var realX = rtlHelper.x(x);
        drawLegendBox(realX, y, legendItem);
        x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : _this41.right, opts.rtl);
        fillText(rtlHelper.x(x), y, legendItem);

        if (isHorizontal) {
          cursor.x += width + padding;
        } else {
          cursor.y += lineHeight;
        }
      });
      restoreTextDirection(this.ctx, opts.textDirection);
    }
  }, {
    key: "drawTitle",
    value: function drawTitle() {
      var opts = this.options;
      var titleOpts = opts.title;
      var titleFont = toFont(titleOpts.font);
      var titlePadding = toPadding(titleOpts.padding);

      if (!titleOpts.display) {
        return;
      }

      var rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
      var ctx = this.ctx;
      var position = titleOpts.position;
      var halfFontSize = titleFont.size / 2;
      var topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
      var y;
      var left = this.left;
      var maxWidth = this.width;

      if (this.isHorizontal()) {
        maxWidth = Math.max.apply(Math, _toConsumableArray(this.lineWidths));
        y = this.top + topPaddingPlusHalfFontSize;
        left = _alignStartEnd(opts.align, left, this.right - maxWidth);
      } else {
        var maxHeight = this.columnSizes.reduce(function (acc, size) {
          return Math.max(acc, size.height);
        }, 0);
        y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
      }

      var x = _alignStartEnd(position, left, left + maxWidth);

      ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
      ctx.textBaseline = 'middle';
      ctx.strokeStyle = titleOpts.color;
      ctx.fillStyle = titleOpts.color;
      ctx.font = titleFont.string;
      renderText(ctx, titleOpts.text, x, y, titleFont);
    }
  }, {
    key: "_computeTitleHeight",
    value: function _computeTitleHeight() {
      var titleOpts = this.options.title;
      var titleFont = toFont(titleOpts.font);
      var titlePadding = toPadding(titleOpts.padding);
      return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
  }, {
    key: "_getLegendItemAt",
    value: function _getLegendItemAt(x, y) {
      var i, hitBox, lh;

      if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
        lh = this.legendHitBoxes;

        for (i = 0; i < lh.length; ++i) {
          hitBox = lh[i];

          if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
            return this.legendItems[i];
          }
        }
      }

      return null;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var opts = this.options;

      if (!isListened(e.type, opts)) {
        return;
      }

      var hoveredItem = this._getLegendItemAt(e.x, e.y);

      if (e.type === 'mousemove' || e.type === 'mouseout') {
        var previous = this._hoveredItem;
        var sameItem = itemsEqual(previous, hoveredItem);

        if (previous && !sameItem) {
          callback(opts.onLeave, [e, previous, this], this);
        }

        this._hoveredItem = hoveredItem;

        if (hoveredItem && !sameItem) {
          callback(opts.onHover, [e, hoveredItem, this], this);
        }
      } else if (hoveredItem) {
        callback(opts.onClick, [e, hoveredItem, this], this);
      }
    }
  }]);

  return Legend;
}(Element);

function isListened(type, opts) {
  if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) {
    return true;
  }

  if (opts.onClick && (type === 'click' || type === 'mouseup')) {
    return true;
  }

  return false;
}

var plugin_legend = {
  id: 'legend',
  _element: Legend,
  start: function start(chart, _args, options) {
    var legend = chart.legend = new Legend({
      ctx: chart.ctx,
      options: options,
      chart: chart
    });
    layouts.configure(chart, legend, options);
    layouts.addBox(chart, legend);
  },
  stop: function stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate: function beforeUpdate(chart, _args, options) {
    var legend = chart.legend;
    layouts.configure(chart, legend, options);
    legend.options = options;
  },
  afterUpdate: function afterUpdate(chart) {
    var legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent: function afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: 'top',
    align: 'center',
    fullSize: true,
    reverse: false,
    weight: 1000,
    onClick: function onClick(e, legendItem, legend) {
      var index = legendItem.datasetIndex;
      var ci = legend.chart;

      if (ci.isDatasetVisible(index)) {
        ci.hide(index);
        legendItem.hidden = true;
      } else {
        ci.show(index);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: function color(ctx) {
        return ctx.chart.options.color;
      },
      boxWidth: 40,
      padding: 10,
      generateLabels: function generateLabels(chart) {
        var datasets = chart.data.datasets;
        var _chart$legend$options = chart.legend.options.labels,
            usePointStyle = _chart$legend$options.usePointStyle,
            pointStyle = _chart$legend$options.pointStyle,
            textAlign = _chart$legend$options.textAlign,
            color = _chart$legend$options.color;
        return chart._getSortedDatasetMetas().map(function (meta) {
          var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
          var borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: 0,
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: function color(ctx) {
        return ctx.chart.options.color;
      },
      display: false,
      position: 'center',
      text: ''
    }
  },
  descriptors: {
    _scriptable: function _scriptable(name) {
      return !name.startsWith('on');
    },
    labels: {
      _scriptable: function _scriptable(name) {
        return !['generateLabels', 'filter', 'sort'].includes(name);
      }
    }
  }
};

var Title = /*#__PURE__*/function (_Element7) {
  _inherits(Title, _Element7);

  var _super19 = _createSuper(Title);

  function Title(config) {
    var _this42;

    _classCallCheck(this, Title);

    _this42 = _super19.call(this);
    _this42.chart = config.chart;
    _this42.options = config.options;
    _this42.ctx = config.ctx;
    _this42._padding = undefined;
    _this42.top = undefined;
    _this42.bottom = undefined;
    _this42.left = undefined;
    _this42.right = undefined;
    _this42.width = undefined;
    _this42.height = undefined;
    _this42.position = undefined;
    _this42.weight = undefined;
    _this42.fullSize = undefined;
    return _this42;
  }

  _createClass(Title, [{
    key: "update",
    value: function update(maxWidth, maxHeight) {
      var opts = this.options;
      this.left = 0;
      this.top = 0;

      if (!opts.display) {
        this.width = this.height = this.right = this.bottom = 0;
        return;
      }

      this.width = this.right = maxWidth;
      this.height = this.bottom = maxHeight;
      var lineCount = isArray(opts.text) ? opts.text.length : 1;
      this._padding = toPadding(opts.padding);

      var textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;

      if (this.isHorizontal()) {
        this.height = textSize;
      } else {
        this.width = textSize;
      }
    }
  }, {
    key: "isHorizontal",
    value: function isHorizontal() {
      var pos = this.options.position;
      return pos === 'top' || pos === 'bottom';
    }
  }, {
    key: "_drawArgs",
    value: function _drawArgs(offset) {
      var top = this.top,
          left = this.left,
          bottom = this.bottom,
          right = this.right,
          options = this.options;
      var align = options.align;
      var rotation = 0;
      var maxWidth, titleX, titleY;

      if (this.isHorizontal()) {
        titleX = _alignStartEnd(align, left, right);
        titleY = top + offset;
        maxWidth = right - left;
      } else {
        if (options.position === 'left') {
          titleX = left + offset;
          titleY = _alignStartEnd(align, bottom, top);
          rotation = PI * -0.5;
        } else {
          titleX = right - offset;
          titleY = _alignStartEnd(align, top, bottom);
          rotation = PI * 0.5;
        }

        maxWidth = bottom - top;
      }

      return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
      };
    }
  }, {
    key: "draw",
    value: function draw() {
      var ctx = this.ctx;
      var opts = this.options;

      if (!opts.display) {
        return;
      }

      var fontOpts = toFont(opts.font);
      var lineHeight = fontOpts.lineHeight;
      var offset = lineHeight / 2 + this._padding.top;

      var _this$_drawArgs = this._drawArgs(offset),
          titleX = _this$_drawArgs.titleX,
          titleY = _this$_drawArgs.titleY,
          maxWidth = _this$_drawArgs.maxWidth,
          rotation = _this$_drawArgs.rotation;

      renderText(ctx, opts.text, 0, 0, fontOpts, {
        color: opts.color,
        maxWidth: maxWidth,
        rotation: rotation,
        textAlign: _toLeftRightCenter(opts.align),
        textBaseline: 'middle',
        translation: [titleX, titleY]
      });
    }
  }]);

  return Title;
}(Element);

function createTitle(chart, titleOpts) {
  var title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart: chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}

var plugin_title = {
  id: 'title',
  _element: Title,
  start: function start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop: function stop(chart) {
    var titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate: function beforeUpdate(chart, _args, options) {
    var title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: 'center',
    display: false,
    font: {
      weight: 'bold'
    },
    fullSize: true,
    padding: 10,
    position: 'top',
    text: '',
    weight: 2000
  },
  defaultRoutes: {
    color: 'color'
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
var map = new WeakMap();
var plugin_subtitle = {
  id: 'subtitle',
  start: function start(chart, _args, options) {
    var title = new Title({
      ctx: chart.ctx,
      options: options,
      chart: chart
    });
    layouts.configure(chart, title, options);
    layouts.addBox(chart, title);
    map.set(chart, title);
  },
  stop: function stop(chart) {
    layouts.removeBox(chart, map.get(chart));
    map["delete"](chart);
  },
  beforeUpdate: function beforeUpdate(chart, _args, options) {
    var title = map.get(chart);
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: 'center',
    display: false,
    font: {
      weight: 'normal'
    },
    fullSize: true,
    padding: 0,
    position: 'top',
    text: '',
    weight: 1500
  },
  defaultRoutes: {
    color: 'color'
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
var positioners = {
  average: function average(items) {
    if (!items.length) {
      return false;
    }

    var i, len;
    var x = 0;
    var y = 0;
    var count = 0;

    for (i = 0, len = items.length; i < len; ++i) {
      var el = items[i].element;

      if (el && el.hasValue()) {
        var pos = el.tooltipPosition();
        x += pos.x;
        y += pos.y;
        ++count;
      }
    }

    return {
      x: x / count,
      y: y / count
    };
  },
  nearest: function nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }

    var x = eventPosition.x;
    var y = eventPosition.y;
    var minDistance = Number.POSITIVE_INFINITY;
    var i, len, nearestElement;

    for (i = 0, len = items.length; i < len; ++i) {
      var el = items[i].element;

      if (el && el.hasValue()) {
        var center = el.getCenterPoint();
        var d = distanceBetweenPoints(eventPosition, center);

        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }

    if (nearestElement) {
      var tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }

    return {
      x: x,
      y: y
    };
  }
};

function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }

  return base;
}

function splitNewlines(str) {
  if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
    return str.split('\n');
  }

  return str;
}

function createTooltipItem(chart, item) {
  var element = item.element,
      datasetIndex = item.datasetIndex,
      index = item.index;
  var controller = chart.getDatasetMeta(datasetIndex).controller;

  var _controller$getLabelA = controller.getLabelAndValue(index),
      label = _controller$getLabelA.label,
      value = _controller$getLabelA.value;

  return {
    chart: chart,
    label: label,
    parsed: controller.getParsed(index),
    raw: chart.data.datasets[datasetIndex].data[index],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index,
    datasetIndex: datasetIndex,
    element: element
  };
}

function getTooltipSize(tooltip, options) {
  var ctx = tooltip.chart.ctx;
  var body = tooltip.body,
      footer = tooltip.footer,
      title = tooltip.title;
  var boxWidth = options.boxWidth,
      boxHeight = options.boxHeight;
  var bodyFont = toFont(options.bodyFont);
  var titleFont = toFont(options.titleFont);
  var footerFont = toFont(options.footerFont);
  var titleLineCount = title.length;
  var footerLineCount = footer.length;
  var bodyLineItemCount = body.length;
  var padding = toPadding(options.padding);
  var height = padding.height;
  var width = 0;
  var combinedBodyLength = body.reduce(function (count, bodyItem) {
    return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
  }, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;

  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }

  if (combinedBodyLength) {
    var bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }

  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }

  var widthPadding = 0;

  var maxLineWidth = function maxLineWidth(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };

  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, function (bodyItem) {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width: width,
    height: height
  };
}

function determineYAlign(chart, size) {
  var y = size.y,
      height = size.height;

  if (y < height / 2) {
    return 'top';
  } else if (y > chart.height - height / 2) {
    return 'bottom';
  }

  return 'center';
}

function doesNotFitWithAlign(xAlign, chart, options, size) {
  var x = size.x,
      width = size.width;
  var caret = options.caretSize + options.caretPadding;

  if (xAlign === 'left' && x + width + caret > chart.width) {
    return true;
  }

  if (xAlign === 'right' && x - width - caret < 0) {
    return true;
  }
}

function determineXAlign(chart, options, size, yAlign) {
  var x = size.x,
      width = size.width;
  var chartWidth = chart.width,
      _chart$chartArea = chart.chartArea,
      left = _chart$chartArea.left,
      right = _chart$chartArea.right;
  var xAlign = 'center';

  if (yAlign === 'center') {
    xAlign = x <= (left + right) / 2 ? 'left' : 'right';
  } else if (x <= width / 2) {
    xAlign = 'left';
  } else if (x >= chartWidth - width / 2) {
    xAlign = 'right';
  }

  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = 'center';
  }

  return xAlign;
}

function determineAlignment(chart, options, size) {
  var yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign: yAlign
  };
}

function alignX(size, xAlign) {
  var x = size.x,
      width = size.width;

  if (xAlign === 'right') {
    x -= width;
  } else if (xAlign === 'center') {
    x -= width / 2;
  }

  return x;
}

function alignY(size, yAlign, paddingAndSize) {
  var y = size.y,
      height = size.height;

  if (yAlign === 'top') {
    y += paddingAndSize;
  } else if (yAlign === 'bottom') {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }

  return y;
}

function getBackgroundPoint(options, size, alignment, chart) {
  var caretSize = options.caretSize,
      caretPadding = options.caretPadding,
      cornerRadius = options.cornerRadius;
  var xAlign = alignment.xAlign,
      yAlign = alignment.yAlign;
  var paddingAndSize = caretSize + caretPadding;

  var _toTRBLCorners = toTRBLCorners(cornerRadius),
      topLeft = _toTRBLCorners.topLeft,
      topRight = _toTRBLCorners.topRight,
      bottomLeft = _toTRBLCorners.bottomLeft,
      bottomRight = _toTRBLCorners.bottomRight;

  var x = alignX(size, xAlign);
  var y = alignY(size, yAlign, paddingAndSize);

  if (yAlign === 'center') {
    if (xAlign === 'left') {
      x += paddingAndSize;
    } else if (xAlign === 'right') {
      x -= paddingAndSize;
    }
  } else if (xAlign === 'left') {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === 'right') {
    x += Math.max(topRight, bottomRight) + caretSize;
  }

  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}

function getAlignedX(tooltip, align, options) {
  var padding = toPadding(options.padding);
  return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}

function getBeforeAfterBodyLines(callback) {
  return pushOrConcat([], splitNewlines(callback));
}

function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip: tooltip,
    tooltipItems: tooltipItems,
    type: 'tooltip'
  });
}

function overrideCallbacks(callbacks, context) {
  var override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}

var Tooltip = /*#__PURE__*/function (_Element8) {
  _inherits(Tooltip, _Element8);

  var _super20 = _createSuper(Tooltip);

  function Tooltip(config) {
    var _this43;

    _classCallCheck(this, Tooltip);

    _this43 = _super20.call(this);
    _this43.opacity = 0;
    _this43._active = [];
    _this43._eventPosition = undefined;
    _this43._size = undefined;
    _this43._cachedAnimations = undefined;
    _this43._tooltipItems = [];
    _this43.$animations = undefined;
    _this43.$context = undefined;
    _this43.chart = config.chart || config._chart;
    _this43._chart = _this43.chart;
    _this43.options = config.options;
    _this43.dataPoints = undefined;
    _this43.title = undefined;
    _this43.beforeBody = undefined;
    _this43.body = undefined;
    _this43.afterBody = undefined;
    _this43.footer = undefined;
    _this43.xAlign = undefined;
    _this43.yAlign = undefined;
    _this43.x = undefined;
    _this43.y = undefined;
    _this43.height = undefined;
    _this43.width = undefined;
    _this43.caretX = undefined;
    _this43.caretY = undefined;
    _this43.labelColors = undefined;
    _this43.labelPointStyles = undefined;
    _this43.labelTextColors = undefined;
    return _this43;
  }

  _createClass(Tooltip, [{
    key: "initialize",
    value: function initialize(options) {
      this.options = options;
      this._cachedAnimations = undefined;
      this.$context = undefined;
    }
  }, {
    key: "_resolveAnimations",
    value: function _resolveAnimations() {
      var cached = this._cachedAnimations;

      if (cached) {
        return cached;
      }

      var chart = this.chart;
      var options = this.options.setContext(this.getContext());
      var opts = options.enabled && chart.options.animation && options.animations;
      var animations = new Animations(this.chart, opts);

      if (opts._cacheable) {
        this._cachedAnimations = Object.freeze(animations);
      }

      return animations;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
  }, {
    key: "getTitle",
    value: function getTitle(context, options) {
      var callbacks = options.callbacks;
      var beforeTitle = callbacks.beforeTitle.apply(this, [context]);
      var title = callbacks.title.apply(this, [context]);
      var afterTitle = callbacks.afterTitle.apply(this, [context]);
      var lines = [];
      lines = pushOrConcat(lines, splitNewlines(beforeTitle));
      lines = pushOrConcat(lines, splitNewlines(title));
      lines = pushOrConcat(lines, splitNewlines(afterTitle));
      return lines;
    }
  }, {
    key: "getBeforeBody",
    value: function getBeforeBody(tooltipItems, options) {
      return getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [tooltipItems]));
    }
  }, {
    key: "getBody",
    value: function getBody(tooltipItems, options) {
      var _this44 = this;

      var callbacks = options.callbacks;
      var bodyItems = [];
      each(tooltipItems, function (context) {
        var bodyItem = {
          before: [],
          lines: [],
          after: []
        };
        var scoped = overrideCallbacks(callbacks, context);
        pushOrConcat(bodyItem.before, splitNewlines(scoped.beforeLabel.call(_this44, context)));
        pushOrConcat(bodyItem.lines, scoped.label.call(_this44, context));
        pushOrConcat(bodyItem.after, splitNewlines(scoped.afterLabel.call(_this44, context)));
        bodyItems.push(bodyItem);
      });
      return bodyItems;
    }
  }, {
    key: "getAfterBody",
    value: function getAfterBody(tooltipItems, options) {
      return getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [tooltipItems]));
    }
  }, {
    key: "getFooter",
    value: function getFooter(tooltipItems, options) {
      var callbacks = options.callbacks;
      var beforeFooter = callbacks.beforeFooter.apply(this, [tooltipItems]);
      var footer = callbacks.footer.apply(this, [tooltipItems]);
      var afterFooter = callbacks.afterFooter.apply(this, [tooltipItems]);
      var lines = [];
      lines = pushOrConcat(lines, splitNewlines(beforeFooter));
      lines = pushOrConcat(lines, splitNewlines(footer));
      lines = pushOrConcat(lines, splitNewlines(afterFooter));
      return lines;
    }
  }, {
    key: "_createItems",
    value: function _createItems(options) {
      var _this45 = this;

      var active = this._active;
      var data = this.chart.data;
      var labelColors = [];
      var labelPointStyles = [];
      var labelTextColors = [];
      var tooltipItems = [];
      var i, len;

      for (i = 0, len = active.length; i < len; ++i) {
        tooltipItems.push(createTooltipItem(this.chart, active[i]));
      }

      if (options.filter) {
        tooltipItems = tooltipItems.filter(function (element, index, array) {
          return options.filter(element, index, array, data);
        });
      }

      if (options.itemSort) {
        tooltipItems = tooltipItems.sort(function (a, b) {
          return options.itemSort(a, b, data);
        });
      }

      each(tooltipItems, function (context) {
        var scoped = overrideCallbacks(options.callbacks, context);
        labelColors.push(scoped.labelColor.call(_this45, context));
        labelPointStyles.push(scoped.labelPointStyle.call(_this45, context));
        labelTextColors.push(scoped.labelTextColor.call(_this45, context));
      });
      this.labelColors = labelColors;
      this.labelPointStyles = labelPointStyles;
      this.labelTextColors = labelTextColors;
      this.dataPoints = tooltipItems;
      return tooltipItems;
    }
  }, {
    key: "update",
    value: function update(changed, replay) {
      var options = this.options.setContext(this.getContext());
      var active = this._active;
      var properties;
      var tooltipItems = [];

      if (!active.length) {
        if (this.opacity !== 0) {
          properties = {
            opacity: 0
          };
        }
      } else {
        var position = positioners[options.position].call(this, active, this._eventPosition);
        tooltipItems = this._createItems(options);
        this.title = this.getTitle(tooltipItems, options);
        this.beforeBody = this.getBeforeBody(tooltipItems, options);
        this.body = this.getBody(tooltipItems, options);
        this.afterBody = this.getAfterBody(tooltipItems, options);
        this.footer = this.getFooter(tooltipItems, options);
        var size = this._size = getTooltipSize(this, options);
        var positionAndSize = Object.assign({}, position, size);
        var alignment = determineAlignment(this.chart, options, positionAndSize);
        var backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        properties = {
          opacity: 1,
          x: backgroundPoint.x,
          y: backgroundPoint.y,
          width: size.width,
          height: size.height,
          caretX: position.x,
          caretY: position.y
        };
      }

      this._tooltipItems = tooltipItems;
      this.$context = undefined;

      if (properties) {
        this._resolveAnimations().update(this, properties);
      }

      if (changed && options.external) {
        options.external.call(this, {
          chart: this.chart,
          tooltip: this,
          replay: replay
        });
      }
    }
  }, {
    key: "drawCaret",
    value: function drawCaret(tooltipPoint, ctx, size, options) {
      var caretPosition = this.getCaretPosition(tooltipPoint, size, options);
      ctx.lineTo(caretPosition.x1, caretPosition.y1);
      ctx.lineTo(caretPosition.x2, caretPosition.y2);
      ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
  }, {
    key: "getCaretPosition",
    value: function getCaretPosition(tooltipPoint, size, options) {
      var xAlign = this.xAlign,
          yAlign = this.yAlign;
      var caretSize = options.caretSize,
          cornerRadius = options.cornerRadius;

      var _toTRBLCorners2 = toTRBLCorners(cornerRadius),
          topLeft = _toTRBLCorners2.topLeft,
          topRight = _toTRBLCorners2.topRight,
          bottomLeft = _toTRBLCorners2.bottomLeft,
          bottomRight = _toTRBLCorners2.bottomRight;

      var ptX = tooltipPoint.x,
          ptY = tooltipPoint.y;
      var width = size.width,
          height = size.height;
      var x1, x2, x3, y1, y2, y3;

      if (yAlign === 'center') {
        y2 = ptY + height / 2;

        if (xAlign === 'left') {
          x1 = ptX;
          x2 = x1 - caretSize;
          y1 = y2 + caretSize;
          y3 = y2 - caretSize;
        } else {
          x1 = ptX + width;
          x2 = x1 + caretSize;
          y1 = y2 - caretSize;
          y3 = y2 + caretSize;
        }

        x3 = x1;
      } else {
        if (xAlign === 'left') {
          x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
        } else if (xAlign === 'right') {
          x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
        } else {
          x2 = this.caretX;
        }

        if (yAlign === 'top') {
          y1 = ptY;
          y2 = y1 - caretSize;
          x1 = x2 - caretSize;
          x3 = x2 + caretSize;
        } else {
          y1 = ptY + height;
          y2 = y1 + caretSize;
          x1 = x2 + caretSize;
          x3 = x2 - caretSize;
        }

        y3 = y1;
      }

      return {
        x1: x1,
        x2: x2,
        x3: x3,
        y1: y1,
        y2: y2,
        y3: y3
      };
    }
  }, {
    key: "drawTitle",
    value: function drawTitle(pt, ctx, options) {
      var title = this.title;
      var length = title.length;
      var titleFont, titleSpacing, i;

      if (length) {
        var rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
        pt.x = getAlignedX(this, options.titleAlign, options);
        ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
        ctx.textBaseline = 'middle';
        titleFont = toFont(options.titleFont);
        titleSpacing = options.titleSpacing;
        ctx.fillStyle = options.titleColor;
        ctx.font = titleFont.string;

        for (i = 0; i < length; ++i) {
          ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
          pt.y += titleFont.lineHeight + titleSpacing;

          if (i + 1 === length) {
            pt.y += options.titleMarginBottom - titleSpacing;
          }
        }
      }
    }
  }, {
    key: "_drawColorBox",
    value: function _drawColorBox(ctx, pt, i, rtlHelper, options) {
      var labelColors = this.labelColors[i];
      var labelPointStyle = this.labelPointStyles[i];
      var boxHeight = options.boxHeight,
          boxWidth = options.boxWidth,
          boxPadding = options.boxPadding;
      var bodyFont = toFont(options.bodyFont);
      var colorX = getAlignedX(this, 'left', options);
      var rtlColorX = rtlHelper.x(colorX);
      var yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
      var colorY = pt.y + yOffSet;

      if (options.usePointStyle) {
        var drawOptions = {
          radius: Math.min(boxWidth, boxHeight) / 2,
          pointStyle: labelPointStyle.pointStyle,
          rotation: labelPointStyle.rotation,
          borderWidth: 1
        };
        var centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
        var centerY = colorY + boxHeight / 2;
        ctx.strokeStyle = options.multiKeyBackground;
        ctx.fillStyle = options.multiKeyBackground;
        drawPoint(ctx, drawOptions, centerX, centerY);
        ctx.strokeStyle = labelColors.borderColor;
        ctx.fillStyle = labelColors.backgroundColor;
        drawPoint(ctx, drawOptions, centerX, centerY);
      } else {
        ctx.lineWidth = labelColors.borderWidth || 1;
        ctx.strokeStyle = labelColors.borderColor;
        ctx.setLineDash(labelColors.borderDash || []);
        ctx.lineDashOffset = labelColors.borderDashOffset || 0;
        var outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
        var innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
        var borderRadius = toTRBLCorners(labelColors.borderRadius);

        if (Object.values(borderRadius).some(function (v) {
          return v !== 0;
        })) {
          ctx.beginPath();
          ctx.fillStyle = options.multiKeyBackground;
          addRoundedRectPath(ctx, {
            x: outerX,
            y: colorY,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius
          });
          ctx.fill();
          ctx.stroke();
          ctx.fillStyle = labelColors.backgroundColor;
          ctx.beginPath();
          addRoundedRectPath(ctx, {
            x: innerX,
            y: colorY + 1,
            w: boxWidth - 2,
            h: boxHeight - 2,
            radius: borderRadius
          });
          ctx.fill();
        } else {
          ctx.fillStyle = options.multiKeyBackground;
          ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
          ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
          ctx.fillStyle = labelColors.backgroundColor;
          ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
        }
      }

      ctx.fillStyle = this.labelTextColors[i];
    }
  }, {
    key: "drawBody",
    value: function drawBody(pt, ctx, options) {
      var body = this.body;
      var bodySpacing = options.bodySpacing,
          bodyAlign = options.bodyAlign,
          displayColors = options.displayColors,
          boxHeight = options.boxHeight,
          boxWidth = options.boxWidth,
          boxPadding = options.boxPadding;
      var bodyFont = toFont(options.bodyFont);
      var bodyLineHeight = bodyFont.lineHeight;
      var xLinePadding = 0;
      var rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);

      var fillLineOfText = function fillLineOfText(line) {
        ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
        pt.y += bodyLineHeight + bodySpacing;
      };

      var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
      var bodyItem, textColor, lines, i, j, ilen, jlen;
      ctx.textAlign = bodyAlign;
      ctx.textBaseline = 'middle';
      ctx.font = bodyFont.string;
      pt.x = getAlignedX(this, bodyAlignForCalculation, options);
      ctx.fillStyle = options.bodyColor;
      each(this.beforeBody, fillLineOfText);
      xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;

      for (i = 0, ilen = body.length; i < ilen; ++i) {
        bodyItem = body[i];
        textColor = this.labelTextColors[i];
        ctx.fillStyle = textColor;
        each(bodyItem.before, fillLineOfText);
        lines = bodyItem.lines;

        if (displayColors && lines.length) {
          this._drawColorBox(ctx, pt, i, rtlHelper, options);

          bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
        }

        for (j = 0, jlen = lines.length; j < jlen; ++j) {
          fillLineOfText(lines[j]);
          bodyLineHeight = bodyFont.lineHeight;
        }

        each(bodyItem.after, fillLineOfText);
      }

      xLinePadding = 0;
      bodyLineHeight = bodyFont.lineHeight;
      each(this.afterBody, fillLineOfText);
      pt.y -= bodySpacing;
    }
  }, {
    key: "drawFooter",
    value: function drawFooter(pt, ctx, options) {
      var footer = this.footer;
      var length = footer.length;
      var footerFont, i;

      if (length) {
        var rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
        pt.x = getAlignedX(this, options.footerAlign, options);
        pt.y += options.footerMarginTop;
        ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
        ctx.textBaseline = 'middle';
        footerFont = toFont(options.footerFont);
        ctx.fillStyle = options.footerColor;
        ctx.font = footerFont.string;

        for (i = 0; i < length; ++i) {
          ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
          pt.y += footerFont.lineHeight + options.footerSpacing;
        }
      }
    }
  }, {
    key: "drawBackground",
    value: function drawBackground(pt, ctx, tooltipSize, options) {
      var xAlign = this.xAlign,
          yAlign = this.yAlign;
      var x = pt.x,
          y = pt.y;
      var width = tooltipSize.width,
          height = tooltipSize.height;

      var _toTRBLCorners3 = toTRBLCorners(options.cornerRadius),
          topLeft = _toTRBLCorners3.topLeft,
          topRight = _toTRBLCorners3.topRight,
          bottomLeft = _toTRBLCorners3.bottomLeft,
          bottomRight = _toTRBLCorners3.bottomRight;

      ctx.fillStyle = options.backgroundColor;
      ctx.strokeStyle = options.borderColor;
      ctx.lineWidth = options.borderWidth;
      ctx.beginPath();
      ctx.moveTo(x + topLeft, y);

      if (yAlign === 'top') {
        this.drawCaret(pt, ctx, tooltipSize, options);
      }

      ctx.lineTo(x + width - topRight, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);

      if (yAlign === 'center' && xAlign === 'right') {
        this.drawCaret(pt, ctx, tooltipSize, options);
      }

      ctx.lineTo(x + width, y + height - bottomRight);
      ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);

      if (yAlign === 'bottom') {
        this.drawCaret(pt, ctx, tooltipSize, options);
      }

      ctx.lineTo(x + bottomLeft, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);

      if (yAlign === 'center' && xAlign === 'left') {
        this.drawCaret(pt, ctx, tooltipSize, options);
      }

      ctx.lineTo(x, y + topLeft);
      ctx.quadraticCurveTo(x, y, x + topLeft, y);
      ctx.closePath();
      ctx.fill();

      if (options.borderWidth > 0) {
        ctx.stroke();
      }
    }
  }, {
    key: "_updateAnimationTarget",
    value: function _updateAnimationTarget(options) {
      var chart = this.chart;
      var anims = this.$animations;
      var animX = anims && anims.x;
      var animY = anims && anims.y;

      if (animX || animY) {
        var position = positioners[options.position].call(this, this._active, this._eventPosition);

        if (!position) {
          return;
        }

        var size = this._size = getTooltipSize(this, options);
        var positionAndSize = Object.assign({}, position, this._size);
        var alignment = determineAlignment(chart, options, positionAndSize);
        var point = getBackgroundPoint(options, positionAndSize, alignment, chart);

        if (animX._to !== point.x || animY._to !== point.y) {
          this.xAlign = alignment.xAlign;
          this.yAlign = alignment.yAlign;
          this.width = size.width;
          this.height = size.height;
          this.caretX = position.x;
          this.caretY = position.y;

          this._resolveAnimations().update(this, point);
        }
      }
    }
  }, {
    key: "_willRender",
    value: function _willRender() {
      return !!this.opacity;
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      var options = this.options.setContext(this.getContext());
      var opacity = this.opacity;

      if (!opacity) {
        return;
      }

      this._updateAnimationTarget(options);

      var tooltipSize = {
        width: this.width,
        height: this.height
      };
      var pt = {
        x: this.x,
        y: this.y
      };
      opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
      var padding = toPadding(options.padding);
      var hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;

      if (options.enabled && hasTooltipContent) {
        ctx.save();
        ctx.globalAlpha = opacity;
        this.drawBackground(pt, ctx, tooltipSize, options);
        overrideTextDirection(ctx, options.textDirection);
        pt.y += padding.top;
        this.drawTitle(pt, ctx, options);
        this.drawBody(pt, ctx, options);
        this.drawFooter(pt, ctx, options);
        restoreTextDirection(ctx, options.textDirection);
        ctx.restore();
      }
    }
  }, {
    key: "getActiveElements",
    value: function getActiveElements() {
      return this._active || [];
    }
  }, {
    key: "setActiveElements",
    value: function setActiveElements(activeElements, eventPosition) {
      var _this46 = this;

      var lastActive = this._active;
      var active = activeElements.map(function (_ref13) {
        var datasetIndex = _ref13.datasetIndex,
            index = _ref13.index;

        var meta = _this46.chart.getDatasetMeta(datasetIndex);

        if (!meta) {
          throw new Error('Cannot find a dataset at index ' + datasetIndex);
        }

        return {
          datasetIndex: datasetIndex,
          element: meta.data[index],
          index: index
        };
      });
      var changed = !_elementsEqual(lastActive, active);

      var positionChanged = this._positionChanged(active, eventPosition);

      if (changed || positionChanged) {
        this._active = active;
        this._eventPosition = eventPosition;
        this._ignoreReplayEvents = true;
        this.update(true);
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e, replay) {
      var inChartArea = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (replay && this._ignoreReplayEvents) {
        return false;
      }

      this._ignoreReplayEvents = false;
      var options = this.options;
      var lastActive = this._active || [];

      var active = this._getActiveElements(e, lastActive, replay, inChartArea);

      var positionChanged = this._positionChanged(active, e);

      var changed = replay || !_elementsEqual(active, lastActive) || positionChanged;

      if (changed) {
        this._active = active;

        if (options.enabled || options.external) {
          this._eventPosition = {
            x: e.x,
            y: e.y
          };
          this.update(true, replay);
        }
      }

      return changed;
    }
  }, {
    key: "_getActiveElements",
    value: function _getActiveElements(e, lastActive, replay, inChartArea) {
      var options = this.options;

      if (e.type === 'mouseout') {
        return [];
      }

      if (!inChartArea) {
        return lastActive;
      }

      var active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);

      if (options.reverse) {
        active.reverse();
      }

      return active;
    }
  }, {
    key: "_positionChanged",
    value: function _positionChanged(active, e) {
      var caretX = this.caretX,
          caretY = this.caretY,
          options = this.options;
      var position = positioners[options.position].call(this, active, e);
      return position !== false && (caretX !== position.x || caretY !== position.y);
    }
  }]);

  return Tooltip;
}(Element);

Tooltip.positioners = positioners;
var plugin_tooltip = {
  id: 'tooltip',
  _element: Tooltip,
  positioners: positioners,
  afterInit: function afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({
        chart: chart,
        options: options
      });
    }
  },
  beforeUpdate: function beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset: function reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw: function afterDraw(chart) {
    var tooltip = chart.tooltip;

    if (tooltip && tooltip._willRender()) {
      var args = {
        tooltip: tooltip
      };

      if (chart.notifyPlugins('beforeTooltipDraw', args) === false) {
        return;
      }

      tooltip.draw(chart.ctx);
      chart.notifyPlugins('afterTooltipDraw', args);
    }
  },
  afterEvent: function afterEvent(chart, args) {
    if (chart.tooltip) {
      var useFinalPosition = args.replay;

      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: 'average',
    backgroundColor: 'rgba(0,0,0,0.8)',
    titleColor: '#fff',
    titleFont: {
      weight: 'bold'
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: 'left',
    bodyColor: '#fff',
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: 'left',
    footerColor: '#fff',
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: 'bold'
    },
    footerAlign: 'left',
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: function boxHeight(ctx, opts) {
      return opts.bodyFont.size;
    },
    boxWidth: function boxWidth(ctx, opts) {
      return opts.bodyFont.size;
    },
    multiKeyBackground: '#fff',
    displayColors: true,
    boxPadding: 0,
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: 'easeOutQuart'
    },
    animations: {
      numbers: {
        type: 'number',
        properties: ['x', 'y', 'width', 'height', 'caretX', 'caretY']
      },
      opacity: {
        easing: 'linear',
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: noop,
      title: function title(tooltipItems) {
        if (tooltipItems.length > 0) {
          var item = tooltipItems[0];
          var labels = item.chart.data.labels;
          var labelCount = labels ? labels.length : 0;

          if (this && this.options && this.options.mode === 'dataset') {
            return item.dataset.label || '';
          } else if (item.label) {
            return item.label;
          } else if (labelCount > 0 && item.dataIndex < labelCount) {
            return labels[item.dataIndex];
          }
        }

        return '';
      },
      afterTitle: noop,
      beforeBody: noop,
      beforeLabel: noop,
      label: function label(tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') {
          return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }

        var label = tooltipItem.dataset.label || '';

        if (label) {
          label += ': ';
        }

        var value = tooltipItem.formattedValue;

        if (!isNullOrUndef(value)) {
          label += value;
        }

        return label;
      },
      labelColor: function labelColor(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          borderColor: options.borderColor,
          backgroundColor: options.backgroundColor,
          borderWidth: options.borderWidth,
          borderDash: options.borderDash,
          borderDashOffset: options.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor: function labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle: function labelPointStyle(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          pointStyle: options.pointStyle,
          rotation: options.rotation
        };
      },
      afterLabel: noop,
      afterBody: noop,
      beforeFooter: noop,
      footer: noop,
      afterFooter: noop
    }
  },
  defaultRoutes: {
    bodyFont: 'font',
    footerFont: 'font',
    titleFont: 'font'
  },
  descriptors: {
    _scriptable: function _scriptable(name) {
      return name !== 'filter' && name !== 'itemSort' && name !== 'external';
    },
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: 'animation'
    }
  },
  additionalOptionScopes: ['interaction']
};
var plugins = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Decimation: plugin_decimation,
  Filler: index,
  Legend: plugin_legend,
  SubTitle: plugin_subtitle,
  Title: plugin_title,
  Tooltip: plugin_tooltip
});

var addIfString = function addIfString(labels, raw, index, addedLabels) {
  if (typeof raw === 'string') {
    index = labels.push(raw) - 1;
    addedLabels.unshift({
      index: index,
      label: raw
    });
  } else if (isNaN(raw)) {
    index = null;
  }

  return index;
};

function findOrAddLabel(labels, raw, index, addedLabels) {
  var first = labels.indexOf(raw);

  if (first === -1) {
    return addIfString(labels, raw, index, addedLabels);
  }

  var last = labels.lastIndexOf(raw);
  return first !== last ? index : first;
}

var validIndex = function validIndex(index, max) {
  return index === null ? null : _limitValue(Math.round(index), 0, max);
};

var CategoryScale = /*#__PURE__*/function (_Scale) {
  _inherits(CategoryScale, _Scale);

  var _super21 = _createSuper(CategoryScale);

  function CategoryScale(cfg) {
    var _this47;

    _classCallCheck(this, CategoryScale);

    _this47 = _super21.call(this, cfg);
    _this47._startValue = undefined;
    _this47._valueRange = 0;
    _this47._addedLabels = [];
    return _this47;
  }

  _createClass(CategoryScale, [{
    key: "init",
    value: function init(scaleOptions) {
      var added = this._addedLabels;

      if (added.length) {
        var labels = this.getLabels();

        var _iterator32 = _createForOfIteratorHelper(added),
            _step32;

        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var _step32$value = _step32.value,
                _index7 = _step32$value.index,
                label = _step32$value.label;

            if (labels[_index7] === label) {
              labels.splice(_index7, 1);
            }
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }

        this._addedLabels = [];
      }

      _get(_getPrototypeOf(CategoryScale.prototype), "init", this).call(this, scaleOptions);
    }
  }, {
    key: "parse",
    value: function parse(raw, index) {
      if (isNullOrUndef(raw)) {
        return null;
      }

      var labels = this.getLabels();
      index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
      return validIndex(index, labels.length - 1);
    }
  }, {
    key: "determineDataLimits",
    value: function determineDataLimits() {
      var _this$getUserBounds2 = this.getUserBounds(),
          minDefined = _this$getUserBounds2.minDefined,
          maxDefined = _this$getUserBounds2.maxDefined;

      var _this$getMinMax = this.getMinMax(true),
          min = _this$getMinMax.min,
          max = _this$getMinMax.max;

      if (this.options.bounds === 'ticks') {
        if (!minDefined) {
          min = 0;
        }

        if (!maxDefined) {
          max = this.getLabels().length - 1;
        }
      }

      this.min = min;
      this.max = max;
    }
  }, {
    key: "buildTicks",
    value: function buildTicks() {
      var min = this.min;
      var max = this.max;
      var offset = this.options.offset;
      var ticks = [];
      var labels = this.getLabels();
      labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
      this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
      this._startValue = this.min - (offset ? 0.5 : 0);

      for (var value = min; value <= max; value++) {
        ticks.push({
          value: value
        });
      }

      return ticks;
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value) {
      var labels = this.getLabels();

      if (value >= 0 && value < labels.length) {
        return labels[value];
      }

      return value;
    }
  }, {
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(CategoryScale.prototype), "configure", this).call(this);

      if (!this.isHorizontal()) {
        this._reversePixels = !this._reversePixels;
      }
    }
  }, {
    key: "getPixelForValue",
    value: function getPixelForValue(value) {
      if (typeof value !== 'number') {
        value = this.parse(value);
      }

      return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
  }, {
    key: "getPixelForTick",
    value: function getPixelForTick(index) {
      var ticks = this.ticks;

      if (index < 0 || index > ticks.length - 1) {
        return null;
      }

      return this.getPixelForValue(ticks[index].value);
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {
      return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
  }, {
    key: "getBasePixel",
    value: function getBasePixel() {
      return this.bottom;
    }
  }]);

  return CategoryScale;
}(Scale);

CategoryScale.id = 'category';
CategoryScale.defaults = {
  ticks: {
    callback: CategoryScale.prototype.getLabelForValue
  }
};

function generateTicks$1(generationOptions, dataRange) {
  var ticks = [];
  var MIN_SPACING = 1e-14;
  var bounds = generationOptions.bounds,
      step = generationOptions.step,
      min = generationOptions.min,
      max = generationOptions.max,
      precision = generationOptions.precision,
      count = generationOptions.count,
      maxTicks = generationOptions.maxTicks,
      maxDigits = generationOptions.maxDigits,
      includeBounds = generationOptions.includeBounds;
  var unit = step || 1;
  var maxSpaces = maxTicks - 1;
  var rmin = dataRange.min,
      rmax = dataRange.max;
  var minDefined = !isNullOrUndef(min);
  var maxDefined = !isNullOrUndef(max);
  var countDefined = !isNullOrUndef(count);
  var minSpacing = (rmax - rmin) / (maxDigits + 1);
  var spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  var factor, niceMin, niceMax, numSpaces;

  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [{
      value: rmin
    }, {
      value: rmax
    }];
  }

  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);

  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }

  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }

  if (bounds === 'ticks') {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }

  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;

    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }

  var decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  var j = 0;

  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({
        value: min
      });

      if (niceMin < min) {
        j++;
      }

      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }

  for (; j < numSpaces; ++j) {
    ticks.push({
      value: Math.round((niceMin + j * spacing) * factor) / factor
    });
  }

  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({
        value: max
      });
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({
      value: niceMax
    });
  }

  return ticks;
}

function relativeLabelSize(value, minSpacing, _ref14) {
  var horizontal = _ref14.horizontal,
      minRotation = _ref14.minRotation;
  var rad = toRadians(minRotation);
  var ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
  var length = 0.75 * minSpacing * ('' + value).length;
  return Math.min(minSpacing / ratio, length);
}

var LinearScaleBase = /*#__PURE__*/function (_Scale2) {
  _inherits(LinearScaleBase, _Scale2);

  var _super22 = _createSuper(LinearScaleBase);

  function LinearScaleBase(cfg) {
    var _this48;

    _classCallCheck(this, LinearScaleBase);

    _this48 = _super22.call(this, cfg);
    _this48.start = undefined;
    _this48.end = undefined;
    _this48._startValue = undefined;
    _this48._endValue = undefined;
    _this48._valueRange = 0;
    return _this48;
  }

  _createClass(LinearScaleBase, [{
    key: "parse",
    value: function parse(raw, index) {
      if (isNullOrUndef(raw)) {
        return null;
      }

      if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
        return null;
      }

      return +raw;
    }
  }, {
    key: "handleTickRangeOptions",
    value: function handleTickRangeOptions() {
      var beginAtZero = this.options.beginAtZero;

      var _this$getUserBounds3 = this.getUserBounds(),
          minDefined = _this$getUserBounds3.minDefined,
          maxDefined = _this$getUserBounds3.maxDefined;

      var min = this.min,
          max = this.max;

      var setMin = function setMin(v) {
        return min = minDefined ? min : v;
      };

      var setMax = function setMax(v) {
        return max = maxDefined ? max : v;
      };

      if (beginAtZero) {
        var minSign = sign(min);
        var maxSign = sign(max);

        if (minSign < 0 && maxSign < 0) {
          setMax(0);
        } else if (minSign > 0 && maxSign > 0) {
          setMin(0);
        }
      }

      if (min === max) {
        var _offset4 = 1;

        if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) {
          _offset4 = Math.abs(max * 0.05);
        }

        setMax(max + _offset4);

        if (!beginAtZero) {
          setMin(min - _offset4);
        }
      }

      this.min = min;
      this.max = max;
    }
  }, {
    key: "getTickLimit",
    value: function getTickLimit() {
      var tickOpts = this.options.ticks;
      var maxTicksLimit = tickOpts.maxTicksLimit,
          stepSize = tickOpts.stepSize;
      var maxTicks;

      if (stepSize) {
        maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;

        if (maxTicks > 1000) {
          console.warn("scales.".concat(this.id, ".ticks.stepSize: ").concat(stepSize, " would result generating up to ").concat(maxTicks, " ticks. Limiting to 1000."));
          maxTicks = 1000;
        }
      } else {
        maxTicks = this.computeTickLimit();
        maxTicksLimit = maxTicksLimit || 11;
      }

      if (maxTicksLimit) {
        maxTicks = Math.min(maxTicksLimit, maxTicks);
      }

      return maxTicks;
    }
  }, {
    key: "computeTickLimit",
    value: function computeTickLimit() {
      return Number.POSITIVE_INFINITY;
    }
  }, {
    key: "buildTicks",
    value: function buildTicks() {
      var opts = this.options;
      var tickOpts = opts.ticks;
      var maxTicks = this.getTickLimit();
      maxTicks = Math.max(2, maxTicks);
      var numericGeneratorOptions = {
        maxTicks: maxTicks,
        bounds: opts.bounds,
        min: opts.min,
        max: opts.max,
        precision: tickOpts.precision,
        step: tickOpts.stepSize,
        count: tickOpts.count,
        maxDigits: this._maxDigits(),
        horizontal: this.isHorizontal(),
        minRotation: tickOpts.minRotation || 0,
        includeBounds: tickOpts.includeBounds !== false
      };
      var dataRange = this._range || this;
      var ticks = generateTicks$1(numericGeneratorOptions, dataRange);

      if (opts.bounds === 'ticks') {
        _setMinAndMaxByKey(ticks, this, 'value');
      }

      if (opts.reverse) {
        ticks.reverse();
        this.start = this.max;
        this.end = this.min;
      } else {
        this.start = this.min;
        this.end = this.max;
      }

      return ticks;
    }
  }, {
    key: "configure",
    value: function configure() {
      var ticks = this.ticks;
      var start = this.min;
      var end = this.max;

      _get(_getPrototypeOf(LinearScaleBase.prototype), "configure", this).call(this);

      if (this.options.offset && ticks.length) {
        var _offset5 = (end - start) / Math.max(ticks.length - 1, 1) / 2;

        start -= _offset5;
        end += _offset5;
      }

      this._startValue = start;
      this._endValue = end;
      this._valueRange = end - start;
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value) {
      return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
  }]);

  return LinearScaleBase;
}(Scale);

var LinearScale = /*#__PURE__*/function (_LinearScaleBase) {
  _inherits(LinearScale, _LinearScaleBase);

  var _super23 = _createSuper(LinearScale);

  function LinearScale() {
    _classCallCheck(this, LinearScale);

    return _super23.apply(this, arguments);
  }

  _createClass(LinearScale, [{
    key: "determineDataLimits",
    value: function determineDataLimits() {
      var _this$getMinMax2 = this.getMinMax(true),
          min = _this$getMinMax2.min,
          max = _this$getMinMax2.max;

      this.min = isNumberFinite(min) ? min : 0;
      this.max = isNumberFinite(max) ? max : 1;
      this.handleTickRangeOptions();
    }
  }, {
    key: "computeTickLimit",
    value: function computeTickLimit() {
      var horizontal = this.isHorizontal();
      var length = horizontal ? this.width : this.height;
      var minRotation = toRadians(this.options.ticks.minRotation);
      var ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;

      var tickFont = this._resolveTickFontOptions(0);

      return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
  }, {
    key: "getPixelForValue",
    value: function getPixelForValue(value) {
      return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {
      return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
  }]);

  return LinearScale;
}(LinearScaleBase);

LinearScale.id = 'linear';
LinearScale.defaults = {
  ticks: {
    callback: Ticks.formatters.numeric
  }
};

function isMajor(tickVal) {
  var remain = tickVal / Math.pow(10, Math.floor(log10(tickVal)));
  return remain === 1;
}

function generateTicks(generationOptions, dataRange) {
  var endExp = Math.floor(log10(dataRange.max));
  var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
  var ticks = [];
  var tickVal = finiteOrDefault(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
  var exp = Math.floor(log10(tickVal));
  var significand = Math.floor(tickVal / Math.pow(10, exp));
  var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

  do {
    ticks.push({
      value: tickVal,
      major: isMajor(tickVal)
    });
    ++significand;

    if (significand === 10) {
      significand = 1;
      ++exp;
      precision = exp >= 0 ? 1 : precision;
    }

    tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
  } while (exp < endExp || exp === endExp && significand < endSignificand);

  var lastTick = finiteOrDefault(generationOptions.max, tickVal);
  ticks.push({
    value: lastTick,
    major: isMajor(tickVal)
  });
  return ticks;
}

var LogarithmicScale = /*#__PURE__*/function (_Scale3) {
  _inherits(LogarithmicScale, _Scale3);

  var _super24 = _createSuper(LogarithmicScale);

  function LogarithmicScale(cfg) {
    var _this49;

    _classCallCheck(this, LogarithmicScale);

    _this49 = _super24.call(this, cfg);
    _this49.start = undefined;
    _this49.end = undefined;
    _this49._startValue = undefined;
    _this49._valueRange = 0;
    return _this49;
  }

  _createClass(LogarithmicScale, [{
    key: "parse",
    value: function parse(raw, index) {
      var value = LinearScaleBase.prototype.parse.apply(this, [raw, index]);

      if (value === 0) {
        this._zero = true;
        return undefined;
      }

      return isNumberFinite(value) && value > 0 ? value : null;
    }
  }, {
    key: "determineDataLimits",
    value: function determineDataLimits() {
      var _this$getMinMax3 = this.getMinMax(true),
          min = _this$getMinMax3.min,
          max = _this$getMinMax3.max;

      this.min = isNumberFinite(min) ? Math.max(0, min) : null;
      this.max = isNumberFinite(max) ? Math.max(0, max) : null;

      if (this.options.beginAtZero) {
        this._zero = true;
      }

      this.handleTickRangeOptions();
    }
  }, {
    key: "handleTickRangeOptions",
    value: function handleTickRangeOptions() {
      var _this$getUserBounds4 = this.getUserBounds(),
          minDefined = _this$getUserBounds4.minDefined,
          maxDefined = _this$getUserBounds4.maxDefined;

      var min = this.min;
      var max = this.max;

      var setMin = function setMin(v) {
        return min = minDefined ? min : v;
      };

      var setMax = function setMax(v) {
        return max = maxDefined ? max : v;
      };

      var exp = function exp(v, m) {
        return Math.pow(10, Math.floor(log10(v)) + m);
      };

      if (min === max) {
        if (min <= 0) {
          setMin(1);
          setMax(10);
        } else {
          setMin(exp(min, -1));
          setMax(exp(max, +1));
        }
      }

      if (min <= 0) {
        setMin(exp(max, -1));
      }

      if (max <= 0) {
        setMax(exp(min, +1));
      }

      if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) {
        setMin(exp(min, -1));
      }

      this.min = min;
      this.max = max;
    }
  }, {
    key: "buildTicks",
    value: function buildTicks() {
      var opts = this.options;
      var generationOptions = {
        min: this._userMin,
        max: this._userMax
      };
      var ticks = generateTicks(generationOptions, this);

      if (opts.bounds === 'ticks') {
        _setMinAndMaxByKey(ticks, this, 'value');
      }

      if (opts.reverse) {
        ticks.reverse();
        this.start = this.max;
        this.end = this.min;
      } else {
        this.start = this.min;
        this.end = this.max;
      }

      return ticks;
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value) {
      return value === undefined ? '0' : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
  }, {
    key: "configure",
    value: function configure() {
      var start = this.min;

      _get(_getPrototypeOf(LogarithmicScale.prototype), "configure", this).call(this);

      this._startValue = log10(start);
      this._valueRange = log10(this.max) - log10(start);
    }
  }, {
    key: "getPixelForValue",
    value: function getPixelForValue(value) {
      if (value === undefined || value === 0) {
        value = this.min;
      }

      if (value === null || isNaN(value)) {
        return NaN;
      }

      return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {
      var decimal = this.getDecimalForPixel(pixel);
      return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
  }]);

  return LogarithmicScale;
}(Scale);

LogarithmicScale.id = 'logarithmic';
LogarithmicScale.defaults = {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
};

function getTickBackdropHeight(opts) {
  var tickOpts = opts.ticks;

  if (tickOpts.display && opts.display) {
    var padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
  }

  return 0;
}

function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}

function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }

  return {
    start: pos,
    end: pos + size
  };
}

function fitWithPointLabels(scale) {
  var orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  var limits = Object.assign({}, orig);
  var labelSizes = [];
  var padding = [];
  var valueCount = scale._pointLabels.length;
  var pointLabelOpts = scale.options.pointLabels;
  var additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;

  for (var i = 0; i < valueCount; i++) {
    var opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    var pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    var plFont = toFont(opts.font);
    var textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;

    var angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);

    var angle = Math.round(toDegrees(angleRadians));
    var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }

  scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}

function updateLimits(limits, orig, angle, hLimits, vLimits) {
  var sin = Math.abs(Math.sin(angle));
  var cos = Math.abs(Math.cos(angle));
  var x = 0;
  var y = 0;

  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }

  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}

function buildPointLabelItems(scale, labelSizes, padding) {
  var items = [];
  var valueCount = scale._pointLabels.length;
  var opts = scale.options;
  var extra = getTickBackdropHeight(opts) / 2;
  var outerDistance = scale.drawingArea;
  var additionalAngle = opts.pointLabels.centerPointLabels ? PI / valueCount : 0;

  for (var i = 0; i < valueCount; i++) {
    var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
    var angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    var size = labelSizes[i];
    var y = yForAngle(pointLabelPosition.y, size.h, angle);
    var textAlign = getTextAlignForAngle(angle);
    var left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    items.push({
      x: pointLabelPosition.x,
      y: y,
      textAlign: textAlign,
      left: left,
      top: y,
      right: left + size.w,
      bottom: y + size.h
    });
  }

  return items;
}

function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return 'center';
  } else if (angle < 180) {
    return 'left';
  }

  return 'right';
}

function leftForTextAlign(x, w, align) {
  if (align === 'right') {
    x -= w;
  } else if (align === 'center') {
    x -= w / 2;
  }

  return x;
}

function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= h / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }

  return y;
}

function drawPointLabels(scale, labelCount) {
  var ctx = scale.ctx,
      pointLabels = scale.options.pointLabels;

  for (var i = labelCount - 1; i >= 0; i--) {
    var optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    var plFont = toFont(optsAtIndex.font);
    var _scale$_pointLabelIte = scale._pointLabelItems[i],
        x = _scale$_pointLabelIte.x,
        y = _scale$_pointLabelIte.y,
        textAlign = _scale$_pointLabelIte.textAlign,
        left = _scale$_pointLabelIte.left,
        top = _scale$_pointLabelIte.top,
        right = _scale$_pointLabelIte.right,
        bottom = _scale$_pointLabelIte.bottom;
    var backdropColor = optsAtIndex.backdropColor;

    if (!isNullOrUndef(backdropColor)) {
      var borderRadius = toTRBLCorners(optsAtIndex.borderRadius);
      var padding = toPadding(optsAtIndex.backdropPadding);
      ctx.fillStyle = backdropColor;
      var backdropLeft = left - padding.left;
      var backdropTop = top - padding.top;
      var backdropWidth = right - left + padding.width;
      var backdropHeight = bottom - top + padding.height;

      if (Object.values(borderRadius).some(function (v) {
        return v !== 0;
      })) {
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: backdropLeft,
          y: backdropTop,
          w: backdropWidth,
          h: backdropHeight,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
      }
    }

    renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign: textAlign,
      textBaseline: 'middle'
    });
  }
}

function pathRadiusLine(scale, radius, circular, labelCount) {
  var ctx = scale.ctx;

  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    var pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);

    for (var i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}

function drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
  var ctx = scale.ctx;
  var circular = gridLineOpts.circular;
  var color = gridLineOpts.color,
      lineWidth = gridLineOpts.lineWidth;

  if (!circular && !labelCount || !color || !lineWidth || radius < 0) {
    return;
  }

  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(gridLineOpts.borderDash);
  ctx.lineDashOffset = gridLineOpts.borderDashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}

function createPointLabelContext(parent, index, label) {
  return createContext(parent, {
    label: label,
    index: index,
    type: 'pointLabel'
  });
}

var RadialLinearScale = /*#__PURE__*/function (_LinearScaleBase2) {
  _inherits(RadialLinearScale, _LinearScaleBase2);

  var _super25 = _createSuper(RadialLinearScale);

  function RadialLinearScale(cfg) {
    var _this50;

    _classCallCheck(this, RadialLinearScale);

    _this50 = _super25.call(this, cfg);
    _this50.xCenter = undefined;
    _this50.yCenter = undefined;
    _this50.drawingArea = undefined;
    _this50._pointLabels = [];
    _this50._pointLabelItems = [];
    return _this50;
  }

  _createClass(RadialLinearScale, [{
    key: "setDimensions",
    value: function setDimensions() {
      var padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
      var w = this.width = this.maxWidth - padding.width;
      var h = this.height = this.maxHeight - padding.height;
      this.xCenter = Math.floor(this.left + w / 2 + padding.left);
      this.yCenter = Math.floor(this.top + h / 2 + padding.top);
      this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
  }, {
    key: "determineDataLimits",
    value: function determineDataLimits() {
      var _this$getMinMax4 = this.getMinMax(false),
          min = _this$getMinMax4.min,
          max = _this$getMinMax4.max;

      this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
      this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
      this.handleTickRangeOptions();
    }
  }, {
    key: "computeTickLimit",
    value: function computeTickLimit() {
      return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
  }, {
    key: "generateTickLabels",
    value: function generateTickLabels(ticks) {
      var _this51 = this;

      LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
      this._pointLabels = this.getLabels().map(function (value, index) {
        var label = callback(_this51.options.pointLabels.callback, [value, index], _this51);
        return label || label === 0 ? label : '';
      }).filter(function (v, i) {
        return _this51.chart.getDataVisibility(i);
      });
    }
  }, {
    key: "fit",
    value: function fit() {
      var opts = this.options;

      if (opts.display && opts.pointLabels.display) {
        fitWithPointLabels(this);
      } else {
        this.setCenterPoint(0, 0, 0, 0);
      }
    }
  }, {
    key: "setCenterPoint",
    value: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
      this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
      this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
      this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
  }, {
    key: "getIndexAngle",
    value: function getIndexAngle(index) {
      var angleMultiplier = TAU / (this._pointLabels.length || 1);
      var startAngle = this.options.startAngle || 0;
      return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
    }
  }, {
    key: "getDistanceFromCenterForValue",
    value: function getDistanceFromCenterForValue(value) {
      if (isNullOrUndef(value)) {
        return NaN;
      }

      var scalingFactor = this.drawingArea / (this.max - this.min);

      if (this.options.reverse) {
        return (this.max - value) * scalingFactor;
      }

      return (value - this.min) * scalingFactor;
    }
  }, {
    key: "getValueForDistanceFromCenter",
    value: function getValueForDistanceFromCenter(distance) {
      if (isNullOrUndef(distance)) {
        return NaN;
      }

      var scaledDistance = distance / (this.drawingArea / (this.max - this.min));
      return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
  }, {
    key: "getPointLabelContext",
    value: function getPointLabelContext(index) {
      var pointLabels = this._pointLabels || [];

      if (index >= 0 && index < pointLabels.length) {
        var pointLabel = pointLabels[index];
        return createPointLabelContext(this.getContext(), index, pointLabel);
      }
    }
  }, {
    key: "getPointPosition",
    value: function getPointPosition(index, distanceFromCenter) {
      var additionalAngle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
      return {
        x: Math.cos(angle) * distanceFromCenter + this.xCenter,
        y: Math.sin(angle) * distanceFromCenter + this.yCenter,
        angle: angle
      };
    }
  }, {
    key: "getPointPositionForValue",
    value: function getPointPositionForValue(index, value) {
      return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
  }, {
    key: "getBasePosition",
    value: function getBasePosition(index) {
      return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
  }, {
    key: "getPointLabelPosition",
    value: function getPointLabelPosition(index) {
      var _this$_pointLabelItem = this._pointLabelItems[index],
          left = _this$_pointLabelItem.left,
          top = _this$_pointLabelItem.top,
          right = _this$_pointLabelItem.right,
          bottom = _this$_pointLabelItem.bottom;
      return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
      };
    }
  }, {
    key: "drawBackground",
    value: function drawBackground() {
      var _this$options14 = this.options,
          backgroundColor = _this$options14.backgroundColor,
          circular = _this$options14.grid.circular;

      if (backgroundColor) {
        var ctx = this.ctx;
        ctx.save();
        ctx.beginPath();
        pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
        ctx.closePath();
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
      }
    }
  }, {
    key: "drawGrid",
    value: function drawGrid() {
      var _this52 = this;

      var ctx = this.ctx;
      var opts = this.options;
      var angleLines = opts.angleLines,
          grid = opts.grid;
      var labelCount = this._pointLabels.length;
      var i, offset, position;

      if (opts.pointLabels.display) {
        drawPointLabels(this, labelCount);
      }

      if (grid.display) {
        this.ticks.forEach(function (tick, index) {
          if (index !== 0) {
            offset = _this52.getDistanceFromCenterForValue(tick.value);
            var optsAtIndex = grid.setContext(_this52.getContext(index - 1));
            drawRadiusLine(_this52, optsAtIndex, offset, labelCount);
          }
        });
      }

      if (angleLines.display) {
        ctx.save();

        for (i = labelCount - 1; i >= 0; i--) {
          var optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
          var color = optsAtIndex.color,
              lineWidth = optsAtIndex.lineWidth;

          if (!lineWidth || !color) {
            continue;
          }

          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = color;
          ctx.setLineDash(optsAtIndex.borderDash);
          ctx.lineDashOffset = optsAtIndex.borderDashOffset;
          offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
          position = this.getPointPosition(i, offset);
          ctx.beginPath();
          ctx.moveTo(this.xCenter, this.yCenter);
          ctx.lineTo(position.x, position.y);
          ctx.stroke();
        }

        ctx.restore();
      }
    }
  }, {
    key: "drawBorder",
    value: function drawBorder() {}
  }, {
    key: "drawLabels",
    value: function drawLabels() {
      var _this53 = this;

      var ctx = this.ctx;
      var opts = this.options;
      var tickOpts = opts.ticks;

      if (!tickOpts.display) {
        return;
      }

      var startAngle = this.getIndexAngle(0);
      var offset, width;
      ctx.save();
      ctx.translate(this.xCenter, this.yCenter);
      ctx.rotate(startAngle);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      this.ticks.forEach(function (tick, index) {
        if (index === 0 && !opts.reverse) {
          return;
        }

        var optsAtIndex = tickOpts.setContext(_this53.getContext(index));
        var tickFont = toFont(optsAtIndex.font);
        offset = _this53.getDistanceFromCenterForValue(_this53.ticks[index].value);

        if (optsAtIndex.showLabelBackdrop) {
          ctx.font = tickFont.string;
          width = ctx.measureText(tick.label).width;
          ctx.fillStyle = optsAtIndex.backdropColor;
          var padding = toPadding(optsAtIndex.backdropPadding);
          ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
        }

        renderText(ctx, tick.label, 0, -offset, tickFont, {
          color: optsAtIndex.color
        });
      });
      ctx.restore();
    }
  }, {
    key: "drawTitle",
    value: function drawTitle() {}
  }]);

  return RadialLinearScale;
}(LinearScaleBase);

RadialLinearScale.id = 'radialLinear';
RadialLinearScale.defaults = {
  display: true,
  animate: true,
  position: 'chartArea',
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0.0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: undefined,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback: function callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
};
RadialLinearScale.defaultRoutes = {
  'angleLines.color': 'borderColor',
  'pointLabels.color': 'color',
  'ticks.color': 'color'
};
RadialLinearScale.descriptors = {
  angleLines: {
    _fallback: 'grid'
  }
};
var INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1000
  },
  second: {
    common: true,
    size: 1000,
    steps: 60
  },
  minute: {
    common: true,
    size: 60000,
    steps: 60
  },
  hour: {
    common: true,
    size: 3600000,
    steps: 24
  },
  day: {
    common: true,
    size: 86400000,
    steps: 30
  },
  week: {
    common: false,
    size: 604800000,
    steps: 4
  },
  month: {
    common: true,
    size: 2.628e9,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7.884e9,
    steps: 4
  },
  year: {
    common: true,
    size: 3.154e10
  }
};
var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
  return a - b;
}

function _parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }

  var adapter = scale._adapter;
  var _scale$_parseOpts = scale._parseOpts,
      parser = _scale$_parseOpts.parser,
      round = _scale$_parseOpts.round,
      isoWeekday = _scale$_parseOpts.isoWeekday;
  var value = input;

  if (typeof parser === 'function') {
    value = parser(value);
  }

  if (!isNumberFinite(value)) {
    value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
  }

  if (value === null) {
    return null;
  }

  if (round) {
    value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
  }

  return +value;
}

function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  var ilen = UNITS.length;

  for (var i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    var interval = INTERVALS[UNITS[i]];
    var factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;

    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }

  return UNITS[ilen - 1];
}

function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (var i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    var unit = UNITS[i];

    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }

  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
  for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}

function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    var _lookup2 = _lookup(timestamps, time),
        lo = _lookup2.lo,
        hi = _lookup2.hi;

    var timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}

function setMajorTicks(scale, ticks, map, majorUnit) {
  var adapter = scale._adapter;
  var first = +adapter.startOf(ticks[0].value, majorUnit);
  var last = ticks[ticks.length - 1].value;
  var major, index;

  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index = map[major];

    if (index >= 0) {
      ticks[index].major = true;
    }
  }

  return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
  var ticks = [];
  var map = {};
  var ilen = values.length;
  var i, value;

  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map[value] = i;
    ticks.push({
      value: value,
      major: false
    });
  }

  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var TimeScale = /*#__PURE__*/function (_Scale4) {
  _inherits(TimeScale, _Scale4);

  var _super26 = _createSuper(TimeScale);

  function TimeScale(props) {
    var _this54;

    _classCallCheck(this, TimeScale);

    _this54 = _super26.call(this, props);
    _this54._cache = {
      data: [],
      labels: [],
      all: []
    };
    _this54._unit = 'day';
    _this54._majorUnit = undefined;
    _this54._offsets = {};
    _this54._normalized = false;
    _this54._parseOpts = undefined;
    return _this54;
  }

  _createClass(TimeScale, [{
    key: "init",
    value: function init(scaleOpts, opts) {
      var time = scaleOpts.time || (scaleOpts.time = {});
      var adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
      mergeIf(time.displayFormats, adapter.formats());
      this._parseOpts = {
        parser: time.parser,
        round: time.round,
        isoWeekday: time.isoWeekday
      };

      _get(_getPrototypeOf(TimeScale.prototype), "init", this).call(this, scaleOpts);

      this._normalized = opts.normalized;
    }
  }, {
    key: "parse",
    value: function parse(raw, index) {
      if (raw === undefined) {
        return null;
      }

      return _parse(this, raw);
    }
  }, {
    key: "beforeLayout",
    value: function beforeLayout() {
      _get(_getPrototypeOf(TimeScale.prototype), "beforeLayout", this).call(this);

      this._cache = {
        data: [],
        labels: [],
        all: []
      };
    }
  }, {
    key: "determineDataLimits",
    value: function determineDataLimits() {
      var options = this.options;
      var adapter = this._adapter;
      var unit = options.time.unit || 'day';

      var _this$getUserBounds5 = this.getUserBounds(),
          min = _this$getUserBounds5.min,
          max = _this$getUserBounds5.max,
          minDefined = _this$getUserBounds5.minDefined,
          maxDefined = _this$getUserBounds5.maxDefined;

      function _applyBounds(bounds) {
        if (!minDefined && !isNaN(bounds.min)) {
          min = Math.min(min, bounds.min);
        }

        if (!maxDefined && !isNaN(bounds.max)) {
          max = Math.max(max, bounds.max);
        }
      }

      if (!minDefined || !maxDefined) {
        _applyBounds(this._getLabelBounds());

        if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
          _applyBounds(this.getMinMax(false));
        }
      }

      min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
      max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
      this.min = Math.min(min, max - 1);
      this.max = Math.max(min + 1, max);
    }
  }, {
    key: "_getLabelBounds",
    value: function _getLabelBounds() {
      var arr = this.getLabelTimestamps();
      var min = Number.POSITIVE_INFINITY;
      var max = Number.NEGATIVE_INFINITY;

      if (arr.length) {
        min = arr[0];
        max = arr[arr.length - 1];
      }

      return {
        min: min,
        max: max
      };
    }
  }, {
    key: "buildTicks",
    value: function buildTicks() {
      var options = this.options;
      var timeOpts = options.time;
      var tickOpts = options.ticks;
      var timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();

      if (options.bounds === 'ticks' && timestamps.length) {
        this.min = this._userMin || timestamps[0];
        this.max = this._userMax || timestamps[timestamps.length - 1];
      }

      var min = this.min;
      var max = this.max;

      var ticks = _filterBetween(timestamps, min, max);

      this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
      this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
      this.initOffsets(timestamps);

      if (options.reverse) {
        ticks.reverse();
      }

      return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
  }, {
    key: "afterAutoSkip",
    value: function afterAutoSkip() {
      if (this.options.offsetAfterAutoskip) {
        this.initOffsets(this.ticks.map(function (tick) {
          return +tick.value;
        }));
      }
    }
  }, {
    key: "initOffsets",
    value: function initOffsets(timestamps) {
      var start = 0;
      var end = 0;
      var first, last;

      if (this.options.offset && timestamps.length) {
        first = this.getDecimalForValue(timestamps[0]);

        if (timestamps.length === 1) {
          start = 1 - first;
        } else {
          start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
        }

        last = this.getDecimalForValue(timestamps[timestamps.length - 1]);

        if (timestamps.length === 1) {
          end = last;
        } else {
          end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
      }

      var limit = timestamps.length < 3 ? 0.5 : 0.25;
      start = _limitValue(start, 0, limit);
      end = _limitValue(end, 0, limit);
      this._offsets = {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
  }, {
    key: "_generate",
    value: function _generate() {
      var adapter = this._adapter;
      var min = this.min;
      var max = this.max;
      var options = this.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
      var stepSize = valueOrDefault(timeOpts.stepSize, 1);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var hasWeekday = isNumber(weekday) || weekday === true;
      var ticks = {};
      var first = min;
      var time, count;

      if (hasWeekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }

      first = +adapter.startOf(first, hasWeekday ? 'day' : minor);

      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
      }

      var timestamps = options.ticks.source === 'data' && this.getDataTimestamps();

      for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
        addTick(ticks, time, timestamps);
      }

      if (time === max || options.bounds === 'ticks' || count === 1) {
        addTick(ticks, time, timestamps);
      }

      return Object.keys(ticks).sort(function (a, b) {
        return a - b;
      }).map(function (x) {
        return +x;
      });
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value) {
      var adapter = this._adapter;
      var timeOpts = this.options.time;

      if (timeOpts.tooltipFormat) {
        return adapter.format(value, timeOpts.tooltipFormat);
      }

      return adapter.format(value, timeOpts.displayFormats.datetime);
    }
  }, {
    key: "_tickFormatFunction",
    value: function _tickFormatFunction(time, index, ticks, format) {
      var options = this.options;
      var formats = options.time.displayFormats;
      var unit = this._unit;
      var majorUnit = this._majorUnit;
      var minorFormat = unit && formats[unit];
      var majorFormat = majorUnit && formats[majorUnit];
      var tick = ticks[index];
      var major = majorUnit && majorFormat && tick && tick.major;

      var label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));

      var formatter = options.ticks.callback;
      return formatter ? callback(formatter, [label, index, ticks], this) : label;
    }
  }, {
    key: "generateTickLabels",
    value: function generateTickLabels(ticks) {
      var i, ilen, tick;

      for (i = 0, ilen = ticks.length; i < ilen; ++i) {
        tick = ticks[i];
        tick.label = this._tickFormatFunction(tick.value, i, ticks);
      }
    }
  }, {
    key: "getDecimalForValue",
    value: function getDecimalForValue(value) {
      return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
  }, {
    key: "getPixelForValue",
    value: function getPixelForValue(value) {
      var offsets = this._offsets;
      var pos = this.getDecimalForValue(value);
      return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {
      var offsets = this._offsets;
      var pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
      return this.min + pos * (this.max - this.min);
    }
  }, {
    key: "_getLabelSize",
    value: function _getLabelSize(label) {
      var ticksOpts = this.options.ticks;
      var tickLabelWidth = this.ctx.measureText(label).width;
      var angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
      var cosRotation = Math.cos(angle);
      var sinRotation = Math.sin(angle);

      var tickFontSize = this._resolveTickFontOptions(0).size;

      return {
        w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
        h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
      };
    }
  }, {
    key: "_getLabelCapacity",
    value: function _getLabelCapacity(exampleTime) {
      var timeOpts = this.options.time;
      var displayFormats = timeOpts.displayFormats;
      var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;

      var exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format);

      var size = this._getLabelSize(exampleLabel);

      var capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
      return capacity > 0 ? capacity : 1;
    }
  }, {
    key: "getDataTimestamps",
    value: function getDataTimestamps() {
      var timestamps = this._cache.data || [];
      var i, ilen;

      if (timestamps.length) {
        return timestamps;
      }

      var metas = this.getMatchingVisibleMetas();

      if (this._normalized && metas.length) {
        return this._cache.data = metas[0].controller.getAllParsedValues(this);
      }

      for (i = 0, ilen = metas.length; i < ilen; ++i) {
        timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
      }

      return this._cache.data = this.normalize(timestamps);
    }
  }, {
    key: "getLabelTimestamps",
    value: function getLabelTimestamps() {
      var timestamps = this._cache.labels || [];
      var i, ilen;

      if (timestamps.length) {
        return timestamps;
      }

      var labels = this.getLabels();

      for (i = 0, ilen = labels.length; i < ilen; ++i) {
        timestamps.push(_parse(this, labels[i]));
      }

      return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
  }, {
    key: "normalize",
    value: function normalize(values) {
      return _arrayUnique(values.sort(sorter));
    }
  }]);

  return TimeScale;
}(Scale);

TimeScale.id = 'time';
TimeScale.defaults = {
  bounds: 'data',
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: 'millisecond',
    displayFormats: {}
  },
  ticks: {
    source: 'auto',
    major: {
      enabled: false
    }
  }
};

function interpolate(table, val, reverse) {
  var lo = 0;
  var hi = table.length - 1;
  var prevSource, nextSource, prevTarget, nextTarget;

  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      var _lookupByKey2 = _lookupByKey(table, 'pos', val);

      lo = _lookupByKey2.lo;
      hi = _lookupByKey2.hi;
    }

    var _table$lo = table[lo];
    prevSource = _table$lo.pos;
    prevTarget = _table$lo.time;
    var _table$hi = table[hi];
    nextSource = _table$hi.pos;
    nextTarget = _table$hi.time;
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      var _lookupByKey3 = _lookupByKey(table, 'time', val);

      lo = _lookupByKey3.lo;
      hi = _lookupByKey3.hi;
    }

    var _table$lo2 = table[lo];
    prevSource = _table$lo2.time;
    prevTarget = _table$lo2.pos;
    var _table$hi2 = table[hi];
    nextSource = _table$hi2.time;
    nextTarget = _table$hi2.pos;
  }

  var span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}

var TimeSeriesScale = /*#__PURE__*/function (_TimeScale) {
  _inherits(TimeSeriesScale, _TimeScale);

  var _super27 = _createSuper(TimeSeriesScale);

  function TimeSeriesScale(props) {
    var _this55;

    _classCallCheck(this, TimeSeriesScale);

    _this55 = _super27.call(this, props);
    _this55._table = [];
    _this55._minPos = undefined;
    _this55._tableRange = undefined;
    return _this55;
  }

  _createClass(TimeSeriesScale, [{
    key: "initOffsets",
    value: function initOffsets() {
      var timestamps = this._getTimestampsForTable();

      var table = this._table = this.buildLookupTable(timestamps);
      this._minPos = interpolate(table, this.min);
      this._tableRange = interpolate(table, this.max) - this._minPos;

      _get(_getPrototypeOf(TimeSeriesScale.prototype), "initOffsets", this).call(this, timestamps);
    }
  }, {
    key: "buildLookupTable",
    value: function buildLookupTable(timestamps) {
      var min = this.min,
          max = this.max;
      var items = [];
      var table = [];
      var i, ilen, prev, curr, next;

      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];

        if (curr >= min && curr <= max) {
          items.push(curr);
        }
      }

      if (items.length < 2) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }

      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];

        if (Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }

      return table;
    }
  }, {
    key: "_getTimestampsForTable",
    value: function _getTimestampsForTable() {
      var timestamps = this._cache.all || [];

      if (timestamps.length) {
        return timestamps;
      }

      var data = this.getDataTimestamps();
      var label = this.getLabelTimestamps();

      if (data.length && label.length) {
        timestamps = this.normalize(data.concat(label));
      } else {
        timestamps = data.length ? data : label;
      }

      timestamps = this._cache.all = timestamps;
      return timestamps;
    }
  }, {
    key: "getDecimalForValue",
    value: function getDecimalForValue(value) {
      return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
  }, {
    key: "getValueForPixel",
    value: function getValueForPixel(pixel) {
      var offsets = this._offsets;
      var decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
      return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
  }]);

  return TimeSeriesScale;
}(TimeScale);

TimeSeriesScale.id = 'timeseries';
TimeSeriesScale.defaults = TimeScale.defaults;
var scales = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CategoryScale: CategoryScale,
  LinearScale: LinearScale,
  LogarithmicScale: LogarithmicScale,
  RadialLinearScale: RadialLinearScale,
  TimeScale: TimeScale,
  TimeSeriesScale: TimeSeriesScale
});
var registerables = [controllers, elements, plugins, scales];
var ChartEmits;

(function (ChartEmits) {
  ChartEmits["ChartRendered"] = "chart:rendered";
  ChartEmits["ChartUpdated"] = "chart:updated";
  ChartEmits["ChartDestroyed"] = "chart:destroyed";
  ChartEmits["LabelsUpdated"] = "labels:updated";
})(ChartEmits || (ChartEmits = {}));

function chartCreate(createChartFunction, chartData, chartOptions, context) {
  createChartFunction(chartData, chartOptions);

  if (context !== undefined) {
    context.emit(ChartEmits.ChartRendered);
  }
}

function chartUpdate(chart, context) {
  chart.update();

  if (context !== undefined) {
    context.emit(ChartEmits.ChartUpdated);
  }
}

function chartDestroy(chart, context) {
  chart.destroy();

  if (context !== undefined) {
    context.emit(ChartEmits.ChartDestroyed);
  }
}

function getChartData(data, datasetIdKey) {
  var nextData = {
    labels: typeof data.labels === "undefined" ? [] : _toConsumableArray(data.labels),
    datasets: []
  };
  setChartDatasets(nextData, _objectSpread({}, data), datasetIdKey);
  return nextData;
}

function setChartDatasets(oldData, newData, datasetIdKey) {
  var addedDatasets = [];
  oldData.datasets = newData.datasets.map(function (nextDataset) {
    // given the new set, find it's current match
    var currentDataset = oldData.datasets.find(function (dataset) {
      return dataset[datasetIdKey] === nextDataset[datasetIdKey];
    }); // There is no original to update, so simply add new one

    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return _objectSpread({}, nextDataset);
    }

    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}

function setChartLabels(chart, labels, context) {
  chart.data.labels = labels;

  if (context !== undefined) {
    context.emit(ChartEmits.LabelsUpdated);
  }
}

function setChartOptions(chart, options) {
  chart.options = _objectSpread({}, options);
}

function compareData(newData, oldData) {
  // Get new and old DataSet Labels
  var newDatasetLabels = newData.datasets.map(function (dataset) {
    return dataset.label;
  });
  var oldDatasetLabels = oldData.datasets.map(function (dataset) {
    return dataset.label;
  }); // Check if Labels are equal and if dataset length is equal

  return oldData.datasets.length === newData.datasets.length && newDatasetLabels.every(function (value, index) {
    return value === oldDatasetLabels[index];
  });
}

var templateError = "Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components";
var ANNOTATION_PLUGIN_KEY = "annotation";

function generateChart(chartId, chartType, chartController) {
  var _chartRef = null;
  return {
    props: {
      chartData: {
        type: Object,
        required: true
      },
      chartOptions: {
        type: Object,
        "default": function _default() {}
      },
      datasetIdKey: {
        type: String,
        "default": "label"
      },
      chartId: {
        type: String,
        "default": chartId
      },
      width: {
        type: Number,
        "default": 400
      },
      height: {
        type: Number,
        "default": 400
      },
      cssClasses: {
        type: String,
        "default": ""
      },
      styles: {
        type: Object,
        "default": function _default() {}
      },
      plugins: {
        type: Array,
        "default": function _default() {
          return [];
        }
      }
    },
    data: function data() {
      return {
        _chart: null
      };
    },
    computed: {
      hasAnnotationPlugin: function hasAnnotationPlugin() {
        var ref, ref1;
        var pluginSettings = (ref = this.chartOptions) === null || ref === void 0 ? void 0 : (ref1 = ref.plugins) === null || ref1 === void 0 ? void 0 : ref1[ANNOTATION_PLUGIN_KEY];
        return typeof pluginSettings !== "undefined";
      }
    },
    created: function created() {
      Chart.register(chartController);
    },
    mounted: function mounted() {
      _chartRef = {
        current: null
      };

      if ("datasets" in this.chartData && this.chartData.datasets.length > 0) {
        chartCreate(this.renderChart, this.chartData, this.chartOptions);
        this.$emit(ChartEmits.ChartRendered);
      }
    },
    watch: {
      chartData: {
        handler: function handler(newValue, oldValue) {
          this.chartDataHandler(newValue, oldValue);
        },
        deep: true
      },
      chartOptions: {
        handler: function handler(newValue) {
          this.chartOptionsHandler(newValue);
        },
        deep: true
      }
    },
    methods: {
      renderChart: function renderChart(data, options) {
        var currentChart = this.getCurrentChart();

        if (currentChart !== null) {
          chartDestroy(currentChart);
          this.$emit(ChartEmits.ChartDestroyed);
        }

        if (!this.$refs.canvas) {
          throw new Error(templateError);
        } else {
          var chartData = getChartData(data, this.datasetIdKey);
          var canvasEl2DContext = this.$refs.canvas.getContext("2d");

          if (canvasEl2DContext !== null) {
            this.setCurrentChart(new Chart(canvasEl2DContext, {
              type: chartType,
              data: chartData,
              options: options,
              plugins: this.plugins
            }));
          }
        }
      },
      chartDataHandler: function chartDataHandler(newValue, oldValue) {
        var newData = _objectSpread({}, newValue);

        var oldData = _objectSpread({}, oldValue);

        var currentChart = this.getCurrentChart();

        if (Object.keys(oldData).length > 0) {
          var isEqualLabelsAndDatasetsLength = compareData(newData, oldData);

          if (isEqualLabelsAndDatasetsLength && currentChart !== null) {
            setChartDatasets(currentChart.data, newData, this.datasetIdKey);

            if (newData.labels !== undefined) {
              setChartLabels(currentChart, newData.labels);
              this.$emit(ChartEmits.LabelsUpdated);
            }

            this.updateChart();
            this.$emit(ChartEmits.ChartUpdated);
          } else {
            if (currentChart !== null) {
              chartDestroy(currentChart);
              this.$emit(ChartEmits.ChartDestroyed);
            }

            chartCreate(this.renderChart, this.chartData, this.chartOptions);
            this.$emit(ChartEmits.ChartRendered);
          }
        } else {
          if (currentChart !== null) {
            chartDestroy(currentChart);
            this.$emit(ChartEmits.ChartDestroyed);
          }

          chartCreate(this.renderChart, this.chartData, this.chartOptions);
          this.$emit(ChartEmits.ChartRendered);
        }
      },
      chartOptionsHandler: function chartOptionsHandler(options) {
        var currentChart = this.getCurrentChart();

        if (currentChart !== null) {
          setChartOptions(currentChart, options);
          this.updateChart();
        } else {
          chartCreate(this.renderChart, this.chartData, this.chartOptions);
        }
      },
      updateChart: function updateChart() {
        var currentChart = this.getCurrentChart();
        chartUpdate(currentChart);
      },
      getCurrentChart: function getCurrentChart() {
        return this.hasAnnotationPlugin ? _chartRef.current : this.$data._chart;
      },
      setCurrentChart: function setCurrentChart(chart) {
        this.hasAnnotationPlugin ? _chartRef.current = chart : this.$data._chart = chart;
      }
    },
    beforeDestroy: function beforeDestroy() {
      var currentChart = this.getCurrentChart();

      if (currentChart !== null) {
        chartDestroy(currentChart);
        this.$emit(ChartEmits.ChartDestroyed);
      }
    },
    render: function render(createElement) {
      return createElement("div", {
        style: this.styles,
        "class": this.cssClasses
      }, [createElement("canvas", {
        attrs: {
          id: this.chartId,
          width: this.width,
          height: this.height
        },
        ref: "canvas"
      })]);
    }
  };
}
/** @type Object */


var Bar = /* #__PURE__ */generateChart("bar-chart", "bar", BarController); //

Chart.register.apply(Chart, registerables);
var script$b = {
  name: "bar-chart",
  components: {
    Bar: Bar
  },
  props: {
    height: {
      type: Number,
      "default": 200
    },
    cssClasses: {
      "default": "",
      type: String
    },
    cssTooltipClasses: {
      "default": "",
      type: String
    },
    tooltipElId: {
      "default": "chartjs-tooltip",
      type: String
    },
    styles: {
      type: Object,
      "default": function _default() {}
    },
    plugins: {
      type: Object,
      "default": function _default() {}
    },
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    gradientTopColor: {
      type: String,
      "default": "#128FF9"
    },
    gradientBottomColor: {
      type: String,
      "default": "#6044F8"
    },
    showExtraInfoInLabel: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      chartData: this.setChartData(),
      chartOptions: this.setChartOption()
    };
  },
  methods: {
    shortenNumber: function shortenNumber(number, useCurrency) {
      // from: https://stackoverflow.com/a/55987576
      var n = parseInt(number),
          isDecimal = number > 0 && number < 1,
          isNeg = n < 0,
          absNumber = Math.abs(n),
          shortNumber;

      switch (true) {
        case absNumber >= 1e3 && absNumber < 1e6:
          shortNumber = "".concat(+(absNumber / 1e3).toFixed(1), "k");
          break;

        case absNumber >= 1e6 && absNumber < 1e9:
          shortNumber = "".concat(+(absNumber / 1e6).toFixed(1), "m");
          break;

        case absNumber >= 1e9 && absNumber < 1e12:
          shortNumber = "".concat(+(absNumber / 1e9).toFixed(1), "b");
          break;

        case absNumber >= 1e12:
          shortNumber = "".concat(+(absNumber / 1e12).toFixed(1), "t");
          break;

        default:
          shortNumber = isDecimal ? number.toFixed(2) : absNumber;
      }

      var currencyNumber = isNeg ? "-$".concat(shortNumber) : "$".concat(shortNumber);
      shortNumber = isNeg ? "-".concat(shortNumber) : shortNumber;
      return useCurrency ? currencyNumber : shortNumber;
    },
    getLabels: function getLabels() {
      var _this56 = this;

      var _this$data;

      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.map(function (v) {
        return _this56.showExtraInfoInLabel && v.label ? v.label : _this56.shortenNumber(v.value, "$");
      });
    },
    setChartData: function setChartData() {
      var _this57 = this;

      return {
        labels: this.getLabels(),
        datasets: [{
          data: this.data,
          parsing: {
            xAxisKey: "value",
            yAxisKey: "value"
          },
          borderRadius: 8,
          borderSkipped: false,
          barPercentage: 1,
          backgroundColor: function backgroundColor(context) {
            var _context$chart = context.chart,
                ctx = _context$chart.ctx,
                chartArea = _context$chart.chartArea;

            if (!chartArea) {
              return;
            }

            var gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);

            if (gradient) {
              gradient.addColorStop(0.4, _this57.gradientBottomColor);
              gradient.addColorStop(1, _this57.gradientTopColor);
            }

            return gradient;
          }
        }]
      };
    },
    setChartOption: function setChartOption() {
      var _this58 = this;

      var props = this;
      return {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            // Disable the on-canvas tooltip
            enabled: false,
            external: function external(context) {
              // Tooltip Element
              var tooltipEl = document.getElementById(props.tooltipElId); // Create element on first render

              if (!tooltipEl) {
                tooltipEl = document.createElement("div");
                tooltipEl.id = props.tooltipElId;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.transform = "translate(-50%, 0)";
                tooltipEl.style.transition = "all .1s ease";
                tooltipEl.style.pointerEvents = "none";
                tooltipEl.innerHTML = "<div class=\"custom-tooltip w-8 bg-white text-xs p-1 text-center border-1 border-solid border-blue rounded-md leading-4 ".concat(props.cssTooltipClasses, "\"></div>");
                document.body.appendChild(tooltipEl);
              } // Hide if no tooltip


              var tooltipModel = context.tooltip;

              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = "0";
                return;
              } // Set Text


              if (tooltipModel.body) {
                var titleLines = tooltipModel.title || [];
                var innerHtml = "<span>";
                titleLines.forEach(function (title) {
                  innerHtml += title;
                });
                innerHtml += "</span>";
                var divRoot = tooltipEl.querySelector(".custom-tooltip");
                divRoot.innerHTML = innerHtml;
              }

              var position = context.chart.canvas.getBoundingClientRect(); // Display, position, and set styles for font

              tooltipEl.style.opacity = "1";
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + "px";
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 50 + "px";
              tooltipEl.style.padding = tooltipModel.padding + "px " + tooltipModel.padding + "px";
            }
          }
        },
        responsive: true,
        animations: {
          tension: {
            duration: 1000,
            easing: "Linear",
            from: 0,
            top: 1
          }
        },
        scales: {
          y: {
            min: 0,
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              align: "end",
              count: 5,
              font: {
                size: 12
              },
              callback: function callback(v) {
                return _this58.shortenNumber(v);
              }
            }
          },
          x: {
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              display: false
            }
          }
        }
      };
    }
  }
};
/* script */

var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__$b() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Bar", {
    attrs: {
      "chart-options": _vm.chartOptions,
      "chart-data": _vm.chartData,
      plugins: _vm.plugins,
      "css-classes": _vm.cssClasses,
      styles: _vm.styles,
      height: _vm.height
    }
  });
};

var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$a = Vue.extend({
  name: "custom-grid-table",
  props: {
    columns: {
      type: Array,
      "default": []
    },
    rows: {
      type: Array,
      "default": []
    },
    sortable: {
      type: Boolean,
      "default": false
    },
    defaultSortColumn: {
      type: String,
      "default": ""
    },
    defaultSortDirection: {
      type: String,
      "default": "desc"
    },
    disableTableSort: {
      type: Boolean,
      "default": false
    },
    loading: {
      type: Boolean,
      "default": false
    }
  },
  components: {
    LoadingIcon: __vue_component__$u
  },
  data: function data() {
    return {
      order: {
        key: "",
        sorting: "asc"
      },
      gridColumns: []
    };
  },
  created: function created() {
    var _this$columns, _this$columns$;

    this.order = {
      key: this.defaultSortColumn || ((_this$columns = this.columns) === null || _this$columns === void 0 ? void 0 : (_this$columns$ = _this$columns[0]) === null || _this$columns$ === void 0 ? void 0 : _this$columns$.key),
      sorting: this.defaultSortDirection
    };
    this.gridColumns = this.columns;
  },
  computed: {
    getRows: function getRows() {
      if (!this.disableTableSort) {
        return this.sortRows(this.order.key, this.order.sorting);
      }

      return this.rows;
    }
  },
  methods: {
    sortRows: function sortRows(key) {
      var sorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
      return this.rows.sort(function (a, b) {
        if (a[key] < b[key]) {
          return sorting === "asc" ? -1 : 1;
        }

        if (a[key] > b[key]) {
          return sorting === "asc" ? 1 : -1;
        }

        return 0;
      });
    },
    setSortOrder: function setSortOrder(column) {
      if (this.order.key === column.key && this.order.sorting === "asc") {
        this.order = {
          key: column.key,
          sorting: "desc"
        };
      } else {
        this.order = {
          key: column.key,
          sorting: "asc"
        };
      }
    },
    getIsOrderSelected: function getIsOrderSelected(columnKey, order) {
      return this.order.key === columnKey && this.order.sorting === order;
    },
    isColumnSortable: function isColumnSortable(column) {
      return this.sortable && (!column.hasOwnProperty("sortable") || column.sortable) || !this.sortable && column.sortable;
    }
  },
  watch: {
    order: function order(value) {
      this.$emit("sortChange", value);
    }
  }
});
/* script */

var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__$a() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "w-full overflow-x-auto box-content bg-white"
  }, [_c("div", {
    staticClass: "\n      flex flex-col\n      min-w-min\n      text-left\n      vertical-line\n      relative\n      pb-8\n    "
  }, [_c("div", {
    staticClass: "grid ml-24",
    style: {
      gridTemplateColumns: "repeat(" + _vm.gridColumns.length + ", 1fr)"
    }
  }, _vm._l(_vm.gridColumns, function (column, index) {
    return _c("div", {
      key: column.key,
      staticClass: "p-2 font-bold",
      "class": {
        "cursor-pointer": _vm.isColumnSortable(column),
        "pointer-events-none": !_vm.isColumnSortable(column),
        "text-center": index !== 0 && index > _vm.gridColumns.length || _vm.gridColumns.length > 2,
        "text-right": index === _vm.gridColumns.length - 1 && _vm.gridColumns.length <= 2
      },
      on: {
        click: function click($event) {
          return _vm.setSortOrder(column);
        }
      }
    }, [_c("span", {
      staticClass: "sb-table__head-item relative text-gray text-base",
      "class": {
        sortable: _vm.isColumnSortable(column)
      }
    }, [_c("span", [_vm._v(_vm._s(column.value))]), _vm._v(" "), _vm.isColumnSortable(column) ? _c("div", {
      staticClass: "absolute -right-3 bottom-0"
    }, [!_vm.getIsOrderSelected(column.key, "desc") ? _c("div", {
      staticClass: "\n                sb-table__head-item__arrow\n                text-gray-light\n                cursor-pointer\n              ",
      "class": {
        "text-purple": _vm.getIsOrderSelected(column.key, "asc"),
        "mt-1": _vm.getIsOrderSelected(column.key, "asc")
      }
    }, [_vm._v("\n              ▲\n            ")]) : _vm._e(), _vm._v(" "), !_vm.getIsOrderSelected(column.key, "asc") ? _c("div", {
      staticClass: "\n                sb-table__head-item__arrow\n                text-gray-light\n                cursor-pointer\n              ",
      "class": {
        "text-purple": _vm.getIsOrderSelected(column.key, "desc"),
        "mt-1": _vm.getIsOrderSelected(column.key, "desc")
      }
    }, [_vm._v("\n              ▼\n            ")]) : _vm._e()]) : _vm._e()])]);
  }), 0), _vm._v(" "), _vm._l(_vm.getRows, function (row, rowIndex) {
    return _c("div", {
      key: rowIndex,
      staticClass: "flex my-3 z-10"
    }, [_c("div", {
      staticClass: "\n          flex\n          justify-center\n          items-center\n          my-1\n          border-1 border-solid border-blue\n          rounded-full\n          bg-white\n          relative\n          dash\n        "
    }, [_vm._t("view", function () {
      return [_vm._v("\n          view\n        ")];
    }, {
      row: row
    })], 2), _vm._v(" "), _c("div", {
      staticClass: "\n          grid\n          w-full\n          ml-4\n          border-1 border-solid border-blue\n          rounded-full\n        ",
      style: {
        gridTemplateColumns: "repeat(" + _vm.gridColumns.length + ", 1fr)"
      }
    }, _vm._l(_vm.gridColumns, function (column, index) {
      return _c("div", {
        key: column.key,
        staticClass: "px-2.5 py-1 truncate",
        "class": {
          "text-left": index === 0,
          "text-center": index > 0 && _vm.gridColumns.length >= 2,
          "text-right": index === _vm.gridColumns.length - 1 && _vm.gridColumns.length <= 2,
          "flex justify-center": _vm.loading
        }
      }, [_vm.loading ? _c("loading-icon", {
        staticClass: "w-6 h-6 flex justify-center"
      }) : _vm._t(column.key, function () {
        return [_vm._v("\n            " + _vm._s(row[column.key]) + "\n          ")];
      }, {
        column: column,
        row: row
      })], 2);
    }), 0)]);
  })], 2)]);
};

var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;
/* style */

var __vue_inject_styles__$a = function __vue_inject_styles__$a(inject) {
  if (!inject) return;
  inject("data-v-60439143_0", {
    source: ".sb-table__head-item__arrow[data-v-60439143] {\n  font-size: 0.5rem;\n  line-height: 0.55rem;\n}\n.vertical-line[data-v-60439143]::before {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  top: 0;\n  bottom: 0;\n  left: 35px;\n  width: 12px;\n  background-image: linear-gradient(to bottom, #128ff9 0%, #6044f8 100%);\n  border-radius: 12px;\n}\n.dash[data-v-60439143] {\n  width: 88px;\n}\n.dash[data-v-60439143]::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: -10px;\n  width: 10px;\n  border-top: 1px solid #128FF9;\n}\n\n/*# sourceMappingURL=CustomGridTable.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/CustomGridTable.vue", "CustomGridTable.vue"],
      "names": [],
      "mappings": "AA8PA;EACA,iBAAA;EACA,oBAAA;AC7PA;ADgQA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sEAAA;EACA,mBAAA;AC7PA;ADgQA;EACA,WAAA;AC7PA;AD8PA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AC5PA;;AAEA,8CAA8C",
      "file": "CustomGridTable.vue",
      "sourcesContent": ["<template>\n  <div class=\"w-full overflow-x-auto box-content bg-white\">\n    <div\n      class=\"\n        flex flex-col\n        min-w-min\n        text-left\n        vertical-line\n        relative\n        pb-8\n      \"\n    >\n      <div\n        class=\"grid ml-24\"\n        :style=\"{ gridTemplateColumns: `repeat(${gridColumns.length}, 1fr)` }\"\n      >\n        <div\n          v-for=\"(column, index) in gridColumns\"\n          class=\"p-2 font-bold\"\n          :class=\"{\n            'cursor-pointer': isColumnSortable(column),\n            'pointer-events-none': !isColumnSortable(column),\n            'text-center':\n              (index !== 0 && index > gridColumns.length) ||\n              gridColumns.length > 2,\n            'text-right':\n              index === gridColumns.length - 1 && gridColumns.length <= 2,\n          }\"\n          @click=\"setSortOrder(column)\"\n          :key=\"column.key\"\n        >\n          <span\n            :class=\"{\n              sortable: isColumnSortable(column),\n            }\"\n            class=\"sb-table__head-item relative text-gray text-base\"\n          >\n            <span>{{ column.value }}</span>\n            <div\n              v-if=\"isColumnSortable(column)\"\n              class=\"absolute -right-3 bottom-0\"\n            >\n              <div\n                v-if=\"!getIsOrderSelected(column.key, 'desc')\"\n                v-bind:class=\"{\n                  'text-purple': getIsOrderSelected(column.key, 'asc'),\n                  'mt-1': getIsOrderSelected(column.key, 'asc'),\n                }\"\n                class=\"\n                  sb-table__head-item__arrow\n                  text-gray-light\n                  cursor-pointer\n                \"\n              >\n                ▲\n              </div>\n              <div\n                v-if=\"!getIsOrderSelected(column.key, 'asc')\"\n                v-bind:class=\"{\n                  'text-purple': getIsOrderSelected(column.key, 'desc'),\n                  'mt-1': getIsOrderSelected(column.key, 'desc'),\n                }\"\n                class=\"\n                  sb-table__head-item__arrow\n                  text-gray-light\n                  cursor-pointer\n                \"\n              >\n                ▼\n              </div>\n            </div>\n          </span>\n        </div>\n      </div>\n      <div\n        v-for=\"(row, rowIndex) in getRows\"\n        :key=\"rowIndex\"\n        class=\"flex my-3 z-10\"\n      >\n        <div\n          class=\"\n            flex\n            justify-center\n            items-center\n            my-1\n            border-1 border-solid border-blue\n            rounded-full\n            bg-white\n            relative\n            dash\n          \"\n        >\n          <slot name=\"view\" :row=\"row\">\n            view\n          </slot>\n        </div>\n        <div\n          class=\"\n            grid\n            w-full\n            ml-4\n            border-1 border-solid border-blue\n            rounded-full\n          \"\n          :style=\"{\n            gridTemplateColumns: `repeat(${gridColumns.length}, 1fr)`,\n          }\"\n        >\n          <div\n            v-for=\"(column, index) in gridColumns\"\n            :key=\"column.key\"\n            class=\"px-2.5 py-1 truncate\"\n            :class=\"{\n              'text-left': index === 0,\n              'text-center': index > 0 && gridColumns.length >= 2,\n              'text-right':\n                index === gridColumns.length - 1 && gridColumns.length <= 2,\n              'flex justify-center': loading\n            }\"\n          >\n            <loading-icon v-if=\"loading\" class=\"w-6 h-6 flex justify-center\" />\n            <slot v-else :name=\"column.key\" :column=\"column\" :row=\"row\">\n              {{ row[column.key] }}\n            </slot>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n<script lang=\"ts\">\nimport Vue, { PropType } from \"vue\";\nimport LoadingIcon from \"../icons/LoadingIcon.vue\"\n\ntype Row = {\n  [key in string | number]: string;\n};\n\ntype SortDirection = \"asc\" | \"desc\";\n\ninterface Column {\n  key: string;\n  sorting: SortDirection;\n  value: string;\n  sortable?: boolean;\n}\ninterface Order {\n  key: string;\n  sorting: SortDirection;\n}\n\nexport default Vue.extend({\n  name: \"custom-grid-table\",\n  props: {\n    columns: {\n      type: Array as PropType<Array<Column>>,\n      default: [],\n    },\n    rows: {\n      type: Array as PropType<Array<Row>>,\n      default: [],\n    },\n    sortable: {\n      type: Boolean,\n      default: false,\n    },\n    defaultSortColumn: {\n      type: String,\n      default: \"\",\n    },\n    defaultSortDirection: {\n      type: String as PropType<SortDirection>,\n      default: \"desc\",\n    },\n    disableTableSort: {\n      type: Boolean,\n      default: false,\n    },\n    loading: {\n      type: Boolean,\n      default: false,\n    }\n  },\n  components: {\n    LoadingIcon\n  },\n  data(): { order: Order; gridColumns: Column[] } {\n    return {\n      order: {\n        key: \"\",\n        sorting: \"asc\",\n      },\n      gridColumns: [],\n    };\n  },\n  created() {\n    this.order = {\n      key: this.defaultSortColumn || this.columns?.[0]?.key,\n      sorting: this.defaultSortDirection,\n    } as Order;\n    this.gridColumns = this.columns;\n  },\n  computed: {\n    getRows(): Row[] {\n      if (!this.disableTableSort) {\n        return this.sortRows(this.order.key, this.order.sorting);\n      }\n      return this.rows;\n    },\n  },\n  methods: {\n    sortRows(key: string | number, sorting = \"asc\"): Row[] {\n      return this.rows.sort((a: Row, b: Row) => {\n        if (a[key] < b[key]) {\n          return sorting === \"asc\" ? -1 : 1;\n        }\n        if (a[key] > b[key]) {\n          return sorting === \"asc\" ? 1 : -1;\n        }\n        return 0;\n      });\n    },\n    setSortOrder(column: Column): void {\n      if (this.order.key === column.key && this.order.sorting === \"asc\") {\n        this.order = {\n          key: column.key,\n          sorting: \"desc\",\n        };\n      } else {\n        this.order = {\n          key: column.key,\n          sorting: \"asc\",\n        };\n      }\n    },\n    getIsOrderSelected(columnKey: string, order: SortDirection): boolean {\n      return this.order.key === columnKey && this.order.sorting === order;\n    },\n    isColumnSortable(column: Column) {\n      return (\n        (this.sortable &&\n          (!column.hasOwnProperty(\"sortable\") || column.sortable)) ||\n        (!this.sortable && column.sortable)\n      );\n    },\n  },\n  watch: {\n    order(value: Column): void {\n      this.$emit(\"sortChange\", value);\n    },\n  },\n});\n</script>\n<style lang=\"scss\" scoped>\n  .sb-table__head-item__arrow {\n    font-size: 0.5rem;\n    line-height: 0.55rem;\n  }\n  .vertical-line {\n    &::before {\n      content: \"\";\n      position: absolute;\n      z-index: 0;\n      top: 0;\n      bottom: 0;\n      left: 35px;\n      width: 12px;\n      background-image: linear-gradient(to bottom, #128ff9 0%, #6044f8 100%);\n      border-radius: 12px;\n    }\n  }\n  .dash {\n    width: 88px;\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      right: -10px;\n      width: 10px;\n      border-top: 1px solid #128FF9;\n    }\n  }\n</style>\n", ".sb-table__head-item__arrow {\n  font-size: 0.5rem;\n  line-height: 0.55rem;\n}\n\n.vertical-line::before {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  top: 0;\n  bottom: 0;\n  left: 35px;\n  width: 12px;\n  background-image: linear-gradient(to bottom, #128ff9 0%, #6044f8 100%);\n  border-radius: 12px;\n}\n\n.dash {\n  width: 88px;\n}\n.dash::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: -10px;\n  width: 10px;\n  border-top: 1px solid #128FF9;\n}\n\n/*# sourceMappingURL=CustomGridTable.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$a = "data-v-60439143";
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);
/*! For license information please see mermaid.esm.min.mjs.LICENSE.txt */


var t = {
  1362: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t5, e, n, r) {
        for (n = n || {}, r = _t5.length; r--; n[_t5[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 6],
          n = [1, 7],
          r = [1, 8],
          i = [1, 9],
          a = [1, 12],
          o = [1, 11],
          s = [1, 15, 24],
          c = [1, 19],
          u = [1, 31],
          l = [1, 34],
          h = [1, 32],
          f = [1, 33],
          d = [1, 35],
          p = [1, 36],
          y = [1, 37],
          g = [1, 38],
          m = [1, 41],
          v = [1, 42],
          b = [1, 43],
          _ = [1, 44],
          x = [15, 24],
          w = [1, 56],
          k = [1, 57],
          T = [1, 58],
          E = [1, 59],
          C = [1, 60],
          S = [1, 61],
          A = [15, 24, 31, 38, 39, 47, 50, 51, 52, 53, 54, 55, 60, 62],
          M = [15, 24, 29, 31, 38, 39, 43, 47, 50, 51, 52, 53, 54, 55, 60, 62, 77, 78, 79, 80],
          N = [7, 8, 9, 10, 15, 18, 22, 24],
          D = [47, 77, 78, 79, 80],
          O = [47, 54, 55, 77, 78, 79, 80],
          B = [47, 50, 51, 52, 53, 77, 78, 79, 80],
          L = [15, 24, 31],
          I = [1, 93],
          R = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          mermaidDoc: 4,
          direction: 5,
          directive: 6,
          direction_tb: 7,
          direction_bt: 8,
          direction_rl: 9,
          direction_lr: 10,
          graphConfig: 11,
          openDirective: 12,
          typeDirective: 13,
          closeDirective: 14,
          NEWLINE: 15,
          ":": 16,
          argDirective: 17,
          open_directive: 18,
          type_directive: 19,
          arg_directive: 20,
          close_directive: 21,
          CLASS_DIAGRAM: 22,
          statements: 23,
          EOF: 24,
          statement: 25,
          className: 26,
          alphaNumToken: 27,
          classLiteralName: 28,
          GENERICTYPE: 29,
          relationStatement: 30,
          LABEL: 31,
          classStatement: 32,
          methodStatement: 33,
          annotationStatement: 34,
          clickStatement: 35,
          cssClassStatement: 36,
          CLASS: 37,
          STYLE_SEPARATOR: 38,
          STRUCT_START: 39,
          members: 40,
          STRUCT_STOP: 41,
          ANNOTATION_START: 42,
          ANNOTATION_END: 43,
          MEMBER: 44,
          SEPARATOR: 45,
          relation: 46,
          STR: 47,
          relationType: 48,
          lineType: 49,
          AGGREGATION: 50,
          EXTENSION: 51,
          COMPOSITION: 52,
          DEPENDENCY: 53,
          LINE: 54,
          DOTTED_LINE: 55,
          CALLBACK: 56,
          LINK: 57,
          LINK_TARGET: 58,
          CLICK: 59,
          CALLBACK_NAME: 60,
          CALLBACK_ARGS: 61,
          HREF: 62,
          CSSCLASS: 63,
          commentToken: 64,
          textToken: 65,
          graphCodeTokens: 66,
          textNoTagsToken: 67,
          TAGSTART: 68,
          TAGEND: 69,
          "==": 70,
          "--": 71,
          PCT: 72,
          DEFAULT: 73,
          SPACE: 74,
          MINUS: 75,
          keywords: 76,
          UNICODE_TEXT: 77,
          NUM: 78,
          ALPHA: 79,
          BQUOTE_STR: 80,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          7: "direction_tb",
          8: "direction_bt",
          9: "direction_rl",
          10: "direction_lr",
          15: "NEWLINE",
          16: ":",
          18: "open_directive",
          19: "type_directive",
          20: "arg_directive",
          21: "close_directive",
          22: "CLASS_DIAGRAM",
          24: "EOF",
          29: "GENERICTYPE",
          31: "LABEL",
          37: "CLASS",
          38: "STYLE_SEPARATOR",
          39: "STRUCT_START",
          41: "STRUCT_STOP",
          42: "ANNOTATION_START",
          43: "ANNOTATION_END",
          44: "MEMBER",
          45: "SEPARATOR",
          47: "STR",
          50: "AGGREGATION",
          51: "EXTENSION",
          52: "COMPOSITION",
          53: "DEPENDENCY",
          54: "LINE",
          55: "DOTTED_LINE",
          56: "CALLBACK",
          57: "LINK",
          58: "LINK_TARGET",
          59: "CLICK",
          60: "CALLBACK_NAME",
          61: "CALLBACK_ARGS",
          62: "HREF",
          63: "CSSCLASS",
          66: "graphCodeTokens",
          68: "TAGSTART",
          69: "TAGEND",
          70: "==",
          71: "--",
          72: "PCT",
          73: "DEFAULT",
          74: "SPACE",
          75: "MINUS",
          76: "keywords",
          77: "UNICODE_TEXT",
          78: "NUM",
          79: "ALPHA",
          80: "BQUOTE_STR"
        },
        productions_: [0, [3, 1], [3, 1], [3, 2], [5, 1], [5, 1], [5, 1], [5, 1], [4, 1], [6, 4], [6, 6], [12, 1], [13, 1], [17, 1], [14, 1], [11, 4], [23, 1], [23, 2], [23, 3], [26, 1], [26, 1], [26, 2], [26, 2], [26, 2], [25, 1], [25, 2], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [32, 2], [32, 4], [32, 5], [32, 7], [34, 4], [40, 1], [40, 2], [33, 1], [33, 2], [33, 1], [33, 1], [30, 3], [30, 4], [30, 4], [30, 5], [46, 3], [46, 2], [46, 2], [46, 1], [48, 1], [48, 1], [48, 1], [48, 1], [49, 1], [49, 1], [35, 3], [35, 4], [35, 3], [35, 4], [35, 4], [35, 5], [35, 3], [35, 4], [35, 4], [35, 5], [35, 3], [35, 4], [35, 4], [35, 5], [36, 3], [64, 1], [64, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [67, 1], [67, 1], [67, 1], [67, 1], [27, 1], [27, 1], [27, 1], [28, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 4:
              r.setDirection("TB");
              break;

            case 5:
              r.setDirection("BT");
              break;

            case 6:
              r.setDirection("RL");
              break;

            case 7:
              r.setDirection("LR");
              break;

            case 11:
              r.parseDirective("%%{", "open_directive");
              break;

            case 12:
              r.parseDirective(a[s], "type_directive");
              break;

            case 13:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 14:
              r.parseDirective("}%%", "close_directive", "class");
              break;

            case 19:
            case 20:
              this.$ = a[s];
              break;

            case 21:
              this.$ = a[s - 1] + a[s];
              break;

            case 22:
            case 23:
              this.$ = a[s - 1] + "~" + a[s];
              break;

            case 24:
              r.addRelation(a[s]);
              break;

            case 25:
              a[s - 1].title = r.cleanupLabel(a[s]), r.addRelation(a[s - 1]);
              break;

            case 33:
              r.addClass(a[s]);
              break;

            case 34:
              r.addClass(a[s - 2]), r.setCssClass(a[s - 2], a[s]);
              break;

            case 35:
              r.addClass(a[s - 3]), r.addMembers(a[s - 3], a[s - 1]);
              break;

            case 36:
              r.addClass(a[s - 5]), r.setCssClass(a[s - 5], a[s - 3]), r.addMembers(a[s - 5], a[s - 1]);
              break;

            case 37:
              r.addAnnotation(a[s], a[s - 2]);
              break;

            case 38:
              this.$ = [a[s]];
              break;

            case 39:
              a[s].push(a[s - 1]), this.$ = a[s];
              break;

            case 40:
            case 42:
            case 43:
              break;

            case 41:
              r.addMember(a[s - 1], r.cleanupLabel(a[s]));
              break;

            case 44:
              this.$ = {
                id1: a[s - 2],
                id2: a[s],
                relation: a[s - 1],
                relationTitle1: "none",
                relationTitle2: "none"
              };
              break;

            case 45:
              this.$ = {
                id1: a[s - 3],
                id2: a[s],
                relation: a[s - 1],
                relationTitle1: a[s - 2],
                relationTitle2: "none"
              };
              break;

            case 46:
              this.$ = {
                id1: a[s - 3],
                id2: a[s],
                relation: a[s - 2],
                relationTitle1: "none",
                relationTitle2: a[s - 1]
              };
              break;

            case 47:
              this.$ = {
                id1: a[s - 4],
                id2: a[s],
                relation: a[s - 2],
                relationTitle1: a[s - 3],
                relationTitle2: a[s - 1]
              };
              break;

            case 48:
              this.$ = {
                type1: a[s - 2],
                type2: a[s],
                lineType: a[s - 1]
              };
              break;

            case 49:
              this.$ = {
                type1: "none",
                type2: a[s],
                lineType: a[s - 1]
              };
              break;

            case 50:
              this.$ = {
                type1: a[s - 1],
                type2: "none",
                lineType: a[s]
              };
              break;

            case 51:
              this.$ = {
                type1: "none",
                type2: "none",
                lineType: a[s]
              };
              break;

            case 52:
              this.$ = r.relationType.AGGREGATION;
              break;

            case 53:
              this.$ = r.relationType.EXTENSION;
              break;

            case 54:
              this.$ = r.relationType.COMPOSITION;
              break;

            case 55:
              this.$ = r.relationType.DEPENDENCY;
              break;

            case 56:
              this.$ = r.lineType.LINE;
              break;

            case 57:
              this.$ = r.lineType.DOTTED_LINE;
              break;

            case 58:
            case 64:
              this.$ = a[s - 2], r.setClickEvent(a[s - 1], a[s]);
              break;

            case 59:
            case 65:
              this.$ = a[s - 3], r.setClickEvent(a[s - 2], a[s - 1]), r.setTooltip(a[s - 2], a[s]);
              break;

            case 60:
            case 68:
              this.$ = a[s - 2], r.setLink(a[s - 1], a[s]);
              break;

            case 61:
            case 69:
              this.$ = a[s - 3], r.setLink(a[s - 2], a[s - 1], a[s]);
              break;

            case 62:
            case 70:
              this.$ = a[s - 3], r.setLink(a[s - 2], a[s - 1]), r.setTooltip(a[s - 2], a[s]);
              break;

            case 63:
            case 71:
              this.$ = a[s - 4], r.setLink(a[s - 3], a[s - 2], a[s]), r.setTooltip(a[s - 3], a[s - 1]);
              break;

            case 66:
              this.$ = a[s - 3], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
              break;

            case 67:
              this.$ = a[s - 4], r.setClickEvent(a[s - 3], a[s - 2], a[s - 1]), r.setTooltip(a[s - 3], a[s]);
              break;

            case 72:
              r.setCssClass(a[s - 1], a[s]);
          }
        },
        table: [{
          3: 1,
          4: 2,
          5: 3,
          6: 4,
          7: e,
          8: n,
          9: r,
          10: i,
          11: 5,
          12: 10,
          18: a,
          22: o
        }, {
          1: [3]
        }, {
          1: [2, 1]
        }, {
          1: [2, 2]
        }, {
          3: 13,
          4: 2,
          5: 3,
          6: 4,
          7: e,
          8: n,
          9: r,
          10: i,
          11: 5,
          12: 10,
          18: a,
          22: o
        }, {
          1: [2, 8]
        }, t(s, [2, 4]), t(s, [2, 5]), t(s, [2, 6]), t(s, [2, 7]), {
          13: 14,
          19: [1, 15]
        }, {
          15: [1, 16]
        }, {
          19: [2, 11]
        }, {
          1: [2, 3]
        }, {
          14: 17,
          16: [1, 18],
          21: c
        }, t([16, 21], [2, 12]), {
          5: 29,
          6: 28,
          7: e,
          8: n,
          9: r,
          10: i,
          12: 10,
          18: a,
          23: 20,
          25: 21,
          26: 30,
          27: 39,
          28: 40,
          30: 22,
          32: 23,
          33: 24,
          34: 25,
          35: 26,
          36: 27,
          37: u,
          42: l,
          44: h,
          45: f,
          56: d,
          57: p,
          59: y,
          63: g,
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          15: [1, 45]
        }, {
          17: 46,
          20: [1, 47]
        }, {
          15: [2, 14]
        }, {
          24: [1, 48]
        }, {
          15: [1, 49],
          24: [2, 16]
        }, t(x, [2, 24], {
          31: [1, 50]
        }), t(x, [2, 26]), t(x, [2, 27]), t(x, [2, 28]), t(x, [2, 29]), t(x, [2, 30]), t(x, [2, 31]), t(x, [2, 32]), t(x, [2, 40], {
          46: 51,
          48: 54,
          49: 55,
          31: [1, 53],
          47: [1, 52],
          50: w,
          51: k,
          52: T,
          53: E,
          54: C,
          55: S
        }), {
          26: 62,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, t(x, [2, 42]), t(x, [2, 43]), {
          27: 63,
          77: m,
          78: v,
          79: b
        }, {
          26: 64,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          26: 65,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          26: 66,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          47: [1, 67]
        }, t(A, [2, 19], {
          27: 39,
          28: 40,
          26: 68,
          29: [1, 69],
          77: m,
          78: v,
          79: b,
          80: _
        }), t(A, [2, 20], {
          29: [1, 70]
        }), t(M, [2, 86]), t(M, [2, 87]), t(M, [2, 88]), t([15, 24, 29, 31, 38, 39, 47, 50, 51, 52, 53, 54, 55, 60, 62], [2, 89]), t(N, [2, 9]), {
          14: 71,
          21: c
        }, {
          21: [2, 13]
        }, {
          1: [2, 15]
        }, {
          5: 29,
          6: 28,
          7: e,
          8: n,
          9: r,
          10: i,
          12: 10,
          18: a,
          23: 72,
          24: [2, 17],
          25: 21,
          26: 30,
          27: 39,
          28: 40,
          30: 22,
          32: 23,
          33: 24,
          34: 25,
          35: 26,
          36: 27,
          37: u,
          42: l,
          44: h,
          45: f,
          56: d,
          57: p,
          59: y,
          63: g,
          77: m,
          78: v,
          79: b,
          80: _
        }, t(x, [2, 25]), {
          26: 73,
          27: 39,
          28: 40,
          47: [1, 74],
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          46: 75,
          48: 54,
          49: 55,
          50: w,
          51: k,
          52: T,
          53: E,
          54: C,
          55: S
        }, t(x, [2, 41]), {
          49: 76,
          54: C,
          55: S
        }, t(D, [2, 51], {
          48: 77,
          50: w,
          51: k,
          52: T,
          53: E
        }), t(O, [2, 52]), t(O, [2, 53]), t(O, [2, 54]), t(O, [2, 55]), t(B, [2, 56]), t(B, [2, 57]), t(x, [2, 33], {
          38: [1, 78],
          39: [1, 79]
        }), {
          43: [1, 80]
        }, {
          47: [1, 81]
        }, {
          47: [1, 82]
        }, {
          60: [1, 83],
          62: [1, 84]
        }, {
          27: 85,
          77: m,
          78: v,
          79: b
        }, t(A, [2, 21]), t(A, [2, 22]), t(A, [2, 23]), {
          15: [1, 86]
        }, {
          24: [2, 18]
        }, t(L, [2, 44]), {
          26: 87,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, {
          26: 88,
          27: 39,
          28: 40,
          47: [1, 89],
          77: m,
          78: v,
          79: b,
          80: _
        }, t(D, [2, 50], {
          48: 90,
          50: w,
          51: k,
          52: T,
          53: E
        }), t(D, [2, 49]), {
          27: 91,
          77: m,
          78: v,
          79: b
        }, {
          40: 92,
          44: I
        }, {
          26: 94,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, t(x, [2, 58], {
          47: [1, 95]
        }), t(x, [2, 60], {
          47: [1, 97],
          58: [1, 96]
        }), t(x, [2, 64], {
          47: [1, 98],
          61: [1, 99]
        }), t(x, [2, 68], {
          47: [1, 101],
          58: [1, 100]
        }), t(x, [2, 72]), t(N, [2, 10]), t(L, [2, 46]), t(L, [2, 45]), {
          26: 102,
          27: 39,
          28: 40,
          77: m,
          78: v,
          79: b,
          80: _
        }, t(D, [2, 48]), t(x, [2, 34], {
          39: [1, 103]
        }), {
          41: [1, 104]
        }, {
          40: 105,
          41: [2, 38],
          44: I
        }, t(x, [2, 37]), t(x, [2, 59]), t(x, [2, 61]), t(x, [2, 62], {
          58: [1, 106]
        }), t(x, [2, 65]), t(x, [2, 66], {
          47: [1, 107]
        }), t(x, [2, 69]), t(x, [2, 70], {
          58: [1, 108]
        }), t(L, [2, 47]), {
          40: 109,
          44: I
        }, t(x, [2, 35]), {
          41: [2, 39]
        }, t(x, [2, 63]), t(x, [2, 67]), t(x, [2, 71]), {
          41: [1, 110]
        }, t(x, [2, 36])],
        defaultActions: {
          2: [2, 1],
          3: [2, 2],
          5: [2, 8],
          12: [2, 11],
          13: [2, 3],
          19: [2, 14],
          47: [2, 13],
          48: [2, 15],
          72: [2, 18],
          105: [2, 39]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          F = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {},
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 18;

            case 1:
              return 7;

            case 2:
              return 8;

            case 3:
              return 9;

            case 4:
              return 10;

            case 5:
              return this.begin("type_directive"), 19;

            case 6:
              return this.popState(), this.begin("arg_directive"), 16;

            case 7:
              return this.popState(), this.popState(), 21;

            case 8:
              return 20;

            case 9:
            case 10:
            case 12:
            case 19:
              break;

            case 11:
              return 15;

            case 13:
            case 14:
              return 22;

            case 15:
              return this.begin("struct"), 39;

            case 16:
              return "EOF_IN_STRUCT";

            case 17:
              return "OPEN_IN_STRUCT";

            case 18:
              return this.popState(), 41;

            case 20:
              return "MEMBER";

            case 21:
              return 37;

            case 22:
              return 63;

            case 23:
              return 56;

            case 24:
              return 57;

            case 25:
              return 59;

            case 26:
              return 42;

            case 27:
              return 43;

            case 28:
              this.begin("generic");
              break;

            case 29:
            case 32:
            case 35:
            case 38:
            case 41:
            case 44:
              this.popState();
              break;

            case 30:
              return "GENERICTYPE";

            case 31:
              this.begin("string");
              break;

            case 33:
              return "STR";

            case 34:
              this.begin("bqstring");
              break;

            case 36:
              return "BQUOTE_STR";

            case 37:
              this.begin("href");
              break;

            case 39:
              return 62;

            case 40:
              this.begin("callback_name");
              break;

            case 42:
              this.popState(), this.begin("callback_args");
              break;

            case 43:
              return 60;

            case 45:
              return 61;

            case 46:
            case 47:
            case 48:
            case 49:
              return 58;

            case 50:
            case 51:
              return 51;

            case 52:
            case 53:
              return 53;

            case 54:
              return 52;

            case 55:
              return 50;

            case 56:
              return 54;

            case 57:
              return 55;

            case 58:
              return 31;

            case 59:
              return 38;

            case 60:
              return 75;

            case 61:
              return "DOT";

            case 62:
              return "PLUS";

            case 63:
              return 72;

            case 64:
            case 65:
              return "EQUALS";

            case 66:
              return 79;

            case 67:
              return "PUNCTUATION";

            case 68:
              return 78;

            case 69:
              return 77;

            case 70:
              return 74;

            case 71:
              return 24;
          }
        },
        rules: [/^(?:%%\{)/, /^(?:.*direction\s+TB[^\n]*)/, /^(?:.*direction\s+BT[^\n]*)/, /^(?:.*direction\s+RL[^\n]*)/, /^(?:.*direction\s+LR[^\n]*)/, /^(?:((?:(?!\}%%)[^:.])*))/, /^(?::)/, /^(?:\}%%)/, /^(?:((?:(?!\}%%).|\n)*))/, /^(?:%%(?!\{)*[^\n]*(\r?\n?)+)/, /^(?:%%[^\n]*(\r?\n)*)/, /^(?:\s*(\r?\n)+)/, /^(?:\s+)/, /^(?:classDiagram-v2\b)/, /^(?:classDiagram\b)/, /^(?:[{])/, /^(?:$)/, /^(?:[{])/, /^(?:[}])/, /^(?:[\n])/, /^(?:[^{}\n]*)/, /^(?:class\b)/, /^(?:cssClass\b)/, /^(?:callback\b)/, /^(?:link\b)/, /^(?:click\b)/, /^(?:<<)/, /^(?:>>)/, /^(?:[~])/, /^(?:[~])/, /^(?:[^~]*)/, /^(?:["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:[`])/, /^(?:[`])/, /^(?:[^`]+)/, /^(?:href[\s]+["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:call[\s]+)/, /^(?:\([\s]*\))/, /^(?:\()/, /^(?:[^(]*)/, /^(?:\))/, /^(?:[^)]*)/, /^(?:_self\b)/, /^(?:_blank\b)/, /^(?:_parent\b)/, /^(?:_top\b)/, /^(?:\s*<\|)/, /^(?:\s*\|>)/, /^(?:\s*>)/, /^(?:\s*<)/, /^(?:\s*\*)/, /^(?:\s*o\b)/, /^(?:--)/, /^(?:\.\.)/, /^(?::{1}[^:\n;]+)/, /^(?::{3})/, /^(?:-)/, /^(?:\.)/, /^(?:\+)/, /^(?:%)/, /^(?:=)/, /^(?:=)/, /^(?:\w+)/, /^(?:[!"#$%&'*+,-.`?\\/])/, /^(?:[0-9]+)/, /^(?:[\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6]|[\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377]|[\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5]|[\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA]|[\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE]|[\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA]|[\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0]|[\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977]|[\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2]|[\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A]|[\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39]|[\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8]|[\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C]|[\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C]|[\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99]|[\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0]|[\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D]|[\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3]|[\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10]|[\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1]|[\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81]|[\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3]|[\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6]|[\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A]|[\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081]|[\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D]|[\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0]|[\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310]|[\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C]|[\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711]|[\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7]|[\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C]|[\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16]|[\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF]|[\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC]|[\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D]|[\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D]|[\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3]|[\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F]|[\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128]|[\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184]|[\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3]|[\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6]|[\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE]|[\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C]|[\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D]|[\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC]|[\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B]|[\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788]|[\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805]|[\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB]|[\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28]|[\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5]|[\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4]|[\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|[\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D]|[\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36]|[\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D]|[\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC]|[\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF]|[\uFFD2-\uFFD7\uFFDA-\uFFDC])/, /^(?:\s)/, /^(?:$)/],
        conditions: {
          arg_directive: {
            rules: [7, 8],
            inclusive: !1
          },
          type_directive: {
            rules: [6, 7],
            inclusive: !1
          },
          open_directive: {
            rules: [5],
            inclusive: !1
          },
          callback_args: {
            rules: [44, 45],
            inclusive: !1
          },
          callback_name: {
            rules: [41, 42, 43],
            inclusive: !1
          },
          href: {
            rules: [38, 39],
            inclusive: !1
          },
          struct: {
            rules: [16, 17, 18, 19, 20],
            inclusive: !1
          },
          generic: {
            rules: [29, 30],
            inclusive: !1
          },
          bqstring: {
            rules: [35, 36],
            inclusive: !1
          },
          string: {
            rules: [32, 33],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15, 21, 22, 23, 24, 25, 26, 27, 28, 31, 34, 37, 40, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71],
            inclusive: !0
          }
        }
      };

      function P() {
        this.yy = {};
      }

      return R.lexer = F, P.prototype = R, R.Parser = P, new P();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(8218).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  5890: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t6, e, n, r) {
        for (n = n || {}, r = _t6.length; r--; n[_t6[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 2],
          n = [1, 5],
          r = [6, 9, 11, 23, 41],
          i = [1, 17],
          a = [1, 20],
          o = [1, 25],
          s = [1, 26],
          c = [1, 27],
          u = [1, 28],
          l = [1, 37],
          h = [23, 38, 39],
          f = [4, 6, 9, 11, 23, 41],
          d = [34, 35, 36, 37],
          p = [22, 29],
          y = [1, 55],
          g = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          ER_DIAGRAM: 4,
          document: 5,
          EOF: 6,
          directive: 7,
          line: 8,
          SPACE: 9,
          statement: 10,
          NEWLINE: 11,
          openDirective: 12,
          typeDirective: 13,
          closeDirective: 14,
          ":": 15,
          argDirective: 16,
          entityName: 17,
          relSpec: 18,
          role: 19,
          BLOCK_START: 20,
          attributes: 21,
          BLOCK_STOP: 22,
          ALPHANUM: 23,
          attribute: 24,
          attributeType: 25,
          attributeName: 26,
          attributeKeyType: 27,
          attributeComment: 28,
          ATTRIBUTE_WORD: 29,
          ATTRIBUTE_KEY: 30,
          COMMENT: 31,
          cardinality: 32,
          relType: 33,
          ZERO_OR_ONE: 34,
          ZERO_OR_MORE: 35,
          ONE_OR_MORE: 36,
          ONLY_ONE: 37,
          NON_IDENTIFYING: 38,
          IDENTIFYING: 39,
          WORD: 40,
          open_directive: 41,
          type_directive: 42,
          arg_directive: 43,
          close_directive: 44,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "ER_DIAGRAM",
          6: "EOF",
          9: "SPACE",
          11: "NEWLINE",
          15: ":",
          20: "BLOCK_START",
          22: "BLOCK_STOP",
          23: "ALPHANUM",
          29: "ATTRIBUTE_WORD",
          30: "ATTRIBUTE_KEY",
          31: "COMMENT",
          34: "ZERO_OR_ONE",
          35: "ZERO_OR_MORE",
          36: "ONE_OR_MORE",
          37: "ONLY_ONE",
          38: "NON_IDENTIFYING",
          39: "IDENTIFYING",
          40: "WORD",
          41: "open_directive",
          42: "type_directive",
          43: "arg_directive",
          44: "close_directive"
        },
        productions_: [0, [3, 3], [3, 2], [5, 0], [5, 2], [8, 2], [8, 1], [8, 1], [8, 1], [7, 4], [7, 6], [10, 1], [10, 5], [10, 4], [10, 3], [10, 1], [17, 1], [21, 1], [21, 2], [24, 2], [24, 3], [24, 3], [24, 4], [25, 1], [26, 1], [27, 1], [28, 1], [18, 3], [32, 1], [32, 1], [32, 1], [32, 1], [33, 1], [33, 1], [19, 1], [19, 1], [12, 1], [13, 1], [16, 1], [14, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 1:
              break;

            case 3:
            case 7:
            case 8:
              this.$ = [];
              break;

            case 4:
              a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 5:
            case 6:
            case 16:
            case 23:
            case 24:
            case 25:
            case 35:
              this.$ = a[s];
              break;

            case 12:
              r.addEntity(a[s - 4]), r.addEntity(a[s - 2]), r.addRelationship(a[s - 4], a[s], a[s - 2], a[s - 3]);
              break;

            case 13:
              r.addEntity(a[s - 3]), r.addAttributes(a[s - 3], a[s - 1]);
              break;

            case 14:
              r.addEntity(a[s - 2]);
              break;

            case 15:
              r.addEntity(a[s]);
              break;

            case 17:
              this.$ = [a[s]];
              break;

            case 18:
              a[s].push(a[s - 1]), this.$ = a[s];
              break;

            case 19:
              this.$ = {
                attributeType: a[s - 1],
                attributeName: a[s]
              };
              break;

            case 20:
              this.$ = {
                attributeType: a[s - 2],
                attributeName: a[s - 1],
                attributeKeyType: a[s]
              };
              break;

            case 21:
              this.$ = {
                attributeType: a[s - 2],
                attributeName: a[s - 1],
                attributeComment: a[s]
              };
              break;

            case 22:
              this.$ = {
                attributeType: a[s - 3],
                attributeName: a[s - 2],
                attributeKeyType: a[s - 1],
                attributeComment: a[s]
              };
              break;

            case 26:
            case 34:
              this.$ = a[s].replace(/"/g, "");
              break;

            case 27:
              this.$ = {
                cardA: a[s],
                relType: a[s - 1],
                cardB: a[s - 2]
              };
              break;

            case 28:
              this.$ = r.Cardinality.ZERO_OR_ONE;
              break;

            case 29:
              this.$ = r.Cardinality.ZERO_OR_MORE;
              break;

            case 30:
              this.$ = r.Cardinality.ONE_OR_MORE;
              break;

            case 31:
              this.$ = r.Cardinality.ONLY_ONE;
              break;

            case 32:
              this.$ = r.Identification.NON_IDENTIFYING;
              break;

            case 33:
              this.$ = r.Identification.IDENTIFYING;
              break;

            case 36:
              r.parseDirective("%%{", "open_directive");
              break;

            case 37:
              r.parseDirective(a[s], "type_directive");
              break;

            case 38:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 39:
              r.parseDirective("}%%", "close_directive", "er");
          }
        },
        table: [{
          3: 1,
          4: e,
          7: 3,
          12: 4,
          41: n
        }, {
          1: [3]
        }, t(r, [2, 3], {
          5: 6
        }), {
          3: 7,
          4: e,
          7: 3,
          12: 4,
          41: n
        }, {
          13: 8,
          42: [1, 9]
        }, {
          42: [2, 36]
        }, {
          6: [1, 10],
          7: 15,
          8: 11,
          9: [1, 12],
          10: 13,
          11: [1, 14],
          12: 4,
          17: 16,
          23: i,
          41: n
        }, {
          1: [2, 2]
        }, {
          14: 18,
          15: [1, 19],
          44: a
        }, t([15, 44], [2, 37]), t(r, [2, 8], {
          1: [2, 1]
        }), t(r, [2, 4]), {
          7: 15,
          10: 21,
          12: 4,
          17: 16,
          23: i,
          41: n
        }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 11]), t(r, [2, 15], {
          18: 22,
          32: 24,
          20: [1, 23],
          34: o,
          35: s,
          36: c,
          37: u
        }), t([6, 9, 11, 15, 20, 23, 34, 35, 36, 37, 41], [2, 16]), {
          11: [1, 29]
        }, {
          16: 30,
          43: [1, 31]
        }, {
          11: [2, 39]
        }, t(r, [2, 5]), {
          17: 32,
          23: i
        }, {
          21: 33,
          22: [1, 34],
          24: 35,
          25: 36,
          29: l
        }, {
          33: 38,
          38: [1, 39],
          39: [1, 40]
        }, t(h, [2, 28]), t(h, [2, 29]), t(h, [2, 30]), t(h, [2, 31]), t(f, [2, 9]), {
          14: 41,
          44: a
        }, {
          44: [2, 38]
        }, {
          15: [1, 42]
        }, {
          22: [1, 43]
        }, t(r, [2, 14]), {
          21: 44,
          22: [2, 17],
          24: 35,
          25: 36,
          29: l
        }, {
          26: 45,
          29: [1, 46]
        }, {
          29: [2, 23]
        }, {
          32: 47,
          34: o,
          35: s,
          36: c,
          37: u
        }, t(d, [2, 32]), t(d, [2, 33]), {
          11: [1, 48]
        }, {
          19: 49,
          23: [1, 51],
          40: [1, 50]
        }, t(r, [2, 13]), {
          22: [2, 18]
        }, t(p, [2, 19], {
          27: 52,
          28: 53,
          30: [1, 54],
          31: y
        }), t([22, 29, 30, 31], [2, 24]), {
          23: [2, 27]
        }, t(f, [2, 10]), t(r, [2, 12]), t(r, [2, 34]), t(r, [2, 35]), t(p, [2, 20], {
          28: 56,
          31: y
        }), t(p, [2, 21]), t([22, 29, 31], [2, 25]), t(p, [2, 26]), t(p, [2, 22])],
        defaultActions: {
          5: [2, 36],
          7: [2, 2],
          20: [2, 39],
          31: [2, 38],
          37: [2, 23],
          44: [2, 18],
          47: [2, 27]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          m = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 41;

            case 1:
              return this.begin("type_directive"), 42;

            case 2:
              return this.popState(), this.begin("arg_directive"), 15;

            case 3:
              return this.popState(), this.popState(), 44;

            case 4:
              return 43;

            case 5:
            case 6:
            case 8:
            case 13:
            case 17:
              break;

            case 7:
              return 11;

            case 9:
              return 9;

            case 10:
              return 40;

            case 11:
              return 4;

            case 12:
              return this.begin("block"), 20;

            case 14:
              return 30;

            case 15:
              return 29;

            case 16:
              return 31;

            case 18:
              return this.popState(), 22;

            case 19:
            case 32:
              return e.yytext[0];

            case 20:
            case 24:
              return 34;

            case 21:
            case 25:
              return 35;

            case 22:
            case 26:
              return 36;

            case 23:
              return 37;

            case 27:
            case 29:
            case 30:
              return 38;

            case 28:
              return 39;

            case 31:
              return 23;

            case 33:
              return 6;
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:[\s]+)/i, /^(?:"[^"]*")/i, /^(?:erDiagram\b)/i, /^(?:\{)/i, /^(?:\s+)/i, /^(?:(?:PK)|(?:FK))/i, /^(?:[A-Za-z][A-Za-z0-9\-_]*)/i, /^(?:"[^"]*")/i, /^(?:[\n]+)/i, /^(?:\})/i, /^(?:.)/i, /^(?:\|o\b)/i, /^(?:\}o\b)/i, /^(?:\}\|)/i, /^(?:\|\|)/i, /^(?:o\|)/i, /^(?:o\{)/i, /^(?:\|\{)/i, /^(?:\.\.)/i, /^(?:--)/i, /^(?:\.-)/i, /^(?:-\.)/i, /^(?:[A-Za-z][A-Za-z0-9\-_]*)/i, /^(?:.)/i, /^(?:$)/i],
        conditions: {
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          block: {
            rules: [13, 14, 15, 16, 17, 18, 19],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33],
            inclusive: !0
          }
        }
      };

      function v() {
        this.yy = {};
      }

      return g.lexer = m, v.prototype = g, g.Parser = v, new v();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(8009).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  3602: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t7, e, n, r) {
        for (n = n || {}, r = _t7.length; r--; n[_t7[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 9],
          n = [1, 7],
          r = [1, 6],
          i = [1, 8],
          a = [1, 20, 21, 22, 23, 38, 47, 59, 60, 79, 80, 81, 82, 83, 84, 88, 98, 99, 102, 104, 105, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
          o = [2, 10],
          s = [1, 20],
          c = [1, 21],
          u = [1, 22],
          l = [1, 23],
          h = [1, 30],
          f = [1, 59],
          d = [1, 45],
          p = [1, 49],
          y = [1, 33],
          g = [1, 34],
          m = [1, 35],
          v = [1, 36],
          b = [1, 37],
          _ = [1, 53],
          x = [1, 60],
          w = [1, 48],
          k = [1, 50],
          T = [1, 52],
          E = [1, 56],
          C = [1, 57],
          S = [1, 38],
          A = [1, 39],
          M = [1, 40],
          N = [1, 41],
          D = [1, 58],
          O = [1, 47],
          B = [1, 51],
          L = [1, 54],
          I = [1, 55],
          R = [1, 46],
          F = [1, 63],
          P = [1, 68],
          j = [1, 20, 21, 22, 23, 38, 42, 47, 59, 60, 79, 80, 81, 82, 83, 84, 88, 98, 99, 102, 104, 105, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
          Y = [1, 72],
          z = [1, 71],
          U = [1, 73],
          q = [20, 21, 23, 74, 75],
          H = [1, 94],
          $ = [1, 99],
          W = [1, 102],
          V = [1, 103],
          G = [1, 96],
          X = [1, 101],
          Z = [1, 104],
          Q = [1, 97],
          K = [1, 109],
          J = [1, 108],
          tt = [1, 98],
          et = [1, 100],
          nt = [1, 105],
          rt = [1, 106],
          it = [1, 107],
          at = [1, 110],
          ot = [20, 21, 22, 23, 74, 75],
          st = [20, 21, 22, 23, 48, 74, 75],
          ct = [20, 21, 22, 23, 40, 47, 48, 50, 52, 54, 56, 58, 59, 60, 62, 64, 66, 67, 69, 74, 75, 84, 88, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120],
          ut = [20, 21, 23],
          lt = [20, 21, 23, 47, 59, 60, 74, 75, 84, 88, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120],
          ht = [1, 12, 20, 21, 22, 23, 24, 38, 42, 47, 59, 60, 79, 80, 81, 82, 83, 84, 88, 98, 99, 102, 104, 105, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
          ft = [47, 59, 60, 84, 88, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120],
          dt = [1, 143],
          pt = [1, 151],
          yt = [1, 152],
          gt = [1, 153],
          mt = [1, 154],
          vt = [1, 138],
          bt = [1, 139],
          _t = [1, 135],
          xt = [1, 146],
          wt = [1, 147],
          kt = [1, 148],
          Tt = [1, 149],
          Et = [1, 150],
          Ct = [1, 155],
          St = [1, 156],
          At = [1, 141],
          Mt = [1, 144],
          Nt = [1, 140],
          Dt = [1, 137],
          Ot = [20, 21, 22, 23, 38, 42, 47, 59, 60, 79, 80, 81, 82, 83, 84, 88, 98, 99, 102, 104, 105, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
          Bt = [1, 159],
          Lt = [20, 21, 22, 23, 26, 47, 59, 60, 84, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120],
          It = [20, 21, 22, 23, 24, 26, 38, 40, 41, 42, 47, 51, 53, 55, 57, 59, 60, 61, 63, 65, 66, 68, 70, 74, 75, 79, 80, 81, 82, 83, 84, 85, 88, 98, 99, 102, 104, 105, 106, 107, 115, 116, 117, 118, 119, 120],
          Rt = [12, 21, 22, 24],
          Ft = [22, 99],
          Pt = [1, 242],
          jt = [1, 237],
          Yt = [1, 238],
          zt = [1, 246],
          Ut = [1, 243],
          qt = [1, 240],
          Ht = [1, 239],
          $t = [1, 241],
          Wt = [1, 244],
          Vt = [1, 245],
          Gt = [1, 247],
          Xt = [1, 265],
          Zt = [20, 21, 23, 99],
          Qt = [20, 21, 22, 23, 59, 60, 79, 95, 98, 99, 102, 103, 104, 105, 106],
          Kt = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          mermaidDoc: 4,
          directive: 5,
          openDirective: 6,
          typeDirective: 7,
          closeDirective: 8,
          separator: 9,
          ":": 10,
          argDirective: 11,
          open_directive: 12,
          type_directive: 13,
          arg_directive: 14,
          close_directive: 15,
          graphConfig: 16,
          document: 17,
          line: 18,
          statement: 19,
          SEMI: 20,
          NEWLINE: 21,
          SPACE: 22,
          EOF: 23,
          GRAPH: 24,
          NODIR: 25,
          DIR: 26,
          FirstStmtSeperator: 27,
          ending: 28,
          endToken: 29,
          spaceList: 30,
          spaceListNewline: 31,
          verticeStatement: 32,
          styleStatement: 33,
          linkStyleStatement: 34,
          classDefStatement: 35,
          classStatement: 36,
          clickStatement: 37,
          subgraph: 38,
          text: 39,
          SQS: 40,
          SQE: 41,
          end: 42,
          direction: 43,
          link: 44,
          node: 45,
          vertex: 46,
          AMP: 47,
          STYLE_SEPARATOR: 48,
          idString: 49,
          PS: 50,
          PE: 51,
          "(-": 52,
          "-)": 53,
          STADIUMSTART: 54,
          STADIUMEND: 55,
          SUBROUTINESTART: 56,
          SUBROUTINEEND: 57,
          VERTEX_WITH_PROPS_START: 58,
          ALPHA: 59,
          COLON: 60,
          PIPE: 61,
          CYLINDERSTART: 62,
          CYLINDEREND: 63,
          DIAMOND_START: 64,
          DIAMOND_STOP: 65,
          TAGEND: 66,
          TRAPSTART: 67,
          TRAPEND: 68,
          INVTRAPSTART: 69,
          INVTRAPEND: 70,
          linkStatement: 71,
          arrowText: 72,
          TESTSTR: 73,
          START_LINK: 74,
          LINK: 75,
          textToken: 76,
          STR: 77,
          keywords: 78,
          STYLE: 79,
          LINKSTYLE: 80,
          CLASSDEF: 81,
          CLASS: 82,
          CLICK: 83,
          DOWN: 84,
          UP: 85,
          textNoTags: 86,
          textNoTagsToken: 87,
          DEFAULT: 88,
          stylesOpt: 89,
          alphaNum: 90,
          CALLBACKNAME: 91,
          CALLBACKARGS: 92,
          HREF: 93,
          LINK_TARGET: 94,
          HEX: 95,
          numList: 96,
          INTERPOLATE: 97,
          NUM: 98,
          COMMA: 99,
          style: 100,
          styleComponent: 101,
          MINUS: 102,
          UNIT: 103,
          BRKT: 104,
          DOT: 105,
          PCT: 106,
          TAGSTART: 107,
          alphaNumToken: 108,
          idStringToken: 109,
          alphaNumStatement: 110,
          direction_tb: 111,
          direction_bt: 112,
          direction_rl: 113,
          direction_lr: 114,
          PUNCTUATION: 115,
          UNICODE_TEXT: 116,
          PLUS: 117,
          EQUALS: 118,
          MULT: 119,
          UNDERSCORE: 120,
          graphCodeTokens: 121,
          ARROW_CROSS: 122,
          ARROW_POINT: 123,
          ARROW_CIRCLE: 124,
          ARROW_OPEN: 125,
          QUOTE: 126,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          10: ":",
          12: "open_directive",
          13: "type_directive",
          14: "arg_directive",
          15: "close_directive",
          20: "SEMI",
          21: "NEWLINE",
          22: "SPACE",
          23: "EOF",
          24: "GRAPH",
          25: "NODIR",
          26: "DIR",
          38: "subgraph",
          40: "SQS",
          41: "SQE",
          42: "end",
          47: "AMP",
          48: "STYLE_SEPARATOR",
          50: "PS",
          51: "PE",
          52: "(-",
          53: "-)",
          54: "STADIUMSTART",
          55: "STADIUMEND",
          56: "SUBROUTINESTART",
          57: "SUBROUTINEEND",
          58: "VERTEX_WITH_PROPS_START",
          59: "ALPHA",
          60: "COLON",
          61: "PIPE",
          62: "CYLINDERSTART",
          63: "CYLINDEREND",
          64: "DIAMOND_START",
          65: "DIAMOND_STOP",
          66: "TAGEND",
          67: "TRAPSTART",
          68: "TRAPEND",
          69: "INVTRAPSTART",
          70: "INVTRAPEND",
          73: "TESTSTR",
          74: "START_LINK",
          75: "LINK",
          77: "STR",
          79: "STYLE",
          80: "LINKSTYLE",
          81: "CLASSDEF",
          82: "CLASS",
          83: "CLICK",
          84: "DOWN",
          85: "UP",
          88: "DEFAULT",
          91: "CALLBACKNAME",
          92: "CALLBACKARGS",
          93: "HREF",
          94: "LINK_TARGET",
          95: "HEX",
          97: "INTERPOLATE",
          98: "NUM",
          99: "COMMA",
          102: "MINUS",
          103: "UNIT",
          104: "BRKT",
          105: "DOT",
          106: "PCT",
          107: "TAGSTART",
          111: "direction_tb",
          112: "direction_bt",
          113: "direction_rl",
          114: "direction_lr",
          115: "PUNCTUATION",
          116: "UNICODE_TEXT",
          117: "PLUS",
          118: "EQUALS",
          119: "MULT",
          120: "UNDERSCORE",
          122: "ARROW_CROSS",
          123: "ARROW_POINT",
          124: "ARROW_CIRCLE",
          125: "ARROW_OPEN",
          126: "QUOTE"
        },
        productions_: [0, [3, 1], [3, 2], [5, 4], [5, 6], [6, 1], [7, 1], [11, 1], [8, 1], [4, 2], [17, 0], [17, 2], [18, 1], [18, 1], [18, 1], [18, 1], [18, 1], [16, 2], [16, 2], [16, 2], [16, 3], [28, 2], [28, 1], [29, 1], [29, 1], [29, 1], [27, 1], [27, 1], [27, 2], [31, 2], [31, 2], [31, 1], [31, 1], [30, 2], [30, 1], [19, 2], [19, 2], [19, 2], [19, 2], [19, 2], [19, 2], [19, 9], [19, 6], [19, 4], [19, 1], [9, 1], [9, 1], [9, 1], [32, 3], [32, 4], [32, 2], [32, 1], [45, 1], [45, 5], [45, 3], [46, 4], [46, 6], [46, 4], [46, 4], [46, 4], [46, 8], [46, 4], [46, 4], [46, 4], [46, 6], [46, 4], [46, 4], [46, 4], [46, 4], [46, 4], [46, 1], [44, 2], [44, 3], [44, 3], [44, 1], [44, 3], [71, 1], [72, 3], [39, 1], [39, 2], [39, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [78, 1], [86, 1], [86, 2], [35, 5], [35, 5], [36, 5], [37, 2], [37, 4], [37, 3], [37, 5], [37, 2], [37, 4], [37, 4], [37, 6], [37, 2], [37, 4], [37, 2], [37, 4], [37, 4], [37, 6], [33, 5], [33, 5], [34, 5], [34, 5], [34, 9], [34, 9], [34, 7], [34, 7], [96, 1], [96, 3], [89, 1], [89, 3], [100, 1], [100, 2], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [101, 1], [76, 1], [76, 1], [76, 1], [76, 1], [76, 1], [76, 1], [87, 1], [87, 1], [87, 1], [87, 1], [49, 1], [49, 2], [90, 1], [90, 2], [110, 1], [110, 1], [110, 1], [110, 1], [43, 1], [43, 1], [43, 1], [43, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [109, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1], [121, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 5:
              r.parseDirective("%%{", "open_directive");
              break;

            case 6:
              r.parseDirective(a[s], "type_directive");
              break;

            case 7:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 8:
              r.parseDirective("}%%", "close_directive", "flowchart");
              break;

            case 10:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
              this.$ = [];
              break;

            case 11:
              a[s] !== [] && a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 12:
            case 78:
            case 80:
            case 92:
            case 148:
            case 150:
            case 151:
            case 74:
            case 146:
              this.$ = a[s];
              break;

            case 19:
              r.setDirection("TB"), this.$ = "TB";
              break;

            case 20:
              r.setDirection(a[s - 1]), this.$ = a[s - 1];
              break;

            case 35:
              this.$ = a[s - 1].nodes;
              break;

            case 41:
              this.$ = r.addSubGraph(a[s - 6], a[s - 1], a[s - 4]);
              break;

            case 42:
              this.$ = r.addSubGraph(a[s - 3], a[s - 1], a[s - 3]);
              break;

            case 43:
              this.$ = r.addSubGraph(void 0, a[s - 1], void 0);
              break;

            case 48:
              r.addLink(a[s - 2].stmt, a[s], a[s - 1]), this.$ = {
                stmt: a[s],
                nodes: a[s].concat(a[s - 2].nodes)
              };
              break;

            case 49:
              r.addLink(a[s - 3].stmt, a[s - 1], a[s - 2]), this.$ = {
                stmt: a[s - 1],
                nodes: a[s - 1].concat(a[s - 3].nodes)
              };
              break;

            case 50:
              this.$ = {
                stmt: a[s - 1],
                nodes: a[s - 1]
              };
              break;

            case 51:
              this.$ = {
                stmt: a[s],
                nodes: a[s]
              };
              break;

            case 52:
            case 119:
            case 121:
              this.$ = [a[s]];
              break;

            case 53:
              this.$ = a[s - 4].concat(a[s]);
              break;

            case 54:
              this.$ = [a[s - 2]], r.setClass(a[s - 2], a[s]);
              break;

            case 55:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "square");
              break;

            case 56:
              this.$ = a[s - 5], r.addVertex(a[s - 5], a[s - 2], "circle");
              break;

            case 57:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "ellipse");
              break;

            case 58:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "stadium");
              break;

            case 59:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "subroutine");
              break;

            case 60:
              this.$ = a[s - 7], r.addVertex(a[s - 7], a[s - 1], "rect", void 0, void 0, void 0, Object.fromEntries([[a[s - 5], a[s - 3]]]));
              break;

            case 61:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "cylinder");
              break;

            case 62:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "round");
              break;

            case 63:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "diamond");
              break;

            case 64:
              this.$ = a[s - 5], r.addVertex(a[s - 5], a[s - 2], "hexagon");
              break;

            case 65:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "odd");
              break;

            case 66:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "trapezoid");
              break;

            case 67:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "inv_trapezoid");
              break;

            case 68:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "lean_right");
              break;

            case 69:
              this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "lean_left");
              break;

            case 70:
              this.$ = a[s], r.addVertex(a[s]);
              break;

            case 71:
              a[s - 1].text = a[s], this.$ = a[s - 1];
              break;

            case 72:
            case 73:
              a[s - 2].text = a[s - 1], this.$ = a[s - 2];
              break;

            case 75:
              var c = r.destructLink(a[s], a[s - 2]);
              this.$ = {
                type: c.type,
                stroke: c.stroke,
                length: c.length,
                text: a[s - 1]
              };
              break;

            case 76:
              c = r.destructLink(a[s]), this.$ = {
                type: c.type,
                stroke: c.stroke,
                length: c.length
              };
              break;

            case 77:
              this.$ = a[s - 1];
              break;

            case 79:
            case 93:
            case 149:
            case 147:
              this.$ = a[s - 1] + "" + a[s];
              break;

            case 94:
            case 95:
              this.$ = a[s - 4], r.addClass(a[s - 2], a[s]);
              break;

            case 96:
              this.$ = a[s - 4], r.setClass(a[s - 2], a[s]);
              break;

            case 97:
            case 105:
              this.$ = a[s - 1], r.setClickEvent(a[s - 1], a[s]);
              break;

            case 98:
            case 106:
              this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 2]), r.setTooltip(a[s - 3], a[s]);
              break;

            case 99:
              this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
              break;

            case 100:
              this.$ = a[s - 4], r.setClickEvent(a[s - 4], a[s - 3], a[s - 2]), r.setTooltip(a[s - 4], a[s]);
              break;

            case 101:
            case 107:
              this.$ = a[s - 1], r.setLink(a[s - 1], a[s]);
              break;

            case 102:
            case 108:
              this.$ = a[s - 3], r.setLink(a[s - 3], a[s - 2]), r.setTooltip(a[s - 3], a[s]);
              break;

            case 103:
            case 109:
              this.$ = a[s - 3], r.setLink(a[s - 3], a[s - 2], a[s]);
              break;

            case 104:
            case 110:
              this.$ = a[s - 5], r.setLink(a[s - 5], a[s - 4], a[s]), r.setTooltip(a[s - 5], a[s - 2]);
              break;

            case 111:
              this.$ = a[s - 4], r.addVertex(a[s - 2], void 0, void 0, a[s]);
              break;

            case 112:
            case 114:
              this.$ = a[s - 4], r.updateLink(a[s - 2], a[s]);
              break;

            case 113:
              this.$ = a[s - 4], r.updateLink([a[s - 2]], a[s]);
              break;

            case 115:
              this.$ = a[s - 8], r.updateLinkInterpolate([a[s - 6]], a[s - 2]), r.updateLink([a[s - 6]], a[s]);
              break;

            case 116:
              this.$ = a[s - 8], r.updateLinkInterpolate(a[s - 6], a[s - 2]), r.updateLink(a[s - 6], a[s]);
              break;

            case 117:
              this.$ = a[s - 6], r.updateLinkInterpolate([a[s - 4]], a[s]);
              break;

            case 118:
              this.$ = a[s - 6], r.updateLinkInterpolate(a[s - 4], a[s]);
              break;

            case 120:
            case 122:
              a[s - 2].push(a[s]), this.$ = a[s - 2];
              break;

            case 124:
              this.$ = a[s - 1] + a[s];
              break;

            case 152:
              this.$ = "v";
              break;

            case 153:
              this.$ = "-";
              break;

            case 154:
              this.$ = {
                stmt: "dir",
                value: "TB"
              };
              break;

            case 155:
              this.$ = {
                stmt: "dir",
                value: "BT"
              };
              break;

            case 156:
              this.$ = {
                stmt: "dir",
                value: "RL"
              };
              break;

            case 157:
              this.$ = {
                stmt: "dir",
                value: "LR"
              };
          }
        },
        table: [{
          3: 1,
          4: 2,
          5: 3,
          6: 5,
          12: e,
          16: 4,
          21: n,
          22: r,
          24: i
        }, {
          1: [3]
        }, {
          1: [2, 1]
        }, {
          3: 10,
          4: 2,
          5: 3,
          6: 5,
          12: e,
          16: 4,
          21: n,
          22: r,
          24: i
        }, t(a, o, {
          17: 11
        }), {
          7: 12,
          13: [1, 13]
        }, {
          16: 14,
          21: n,
          22: r,
          24: i
        }, {
          16: 15,
          21: n,
          22: r,
          24: i
        }, {
          25: [1, 16],
          26: [1, 17]
        }, {
          13: [2, 5]
        }, {
          1: [2, 2]
        }, {
          1: [2, 9],
          18: 18,
          19: 19,
          20: s,
          21: c,
          22: u,
          23: l,
          32: 24,
          33: 25,
          34: 26,
          35: 27,
          36: 28,
          37: 29,
          38: h,
          43: 31,
          45: 32,
          46: 42,
          47: f,
          49: 43,
          59: d,
          60: p,
          79: y,
          80: g,
          81: m,
          82: v,
          83: b,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          111: S,
          112: A,
          113: M,
          114: N,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, {
          8: 61,
          10: [1, 62],
          15: F
        }, t([10, 15], [2, 6]), t(a, [2, 17]), t(a, [2, 18]), t(a, [2, 19]), {
          20: [1, 65],
          21: [1, 66],
          22: P,
          27: 64,
          30: 67
        }, t(j, [2, 11]), t(j, [2, 12]), t(j, [2, 13]), t(j, [2, 14]), t(j, [2, 15]), t(j, [2, 16]), {
          9: 69,
          20: Y,
          21: z,
          23: U,
          44: 70,
          71: 74,
          74: [1, 75],
          75: [1, 76]
        }, {
          9: 77,
          20: Y,
          21: z,
          23: U
        }, {
          9: 78,
          20: Y,
          21: z,
          23: U
        }, {
          9: 79,
          20: Y,
          21: z,
          23: U
        }, {
          9: 80,
          20: Y,
          21: z,
          23: U
        }, {
          9: 81,
          20: Y,
          21: z,
          23: U
        }, {
          9: 83,
          20: Y,
          21: z,
          22: [1, 82],
          23: U
        }, t(j, [2, 44]), t(q, [2, 51], {
          30: 84,
          22: P
        }), {
          22: [1, 85]
        }, {
          22: [1, 86]
        }, {
          22: [1, 87]
        }, {
          22: [1, 88]
        }, {
          26: H,
          47: $,
          59: W,
          60: V,
          77: [1, 92],
          84: G,
          90: 91,
          91: [1, 89],
          93: [1, 90],
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(j, [2, 154]), t(j, [2, 155]), t(j, [2, 156]), t(j, [2, 157]), t(ot, [2, 52], {
          48: [1, 111]
        }), t(st, [2, 70], {
          109: 123,
          40: [1, 112],
          47: f,
          50: [1, 113],
          52: [1, 114],
          54: [1, 115],
          56: [1, 116],
          58: [1, 117],
          59: d,
          60: p,
          62: [1, 118],
          64: [1, 119],
          66: [1, 120],
          67: [1, 121],
          69: [1, 122],
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }), t(ct, [2, 146]), t(ct, [2, 171]), t(ct, [2, 172]), t(ct, [2, 173]), t(ct, [2, 174]), t(ct, [2, 175]), t(ct, [2, 176]), t(ct, [2, 177]), t(ct, [2, 178]), t(ct, [2, 179]), t(ct, [2, 180]), t(ct, [2, 181]), t(ct, [2, 182]), t(ct, [2, 183]), t(ct, [2, 184]), t(ct, [2, 185]), t(ct, [2, 186]), {
          9: 124,
          20: Y,
          21: z,
          23: U
        }, {
          11: 125,
          14: [1, 126]
        }, t(ut, [2, 8]), t(a, [2, 20]), t(a, [2, 26]), t(a, [2, 27]), {
          21: [1, 127]
        }, t(lt, [2, 34], {
          30: 128,
          22: P
        }), t(j, [2, 35]), {
          45: 129,
          46: 42,
          47: f,
          49: 43,
          59: d,
          60: p,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, t(ht, [2, 45]), t(ht, [2, 46]), t(ht, [2, 47]), t(ft, [2, 74], {
          72: 130,
          61: [1, 132],
          73: [1, 131]
        }), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 133,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t([47, 59, 60, 61, 73, 84, 88, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120], [2, 76]), t(j, [2, 36]), t(j, [2, 37]), t(j, [2, 38]), t(j, [2, 39]), t(j, [2, 40]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 157,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(Ot, o, {
          17: 158
        }), t(q, [2, 50], {
          47: Bt
        }), {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          90: 160,
          95: [1, 161],
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          88: [1, 162],
          96: 163,
          98: [1, 164]
        }, {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          88: [1, 165],
          90: 166,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          90: 167,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(ut, [2, 97], {
          22: [1, 168],
          92: [1, 169]
        }), t(ut, [2, 101], {
          22: [1, 170]
        }), t(ut, [2, 105], {
          108: 95,
          110: 172,
          22: [1, 171],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }), t(ut, [2, 107], {
          22: [1, 173]
        }), t(Lt, [2, 148]), t(Lt, [2, 150]), t(Lt, [2, 151]), t(Lt, [2, 152]), t(Lt, [2, 153]), t(It, [2, 158]), t(It, [2, 159]), t(It, [2, 160]), t(It, [2, 161]), t(It, [2, 162]), t(It, [2, 163]), t(It, [2, 164]), t(It, [2, 165]), t(It, [2, 166]), t(It, [2, 167]), t(It, [2, 168]), t(It, [2, 169]), t(It, [2, 170]), {
          47: f,
          49: 174,
          59: d,
          60: p,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 175,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 177,
          42: mt,
          47: $,
          50: [1, 176],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 178,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 179,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 180,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          59: [1, 181]
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 182,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 183,
          42: mt,
          47: $,
          59: W,
          60: V,
          64: [1, 184],
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 185,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 186,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 187,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(ct, [2, 147]), t(Rt, [2, 3]), {
          8: 188,
          15: F
        }, {
          15: [2, 7]
        }, t(a, [2, 28]), t(lt, [2, 33]), t(q, [2, 48], {
          30: 189,
          22: P
        }), t(ft, [2, 71], {
          22: [1, 190]
        }), {
          22: [1, 191]
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 192,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          75: [1, 193],
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(It, [2, 78]), t(It, [2, 80]), t(It, [2, 136]), t(It, [2, 137]), t(It, [2, 138]), t(It, [2, 139]), t(It, [2, 140]), t(It, [2, 141]), t(It, [2, 142]), t(It, [2, 143]), t(It, [2, 144]), t(It, [2, 145]), t(It, [2, 81]), t(It, [2, 82]), t(It, [2, 83]), t(It, [2, 84]), t(It, [2, 85]), t(It, [2, 86]), t(It, [2, 87]), t(It, [2, 88]), t(It, [2, 89]), t(It, [2, 90]), t(It, [2, 91]), {
          9: 196,
          20: Y,
          21: z,
          22: dt,
          23: U,
          24: pt,
          26: yt,
          38: gt,
          40: [1, 195],
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          18: 18,
          19: 19,
          20: s,
          21: c,
          22: u,
          23: l,
          32: 24,
          33: 25,
          34: 26,
          35: 27,
          36: 28,
          37: 29,
          38: h,
          42: [1, 197],
          43: 31,
          45: 32,
          46: 42,
          47: f,
          49: 43,
          59: d,
          60: p,
          79: y,
          80: g,
          81: m,
          82: v,
          83: b,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          111: S,
          112: A,
          113: M,
          114: N,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, {
          22: P,
          30: 198
        }, {
          22: [1, 199],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 172,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: [1, 200]
        }, {
          22: [1, 201]
        }, {
          22: [1, 202],
          99: [1, 203]
        }, t(Ft, [2, 119]), {
          22: [1, 204]
        }, {
          22: [1, 205],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 172,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: [1, 206],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 172,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          77: [1, 207]
        }, t(ut, [2, 99], {
          22: [1, 208]
        }), {
          77: [1, 209],
          94: [1, 210]
        }, {
          77: [1, 211]
        }, t(Lt, [2, 149]), {
          77: [1, 212],
          94: [1, 213]
        }, t(ot, [2, 54], {
          109: 123,
          47: f,
          59: d,
          60: p,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          41: [1, 214],
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 215,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          51: [1, 216],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          53: [1, 217],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          55: [1, 218],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          57: [1, 219],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          60: [1, 220]
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          63: [1, 221],
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          65: [1, 222],
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 223,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          41: [1, 224],
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          68: [1, 225],
          70: [1, 226],
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          68: [1, 228],
          70: [1, 227],
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          9: 229,
          20: Y,
          21: z,
          23: U
        }, t(q, [2, 49], {
          47: Bt
        }), t(ft, [2, 73]), t(ft, [2, 72]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          61: [1, 230],
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(ft, [2, 75]), t(It, [2, 79]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 231,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(Ot, o, {
          17: 232
        }), t(j, [2, 43]), {
          46: 233,
          47: f,
          49: 43,
          59: d,
          60: p,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 234,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 248,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 249,
          95: Ut,
          97: [1, 250],
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 251,
          95: Ut,
          97: [1, 252],
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          98: [1, 253]
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 254,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 255,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          90: 256,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(ut, [2, 98]), {
          77: [1, 257]
        }, t(ut, [2, 102], {
          22: [1, 258]
        }), t(ut, [2, 103]), t(ut, [2, 106]), t(ut, [2, 108], {
          22: [1, 259]
        }), t(ut, [2, 109]), t(st, [2, 55]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          51: [1, 260],
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(st, [2, 62]), t(st, [2, 57]), t(st, [2, 58]), t(st, [2, 59]), {
          59: [1, 261]
        }, t(st, [2, 61]), t(st, [2, 63]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          42: mt,
          47: $,
          59: W,
          60: V,
          65: [1, 262],
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(st, [2, 65]), t(st, [2, 66]), t(st, [2, 68]), t(st, [2, 67]), t(st, [2, 69]), t(Rt, [2, 4]), t([22, 47, 59, 60, 84, 88, 98, 99, 102, 104, 105, 115, 116, 117, 118, 119, 120], [2, 77]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          41: [1, 263],
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          18: 18,
          19: 19,
          20: s,
          21: c,
          22: u,
          23: l,
          32: 24,
          33: 25,
          34: 26,
          35: 27,
          36: 28,
          37: 29,
          38: h,
          42: [1, 264],
          43: 31,
          45: 32,
          46: 42,
          47: f,
          49: 43,
          59: d,
          60: p,
          79: y,
          80: g,
          81: m,
          82: v,
          83: b,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          111: S,
          112: A,
          113: M,
          114: N,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, t(ot, [2, 53]), t(ut, [2, 111], {
          99: Xt
        }), t(Zt, [2, 121], {
          101: 266,
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          95: Ut,
          98: qt,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }), t(Qt, [2, 123]), t(Qt, [2, 125]), t(Qt, [2, 126]), t(Qt, [2, 127]), t(Qt, [2, 128]), t(Qt, [2, 129]), t(Qt, [2, 130]), t(Qt, [2, 131]), t(Qt, [2, 132]), t(Qt, [2, 133]), t(Qt, [2, 134]), t(Qt, [2, 135]), t(ut, [2, 112], {
          99: Xt
        }), t(ut, [2, 113], {
          99: Xt
        }), {
          22: [1, 267]
        }, t(ut, [2, 114], {
          99: Xt
        }), {
          22: [1, 268]
        }, t(Ft, [2, 120]), t(ut, [2, 94], {
          99: Xt
        }), t(ut, [2, 95], {
          99: Xt
        }), t(ut, [2, 96], {
          108: 95,
          110: 172,
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }), t(ut, [2, 100]), {
          94: [1, 269]
        }, {
          94: [1, 270]
        }, {
          51: [1, 271]
        }, {
          61: [1, 272]
        }, {
          65: [1, 273]
        }, {
          9: 274,
          20: Y,
          21: z,
          23: U
        }, t(j, [2, 42]), {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          95: Ut,
          98: qt,
          100: 275,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, t(Qt, [2, 124]), {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          90: 276,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          90: 277,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          108: 95,
          110: 93,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(ut, [2, 104]), t(ut, [2, 110]), t(st, [2, 56]), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          39: 278,
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 134,
          77: _t,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, t(st, [2, 64]), t(Ot, o, {
          17: 279
        }), t(Zt, [2, 122], {
          101: 266,
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          95: Ut,
          98: qt,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }), t(ut, [2, 117], {
          108: 95,
          110: 172,
          22: [1, 280],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }), t(ut, [2, 118], {
          108: 95,
          110: 172,
          22: [1, 281],
          26: H,
          47: $,
          59: W,
          60: V,
          84: G,
          98: X,
          99: Z,
          102: Q,
          104: K,
          105: J,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }), {
          22: dt,
          24: pt,
          26: yt,
          38: gt,
          41: [1, 282],
          42: mt,
          47: $,
          59: W,
          60: V,
          66: vt,
          74: bt,
          76: 194,
          78: 145,
          79: xt,
          80: wt,
          81: kt,
          82: Tt,
          83: Et,
          84: Ct,
          85: St,
          87: 136,
          88: At,
          98: X,
          99: Z,
          102: Mt,
          104: K,
          105: J,
          106: Nt,
          107: Dt,
          108: 142,
          115: tt,
          116: et,
          117: nt,
          118: rt,
          119: it,
          120: at
        }, {
          18: 18,
          19: 19,
          20: s,
          21: c,
          22: u,
          23: l,
          32: 24,
          33: 25,
          34: 26,
          35: 27,
          36: 28,
          37: 29,
          38: h,
          42: [1, 283],
          43: 31,
          45: 32,
          46: 42,
          47: f,
          49: 43,
          59: d,
          60: p,
          79: y,
          80: g,
          81: m,
          82: v,
          83: b,
          84: _,
          88: x,
          98: w,
          99: k,
          102: T,
          104: E,
          105: C,
          109: 44,
          111: S,
          112: A,
          113: M,
          114: N,
          115: D,
          116: O,
          117: B,
          118: L,
          119: I,
          120: R
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 284,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, {
          22: Pt,
          59: jt,
          60: Yt,
          79: zt,
          89: 285,
          95: Ut,
          98: qt,
          100: 235,
          101: 236,
          102: Ht,
          103: $t,
          104: Wt,
          105: Vt,
          106: Gt
        }, t(st, [2, 60]), t(j, [2, 41]), t(ut, [2, 115], {
          99: Xt
        }), t(ut, [2, 116], {
          99: Xt
        })],
        defaultActions: {
          2: [2, 1],
          9: [2, 5],
          10: [2, 2],
          126: [2, 7]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          Jt = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {},
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 12;

            case 1:
              return this.begin("type_directive"), 13;

            case 2:
              return this.popState(), this.begin("arg_directive"), 10;

            case 3:
              return this.popState(), this.popState(), 15;

            case 4:
              return 14;

            case 5:
            case 6:
              break;

            case 7:
              this.begin("string");
              break;

            case 8:
            case 17:
            case 20:
            case 23:
            case 26:
              this.popState();
              break;

            case 9:
              return "STR";

            case 10:
              return 79;

            case 11:
              return 88;

            case 12:
              return 80;

            case 13:
              return 97;

            case 14:
              return 81;

            case 15:
              return 82;

            case 16:
              this.begin("href");
              break;

            case 18:
              return 93;

            case 19:
              this.begin("callbackname");
              break;

            case 21:
              this.popState(), this.begin("callbackargs");
              break;

            case 22:
              return 91;

            case 24:
              return 92;

            case 25:
              this.begin("click");
              break;

            case 27:
              return 83;

            case 28:
            case 29:
              return t.lex.firstGraph() && this.begin("dir"), 24;

            case 30:
              return 38;

            case 31:
              return 42;

            case 32:
            case 33:
            case 34:
            case 35:
              return 94;

            case 36:
              return this.popState(), 25;

            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
              return this.popState(), 26;

            case 47:
              return 111;

            case 48:
              return 112;

            case 49:
              return 113;

            case 50:
              return 114;

            case 51:
              return 98;

            case 52:
              return 104;

            case 53:
              return 48;

            case 54:
              return 60;

            case 55:
              return 47;

            case 56:
              return 20;

            case 57:
              return 99;

            case 58:
              return 119;

            case 59:
            case 60:
            case 61:
              return 75;

            case 62:
            case 63:
            case 64:
              return 74;

            case 65:
              return 52;

            case 66:
              return 53;

            case 67:
              return 54;

            case 68:
              return 55;

            case 69:
              return 56;

            case 70:
              return 57;

            case 71:
              return 58;

            case 72:
              return 62;

            case 73:
              return 63;

            case 74:
              return 102;

            case 75:
              return 105;

            case 76:
              return 120;

            case 77:
              return 117;

            case 78:
              return 106;

            case 79:
            case 80:
              return 118;

            case 81:
              return 107;

            case 82:
              return 66;

            case 83:
              return 85;

            case 84:
              return "SEP";

            case 85:
              return 84;

            case 86:
              return 59;

            case 87:
              return 68;

            case 88:
              return 67;

            case 89:
              return 70;

            case 90:
              return 69;

            case 91:
              return 115;

            case 92:
              return 116;

            case 93:
              return 61;

            case 94:
              return 50;

            case 95:
              return 51;

            case 96:
              return 40;

            case 97:
              return 41;

            case 98:
              return 64;

            case 99:
              return 65;

            case 100:
              return 126;

            case 101:
              return 21;

            case 102:
              return 22;

            case 103:
              return 23;
          }
        },
        rules: [/^(?:%%\{)/, /^(?:((?:(?!\}%%)[^:.])*))/, /^(?::)/, /^(?:\}%%)/, /^(?:((?:(?!\}%%).|\n)*))/, /^(?:%%(?!\{)[^\n]*)/, /^(?:[^\}]%%[^\n]*)/, /^(?:["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:style\b)/, /^(?:default\b)/, /^(?:linkStyle\b)/, /^(?:interpolate\b)/, /^(?:classDef\b)/, /^(?:class\b)/, /^(?:href[\s]+["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:call[\s]+)/, /^(?:\([\s]*\))/, /^(?:\()/, /^(?:[^(]*)/, /^(?:\))/, /^(?:[^)]*)/, /^(?:click[\s]+)/, /^(?:[\s\n])/, /^(?:[^\s\n]*)/, /^(?:graph\b)/, /^(?:flowchart\b)/, /^(?:subgraph\b)/, /^(?:end\b\s*)/, /^(?:_self\b)/, /^(?:_blank\b)/, /^(?:_parent\b)/, /^(?:_top\b)/, /^(?:(\r?\n)*\s*\n)/, /^(?:\s*LR\b)/, /^(?:\s*RL\b)/, /^(?:\s*TB\b)/, /^(?:\s*BT\b)/, /^(?:\s*TD\b)/, /^(?:\s*BR\b)/, /^(?:\s*<)/, /^(?:\s*>)/, /^(?:\s*\^)/, /^(?:\s*v\b)/, /^(?:.*direction\s+TB[^\n]*)/, /^(?:.*direction\s+BT[^\n]*)/, /^(?:.*direction\s+RL[^\n]*)/, /^(?:.*direction\s+LR[^\n]*)/, /^(?:[0-9]+)/, /^(?:#)/, /^(?::::)/, /^(?::)/, /^(?:&)/, /^(?:;)/, /^(?:,)/, /^(?:\*)/, /^(?:\s*[xo<]?--+[-xo>]\s*)/, /^(?:\s*[xo<]?==+[=xo>]\s*)/, /^(?:\s*[xo<]?-?\.+-[xo>]?\s*)/, /^(?:\s*[xo<]?--\s*)/, /^(?:\s*[xo<]?==\s*)/, /^(?:\s*[xo<]?-\.\s*)/, /^(?:\(-)/, /^(?:-\))/, /^(?:\(\[)/, /^(?:\]\))/, /^(?:\[\[)/, /^(?:\]\])/, /^(?:\[\|)/, /^(?:\[\()/, /^(?:\)\])/, /^(?:-)/, /^(?:\.)/, /^(?:[\_])/, /^(?:\+)/, /^(?:%)/, /^(?:=)/, /^(?:=)/, /^(?:<)/, /^(?:>)/, /^(?:\^)/, /^(?:\\\|)/, /^(?:v\b)/, /^(?:[A-Za-z]+)/, /^(?:\\\])/, /^(?:\[\/)/, /^(?:\/\])/, /^(?:\[\\)/, /^(?:[!"#$%&'*+,-.`?\\_/])/, /^(?:[\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6]|[\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377]|[\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5]|[\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA]|[\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE]|[\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA]|[\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0]|[\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977]|[\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2]|[\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A]|[\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39]|[\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8]|[\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C]|[\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C]|[\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99]|[\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0]|[\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D]|[\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3]|[\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10]|[\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1]|[\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81]|[\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3]|[\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6]|[\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A]|[\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081]|[\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D]|[\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0]|[\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310]|[\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C]|[\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711]|[\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7]|[\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C]|[\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16]|[\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF]|[\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC]|[\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D]|[\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D]|[\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3]|[\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F]|[\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128]|[\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184]|[\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3]|[\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6]|[\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE]|[\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C]|[\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D]|[\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC]|[\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B]|[\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788]|[\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805]|[\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB]|[\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28]|[\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5]|[\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4]|[\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|[\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D]|[\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36]|[\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D]|[\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC]|[\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF]|[\uFFD2-\uFFD7\uFFDA-\uFFDC])/, /^(?:\|)/, /^(?:\()/, /^(?:\))/, /^(?:\[)/, /^(?:\])/, /^(?:\{)/, /^(?:\})/, /^(?:")/, /^(?:(\r?\n)+)/, /^(?:\s)/, /^(?:$)/],
        conditions: {
          close_directive: {
            rules: [],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          callbackargs: {
            rules: [23, 24],
            inclusive: !1
          },
          callbackname: {
            rules: [20, 21, 22],
            inclusive: !1
          },
          href: {
            rules: [17, 18],
            inclusive: !1
          },
          click: {
            rules: [26, 27],
            inclusive: !1
          },
          vertex: {
            rules: [],
            inclusive: !1
          },
          dir: {
            rules: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
            inclusive: !1
          },
          string: {
            rules: [8, 9],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 10, 11, 12, 13, 14, 15, 16, 19, 25, 28, 29, 30, 31, 32, 33, 34, 35, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103],
            inclusive: !0
          }
        }
      };

      function te() {
        this.yy = {};
      }

      return Kt.lexer = Jt, te.prototype = Kt, Kt.Parser = te, new te();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(5354).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  9959: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t8, e, n, r) {
        for (n = n || {}, r = _t8.length; r--; n[_t8[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 3],
          n = [1, 5],
          r = [7, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 29, 34],
          i = [1, 15],
          a = [1, 16],
          o = [1, 17],
          s = [1, 18],
          c = [1, 19],
          u = [1, 20],
          l = [1, 21],
          h = [1, 22],
          f = [1, 23],
          d = [1, 25],
          p = [1, 27],
          y = [1, 30],
          g = [5, 7, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 29, 34],
          m = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          directive: 4,
          gantt: 5,
          document: 6,
          EOF: 7,
          line: 8,
          SPACE: 9,
          statement: 10,
          NL: 11,
          dateFormat: 12,
          inclusiveEndDates: 13,
          topAxis: 14,
          axisFormat: 15,
          excludes: 16,
          includes: 17,
          todayMarker: 18,
          title: 19,
          section: 20,
          clickStatement: 21,
          taskTxt: 22,
          taskData: 23,
          openDirective: 24,
          typeDirective: 25,
          closeDirective: 26,
          ":": 27,
          argDirective: 28,
          click: 29,
          callbackname: 30,
          callbackargs: 31,
          href: 32,
          clickStatementDebug: 33,
          open_directive: 34,
          type_directive: 35,
          arg_directive: 36,
          close_directive: 37,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          5: "gantt",
          7: "EOF",
          9: "SPACE",
          11: "NL",
          12: "dateFormat",
          13: "inclusiveEndDates",
          14: "topAxis",
          15: "axisFormat",
          16: "excludes",
          17: "includes",
          18: "todayMarker",
          19: "title",
          20: "section",
          22: "taskTxt",
          23: "taskData",
          27: ":",
          29: "click",
          30: "callbackname",
          31: "callbackargs",
          32: "href",
          34: "open_directive",
          35: "type_directive",
          36: "arg_directive",
          37: "close_directive"
        },
        productions_: [0, [3, 2], [3, 3], [6, 0], [6, 2], [8, 2], [8, 1], [8, 1], [8, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 2], [10, 1], [4, 4], [4, 6], [21, 2], [21, 3], [21, 3], [21, 4], [21, 3], [21, 4], [21, 2], [33, 2], [33, 3], [33, 3], [33, 4], [33, 3], [33, 4], [33, 2], [24, 1], [25, 1], [28, 1], [26, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 2:
              return a[s - 1];

            case 3:
            case 7:
            case 8:
              this.$ = [];
              break;

            case 4:
              a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 5:
            case 6:
              this.$ = a[s];
              break;

            case 9:
              r.setDateFormat(a[s].substr(11)), this.$ = a[s].substr(11);
              break;

            case 10:
              r.enableInclusiveEndDates(), this.$ = a[s].substr(18);
              break;

            case 11:
              r.TopAxis(), this.$ = a[s].substr(8);
              break;

            case 12:
              r.setAxisFormat(a[s].substr(11)), this.$ = a[s].substr(11);
              break;

            case 13:
              r.setExcludes(a[s].substr(9)), this.$ = a[s].substr(9);
              break;

            case 14:
              r.setIncludes(a[s].substr(9)), this.$ = a[s].substr(9);
              break;

            case 15:
              r.setTodayMarker(a[s].substr(12)), this.$ = a[s].substr(12);
              break;

            case 16:
              r.setTitle(a[s].substr(6)), this.$ = a[s].substr(6);
              break;

            case 17:
              r.addSection(a[s].substr(8)), this.$ = a[s].substr(8);
              break;

            case 19:
              r.addTask(a[s - 1], a[s]), this.$ = "task";
              break;

            case 23:
              this.$ = a[s - 1], r.setClickEvent(a[s - 1], a[s], null);
              break;

            case 24:
              this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
              break;

            case 25:
              this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], null), r.setLink(a[s - 2], a[s]);
              break;

            case 26:
              this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 2], a[s - 1]), r.setLink(a[s - 3], a[s]);
              break;

            case 27:
              this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s], null), r.setLink(a[s - 2], a[s - 1]);
              break;

            case 28:
              this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 1], a[s]), r.setLink(a[s - 3], a[s - 2]);
              break;

            case 29:
              this.$ = a[s - 1], r.setLink(a[s - 1], a[s]);
              break;

            case 30:
            case 36:
              this.$ = a[s - 1] + " " + a[s];
              break;

            case 31:
            case 32:
            case 34:
              this.$ = a[s - 2] + " " + a[s - 1] + " " + a[s];
              break;

            case 33:
            case 35:
              this.$ = a[s - 3] + " " + a[s - 2] + " " + a[s - 1] + " " + a[s];
              break;

            case 37:
              r.parseDirective("%%{", "open_directive");
              break;

            case 38:
              r.parseDirective(a[s], "type_directive");
              break;

            case 39:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 40:
              r.parseDirective("}%%", "close_directive", "gantt");
          }
        },
        table: [{
          3: 1,
          4: 2,
          5: e,
          24: 4,
          34: n
        }, {
          1: [3]
        }, {
          3: 6,
          4: 2,
          5: e,
          24: 4,
          34: n
        }, t(r, [2, 3], {
          6: 7
        }), {
          25: 8,
          35: [1, 9]
        }, {
          35: [2, 37]
        }, {
          1: [2, 1]
        }, {
          4: 26,
          7: [1, 10],
          8: 11,
          9: [1, 12],
          10: 13,
          11: [1, 14],
          12: i,
          13: a,
          14: o,
          15: s,
          16: c,
          17: u,
          18: l,
          19: h,
          20: f,
          21: 24,
          22: d,
          24: 4,
          29: p,
          34: n
        }, {
          26: 28,
          27: [1, 29],
          37: y
        }, t([27, 37], [2, 38]), t(r, [2, 8], {
          1: [2, 2]
        }), t(r, [2, 4]), {
          4: 26,
          10: 31,
          12: i,
          13: a,
          14: o,
          15: s,
          16: c,
          17: u,
          18: l,
          19: h,
          20: f,
          21: 24,
          22: d,
          24: 4,
          29: p,
          34: n
        }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 9]), t(r, [2, 10]), t(r, [2, 11]), t(r, [2, 12]), t(r, [2, 13]), t(r, [2, 14]), t(r, [2, 15]), t(r, [2, 16]), t(r, [2, 17]), t(r, [2, 18]), {
          23: [1, 32]
        }, t(r, [2, 20]), {
          30: [1, 33],
          32: [1, 34]
        }, {
          11: [1, 35]
        }, {
          28: 36,
          36: [1, 37]
        }, {
          11: [2, 40]
        }, t(r, [2, 5]), t(r, [2, 19]), t(r, [2, 23], {
          31: [1, 38],
          32: [1, 39]
        }), t(r, [2, 29], {
          30: [1, 40]
        }), t(g, [2, 21]), {
          26: 41,
          37: y
        }, {
          37: [2, 39]
        }, t(r, [2, 24], {
          32: [1, 42]
        }), t(r, [2, 25]), t(r, [2, 27], {
          31: [1, 43]
        }), {
          11: [1, 44]
        }, t(r, [2, 26]), t(r, [2, 28]), t(g, [2, 22])],
        defaultActions: {
          5: [2, 37],
          6: [2, 1],
          30: [2, 40],
          37: [2, 39]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          v = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 34;

            case 1:
              return this.begin("type_directive"), 35;

            case 2:
              return this.popState(), this.begin("arg_directive"), 27;

            case 3:
              return this.popState(), this.popState(), 37;

            case 4:
              return 36;

            case 5:
            case 6:
            case 7:
            case 9:
            case 10:
            case 11:
              break;

            case 8:
              return 11;

            case 12:
              this.begin("href");
              break;

            case 13:
            case 16:
            case 19:
            case 22:
              this.popState();
              break;

            case 14:
              return 32;

            case 15:
              this.begin("callbackname");
              break;

            case 17:
              this.popState(), this.begin("callbackargs");
              break;

            case 18:
              return 30;

            case 20:
              return 31;

            case 21:
              this.begin("click");
              break;

            case 23:
              return 29;

            case 24:
              return 5;

            case 25:
              return 12;

            case 26:
              return 13;

            case 27:
              return 14;

            case 28:
              return 15;

            case 29:
              return 17;

            case 30:
              return 16;

            case 31:
              return 18;

            case 32:
              return "date";

            case 33:
              return 19;

            case 34:
              return 20;

            case 35:
              return 22;

            case 36:
              return 23;

            case 37:
              return 27;

            case 38:
              return 7;

            case 39:
              return "INVALID";
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)*[^\n]*)/i, /^(?:[^\}]%%*[^\n]*)/i, /^(?:%%*[^\n]*[\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:href[\s]+["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:call[\s]+)/i, /^(?:\([\s]*\))/i, /^(?:\()/i, /^(?:[^(]*)/i, /^(?:\))/i, /^(?:[^)]*)/i, /^(?:click[\s]+)/i, /^(?:[\s\n])/i, /^(?:[^\s\n]*)/i, /^(?:gantt\b)/i, /^(?:dateFormat\s[^#\n;]+)/i, /^(?:inclusiveEndDates\b)/i, /^(?:topAxis\b)/i, /^(?:axisFormat\s[^#\n;]+)/i, /^(?:includes\s[^#\n;]+)/i, /^(?:excludes\s[^#\n;]+)/i, /^(?:todayMarker\s[^\n;]+)/i, /^(?:\d\d\d\d-\d\d-\d\d\b)/i, /^(?:title\s[^#\n;]+)/i, /^(?:section\s[^#:\n;]+)/i, /^(?:[^#:\n;]+)/i, /^(?::[^#\n;]+)/i, /^(?::)/i, /^(?:$)/i, /^(?:.)/i],
        conditions: {
          close_directive: {
            rules: [],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          callbackargs: {
            rules: [19, 20],
            inclusive: !1
          },
          callbackname: {
            rules: [16, 17, 18],
            inclusive: !1
          },
          href: {
            rules: [13, 14],
            inclusive: !1
          },
          click: {
            rules: [22, 23],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 15, 21, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            inclusive: !0
          }
        }
      };

      function b() {
        this.yy = {};
      }

      return m.lexer = v, b.prototype = m, m.Parser = b, new b();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(6878).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  2553: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t9, e, n, r) {
        for (n = n || {}, r = _t9.length; r--; n[_t9[r]] = e) {
          ;
        }

        return n;
      },
          e = [2, 3],
          n = [1, 7],
          r = [7, 12, 15, 17, 19, 20, 21],
          i = [7, 11, 12, 15, 17, 19, 20, 21],
          a = [2, 20],
          o = [1, 32],
          s = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          GG: 4,
          ":": 5,
          document: 6,
          EOF: 7,
          DIR: 8,
          options: 9,
          body: 10,
          OPT: 11,
          NL: 12,
          line: 13,
          statement: 14,
          COMMIT: 15,
          commit_arg: 16,
          BRANCH: 17,
          ID: 18,
          CHECKOUT: 19,
          MERGE: 20,
          RESET: 21,
          reset_arg: 22,
          STR: 23,
          HEAD: 24,
          reset_parents: 25,
          CARET: 26,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "GG",
          5: ":",
          7: "EOF",
          8: "DIR",
          11: "OPT",
          12: "NL",
          15: "COMMIT",
          17: "BRANCH",
          18: "ID",
          19: "CHECKOUT",
          20: "MERGE",
          21: "RESET",
          23: "STR",
          24: "HEAD",
          26: "CARET"
        },
        productions_: [0, [3, 4], [3, 5], [6, 0], [6, 2], [9, 2], [9, 1], [10, 0], [10, 2], [13, 2], [13, 1], [14, 2], [14, 2], [14, 2], [14, 2], [14, 2], [16, 0], [16, 1], [22, 2], [22, 2], [25, 0], [25, 2]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 1:
              return a[s - 1];

            case 2:
              return r.setDirection(a[s - 3]), a[s - 1];

            case 4:
              r.setOptions(a[s - 1]), this.$ = a[s];
              break;

            case 5:
              a[s - 1] += a[s], this.$ = a[s - 1];
              break;

            case 7:
              this.$ = [];
              break;

            case 8:
              a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 9:
              this.$ = a[s - 1];
              break;

            case 11:
              r.commit(a[s]);
              break;

            case 12:
              r.branch(a[s]);
              break;

            case 13:
              r.checkout(a[s]);
              break;

            case 14:
              r.merge(a[s]);
              break;

            case 15:
              r.reset(a[s]);
              break;

            case 16:
              this.$ = "";
              break;

            case 17:
              this.$ = a[s];
              break;

            case 18:
              this.$ = a[s - 1] + ":" + a[s];
              break;

            case 19:
              this.$ = a[s - 1] + ":" + r.count, r.count = 0;
              break;

            case 20:
              r.count = 0;
              break;

            case 21:
              r.count += 1;
          }
        },
        table: [{
          3: 1,
          4: [1, 2]
        }, {
          1: [3]
        }, {
          5: [1, 3],
          8: [1, 4]
        }, {
          6: 5,
          7: e,
          9: 6,
          12: n
        }, {
          5: [1, 8]
        }, {
          7: [1, 9]
        }, t(r, [2, 7], {
          10: 10,
          11: [1, 11]
        }), t(i, [2, 6]), {
          6: 12,
          7: e,
          9: 6,
          12: n
        }, {
          1: [2, 1]
        }, {
          7: [2, 4],
          12: [1, 15],
          13: 13,
          14: 14,
          15: [1, 16],
          17: [1, 17],
          19: [1, 18],
          20: [1, 19],
          21: [1, 20]
        }, t(i, [2, 5]), {
          7: [1, 21]
        }, t(r, [2, 8]), {
          12: [1, 22]
        }, t(r, [2, 10]), {
          12: [2, 16],
          16: 23,
          23: [1, 24]
        }, {
          18: [1, 25]
        }, {
          18: [1, 26]
        }, {
          18: [1, 27]
        }, {
          18: [1, 30],
          22: 28,
          24: [1, 29]
        }, {
          1: [2, 2]
        }, t(r, [2, 9]), {
          12: [2, 11]
        }, {
          12: [2, 17]
        }, {
          12: [2, 12]
        }, {
          12: [2, 13]
        }, {
          12: [2, 14]
        }, {
          12: [2, 15]
        }, {
          12: a,
          25: 31,
          26: o
        }, {
          12: a,
          25: 33,
          26: o
        }, {
          12: [2, 18]
        }, {
          12: a,
          25: 34,
          26: o
        }, {
          12: [2, 19]
        }, {
          12: [2, 21]
        }],
        defaultActions: {
          9: [2, 1],
          21: [2, 2],
          23: [2, 11],
          24: [2, 17],
          25: [2, 12],
          26: [2, 13],
          27: [2, 14],
          28: [2, 15],
          31: [2, 18],
          33: [2, 19],
          34: [2, 21]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          c = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return 12;

            case 1:
            case 2:
            case 3:
              break;

            case 4:
              return 4;

            case 5:
              return 15;

            case 6:
              return 17;

            case 7:
              return 20;

            case 8:
              return 21;

            case 9:
              return 19;

            case 10:
            case 11:
              return 8;

            case 12:
              return 5;

            case 13:
              return 26;

            case 14:
              this.begin("options");
              break;

            case 15:
            case 18:
              this.popState();
              break;

            case 16:
              return 11;

            case 17:
              this.begin("string");
              break;

            case 19:
              return 23;

            case 20:
              return 18;

            case 21:
              return 7;
          }
        },
        rules: [/^(?:(\r?\n)+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:gitGraph\b)/i, /^(?:commit\b)/i, /^(?:branch\b)/i, /^(?:merge\b)/i, /^(?:reset\b)/i, /^(?:checkout\b)/i, /^(?:LR\b)/i, /^(?:BT\b)/i, /^(?::)/i, /^(?:\^)/i, /^(?:options\r?\n)/i, /^(?:end\r?\n)/i, /^(?:[^\n]+\r?\n)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[a-zA-Z][-_\.a-zA-Z0-9]*[-_a-zA-Z0-9])/i, /^(?:$)/i],
        conditions: {
          options: {
            rules: [15, 16],
            inclusive: !1
          },
          string: {
            rules: [18, 19],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 17, 20, 21],
            inclusive: !0
          }
        }
      };

      function u() {
        this.yy = {};
      }

      return s.lexer = c, u.prototype = s, s.Parser = u, new u();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(8183).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  6765: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t10, e, n, r) {
        for (n = n || {}, r = _t10.length; r--; n[_t10[r]] = e) {
          ;
        }

        return n;
      },
          e = [6, 9, 10],
          n = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          info: 4,
          document: 5,
          EOF: 6,
          line: 7,
          statement: 8,
          NL: 9,
          showInfo: 10,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "info",
          6: "EOF",
          9: "NL",
          10: "showInfo"
        },
        productions_: [0, [3, 3], [5, 0], [5, 2], [7, 1], [7, 1], [8, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          switch (a.length, i) {
            case 1:
              return r;

            case 4:
              break;

            case 6:
              r.setInfo(!0);
          }
        },
        table: [{
          3: 1,
          4: [1, 2]
        }, {
          1: [3]
        }, t(e, [2, 2], {
          5: 3
        }), {
          6: [1, 4],
          7: 5,
          8: 6,
          9: [1, 7],
          10: [1, 8]
        }, {
          1: [2, 1]
        }, t(e, [2, 3]), t(e, [2, 4]), t(e, [2, 5]), t(e, [2, 6])],
        defaultActions: {
          4: [2, 1]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          r = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return 4;

            case 1:
              return 9;

            case 2:
              return "space";

            case 3:
              return 10;

            case 4:
              return 6;

            case 5:
              return "TXT";
          }
        },
        rules: [/^(?:info\b)/i, /^(?:[\s\n\r]+)/i, /^(?:[\s]+)/i, /^(?:showInfo\b)/i, /^(?:$)/i, /^(?:.)/i],
        conditions: {
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 5],
            inclusive: !0
          }
        }
      };

      function i() {
        this.yy = {};
      }

      return n.lexer = r, i.prototype = n, n.Parser = i, new i();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(1428).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  7062: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t11, e, n, r) {
        for (n = n || {}, r = _t11.length; r--; n[_t11[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 4],
          n = [1, 5],
          r = [1, 6],
          i = [1, 7],
          a = [1, 9],
          o = [1, 11, 13, 20, 21, 22, 23],
          s = [2, 5],
          c = [1, 6, 11, 13, 20, 21, 22, 23],
          u = [20, 21, 22],
          l = [2, 8],
          h = [1, 18],
          f = [1, 19],
          d = [1, 24],
          p = [6, 20, 21, 22, 23],
          y = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          eol: 4,
          directive: 5,
          PIE: 6,
          document: 7,
          showData: 8,
          line: 9,
          statement: 10,
          txt: 11,
          value: 12,
          title: 13,
          title_value: 14,
          openDirective: 15,
          typeDirective: 16,
          closeDirective: 17,
          ":": 18,
          argDirective: 19,
          NEWLINE: 20,
          ";": 21,
          EOF: 22,
          open_directive: 23,
          type_directive: 24,
          arg_directive: 25,
          close_directive: 26,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          6: "PIE",
          8: "showData",
          11: "txt",
          12: "value",
          13: "title",
          14: "title_value",
          18: ":",
          20: "NEWLINE",
          21: ";",
          22: "EOF",
          23: "open_directive",
          24: "type_directive",
          25: "arg_directive",
          26: "close_directive"
        },
        productions_: [0, [3, 2], [3, 2], [3, 2], [3, 3], [7, 0], [7, 2], [9, 2], [10, 0], [10, 2], [10, 2], [10, 1], [5, 3], [5, 5], [4, 1], [4, 1], [4, 1], [15, 1], [16, 1], [19, 1], [17, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 4:
              r.setShowData(!0);
              break;

            case 7:
              this.$ = a[s - 1];
              break;

            case 9:
              r.addSection(a[s - 1], r.cleanupValue(a[s]));
              break;

            case 10:
              this.$ = a[s].trim(), r.setTitle(this.$);
              break;

            case 17:
              r.parseDirective("%%{", "open_directive");
              break;

            case 18:
              r.parseDirective(a[s], "type_directive");
              break;

            case 19:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 20:
              r.parseDirective("}%%", "close_directive", "pie");
          }
        },
        table: [{
          3: 1,
          4: 2,
          5: 3,
          6: e,
          15: 8,
          20: n,
          21: r,
          22: i,
          23: a
        }, {
          1: [3]
        }, {
          3: 10,
          4: 2,
          5: 3,
          6: e,
          15: 8,
          20: n,
          21: r,
          22: i,
          23: a
        }, {
          3: 11,
          4: 2,
          5: 3,
          6: e,
          15: 8,
          20: n,
          21: r,
          22: i,
          23: a
        }, t(o, s, {
          7: 12,
          8: [1, 13]
        }), t(c, [2, 14]), t(c, [2, 15]), t(c, [2, 16]), {
          16: 14,
          24: [1, 15]
        }, {
          24: [2, 17]
        }, {
          1: [2, 1]
        }, {
          1: [2, 2]
        }, t(u, l, {
          15: 8,
          9: 16,
          10: 17,
          5: 20,
          1: [2, 3],
          11: h,
          13: f,
          23: a
        }), t(o, s, {
          7: 21
        }), {
          17: 22,
          18: [1, 23],
          26: d
        }, t([18, 26], [2, 18]), t(o, [2, 6]), {
          4: 25,
          20: n,
          21: r,
          22: i
        }, {
          12: [1, 26]
        }, {
          14: [1, 27]
        }, t(u, [2, 11]), t(u, l, {
          15: 8,
          9: 16,
          10: 17,
          5: 20,
          1: [2, 4],
          11: h,
          13: f,
          23: a
        }), t(p, [2, 12]), {
          19: 28,
          25: [1, 29]
        }, t(p, [2, 20]), t(o, [2, 7]), t(u, [2, 9]), t(u, [2, 10]), {
          17: 30,
          26: d
        }, {
          26: [2, 19]
        }, t(p, [2, 13])],
        defaultActions: {
          9: [2, 17],
          10: [2, 1],
          11: [2, 2],
          29: [2, 19]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          g = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 23;

            case 1:
              return this.begin("type_directive"), 24;

            case 2:
              return this.popState(), this.begin("arg_directive"), 18;

            case 3:
              return this.popState(), this.popState(), 26;

            case 4:
              return 25;

            case 5:
            case 6:
            case 8:
            case 9:
              break;

            case 7:
              return 20;

            case 10:
              return this.begin("title"), 13;

            case 11:
              return this.popState(), "title_value";

            case 12:
              this.begin("string");
              break;

            case 13:
              this.popState();
              break;

            case 14:
              return "txt";

            case 15:
              return 6;

            case 16:
              return 8;

            case 17:
              return "value";

            case 18:
              return 22;
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n\r]+)/i, /^(?:%%[^\n]*)/i, /^(?:[\s]+)/i, /^(?:title\b)/i, /^(?:(?!\n||)*[^\n]*)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:pie\b)/i, /^(?:showData\b)/i, /^(?::[\s]*[\d]+(?:\.[\d]+)?)/i, /^(?:$)/i],
        conditions: {
          close_directive: {
            rules: [],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          title: {
            rules: [11],
            inclusive: !1
          },
          string: {
            rules: [13, 14],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 8, 9, 10, 12, 15, 16, 17, 18],
            inclusive: !0
          }
        }
      };

      function m() {
        this.yy = {};
      }

      return y.lexer = g, m.prototype = y, y.Parser = m, new m();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(4551).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  3176: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t12, e, n, r) {
        for (n = n || {}, r = _t12.length; r--; n[_t12[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 3],
          n = [1, 5],
          r = [1, 17],
          i = [2, 10],
          a = [1, 21],
          o = [1, 22],
          s = [1, 23],
          c = [1, 24],
          u = [1, 25],
          l = [1, 26],
          h = [1, 19],
          f = [1, 27],
          d = [1, 28],
          p = [1, 31],
          y = [66, 67],
          g = [5, 8, 14, 35, 36, 37, 38, 39, 40, 48, 55, 57, 66, 67],
          m = [5, 6, 8, 14, 35, 36, 37, 38, 39, 40, 48, 66, 67],
          v = [1, 51],
          b = [1, 52],
          _ = [1, 53],
          x = [1, 54],
          w = [1, 55],
          k = [1, 56],
          T = [1, 57],
          E = [57, 58],
          C = [1, 69],
          S = [1, 65],
          A = [1, 66],
          M = [1, 67],
          N = [1, 68],
          D = [1, 70],
          O = [1, 74],
          B = [1, 75],
          L = [1, 72],
          I = [1, 73],
          R = [5, 8, 14, 35, 36, 37, 38, 39, 40, 48, 66, 67],
          F = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          directive: 4,
          NEWLINE: 5,
          RD: 6,
          diagram: 7,
          EOF: 8,
          openDirective: 9,
          typeDirective: 10,
          closeDirective: 11,
          ":": 12,
          argDirective: 13,
          open_directive: 14,
          type_directive: 15,
          arg_directive: 16,
          close_directive: 17,
          requirementDef: 18,
          elementDef: 19,
          relationshipDef: 20,
          requirementType: 21,
          requirementName: 22,
          STRUCT_START: 23,
          requirementBody: 24,
          ID: 25,
          COLONSEP: 26,
          id: 27,
          TEXT: 28,
          text: 29,
          RISK: 30,
          riskLevel: 31,
          VERIFYMTHD: 32,
          verifyType: 33,
          STRUCT_STOP: 34,
          REQUIREMENT: 35,
          FUNCTIONAL_REQUIREMENT: 36,
          INTERFACE_REQUIREMENT: 37,
          PERFORMANCE_REQUIREMENT: 38,
          PHYSICAL_REQUIREMENT: 39,
          DESIGN_CONSTRAINT: 40,
          LOW_RISK: 41,
          MED_RISK: 42,
          HIGH_RISK: 43,
          VERIFY_ANALYSIS: 44,
          VERIFY_DEMONSTRATION: 45,
          VERIFY_INSPECTION: 46,
          VERIFY_TEST: 47,
          ELEMENT: 48,
          elementName: 49,
          elementBody: 50,
          TYPE: 51,
          type: 52,
          DOCREF: 53,
          ref: 54,
          END_ARROW_L: 55,
          relationship: 56,
          LINE: 57,
          END_ARROW_R: 58,
          CONTAINS: 59,
          COPIES: 60,
          DERIVES: 61,
          SATISFIES: 62,
          VERIFIES: 63,
          REFINES: 64,
          TRACES: 65,
          unqString: 66,
          qString: 67,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          5: "NEWLINE",
          6: "RD",
          8: "EOF",
          12: ":",
          14: "open_directive",
          15: "type_directive",
          16: "arg_directive",
          17: "close_directive",
          23: "STRUCT_START",
          25: "ID",
          26: "COLONSEP",
          28: "TEXT",
          30: "RISK",
          32: "VERIFYMTHD",
          34: "STRUCT_STOP",
          35: "REQUIREMENT",
          36: "FUNCTIONAL_REQUIREMENT",
          37: "INTERFACE_REQUIREMENT",
          38: "PERFORMANCE_REQUIREMENT",
          39: "PHYSICAL_REQUIREMENT",
          40: "DESIGN_CONSTRAINT",
          41: "LOW_RISK",
          42: "MED_RISK",
          43: "HIGH_RISK",
          44: "VERIFY_ANALYSIS",
          45: "VERIFY_DEMONSTRATION",
          46: "VERIFY_INSPECTION",
          47: "VERIFY_TEST",
          48: "ELEMENT",
          51: "TYPE",
          53: "DOCREF",
          55: "END_ARROW_L",
          57: "LINE",
          58: "END_ARROW_R",
          59: "CONTAINS",
          60: "COPIES",
          61: "DERIVES",
          62: "SATISFIES",
          63: "VERIFIES",
          64: "REFINES",
          65: "TRACES",
          66: "unqString",
          67: "qString"
        },
        productions_: [0, [3, 3], [3, 2], [3, 4], [4, 3], [4, 5], [9, 1], [10, 1], [13, 1], [11, 1], [7, 0], [7, 2], [7, 2], [7, 2], [7, 2], [7, 2], [18, 5], [24, 5], [24, 5], [24, 5], [24, 5], [24, 2], [24, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [31, 1], [31, 1], [31, 1], [33, 1], [33, 1], [33, 1], [33, 1], [19, 5], [50, 5], [50, 5], [50, 2], [50, 1], [20, 5], [20, 5], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [22, 1], [22, 1], [27, 1], [27, 1], [29, 1], [29, 1], [49, 1], [49, 1], [52, 1], [52, 1], [54, 1], [54, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 6:
              r.parseDirective("%%{", "open_directive");
              break;

            case 7:
              r.parseDirective(a[s], "type_directive");
              break;

            case 8:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 9:
              r.parseDirective("}%%", "close_directive", "pie");
              break;

            case 10:
              this.$ = [];
              break;

            case 16:
              r.addRequirement(a[s - 3], a[s - 4]);
              break;

            case 17:
              r.setNewReqId(a[s - 2]);
              break;

            case 18:
              r.setNewReqText(a[s - 2]);
              break;

            case 19:
              r.setNewReqRisk(a[s - 2]);
              break;

            case 20:
              r.setNewReqVerifyMethod(a[s - 2]);
              break;

            case 23:
              this.$ = r.RequirementType.REQUIREMENT;
              break;

            case 24:
              this.$ = r.RequirementType.FUNCTIONAL_REQUIREMENT;
              break;

            case 25:
              this.$ = r.RequirementType.INTERFACE_REQUIREMENT;
              break;

            case 26:
              this.$ = r.RequirementType.PERFORMANCE_REQUIREMENT;
              break;

            case 27:
              this.$ = r.RequirementType.PHYSICAL_REQUIREMENT;
              break;

            case 28:
              this.$ = r.RequirementType.DESIGN_CONSTRAINT;
              break;

            case 29:
              this.$ = r.RiskLevel.LOW_RISK;
              break;

            case 30:
              this.$ = r.RiskLevel.MED_RISK;
              break;

            case 31:
              this.$ = r.RiskLevel.HIGH_RISK;
              break;

            case 32:
              this.$ = r.VerifyType.VERIFY_ANALYSIS;
              break;

            case 33:
              this.$ = r.VerifyType.VERIFY_DEMONSTRATION;
              break;

            case 34:
              this.$ = r.VerifyType.VERIFY_INSPECTION;
              break;

            case 35:
              this.$ = r.VerifyType.VERIFY_TEST;
              break;

            case 36:
              r.addElement(a[s - 3]);
              break;

            case 37:
              r.setNewElementType(a[s - 2]);
              break;

            case 38:
              r.setNewElementDocRef(a[s - 2]);
              break;

            case 41:
              r.addRelationship(a[s - 2], a[s], a[s - 4]);
              break;

            case 42:
              r.addRelationship(a[s - 2], a[s - 4], a[s]);
              break;

            case 43:
              this.$ = r.Relationships.CONTAINS;
              break;

            case 44:
              this.$ = r.Relationships.COPIES;
              break;

            case 45:
              this.$ = r.Relationships.DERIVES;
              break;

            case 46:
              this.$ = r.Relationships.SATISFIES;
              break;

            case 47:
              this.$ = r.Relationships.VERIFIES;
              break;

            case 48:
              this.$ = r.Relationships.REFINES;
              break;

            case 49:
              this.$ = r.Relationships.TRACES;
          }
        },
        table: [{
          3: 1,
          4: 2,
          6: e,
          9: 4,
          14: n
        }, {
          1: [3]
        }, {
          3: 7,
          4: 2,
          5: [1, 6],
          6: e,
          9: 4,
          14: n
        }, {
          5: [1, 8]
        }, {
          10: 9,
          15: [1, 10]
        }, {
          15: [2, 6]
        }, {
          3: 11,
          4: 2,
          6: e,
          9: 4,
          14: n
        }, {
          1: [2, 2]
        }, {
          4: 16,
          5: r,
          7: 12,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          11: 29,
          12: [1, 30],
          17: p
        }, t([12, 17], [2, 7]), {
          1: [2, 1]
        }, {
          8: [1, 32]
        }, {
          4: 16,
          5: r,
          7: 33,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          4: 16,
          5: r,
          7: 34,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          4: 16,
          5: r,
          7: 35,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          4: 16,
          5: r,
          7: 36,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          4: 16,
          5: r,
          7: 37,
          8: i,
          9: 4,
          14: n,
          18: 13,
          19: 14,
          20: 15,
          21: 18,
          27: 20,
          35: a,
          36: o,
          37: s,
          38: c,
          39: u,
          40: l,
          48: h,
          66: f,
          67: d
        }, {
          22: 38,
          66: [1, 39],
          67: [1, 40]
        }, {
          49: 41,
          66: [1, 42],
          67: [1, 43]
        }, {
          55: [1, 44],
          57: [1, 45]
        }, t(y, [2, 23]), t(y, [2, 24]), t(y, [2, 25]), t(y, [2, 26]), t(y, [2, 27]), t(y, [2, 28]), t(g, [2, 52]), t(g, [2, 53]), t(m, [2, 4]), {
          13: 46,
          16: [1, 47]
        }, t(m, [2, 9]), {
          1: [2, 3]
        }, {
          8: [2, 11]
        }, {
          8: [2, 12]
        }, {
          8: [2, 13]
        }, {
          8: [2, 14]
        }, {
          8: [2, 15]
        }, {
          23: [1, 48]
        }, {
          23: [2, 50]
        }, {
          23: [2, 51]
        }, {
          23: [1, 49]
        }, {
          23: [2, 56]
        }, {
          23: [2, 57]
        }, {
          56: 50,
          59: v,
          60: b,
          61: _,
          62: x,
          63: w,
          64: k,
          65: T
        }, {
          56: 58,
          59: v,
          60: b,
          61: _,
          62: x,
          63: w,
          64: k,
          65: T
        }, {
          11: 59,
          17: p
        }, {
          17: [2, 8]
        }, {
          5: [1, 60]
        }, {
          5: [1, 61]
        }, {
          57: [1, 62]
        }, t(E, [2, 43]), t(E, [2, 44]), t(E, [2, 45]), t(E, [2, 46]), t(E, [2, 47]), t(E, [2, 48]), t(E, [2, 49]), {
          58: [1, 63]
        }, t(m, [2, 5]), {
          5: C,
          24: 64,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, {
          5: O,
          34: B,
          50: 71,
          51: L,
          53: I
        }, {
          27: 76,
          66: f,
          67: d
        }, {
          27: 77,
          66: f,
          67: d
        }, t(R, [2, 16]), {
          26: [1, 78]
        }, {
          26: [1, 79]
        }, {
          26: [1, 80]
        }, {
          26: [1, 81]
        }, {
          5: C,
          24: 82,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, t(R, [2, 22]), t(R, [2, 36]), {
          26: [1, 83]
        }, {
          26: [1, 84]
        }, {
          5: O,
          34: B,
          50: 85,
          51: L,
          53: I
        }, t(R, [2, 40]), t(R, [2, 41]), t(R, [2, 42]), {
          27: 86,
          66: f,
          67: d
        }, {
          29: 87,
          66: [1, 88],
          67: [1, 89]
        }, {
          31: 90,
          41: [1, 91],
          42: [1, 92],
          43: [1, 93]
        }, {
          33: 94,
          44: [1, 95],
          45: [1, 96],
          46: [1, 97],
          47: [1, 98]
        }, t(R, [2, 21]), {
          52: 99,
          66: [1, 100],
          67: [1, 101]
        }, {
          54: 102,
          66: [1, 103],
          67: [1, 104]
        }, t(R, [2, 39]), {
          5: [1, 105]
        }, {
          5: [1, 106]
        }, {
          5: [2, 54]
        }, {
          5: [2, 55]
        }, {
          5: [1, 107]
        }, {
          5: [2, 29]
        }, {
          5: [2, 30]
        }, {
          5: [2, 31]
        }, {
          5: [1, 108]
        }, {
          5: [2, 32]
        }, {
          5: [2, 33]
        }, {
          5: [2, 34]
        }, {
          5: [2, 35]
        }, {
          5: [1, 109]
        }, {
          5: [2, 58]
        }, {
          5: [2, 59]
        }, {
          5: [1, 110]
        }, {
          5: [2, 60]
        }, {
          5: [2, 61]
        }, {
          5: C,
          24: 111,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, {
          5: C,
          24: 112,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, {
          5: C,
          24: 113,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, {
          5: C,
          24: 114,
          25: S,
          28: A,
          30: M,
          32: N,
          34: D
        }, {
          5: O,
          34: B,
          50: 115,
          51: L,
          53: I
        }, {
          5: O,
          34: B,
          50: 116,
          51: L,
          53: I
        }, t(R, [2, 17]), t(R, [2, 18]), t(R, [2, 19]), t(R, [2, 20]), t(R, [2, 37]), t(R, [2, 38])],
        defaultActions: {
          5: [2, 6],
          7: [2, 2],
          11: [2, 1],
          32: [2, 3],
          33: [2, 11],
          34: [2, 12],
          35: [2, 13],
          36: [2, 14],
          37: [2, 15],
          39: [2, 50],
          40: [2, 51],
          42: [2, 56],
          43: [2, 57],
          47: [2, 8],
          88: [2, 54],
          89: [2, 55],
          91: [2, 29],
          92: [2, 30],
          93: [2, 31],
          95: [2, 32],
          96: [2, 33],
          97: [2, 34],
          98: [2, 35],
          100: [2, 58],
          101: [2, 59],
          103: [2, 60],
          104: [2, 61]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          P = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 14;

            case 1:
              return this.begin("type_directive"), 15;

            case 2:
              return this.popState(), this.begin("arg_directive"), 12;

            case 3:
              return this.popState(), this.popState(), 17;

            case 4:
              return 16;

            case 5:
              return 5;

            case 6:
            case 7:
            case 8:
              break;

            case 9:
              return 8;

            case 10:
              return 6;

            case 11:
              return 23;

            case 12:
              return 34;

            case 13:
              return 26;

            case 14:
              return 25;

            case 15:
              return 28;

            case 16:
              return 30;

            case 17:
              return 32;

            case 18:
              return 35;

            case 19:
              return 36;

            case 20:
              return 37;

            case 21:
              return 38;

            case 22:
              return 39;

            case 23:
              return 40;

            case 24:
              return 41;

            case 25:
              return 42;

            case 26:
              return 43;

            case 27:
              return 44;

            case 28:
              return 45;

            case 29:
              return 46;

            case 30:
              return 47;

            case 31:
              return 48;

            case 32:
              return 59;

            case 33:
              return 60;

            case 34:
              return 61;

            case 35:
              return 62;

            case 36:
              return 63;

            case 37:
              return 64;

            case 38:
              return 65;

            case 39:
              return 51;

            case 40:
              return 53;

            case 41:
              return 55;

            case 42:
              return 58;

            case 43:
              return 57;

            case 44:
              this.begin("string");
              break;

            case 45:
              this.popState();
              break;

            case 46:
              return "qString";

            case 47:
              return e.yytext = e.yytext.trim(), 66;
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:(\r?\n)+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:$)/i, /^(?:requirementDiagram\b)/i, /^(?:\{)/i, /^(?:\})/i, /^(?::)/i, /^(?:id\b)/i, /^(?:text\b)/i, /^(?:risk\b)/i, /^(?:verifyMethod\b)/i, /^(?:requirement\b)/i, /^(?:functionalRequirement\b)/i, /^(?:interfaceRequirement\b)/i, /^(?:performanceRequirement\b)/i, /^(?:physicalRequirement\b)/i, /^(?:designConstraint\b)/i, /^(?:low\b)/i, /^(?:medium\b)/i, /^(?:high\b)/i, /^(?:analysis\b)/i, /^(?:demonstration\b)/i, /^(?:inspection\b)/i, /^(?:test\b)/i, /^(?:element\b)/i, /^(?:contains\b)/i, /^(?:copies\b)/i, /^(?:derives\b)/i, /^(?:satisfies\b)/i, /^(?:verifies\b)/i, /^(?:refines\b)/i, /^(?:traces\b)/i, /^(?:type\b)/i, /^(?:docref\b)/i, /^(?:<-)/i, /^(?:->)/i, /^(?:-)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[\w][^\r\n\{\<\>\-\=]*)/i],
        conditions: {
          close_directive: {
            rules: [],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          unqString: {
            rules: [],
            inclusive: !1
          },
          token: {
            rules: [],
            inclusive: !1
          },
          string: {
            rules: [45, 46],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 47],
            inclusive: !0
          }
        }
      };

      function j() {
        this.yy = {};
      }

      return F.lexer = P, j.prototype = F, F.Parser = j, new j();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(8800).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  6876: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t13, e, n, r) {
        for (n = n || {}, r = _t13.length; r--; n[_t13[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 2],
          n = [1, 3],
          r = [1, 5],
          i = [1, 7],
          a = [2, 5],
          o = [1, 15],
          s = [1, 17],
          c = [1, 18],
          u = [1, 19],
          l = [1, 21],
          h = [1, 22],
          f = [1, 23],
          d = [1, 29],
          p = [1, 30],
          y = [1, 31],
          g = [1, 32],
          m = [1, 33],
          v = [1, 34],
          b = [1, 37],
          _ = [1, 38],
          x = [1, 39],
          w = [1, 40],
          k = [1, 41],
          T = [1, 42],
          E = [1, 45],
          C = [1, 4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 41, 42, 46, 47, 48, 49, 57, 67],
          S = [1, 58],
          A = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 42, 46, 47, 48, 49, 57, 67],
          M = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 41, 42, 46, 47, 48, 49, 57, 67],
          N = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 42, 46, 47, 48, 49, 57, 67],
          D = [55, 56, 57],
          O = [1, 4, 5, 7, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 41, 42, 46, 47, 48, 49, 57, 67],
          B = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          SPACE: 4,
          NEWLINE: 5,
          directive: 6,
          SD: 7,
          document: 8,
          line: 9,
          statement: 10,
          openDirective: 11,
          typeDirective: 12,
          closeDirective: 13,
          ":": 14,
          argDirective: 15,
          participant: 16,
          actor: 17,
          AS: 18,
          restOfLine: 19,
          participant_actor: 20,
          signal: 21,
          autonumber: 22,
          activate: 23,
          deactivate: 24,
          note_statement: 25,
          links_statement: 26,
          link_statement: 27,
          properties_statement: 28,
          details_statement: 29,
          title: 30,
          text2: 31,
          loop: 32,
          end: 33,
          rect: 34,
          opt: 35,
          alt: 36,
          else_sections: 37,
          par: 38,
          par_sections: 39,
          and: 40,
          "else": 41,
          note: 42,
          placement: 43,
          over: 44,
          actor_pair: 45,
          links: 46,
          link: 47,
          properties: 48,
          details: 49,
          spaceList: 50,
          ",": 51,
          left_of: 52,
          right_of: 53,
          signaltype: 54,
          "+": 55,
          "-": 56,
          ACTOR: 57,
          SOLID_OPEN_ARROW: 58,
          DOTTED_OPEN_ARROW: 59,
          SOLID_ARROW: 60,
          DOTTED_ARROW: 61,
          SOLID_CROSS: 62,
          DOTTED_CROSS: 63,
          SOLID_POINT: 64,
          DOTTED_POINT: 65,
          TXT: 66,
          open_directive: 67,
          type_directive: 68,
          arg_directive: 69,
          close_directive: 70,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "SPACE",
          5: "NEWLINE",
          7: "SD",
          14: ":",
          16: "participant",
          18: "AS",
          19: "restOfLine",
          20: "participant_actor",
          22: "autonumber",
          23: "activate",
          24: "deactivate",
          30: "title",
          32: "loop",
          33: "end",
          34: "rect",
          35: "opt",
          36: "alt",
          38: "par",
          40: "and",
          41: "else",
          42: "note",
          44: "over",
          46: "links",
          47: "link",
          48: "properties",
          49: "details",
          51: ",",
          52: "left_of",
          53: "right_of",
          55: "+",
          56: "-",
          57: "ACTOR",
          58: "SOLID_OPEN_ARROW",
          59: "DOTTED_OPEN_ARROW",
          60: "SOLID_ARROW",
          61: "DOTTED_ARROW",
          62: "SOLID_CROSS",
          63: "DOTTED_CROSS",
          64: "SOLID_POINT",
          65: "DOTTED_POINT",
          66: "TXT",
          67: "open_directive",
          68: "type_directive",
          69: "arg_directive",
          70: "close_directive"
        },
        productions_: [0, [3, 2], [3, 2], [3, 2], [3, 2], [8, 0], [8, 2], [9, 2], [9, 1], [9, 1], [6, 4], [6, 6], [10, 5], [10, 3], [10, 5], [10, 3], [10, 2], [10, 1], [10, 3], [10, 3], [10, 2], [10, 2], [10, 2], [10, 2], [10, 2], [10, 3], [10, 4], [10, 4], [10, 4], [10, 4], [10, 4], [10, 1], [39, 1], [39, 4], [37, 1], [37, 4], [25, 4], [25, 4], [26, 3], [27, 3], [28, 3], [29, 3], [50, 2], [50, 1], [45, 3], [45, 1], [43, 1], [43, 1], [21, 5], [21, 5], [21, 4], [17, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [31, 1], [11, 1], [12, 1], [15, 1], [13, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 4:
              return r.apply(a[s]), a[s];

            case 5:
            case 9:
              this.$ = [];
              break;

            case 6:
              a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 7:
            case 8:
            case 45:
              this.$ = a[s];
              break;

            case 12:
              a[s - 3].type = "addParticipant", a[s - 3].description = r.parseMessage(a[s - 1]), this.$ = a[s - 3];
              break;

            case 13:
              a[s - 1].type = "addParticipant", this.$ = a[s - 1];
              break;

            case 14:
              a[s - 3].type = "addActor", a[s - 3].description = r.parseMessage(a[s - 1]), this.$ = a[s - 3];
              break;

            case 15:
              a[s - 1].type = "addActor", this.$ = a[s - 1];
              break;

            case 17:
              r.enableSequenceNumbers();
              break;

            case 18:
              this.$ = {
                type: "activeStart",
                signalType: r.LINETYPE.ACTIVE_START,
                actor: a[s - 1]
              };
              break;

            case 19:
              this.$ = {
                type: "activeEnd",
                signalType: r.LINETYPE.ACTIVE_END,
                actor: a[s - 1]
              };
              break;

            case 25:
              this.$ = [{
                type: "setTitle",
                text: a[s - 1]
              }];
              break;

            case 26:
              a[s - 1].unshift({
                type: "loopStart",
                loopText: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.LOOP_START
              }), a[s - 1].push({
                type: "loopEnd",
                loopText: a[s - 2],
                signalType: r.LINETYPE.LOOP_END
              }), this.$ = a[s - 1];
              break;

            case 27:
              a[s - 1].unshift({
                type: "rectStart",
                color: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.RECT_START
              }), a[s - 1].push({
                type: "rectEnd",
                color: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.RECT_END
              }), this.$ = a[s - 1];
              break;

            case 28:
              a[s - 1].unshift({
                type: "optStart",
                optText: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.OPT_START
              }), a[s - 1].push({
                type: "optEnd",
                optText: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.OPT_END
              }), this.$ = a[s - 1];
              break;

            case 29:
              a[s - 1].unshift({
                type: "altStart",
                altText: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.ALT_START
              }), a[s - 1].push({
                type: "altEnd",
                signalType: r.LINETYPE.ALT_END
              }), this.$ = a[s - 1];
              break;

            case 30:
              a[s - 1].unshift({
                type: "parStart",
                parText: r.parseMessage(a[s - 2]),
                signalType: r.LINETYPE.PAR_START
              }), a[s - 1].push({
                type: "parEnd",
                signalType: r.LINETYPE.PAR_END
              }), this.$ = a[s - 1];
              break;

            case 33:
              this.$ = a[s - 3].concat([{
                type: "and",
                parText: r.parseMessage(a[s - 1]),
                signalType: r.LINETYPE.PAR_AND
              }, a[s]]);
              break;

            case 35:
              this.$ = a[s - 3].concat([{
                type: "else",
                altText: r.parseMessage(a[s - 1]),
                signalType: r.LINETYPE.ALT_ELSE
              }, a[s]]);
              break;

            case 36:
              this.$ = [a[s - 1], {
                type: "addNote",
                placement: a[s - 2],
                actor: a[s - 1].actor,
                text: a[s]
              }];
              break;

            case 37:
              a[s - 2] = [].concat(a[s - 1], a[s - 1]).slice(0, 2), a[s - 2][0] = a[s - 2][0].actor, a[s - 2][1] = a[s - 2][1].actor, this.$ = [a[s - 1], {
                type: "addNote",
                placement: r.PLACEMENT.OVER,
                actor: a[s - 2].slice(0, 2),
                text: a[s]
              }];
              break;

            case 38:
              this.$ = [a[s - 1], {
                type: "addLinks",
                actor: a[s - 1].actor,
                text: a[s]
              }];
              break;

            case 39:
              this.$ = [a[s - 1], {
                type: "addALink",
                actor: a[s - 1].actor,
                text: a[s]
              }];
              break;

            case 40:
              this.$ = [a[s - 1], {
                type: "addProperties",
                actor: a[s - 1].actor,
                text: a[s]
              }];
              break;

            case 41:
              this.$ = [a[s - 1], {
                type: "addDetails",
                actor: a[s - 1].actor,
                text: a[s]
              }];
              break;

            case 44:
              this.$ = [a[s - 2], a[s]];
              break;

            case 46:
              this.$ = r.PLACEMENT.LEFTOF;
              break;

            case 47:
              this.$ = r.PLACEMENT.RIGHTOF;
              break;

            case 48:
              this.$ = [a[s - 4], a[s - 1], {
                type: "addMessage",
                from: a[s - 4].actor,
                to: a[s - 1].actor,
                signalType: a[s - 3],
                msg: a[s]
              }, {
                type: "activeStart",
                signalType: r.LINETYPE.ACTIVE_START,
                actor: a[s - 1]
              }];
              break;

            case 49:
              this.$ = [a[s - 4], a[s - 1], {
                type: "addMessage",
                from: a[s - 4].actor,
                to: a[s - 1].actor,
                signalType: a[s - 3],
                msg: a[s]
              }, {
                type: "activeEnd",
                signalType: r.LINETYPE.ACTIVE_END,
                actor: a[s - 4]
              }];
              break;

            case 50:
              this.$ = [a[s - 3], a[s - 1], {
                type: "addMessage",
                from: a[s - 3].actor,
                to: a[s - 1].actor,
                signalType: a[s - 2],
                msg: a[s]
              }];
              break;

            case 51:
              this.$ = {
                type: "addParticipant",
                actor: a[s]
              };
              break;

            case 52:
              this.$ = r.LINETYPE.SOLID_OPEN;
              break;

            case 53:
              this.$ = r.LINETYPE.DOTTED_OPEN;
              break;

            case 54:
              this.$ = r.LINETYPE.SOLID;
              break;

            case 55:
              this.$ = r.LINETYPE.DOTTED;
              break;

            case 56:
              this.$ = r.LINETYPE.SOLID_CROSS;
              break;

            case 57:
              this.$ = r.LINETYPE.DOTTED_CROSS;
              break;

            case 58:
              this.$ = r.LINETYPE.SOLID_POINT;
              break;

            case 59:
              this.$ = r.LINETYPE.DOTTED_POINT;
              break;

            case 60:
              this.$ = r.parseMessage(a[s].trim().substring(1));
              break;

            case 61:
              r.parseDirective("%%{", "open_directive");
              break;

            case 62:
              r.parseDirective(a[s], "type_directive");
              break;

            case 63:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 64:
              r.parseDirective("}%%", "close_directive", "sequence");
          }
        },
        table: [{
          3: 1,
          4: e,
          5: n,
          6: 4,
          7: r,
          11: 6,
          67: i
        }, {
          1: [3]
        }, {
          3: 8,
          4: e,
          5: n,
          6: 4,
          7: r,
          11: 6,
          67: i
        }, {
          3: 9,
          4: e,
          5: n,
          6: 4,
          7: r,
          11: 6,
          67: i
        }, {
          3: 10,
          4: e,
          5: n,
          6: 4,
          7: r,
          11: 6,
          67: i
        }, t([1, 4, 5, 16, 20, 22, 23, 24, 30, 32, 34, 35, 36, 38, 42, 46, 47, 48, 49, 57, 67], a, {
          8: 11
        }), {
          12: 12,
          68: [1, 13]
        }, {
          68: [2, 61]
        }, {
          1: [2, 1]
        }, {
          1: [2, 2]
        }, {
          1: [2, 3]
        }, {
          1: [2, 4],
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          34: y,
          35: g,
          36: m,
          38: v,
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          13: 43,
          14: [1, 44],
          70: E
        }, t([14, 70], [2, 62]), t(C, [2, 6]), {
          6: 35,
          10: 46,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          34: y,
          35: g,
          36: m,
          38: v,
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, t(C, [2, 8]), t(C, [2, 9]), {
          17: 47,
          57: T
        }, {
          17: 48,
          57: T
        }, {
          5: [1, 49]
        }, t(C, [2, 17]), {
          17: 50,
          57: T
        }, {
          17: 51,
          57: T
        }, {
          5: [1, 52]
        }, {
          5: [1, 53]
        }, {
          5: [1, 54]
        }, {
          5: [1, 55]
        }, {
          5: [1, 56]
        }, {
          31: 57,
          66: S
        }, {
          19: [1, 59]
        }, {
          19: [1, 60]
        }, {
          19: [1, 61]
        }, {
          19: [1, 62]
        }, {
          19: [1, 63]
        }, t(C, [2, 31]), {
          54: 64,
          58: [1, 65],
          59: [1, 66],
          60: [1, 67],
          61: [1, 68],
          62: [1, 69],
          63: [1, 70],
          64: [1, 71],
          65: [1, 72]
        }, {
          43: 73,
          44: [1, 74],
          52: [1, 75],
          53: [1, 76]
        }, {
          17: 77,
          57: T
        }, {
          17: 78,
          57: T
        }, {
          17: 79,
          57: T
        }, {
          17: 80,
          57: T
        }, t([5, 18, 51, 58, 59, 60, 61, 62, 63, 64, 65, 66], [2, 51]), {
          5: [1, 81]
        }, {
          15: 82,
          69: [1, 83]
        }, {
          5: [2, 64]
        }, t(C, [2, 7]), {
          5: [1, 85],
          18: [1, 84]
        }, {
          5: [1, 87],
          18: [1, 86]
        }, t(C, [2, 16]), {
          5: [1, 88]
        }, {
          5: [1, 89]
        }, t(C, [2, 20]), t(C, [2, 21]), t(C, [2, 22]), t(C, [2, 23]), t(C, [2, 24]), {
          5: [1, 90]
        }, {
          5: [2, 60]
        }, t(A, a, {
          8: 91
        }), t(A, a, {
          8: 92
        }), t(A, a, {
          8: 93
        }), t(M, a, {
          37: 94,
          8: 95
        }), t(N, a, {
          39: 96,
          8: 97
        }), {
          17: 100,
          55: [1, 98],
          56: [1, 99],
          57: T
        }, t(D, [2, 52]), t(D, [2, 53]), t(D, [2, 54]), t(D, [2, 55]), t(D, [2, 56]), t(D, [2, 57]), t(D, [2, 58]), t(D, [2, 59]), {
          17: 101,
          57: T
        }, {
          17: 103,
          45: 102,
          57: T
        }, {
          57: [2, 46]
        }, {
          57: [2, 47]
        }, {
          31: 104,
          66: S
        }, {
          31: 105,
          66: S
        }, {
          31: 106,
          66: S
        }, {
          31: 107,
          66: S
        }, t(O, [2, 10]), {
          13: 108,
          70: E
        }, {
          70: [2, 63]
        }, {
          19: [1, 109]
        }, t(C, [2, 13]), {
          19: [1, 110]
        }, t(C, [2, 15]), t(C, [2, 18]), t(C, [2, 19]), t(C, [2, 25]), {
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          33: [1, 111],
          34: y,
          35: g,
          36: m,
          38: v,
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          33: [1, 112],
          34: y,
          35: g,
          36: m,
          38: v,
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          33: [1, 113],
          34: y,
          35: g,
          36: m,
          38: v,
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          33: [1, 114]
        }, {
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          33: [2, 34],
          34: y,
          35: g,
          36: m,
          38: v,
          41: [1, 115],
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          33: [1, 116]
        }, {
          4: o,
          5: s,
          6: 35,
          9: 14,
          10: 16,
          11: 6,
          16: c,
          17: 36,
          20: u,
          21: 20,
          22: l,
          23: h,
          24: f,
          25: 24,
          26: 25,
          27: 26,
          28: 27,
          29: 28,
          30: d,
          32: p,
          33: [2, 32],
          34: y,
          35: g,
          36: m,
          38: v,
          40: [1, 117],
          42: b,
          46: _,
          47: x,
          48: w,
          49: k,
          57: T,
          67: i
        }, {
          17: 118,
          57: T
        }, {
          17: 119,
          57: T
        }, {
          31: 120,
          66: S
        }, {
          31: 121,
          66: S
        }, {
          31: 122,
          66: S
        }, {
          51: [1, 123],
          66: [2, 45]
        }, {
          5: [2, 38]
        }, {
          5: [2, 39]
        }, {
          5: [2, 40]
        }, {
          5: [2, 41]
        }, {
          5: [1, 124]
        }, {
          5: [1, 125]
        }, {
          5: [1, 126]
        }, t(C, [2, 26]), t(C, [2, 27]), t(C, [2, 28]), t(C, [2, 29]), {
          19: [1, 127]
        }, t(C, [2, 30]), {
          19: [1, 128]
        }, {
          31: 129,
          66: S
        }, {
          31: 130,
          66: S
        }, {
          5: [2, 50]
        }, {
          5: [2, 36]
        }, {
          5: [2, 37]
        }, {
          17: 131,
          57: T
        }, t(O, [2, 11]), t(C, [2, 12]), t(C, [2, 14]), t(M, a, {
          8: 95,
          37: 132
        }), t(N, a, {
          8: 97,
          39: 133
        }), {
          5: [2, 48]
        }, {
          5: [2, 49]
        }, {
          66: [2, 44]
        }, {
          33: [2, 35]
        }, {
          33: [2, 33]
        }],
        defaultActions: {
          7: [2, 61],
          8: [2, 1],
          9: [2, 2],
          10: [2, 3],
          45: [2, 64],
          58: [2, 60],
          75: [2, 46],
          76: [2, 47],
          83: [2, 63],
          104: [2, 38],
          105: [2, 39],
          106: [2, 40],
          107: [2, 41],
          120: [2, 50],
          121: [2, 36],
          122: [2, 37],
          129: [2, 48],
          130: [2, 49],
          131: [2, 44],
          132: [2, 35],
          133: [2, 33]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          L = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 67;

            case 1:
              return this.begin("type_directive"), 68;

            case 2:
              return this.popState(), this.begin("arg_directive"), 14;

            case 3:
              return this.popState(), this.popState(), 70;

            case 4:
              return 69;

            case 5:
            case 39:
            case 52:
              return 5;

            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
              break;

            case 11:
              return this.begin("ID"), 16;

            case 12:
              return this.begin("ID"), 20;

            case 13:
              return e.yytext = e.yytext.trim(), this.begin("ALIAS"), 57;

            case 14:
              return this.popState(), this.popState(), this.begin("LINE"), 18;

            case 15:
              return this.popState(), this.popState(), 5;

            case 16:
              return this.begin("LINE"), 32;

            case 17:
              return this.begin("LINE"), 34;

            case 18:
              return this.begin("LINE"), 35;

            case 19:
              return this.begin("LINE"), 36;

            case 20:
              return this.begin("LINE"), 41;

            case 21:
              return this.begin("LINE"), 38;

            case 22:
              return this.begin("LINE"), 40;

            case 23:
              return this.popState(), 19;

            case 24:
              return 33;

            case 25:
              return 52;

            case 26:
              return 53;

            case 27:
              return 46;

            case 28:
              return 47;

            case 29:
              return 48;

            case 30:
              return 49;

            case 31:
              return 44;

            case 32:
              return 42;

            case 33:
              return this.begin("ID"), 23;

            case 34:
              return this.begin("ID"), 24;

            case 35:
              return 30;

            case 36:
              return 7;

            case 37:
              return 22;

            case 38:
              return 51;

            case 40:
              return e.yytext = e.yytext.trim(), 57;

            case 41:
              return 60;

            case 42:
              return 61;

            case 43:
              return 58;

            case 44:
              return 59;

            case 45:
              return 62;

            case 46:
              return 63;

            case 47:
              return 64;

            case 48:
              return 65;

            case 49:
              return 66;

            case 50:
              return 55;

            case 51:
              return 56;

            case 53:
              return "INVALID";
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:((?!\n)\s)+)/i, /^(?:#[^\n]*)/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:participant\b)/i, /^(?:actor\b)/i, /^(?:[^\->:\n,;]+?(?=((?!\n)\s)+as(?!\n)\s|[#\n;]|$))/i, /^(?:as\b)/i, /^(?:(?:))/i, /^(?:loop\b)/i, /^(?:rect\b)/i, /^(?:opt\b)/i, /^(?:alt\b)/i, /^(?:else\b)/i, /^(?:par\b)/i, /^(?:and\b)/i, /^(?:(?:[:]?(?:no)?wrap)?[^#\n;]*)/i, /^(?:end\b)/i, /^(?:left of\b)/i, /^(?:right of\b)/i, /^(?:links\b)/i, /^(?:link\b)/i, /^(?:properties\b)/i, /^(?:details\b)/i, /^(?:over\b)/i, /^(?:note\b)/i, /^(?:activate\b)/i, /^(?:deactivate\b)/i, /^(?:title\b)/i, /^(?:sequenceDiagram\b)/i, /^(?:autonumber\b)/i, /^(?:,)/i, /^(?:;)/i, /^(?:[^\+\->:\n,;]+((?!(-x|--x|-\)|--\)))[\-]*[^\+\->:\n,;]+)*)/i, /^(?:->>)/i, /^(?:-->>)/i, /^(?:->)/i, /^(?:-->)/i, /^(?:-[x])/i, /^(?:--[x])/i, /^(?:-[\)])/i, /^(?:--[\)])/i, /^(?::(?:(?:no)?wrap)?[^#\n;]+)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:$)/i, /^(?:.)/i],
        conditions: {
          open_directive: {
            rules: [1, 8],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3, 8],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4, 8],
            inclusive: !1
          },
          ID: {
            rules: [7, 8, 13],
            inclusive: !1
          },
          ALIAS: {
            rules: [7, 8, 14, 15],
            inclusive: !1
          },
          LINE: {
            rules: [7, 8, 23],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 8, 9, 10, 11, 12, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
            inclusive: !0
          }
        }
      };

      function I() {
        this.yy = {};
      }

      return B.lexer = L, I.prototype = B, B.Parser = I, new I();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(1993).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  3584: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t14, e, n, r) {
        for (n = n || {}, r = _t14.length; r--; n[_t14[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 2],
          n = [1, 3],
          r = [1, 5],
          i = [1, 7],
          a = [2, 5],
          o = [1, 15],
          s = [1, 17],
          c = [1, 19],
          u = [1, 20],
          l = [1, 21],
          h = [1, 22],
          f = [1, 30],
          d = [1, 23],
          p = [1, 24],
          y = [1, 25],
          g = [1, 26],
          m = [1, 27],
          v = [1, 32],
          b = [1, 33],
          _ = [1, 34],
          x = [1, 35],
          w = [1, 31],
          k = [1, 38],
          T = [1, 4, 5, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
          E = [1, 4, 5, 12, 13, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
          C = [1, 4, 5, 7, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
          S = [4, 5, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
          A = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          SPACE: 4,
          NL: 5,
          directive: 6,
          SD: 7,
          document: 8,
          line: 9,
          statement: 10,
          idStatement: 11,
          DESCR: 12,
          "--\x3e": 13,
          HIDE_EMPTY: 14,
          scale: 15,
          WIDTH: 16,
          COMPOSIT_STATE: 17,
          STRUCT_START: 18,
          STRUCT_STOP: 19,
          STATE_DESCR: 20,
          AS: 21,
          ID: 22,
          FORK: 23,
          JOIN: 24,
          CHOICE: 25,
          CONCURRENT: 26,
          note: 27,
          notePosition: 28,
          NOTE_TEXT: 29,
          direction: 30,
          openDirective: 31,
          typeDirective: 32,
          closeDirective: 33,
          ":": 34,
          argDirective: 35,
          direction_tb: 36,
          direction_bt: 37,
          direction_rl: 38,
          direction_lr: 39,
          eol: 40,
          ";": 41,
          EDGE_STATE: 42,
          left_of: 43,
          right_of: 44,
          open_directive: 45,
          type_directive: 46,
          arg_directive: 47,
          close_directive: 48,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "SPACE",
          5: "NL",
          7: "SD",
          12: "DESCR",
          13: "--\x3e",
          14: "HIDE_EMPTY",
          15: "scale",
          16: "WIDTH",
          17: "COMPOSIT_STATE",
          18: "STRUCT_START",
          19: "STRUCT_STOP",
          20: "STATE_DESCR",
          21: "AS",
          22: "ID",
          23: "FORK",
          24: "JOIN",
          25: "CHOICE",
          26: "CONCURRENT",
          27: "note",
          29: "NOTE_TEXT",
          34: ":",
          36: "direction_tb",
          37: "direction_bt",
          38: "direction_rl",
          39: "direction_lr",
          41: ";",
          42: "EDGE_STATE",
          43: "left_of",
          44: "right_of",
          45: "open_directive",
          46: "type_directive",
          47: "arg_directive",
          48: "close_directive"
        },
        productions_: [0, [3, 2], [3, 2], [3, 2], [3, 2], [8, 0], [8, 2], [9, 2], [9, 1], [9, 1], [10, 1], [10, 2], [10, 3], [10, 4], [10, 1], [10, 2], [10, 1], [10, 4], [10, 3], [10, 6], [10, 1], [10, 1], [10, 1], [10, 1], [10, 4], [10, 4], [10, 1], [10, 1], [6, 3], [6, 5], [30, 1], [30, 1], [30, 1], [30, 1], [40, 1], [40, 1], [11, 1], [11, 1], [28, 1], [28, 1], [31, 1], [32, 1], [35, 1], [33, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 4:
              return r.setRootDoc(a[s]), a[s];

            case 5:
              this.$ = [];
              break;

            case 6:
              "nl" != a[s] && (a[s - 1].push(a[s]), this.$ = a[s - 1]);
              break;

            case 7:
            case 8:
            case 36:
            case 37:
              this.$ = a[s];
              break;

            case 9:
              this.$ = "nl";
              break;

            case 10:
              this.$ = {
                stmt: "state",
                id: a[s],
                type: "default",
                description: ""
              };
              break;

            case 11:
              this.$ = {
                stmt: "state",
                id: a[s - 1],
                type: "default",
                description: r.trimColon(a[s])
              };
              break;

            case 12:
              this.$ = {
                stmt: "relation",
                state1: {
                  stmt: "state",
                  id: a[s - 2],
                  type: "default",
                  description: ""
                },
                state2: {
                  stmt: "state",
                  id: a[s],
                  type: "default",
                  description: ""
                }
              };
              break;

            case 13:
              this.$ = {
                stmt: "relation",
                state1: {
                  stmt: "state",
                  id: a[s - 3],
                  type: "default",
                  description: ""
                },
                state2: {
                  stmt: "state",
                  id: a[s - 1],
                  type: "default",
                  description: ""
                },
                description: a[s].substr(1).trim()
              };
              break;

            case 17:
              this.$ = {
                stmt: "state",
                id: a[s - 3],
                type: "default",
                description: "",
                doc: a[s - 1]
              };
              break;

            case 18:
              var c = a[s],
                  u = a[s - 2].trim();

              if (a[s].match(":")) {
                var l = a[s].split(":");
                c = l[0], u = [u, l[1]];
              }

              this.$ = {
                stmt: "state",
                id: c,
                type: "default",
                description: u
              };
              break;

            case 19:
              this.$ = {
                stmt: "state",
                id: a[s - 3],
                type: "default",
                description: a[s - 5],
                doc: a[s - 1]
              };
              break;

            case 20:
              this.$ = {
                stmt: "state",
                id: a[s],
                type: "fork"
              };
              break;

            case 21:
              this.$ = {
                stmt: "state",
                id: a[s],
                type: "join"
              };
              break;

            case 22:
              this.$ = {
                stmt: "state",
                id: a[s],
                type: "choice"
              };
              break;

            case 23:
              this.$ = {
                stmt: "state",
                id: r.getDividerId(),
                type: "divider"
              };
              break;

            case 24:
              this.$ = {
                stmt: "state",
                id: a[s - 1].trim(),
                note: {
                  position: a[s - 2].trim(),
                  text: a[s].trim()
                }
              };
              break;

            case 30:
              r.setDirection("TB"), this.$ = {
                stmt: "dir",
                value: "TB"
              };
              break;

            case 31:
              r.setDirection("BT"), this.$ = {
                stmt: "dir",
                value: "BT"
              };
              break;

            case 32:
              r.setDirection("RL"), this.$ = {
                stmt: "dir",
                value: "RL"
              };
              break;

            case 33:
              r.setDirection("LR"), this.$ = {
                stmt: "dir",
                value: "LR"
              };
              break;

            case 40:
              r.parseDirective("%%{", "open_directive");
              break;

            case 41:
              r.parseDirective(a[s], "type_directive");
              break;

            case 42:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 43:
              r.parseDirective("}%%", "close_directive", "state");
          }
        },
        table: [{
          3: 1,
          4: e,
          5: n,
          6: 4,
          7: r,
          31: 6,
          45: i
        }, {
          1: [3]
        }, {
          3: 8,
          4: e,
          5: n,
          6: 4,
          7: r,
          31: 6,
          45: i
        }, {
          3: 9,
          4: e,
          5: n,
          6: 4,
          7: r,
          31: 6,
          45: i
        }, {
          3: 10,
          4: e,
          5: n,
          6: 4,
          7: r,
          31: 6,
          45: i
        }, t([1, 4, 5, 14, 15, 17, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45], a, {
          8: 11
        }), {
          32: 12,
          46: [1, 13]
        }, {
          46: [2, 40]
        }, {
          1: [2, 1]
        }, {
          1: [2, 2]
        }, {
          1: [2, 3]
        }, {
          1: [2, 4],
          4: o,
          5: s,
          6: 28,
          9: 14,
          10: 16,
          11: 18,
          14: c,
          15: u,
          17: l,
          20: h,
          22: f,
          23: d,
          24: p,
          25: y,
          26: g,
          27: m,
          30: 29,
          31: 6,
          36: v,
          37: b,
          38: _,
          39: x,
          42: w,
          45: i
        }, {
          33: 36,
          34: [1, 37],
          48: k
        }, t([34, 48], [2, 41]), t(T, [2, 6]), {
          6: 28,
          10: 39,
          11: 18,
          14: c,
          15: u,
          17: l,
          20: h,
          22: f,
          23: d,
          24: p,
          25: y,
          26: g,
          27: m,
          30: 29,
          31: 6,
          36: v,
          37: b,
          38: _,
          39: x,
          42: w,
          45: i
        }, t(T, [2, 8]), t(T, [2, 9]), t(T, [2, 10], {
          12: [1, 40],
          13: [1, 41]
        }), t(T, [2, 14]), {
          16: [1, 42]
        }, t(T, [2, 16], {
          18: [1, 43]
        }), {
          21: [1, 44]
        }, t(T, [2, 20]), t(T, [2, 21]), t(T, [2, 22]), t(T, [2, 23]), {
          28: 45,
          29: [1, 46],
          43: [1, 47],
          44: [1, 48]
        }, t(T, [2, 26]), t(T, [2, 27]), t(E, [2, 36]), t(E, [2, 37]), t(T, [2, 30]), t(T, [2, 31]), t(T, [2, 32]), t(T, [2, 33]), t(C, [2, 28]), {
          35: 49,
          47: [1, 50]
        }, t(C, [2, 43]), t(T, [2, 7]), t(T, [2, 11]), {
          11: 51,
          22: f,
          42: w
        }, t(T, [2, 15]), t(S, a, {
          8: 52
        }), {
          22: [1, 53]
        }, {
          22: [1, 54]
        }, {
          21: [1, 55]
        }, {
          22: [2, 38]
        }, {
          22: [2, 39]
        }, {
          33: 56,
          48: k
        }, {
          48: [2, 42]
        }, t(T, [2, 12], {
          12: [1, 57]
        }), {
          4: o,
          5: s,
          6: 28,
          9: 14,
          10: 16,
          11: 18,
          14: c,
          15: u,
          17: l,
          19: [1, 58],
          20: h,
          22: f,
          23: d,
          24: p,
          25: y,
          26: g,
          27: m,
          30: 29,
          31: 6,
          36: v,
          37: b,
          38: _,
          39: x,
          42: w,
          45: i
        }, t(T, [2, 18], {
          18: [1, 59]
        }), {
          29: [1, 60]
        }, {
          22: [1, 61]
        }, t(C, [2, 29]), t(T, [2, 13]), t(T, [2, 17]), t(S, a, {
          8: 62
        }), t(T, [2, 24]), t(T, [2, 25]), {
          4: o,
          5: s,
          6: 28,
          9: 14,
          10: 16,
          11: 18,
          14: c,
          15: u,
          17: l,
          19: [1, 63],
          20: h,
          22: f,
          23: d,
          24: p,
          25: y,
          26: g,
          27: m,
          30: 29,
          31: 6,
          36: v,
          37: b,
          38: _,
          39: x,
          42: w,
          45: i
        }, t(T, [2, 19])],
        defaultActions: {
          7: [2, 40],
          8: [2, 1],
          9: [2, 2],
          10: [2, 3],
          47: [2, 38],
          48: [2, 39],
          50: [2, 42]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          M = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
            case 26:
              return 36;

            case 1:
            case 27:
              return 37;

            case 2:
            case 28:
              return 38;

            case 3:
            case 29:
              return 39;

            case 4:
              return this.begin("open_directive"), 45;

            case 5:
              return this.begin("type_directive"), 46;

            case 6:
              return this.popState(), this.begin("arg_directive"), 34;

            case 7:
              return this.popState(), this.popState(), 48;

            case 8:
              return 47;

            case 9:
            case 10:
            case 12:
            case 13:
            case 14:
            case 15:
            case 39:
            case 45:
              break;

            case 11:
            case 59:
              return 5;

            case 16:
              return this.pushState("SCALE"), 15;

            case 17:
              return 16;

            case 18:
            case 33:
            case 36:
              this.popState();
              break;

            case 19:
              this.pushState("STATE");
              break;

            case 20:
            case 23:
              return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 23;

            case 21:
            case 24:
              return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 24;

            case 22:
            case 25:
              return this.popState(), e.yytext = e.yytext.slice(0, -10).trim(), 25;

            case 30:
              this.begin("STATE_STRING");
              break;

            case 31:
              return this.popState(), this.pushState("STATE_ID"), "AS";

            case 32:
            case 47:
              return this.popState(), "ID";

            case 34:
              return "STATE_DESCR";

            case 35:
              return 17;

            case 37:
              return this.popState(), this.pushState("struct"), 18;

            case 38:
              return this.popState(), 19;

            case 40:
              return this.begin("NOTE"), 27;

            case 41:
              return this.popState(), this.pushState("NOTE_ID"), 43;

            case 42:
              return this.popState(), this.pushState("NOTE_ID"), 44;

            case 43:
              this.popState(), this.pushState("FLOATING_NOTE");
              break;

            case 44:
              return this.popState(), this.pushState("FLOATING_NOTE_ID"), "AS";

            case 46:
              return "NOTE_TEXT";

            case 48:
              return this.popState(), this.pushState("NOTE_TEXT"), 22;

            case 49:
              return this.popState(), e.yytext = e.yytext.substr(2).trim(), 29;

            case 50:
              return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 29;

            case 51:
            case 52:
              return 7;

            case 53:
              return 14;

            case 54:
              return 42;

            case 55:
              return 22;

            case 56:
              return e.yytext = e.yytext.trim(), 12;

            case 57:
              return 13;

            case 58:
              return 26;

            case 60:
              return "INVALID";
          }
        },
        rules: [/^(?:.*direction\s+TB[^\n]*)/i, /^(?:.*direction\s+BT[^\n]*)/i, /^(?:.*direction\s+RL[^\n]*)/i, /^(?:.*direction\s+LR[^\n]*)/i, /^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:[\s]+)/i, /^(?:((?!\n)\s)+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:scale\s+)/i, /^(?:\d+)/i, /^(?:\s+width\b)/i, /^(?:state\s+)/i, /^(?:.*<<fork>>)/i, /^(?:.*<<join>>)/i, /^(?:.*<<choice>>)/i, /^(?:.*\[\[fork\]\])/i, /^(?:.*\[\[join\]\])/i, /^(?:.*\[\[choice\]\])/i, /^(?:.*direction\s+TB[^\n]*)/i, /^(?:.*direction\s+BT[^\n]*)/i, /^(?:.*direction\s+RL[^\n]*)/i, /^(?:.*direction\s+LR[^\n]*)/i, /^(?:["])/i, /^(?:\s*as\s+)/i, /^(?:[^\n\{]*)/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[^\n\s\{]+)/i, /^(?:\n)/i, /^(?:\{)/i, /^(?:\})/i, /^(?:[\n])/i, /^(?:note\s+)/i, /^(?:left of\b)/i, /^(?:right of\b)/i, /^(?:")/i, /^(?:\s*as\s*)/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[^\n]*)/i, /^(?:\s*[^:\n\s\-]+)/i, /^(?:\s*:[^:\n;]+)/i, /^(?:[\s\S]*?end note\b)/i, /^(?:stateDiagram\s+)/i, /^(?:stateDiagram-v2\s+)/i, /^(?:hide empty description\b)/i, /^(?:\[\*\])/i, /^(?:[^:\n\s\-\{]+)/i, /^(?:\s*:[^:\n;]+)/i, /^(?:-->)/i, /^(?:--)/i, /^(?:$)/i, /^(?:.)/i],
        conditions: {
          LINE: {
            rules: [13, 14],
            inclusive: !1
          },
          close_directive: {
            rules: [13, 14],
            inclusive: !1
          },
          arg_directive: {
            rules: [7, 8, 13, 14],
            inclusive: !1
          },
          type_directive: {
            rules: [6, 7, 13, 14],
            inclusive: !1
          },
          open_directive: {
            rules: [5, 13, 14],
            inclusive: !1
          },
          struct: {
            rules: [13, 14, 19, 26, 27, 28, 29, 38, 39, 40, 54, 55, 56, 57, 58],
            inclusive: !1
          },
          FLOATING_NOTE_ID: {
            rules: [47],
            inclusive: !1
          },
          FLOATING_NOTE: {
            rules: [44, 45, 46],
            inclusive: !1
          },
          NOTE_TEXT: {
            rules: [49, 50],
            inclusive: !1
          },
          NOTE_ID: {
            rules: [48],
            inclusive: !1
          },
          NOTE: {
            rules: [41, 42, 43],
            inclusive: !1
          },
          SCALE: {
            rules: [17, 18],
            inclusive: !1
          },
          ALIAS: {
            rules: [],
            inclusive: !1
          },
          STATE_ID: {
            rules: [32],
            inclusive: !1
          },
          STATE_STRING: {
            rules: [33, 34],
            inclusive: !1
          },
          FORK_STATE: {
            rules: [],
            inclusive: !1
          },
          STATE: {
            rules: [13, 14, 20, 21, 22, 23, 24, 25, 30, 31, 35, 36, 37],
            inclusive: !1
          },
          ID: {
            rules: [13, 14],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 9, 10, 11, 12, 14, 15, 16, 19, 37, 40, 51, 52, 53, 54, 55, 56, 57, 59, 60],
            inclusive: !0
          }
        }
      };

      function N() {
        this.yy = {};
      }

      return A.lexer = M, N.prototype = A, A.Parser = N, new N();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(3069).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  9763: function _(t, e, n) {
    t = n.nmd(t);

    var r = function () {
      var t = function t(_t15, e, n, r) {
        for (n = n || {}, r = _t15.length; r--; n[_t15[r]] = e) {
          ;
        }

        return n;
      },
          e = [1, 2],
          n = [1, 5],
          r = [6, 9, 11, 17, 18, 19, 21],
          i = [1, 15],
          a = [1, 16],
          o = [1, 17],
          s = [1, 21],
          c = [4, 6, 9, 11, 17, 18, 19, 21],
          u = {
        trace: function trace() {},
        yy: {},
        symbols_: {
          error: 2,
          start: 3,
          journey: 4,
          document: 5,
          EOF: 6,
          directive: 7,
          line: 8,
          SPACE: 9,
          statement: 10,
          NEWLINE: 11,
          openDirective: 12,
          typeDirective: 13,
          closeDirective: 14,
          ":": 15,
          argDirective: 16,
          title: 17,
          section: 18,
          taskName: 19,
          taskData: 20,
          open_directive: 21,
          type_directive: 22,
          arg_directive: 23,
          close_directive: 24,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "journey",
          6: "EOF",
          9: "SPACE",
          11: "NEWLINE",
          15: ":",
          17: "title",
          18: "section",
          19: "taskName",
          20: "taskData",
          21: "open_directive",
          22: "type_directive",
          23: "arg_directive",
          24: "close_directive"
        },
        productions_: [0, [3, 3], [3, 2], [5, 0], [5, 2], [8, 2], [8, 1], [8, 1], [8, 1], [7, 4], [7, 6], [10, 1], [10, 1], [10, 2], [10, 1], [12, 1], [13, 1], [16, 1], [14, 1]],
        performAction: function performAction(t, e, n, r, i, a, o) {
          var s = a.length - 1;

          switch (i) {
            case 1:
              return a[s - 1];

            case 3:
            case 7:
            case 8:
              this.$ = [];
              break;

            case 4:
              a[s - 1].push(a[s]), this.$ = a[s - 1];
              break;

            case 5:
            case 6:
              this.$ = a[s];
              break;

            case 11:
              r.setTitle(a[s].substr(6)), this.$ = a[s].substr(6);
              break;

            case 12:
              r.addSection(a[s].substr(8)), this.$ = a[s].substr(8);
              break;

            case 13:
              r.addTask(a[s - 1], a[s]), this.$ = "task";
              break;

            case 15:
              r.parseDirective("%%{", "open_directive");
              break;

            case 16:
              r.parseDirective(a[s], "type_directive");
              break;

            case 17:
              a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
              break;

            case 18:
              r.parseDirective("}%%", "close_directive", "journey");
          }
        },
        table: [{
          3: 1,
          4: e,
          7: 3,
          12: 4,
          21: n
        }, {
          1: [3]
        }, t(r, [2, 3], {
          5: 6
        }), {
          3: 7,
          4: e,
          7: 3,
          12: 4,
          21: n
        }, {
          13: 8,
          22: [1, 9]
        }, {
          22: [2, 15]
        }, {
          6: [1, 10],
          7: 18,
          8: 11,
          9: [1, 12],
          10: 13,
          11: [1, 14],
          12: 4,
          17: i,
          18: a,
          19: o,
          21: n
        }, {
          1: [2, 2]
        }, {
          14: 19,
          15: [1, 20],
          24: s
        }, t([15, 24], [2, 16]), t(r, [2, 8], {
          1: [2, 1]
        }), t(r, [2, 4]), {
          7: 18,
          10: 22,
          12: 4,
          17: i,
          18: a,
          19: o,
          21: n
        }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 11]), t(r, [2, 12]), {
          20: [1, 23]
        }, t(r, [2, 14]), {
          11: [1, 24]
        }, {
          16: 25,
          23: [1, 26]
        }, {
          11: [2, 18]
        }, t(r, [2, 5]), t(r, [2, 13]), t(c, [2, 9]), {
          14: 27,
          24: s
        }, {
          24: [2, 17]
        }, {
          11: [1, 28]
        }, t(c, [2, 10])],
        defaultActions: {
          5: [2, 15],
          7: [2, 2],
          21: [2, 18],
          26: [2, 17]
        },
        parseError: function parseError(t, e) {
          if (!e.recoverable) {
            var n = new Error(t);
            throw n.hash = e, n;
          }

          this.trace(t);
        },
        parse: function parse(t) {
          var e = this,
              n = [0],
              r = [],
              i = [null],
              a = [],
              o = this.table,
              s = "",
              c = 0,
              u = 0,
              l = 0,
              h = 2,
              f = 1,
              d = a.slice.call(arguments, 1),
              p = Object.create(this.lexer),
              y = {
            yy: {}
          };

          for (var g in this.yy) {
            Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
          }

          p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
          var m = p.yylloc;
          a.push(m);
          var v = p.options && p.options.ranges;

          function b() {
            var t;
            return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
          }

          "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

          for (var _, x, w, k, T, E, C, S, A, M = {};;) {
            if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
              var N = "";

              for (E in A = [], o[w]) {
                this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
              }

              N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                text: p.match,
                token: this.terminals_[_] || _,
                line: p.yylineno,
                loc: m,
                expected: A
              });
            }

            if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

            switch (k[0]) {
              case 1:
                n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0);
                break;

              case 2:
                if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                  first_line: a[a.length - (C || 1)].first_line,
                  last_line: a[a.length - 1].last_line,
                  first_column: a[a.length - (C || 1)].first_column,
                  last_column: a[a.length - 1].last_column
                }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      },
          l = {
        EOF: 1,
        parseError: function parseError(t, e) {
          if (!this.yy.parser) throw new Error(t);
          this.yy.parser.parseError(t, e);
        },
        setInput: function setInput(t, e) {
          return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
        },
        input: function input() {
          var t = this._input[0];
          return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
        },
        unput: function unput(t) {
          var e = t.length,
              n = t.split(/(?:\r\n?|\n)/g);
          this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
          var r = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
          var i = this.yylloc.range;
          return this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
          }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
        },
        more: function more() {
          return this._more = !0, this;
        },
        reject: function reject() {
          return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        less: function less(t) {
          this.unput(this.match.slice(t));
        },
        pastInput: function pastInput() {
          var t = this.matched.substr(0, this.matched.length - this.match.length);
          return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function upcomingInput() {
          var t = this.match;
          return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function showPosition() {
          var t = this.pastInput(),
              e = new Array(t.length + 1).join("-");
          return t + this.upcomingInput() + "\n" + e + "^";
        },
        test_match: function test_match(t, e) {
          var n, r, i;
          if (this.options.backtrack_lexer && (i = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
          }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

          if (this._backtrack) {
            for (var a in i) {
              this[a] = i[a];
            }

            return !1;
          }

          return !1;
        },
        next: function next() {
          if (this.done) return this.EOF;
          var t, e, n, r;
          this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

          for (var i = this._currentRules(), a = 0; a < i.length; a++) {
            if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
              if (e = n, r = a, this.options.backtrack_lexer) {
                if (!1 !== (t = this.test_match(n, i[a]))) return t;

                if (this._backtrack) {
                  e = !1;
                  continue;
                }

                return !1;
              }

              if (!this.options.flex) break;
            }
          }

          return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        },
        lex: function lex() {
          return this.next() || this.lex();
        },
        begin: function begin(t) {
          this.conditionStack.push(t);
        },
        popState: function popState() {
          return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
        },
        _currentRules: function _currentRules() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
        },
        topState: function topState(t) {
          return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
        },
        pushState: function pushState(t) {
          this.begin(t);
        },
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {
          "case-insensitive": !0
        },
        performAction: function performAction(t, e, n, r) {
          switch (n) {
            case 0:
              return this.begin("open_directive"), 21;

            case 1:
              return this.begin("type_directive"), 22;

            case 2:
              return this.popState(), this.begin("arg_directive"), 15;

            case 3:
              return this.popState(), this.popState(), 24;

            case 4:
              return 23;

            case 5:
            case 6:
            case 8:
            case 9:
              break;

            case 7:
              return 11;

            case 10:
              return 4;

            case 11:
              return 17;

            case 12:
              return 18;

            case 13:
              return 19;

            case 14:
              return 20;

            case 15:
              return 15;

            case 16:
              return 6;

            case 17:
              return "INVALID";
          }
        },
        rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:journey\b)/i, /^(?:title\s[^#\n;]+)/i, /^(?:section\s[^#:\n;]+)/i, /^(?:[^#:\n;]+)/i, /^(?::[^#\n;]+)/i, /^(?::)/i, /^(?:$)/i, /^(?:.)/i],
        conditions: {
          open_directive: {
            rules: [1],
            inclusive: !1
          },
          type_directive: {
            rules: [2, 3],
            inclusive: !1
          },
          arg_directive: {
            rules: [3, 4],
            inclusive: !1
          },
          INITIAL: {
            rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            inclusive: !0
          }
        }
      };

      function h() {
        this.yy = {};
      }

      return u.lexer = l, h.prototype = u, u.Parser = h, new h();
    }();

    e.parser = r, e.Parser = r.Parser, e.parse = function () {
      return r.parse.apply(r, arguments);
    }, e.main = function (t) {
      t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
      var r = n(9143).readFileSync(n(6470).normalize(t[1]), "utf8");
      return e.parser.parse(r);
    }, n.c[n.s] === t && e.main(process.argv.slice(1));
  },
  9609: function _(t) {
    var e = /^(%20|\s)*(javascript|data)/im,
        n = /[^\x20-\x7E]/gim,
        r = /^([^:]+):/gm,
        i = [".", "/"];
    t.exports = {
      sanitizeUrl: function sanitizeUrl(t) {
        if (!t) return "about:blank";
        var a,
            o,
            s = t.replace(n, "").trim();
        return function (t) {
          return i.indexOf(t[0]) > -1;
        }(s) ? s : (o = s.match(r)) ? (a = o[0], e.test(a) ? "about:blank" : s) : "about:blank";
      }
    };
  },
  3841: function _(t) {
    t.exports = function (t, e) {
      return t.intersect(e);
    };
  },
  7458: function _(t, e, n) {
    n.d(e, {
      Z: function Z() {
        return fC;
      }
    });

    var r = n(1941),
        i = n.n(r),
        a = {
      debug: 1,
      info: 2,
      warn: 3,
      error: 4,
      fatal: 5
    },
        o = {
      debug: function debug() {},
      info: function info() {},
      warn: function warn() {},
      error: function error() {},
      fatal: function fatal() {}
    },
        s = function s() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "fatal";
      isNaN(t) && (t = t.toLowerCase(), void 0 !== a[t] && (t = a[t])), o.trace = function () {}, o.debug = function () {}, o.info = function () {}, o.warn = function () {}, o.error = function () {}, o.fatal = function () {}, t <= a.fatal && (o.fatal = console.error ? console.error.bind(console, c("FATAL"), "color: orange") : console.log.bind(console, "[35m", c("FATAL"))), t <= a.error && (o.error = console.error ? console.error.bind(console, c("ERROR"), "color: orange") : console.log.bind(console, "[31m", c("ERROR"))), t <= a.warn && (o.warn = console.warn ? console.warn.bind(console, c("WARN"), "color: orange") : console.log.bind(console, "[33m", c("WARN"))), t <= a.info && (o.info = console.info ? console.info.bind(console, c("INFO"), "color: lightblue") : console.log.bind(console, "[34m", c("INFO"))), t <= a.debug && (o.debug = console.debug ? console.debug.bind(console, c("DEBUG"), "color: lightgreen") : console.log.bind(console, "[32m", c("DEBUG")));
    },
        c = function c(t) {
      var e = i()().format("ss.SSS");
      return "%c".concat(e, " : ").concat(t, " : ");
    };

    function u(t, e) {
      var n;

      if (void 0 === e) {
        var _iterator33 = _createForOfIteratorHelper(t),
            _step33;

        try {
          for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
            var _e2 = _step33.value;
            null != _e2 && (n < _e2 || void 0 === n && _e2 >= _e2) && (n = _e2);
          }
        } catch (err) {
          _iterator33.e(err);
        } finally {
          _iterator33.f();
        }
      } else {
        var _r2 = -1;

        var _iterator34 = _createForOfIteratorHelper(t),
            _step34;

        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _i20 = _step34.value;
            null != (_i20 = e(_i20, ++_r2, t)) && (n < _i20 || void 0 === n && _i20 >= _i20) && (n = _i20);
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
      }

      return n;
    }

    function l(t, e) {
      var n;

      if (void 0 === e) {
        var _iterator35 = _createForOfIteratorHelper(t),
            _step35;

        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _e3 = _step35.value;
            null != _e3 && (n > _e3 || void 0 === n && _e3 >= _e3) && (n = _e3);
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
      } else {
        var _r3 = -1;

        var _iterator36 = _createForOfIteratorHelper(t),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _i21 = _step36.value;
            null != (_i21 = e(_i21, ++_r3, t)) && (n > _i21 || void 0 === n && _i21 >= _i21) && (n = _i21);
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      }

      return n;
    }

    function h(t) {
      return t;
    }

    var f = 1e-6;

    function d(t) {
      return "translate(" + t + ",0)";
    }

    function p(t) {
      return "translate(0," + t + ")";
    }

    function y(t) {
      return function (e) {
        return +t(e);
      };
    }

    function g(t, e) {
      return e = Math.max(0, t.bandwidth() - 2 * e) / 2, t.round() && (e = Math.round(e)), function (n) {
        return +t(n) + e;
      };
    }

    function m() {
      return !this.__axis;
    }

    function v(t, e) {
      var n = [],
          r = null,
          i = null,
          a = 6,
          o = 6,
          s = 3,
          c = "undefined" != typeof window && window.devicePixelRatio > 1 ? 0 : .5,
          u = 1 === t || 4 === t ? -1 : 1,
          l = 4 === t || 2 === t ? "x" : "y",
          v = 1 === t || 3 === t ? d : p;

      function b(d) {
        var p = null == r ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r,
            b = null == i ? e.tickFormat ? e.tickFormat.apply(e, n) : h : i,
            _ = Math.max(a, 0) + s,
            x = e.range(),
            w = +x[0] + c,
            k = +x[x.length - 1] + c,
            T = (e.bandwidth ? g : y)(e.copy(), c),
            E = d.selection ? d.selection() : d,
            C = E.selectAll(".domain").data([null]),
            S = E.selectAll(".tick").data(p, e).order(),
            A = S.exit(),
            M = S.enter().append("g").attr("class", "tick"),
            N = S.select("line"),
            D = S.select("text");

        C = C.merge(C.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), S = S.merge(M), N = N.merge(M.append("line").attr("stroke", "currentColor").attr(l + "2", u * a)), D = D.merge(M.append("text").attr("fill", "currentColor").attr(l, u * _).attr("dy", 1 === t ? "0em" : 3 === t ? "0.71em" : "0.32em")), d !== E && (C = C.transition(d), S = S.transition(d), N = N.transition(d), D = D.transition(d), A = A.transition(d).attr("opacity", f).attr("transform", function (t) {
          return isFinite(t = T(t)) ? v(t + c) : this.getAttribute("transform");
        }), M.attr("opacity", f).attr("transform", function (t) {
          var e = this.parentNode.__axis;
          return v((e && isFinite(e = e(t)) ? e : T(t)) + c);
        })), A.remove(), C.attr("d", 4 === t || 2 === t ? o ? "M" + u * o + "," + w + "H" + c + "V" + k + "H" + u * o : "M" + c + "," + w + "V" + k : o ? "M" + w + "," + u * o + "V" + c + "H" + k + "V" + u * o : "M" + w + "," + c + "H" + k), S.attr("opacity", 1).attr("transform", function (t) {
          return v(T(t) + c);
        }), N.attr(l + "2", u * a), D.attr(l, u * _).text(b), E.filter(m).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === t ? "start" : 4 === t ? "end" : "middle"), E.each(function () {
          this.__axis = T;
        });
      }

      return b.scale = function (t) {
        return arguments.length ? (e = t, b) : e;
      }, b.ticks = function () {
        return n = Array.from(arguments), b;
      }, b.tickArguments = function (t) {
        return arguments.length ? (n = null == t ? [] : Array.from(t), b) : n.slice();
      }, b.tickValues = function (t) {
        return arguments.length ? (r = null == t ? null : Array.from(t), b) : r && r.slice();
      }, b.tickFormat = function (t) {
        return arguments.length ? (i = t, b) : i;
      }, b.tickSize = function (t) {
        return arguments.length ? (a = o = +t, b) : a;
      }, b.tickSizeInner = function (t) {
        return arguments.length ? (a = +t, b) : a;
      }, b.tickSizeOuter = function (t) {
        return arguments.length ? (o = +t, b) : o;
      }, b.tickPadding = function (t) {
        return arguments.length ? (s = +t, b) : s;
      }, b.offset = function (t) {
        return arguments.length ? (c = +t, b) : c;
      }, b;
    }

    function b() {}

    function _(t) {
      return null == t ? b : function () {
        return this.querySelector(t);
      };
    }

    function x(t) {
      return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
    }

    function w() {
      return [];
    }

    function k(t) {
      return null == t ? w : function () {
        return this.querySelectorAll(t);
      };
    }

    function T(t) {
      return function () {
        return this.matches(t);
      };
    }

    function E(t) {
      return function (e) {
        return e.matches(t);
      };
    }

    var C = Array.prototype.find;

    function S() {
      return this.firstElementChild;
    }

    var A = Array.prototype.filter;

    function M() {
      return Array.from(this.children);
    }

    function N(t) {
      return new Array(t.length);
    }

    function D(t, e) {
      this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
    }

    function O(t) {
      return function () {
        return t;
      };
    }

    function B(t, e, n, r, i, a) {
      for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
        (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new D(t, a[s]);
      }

      for (; s < c; ++s) {
        (o = e[s]) && (i[s] = o);
      }
    }

    function L(t, e, n, r, i, a, o) {
      var s,
          c,
          u,
          l = new Map(),
          h = e.length,
          f = a.length,
          d = new Array(h);

      for (s = 0; s < h; ++s) {
        (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
      }

      for (s = 0; s < f; ++s) {
        u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l["delete"](u)) : n[s] = new D(t, a[s]);
      }

      for (s = 0; s < h; ++s) {
        (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
      }
    }

    function I(t) {
      return t.__data__;
    }

    function R(t) {
      return "object" == _typeof(t) && "length" in t ? t : Array.from(t);
    }

    function F(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    D.prototype = {
      constructor: D,
      appendChild: function appendChild(t) {
        return this._parent.insertBefore(t, this._next);
      },
      insertBefore: function insertBefore(t, e) {
        return this._parent.insertBefore(t, e);
      },
      querySelector: function querySelector(t) {
        return this._parent.querySelector(t);
      },
      querySelectorAll: function querySelectorAll(t) {
        return this._parent.querySelectorAll(t);
      }
    };
    var P = "http://www.w3.org/1999/xhtml";
    var j = {
      svg: "http://www.w3.org/2000/svg",
      xhtml: P,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };

    function Y(t) {
      var e = t += "",
          n = e.indexOf(":");
      return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), j.hasOwnProperty(e) ? {
        space: j[e],
        local: t
      } : t;
    }

    function z(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function U(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function q(t, e) {
      return function () {
        this.setAttribute(t, e);
      };
    }

    function H(t, e) {
      return function () {
        this.setAttributeNS(t.space, t.local, e);
      };
    }

    function $(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
      };
    }

    function W(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
      };
    }

    function V(t) {
      return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
    }

    function G(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function X(t, e, n) {
      return function () {
        this.style.setProperty(t, e, n);
      };
    }

    function Z(t, e, n) {
      return function () {
        var r = e.apply(this, arguments);
        null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
      };
    }

    function Q(t, e) {
      return t.style.getPropertyValue(e) || V(t).getComputedStyle(t, null).getPropertyValue(e);
    }

    function K(t) {
      return function () {
        delete this[t];
      };
    }

    function J(t, e) {
      return function () {
        this[t] = e;
      };
    }

    function tt(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? delete this[t] : this[t] = n;
      };
    }

    function et(t) {
      return t.trim().split(/^|\s+/);
    }

    function nt(t) {
      return t.classList || new rt(t);
    }

    function rt(t) {
      this._node = t, this._names = et(t.getAttribute("class") || "");
    }

    function it(t, e) {
      for (var n = nt(t), r = -1, i = e.length; ++r < i;) {
        n.add(e[r]);
      }
    }

    function at(t, e) {
      for (var n = nt(t), r = -1, i = e.length; ++r < i;) {
        n.remove(e[r]);
      }
    }

    function ot(t) {
      return function () {
        it(this, t);
      };
    }

    function st(t) {
      return function () {
        at(this, t);
      };
    }

    function ct(t, e) {
      return function () {
        (e.apply(this, arguments) ? it : at)(this, t);
      };
    }

    function ut() {
      this.textContent = "";
    }

    function lt(t) {
      return function () {
        this.textContent = t;
      };
    }

    function ht(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.textContent = null == e ? "" : e;
      };
    }

    function ft() {
      this.innerHTML = "";
    }

    function dt(t) {
      return function () {
        this.innerHTML = t;
      };
    }

    function pt(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.innerHTML = null == e ? "" : e;
      };
    }

    function yt() {
      this.nextSibling && this.parentNode.appendChild(this);
    }

    function gt() {
      this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }

    function mt(t) {
      return function () {
        var e = this.ownerDocument,
            n = this.namespaceURI;
        return n === P && e.documentElement.namespaceURI === P ? e.createElement(t) : e.createElementNS(n, t);
      };
    }

    function vt(t) {
      return function () {
        return this.ownerDocument.createElementNS(t.space, t.local);
      };
    }

    function bt(t) {
      var e = Y(t);
      return (e.local ? vt : mt)(e);
    }

    function _t() {
      return null;
    }

    function xt() {
      var t = this.parentNode;
      t && t.removeChild(this);
    }

    function wt() {
      var t = this.cloneNode(!1),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function kt() {
      var t = this.cloneNode(!0),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function Tt(t) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var e = "",
            n = t.indexOf(".");
        return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
          type: t,
          name: e
        };
      });
    }

    function Et(t) {
      return function () {
        var e = this.__on;

        if (e) {
          for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
            n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
          }

          ++i ? e.length = i : delete this.__on;
        }
      };
    }

    function Ct(t, e, n) {
      return function () {
        var r,
            i = this.__on,
            a = function (t) {
          return function (e) {
            t.call(this, e, this.__data__);
          };
        }(e);

        if (i) for (var o = 0, s = i.length; o < s; ++o) {
          if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
        }
        this.addEventListener(t.type, a, n), r = {
          type: t.type,
          name: t.name,
          value: e,
          listener: a,
          options: n
        }, i ? i.push(r) : this.__on = [r];
      };
    }

    function St(t, e, n) {
      var r = V(t),
          i = r.CustomEvent;
      "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
    }

    function At(t, e) {
      return function () {
        return St(this, t, e);
      };
    }

    function Mt(t, e) {
      return function () {
        return St(this, t, e.apply(this, arguments));
      };
    }

    rt.prototype = {
      add: function add(t) {
        this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
      },
      remove: function remove(t) {
        var e = this._names.indexOf(t);

        e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
      },
      contains: function contains(t) {
        return this._names.indexOf(t) >= 0;
      }
    };
    var Nt = [null];

    function Dt(t, e) {
      this._groups = t, this._parents = e;
    }

    function Ot() {
      return new Dt([[document.documentElement]], Nt);
    }

    Dt.prototype = Ot.prototype = _defineProperty2({
      constructor: Dt,
      select: function select(t) {
        "function" != typeof t && (t = _(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
            (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
          }
        }

        return new Dt(r, this._parents);
      },
      selectAll: function selectAll(t) {
        t = "function" == typeof t ? function (t) {
          return function () {
            return x(t.apply(this, arguments));
          };
        }(t) : k(t);

        for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
          for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
            (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
          }
        }

        return new Dt(r, i);
      },
      selectChild: function selectChild(t) {
        return this.select(null == t ? S : function (t) {
          return function () {
            return C.call(this.children, t);
          };
        }("function" == typeof t ? t : E(t)));
      },
      selectChildren: function selectChildren(t) {
        return this.selectAll(null == t ? M : function (t) {
          return function () {
            return A.call(this.children, t);
          };
        }("function" == typeof t ? t : E(t)));
      },
      filter: function filter(t) {
        "function" != typeof t && (t = T(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new Dt(r, this._parents);
      },
      data: function data(t, e) {
        if (!arguments.length) return Array.from(this, I);
        var n = e ? L : B,
            r = this._parents,
            i = this._groups;
        "function" != typeof t && (t = O(t));

        for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
          var l = r[u],
              h = i[u],
              f = h.length,
              d = R(t.call(l, l && l.__data__, u, r)),
              p = d.length,
              y = s[u] = new Array(p),
              g = o[u] = new Array(p),
              m = c[u] = new Array(f);
          n(l, h, y, g, m, d, e);

          for (var v, b, _ = 0, x = 0; _ < p; ++_) {
            if (v = y[_]) {
              for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                ;
              }

              v._next = b || null;
            }
          }
        }

        return (o = new Dt(o, r))._enter = s, o._exit = c, o;
      },
      enter: function enter() {
        return new Dt(this._enter || this._groups.map(N), this._parents);
      },
      exit: function exit() {
        return new Dt(this._exit || this._groups.map(N), this._parents);
      },
      join: function join(t, e, n) {
        var r = this.enter(),
            i = this,
            a = this.exit();
        return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
      },
      merge: function merge(t) {
        for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
          for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
            (u = l[p] || h[p]) && (d[p] = u);
          }
        }

        for (; c < i; ++c) {
          s[c] = n[c];
        }

        return new Dt(s, this._parents);
      },
      selection: function selection() {
        return this;
      },
      order: function order() {
        for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
          for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
            (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
          }
        }

        return this;
      },
      sort: function sort(t) {
        function e(e, n) {
          return e && n ? t(e.__data__, n.__data__) : !e - !n;
        }

        t || (t = F);

        for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
          for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
            (o = s[l]) && (u[l] = o);
          }

          u.sort(e);
        }

        return new Dt(i, this._parents).order();
      },
      call: function call() {
        var t = arguments[0];
        return arguments[0] = this, t.apply(null, arguments), this;
      },
      nodes: function nodes() {
        return Array.from(this);
      },
      node: function node() {
        for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
          for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
            var o = r[i];
            if (o) return o;
          }
        }

        return null;
      },
      size: function size() {
        var t = 0;

        var _iterator37 = _createForOfIteratorHelper(this),
            _step37;

        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var _e4 = _step37.value;
            ++t;
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }

        return t;
      },
      empty: function empty() {
        return !this.node();
      },
      each: function each(t) {
        for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
          for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
            (i = a[o]) && t.call(i, i.__data__, o, a);
          }
        }

        return this;
      },
      attr: function attr(t, e) {
        var n = Y(t);

        if (arguments.length < 2) {
          var r = this.node();
          return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
        }

        return this.each((null == e ? n.local ? U : z : "function" == typeof e ? n.local ? W : $ : n.local ? H : q)(n, e));
      },
      style: function style(t, e, n) {
        return arguments.length > 1 ? this.each((null == e ? G : "function" == typeof e ? Z : X)(t, e, null == n ? "" : n)) : Q(this.node(), t);
      },
      property: function property(t, e) {
        return arguments.length > 1 ? this.each((null == e ? K : "function" == typeof e ? tt : J)(t, e)) : this.node()[t];
      },
      classed: function classed(t, e) {
        var n = et(t + "");

        if (arguments.length < 2) {
          for (var r = nt(this.node()), i = -1, a = n.length; ++i < a;) {
            if (!r.contains(n[i])) return !1;
          }

          return !0;
        }

        return this.each(("function" == typeof e ? ct : e ? ot : st)(n, e));
      },
      text: function text(t) {
        return arguments.length ? this.each(null == t ? ut : ("function" == typeof t ? ht : lt)(t)) : this.node().textContent;
      },
      html: function html(t) {
        return arguments.length ? this.each(null == t ? ft : ("function" == typeof t ? pt : dt)(t)) : this.node().innerHTML;
      },
      raise: function raise() {
        return this.each(yt);
      },
      lower: function lower() {
        return this.each(gt);
      },
      append: function append(t) {
        var e = "function" == typeof t ? t : bt(t);
        return this.select(function () {
          return this.appendChild(e.apply(this, arguments));
        });
      },
      insert: function insert(t, e) {
        var n = "function" == typeof t ? t : bt(t),
            r = null == e ? _t : "function" == typeof e ? e : _(e);
        return this.select(function () {
          return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
        });
      },
      remove: function remove() {
        return this.each(xt);
      },
      clone: function clone(t) {
        return this.select(t ? kt : wt);
      },
      datum: function datum(t) {
        return arguments.length ? this.property("__data__", t) : this.node().__data__;
      },
      on: function on(t, e, n) {
        var r,
            i,
            a = Tt(t + ""),
            o = a.length;

        if (!(arguments.length < 2)) {
          for (s = e ? Ct : Et, r = 0; r < o; ++r) {
            this.each(s(a[r], e, n));
          }

          return this;
        }

        var s = this.node().__on;

        if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
          for (r = 0, c = s[u]; r < o; ++r) {
            if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
          }
        }
      },
      dispatch: function dispatch(t, e) {
        return this.each(("function" == typeof e ? Mt : At)(t, e));
      }
    }, Symbol.iterator, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var t, e, n, r, i, a, o;
      return regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              t = this._groups, e = 0, n = t.length;

            case 1:
              if (!(e < n)) {
                _context4.next = 14;
                break;
              }

              i = t[e], a = 0, o = i.length;

            case 3:
              if (!(a < o)) {
                _context4.next = 11;
                break;
              }

              _context4.t0 = r = i[a];

              if (!_context4.t0) {
                _context4.next = 8;
                break;
              }

              _context4.next = 8;
              return r;

            case 8:
              ++a;
              _context4.next = 3;
              break;

            case 11:
              ++e;
              _context4.next = 1;
              break;

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3, this);
    }));
    var Bt = Ot;
    var Lt = {
      value: function value() {}
    };

    function It() {
      for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
        if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        r[t] = [];
      }

      return new Rt(r);
    }

    function Rt(t) {
      this._ = t;
    }

    function Ft(t, e) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var n = "",
            r = t.indexOf(".");
        if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: n
        };
      });
    }

    function Pt(t, e) {
      for (var n, r = 0, i = t.length; r < i; ++r) {
        if ((n = t[r]).name === e) return n.value;
      }
    }

    function jt(t, e, n) {
      for (var r = 0, i = t.length; r < i; ++r) {
        if (t[r].name === e) {
          t[r] = Lt, t = t.slice(0, r).concat(t.slice(r + 1));
          break;
        }
      }

      return null != n && t.push({
        name: e,
        value: n
      }), t;
    }

    Rt.prototype = It.prototype = {
      constructor: Rt,
      on: function on(t, e) {
        var n,
            r = this._,
            i = Ft(t + "", r),
            a = -1,
            o = i.length;

        if (!(arguments.length < 2)) {
          if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

          for (; ++a < o;) {
            if (n = (t = i[a]).type) r[n] = jt(r[n], t.name, e);else if (null == e) for (n in r) {
              r[n] = jt(r[n], t.name, null);
            }
          }

          return this;
        }

        for (; ++a < o;) {
          if ((n = (t = i[a]).type) && (n = Pt(r[n], t.name))) return n;
        }
      },
      copy: function copy() {
        var t = {},
            e = this._;

        for (var n in e) {
          t[n] = e[n].slice();
        }

        return new Rt(t);
      },
      call: function call(t, e) {
        if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
          i[a] = arguments[a + 2];
        }
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
          r[a].value.apply(e, i);
        }
      },
      apply: function apply(t, e, n) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
          r[i].value.apply(e, n);
        }
      }
    };
    var Yt = It;
    var zt,
        Ut,
        qt = 0,
        Ht = 0,
        $t = 0,
        Wt = 0,
        Vt = 0,
        Gt = 0,
        Xt = "object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && performance.now ? performance : Date,
        Zt = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
      setTimeout(t, 17);
    };

    function Qt() {
      return Vt || (Zt(Kt), Vt = Xt.now() + Gt);
    }

    function Kt() {
      Vt = 0;
    }

    function Jt() {
      this._call = this._time = this._next = null;
    }

    function te(t, e, n) {
      var r = new Jt();
      return r.restart(t, e, n), r;
    }

    function ee() {
      Vt = (Wt = Xt.now()) + Gt, qt = Ht = 0;

      try {
        !function () {
          Qt(), ++qt;

          for (var t, e = zt; e;) {
            (t = Vt - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
          }

          --qt;
        }();
      } finally {
        qt = 0, function () {
          for (var t, e, n = zt, r = 1 / 0; n;) {
            n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : zt = e);
          }

          Ut = t, re(r);
        }(), Vt = 0;
      }
    }

    function ne() {
      var t = Xt.now(),
          e = t - Wt;
      e > 1e3 && (Gt -= e, Wt = t);
    }

    function re(t) {
      qt || (Ht && (Ht = clearTimeout(Ht)), t - Vt > 24 ? (t < 1 / 0 && (Ht = setTimeout(ee, t - Xt.now() - Gt)), $t && ($t = clearInterval($t))) : ($t || (Wt = Xt.now(), $t = setInterval(ne, 1e3)), qt = 1, Zt(ee)));
    }

    function ie(t, e, n) {
      var r = new Jt();
      return e = null == e ? 0 : +e, r.restart(function (n) {
        r.stop(), t(n + e);
      }, e, n), r;
    }

    Jt.prototype = te.prototype = {
      constructor: Jt,
      restart: function restart(t, e, n) {
        if ("function" != typeof t) throw new TypeError("callback is not a function");
        n = (null == n ? Qt() : +n) + (null == e ? 0 : +e), this._next || Ut === this || (Ut ? Ut._next = this : zt = this, Ut = this), this._call = t, this._time = n, re();
      },
      stop: function stop() {
        this._call && (this._call = null, this._time = 1 / 0, re());
      }
    };
    var ae = Yt("start", "end", "cancel", "interrupt"),
        oe = [];

    function se(t, e, n, r, i, a) {
      var o = t.__transition;

      if (o) {
        if (n in o) return;
      } else t.__transition = {};

      !function (t, e, n) {
        var r,
            i = t.__transition;

        function a(c) {
          var u, l, h, f;
          if (1 !== n.state) return s();

          for (u in i) {
            if ((f = i[u]).name === n.name) {
              if (3 === f.state) return ie(a);
              4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
            }
          }

          if (ie(function () {
            3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
          }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
            for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
              (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
            }

            r.length = l + 1;
          }
        }

        function o(e) {
          for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
            r[a].call(t, i);
          }

          5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
        }

        function s() {
          for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
            return;
          }

          delete t.__transition;
        }

        i[e] = n, n.timer = te(function (t) {
          n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
        }, 0, n.time);
      }(t, n, {
        name: e,
        index: r,
        group: i,
        on: ae,
        tween: oe,
        time: a.time,
        delay: a.delay,
        duration: a.duration,
        ease: a.ease,
        timer: null,
        state: 0
      });
    }

    function ce(t, e) {
      var n = le(t, e);
      if (n.state > 0) throw new Error("too late; already scheduled");
      return n;
    }

    function ue(t, e) {
      var n = le(t, e);
      if (n.state > 3) throw new Error("too late; already running");
      return n;
    }

    function le(t, e) {
      var n = t.__transition;
      if (!n || !(n = n[e])) throw new Error("transition not found");
      return n;
    }

    function he(t, e) {
      return t = +t, e = +e, function (n) {
        return t * (1 - n) + e * n;
      };
    }

    var fe,
        de = 180 / Math.PI,
        pe = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };

    function ye(t, e, n, r, i, a) {
      var o, s, c;
      return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
        translateX: i,
        translateY: a,
        rotate: Math.atan2(e, t) * de,
        skewX: Math.atan(c) * de,
        scaleX: o,
        scaleY: s
      };
    }

    function ge(t, e, n, r) {
      function i(t) {
        return t.length ? t.pop() + " " : "";
      }

      return function (a, o) {
        var s = [],
            c = [];
        return a = t(a), o = t(o), function (t, r, i, a, o, s) {
          if (t !== i || r !== a) {
            var c = o.push("translate(", null, e, null, n);
            s.push({
              i: c - 4,
              x: he(t, i)
            }, {
              i: c - 2,
              x: he(r, a)
            });
          } else (i || a) && o.push("translate(" + i + e + a + n);
        }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
          t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
            i: n.push(i(n) + "rotate(", null, r) - 2,
            x: he(t, e)
          })) : e && n.push(i(n) + "rotate(" + e + r);
        }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
          t !== e ? a.push({
            i: n.push(i(n) + "skewX(", null, r) - 2,
            x: he(t, e)
          }) : e && n.push(i(n) + "skewX(" + e + r);
        }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
          if (t !== n || e !== r) {
            var s = a.push(i(a) + "scale(", null, ",", null, ")");
            o.push({
              i: s - 4,
              x: he(t, n)
            }, {
              i: s - 2,
              x: he(e, r)
            });
          } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
        }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
          for (var e, n = -1, r = c.length; ++n < r;) {
            s[(e = c[n]).i] = e.x(t);
          }

          return s.join("");
        };
      };
    }

    var me = ge(function (t) {
      var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
      return e.isIdentity ? pe : ye(e.a, e.b, e.c, e.d, e.e, e.f);
    }, "px, ", "px)", "deg)"),
        ve = ge(function (t) {
      return null == t ? pe : (fe || (fe = document.createElementNS("http://www.w3.org/2000/svg", "g")), fe.setAttribute("transform", t), (t = fe.transform.baseVal.consolidate()) ? ye((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : pe);
    }, ", ", ")", ")");

    function be(t, e) {
      var n, r;
      return function () {
        var i = ue(this, t),
            a = i.tween;
        if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
          if (r[o].name === e) {
            (r = r.slice()).splice(o, 1);
            break;
          }
        }
        i.tween = r;
      };
    }

    function _e(t, e, n) {
      var r, i;
      if ("function" != typeof n) throw new Error();
      return function () {
        var a = ue(this, t),
            o = a.tween;

        if (o !== r) {
          i = (r = o).slice();

          for (var s = {
            name: e,
            value: n
          }, c = 0, u = i.length; c < u; ++c) {
            if (i[c].name === e) {
              i[c] = s;
              break;
            }
          }

          c === u && i.push(s);
        }

        a.tween = i;
      };
    }

    function xe(t, e, n) {
      var r = t._id;
      return t.each(function () {
        var t = ue(this, r);
        (t.value || (t.value = {}))[e] = n.apply(this, arguments);
      }), function (t) {
        return le(t, r).value[e];
      };
    }

    function we(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    }

    function ke(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function Te() {}

    var Ee = .7,
        Ce = 1 / Ee,
        Se = "\\s*([+-]?\\d+)\\s*",
        Ae = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        Me = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        Ne = /^#([0-9a-f]{3,8})$/,
        De = new RegExp("^rgb\\(" + [Se, Se, Se] + "\\)$"),
        Oe = new RegExp("^rgb\\(" + [Me, Me, Me] + "\\)$"),
        Be = new RegExp("^rgba\\(" + [Se, Se, Se, Ae] + "\\)$"),
        Le = new RegExp("^rgba\\(" + [Me, Me, Me, Ae] + "\\)$"),
        Ie = new RegExp("^hsl\\(" + [Ae, Me, Me] + "\\)$"),
        Re = new RegExp("^hsla\\(" + [Ae, Me, Me, Ae] + "\\)$"),
        Fe = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function Pe() {
      return this.rgb().formatHex();
    }

    function je() {
      return this.rgb().formatRgb();
    }

    function Ye(t) {
      var e, n;
      return t = (t + "").trim().toLowerCase(), (e = Ne.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? ze(e) : 3 === n ? new $e(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Ue(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Ue(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = De.exec(t)) ? new $e(e[1], e[2], e[3], 1) : (e = Oe.exec(t)) ? new $e(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Be.exec(t)) ? Ue(e[1], e[2], e[3], e[4]) : (e = Le.exec(t)) ? Ue(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Ie.exec(t)) ? Xe(e[1], e[2] / 100, e[3] / 100, 1) : (e = Re.exec(t)) ? Xe(e[1], e[2] / 100, e[3] / 100, e[4]) : Fe.hasOwnProperty(t) ? ze(Fe[t]) : "transparent" === t ? new $e(NaN, NaN, NaN, 0) : null;
    }

    function ze(t) {
      return new $e(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function Ue(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new $e(t, e, n, r);
    }

    function qe(t) {
      return t instanceof Te || (t = Ye(t)), t ? new $e((t = t.rgb()).r, t.g, t.b, t.opacity) : new $e();
    }

    function He(t, e, n, r) {
      return 1 === arguments.length ? qe(t) : new $e(t, e, n, null == r ? 1 : r);
    }

    function $e(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function We() {
      return "#" + Ge(this.r) + Ge(this.g) + Ge(this.b);
    }

    function Ve() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function Ge(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function Xe(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Qe(t, e, n, r);
    }

    function Ze(t) {
      if (t instanceof Qe) return new Qe(t.h, t.s, t.l, t.opacity);
      if (t instanceof Te || (t = Ye(t)), !t) return new Qe();
      if (t instanceof Qe) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          o = NaN,
          s = a - i,
          c = (a + i) / 2;
      return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Qe(o, s, c, t.opacity);
    }

    function Qe(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function Ke(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    we(Te, Ye, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: Pe,
      formatHex: Pe,
      formatHsl: function formatHsl() {
        return Ze(this).formatHsl();
      },
      formatRgb: je,
      toString: je
    }), we($e, He, ke(Te, {
      brighter: function brighter(t) {
        return t = null == t ? Ce : Math.pow(Ce, t), new $e(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Ee : Math.pow(Ee, t), new $e(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: We,
      formatHex: We,
      formatRgb: Ve,
      toString: Ve
    })), we(Qe, function (t, e, n, r) {
      return 1 === arguments.length ? Ze(t) : new Qe(t, e, n, null == r ? 1 : r);
    }, ke(Te, {
      brighter: function brighter(t) {
        return t = null == t ? Ce : Math.pow(Ce, t), new Qe(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Ee : Math.pow(Ee, t), new Qe(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new $e(Ke(t >= 240 ? t - 240 : t + 120, i, r), Ke(t, i, r), Ke(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));

    var tn = function tn(t) {
      return function () {
        return t;
      };
    };

    function en(t, e) {
      var n = e - t;
      return n ? function (t, e) {
        return function (n) {
          return t + n * e;
        };
      }(t, n) : tn(isNaN(t) ? e : t);
    }

    var nn = function t(e) {
      var n = function (t) {
        return 1 == (t = +t) ? en : function (e, n) {
          return n - e ? function (t, e, n) {
            return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
              return Math.pow(t + r * e, n);
            };
          }(e, n, t) : tn(isNaN(e) ? n : e);
        };
      }(e);

      function r(t, e) {
        var r = n((t = He(t)).r, (e = He(e)).r),
            i = n(t.g, e.g),
            a = n(t.b, e.b),
            o = en(t.opacity, e.opacity);
        return function (e) {
          return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
        };
      }

      return r.gamma = t, r;
    }(1);

    var an = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        on = new RegExp(an.source, "g");

    function sn(t, e) {
      var n,
          r,
          i,
          a = an.lastIndex = on.lastIndex = 0,
          o = -1,
          s = [],
          c = [];

      for (t += "", e += ""; (n = an.exec(t)) && (r = on.exec(e));) {
        (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
          i: o,
          x: he(n, r)
        })), a = on.lastIndex;
      }

      return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          s[(n = c[r]).i] = n.x(t);
        }

        return s.join("");
      });
    }

    function cn(t, e) {
      var n;
      return ("number" == typeof e ? he : e instanceof Ye ? nn : (n = Ye(e)) ? (e = n, nn) : sn)(t, e);
    }

    function un(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function ln(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function hn(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttribute(t);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function fn(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttributeNS(t.space, t.local);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function dn(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttribute(t);
      };
    }

    function pn(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function yn(t, e) {
      return function (n) {
        this.setAttribute(t, e.call(this, n));
      };
    }

    function gn(t, e) {
      return function (n) {
        this.setAttributeNS(t.space, t.local, e.call(this, n));
      };
    }

    function mn(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && gn(t, i)), n;
      }

      return i._value = e, i;
    }

    function vn(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && yn(t, i)), n;
      }

      return i._value = e, i;
    }

    function bn(t, e) {
      return function () {
        ce(this, t).delay = +e.apply(this, arguments);
      };
    }

    function _n(t, e) {
      return e = +e, function () {
        ce(this, t).delay = e;
      };
    }

    function xn(t, e) {
      return function () {
        ue(this, t).duration = +e.apply(this, arguments);
      };
    }

    function wn(t, e) {
      return e = +e, function () {
        ue(this, t).duration = e;
      };
    }

    function kn(t, e) {
      if ("function" != typeof e) throw new Error();
      return function () {
        ue(this, t).ease = e;
      };
    }

    function Tn(t, e, n) {
      var r,
          i,
          a = function (t) {
        return (t + "").trim().split(/^|\s+/).every(function (t) {
          var e = t.indexOf(".");
          return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
        });
      }(e) ? ce : ue;
      return function () {
        var o = a(this, t),
            s = o.on;
        s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
      };
    }

    var En = Bt.prototype.constructor;

    function Cn(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function Sn(t, e, n) {
      return function (r) {
        this.style.setProperty(t, e.call(this, r), n);
      };
    }

    function An(t, e, n) {
      var r, i;

      function a() {
        var a = e.apply(this, arguments);
        return a !== i && (r = (i = a) && Sn(t, a, n)), r;
      }

      return a._value = e, a;
    }

    function Mn(t) {
      return function (e) {
        this.textContent = t.call(this, e);
      };
    }

    function Nn(t) {
      var e, n;

      function r() {
        var r = t.apply(this, arguments);
        return r !== n && (e = (n = r) && Mn(r)), e;
      }

      return r._value = t, r;
    }

    var Dn = 0;

    function On(t, e, n, r) {
      this._groups = t, this._parents = e, this._name = n, this._id = r;
    }

    function Bn() {
      return ++Dn;
    }

    var Ln = Bt.prototype;
    On.prototype = _defineProperty2({
      constructor: On,
      select: function select(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = _(t));

        for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
          for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
            (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, se(h[f], e, n, f, h, le(s, n)));
          }
        }

        return new On(a, this._parents, e, n);
      },
      selectAll: function selectAll(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = k(t));

        for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
          for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
            if (c = u[h]) {
              for (var f, d = t.call(c, c.__data__, h, u), p = le(c, n), y = 0, g = d.length; y < g; ++y) {
                (f = d[y]) && se(f, e, n, y, d, p);
              }

              a.push(d), o.push(c);
            }
          }
        }

        return new On(a, o, e, n);
      },
      selectChild: Ln.selectChild,
      selectChildren: Ln.selectChildren,
      filter: function filter(t) {
        "function" != typeof t && (t = T(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new On(r, this._parents, this._name, this._id);
      },
      merge: function merge(t) {
        if (t._id !== this._id) throw new Error();

        for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
          for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
            (c = u[d] || l[d]) && (f[d] = c);
          }
        }

        for (; s < r; ++s) {
          o[s] = e[s];
        }

        return new On(o, this._parents, this._name, this._id);
      },
      selection: function selection() {
        return new En(this._groups, this._parents);
      },
      transition: function transition() {
        for (var t = this._name, e = this._id, n = Bn(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
          for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
            if (o = s[u]) {
              var l = le(o, e);
              se(o, t, n, u, s, {
                time: l.time + l.delay + l.duration,
                delay: 0,
                duration: l.duration,
                ease: l.ease
              });
            }
          }
        }

        return new On(r, this._parents, t, n);
      },
      call: Ln.call,
      nodes: Ln.nodes,
      node: Ln.node,
      size: Ln.size,
      empty: Ln.empty,
      each: Ln.each,
      on: function on(t, e) {
        var n = this._id;
        return arguments.length < 2 ? le(this.node(), n).on.on(t) : this.each(Tn(n, t, e));
      },
      attr: function attr(t, e) {
        var n = Y(t),
            r = "transform" === n ? ve : cn;
        return this.attrTween(t, "function" == typeof e ? (n.local ? pn : dn)(n, r, xe(this, "attr." + t, e)) : null == e ? (n.local ? ln : un)(n) : (n.local ? fn : hn)(n, r, e));
      },
      attrTween: function attrTween(t, e) {
        var n = "attr." + t;
        if (arguments.length < 2) return (n = this.tween(n)) && n._value;
        if (null == e) return this.tween(n, null);
        if ("function" != typeof e) throw new Error();
        var r = Y(t);
        return this.tween(n, (r.local ? mn : vn)(r, e));
      },
      style: function style(t, e, n) {
        var r = "transform" == (t += "") ? me : cn;
        return null == e ? this.styleTween(t, function (t, e) {
          var n, r, i;
          return function () {
            var a = Q(this, t),
                o = (this.style.removeProperty(t), Q(this, t));
            return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
          };
        }(t, r)).on("end.style." + t, Cn(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
          var r, i, a;
          return function () {
            var o = Q(this, t),
                s = n(this),
                c = s + "";
            return null == s && (this.style.removeProperty(t), c = s = Q(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
          };
        }(t, r, xe(this, "style." + t, e))).each(function (t, e) {
          var n,
              r,
              i,
              a,
              o = "style." + e,
              s = "end." + o;
          return function () {
            var c = ue(this, t),
                u = c.on,
                l = null == c.value[o] ? a || (a = Cn(e)) : void 0;
            u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
          };
        }(this._id, t)) : this.styleTween(t, function (t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = Q(this, t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }(t, r, e), n).on("end.style." + t, null);
      },
      styleTween: function styleTween(t, e, n) {
        var r = "style." + (t += "");
        if (arguments.length < 2) return (r = this.tween(r)) && r._value;
        if (null == e) return this.tween(r, null);
        if ("function" != typeof e) throw new Error();
        return this.tween(r, An(t, e, null == n ? "" : n));
      },
      text: function text(t) {
        return this.tween("text", "function" == typeof t ? function (t) {
          return function () {
            var e = t(this);
            this.textContent = null == e ? "" : e;
          };
        }(xe(this, "text", t)) : function (t) {
          return function () {
            this.textContent = t;
          };
        }(null == t ? "" : t + ""));
      },
      textTween: function textTween(t) {
        var e = "text";
        if (arguments.length < 1) return (e = this.tween(e)) && e._value;
        if (null == t) return this.tween(e, null);
        if ("function" != typeof t) throw new Error();
        return this.tween(e, Nn(t));
      },
      remove: function remove() {
        return this.on("end.remove", function (t) {
          return function () {
            var e = this.parentNode;

            for (var n in this.__transition) {
              if (+n !== t) return;
            }

            e && e.removeChild(this);
          };
        }(this._id));
      },
      tween: function tween(t, e) {
        var n = this._id;

        if (t += "", arguments.length < 2) {
          for (var r, i = le(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
            if ((r = i[a]).name === t) return r.value;
          }

          return null;
        }

        return this.each((null == e ? be : _e)(n, t, e));
      },
      delay: function delay(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? bn : _n)(e, t)) : le(this.node(), e).delay;
      },
      duration: function duration(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? xn : wn)(e, t)) : le(this.node(), e).duration;
      },
      ease: function ease(t) {
        var e = this._id;
        return arguments.length ? this.each(kn(e, t)) : le(this.node(), e).ease;
      },
      easeVarying: function easeVarying(t) {
        if ("function" != typeof t) throw new Error();
        return this.each(function (t, e) {
          return function () {
            var n = e.apply(this, arguments);
            if ("function" != typeof n) throw new Error();
            ue(this, t).ease = n;
          };
        }(this._id, t));
      },
      end: function end() {
        var t,
            e,
            n = this,
            r = n._id,
            i = n.size();
        return new Promise(function (a, o) {
          var s = {
            value: o
          },
              c = {
            value: function value() {
              0 == --i && a();
            }
          };
          n.each(function () {
            var n = ue(this, r),
                i = n.on;
            i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
          }), 0 === i && a();
        });
      }
    }, Symbol.iterator, Ln[Symbol.iterator]);
    var In = {
      time: null,
      delay: 0,
      duration: 250,
      ease: function ease(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
      }
    };

    function Rn(t, e) {
      for (var n; !(n = t.__transition) || !(n = n[e]);) {
        if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
      }

      return n;
    }

    Bt.prototype.interrupt = function (t) {
      return this.each(function () {
        !function (t, e) {
          var n,
              r,
              i,
              a = t.__transition,
              o = !0;

          if (a) {
            for (i in e = null == e ? null : e + "", a) {
              (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
            }

            o && delete t.__transition;
          }
        }(this, t);
      });
    }, Bt.prototype.transition = function (t) {
      var e, n;
      t instanceof On ? (e = t._id, t = t._name) : (e = Bn(), (n = In).time = Qt(), t = null == t ? null : t + "");

      for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
        for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
          (o = s[u]) && se(o, t, e, u, s, n || Rn(o, e));
        }
      }

      return new On(r, this._parents, t, e);
    };

    function zn(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    }

    function Un(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function qn() {}

    var Hn = .7,
        $n = 1 / Hn,
        Wn = "\\s*([+-]?\\d+)\\s*",
        Vn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        Gn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        Xn = /^#([0-9a-f]{3,8})$/,
        Zn = new RegExp("^rgb\\(" + [Wn, Wn, Wn] + "\\)$"),
        Qn = new RegExp("^rgb\\(" + [Gn, Gn, Gn] + "\\)$"),
        Kn = new RegExp("^rgba\\(" + [Wn, Wn, Wn, Vn] + "\\)$"),
        Jn = new RegExp("^rgba\\(" + [Gn, Gn, Gn, Vn] + "\\)$"),
        tr = new RegExp("^hsl\\(" + [Vn, Gn, Gn] + "\\)$"),
        er = new RegExp("^hsla\\(" + [Vn, Gn, Gn, Vn] + "\\)$"),
        nr = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function rr() {
      return this.rgb().formatHex();
    }

    function ir() {
      return this.rgb().formatRgb();
    }

    function ar(t) {
      var e, n;
      return t = (t + "").trim().toLowerCase(), (e = Xn.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? or(e) : 3 === n ? new lr(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? sr(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? sr(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Zn.exec(t)) ? new lr(e[1], e[2], e[3], 1) : (e = Qn.exec(t)) ? new lr(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Kn.exec(t)) ? sr(e[1], e[2], e[3], e[4]) : (e = Jn.exec(t)) ? sr(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = tr.exec(t)) ? pr(e[1], e[2] / 100, e[3] / 100, 1) : (e = er.exec(t)) ? pr(e[1], e[2] / 100, e[3] / 100, e[4]) : nr.hasOwnProperty(t) ? or(nr[t]) : "transparent" === t ? new lr(NaN, NaN, NaN, 0) : null;
    }

    function or(t) {
      return new lr(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function sr(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new lr(t, e, n, r);
    }

    function cr(t) {
      return t instanceof qn || (t = ar(t)), t ? new lr((t = t.rgb()).r, t.g, t.b, t.opacity) : new lr();
    }

    function ur(t, e, n, r) {
      return 1 === arguments.length ? cr(t) : new lr(t, e, n, null == r ? 1 : r);
    }

    function lr(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function hr() {
      return "#" + dr(this.r) + dr(this.g) + dr(this.b);
    }

    function fr() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function dr(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function pr(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new gr(t, e, n, r);
    }

    function yr(t) {
      if (t instanceof gr) return new gr(t.h, t.s, t.l, t.opacity);
      if (t instanceof qn || (t = ar(t)), !t) return new gr();
      if (t instanceof gr) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          o = NaN,
          s = a - i,
          c = (a + i) / 2;
      return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new gr(o, s, c, t.opacity);
    }

    function gr(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function mr(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    zn(qn, ar, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: rr,
      formatHex: rr,
      formatHsl: function formatHsl() {
        return yr(this).formatHsl();
      },
      formatRgb: ir,
      toString: ir
    }), zn(lr, ur, Un(qn, {
      brighter: function brighter(t) {
        return t = null == t ? $n : Math.pow($n, t), new lr(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Hn : Math.pow(Hn, t), new lr(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: hr,
      formatHex: hr,
      formatRgb: fr,
      toString: fr
    })), zn(gr, function (t, e, n, r) {
      return 1 === arguments.length ? yr(t) : new gr(t, e, n, null == r ? 1 : r);
    }, Un(qn, {
      brighter: function brighter(t) {
        return t = null == t ? $n : Math.pow($n, t), new gr(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Hn : Math.pow(Hn, t), new gr(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new lr(mr(t >= 240 ? t - 240 : t + 120, i, r), mr(t, i, r), mr(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));
    var vr = Math.PI / 180,
        br = 180 / Math.PI,
        _r = .96422,
        xr = .82521,
        wr = 4 / 29,
        kr = 6 / 29,
        Tr = 3 * kr * kr;

    function Er(t) {
      if (t instanceof Cr) return new Cr(t.l, t.a, t.b, t.opacity);
      if (t instanceof Br) return Lr(t);
      t instanceof lr || (t = cr(t));
      var e,
          n,
          r = Nr(t.r),
          i = Nr(t.g),
          a = Nr(t.b),
          o = Sr((.2225045 * r + .7168786 * i + .0606169 * a) / 1);
      return r === i && i === a ? e = n = o : (e = Sr((.4360747 * r + .3850649 * i + .1430804 * a) / _r), n = Sr((.0139322 * r + .0971045 * i + .7141733 * a) / xr)), new Cr(116 * o - 16, 500 * (e - o), 200 * (o - n), t.opacity);
    }

    function Cr(t, e, n, r) {
      this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
    }

    function Sr(t) {
      return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / Tr + wr;
    }

    function Ar(t) {
      return t > kr ? t * t * t : Tr * (t - wr);
    }

    function Mr(t) {
      return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
    }

    function Nr(t) {
      return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    }

    function Dr(t) {
      if (t instanceof Br) return new Br(t.h, t.c, t.l, t.opacity);
      if (t instanceof Cr || (t = Er(t)), 0 === t.a && 0 === t.b) return new Br(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
      var e = Math.atan2(t.b, t.a) * br;
      return new Br(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
    }

    function Or(t, e, n, r) {
      return 1 === arguments.length ? Dr(t) : new Br(t, e, n, null == r ? 1 : r);
    }

    function Br(t, e, n, r) {
      this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
    }

    function Lr(t) {
      if (isNaN(t.h)) return new Cr(t.l, 0, 0, t.opacity);
      var e = t.h * vr;
      return new Cr(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
    }

    zn(Cr, function (t, e, n, r) {
      return 1 === arguments.length ? Er(t) : new Cr(t, e, n, null == r ? 1 : r);
    }, Un(qn, {
      brighter: function brighter(t) {
        return new Cr(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      darker: function darker(t) {
        return new Cr(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      rgb: function rgb() {
        var t = (this.l + 16) / 116,
            e = isNaN(this.a) ? t : t + this.a / 500,
            n = isNaN(this.b) ? t : t - this.b / 200;
        return new lr(Mr(3.1338561 * (e = _r * Ar(e)) - 1.6168667 * (t = 1 * Ar(t)) - .4906146 * (n = xr * Ar(n))), Mr(-.9787684 * e + 1.9161415 * t + .033454 * n), Mr(.0719453 * e - .2289914 * t + 1.4052427 * n), this.opacity);
      }
    })), zn(Br, Or, Un(qn, {
      brighter: function brighter(t) {
        return new Br(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
      },
      darker: function darker(t) {
        return new Br(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
      },
      rgb: function rgb() {
        return Lr(this).rgb();
      }
    }));

    var Ir = function Ir(t) {
      return function () {
        return t;
      };
    };

    function Rr(t, e) {
      return function (n) {
        return t + n * e;
      };
    }

    function Fr(t, e) {
      var n = e - t;
      return n ? Rr(t, n) : Ir(isNaN(t) ? e : t);
    }

    function Pr(t) {
      return function (e, n) {
        var r = t((e = Or(e)).h, (n = Or(n)).h),
            i = Fr(e.c, n.c),
            a = Fr(e.l, n.l),
            o = Fr(e.opacity, n.opacity);
        return function (t) {
          return e.h = r(t), e.c = i(t), e.l = a(t), e.opacity = o(t), e + "";
        };
      };
    }

    var jr = Pr(function (t, e) {
      var n = e - t;
      return n ? Rr(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Ir(isNaN(t) ? e : t);
    });
    var Yr = Math.sqrt(50),
        zr = Math.sqrt(10),
        Ur = Math.sqrt(2);

    function qr(t, e, n) {
      var r = (e - t) / Math.max(0, n),
          i = Math.floor(Math.log(r) / Math.LN10),
          a = r / Math.pow(10, i);
      return i >= 0 ? (a >= Yr ? 10 : a >= zr ? 5 : a >= Ur ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= Yr ? 10 : a >= zr ? 5 : a >= Ur ? 2 : 1);
    }

    function Hr(t, e, n) {
      var r = Math.abs(e - t) / Math.max(0, n),
          i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
          a = r / i;
      return a >= Yr ? i *= 10 : a >= zr ? i *= 5 : a >= Ur && (i *= 2), e < t ? -i : i;
    }

    function $r(t, e) {
      return null == t || null == e ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    function Wr(t) {
      var e = t,
          n = t,
          r = t;

      function i(t, e) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length;

        if (i < a) {
          if (0 !== n(e, e)) return a;

          do {
            var _n3 = i + a >>> 1;

            r(t[_n3], e) < 0 ? i = _n3 + 1 : a = _n3;
          } while (i < a);
        }

        return i;
      }

      return 2 !== t.length && (e = function e(_e5, n) {
        return t(_e5) - n;
      }, n = $r, r = function r(e, n) {
        return $r(t(e), n);
      }), {
        left: i,
        center: function center(t, n) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length;
          var o = i(t, n, r, a - 1);
          return o > r && e(t[o - 1], n) > -e(t[o], n) ? o - 1 : o;
        },
        right: function right(t, e) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length;

          if (i < a) {
            if (0 !== n(e, e)) return a;

            do {
              var _n4 = i + a >>> 1;

              r(t[_n4], e) <= 0 ? i = _n4 + 1 : a = _n4;
            } while (i < a);
          }

          return i;
        }
      };
    }

    var Vr = Wr($r),
        Gr = Vr.right,
        Xr = (Wr(function (t) {
      return null === t ? NaN : +t;
    }).center, Gr);

    function Zr(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    }

    function Qr(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function Kr() {}

    var Jr = .7,
        ti = 1.4285714285714286,
        ei = "\\s*([+-]?\\d+)\\s*",
        ni = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        ri = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        ii = /^#([0-9a-f]{3,8})$/,
        ai = new RegExp("^rgb\\(" + [ei, ei, ei] + "\\)$"),
        oi = new RegExp("^rgb\\(" + [ri, ri, ri] + "\\)$"),
        si = new RegExp("^rgba\\(" + [ei, ei, ei, ni] + "\\)$"),
        ci = new RegExp("^rgba\\(" + [ri, ri, ri, ni] + "\\)$"),
        ui = new RegExp("^hsl\\(" + [ni, ri, ri] + "\\)$"),
        li = new RegExp("^hsla\\(" + [ni, ri, ri, ni] + "\\)$"),
        hi = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function fi() {
      return this.rgb().formatHex();
    }

    function di() {
      return this.rgb().formatRgb();
    }

    function pi(t) {
      var e, n;
      return t = (t + "").trim().toLowerCase(), (e = ii.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? yi(e) : 3 === n ? new bi(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? gi(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? gi(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = ai.exec(t)) ? new bi(e[1], e[2], e[3], 1) : (e = oi.exec(t)) ? new bi(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = si.exec(t)) ? gi(e[1], e[2], e[3], e[4]) : (e = ci.exec(t)) ? gi(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = ui.exec(t)) ? ki(e[1], e[2] / 100, e[3] / 100, 1) : (e = li.exec(t)) ? ki(e[1], e[2] / 100, e[3] / 100, e[4]) : hi.hasOwnProperty(t) ? yi(hi[t]) : "transparent" === t ? new bi(NaN, NaN, NaN, 0) : null;
    }

    function yi(t) {
      return new bi(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function gi(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new bi(t, e, n, r);
    }

    function mi(t) {
      return t instanceof Kr || (t = pi(t)), t ? new bi((t = t.rgb()).r, t.g, t.b, t.opacity) : new bi();
    }

    function vi(t, e, n, r) {
      return 1 === arguments.length ? mi(t) : new bi(t, e, n, null == r ? 1 : r);
    }

    function bi(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function _i() {
      return "#" + wi(this.r) + wi(this.g) + wi(this.b);
    }

    function xi() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function wi(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function ki(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Ei(t, e, n, r);
    }

    function Ti(t) {
      if (t instanceof Ei) return new Ei(t.h, t.s, t.l, t.opacity);
      if (t instanceof Kr || (t = pi(t)), !t) return new Ei();
      if (t instanceof Ei) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          o = NaN,
          s = a - i,
          c = (a + i) / 2;
      return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Ei(o, s, c, t.opacity);
    }

    function Ei(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function Ci(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    Zr(Kr, pi, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: fi,
      formatHex: fi,
      formatHsl: function formatHsl() {
        return Ti(this).formatHsl();
      },
      formatRgb: di,
      toString: di
    }), Zr(bi, vi, Qr(Kr, {
      brighter: function brighter(t) {
        return t = null == t ? ti : Math.pow(ti, t), new bi(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Jr : Math.pow(Jr, t), new bi(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: _i,
      formatHex: _i,
      formatRgb: xi,
      toString: xi
    })), Zr(Ei, function (t, e, n, r) {
      return 1 === arguments.length ? Ti(t) : new Ei(t, e, n, null == r ? 1 : r);
    }, Qr(Kr, {
      brighter: function brighter(t) {
        return t = null == t ? ti : Math.pow(ti, t), new Ei(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Jr : Math.pow(Jr, t), new Ei(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new bi(Ci(t >= 240 ? t - 240 : t + 120, i, r), Ci(t, i, r), Ci(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));

    var Ai = function Ai(t) {
      return function () {
        return t;
      };
    };

    function Mi(t, e) {
      var n = e - t;
      return n ? function (t, e) {
        return function (n) {
          return t + n * e;
        };
      }(t, n) : Ai(isNaN(t) ? e : t);
    }

    var Ni = function t(e) {
      var n = function (t) {
        return 1 == (t = +t) ? Mi : function (e, n) {
          return n - e ? function (t, e, n) {
            return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
              return Math.pow(t + r * e, n);
            };
          }(e, n, t) : Ai(isNaN(e) ? n : e);
        };
      }(e);

      function r(t, e) {
        var r = n((t = vi(t)).r, (e = vi(e)).r),
            i = n(t.g, e.g),
            a = n(t.b, e.b),
            o = Mi(t.opacity, e.opacity);
        return function (e) {
          return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
        };
      }

      return r.gamma = t, r;
    }(1);

    function Oi(t, e) {
      var n,
          r = e ? e.length : 0,
          i = t ? Math.min(r, t.length) : 0,
          a = new Array(i),
          o = new Array(r);

      for (n = 0; n < i; ++n) {
        a[n] = Yi(t[n], e[n]);
      }

      for (; n < r; ++n) {
        o[n] = e[n];
      }

      return function (t) {
        for (n = 0; n < i; ++n) {
          o[n] = a[n](t);
        }

        return o;
      };
    }

    function Bi(t, e) {
      var n = new Date();
      return t = +t, e = +e, function (r) {
        return n.setTime(t * (1 - r) + e * r), n;
      };
    }

    function Li(t, e) {
      return t = +t, e = +e, function (n) {
        return t * (1 - n) + e * n;
      };
    }

    function Ii(t, e) {
      var n,
          r = {},
          i = {};

      for (n in null !== t && "object" == _typeof(t) || (t = {}), null !== e && "object" == _typeof(e) || (e = {}), e) {
        n in t ? r[n] = Yi(t[n], e[n]) : i[n] = e[n];
      }

      return function (t) {
        for (n in r) {
          i[n] = r[n](t);
        }

        return i;
      };
    }

    var Ri = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        Fi = new RegExp(Ri.source, "g");

    function Pi(t, e) {
      var n,
          r,
          i,
          a = Ri.lastIndex = Fi.lastIndex = 0,
          o = -1,
          s = [],
          c = [];

      for (t += "", e += ""; (n = Ri.exec(t)) && (r = Fi.exec(e));) {
        (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
          i: o,
          x: Li(n, r)
        })), a = Fi.lastIndex;
      }

      return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          s[(n = c[r]).i] = n.x(t);
        }

        return s.join("");
      });
    }

    function ji(t, e) {
      e || (e = []);
      var n,
          r = t ? Math.min(e.length, t.length) : 0,
          i = e.slice();
      return function (a) {
        for (n = 0; n < r; ++n) {
          i[n] = t[n] * (1 - a) + e[n] * a;
        }

        return i;
      };
    }

    function Yi(t, e) {
      var n,
          r,
          i = _typeof(e);

      return null == e || "boolean" === i ? Ai(e) : ("number" === i ? Li : "string" === i ? (n = pi(e)) ? (e = n, Ni) : Pi : e instanceof pi ? Ni : e instanceof Date ? Bi : (r = e, !ArrayBuffer.isView(r) || r instanceof DataView ? Array.isArray(e) ? Oi : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Ii : Li : ji))(t, e);
    }

    function zi(t, e) {
      return t = +t, e = +e, function (n) {
        return Math.round(t * (1 - n) + e * n);
      };
    }

    function Ui(t) {
      return +t;
    }

    var qi = [0, 1];

    function Hi(t) {
      return t;
    }

    function $i(t, e) {
      return (e -= t = +t) ? function (n) {
        return (n - t) / e;
      } : (n = isNaN(e) ? NaN : .5, function () {
        return n;
      });
      var n;
    }

    function Wi(t, e, n) {
      var r = t[0],
          i = t[1],
          a = e[0],
          o = e[1];
      return i < r ? (r = $i(i, r), a = n(o, a)) : (r = $i(r, i), a = n(a, o)), function (t) {
        return a(r(t));
      };
    }

    function Vi(t, e, n) {
      var r = Math.min(t.length, e.length) - 1,
          i = new Array(r),
          a = new Array(r),
          o = -1;

      for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r;) {
        i[o] = $i(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
      }

      return function (e) {
        var n = Xr(t, e, 1, r) - 1;
        return a[n](i[n](e));
      };
    }

    function Gi(t, e) {
      return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
    }

    function Xi() {
      return function () {
        var t,
            e,
            n,
            r,
            i,
            a,
            o = qi,
            s = qi,
            c = Yi,
            u = Hi;

        function l() {
          var t,
              e,
              n,
              c = Math.min(o.length, s.length);
          return u !== Hi && (t = o[0], e = o[c - 1], t > e && (n = t, t = e, e = n), u = function u(n) {
            return Math.max(t, Math.min(e, n));
          }), r = c > 2 ? Vi : Wi, i = a = null, h;
        }

        function h(e) {
          return null == e || isNaN(e = +e) ? n : (i || (i = r(o.map(t), s, c)))(t(u(e)));
        }

        return h.invert = function (n) {
          return u(e((a || (a = r(s, o.map(t), Li)))(n)));
        }, h.domain = function (t) {
          return arguments.length ? (o = Array.from(t, Ui), l()) : o.slice();
        }, h.range = function (t) {
          return arguments.length ? (s = Array.from(t), l()) : s.slice();
        }, h.rangeRound = function (t) {
          return s = Array.from(t), c = zi, l();
        }, h.clamp = function (t) {
          return arguments.length ? (u = !!t || Hi, l()) : u !== Hi;
        }, h.interpolate = function (t) {
          return arguments.length ? (c = t, l()) : c;
        }, h.unknown = function (t) {
          return arguments.length ? (n = t, h) : n;
        }, function (n, r) {
          return t = n, e = r, l();
        };
      }()(Hi, Hi);
    }

    function Zi(t, e) {
      switch (arguments.length) {
        case 0:
          break;

        case 1:
          this.range(t);
          break;

        default:
          this.range(e).domain(t);
      }

      return this;
    }

    var Qi,
        Ki = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

    function Ji(t) {
      if (!(e = Ki.exec(t))) throw new Error("invalid format: " + t);
      var e;
      return new ta({
        fill: e[1],
        align: e[2],
        sign: e[3],
        symbol: e[4],
        zero: e[5],
        width: e[6],
        comma: e[7],
        precision: e[8] && e[8].slice(1),
        trim: e[9],
        type: e[10]
      });
    }

    function ta(t) {
      this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
    }

    function ea(t, e) {
      if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
      var n,
          r = t.slice(0, n);
      return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
    }

    function na(t) {
      return (t = ea(Math.abs(t))) ? t[1] : NaN;
    }

    function ra(t, e) {
      var n = ea(t, e);
      if (!n) return t + "";
      var r = n[0],
          i = n[1];
      return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
    }

    Ji.prototype = ta.prototype, ta.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    };
    var ia = {
      "%": function _(t, e) {
        return (100 * t).toFixed(e);
      },
      b: function b(t) {
        return Math.round(t).toString(2);
      },
      c: function c(t) {
        return t + "";
      },
      d: function d(t) {
        return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
      },
      e: function e(t, _e6) {
        return t.toExponential(_e6);
      },
      f: function f(t, e) {
        return t.toFixed(e);
      },
      g: function g(t, e) {
        return t.toPrecision(e);
      },
      o: function o(t) {
        return Math.round(t).toString(8);
      },
      p: function p(t, e) {
        return ra(100 * t, e);
      },
      r: ra,
      s: function s(t, e) {
        var n = ea(t, e);
        if (!n) return t + "";
        var r = n[0],
            i = n[1],
            a = i - (Qi = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
            o = r.length;
        return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + ea(t, Math.max(0, e + a - 1))[0];
      },
      X: function X(t) {
        return Math.round(t).toString(16).toUpperCase();
      },
      x: function x(t) {
        return Math.round(t).toString(16);
      }
    };

    function aa(t) {
      return t;
    }

    var oa,
        sa,
        ca,
        ua = Array.prototype.map,
        la = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

    function ha(t) {
      var e = t.domain;
      return t.ticks = function (t) {
        var n = e();
        return function (t, e, n) {
          var r,
              i,
              a,
              o,
              s = -1;
          if (n = +n, (t = +t) == (e = +e) && n > 0) return [t];
          if ((r = e < t) && (i = t, t = e, e = i), 0 === (o = qr(t, e, n)) || !isFinite(o)) return [];

          if (o > 0) {
            var _n5 = Math.round(t / o),
                _r4 = Math.round(e / o);

            for (_n5 * o < t && ++_n5, _r4 * o > e && --_r4, a = new Array(i = _r4 - _n5 + 1); ++s < i;) {
              a[s] = (_n5 + s) * o;
            }
          } else {
            o = -o;

            var _n6 = Math.round(t * o),
                _r5 = Math.round(e * o);

            for (_n6 / o < t && ++_n6, _r5 / o > e && --_r5, a = new Array(i = _r5 - _n6 + 1); ++s < i;) {
              a[s] = (_n6 + s) / o;
            }
          }

          return r && a.reverse(), a;
        }(n[0], n[n.length - 1], null == t ? 10 : t);
      }, t.tickFormat = function (t, n) {
        var r = e();
        return function (t, e, n, r) {
          var i,
              a = Hr(t, e, n);

          switch ((r = Ji(null == r ? ",f" : r)).type) {
            case "s":
              var o = Math.max(Math.abs(t), Math.abs(e));
              return null != r.precision || isNaN(i = function (t, e) {
                return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(na(e) / 3))) - na(Math.abs(t)));
              }(a, o)) || (r.precision = i), ca(r, o);

            case "":
            case "e":
            case "g":
            case "p":
            case "r":
              null != r.precision || isNaN(i = function (t, e) {
                return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, na(e) - na(t)) + 1;
              }(a, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
              break;

            case "f":
            case "%":
              null != r.precision || isNaN(i = function (t) {
                return Math.max(0, -na(Math.abs(t)));
              }(a)) || (r.precision = i - 2 * ("%" === r.type));
          }

          return sa(r);
        }(r[0], r[r.length - 1], null == t ? 10 : t, n);
      }, t.nice = function (n) {
        null == n && (n = 10);
        var r,
            i,
            a = e(),
            o = 0,
            s = a.length - 1,
            c = a[o],
            u = a[s],
            l = 10;

        for (u < c && (i = c, c = u, u = i, i = o, o = s, s = i); l-- > 0;) {
          if ((i = qr(c, u, n)) === r) return a[o] = c, a[s] = u, e(a);
          if (i > 0) c = Math.floor(c / i) * i, u = Math.ceil(u / i) * i;else {
            if (!(i < 0)) break;
            c = Math.ceil(c * i) / i, u = Math.floor(u * i) / i;
          }
          r = i;
        }

        return t;
      }, t;
    }

    function fa() {
      var t = Xi();
      return t.copy = function () {
        return Gi(t, fa());
      }, Zi.apply(t, arguments), ha(t);
    }

    oa = function (t) {
      var e,
          n,
          r = void 0 === t.grouping || void 0 === t.thousands ? aa : (e = ua.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
        for (var i = t.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(t.substring(i -= s, i + s)), !((c += s + 1) > r));) {
          s = e[o = (o + 1) % e.length];
        }

        return a.reverse().join(n);
      }),
          i = void 0 === t.currency ? "" : t.currency[0] + "",
          a = void 0 === t.currency ? "" : t.currency[1] + "",
          o = void 0 === t.decimal ? "." : t.decimal + "",
          s = void 0 === t.numerals ? aa : function (t) {
        return function (e) {
          return e.replace(/[0-9]/g, function (e) {
            return t[+e];
          });
        };
      }(ua.call(t.numerals, String)),
          c = void 0 === t.percent ? "%" : t.percent + "",
          u = void 0 === t.minus ? "−" : t.minus + "",
          l = void 0 === t.nan ? "NaN" : t.nan + "";

      function h(t) {
        var e = (t = Ji(t)).fill,
            n = t.align,
            h = t.sign,
            f = t.symbol,
            d = t.zero,
            p = t.width,
            y = t.comma,
            g = t.precision,
            m = t.trim,
            v = t.type;
        "n" === v ? (y = !0, v = "g") : ia[v] || (void 0 === g && (g = 12), m = !0, v = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");

        var b = "$" === f ? i : "#" === f && /[boxX]/.test(v) ? "0" + v.toLowerCase() : "",
            _ = "$" === f ? a : /[%p]/.test(v) ? c : "",
            x = ia[v],
            w = /[defgprs%]/.test(v);

        function k(t) {
          var i,
              a,
              c,
              f = b,
              k = _;
          if ("c" === v) k = x(t) + k, t = "";else {
            var T = (t = +t) < 0 || 1 / t < 0;
            if (t = isNaN(t) ? l : x(Math.abs(t), g), m && (t = function (t) {
              t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
                switch (t[r]) {
                  case ".":
                    i = e = r;
                    break;

                  case "0":
                    0 === i && (i = r), e = r;
                    break;

                  default:
                    if (!+t[r]) break t;
                    i > 0 && (i = 0);
                }
              }

              return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
            }(t)), T && 0 == +t && "+" !== h && (T = !1), f = (T ? "(" === h ? h : u : "-" === h || "(" === h ? "" : h) + f, k = ("s" === v ? la[8 + Qi / 3] : "") + k + (T && "(" === h ? ")" : ""), w) for (i = -1, a = t.length; ++i < a;) {
              if (48 > (c = t.charCodeAt(i)) || c > 57) {
                k = (46 === c ? o + t.slice(i + 1) : t.slice(i)) + k, t = t.slice(0, i);
                break;
              }
            }
          }
          y && !d && (t = r(t, 1 / 0));
          var E = f.length + t.length + k.length,
              C = E < p ? new Array(p - E + 1).join(e) : "";

          switch (y && d && (t = r(C + t, C.length ? p - k.length : 1 / 0), C = ""), n) {
            case "<":
              t = f + t + k + C;
              break;

            case "=":
              t = f + C + t + k;
              break;

            case "^":
              t = C.slice(0, E = C.length >> 1) + f + t + k + C.slice(E);
              break;

            default:
              t = C + f + t + k;
          }

          return s(t);
        }

        return g = void 0 === g ? 6 : /[gprs]/.test(v) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), k.toString = function () {
          return t + "";
        }, k;
      }

      return {
        format: h,
        formatPrefix: function formatPrefix(t, e) {
          var n = h(((t = Ji(t)).type = "f", t)),
              r = 3 * Math.max(-8, Math.min(8, Math.floor(na(e) / 3))),
              i = Math.pow(10, -r),
              a = la[8 + r / 3];
          return function (t) {
            return n(i * t) + a;
          };
        }
      };
    }({
      thousands: ",",
      grouping: [3],
      currency: ["$", ""]
    }), sa = oa.format, ca = oa.formatPrefix;

    var da = /*#__PURE__*/function (_Map2) {
      _inherits(da, _Map2);

      var _super28 = _createSuper(da);

      function da(t) {
        var _this59;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ya;

        _classCallCheck(this, da);

        if (_this59 = _super28.call(this), Object.defineProperties(_assertThisInitialized(_this59), {
          _intern: {
            value: new Map()
          },
          _key: {
            value: e
          }
        }), null != t) {
          var _iterator38 = _createForOfIteratorHelper(t),
              _step38;

          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _step38$value = _slicedToArray(_step38.value, 2),
                  _e7 = _step38$value[0],
                  _n7 = _step38$value[1];

              _this59.set(_e7, _n7);
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
        }

        return _possibleConstructorReturn(_this59);
      }

      _createClass(da, [{
        key: "get",
        value: function get(t) {
          return _get(_getPrototypeOf(da.prototype), "get", this).call(this, pa(this, t));
        }
      }, {
        key: "has",
        value: function has(t) {
          return _get(_getPrototypeOf(da.prototype), "has", this).call(this, pa(this, t));
        }
      }, {
        key: "set",
        value: function set(t, e) {
          return _get(_getPrototypeOf(da.prototype), "set", this).call(this, function (_ref15, n) {
            var t = _ref15._intern,
                e = _ref15._key;
            var r = e(n);
            return t.has(r) ? t.get(r) : (t.set(r, n), n);
          }(this, t), e);
        }
      }, {
        key: "delete",
        value: function _delete(t) {
          return _get(_getPrototypeOf(da.prototype), "delete", this).call(this, function (_ref16, n) {
            var t = _ref16._intern,
                e = _ref16._key;
            var r = e(n);
            return t.has(r) && (n = t.get(r), t["delete"](r)), n;
          }(this, t));
        }
      }]);

      return da;
    }( /*#__PURE__*/_wrapNativeSuper(Map));

    function pa(_ref17, n) {
      var t = _ref17._intern,
          e = _ref17._key;
      var r = e(n);
      return t.has(r) ? t.get(r) : n;
    }

    function ya(t) {
      return null !== t && "object" == _typeof(t) ? t.valueOf() : t;
    }

    var ga = Symbol("implicit");

    function ma() {
      var t = new da(),
          e = [],
          n = [],
          r = ga;

      function i(i) {
        var a = t.get(i);

        if (void 0 === a) {
          if (r !== ga) return r;
          t.set(i, a = e.push(i) - 1);
        }

        return n[a % n.length];
      }

      return i.domain = function (n) {
        if (!arguments.length) return e.slice();
        e = [], t = new da();

        var _iterator39 = _createForOfIteratorHelper(n),
            _step39;

        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var _r6 = _step39.value;
            t.has(_r6) || t.set(_r6, e.push(_r6) - 1);
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }

        return i;
      }, i.range = function (t) {
        return arguments.length ? (n = Array.from(t), i) : n.slice();
      }, i.unknown = function (t) {
        return arguments.length ? (r = t, i) : r;
      }, i.copy = function () {
        return ma(e, n).unknown(r);
      }, Zi.apply(i, arguments), i;
    }

    var va = 1e3,
        ba = 6e4,
        _a = 36e5,
        xa = 864e5,
        wa = 6048e5,
        ka = 31536e6;
    var Ta = new Date(),
        Ea = new Date();

    function Ca(t, e, n, r) {
      function i(e) {
        return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
      }

      return i.floor = function (e) {
        return t(e = new Date(+e)), e;
      }, i.ceil = function (n) {
        return t(n = new Date(n - 1)), e(n, 1), t(n), n;
      }, i.round = function (t) {
        var e = i(t),
            n = i.ceil(t);
        return t - e < n - t ? e : n;
      }, i.offset = function (t, n) {
        return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
      }, i.range = function (n, r, a) {
        var o,
            s = [];
        if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

        do {
          s.push(o = new Date(+n)), e(n, a), t(n);
        } while (o < n && n < r);

        return s;
      }, i.filter = function (n) {
        return Ca(function (e) {
          if (e >= e) for (; t(e), !n(e);) {
            e.setTime(e - 1);
          }
        }, function (t, r) {
          if (t >= t) if (r < 0) for (; ++r <= 0;) {
            for (; e(t, -1), !n(t);) {
              ;
            }
          } else for (; --r >= 0;) {
            for (; e(t, 1), !n(t);) {
              ;
            }
          }
        });
      }, n && (i.count = function (e, r) {
        return Ta.setTime(+e), Ea.setTime(+r), t(Ta), t(Ea), Math.floor(n(Ta, Ea));
      }, i.every = function (t) {
        return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
          return r(e) % t == 0;
        } : function (e) {
          return i.count(0, e) % t == 0;
        }) : i : null;
      }), i;
    }

    var Sa = Ca(function () {}, function (t, e) {
      t.setTime(+t + e);
    }, function (t, e) {
      return e - t;
    });

    Sa.every = function (t) {
      return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? Ca(function (e) {
        e.setTime(Math.floor(e / t) * t);
      }, function (e, n) {
        e.setTime(+e + n * t);
      }, function (e, n) {
        return (n - e) / t;
      }) : Sa : null;
    };

    var Aa = Sa;
    var Ma = Ca(function (t) {
      t.setTime(t - t.getMilliseconds());
    }, function (t, e) {
      t.setTime(+t + e * va);
    }, function (t, e) {
      return (e - t) / va;
    }, function (t) {
      return t.getUTCSeconds();
    });
    var Na = Ma;
    var Da = Ca(function (t) {
      t.setTime(t - t.getMilliseconds() - t.getSeconds() * va);
    }, function (t, e) {
      t.setTime(+t + e * ba);
    }, function (t, e) {
      return (e - t) / ba;
    }, function (t) {
      return t.getMinutes();
    });
    var Oa = Da;
    var Ba = Ca(function (t) {
      t.setTime(t - t.getMilliseconds() - t.getSeconds() * va - t.getMinutes() * ba);
    }, function (t, e) {
      t.setTime(+t + e * _a);
    }, function (t, e) {
      return (e - t) / _a;
    }, function (t) {
      return t.getHours();
    });
    var La = Ba;
    var Ia = Ca(function (t) {
      return t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      return t.setDate(t.getDate() + e);
    }, function (t, e) {
      return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * ba) / xa;
    }, function (t) {
      return t.getDate() - 1;
    });
    var Ra = Ia;

    function Fa(t) {
      return Ca(function (e) {
        e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setDate(t.getDate() + 7 * e);
      }, function (t, e) {
        return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * ba) / wa;
      });
    }

    var Pa = Fa(0),
        ja = Fa(1);
    Fa(2);
    Fa(3);
    var Ua = Fa(4);
    Fa(5);
    Fa(6);
    var $a = Ca(function (t) {
      t.setDate(1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setMonth(t.getMonth() + e);
    }, function (t, e) {
      return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
    }, function (t) {
      return t.getMonth();
    });
    var Wa = $a;
    var Va = Ca(function (t) {
      t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setFullYear(t.getFullYear() + e);
    }, function (t, e) {
      return e.getFullYear() - t.getFullYear();
    }, function (t) {
      return t.getFullYear();
    });

    Va.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? Ca(function (e) {
        e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setFullYear(e.getFullYear() + n * t);
      }) : null;
    };

    var Ga = Va;
    Ca(function (t) {
      t.setUTCSeconds(0, 0);
    }, function (t, e) {
      t.setTime(+t + e * ba);
    }, function (t, e) {
      return (e - t) / ba;
    }, function (t) {
      return t.getUTCMinutes();
    });
    Ca(function (t) {
      t.setUTCMinutes(0, 0, 0);
    }, function (t, e) {
      t.setTime(+t + e * _a);
    }, function (t, e) {
      return (e - t) / _a;
    }, function (t) {
      return t.getUTCHours();
    });
    var Ja = Ca(function (t) {
      t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCDate(t.getUTCDate() + e);
    }, function (t, e) {
      return (e - t) / xa;
    }, function (t) {
      return t.getUTCDate() - 1;
    });
    var to = Ja;

    function eo(t) {
      return Ca(function (e) {
        e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setUTCDate(t.getUTCDate() + 7 * e);
      }, function (t, e) {
        return (e - t) / wa;
      });
    }

    var no = eo(0),
        ro = eo(1);
    eo(2);
    eo(3);
    var oo = eo(4);
    eo(5);
    eo(6);
    Ca(function (t) {
      t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCMonth(t.getUTCMonth() + e);
    }, function (t, e) {
      return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
    }, function (t) {
      return t.getUTCMonth();
    });
    var ho = Ca(function (t) {
      t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCFullYear(t.getUTCFullYear() + e);
    }, function (t, e) {
      return e.getUTCFullYear() - t.getUTCFullYear();
    }, function (t) {
      return t.getUTCFullYear();
    });

    ho.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? Ca(function (e) {
        e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setUTCFullYear(e.getUTCFullYear() + n * t);
      }) : null;
    };

    var fo = ho;

    function po(t, e, n, r, i, a) {
      var o = [[Na, 1, va], [Na, 5, 5e3], [Na, 15, 15e3], [Na, 30, 3e4], [a, 1, ba], [a, 5, 3e5], [a, 15, 9e5], [a, 30, 18e5], [i, 1, _a], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, xa], [r, 2, 1728e5], [n, 1, wa], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, ka]];

      function s(e, n, r) {
        var i = Math.abs(n - e) / r,
            a = Wr(function (_ref18) {
          var _ref19 = _slicedToArray(_ref18, 3),
              t = _ref19[2];

          return t;
        }).right(o, i);
        if (a === o.length) return t.every(Hr(e / ka, n / ka, r));
        if (0 === a) return Aa.every(Math.max(Hr(e, n, r), 1));

        var _o2 = _slicedToArray(o[i / o[a - 1][2] < o[a][2] / i ? a - 1 : a], 2),
            s = _o2[0],
            c = _o2[1];

        return s.every(c);
      }

      return [function (t, e, n) {
        var _ref20;

        var r = e < t;
        r && (_ref20 = [e, t], t = _ref20[0], e = _ref20[1], _ref20);
        var i = n && "function" == typeof n.range ? n : s(t, e, n),
            a = i ? i.range(t, +e + 1) : [];
        return r ? a.reverse() : a;
      }, s];
    }

    var _po = po(Ga, Wa, Pa, Ra, La, Oa),
        _po2 = _slicedToArray(_po, 2),
        mo = _po2[0],
        vo = _po2[1];

    function bo(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
        return e.setFullYear(t.y), e;
      }

      return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
    }

    function _o(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
        return e.setUTCFullYear(t.y), e;
      }

      return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
    }

    function xo(t, e, n) {
      return {
        y: t,
        m: e,
        d: n,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    var wo,
        ko,
        To = {
      "-": "",
      _: " ",
      0: "0"
    },
        Eo = /^\s*\d+/,
        Co = /^%/,
        So = /[\\^$*+?|[\]().{}]/g;

    function Ao(t, e, n) {
      var r = t < 0 ? "-" : "",
          i = (r ? -t : t) + "",
          a = i.length;
      return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
    }

    function Mo(t) {
      return t.replace(So, "\\$&");
    }

    function No(t) {
      return new RegExp("^(?:" + t.map(Mo).join("|") + ")", "i");
    }

    function Do(t) {
      return new Map(t.map(function (t, e) {
        return [t.toLowerCase(), e];
      }));
    }

    function Oo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 1));
      return r ? (t.w = +r[0], n + r[0].length) : -1;
    }

    function Bo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 1));
      return r ? (t.u = +r[0], n + r[0].length) : -1;
    }

    function Lo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.U = +r[0], n + r[0].length) : -1;
    }

    function Io(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.V = +r[0], n + r[0].length) : -1;
    }

    function Ro(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.W = +r[0], n + r[0].length) : -1;
    }

    function Fo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 4));
      return r ? (t.y = +r[0], n + r[0].length) : -1;
    }

    function Po(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    }

    function jo(t, e, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
      return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    }

    function Yo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 1));
      return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
    }

    function zo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
    }

    function Uo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.d = +r[0], n + r[0].length) : -1;
    }

    function qo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 3));
      return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
    }

    function Ho(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.H = +r[0], n + r[0].length) : -1;
    }

    function $o(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.M = +r[0], n + r[0].length) : -1;
    }

    function Wo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 2));
      return r ? (t.S = +r[0], n + r[0].length) : -1;
    }

    function Vo(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 3));
      return r ? (t.L = +r[0], n + r[0].length) : -1;
    }

    function Go(t, e, n) {
      var r = Eo.exec(e.slice(n, n + 6));
      return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    }

    function Xo(t, e, n) {
      var r = Co.exec(e.slice(n, n + 1));
      return r ? n + r[0].length : -1;
    }

    function Zo(t, e, n) {
      var r = Eo.exec(e.slice(n));
      return r ? (t.Q = +r[0], n + r[0].length) : -1;
    }

    function Qo(t, e, n) {
      var r = Eo.exec(e.slice(n));
      return r ? (t.s = +r[0], n + r[0].length) : -1;
    }

    function Ko(t, e) {
      return Ao(t.getDate(), e, 2);
    }

    function Jo(t, e) {
      return Ao(t.getHours(), e, 2);
    }

    function ts(t, e) {
      return Ao(t.getHours() % 12 || 12, e, 2);
    }

    function es(t, e) {
      return Ao(1 + Ra.count(Ga(t), t), e, 3);
    }

    function ns(t, e) {
      return Ao(t.getMilliseconds(), e, 3);
    }

    function rs(t, e) {
      return ns(t, e) + "000";
    }

    function is(t, e) {
      return Ao(t.getMonth() + 1, e, 2);
    }

    function as(t, e) {
      return Ao(t.getMinutes(), e, 2);
    }

    function os(t, e) {
      return Ao(t.getSeconds(), e, 2);
    }

    function ss(t) {
      var e = t.getDay();
      return 0 === e ? 7 : e;
    }

    function cs(t, e) {
      return Ao(Pa.count(Ga(t) - 1, t), e, 2);
    }

    function us(t) {
      var e = t.getDay();
      return e >= 4 || 0 === e ? Ua(t) : Ua.ceil(t);
    }

    function ls(t, e) {
      return t = us(t), Ao(Ua.count(Ga(t), t) + (4 === Ga(t).getDay()), e, 2);
    }

    function hs(t) {
      return t.getDay();
    }

    function fs(t, e) {
      return Ao(ja.count(Ga(t) - 1, t), e, 2);
    }

    function ds(t, e) {
      return Ao(t.getFullYear() % 100, e, 2);
    }

    function ps(t, e) {
      return Ao((t = us(t)).getFullYear() % 100, e, 2);
    }

    function ys(t, e) {
      return Ao(t.getFullYear() % 1e4, e, 4);
    }

    function gs(t, e) {
      var n = t.getDay();
      return Ao((t = n >= 4 || 0 === n ? Ua(t) : Ua.ceil(t)).getFullYear() % 1e4, e, 4);
    }

    function ms(t) {
      var e = t.getTimezoneOffset();
      return (e > 0 ? "-" : (e *= -1, "+")) + Ao(e / 60 | 0, "0", 2) + Ao(e % 60, "0", 2);
    }

    function vs(t, e) {
      return Ao(t.getUTCDate(), e, 2);
    }

    function bs(t, e) {
      return Ao(t.getUTCHours(), e, 2);
    }

    function _s(t, e) {
      return Ao(t.getUTCHours() % 12 || 12, e, 2);
    }

    function xs(t, e) {
      return Ao(1 + to.count(fo(t), t), e, 3);
    }

    function ws(t, e) {
      return Ao(t.getUTCMilliseconds(), e, 3);
    }

    function ks(t, e) {
      return ws(t, e) + "000";
    }

    function Ts(t, e) {
      return Ao(t.getUTCMonth() + 1, e, 2);
    }

    function Es(t, e) {
      return Ao(t.getUTCMinutes(), e, 2);
    }

    function Cs(t, e) {
      return Ao(t.getUTCSeconds(), e, 2);
    }

    function Ss(t) {
      var e = t.getUTCDay();
      return 0 === e ? 7 : e;
    }

    function As(t, e) {
      return Ao(no.count(fo(t) - 1, t), e, 2);
    }

    function Ms(t) {
      var e = t.getUTCDay();
      return e >= 4 || 0 === e ? oo(t) : oo.ceil(t);
    }

    function Ns(t, e) {
      return t = Ms(t), Ao(oo.count(fo(t), t) + (4 === fo(t).getUTCDay()), e, 2);
    }

    function Ds(t) {
      return t.getUTCDay();
    }

    function Os(t, e) {
      return Ao(ro.count(fo(t) - 1, t), e, 2);
    }

    function Bs(t, e) {
      return Ao(t.getUTCFullYear() % 100, e, 2);
    }

    function Ls(t, e) {
      return Ao((t = Ms(t)).getUTCFullYear() % 100, e, 2);
    }

    function Is(t, e) {
      return Ao(t.getUTCFullYear() % 1e4, e, 4);
    }

    function Rs(t, e) {
      var n = t.getUTCDay();
      return Ao((t = n >= 4 || 0 === n ? oo(t) : oo.ceil(t)).getUTCFullYear() % 1e4, e, 4);
    }

    function Fs() {
      return "+0000";
    }

    function Ps() {
      return "%";
    }

    function js(t) {
      return +t;
    }

    function Ys(t) {
      return Math.floor(+t / 1e3);
    }

    function zs(t) {
      return new Date(t);
    }

    function Us(t) {
      return t instanceof Date ? +t : +new Date(+t);
    }

    function qs(t, e, n, r, i, a, o, s, c, u) {
      var l = Xi(),
          h = l.invert,
          f = l.domain,
          d = u(".%L"),
          p = u(":%S"),
          y = u("%I:%M"),
          g = u("%I %p"),
          m = u("%a %d"),
          v = u("%b %d"),
          b = u("%B"),
          _ = u("%Y");

      function x(t) {
        return (c(t) < t ? d : s(t) < t ? p : o(t) < t ? y : a(t) < t ? g : r(t) < t ? i(t) < t ? m : v : n(t) < t ? b : _)(t);
      }

      return l.invert = function (t) {
        return new Date(h(t));
      }, l.domain = function (t) {
        return arguments.length ? f(Array.from(t, Us)) : f().map(zs);
      }, l.ticks = function (e) {
        var n = f();
        return t(n[0], n[n.length - 1], null == e ? 10 : e);
      }, l.tickFormat = function (t, e) {
        return null == e ? x : u(e);
      }, l.nice = function (t) {
        var n = f();
        return t && "function" == typeof t.range || (t = e(n[0], n[n.length - 1], null == t ? 10 : t)), t ? f(function (t, e) {
          var n,
              r = 0,
              i = (t = t.slice()).length - 1,
              a = t[r],
              o = t[i];
          return o < a && (n = r, r = i, i = n, n = a, a = o, o = n), t[r] = e.floor(a), t[i] = e.ceil(o), t;
        }(n, t)) : l;
      }, l.copy = function () {
        return Gi(l, qs(t, e, n, r, i, a, o, s, c, u));
      }, l;
    }

    function Hs() {}

    function $s(t) {
      return null == t ? Hs : function () {
        return this.querySelector(t);
      };
    }

    function Ws(t) {
      return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
    }

    function Vs() {
      return [];
    }

    function Gs(t) {
      return null == t ? Vs : function () {
        return this.querySelectorAll(t);
      };
    }

    function Xs(t) {
      return function () {
        return this.matches(t);
      };
    }

    function Zs(t) {
      return function (e) {
        return e.matches(t);
      };
    }

    wo = function (t) {
      var e = t.dateTime,
          n = t.date,
          r = t.time,
          i = t.periods,
          a = t.days,
          o = t.shortDays,
          s = t.months,
          c = t.shortMonths,
          u = No(i),
          l = Do(i),
          h = No(a),
          f = Do(a),
          d = No(o),
          p = Do(o),
          y = No(s),
          g = Do(s),
          m = No(c),
          v = Do(c),
          b = {
        a: function a(t) {
          return o[t.getDay()];
        },
        A: function A(t) {
          return a[t.getDay()];
        },
        b: function b(t) {
          return c[t.getMonth()];
        },
        B: function B(t) {
          return s[t.getMonth()];
        },
        c: null,
        d: Ko,
        e: Ko,
        f: rs,
        g: ps,
        G: gs,
        H: Jo,
        I: ts,
        j: es,
        L: ns,
        m: is,
        M: as,
        p: function p(t) {
          return i[+(t.getHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getMonth() / 3);
        },
        Q: js,
        s: Ys,
        S: os,
        u: ss,
        U: cs,
        V: ls,
        w: hs,
        W: fs,
        x: null,
        X: null,
        y: ds,
        Y: ys,
        Z: ms,
        "%": Ps
      },
          _ = {
        a: function a(t) {
          return o[t.getUTCDay()];
        },
        A: function A(t) {
          return a[t.getUTCDay()];
        },
        b: function b(t) {
          return c[t.getUTCMonth()];
        },
        B: function B(t) {
          return s[t.getUTCMonth()];
        },
        c: null,
        d: vs,
        e: vs,
        f: ks,
        g: Ls,
        G: Rs,
        H: bs,
        I: _s,
        j: xs,
        L: ws,
        m: Ts,
        M: Es,
        p: function p(t) {
          return i[+(t.getUTCHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getUTCMonth() / 3);
        },
        Q: js,
        s: Ys,
        S: Cs,
        u: Ss,
        U: As,
        V: Ns,
        w: Ds,
        W: Os,
        x: null,
        X: null,
        y: Bs,
        Y: Is,
        Z: Fs,
        "%": Ps
      },
          x = {
        a: function a(t, e, n) {
          var r = d.exec(e.slice(n));
          return r ? (t.w = p.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        A: function A(t, e, n) {
          var r = h.exec(e.slice(n));
          return r ? (t.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        b: function b(t, e, n) {
          var r = m.exec(e.slice(n));
          return r ? (t.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        B: function B(t, e, n) {
          var r = y.exec(e.slice(n));
          return r ? (t.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        c: function c(t, n, r) {
          return T(t, e, n, r);
        },
        d: Uo,
        e: Uo,
        f: Go,
        g: Po,
        G: Fo,
        H: Ho,
        I: Ho,
        j: qo,
        L: Vo,
        m: zo,
        M: $o,
        p: function p(t, e, n) {
          var r = u.exec(e.slice(n));
          return r ? (t.p = l.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        q: Yo,
        Q: Zo,
        s: Qo,
        S: Wo,
        u: Bo,
        U: Lo,
        V: Io,
        w: Oo,
        W: Ro,
        x: function x(t, e, r) {
          return T(t, n, e, r);
        },
        X: function X(t, e, n) {
          return T(t, r, e, n);
        },
        y: Po,
        Y: Fo,
        Z: jo,
        "%": Xo
      };

      function w(t, e) {
        return function (n) {
          var r,
              i,
              a,
              o = [],
              s = -1,
              c = 0,
              u = t.length;

          for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
            37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = To[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
          }

          return o.push(t.slice(c, s)), o.join("");
        };
      }

      function k(t, e) {
        return function (n) {
          var r,
              i,
              a = xo(1900, void 0, 1);
          if (T(a, t, n += "", 0) != n.length) return null;
          if ("Q" in a) return new Date(a.Q);
          if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

          if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
            if (a.V < 1 || a.V > 53) return null;
            "w" in a || (a.w = 1), "Z" in a ? (i = (r = _o(xo(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? ro.ceil(r) : ro(r), r = to.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = bo(xo(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? ja.ceil(r) : ja(r), r = Ra.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
          } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? _o(xo(a.y, 0, 1)).getUTCDay() : bo(xo(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

          return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, _o(a)) : bo(a);
        };
      }

      function T(t, e, n, r) {
        for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
          if (r >= c) return -1;

          if (37 === (i = e.charCodeAt(o++))) {
            if (i = e.charAt(o++), !(a = x[i in To ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
          } else if (i != n.charCodeAt(r++)) return -1;
        }

        return r;
      }

      return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
        format: function format(t) {
          var e = w(t += "", b);
          return e.toString = function () {
            return t;
          }, e;
        },
        parse: function parse(t) {
          var e = k(t += "", !1);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcFormat: function utcFormat(t) {
          var e = w(t += "", _);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcParse: function utcParse(t) {
          var e = k(t += "", !0);
          return e.toString = function () {
            return t;
          }, e;
        }
      };
    }({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }), ko = wo.format, wo.parse, wo.utcFormat, wo.utcParse;
    var Qs = Array.prototype.find;

    function Ks() {
      return this.firstElementChild;
    }

    var Js = Array.prototype.filter;

    function tc() {
      return Array.from(this.children);
    }

    function ec(t) {
      return new Array(t.length);
    }

    function nc(t, e) {
      this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
    }

    function rc(t) {
      return function () {
        return t;
      };
    }

    function ic(t, e, n, r, i, a) {
      for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
        (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new nc(t, a[s]);
      }

      for (; s < c; ++s) {
        (o = e[s]) && (i[s] = o);
      }
    }

    function ac(t, e, n, r, i, a, o) {
      var s,
          c,
          u,
          l = new Map(),
          h = e.length,
          f = a.length,
          d = new Array(h);

      for (s = 0; s < h; ++s) {
        (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
      }

      for (s = 0; s < f; ++s) {
        u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l["delete"](u)) : n[s] = new nc(t, a[s]);
      }

      for (s = 0; s < h; ++s) {
        (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
      }
    }

    function oc(t) {
      return t.__data__;
    }

    function sc(t) {
      return "object" == _typeof(t) && "length" in t ? t : Array.from(t);
    }

    function cc(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    nc.prototype = {
      constructor: nc,
      appendChild: function appendChild(t) {
        return this._parent.insertBefore(t, this._next);
      },
      insertBefore: function insertBefore(t, e) {
        return this._parent.insertBefore(t, e);
      },
      querySelector: function querySelector(t) {
        return this._parent.querySelector(t);
      },
      querySelectorAll: function querySelectorAll(t) {
        return this._parent.querySelectorAll(t);
      }
    };
    var uc = "http://www.w3.org/1999/xhtml";
    var lc = {
      svg: "http://www.w3.org/2000/svg",
      xhtml: uc,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };

    function hc(t) {
      var e = t += "",
          n = e.indexOf(":");
      return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), lc.hasOwnProperty(e) ? {
        space: lc[e],
        local: t
      } : t;
    }

    function fc(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function dc(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function pc(t, e) {
      return function () {
        this.setAttribute(t, e);
      };
    }

    function yc(t, e) {
      return function () {
        this.setAttributeNS(t.space, t.local, e);
      };
    }

    function gc(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
      };
    }

    function mc(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
      };
    }

    function vc(t) {
      return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
    }

    function bc(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function _c(t, e, n) {
      return function () {
        this.style.setProperty(t, e, n);
      };
    }

    function xc(t, e, n) {
      return function () {
        var r = e.apply(this, arguments);
        null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
      };
    }

    function wc(t, e) {
      return t.style.getPropertyValue(e) || vc(t).getComputedStyle(t, null).getPropertyValue(e);
    }

    function kc(t) {
      return function () {
        delete this[t];
      };
    }

    function Tc(t, e) {
      return function () {
        this[t] = e;
      };
    }

    function Ec(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? delete this[t] : this[t] = n;
      };
    }

    function Cc(t) {
      return t.trim().split(/^|\s+/);
    }

    function Sc(t) {
      return t.classList || new Ac(t);
    }

    function Ac(t) {
      this._node = t, this._names = Cc(t.getAttribute("class") || "");
    }

    function Mc(t, e) {
      for (var n = Sc(t), r = -1, i = e.length; ++r < i;) {
        n.add(e[r]);
      }
    }

    function Nc(t, e) {
      for (var n = Sc(t), r = -1, i = e.length; ++r < i;) {
        n.remove(e[r]);
      }
    }

    function Dc(t) {
      return function () {
        Mc(this, t);
      };
    }

    function Oc(t) {
      return function () {
        Nc(this, t);
      };
    }

    function Bc(t, e) {
      return function () {
        (e.apply(this, arguments) ? Mc : Nc)(this, t);
      };
    }

    function Lc() {
      this.textContent = "";
    }

    function Ic(t) {
      return function () {
        this.textContent = t;
      };
    }

    function Rc(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.textContent = null == e ? "" : e;
      };
    }

    function Fc() {
      this.innerHTML = "";
    }

    function Pc(t) {
      return function () {
        this.innerHTML = t;
      };
    }

    function jc(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.innerHTML = null == e ? "" : e;
      };
    }

    function Yc() {
      this.nextSibling && this.parentNode.appendChild(this);
    }

    function zc() {
      this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }

    function Uc(t) {
      return function () {
        var e = this.ownerDocument,
            n = this.namespaceURI;
        return n === uc && e.documentElement.namespaceURI === uc ? e.createElement(t) : e.createElementNS(n, t);
      };
    }

    function qc(t) {
      return function () {
        return this.ownerDocument.createElementNS(t.space, t.local);
      };
    }

    function Hc(t) {
      var e = hc(t);
      return (e.local ? qc : Uc)(e);
    }

    function $c() {
      return null;
    }

    function Wc() {
      var t = this.parentNode;
      t && t.removeChild(this);
    }

    function Vc() {
      var t = this.cloneNode(!1),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function Gc() {
      var t = this.cloneNode(!0),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function Xc(t) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var e = "",
            n = t.indexOf(".");
        return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
          type: t,
          name: e
        };
      });
    }

    function Zc(t) {
      return function () {
        var e = this.__on;

        if (e) {
          for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
            n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
          }

          ++i ? e.length = i : delete this.__on;
        }
      };
    }

    function Qc(t, e, n) {
      return function () {
        var r,
            i = this.__on,
            a = function (t) {
          return function (e) {
            t.call(this, e, this.__data__);
          };
        }(e);

        if (i) for (var o = 0, s = i.length; o < s; ++o) {
          if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
        }
        this.addEventListener(t.type, a, n), r = {
          type: t.type,
          name: t.name,
          value: e,
          listener: a,
          options: n
        }, i ? i.push(r) : this.__on = [r];
      };
    }

    function Kc(t, e, n) {
      var r = vc(t),
          i = r.CustomEvent;
      "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
    }

    function Jc(t, e) {
      return function () {
        return Kc(this, t, e);
      };
    }

    function tu(t, e) {
      return function () {
        return Kc(this, t, e.apply(this, arguments));
      };
    }

    Ac.prototype = {
      add: function add(t) {
        this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
      },
      remove: function remove(t) {
        var e = this._names.indexOf(t);

        e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
      },
      contains: function contains(t) {
        return this._names.indexOf(t) >= 0;
      }
    };
    var eu = [null];

    function nu(t, e) {
      this._groups = t, this._parents = e;
    }

    function ru() {
      return new nu([[document.documentElement]], eu);
    }

    nu.prototype = ru.prototype = _defineProperty2({
      constructor: nu,
      select: function select(t) {
        "function" != typeof t && (t = $s(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
            (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
          }
        }

        return new nu(r, this._parents);
      },
      selectAll: function selectAll(t) {
        t = "function" == typeof t ? function (t) {
          return function () {
            return Ws(t.apply(this, arguments));
          };
        }(t) : Gs(t);

        for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
          for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
            (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
          }
        }

        return new nu(r, i);
      },
      selectChild: function selectChild(t) {
        return this.select(null == t ? Ks : function (t) {
          return function () {
            return Qs.call(this.children, t);
          };
        }("function" == typeof t ? t : Zs(t)));
      },
      selectChildren: function selectChildren(t) {
        return this.selectAll(null == t ? tc : function (t) {
          return function () {
            return Js.call(this.children, t);
          };
        }("function" == typeof t ? t : Zs(t)));
      },
      filter: function filter(t) {
        "function" != typeof t && (t = Xs(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new nu(r, this._parents);
      },
      data: function data(t, e) {
        if (!arguments.length) return Array.from(this, oc);
        var n = e ? ac : ic,
            r = this._parents,
            i = this._groups;
        "function" != typeof t && (t = rc(t));

        for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
          var l = r[u],
              h = i[u],
              f = h.length,
              d = sc(t.call(l, l && l.__data__, u, r)),
              p = d.length,
              y = s[u] = new Array(p),
              g = o[u] = new Array(p),
              m = c[u] = new Array(f);
          n(l, h, y, g, m, d, e);

          for (var v, b, _ = 0, x = 0; _ < p; ++_) {
            if (v = y[_]) {
              for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                ;
              }

              v._next = b || null;
            }
          }
        }

        return (o = new nu(o, r))._enter = s, o._exit = c, o;
      },
      enter: function enter() {
        return new nu(this._enter || this._groups.map(ec), this._parents);
      },
      exit: function exit() {
        return new nu(this._exit || this._groups.map(ec), this._parents);
      },
      join: function join(t, e, n) {
        var r = this.enter(),
            i = this,
            a = this.exit();
        return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
      },
      merge: function merge(t) {
        for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
          for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
            (u = l[p] || h[p]) && (d[p] = u);
          }
        }

        for (; c < i; ++c) {
          s[c] = n[c];
        }

        return new nu(s, this._parents);
      },
      selection: function selection() {
        return this;
      },
      order: function order() {
        for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
          for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
            (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
          }
        }

        return this;
      },
      sort: function sort(t) {
        function e(e, n) {
          return e && n ? t(e.__data__, n.__data__) : !e - !n;
        }

        t || (t = cc);

        for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
          for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
            (o = s[l]) && (u[l] = o);
          }

          u.sort(e);
        }

        return new nu(i, this._parents).order();
      },
      call: function call() {
        var t = arguments[0];
        return arguments[0] = this, t.apply(null, arguments), this;
      },
      nodes: function nodes() {
        return Array.from(this);
      },
      node: function node() {
        for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
          for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
            var o = r[i];
            if (o) return o;
          }
        }

        return null;
      },
      size: function size() {
        var t = 0;

        var _iterator40 = _createForOfIteratorHelper(this),
            _step40;

        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var _e8 = _step40.value;
            ++t;
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }

        return t;
      },
      empty: function empty() {
        return !this.node();
      },
      each: function each(t) {
        for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
          for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
            (i = a[o]) && t.call(i, i.__data__, o, a);
          }
        }

        return this;
      },
      attr: function attr(t, e) {
        var n = hc(t);

        if (arguments.length < 2) {
          var r = this.node();
          return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
        }

        return this.each((null == e ? n.local ? dc : fc : "function" == typeof e ? n.local ? mc : gc : n.local ? yc : pc)(n, e));
      },
      style: function style(t, e, n) {
        return arguments.length > 1 ? this.each((null == e ? bc : "function" == typeof e ? xc : _c)(t, e, null == n ? "" : n)) : wc(this.node(), t);
      },
      property: function property(t, e) {
        return arguments.length > 1 ? this.each((null == e ? kc : "function" == typeof e ? Ec : Tc)(t, e)) : this.node()[t];
      },
      classed: function classed(t, e) {
        var n = Cc(t + "");

        if (arguments.length < 2) {
          for (var r = Sc(this.node()), i = -1, a = n.length; ++i < a;) {
            if (!r.contains(n[i])) return !1;
          }

          return !0;
        }

        return this.each(("function" == typeof e ? Bc : e ? Dc : Oc)(n, e));
      },
      text: function text(t) {
        return arguments.length ? this.each(null == t ? Lc : ("function" == typeof t ? Rc : Ic)(t)) : this.node().textContent;
      },
      html: function html(t) {
        return arguments.length ? this.each(null == t ? Fc : ("function" == typeof t ? jc : Pc)(t)) : this.node().innerHTML;
      },
      raise: function raise() {
        return this.each(Yc);
      },
      lower: function lower() {
        return this.each(zc);
      },
      append: function append(t) {
        var e = "function" == typeof t ? t : Hc(t);
        return this.select(function () {
          return this.appendChild(e.apply(this, arguments));
        });
      },
      insert: function insert(t, e) {
        var n = "function" == typeof t ? t : Hc(t),
            r = null == e ? $c : "function" == typeof e ? e : $s(e);
        return this.select(function () {
          return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
        });
      },
      remove: function remove() {
        return this.each(Wc);
      },
      clone: function clone(t) {
        return this.select(t ? Gc : Vc);
      },
      datum: function datum(t) {
        return arguments.length ? this.property("__data__", t) : this.node().__data__;
      },
      on: function on(t, e, n) {
        var r,
            i,
            a = Xc(t + ""),
            o = a.length;

        if (!(arguments.length < 2)) {
          for (s = e ? Qc : Zc, r = 0; r < o; ++r) {
            this.each(s(a[r], e, n));
          }

          return this;
        }

        var s = this.node().__on;

        if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
          for (r = 0, c = s[u]; r < o; ++r) {
            if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
          }
        }
      },
      dispatch: function dispatch(t, e) {
        return this.each(("function" == typeof e ? tu : Jc)(t, e));
      }
    }, Symbol.iterator, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var t, e, n, r, i, a, o;
      return regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              t = this._groups, e = 0, n = t.length;

            case 1:
              if (!(e < n)) {
                _context5.next = 14;
                break;
              }

              i = t[e], a = 0, o = i.length;

            case 3:
              if (!(a < o)) {
                _context5.next = 11;
                break;
              }

              _context5.t0 = r = i[a];

              if (!_context5.t0) {
                _context5.next = 8;
                break;
              }

              _context5.next = 8;
              return r;

            case 8:
              ++a;
              _context5.next = 3;
              break;

            case 11:
              ++e;
              _context5.next = 1;
              break;

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4, this);
    }));
    var iu = ru;

    function au(t) {
      return "string" == typeof t ? new nu([[document.querySelector(t)]], [document.documentElement]) : new nu([[t]], eu);
    }

    function ou(t) {
      return "string" == typeof t ? new nu([document.querySelectorAll(t)], [document.documentElement]) : new nu([Ws(t)], eu);
    }

    var su = Math.PI,
        cu = 2 * su,
        uu = 1e-6,
        lu = cu - uu;

    function hu() {
      this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
    }

    function fu() {
      return new hu();
    }

    hu.prototype = fu.prototype = {
      constructor: hu,
      moveTo: function moveTo(t, e) {
        this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
      },
      closePath: function closePath() {
        null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
      },
      lineTo: function lineTo(t, e) {
        this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
      },
      quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
        this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
      },
      bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
        this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
      },
      arcTo: function arcTo(t, e, n, r, i) {
        t = +t, e = +e, n = +n, r = +r, i = +i;
        var a = this._x1,
            o = this._y1,
            s = n - t,
            c = r - e,
            u = a - t,
            l = o - e,
            h = u * u + l * l;
        if (i < 0) throw new Error("negative radius: " + i);
        if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (h > uu) if (Math.abs(l * s - c * u) > uu && i) {
          var f = n - a,
              d = r - o,
              p = s * s + c * c,
              y = f * f + d * d,
              g = Math.sqrt(p),
              m = Math.sqrt(h),
              v = i * Math.tan((su - Math.acos((p + h - y) / (2 * g * m))) / 2),
              b = v / m,
              _ = v / g;

          Math.abs(b - 1) > uu && (this._ += "L" + (t + b * u) + "," + (e + b * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > u * d) + "," + (this._x1 = t + _ * s) + "," + (this._y1 = e + _ * c);
        } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
      },
      arc: function arc(t, e, n, r, i, a) {
        t = +t, e = +e, a = !!a;
        var o = (n = +n) * Math.cos(r),
            s = n * Math.sin(r),
            c = t + o,
            u = e + s,
            l = 1 ^ a,
            h = a ? r - i : i - r;
        if (n < 0) throw new Error("negative radius: " + n);
        null === this._x1 ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > uu || Math.abs(this._y1 - u) > uu) && (this._ += "L" + c + "," + u), n && (h < 0 && (h = h % cu + cu), h > lu ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : h > uu && (this._ += "A" + n + "," + n + ",0," + +(h >= su) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
      },
      rect: function rect(t, e, n, r) {
        this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
      },
      toString: function toString() {
        return this._;
      }
    };
    var du = fu;

    function pu(t) {
      return function () {
        return t;
      };
    }

    var yu = Math.abs,
        gu = Math.atan2,
        mu = Math.cos,
        vu = Math.max,
        bu = Math.min,
        _u = Math.sin,
        xu = Math.sqrt,
        wu = 1e-12,
        ku = Math.PI,
        Tu = ku / 2,
        Eu = 2 * ku;

    function Cu(t) {
      return t > 1 ? 0 : t < -1 ? ku : Math.acos(t);
    }

    function Su(t) {
      return t >= 1 ? Tu : t <= -1 ? -Tu : Math.asin(t);
    }

    function Au(t) {
      return t.innerRadius;
    }

    function Mu(t) {
      return t.outerRadius;
    }

    function Nu(t) {
      return t.startAngle;
    }

    function Du(t) {
      return t.endAngle;
    }

    function Ou(t) {
      return t && t.padAngle;
    }

    function Bu(t, e, n, r, i, a, o, s) {
      var c = n - t,
          u = r - e,
          l = o - i,
          h = s - a,
          f = h * c - l * u;
      if (!(f * f < wu)) return [t + (f = (l * (e - a) - h * (t - i)) / f) * c, e + f * u];
    }

    function Lu(t, e, n, r, i, a, o) {
      var s = t - n,
          c = e - r,
          u = (o ? a : -a) / xu(s * s + c * c),
          l = u * c,
          h = -u * s,
          f = t + l,
          d = e + h,
          p = n + l,
          y = r + h,
          g = (f + p) / 2,
          m = (d + y) / 2,
          v = p - f,
          b = y - d,
          _ = v * v + b * b,
          x = i - a,
          w = f * y - p * d,
          k = (b < 0 ? -1 : 1) * xu(vu(0, x * x * _ - w * w)),
          T = (w * b - v * k) / _,
          E = (-w * v - b * k) / _,
          C = (w * b + v * k) / _,
          S = (-w * v + b * k) / _,
          A = T - g,
          M = E - m,
          N = C - g,
          D = S - m;

      return A * A + M * M > N * N + D * D && (T = C, E = S), {
        cx: T,
        cy: E,
        x01: -l,
        y01: -h,
        x11: T * (i / x - 1),
        y11: E * (i / x - 1)
      };
    }

    function Iu() {
      var t = Au,
          e = Mu,
          n = pu(0),
          r = null,
          i = Nu,
          a = Du,
          o = Ou,
          s = null;

      function c() {
        var c,
            u,
            l = +t.apply(this, arguments),
            h = +e.apply(this, arguments),
            f = i.apply(this, arguments) - Tu,
            d = a.apply(this, arguments) - Tu,
            p = yu(d - f),
            y = d > f;
        if (s || (s = c = du()), h < l && (u = h, h = l, l = u), h > wu) {
          if (p > Eu - wu) s.moveTo(h * mu(f), h * _u(f)), s.arc(0, 0, h, f, d, !y), l > wu && (s.moveTo(l * mu(d), l * _u(d)), s.arc(0, 0, l, d, f, y));else {
            var g,
                m,
                v = f,
                b = d,
                _ = f,
                x = d,
                w = p,
                k = p,
                T = o.apply(this, arguments) / 2,
                E = T > wu && (r ? +r.apply(this, arguments) : xu(l * l + h * h)),
                C = bu(yu(h - l) / 2, +n.apply(this, arguments)),
                S = C,
                A = C;

            if (E > wu) {
              var M = Su(E / l * _u(T)),
                  N = Su(E / h * _u(T));
              (w -= 2 * M) > wu ? (_ += M *= y ? 1 : -1, x -= M) : (w = 0, _ = x = (f + d) / 2), (k -= 2 * N) > wu ? (v += N *= y ? 1 : -1, b -= N) : (k = 0, v = b = (f + d) / 2);
            }

            var D = h * mu(v),
                O = h * _u(v),
                B = l * mu(x),
                L = l * _u(x);

            if (C > wu) {
              var I,
                  R = h * mu(b),
                  F = h * _u(b),
                  P = l * mu(_),
                  j = l * _u(_);

              if (p < ku && (I = Bu(D, O, P, j, R, F, B, L))) {
                var Y = D - I[0],
                    z = O - I[1],
                    U = R - I[0],
                    q = F - I[1],
                    H = 1 / _u(Cu((Y * U + z * q) / (xu(Y * Y + z * z) * xu(U * U + q * q))) / 2),
                    $ = xu(I[0] * I[0] + I[1] * I[1]);

                S = bu(C, (l - $) / (H - 1)), A = bu(C, (h - $) / (H + 1));
              }
            }

            k > wu ? A > wu ? (g = Lu(P, j, D, O, h, A, y), m = Lu(R, F, B, L, h, A, y), s.moveTo(g.cx + g.x01, g.cy + g.y01), A < C ? s.arc(g.cx, g.cy, A, gu(g.y01, g.x01), gu(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, A, gu(g.y01, g.x01), gu(g.y11, g.x11), !y), s.arc(0, 0, h, gu(g.cy + g.y11, g.cx + g.x11), gu(m.cy + m.y11, m.cx + m.x11), !y), s.arc(m.cx, m.cy, A, gu(m.y11, m.x11), gu(m.y01, m.x01), !y))) : (s.moveTo(D, O), s.arc(0, 0, h, v, b, !y)) : s.moveTo(D, O), l > wu && w > wu ? S > wu ? (g = Lu(B, L, R, F, l, -S, y), m = Lu(D, O, P, j, l, -S, y), s.lineTo(g.cx + g.x01, g.cy + g.y01), S < C ? s.arc(g.cx, g.cy, S, gu(g.y01, g.x01), gu(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, S, gu(g.y01, g.x01), gu(g.y11, g.x11), !y), s.arc(0, 0, l, gu(g.cy + g.y11, g.cx + g.x11), gu(m.cy + m.y11, m.cx + m.x11), y), s.arc(m.cx, m.cy, S, gu(m.y11, m.x11), gu(m.y01, m.x01), !y))) : s.arc(0, 0, l, x, _, y) : s.lineTo(B, L);
          }
        } else s.moveTo(0, 0);
        if (s.closePath(), c) return s = null, c + "" || null;
      }

      return c.centroid = function () {
        var n = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
            r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - ku / 2;
        return [mu(r) * n, _u(r) * n];
      }, c.innerRadius = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : pu(+e), c) : t;
      }, c.outerRadius = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : pu(+t), c) : e;
      }, c.cornerRadius = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : pu(+t), c) : n;
      }, c.padRadius = function (t) {
        return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : pu(+t), c) : r;
      }, c.startAngle = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : pu(+t), c) : i;
      }, c.endAngle = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : pu(+t), c) : a;
      }, c.padAngle = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : pu(+t), c) : o;
      }, c.context = function (t) {
        return arguments.length ? (s = null == t ? null : t, c) : s;
      }, c;
    }

    function Ru(t) {
      return "object" == _typeof(t) && "length" in t ? t : Array.from(t);
    }

    function Fu(t) {
      this._context = t;
    }

    function Pu(t) {
      return new Fu(t);
    }

    function ju(t) {
      return t[0];
    }

    function Yu(t) {
      return t[1];
    }

    function zu(t, e) {
      var n = pu(!0),
          r = null,
          i = Pu,
          a = null;

      function o(o) {
        var s,
            c,
            u,
            l = (o = Ru(o)).length,
            h = !1;

        for (null == r && (a = i(u = du())), s = 0; s <= l; ++s) {
          !(s < l && n(c = o[s], s, o)) === h && ((h = !h) ? a.lineStart() : a.lineEnd()), h && a.point(+t(c, s, o), +e(c, s, o));
        }

        if (u) return a = null, u + "" || null;
      }

      return t = "function" == typeof t ? t : void 0 === t ? ju : pu(t), e = "function" == typeof e ? e : void 0 === e ? Yu : pu(e), o.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : pu(+e), o) : t;
      }, o.y = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : pu(+t), o) : e;
      }, o.defined = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : pu(!!t), o) : n;
      }, o.curve = function (t) {
        return arguments.length ? (i = t, null != r && (a = i(r)), o) : i;
      }, o.context = function (t) {
        return arguments.length ? (null == t ? r = a = null : a = i(r = t), o) : r;
      }, o;
    }

    function Uu(t, e) {
      return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
    }

    function qu(t) {
      return t;
    }

    function Hu() {}

    function $u(t, e, n) {
      t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
    }

    function Wu(t) {
      this._context = t;
    }

    function Vu(t) {
      return new Wu(t);
    }

    function Gu(t) {
      this._context = t;
    }

    function Xu(t) {
      this._context = t;
    }

    function Zu(t) {
      this._context = t;
    }

    function Qu(t) {
      return t < 0 ? -1 : 1;
    }

    function Ku(t, e, n) {
      var r = t._x1 - t._x0,
          i = e - t._x1,
          a = (t._y1 - t._y0) / (r || i < 0 && -0),
          o = (n - t._y1) / (i || r < 0 && -0),
          s = (a * i + o * r) / (r + i);
      return (Qu(a) + Qu(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
    }

    function Ju(t, e) {
      var n = t._x1 - t._x0;
      return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
    }

    function tl(t, e, n) {
      var r = t._x0,
          i = t._y0,
          a = t._x1,
          o = t._y1,
          s = (a - r) / 3;

      t._context.bezierCurveTo(r + s, i + s * e, a - s, o - s * n, a, o);
    }

    function el(t) {
      this._context = t;
    }

    function nl(t) {
      this._context = new rl(t);
    }

    function rl(t) {
      this._context = t;
    }

    function il(t) {
      this._context = t;
    }

    function al(t) {
      var e,
          n,
          r = t.length - 1,
          i = new Array(r),
          a = new Array(r),
          o = new Array(r);

      for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
        i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
      }

      for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
        n = i[e] / a[e - 1], a[e] -= n, o[e] -= n * o[e - 1];
      }

      for (i[r - 1] = o[r - 1] / a[r - 1], e = r - 2; e >= 0; --e) {
        i[e] = (o[e] - i[e + 1]) / a[e];
      }

      for (a[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
        a[e] = 2 * t[e + 1] - i[e + 1];
      }

      return [i, a];
    }

    function ol(t, e) {
      this._context = t, this._t = e;
    }

    Fu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;

          default:
            this._context.lineTo(t, e);

        }
      }
    }, Wu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 3:
            $u(this, this._x1, this._y1);

          case 2:
            this._context.lineTo(this._x1, this._y1);

        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

          default:
            $u(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, Gu.prototype = {
      areaStart: Hu,
      areaEnd: Hu,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x2, this._y2), this._context.closePath();
            break;

          case 2:
            this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
            break;

          case 3:
            this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        }
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._x2 = t, this._y2 = e;
            break;

          case 1:
            this._point = 2, this._x3 = t, this._y3 = e;
            break;

          case 2:
            this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
            break;

          default:
            $u(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, Xu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3;
            var n = (this._x0 + 4 * this._x1 + t) / 6,
                r = (this._y0 + 4 * this._y1 + e) / 6;
            this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
            break;

          case 3:
            this._point = 4;

          default:
            $u(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, Zu.prototype = {
      areaStart: Hu,
      areaEnd: Hu,
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        this._point && this._context.closePath();
      },
      point: function point(t, e) {
        t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
      }
    }, el.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x1, this._y1);

            break;

          case 3:
            tl(this, this._t0, Ju(this, this._t0));
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        var n = NaN;

        if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
          switch (this._point) {
            case 0:
              this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
              break;

            case 1:
              this._point = 2;
              break;

            case 2:
              this._point = 3, tl(this, Ju(this, n = Ku(this, t, e)), n);
              break;

            default:
              tl(this, this._t0, n = Ku(this, t, e));
          }

          this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
        }
      }
    }, (nl.prototype = Object.create(el.prototype)).point = function (t, e) {
      el.prototype.point.call(this, e, t);
    }, rl.prototype = {
      moveTo: function moveTo(t, e) {
        this._context.moveTo(e, t);
      },
      closePath: function closePath() {
        this._context.closePath();
      },
      lineTo: function lineTo(t, e) {
        this._context.lineTo(e, t);
      },
      bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
        this._context.bezierCurveTo(e, t, r, n, a, i);
      }
    }, il.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = [], this._y = [];
      },
      lineEnd: function lineEnd() {
        var t = this._x,
            e = this._y,
            n = t.length;
        if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = al(t), i = al(e), a = 0, o = 1; o < n; ++a, ++o) {
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], t[o], e[o]);
        }
        (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
      },
      point: function point(t, e) {
        this._x.push(+t), this._y.push(+e);
      }
    }, ol.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = this._y = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;

          default:
            if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
              var n = this._x * (1 - this._t) + t * this._t;
              this._context.lineTo(n, this._y), this._context.lineTo(n, e);
            }
        }

        this._x = t, this._y = e;
      }
    };
    var sl = new Date(),
        cl = new Date();

    function ul(t, e, n, r) {
      function i(e) {
        return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
      }

      return i.floor = function (e) {
        return t(e = new Date(+e)), e;
      }, i.ceil = function (n) {
        return t(n = new Date(n - 1)), e(n, 1), t(n), n;
      }, i.round = function (t) {
        var e = i(t),
            n = i.ceil(t);
        return t - e < n - t ? e : n;
      }, i.offset = function (t, n) {
        return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
      }, i.range = function (n, r, a) {
        var o,
            s = [];
        if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

        do {
          s.push(o = new Date(+n)), e(n, a), t(n);
        } while (o < n && n < r);

        return s;
      }, i.filter = function (n) {
        return ul(function (e) {
          if (e >= e) for (; t(e), !n(e);) {
            e.setTime(e - 1);
          }
        }, function (t, r) {
          if (t >= t) if (r < 0) for (; ++r <= 0;) {
            for (; e(t, -1), !n(t);) {
              ;
            }
          } else for (; --r >= 0;) {
            for (; e(t, 1), !n(t);) {
              ;
            }
          }
        });
      }, n && (i.count = function (e, r) {
        return sl.setTime(+e), cl.setTime(+r), t(sl), t(cl), Math.floor(n(sl, cl));
      }, i.every = function (t) {
        return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
          return r(e) % t == 0;
        } : function (e) {
          return i.count(0, e) % t == 0;
        }) : i : null;
      }), i;
    }

    var ll = 864e5,
        hl = 6048e5;

    function fl(t) {
      return ul(function (e) {
        e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setUTCDate(t.getUTCDate() + 7 * e);
      }, function (t, e) {
        return (e - t) / hl;
      });
    }

    var dl = fl(0),
        pl = fl(1);
    fl(2);
    fl(3);
    var ml = fl(4);
    fl(5);
    fl(6);

    var _l = ul(function (t) {
      t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCDate(t.getUTCDate() + e);
    }, function (t, e) {
      return (e - t) / ll;
    }, function (t) {
      return t.getUTCDate() - 1;
    });

    var xl = _l;

    function wl(t) {
      return ul(function (e) {
        e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setDate(t.getDate() + 7 * e);
      }, function (t, e) {
        return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / hl;
      });
    }

    var kl = wl(0),
        Tl = wl(1);
    wl(2);
    wl(3);
    var Sl = wl(4);
    wl(5);
    wl(6);
    var Nl = ul(function (t) {
      return t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      return t.setDate(t.getDate() + e);
    }, function (t, e) {
      return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / ll;
    }, function (t) {
      return t.getDate() - 1;
    });
    var Dl = Nl;
    var Ol = ul(function (t) {
      t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setFullYear(t.getFullYear() + e);
    }, function (t, e) {
      return e.getFullYear() - t.getFullYear();
    }, function (t) {
      return t.getFullYear();
    });

    Ol.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? ul(function (e) {
        e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setFullYear(e.getFullYear() + n * t);
      }) : null;
    };

    var Bl = Ol;
    var Ll = ul(function (t) {
      t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCFullYear(t.getUTCFullYear() + e);
    }, function (t, e) {
      return e.getUTCFullYear() - t.getUTCFullYear();
    }, function (t) {
      return t.getUTCFullYear();
    });

    Ll.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? ul(function (e) {
        e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setUTCFullYear(e.getUTCFullYear() + n * t);
      }) : null;
    };

    var Il = Ll;

    function Rl(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
        return e.setFullYear(t.y), e;
      }

      return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
    }

    function Fl(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
        return e.setUTCFullYear(t.y), e;
      }

      return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
    }

    function Pl(t, e, n) {
      return {
        y: t,
        m: e,
        d: n,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    var jl,
        Yl,
        zl = {
      "-": "",
      _: " ",
      0: "0"
    },
        Ul = /^\s*\d+/,
        ql = /^%/,
        Hl = /[\\^$*+?|[\]().{}]/g;

    function $l(t, e, n) {
      var r = t < 0 ? "-" : "",
          i = (r ? -t : t) + "",
          a = i.length;
      return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
    }

    function Wl(t) {
      return t.replace(Hl, "\\$&");
    }

    function Vl(t) {
      return new RegExp("^(?:" + t.map(Wl).join("|") + ")", "i");
    }

    function Gl(t) {
      return new Map(t.map(function (t, e) {
        return [t.toLowerCase(), e];
      }));
    }

    function Xl(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 1));
      return r ? (t.w = +r[0], n + r[0].length) : -1;
    }

    function Zl(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 1));
      return r ? (t.u = +r[0], n + r[0].length) : -1;
    }

    function Ql(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.U = +r[0], n + r[0].length) : -1;
    }

    function Kl(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.V = +r[0], n + r[0].length) : -1;
    }

    function Jl(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.W = +r[0], n + r[0].length) : -1;
    }

    function th(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 4));
      return r ? (t.y = +r[0], n + r[0].length) : -1;
    }

    function eh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    }

    function nh(t, e, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
      return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    }

    function rh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 1));
      return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
    }

    function ih(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
    }

    function ah(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.d = +r[0], n + r[0].length) : -1;
    }

    function oh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 3));
      return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
    }

    function sh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.H = +r[0], n + r[0].length) : -1;
    }

    function ch(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.M = +r[0], n + r[0].length) : -1;
    }

    function uh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 2));
      return r ? (t.S = +r[0], n + r[0].length) : -1;
    }

    function lh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 3));
      return r ? (t.L = +r[0], n + r[0].length) : -1;
    }

    function hh(t, e, n) {
      var r = Ul.exec(e.slice(n, n + 6));
      return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    }

    function fh(t, e, n) {
      var r = ql.exec(e.slice(n, n + 1));
      return r ? n + r[0].length : -1;
    }

    function dh(t, e, n) {
      var r = Ul.exec(e.slice(n));
      return r ? (t.Q = +r[0], n + r[0].length) : -1;
    }

    function ph(t, e, n) {
      var r = Ul.exec(e.slice(n));
      return r ? (t.s = +r[0], n + r[0].length) : -1;
    }

    function yh(t, e) {
      return $l(t.getDate(), e, 2);
    }

    function gh(t, e) {
      return $l(t.getHours(), e, 2);
    }

    function mh(t, e) {
      return $l(t.getHours() % 12 || 12, e, 2);
    }

    function vh(t, e) {
      return $l(1 + Dl.count(Bl(t), t), e, 3);
    }

    function bh(t, e) {
      return $l(t.getMilliseconds(), e, 3);
    }

    function _h(t, e) {
      return bh(t, e) + "000";
    }

    function xh(t, e) {
      return $l(t.getMonth() + 1, e, 2);
    }

    function wh(t, e) {
      return $l(t.getMinutes(), e, 2);
    }

    function kh(t, e) {
      return $l(t.getSeconds(), e, 2);
    }

    function Th(t) {
      var e = t.getDay();
      return 0 === e ? 7 : e;
    }

    function Eh(t, e) {
      return $l(kl.count(Bl(t) - 1, t), e, 2);
    }

    function Ch(t) {
      var e = t.getDay();
      return e >= 4 || 0 === e ? Sl(t) : Sl.ceil(t);
    }

    function Sh(t, e) {
      return t = Ch(t), $l(Sl.count(Bl(t), t) + (4 === Bl(t).getDay()), e, 2);
    }

    function Ah(t) {
      return t.getDay();
    }

    function Mh(t, e) {
      return $l(Tl.count(Bl(t) - 1, t), e, 2);
    }

    function Nh(t, e) {
      return $l(t.getFullYear() % 100, e, 2);
    }

    function Dh(t, e) {
      return $l((t = Ch(t)).getFullYear() % 100, e, 2);
    }

    function Oh(t, e) {
      return $l(t.getFullYear() % 1e4, e, 4);
    }

    function Bh(t, e) {
      var n = t.getDay();
      return $l((t = n >= 4 || 0 === n ? Sl(t) : Sl.ceil(t)).getFullYear() % 1e4, e, 4);
    }

    function Lh(t) {
      var e = t.getTimezoneOffset();
      return (e > 0 ? "-" : (e *= -1, "+")) + $l(e / 60 | 0, "0", 2) + $l(e % 60, "0", 2);
    }

    function Ih(t, e) {
      return $l(t.getUTCDate(), e, 2);
    }

    function Rh(t, e) {
      return $l(t.getUTCHours(), e, 2);
    }

    function Fh(t, e) {
      return $l(t.getUTCHours() % 12 || 12, e, 2);
    }

    function Ph(t, e) {
      return $l(1 + xl.count(Il(t), t), e, 3);
    }

    function jh(t, e) {
      return $l(t.getUTCMilliseconds(), e, 3);
    }

    function Yh(t, e) {
      return jh(t, e) + "000";
    }

    function zh(t, e) {
      return $l(t.getUTCMonth() + 1, e, 2);
    }

    function Uh(t, e) {
      return $l(t.getUTCMinutes(), e, 2);
    }

    function qh(t, e) {
      return $l(t.getUTCSeconds(), e, 2);
    }

    function Hh(t) {
      var e = t.getUTCDay();
      return 0 === e ? 7 : e;
    }

    function $h(t, e) {
      return $l(dl.count(Il(t) - 1, t), e, 2);
    }

    function Wh(t) {
      var e = t.getUTCDay();
      return e >= 4 || 0 === e ? ml(t) : ml.ceil(t);
    }

    function Vh(t, e) {
      return t = Wh(t), $l(ml.count(Il(t), t) + (4 === Il(t).getUTCDay()), e, 2);
    }

    function Gh(t) {
      return t.getUTCDay();
    }

    function Xh(t, e) {
      return $l(pl.count(Il(t) - 1, t), e, 2);
    }

    function Zh(t, e) {
      return $l(t.getUTCFullYear() % 100, e, 2);
    }

    function Qh(t, e) {
      return $l((t = Wh(t)).getUTCFullYear() % 100, e, 2);
    }

    function Kh(t, e) {
      return $l(t.getUTCFullYear() % 1e4, e, 4);
    }

    function Jh(t, e) {
      var n = t.getUTCDay();
      return $l((t = n >= 4 || 0 === n ? ml(t) : ml.ceil(t)).getUTCFullYear() % 1e4, e, 4);
    }

    function tf() {
      return "+0000";
    }

    function ef() {
      return "%";
    }

    function nf(t) {
      return +t;
    }

    function rf(t) {
      return Math.floor(+t / 1e3);
    }

    jl = function (t) {
      var e = t.dateTime,
          n = t.date,
          r = t.time,
          i = t.periods,
          a = t.days,
          o = t.shortDays,
          s = t.months,
          c = t.shortMonths,
          u = Vl(i),
          l = Gl(i),
          h = Vl(a),
          f = Gl(a),
          d = Vl(o),
          p = Gl(o),
          y = Vl(s),
          g = Gl(s),
          m = Vl(c),
          v = Gl(c),
          b = {
        a: function a(t) {
          return o[t.getDay()];
        },
        A: function A(t) {
          return a[t.getDay()];
        },
        b: function b(t) {
          return c[t.getMonth()];
        },
        B: function B(t) {
          return s[t.getMonth()];
        },
        c: null,
        d: yh,
        e: yh,
        f: _h,
        g: Dh,
        G: Bh,
        H: gh,
        I: mh,
        j: vh,
        L: bh,
        m: xh,
        M: wh,
        p: function p(t) {
          return i[+(t.getHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getMonth() / 3);
        },
        Q: nf,
        s: rf,
        S: kh,
        u: Th,
        U: Eh,
        V: Sh,
        w: Ah,
        W: Mh,
        x: null,
        X: null,
        y: Nh,
        Y: Oh,
        Z: Lh,
        "%": ef
      },
          _ = {
        a: function a(t) {
          return o[t.getUTCDay()];
        },
        A: function A(t) {
          return a[t.getUTCDay()];
        },
        b: function b(t) {
          return c[t.getUTCMonth()];
        },
        B: function B(t) {
          return s[t.getUTCMonth()];
        },
        c: null,
        d: Ih,
        e: Ih,
        f: Yh,
        g: Qh,
        G: Jh,
        H: Rh,
        I: Fh,
        j: Ph,
        L: jh,
        m: zh,
        M: Uh,
        p: function p(t) {
          return i[+(t.getUTCHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getUTCMonth() / 3);
        },
        Q: nf,
        s: rf,
        S: qh,
        u: Hh,
        U: $h,
        V: Vh,
        w: Gh,
        W: Xh,
        x: null,
        X: null,
        y: Zh,
        Y: Kh,
        Z: tf,
        "%": ef
      },
          x = {
        a: function a(t, e, n) {
          var r = d.exec(e.slice(n));
          return r ? (t.w = p.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        A: function A(t, e, n) {
          var r = h.exec(e.slice(n));
          return r ? (t.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        b: function b(t, e, n) {
          var r = m.exec(e.slice(n));
          return r ? (t.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        B: function B(t, e, n) {
          var r = y.exec(e.slice(n));
          return r ? (t.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        c: function c(t, n, r) {
          return T(t, e, n, r);
        },
        d: ah,
        e: ah,
        f: hh,
        g: eh,
        G: th,
        H: sh,
        I: sh,
        j: oh,
        L: lh,
        m: ih,
        M: ch,
        p: function p(t, e, n) {
          var r = u.exec(e.slice(n));
          return r ? (t.p = l.get(r[0].toLowerCase()), n + r[0].length) : -1;
        },
        q: rh,
        Q: dh,
        s: ph,
        S: uh,
        u: Zl,
        U: Ql,
        V: Kl,
        w: Xl,
        W: Jl,
        x: function x(t, e, r) {
          return T(t, n, e, r);
        },
        X: function X(t, e, n) {
          return T(t, r, e, n);
        },
        y: eh,
        Y: th,
        Z: nh,
        "%": fh
      };

      function w(t, e) {
        return function (n) {
          var r,
              i,
              a,
              o = [],
              s = -1,
              c = 0,
              u = t.length;

          for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
            37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = zl[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
          }

          return o.push(t.slice(c, s)), o.join("");
        };
      }

      function k(t, e) {
        return function (n) {
          var r,
              i,
              a = Pl(1900, void 0, 1);
          if (T(a, t, n += "", 0) != n.length) return null;
          if ("Q" in a) return new Date(a.Q);
          if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

          if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
            if (a.V < 1 || a.V > 53) return null;
            "w" in a || (a.w = 1), "Z" in a ? (i = (r = Fl(Pl(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? pl.ceil(r) : pl(r), r = xl.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = Rl(Pl(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? Tl.ceil(r) : Tl(r), r = Dl.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
          } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? Fl(Pl(a.y, 0, 1)).getUTCDay() : Rl(Pl(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

          return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, Fl(a)) : Rl(a);
        };
      }

      function T(t, e, n, r) {
        for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
          if (r >= c) return -1;

          if (37 === (i = e.charCodeAt(o++))) {
            if (i = e.charAt(o++), !(a = x[i in zl ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
          } else if (i != n.charCodeAt(r++)) return -1;
        }

        return r;
      }

      return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
        format: function format(t) {
          var e = w(t += "", b);
          return e.toString = function () {
            return t;
          }, e;
        },
        parse: function parse(t) {
          var e = k(t += "", !1);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcFormat: function utcFormat(t) {
          var e = w(t += "", _);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcParse: function utcParse(t) {
          var e = k(t += "", !0);
          return e.toString = function () {
            return t;
          }, e;
        }
      };
    }({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }), Yl = jl.format, jl.parse, jl.utcFormat, jl.utcParse;
    var af = {
      value: function value() {}
    };

    function of() {
      for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
        if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        r[t] = [];
      }

      return new sf(r);
    }

    function sf(t) {
      this._ = t;
    }

    function cf(t, e) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var n = "",
            r = t.indexOf(".");
        if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: n
        };
      });
    }

    function uf(t, e) {
      for (var n, r = 0, i = t.length; r < i; ++r) {
        if ((n = t[r]).name === e) return n.value;
      }
    }

    function lf(t, e, n) {
      for (var r = 0, i = t.length; r < i; ++r) {
        if (t[r].name === e) {
          t[r] = af, t = t.slice(0, r).concat(t.slice(r + 1));
          break;
        }
      }

      return null != n && t.push({
        name: e,
        value: n
      }), t;
    }

    sf.prototype = of.prototype = {
      constructor: sf,
      on: function on(t, e) {
        var n,
            r = this._,
            i = cf(t + "", r),
            a = -1,
            o = i.length;

        if (!(arguments.length < 2)) {
          if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

          for (; ++a < o;) {
            if (n = (t = i[a]).type) r[n] = lf(r[n], t.name, e);else if (null == e) for (n in r) {
              r[n] = lf(r[n], t.name, null);
            }
          }

          return this;
        }

        for (; ++a < o;) {
          if ((n = (t = i[a]).type) && (n = uf(r[n], t.name))) return n;
        }
      },
      copy: function copy() {
        var t = {},
            e = this._;

        for (var n in e) {
          t[n] = e[n].slice();
        }

        return new sf(t);
      },
      call: function call(t, e) {
        if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
          i[a] = arguments[a + 2];
        }
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
          r[a].value.apply(e, i);
        }
      },
      apply: function apply(t, e, n) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
          r[i].value.apply(e, n);
        }
      }
    };
    var hf = of;

    var ff,
        df,
        pf = 0,
        yf = 0,
        gf = 0,
        mf = 0,
        vf = 0,
        bf = 0,
        _f = "object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && performance.now ? performance : Date,
        xf = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
      setTimeout(t, 17);
    };

    function wf() {
      return vf || (xf(kf), vf = _f.now() + bf);
    }

    function kf() {
      vf = 0;
    }

    function Tf() {
      this._call = this._time = this._next = null;
    }

    function Ef(t, e, n) {
      var r = new Tf();
      return r.restart(t, e, n), r;
    }

    function Cf() {
      vf = (mf = _f.now()) + bf, pf = yf = 0;

      try {
        !function () {
          wf(), ++pf;

          for (var t, e = ff; e;) {
            (t = vf - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
          }

          --pf;
        }();
      } finally {
        pf = 0, function () {
          for (var t, e, n = ff, r = 1 / 0; n;) {
            n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : ff = e);
          }

          df = t, Af(r);
        }(), vf = 0;
      }
    }

    function Sf() {
      var t = _f.now(),
          e = t - mf;

      e > 1e3 && (bf -= e, mf = t);
    }

    function Af(t) {
      pf || (yf && (yf = clearTimeout(yf)), t - vf > 24 ? (t < 1 / 0 && (yf = setTimeout(Cf, t - _f.now() - bf)), gf && (gf = clearInterval(gf))) : (gf || (mf = _f.now(), gf = setInterval(Sf, 1e3)), pf = 1, xf(Cf)));
    }

    function Mf(t, e, n) {
      var r = new Tf();
      return e = null == e ? 0 : +e, r.restart(function (n) {
        r.stop(), t(n + e);
      }, e, n), r;
    }

    Tf.prototype = Ef.prototype = {
      constructor: Tf,
      restart: function restart(t, e, n) {
        if ("function" != typeof t) throw new TypeError("callback is not a function");
        n = (null == n ? wf() : +n) + (null == e ? 0 : +e), this._next || df === this || (df ? df._next = this : ff = this, df = this), this._call = t, this._time = n, Af();
      },
      stop: function stop() {
        this._call && (this._call = null, this._time = 1 / 0, Af());
      }
    };
    var Nf = hf("start", "end", "cancel", "interrupt"),
        Df = [];

    function Of(t, e, n, r, i, a) {
      var o = t.__transition;

      if (o) {
        if (n in o) return;
      } else t.__transition = {};

      !function (t, e, n) {
        var r,
            i = t.__transition;

        function a(c) {
          var u, l, h, f;
          if (1 !== n.state) return s();

          for (u in i) {
            if ((f = i[u]).name === n.name) {
              if (3 === f.state) return Mf(a);
              4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
            }
          }

          if (Mf(function () {
            3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
          }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
            for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
              (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
            }

            r.length = l + 1;
          }
        }

        function o(e) {
          for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
            r[a].call(t, i);
          }

          5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
        }

        function s() {
          for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
            return;
          }

          delete t.__transition;
        }

        i[e] = n, n.timer = Ef(function (t) {
          n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
        }, 0, n.time);
      }(t, n, {
        name: e,
        index: r,
        group: i,
        on: Nf,
        tween: Df,
        time: a.time,
        delay: a.delay,
        duration: a.duration,
        ease: a.ease,
        timer: null,
        state: 0
      });
    }

    function Bf(t, e) {
      var n = If(t, e);
      if (n.state > 0) throw new Error("too late; already scheduled");
      return n;
    }

    function Lf(t, e) {
      var n = If(t, e);
      if (n.state > 3) throw new Error("too late; already running");
      return n;
    }

    function If(t, e) {
      var n = t.__transition;
      if (!n || !(n = n[e])) throw new Error("transition not found");
      return n;
    }

    function Rf(t, e) {
      return t = +t, e = +e, function (n) {
        return t * (1 - n) + e * n;
      };
    }

    var Ff,
        Pf = 180 / Math.PI,
        jf = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };

    function Yf(t, e, n, r, i, a) {
      var o, s, c;
      return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
        translateX: i,
        translateY: a,
        rotate: Math.atan2(e, t) * Pf,
        skewX: Math.atan(c) * Pf,
        scaleX: o,
        scaleY: s
      };
    }

    function zf(t, e, n, r) {
      function i(t) {
        return t.length ? t.pop() + " " : "";
      }

      return function (a, o) {
        var s = [],
            c = [];
        return a = t(a), o = t(o), function (t, r, i, a, o, s) {
          if (t !== i || r !== a) {
            var c = o.push("translate(", null, e, null, n);
            s.push({
              i: c - 4,
              x: Rf(t, i)
            }, {
              i: c - 2,
              x: Rf(r, a)
            });
          } else (i || a) && o.push("translate(" + i + e + a + n);
        }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
          t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
            i: n.push(i(n) + "rotate(", null, r) - 2,
            x: Rf(t, e)
          })) : e && n.push(i(n) + "rotate(" + e + r);
        }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
          t !== e ? a.push({
            i: n.push(i(n) + "skewX(", null, r) - 2,
            x: Rf(t, e)
          }) : e && n.push(i(n) + "skewX(" + e + r);
        }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
          if (t !== n || e !== r) {
            var s = a.push(i(a) + "scale(", null, ",", null, ")");
            o.push({
              i: s - 4,
              x: Rf(t, n)
            }, {
              i: s - 2,
              x: Rf(e, r)
            });
          } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
        }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
          for (var e, n = -1, r = c.length; ++n < r;) {
            s[(e = c[n]).i] = e.x(t);
          }

          return s.join("");
        };
      };
    }

    var Uf = zf(function (t) {
      var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
      return e.isIdentity ? jf : Yf(e.a, e.b, e.c, e.d, e.e, e.f);
    }, "px, ", "px)", "deg)"),
        qf = zf(function (t) {
      return null == t ? jf : (Ff || (Ff = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ff.setAttribute("transform", t), (t = Ff.transform.baseVal.consolidate()) ? Yf((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : jf);
    }, ", ", ")", ")");

    function Hf(t, e) {
      var n, r;
      return function () {
        var i = Lf(this, t),
            a = i.tween;
        if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
          if (r[o].name === e) {
            (r = r.slice()).splice(o, 1);
            break;
          }
        }
        i.tween = r;
      };
    }

    function $f(t, e, n) {
      var r, i;
      if ("function" != typeof n) throw new Error();
      return function () {
        var a = Lf(this, t),
            o = a.tween;

        if (o !== r) {
          i = (r = o).slice();

          for (var s = {
            name: e,
            value: n
          }, c = 0, u = i.length; c < u; ++c) {
            if (i[c].name === e) {
              i[c] = s;
              break;
            }
          }

          c === u && i.push(s);
        }

        a.tween = i;
      };
    }

    function Wf(t, e, n) {
      var r = t._id;
      return t.each(function () {
        var t = Lf(this, r);
        (t.value || (t.value = {}))[e] = n.apply(this, arguments);
      }), function (t) {
        return If(t, r).value[e];
      };
    }

    var Gf = function t(e) {
      var n = function (t) {
        return 1 == (t = +t) ? Fr : function (e, n) {
          return n - e ? function (t, e, n) {
            return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
              return Math.pow(t + r * e, n);
            };
          }(e, n, t) : Ir(isNaN(e) ? n : e);
        };
      }(e);

      function r(t, e) {
        var r = n((t = ur(t)).r, (e = ur(e)).r),
            i = n(t.g, e.g),
            a = n(t.b, e.b),
            o = Fr(t.opacity, e.opacity);
        return function (e) {
          return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
        };
      }

      return r.gamma = t, r;
    }(1);

    var Zf = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        Qf = new RegExp(Zf.source, "g");

    function Kf(t, e) {
      var n,
          r,
          i,
          a = Zf.lastIndex = Qf.lastIndex = 0,
          o = -1,
          s = [],
          c = [];

      for (t += "", e += ""; (n = Zf.exec(t)) && (r = Qf.exec(e));) {
        (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
          i: o,
          x: Rf(n, r)
        })), a = Qf.lastIndex;
      }

      return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          s[(n = c[r]).i] = n.x(t);
        }

        return s.join("");
      });
    }

    function Jf(t, e) {
      var n;
      return ("number" == typeof e ? Rf : e instanceof ar ? Gf : (n = ar(e)) ? (e = n, Gf) : Kf)(t, e);
    }

    function td(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function ed(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function nd(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttribute(t);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function rd(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttributeNS(t.space, t.local);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function id(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttribute(t);
      };
    }

    function ad(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function od(t, e) {
      return function (n) {
        this.setAttribute(t, e.call(this, n));
      };
    }

    function sd(t, e) {
      return function (n) {
        this.setAttributeNS(t.space, t.local, e.call(this, n));
      };
    }

    function cd(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && sd(t, i)), n;
      }

      return i._value = e, i;
    }

    function ud(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && od(t, i)), n;
      }

      return i._value = e, i;
    }

    function ld(t, e) {
      return function () {
        Bf(this, t).delay = +e.apply(this, arguments);
      };
    }

    function hd(t, e) {
      return e = +e, function () {
        Bf(this, t).delay = e;
      };
    }

    function fd(t, e) {
      return function () {
        Lf(this, t).duration = +e.apply(this, arguments);
      };
    }

    function dd(t, e) {
      return e = +e, function () {
        Lf(this, t).duration = e;
      };
    }

    function pd(t, e) {
      if ("function" != typeof e) throw new Error();
      return function () {
        Lf(this, t).ease = e;
      };
    }

    function yd(t, e, n) {
      var r,
          i,
          a = function (t) {
        return (t + "").trim().split(/^|\s+/).every(function (t) {
          var e = t.indexOf(".");
          return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
        });
      }(e) ? Bf : Lf;
      return function () {
        var o = a(this, t),
            s = o.on;
        s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
      };
    }

    var gd = iu.prototype.constructor;

    function md(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function vd(t, e, n) {
      return function (r) {
        this.style.setProperty(t, e.call(this, r), n);
      };
    }

    function bd(t, e, n) {
      var r, i;

      function a() {
        var a = e.apply(this, arguments);
        return a !== i && (r = (i = a) && vd(t, a, n)), r;
      }

      return a._value = e, a;
    }

    function _d(t) {
      return function (e) {
        this.textContent = t.call(this, e);
      };
    }

    function xd(t) {
      var e, n;

      function r() {
        var r = t.apply(this, arguments);
        return r !== n && (e = (n = r) && _d(r)), e;
      }

      return r._value = t, r;
    }

    var wd = 0;

    function kd(t, e, n, r) {
      this._groups = t, this._parents = e, this._name = n, this._id = r;
    }

    function Td() {
      return ++wd;
    }

    var Ed = iu.prototype;
    kd.prototype = _defineProperty2({
      constructor: kd,
      select: function select(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = $s(t));

        for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
          for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
            (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, Of(h[f], e, n, f, h, If(s, n)));
          }
        }

        return new kd(a, this._parents, e, n);
      },
      selectAll: function selectAll(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = Gs(t));

        for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
          for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
            if (c = u[h]) {
              for (var f, d = t.call(c, c.__data__, h, u), p = If(c, n), y = 0, g = d.length; y < g; ++y) {
                (f = d[y]) && Of(f, e, n, y, d, p);
              }

              a.push(d), o.push(c);
            }
          }
        }

        return new kd(a, o, e, n);
      },
      selectChild: Ed.selectChild,
      selectChildren: Ed.selectChildren,
      filter: function filter(t) {
        "function" != typeof t && (t = Xs(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new kd(r, this._parents, this._name, this._id);
      },
      merge: function merge(t) {
        if (t._id !== this._id) throw new Error();

        for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
          for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
            (c = u[d] || l[d]) && (f[d] = c);
          }
        }

        for (; s < r; ++s) {
          o[s] = e[s];
        }

        return new kd(o, this._parents, this._name, this._id);
      },
      selection: function selection() {
        return new gd(this._groups, this._parents);
      },
      transition: function transition() {
        for (var t = this._name, e = this._id, n = Td(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
          for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
            if (o = s[u]) {
              var l = If(o, e);
              Of(o, t, n, u, s, {
                time: l.time + l.delay + l.duration,
                delay: 0,
                duration: l.duration,
                ease: l.ease
              });
            }
          }
        }

        return new kd(r, this._parents, t, n);
      },
      call: Ed.call,
      nodes: Ed.nodes,
      node: Ed.node,
      size: Ed.size,
      empty: Ed.empty,
      each: Ed.each,
      on: function on(t, e) {
        var n = this._id;
        return arguments.length < 2 ? If(this.node(), n).on.on(t) : this.each(yd(n, t, e));
      },
      attr: function attr(t, e) {
        var n = hc(t),
            r = "transform" === n ? qf : Jf;
        return this.attrTween(t, "function" == typeof e ? (n.local ? ad : id)(n, r, Wf(this, "attr." + t, e)) : null == e ? (n.local ? ed : td)(n) : (n.local ? rd : nd)(n, r, e));
      },
      attrTween: function attrTween(t, e) {
        var n = "attr." + t;
        if (arguments.length < 2) return (n = this.tween(n)) && n._value;
        if (null == e) return this.tween(n, null);
        if ("function" != typeof e) throw new Error();
        var r = hc(t);
        return this.tween(n, (r.local ? cd : ud)(r, e));
      },
      style: function style(t, e, n) {
        var r = "transform" == (t += "") ? Uf : Jf;
        return null == e ? this.styleTween(t, function (t, e) {
          var n, r, i;
          return function () {
            var a = wc(this, t),
                o = (this.style.removeProperty(t), wc(this, t));
            return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
          };
        }(t, r)).on("end.style." + t, md(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
          var r, i, a;
          return function () {
            var o = wc(this, t),
                s = n(this),
                c = s + "";
            return null == s && (this.style.removeProperty(t), c = s = wc(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
          };
        }(t, r, Wf(this, "style." + t, e))).each(function (t, e) {
          var n,
              r,
              i,
              a,
              o = "style." + e,
              s = "end." + o;
          return function () {
            var c = Lf(this, t),
                u = c.on,
                l = null == c.value[o] ? a || (a = md(e)) : void 0;
            u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
          };
        }(this._id, t)) : this.styleTween(t, function (t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = wc(this, t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }(t, r, e), n).on("end.style." + t, null);
      },
      styleTween: function styleTween(t, e, n) {
        var r = "style." + (t += "");
        if (arguments.length < 2) return (r = this.tween(r)) && r._value;
        if (null == e) return this.tween(r, null);
        if ("function" != typeof e) throw new Error();
        return this.tween(r, bd(t, e, null == n ? "" : n));
      },
      text: function text(t) {
        return this.tween("text", "function" == typeof t ? function (t) {
          return function () {
            var e = t(this);
            this.textContent = null == e ? "" : e;
          };
        }(Wf(this, "text", t)) : function (t) {
          return function () {
            this.textContent = t;
          };
        }(null == t ? "" : t + ""));
      },
      textTween: function textTween(t) {
        var e = "text";
        if (arguments.length < 1) return (e = this.tween(e)) && e._value;
        if (null == t) return this.tween(e, null);
        if ("function" != typeof t) throw new Error();
        return this.tween(e, xd(t));
      },
      remove: function remove() {
        return this.on("end.remove", function (t) {
          return function () {
            var e = this.parentNode;

            for (var n in this.__transition) {
              if (+n !== t) return;
            }

            e && e.removeChild(this);
          };
        }(this._id));
      },
      tween: function tween(t, e) {
        var n = this._id;

        if (t += "", arguments.length < 2) {
          for (var r, i = If(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
            if ((r = i[a]).name === t) return r.value;
          }

          return null;
        }

        return this.each((null == e ? Hf : $f)(n, t, e));
      },
      delay: function delay(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? ld : hd)(e, t)) : If(this.node(), e).delay;
      },
      duration: function duration(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? fd : dd)(e, t)) : If(this.node(), e).duration;
      },
      ease: function ease(t) {
        var e = this._id;
        return arguments.length ? this.each(pd(e, t)) : If(this.node(), e).ease;
      },
      easeVarying: function easeVarying(t) {
        if ("function" != typeof t) throw new Error();
        return this.each(function (t, e) {
          return function () {
            var n = e.apply(this, arguments);
            if ("function" != typeof n) throw new Error();
            Lf(this, t).ease = n;
          };
        }(this._id, t));
      },
      end: function end() {
        var t,
            e,
            n = this,
            r = n._id,
            i = n.size();
        return new Promise(function (a, o) {
          var s = {
            value: o
          },
              c = {
            value: function value() {
              0 == --i && a();
            }
          };
          n.each(function () {
            var n = Lf(this, r),
                i = n.on;
            i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
          }), 0 === i && a();
        });
      }
    }, Symbol.iterator, Ed[Symbol.iterator]);
    var Cd = {
      time: null,
      delay: 0,
      duration: 250,
      ease: function ease(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
      }
    };

    function Sd(t, e) {
      for (var n; !(n = t.__transition) || !(n = n[e]);) {
        if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
      }

      return n;
    }

    function Ad() {}

    function Md(t) {
      return null == t ? Ad : function () {
        return this.querySelector(t);
      };
    }

    function Nd(t) {
      return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
    }

    function Dd() {
      return [];
    }

    function Od(t) {
      return null == t ? Dd : function () {
        return this.querySelectorAll(t);
      };
    }

    function Bd(t) {
      return function () {
        return this.matches(t);
      };
    }

    function Ld(t) {
      return function (e) {
        return e.matches(t);
      };
    }

    iu.prototype.interrupt = function (t) {
      return this.each(function () {
        !function (t, e) {
          var n,
              r,
              i,
              a = t.__transition,
              o = !0;

          if (a) {
            for (i in e = null == e ? null : e + "", a) {
              (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
            }

            o && delete t.__transition;
          }
        }(this, t);
      });
    }, iu.prototype.transition = function (t) {
      var e, n;
      t instanceof kd ? (e = t._id, t = t._name) : (e = Td(), (n = Cd).time = wf(), t = null == t ? null : t + "");

      for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
        for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
          (o = s[u]) && Of(o, t, e, u, s, n || Sd(o, e));
        }
      }

      return new kd(r, this._parents, t, e);
    };
    var Id = Array.prototype.find;

    function Rd() {
      return this.firstElementChild;
    }

    var Fd = Array.prototype.filter;

    function Pd() {
      return Array.from(this.children);
    }

    function jd(t) {
      return new Array(t.length);
    }

    function Yd(t, e) {
      this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
    }

    function zd(t) {
      return function () {
        return t;
      };
    }

    function Ud(t, e, n, r, i, a) {
      for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
        (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new Yd(t, a[s]);
      }

      for (; s < c; ++s) {
        (o = e[s]) && (i[s] = o);
      }
    }

    function qd(t, e, n, r, i, a, o) {
      var s,
          c,
          u,
          l = new Map(),
          h = e.length,
          f = a.length,
          d = new Array(h);

      for (s = 0; s < h; ++s) {
        (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
      }

      for (s = 0; s < f; ++s) {
        u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l["delete"](u)) : n[s] = new Yd(t, a[s]);
      }

      for (s = 0; s < h; ++s) {
        (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
      }
    }

    function Hd(t) {
      return t.__data__;
    }

    function $d(t) {
      return "object" == _typeof(t) && "length" in t ? t : Array.from(t);
    }

    function Wd(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    Yd.prototype = {
      constructor: Yd,
      appendChild: function appendChild(t) {
        return this._parent.insertBefore(t, this._next);
      },
      insertBefore: function insertBefore(t, e) {
        return this._parent.insertBefore(t, e);
      },
      querySelector: function querySelector(t) {
        return this._parent.querySelector(t);
      },
      querySelectorAll: function querySelectorAll(t) {
        return this._parent.querySelectorAll(t);
      }
    };
    var Vd = "http://www.w3.org/1999/xhtml";
    var Gd = {
      svg: "http://www.w3.org/2000/svg",
      xhtml: Vd,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };

    function Xd(t) {
      var e = t += "",
          n = e.indexOf(":");
      return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), Gd.hasOwnProperty(e) ? {
        space: Gd[e],
        local: t
      } : t;
    }

    function Zd(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function Qd(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function Kd(t, e) {
      return function () {
        this.setAttribute(t, e);
      };
    }

    function Jd(t, e) {
      return function () {
        this.setAttributeNS(t.space, t.local, e);
      };
    }

    function tp(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
      };
    }

    function ep(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
      };
    }

    function np(t) {
      return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
    }

    function rp(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function ip(t, e, n) {
      return function () {
        this.style.setProperty(t, e, n);
      };
    }

    function ap(t, e, n) {
      return function () {
        var r = e.apply(this, arguments);
        null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
      };
    }

    function op(t, e) {
      return t.style.getPropertyValue(e) || np(t).getComputedStyle(t, null).getPropertyValue(e);
    }

    function sp(t) {
      return function () {
        delete this[t];
      };
    }

    function cp(t, e) {
      return function () {
        this[t] = e;
      };
    }

    function up(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? delete this[t] : this[t] = n;
      };
    }

    function lp(t) {
      return t.trim().split(/^|\s+/);
    }

    function hp(t) {
      return t.classList || new fp(t);
    }

    function fp(t) {
      this._node = t, this._names = lp(t.getAttribute("class") || "");
    }

    function dp(t, e) {
      for (var n = hp(t), r = -1, i = e.length; ++r < i;) {
        n.add(e[r]);
      }
    }

    function pp(t, e) {
      for (var n = hp(t), r = -1, i = e.length; ++r < i;) {
        n.remove(e[r]);
      }
    }

    function yp(t) {
      return function () {
        dp(this, t);
      };
    }

    function gp(t) {
      return function () {
        pp(this, t);
      };
    }

    function mp(t, e) {
      return function () {
        (e.apply(this, arguments) ? dp : pp)(this, t);
      };
    }

    function vp() {
      this.textContent = "";
    }

    function bp(t) {
      return function () {
        this.textContent = t;
      };
    }

    function _p(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.textContent = null == e ? "" : e;
      };
    }

    function xp() {
      this.innerHTML = "";
    }

    function wp(t) {
      return function () {
        this.innerHTML = t;
      };
    }

    function kp(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.innerHTML = null == e ? "" : e;
      };
    }

    function Tp() {
      this.nextSibling && this.parentNode.appendChild(this);
    }

    function Ep() {
      this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }

    function Cp(t) {
      return function () {
        var e = this.ownerDocument,
            n = this.namespaceURI;
        return n === Vd && e.documentElement.namespaceURI === Vd ? e.createElement(t) : e.createElementNS(n, t);
      };
    }

    function Sp(t) {
      return function () {
        return this.ownerDocument.createElementNS(t.space, t.local);
      };
    }

    function Ap(t) {
      var e = Xd(t);
      return (e.local ? Sp : Cp)(e);
    }

    function Mp() {
      return null;
    }

    function Np() {
      var t = this.parentNode;
      t && t.removeChild(this);
    }

    function Dp() {
      var t = this.cloneNode(!1),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function Op() {
      var t = this.cloneNode(!0),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function Bp(t) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var e = "",
            n = t.indexOf(".");
        return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
          type: t,
          name: e
        };
      });
    }

    function Lp(t) {
      return function () {
        var e = this.__on;

        if (e) {
          for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
            n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
          }

          ++i ? e.length = i : delete this.__on;
        }
      };
    }

    function Ip(t, e, n) {
      return function () {
        var r,
            i = this.__on,
            a = function (t) {
          return function (e) {
            t.call(this, e, this.__data__);
          };
        }(e);

        if (i) for (var o = 0, s = i.length; o < s; ++o) {
          if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
        }
        this.addEventListener(t.type, a, n), r = {
          type: t.type,
          name: t.name,
          value: e,
          listener: a,
          options: n
        }, i ? i.push(r) : this.__on = [r];
      };
    }

    function Rp(t, e, n) {
      var r = np(t),
          i = r.CustomEvent;
      "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
    }

    function Fp(t, e) {
      return function () {
        return Rp(this, t, e);
      };
    }

    function Pp(t, e) {
      return function () {
        return Rp(this, t, e.apply(this, arguments));
      };
    }

    fp.prototype = {
      add: function add(t) {
        this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
      },
      remove: function remove(t) {
        var e = this._names.indexOf(t);

        e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
      },
      contains: function contains(t) {
        return this._names.indexOf(t) >= 0;
      }
    };
    var jp = [null];

    function Yp(t, e) {
      this._groups = t, this._parents = e;
    }

    function zp() {
      return new Yp([[document.documentElement]], jp);
    }

    Yp.prototype = zp.prototype = _defineProperty2({
      constructor: Yp,
      select: function select(t) {
        "function" != typeof t && (t = Md(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
            (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
          }
        }

        return new Yp(r, this._parents);
      },
      selectAll: function selectAll(t) {
        t = "function" == typeof t ? function (t) {
          return function () {
            return Nd(t.apply(this, arguments));
          };
        }(t) : Od(t);

        for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
          for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
            (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
          }
        }

        return new Yp(r, i);
      },
      selectChild: function selectChild(t) {
        return this.select(null == t ? Rd : function (t) {
          return function () {
            return Id.call(this.children, t);
          };
        }("function" == typeof t ? t : Ld(t)));
      },
      selectChildren: function selectChildren(t) {
        return this.selectAll(null == t ? Pd : function (t) {
          return function () {
            return Fd.call(this.children, t);
          };
        }("function" == typeof t ? t : Ld(t)));
      },
      filter: function filter(t) {
        "function" != typeof t && (t = Bd(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new Yp(r, this._parents);
      },
      data: function data(t, e) {
        if (!arguments.length) return Array.from(this, Hd);
        var n = e ? qd : Ud,
            r = this._parents,
            i = this._groups;
        "function" != typeof t && (t = zd(t));

        for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
          var l = r[u],
              h = i[u],
              f = h.length,
              d = $d(t.call(l, l && l.__data__, u, r)),
              p = d.length,
              y = s[u] = new Array(p),
              g = o[u] = new Array(p),
              m = c[u] = new Array(f);
          n(l, h, y, g, m, d, e);

          for (var v, b, _ = 0, x = 0; _ < p; ++_) {
            if (v = y[_]) {
              for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                ;
              }

              v._next = b || null;
            }
          }
        }

        return (o = new Yp(o, r))._enter = s, o._exit = c, o;
      },
      enter: function enter() {
        return new Yp(this._enter || this._groups.map(jd), this._parents);
      },
      exit: function exit() {
        return new Yp(this._exit || this._groups.map(jd), this._parents);
      },
      join: function join(t, e, n) {
        var r = this.enter(),
            i = this,
            a = this.exit();
        return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
      },
      merge: function merge(t) {
        for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
          for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
            (u = l[p] || h[p]) && (d[p] = u);
          }
        }

        for (; c < i; ++c) {
          s[c] = n[c];
        }

        return new Yp(s, this._parents);
      },
      selection: function selection() {
        return this;
      },
      order: function order() {
        for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
          for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
            (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
          }
        }

        return this;
      },
      sort: function sort(t) {
        function e(e, n) {
          return e && n ? t(e.__data__, n.__data__) : !e - !n;
        }

        t || (t = Wd);

        for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
          for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
            (o = s[l]) && (u[l] = o);
          }

          u.sort(e);
        }

        return new Yp(i, this._parents).order();
      },
      call: function call() {
        var t = arguments[0];
        return arguments[0] = this, t.apply(null, arguments), this;
      },
      nodes: function nodes() {
        return Array.from(this);
      },
      node: function node() {
        for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
          for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
            var o = r[i];
            if (o) return o;
          }
        }

        return null;
      },
      size: function size() {
        var t = 0;

        var _iterator41 = _createForOfIteratorHelper(this),
            _step41;

        try {
          for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
            var _e9 = _step41.value;
            ++t;
          }
        } catch (err) {
          _iterator41.e(err);
        } finally {
          _iterator41.f();
        }

        return t;
      },
      empty: function empty() {
        return !this.node();
      },
      each: function each(t) {
        for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
          for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
            (i = a[o]) && t.call(i, i.__data__, o, a);
          }
        }

        return this;
      },
      attr: function attr(t, e) {
        var n = Xd(t);

        if (arguments.length < 2) {
          var r = this.node();
          return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
        }

        return this.each((null == e ? n.local ? Qd : Zd : "function" == typeof e ? n.local ? ep : tp : n.local ? Jd : Kd)(n, e));
      },
      style: function style(t, e, n) {
        return arguments.length > 1 ? this.each((null == e ? rp : "function" == typeof e ? ap : ip)(t, e, null == n ? "" : n)) : op(this.node(), t);
      },
      property: function property(t, e) {
        return arguments.length > 1 ? this.each((null == e ? sp : "function" == typeof e ? up : cp)(t, e)) : this.node()[t];
      },
      classed: function classed(t, e) {
        var n = lp(t + "");

        if (arguments.length < 2) {
          for (var r = hp(this.node()), i = -1, a = n.length; ++i < a;) {
            if (!r.contains(n[i])) return !1;
          }

          return !0;
        }

        return this.each(("function" == typeof e ? mp : e ? yp : gp)(n, e));
      },
      text: function text(t) {
        return arguments.length ? this.each(null == t ? vp : ("function" == typeof t ? _p : bp)(t)) : this.node().textContent;
      },
      html: function html(t) {
        return arguments.length ? this.each(null == t ? xp : ("function" == typeof t ? kp : wp)(t)) : this.node().innerHTML;
      },
      raise: function raise() {
        return this.each(Tp);
      },
      lower: function lower() {
        return this.each(Ep);
      },
      append: function append(t) {
        var e = "function" == typeof t ? t : Ap(t);
        return this.select(function () {
          return this.appendChild(e.apply(this, arguments));
        });
      },
      insert: function insert(t, e) {
        var n = "function" == typeof t ? t : Ap(t),
            r = null == e ? Mp : "function" == typeof e ? e : Md(e);
        return this.select(function () {
          return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
        });
      },
      remove: function remove() {
        return this.each(Np);
      },
      clone: function clone(t) {
        return this.select(t ? Op : Dp);
      },
      datum: function datum(t) {
        return arguments.length ? this.property("__data__", t) : this.node().__data__;
      },
      on: function on(t, e, n) {
        var r,
            i,
            a = Bp(t + ""),
            o = a.length;

        if (!(arguments.length < 2)) {
          for (s = e ? Ip : Lp, r = 0; r < o; ++r) {
            this.each(s(a[r], e, n));
          }

          return this;
        }

        var s = this.node().__on;

        if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
          for (r = 0, c = s[u]; r < o; ++r) {
            if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
          }
        }
      },
      dispatch: function dispatch(t, e) {
        return this.each(("function" == typeof e ? Pp : Fp)(t, e));
      }
    }, Symbol.iterator, /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var t, e, n, r, i, a, o;
      return regeneratorRuntime.wrap(function _callee5$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              t = this._groups, e = 0, n = t.length;

            case 1:
              if (!(e < n)) {
                _context6.next = 14;
                break;
              }

              i = t[e], a = 0, o = i.length;

            case 3:
              if (!(a < o)) {
                _context6.next = 11;
                break;
              }

              _context6.t0 = r = i[a];

              if (!_context6.t0) {
                _context6.next = 8;
                break;
              }

              _context6.next = 8;
              return r;

            case 8:
              ++a;
              _context6.next = 3;
              break;

            case 11:
              ++e;
              _context6.next = 1;
              break;

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee5, this);
    }));
    var Up = zp;
    var qp = {
      value: function value() {}
    };

    function Hp() {
      for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
        if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        r[t] = [];
      }

      return new $p(r);
    }

    function $p(t) {
      this._ = t;
    }

    function Wp(t, e) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var n = "",
            r = t.indexOf(".");
        if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: n
        };
      });
    }

    function Vp(t, e) {
      for (var n, r = 0, i = t.length; r < i; ++r) {
        if ((n = t[r]).name === e) return n.value;
      }
    }

    function Gp(t, e, n) {
      for (var r = 0, i = t.length; r < i; ++r) {
        if (t[r].name === e) {
          t[r] = qp, t = t.slice(0, r).concat(t.slice(r + 1));
          break;
        }
      }

      return null != n && t.push({
        name: e,
        value: n
      }), t;
    }

    $p.prototype = Hp.prototype = {
      constructor: $p,
      on: function on(t, e) {
        var n,
            r = this._,
            i = Wp(t + "", r),
            a = -1,
            o = i.length;

        if (!(arguments.length < 2)) {
          if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

          for (; ++a < o;) {
            if (n = (t = i[a]).type) r[n] = Gp(r[n], t.name, e);else if (null == e) for (n in r) {
              r[n] = Gp(r[n], t.name, null);
            }
          }

          return this;
        }

        for (; ++a < o;) {
          if ((n = (t = i[a]).type) && (n = Vp(r[n], t.name))) return n;
        }
      },
      copy: function copy() {
        var t = {},
            e = this._;

        for (var n in e) {
          t[n] = e[n].slice();
        }

        return new $p(t);
      },
      call: function call(t, e) {
        if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
          i[a] = arguments[a + 2];
        }
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
          r[a].value.apply(e, i);
        }
      },
      apply: function apply(t, e, n) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
          r[i].value.apply(e, n);
        }
      }
    };
    var Xp = Hp;
    var Zp,
        Qp,
        Kp = 0,
        Jp = 0,
        ty = 0,
        ey = 0,
        ny = 0,
        ry = 0,
        iy = "object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && performance.now ? performance : Date,
        ay = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
      setTimeout(t, 17);
    };

    function oy() {
      return ny || (ay(sy), ny = iy.now() + ry);
    }

    function sy() {
      ny = 0;
    }

    function cy() {
      this._call = this._time = this._next = null;
    }

    function uy(t, e, n) {
      var r = new cy();
      return r.restart(t, e, n), r;
    }

    function ly() {
      ny = (ey = iy.now()) + ry, Kp = Jp = 0;

      try {
        !function () {
          oy(), ++Kp;

          for (var t, e = Zp; e;) {
            (t = ny - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
          }

          --Kp;
        }();
      } finally {
        Kp = 0, function () {
          for (var t, e, n = Zp, r = 1 / 0; n;) {
            n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Zp = e);
          }

          Qp = t, fy(r);
        }(), ny = 0;
      }
    }

    function hy() {
      var t = iy.now(),
          e = t - ey;
      e > 1e3 && (ry -= e, ey = t);
    }

    function fy(t) {
      Kp || (Jp && (Jp = clearTimeout(Jp)), t - ny > 24 ? (t < 1 / 0 && (Jp = setTimeout(ly, t - iy.now() - ry)), ty && (ty = clearInterval(ty))) : (ty || (ey = iy.now(), ty = setInterval(hy, 1e3)), Kp = 1, ay(ly)));
    }

    function dy(t, e, n) {
      var r = new cy();
      return e = null == e ? 0 : +e, r.restart(function (n) {
        r.stop(), t(n + e);
      }, e, n), r;
    }

    cy.prototype = uy.prototype = {
      constructor: cy,
      restart: function restart(t, e, n) {
        if ("function" != typeof t) throw new TypeError("callback is not a function");
        n = (null == n ? oy() : +n) + (null == e ? 0 : +e), this._next || Qp === this || (Qp ? Qp._next = this : Zp = this, Qp = this), this._call = t, this._time = n, fy();
      },
      stop: function stop() {
        this._call && (this._call = null, this._time = 1 / 0, fy());
      }
    };
    var py = Xp("start", "end", "cancel", "interrupt"),
        yy = [];

    function gy(t, e, n, r, i, a) {
      var o = t.__transition;

      if (o) {
        if (n in o) return;
      } else t.__transition = {};

      !function (t, e, n) {
        var r,
            i = t.__transition;

        function a(c) {
          var u, l, h, f;
          if (1 !== n.state) return s();

          for (u in i) {
            if ((f = i[u]).name === n.name) {
              if (3 === f.state) return dy(a);
              4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
            }
          }

          if (dy(function () {
            3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
          }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
            for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
              (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
            }

            r.length = l + 1;
          }
        }

        function o(e) {
          for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
            r[a].call(t, i);
          }

          5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
        }

        function s() {
          for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
            return;
          }

          delete t.__transition;
        }

        i[e] = n, n.timer = uy(function (t) {
          n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
        }, 0, n.time);
      }(t, n, {
        name: e,
        index: r,
        group: i,
        on: py,
        tween: yy,
        time: a.time,
        delay: a.delay,
        duration: a.duration,
        ease: a.ease,
        timer: null,
        state: 0
      });
    }

    function my(t, e) {
      var n = by(t, e);
      if (n.state > 0) throw new Error("too late; already scheduled");
      return n;
    }

    function vy(t, e) {
      var n = by(t, e);
      if (n.state > 3) throw new Error("too late; already running");
      return n;
    }

    function by(t, e) {
      var n = t.__transition;
      if (!n || !(n = n[e])) throw new Error("transition not found");
      return n;
    }

    function _y(t, e) {
      return t = +t, e = +e, function (n) {
        return t * (1 - n) + e * n;
      };
    }

    var xy,
        wy = 180 / Math.PI,
        ky = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };

    function Ty(t, e, n, r, i, a) {
      var o, s, c;
      return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
        translateX: i,
        translateY: a,
        rotate: Math.atan2(e, t) * wy,
        skewX: Math.atan(c) * wy,
        scaleX: o,
        scaleY: s
      };
    }

    function Ey(t, e, n, r) {
      function i(t) {
        return t.length ? t.pop() + " " : "";
      }

      return function (a, o) {
        var s = [],
            c = [];
        return a = t(a), o = t(o), function (t, r, i, a, o, s) {
          if (t !== i || r !== a) {
            var c = o.push("translate(", null, e, null, n);
            s.push({
              i: c - 4,
              x: _y(t, i)
            }, {
              i: c - 2,
              x: _y(r, a)
            });
          } else (i || a) && o.push("translate(" + i + e + a + n);
        }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
          t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
            i: n.push(i(n) + "rotate(", null, r) - 2,
            x: _y(t, e)
          })) : e && n.push(i(n) + "rotate(" + e + r);
        }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
          t !== e ? a.push({
            i: n.push(i(n) + "skewX(", null, r) - 2,
            x: _y(t, e)
          }) : e && n.push(i(n) + "skewX(" + e + r);
        }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
          if (t !== n || e !== r) {
            var s = a.push(i(a) + "scale(", null, ",", null, ")");
            o.push({
              i: s - 4,
              x: _y(t, n)
            }, {
              i: s - 2,
              x: _y(e, r)
            });
          } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
        }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
          for (var e, n = -1, r = c.length; ++n < r;) {
            s[(e = c[n]).i] = e.x(t);
          }

          return s.join("");
        };
      };
    }

    var Cy = Ey(function (t) {
      var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
      return e.isIdentity ? ky : Ty(e.a, e.b, e.c, e.d, e.e, e.f);
    }, "px, ", "px)", "deg)"),
        Sy = Ey(function (t) {
      return null == t ? ky : (xy || (xy = document.createElementNS("http://www.w3.org/2000/svg", "g")), xy.setAttribute("transform", t), (t = xy.transform.baseVal.consolidate()) ? Ty((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : ky);
    }, ", ", ")", ")");

    function Ay(t, e) {
      var n, r;
      return function () {
        var i = vy(this, t),
            a = i.tween;
        if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
          if (r[o].name === e) {
            (r = r.slice()).splice(o, 1);
            break;
          }
        }
        i.tween = r;
      };
    }

    function My(t, e, n) {
      var r, i;
      if ("function" != typeof n) throw new Error();
      return function () {
        var a = vy(this, t),
            o = a.tween;

        if (o !== r) {
          i = (r = o).slice();

          for (var s = {
            name: e,
            value: n
          }, c = 0, u = i.length; c < u; ++c) {
            if (i[c].name === e) {
              i[c] = s;
              break;
            }
          }

          c === u && i.push(s);
        }

        a.tween = i;
      };
    }

    function Ny(t, e, n) {
      var r = t._id;
      return t.each(function () {
        var t = vy(this, r);
        (t.value || (t.value = {}))[e] = n.apply(this, arguments);
      }), function (t) {
        return by(t, r).value[e];
      };
    }

    function Dy(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    }

    function Oy(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function By() {}

    var Ly = .7,
        Iy = 1.4285714285714286,
        Ry = "\\s*([+-]?\\d+)\\s*",
        Fy = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        Py = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        jy = /^#([0-9a-f]{3,8})$/,
        Yy = new RegExp("^rgb\\(" + [Ry, Ry, Ry] + "\\)$"),
        zy = new RegExp("^rgb\\(" + [Py, Py, Py] + "\\)$"),
        Uy = new RegExp("^rgba\\(" + [Ry, Ry, Ry, Fy] + "\\)$"),
        qy = new RegExp("^rgba\\(" + [Py, Py, Py, Fy] + "\\)$"),
        Hy = new RegExp("^hsl\\(" + [Fy, Py, Py] + "\\)$"),
        $y = new RegExp("^hsla\\(" + [Fy, Py, Py, Fy] + "\\)$"),
        Wy = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function Vy() {
      return this.rgb().formatHex();
    }

    function Gy() {
      return this.rgb().formatRgb();
    }

    function Xy(t) {
      var e, n;
      return t = (t + "").trim().toLowerCase(), (e = jy.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? Zy(e) : 3 === n ? new tg(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Qy(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Qy(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Yy.exec(t)) ? new tg(e[1], e[2], e[3], 1) : (e = zy.exec(t)) ? new tg(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Uy.exec(t)) ? Qy(e[1], e[2], e[3], e[4]) : (e = qy.exec(t)) ? Qy(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Hy.exec(t)) ? ig(e[1], e[2] / 100, e[3] / 100, 1) : (e = $y.exec(t)) ? ig(e[1], e[2] / 100, e[3] / 100, e[4]) : Wy.hasOwnProperty(t) ? Zy(Wy[t]) : "transparent" === t ? new tg(NaN, NaN, NaN, 0) : null;
    }

    function Zy(t) {
      return new tg(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function Qy(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new tg(t, e, n, r);
    }

    function Ky(t) {
      return t instanceof By || (t = Xy(t)), t ? new tg((t = t.rgb()).r, t.g, t.b, t.opacity) : new tg();
    }

    function Jy(t, e, n, r) {
      return 1 === arguments.length ? Ky(t) : new tg(t, e, n, null == r ? 1 : r);
    }

    function tg(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function eg() {
      return "#" + rg(this.r) + rg(this.g) + rg(this.b);
    }

    function ng() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function rg(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function ig(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new og(t, e, n, r);
    }

    function ag(t) {
      if (t instanceof og) return new og(t.h, t.s, t.l, t.opacity);
      if (t instanceof By || (t = Xy(t)), !t) return new og();
      if (t instanceof og) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          o = NaN,
          s = a - i,
          c = (a + i) / 2;
      return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new og(o, s, c, t.opacity);
    }

    function og(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function sg(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    Dy(By, Xy, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: Vy,
      formatHex: Vy,
      formatHsl: function formatHsl() {
        return ag(this).formatHsl();
      },
      formatRgb: Gy,
      toString: Gy
    }), Dy(tg, Jy, Oy(By, {
      brighter: function brighter(t) {
        return t = null == t ? Iy : Math.pow(Iy, t), new tg(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Ly : Math.pow(Ly, t), new tg(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: eg,
      formatHex: eg,
      formatRgb: ng,
      toString: ng
    })), Dy(og, function (t, e, n, r) {
      return 1 === arguments.length ? ag(t) : new og(t, e, n, null == r ? 1 : r);
    }, Oy(By, {
      brighter: function brighter(t) {
        return t = null == t ? Iy : Math.pow(Iy, t), new og(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Ly : Math.pow(Ly, t), new og(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new tg(sg(t >= 240 ? t - 240 : t + 120, i, r), sg(t, i, r), sg(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));

    var ug = function ug(t) {
      return function () {
        return t;
      };
    };

    function lg(t, e) {
      var n = e - t;
      return n ? function (t, e) {
        return function (n) {
          return t + n * e;
        };
      }(t, n) : ug(isNaN(t) ? e : t);
    }

    var hg = function t(e) {
      var n = function (t) {
        return 1 == (t = +t) ? lg : function (e, n) {
          return n - e ? function (t, e, n) {
            return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
              return Math.pow(t + r * e, n);
            };
          }(e, n, t) : ug(isNaN(e) ? n : e);
        };
      }(e);

      function r(t, e) {
        var r = n((t = Jy(t)).r, (e = Jy(e)).r),
            i = n(t.g, e.g),
            a = n(t.b, e.b),
            o = lg(t.opacity, e.opacity);
        return function (e) {
          return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
        };
      }

      return r.gamma = t, r;
    }(1);

    var dg = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        pg = new RegExp(dg.source, "g");

    function yg(t, e) {
      var n,
          r,
          i,
          a = dg.lastIndex = pg.lastIndex = 0,
          o = -1,
          s = [],
          c = [];

      for (t += "", e += ""; (n = dg.exec(t)) && (r = pg.exec(e));) {
        (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
          i: o,
          x: _y(n, r)
        })), a = pg.lastIndex;
      }

      return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          s[(n = c[r]).i] = n.x(t);
        }

        return s.join("");
      });
    }

    function gg(t, e) {
      var n;
      return ("number" == typeof e ? _y : e instanceof Xy ? hg : (n = Xy(e)) ? (e = n, hg) : yg)(t, e);
    }

    function mg(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function vg(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function bg(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttribute(t);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function _g(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttributeNS(t.space, t.local);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function xg(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttribute(t);
      };
    }

    function wg(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function kg(t, e) {
      return function (n) {
        this.setAttribute(t, e.call(this, n));
      };
    }

    function Tg(t, e) {
      return function (n) {
        this.setAttributeNS(t.space, t.local, e.call(this, n));
      };
    }

    function Eg(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && Tg(t, i)), n;
      }

      return i._value = e, i;
    }

    function Cg(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && kg(t, i)), n;
      }

      return i._value = e, i;
    }

    function Sg(t, e) {
      return function () {
        my(this, t).delay = +e.apply(this, arguments);
      };
    }

    function Ag(t, e) {
      return e = +e, function () {
        my(this, t).delay = e;
      };
    }

    function Mg(t, e) {
      return function () {
        vy(this, t).duration = +e.apply(this, arguments);
      };
    }

    function Ng(t, e) {
      return e = +e, function () {
        vy(this, t).duration = e;
      };
    }

    function Dg(t, e) {
      if ("function" != typeof e) throw new Error();
      return function () {
        vy(this, t).ease = e;
      };
    }

    function Og(t, e, n) {
      var r,
          i,
          a = function (t) {
        return (t + "").trim().split(/^|\s+/).every(function (t) {
          var e = t.indexOf(".");
          return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
        });
      }(e) ? my : vy;
      return function () {
        var o = a(this, t),
            s = o.on;
        s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
      };
    }

    var Bg = Up.prototype.constructor;

    function Lg(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function Ig(t, e, n) {
      return function (r) {
        this.style.setProperty(t, e.call(this, r), n);
      };
    }

    function Rg(t, e, n) {
      var r, i;

      function a() {
        var a = e.apply(this, arguments);
        return a !== i && (r = (i = a) && Ig(t, a, n)), r;
      }

      return a._value = e, a;
    }

    function Fg(t) {
      return function (e) {
        this.textContent = t.call(this, e);
      };
    }

    function Pg(t) {
      var e, n;

      function r() {
        var r = t.apply(this, arguments);
        return r !== n && (e = (n = r) && Fg(r)), e;
      }

      return r._value = t, r;
    }

    var jg = 0;

    function Yg(t, e, n, r) {
      this._groups = t, this._parents = e, this._name = n, this._id = r;
    }

    function zg() {
      return ++jg;
    }

    var Ug = Up.prototype;
    Yg.prototype = _defineProperty2({
      constructor: Yg,
      select: function select(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = Md(t));

        for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
          for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
            (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, gy(h[f], e, n, f, h, by(s, n)));
          }
        }

        return new Yg(a, this._parents, e, n);
      },
      selectAll: function selectAll(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = Od(t));

        for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
          for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
            if (c = u[h]) {
              for (var f, d = t.call(c, c.__data__, h, u), p = by(c, n), y = 0, g = d.length; y < g; ++y) {
                (f = d[y]) && gy(f, e, n, y, d, p);
              }

              a.push(d), o.push(c);
            }
          }
        }

        return new Yg(a, o, e, n);
      },
      selectChild: Ug.selectChild,
      selectChildren: Ug.selectChildren,
      filter: function filter(t) {
        "function" != typeof t && (t = Bd(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new Yg(r, this._parents, this._name, this._id);
      },
      merge: function merge(t) {
        if (t._id !== this._id) throw new Error();

        for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
          for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
            (c = u[d] || l[d]) && (f[d] = c);
          }
        }

        for (; s < r; ++s) {
          o[s] = e[s];
        }

        return new Yg(o, this._parents, this._name, this._id);
      },
      selection: function selection() {
        return new Bg(this._groups, this._parents);
      },
      transition: function transition() {
        for (var t = this._name, e = this._id, n = zg(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
          for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
            if (o = s[u]) {
              var l = by(o, e);
              gy(o, t, n, u, s, {
                time: l.time + l.delay + l.duration,
                delay: 0,
                duration: l.duration,
                ease: l.ease
              });
            }
          }
        }

        return new Yg(r, this._parents, t, n);
      },
      call: Ug.call,
      nodes: Ug.nodes,
      node: Ug.node,
      size: Ug.size,
      empty: Ug.empty,
      each: Ug.each,
      on: function on(t, e) {
        var n = this._id;
        return arguments.length < 2 ? by(this.node(), n).on.on(t) : this.each(Og(n, t, e));
      },
      attr: function attr(t, e) {
        var n = Xd(t),
            r = "transform" === n ? Sy : gg;
        return this.attrTween(t, "function" == typeof e ? (n.local ? wg : xg)(n, r, Ny(this, "attr." + t, e)) : null == e ? (n.local ? vg : mg)(n) : (n.local ? _g : bg)(n, r, e));
      },
      attrTween: function attrTween(t, e) {
        var n = "attr." + t;
        if (arguments.length < 2) return (n = this.tween(n)) && n._value;
        if (null == e) return this.tween(n, null);
        if ("function" != typeof e) throw new Error();
        var r = Xd(t);
        return this.tween(n, (r.local ? Eg : Cg)(r, e));
      },
      style: function style(t, e, n) {
        var r = "transform" == (t += "") ? Cy : gg;
        return null == e ? this.styleTween(t, function (t, e) {
          var n, r, i;
          return function () {
            var a = op(this, t),
                o = (this.style.removeProperty(t), op(this, t));
            return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
          };
        }(t, r)).on("end.style." + t, Lg(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
          var r, i, a;
          return function () {
            var o = op(this, t),
                s = n(this),
                c = s + "";
            return null == s && (this.style.removeProperty(t), c = s = op(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
          };
        }(t, r, Ny(this, "style." + t, e))).each(function (t, e) {
          var n,
              r,
              i,
              a,
              o = "style." + e,
              s = "end." + o;
          return function () {
            var c = vy(this, t),
                u = c.on,
                l = null == c.value[o] ? a || (a = Lg(e)) : void 0;
            u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
          };
        }(this._id, t)) : this.styleTween(t, function (t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = op(this, t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }(t, r, e), n).on("end.style." + t, null);
      },
      styleTween: function styleTween(t, e, n) {
        var r = "style." + (t += "");
        if (arguments.length < 2) return (r = this.tween(r)) && r._value;
        if (null == e) return this.tween(r, null);
        if ("function" != typeof e) throw new Error();
        return this.tween(r, Rg(t, e, null == n ? "" : n));
      },
      text: function text(t) {
        return this.tween("text", "function" == typeof t ? function (t) {
          return function () {
            var e = t(this);
            this.textContent = null == e ? "" : e;
          };
        }(Ny(this, "text", t)) : function (t) {
          return function () {
            this.textContent = t;
          };
        }(null == t ? "" : t + ""));
      },
      textTween: function textTween(t) {
        var e = "text";
        if (arguments.length < 1) return (e = this.tween(e)) && e._value;
        if (null == t) return this.tween(e, null);
        if ("function" != typeof t) throw new Error();
        return this.tween(e, Pg(t));
      },
      remove: function remove() {
        return this.on("end.remove", function (t) {
          return function () {
            var e = this.parentNode;

            for (var n in this.__transition) {
              if (+n !== t) return;
            }

            e && e.removeChild(this);
          };
        }(this._id));
      },
      tween: function tween(t, e) {
        var n = this._id;

        if (t += "", arguments.length < 2) {
          for (var r, i = by(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
            if ((r = i[a]).name === t) return r.value;
          }

          return null;
        }

        return this.each((null == e ? Ay : My)(n, t, e));
      },
      delay: function delay(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? Sg : Ag)(e, t)) : by(this.node(), e).delay;
      },
      duration: function duration(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? Mg : Ng)(e, t)) : by(this.node(), e).duration;
      },
      ease: function ease(t) {
        var e = this._id;
        return arguments.length ? this.each(Dg(e, t)) : by(this.node(), e).ease;
      },
      easeVarying: function easeVarying(t) {
        if ("function" != typeof t) throw new Error();
        return this.each(function (t, e) {
          return function () {
            var n = e.apply(this, arguments);
            if ("function" != typeof n) throw new Error();
            vy(this, t).ease = n;
          };
        }(this._id, t));
      },
      end: function end() {
        var t,
            e,
            n = this,
            r = n._id,
            i = n.size();
        return new Promise(function (a, o) {
          var s = {
            value: o
          },
              c = {
            value: function value() {
              0 == --i && a();
            }
          };
          n.each(function () {
            var n = vy(this, r),
                i = n.on;
            i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
          }), 0 === i && a();
        });
      }
    }, Symbol.iterator, Ug[Symbol.iterator]);
    var qg = {
      time: null,
      delay: 0,
      duration: 250,
      ease: function ease(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
      }
    };

    function Hg(t, e) {
      for (var n; !(n = t.__transition) || !(n = n[e]);) {
        if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
      }

      return n;
    }

    Up.prototype.interrupt = function (t) {
      return this.each(function () {
        !function (t, e) {
          var n,
              r,
              i,
              a = t.__transition,
              o = !0;

          if (a) {
            for (i in e = null == e ? null : e + "", a) {
              (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
            }

            o && delete t.__transition;
          }
        }(this, t);
      });
    }, Up.prototype.transition = function (t) {
      var e, n;
      t instanceof Yg ? (e = t._id, t = t._name) : (e = zg(), (n = qg).time = oy(), t = null == t ? null : t + "");

      for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
        for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
          (o = s[u]) && gy(o, t, e, u, s, n || Hg(o, e));
        }
      }

      return new Yg(r, this._parents, t, e);
    };
    var Wg = "comm",
        Vg = "rule",
        Gg = "decl",
        Xg = Math.abs,
        Zg = String.fromCharCode;

    function Qg(t) {
      return t.trim();
    }

    function Kg(t, e, n) {
      return t.replace(e, n);
    }

    function Jg(t, e) {
      return t.indexOf(e);
    }

    function tm(t, e) {
      return 0 | t.charCodeAt(e);
    }

    function em(t, e, n) {
      return t.slice(e, n);
    }

    function nm(t) {
      return t.length;
    }

    function rm(t) {
      return t.length;
    }

    function im(t, e) {
      return e.push(t), t;
    }

    function am(t, e) {
      for (var n = "", r = rm(t), i = 0; i < r; i++) {
        n += e(t[i], i, t, e) || "";
      }

      return n;
    }

    function om(t, e, n, r) {
      switch (t.type) {
        case "@import":
        case Gg:
          return t["return"] = t["return"] || t.value;

        case Wg:
          return "";

        case "@keyframes":
          return t["return"] = t.value + "{" + am(t.children, r) + "}";

        case Vg:
          t.value = t.props.join(",");
      }

      return nm(n = am(t.children, r)) ? t["return"] = t.value + "{" + n + "}" : "";
    }

    var sm = 1,
        cm = 1,
        um = 0,
        lm = 0,
        hm = 0,
        fm = "";

    function dm(t, e, n, r, i, a, o) {
      return {
        value: t,
        root: e,
        parent: n,
        type: r,
        props: i,
        children: a,
        line: sm,
        column: cm,
        length: o,
        "return": ""
      };
    }

    function pm() {
      return hm = lm > 0 ? tm(fm, --lm) : 0, cm--, 10 === hm && (cm = 1, sm--), hm;
    }

    function ym() {
      return hm = lm < um ? tm(fm, lm++) : 0, cm++, 10 === hm && (cm = 1, sm++), hm;
    }

    function gm() {
      return tm(fm, lm);
    }

    function mm() {
      return lm;
    }

    function vm(t, e) {
      return em(fm, t, e);
    }

    function bm(t) {
      switch (t) {
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
          return 5;

        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
          return 4;

        case 58:
          return 3;

        case 34:
        case 39:
        case 40:
        case 91:
          return 2;

        case 41:
        case 93:
          return 1;
      }

      return 0;
    }

    function _m(t) {
      return Qg(vm(lm - 1, km(91 === t ? t + 2 : 40 === t ? t + 1 : t)));
    }

    function xm(t) {
      for (; (hm = gm()) && hm < 33;) {
        ym();
      }

      return bm(t) > 2 || bm(hm) > 3 ? "" : " ";
    }

    function wm(t, e) {
      for (; --e && ym() && !(hm < 48 || hm > 102 || hm > 57 && hm < 65 || hm > 70 && hm < 97);) {
        ;
      }

      return vm(t, mm() + (e < 6 && 32 == gm() && 32 == ym()));
    }

    function km(t) {
      for (; ym();) {
        switch (hm) {
          case t:
            return lm;

          case 34:
          case 39:
            34 !== t && 39 !== t && km(hm);
            break;

          case 40:
            41 === t && km(t);
            break;

          case 92:
            ym();
        }
      }

      return lm;
    }

    function Tm(t, e) {
      for (; ym() && t + hm !== 57 && (t + hm !== 84 || 47 !== gm());) {
        ;
      }

      return "/*" + vm(e, lm - 1) + "*" + Zg(47 === t ? t : ym());
    }

    function Em(t) {
      for (; !bm(gm());) {
        ym();
      }

      return vm(t, lm);
    }

    function Cm(t) {
      return function (t) {
        return fm = "", t;
      }(Sm("", null, null, null, [""], t = function (t) {
        return sm = cm = 1, um = nm(fm = t), lm = 0, [];
      }(t), 0, [0], t));
    }

    function Sm(t, e, n, r, i, a, o, s, c) {
      for (var u = 0, l = 0, h = o, f = 0, d = 0, p = 0, y = 1, g = 1, m = 1, v = 0, b = "", _ = i, x = a, w = r, k = b; g;) {
        switch (p = v, v = ym()) {
          case 40:
            if (108 != p && 58 == k.charCodeAt(h - 1)) {
              -1 != Jg(k += Kg(_m(v), "&", "&\f"), "&\f") && (m = -1);
              break;
            }

          case 34:
          case 39:
          case 91:
            k += _m(v);
            break;

          case 9:
          case 10:
          case 13:
          case 32:
            k += xm(p);
            break;

          case 92:
            k += wm(mm() - 1, 7);
            continue;

          case 47:
            switch (gm()) {
              case 42:
              case 47:
                im(Mm(Tm(ym(), mm()), e, n), c);
                break;

              default:
                k += "/";
            }

            break;

          case 123 * y:
            s[u++] = nm(k) * m;

          case 125 * y:
          case 59:
          case 0:
            switch (v) {
              case 0:
              case 125:
                g = 0;

              case 59 + l:
                d > 0 && nm(k) - h && im(d > 32 ? Nm(k + ";", r, n, h - 1) : Nm(Kg(k, " ", "") + ";", r, n, h - 2), c);
                break;

              case 59:
                k += ";";

              default:
                if (im(w = Am(k, e, n, u, l, i, s, b, _ = [], x = [], h), a), 123 === v) if (0 === l) Sm(k, e, w, w, _, a, h, s, x);else switch (f) {
                  case 100:
                  case 109:
                  case 115:
                    Sm(t, w, w, r && im(Am(t, w, w, 0, 0, i, s, b, i, _ = [], h), x), i, x, h, s, r ? _ : x);
                    break;

                  default:
                    Sm(k, w, w, w, [""], x, 0, s, x);
                }
            }

            u = l = d = 0, y = m = 1, b = k = "", h = o;
            break;

          case 58:
            h = 1 + nm(k), d = p;

          default:
            if (y < 1) if (123 == v) --y;else if (125 == v && 0 == y++ && 125 == pm()) continue;

            switch (k += Zg(v), v * y) {
              case 38:
                m = l > 0 ? 1 : (k += "\f", -1);
                break;

              case 44:
                s[u++] = (nm(k) - 1) * m, m = 1;
                break;

              case 64:
                45 === gm() && (k += _m(ym())), f = gm(), l = h = nm(b = k += Em(mm())), v++;
                break;

              case 45:
                45 === p && 2 == nm(k) && (y = 0);
            }

        }
      }

      return a;
    }

    function Am(t, e, n, r, i, a, o, s, c, u, l) {
      for (var h = i - 1, f = 0 === i ? a : [""], d = rm(f), p = 0, y = 0, g = 0; p < r; ++p) {
        for (var m = 0, v = em(t, h + 1, h = Xg(y = o[p])), b = t; m < d; ++m) {
          (b = Qg(y > 0 ? f[m] + " " + v : Kg(v, /&\f/g, f[m]))) && (c[g++] = b);
        }
      }

      return dm(t, e, n, 0 === i ? Vg : s, c, u, l);
    }

    function Mm(t, e, n) {
      return dm(t, e, n, Wg, Zg(hm), em(t, 2, -2), 0);
    }

    function Nm(t, e, n, r) {
      return dm(t, e, n, Gg, em(t, 0, r), em(t, r + 1, -1), r);
    }

    var Dm = "8.14.0";

    var Om = n(9609),
        Bm = n(7856),
        Lm = n.n(Bm),
        Im = function Im(t) {
      var e = t.replace(/\\u[\dA-F]{4}/gi, function (t) {
        return String.fromCharCode(parseInt(t.replace(/\\u/g, ""), 16));
      });
      return e = (e = (e = e.replace(/\\x([0-9a-f]{2})/gi, function (t, e) {
        return String.fromCharCode(parseInt(e, 16));
      })).replace(/\\[\d\d\d]{3}/gi, function (t) {
        return String.fromCharCode(parseInt(t.replace(/\\/g, ""), 8));
      })).replace(/\\[\d\d\d]{2}/gi, function (t) {
        return String.fromCharCode(parseInt(t.replace(/\\/g, ""), 8));
      });
    },
        Rm = function Rm(t) {
      for (var e = "", n = 0; n >= 0;) {
        if (!((n = t.indexOf("<script")) >= 0)) {
          e += t, n = -1;
          break;
        }

        e += t.substr(0, n), (n = (t = t.substr(n + 1)).indexOf("<\/script>")) >= 0 && (n += 9, t = t.substr(n));
      }

      var r = Im(e);
      return (r = (r = (r = r.replace(/script>/gi, "#")).replace(/javascript:/gi, "#")).replace(/onerror=/gi, "onerror:")).replace(/<iframe/gi, "");
    },
        Fm = function Fm(t, e) {
      if (!t) return t;
      var n = Lm().sanitize(function (t, e) {
        var n = t,
            r = !0;

        if (!e.flowchart || !1 !== e.flowchart.htmlLabels && "false" !== e.flowchart.htmlLabels || (r = !1), r) {
          var i = e.securityLevel;
          "antiscript" === i || "strict" === i ? n = Rm(n) : "loose" !== i && (n = (n = (n = Ym(n)).replace(/</g, "&lt;").replace(/>/g, "&gt;")).replace(/=/g, "&equals;"), n = jm(n));
        }

        return n;
      }(t, e));
      return n;
    },
        Pm = /<br\s*\/?>/gi,
        jm = function jm(t) {
      return t.replace(/#br#/g, "<br/>");
    },
        Ym = function Ym(t) {
      return t.replace(Pm, "#br#");
    },
        zm = function zm(t) {
      return "false" !== t && !1 !== t;
    };

    var Um = {
      getRows: function getRows(t) {
        if (!t) return 1;
        var e = Ym(t);
        return (e = e.replace(/\\n/g, "#br#")).split("#br#");
      },
      sanitizeText: Fm,
      sanitizeTextOrArray: function sanitizeTextOrArray(t, e) {
        return "string" == typeof t ? Fm(t, e) : t.flat().map(function (t) {
          return Fm(t, e);
        });
      },
      hasBreaks: function hasBreaks(t) {
        return Pm.test(t);
      },
      splitBreaks: function splitBreaks(t) {
        return t.split(Pm);
      },
      lineBreakRegex: Pm,
      removeScript: Rm,
      getUrl: function getUrl(t) {
        var e = "";
        return t && (e = (e = (e = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), e;
      },
      evaluate: zm,
      removeEscapes: Im
    };

    var qm = n(8613),
        Hm = function Hm(t, e) {
      return e ? (0, qm.adjust)(t, {
        s: -40,
        l: 10
      }) : (0, qm.adjust)(t, {
        s: -40,
        l: -10
      });
    };

    function $m(t) {
      return $m = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, $m(t);
    }

    function Wm(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var Vm = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.background = "#f4f4f4", this.darkMode = !1, this.primaryColor = "#fff4dd", this.noteBkgColor = "#fff5ad", this.noteTextColor = "#333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px";
      }

      var e, n;
      return e = t, n = [{
        key: "updateColors",
        value: function value() {
          this.primaryTextColor = this.primaryTextColor || (this.darkMode ? "#ddd" : "#333"), this.secondaryColor = this.secondaryColor || (0, qm.adjust)(this.primaryColor, {
            h: -120
          }), this.tertiaryColor = this.tertiaryColor || (0, qm.adjust)(this.primaryColor, {
            h: 180,
            l: 5
          }), this.primaryBorderColor = this.primaryBorderColor || Hm(this.primaryColor, this.darkMode), this.secondaryBorderColor = this.secondaryBorderColor || Hm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = this.tertiaryBorderColor || Hm(this.tertiaryColor, this.darkMode), this.noteBorderColor = this.noteBorderColor || Hm(this.noteBkgColor, this.darkMode), this.noteBkgColor = this.noteBkgColor || "#fff5ad", this.noteTextColor = this.noteTextColor || "#333", this.secondaryTextColor = this.secondaryTextColor || (0, qm.invert)(this.secondaryColor), this.tertiaryTextColor = this.tertiaryTextColor || (0, qm.invert)(this.tertiaryColor), this.lineColor = this.lineColor || (0, qm.invert)(this.background), this.textColor = this.textColor || this.primaryTextColor, this.nodeBkg = this.nodeBkg || this.primaryColor, this.mainBkg = this.mainBkg || this.primaryColor, this.nodeBorder = this.nodeBorder || this.primaryBorderColor, this.clusterBkg = this.clusterBkg || this.tertiaryColor, this.clusterBorder = this.clusterBorder || this.tertiaryBorderColor, this.defaultLinkColor = this.defaultLinkColor || this.lineColor, this.titleColor = this.titleColor || this.tertiaryTextColor, this.edgeLabelBackground = this.edgeLabelBackground || (this.darkMode ? (0, qm.darken)(this.secondaryColor, 30) : this.secondaryColor), this.nodeTextColor = this.nodeTextColor || this.primaryTextColor, this.actorBorder = this.actorBorder || this.primaryBorderColor, this.actorBkg = this.actorBkg || this.mainBkg, this.actorTextColor = this.actorTextColor || this.primaryTextColor, this.actorLineColor = this.actorLineColor || "grey", this.labelBoxBkgColor = this.labelBoxBkgColor || this.actorBkg, this.signalColor = this.signalColor || this.textColor, this.signalTextColor = this.signalTextColor || this.textColor, this.labelBoxBorderColor = this.labelBoxBorderColor || this.actorBorder, this.labelTextColor = this.labelTextColor || this.actorTextColor, this.loopTextColor = this.loopTextColor || this.actorTextColor, this.activationBorderColor = this.activationBorderColor || (0, qm.darken)(this.secondaryColor, 10), this.activationBkgColor = this.activationBkgColor || this.secondaryColor, this.sequenceNumberColor = this.sequenceNumberColor || (0, qm.invert)(this.lineColor), this.sectionBkgColor = this.sectionBkgColor || this.tertiaryColor, this.altSectionBkgColor = this.altSectionBkgColor || "white", this.sectionBkgColor = this.sectionBkgColor || this.secondaryColor, this.sectionBkgColor2 = this.sectionBkgColor2 || this.primaryColor, this.excludeBkgColor = this.excludeBkgColor || "#eeeeee", this.taskBorderColor = this.taskBorderColor || this.primaryBorderColor, this.taskBkgColor = this.taskBkgColor || this.primaryColor, this.activeTaskBorderColor = this.activeTaskBorderColor || this.primaryColor, this.activeTaskBkgColor = this.activeTaskBkgColor || (0, qm.lighten)(this.primaryColor, 23), this.gridColor = this.gridColor || "lightgrey", this.doneTaskBkgColor = this.doneTaskBkgColor || "lightgrey", this.doneTaskBorderColor = this.doneTaskBorderColor || "grey", this.critBorderColor = this.critBorderColor || "#ff8888", this.critBkgColor = this.critBkgColor || "red", this.todayLineColor = this.todayLineColor || "red", this.taskTextColor = this.taskTextColor || this.textColor, this.taskTextOutsideColor = this.taskTextOutsideColor || this.textColor, this.taskTextLightColor = this.taskTextLightColor || this.textColor, this.taskTextColor = this.taskTextColor || this.primaryTextColor, this.taskTextDarkColor = this.taskTextDarkColor || this.textColor, this.taskTextClickableColor = this.taskTextClickableColor || "#003163", this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || this.tertiaryColor, this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.nodeBorder, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.specialStateColor = this.lineColor, this.classText = this.classText || this.textColor, this.fillType0 = this.fillType0 || this.primaryColor, this.fillType1 = this.fillType1 || this.secondaryColor, this.fillType2 = this.fillType2 || (0, qm.adjust)(this.primaryColor, {
            h: 64
          }), this.fillType3 = this.fillType3 || (0, qm.adjust)(this.secondaryColor, {
            h: 64
          }), this.fillType4 = this.fillType4 || (0, qm.adjust)(this.primaryColor, {
            h: -64
          }), this.fillType5 = this.fillType5 || (0, qm.adjust)(this.secondaryColor, {
            h: -64
          }), this.fillType6 = this.fillType6 || (0, qm.adjust)(this.primaryColor, {
            h: 128
          }), this.fillType7 = this.fillType7 || (0, qm.adjust)(this.secondaryColor, {
            h: 128
          }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || this.tertiaryColor, this.pie4 = this.pie4 || (0, qm.adjust)(this.primaryColor, {
            l: -10
          }), this.pie5 = this.pie5 || (0, qm.adjust)(this.secondaryColor, {
            l: -10
          }), this.pie6 = this.pie6 || (0, qm.adjust)(this.tertiaryColor, {
            l: -10
          }), this.pie7 = this.pie7 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -10
          }), this.pie8 = this.pie8 || (0, qm.adjust)(this.primaryColor, {
            h: -60,
            l: -10
          }), this.pie9 = this.pie9 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: 0
          }), this.pie10 = this.pie10 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -20
          }), this.pie11 = this.pie11 || (0, qm.adjust)(this.primaryColor, {
            h: -60,
            l: -20
          }), this.pie12 = this.pie12 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: -10
          }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, qm.darken)(this.secondaryColor, 30) : this.secondaryColor), this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        }
      }, {
        key: "calculate",
        value: function value(t) {
          var e = this;

          if ("object" === $m(t)) {
            var n = Object.keys(t);
            n.forEach(function (n) {
              e[n] = t[n];
            }), this.updateColors(), n.forEach(function (n) {
              e[n] = t[n];
            });
          } else this.updateColors();
        }
      }], n && Wm(e.prototype, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function Gm(t) {
      return Gm = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, Gm(t);
    }

    function Xm(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var Zm = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.background = "#333", this.primaryColor = "#1f2020", this.secondaryColor = (0, qm.lighten)(this.primaryColor, 16), this.tertiaryColor = (0, qm.adjust)(this.primaryColor, {
          h: -160
        }), this.primaryBorderColor = Hm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Hm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Hm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, qm.invert)(this.primaryColor), this.secondaryTextColor = (0, qm.invert)(this.secondaryColor), this.tertiaryTextColor = (0, qm.invert)(this.tertiaryColor), this.lineColor = (0, qm.invert)(this.background), this.textColor = (0, qm.invert)(this.background), this.mainBkg = "#1f2020", this.secondBkg = "calculated", this.mainContrastColor = "lightgrey", this.darkTextColor = (0, qm.lighten)((0, qm.invert)("#323D47"), 10), this.lineColor = "calculated", this.border1 = "#81B1DB", this.border2 = (0, qm.rgba)(255, 255, 255, .25), this.arrowheadColor = "calculated", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.labelBackground = "#181818", this.textColor = "#ccc", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "#F9FFFE", this.edgeLabelBackground = "calculated", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "calculated", this.actorLineColor = "calculated", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "calculated", this.activationBkgColor = "calculated", this.sequenceNumberColor = "black", this.sectionBkgColor = (0, qm.darken)("#EAE8D9", 30), this.altSectionBkgColor = "calculated", this.sectionBkgColor2 = "#EAE8D9", this.taskBorderColor = (0, qm.rgba)(255, 255, 255, 70), this.taskBkgColor = "calculated", this.taskTextColor = "calculated", this.taskTextLightColor = "calculated", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = (0, qm.rgba)(255, 255, 255, 50), this.activeTaskBkgColor = "#81B1DB", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "grey", this.critBorderColor = "#E83737", this.critBkgColor = "#E83737", this.taskTextDarkColor = "calculated", this.todayLineColor = "#DB5757", this.labelColor = "calculated", this.errorBkgColor = "#a44141", this.errorTextColor = "#ddd";
      }

      var e, n;
      return e = t, n = [{
        key: "updateColors",
        value: function value() {
          this.secondBkg = (0, qm.lighten)(this.mainBkg, 16), this.lineColor = this.mainContrastColor, this.arrowheadColor = this.mainContrastColor, this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.edgeLabelBackground = (0, qm.lighten)(this.labelBackground, 25), this.actorBorder = this.border1, this.actorBkg = this.mainBkg, this.actorTextColor = this.mainContrastColor, this.actorLineColor = this.mainContrastColor, this.signalColor = this.mainContrastColor, this.signalTextColor = this.mainContrastColor, this.labelBoxBkgColor = this.actorBkg, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.mainContrastColor, this.loopTextColor = this.mainContrastColor, this.noteBorderColor = this.secondaryBorderColor, this.noteBkgColor = this.secondBkg, this.noteTextColor = this.secondaryTextColor, this.activationBorderColor = this.border1, this.activationBkgColor = this.secondBkg, this.altSectionBkgColor = this.background, this.taskBkgColor = (0, qm.lighten)(this.mainBkg, 23), this.taskTextColor = this.darkTextColor, this.taskTextLightColor = this.mainContrastColor, this.taskTextOutsideColor = this.taskTextLightColor, this.gridColor = this.mainContrastColor, this.doneTaskBkgColor = this.mainContrastColor, this.taskTextDarkColor = this.darkTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#555", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = "#f4f4f4", this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, qm.adjust)(this.primaryColor, {
            h: 64
          }), this.fillType3 = (0, qm.adjust)(this.secondaryColor, {
            h: 64
          }), this.fillType4 = (0, qm.adjust)(this.primaryColor, {
            h: -64
          }), this.fillType5 = (0, qm.adjust)(this.secondaryColor, {
            h: -64
          }), this.fillType6 = (0, qm.adjust)(this.primaryColor, {
            h: 128
          }), this.fillType7 = (0, qm.adjust)(this.secondaryColor, {
            h: 128
          }), this.pie1 = this.pie1 || "#0b0000", this.pie2 = this.pie2 || "#4d1037", this.pie3 = this.pie3 || "#3f5258", this.pie4 = this.pie4 || "#4f2f1b", this.pie5 = this.pie5 || "#6e0a0a", this.pie6 = this.pie6 || "#3b0048", this.pie7 = this.pie7 || "#995a01", this.pie8 = this.pie8 || "#154706", this.pie9 = this.pie9 || "#161722", this.pie10 = this.pie10 || "#00296f", this.pie11 = this.pie11 || "#01629c", this.pie12 = this.pie12 || "#010029", this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.classText = this.primaryTextColor, this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, qm.darken)(this.secondaryColor, 30) : this.secondaryColor), this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        }
      }, {
        key: "calculate",
        value: function value(t) {
          var e = this;

          if ("object" === Gm(t)) {
            var n = Object.keys(t);
            n.forEach(function (n) {
              e[n] = t[n];
            }), this.updateColors(), n.forEach(function (n) {
              e[n] = t[n];
            });
          } else this.updateColors();
        }
      }], n && Xm(e.prototype, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function Qm(t) {
      return Qm = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, Qm(t);
    }

    function Km(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var Jm = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.background = "#f4f4f4", this.primaryColor = "#ECECFF", this.secondaryColor = (0, qm.adjust)(this.primaryColor, {
          h: 120
        }), this.secondaryColor = "#ffffde", this.tertiaryColor = (0, qm.adjust)(this.primaryColor, {
          h: -160
        }), this.primaryBorderColor = Hm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Hm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Hm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, qm.invert)(this.primaryColor), this.secondaryTextColor = (0, qm.invert)(this.secondaryColor), this.tertiaryTextColor = (0, qm.invert)(this.tertiaryColor), this.lineColor = (0, qm.invert)(this.background), this.textColor = (0, qm.invert)(this.background), this.background = "white", this.mainBkg = "#ECECFF", this.secondBkg = "#ffffde", this.lineColor = "#333333", this.border1 = "#9370DB", this.border2 = "#aaaa33", this.arrowheadColor = "#333333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.labelBackground = "#e8e8e8", this.textColor = "#333", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "calculated", this.edgeLabelBackground = "calculated", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "black", this.actorLineColor = "grey", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "calculated", this.altSectionBkgColor = "calculated", this.sectionBkgColor2 = "calculated", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "calculated", this.taskTextLightColor = "calculated", this.taskTextColor = this.taskTextLightColor, this.taskTextDarkColor = "calculated", this.taskTextOutsideColor = this.taskTextDarkColor, this.taskTextClickableColor = "calculated", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "calculated", this.critBorderColor = "calculated", this.critBkgColor = "calculated", this.todayLineColor = "calculated", this.sectionBkgColor = (0, qm.rgba)(102, 102, 255, .49), this.altSectionBkgColor = "white", this.sectionBkgColor2 = "#fff400", this.taskBorderColor = "#534fbc", this.taskBkgColor = "#8a90dd", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "black", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "#534fbc", this.activeTaskBkgColor = "#bfc7ff", this.gridColor = "lightgrey", this.doneTaskBkgColor = "lightgrey", this.doneTaskBorderColor = "grey", this.critBorderColor = "#ff8888", this.critBkgColor = "red", this.todayLineColor = "red", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222", this.updateColors();
      }

      var e, n;
      return e = t, n = [{
        key: "updateColors",
        value: function value() {
          this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.titleColor = this.textColor, this.edgeLabelBackground = this.labelBackground, this.actorBorder = (0, qm.lighten)(this.border1, 23), this.actorBkg = this.mainBkg, this.labelBoxBkgColor = this.actorBkg, this.signalColor = this.textColor, this.signalTextColor = this.textColor, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.actorTextColor, this.loopTextColor = this.actorTextColor, this.noteBorderColor = this.border2, this.noteTextColor = this.actorTextColor, this.taskTextColor = this.taskTextLightColor, this.taskTextOutsideColor = this.taskTextDarkColor, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f0f0f0", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.nodeBorder, this.specialStateColor = this.lineColor, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, qm.adjust)(this.primaryColor, {
            h: 64
          }), this.fillType3 = (0, qm.adjust)(this.secondaryColor, {
            h: 64
          }), this.fillType4 = (0, qm.adjust)(this.primaryColor, {
            h: -64
          }), this.fillType5 = (0, qm.adjust)(this.secondaryColor, {
            h: -64
          }), this.fillType6 = (0, qm.adjust)(this.primaryColor, {
            h: 128
          }), this.fillType7 = (0, qm.adjust)(this.secondaryColor, {
            h: 128
          }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || (0, qm.adjust)(this.tertiaryColor, {
            l: -40
          }), this.pie4 = this.pie4 || (0, qm.adjust)(this.primaryColor, {
            l: -10
          }), this.pie5 = this.pie5 || (0, qm.adjust)(this.secondaryColor, {
            l: -30
          }), this.pie6 = this.pie6 || (0, qm.adjust)(this.tertiaryColor, {
            l: -20
          }), this.pie7 = this.pie7 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -20
          }), this.pie8 = this.pie8 || (0, qm.adjust)(this.primaryColor, {
            h: -60,
            l: -40
          }), this.pie9 = this.pie9 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: -40
          }), this.pie10 = this.pie10 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -40
          }), this.pie11 = this.pie11 || (0, qm.adjust)(this.primaryColor, {
            h: -90,
            l: -40
          }), this.pie12 = this.pie12 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: -30
          }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.labelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        }
      }, {
        key: "calculate",
        value: function value(t) {
          var e = this;

          if ("object" === Qm(t)) {
            var n = Object.keys(t);
            n.forEach(function (n) {
              e[n] = t[n];
            }), this.updateColors(), n.forEach(function (n) {
              e[n] = t[n];
            });
          } else this.updateColors();
        }
      }], n && Km(e.prototype, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function tv(t) {
      return tv = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, tv(t);
    }

    function ev(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var nv = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.background = "#f4f4f4", this.primaryColor = "#cde498", this.secondaryColor = "#cdffb2", this.background = "white", this.mainBkg = "#cde498", this.secondBkg = "#cdffb2", this.lineColor = "green", this.border1 = "#13540c", this.border2 = "#6eaa49", this.arrowheadColor = "green", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.tertiaryColor = (0, qm.lighten)("#cde498", 10), this.primaryBorderColor = Hm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Hm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Hm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, qm.invert)(this.primaryColor), this.secondaryTextColor = (0, qm.invert)(this.secondaryColor), this.tertiaryTextColor = (0, qm.invert)(this.primaryColor), this.lineColor = (0, qm.invert)(this.background), this.textColor = (0, qm.invert)(this.background), this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "#333", this.edgeLabelBackground = "#e8e8e8", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "black", this.actorLineColor = "grey", this.signalColor = "#333", this.signalTextColor = "#333", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "#326932", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "#6eaa49", this.altSectionBkgColor = "white", this.sectionBkgColor2 = "#6eaa49", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "#487e3a", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "black", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "lightgrey", this.doneTaskBkgColor = "lightgrey", this.doneTaskBorderColor = "grey", this.critBorderColor = "#ff8888", this.critBkgColor = "red", this.todayLineColor = "red", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222";
      }

      var e, n;
      return e = t, n = [{
        key: "updateColors",
        value: function value() {
          this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.actorBorder = (0, qm.darken)(this.mainBkg, 20), this.actorBkg = this.mainBkg, this.labelBoxBkgColor = this.actorBkg, this.labelTextColor = this.actorTextColor, this.loopTextColor = this.actorTextColor, this.noteBorderColor = this.border2, this.noteTextColor = this.actorTextColor, this.taskBorderColor = this.border1, this.taskTextColor = this.taskTextLightColor, this.taskTextOutsideColor = this.taskTextDarkColor, this.activeTaskBorderColor = this.taskBorderColor, this.activeTaskBkgColor = this.mainBkg, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f0f0f0", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = this.lineColor, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, qm.adjust)(this.primaryColor, {
            h: 64
          }), this.fillType3 = (0, qm.adjust)(this.secondaryColor, {
            h: 64
          }), this.fillType4 = (0, qm.adjust)(this.primaryColor, {
            h: -64
          }), this.fillType5 = (0, qm.adjust)(this.secondaryColor, {
            h: -64
          }), this.fillType6 = (0, qm.adjust)(this.primaryColor, {
            h: 128
          }), this.fillType7 = (0, qm.adjust)(this.secondaryColor, {
            h: 128
          }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || this.tertiaryColor, this.pie4 = this.pie4 || (0, qm.adjust)(this.primaryColor, {
            l: -30
          }), this.pie5 = this.pie5 || (0, qm.adjust)(this.secondaryColor, {
            l: -30
          }), this.pie6 = this.pie6 || (0, qm.adjust)(this.tertiaryColor, {
            h: 40,
            l: -40
          }), this.pie7 = this.pie7 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -10
          }), this.pie8 = this.pie8 || (0, qm.adjust)(this.primaryColor, {
            h: -60,
            l: -10
          }), this.pie9 = this.pie9 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: 0
          }), this.pie10 = this.pie10 || (0, qm.adjust)(this.primaryColor, {
            h: 60,
            l: -50
          }), this.pie11 = this.pie11 || (0, qm.adjust)(this.primaryColor, {
            h: -60,
            l: -50
          }), this.pie12 = this.pie12 || (0, qm.adjust)(this.primaryColor, {
            h: 120,
            l: -50
          }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        }
      }, {
        key: "calculate",
        value: function value(t) {
          var e = this;

          if ("object" === tv(t)) {
            var n = Object.keys(t);
            n.forEach(function (n) {
              e[n] = t[n];
            }), this.updateColors(), n.forEach(function (n) {
              e[n] = t[n];
            });
          } else this.updateColors();
        }
      }], n && ev(e.prototype, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function rv(t) {
      return rv = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, rv(t);
    }

    function iv(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var av = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.primaryColor = "#eee", this.contrast = "#707070", this.secondaryColor = (0, qm.lighten)(this.contrast, 55), this.background = "#ffffff", this.tertiaryColor = (0, qm.adjust)(this.primaryColor, {
          h: -160
        }), this.primaryBorderColor = Hm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Hm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Hm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, qm.invert)(this.primaryColor), this.secondaryTextColor = (0, qm.invert)(this.secondaryColor), this.tertiaryTextColor = (0, qm.invert)(this.tertiaryColor), this.lineColor = (0, qm.invert)(this.background), this.textColor = (0, qm.invert)(this.background), this.mainBkg = "#eee", this.secondBkg = "calculated", this.lineColor = "#666", this.border1 = "#999", this.border2 = "calculated", this.note = "#ffa", this.text = "#333", this.critical = "#d42", this.done = "#bbb", this.arrowheadColor = "#333333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "calculated", this.edgeLabelBackground = "white", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "calculated", this.actorLineColor = "calculated", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "calculated", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "calculated", this.altSectionBkgColor = "white", this.sectionBkgColor2 = "calculated", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "calculated", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "calculated", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "calculated", this.critBkgColor = "calculated", this.critBorderColor = "calculated", this.todayLineColor = "calculated", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222";
      }

      var e, n;
      return e = t, n = [{
        key: "updateColors",
        value: function value() {
          this.secondBkg = (0, qm.lighten)(this.contrast, 55), this.border2 = this.contrast, this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.titleColor = this.text, this.actorBorder = (0, qm.lighten)(this.border1, 23), this.actorBkg = this.mainBkg, this.actorTextColor = this.text, this.actorLineColor = this.lineColor, this.signalColor = this.text, this.signalTextColor = this.text, this.labelBoxBkgColor = this.actorBkg, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.text, this.loopTextColor = this.text, this.noteBorderColor = "#999", this.noteBkgColor = "#666", this.noteTextColor = "#fff", this.sectionBkgColor = (0, qm.lighten)(this.contrast, 30), this.sectionBkgColor2 = (0, qm.lighten)(this.contrast, 30), this.taskBorderColor = (0, qm.darken)(this.contrast, 10), this.taskBkgColor = this.contrast, this.taskTextColor = this.taskTextLightColor, this.taskTextDarkColor = this.text, this.taskTextOutsideColor = this.taskTextDarkColor, this.activeTaskBorderColor = this.taskBorderColor, this.activeTaskBkgColor = this.mainBkg, this.gridColor = (0, qm.lighten)(this.border1, 30), this.doneTaskBkgColor = this.done, this.doneTaskBorderColor = this.lineColor, this.critBkgColor = this.critical, this.critBorderColor = (0, qm.darken)(this.critBkgColor, 10), this.todayLineColor = this.critBkgColor, this.transitionColor = this.transitionColor || "#000", this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f4f4f4", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.stateBorder = this.stateBorder || "#000", this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = "#222", this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, qm.adjust)(this.primaryColor, {
            h: 64
          }), this.fillType3 = (0, qm.adjust)(this.secondaryColor, {
            h: 64
          }), this.fillType4 = (0, qm.adjust)(this.primaryColor, {
            h: -64
          }), this.fillType5 = (0, qm.adjust)(this.secondaryColor, {
            h: -64
          }), this.fillType6 = (0, qm.adjust)(this.primaryColor, {
            h: 128
          }), this.fillType7 = (0, qm.adjust)(this.secondaryColor, {
            h: 128
          }), this.pie1 = this.pie1 || "#F4F4F4", this.pie2 = this.pie2 || "#555", this.pie3 = this.pie3 || "#BBB", this.pie4 = this.pie4 || "#777", this.pie5 = this.pie5 || "#999", this.pie6 = this.pie6 || "#DDD", this.pie7 = this.pie7 || "#FFF", this.pie8 = this.pie8 || "#DDD", this.pie9 = this.pie9 || "#BBB", this.pie10 = this.pie10 || "#999", this.pie11 = this.pie11 || "#777", this.pie12 = this.pie12 || "#555", this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        }
      }, {
        key: "calculate",
        value: function value(t) {
          var e = this;

          if ("object" === rv(t)) {
            var n = Object.keys(t);
            n.forEach(function (n) {
              e[n] = t[n];
            }), this.updateColors(), n.forEach(function (n) {
              e[n] = t[n];
            });
          } else this.updateColors();
        }
      }], n && iv(e.prototype, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    var ov = {
      base: {
        getThemeVariables: function getThemeVariables(t) {
          var e = new Vm();
          return e.calculate(t), e;
        }
      },
      dark: {
        getThemeVariables: function getThemeVariables(t) {
          var e = new Zm();
          return e.calculate(t), e;
        }
      },
      "default": {
        getThemeVariables: function getThemeVariables(t) {
          var e = new Jm();
          return e.calculate(t), e;
        }
      },
      forest: {
        getThemeVariables: function getThemeVariables(t) {
          var e = new nv();
          return e.calculate(t), e;
        }
      },
      neutral: {
        getThemeVariables: function getThemeVariables(t) {
          var e = new av();
          return e.calculate(t), e;
        }
      }
    };

    function sv(t) {
      return function (t) {
        if (Array.isArray(t)) return cv(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return cv(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? cv(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function cv(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    function uv(t) {
      return uv = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, uv(t);
    }

    var lv = {
      theme: "default",
      themeVariables: ov["default"].getThemeVariables(),
      themeCSS: void 0,
      maxTextSize: 5e4,
      darkMode: !1,
      fontFamily: '"trebuchet ms", verdana, arial, sans-serif;',
      logLevel: 5,
      securityLevel: "strict",
      startOnLoad: !0,
      arrowMarkerAbsolute: !1,
      secure: ["secure", "securityLevel", "startOnLoad", "maxTextSize"],
      deterministicIds: !1,
      deterministicIDSeed: void 0,
      flowchart: {
        diagramPadding: 8,
        htmlLabels: !0,
        nodeSpacing: 50,
        rankSpacing: 50,
        curve: "basis",
        padding: 15,
        useMaxWidth: !0,
        defaultRenderer: "dagre-d3"
      },
      sequence: {
        activationWidth: 10,
        diagramMarginX: 50,
        diagramMarginY: 10,
        actorMargin: 50,
        width: 150,
        height: 65,
        boxMargin: 10,
        boxTextMargin: 5,
        noteMargin: 10,
        messageMargin: 35,
        messageAlign: "center",
        mirrorActors: !0,
        forceMenus: !1,
        bottomMarginAdj: 1,
        useMaxWidth: !0,
        rightAngles: !1,
        showSequenceNumbers: !1,
        actorFontSize: 14,
        actorFontFamily: '"Open-Sans", "sans-serif"',
        actorFontWeight: 400,
        noteFontSize: 14,
        noteFontFamily: '"trebuchet ms", verdana, arial, sans-serif',
        noteFontWeight: 400,
        noteAlign: "center",
        messageFontSize: 16,
        messageFontFamily: '"trebuchet ms", verdana, arial, sans-serif',
        messageFontWeight: 400,
        wrap: !1,
        wrapPadding: 10,
        labelBoxWidth: 50,
        labelBoxHeight: 20,
        messageFont: function messageFont() {
          return {
            fontFamily: this.messageFontFamily,
            fontSize: this.messageFontSize,
            fontWeight: this.messageFontWeight
          };
        },
        noteFont: function noteFont() {
          return {
            fontFamily: this.noteFontFamily,
            fontSize: this.noteFontSize,
            fontWeight: this.noteFontWeight
          };
        },
        actorFont: function actorFont() {
          return {
            fontFamily: this.actorFontFamily,
            fontSize: this.actorFontSize,
            fontWeight: this.actorFontWeight
          };
        }
      },
      gantt: {
        titleTopMargin: 25,
        barHeight: 20,
        barGap: 4,
        topPadding: 50,
        rightPadding: 75,
        leftPadding: 75,
        gridLineStartPadding: 35,
        fontSize: 11,
        sectionFontSize: 11,
        numberSectionStyles: 4,
        axisFormat: "%Y-%m-%d",
        useMaxWidth: !0,
        topAxis: !1,
        useWidth: void 0
      },
      journey: {
        diagramMarginX: 50,
        diagramMarginY: 10,
        leftMargin: 150,
        width: 150,
        height: 50,
        boxMargin: 10,
        boxTextMargin: 5,
        noteMargin: 10,
        messageMargin: 35,
        messageAlign: "center",
        bottomMarginAdj: 1,
        useMaxWidth: !0,
        rightAngles: !1,
        taskFontSize: 14,
        taskFontFamily: '"Open-Sans", "sans-serif"',
        taskMargin: 50,
        activationWidth: 10,
        textPlacement: "fo",
        actorColours: ["#8FBC8F", "#7CFC00", "#00FFFF", "#20B2AA", "#B0E0E6", "#FFFFE0"],
        sectionFills: ["#191970", "#8B008B", "#4B0082", "#2F4F4F", "#800000", "#8B4513", "#00008B"],
        sectionColours: ["#fff"]
      },
      "class": {
        arrowMarkerAbsolute: !1,
        useMaxWidth: !0,
        defaultRenderer: "dagre-wrapper"
      },
      git: {
        arrowMarkerAbsolute: !1,
        useWidth: void 0,
        useMaxWidth: !0
      },
      state: {
        dividerMargin: 10,
        sizeUnit: 5,
        padding: 8,
        textHeight: 10,
        titleShift: -15,
        noteMargin: 10,
        forkWidth: 70,
        forkHeight: 7,
        miniPadding: 2,
        fontSizeFactor: 5.02,
        fontSize: 24,
        labelHeight: 16,
        edgeLengthFactor: "20",
        compositTitleSize: 35,
        radius: 5,
        useMaxWidth: !0,
        defaultRenderer: "dagre-wrapper"
      },
      er: {
        diagramPadding: 20,
        layoutDirection: "TB",
        minEntityWidth: 100,
        minEntityHeight: 75,
        entityPadding: 15,
        stroke: "gray",
        fill: "honeydew",
        fontSize: 12,
        useMaxWidth: !0
      },
      pie: {
        useWidth: void 0,
        useMaxWidth: !0
      },
      requirement: {
        useWidth: void 0,
        useMaxWidth: !0,
        rect_fill: "#f9f9f9",
        text_color: "#333",
        rect_border_size: "0.5px",
        rect_border_color: "#bbb",
        rect_min_width: 200,
        rect_min_height: 200,
        fontSize: 14,
        rect_padding: 10,
        line_height: 20
      }
    };
    lv["class"].arrowMarkerAbsolute = lv.arrowMarkerAbsolute, lv.git.arrowMarkerAbsolute = lv.arrowMarkerAbsolute;

    var hv = function t(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
      return Object.keys(e).reduce(function (r, i) {
        return Array.isArray(e[i]) ? r : "object" === uv(e[i]) && null !== e[i] ? [].concat(sv(r), [n + i], sv(t(e[i], ""))) : [].concat(sv(r), [n + i]);
      }, []);
    }(lv, "");

    var fv = lv;
    var dv = void 0;

    function pv(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function yv(t, e) {
      var _n8 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

      if (!_n8) {
        if (Array.isArray(t) || (_n8 = vv(t)) || e && t && "number" == typeof t.length) {
          _n8 && (t = _n8);

          var r = 0,
              i = function i() {};

          return {
            s: i,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: i
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var a,
          o = !0,
          s = !1;
      return {
        s: function s() {
          _n8 = _n8.call(t);
        },
        n: function n() {
          var t = _n8.next();

          return o = t.done, t;
        },
        e: function e(t) {
          s = !0, a = t;
        },
        f: function f() {
          try {
            o || null == _n8["return"] || _n8["return"]();
          } finally {
            if (s) throw a;
          }
        }
      };
    }

    function gv(t) {
      return gv = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, gv(t);
    }

    function mv(t) {
      return function (t) {
        if (Array.isArray(t)) return bv(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || vv(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function vv(t, e) {
      if (t) {
        if ("string" == typeof t) return bv(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bv(t, e) : void 0;
      }
    }

    function bv(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var _v,
        xv = {
      curveBasis: Vu,
      curveBasisClosed: function curveBasisClosed(t) {
        return new Gu(t);
      },
      curveBasisOpen: function curveBasisOpen(t) {
        return new Xu(t);
      },
      curveLinear: Pu,
      curveLinearClosed: function curveLinearClosed(t) {
        return new Zu(t);
      },
      curveMonotoneX: function curveMonotoneX(t) {
        return new el(t);
      },
      curveMonotoneY: function curveMonotoneY(t) {
        return new nl(t);
      },
      curveNatural: function curveNatural(t) {
        return new il(t);
      },
      curveStep: function curveStep(t) {
        return new ol(t, .5);
      },
      curveStepAfter: function curveStepAfter(t) {
        return new ol(t, 1);
      },
      curveStepBefore: function curveStepBefore(t) {
        return new ol(t, 0);
      }
    },
        wv = /[%]{2}[{]\s*(?:(?:(\w+)\s*:|(\w+))\s*(?:(?:(\w+))|((?:(?![}][%]{2}).|\r?\n)*))?\s*)(?:[}][%]{2})?/gi,
        kv = /\s*(?:(?:(\w+)(?=:):|(\w+))\s*(?:(?:(\w+))|((?:(?![}][%]{2}).|\r?\n)*))?\s*)(?:[}][%]{2})?/gi,
        Tv = /\s*%%.*\n/gm,
        Ev = function Ev(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

      try {
        var n = new RegExp("[%]{2}(?![{]".concat(kv.source, ")(?=[}][%]{2}).*\n"), "ig");
        t = t.trim().replace(n, "").replace(/'/gm, '"'), o.debug("Detecting diagram directive".concat(null !== e ? " type:" + e : "", " based on the text:").concat(t));

        for (var r, i = []; null !== (r = wv.exec(t));) {
          if (r.index === wv.lastIndex && wv.lastIndex++, r && !e || e && r[1] && r[1].match(e) || e && r[2] && r[2].match(e)) {
            var a = r[1] ? r[1] : r[2],
                s = r[3] ? r[3].trim() : r[4] ? JSON.parse(r[4].trim()) : null;
            i.push({
              type: a,
              args: s
            });
          }
        }

        return 0 === i.length && i.push({
          type: t,
          args: null
        }), 1 === i.length ? i[0] : i;
      } catch (n) {
        return o.error("ERROR: ".concat(n.message, " - Unable to parse directive\n      ").concat(null !== e ? " type:" + e : "", " based on the text:").concat(t)), {
          type: null,
          args: null
        };
      }
    },
        Cv = function Cv(t, e) {
      return (t = t.replace(wv, "").replace(Tv, "\n")).match(/^\s*sequenceDiagram/) ? "sequence" : t.match(/^\s*gantt/) ? "gantt" : t.match(/^\s*classDiagram-v2/) ? "classDiagram" : t.match(/^\s*classDiagram/) ? e && e["class"] && "dagre-wrapper" === e["class"].defaultRenderer ? "classDiagram" : "class" : t.match(/^\s*stateDiagram-v2/) ? "stateDiagram" : t.match(/^\s*stateDiagram/) ? e && e["class"] && "dagre-wrapper" === e.state.defaultRenderer ? "stateDiagram" : "state" : t.match(/^\s*gitGraph/) ? "git" : t.match(/^\s*flowchart/) ? "flowchart-v2" : t.match(/^\s*info/) ? "info" : t.match(/^\s*pie/) ? "pie" : t.match(/^\s*erDiagram/) ? "er" : t.match(/^\s*journey/) ? "journey" : t.match(/^\s*requirement/) || t.match(/^\s*requirementDiagram/) ? "requirement" : e && e.flowchart && "dagre-wrapper" === e.flowchart.defaultRenderer ? "flowchart-v2" : "flowchart";
    },
        Sv = function Sv(t, e) {
      var n = {};
      return function () {
        for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }

        var o = e ? e.apply(dv, i) : i[0];
        if (o in n) return n[o];
        var s = t.apply(void 0, i);
        return n[o] = s, s;
      };
    },
        Av = function Av(t, e) {
      if (!t) return e;
      var n = "curve".concat(t.charAt(0).toUpperCase() + t.slice(1));
      return xv[n] || e;
    },
        Mv = function Mv(t, e) {
      return t && e ? Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)) : 0;
    },
        Nv = function Nv(t) {
      for (var e = "", n = "", r = 0; r < t.length; r++) {
        void 0 !== t[r] && (t[r].startsWith("color:") || t[r].startsWith("text-align:") ? n = n + t[r] + ";" : e = e + t[r] + ";");
      }

      return {
        style: e,
        labelStyle: n
      };
    },
        Dv = 0,
        Ov = function Ov() {
      return Dv++, "id-" + Math.random().toString(36).substr(2, 12) + "-" + Dv;
    },
        Bv = function Bv(t) {
      return function (t) {
        for (var e = "", n = "0123456789abcdef", r = n.length, i = 0; i < t; i++) {
          e += n.charAt(Math.floor(Math.random() * r));
        }

        return e;
      }(t.length);
    },
        Lv = function t(e, n, r) {
      var i = Object.assign({
        depth: 2,
        clobber: !1
      }, r),
          a = i.depth,
          o = i.clobber;
      return Array.isArray(n) && !Array.isArray(e) ? (n.forEach(function (n) {
        return t(e, n, r);
      }), e) : Array.isArray(n) && Array.isArray(e) ? (n.forEach(function (t) {
        -1 === e.indexOf(t) && e.push(t);
      }), e) : void 0 === e || a <= 0 ? null != e && "object" === gv(e) && "object" === gv(n) ? Object.assign(e, n) : n : (void 0 !== n && "object" === gv(e) && "object" === gv(n) && Object.keys(n).forEach(function (r) {
        "object" !== gv(n[r]) || void 0 !== e[r] && "object" !== gv(e[r]) ? (o || "object" !== gv(e[r]) && "object" !== gv(n[r])) && (e[r] = n[r]) : (void 0 === e[r] && (e[r] = Array.isArray(n[r]) ? [] : {}), e[r] = t(e[r], n[r], {
          depth: a - 1,
          clobber: o
        }));
      }), e);
    },
        Iv = function Iv(t, e) {
      var n = e.text.replace(Um.lineBreakRegex, " "),
          r = t.append("text");
      r.attr("x", e.x), r.attr("y", e.y), r.style("text-anchor", e.anchor), r.style("font-family", e.fontFamily), r.style("font-size", e.fontSize), r.style("font-weight", e.fontWeight), r.attr("fill", e.fill), void 0 !== e["class"] && r.attr("class", e["class"]);
      var i = r.append("tspan");
      return i.attr("x", e.x + 2 * e.textMargin), i.attr("fill", e.fill), i.text(n), r;
    },
        Rv = Sv(function (t, e, n) {
      if (!t) return t;
      if (n = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        joinWith: "<br/>"
      }, n), Um.lineBreakRegex.test(t)) return t;
      var r = t.split(" "),
          i = [],
          a = "";
      return r.forEach(function (t, o) {
        var s = Pv("".concat(t, " "), n),
            c = Pv(a, n);

        if (s > e) {
          var u = Fv(t, e, "-", n),
              l = u.hyphenatedStrings,
              h = u.remainingWord;
          i.push.apply(i, [a].concat(mv(l))), a = h;
        } else c + s >= e ? (i.push(a), a = t) : a = [a, t].filter(Boolean).join(" ");

        o + 1 === r.length && i.push(a);
      }), i.filter(function (t) {
        return "" !== t;
      }).join(n.joinWith);
    }, function (t, e, n) {
      return "".concat(t, "-").concat(e, "-").concat(n.fontSize, "-").concat(n.fontWeight, "-").concat(n.fontFamily, "-").concat(n.joinWith);
    }),
        Fv = Sv(function (t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "-",
          r = arguments.length > 3 ? arguments[3] : void 0;
      r = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        margin: 0
      }, r);
      var i = t.split(""),
          a = [],
          o = "";
      return i.forEach(function (t, s) {
        var c = "".concat(o).concat(t);

        if (Pv(c, r) >= e) {
          var u = s + 1,
              l = i.length === u,
              h = "".concat(c).concat(n);
          a.push(l ? c : h), o = "";
        } else o = c;
      }), {
        hyphenatedStrings: a,
        remainingWord: o
      };
    }, function (t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "-",
          r = arguments.length > 3 ? arguments[3] : void 0;
      return "".concat(t, "-").concat(e, "-").concat(n, "-").concat(r.fontSize, "-").concat(r.fontWeight, "-").concat(r.fontFamily);
    }),
        Pv = function Pv(t, e) {
      return e = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial"
      }, e), jv(t, e).width;
    },
        jv = Sv(function (t, e) {
      var n = e = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial"
      }, e),
          r = n.fontSize,
          i = n.fontFamily,
          a = n.fontWeight;
      if (!t) return {
        width: 0,
        height: 0
      };
      var o = ["sans-serif", i],
          s = t.split(Um.lineBreakRegex),
          c = [],
          u = au("body");
      if (!u.remove) return {
        width: 0,
        height: 0,
        lineHeight: 0
      };

      for (var l = u.append("svg"), h = 0, f = o; h < f.length; h++) {
        var d,
            p = f[h],
            y = 0,
            g = {
          width: 0,
          height: 0,
          lineHeight: 0
        },
            m = yv(s);

        try {
          for (m.s(); !(d = m.n()).done;) {
            var v = d.value,
                b = {
              x: 0,
              y: 0,
              fill: void 0,
              anchor: "start",
              style: "#666",
              width: 100,
              height: 100,
              textMargin: 0,
              rx: 0,
              ry: 0,
              valign: void 0
            };
            b.text = v;

            var _ = Iv(l, b).style("font-size", r).style("font-weight", a).style("font-family", p),
                x = (_._groups || _)[0][0].getBBox();

            g.width = Math.round(Math.max(g.width, x.width)), y = Math.round(x.height), g.height += y, g.lineHeight = Math.round(Math.max(g.lineHeight, y));
          }
        } catch (t) {
          m.e(t);
        } finally {
          m.f();
        }

        c.push(g);
      }

      return l.remove(), c[isNaN(c[1].height) || isNaN(c[1].width) || isNaN(c[1].lineHeight) || c[0].height > c[1].height && c[0].width > c[1].width && c[0].lineHeight > c[1].lineHeight ? 0 : 1];
    }, function (t, e) {
      return "".concat(t, "-").concat(e.fontSize, "-").concat(e.fontWeight, "-").concat(e.fontFamily);
    }),
        Yv = function Yv(t, e, n) {
      var r = new Map();
      return r.set("height", t), n ? (r.set("width", "100%"), r.set("style", "max-width: ".concat(e, "px;"))) : r.set("width", e), r;
    },
        zv = function zv(t, e, n, r) {
      !function (t, e) {
        var n,
            r = yv(e);

        try {
          for (r.s(); !(n = r.n()).done;) {
            var i = n.value;
            t.attr(i[0], i[1]);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }
      }(t, Yv(e, n, r));
    },
        Uv = function t(e) {
      o.debug("directiveSanitizer called with", e), "object" === gv(e) && (e.length ? e.forEach(function (e) {
        return t(e);
      }) : Object.keys(e).forEach(function (n) {
        o.debug("Checking key", n), 0 === n.indexOf("__") && (o.debug("sanitize deleting __ option", n), delete e[n]), n.indexOf("proto") >= 0 && (o.debug("sanitize deleting proto option", n), delete e[n]), n.indexOf("constr") >= 0 && (o.debug("sanitize deleting constr option", n), delete e[n]), n.indexOf("themeCSS") >= 0 && (o.debug("sanitizing themeCss option"), e[n] = qv(e[n])), hv.indexOf(n) < 0 ? (o.debug("sanitize deleting option", n), delete e[n]) : "object" === gv(e[n]) && (o.debug("sanitize deleting object", n), t(e[n]));
      }));
    },
        qv = function qv(t) {
      return (t.match(/\{/g) || []).length !== (t.match(/\}/g) || []).length ? "{ /* ERROR: Unbalanced CSS */ }" : t;
    };

    var Hv = {
      assignWithDepth: Lv,
      wrapLabel: Rv,
      calculateTextHeight: function calculateTextHeight(t, e) {
        return e = Object.assign({
          fontSize: 12,
          fontWeight: 400,
          fontFamily: "Arial",
          margin: 15
        }, e), jv(t, e).height;
      },
      calculateTextWidth: Pv,
      calculateTextDimensions: jv,
      calculateSvgSizeAttrs: Yv,
      configureSvgSize: zv,
      detectInit: function detectInit(t, e) {
        var n = Ev(t, /(?:init\b)|(?:initialize\b)/),
            r = {};

        if (Array.isArray(n)) {
          var i = n.map(function (t) {
            return t.args;
          });
          Uv(i), r = Lv(r, mv(i));
        } else r = n.args;

        if (r) {
          var a = Cv(t, e);
          ["config"].forEach(function (t) {
            void 0 !== r[t] && ("flowchart-v2" === a && (a = "flowchart"), r[a] = r[t], delete r[t]);
          });
        }

        return r;
      },
      detectDirective: Ev,
      detectType: Cv,
      isSubstringInArray: function isSubstringInArray(t, e) {
        for (var n = 0; n < e.length; n++) {
          if (e[n].match(t)) return n;
        }

        return -1;
      },
      interpolateToCurve: Av,
      calcLabelPosition: function calcLabelPosition(t) {
        return function (t) {
          var e,
              n = 0;
          t.forEach(function (t) {
            n += Mv(t, e), e = t;
          });
          var r = n / 2,
              i = void 0;
          return e = void 0, t.forEach(function (t) {
            if (e && !i) {
              var n = Mv(t, e);
              if (n < r) r -= n;else {
                var a = r / n;
                a <= 0 && (i = e), a >= 1 && (i = {
                  x: t.x,
                  y: t.y
                }), a > 0 && a < 1 && (i = {
                  x: (1 - a) * e.x + a * t.x,
                  y: (1 - a) * e.y + a * t.y
                });
              }
            }

            e = t;
          }), i;
        }(t);
      },
      calcCardinalityPosition: function calcCardinalityPosition(t, e, n) {
        var r;
        o.info("our points", e), e[0] !== n && (e = e.reverse()), e.forEach(function (t) {
          Mv(t, r), r = t;
        });
        var i,
            a = 25;
        r = void 0, e.forEach(function (t) {
          if (r && !i) {
            var e = Mv(t, r);
            if (e < a) a -= e;else {
              var n = a / e;
              n <= 0 && (i = r), n >= 1 && (i = {
                x: t.x,
                y: t.y
              }), n > 0 && n < 1 && (i = {
                x: (1 - n) * r.x + n * t.x,
                y: (1 - n) * r.y + n * t.y
              });
            }
          }

          r = t;
        });
        var s = t ? 10 : 5,
            c = Math.atan2(e[0].y - i.y, e[0].x - i.x),
            u = {
          x: 0,
          y: 0
        };
        return u.x = Math.sin(c) * s + (e[0].x + i.x) / 2, u.y = -Math.cos(c) * s + (e[0].y + i.y) / 2, u;
      },
      calcTerminalLabelPosition: function calcTerminalLabelPosition(t, e, n) {
        var r,
            i = JSON.parse(JSON.stringify(n));
        o.info("our points", i), "start_left" !== e && "start_right" !== e && (i = i.reverse()), i.forEach(function (t) {
          Mv(t, r), r = t;
        });
        var a,
            s = 25 + t;
        r = void 0, i.forEach(function (t) {
          if (r && !a) {
            var e = Mv(t, r);
            if (e < s) s -= e;else {
              var n = s / e;
              n <= 0 && (a = r), n >= 1 && (a = {
                x: t.x,
                y: t.y
              }), n > 0 && n < 1 && (a = {
                x: (1 - n) * r.x + n * t.x,
                y: (1 - n) * r.y + n * t.y
              });
            }
          }

          r = t;
        });
        var c = 10 + .5 * t,
            u = Math.atan2(i[0].y - a.y, i[0].x - a.x),
            l = {
          x: 0,
          y: 0
        };
        return l.x = Math.sin(u) * c + (i[0].x + a.x) / 2, l.y = -Math.cos(u) * c + (i[0].y + a.y) / 2, "start_left" === e && (l.x = Math.sin(u + Math.PI) * c + (i[0].x + a.x) / 2, l.y = -Math.cos(u + Math.PI) * c + (i[0].y + a.y) / 2), "end_right" === e && (l.x = Math.sin(u - Math.PI) * c + (i[0].x + a.x) / 2 - 5, l.y = -Math.cos(u - Math.PI) * c + (i[0].y + a.y) / 2 - 5), "end_left" === e && (l.x = Math.sin(u) * c + (i[0].x + a.x) / 2 - 5, l.y = -Math.cos(u) * c + (i[0].y + a.y) / 2 - 5), l;
      },
      formatUrl: function formatUrl(t, e) {
        var n = t.trim();
        if (n) return "loose" !== e.securityLevel ? (0, Om.sanitizeUrl)(n) : n;
      },
      getStylesFromArray: Nv,
      generateId: Ov,
      random: Bv,
      memoize: Sv,
      runFunc: function runFunc(t) {
        for (var e, n = t.split("."), r = n.length - 1, i = n[r], a = window, o = 0; o < r; o++) {
          if (!(a = a[n[o]])) return;
        }

        for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++) {
          c[u - 1] = arguments[u];
        }

        (e = a)[i].apply(e, c);
      },
      entityDecode: function entityDecode(t) {
        return _v = _v || document.createElement("div"), t = escape(t).replace(/%26/g, "&").replace(/%23/g, "#").replace(/%3B/g, ";"), _v.innerHTML = t, unescape(_v.textContent);
      },
      initIdGeneratior: function () {
        function t(e, n) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.deterministic = e, this.seed = n, this.count = n ? n.length : 0;
        }

        var e, n;
        return e = t, (n = [{
          key: "next",
          value: function value() {
            return this.deterministic ? this.count++ : Date.now();
          }
        }]) && pv(e.prototype, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }(),
      directiveSanitizer: Uv,
      sanitizeCss: qv
    };

    function $v(t) {
      return $v = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, $v(t);
    }

    var Wv,
        Vv = Object.freeze(fv),
        Gv = Lv({}, Vv),
        Xv = [],
        Zv = Lv({}, Vv),
        Qv = function Qv(t, e) {
      for (var n = Lv({}, t), r = {}, i = 0; i < e.length; i++) {
        var a = e[i];
        tb(a), r = Lv(r, a);
      }

      if (n = Lv(n, r), r.theme) {
        var o = Lv({}, Wv),
            s = Lv(o.themeVariables || {}, r.themeVariables);
        n.themeVariables = ov[n.theme].getThemeVariables(s);
      }

      return Zv = n, n;
    },
        Kv = function Kv() {
      return Lv({}, Gv);
    },
        Jv = function Jv() {
      return Lv({}, Zv);
    },
        tb = function t(e) {
      Object.keys(Gv.secure).forEach(function (t) {
        void 0 !== e[Gv.secure[t]] && (o.debug("Denied attempt to modify a secure key ".concat(Gv.secure[t]), e[Gv.secure[t]]), delete e[Gv.secure[t]]);
      }), Object.keys(e).forEach(function (t) {
        0 === t.indexOf("__") && delete e[t];
      }), Object.keys(e).forEach(function (n) {
        "string" == typeof e[n] && (e[n].indexOf("<") > -1 || e[n].indexOf(">") > -1 || e[n].indexOf("url(data:") > -1) && delete e[n], "object" === $v(e[n]) && t(e[n]);
      });
    },
        eb = function eb(t) {
      t.fontFamily && (t.themeVariables && t.themeVariables.fontFamily || (t.themeVariables = {
        fontFamily: t.fontFamily
      })), Xv.push(t), Qv(Gv, Xv);
    },
        nb = function nb() {
      Qv(Gv, Xv = []);
    };

    function rb(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var ib = "classid-",
        ab = [],
        ob = {},
        sb = 0,
        cb = [],
        ub = function ub(t) {
      return Um.sanitizeText(t, Jv());
    },
        lb = function lb(t) {
      var e = "",
          n = t;

      if (t.indexOf("~") > 0) {
        var r = t.split("~");
        n = r[0], e = Um.sanitizeText(r[1], Jv());
      }

      return {
        className: n,
        type: e
      };
    },
        hb = function hb(t) {
      var e = lb(t);
      void 0 === ob[e.className] && (ob[e.className] = {
        id: e.className,
        type: e.type,
        cssClasses: [],
        methods: [],
        members: [],
        annotations: [],
        domId: ib + e.className + "-" + sb
      }, sb++);
    },
        fb = function fb(t) {
      for (var e = Object.keys(ob), n = 0; n < e.length; n++) {
        if (ob[e[n]].id === t) return ob[e[n]].domId;
      }
    },
        db = function db(t, e) {
      var n = lb(t).className,
          r = ob[n];

      if ("string" == typeof e) {
        var i = e.trim();
        i.startsWith("<<") && i.endsWith(">>") ? r.annotations.push(ub(i.substring(2, i.length - 2))) : i.indexOf(")") > 0 ? r.methods.push(ub(i)) : i && r.members.push(ub(i));
      }
    },
        pb = function pb(t, e) {
      t.split(",").forEach(function (t) {
        var n = t;
        t[0].match(/\d/) && (n = ib + n), void 0 !== ob[n] && ob[n].cssClasses.push(e);
      });
    },
        yb = function yb(t, e, n) {
      var r = Jv(),
          i = t,
          a = fb(i);

      if ("loose" === r.securityLevel && void 0 !== e && void 0 !== ob[i]) {
        var o = [];

        if ("string" == typeof n) {
          o = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

          for (var s = 0; s < o.length; s++) {
            var c = o[s].trim();
            '"' === c.charAt(0) && '"' === c.charAt(c.length - 1) && (c = c.substr(1, c.length - 2)), o[s] = c;
          }
        }

        0 === o.length && o.push(a), cb.push(function () {
          var t = document.querySelector('[id="'.concat(a, '"]'));
          null !== t && t.addEventListener("click", function () {
            var t;
            Hv.runFunc.apply(Hv, [e].concat(function (t) {
              if (Array.isArray(t)) return rb(t);
            }(t = o) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return rb(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? rb(t, e) : void 0;
              }
            }(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()));
          }, !1);
        });
      }
    },
        gb = {
      AGGREGATION: 0,
      EXTENSION: 1,
      COMPOSITION: 2,
      DEPENDENCY: 3
    },
        mb = function mb(t) {
      var e = au(".mermaidTooltip");
      null === (e._groups || e)[0][0] && (e = au("body").append("div").attr("class", "mermaidTooltip").style("opacity", 0)), au(t).select("svg").selectAll("g.node").on("mouseover", function () {
        var t = au(this);

        if (null !== t.attr("title")) {
          var n = this.getBoundingClientRect();
          e.transition().duration(200).style("opacity", ".9"), e.html(t.attr("title")).style("left", window.scrollX + n.left + (n.right - n.left) / 2 + "px").style("top", window.scrollY + n.top - 14 + document.body.scrollTop + "px"), t.classed("hover", !0);
        }
      }).on("mouseout", function () {
        e.transition().duration(500).style("opacity", 0), au(this).classed("hover", !1);
      });
    };

    cb.push(mb);
    var vb = "TB";
    var bb = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv()["class"];
      },
      addClass: hb,
      bindFunctions: function bindFunctions(t) {
        cb.forEach(function (e) {
          e(t);
        });
      },
      clear: function clear() {
        ab = [], ob = {}, (cb = []).push(mb);
      },
      getClass: function getClass(t) {
        return ob[t];
      },
      getClasses: function getClasses() {
        return ob;
      },
      addAnnotation: function addAnnotation(t, e) {
        var n = lb(t).className;
        ob[n].annotations.push(e);
      },
      getRelations: function getRelations() {
        return ab;
      },
      addRelation: function addRelation(t) {
        o.debug("Adding relation: " + JSON.stringify(t)), hb(t.id1), hb(t.id2), t.id1 = lb(t.id1).className, t.id2 = lb(t.id2).className, t.relationTitle1 = Um.sanitizeText(t.relationTitle1.trim(), Jv()), t.relationTitle2 = Um.sanitizeText(t.relationTitle2.trim(), Jv()), ab.push(t);
      },
      getDirection: function getDirection() {
        return vb;
      },
      setDirection: function setDirection(t) {
        vb = t;
      },
      addMember: db,
      addMembers: function addMembers(t, e) {
        Array.isArray(e) && (e.reverse(), e.forEach(function (e) {
          return db(t, e);
        }));
      },
      cleanupLabel: function cleanupLabel(t) {
        return ":" === t.substring(0, 1) ? Um.sanitizeText(t.substr(1).trim(), Jv()) : ub(t.trim());
      },
      lineType: {
        LINE: 0,
        DOTTED_LINE: 1
      },
      relationType: gb,
      setClickEvent: function setClickEvent(t, e, n) {
        t.split(",").forEach(function (t) {
          yb(t, e, n), ob[t].haveCallback = !0;
        }), pb(t, "clickable");
      },
      setCssClass: pb,
      setLink: function setLink(t, e, n) {
        var r = Jv();
        t.split(",").forEach(function (t) {
          var i = t;
          t[0].match(/\d/) && (i = ib + i), void 0 !== ob[i] && (ob[i].link = Hv.formatUrl(e, r), "sandbox" === r.securityLevel ? ob[i].linkTarget = "_top" : ob[i].linkTarget = "string" == typeof n ? ub(n) : "_blank");
        }), pb(t, "clickable");
      },
      setTooltip: function setTooltip(t, e) {
        var n = Jv();
        t.split(",").forEach(function (t) {
          void 0 !== e && (ob[t].tooltip = Um.sanitizeText(e, n));
        });
      },
      lookUpDomId: fb
    };

    var _b = n(681),
        xb = n.n(_b),
        wb = n(8282),
        kb = n.n(wb),
        Tb = n(1362),
        Eb = n.n(Tb),
        Cb = 0,
        Sb = function Sb(t) {
      var e = t.match(/^(\+|-|~|#)?(\w+)(~\w+~|\[\])?\s+(\w+) *(\*|\$)?$/),
          n = t.match(/^([+|\-|~|#])?(\w+) *\( *(.*)\) *(\*|\$)? *(\w*[~|[\]]*\s*\w*~?)$/);
      return e && !n ? Ab(e) : n ? Mb(n) : Nb(t);
    },
        Ab = function Ab(t) {
      var e = "",
          n = "";

      try {
        var r = t[1] ? t[1].trim() : "",
            i = t[2] ? t[2].trim() : "",
            a = t[3] ? Ob(t[3].trim()) : "",
            o = t[4] ? t[4].trim() : "",
            s = t[5] ? t[5].trim() : "";
        n = r + i + a + " " + o, e = Bb(s);
      } catch (e) {
        n = t;
      }

      return {
        displayText: n,
        cssStyle: e
      };
    },
        Mb = function Mb(t) {
      var e = "",
          n = "";

      try {
        var r = t[1] ? t[1].trim() : "",
            i = t[2] ? t[2].trim() : "",
            a = t[3] ? Ob(t[3].trim()) : "",
            o = t[4] ? t[4].trim() : "";
        n = r + i + "(" + a + ")" + (t[5] ? " : " + Ob(t[5]).trim() : ""), e = Bb(o);
      } catch (e) {
        n = t;
      }

      return {
        displayText: n,
        cssStyle: e
      };
    },
        Nb = function Nb(t) {
      var e = "",
          n = "",
          r = "",
          i = t.indexOf("("),
          a = t.indexOf(")");

      if (i > 1 && a > i && a <= t.length) {
        var o = "",
            s = "",
            c = t.substring(0, 1);
        c.match(/\w/) ? s = t.substring(0, i).trim() : (c.match(/\+|-|~|#/) && (o = c), s = t.substring(1, i).trim());
        var u = t.substring(i + 1, a),
            l = t.substring(a + 1, 1);
        n = Bb(l), e = o + s + "(" + Ob(u.trim()) + ")", a < "".length && "" !== (r = t.substring(a + 2).trim()) && (r = " : " + Ob(r));
      } else e = Ob(t);

      return {
        displayText: e,
        cssStyle: n
      };
    },
        Db = function Db(t, e, n, r) {
      var i = Sb(e),
          a = t.append("tspan").attr("x", r.padding).text(i.displayText);
      "" !== i.cssStyle && a.attr("style", i.cssStyle), n || a.attr("dy", r.textHeight);
    },
        Ob = function t(e) {
      var n = e;
      return -1 != e.indexOf("~") ? t(n = (n = n.replace("~", "<")).replace("~", ">")) : n;
    },
        Bb = function Bb(t) {
      switch (t) {
        case "*":
          return "font-style:italic;";

        case "$":
          return "text-decoration:underline;";

        default:
          return "";
      }
    };

    var Lb = function Lb(t, e, n) {
      o.info("Rendering class " + e);
      var r,
          i = e.id,
          a = {
        id: i,
        label: e.id,
        width: 0,
        height: 0
      },
          s = t.append("g").attr("id", fb(i)).attr("class", "classGroup");
      r = e.link ? s.append("svg:a").attr("xlink:href", e.link).attr("target", e.linkTarget).append("text").attr("y", n.textHeight + n.padding).attr("x", 0) : s.append("text").attr("y", n.textHeight + n.padding).attr("x", 0);
      var c = !0;
      e.annotations.forEach(function (t) {
        var e = r.append("tspan").text("«" + t + "»");
        c || e.attr("dy", n.textHeight), c = !1;
      });
      var u = e.id;
      void 0 !== e.type && "" !== e.type && (u += "<" + e.type + ">");
      var l = r.append("tspan").text(u).attr("class", "title");
      c || l.attr("dy", n.textHeight);
      var h = r.node().getBBox().height,
          f = s.append("line").attr("x1", 0).attr("y1", n.padding + h + n.dividerMargin / 2).attr("y2", n.padding + h + n.dividerMargin / 2),
          d = s.append("text").attr("x", n.padding).attr("y", h + n.dividerMargin + n.textHeight).attr("fill", "white").attr("class", "classText");
      c = !0, e.members.forEach(function (t) {
        Db(d, t, c, n), c = !1;
      });
      var p = d.node().getBBox(),
          y = s.append("line").attr("x1", 0).attr("y1", n.padding + h + n.dividerMargin + p.height).attr("y2", n.padding + h + n.dividerMargin + p.height),
          g = s.append("text").attr("x", n.padding).attr("y", h + 2 * n.dividerMargin + p.height + n.textHeight).attr("fill", "white").attr("class", "classText");
      c = !0, e.methods.forEach(function (t) {
        Db(g, t, c, n), c = !1;
      });
      var m = s.node().getBBox(),
          v = " ";
      e.cssClasses.length > 0 && (v += e.cssClasses.join(" "));
      var b = s.insert("rect", ":first-child").attr("x", 0).attr("y", 0).attr("width", m.width + 2 * n.padding).attr("height", m.height + n.padding + .5 * n.dividerMargin).attr("class", v).node().getBBox().width;
      return r.node().childNodes.forEach(function (t) {
        t.setAttribute("x", (b - t.getBBox().width) / 2);
      }), e.tooltip && r.insert("title").text(e.tooltip), f.attr("x2", b), y.attr("x2", b), a.width = b, a.height = m.height + n.padding + .5 * n.dividerMargin, a;
    };

    Tb.parser.yy = bb;

    var Ib = {},
        Rb = {
      dividerMargin: 10,
      padding: 5,
      textHeight: 10
    },
        Fb = function Fb(t) {
      var e = Object.entries(Ib).find(function (e) {
        return e[1].label === t;
      });
      if (e) return e[0];
    };

    var Pb = function Pb(t) {
      Object.keys(t).forEach(function (e) {
        Rb[e] = t[e];
      });
    },
        jb = function jb(t, e) {
      Ib = {}, Tb.parser.yy.clear(), Tb.parser.parse(t), o.info("Rendering diagram " + t);
      var n,
          r = Jv().securityLevel;
      "sandbox" === r && (n = au("#i" + e));
      var i,
          a = au("sandbox" === r ? n.nodes()[0].contentDocument.body : "body"),
          s = ("sandbox" === r ? n.nodes()[0].contentDocument : document, a.select("[id='".concat(e, "']")));
      s.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), (i = s).append("defs").append("marker").attr("id", "extensionStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 1,7 L18,13 V 1 Z"), i.append("defs").append("marker").attr("id", "extensionEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 1,1 V 13 L18,7 Z"), i.append("defs").append("marker").attr("id", "compositionStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), i.append("defs").append("marker").attr("id", "compositionEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), i.append("defs").append("marker").attr("id", "aggregationStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), i.append("defs").append("marker").attr("id", "aggregationEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), i.append("defs").append("marker").attr("id", "dependencyStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 5,7 L9,13 L1,7 L9,1 Z"), i.append("defs").append("marker").attr("id", "dependencyEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
      var c = new (kb().Graph)({
        multigraph: !0
      });
      c.setGraph({
        isMultiGraph: !0
      }), c.setDefaultEdgeLabel(function () {
        return {};
      });

      for (var u = bb.getClasses(), l = Object.keys(u), h = 0; h < l.length; h++) {
        var f = u[l[h]],
            d = Lb(s, f, Rb);
        Ib[d.id] = d, c.setNode(d.id, d), o.info("Org height: " + d.height);
      }

      bb.getRelations().forEach(function (t) {
        o.info("tjoho" + Fb(t.id1) + Fb(t.id2) + JSON.stringify(t)), c.setEdge(Fb(t.id1), Fb(t.id2), {
          relation: t
        }, t.title || "DEFAULT");
      }), xb().layout(c), c.nodes().forEach(function (t) {
        void 0 !== t && void 0 !== c.node(t) && (o.debug("Node " + t + ": " + JSON.stringify(c.node(t))), a.select("#" + fb(t)).attr("transform", "translate(" + (c.node(t).x - c.node(t).width / 2) + "," + (c.node(t).y - c.node(t).height / 2) + " )"));
      }), c.edges().forEach(function (t) {
        void 0 !== t && void 0 !== c.edge(t) && (o.debug("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(c.edge(t))), function (t, e, n, r) {
          var i = function i(t) {
            switch (t) {
              case gb.AGGREGATION:
                return "aggregation";

              case gb.EXTENSION:
                return "extension";

              case gb.COMPOSITION:
                return "composition";

              case gb.DEPENDENCY:
                return "dependency";
            }
          };

          e.points = e.points.filter(function (t) {
            return !Number.isNaN(t.y);
          });
          var a,
              s,
              c = e.points,
              u = zu().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          }).curve(Vu),
              l = t.append("path").attr("d", u(c)).attr("id", "edge" + Cb).attr("class", "relation"),
              h = "";
          r.arrowMarkerAbsolute && (h = (h = (h = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), 1 == n.relation.lineType && l.attr("class", "relation dashed-line"), "none" !== n.relation.type1 && l.attr("marker-start", "url(" + h + "#" + i(n.relation.type1) + "Start)"), "none" !== n.relation.type2 && l.attr("marker-end", "url(" + h + "#" + i(n.relation.type2) + "End)");
          var f,
              d,
              p,
              y,
              g = e.points.length,
              m = Hv.calcLabelPosition(e.points);

          if (a = m.x, s = m.y, g % 2 != 0 && g > 1) {
            var v = Hv.calcCardinalityPosition("none" !== n.relation.type1, e.points, e.points[0]),
                b = Hv.calcCardinalityPosition("none" !== n.relation.type2, e.points, e.points[g - 1]);
            o.debug("cardinality_1_point " + JSON.stringify(v)), o.debug("cardinality_2_point " + JSON.stringify(b)), f = v.x, d = v.y, p = b.x, y = b.y;
          }

          if (void 0 !== n.title) {
            var _ = t.append("g").attr("class", "classLabel"),
                x = _.append("text").attr("class", "label").attr("x", a).attr("y", s).attr("fill", "red").attr("text-anchor", "middle").text(n.title);

            window.label = x;
            var w = x.node().getBBox();

            _.insert("rect", ":first-child").attr("class", "box").attr("x", w.x - r.padding / 2).attr("y", w.y - r.padding / 2).attr("width", w.width + r.padding).attr("height", w.height + r.padding);
          }

          o.info("Rendering relation " + JSON.stringify(n)), void 0 !== n.relationTitle1 && "none" !== n.relationTitle1 && t.append("g").attr("class", "cardinality").append("text").attr("class", "type1").attr("x", f).attr("y", d).attr("fill", "black").attr("font-size", "6").text(n.relationTitle1), void 0 !== n.relationTitle2 && "none" !== n.relationTitle2 && t.append("g").attr("class", "cardinality").append("text").attr("class", "type2").attr("x", p).attr("y", y).attr("fill", "black").attr("font-size", "6").text(n.relationTitle2), Cb++;
        }(s, c.edge(t), c.edge(t).relation, Rb));
      });
      var p = s.node().getBBox(),
          y = p.width + 40,
          g = p.height + 40;
      zv(s, g, y, Rb.useMaxWidth);
      var m = "".concat(p.x - 20, " ").concat(p.y - 20, " ").concat(y, " ").concat(g);
      o.debug("viewBox ".concat(m)), s.attr("viewBox", m);
    };

    var Yb = {
      extension: function extension(t, e, n) {
        o.trace("Making markers for ", n), t.append("defs").append("marker").attr("id", e + "-extensionStart").attr("class", "marker extension " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 1,7 L18,13 V 1 Z"), t.append("defs").append("marker").attr("id", e + "-extensionEnd").attr("class", "marker extension " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 1,1 V 13 L18,7 Z");
      },
      composition: function composition(t, e) {
        t.append("defs").append("marker").attr("id", e + "-compositionStart").attr("class", "marker composition " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-compositionEnd").attr("class", "marker composition " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z");
      },
      aggregation: function aggregation(t, e) {
        t.append("defs").append("marker").attr("id", e + "-aggregationStart").attr("class", "marker aggregation " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-aggregationEnd").attr("class", "marker aggregation " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z");
      },
      dependency: function dependency(t, e) {
        t.append("defs").append("marker").attr("id", e + "-dependencyStart").attr("class", "marker dependency " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 5,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-dependencyEnd").attr("class", "marker dependency " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
      },
      point: function point(t, e) {
        t.append("marker").attr("id", e + "-pointEnd").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-pointStart").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 0).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 5 L 10 10 L 10 0 z").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
      },
      circle: function circle(t, e) {
        t.append("marker").attr("id", e + "-circleEnd").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 11).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("circle").attr("cx", "5").attr("cy", "5").attr("r", "5").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-circleStart").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", -1).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("circle").attr("cx", "5").attr("cy", "5").attr("r", "5").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
      },
      cross: function cross(t, e) {
        t.append("marker").attr("id", e + "-crossEnd").attr("class", "marker cross " + e).attr("viewBox", "0 0 11 11").attr("refX", 12).attr("refY", 5.2).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("path").attr("d", "M 1,1 l 9,9 M 10,1 l -9,9").attr("class", "arrowMarkerPath").style("stroke-width", 2).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-crossStart").attr("class", "marker cross " + e).attr("viewBox", "0 0 11 11").attr("refX", -1).attr("refY", 5.2).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("path").attr("d", "M 1,1 l 9,9 M 10,1 l -9,9").attr("class", "arrowMarkerPath").style("stroke-width", 2).style("stroke-dasharray", "1,0");
      },
      barb: function barb(t, e) {
        t.append("defs").append("marker").attr("id", e + "-barbEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 14).attr("markerUnits", "strokeWidth").attr("orient", "auto").append("path").attr("d", "M 19,7 L9,13 L14,7 L9,1 Z");
      }
    };

    var zb = function zb(t, e, n, r) {
      e.forEach(function (e) {
        Yb[e](t, n, r);
      });
    };

    function Ub(t) {
      return Ub = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, Ub(t);
    }

    var qb = function qb(t, e, n, r) {
      var i,
          a,
          s,
          c,
          u,
          l,
          h = t || "";
      if ("object" === Ub(h) && (h = h[0]), zm(Jv().flowchart.htmlLabels)) return h = h.replace(/\\n|\n/g, "<br />"), o.info("vertexText" + h), i = {
        isNode: r,
        label: h.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
          return "<i class='".concat(t.replace(":", " "), "'></i>");
        }),
        labelStyle: e.replace("fill:", "color:")
      }, s = au(document.createElementNS("http://www.w3.org/2000/svg", "foreignObject")), c = s.append("xhtml:div"), u = i.label, l = i.isNode ? "nodeLabel" : "edgeLabel", c.html('<span class="' + l + '" ' + (i.labelStyle ? 'style="' + i.labelStyle + '"' : "") + ">" + u + "</span>"), (a = i.labelStyle) && c.attr("style", a), c.style("display", "inline-block"), c.style("white-space", "nowrap"), c.attr("xmlns", "http://www.w3.org/1999/xhtml"), s.node();
      var f = document.createElementNS("http://www.w3.org/2000/svg", "text");
      f.setAttribute("style", e.replace("color:", "fill:"));
      var d = [];
      d = "string" == typeof h ? h.split(/\\n|\n|<br\s*\/?>/gi) : Array.isArray(h) ? h : [];

      for (var p = 0; p < d.length; p++) {
        var y = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        y.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), y.setAttribute("dy", "1em"), y.setAttribute("x", "0"), n ? y.setAttribute("class", "title-row") : y.setAttribute("class", "row"), y.textContent = d[p].trim(), f.appendChild(y);
      }

      return f;
    };

    var Hb = function Hb(t, e, n, r) {
      var i;
      i = n || "node default";
      var a = t.insert("g").attr("class", i).attr("id", e.domId || e.id),
          o = a.insert("g").attr("class", "label").attr("style", e.labelStyle),
          s = "string" == typeof e.labelText ? e.labelText : e.labelText[0],
          c = o.node().appendChild(qb(Fm(aC(s), Jv()), e.labelStyle, !1, r)),
          u = c.getBBox();

      if (zm(Jv().flowchart.htmlLabels)) {
        var l = c.children[0],
            h = au(c);
        u = l.getBoundingClientRect(), h.attr("width", u.width), h.attr("height", u.height);
      }

      var f = e.padding / 2;
      return o.attr("transform", "translate(" + -u.width / 2 + ", " + -u.height / 2 + ")"), {
        shapeSvg: a,
        bbox: u,
        halfPadding: f,
        label: o
      };
    },
        $b = function $b(t, e) {
      var n = e.node().getBBox();
      t.width = n.width, t.height = n.height;
    };

    function Wb(t, e, n, r) {
      return t.insert("polygon", ":first-child").attr("points", r.map(function (t) {
        return t.x + "," + t.y;
      }).join(" ")).attr("class", "label-container").attr("transform", "translate(" + -e / 2 + "," + n / 2 + ")");
    }

    var Vb = {},
        Gb = {},
        Xb = {},
        Zb = function Zb(t, e) {
      return o.trace("In isDecendant", e, " ", t, " = ", Gb[e].indexOf(t) >= 0), Gb[e].indexOf(t) >= 0;
    },
        Qb = function t(e, n, r, i) {
      o.warn("Copying children of ", e, "root", i, "data", n.node(e), i);
      var a = n.children(e) || [];
      e !== i && a.push(e), o.warn("Copying (nodes) clusterId", e, "nodes", a), a.forEach(function (a) {
        if (n.children(a).length > 0) t(a, n, r, i);else {
          var s = n.node(a);
          o.info("cp ", a, " to ", i, " with parent ", e), r.setNode(a, s), i !== n.parent(a) && (o.warn("Setting parent", a, n.parent(a)), r.setParent(a, n.parent(a))), e !== i && a !== e ? (o.debug("Setting parent", a, e), r.setParent(a, e)) : (o.info("In copy ", e, "root", i, "data", n.node(e), i), o.debug("Not Setting parent for node=", a, "cluster!==rootId", e !== i, "node!==clusterId", a !== e));
          var c = n.edges(a);
          o.debug("Copying Edges", c), c.forEach(function (t) {
            o.info("Edge", t);
            var a = n.edge(t.v, t.w, t.name);
            o.info("Edge data", a, i);

            try {
              !function (t, e) {
                return o.info("Decendants of ", e, " is ", Gb[e]), o.info("Edge is ", t), t.v !== e && t.w !== e && (Gb[e] ? (o.info("Here "), Gb[e].indexOf(t.v) >= 0 || !!Zb(t.v, e) || !!Zb(t.w, e) || Gb[e].indexOf(t.w) >= 0) : (o.debug("Tilt, ", e, ",not in decendants"), !1));
              }(t, i) ? o.info("Skipping copy of edge ", t.v, "--\x3e", t.w, " rootId: ", i, " clusterId:", e) : (o.info("Copying as ", t.v, t.w, a, t.name), r.setEdge(t.v, t.w, a, t.name), o.info("newGraph edges ", r.edges(), r.edge(r.edges()[0])));
            } catch (t) {
              o.error(t);
            }
          });
        }
        o.debug("Removing node", a), n.removeNode(a);
      });
    },
        Kb = function t(e, n) {
      for (var r = n.children(e), i = [].concat(r), a = 0; a < r.length; a++) {
        Xb[r[a]] = e, i = i.concat(t(r[a], n));
      }

      return i;
    },
        Jb = function t(e, n) {
      o.trace("Searching", e);
      var r = n.children(e);
      if (o.trace("Searching children of id ", e, r), r.length < 1) return o.trace("This is a valid node", e), e;

      for (var i = 0; i < r.length; i++) {
        var a = t(r[i], n);
        if (a) return o.trace("Found replacement for", e, " => ", a), a;
      }
    },
        t_ = function t_(t) {
      return Vb[t] && Vb[t].externalConnections && Vb[t] ? Vb[t].id : t;
    },
        e_ = function e_(t, e) {
      !t || e > 10 ? o.debug("Opting out, no graph ") : (o.debug("Opting in, graph "), t.nodes().forEach(function (e) {
        t.children(e).length > 0 && (o.warn("Cluster identified", e, " Replacement id in edges: ", Jb(e, t)), Gb[e] = Kb(e, t), Vb[e] = {
          id: Jb(e, t),
          clusterData: t.node(e)
        });
      }), t.nodes().forEach(function (e) {
        var n = t.children(e),
            r = t.edges();
        n.length > 0 ? (o.debug("Cluster identified", e, Gb), r.forEach(function (t) {
          t.v !== e && t.w !== e && Zb(t.v, e) ^ Zb(t.w, e) && (o.warn("Edge: ", t, " leaves cluster ", e), o.warn("Decendants of XXX ", e, ": ", Gb[e]), Vb[e].externalConnections = !0);
        })) : o.debug("Not a cluster ", e, Gb);
      }), t.edges().forEach(function (e) {
        var n = t.edge(e);
        o.warn("Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(e)), o.warn("Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(t.edge(e)));
        var r = e.v,
            i = e.w;
        o.warn("Fix XXX", Vb, "ids:", e.v, e.w, "Translateing: ", Vb[e.v], " --- ", Vb[e.w]), (Vb[e.v] || Vb[e.w]) && (o.warn("Fixing and trixing - removing XXX", e.v, e.w, e.name), r = t_(e.v), i = t_(e.w), t.removeEdge(e.v, e.w, e.name), r !== e.v && (n.fromCluster = e.v), i !== e.w && (n.toCluster = e.w), o.warn("Fix Replacing with XXX", r, i, e.name), t.setEdge(r, i, n, e.name));
      }), o.warn("Adjusted Graph", kb().json.write(t)), n_(t, 0), o.trace(Vb));
    },
        n_ = function t(e, n) {
      if (o.warn("extractor - ", n, kb().json.write(e), e.children("D")), n > 10) o.error("Bailing out");else {
        for (var r = e.nodes(), i = !1, a = 0; a < r.length; a++) {
          var s = r[a],
              c = e.children(s);
          i = i || c.length > 0;
        }

        if (i) {
          o.debug("Nodes = ", r, n);

          for (var u = 0; u < r.length; u++) {
            var l = r[u];
            if (o.debug("Extracting node", l, Vb, Vb[l] && !Vb[l].externalConnections, !e.parent(l), e.node(l), e.children("D"), " Depth ", n), Vb[l]) {
              if (!Vb[l].externalConnections && e.children(l) && e.children(l).length > 0) {
                o.warn("Cluster without external connections, without a parent and with children", l, n);
                var h = "TB" === e.graph().rankdir ? "LR" : "TB";
                Vb[l] && Vb[l].clusterData && Vb[l].clusterData.dir && (h = Vb[l].clusterData.dir, o.warn("Fixing dir", Vb[l].clusterData.dir, h));
                var f = new (kb().Graph)({
                  multigraph: !0,
                  compound: !0
                }).setGraph({
                  rankdir: h,
                  nodesep: 50,
                  ranksep: 50,
                  marginx: 8,
                  marginy: 8
                }).setDefaultEdgeLabel(function () {
                  return {};
                });
                o.warn("Old graph before copy", kb().json.write(e)), Qb(l, e, f, l), e.setNode(l, {
                  clusterNode: !0,
                  id: l,
                  clusterData: Vb[l].clusterData,
                  labelText: Vb[l].labelText,
                  graph: f
                }), o.warn("New graph after copy node: (", l, ")", kb().json.write(f)), o.debug("Old graph after copy", kb().json.write(e));
              } else o.warn("Cluster ** ", l, " **not meeting the criteria !externalConnections:", !Vb[l].externalConnections, " no parent: ", !e.parent(l), " children ", e.children(l) && e.children(l).length > 0, e.children("D"), n), o.debug(Vb);
            } else o.debug("Not a cluster", l, n);
          }

          r = e.nodes(), o.warn("New list of nodes", r);

          for (var d = 0; d < r.length; d++) {
            var p = r[d],
                y = e.node(p);
            o.warn(" Now next level", p, y), y.clusterNode && t(y.graph, n + 1);
          }
        } else o.debug("Done, no node has children", e.nodes());
      }
    },
        r_ = function t(e, n) {
      if (0 === n.length) return [];
      var r = Object.assign(n);
      return n.forEach(function (n) {
        var i = e.children(n),
            a = t(e, i);
        r = r.concat(a);
      }), r;
    },
        i_ = function i_(t) {
      return r_(t, t.children());
    },
        a_ = n(3841);

    var o_ = function o_(t, e, n, r) {
      var i = t.x,
          a = t.y,
          o = i - r.x,
          s = a - r.y,
          c = Math.sqrt(e * e * s * s + n * n * o * o),
          u = Math.abs(e * n * o / c);
      r.x < i && (u = -u);
      var l = Math.abs(e * n * s / c);
      return r.y < a && (l = -l), {
        x: i + u,
        y: a + l
      };
    };

    function s_(t, e) {
      return t * e > 0;
    }

    var c_ = function c_(t, e, n, r) {
      var i, a, o, s, c, u, l, h, f, d, p, y, g;
      if (i = e.y - t.y, o = t.x - e.x, c = e.x * t.y - t.x * e.y, f = i * n.x + o * n.y + c, d = i * r.x + o * r.y + c, !(0 !== f && 0 !== d && s_(f, d) || (a = r.y - n.y, s = n.x - r.x, u = r.x * n.y - n.x * r.y, l = a * t.x + s * t.y + u, h = a * e.x + s * e.y + u, 0 !== l && 0 !== h && s_(l, h) || 0 == (p = i * s - a * o)))) return y = Math.abs(p / 2), {
        x: (g = o * u - s * c) < 0 ? (g - y) / p : (g + y) / p,
        y: (g = a * c - i * u) < 0 ? (g - y) / p : (g + y) / p
      };
    },
        u_ = function u_(t, e) {
      var n,
          r,
          i = t.x,
          a = t.y,
          o = e.x - i,
          s = e.y - a,
          c = t.width / 2,
          u = t.height / 2;
      return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = 0 === s ? 0 : u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = 0 === o ? 0 : c * s / o), {
        x: i + n,
        y: a + r
      };
    },
        l_ = (n.n(a_)(), function (t, e, n) {
      return o_(t, e, e, n);
    }),
        h_ = function h_(t, e, n) {
      var r = t.x,
          i = t.y,
          a = [],
          o = Number.POSITIVE_INFINITY,
          s = Number.POSITIVE_INFINITY;
      "function" == typeof e.forEach ? e.forEach(function (t) {
        o = Math.min(o, t.x), s = Math.min(s, t.y);
      }) : (o = Math.min(o, e.x), s = Math.min(s, e.y));

      for (var c = r - t.width / 2 - o, u = i - t.height / 2 - s, l = 0; l < e.length; l++) {
        var h = e[l],
            f = e[l < e.length - 1 ? l + 1 : 0],
            d = c_(t, n, {
          x: c + h.x,
          y: u + h.y
        }, {
          x: c + f.x,
          y: u + f.y
        });
        d && a.push(d);
      }

      return a.length ? (a.length > 1 && a.sort(function (t, e) {
        var r = t.x - n.x,
            i = t.y - n.y,
            a = Math.sqrt(r * r + i * i),
            o = e.x - n.x,
            s = e.y - n.y,
            c = Math.sqrt(o * o + s * s);
        return a < c ? -1 : a === c ? 0 : 1;
      }), a[0]) : t;
    },
        f_ = u_;

    function d_(t) {
      return d_ = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, d_(t);
    }

    var p_ = function p_(t, e, n) {
      var r = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
          i = 70,
          a = 10;
      "LR" === n && (i = 10, a = 70);
      var o = r.append("rect").attr("x", -1 * i / 2).attr("y", -1 * a / 2).attr("width", i).attr("height", a).attr("class", "fork-join");
      return $b(e, o), e.height = e.height + e.padding / 2, e.width = e.width + e.padding / 2, e.intersect = function (t) {
        return f_(e, t);
      }, r;
    },
        y_ = {
      question: function question(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding + (i.height + e.padding),
            s = [{
          x: a / 2,
          y: 0
        }, {
          x: a,
          y: -a / 2
        }, {
          x: a / 2,
          y: -a
        }, {
          x: 0,
          y: -a / 2
        }];
        o.info("Question main (Circle)");
        var c = Wb(r, a, a, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return o.warn("Intersect called"), h_(e, s, t);
        }, r;
      },
      rect: function rect(t, e) {
        var n = Hb(t, e, "node " + e.classes, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = n.halfPadding;
        o.trace("Classes = ", e.classes);
        var s = r.insert("rect", ":first-child"),
            c = i.width + e.padding,
            u = i.height + e.padding;

        if (s.attr("class", "basic label-container").attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("x", -i.width / 2 - a).attr("y", -i.height / 2 - a).attr("width", c).attr("height", u), e.props) {
          var l = new Set(Object.keys(e.props));
          e.props.borders && (function (t, e, n, r) {
            var i = [],
                a = function a(t) {
              i.push(t), i.push(0);
            },
                s = function s(t) {
              i.push(0), i.push(t);
            };

            e.includes("t") ? (o.debug("add top border"), a(n)) : s(n), e.includes("r") ? (o.debug("add right border"), a(r)) : s(r), e.includes("b") ? (o.debug("add bottom border"), a(n)) : s(n), e.includes("l") ? (o.debug("add left border"), a(r)) : s(r), t.attr("stroke-dasharray", i.join(" "));
          }(s, e.props.borders, c, u), l["delete"]("borders")), l.forEach(function (t) {
            o.warn("Unknown node property ".concat(t));
          });
        }

        return $b(e, s), e.intersect = function (t) {
          return f_(e, t);
        }, r;
      },
      rectWithTitle: function rectWithTitle(t, e) {
        var n;
        n = e.classes ? "node " + e.classes : "node default";
        var r,
            i = t.insert("g").attr("class", n).attr("id", e.domId || e.id),
            a = i.insert("rect", ":first-child"),
            s = i.insert("line"),
            c = i.insert("g").attr("class", "label"),
            u = e.labelText.flat ? e.labelText.flat() : e.labelText;
        r = "object" === d_(u) ? u[0] : u, o.info("Label text abc79", r, u, "object" === d_(u));
        var l = c.node().appendChild(qb(r, e.labelStyle, !0, !0)),
            h = {
          width: 0,
          height: 0
        };

        if (zm(Jv().flowchart.htmlLabels)) {
          var f = l.children[0],
              d = au(l);
          h = f.getBoundingClientRect(), d.attr("width", h.width), d.attr("height", h.height);
        }

        o.info("Text 2", u);
        var p = u.slice(1, u.length),
            y = l.getBBox(),
            g = c.node().appendChild(qb(p.join ? p.join("<br/>") : p, e.labelStyle, !0, !0));

        if (zm(Jv().flowchart.htmlLabels)) {
          var m = g.children[0],
              v = au(g);
          h = m.getBoundingClientRect(), v.attr("width", h.width), v.attr("height", h.height);
        }

        var b = e.padding / 2;
        return au(g).attr("transform", "translate( " + (h.width > y.width ? 0 : (y.width - h.width) / 2) + ", " + (y.height + b + 5) + ")"), au(l).attr("transform", "translate( " + (h.width < y.width ? 0 : -(y.width - h.width) / 2) + ", 0)"), h = c.node().getBBox(), c.attr("transform", "translate(" + -h.width / 2 + ", " + (-h.height / 2 - b + 3) + ")"), a.attr("class", "outer title-state").attr("x", -h.width / 2 - b).attr("y", -h.height / 2 - b).attr("width", h.width + e.padding).attr("height", h.height + e.padding), s.attr("class", "divider").attr("x1", -h.width / 2 - b).attr("x2", h.width / 2 + b).attr("y1", -h.height / 2 - b + y.height + b).attr("y2", -h.height / 2 - b + y.height + b), $b(e, a), e.intersect = function (t) {
          return f_(e, t);
        }, i;
      },
      choice: function choice(t, e) {
        var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id);
        return n.insert("polygon", ":first-child").attr("points", [{
          x: 0,
          y: 14
        }, {
          x: 14,
          y: 0
        }, {
          x: 0,
          y: -14
        }, {
          x: -14,
          y: 0
        }].map(function (t) {
          return t.x + "," + t.y;
        }).join(" ")).attr("class", "state-start").attr("r", 7).attr("width", 28).attr("height", 28), e.width = 28, e.height = 28, e.intersect = function (t) {
          return l_(e, 14, t);
        }, n;
      },
      circle: function circle(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = n.halfPadding,
            s = r.insert("circle", ":first-child");
        return s.attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("r", i.width / 2 + a).attr("width", i.width + e.padding).attr("height", i.height + e.padding), o.info("Circle main"), $b(e, s), e.intersect = function (t) {
          return o.info("Circle intersect", e, i.width / 2 + a, t), l_(e, i.width / 2 + a, t);
        }, r;
      },
      stadium: function stadium(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.height + e.padding,
            o = i.width + a / 4 + e.padding,
            s = r.insert("rect", ":first-child").attr("style", e.style).attr("rx", a / 2).attr("ry", a / 2).attr("x", -o / 2).attr("y", -a / 2).attr("width", o).attr("height", a);
        return $b(e, s), e.intersect = function (t) {
          return f_(e, t);
        }, r;
      },
      hexagon: function hexagon(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.height + e.padding,
            o = a / 4,
            s = i.width + 2 * o + e.padding,
            c = [{
          x: o,
          y: 0
        }, {
          x: s - o,
          y: 0
        }, {
          x: s,
          y: -a / 2
        }, {
          x: s - o,
          y: -a
        }, {
          x: o,
          y: -a
        }, {
          x: 0,
          y: -a / 2
        }],
            u = Wb(r, s, a, c);
        return u.attr("style", e.style), $b(e, u), e.intersect = function (t) {
          return h_(e, c, t);
        }, r;
      },
      rect_left_inv_arrow: function rect_left_inv_arrow(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: -o / 2,
          y: 0
        }, {
          x: a,
          y: 0
        }, {
          x: a,
          y: -o
        }, {
          x: -o / 2,
          y: -o
        }, {
          x: 0,
          y: -o / 2
        }];
        return Wb(r, a, o, s).attr("style", e.style), e.width = a + o, e.height = o, e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      lean_right: function lean_right(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: -2 * o / 6,
          y: 0
        }, {
          x: a - o / 6,
          y: 0
        }, {
          x: a + 2 * o / 6,
          y: -o
        }, {
          x: o / 6,
          y: -o
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      lean_left: function lean_left(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: 2 * o / 6,
          y: 0
        }, {
          x: a + o / 6,
          y: 0
        }, {
          x: a - 2 * o / 6,
          y: -o
        }, {
          x: -o / 6,
          y: -o
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      trapezoid: function trapezoid(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: -2 * o / 6,
          y: 0
        }, {
          x: a + 2 * o / 6,
          y: 0
        }, {
          x: a - o / 6,
          y: -o
        }, {
          x: o / 6,
          y: -o
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      inv_trapezoid: function inv_trapezoid(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: o / 6,
          y: 0
        }, {
          x: a - o / 6,
          y: 0
        }, {
          x: a + 2 * o / 6,
          y: -o
        }, {
          x: -2 * o / 6,
          y: -o
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      rect_right_inv_arrow: function rect_right_inv_arrow(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: 0,
          y: 0
        }, {
          x: a + o / 2,
          y: 0
        }, {
          x: a,
          y: -o / 2
        }, {
          x: a + o / 2,
          y: -o
        }, {
          x: 0,
          y: -o
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      cylinder: function cylinder(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = a / 2,
            s = o / (2.5 + a / 50),
            c = i.height + s + e.padding,
            u = "M 0," + s + " a " + o + "," + s + " 0,0,0 " + a + " 0 a " + o + "," + s + " 0,0,0 " + -a + " 0 l 0," + c + " a " + o + "," + s + " 0,0,0 " + a + " 0 l 0," + -c,
            l = r.attr("label-offset-y", s).insert("path", ":first-child").attr("style", e.style).attr("d", u).attr("transform", "translate(" + -a / 2 + "," + -(c / 2 + s) + ")");
        return $b(e, l), e.intersect = function (t) {
          var n = f_(e, t),
              r = n.x - e.x;

          if (0 != o && (Math.abs(r) < e.width / 2 || Math.abs(r) == e.width / 2 && Math.abs(n.y - e.y) > e.height / 2 - s)) {
            var i = s * s * (1 - r * r / (o * o));
            0 != i && (i = Math.sqrt(i)), i = s - i, t.y - e.y > 0 && (i = -i), n.y += i;
          }

          return n;
        }, r;
      },
      start: function start(t, e) {
        var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
            r = n.insert("circle", ":first-child");
        return r.attr("class", "state-start").attr("r", 7).attr("width", 14).attr("height", 14), $b(e, r), e.intersect = function (t) {
          return l_(e, 7, t);
        }, n;
      },
      end: function end(t, e) {
        var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
            r = n.insert("circle", ":first-child"),
            i = n.insert("circle", ":first-child");
        return i.attr("class", "state-start").attr("r", 7).attr("width", 14).attr("height", 14), r.attr("class", "state-end").attr("r", 5).attr("width", 10).attr("height", 10), $b(e, i), e.intersect = function (t) {
          return l_(e, 7, t);
        }, n;
      },
      note: function note(t, e) {
        var n = Hb(t, e, "node " + e.classes, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = n.halfPadding;
        o.info("Classes = ", e.classes);
        var s = r.insert("rect", ":first-child");
        return s.attr("rx", e.rx).attr("ry", e.ry).attr("x", -i.width / 2 - a).attr("y", -i.height / 2 - a).attr("width", i.width + e.padding).attr("height", i.height + e.padding), $b(e, s), e.intersect = function (t) {
          return f_(e, t);
        }, r;
      },
      subroutine: function subroutine(t, e) {
        var n = Hb(t, e, void 0, !0),
            r = n.shapeSvg,
            i = n.bbox,
            a = i.width + e.padding,
            o = i.height + e.padding,
            s = [{
          x: 0,
          y: 0
        }, {
          x: a,
          y: 0
        }, {
          x: a,
          y: -o
        }, {
          x: 0,
          y: -o
        }, {
          x: 0,
          y: 0
        }, {
          x: -8,
          y: 0
        }, {
          x: a + 8,
          y: 0
        }, {
          x: a + 8,
          y: -o
        }, {
          x: -8,
          y: -o
        }, {
          x: -8,
          y: 0
        }],
            c = Wb(r, a, o, s);
        return c.attr("style", e.style), $b(e, c), e.intersect = function (t) {
          return h_(e, s, t);
        }, r;
      },
      fork: p_,
      join: p_,
      class_box: function class_box(t, e) {
        var n,
            r = e.padding / 2;
        n = e.classes ? "node " + e.classes : "node default";
        var i = t.insert("g").attr("class", n).attr("id", e.domId || e.id),
            a = i.insert("rect", ":first-child"),
            o = i.insert("line"),
            s = i.insert("line"),
            c = 0,
            u = 4,
            l = i.insert("g").attr("class", "label"),
            h = 0,
            f = e.classData.annotations && e.classData.annotations[0],
            d = e.classData.annotations[0] ? "«" + e.classData.annotations[0] + "»" : "",
            p = l.node().appendChild(qb(d, e.labelStyle, !0, !0)),
            y = p.getBBox();

        if (zm(Jv().flowchart.htmlLabels)) {
          var g = p.children[0],
              m = au(p);
          y = g.getBoundingClientRect(), m.attr("width", y.width), m.attr("height", y.height);
        }

        e.classData.annotations[0] && (u += y.height + 4, c += y.width);
        var v = e.classData.id;
        void 0 !== e.classData.type && "" !== e.classData.type && (Jv().flowchart.htmlLabels ? v += "&lt;" + e.classData.type + "&gt;" : v += "<" + e.classData.type + ">");
        var b = l.node().appendChild(qb(v, e.labelStyle, !0, !0));
        au(b).attr("class", "classTitle");

        var _ = b.getBBox();

        if (zm(Jv().flowchart.htmlLabels)) {
          var x = b.children[0],
              w = au(b);
          _ = x.getBoundingClientRect(), w.attr("width", _.width), w.attr("height", _.height);
        }

        u += _.height + 4, _.width > c && (c = _.width);
        var k = [];
        e.classData.members.forEach(function (t) {
          var n = Sb(t),
              r = n.displayText;
          Jv().flowchart.htmlLabels && (r = r.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
          var i = l.node().appendChild(qb(r, n.cssStyle ? n.cssStyle : e.labelStyle, !0, !0)),
              a = i.getBBox();

          if (zm(Jv().flowchart.htmlLabels)) {
            var o = i.children[0],
                s = au(i);
            a = o.getBoundingClientRect(), s.attr("width", a.width), s.attr("height", a.height);
          }

          a.width > c && (c = a.width), u += a.height + 4, k.push(i);
        }), u += 8;
        var T = [];

        if (e.classData.methods.forEach(function (t) {
          var n = Sb(t),
              r = n.displayText;
          Jv().flowchart.htmlLabels && (r = r.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
          var i = l.node().appendChild(qb(r, n.cssStyle ? n.cssStyle : e.labelStyle, !0, !0)),
              a = i.getBBox();

          if (zm(Jv().flowchart.htmlLabels)) {
            var o = i.children[0],
                s = au(i);
            a = o.getBoundingClientRect(), s.attr("width", a.width), s.attr("height", a.height);
          }

          a.width > c && (c = a.width), u += a.height + 4, T.push(i);
        }), u += 8, f) {
          var E = (c - y.width) / 2;
          au(p).attr("transform", "translate( " + (-1 * c / 2 + E) + ", " + -1 * u / 2 + ")"), h = y.height + 4;
        }

        var C = (c - _.width) / 2;
        return au(b).attr("transform", "translate( " + (-1 * c / 2 + C) + ", " + (-1 * u / 2 + h) + ")"), h += _.height + 4, o.attr("class", "divider").attr("x1", -c / 2 - r).attr("x2", c / 2 + r).attr("y1", -u / 2 - r + 8 + h).attr("y2", -u / 2 - r + 8 + h), h += 8, k.forEach(function (t) {
          au(t).attr("transform", "translate( " + -c / 2 + ", " + (-1 * u / 2 + h + 4) + ")"), h += _.height + 4;
        }), h += 8, s.attr("class", "divider").attr("x1", -c / 2 - r).attr("x2", c / 2 + r).attr("y1", -u / 2 - r + 8 + h).attr("y2", -u / 2 - r + 8 + h), h += 8, T.forEach(function (t) {
          au(t).attr("transform", "translate( " + -c / 2 + ", " + (-1 * u / 2 + h) + ")"), h += _.height + 4;
        }), a.attr("class", "outer title-state").attr("x", -c / 2 - r).attr("y", -u / 2 - r).attr("width", c + e.padding).attr("height", u + e.padding), $b(e, a), e.intersect = function (t) {
          return f_(e, t);
        }, i;
      }
    },
        g_ = {},
        m_ = function m_(t) {
      var e = g_[t.id];
      o.trace("Transforming node", t.diff, t, "translate(" + (t.x - t.width / 2 - 5) + ", " + t.width / 2 + ")");
      var n = t.diff || 0;
      return t.clusterNode ? e.attr("transform", "translate(" + (t.x + n - t.width / 2) + ", " + (t.y - t.height / 2 - 8) + ")") : e.attr("transform", "translate(" + t.x + ", " + t.y + ")"), n;
    },
        v_ = {
      rect: function rect(t, e) {
        o.trace("Creating subgraph rect for ", e.id, e);
        var n = t.insert("g").attr("class", "cluster" + (e["class"] ? " " + e["class"] : "")).attr("id", e.id),
            r = n.insert("rect", ":first-child"),
            i = n.insert("g").attr("class", "cluster-label"),
            a = i.node().appendChild(qb(e.labelText, e.labelStyle, void 0, !0)),
            s = a.getBBox();

        if (zm(Jv().flowchart.htmlLabels)) {
          var c = a.children[0],
              u = au(a);
          s = c.getBoundingClientRect(), u.attr("width", s.width), u.attr("height", s.height);
        }

        var l = 0 * e.padding,
            h = l / 2,
            f = e.width <= s.width + l ? s.width + l : e.width;
        e.width <= s.width + l ? e.diff = (s.width - e.width) / 2 : e.diff = -e.padding / 2, o.trace("Data ", e, JSON.stringify(e)), r.attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("x", e.x - f / 2).attr("y", e.y - e.height / 2 - h).attr("width", f).attr("height", e.height + l), i.attr("transform", "translate(" + (e.x - s.width / 2) + ", " + (e.y - e.height / 2 + e.padding / 3) + ")");
        var d = r.node().getBBox();
        return e.width = d.width, e.height = d.height, e.intersect = function (t) {
          return u_(e, t);
        }, n;
      },
      roundedWithTitle: function roundedWithTitle(t, e) {
        var n = t.insert("g").attr("class", e.classes).attr("id", e.id),
            r = n.insert("rect", ":first-child"),
            i = n.insert("g").attr("class", "cluster-label"),
            a = n.append("rect"),
            o = i.node().appendChild(qb(e.labelText, e.labelStyle, void 0, !0)),
            s = o.getBBox();

        if (zm(Jv().flowchart.htmlLabels)) {
          var c = o.children[0],
              u = au(o);
          s = c.getBoundingClientRect(), u.attr("width", s.width), u.attr("height", s.height);
        }

        s = o.getBBox();
        var l = 0 * e.padding,
            h = l / 2,
            f = e.width <= s.width + e.padding ? s.width + e.padding : e.width;
        e.width <= s.width + e.padding ? e.diff = (s.width + 0 * e.padding - e.width) / 2 : e.diff = -e.padding / 2, r.attr("class", "outer").attr("x", e.x - f / 2 - h).attr("y", e.y - e.height / 2 - h).attr("width", f + l).attr("height", e.height + l), a.attr("class", "inner").attr("x", e.x - f / 2 - h).attr("y", e.y - e.height / 2 - h + s.height - 1).attr("width", f + l).attr("height", e.height + l - s.height - 3), i.attr("transform", "translate(" + (e.x - s.width / 2) + ", " + (e.y - e.height / 2 - e.padding / 3 + (zm(Jv().flowchart.htmlLabels) ? 5 : 3)) + ")");
        var d = r.node().getBBox();
        return e.height = d.height, e.intersect = function (t) {
          return u_(e, t);
        }, n;
      },
      noteGroup: function noteGroup(t, e) {
        var n = t.insert("g").attr("class", "note-cluster").attr("id", e.id),
            r = n.insert("rect", ":first-child"),
            i = 0 * e.padding,
            a = i / 2;
        r.attr("rx", e.rx).attr("ry", e.ry).attr("x", e.x - e.width / 2 - a).attr("y", e.y - e.height / 2 - a).attr("width", e.width + i).attr("height", e.height + i).attr("fill", "none");
        var o = r.node().getBBox();
        return e.width = o.width, e.height = o.height, e.intersect = function (t) {
          return u_(e, t);
        }, n;
      },
      divider: function divider(t, e) {
        var n = t.insert("g").attr("class", e.classes).attr("id", e.id),
            r = n.insert("rect", ":first-child"),
            i = 0 * e.padding,
            a = i / 2;
        r.attr("class", "divider").attr("x", e.x - e.width / 2 - a).attr("y", e.y - e.height / 2).attr("width", e.width + i).attr("height", e.height + i);
        var o = r.node().getBBox();
        return e.width = o.width, e.height = o.height, e.diff = -e.padding / 2, e.intersect = function (t) {
          return u_(e, t);
        }, n;
      }
    },
        b_ = {},
        __ = {},
        x_ = {},
        w_ = function w_(t, e) {
      var n = qb(e.label, e.labelStyle),
          r = t.insert("g").attr("class", "edgeLabel"),
          i = r.insert("g").attr("class", "label");
      i.node().appendChild(n);
      var a,
          o = n.getBBox();

      if (zm(Jv().flowchart.htmlLabels)) {
        var s = n.children[0],
            c = au(n);
        o = s.getBoundingClientRect(), c.attr("width", o.width), c.attr("height", o.height);
      }

      if (i.attr("transform", "translate(" + -o.width / 2 + ", " + -o.height / 2 + ")"), __[e.id] = r, e.width = o.width, e.height = o.height, e.startLabelLeft) {
        var u = qb(e.startLabelLeft, e.labelStyle),
            l = t.insert("g").attr("class", "edgeTerminals"),
            h = l.insert("g").attr("class", "inner");
        a = h.node().appendChild(u);
        var f = u.getBBox();
        h.attr("transform", "translate(" + -f.width / 2 + ", " + -f.height / 2 + ")"), x_[e.id] || (x_[e.id] = {}), x_[e.id].startLeft = l, k_(a, e.startLabelLeft);
      }

      if (e.startLabelRight) {
        var d = qb(e.startLabelRight, e.labelStyle),
            p = t.insert("g").attr("class", "edgeTerminals"),
            y = p.insert("g").attr("class", "inner");
        a = p.node().appendChild(d), y.node().appendChild(d);
        var g = d.getBBox();
        y.attr("transform", "translate(" + -g.width / 2 + ", " + -g.height / 2 + ")"), x_[e.id] || (x_[e.id] = {}), x_[e.id].startRight = p, k_(a, e.startLabelRight);
      }

      if (e.endLabelLeft) {
        var m = qb(e.endLabelLeft, e.labelStyle),
            v = t.insert("g").attr("class", "edgeTerminals"),
            b = v.insert("g").attr("class", "inner");
        a = b.node().appendChild(m);

        var _ = m.getBBox();

        b.attr("transform", "translate(" + -_.width / 2 + ", " + -_.height / 2 + ")"), v.node().appendChild(m), x_[e.id] || (x_[e.id] = {}), x_[e.id].endLeft = v, k_(a, e.endLabelLeft);
      }

      if (e.endLabelRight) {
        var x = qb(e.endLabelRight, e.labelStyle),
            w = t.insert("g").attr("class", "edgeTerminals"),
            k = w.insert("g").attr("class", "inner");
        a = k.node().appendChild(x);
        var T = x.getBBox();
        k.attr("transform", "translate(" + -T.width / 2 + ", " + -T.height / 2 + ")"), w.node().appendChild(x), x_[e.id] || (x_[e.id] = {}), x_[e.id].endRight = w, k_(a, e.endLabelRight);
      }
    };

    function k_(t, e) {
      Jv().flowchart.htmlLabels && t && (t.style.width = 9 * e.length + "px", t.style.height = "12px");
    }

    var T_ = function T_(t, e) {
      o.info("Moving label abc78 ", t.id, t.label, __[t.id]);
      var n = e.updatedPath ? e.updatedPath : e.originalPath;

      if (t.label) {
        var r = __[t.id],
            i = t.x,
            a = t.y;

        if (n) {
          var s = Hv.calcLabelPosition(n);
          o.info("Moving label from (", i, ",", a, ") to (", s.x, ",", s.y, ") abc78");
        }

        r.attr("transform", "translate(" + i + ", " + a + ")");
      }

      if (t.startLabelLeft) {
        var c = x_[t.id].startLeft,
            u = t.x,
            l = t.y;

        if (n) {
          var h = Hv.calcTerminalLabelPosition(t.arrowTypeStart ? 10 : 0, "start_left", n);
          u = h.x, l = h.y;
        }

        c.attr("transform", "translate(" + u + ", " + l + ")");
      }

      if (t.startLabelRight) {
        var f = x_[t.id].startRight,
            d = t.x,
            p = t.y;

        if (n) {
          var y = Hv.calcTerminalLabelPosition(t.arrowTypeStart ? 10 : 0, "start_right", n);
          d = y.x, p = y.y;
        }

        f.attr("transform", "translate(" + d + ", " + p + ")");
      }

      if (t.endLabelLeft) {
        var g = x_[t.id].endLeft,
            m = t.x,
            v = t.y;

        if (n) {
          var b = Hv.calcTerminalLabelPosition(t.arrowTypeEnd ? 10 : 0, "end_left", n);
          m = b.x, v = b.y;
        }

        g.attr("transform", "translate(" + m + ", " + v + ")");
      }

      if (t.endLabelRight) {
        var _ = x_[t.id].endRight,
            x = t.x,
            w = t.y;

        if (n) {
          var k = Hv.calcTerminalLabelPosition(t.arrowTypeEnd ? 10 : 0, "end_right", n);
          x = k.x, w = k.y;
        }

        _.attr("transform", "translate(" + x + ", " + w + ")");
      }
    },
        E_ = function E_(t, e) {
      o.warn("abc88 cutPathAtIntersect", t, e);
      var n = [],
          r = t[0],
          i = !1;
      return t.forEach(function (t) {
        if (o.info("abc88 checking point", t, e), function (t, e) {
          var n = t.x,
              r = t.y,
              i = Math.abs(e.x - n),
              a = Math.abs(e.y - r),
              o = t.width / 2,
              s = t.height / 2;
          return i >= o || a >= s;
        }(e, t) || i) o.warn("abc88 outside", t, r), r = t, i || n.push(t);else {
          var a = function (t, e, n) {
            o.warn("intersection calc abc89:\n  outsidePoint: ".concat(JSON.stringify(e), "\n  insidePoint : ").concat(JSON.stringify(n), "\n  node        : x:").concat(t.x, " y:").concat(t.y, " w:").concat(t.width, " h:").concat(t.height));
            var r = t.x,
                i = t.y,
                a = Math.abs(r - n.x),
                s = t.width / 2,
                c = n.x < e.x ? s - a : s + a,
                u = t.height / 2,
                l = Math.abs(e.y - n.y),
                h = Math.abs(e.x - n.x);

            if (Math.abs(i - e.y) * s > Math.abs(r - e.x) * u) {
              var f = n.y < e.y ? e.y - u - i : i - u - e.y;
              c = h * f / l;
              var d = {
                x: n.x < e.x ? n.x + c : n.x - h + c,
                y: n.y < e.y ? n.y + l - f : n.y - l + f
              };
              return 0 === c && (d.x = e.x, d.y = e.y), 0 === h && (d.x = e.x), 0 === l && (d.y = e.y), o.warn("abc89 topp/bott calc, Q ".concat(l, ", q ").concat(f, ", R ").concat(h, ", r ").concat(c), d), d;
            }

            var p = l * (c = n.x < e.x ? e.x - s - r : r - s - e.x) / h,
                y = n.x < e.x ? n.x + h - c : n.x - h + c,
                g = n.y < e.y ? n.y + p : n.y - p;
            return o.warn("sides calc abc89, Q ".concat(l, ", q ").concat(p, ", R ").concat(h, ", r ").concat(c), {
              _x: y,
              _y: g
            }), 0 === c && (y = e.x, g = e.y), 0 === h && (y = e.x), 0 === l && (g = e.y), {
              x: y,
              y: g
            };
          }(e, r, t);

          o.warn("abc88 inside", t, r, a), o.warn("abc88 intersection", a);
          var s = !1;
          n.forEach(function (t) {
            s = s || t.x === a.x && t.y === a.y;
          }), n.find(function (t) {
            return t.x === a.x && t.y === a.y;
          }) ? o.warn("abc88 no intersect", a, n) : n.push(a), i = !0;
        }
      }), o.warn("abc88 returning points", n), n;
    },
        C_ = function t(e, n, r, i) {
      o.info("Graph in recursive render: XXX", kb().json.write(n), i);
      var a = n.graph().rankdir;
      o.trace("Dir in recursive render - dir:", a);
      var s = e.insert("g").attr("class", "root");
      n.nodes() ? o.info("Recursive render XXX", n.nodes()) : o.info("No nodes found for", n), n.edges().length > 0 && o.trace("Recursive edges", n.edge(n.edges()[0]));
      var c = s.insert("g").attr("class", "clusters"),
          u = s.insert("g").attr("class", "edgePaths"),
          l = s.insert("g").attr("class", "edgeLabels"),
          h = s.insert("g").attr("class", "nodes");
      n.nodes().forEach(function (e) {
        var s = n.node(e);

        if (void 0 !== i) {
          var c = JSON.parse(JSON.stringify(i.clusterData));
          o.info("Setting data for cluster XXX (", e, ") ", c, i), n.setNode(i.id, c), n.parent(e) || (o.trace("Setting parent", e, i.id), n.setParent(e, i.id, c));
        }

        if (o.info("(Insert) Node XXX" + e + ": " + JSON.stringify(n.node(e))), s && s.clusterNode) {
          o.info("Cluster identified", e, s.width, n.node(e));
          var u = t(h, s.graph, r, n.node(e)),
              l = u.elem;
          $b(s, l), s.diff = u.diff || 0, o.info("Node bounds (abc123)", e, s, s.width, s.x, s.y), function (t, e) {
            g_[e.id] = t;
          }(l, s), o.warn("Recursive render complete ", l, s);
        } else n.children(e).length > 0 ? (o.info("Cluster - the non recursive path XXX", e, s.id, s, n), o.info(Jb(s.id, n)), Vb[s.id] = {
          id: Jb(s.id, n),
          node: s
        }) : (o.info("Node - the non recursive path", e, s.id, s), function (t, e, n) {
          var r, i, a;
          e.link ? ("sandbox" === Jv().securityLevel ? a = "_top" : e.linkTarget && (a = e.linkTarget || "_blank"), r = t.insert("svg:a").attr("xlink:href", e.link).attr("target", a), i = y_[e.shape](r, e, n)) : r = i = y_[e.shape](t, e, n), e.tooltip && i.attr("title", e.tooltip), e["class"] && i.attr("class", "node default " + e["class"]), g_[e.id] = r, e.haveCallback && g_[e.id].attr("class", g_[e.id].attr("class") + " clickable");
        }(h, n.node(e), a));
      }), n.edges().forEach(function (t) {
        var e = n.edge(t.v, t.w, t.name);
        o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(t)), o.info("Edge " + t.v + " -> " + t.w + ": ", t, " ", JSON.stringify(n.edge(t))), o.info("Fix", Vb, "ids:", t.v, t.w, "Translateing: ", Vb[t.v], Vb[t.w]), w_(l, e);
      }), n.edges().forEach(function (t) {
        o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(t));
      }), o.info("#############################################"), o.info("###                Layout                 ###"), o.info("#############################################"), o.info(n), xb().layout(n), o.info("Graph after layout:", kb().json.write(n));
      var f = 0;
      return i_(n).forEach(function (t) {
        var e = n.node(t);
        o.info("Position " + t + ": " + JSON.stringify(n.node(t))), o.info("Position " + t + ": (" + e.x, "," + e.y, ") width: ", e.width, " height: ", e.height), e && e.clusterNode ? m_(e) : n.children(t).length > 0 ? (function (t, e) {
          o.trace("Inserting cluster");
          var n = e.shape || "rect";
          b_[e.id] = v_[n](t, e);
        }(c, e), Vb[e.id].node = e) : m_(e);
      }), n.edges().forEach(function (t) {
        var e = n.edge(t);
        o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(e), e);

        var i = function (t, e, n, r, i, a) {
          var s = n.points,
              c = !1,
              u = a.node(e.v),
              l = a.node(e.w);
          o.info("abc88 InsertEdge: ", n), l.intersect && u.intersect && ((s = s.slice(1, n.points.length - 1)).unshift(u.intersect(s[0])), o.info("Last point", s[s.length - 1], l, l.intersect(s[s.length - 1])), s.push(l.intersect(s[s.length - 1]))), n.toCluster && (o.info("to cluster abc88", r[n.toCluster]), s = E_(n.points, r[n.toCluster].node), c = !0), n.fromCluster && (o.info("from cluster abc88", r[n.fromCluster]), s = E_(s.reverse(), r[n.fromCluster].node).reverse(), c = !0);
          var h,
              f = s.filter(function (t) {
            return !Number.isNaN(t.y);
          });
          h = ("graph" === i || "flowchart" === i) && n.curve || Vu;
          var d,
              p = zu().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          }).curve(h);

          switch (n.thickness) {
            case "normal":
              d = "edge-thickness-normal";
              break;

            case "thick":
              d = "edge-thickness-thick";
              break;

            default:
              d = "";
          }

          switch (n.pattern) {
            case "solid":
              d += " edge-pattern-solid";
              break;

            case "dotted":
              d += " edge-pattern-dotted";
              break;

            case "dashed":
              d += " edge-pattern-dashed";
          }

          var y = t.append("path").attr("d", p(f)).attr("id", n.id).attr("class", " " + d + (n.classes ? " " + n.classes : "")).attr("style", n.style),
              g = "";

          switch (Jv().state.arrowMarkerAbsolute && (g = (g = (g = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), o.info("arrowTypeStart", n.arrowTypeStart), o.info("arrowTypeEnd", n.arrowTypeEnd), n.arrowTypeStart) {
            case "arrow_cross":
              y.attr("marker-start", "url(" + g + "#" + i + "-crossStart)");
              break;

            case "arrow_point":
              y.attr("marker-start", "url(" + g + "#" + i + "-pointStart)");
              break;

            case "arrow_barb":
              y.attr("marker-start", "url(" + g + "#" + i + "-barbStart)");
              break;

            case "arrow_circle":
              y.attr("marker-start", "url(" + g + "#" + i + "-circleStart)");
              break;

            case "aggregation":
              y.attr("marker-start", "url(" + g + "#" + i + "-aggregationStart)");
              break;

            case "extension":
              y.attr("marker-start", "url(" + g + "#" + i + "-extensionStart)");
              break;

            case "composition":
              y.attr("marker-start", "url(" + g + "#" + i + "-compositionStart)");
              break;

            case "dependency":
              y.attr("marker-start", "url(" + g + "#" + i + "-dependencyStart)");
          }

          switch (n.arrowTypeEnd) {
            case "arrow_cross":
              y.attr("marker-end", "url(" + g + "#" + i + "-crossEnd)");
              break;

            case "arrow_point":
              y.attr("marker-end", "url(" + g + "#" + i + "-pointEnd)");
              break;

            case "arrow_barb":
              y.attr("marker-end", "url(" + g + "#" + i + "-barbEnd)");
              break;

            case "arrow_circle":
              y.attr("marker-end", "url(" + g + "#" + i + "-circleEnd)");
              break;

            case "aggregation":
              y.attr("marker-end", "url(" + g + "#" + i + "-aggregationEnd)");
              break;

            case "extension":
              y.attr("marker-end", "url(" + g + "#" + i + "-extensionEnd)");
              break;

            case "composition":
              y.attr("marker-end", "url(" + g + "#" + i + "-compositionEnd)");
              break;

            case "dependency":
              y.attr("marker-end", "url(" + g + "#" + i + "-dependencyEnd)");
          }

          var m = {};
          return c && (m.updatedPath = s), m.originalPath = n.points, m;
        }(u, t, e, Vb, r, n);

        T_(e, i);
      }), n.nodes().forEach(function (t) {
        var e = n.node(t);
        o.info(t, e.type, e.diff), "group" === e.type && (f = e.diff);
      }), {
        elem: s,
        diff: f
      };
    },
        S_ = function S_(t, e, n, r, i) {
      zb(t, n, r, i), g_ = {}, __ = {}, x_ = {}, b_ = {}, Gb = {}, Xb = {}, Vb = {}, o.warn("Graph at first:", kb().json.write(e)), e_(e), o.warn("Graph after:", kb().json.write(e)), C_(t, e, r);
    };

    Tb.parser.yy = bb;
    var A_ = {
      dividerMargin: 10,
      padding: 5,
      textHeight: 10
    };

    function M_(t) {
      var e;

      switch (t) {
        case 0:
          e = "aggregation";
          break;

        case 1:
          e = "extension";
          break;

        case 2:
          e = "composition";
          break;

        case 3:
          e = "dependency";
          break;

        default:
          e = "none";
      }

      return e;
    }

    var N_ = {},
        D_ = [],
        O_ = "",
        B_ = function B_(t) {
      return void 0 === N_[t] && (N_[t] = {
        attributes: []
      }, o.info("Added new entity :", t)), N_[t];
    };

    var L_ = {
      Cardinality: {
        ZERO_OR_ONE: "ZERO_OR_ONE",
        ZERO_OR_MORE: "ZERO_OR_MORE",
        ONE_OR_MORE: "ONE_OR_MORE",
        ONLY_ONE: "ONLY_ONE"
      },
      Identification: {
        NON_IDENTIFYING: "NON_IDENTIFYING",
        IDENTIFYING: "IDENTIFYING"
      },
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().er;
      },
      addEntity: B_,
      addAttributes: function addAttributes(t, e) {
        var n,
            r = B_(t);

        for (n = e.length - 1; n >= 0; n--) {
          r.attributes.push(e[n]), o.debug("Added attribute ", e[n].attributeName);
        }
      },
      getEntities: function getEntities() {
        return N_;
      },
      addRelationship: function addRelationship(t, e, n, r) {
        var i = {
          entityA: t,
          roleA: e,
          entityB: n,
          relSpec: r
        };
        D_.push(i), o.debug("Added new relationship :", i);
      },
      getRelationships: function getRelationships() {
        return D_;
      },
      clear: function clear() {
        N_ = {}, D_ = [], O_ = "";
      },
      setTitle: function setTitle(t) {
        O_ = t;
      },
      getTitle: function getTitle() {
        return O_;
      }
    };
    var I_ = n(5890),
        R_ = n.n(I_),
        F_ = {
      ONLY_ONE_START: "ONLY_ONE_START",
      ONLY_ONE_END: "ONLY_ONE_END",
      ZERO_OR_ONE_START: "ZERO_OR_ONE_START",
      ZERO_OR_ONE_END: "ZERO_OR_ONE_END",
      ONE_OR_MORE_START: "ONE_OR_MORE_START",
      ONE_OR_MORE_END: "ONE_OR_MORE_END",
      ZERO_OR_MORE_START: "ZERO_OR_MORE_START",
      ZERO_OR_MORE_END: "ZERO_OR_MORE_END"
    };
    var P_ = F_;

    var j_ = {},
        Y_ = function Y_(t) {
      return (t.entityA + t.roleA + t.entityB).replace(/\s/g, "");
    },
        z_ = 0;

    var U_ = function U_(t) {
      for (var e = Object.keys(t), n = 0; n < e.length; n++) {
        j_[e[n]] = t[e[n]];
      }
    },
        q_ = function q_(t, e) {
      o.info("Drawing ER diagram"), L_.clear();
      var n = R_().parser;
      n.yy = L_;
      var r,
          i = Jv().securityLevel;
      "sandbox" === i && (r = au("#i" + e));
      var a = au("sandbox" === i ? r.nodes()[0].contentDocument.body : "body");
      "sandbox" === i ? r.nodes()[0].contentDocument : document;

      try {
        n.parse(t);
      } catch (t) {
        o.debug("Parsing failed");
      }

      var s,
          c = a.select("[id='".concat(e, "']"));
      (function (t, e) {
        var n;
        t.append("defs").append("marker").attr("id", F_.ONLY_ONE_START).attr("refX", 0).attr("refY", 9).attr("markerWidth", 18).attr("markerHeight", 18).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M9,0 L9,18 M15,0 L15,18"), t.append("defs").append("marker").attr("id", F_.ONLY_ONE_END).attr("refX", 18).attr("refY", 9).attr("markerWidth", 18).attr("markerHeight", 18).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M3,0 L3,18 M9,0 L9,18"), (n = t.append("defs").append("marker").attr("id", F_.ZERO_OR_ONE_START).attr("refX", 0).attr("refY", 9).attr("markerWidth", 30).attr("markerHeight", 18).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 21).attr("cy", 9).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M9,0 L9,18"), (n = t.append("defs").append("marker").attr("id", F_.ZERO_OR_ONE_END).attr("refX", 30).attr("refY", 9).attr("markerWidth", 30).attr("markerHeight", 18).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 9).attr("cy", 9).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M21,0 L21,18"), t.append("defs").append("marker").attr("id", F_.ONE_OR_MORE_START).attr("refX", 18).attr("refY", 18).attr("markerWidth", 45).attr("markerHeight", 36).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M0,18 Q 18,0 36,18 Q 18,36 0,18 M42,9 L42,27"), t.append("defs").append("marker").attr("id", F_.ONE_OR_MORE_END).attr("refX", 27).attr("refY", 18).attr("markerWidth", 45).attr("markerHeight", 36).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M3,9 L3,27 M9,18 Q27,0 45,18 Q27,36 9,18"), (n = t.append("defs").append("marker").attr("id", F_.ZERO_OR_MORE_START).attr("refX", 18).attr("refY", 18).attr("markerWidth", 57).attr("markerHeight", 36).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 48).attr("cy", 18).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M0,18 Q18,0 36,18 Q18,36 0,18"), (n = t.append("defs").append("marker").attr("id", F_.ZERO_OR_MORE_END).attr("refX", 39).attr("refY", 18).attr("markerWidth", 57).attr("markerHeight", 36).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 9).attr("cy", 18).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M21,18 Q39,0 57,18 Q39,36 21,18");
      })(c, j_), s = new (kb().Graph)({
        multigraph: !0,
        directed: !0,
        compound: !1
      }).setGraph({
        rankdir: j_.layoutDirection,
        marginx: 20,
        marginy: 20,
        nodesep: 100,
        edgesep: 100,
        ranksep: 100
      }).setDefaultEdgeLabel(function () {
        return {};
      });

      var u = function (t, e, n) {
        var r;
        return Object.keys(e).forEach(function (i) {
          var a = t.append("g").attr("id", i);
          r = void 0 === r ? i : r;

          var o = "entity-" + i,
              s = a.append("text").attr("class", "er entityLabel").attr("id", o).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "middle").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + j_.fontSize + "px").text(i),
              c = function (t, e, n) {
            var r = j_.entityPadding / 3,
                i = j_.entityPadding / 3,
                a = .85 * j_.fontSize,
                o = e.node().getBBox(),
                s = [],
                c = !1,
                u = !1,
                l = 0,
                h = 0,
                f = 0,
                d = 0,
                p = o.height + 2 * r,
                y = 1;
            n.forEach(function (t) {
              void 0 !== t.attributeKeyType && (c = !0), void 0 !== t.attributeComment && (u = !0);
            }), n.forEach(function (n) {
              var i = "".concat(e.node().id, "-attr-").concat(y),
                  o = 0,
                  g = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-type")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + a + "px").text(n.attributeType),
                  m = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-name")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + a + "px").text(n.attributeName),
                  v = {};
              v.tn = g, v.nn = m;

              var b = g.node().getBBox(),
                  _ = m.node().getBBox();

              if (l = Math.max(l, b.width), h = Math.max(h, _.width), o = Math.max(b.height, _.height), c) {
                var x = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-key")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + a + "px").text(n.attributeKeyType || "");
                v.kn = x;
                var w = x.node().getBBox();
                f = Math.max(f, w.width), o = Math.max(o, w.height);
              }

              if (u) {
                var k = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-comment")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + a + "px").text(n.attributeComment || "");
                v.cn = k;
                var T = k.node().getBBox();
                d = Math.max(d, T.width), o = Math.max(o, T.height);
              }

              v.height = o, s.push(v), p += o + 2 * r, y += 1;
            });
            var g = 4;
            c && (g += 2), u && (g += 2);
            var m = l + h + f + d,
                v = {
              width: Math.max(j_.minEntityWidth, Math.max(o.width + 2 * j_.entityPadding, m + i * g)),
              height: n.length > 0 ? p : Math.max(j_.minEntityHeight, o.height + 2 * j_.entityPadding)
            };

            if (n.length > 0) {
              var b = Math.max(0, (v.width - m - i * g) / (g / 2));
              e.attr("transform", "translate(" + v.width / 2 + "," + (r + o.height / 2) + ")");

              var _ = o.height + 2 * r,
                  x = "attributeBoxOdd";

              s.forEach(function (e) {
                var n = _ + r + e.height / 2;
                e.tn.attr("transform", "translate(" + i + "," + n + ")");
                var a = t.insert("rect", "#" + e.tn.node().id).attr("class", "er ".concat(x)).attr("fill", j_.fill).attr("fill-opacity", "100%").attr("stroke", j_.stroke).attr("x", 0).attr("y", _).attr("width", l + 2 * i + b).attr("height", e.height + 2 * r),
                    o = parseFloat(a.attr("x")) + parseFloat(a.attr("width"));
                e.nn.attr("transform", "translate(" + (o + i) + "," + n + ")");
                var s = t.insert("rect", "#" + e.nn.node().id).attr("class", "er ".concat(x)).attr("fill", j_.fill).attr("fill-opacity", "100%").attr("stroke", j_.stroke).attr("x", o).attr("y", _).attr("width", h + 2 * i + b).attr("height", e.height + 2 * r),
                    p = parseFloat(s.attr("x")) + parseFloat(s.attr("width"));

                if (c) {
                  e.kn.attr("transform", "translate(" + (p + i) + "," + n + ")");
                  var y = t.insert("rect", "#" + e.kn.node().id).attr("class", "er ".concat(x)).attr("fill", j_.fill).attr("fill-opacity", "100%").attr("stroke", j_.stroke).attr("x", p).attr("y", _).attr("width", f + 2 * i + b).attr("height", e.height + 2 * r);
                  p = parseFloat(y.attr("x")) + parseFloat(y.attr("width"));
                }

                u && (e.cn.attr("transform", "translate(" + (p + i) + "," + n + ")"), t.insert("rect", "#" + e.cn.node().id).attr("class", "er ".concat(x)).attr("fill", j_.fill).attr("fill-opacity", "100%").attr("stroke", j_.stroke).attr("x", p).attr("y", _).attr("width", d + 2 * i + b).attr("height", e.height + 2 * r)), _ += e.height + 2 * r, x = "attributeBoxOdd" == x ? "attributeBoxEven" : "attributeBoxOdd";
              });
            } else v.height = Math.max(j_.minEntityHeight, p), e.attr("transform", "translate(" + v.width / 2 + "," + v.height / 2 + ")");

            return v;
          }(a, s, e[i].attributes),
              u = c.width,
              l = c.height,
              h = a.insert("rect", "#" + o).attr("class", "er entityBox").attr("fill", j_.fill).attr("fill-opacity", "100%").attr("stroke", j_.stroke).attr("x", 0).attr("y", 0).attr("width", u).attr("height", l).node().getBBox();

          n.setNode(i, {
            width: h.width,
            height: h.height,
            shape: "rect",
            id: i
          });
        }), r;
      }(c, L_.getEntities(), s),
          l = function (t, e) {
        return t.forEach(function (t) {
          e.setEdge(t.entityA, t.entityB, {
            relationship: t
          }, Y_(t));
        }), t;
      }(L_.getRelationships(), s);

      xb().layout(s), function (t, e) {
        e.nodes().forEach(function (n) {
          void 0 !== n && void 0 !== e.node(n) && t.select("#" + n).attr("transform", "translate(" + (e.node(n).x - e.node(n).width / 2) + "," + (e.node(n).y - e.node(n).height / 2) + " )");
        });
      }(c, s), l.forEach(function (t) {
        !function (t, e, n, r) {
          z_++;
          var i = n.edge(e.entityA, e.entityB, Y_(e)),
              a = zu().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          }).curve(Vu),
              o = t.insert("path", "#" + r).attr("class", "er relationshipLine").attr("d", a(i.points)).attr("stroke", j_.stroke).attr("fill", "none");
          e.relSpec.relType === L_.Identification.NON_IDENTIFYING && o.attr("stroke-dasharray", "8,8");
          var s = "";

          switch (j_.arrowMarkerAbsolute && (s = (s = (s = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), e.relSpec.cardA) {
            case L_.Cardinality.ZERO_OR_ONE:
              o.attr("marker-end", "url(" + s + "#" + P_.ZERO_OR_ONE_END + ")");
              break;

            case L_.Cardinality.ZERO_OR_MORE:
              o.attr("marker-end", "url(" + s + "#" + P_.ZERO_OR_MORE_END + ")");
              break;

            case L_.Cardinality.ONE_OR_MORE:
              o.attr("marker-end", "url(" + s + "#" + P_.ONE_OR_MORE_END + ")");
              break;

            case L_.Cardinality.ONLY_ONE:
              o.attr("marker-end", "url(" + s + "#" + P_.ONLY_ONE_END + ")");
          }

          switch (e.relSpec.cardB) {
            case L_.Cardinality.ZERO_OR_ONE:
              o.attr("marker-start", "url(" + s + "#" + P_.ZERO_OR_ONE_START + ")");
              break;

            case L_.Cardinality.ZERO_OR_MORE:
              o.attr("marker-start", "url(" + s + "#" + P_.ZERO_OR_MORE_START + ")");
              break;

            case L_.Cardinality.ONE_OR_MORE:
              o.attr("marker-start", "url(" + s + "#" + P_.ONE_OR_MORE_START + ")");
              break;

            case L_.Cardinality.ONLY_ONE:
              o.attr("marker-start", "url(" + s + "#" + P_.ONLY_ONE_START + ")");
          }

          var c = o.node().getTotalLength(),
              u = o.node().getPointAtLength(.5 * c),
              l = "rel" + z_,
              h = t.append("text").attr("class", "er relationshipLabel").attr("id", l).attr("x", u.x).attr("y", u.y).attr("text-anchor", "middle").attr("dominant-baseline", "middle").attr("style", "font-family: " + Jv().fontFamily + "; font-size: " + j_.fontSize + "px").text(e.roleA).node().getBBox();
          t.insert("rect", "#" + l).attr("class", "er relationshipLabelBox").attr("x", u.x - h.width / 2).attr("y", u.y - h.height / 2).attr("width", h.width).attr("height", h.height).attr("fill", "white").attr("fill-opacity", "85%");
        }(c, t, s, u);
      });
      var h = j_.diagramPadding,
          f = c.node().getBBox(),
          d = f.width + 2 * h,
          p = f.height + 2 * h;
      zv(c, p, d, j_.useMaxWidth), c.attr("viewBox", "".concat(f.x - h, " ").concat(f.y - h, " ").concat(d, " ").concat(p));
    };

    function H_(t) {
      return H_ = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, H_(t);
    }

    function $_(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var W_,
        V_,
        G_ = "flowchart-",
        X_ = 0,
        Z_ = Jv(),
        Q_ = {},
        K_ = [],
        J_ = [],
        tx = [],
        ex = {},
        nx = {},
        rx = 0,
        ix = !0,
        ax = [],
        ox = function ox(t) {
      for (var e = Object.keys(Q_), n = 0; n < e.length; n++) {
        if (Q_[e[n]].id === t) return Q_[e[n]].domId;
      }

      return t;
    },
        sx = function sx(t, e, n, r) {
      var i = {
        start: t,
        end: e,
        type: void 0,
        text: ""
      };
      void 0 !== (r = n.text) && (i.text = Um.sanitizeText(r.trim(), Z_), '"' === i.text[0] && '"' === i.text[i.text.length - 1] && (i.text = i.text.substring(1, i.text.length - 1))), void 0 !== n && (i.type = n.type, i.stroke = n.stroke, i.length = n.length), K_.push(i);
    },
        cx = function cx(t, e) {
      t.split(",").forEach(function (t) {
        var n = t;
        void 0 !== Q_[n] && Q_[n].classes.push(e), void 0 !== ex[n] && ex[n].classes.push(e);
      });
    },
        ux = function ux(t) {
      var e = au(".mermaidTooltip");
      null === (e._groups || e)[0][0] && (e = au("body").append("div").attr("class", "mermaidTooltip").style("opacity", 0)), au(t).select("svg").selectAll("g.node").on("mouseover", function () {
        var t = au(this);

        if (null !== t.attr("title")) {
          var n = this.getBoundingClientRect();
          e.transition().duration(200).style("opacity", ".9"), e.html(t.attr("title")).style("left", window.scrollX + n.left + (n.right - n.left) / 2 + "px").style("top", window.scrollY + n.top - 14 + document.body.scrollTop + "px"), t.classed("hover", !0);
        }
      }).on("mouseout", function () {
        e.transition().duration(500).style("opacity", 0), au(this).classed("hover", !1);
      });
    };

    ax.push(ux);

    var lx = function lx(t) {
      for (var e = 0; e < tx.length; e++) {
        if (tx[e].id === t) return e;
      }

      return -1;
    },
        hx = -1,
        fx = [],
        dx = function t(e, n) {
      var r = tx[n].nodes;

      if (!((hx += 1) > 2e3)) {
        if (fx[hx] = n, tx[n].id === e) return {
          result: !0,
          count: 0
        };

        for (var i = 0, a = 1; i < r.length;) {
          var o = lx(r[i]);

          if (o >= 0) {
            var s = t(e, o);
            if (s.result) return {
              result: !0,
              count: a + s.count
            };
            a += s.count;
          }

          i += 1;
        }

        return {
          result: !1,
          count: a
        };
      }
    },
        px = function px(t, e) {
      var n = !1;
      return t.forEach(function (t) {
        t.nodes.indexOf(e) >= 0 && (n = !0);
      }), n;
    },
        yx = function yx(t, e) {
      var n = [];
      return t.nodes.forEach(function (r, i) {
        px(e, r) || n.push(t.nodes[i]);
      }), {
        nodes: n
      };
    };

    var gx = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      defaultConfig: function defaultConfig() {
        return Vv.flowchart;
      },
      addVertex: function addVertex(t, e, n, r, i, a) {
        var o,
            s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {},
            c = t;
        void 0 !== c && 0 !== c.trim().length && (void 0 === Q_[c] && (Q_[c] = {
          id: c,
          domId: G_ + c + "-" + X_,
          styles: [],
          classes: []
        }), X_++, void 0 !== e ? (Z_ = Jv(), '"' === (o = Um.sanitizeText(e.trim(), Z_))[0] && '"' === o[o.length - 1] && (o = o.substring(1, o.length - 1)), Q_[c].text = o) : void 0 === Q_[c].text && (Q_[c].text = t), void 0 !== n && (Q_[c].type = n), null != r && r.forEach(function (t) {
          Q_[c].styles.push(t);
        }), null != i && i.forEach(function (t) {
          Q_[c].classes.push(t);
        }), void 0 !== a && (Q_[c].dir = a), Q_[c].props = s);
      },
      lookUpDomId: ox,
      addLink: function addLink(t, e, n, r) {
        var i, a;

        for (i = 0; i < t.length; i++) {
          for (a = 0; a < e.length; a++) {
            sx(t[i], e[a], n, r);
          }
        }
      },
      updateLinkInterpolate: function updateLinkInterpolate(t, e) {
        t.forEach(function (t) {
          "default" === t ? K_.defaultInterpolate = e : K_[t].interpolate = e;
        });
      },
      updateLink: function updateLink(t, e) {
        t.forEach(function (t) {
          "default" === t ? K_.defaultStyle = e : (-1 === Hv.isSubstringInArray("fill", e) && e.push("fill:none"), K_[t].style = e);
        });
      },
      addClass: function addClass(t, e) {
        void 0 === J_[t] && (J_[t] = {
          id: t,
          styles: [],
          textStyles: []
        }), null != e && e.forEach(function (e) {
          if (e.match("color")) {
            var n = e.replace("fill", "bgFill").replace("color", "fill");
            J_[t].textStyles.push(n);
          }

          J_[t].styles.push(e);
        });
      },
      setDirection: function setDirection(t) {
        (W_ = t).match(/.*</) && (W_ = "RL"), W_.match(/.*\^/) && (W_ = "BT"), W_.match(/.*>/) && (W_ = "LR"), W_.match(/.*v/) && (W_ = "TB");
      },
      setClass: cx,
      setTooltip: function setTooltip(t, e) {
        t.split(",").forEach(function (t) {
          void 0 !== e && (nx["gen-1" === V_ ? ox(t) : t] = Um.sanitizeText(e, Z_));
        });
      },
      getTooltip: function getTooltip(t) {
        return nx[t];
      },
      setClickEvent: function setClickEvent(t, e, n) {
        t.split(",").forEach(function (t) {
          !function (t, e, n) {
            var r = ox(t);

            if ("loose" === Jv().securityLevel && void 0 !== e) {
              var i = [];

              if ("string" == typeof n) {
                i = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                for (var a = 0; a < i.length; a++) {
                  var o = i[a].trim();
                  '"' === o.charAt(0) && '"' === o.charAt(o.length - 1) && (o = o.substr(1, o.length - 2)), i[a] = o;
                }
              }

              0 === i.length && i.push(t), void 0 !== Q_[t] && (Q_[t].haveCallback = !0, ax.push(function () {
                var t = document.querySelector('[id="'.concat(r, '"]'));
                null !== t && t.addEventListener("click", function () {
                  var t;
                  Hv.runFunc.apply(Hv, [e].concat(function (t) {
                    if (Array.isArray(t)) return $_(t);
                  }(t = i) || function (t) {
                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                  }(t) || function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return $_(t, e);
                      var n = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $_(t, e) : void 0;
                    }
                  }(t) || function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }()));
                }, !1);
              }));
            }
          }(t, e, n);
        }), cx(t, "clickable");
      },
      setLink: function setLink(t, e, n) {
        t.split(",").forEach(function (t) {
          void 0 !== Q_[t] && (Q_[t].link = Hv.formatUrl(e, Z_), Q_[t].linkTarget = n);
        }), cx(t, "clickable");
      },
      bindFunctions: function bindFunctions(t) {
        ax.forEach(function (e) {
          e(t);
        });
      },
      getDirection: function getDirection() {
        return W_.trim();
      },
      getVertices: function getVertices() {
        return Q_;
      },
      getEdges: function getEdges() {
        return K_;
      },
      getClasses: function getClasses() {
        return J_;
      },
      clear: function clear(t) {
        Q_ = {}, J_ = {}, K_ = [], (ax = []).push(ux), tx = [], ex = {}, rx = 0, nx = [], ix = !0, V_ = t || "gen-1";
      },
      setGen: function setGen(t) {
        V_ = t || "gen-1";
      },
      defaultStyle: function defaultStyle() {
        return "fill:#ffa;stroke: #f66; stroke-width: 3px; stroke-dasharray: 5, 5;fill:#ffa;stroke: #666;";
      },
      addSubGraph: function addSubGraph(t, e, n) {
        var r = t.trim(),
            i = n;
        t === n && n.match(/\s/) && (r = void 0);

        var a = [],
            s = function (t) {
          var e,
              n = {
            "boolean": {},
            number: {},
            string: {}
          },
              r = [],
              i = t.filter(function (t) {
            var i = H_(t);
            return t.stmt && "dir" === t.stmt ? (e = t.value, !1) : "" !== t.trim() && (i in n ? !n[i].hasOwnProperty(t) && (n[i][t] = !0) : !(r.indexOf(t) >= 0) && r.push(t));
          });
          return {
            nodeList: i,
            dir: e
          };
        }(a.concat.apply(a, e)),
            c = s.nodeList,
            u = s.dir;

        if (a = c, "gen-1" === V_) {
          o.warn("LOOKING UP");

          for (var l = 0; l < a.length; l++) {
            a[l] = ox(a[l]);
          }
        }

        r = r || "subGraph" + rx, i = i || "", i = Um.sanitizeText(i, Z_), rx += 1;
        var h = {
          id: r,
          nodes: a,
          title: i.trim(),
          classes: [],
          dir: u
        };
        return o.info("Adding", h.id, h.nodes, h.dir), h.nodes = yx(h, tx).nodes, tx.push(h), ex[r] = h, r;
      },
      getDepthFirstPos: function getDepthFirstPos(t) {
        return fx[t];
      },
      indexNodes: function indexNodes() {
        hx = -1, tx.length > 0 && dx("none", tx.length - 1);
      },
      getSubGraphs: function getSubGraphs() {
        return tx;
      },
      destructLink: function destructLink(t, e) {
        var n,
            r = function (t) {
          var e = t.trim(),
              n = e.slice(0, -1),
              r = "arrow_open";

          switch (e.slice(-1)) {
            case "x":
              r = "arrow_cross", "x" === e[0] && (r = "double_" + r, n = n.slice(1));
              break;

            case ">":
              r = "arrow_point", "<" === e[0] && (r = "double_" + r, n = n.slice(1));
              break;

            case "o":
              r = "arrow_circle", "o" === e[0] && (r = "double_" + r, n = n.slice(1));
          }

          var i = "normal",
              a = n.length - 1;
          "=" === n[0] && (i = "thick");

          var o = function (t, e) {
            for (var n = e.length, r = 0, i = 0; i < n; ++i) {
              "." === e[i] && ++r;
            }

            return r;
          }(0, n);

          return o && (i = "dotted", a = o), {
            type: r,
            stroke: i,
            length: a
          };
        }(t);

        if (e) {
          if (n = function (t) {
            var e = t.trim(),
                n = "arrow_open";

            switch (e[0]) {
              case "<":
                n = "arrow_point", e = e.slice(1);
                break;

              case "x":
                n = "arrow_cross", e = e.slice(1);
                break;

              case "o":
                n = "arrow_circle", e = e.slice(1);
            }

            var r = "normal";
            return -1 !== e.indexOf("=") && (r = "thick"), -1 !== e.indexOf(".") && (r = "dotted"), {
              type: n,
              stroke: r
            };
          }(e), n.stroke !== r.stroke) return {
            type: "INVALID",
            stroke: "INVALID"
          };
          if ("arrow_open" === n.type) n.type = r.type;else {
            if (n.type !== r.type) return {
              type: "INVALID",
              stroke: "INVALID"
            };
            n.type = "double_" + n.type;
          }
          return "double_arrow" === n.type && (n.type = "double_arrow_point"), n.length = r.length, n;
        }

        return r;
      },
      lex: {
        firstGraph: function firstGraph() {
          return !!ix && (ix = !1, !0);
        }
      },
      exists: px,
      makeUniq: yx
    };

    var mx = n(3602),
        vx = n.n(mx),
        bx = n(4949),
        _x = n.n(bx),
        xx = n(8284),
        wx = n.n(xx);

    function kx(t, e, n) {
      var r = .9 * (e.width + e.height),
          i = [{
        x: r / 2,
        y: 0
      }, {
        x: r,
        y: -r / 2
      }, {
        x: r / 2,
        y: -r
      }, {
        x: 0,
        y: -r / 2
      }],
          a = Lx(t, r, r, i);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, i, t);
      }, a;
    }

    function Tx(t, e, n) {
      var r = e.height,
          i = r / 4,
          a = e.width + 2 * i,
          o = [{
        x: i,
        y: 0
      }, {
        x: a - i,
        y: 0
      }, {
        x: a,
        y: -r / 2
      }, {
        x: a - i,
        y: -r
      }, {
        x: i,
        y: -r
      }, {
        x: 0,
        y: -r / 2
      }],
          s = Lx(t, a, r, o);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, o, t);
      }, s;
    }

    function Ex(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: -i / 2,
        y: 0
      }, {
        x: r,
        y: 0
      }, {
        x: r,
        y: -i
      }, {
        x: -i / 2,
        y: -i
      }, {
        x: 0,
        y: -i / 2
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Cx(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: -2 * i / 6,
        y: 0
      }, {
        x: r - i / 6,
        y: 0
      }, {
        x: r + 2 * i / 6,
        y: -i
      }, {
        x: i / 6,
        y: -i
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Sx(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: 2 * i / 6,
        y: 0
      }, {
        x: r + i / 6,
        y: 0
      }, {
        x: r - 2 * i / 6,
        y: -i
      }, {
        x: -i / 6,
        y: -i
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Ax(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: -2 * i / 6,
        y: 0
      }, {
        x: r + 2 * i / 6,
        y: 0
      }, {
        x: r - i / 6,
        y: -i
      }, {
        x: i / 6,
        y: -i
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Mx(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: i / 6,
        y: 0
      }, {
        x: r - i / 6,
        y: 0
      }, {
        x: r + 2 * i / 6,
        y: -i
      }, {
        x: -2 * i / 6,
        y: -i
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Nx(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: 0,
        y: 0
      }, {
        x: r + i / 2,
        y: 0
      }, {
        x: r,
        y: -i / 2
      }, {
        x: r + i / 2,
        y: -i
      }, {
        x: 0,
        y: -i
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Dx(t, e, n) {
      var r = e.height,
          i = e.width + r / 4,
          a = t.insert("rect", ":first-child").attr("rx", r / 2).attr("ry", r / 2).attr("x", -i / 2).attr("y", -r / 2).attr("width", i).attr("height", r);
      return n.intersect = function (t) {
        return _x().intersect.rect(n, t);
      }, a;
    }

    function Ox(t, e, n) {
      var r = e.width,
          i = e.height,
          a = [{
        x: 0,
        y: 0
      }, {
        x: r,
        y: 0
      }, {
        x: r,
        y: -i
      }, {
        x: 0,
        y: -i
      }, {
        x: 0,
        y: 0
      }, {
        x: -8,
        y: 0
      }, {
        x: r + 8,
        y: 0
      }, {
        x: r + 8,
        y: -i
      }, {
        x: -8,
        y: -i
      }, {
        x: -8,
        y: 0
      }],
          o = Lx(t, r, i, a);
      return n.intersect = function (t) {
        return _x().intersect.polygon(n, a, t);
      }, o;
    }

    function Bx(t, e, n) {
      var r = e.width,
          i = r / 2,
          a = i / (2.5 + r / 50),
          o = e.height + a,
          s = "M 0," + a + " a " + i + "," + a + " 0,0,0 " + r + " 0 a " + i + "," + a + " 0,0,0 " + -r + " 0 l 0," + o + " a " + i + "," + a + " 0,0,0 " + r + " 0 l 0," + -o,
          c = t.attr("label-offset-y", a).insert("path", ":first-child").attr("d", s).attr("transform", "translate(" + -r / 2 + "," + -(o / 2 + a) + ")");
      return n.intersect = function (t) {
        var e = _x().intersect.rect(n, t),
            r = e.x - n.x;

        if (0 != i && (Math.abs(r) < n.width / 2 || Math.abs(r) == n.width / 2 && Math.abs(e.y - n.y) > n.height / 2 - a)) {
          var o = a * a * (1 - r * r / (i * i));
          0 != o && (o = Math.sqrt(o)), o = a - o, t.y - n.y > 0 && (o = -o), e.y += o;
        }

        return e;
      }, c;
    }

    function Lx(t, e, n, r) {
      return t.insert("polygon", ":first-child").attr("points", r.map(function (t) {
        return t.x + "," + t.y;
      }).join(" ")).attr("transform", "translate(" + -e / 2 + "," + n / 2 + ")");
    }

    var Ix = function Ix(t) {
      t.shapes().question = kx, t.shapes().hexagon = Tx, t.shapes().stadium = Dx, t.shapes().subroutine = Ox, t.shapes().cylinder = Bx, t.shapes().rect_left_inv_arrow = Ex, t.shapes().lean_right = Cx, t.shapes().lean_left = Sx, t.shapes().trapezoid = Ax, t.shapes().inv_trapezoid = Mx, t.shapes().rect_right_inv_arrow = Nx;
    };

    var Rx = {};

    var Fx = function Fx(t) {
      for (var e = Object.keys(t), n = 0; n < e.length; n++) {
        Rx[e[n]] = t[e[n]];
      }
    },
        Px = function Px(t, e) {
      o.info("Drawing flowchart"), gx.clear(), gx.setGen("gen-1");
      var n = vx().parser;
      n.yy = gx;
      var r,
          i = Jv().securityLevel;
      "sandbox" === i && (r = au("#i" + e));
      var a = au("sandbox" === i ? r.nodes()[0].contentDocument.body : "body"),
          s = "sandbox" === i ? r.nodes()[0].contentDocument : document;
      n.parse(t);
      var c = gx.getDirection();
      void 0 === c && (c = "TD");

      for (var u, l = Jv().flowchart, h = l.nodeSpacing || 50, f = l.rankSpacing || 50, d = new (kb().Graph)({
        multigraph: !0,
        compound: !0
      }).setGraph({
        rankdir: c,
        nodesep: h,
        ranksep: f,
        marginx: 8,
        marginy: 8
      }).setDefaultEdgeLabel(function () {
        return {};
      }), p = gx.getSubGraphs(), y = p.length - 1; y >= 0; y--) {
        u = p[y], gx.addVertex(u.id, u.title, "group", void 0, u.classes);
      }

      var g = gx.getVertices();
      o.warn("Get vertices", g);
      var m = gx.getEdges(),
          v = 0;

      for (v = p.length - 1; v >= 0; v--) {
        u = p[v], ou("cluster").append("text");

        for (var b = 0; b < u.nodes.length; b++) {
          o.warn("Setting subgraph", u.nodes[b], gx.lookUpDomId(u.nodes[b]), gx.lookUpDomId(u.id)), d.setParent(gx.lookUpDomId(u.nodes[b]), gx.lookUpDomId(u.id));
        }
      }

      (function (t, e, n, r, i) {
        Jv().securityLevel;
        var a = r ? r.select('[id="'.concat(n, '"]')) : au('[id="'.concat(n, '"]')),
            s = i || document;
        Object.keys(t).forEach(function (n) {
          var r = t[n],
              i = "default";
          r.classes.length > 0 && (i = r.classes.join(" "));
          var c,
              u = Nv(r.styles),
              l = void 0 !== r.text ? r.text : r.id;

          if (zm(Jv().flowchart.htmlLabels)) {
            var h = {
              label: l.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
                return "<i class='".concat(t.replace(":", " "), "'></i>");
              })
            };
            (c = wx()(a, h).node()).parentNode.removeChild(c);
          } else {
            var f = s.createElementNS("http://www.w3.org/2000/svg", "text");
            f.setAttribute("style", u.labelStyle.replace("color:", "fill:"));

            for (var d = l.split(Um.lineBreakRegex), p = 0; p < d.length; p++) {
              var y = s.createElementNS("http://www.w3.org/2000/svg", "tspan");
              y.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), y.setAttribute("dy", "1em"), y.setAttribute("x", "1"), y.textContent = d[p], f.appendChild(y);
            }

            c = f;
          }

          var g = 0,
              m = "";

          switch (r.type) {
            case "round":
              g = 5, m = "rect";
              break;

            case "square":
            case "group":
            default:
              m = "rect";
              break;

            case "diamond":
              m = "question";
              break;

            case "hexagon":
              m = "hexagon";
              break;

            case "odd":
            case "odd_right":
              m = "rect_left_inv_arrow";
              break;

            case "lean_right":
              m = "lean_right";
              break;

            case "lean_left":
              m = "lean_left";
              break;

            case "trapezoid":
              m = "trapezoid";
              break;

            case "inv_trapezoid":
              m = "inv_trapezoid";
              break;

            case "circle":
              m = "circle";
              break;

            case "ellipse":
              m = "ellipse";
              break;

            case "stadium":
              m = "stadium";
              break;

            case "subroutine":
              m = "subroutine";
              break;

            case "cylinder":
              m = "cylinder";
          }

          o.warn("Adding node", r.id, r.domId), e.setNode(gx.lookUpDomId(r.id), {
            labelType: "svg",
            labelStyle: u.labelStyle,
            shape: m,
            label: c,
            rx: g,
            ry: g,
            "class": i,
            style: u.style,
            id: gx.lookUpDomId(r.id)
          });
        });
      })(g, d, e, a, s), function (t, e) {
        var n,
            r,
            i = 0;

        if (void 0 !== t.defaultStyle) {
          var a = Nv(t.defaultStyle);
          n = a.style, r = a.labelStyle;
        }

        t.forEach(function (a) {
          i++;
          var o = "L-" + a.start + "-" + a.end,
              s = "LS-" + a.start,
              c = "LE-" + a.end,
              u = {};
          "arrow_open" === a.type ? u.arrowhead = "none" : u.arrowhead = "normal";
          var l = "",
              h = "";

          if (void 0 !== a.style) {
            var f = Nv(a.style);
            l = f.style, h = f.labelStyle;
          } else switch (a.stroke) {
            case "normal":
              l = "fill:none", void 0 !== n && (l = n), void 0 !== r && (h = r);
              break;

            case "dotted":
              l = "fill:none;stroke-width:2px;stroke-dasharray:3;";
              break;

            case "thick":
              l = " stroke-width: 3.5px;fill:none";
          }

          u.style = l, u.labelStyle = h, void 0 !== a.interpolate ? u.curve = Av(a.interpolate, Pu) : void 0 !== t.defaultInterpolate ? u.curve = Av(t.defaultInterpolate, Pu) : u.curve = Av(Rx.curve, Pu), void 0 === a.text ? void 0 !== a.style && (u.arrowheadStyle = "fill: #333") : (u.arrowheadStyle = "fill: #333", u.labelpos = "c", zm(Jv().flowchart.htmlLabels) ? (u.labelType = "html", u.label = '<span id="L-'.concat(o, '" class="edgeLabel L-').concat(s, "' L-").concat(c, '">').concat(a.text.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
            return "<i class='".concat(t.replace(":", " "), "'></i>");
          }), "</span>")) : (u.labelType = "text", u.label = a.text.replace(Um.lineBreakRegex, "\n"), void 0 === a.style && (u.style = u.style || "stroke: #333; stroke-width: 1.5px;fill:none"), u.labelStyle = u.labelStyle.replace("color:", "fill:"))), u.id = o, u["class"] = s + " " + c, u.minlen = a.length || 1, e.setEdge(gx.lookUpDomId(a.start), gx.lookUpDomId(a.end), u, i);
        });
      }(m, d);

      var _ = new (_x().render)();

      Ix(_), _.arrows().none = function (t, e, n, r) {
        var i = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 0 0 L 0 0 z");

        _x().util.applyStyle(i, n[r + "Style"]);
      }, _.arrows().normal = function (t, e) {
        t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").attr("class", "arrowheadPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
      };
      var x = a.select('[id="'.concat(e, '"]'));
      x.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), o.warn(d);
      var w = a.select("#" + e + " g");
      _(w, d), w.selectAll("g.node").attr("title", function () {
        return gx.getTooltip(this.id);
      });
      var k = l.diagramPadding,
          T = x.node().getBBox(),
          E = T.width + 2 * k,
          C = T.height + 2 * k;
      zv(x, C, E, l.useMaxWidth);
      var S = "".concat(T.x - k, " ").concat(T.y - k, " ").concat(E, " ").concat(C);

      for (o.debug("viewBox ".concat(S)), x.attr("viewBox", S), gx.indexNodes("subGraph" + v), v = 0; v < p.length; v++) {
        if ("undefined" !== (u = p[v]).title) {
          var A = s.querySelectorAll("#" + e + ' [id="' + gx.lookUpDomId(u.id) + '"] rect'),
              M = s.querySelectorAll("#" + e + ' [id="' + gx.lookUpDomId(u.id) + '"]'),
              N = A[0].x.baseVal.value,
              D = A[0].y.baseVal.value,
              O = A[0].width.baseVal.value,
              B = au(M[0]).select(".label");
          B.attr("transform", "translate(".concat(N + O / 2, ", ").concat(D + 14, ")")), B.attr("id", e + "Text");

          for (var L = 0; L < u.classes.length; L++) {
            M[0].classList.add(u.classes[L]);
          }
        }
      }

      zm(l.htmlLabels);

      for (var I = s.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), R = 0; R < I.length; R++) {
        var F = I[R],
            P = F.getBBox(),
            j = s.createElementNS("http://www.w3.org/2000/svg", "rect");
        j.setAttribute("rx", 0), j.setAttribute("ry", 0), j.setAttribute("width", P.width), j.setAttribute("height", P.height), F.insertBefore(j, F.firstChild);
      }

      Object.keys(g).forEach(function (t) {
        var n = g[t];

        if (n.link) {
          var r = a.select("#" + e + ' [id="' + gx.lookUpDomId(t) + '"]');

          if (r) {
            var o = s.createElementNS("http://www.w3.org/2000/svg", "a");
            o.setAttributeNS("http://www.w3.org/2000/svg", "class", n.classes.join(" ")), o.setAttributeNS("http://www.w3.org/2000/svg", "href", n.link), o.setAttributeNS("http://www.w3.org/2000/svg", "rel", "noopener"), "sandbox" === i ? o.setAttributeNS("http://www.w3.org/2000/svg", "target", "_top") : n.linkTarget && o.setAttributeNS("http://www.w3.org/2000/svg", "target", n.linkTarget);
            var c = r.insert(function () {
              return o;
            }, ":first-child"),
                u = r.select(".label-container");
            u && c.append(function () {
              return u.node();
            });
            var l = r.select(".label");
            l && c.append(function () {
              return l.node();
            });
          }
        }
      });
    };

    var jx = {};

    var Yx = function Yx(t) {
      for (var e = Object.keys(t), n = 0; n < e.length; n++) {
        jx[e[n]] = t[e[n]];
      }
    },
        zx = function zx(t, e) {
      o.info("Drawing flowchart"), gx.clear(), gx.setGen("gen-2");
      var n = vx().parser;
      n.yy = gx, n.parse(t);
      var r = gx.getDirection();
      void 0 === r && (r = "TD");
      var i,
          a = Jv().flowchart,
          s = a.nodeSpacing || 50,
          c = a.rankSpacing || 50,
          u = Jv().securityLevel;
      "sandbox" === u && (i = au("#i" + e));
      var l,
          h = au("sandbox" === u ? i.nodes()[0].contentDocument.body : "body"),
          f = "sandbox" === u ? i.nodes()[0].contentDocument : document,
          d = new (kb().Graph)({
        multigraph: !0,
        compound: !0
      }).setGraph({
        rankdir: r,
        nodesep: s,
        ranksep: c,
        marginx: 8,
        marginy: 8
      }).setDefaultEdgeLabel(function () {
        return {};
      }),
          p = gx.getSubGraphs();
      o.info("Subgraphs - ", p);

      for (var y = p.length - 1; y >= 0; y--) {
        l = p[y], o.info("Subgraph - ", l), gx.addVertex(l.id, l.title, "group", void 0, l.classes, l.dir);
      }

      var g = gx.getVertices(),
          m = gx.getEdges();
      o.info(m);
      var v = 0;

      for (v = p.length - 1; v >= 0; v--) {
        l = p[v], ou("cluster").append("text");

        for (var b = 0; b < l.nodes.length; b++) {
          o.info("Setting up subgraphs", l.nodes[b], l.id), d.setParent(l.nodes[b], l.id);
        }
      }

      (function (t, e, n, r, i) {
        var a = r.select('[id="'.concat(n, '"]'));
        Object.keys(t).forEach(function (n) {
          var r = t[n],
              s = "default";
          r.classes.length > 0 && (s = r.classes.join(" "));
          var c,
              u = Nv(r.styles),
              l = void 0 !== r.text ? r.text : r.id;

          if (zm(Jv().flowchart.htmlLabels)) {
            var h = {
              label: l.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
                return "<i class='".concat(t.replace(":", " "), "'></i>");
              })
            };
            (c = wx()(a, h).node()).parentNode.removeChild(c);
          } else {
            var f = i.createElementNS("http://www.w3.org/2000/svg", "text");
            f.setAttribute("style", u.labelStyle.replace("color:", "fill:"));

            for (var d = l.split(Um.lineBreakRegex), p = 0; p < d.length; p++) {
              var y = i.createElementNS("http://www.w3.org/2000/svg", "tspan");
              y.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), y.setAttribute("dy", "1em"), y.setAttribute("x", "1"), y.textContent = d[p], f.appendChild(y);
            }

            c = f;
          }

          var g = 0,
              m = "";

          switch (r.type) {
            case "round":
              g = 5, m = "rect";
              break;

            case "square":
            case "group":
            default:
              m = "rect";
              break;

            case "diamond":
              m = "question";
              break;

            case "hexagon":
              m = "hexagon";
              break;

            case "odd":
            case "odd_right":
              m = "rect_left_inv_arrow";
              break;

            case "lean_right":
              m = "lean_right";
              break;

            case "lean_left":
              m = "lean_left";
              break;

            case "trapezoid":
              m = "trapezoid";
              break;

            case "inv_trapezoid":
              m = "inv_trapezoid";
              break;

            case "circle":
              m = "circle";
              break;

            case "ellipse":
              m = "ellipse";
              break;

            case "stadium":
              m = "stadium";
              break;

            case "subroutine":
              m = "subroutine";
              break;

            case "cylinder":
              m = "cylinder";
          }

          e.setNode(r.id, {
            labelStyle: u.labelStyle,
            shape: m,
            labelText: l,
            rx: g,
            ry: g,
            "class": s,
            style: u.style,
            id: r.id,
            link: r.link,
            linkTarget: r.linkTarget,
            tooltip: gx.getTooltip(r.id) || "",
            domId: gx.lookUpDomId(r.id),
            haveCallback: r.haveCallback,
            width: "group" === r.type ? 500 : void 0,
            dir: r.dir,
            type: r.type,
            props: r.props,
            padding: Jv().flowchart.padding
          }), o.info("setNode", {
            labelStyle: u.labelStyle,
            shape: m,
            labelText: l,
            rx: g,
            ry: g,
            "class": s,
            style: u.style,
            id: r.id,
            domId: gx.lookUpDomId(r.id),
            width: "group" === r.type ? 500 : void 0,
            type: r.type,
            dir: r.dir,
            props: r.props,
            padding: Jv().flowchart.padding
          });
        });
      })(g, d, e, h, f), function (t, e) {
        o.info("abc78 edges = ", t);
        var n,
            r,
            i = 0,
            a = {};

        if (void 0 !== t.defaultStyle) {
          var s = Nv(t.defaultStyle);
          n = s.style, r = s.labelStyle;
        }

        t.forEach(function (s) {
          i++;
          var c = "L-" + s.start + "-" + s.end;
          void 0 === a[c] ? (a[c] = 0, o.info("abc78 new entry", c, a[c])) : (a[c]++, o.info("abc78 new entry", c, a[c]));
          var u = c + "-" + a[c];
          o.info("abc78 new link id to be used is", c, u, a[c]);
          var l = "LS-" + s.start,
              h = "LE-" + s.end,
              f = {
            style: "",
            labelStyle: ""
          };

          switch (f.minlen = s.length || 1, "arrow_open" === s.type ? f.arrowhead = "none" : f.arrowhead = "normal", f.arrowTypeStart = "arrow_open", f.arrowTypeEnd = "arrow_open", s.type) {
            case "double_arrow_cross":
              f.arrowTypeStart = "arrow_cross";

            case "arrow_cross":
              f.arrowTypeEnd = "arrow_cross";
              break;

            case "double_arrow_point":
              f.arrowTypeStart = "arrow_point";

            case "arrow_point":
              f.arrowTypeEnd = "arrow_point";
              break;

            case "double_arrow_circle":
              f.arrowTypeStart = "arrow_circle";

            case "arrow_circle":
              f.arrowTypeEnd = "arrow_circle";
          }

          var d = "",
              p = "";

          switch (s.stroke) {
            case "normal":
              d = "fill:none;", void 0 !== n && (d = n), void 0 !== r && (p = r), f.thickness = "normal", f.pattern = "solid";
              break;

            case "dotted":
              f.thickness = "normal", f.pattern = "dotted", f.style = "fill:none;stroke-width:2px;stroke-dasharray:3;";
              break;

            case "thick":
              f.thickness = "thick", f.pattern = "solid", f.style = "stroke-width: 3.5px;fill:none;";
          }

          if (void 0 !== s.style) {
            var y = Nv(s.style);
            d = y.style, p = y.labelStyle;
          }

          f.style = f.style += d, f.labelStyle = f.labelStyle += p, void 0 !== s.interpolate ? f.curve = Av(s.interpolate, Pu) : void 0 !== t.defaultInterpolate ? f.curve = Av(t.defaultInterpolate, Pu) : f.curve = Av(jx.curve, Pu), void 0 === s.text ? void 0 !== s.style && (f.arrowheadStyle = "fill: #333") : (f.arrowheadStyle = "fill: #333", f.labelpos = "c"), f.labelType = "text", f.label = s.text.replace(Um.lineBreakRegex, "\n"), void 0 === s.style && (f.style = f.style || "stroke: #333; stroke-width: 1.5px;fill:none;"), f.labelStyle = f.labelStyle.replace("color:", "fill:"), f.id = u, f.classes = "flowchart-link " + l + " " + h, e.setEdge(s.start, s.end, f, i);
        });
      }(m, d);

      var _ = h.select('[id="'.concat(e, '"]'));

      _.attr("xmlns:xlink", "http://www.w3.org/1999/xlink");

      var x = h.select("#" + e + " g");
      S_(x, d, ["point", "circle", "cross"], "flowchart", e);

      var w = a.diagramPadding,
          k = _.node().getBBox(),
          T = k.width + 2 * w,
          E = k.height + 2 * w;

      if (o.debug("new ViewBox 0 0 ".concat(T, " ").concat(E), "translate(".concat(w - d._label.marginx, ", ").concat(w - d._label.marginy, ")")), zv(_, E, T, a.useMaxWidth), _.attr("viewBox", "0 0 ".concat(T, " ").concat(E)), _.select("g").attr("transform", "translate(".concat(w - d._label.marginx, ", ").concat(w - k.y, ")")), gx.indexNodes("subGraph" + v), !a.htmlLabels) for (var C = f.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), S = 0; S < C.length; S++) {
        var A = C[S],
            M = A.getBBox(),
            N = f.createElementNS("http://www.w3.org/2000/svg", "rect");
        N.setAttribute("rx", 0), N.setAttribute("ry", 0), N.setAttribute("width", M.width), N.setAttribute("height", M.height), A.insertBefore(N, A.firstChild);
      }
      Object.keys(g).forEach(function (t) {
        var n = g[t];

        if (n.link) {
          var r = au("#" + e + ' [id="' + t + '"]');

          if (r) {
            var i = f.createElementNS("http://www.w3.org/2000/svg", "a");
            i.setAttributeNS("http://www.w3.org/2000/svg", "class", n.classes.join(" ")), i.setAttributeNS("http://www.w3.org/2000/svg", "href", n.link), i.setAttributeNS("http://www.w3.org/2000/svg", "rel", "noopener"), "sandbox" === u ? i.setAttributeNS("http://www.w3.org/2000/svg", "target", "_top") : n.linkTarget && i.setAttributeNS("http://www.w3.org/2000/svg", "target", n.linkTarget);
            var a = r.insert(function () {
              return i;
            }, ":first-child"),
                o = r.select(".label-container");
            o && a.append(function () {
              return o.node();
            });
            var s = r.select(".label");
            s && a.append(function () {
              return s.node();
            });
          }
        }
      });
    };

    function Ux(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var qx,
        Hx,
        $x = "",
        Wx = "",
        Vx = "",
        Gx = [],
        Xx = [],
        Zx = {},
        Qx = "",
        Kx = [],
        Jx = [],
        tw = "",
        ew = ["active", "done", "crit", "milestone"],
        nw = [],
        rw = !1,
        iw = !1,
        aw = 0,
        ow = function ow(t, e, n, r) {
      return !(r.indexOf(t.format(e.trim())) >= 0) && (t.isoWeekday() >= 6 && n.indexOf("weekends") >= 0 || n.indexOf(t.format("dddd").toLowerCase()) >= 0 || n.indexOf(t.format(e.trim())) >= 0);
    },
        sw = function sw(t, e, n, r) {
      if (n.length && !t.manualEndTime) {
        var a = i()(t.startTime, e, !0);
        a.add(1, "d");
        var o = i()(t.endTime, e, !0),
            s = cw(a, o, e, n, r);
        t.endTime = o.toDate(), t.renderEndTime = s;
      }
    },
        cw = function cw(t, e, n, r, i) {
      for (var a = !1, o = null; t <= e;) {
        a || (o = e.toDate()), (a = ow(t, n, r, i)) && e.add(1, "d"), t.add(1, "d");
      }

      return o;
    },
        uw = function uw(t, e, n) {
      n = n.trim();
      var r = /^after\s+([\d\w- ]+)/.exec(n.trim());

      if (null !== r) {
        var a = null;
        if (r[1].split(" ").forEach(function (t) {
          var e = gw(t);
          void 0 !== e && (a ? e.endTime > a.endTime && (a = e) : a = e);
        }), a) return a.endTime;
        var s = new Date();
        return s.setHours(0, 0, 0, 0), s;
      }

      var c = i()(n, e.trim(), !0);
      return c.isValid() ? c.toDate() : (o.debug("Invalid date:" + n), o.debug("With date format:" + e.trim()), new Date());
    },
        lw = function lw(t, e) {
      if (null !== t) switch (t[2]) {
        case "s":
          e.add(t[1], "seconds");
          break;

        case "m":
          e.add(t[1], "minutes");
          break;

        case "h":
          e.add(t[1], "hours");
          break;

        case "d":
          e.add(t[1], "days");
          break;

        case "w":
          e.add(t[1], "weeks");
      }
      return e.toDate();
    },
        hw = function hw(t, e, n, r) {
      r = r || !1, n = n.trim();
      var a = i()(n, e.trim(), !0);
      return a.isValid() ? (r && a.add(1, "d"), a.toDate()) : lw(/^([\d]+)([wdhms])/.exec(n.trim()), i()(t));
    },
        fw = 0,
        dw = function dw(t) {
      return void 0 === t ? "task" + (fw += 1) : t;
    },
        pw = [],
        yw = {},
        gw = function gw(t) {
      var e = yw[t];
      return pw[e];
    },
        mw = function mw() {
      for (var t = function t(_t16) {
        var e = pw[_t16],
            n = "";

        switch (pw[_t16].raw.startTime.type) {
          case "prevTaskEnd":
            var r = gw(e.prevTaskId);
            e.startTime = r.endTime;
            break;

          case "getStartDate":
            (n = uw(0, $x, pw[_t16].raw.startTime.startData)) && (pw[_t16].startTime = n);
        }

        return pw[_t16].startTime && (pw[_t16].endTime = hw(pw[_t16].startTime, $x, pw[_t16].raw.endTime.data, rw), pw[_t16].endTime && (pw[_t16].processed = !0, pw[_t16].manualEndTime = i()(pw[_t16].raw.endTime.data, "YYYY-MM-DD", !0).isValid(), sw(pw[_t16], $x, Xx, Gx))), pw[_t16].processed;
      }, e = !0, n = 0; n < pw.length; n++) {
        t(n), e = e && pw[n].processed;
      }

      return e;
    },
        vw = function vw(t, e) {
      t.split(",").forEach(function (t) {
        var n = gw(t);
        void 0 !== n && n.classes.push(e);
      });
    },
        bw = function bw(t, e) {
      nw.push(function () {
        var n = document.querySelector('[id="'.concat(t, '"]'));
        null !== n && n.addEventListener("click", function () {
          e();
        });
      }), nw.push(function () {
        var n = document.querySelector('[id="'.concat(t, '-text"]'));
        null !== n && n.addEventListener("click", function () {
          e();
        });
      });
    };

    var _w = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().gantt;
      },
      clear: function clear() {
        Kx = [], Jx = [], tw = "", nw = [], Qx = "", fw = 0, qx = void 0, Hx = void 0, pw = [], $x = "", Wx = "", Vx = "", Gx = [], Xx = [], rw = !1, iw = !1, aw = 0, Zx = {};
      },
      setDateFormat: function setDateFormat(t) {
        $x = t;
      },
      getDateFormat: function getDateFormat() {
        return $x;
      },
      enableInclusiveEndDates: function enableInclusiveEndDates() {
        rw = !0;
      },
      endDatesAreInclusive: function endDatesAreInclusive() {
        return rw;
      },
      enableTopAxis: function enableTopAxis() {
        iw = !0;
      },
      topAxisEnabled: function topAxisEnabled() {
        return iw;
      },
      setAxisFormat: function setAxisFormat(t) {
        Wx = t;
      },
      getAxisFormat: function getAxisFormat() {
        return Wx;
      },
      setTodayMarker: function setTodayMarker(t) {
        Vx = t;
      },
      getTodayMarker: function getTodayMarker() {
        return Vx;
      },
      setTitle: function setTitle(t) {
        Qx = t;
      },
      getTitle: function getTitle() {
        return Qx;
      },
      addSection: function addSection(t) {
        tw = t, Kx.push(t);
      },
      getSections: function getSections() {
        return Kx;
      },
      getTasks: function getTasks() {
        for (var t = mw(), e = 0; !t && e < 10;) {
          t = mw(), e++;
        }

        return Jx = pw;
      },
      addTask: function addTask(t, e) {
        var n = {
          section: tw,
          type: tw,
          processed: !1,
          manualEndTime: !1,
          renderEndTime: null,
          raw: {
            data: e
          },
          task: t,
          classes: []
        },
            r = function (t, e) {
          var n = (":" === e.substr(0, 1) ? e.substr(1, e.length) : e).split(","),
              r = {};
          xw(n, r, ew);

          for (var i = 0; i < n.length; i++) {
            n[i] = n[i].trim();
          }

          switch (n.length) {
            case 1:
              r.id = dw(), r.startTime = {
                type: "prevTaskEnd",
                id: t
              }, r.endTime = {
                data: n[0]
              };
              break;

            case 2:
              r.id = dw(), r.startTime = {
                type: "getStartDate",
                startData: n[0]
              }, r.endTime = {
                data: n[1]
              };
              break;

            case 3:
              r.id = dw(n[0]), r.startTime = {
                type: "getStartDate",
                startData: n[1]
              }, r.endTime = {
                data: n[2]
              };
          }

          return r;
        }(Hx, e);

        n.raw.startTime = r.startTime, n.raw.endTime = r.endTime, n.id = r.id, n.prevTaskId = Hx, n.active = r.active, n.done = r.done, n.crit = r.crit, n.milestone = r.milestone, n.order = aw, aw++;
        var i = pw.push(n);
        Hx = n.id, yw[n.id] = i - 1;
      },
      findTaskById: gw,
      addTaskOrg: function addTaskOrg(t, e) {
        var n = {
          section: tw,
          type: tw,
          description: t,
          task: t,
          classes: []
        },
            r = function (t, e) {
          var n = (":" === e.substr(0, 1) ? e.substr(1, e.length) : e).split(","),
              r = {};
          xw(n, r, ew);

          for (var a = 0; a < n.length; a++) {
            n[a] = n[a].trim();
          }

          var o = "";

          switch (n.length) {
            case 1:
              r.id = dw(), r.startTime = t.endTime, o = n[0];
              break;

            case 2:
              r.id = dw(), r.startTime = uw(0, $x, n[0]), o = n[1];
              break;

            case 3:
              r.id = dw(n[0]), r.startTime = uw(0, $x, n[1]), o = n[2];
          }

          return o && (r.endTime = hw(r.startTime, $x, o, rw), r.manualEndTime = i()(o, "YYYY-MM-DD", !0).isValid(), sw(r, $x, Xx, Gx)), r;
        }(qx, e);

        n.startTime = r.startTime, n.endTime = r.endTime, n.id = r.id, n.active = r.active, n.done = r.done, n.crit = r.crit, n.milestone = r.milestone, qx = n, Jx.push(n);
      },
      setIncludes: function setIncludes(t) {
        Gx = t.toLowerCase().split(/[\s,]+/);
      },
      getIncludes: function getIncludes() {
        return Gx;
      },
      setExcludes: function setExcludes(t) {
        Xx = t.toLowerCase().split(/[\s,]+/);
      },
      getExcludes: function getExcludes() {
        return Xx;
      },
      setClickEvent: function setClickEvent(t, e, n) {
        t.split(",").forEach(function (t) {
          !function (t, e, n) {
            if ("loose" === Jv().securityLevel && void 0 !== e) {
              var r = [];

              if ("string" == typeof n) {
                r = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                for (var i = 0; i < r.length; i++) {
                  var a = r[i].trim();
                  '"' === a.charAt(0) && '"' === a.charAt(a.length - 1) && (a = a.substr(1, a.length - 2)), r[i] = a;
                }
              }

              0 === r.length && r.push(t), void 0 !== gw(t) && bw(t, function () {
                var t;
                Hv.runFunc.apply(Hv, [e].concat(function (t) {
                  if (Array.isArray(t)) return Ux(t);
                }(t = r) || function (t) {
                  if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                }(t) || function (t, e) {
                  if (t) {
                    if ("string" == typeof t) return Ux(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ux(t, e) : void 0;
                  }
                }(t) || function () {
                  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }()));
              });
            }
          }(t, e, n);
        }), vw(t, "clickable");
      },
      setLink: function setLink(t, e) {
        var n = e;
        "loose" !== Jv().securityLevel && (n = (0, Om.sanitizeUrl)(e)), t.split(",").forEach(function (t) {
          void 0 !== gw(t) && (bw(t, function () {
            window.open(n, "_self");
          }), Zx[t] = n);
        }), vw(t, "clickable");
      },
      getLinks: function getLinks() {
        return Zx;
      },
      bindFunctions: function bindFunctions(t) {
        nw.forEach(function (e) {
          e(t);
        });
      },
      durationToDate: lw,
      isInvalidDate: ow
    };

    function xw(t, e, n) {
      for (var r = !0; r;) {
        r = !1, n.forEach(function (n) {
          var i = new RegExp("^\\s*" + n + "\\s*$");
          t[0].match(i) && (e[n] = !0, t.shift(1), r = !0);
        });
      }
    }

    var ww,
        kw = n(9959),
        Tw = n.n(kw);
    kw.parser.yy = _w;

    var Ew = function Ew(t, e) {
      var n = Jv().gantt;
      kw.parser.yy.clear(), kw.parser.parse(t);
      var r,
          a = Jv().securityLevel;
      "sandbox" === a && (r = au("#i" + e));
      var o = au("sandbox" === a ? r.nodes()[0].contentDocument.body : "body"),
          s = "sandbox" === a ? r.nodes()[0].contentDocument : document,
          c = s.getElementById(e);
      void 0 === (ww = c.parentElement.offsetWidth) && (ww = 1200), void 0 !== n.useWidth && (ww = n.useWidth);
      var h = kw.parser.yy.getTasks(),
          f = h.length * (n.barHeight + n.barGap) + 2 * n.topPadding;
      c.setAttribute("viewBox", "0 0 " + ww + " " + f);

      for (var d = o.select('[id="'.concat(e, '"]')), p = function () {
        return Zi.apply(qs(mo, vo, Ga, Wa, Pa, Ra, La, Oa, Na, ko).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
      }().domain([l(h, function (t) {
        return t.startTime;
      }), u(h, function (t) {
        return t.endTime;
      })]).rangeRound([0, ww - n.leftPadding - n.rightPadding]), y = [], g = 0; g < h.length; g++) {
        y.push(h[g].type);
      }

      var m = y;
      y = function (t) {
        for (var e = {}, n = [], r = 0, i = t.length; r < i; ++r) {
          Object.prototype.hasOwnProperty.call(e, t[r]) || (e[t[r]] = !0, n.push(t[r]));
        }

        return n;
      }(y), h.sort(function (t, e) {
        var n = t.startTime,
            r = e.startTime,
            i = 0;
        return n > r ? i = 1 : n < r && (i = -1), i;
      }), function (t, r, a) {
        var o = n.barHeight,
            c = o + n.barGap,
            u = n.topPadding,
            l = n.leftPadding;
        fa().domain([0, y.length]).range(["#00B9FA", "#F95002"]).interpolate(jr), function (t, e, r, a, o, s, c, u) {
          var l = s.reduce(function (t, e) {
            var n = e.startTime;
            return t ? Math.min(t, n) : n;
          }, 0),
              h = s.reduce(function (t, e) {
            var n = e.endTime;
            return t ? Math.max(t, n) : n;
          }, 0),
              f = kw.parser.yy.getDateFormat();

          if (l && h) {
            for (var y = [], g = null, m = i()(l); m.valueOf() <= h;) {
              kw.parser.yy.isInvalidDate(m, f, c, u) ? g ? g.end = m.clone() : g = {
                start: m.clone(),
                end: m.clone()
              } : g && (y.push(g), g = null), m.add(1, "d");
            }

            d.append("g").selectAll("rect").data(y).enter().append("rect").attr("id", function (t) {
              return "exclude-" + t.start.format("YYYY-MM-DD");
            }).attr("x", function (t) {
              return p(t.start) + r;
            }).attr("y", n.gridLineStartPadding).attr("width", function (t) {
              var e = t.end.clone().add(1, "day");
              return p(e) - p(t.start);
            }).attr("height", o - e - n.gridLineStartPadding).attr("transform-origin", function (e, n) {
              return (p(e.start) + r + .5 * (p(e.end) - p(e.start))).toString() + "px " + (n * t + .5 * o).toString() + "px";
            }).attr("class", "exclude-range");
          }
        }(c, u, l, 0, a, t, kw.parser.yy.getExcludes(), kw.parser.yy.getIncludes()), function (t, e, r, i) {
          var a,
              o = (a = p, v(3, a)).tickSize(-i + e + n.gridLineStartPadding).tickFormat(Yl(kw.parser.yy.getAxisFormat() || n.axisFormat || "%Y-%m-%d"));

          if (d.append("g").attr("class", "grid").attr("transform", "translate(" + t + ", " + (i - 50) + ")").call(o).selectAll("text").style("text-anchor", "middle").attr("fill", "#000").attr("stroke", "none").attr("font-size", 10).attr("dy", "1em"), _w.topAxisEnabled() || n.topAxis) {
            var s = function (t) {
              return v(1, t);
            }(p).tickSize(-i + e + n.gridLineStartPadding).tickFormat(Yl(kw.parser.yy.getAxisFormat() || n.axisFormat || "%Y-%m-%d"));

            d.append("g").attr("class", "grid").attr("transform", "translate(" + t + ", " + e + ")").call(s).selectAll("text").style("text-anchor", "middle").attr("fill", "#000").attr("stroke", "none").attr("font-size", 10);
          }
        }(l, u, 0, a), function (t, r, i, a, o, s, c) {
          d.append("g").selectAll("rect").data(t).enter().append("rect").attr("x", 0).attr("y", function (t, e) {
            return t.order * r + i - 2;
          }).attr("width", function () {
            return c - n.rightPadding / 2;
          }).attr("height", r).attr("class", function (t) {
            for (var e = 0; e < y.length; e++) {
              if (t.type === y[e]) return "section section" + e % n.numberSectionStyles;
            }

            return "section section0";
          });

          var u = d.append("g").selectAll("rect").data(t).enter(),
              l = _w.getLinks();

          if (u.append("rect").attr("id", function (t) {
            return t.id;
          }).attr("rx", 3).attr("ry", 3).attr("x", function (t) {
            return t.milestone ? p(t.startTime) + a + .5 * (p(t.endTime) - p(t.startTime)) - .5 * o : p(t.startTime) + a;
          }).attr("y", function (t, e) {
            return t.order * r + i;
          }).attr("width", function (t) {
            return t.milestone ? o : p(t.renderEndTime || t.endTime) - p(t.startTime);
          }).attr("height", o).attr("transform-origin", function (t, e) {
            return e = t.order, (p(t.startTime) + a + .5 * (p(t.endTime) - p(t.startTime))).toString() + "px " + (e * r + i + .5 * o).toString() + "px";
          }).attr("class", function (t) {
            var e = "";
            t.classes.length > 0 && (e = t.classes.join(" "));

            for (var r = 0, i = 0; i < y.length; i++) {
              t.type === y[i] && (r = i % n.numberSectionStyles);
            }

            var a = "";
            return t.active ? t.crit ? a += " activeCrit" : a = " active" : t.done ? a = t.crit ? " doneCrit" : " done" : t.crit && (a += " crit"), 0 === a.length && (a = " task"), t.milestone && (a = " milestone " + a), "task" + (a += r) + " " + e;
          }), u.append("text").attr("id", function (t) {
            return t.id + "-text";
          }).text(function (t) {
            return t.task;
          }).attr("font-size", n.fontSize).attr("x", function (t) {
            var e = p(t.startTime),
                r = p(t.renderEndTime || t.endTime);
            t.milestone && (e += .5 * (p(t.endTime) - p(t.startTime)) - .5 * o), t.milestone && (r = e + o);
            var i = this.getBBox().width;
            return i > r - e ? r + i + 1.5 * n.leftPadding > c ? e + a - 5 : r + a + 5 : (r - e) / 2 + e + a;
          }).attr("y", function (t, e) {
            return t.order * r + n.barHeight / 2 + (n.fontSize / 2 - 2) + i;
          }).attr("text-height", o).attr("class", function (t) {
            var e = p(t.startTime),
                r = p(t.endTime);
            t.milestone && (r = e + o);
            var i = this.getBBox().width,
                a = "";
            t.classes.length > 0 && (a = t.classes.join(" "));

            for (var s = 0, u = 0; u < y.length; u++) {
              t.type === y[u] && (s = u % n.numberSectionStyles);
            }

            var l = "";
            return t.active && (l = t.crit ? "activeCritText" + s : "activeText" + s), t.done ? l = t.crit ? l + " doneCritText" + s : l + " doneText" + s : t.crit && (l = l + " critText" + s), t.milestone && (l += " milestoneText"), i > r - e ? r + i + 1.5 * n.leftPadding > c ? a + " taskTextOutsideLeft taskTextOutside" + s + " " + l : a + " taskTextOutsideRight taskTextOutside" + s + " " + l + " width-" + i : a + " taskText taskText" + s + " " + l + " width-" + i;
          }), "sandbox" === Jv().securityLevel) {
            var h;
            h = au("#i" + e), au(h.nodes()[0].contentDocument.body);
            var f = h.nodes()[0].contentDocument;
            u.filter(function (t) {
              return void 0 !== l[t.id];
            }).each(function (t) {
              var e = f.querySelector("#" + t.id),
                  n = f.querySelector("#" + t.id + "-text"),
                  r = e.parentNode,
                  i = f.createElement("a");
              i.setAttribute("xlink:href", l[t.id]), i.setAttribute("target", "_top"), r.appendChild(i), i.appendChild(e), i.appendChild(n);
            });
          }
        }(t, c, u, l, o, 0, r), function (t, e) {
          for (var r = [], i = 0, a = 0; a < y.length; a++) {
            r[a] = [y[a], (o = y[a], c = m, function (t) {
              for (var e = t.length, n = {}; e;) {
                n[t[--e]] = (n[t[e]] || 0) + 1;
              }

              return n;
            }(c)[o] || 0)];
          }

          var o, c;
          d.append("g").selectAll("text").data(r).enter().append(function (t) {
            var e = t[0].split(Um.lineBreakRegex),
                n = -(e.length - 1) / 2,
                r = s.createElementNS("http://www.w3.org/2000/svg", "text");
            r.setAttribute("dy", n + "em");

            for (var i = 0; i < e.length; i++) {
              var a = s.createElementNS("http://www.w3.org/2000/svg", "tspan");
              a.setAttribute("alignment-baseline", "central"), a.setAttribute("x", "10"), i > 0 && a.setAttribute("dy", "1em"), a.textContent = e[i], r.appendChild(a);
            }

            return r;
          }).attr("x", 10).attr("y", function (n, a) {
            if (!(a > 0)) return n[1] * t / 2 + e;

            for (var o = 0; o < a; o++) {
              return i += r[a - 1][1], n[1] * t / 2 + i * t + e;
            }
          }).attr("font-size", n.sectionFontSize).attr("font-size", n.sectionFontSize).attr("class", function (t) {
            for (var e = 0; e < y.length; e++) {
              if (t[0] === y[e]) return "sectionTitle sectionTitle" + e % n.numberSectionStyles;
            }

            return "sectionTitle";
          });
        }(c, u), function (t, e, r, i) {
          var a = _w.getTodayMarker();

          if ("off" !== a) {
            var o = d.append("g").attr("class", "today"),
                s = new Date(),
                c = o.append("line");
            c.attr("x1", p(s) + t).attr("x2", p(s) + t).attr("y1", n.titleTopMargin).attr("y2", i - n.titleTopMargin).attr("class", "today"), "" !== a && c.attr("style", a.replace(/,/g, ";"));
          }
        }(l, 0, 0, a);
      }(h, ww, f), zv(d, f, ww, n.useMaxWidth), d.append("text").text(kw.parser.yy.getTitle()).attr("x", ww / 2).attr("y", n.titleTopMargin).attr("class", "titleText");
    };

    var Cw = {},
        Sw = null,
        Aw = {
      master: Sw
    },
        Mw = "master",
        Nw = "LR",
        Dw = 0;

    function Ow() {
      return Bv({
        length: 7
      });
    }

    function Bw(t, e) {
      o.debug("Entering isfastforwardable:", t.id, e.id);

      for (var n = 0; t.seq <= e.seq && t !== e && n < 1e3 && (n++, null != e.parent);) {
        if (Array.isArray(e.parent)) return o.debug("In merge commit:", e.parent), Bw(t, Cw[e.parent[0]]) || Bw(t, Cw[e.parent[1]]);
        e = Cw[e.parent];
      }

      return o.debug(t.id, e.id), t.id === e.id;
    }

    var Lw = {};

    function Iw(t, e, n) {
      var r = t.indexOf(e);
      -1 === r ? t.push(n) : t.splice(r, 1, n);
    }

    function Rw(t) {
      var e = t.reduce(function (t, e) {
        return t.seq > e.seq ? t : e;
      }, t[0]),
          n = "";
      t.forEach(function (t) {
        n += t === e ? "\t*" : "\t|";
      });
      var r,
          i,
          a,
          s = [n, e.id, e.seq];

      for (var c in Aw) {
        Aw[c] === e.id && s.push(c);
      }

      if (o.debug(s.join(" ")), Array.isArray(e.parent)) {
        var u = Cw[e.parent[0]];
        Iw(t, e, u), t.push(Cw[e.parent[1]]);
      } else {
        if (null == e.parent) return;
        var l = Cw[e.parent];
        Iw(t, e, l);
      }

      r = t, i = function i(t) {
        return t.id;
      }, a = Object.create(null), Rw(t = r.reduce(function (t, e) {
        var n = i(e);
        return a[n] || (a[n] = !0, t.push(e)), t;
      }, []));
    }

    var Fw = function Fw() {
      var t = Object.keys(Cw).map(function (t) {
        return Cw[t];
      });
      return t.forEach(function (t) {
        o.debug(t.id);
      }), t.sort(function (t, e) {
        return e.seq - t.seq;
      }), t;
    };

    var Pw = {
      setDirection: function setDirection(t) {
        Nw = t;
      },
      setOptions: function setOptions(t) {
        o.debug("options str", t), t = (t = t && t.trim()) || "{}";

        try {
          Lw = JSON.parse(t);
        } catch (t) {
          o.error("error while parsing gitGraph options", t.message);
        }
      },
      getOptions: function getOptions() {
        return Lw;
      },
      commit: function commit(t) {
        var e = {
          id: Ow(),
          message: t,
          seq: Dw++,
          parent: null == Sw ? null : Sw.id
        };
        Sw = e, Cw[e.id] = e, Aw[Mw] = e.id, o.debug("in pushCommit " + e.id);
      },
      branch: function branch(t) {
        Aw[t] = null != Sw ? Sw.id : null, o.debug("in createBranch");
      },
      merge: function merge(t) {
        var e = Cw[Aw[Mw]],
            n = Cw[Aw[t]];
        if (function (t, e) {
          return t.seq > e.seq && Bw(e, t);
        }(e, n)) o.debug("Already merged");else {
          if (Bw(e, n)) Aw[Mw] = Aw[t], Sw = Cw[Aw[Mw]];else {
            var r = {
              id: Ow(),
              message: "merged branch " + t + " into " + Mw,
              seq: Dw++,
              parent: [null == Sw ? null : Sw.id, Aw[t]]
            };
            Sw = r, Cw[r.id] = r, Aw[Mw] = r.id;
          }
          o.debug(Aw), o.debug("in mergeBranch");
        }
      },
      checkout: function checkout(t) {
        o.debug("in checkout");
        var e = Aw[Mw = t];
        Sw = Cw[e];
      },
      reset: function reset(t) {
        o.debug("in reset", t);
        var e = t.split(":")[0],
            n = parseInt(t.split(":")[1]),
            r = "HEAD" === e ? Sw : Cw[Aw[e]];

        for (o.debug(r, n); n > 0;) {
          if (n--, !(r = Cw[r.parent])) {
            var i = "Critical error - unique parent commit not found during reset";
            throw o.error(i), i;
          }
        }

        Sw = r, Aw[Mw] = r.id;
      },
      prettyPrint: function prettyPrint() {
        o.debug(Cw), Rw([Fw()[0]]);
      },
      clear: function clear() {
        Cw = {}, Aw = {
          master: Sw = null
        }, Mw = "master", Dw = 0;
      },
      getBranchesAsObjArray: function getBranchesAsObjArray() {
        var t = [];

        for (var e in Aw) {
          t.push({
            name: e,
            commit: Cw[Aw[e]]
          });
        }

        return t;
      },
      getBranches: function getBranches() {
        return Aw;
      },
      getCommits: function getCommits() {
        return Cw;
      },
      getCommitsArray: Fw,
      getCurrentBranch: function getCurrentBranch() {
        return Mw;
      },
      getDirection: function getDirection() {
        return Nw;
      },
      getHead: function getHead() {
        return Sw;
      }
    };
    var jw,
        Yw = n(2553),
        zw = n.n(Yw),
        Uw = {},
        qw = {
      nodeSpacing: 150,
      nodeFillColor: "yellow",
      nodeStrokeWidth: 2,
      nodeStrokeColor: "grey",
      lineStrokeWidth: 4,
      branchOffset: 50,
      lineColor: "grey",
      leftMargin: 50,
      branchColors: ["#442f74", "#983351", "#609732", "#AA9A39"],
      nodeRadius: 10,
      nodeLabel: {
        width: 75,
        height: 100,
        x: -25,
        y: 0
      }
    },
        Hw = {};

    function $w(t, e, n, r) {
      var i = Av(r, Vu),
          a = qw.branchColors[n % qw.branchColors.length],
          o = zu().x(function (t) {
        return Math.round(t.x);
      }).y(function (t) {
        return Math.round(t.y);
      }).curve(i);
      t.append("svg:path").attr("d", o(e)).style("stroke", a).style("stroke-width", qw.lineStrokeWidth).style("fill", "none");
    }

    function Ww(t, e) {
      e = e || t.node().getBBox();
      var n = t.node().getCTM();
      return {
        left: n.e + e.x * n.a,
        top: n.f + e.y * n.d,
        width: e.width,
        height: e.height
      };
    }

    function Vw(t, e, n, r, i) {
      o.debug("svgDrawLineForCommits: ", e, n);
      var a = Ww(t.select("#node-" + e + " circle")),
          s = Ww(t.select("#node-" + n + " circle"));

      switch (r) {
        case "LR":
          if (a.left - s.left > qw.nodeSpacing) {
            var c = {
              x: a.left - qw.nodeSpacing,
              y: s.top + s.height / 2
            };
            $w(t, [c, {
              x: s.left + s.width,
              y: s.top + s.height / 2
            }], i, "linear"), $w(t, [{
              x: a.left,
              y: a.top + a.height / 2
            }, {
              x: a.left - qw.nodeSpacing / 2,
              y: a.top + a.height / 2
            }, {
              x: a.left - qw.nodeSpacing / 2,
              y: c.y
            }, c], i);
          } else $w(t, [{
            x: a.left,
            y: a.top + a.height / 2
          }, {
            x: a.left - qw.nodeSpacing / 2,
            y: a.top + a.height / 2
          }, {
            x: a.left - qw.nodeSpacing / 2,
            y: s.top + s.height / 2
          }, {
            x: s.left + s.width,
            y: s.top + s.height / 2
          }], i);

          break;

        case "BT":
          if (s.top - a.top > qw.nodeSpacing) {
            var u = {
              x: s.left + s.width / 2,
              y: a.top + a.height + qw.nodeSpacing
            };
            $w(t, [u, {
              x: s.left + s.width / 2,
              y: s.top
            }], i, "linear"), $w(t, [{
              x: a.left + a.width / 2,
              y: a.top + a.height
            }, {
              x: a.left + a.width / 2,
              y: a.top + a.height + qw.nodeSpacing / 2
            }, {
              x: s.left + s.width / 2,
              y: u.y - qw.nodeSpacing / 2
            }, u], i);
          } else $w(t, [{
            x: a.left + a.width / 2,
            y: a.top + a.height
          }, {
            x: a.left + a.width / 2,
            y: a.top + qw.nodeSpacing / 2
          }, {
            x: s.left + s.width / 2,
            y: s.top - qw.nodeSpacing / 2
          }, {
            x: s.left + s.width / 2,
            y: s.top
          }], i);

      }
    }

    function Gw(t, e) {
      return t.select(e).node().cloneNode(!0);
    }

    function Xw(t, e, n, r) {
      var i,
          a = Object.keys(Uw).length;

      if ("string" == typeof e) {
        var s = 0;

        do {
          if (s++, i = Uw[e], o.debug("in renderCommitHistory", i.id, i.seq), t.select("#node-" + e).size() > 0) return;
          t.append(function () {
            return Gw(t, "#def-commit");
          }).attr("class", "commit").attr("id", function () {
            return "node-" + i.id;
          }).attr("transform", function () {
            switch (r) {
              case "LR":
                return "translate(" + (i.seq * qw.nodeSpacing + qw.leftMargin) + ", " + jw * qw.branchOffset + ")";

              case "BT":
                return "translate(" + (jw * qw.branchOffset + qw.leftMargin) + ", " + (a - i.seq) * qw.nodeSpacing + ")";
            }
          }).attr("fill", qw.nodeFillColor).attr("stroke", qw.nodeStrokeColor).attr("stroke-width", qw.nodeStrokeWidth);
          var c = void 0;

          for (var u in n) {
            if (n[u].commit === i) {
              c = n[u];
              break;
            }
          }

          c && (o.debug("found branch ", c.name), t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "branch-label").text(c.name + ", ")), t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "commit-id").text(i.id), "" !== i.message && "BT" === r && t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "commit-msg").text(", " + i.message), e = i.parent;
        } while (e && Uw[e] && s < 1e3);
      }

      Array.isArray(e) && (o.debug("found merge commmit", e), Xw(t, e[0], n, r), jw++, Xw(t, e[1], n, r), jw--);
    }

    function Zw(t, e, n, r) {
      r = r || 0;

      for (var i = 0; e.seq > 0 && !e.lineDrawn && i < 1e3;) {
        i++, "string" == typeof e.parent ? (Vw(t, e.id, e.parent, n, r), e.lineDrawn = !0, e = Uw[e.parent]) : Array.isArray(e.parent) && (Vw(t, e.id, e.parent[0], n, r), Vw(t, e.id, e.parent[1], n, r + 1), Zw(t, Uw[e.parent[1]], n, r + 1), e.lineDrawn = !0, e = Uw[e.parent[0]]);
      }
    }

    var Qw = function Qw(t) {
      Hw = t;
    };

    var Kw = "",
        Jw = !1;
    var tk = {
      setMessage: function setMessage(t) {
        o.debug("Setting message to: " + t), Kw = t;
      },
      getMessage: function getMessage() {
        return Kw;
      },
      setInfo: function setInfo(t) {
        Jw = t;
      },
      getInfo: function getInfo() {
        return Jw;
      }
    };
    var ek = n(6765),
        nk = n.n(ek),
        rk = {};

    var ik = function ik(t) {
      Object.keys(t).forEach(function (e) {
        rk[e] = t[e];
      });
    };

    var ak = n(7062),
        ok = n.n(ak),
        sk = {},
        ck = "",
        uk = !1;
    var lk = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().pie;
      },
      addSection: function addSection(t, e) {
        void 0 === sk[t] && (sk[t] = e, o.debug("Added new section :", t));
      },
      getSections: function getSections() {
        return sk;
      },
      cleanupValue: function cleanupValue(t) {
        return ":" === t.substring(0, 1) ? (t = t.substring(1).trim(), Number(t.trim())) : Number(t.trim());
      },
      clear: function clear() {
        sk = {}, ck = "", uk = !1;
      },
      setTitle: function setTitle(t) {
        ck = t;
      },
      getTitle: function getTitle() {
        return ck;
      },
      setShowData: function setShowData(t) {
        uk = t;
      },
      getShowData: function getShowData() {
        return uk;
      }
    };
    var hk,
        fk = Jv();

    var dk = function dk(t, e) {
      try {
        fk = Jv();
        var n = ok().parser;
        n.yy = lk, o.debug("Rendering info diagram\n" + t);
        var r,
            i = Jv().securityLevel;
        "sandbox" === i && (r = au("#i" + e));
        var a = au("sandbox" === i ? r.nodes()[0].contentDocument.body : "body"),
            s = "sandbox" === i ? r.nodes()[0].contentDocument : document;
        n.yy.clear(), n.parse(t), o.debug("Parsed info diagram");
        var c = s.getElementById(e);
        void 0 === (hk = c.parentElement.offsetWidth) && (hk = 1200), void 0 !== fk.useWidth && (hk = fk.useWidth), void 0 !== fk.pie.useWidth && (hk = fk.pie.useWidth);
        var u = a.select("#" + e);
        zv(u, 450, hk, fk.pie.useMaxWidth), c.setAttribute("viewBox", "0 0 " + hk + " 450");
        var l = Math.min(hk, 450) / 2 - 40,
            h = u.append("g").attr("transform", "translate(" + hk / 2 + ",225)"),
            f = lk.getSections(),
            d = 0;
        Object.keys(f).forEach(function (t) {
          d += f[t];
        });

        var p = fk.themeVariables,
            y = [p.pie1, p.pie2, p.pie3, p.pie4, p.pie5, p.pie6, p.pie7, p.pie8, p.pie9, p.pie10, p.pie11, p.pie12],
            g = ma().range(y),
            m = function () {
          var t = qu,
              e = Uu,
              n = null,
              r = pu(0),
              i = pu(Eu),
              a = pu(0);

          function o(o) {
            var s,
                c,
                u,
                l,
                h,
                f = (o = Ru(o)).length,
                d = 0,
                p = new Array(f),
                y = new Array(f),
                g = +r.apply(this, arguments),
                m = Math.min(Eu, Math.max(-Eu, i.apply(this, arguments) - g)),
                v = Math.min(Math.abs(m) / f, a.apply(this, arguments)),
                b = v * (m < 0 ? -1 : 1);

            for (s = 0; s < f; ++s) {
              (h = y[p[s] = s] = +t(o[s], s, o)) > 0 && (d += h);
            }

            for (null != e ? p.sort(function (t, n) {
              return e(y[t], y[n]);
            }) : null != n && p.sort(function (t, e) {
              return n(o[t], o[e]);
            }), s = 0, u = d ? (m - f * b) / d : 0; s < f; ++s, g = l) {
              c = p[s], l = g + ((h = y[c]) > 0 ? h * u : 0) + b, y[c] = {
                data: o[c],
                index: s,
                value: h,
                startAngle: g,
                endAngle: l,
                padAngle: v
              };
            }

            return y;
          }

          return o.value = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : pu(+e), o) : t;
          }, o.sortValues = function (t) {
            return arguments.length ? (e = t, n = null, o) : e;
          }, o.sort = function (t) {
            return arguments.length ? (n = t, e = null, o) : n;
          }, o.startAngle = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : pu(+t), o) : r;
          }, o.endAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : pu(+t), o) : i;
          }, o.padAngle = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : pu(+t), o) : a;
          }, o;
        }().value(function (t) {
          return t[1];
        }),
            v = m(Object.entries(f)),
            b = Iu().innerRadius(0).outerRadius(l);

        h.selectAll("mySlices").data(v).enter().append("path").attr("d", b).attr("fill", function (t) {
          return g(t.data[0]);
        }).attr("class", "pieCircle"), h.selectAll("mySlices").data(v).enter().append("text").text(function (t) {
          return (t.data[1] / d * 100).toFixed(0) + "%";
        }).attr("transform", function (t) {
          return "translate(" + b.centroid(t) + ")";
        }).style("text-anchor", "middle").attr("class", "slice"), h.append("text").text(n.yy.getTitle()).attr("x", 0).attr("y", -200).attr("class", "pieTitleText");

        var _ = h.selectAll(".legend").data(g.domain()).enter().append("g").attr("class", "legend").attr("transform", function (t, e) {
          return "translate(216," + (22 * e - 22 * g.domain().length / 2) + ")";
        });

        _.append("rect").attr("width", 18).attr("height", 18).style("fill", g).style("stroke", g), _.data(v).append("text").attr("x", 22).attr("y", 14).text(function (t) {
          return n.yy.getShowData() || fk.showData || fk.pie.showData ? t.data[0] + " [" + t.data[1] + "]" : t.data[0];
        });
      } catch (t) {
        o.error("Error while rendering info diagram"), o.error(t);
      }
    };

    var pk = n(3176),
        yk = n.n(pk),
        gk = [],
        mk = {},
        vk = {},
        bk = {},
        _k = {};
    var xk = {
      RequirementType: {
        REQUIREMENT: "Requirement",
        FUNCTIONAL_REQUIREMENT: "Functional Requirement",
        INTERFACE_REQUIREMENT: "Interface Requirement",
        PERFORMANCE_REQUIREMENT: "Performance Requirement",
        PHYSICAL_REQUIREMENT: "Physical Requirement",
        DESIGN_CONSTRAINT: "Design Constraint"
      },
      RiskLevel: {
        LOW_RISK: "Low",
        MED_RISK: "Medium",
        HIGH_RISK: "High"
      },
      VerifyType: {
        VERIFY_ANALYSIS: "Analysis",
        VERIFY_DEMONSTRATION: "Demonstration",
        VERIFY_INSPECTION: "Inspection",
        VERIFY_TEST: "Test"
      },
      Relationships: {
        CONTAINS: "contains",
        COPIES: "copies",
        DERIVES: "derives",
        SATISFIES: "satisfies",
        VERIFIES: "verifies",
        REFINES: "refines",
        TRACES: "traces"
      },
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().req;
      },
      addRequirement: function addRequirement(t, e) {
        return void 0 === vk[t] && (vk[t] = {
          name: t,
          type: e,
          id: mk.id,
          text: mk.text,
          risk: mk.risk,
          verifyMethod: mk.verifyMethod
        }), mk = {}, vk[t];
      },
      getRequirements: function getRequirements() {
        return vk;
      },
      setNewReqId: function setNewReqId(t) {
        void 0 !== mk && (mk.id = t);
      },
      setNewReqText: function setNewReqText(t) {
        void 0 !== mk && (mk.text = t);
      },
      setNewReqRisk: function setNewReqRisk(t) {
        void 0 !== mk && (mk.risk = t);
      },
      setNewReqVerifyMethod: function setNewReqVerifyMethod(t) {
        void 0 !== mk && (mk.verifyMethod = t);
      },
      addElement: function addElement(t) {
        return void 0 === _k[t] && (_k[t] = {
          name: t,
          type: bk.type,
          docRef: bk.docRef
        }, o.info("Added new requirement: ", t)), bk = {}, _k[t];
      },
      getElements: function getElements() {
        return _k;
      },
      setNewElementType: function setNewElementType(t) {
        void 0 !== bk && (bk.type = t);
      },
      setNewElementDocRef: function setNewElementDocRef(t) {
        void 0 !== bk && (bk.docRef = t);
      },
      addRelationship: function addRelationship(t, e, n) {
        gk.push({
          type: t,
          src: e,
          dst: n
        });
      },
      getRelationships: function getRelationships() {
        return gk;
      },
      clear: function clear() {
        gk = [], mk = {}, vk = {}, bk = {}, _k = {};
      }
    };
    var wk = {
      CONTAINS: "contains",
      ARROW: "arrow"
    };
    var kk = wk;

    var Tk = {},
        Ek = 0,
        Ck = function Ck(t, e) {
      return t.insert("rect", "#" + e).attr("class", "req reqBox").attr("x", 0).attr("y", 0).attr("width", Tk.rect_min_width + "px").attr("height", Tk.rect_min_height + "px");
    },
        Sk = function Sk(t, e, n) {
      var r = Tk.rect_min_width / 2,
          i = t.append("text").attr("class", "req reqLabel reqTitle").attr("id", e).attr("x", r).attr("y", Tk.rect_padding).attr("dominant-baseline", "hanging"),
          a = 0;
      n.forEach(function (t) {
        0 == a ? i.append("tspan").attr("text-anchor", "middle").attr("x", Tk.rect_min_width / 2).attr("dy", 0).text(t) : i.append("tspan").attr("text-anchor", "middle").attr("x", Tk.rect_min_width / 2).attr("dy", .75 * Tk.line_height).text(t), a++;
      });
      var o = 1.5 * Tk.rect_padding + a * Tk.line_height * .75;
      return t.append("line").attr("class", "req-title-line").attr("x1", "0").attr("x2", Tk.rect_min_width).attr("y1", o).attr("y2", o), {
        titleNode: i,
        y: o
      };
    },
        Ak = function Ak(t, e, n, r) {
      var i = t.append("text").attr("class", "req reqLabel").attr("id", e).attr("x", Tk.rect_padding).attr("y", r).attr("dominant-baseline", "hanging"),
          a = 0,
          o = [];
      return n.forEach(function (t) {
        for (var e = t.length; e > 30 && a < 3;) {
          var n = t.substring(0, 30);
          e = (t = t.substring(30, t.length)).length, o[o.length] = n, a++;
        }

        if (3 == a) {
          var r = o[o.length - 1];
          o[o.length - 1] = r.substring(0, r.length - 4) + "...";
        } else o[o.length] = t;

        a = 0;
      }), o.forEach(function (t) {
        i.append("tspan").attr("x", Tk.rect_padding).attr("dy", Tk.line_height).text(t);
      }), i;
    },
        Mk = function Mk(t) {
      return t.replace(/\s/g, "").replace(/\./g, "_");
    };

    var Nk = function Nk(t) {
      if (void 0 !== t) for (var e = Object.keys(t), n = 0; n < e.length; n++) {
        Tk[e[n]] = t[e[n]];
      }
    },
        Dk = function Dk(t, e) {
      pk.parser.yy = xk, pk.parser.yy.clear(), pk.parser.parse(t);
      var n,
          r = Jv().securityLevel;
      "sandbox" === r && (n = au("#i" + e));
      var i = au("sandbox" === r ? n.nodes()[0].contentDocument.body : "body"),
          a = ("sandbox" === r ? n.nodes()[0].contentDocument : document, i.select("[id='".concat(e, "']")));
      !function (t, e) {
        var n = t.append("defs").append("marker").attr("id", wk.CONTAINS + "_line_ending").attr("refX", 0).attr("refY", e.line_height / 2).attr("markerWidth", e.line_height).attr("markerHeight", e.line_height).attr("orient", "auto").append("g");
        n.append("circle").attr("cx", e.line_height / 2).attr("cy", e.line_height / 2).attr("r", e.line_height / 2).attr("fill", "none"), n.append("line").attr("x1", 0).attr("x2", e.line_height).attr("y1", e.line_height / 2).attr("y2", e.line_height / 2).attr("stroke-width", 1), n.append("line").attr("y1", 0).attr("y2", e.line_height).attr("x1", e.line_height / 2).attr("x2", e.line_height / 2).attr("stroke-width", 1), t.append("defs").append("marker").attr("id", wk.ARROW + "_line_ending").attr("refX", e.line_height).attr("refY", .5 * e.line_height).attr("markerWidth", e.line_height).attr("markerHeight", e.line_height).attr("orient", "auto").append("path").attr("d", "M0,0\n      L".concat(e.line_height, ",").concat(e.line_height / 2, "\n      M").concat(e.line_height, ",").concat(e.line_height / 2, "\n      L0,").concat(e.line_height)).attr("stroke-width", 1);
      }(a, Tk);
      var s = new (kb().Graph)({
        multigraph: !1,
        compound: !1,
        directed: !0
      }).setGraph({
        rankdir: Tk.layoutDirection,
        marginx: 20,
        marginy: 20,
        nodesep: 100,
        edgesep: 100,
        ranksep: 100
      }).setDefaultEdgeLabel(function () {
        return {};
      }),
          c = xk.getRequirements(),
          u = xk.getElements(),
          l = xk.getRelationships();
      !function (t, e, n) {
        Object.keys(t).forEach(function (r) {
          var i = t[r];
          r = Mk(r), o.info("Added new requirement: ", r);
          var a = n.append("g").attr("id", r),
              s = Ck(a, "req-" + r),
              u = Sk(a, r + "_title", ["<<".concat(i.type, ">>"), "".concat(i.name)]);
          Ak(a, r + "_body", ["Id: ".concat(i.id), "Text: ".concat(i.text), "Risk: ".concat(i.risk), "Verification: ".concat(i.verifyMethod)], u.y);
          var h = s.node().getBBox();
          e.setNode(r, {
            width: h.width,
            height: h.height,
            shape: "rect",
            id: r
          });
        });
      }(c, s, a), function (t, e, n) {
        Object.keys(t).forEach(function (r) {
          var i = t[r],
              a = Mk(r),
              o = n.append("g").attr("id", a),
              s = "element-" + a,
              c = Ck(o, s),
              l = Sk(o, s + "_title", ["<<Element>>", "".concat(r)]);
          Ak(o, s + "_body", ["Type: ".concat(i.type || "Not Specified"), "Doc Ref: ".concat(i.docRef || "None")], l.y);
          var f = c.node().getBBox();
          e.setNode(a, {
            width: f.width,
            height: f.height,
            shape: "rect",
            id: a
          });
        });
      }(u, s, a), function (t, e) {
        t.forEach(function (t) {
          var n = Mk(t.src),
              r = Mk(t.dst);
          e.setEdge(n, r, {
            relationship: t
          });
        });
      }(l, s), xb().layout(s), function (t, e) {
        e.nodes().forEach(function (n) {
          void 0 !== n && void 0 !== e.node(n) && (t.select("#" + n), t.select("#" + n).attr("transform", "translate(" + (e.node(n).x - e.node(n).width / 2) + "," + (e.node(n).y - e.node(n).height / 2) + " )"));
        });
      }(a, s), l.forEach(function (t) {
        !function (t, e, n, r) {
          var i = n.edge(Mk(e.src), Mk(e.dst)),
              a = zu().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          }),
              o = t.insert("path", "#" + r).attr("class", "er relationshipLine").attr("d", a(i.points)).attr("fill", "none");
          e.type == xk.Relationships.CONTAINS ? o.attr("marker-start", "url(" + Um.getUrl(Tk.arrowMarkerAbsolute) + "#" + e.type + "_line_ending)") : (o.attr("stroke-dasharray", "10,7"), o.attr("marker-end", "url(" + Um.getUrl(Tk.arrowMarkerAbsolute) + "#" + kk.ARROW + "_line_ending)")), function (t, e, n, r) {
            var i = e.node().getTotalLength(),
                a = e.node().getPointAtLength(.5 * i),
                o = "rel" + Ek;
            Ek++;
            var s = t.append("text").attr("class", "req relationshipLabel").attr("id", o).attr("x", a.x).attr("y", a.y).attr("text-anchor", "middle").attr("dominant-baseline", "middle").text(r).node().getBBox();
            t.insert("rect", "#" + o).attr("class", "req reqLabelBox").attr("x", a.x - s.width / 2).attr("y", a.y - s.height / 2).attr("width", s.width).attr("height", s.height).attr("fill", "white").attr("fill-opacity", "85%");
          }(t, o, 0, "<<".concat(e.type, ">>"));
        }(a, t, s, e);
      });
      var h = Tk.rect_padding,
          f = a.node().getBBox(),
          d = f.width + 2 * h,
          p = f.height + 2 * h;
      zv(a, p, d, Tk.useMaxWidth), a.attr("viewBox", "".concat(f.x - h, " ").concat(f.y - h, " ").concat(d, " ").concat(p));
    };

    var Ok = n(6876),
        Bk = n.n(Ok),
        Lk = void 0,
        Ik = {},
        Rk = [],
        Pk = "",
        jk = !1,
        Yk = !1,
        zk = !1,
        Uk = function Uk(t, e, n, r) {
      var i = Ik[t];
      i && e === i.name && null == n || (null != n && null != n.text || (n = {
        text: e,
        wrap: null,
        type: r
      }), null != r && null != n.text || (n = {
        text: e,
        wrap: null,
        type: r
      }), Ik[t] = {
        name: e,
        description: n.text,
        wrap: void 0 === n.wrap && Wk() || !!n.wrap,
        prevActor: Lk,
        links: {},
        properties: {},
        actorCnt: null,
        rectData: null,
        type: r || "participant"
      }, Lk && Ik[Lk] && (Ik[Lk].nextActor = t), Lk = t);
    },
        qk = function qk(t) {
      var e,
          n = 0;

      for (e = 0; e < Rk.length; e++) {
        Rk[e].type === Vk.ACTIVE_START && Rk[e].from.actor === t && n++, Rk[e].type === Vk.ACTIVE_END && Rk[e].from.actor === t && n--;
      }

      return n;
    },
        Hk = function Hk(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
        text: void 0,
        wrap: void 0
      },
          r = arguments.length > 3 ? arguments[3] : void 0;

      if (r === Vk.ACTIVE_END) {
        var i = qk(t.actor);

        if (i < 1) {
          var a = new Error("Trying to inactivate an inactive participant (" + t.actor + ")");
          throw a.hash = {
            text: "->>-",
            token: "->>-",
            line: "1",
            loc: {
              first_line: 1,
              last_line: 1,
              first_column: 1,
              last_column: 1
            },
            expected: ["'ACTIVE_PARTICIPANT'"]
          }, a;
        }
      }

      return Rk.push({
        from: t,
        to: e,
        message: n.text,
        wrap: void 0 === n.wrap && Wk() || !!n.wrap,
        type: r
      }), !0;
    },
        $k = function $k(t) {
      return Ik[t];
    },
        Wk = function Wk() {
      return zk;
    },
        Vk = {
      SOLID: 0,
      DOTTED: 1,
      NOTE: 2,
      SOLID_CROSS: 3,
      DOTTED_CROSS: 4,
      SOLID_OPEN: 5,
      DOTTED_OPEN: 6,
      LOOP_START: 10,
      LOOP_END: 11,
      ALT_START: 12,
      ALT_ELSE: 13,
      ALT_END: 14,
      OPT_START: 15,
      OPT_END: 16,
      ACTIVE_START: 17,
      ACTIVE_END: 18,
      PAR_START: 19,
      PAR_AND: 20,
      PAR_END: 21,
      RECT_START: 22,
      RECT_END: 23,
      SOLID_POINT: 24,
      DOTTED_POINT: 25
    },
        Gk = function Gk(t, e, n) {
      ({
        actor: t,
        placement: e,
        message: n.text,
        wrap: void 0 === n.wrap && Wk() || !!n.wrap
      });
      var i = [].concat(t, t);
      Rk.push({
        from: i[0],
        to: i[1],
        message: n.text,
        wrap: void 0 === n.wrap && Wk() || !!n.wrap,
        type: Vk.NOTE,
        placement: e
      });
    },
        Xk = function Xk(t, e) {
      var n = $k(t);

      try {
        var r = Fm(e.text, Jv());
        r = (r = r.replace(/&amp;/g, "&")).replace(/&equals;/g, "="), Zk(n, JSON.parse(r));
      } catch (t) {
        o.error("error while parsing actor link text", t);
      }
    };

    function Zk(t, e) {
      if (null == t.links) t.links = e;else for (var n in e) {
        t.links[n] = e[n];
      }
    }

    var Qk = function Qk(t, e) {
      var n = $k(t);

      try {
        var r = Fm(e.text, Jv());
        Kk(n, JSON.parse(r));
      } catch (t) {
        o.error("error while parsing actor properties text", t);
      }
    };

    function Kk(t, e) {
      if (null == t.properties) t.properties = e;else for (var n in e) {
        t.properties[n] = e[n];
      }
    }

    var Jk = function Jk(t, e) {
      var n = $k(t),
          r = document.getElementById(e.text);

      try {
        var i = r.innerHTML,
            a = JSON.parse(i);
        a.properties && Kk(n, a.properties), a.links && Zk(n, a.links);
      } catch (t) {
        o.error("error while parsing actor details text", t);
      }
    },
        tT = function tT(t) {
      Pk = t.text, jk = void 0 === t.wrap && Wk() || !!t.wrap;
    };

    var eT = {
      addActor: Uk,
      addMessage: function addMessage(t, e, n, r) {
        Rk.push({
          from: t,
          to: e,
          message: n.text,
          wrap: void 0 === n.wrap && Wk() || !!n.wrap,
          answer: r
        });
      },
      addSignal: Hk,
      addLinks: Xk,
      addDetails: Jk,
      addProperties: Qk,
      autoWrap: Wk,
      setWrap: function setWrap(t) {
        zk = t;
      },
      enableSequenceNumbers: function enableSequenceNumbers() {
        Yk = !0;
      },
      showSequenceNumbers: function showSequenceNumbers() {
        return Yk;
      },
      getMessages: function getMessages() {
        return Rk;
      },
      getActors: function getActors() {
        return Ik;
      },
      getActor: $k,
      getActorKeys: function getActorKeys() {
        return Object.keys(Ik);
      },
      getActorProperty: function getActorProperty(t, e) {
        if (void 0 !== t && void 0 !== t.properties) return t.properties[e];
      },
      getTitle: function getTitle() {
        return Pk;
      },
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().sequence;
      },
      getTitleWrapped: function getTitleWrapped() {
        return jk;
      },
      clear: function clear() {
        Ik = {}, Rk = [];
      },
      parseMessage: function parseMessage(t) {
        var e = t.trim(),
            n = {
          text: e.replace(/^[:]?(?:no)?wrap:/, "").trim(),
          wrap: null !== e.match(/^[:]?wrap:/) || null === e.match(/^[:]?nowrap:/) && void 0
        };
        return o.debug("parseMessage:", n), n;
      },
      LINETYPE: Vk,
      ARROWTYPE: {
        FILLED: 0,
        OPEN: 1
      },
      PLACEMENT: {
        LEFTOF: 0,
        RIGHTOF: 1,
        OVER: 2
      },
      addNote: Gk,
      setTitle: tT,
      apply: function t(e) {
        if (e instanceof Array) e.forEach(function (e) {
          t(e);
        });else switch (e.type) {
          case "addParticipant":
            Uk(e.actor, e.actor, e.description, "participant");
            break;

          case "addActor":
            Uk(e.actor, e.actor, e.description, "actor");
            break;

          case "activeStart":
          case "activeEnd":
            Hk(e.actor, void 0, void 0, e.signalType);
            break;

          case "addNote":
            Gk(e.actor, e.placement, e.text);
            break;

          case "addLinks":
            Xk(e.actor, e.text);
            break;

          case "addALink":
            !function (t, e) {
              var n = $k(t);

              try {
                var r = {},
                    i = Fm(e.text, Jv()),
                    a = i.indexOf("@"),
                    s = (i = (i = i.replace(/&amp;/g, "&")).replace(/&equals;/g, "=")).slice(0, a - 1).trim(),
                    c = i.slice(a + 1).trim();
                r[s] = c, Zk(n, r);
              } catch (t) {
                o.error("error while parsing actor link text", t);
              }
            }(e.actor, e.text);
            break;

          case "addProperties":
            Qk(e.actor, e.text);
            break;

          case "addDetails":
            Jk(e.actor, e.text);
            break;

          case "addMessage":
            Hk(e.from, e.to, e.msg, e.signalType);
            break;

          case "loopStart":
            Hk(void 0, void 0, e.loopText, e.signalType);
            break;

          case "loopEnd":
          case "rectEnd":
          case "optEnd":
          case "altEnd":
          case "parEnd":
            Hk(void 0, void 0, void 0, e.signalType);
            break;

          case "rectStart":
            Hk(void 0, void 0, e.color, e.signalType);
            break;

          case "optStart":
            Hk(void 0, void 0, e.optText, e.signalType);
            break;

          case "altStart":
          case "else":
            Hk(void 0, void 0, e.altText, e.signalType);
            break;

          case "setTitle":
            tT(e.text);
            break;

          case "parStart":
          case "and":
            Hk(void 0, void 0, e.parText, e.signalType);
        }
      }
    };

    var nT = [],
        rT = function rT(t, e) {
      var n = t.append("rect");
      return n.attr("x", e.x), n.attr("y", e.y), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("width", e.width), n.attr("height", e.height), n.attr("rx", e.rx), n.attr("ry", e.ry), void 0 !== e["class"] && n.attr("class", e["class"]), n;
    },
        iT = function iT(t, e) {
      var n;
      n = function n() {
        var n = document.querySelectorAll(t);
        0 !== n.length && (n[0].addEventListener("mouseover", function () {
          sT("actor" + e + "_popup");
        }), n[0].addEventListener("mouseout", function () {
          cT("actor" + e + "_popup");
        }));
      }, nT.push(n);
    },
        aT = function aT(t, e, n, r) {
      var i = t.append("image");
      i.attr("x", e), i.attr("y", n);
      var a = (0, Om.sanitizeUrl)(r);
      i.attr("xlink:href", a);
    },
        oT = function oT(t, e, n, r) {
      var i = t.append("use");
      i.attr("x", e), i.attr("y", n);
      var a = (0, Om.sanitizeUrl)(r);
      i.attr("xlink:href", "#" + a);
    },
        sT = function sT(t) {
      var e = document.getElementById(t);
      null != e && (e.style.display = "block");
    },
        cT = function cT(t) {
      var e = document.getElementById(t);
      null != e && (e.style.display = "none");
    },
        uT = function uT(t, e) {
      var n = 0,
          r = 0,
          i = e.text.split(Um.lineBreakRegex),
          a = [],
          o = 0,
          s = function s() {
        return e.y;
      };

      if (void 0 !== e.valign && void 0 !== e.textMargin && e.textMargin > 0) switch (e.valign) {
        case "top":
        case "start":
          s = function s() {
            return Math.round(e.y + e.textMargin);
          };

          break;

        case "middle":
        case "center":
          s = function s() {
            return Math.round(e.y + (n + r + e.textMargin) / 2);
          };

          break;

        case "bottom":
        case "end":
          s = function s() {
            return Math.round(e.y + (n + r + 2 * e.textMargin) - e.textMargin);
          };

      }
      if (void 0 !== e.anchor && void 0 !== e.textMargin && void 0 !== e.width) switch (e.anchor) {
        case "left":
        case "start":
          e.x = Math.round(e.x + e.textMargin), e.anchor = "start", e.dominantBaseline = "text-after-edge", e.alignmentBaseline = "middle";
          break;

        case "middle":
        case "center":
          e.x = Math.round(e.x + e.width / 2), e.anchor = "middle", e.dominantBaseline = "middle", e.alignmentBaseline = "middle";
          break;

        case "right":
        case "end":
          e.x = Math.round(e.x + e.width - e.textMargin), e.anchor = "end", e.dominantBaseline = "text-before-edge", e.alignmentBaseline = "middle";
      }

      for (var c = 0; c < i.length; c++) {
        var u = i[c];
        void 0 !== e.textMargin && 0 === e.textMargin && void 0 !== e.fontSize && (o = c * e.fontSize);
        var l = t.append("text");

        if (l.attr("x", e.x), l.attr("y", s()), void 0 !== e.anchor && l.attr("text-anchor", e.anchor).attr("dominant-baseline", e.dominantBaseline).attr("alignment-baseline", e.alignmentBaseline), void 0 !== e.fontFamily && l.style("font-family", e.fontFamily), void 0 !== e.fontSize && l.style("font-size", e.fontSize), void 0 !== e.fontWeight && l.style("font-weight", e.fontWeight), void 0 !== e.fill && l.attr("fill", e.fill), void 0 !== e["class"] && l.attr("class", e["class"]), void 0 !== e.dy ? l.attr("dy", e.dy) : 0 !== o && l.attr("dy", o), e.tspan) {
          var h = l.append("tspan");
          h.attr("x", e.x), void 0 !== e.fill && h.attr("fill", e.fill), h.text(u);
        } else l.text(u);

        void 0 !== e.valign && void 0 !== e.textMargin && e.textMargin > 0 && (r += (l._groups || l)[0][0].getBBox().height, n = r), a.push(l);
      }

      return a;
    },
        lT = function lT(t, e) {
      var n = t.append("polygon");
      return n.attr("points", function (t, e, n, r, i) {
        return t + "," + e + " " + (t + n) + "," + e + " " + (t + n) + "," + (e + r - 7) + " " + (t + n - 8.4) + "," + (e + r) + " " + t + "," + (e + r);
      }(e.x, e.y, e.width, e.height)), n.attr("class", "labelBox"), e.y = e.y + e.height / 2, uT(t, e), n;
    },
        hT = -1,
        fT = function fT(t, e) {
      t.selectAll && t.selectAll(".actor-line").attr("class", "200").attr("y2", e - 55);
    },
        dT = function dT() {
      return {
        x: 0,
        y: 0,
        fill: void 0,
        anchor: void 0,
        style: "#666",
        width: void 0,
        height: void 0,
        textMargin: 0,
        rx: 0,
        ry: 0,
        tspan: !0,
        valign: void 0
      };
    },
        pT = function pT() {
      return {
        x: 0,
        y: 0,
        fill: "#EDF2AE",
        stroke: "#666",
        width: 100,
        anchor: "start",
        height: 100,
        rx: 0,
        ry: 0
      };
    },
        yT = function () {
      function t(t, e, n, i, a, o, s) {
        r(e.append("text").attr("x", n + a / 2).attr("y", i + o / 2 + 5).style("text-anchor", "middle").text(t), s);
      }

      function e(t, e, n, i, a, o, s, c) {
        for (var u = c.actorFontSize, l = c.actorFontFamily, h = c.actorFontWeight, f = t.split(Um.lineBreakRegex), d = 0; d < f.length; d++) {
          var p = d * u - u * (f.length - 1) / 2,
              y = e.append("text").attr("x", n + a / 2).attr("y", i).style("text-anchor", "middle").style("font-size", u).style("font-weight", h).style("font-family", l);
          y.append("tspan").attr("x", n + a / 2).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
        }
      }

      function n(t, n, i, a, o, s, c, u) {
        var l = n.append("switch"),
            h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
        h.append("div").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, o, s, c, u), r(h, c);
      }

      function r(t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && t.attr(n, e[n]);
        }
      }

      return function (r) {
        return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
      };
    }(),
        gT = function () {
      function t(t, e, n, i, a, o, s) {
        r(e.append("text").attr("x", n).attr("y", i).style("text-anchor", "start").text(t), s);
      }

      function e(t, e, n, i, a, o, s, c) {
        for (var u = c.actorFontSize, l = c.actorFontFamily, h = c.actorFontWeight, f = t.split(Um.lineBreakRegex), d = 0; d < f.length; d++) {
          var p = d * u - u * (f.length - 1) / 2,
              y = e.append("text").attr("x", n).attr("y", i).style("text-anchor", "start").style("font-size", u).style("font-weight", h).style("font-family", l);
          y.append("tspan").attr("x", n).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
        }
      }

      function n(t, n, i, a, o, s, c, u) {
        var l = n.append("switch"),
            h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
        h.append("div").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, 0, s, c, u), r(h, c);
      }

      function r(t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && t.attr(n, e[n]);
        }
      }

      return function (r) {
        return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
      };
    }();

    var mT = rT,
        vT = function vT(t, e, n) {
      switch (e.type) {
        case "actor":
          return function (t, e, n) {
            var r = e.x + e.width / 2;
            0 === e.y && (hT++, t.append("line").attr("id", "actor" + hT).attr("x1", r).attr("y1", 80).attr("x2", r).attr("y2", 2e3).attr("class", "actor-line").attr("stroke-width", "0.5px").attr("stroke", "#999"));
            var i = t.append("g");
            i.attr("class", "actor-man");
            var a = {
              x: 0,
              y: 0,
              fill: "#EDF2AE",
              stroke: "#666",
              width: 100,
              anchor: "start",
              height: 100,
              rx: 0,
              ry: 0
            };
            a.x = e.x, a.y = e.y, a.fill = "#eaeaea", a.width = e.width, a.height = e.height, a["class"] = "actor", a.rx = 3, a.ry = 3, i.append("line").attr("id", "actor-man-torso" + hT).attr("x1", r).attr("y1", e.y + 25).attr("x2", r).attr("y2", e.y + 45), i.append("line").attr("id", "actor-man-arms" + hT).attr("x1", r - 18).attr("y1", e.y + 33).attr("x2", r + 18).attr("y2", e.y + 33), i.append("line").attr("x1", r - 18).attr("y1", e.y + 60).attr("x2", r).attr("y2", e.y + 45), i.append("line").attr("x1", r).attr("y1", e.y + 45).attr("x2", r + 16).attr("y2", e.y + 60);
            var o = i.append("circle");
            o.attr("cx", e.x + e.width / 2), o.attr("cy", e.y + 10), o.attr("r", 15), o.attr("width", e.width), o.attr("height", e.height);
            var s = i.node().getBBox();
            return e.height = s.height, yT(n)(e.description, i, a.x, a.y + 35, a.width, a.height, {
              "class": "actor"
            }, n), e.height;
          }(t, e, n);

        case "participant":
          return function (t, e, n) {
            var r = e.x + e.width / 2,
                i = t.append("g"),
                a = i;
            0 === e.y && (hT++, a.append("line").attr("id", "actor" + hT).attr("x1", r).attr("y1", 5).attr("x2", r).attr("y2", 2e3).attr("class", "actor-line").attr("stroke-width", "0.5px").attr("stroke", "#999"), a = i.append("g"), e.actorCnt = hT, null != e.links && (a.attr("id", "root-" + hT), iT("#root-" + hT, hT)));
            var o = {
              x: 0,
              y: 0,
              fill: "#EDF2AE",
              stroke: "#666",
              width: 100,
              anchor: "start",
              height: 100,
              rx: 0,
              ry: 0
            },
                s = "actor";
            null != e.properties && e.properties["class"] ? s = e.properties["class"] : o.fill = "#eaeaea", o.x = e.x, o.y = e.y, o.width = e.width, o.height = e.height, o["class"] = s, o.rx = 3, o.ry = 3;
            var c = rT(a, o);

            if (e.rectData = o, null != e.properties && e.properties.icon) {
              var u = e.properties.icon.trim();
              "@" === u.charAt(0) ? oT(a, o.x + o.width - 20, o.y + 10, u.substr(1)) : aT(a, o.x + o.width - 20, o.y + 10, u);
            }

            yT(n)(e.description, a, o.x, o.y, o.width, o.height, {
              "class": "actor"
            }, n);
            var l = e.height;

            if (c.node) {
              var h = c.node().getBBox();
              e.height = h.height, l = h.height;
            }

            return l;
          }(t, e, n);
      }
    },
        bT = function bT(t, e, n, r, i) {
      if (void 0 === e.links || null === e.links || 0 === Object.keys(e.links).length) return {
        height: 0,
        width: 0
      };
      var a = e.links,
          o = e.actorCnt,
          s = e.rectData,
          c = "none";
      i && (c = "block !important");
      var u = t.append("g");
      u.attr("id", "actor" + o + "_popup"), u.attr("class", "actorPopupMenu"), u.attr("display", c), iT("#actor" + o + "_popup", o);
      var l = "";
      void 0 !== s["class"] && (l = " " + s["class"]);
      var h = s.width > n ? s.width : n,
          f = u.append("rect");

      if (f.attr("class", "actorPopupMenuPanel" + l), f.attr("x", s.x), f.attr("y", s.height), f.attr("fill", s.fill), f.attr("stroke", s.stroke), f.attr("width", h), f.attr("height", s.height), f.attr("rx", s.rx), f.attr("ry", s.ry), null != a) {
        var d = 20;

        for (var p in a) {
          var y = u.append("a"),
              g = (0, Om.sanitizeUrl)(a[p]);
          y.attr("xlink:href", g), y.attr("target", "_blank"), gT(r)(p, y, s.x + 10, s.height + d, h, 20, {
            "class": "actor"
          }, r), d += 30;
        }
      }

      return f.attr("height", d), {
        height: s.height + d,
        width: h
      };
    },
        _T = function _T(t) {
      return t.append("g");
    },
        xT = function xT(t, e, n, r, i) {
      var a = {
        x: 0,
        y: 0,
        fill: "#EDF2AE",
        stroke: "#666",
        width: 100,
        anchor: "start",
        height: 100,
        rx: 0,
        ry: 0
      },
          o = e.anchored;
      a.x = e.startx, a.y = e.starty, a["class"] = "activation" + i % 3, a.width = e.stopx - e.startx, a.height = n - e.starty, rT(o, a);
    },
        wT = function wT(t, e, n, r) {
      var i = r.boxMargin,
          a = r.boxTextMargin,
          o = r.labelBoxHeight,
          s = r.labelBoxWidth,
          c = r.messageFontFamily,
          u = r.messageFontSize,
          l = r.messageFontWeight,
          h = t.append("g"),
          f = function f(t, e, n, r) {
        return h.append("line").attr("x1", t).attr("y1", e).attr("x2", n).attr("y2", r).attr("class", "loopLine");
      };

      f(e.startx, e.starty, e.stopx, e.starty), f(e.stopx, e.starty, e.stopx, e.stopy), f(e.startx, e.stopy, e.stopx, e.stopy), f(e.startx, e.starty, e.startx, e.stopy), void 0 !== e.sections && e.sections.forEach(function (t) {
        f(e.startx, t.y, e.stopx, t.y).style("stroke-dasharray", "3, 3");
      });
      var d = {
        x: 0,
        y: 0,
        fill: void 0,
        anchor: void 0,
        style: "#666",
        width: void 0,
        height: void 0,
        textMargin: 0,
        rx: 0,
        ry: 0,
        tspan: !0,
        valign: void 0
      };
      d.text = n, d.x = e.startx, d.y = e.starty, d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.anchor = "middle", d.valign = "middle", d.tspan = !1, d.width = s || 50, d.height = o || 20, d.textMargin = a, d["class"] = "labelText", lT(h, d), (d = {
        x: 0,
        y: 0,
        fill: void 0,
        anchor: void 0,
        style: "#666",
        width: void 0,
        height: void 0,
        textMargin: 0,
        rx: 0,
        ry: 0,
        tspan: !0,
        valign: void 0
      }).text = e.title, d.x = e.startx + s / 2 + (e.stopx - e.startx) / 2, d.y = e.starty + i + a, d.anchor = "middle", d.valign = "middle", d.textMargin = a, d["class"] = "loopText", d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.wrap = !0;
      var p = uT(h, d);
      return void 0 !== e.sectionTitles && e.sectionTitles.forEach(function (t, n) {
        if (t.message) {
          d.text = t.message, d.x = e.startx + (e.stopx - e.startx) / 2, d.y = e.sections[n].y + i + a, d["class"] = "loopText", d.anchor = "middle", d.valign = "middle", d.tspan = !1, d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.wrap = e.wrap, p = uT(h, d);
          var r = Math.round(p.map(function (t) {
            return (t._groups || t)[0][0].getBBox().height;
          }).reduce(function (t, e) {
            return t + e;
          }));
          e.sections[n].height += r - (i + a);
        }
      }), e.height = Math.round(e.stopy - e.starty), h;
    },
        kT = function kT(t, e) {
      rT(t, {
        x: e.startx,
        y: e.starty,
        width: e.stopx - e.startx,
        height: e.stopy - e.starty,
        fill: e.fill,
        "class": "rect"
      }).lower();
    },
        TT = function TT(t) {
      t.append("defs").append("marker").attr("id", "arrowhead").attr("refX", 9).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z");
    },
        ET = function ET(t) {
      t.append("defs").append("marker").attr("id", "filled-head").attr("refX", 18).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
    },
        CT = function CT(t) {
      t.append("defs").append("marker").attr("id", "sequencenumber").attr("refX", 15).attr("refY", 15).attr("markerWidth", 60).attr("markerHeight", 40).attr("orient", "auto").append("circle").attr("cx", 15).attr("cy", 15).attr("r", 6);
    },
        ST = function ST(t) {
      var e = t.append("defs").append("marker").attr("id", "crosshead").attr("markerWidth", 15).attr("markerHeight", 8).attr("orient", "auto").attr("refX", 16).attr("refY", 4);
      e.append("path").attr("fill", "black").attr("stroke", "#000000").style("stroke-dasharray", "0, 0").attr("stroke-width", "1px").attr("d", "M 9,2 V 6 L16,4 Z"), e.append("path").attr("fill", "none").attr("stroke", "#000000").style("stroke-dasharray", "0, 0").attr("stroke-width", "1px").attr("d", "M 0,1 L 6,7 M 6,1 L 0,7");
    },
        AT = function AT(t) {
      t.append("defs").append("symbol").attr("id", "database").attr("fill-rule", "evenodd").attr("clip-rule", "evenodd").append("path").attr("transform", "scale(.5)").attr("d", "M12.258.001l.256.004.255.005.253.008.251.01.249.012.247.015.246.016.242.019.241.02.239.023.236.024.233.027.231.028.229.031.225.032.223.034.22.036.217.038.214.04.211.041.208.043.205.045.201.046.198.048.194.05.191.051.187.053.183.054.18.056.175.057.172.059.168.06.163.061.16.063.155.064.15.066.074.033.073.033.071.034.07.034.069.035.068.035.067.035.066.035.064.036.064.036.062.036.06.036.06.037.058.037.058.037.055.038.055.038.053.038.052.038.051.039.05.039.048.039.047.039.045.04.044.04.043.04.041.04.04.041.039.041.037.041.036.041.034.041.033.042.032.042.03.042.029.042.027.042.026.043.024.043.023.043.021.043.02.043.018.044.017.043.015.044.013.044.012.044.011.045.009.044.007.045.006.045.004.045.002.045.001.045v17l-.001.045-.002.045-.004.045-.006.045-.007.045-.009.044-.011.045-.012.044-.013.044-.015.044-.017.043-.018.044-.02.043-.021.043-.023.043-.024.043-.026.043-.027.042-.029.042-.03.042-.032.042-.033.042-.034.041-.036.041-.037.041-.039.041-.04.041-.041.04-.043.04-.044.04-.045.04-.047.039-.048.039-.05.039-.051.039-.052.038-.053.038-.055.038-.055.038-.058.037-.058.037-.06.037-.06.036-.062.036-.064.036-.064.036-.066.035-.067.035-.068.035-.069.035-.07.034-.071.034-.073.033-.074.033-.15.066-.155.064-.16.063-.163.061-.168.06-.172.059-.175.057-.18.056-.183.054-.187.053-.191.051-.194.05-.198.048-.201.046-.205.045-.208.043-.211.041-.214.04-.217.038-.22.036-.223.034-.225.032-.229.031-.231.028-.233.027-.236.024-.239.023-.241.02-.242.019-.246.016-.247.015-.249.012-.251.01-.253.008-.255.005-.256.004-.258.001-.258-.001-.256-.004-.255-.005-.253-.008-.251-.01-.249-.012-.247-.015-.245-.016-.243-.019-.241-.02-.238-.023-.236-.024-.234-.027-.231-.028-.228-.031-.226-.032-.223-.034-.22-.036-.217-.038-.214-.04-.211-.041-.208-.043-.204-.045-.201-.046-.198-.048-.195-.05-.19-.051-.187-.053-.184-.054-.179-.056-.176-.057-.172-.059-.167-.06-.164-.061-.159-.063-.155-.064-.151-.066-.074-.033-.072-.033-.072-.034-.07-.034-.069-.035-.068-.035-.067-.035-.066-.035-.064-.036-.063-.036-.062-.036-.061-.036-.06-.037-.058-.037-.057-.037-.056-.038-.055-.038-.053-.038-.052-.038-.051-.039-.049-.039-.049-.039-.046-.039-.046-.04-.044-.04-.043-.04-.041-.04-.04-.041-.039-.041-.037-.041-.036-.041-.034-.041-.033-.042-.032-.042-.03-.042-.029-.042-.027-.042-.026-.043-.024-.043-.023-.043-.021-.043-.02-.043-.018-.044-.017-.043-.015-.044-.013-.044-.012-.044-.011-.045-.009-.044-.007-.045-.006-.045-.004-.045-.002-.045-.001-.045v-17l.001-.045.002-.045.004-.045.006-.045.007-.045.009-.044.011-.045.012-.044.013-.044.015-.044.017-.043.018-.044.02-.043.021-.043.023-.043.024-.043.026-.043.027-.042.029-.042.03-.042.032-.042.033-.042.034-.041.036-.041.037-.041.039-.041.04-.041.041-.04.043-.04.044-.04.046-.04.046-.039.049-.039.049-.039.051-.039.052-.038.053-.038.055-.038.056-.038.057-.037.058-.037.06-.037.061-.036.062-.036.063-.036.064-.036.066-.035.067-.035.068-.035.069-.035.07-.034.072-.034.072-.033.074-.033.151-.066.155-.064.159-.063.164-.061.167-.06.172-.059.176-.057.179-.056.184-.054.187-.053.19-.051.195-.05.198-.048.201-.046.204-.045.208-.043.211-.041.214-.04.217-.038.22-.036.223-.034.226-.032.228-.031.231-.028.234-.027.236-.024.238-.023.241-.02.243-.019.245-.016.247-.015.249-.012.251-.01.253-.008.255-.005.256-.004.258-.001.258.001zm-9.258 20.499v.01l.001.021.003.021.004.022.005.021.006.022.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.023.018.024.019.024.021.024.022.025.023.024.024.025.052.049.056.05.061.051.066.051.07.051.075.051.079.052.084.052.088.052.092.052.097.052.102.051.105.052.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.048.144.049.147.047.152.047.155.047.16.045.163.045.167.043.171.043.176.041.178.041.183.039.187.039.19.037.194.035.197.035.202.033.204.031.209.03.212.029.216.027.219.025.222.024.226.021.23.02.233.018.236.016.24.015.243.012.246.01.249.008.253.005.256.004.259.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.021.224-.024.22-.026.216-.027.212-.028.21-.031.205-.031.202-.034.198-.034.194-.036.191-.037.187-.039.183-.04.179-.04.175-.042.172-.043.168-.044.163-.045.16-.046.155-.046.152-.047.148-.048.143-.049.139-.049.136-.05.131-.05.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.053.083-.051.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.05.023-.024.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.023.01-.022.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.127l-.077.055-.08.053-.083.054-.085.053-.087.052-.09.052-.093.051-.095.05-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.045-.118.044-.12.043-.122.042-.124.042-.126.041-.128.04-.13.04-.132.038-.134.038-.135.037-.138.037-.139.035-.142.035-.143.034-.144.033-.147.032-.148.031-.15.03-.151.03-.153.029-.154.027-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.01-.179.008-.179.008-.181.006-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.006-.179-.008-.179-.008-.178-.01-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.027-.153-.029-.151-.03-.15-.03-.148-.031-.146-.032-.145-.033-.143-.034-.141-.035-.14-.035-.137-.037-.136-.037-.134-.038-.132-.038-.13-.04-.128-.04-.126-.041-.124-.042-.122-.042-.12-.044-.117-.043-.116-.045-.113-.045-.112-.046-.109-.047-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.05-.093-.052-.09-.051-.087-.052-.085-.053-.083-.054-.08-.054-.077-.054v4.127zm0-5.654v.011l.001.021.003.021.004.021.005.022.006.022.007.022.009.022.01.022.011.023.012.023.013.023.015.024.016.023.017.024.018.024.019.024.021.024.022.024.023.025.024.024.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.052.11.051.114.051.119.052.123.05.127.051.131.05.135.049.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.044.171.042.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.022.23.02.233.018.236.016.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.012.241-.015.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.048.139-.05.136-.049.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.051.051-.049.023-.025.023-.024.021-.025.02-.024.019-.024.018-.024.017-.024.015-.023.014-.023.013-.024.012-.022.01-.023.01-.023.008-.022.006-.022.006-.022.004-.021.004-.022.001-.021.001-.021v-4.139l-.077.054-.08.054-.083.054-.085.052-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.044-.118.044-.12.044-.122.042-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.035-.143.033-.144.033-.147.033-.148.031-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.009-.179.009-.179.007-.181.007-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.007-.179-.007-.179-.009-.178-.009-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.031-.146-.033-.145-.033-.143-.033-.141-.035-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.04-.126-.041-.124-.042-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.051-.093-.051-.09-.051-.087-.053-.085-.052-.083-.054-.08-.054-.077-.054v4.139zm0-5.666v.011l.001.02.003.022.004.021.005.022.006.021.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.024.018.023.019.024.021.025.022.024.023.024.024.025.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.051.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.043.171.043.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.021.23.02.233.018.236.017.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.013.241-.014.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.049.139-.049.136-.049.131-.051.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.049.023-.025.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.022.01-.023.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.153l-.077.054-.08.054-.083.053-.085.053-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.048-.105.048-.106.048-.109.046-.111.046-.114.046-.115.044-.118.044-.12.043-.122.043-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.034-.143.034-.144.033-.147.032-.148.032-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.024-.161.024-.162.023-.163.023-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.01-.178.01-.179.009-.179.007-.181.006-.182.006-.182.004-.184.003-.184.001-.185.001-.185-.001-.184-.001-.184-.003-.182-.004-.182-.006-.181-.006-.179-.007-.179-.009-.178-.01-.176-.01-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.023-.162-.023-.161-.024-.159-.024-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.032-.146-.032-.145-.033-.143-.034-.141-.034-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.041-.126-.041-.124-.041-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.048-.105-.048-.102-.048-.1-.05-.097-.049-.095-.051-.093-.051-.09-.052-.087-.052-.085-.053-.083-.053-.08-.054-.077-.054v4.153zm8.74-8.179l-.257.004-.254.005-.25.008-.247.011-.244.012-.241.014-.237.016-.233.018-.231.021-.226.022-.224.023-.22.026-.216.027-.212.028-.21.031-.205.032-.202.033-.198.034-.194.036-.191.038-.187.038-.183.04-.179.041-.175.042-.172.043-.168.043-.163.045-.16.046-.155.046-.152.048-.148.048-.143.048-.139.049-.136.05-.131.05-.126.051-.123.051-.118.051-.114.052-.11.052-.106.052-.101.052-.096.052-.092.052-.088.052-.083.052-.079.052-.074.051-.07.052-.065.051-.06.05-.056.05-.051.05-.023.025-.023.024-.021.024-.02.025-.019.024-.018.024-.017.023-.015.024-.014.023-.013.023-.012.023-.01.023-.01.022-.008.022-.006.023-.006.021-.004.022-.004.021-.001.021-.001.021.001.021.001.021.004.021.004.022.006.021.006.023.008.022.01.022.01.023.012.023.013.023.014.023.015.024.017.023.018.024.019.024.02.025.021.024.023.024.023.025.051.05.056.05.06.05.065.051.07.052.074.051.079.052.083.052.088.052.092.052.096.052.101.052.106.052.11.052.114.052.118.051.123.051.126.051.131.05.136.05.139.049.143.048.148.048.152.048.155.046.16.046.163.045.168.043.172.043.175.042.179.041.183.04.187.038.191.038.194.036.198.034.202.033.205.032.21.031.212.028.216.027.22.026.224.023.226.022.231.021.233.018.237.016.241.014.244.012.247.011.25.008.254.005.257.004.26.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.022.224-.023.22-.026.216-.027.212-.028.21-.031.205-.032.202-.033.198-.034.194-.036.191-.038.187-.038.183-.04.179-.041.175-.042.172-.043.168-.043.163-.045.16-.046.155-.046.152-.048.148-.048.143-.048.139-.049.136-.05.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.05.051-.05.023-.025.023-.024.021-.024.02-.025.019-.024.018-.024.017-.023.015-.024.014-.023.013-.023.012-.023.01-.023.01-.022.008-.022.006-.023.006-.021.004-.022.004-.021.001-.021.001-.021-.001-.021-.001-.021-.004-.021-.004-.022-.006-.021-.006-.023-.008-.022-.01-.022-.01-.023-.012-.023-.013-.023-.014-.023-.015-.024-.017-.023-.018-.024-.019-.024-.02-.025-.021-.024-.023-.024-.023-.025-.051-.05-.056-.05-.06-.05-.065-.051-.07-.052-.074-.051-.079-.052-.083-.052-.088-.052-.092-.052-.096-.052-.101-.052-.106-.052-.11-.052-.114-.052-.118-.051-.123-.051-.126-.051-.131-.05-.136-.05-.139-.049-.143-.048-.148-.048-.152-.048-.155-.046-.16-.046-.163-.045-.168-.043-.172-.043-.175-.042-.179-.041-.183-.04-.187-.038-.191-.038-.194-.036-.198-.034-.202-.033-.205-.032-.21-.031-.212-.028-.216-.027-.22-.026-.224-.023-.226-.022-.231-.021-.233-.018-.237-.016-.241-.014-.244-.012-.247-.011-.25-.008-.254-.005-.257-.004-.26-.001-.26.001z");
    },
        MT = function MT(t) {
      t.append("defs").append("symbol").attr("id", "computer").attr("width", "24").attr("height", "24").append("path").attr("transform", "scale(.5)").attr("d", "M2 2v13h20v-13h-20zm18 11h-16v-9h16v9zm-10.228 6l.466-1h3.524l.467 1h-4.457zm14.228 3h-24l2-6h2.104l-1.33 4h18.45l-1.297-4h2.073l2 6zm-5-10h-14v-7h14v7z");
    },
        NT = function NT(t) {
      t.append("defs").append("symbol").attr("id", "clock").attr("width", "24").attr("height", "24").append("path").attr("transform", "scale(.5)").attr("d", "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.848 12.459c.202.038.202.333.001.372-1.907.361-6.045 1.111-6.547 1.111-.719 0-1.301-.582-1.301-1.301 0-.512.77-5.447 1.125-7.445.034-.192.312-.181.343.014l.985 6.238 5.394 1.011z");
    },
        DT = dT,
        OT = pT;

    Om.sanitizeUrl;
    Ok.parser.yy = eT;

    var BT = {},
        LT = {
      data: {
        startx: void 0,
        stopx: void 0,
        starty: void 0,
        stopy: void 0
      },
      verticalPos: 0,
      sequenceItems: [],
      activations: [],
      models: {
        getHeight: function getHeight() {
          return Math.max.apply(null, 0 === this.actors.length ? [0] : this.actors.map(function (t) {
            return t.height || 0;
          })) + (0 === this.loops.length ? 0 : this.loops.map(function (t) {
            return t.height || 0;
          }).reduce(function (t, e) {
            return t + e;
          })) + (0 === this.messages.length ? 0 : this.messages.map(function (t) {
            return t.height || 0;
          }).reduce(function (t, e) {
            return t + e;
          })) + (0 === this.notes.length ? 0 : this.notes.map(function (t) {
            return t.height || 0;
          }).reduce(function (t, e) {
            return t + e;
          }));
        },
        clear: function clear() {
          this.actors = [], this.loops = [], this.messages = [], this.notes = [];
        },
        addActor: function addActor(t) {
          this.actors.push(t);
        },
        addLoop: function addLoop(t) {
          this.loops.push(t);
        },
        addMessage: function addMessage(t) {
          this.messages.push(t);
        },
        addNote: function addNote(t) {
          this.notes.push(t);
        },
        lastActor: function lastActor() {
          return this.actors[this.actors.length - 1];
        },
        lastLoop: function lastLoop() {
          return this.loops[this.loops.length - 1];
        },
        lastMessage: function lastMessage() {
          return this.messages[this.messages.length - 1];
        },
        lastNote: function lastNote() {
          return this.notes[this.notes.length - 1];
        },
        actors: [],
        loops: [],
        messages: [],
        notes: []
      },
      init: function init() {
        this.sequenceItems = [], this.activations = [], this.models.clear(), this.data = {
          startx: void 0,
          stopx: void 0,
          starty: void 0,
          stopy: void 0
        }, this.verticalPos = 0, YT(Ok.parser.yy.getConfig());
      },
      updateVal: function updateVal(t, e, n, r) {
        void 0 === t[e] ? t[e] = n : t[e] = r(n, t[e]);
      },
      updateBounds: function updateBounds(t, e, n, r) {
        var i = this,
            a = 0;

        function o(o) {
          return function (s) {
            a++;
            var c = i.sequenceItems.length - a + 1;
            i.updateVal(s, "starty", e - c * BT.boxMargin, Math.min), i.updateVal(s, "stopy", r + c * BT.boxMargin, Math.max), i.updateVal(LT.data, "startx", t - c * BT.boxMargin, Math.min), i.updateVal(LT.data, "stopx", n + c * BT.boxMargin, Math.max), "activation" !== o && (i.updateVal(s, "startx", t - c * BT.boxMargin, Math.min), i.updateVal(s, "stopx", n + c * BT.boxMargin, Math.max), i.updateVal(LT.data, "starty", e - c * BT.boxMargin, Math.min), i.updateVal(LT.data, "stopy", r + c * BT.boxMargin, Math.max));
          };
        }

        this.sequenceItems.forEach(o()), this.activations.forEach(o("activation"));
      },
      insert: function insert(t, e, n, r) {
        var i = Math.min(t, n),
            a = Math.max(t, n),
            o = Math.min(e, r),
            s = Math.max(e, r);
        this.updateVal(LT.data, "startx", i, Math.min), this.updateVal(LT.data, "starty", o, Math.min), this.updateVal(LT.data, "stopx", a, Math.max), this.updateVal(LT.data, "stopy", s, Math.max), this.updateBounds(i, o, a, s);
      },
      newActivation: function newActivation(t, e, n) {
        var r = n[t.from.actor],
            i = zT(t.from.actor).length || 0,
            a = r.x + r.width / 2 + (i - 1) * BT.activationWidth / 2;
        this.activations.push({
          startx: a,
          starty: this.verticalPos + 2,
          stopx: a + BT.activationWidth,
          stopy: void 0,
          actor: t.from.actor,
          anchored: _T(e)
        });
      },
      endActivation: function endActivation(t) {
        var e = this.activations.map(function (t) {
          return t.actor;
        }).lastIndexOf(t.from.actor);
        return this.activations.splice(e, 1)[0];
      },
      createLoop: function createLoop() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
          message: void 0,
          wrap: !1,
          width: void 0
        },
            e = arguments.length > 1 ? arguments[1] : void 0;
        return {
          startx: void 0,
          starty: this.verticalPos,
          stopx: void 0,
          stopy: void 0,
          title: t.message,
          wrap: t.wrap,
          width: t.width,
          height: 0,
          fill: e
        };
      },
      newLoop: function newLoop() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
          message: void 0,
          wrap: !1,
          width: void 0
        },
            e = arguments.length > 1 ? arguments[1] : void 0;
        this.sequenceItems.push(this.createLoop(t, e));
      },
      endLoop: function endLoop() {
        return this.sequenceItems.pop();
      },
      addSectionToLoop: function addSectionToLoop(t) {
        var e = this.sequenceItems.pop();
        e.sections = e.sections || [], e.sectionTitles = e.sectionTitles || [], e.sections.push({
          y: LT.getVerticalPos(),
          height: 0
        }), e.sectionTitles.push(t), this.sequenceItems.push(e);
      },
      bumpVerticalPos: function bumpVerticalPos(t) {
        this.verticalPos = this.verticalPos + t, this.data.stopy = this.verticalPos;
      },
      getVerticalPos: function getVerticalPos() {
        return this.verticalPos;
      },
      getBounds: function getBounds() {
        return {
          bounds: this.data,
          models: this.models
        };
      }
    },
        IT = function IT(t) {
      return {
        fontFamily: t.messageFontFamily,
        fontSize: t.messageFontSize,
        fontWeight: t.messageFontWeight
      };
    },
        RT = function RT(t) {
      return {
        fontFamily: t.noteFontFamily,
        fontSize: t.noteFontSize,
        fontWeight: t.noteFontWeight
      };
    },
        FT = function FT(t) {
      return {
        fontFamily: t.actorFontFamily,
        fontSize: t.actorFontSize,
        fontWeight: t.actorFontWeight
      };
    },
        PT = function PT(t, e, n, r) {
      for (var i = 0, a = 0, o = 0, s = 0; s < n.length; s++) {
        var c = e[n[s]];
        c.width = c.width || BT.width, c.height = Math.max(c.height || BT.height, BT.height), c.margin = c.margin || BT.actorMargin, c.x = i + a, c.y = r;
        var u = vT(t, c, BT);
        o = Math.max(o, u), LT.insert(c.x, r, c.x + c.width, c.height), i += c.width, a += c.margin, LT.models.addActor(c);
      }

      LT.bumpVerticalPos(o);
    },
        jT = function jT(t, e, n, r) {
      for (var i = 0, a = 0, o = 0; o < n.length; o++) {
        var s = e[n[o]],
            c = HT(s),
            u = bT(t, s, c, BT, BT.forceMenus);
        u.height > i && (i = u.height), u.width + s.x > a && (a = u.width + s.x);
      }

      return {
        maxHeight: i,
        maxWidth: a
      };
    },
        YT = function YT(t) {
      Lv(BT, t), t.fontFamily && (BT.actorFontFamily = BT.noteFontFamily = BT.messageFontFamily = t.fontFamily), t.fontSize && (BT.actorFontSize = BT.noteFontSize = BT.messageFontSize = t.fontSize), t.fontWeight && (BT.actorFontWeight = BT.noteFontWeight = BT.messageFontWeight = t.fontWeight);
    },
        zT = function zT(t) {
      return LT.activations.filter(function (e) {
        return e.actor === t;
      });
    },
        UT = function UT(t, e) {
      var n = e[t],
          r = zT(t);
      return [r.reduce(function (t, e) {
        return Math.min(t, e.startx);
      }, n.x + n.width / 2), r.reduce(function (t, e) {
        return Math.max(t, e.stopx);
      }, n.x + n.width / 2)];
    };

    function qT(t, e, n, r, i) {
      LT.bumpVerticalPos(n);
      var a = r;

      if (e.id && e.message && t[e.id]) {
        var s = t[e.id].width,
            c = IT(BT);
        e.message = Hv.wrapLabel("[".concat(e.message, "]"), s - 2 * BT.wrapPadding, c), e.width = s, e.wrap = !0;
        var u = Hv.calculateTextDimensions(e.message, c),
            l = Math.max(u.height, BT.labelBoxHeight);
        a = r + l, o.debug("".concat(l, " - ").concat(e.message));
      }

      i(e), LT.bumpVerticalPos(a);
    }

    var HT = function HT(t) {
      var e = 0,
          n = FT(BT);

      for (var r in t.links) {
        var i = Hv.calculateTextDimensions(r, n).width + 2 * BT.wrapPadding + 2 * BT.boxMargin;
        e < i && (e = i);
      }

      return e;
    };

    var $T = {
      bounds: LT,
      drawActors: PT,
      drawActorsPopup: jT,
      setConf: YT,
      draw: function draw(t, e) {
        BT = Jv().sequence;
        var n,
            r = Jv().securityLevel;
        "sandbox" === r && (n = au("#i" + e));
        var i = au("sandbox" === r ? n.nodes()[0].contentDocument.body : "body");
        "sandbox" === r ? n.nodes()[0].contentDocument : document;
        Ok.parser.yy.clear(), Ok.parser.yy.setWrap(BT.wrap), Ok.parser.parse(t + "\n"), LT.init(), o.debug("C:".concat(JSON.stringify(BT, null, 2)));

        var s = "sandbox" === r ? i.select('[id="'.concat(e, '"]')) : au('[id="'.concat(e, '"]')),
            c = Ok.parser.yy.getActors(),
            u = Ok.parser.yy.getActorKeys(),
            l = Ok.parser.yy.getMessages(),
            h = Ok.parser.yy.getTitle(),
            f = function (t, e) {
          var n = {};
          return e.forEach(function (e) {
            if (t[e.to] && t[e.from]) {
              var r = t[e.to];
              if (e.placement === Ok.parser.yy.PLACEMENT.LEFTOF && !r.prevActor) return;
              if (e.placement === Ok.parser.yy.PLACEMENT.RIGHTOF && !r.nextActor) return;
              var i = void 0 !== e.placement,
                  a = !i,
                  o = i ? RT(BT) : IT(BT),
                  s = e.wrap ? Hv.wrapLabel(e.message, BT.width - 2 * BT.wrapPadding, o) : e.message,
                  c = Hv.calculateTextDimensions(s, o).width + 2 * BT.wrapPadding;
              a && e.from === r.nextActor ? n[e.to] = Math.max(n[e.to] || 0, c) : a && e.from === r.prevActor ? n[e.from] = Math.max(n[e.from] || 0, c) : a && e.from === e.to ? (n[e.from] = Math.max(n[e.from] || 0, c / 2), n[e.to] = Math.max(n[e.to] || 0, c / 2)) : e.placement === Ok.parser.yy.PLACEMENT.RIGHTOF ? n[e.from] = Math.max(n[e.from] || 0, c) : e.placement === Ok.parser.yy.PLACEMENT.LEFTOF ? n[r.prevActor] = Math.max(n[r.prevActor] || 0, c) : e.placement === Ok.parser.yy.PLACEMENT.OVER && (r.prevActor && (n[r.prevActor] = Math.max(n[r.prevActor] || 0, c / 2)), r.nextActor && (n[e.from] = Math.max(n[e.from] || 0, c / 2)));
            }
          }), o.debug("maxMessageWidthPerActor:", n), n;
        }(c, l);

        BT.height = function (t, e) {
          var n = 0;

          for (var r in Object.keys(t).forEach(function (e) {
            var r = t[e];
            r.wrap && (r.description = Hv.wrapLabel(r.description, BT.width - 2 * BT.wrapPadding, FT(BT)));
            var i = Hv.calculateTextDimensions(r.description, FT(BT));
            r.width = r.wrap ? BT.width : Math.max(BT.width, i.width + 2 * BT.wrapPadding), r.height = r.wrap ? Math.max(i.height, BT.height) : BT.height, n = Math.max(n, r.height);
          }), e) {
            var i = t[r];

            if (i) {
              var a = t[i.nextActor];

              if (a) {
                var o = e[r] + BT.actorMargin - i.width / 2 - a.width / 2;
                i.margin = Math.max(o, BT.actorMargin);
              }
            }
          }

          return Math.max(n, BT.height);
        }(c, f), MT(s), AT(s), NT(s), PT(s, c, u, 0);

        var d = function (t, e) {
          var n,
              r,
              i,
              a = {},
              s = [];
          return t.forEach(function (t) {
            switch (t.id = Hv.random({
              length: 10
            }), t.type) {
              case Ok.parser.yy.LINETYPE.LOOP_START:
              case Ok.parser.yy.LINETYPE.ALT_START:
              case Ok.parser.yy.LINETYPE.OPT_START:
              case Ok.parser.yy.LINETYPE.PAR_START:
                s.push({
                  id: t.id,
                  msg: t.message,
                  from: Number.MAX_SAFE_INTEGER,
                  to: Number.MIN_SAFE_INTEGER,
                  width: 0
                });
                break;

              case Ok.parser.yy.LINETYPE.ALT_ELSE:
              case Ok.parser.yy.LINETYPE.PAR_AND:
                t.message && (n = s.pop(), a[n.id] = n, a[t.id] = n, s.push(n));
                break;

              case Ok.parser.yy.LINETYPE.LOOP_END:
              case Ok.parser.yy.LINETYPE.ALT_END:
              case Ok.parser.yy.LINETYPE.OPT_END:
              case Ok.parser.yy.LINETYPE.PAR_END:
                n = s.pop(), a[n.id] = n;
                break;

              case Ok.parser.yy.LINETYPE.ACTIVE_START:
                var c = e[t.from ? t.from.actor : t.to.actor],
                    u = zT(t.from ? t.from.actor : t.to.actor).length,
                    l = c.x + c.width / 2 + (u - 1) * BT.activationWidth / 2,
                    h = {
                  startx: l,
                  stopx: l + BT.activationWidth,
                  actor: t.from.actor,
                  enabled: !0
                };
                LT.activations.push(h);
                break;

              case Ok.parser.yy.LINETYPE.ACTIVE_END:
                var f = LT.activations.map(function (t) {
                  return t.actor;
                }).lastIndexOf(t.from.actor);
                delete LT.activations.splice(f, 1)[0];
            }

            void 0 !== t.placement ? (r = function (t, e) {
              var n = e[t.from].x,
                  r = e[t.to].x,
                  i = t.wrap && t.message,
                  a = Hv.calculateTextDimensions(i ? Hv.wrapLabel(t.message, BT.width, RT(BT)) : t.message, RT(BT)),
                  s = {
                width: i ? BT.width : Math.max(BT.width, a.width + 2 * BT.noteMargin),
                height: 0,
                startx: e[t.from].x,
                stopx: 0,
                starty: 0,
                stopy: 0,
                message: t.message
              };
              return t.placement === Ok.parser.yy.PLACEMENT.RIGHTOF ? (s.width = i ? Math.max(BT.width, a.width) : Math.max(e[t.from].width / 2 + e[t.to].width / 2, a.width + 2 * BT.noteMargin), s.startx = n + (e[t.from].width + BT.actorMargin) / 2) : t.placement === Ok.parser.yy.PLACEMENT.LEFTOF ? (s.width = i ? Math.max(BT.width, a.width + 2 * BT.noteMargin) : Math.max(e[t.from].width / 2 + e[t.to].width / 2, a.width + 2 * BT.noteMargin), s.startx = n - s.width + (e[t.from].width - BT.actorMargin) / 2) : t.to === t.from ? (a = Hv.calculateTextDimensions(i ? Hv.wrapLabel(t.message, Math.max(BT.width, e[t.from].width), RT(BT)) : t.message, RT(BT)), s.width = i ? Math.max(BT.width, e[t.from].width) : Math.max(e[t.from].width, BT.width, a.width + 2 * BT.noteMargin), s.startx = n + (e[t.from].width - s.width) / 2) : (s.width = Math.abs(n + e[t.from].width / 2 - (r + e[t.to].width / 2)) + BT.actorMargin, s.startx = n < r ? n + e[t.from].width / 2 - BT.actorMargin / 2 : r + e[t.to].width / 2 - BT.actorMargin / 2), i && (s.message = Hv.wrapLabel(t.message, s.width - 2 * BT.wrapPadding, RT(BT))), o.debug("NM:[".concat(s.startx, ",").concat(s.stopx, ",").concat(s.starty, ",").concat(s.stopy, ":").concat(s.width, ",").concat(s.height, "=").concat(t.message, "]")), s;
            }(t, e), t.noteModel = r, s.forEach(function (t) {
              (n = t).from = Math.min(n.from, r.startx), n.to = Math.max(n.to, r.startx + r.width), n.width = Math.max(n.width, Math.abs(n.from - n.to)) - BT.labelBoxWidth;
            })) : (i = function (t, e) {
              var n = !1;
              if ([Ok.parser.yy.LINETYPE.SOLID_OPEN, Ok.parser.yy.LINETYPE.DOTTED_OPEN, Ok.parser.yy.LINETYPE.SOLID, Ok.parser.yy.LINETYPE.DOTTED, Ok.parser.yy.LINETYPE.SOLID_CROSS, Ok.parser.yy.LINETYPE.DOTTED_CROSS, Ok.parser.yy.LINETYPE.SOLID_POINT, Ok.parser.yy.LINETYPE.DOTTED_POINT].includes(t.type) && (n = !0), !n) return {};
              var r = UT(t.from, e),
                  i = UT(t.to, e),
                  a = r[0] <= i[0] ? 1 : 0,
                  o = r[0] < i[0] ? 0 : 1,
                  s = r.concat(i),
                  c = Math.abs(i[o] - r[a]);
              t.wrap && t.message && (t.message = Hv.wrapLabel(t.message, Math.max(c + 2 * BT.wrapPadding, BT.width), IT(BT)));
              var u = Hv.calculateTextDimensions(t.message, IT(BT));
              return {
                width: Math.max(t.wrap ? 0 : u.width + 2 * BT.wrapPadding, c + 2 * BT.wrapPadding, BT.width),
                height: 0,
                startx: r[a],
                stopx: i[o],
                starty: 0,
                stopy: 0,
                message: t.message,
                type: t.type,
                wrap: t.wrap,
                fromBounds: Math.min.apply(null, s),
                toBounds: Math.max.apply(null, s)
              };
            }(t, e), t.msgModel = i, i.startx && i.stopx && s.length > 0 && s.forEach(function (r) {
              if (n = r, i.startx === i.stopx) {
                var a = e[t.from],
                    o = e[t.to];
                n.from = Math.min(a.x - i.width / 2, a.x - a.width / 2, n.from), n.to = Math.max(o.x + i.width / 2, o.x + a.width / 2, n.to), n.width = Math.max(n.width, Math.abs(n.to - n.from)) - BT.labelBoxWidth;
              } else n.from = Math.min(i.startx, n.from), n.to = Math.max(i.stopx, n.to), n.width = Math.max(n.width, i.width) - BT.labelBoxWidth;
            }));
          }), LT.activations = [], o.debug("Loop type widths:", a), a;
        }(l, c);

        TT(s), ST(s), ET(s), CT(s);
        var p = 1;
        l.forEach(function (t) {
          var e, n, r;

          switch (t.type) {
            case Ok.parser.yy.LINETYPE.NOTE:
              n = t.noteModel, function (t, e) {
                LT.bumpVerticalPos(BT.boxMargin), e.height = BT.boxMargin, e.starty = LT.getVerticalPos();
                var n = OT();
                n.x = e.startx, n.y = e.starty, n.width = e.width || BT.width, n["class"] = "note";
                var r = t.append("g"),
                    i = mT(r, n),
                    a = DT();
                a.x = e.startx, a.y = e.starty, a.width = n.width, a.dy = "1em", a.text = e.message, a["class"] = "noteText", a.fontFamily = BT.noteFontFamily, a.fontSize = BT.noteFontSize, a.fontWeight = BT.noteFontWeight, a.anchor = BT.noteAlign, a.textMargin = BT.noteMargin, a.valign = BT.noteAlign;
                var o = uT(r, a),
                    s = Math.round(o.map(function (t) {
                  return (t._groups || t)[0][0].getBBox().height;
                }).reduce(function (t, e) {
                  return t + e;
                }));
                i.attr("height", s + 2 * BT.noteMargin), e.height += s + 2 * BT.noteMargin, LT.bumpVerticalPos(s + 2 * BT.noteMargin), e.stopy = e.starty + s + 2 * BT.noteMargin, e.stopx = e.startx + n.width, LT.insert(e.startx, e.starty, e.stopx, e.stopy), LT.models.addNote(e);
              }(s, n);
              break;

            case Ok.parser.yy.LINETYPE.ACTIVE_START:
              LT.newActivation(t, s, c);
              break;

            case Ok.parser.yy.LINETYPE.ACTIVE_END:
              !function (t, e) {
                var n = LT.endActivation(t);
                n.starty + 18 > e && (n.starty = e - 6, e += 12), xT(s, n, e, BT, zT(t.from.actor).length), LT.insert(n.startx, e - 10, n.stopx, e);
              }(t, LT.getVerticalPos());
              break;

            case Ok.parser.yy.LINETYPE.LOOP_START:
              qT(d, t, BT.boxMargin, BT.boxMargin + BT.boxTextMargin, function (t) {
                return LT.newLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.LOOP_END:
              e = LT.endLoop(), wT(s, e, "loop", BT), LT.bumpVerticalPos(e.stopy - LT.getVerticalPos()), LT.models.addLoop(e);
              break;

            case Ok.parser.yy.LINETYPE.RECT_START:
              qT(d, t, BT.boxMargin, BT.boxMargin, function (t) {
                return LT.newLoop(void 0, t.message);
              });
              break;

            case Ok.parser.yy.LINETYPE.RECT_END:
              e = LT.endLoop(), kT(s, e), LT.models.addLoop(e), LT.bumpVerticalPos(e.stopy - LT.getVerticalPos());
              break;

            case Ok.parser.yy.LINETYPE.OPT_START:
              qT(d, t, BT.boxMargin, BT.boxMargin + BT.boxTextMargin, function (t) {
                return LT.newLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.OPT_END:
              e = LT.endLoop(), wT(s, e, "opt", BT), LT.bumpVerticalPos(e.stopy - LT.getVerticalPos()), LT.models.addLoop(e);
              break;

            case Ok.parser.yy.LINETYPE.ALT_START:
              qT(d, t, BT.boxMargin, BT.boxMargin + BT.boxTextMargin, function (t) {
                return LT.newLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.ALT_ELSE:
              qT(d, t, BT.boxMargin + BT.boxTextMargin, BT.boxMargin, function (t) {
                return LT.addSectionToLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.ALT_END:
              e = LT.endLoop(), wT(s, e, "alt", BT), LT.bumpVerticalPos(e.stopy - LT.getVerticalPos()), LT.models.addLoop(e);
              break;

            case Ok.parser.yy.LINETYPE.PAR_START:
              qT(d, t, BT.boxMargin, BT.boxMargin + BT.boxTextMargin, function (t) {
                return LT.newLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.PAR_AND:
              qT(d, t, BT.boxMargin + BT.boxTextMargin, BT.boxMargin, function (t) {
                return LT.addSectionToLoop(t);
              });
              break;

            case Ok.parser.yy.LINETYPE.PAR_END:
              e = LT.endLoop(), wT(s, e, "par", BT), LT.bumpVerticalPos(e.stopy - LT.getVerticalPos()), LT.models.addLoop(e);
              break;

            default:
              try {
                (r = t.msgModel).starty = LT.getVerticalPos(), r.sequenceIndex = p, function (t, e) {
                  LT.bumpVerticalPos(10);
                  var n = e.startx,
                      r = e.stopx,
                      i = e.starty,
                      a = e.message,
                      o = e.type,
                      s = e.sequenceIndex,
                      c = Um.splitBreaks(a).length,
                      u = Hv.calculateTextDimensions(a, IT(BT)),
                      l = u.height / c;
                  e.height += l, LT.bumpVerticalPos(l);
                  var h = DT();
                  h.x = n, h.y = i + 10, h.width = r - n, h["class"] = "messageText", h.dy = "1em", h.text = a, h.fontFamily = BT.messageFontFamily, h.fontSize = BT.messageFontSize, h.fontWeight = BT.messageFontWeight, h.anchor = BT.messageAlign, h.valign = BT.messageAlign, h.textMargin = BT.wrapPadding, h.tspan = !1, uT(t, h);
                  var f,
                      d,
                      p = u.height - 10,
                      y = u.width;

                  if (n === r) {
                    d = LT.getVerticalPos() + p, BT.rightAngles ? f = t.append("path").attr("d", "M  ".concat(n, ",").concat(d, " H ").concat(n + Math.max(BT.width / 2, y / 2), " V ").concat(d + 25, " H ").concat(n)) : (p += BT.boxMargin, d = LT.getVerticalPos() + p, f = t.append("path").attr("d", "M " + n + "," + d + " C " + (n + 60) + "," + (d - 10) + " " + (n + 60) + "," + (d + 30) + " " + n + "," + (d + 20))), p += 30;
                    var g = Math.max(y / 2, BT.width / 2);
                    LT.insert(n - g, LT.getVerticalPos() - 10 + p, r + g, LT.getVerticalPos() + 30 + p);
                  } else p += BT.boxMargin, d = LT.getVerticalPos() + p, (f = t.append("line")).attr("x1", n), f.attr("y1", d), f.attr("x2", r), f.attr("y2", d), LT.insert(n, d - 10, r, d);

                  o === Ok.parser.yy.LINETYPE.DOTTED || o === Ok.parser.yy.LINETYPE.DOTTED_CROSS || o === Ok.parser.yy.LINETYPE.DOTTED_POINT || o === Ok.parser.yy.LINETYPE.DOTTED_OPEN ? (f.style("stroke-dasharray", "3, 3"), f.attr("class", "messageLine1")) : f.attr("class", "messageLine0");
                  var m = "";
                  BT.arrowMarkerAbsolute && (m = (m = (m = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), f.attr("stroke-width", 2), f.attr("stroke", "none"), f.style("fill", "none"), o !== Ok.parser.yy.LINETYPE.SOLID && o !== Ok.parser.yy.LINETYPE.DOTTED || f.attr("marker-end", "url(" + m + "#arrowhead)"), o !== Ok.parser.yy.LINETYPE.SOLID_POINT && o !== Ok.parser.yy.LINETYPE.DOTTED_POINT || f.attr("marker-end", "url(" + m + "#filled-head)"), o !== Ok.parser.yy.LINETYPE.SOLID_CROSS && o !== Ok.parser.yy.LINETYPE.DOTTED_CROSS || f.attr("marker-end", "url(" + m + "#crosshead)"), (eT.showSequenceNumbers() || BT.showSequenceNumbers) && (f.attr("marker-start", "url(" + m + "#sequencenumber)"), t.append("text").attr("x", n).attr("y", d + 4).attr("font-family", "sans-serif").attr("font-size", "12px").attr("text-anchor", "middle").attr("textLength", "16px").attr("class", "sequenceNumber").text(s)), LT.bumpVerticalPos(p), e.height += p, e.stopy = e.starty + e.height, LT.insert(e.fromBounds, e.starty, e.toBounds, e.stopy);
                }(s, r), LT.models.addMessage(r);
              } catch (t) {
                o.error("error while drawing message", t);
              }

          }

          [Ok.parser.yy.LINETYPE.SOLID_OPEN, Ok.parser.yy.LINETYPE.DOTTED_OPEN, Ok.parser.yy.LINETYPE.SOLID, Ok.parser.yy.LINETYPE.DOTTED, Ok.parser.yy.LINETYPE.SOLID_CROSS, Ok.parser.yy.LINETYPE.DOTTED_CROSS, Ok.parser.yy.LINETYPE.SOLID_POINT, Ok.parser.yy.LINETYPE.DOTTED_POINT].includes(t.type) && p++;
        }), BT.mirrorActors && (LT.bumpVerticalPos(2 * BT.boxMargin), PT(s, c, u, LT.getVerticalPos()), LT.bumpVerticalPos(BT.boxMargin), fT(s, LT.getVerticalPos()));
        var y = jT(s, c, u),
            g = LT.getBounds().bounds;
        o.debug("For line height fix Querying: #" + e + " .actor-line"), ou("#" + e + " .actor-line").attr("y2", g.stopy);
        var m = g.stopy - g.starty;
        m < y.maxHeight && (m = y.maxHeight);
        var v = m + 2 * BT.diagramMarginY;
        BT.mirrorActors && (v = v - BT.boxMargin + BT.bottomMarginAdj);
        var b = g.stopx - g.startx;
        b < y.maxWidth && (b = y.maxWidth);

        var _ = b + 2 * BT.diagramMarginX;

        h && s.append("text").text(h).attr("x", (g.stopx - g.startx) / 2 - 2 * BT.diagramMarginX).attr("y", -25), zv(s, v, _, BT.useMaxWidth);
        var x = h ? 40 : 0;
        s.attr("viewBox", g.startx - BT.diagramMarginX + " -" + (BT.diagramMarginY + x) + " " + _ + " " + (v + x)), o.debug("models:", LT.models);
      }
    };
    var WT = n(3584),
        VT = n.n(WT);

    function GT(t) {
      return GT = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, GT(t);
    }

    var XT = function XT(t) {
      return JSON.parse(JSON.stringify(t));
    },
        ZT = [],
        QT = function t(e, n, r) {
      if ("relation" === n.stmt) t(e, n.state1, !0), t(e, n.state2, !1);else if ("state" === n.stmt && "[*]" === n.id && (n.id = r ? e.id + "_start" : e.id + "_end", n.start = r), n.doc) {
        var i = [],
            a = 0,
            o = [];

        for (a = 0; a < n.doc.length; a++) {
          if ("divider" === n.doc[a].type) {
            var s = XT(n.doc[a]);
            s.doc = XT(o), i.push(s), o = [];
          } else o.push(n.doc[a]);
        }

        if (i.length > 0 && o.length > 0) {
          var c = {
            stmt: "state",
            id: Ov(),
            type: "divider",
            doc: XT(o)
          };
          i.push(XT(c)), n.doc = i;
        }

        n.doc.forEach(function (e) {
          return t(n, e, !0);
        });
      }
    },
        KT = {
      root: {
        relations: [],
        states: {},
        documents: {}
      }
    },
        JT = KT.root,
        tE = 0,
        eE = function eE(t, e, n, r, i) {
      void 0 === JT.states[t] ? JT.states[t] = {
        id: t,
        descriptions: [],
        type: e,
        doc: n,
        note: i
      } : (JT.states[t].doc || (JT.states[t].doc = n), JT.states[t].type || (JT.states[t].type = e)), r && (o.info("Adding state ", t, r), "string" == typeof r && iE(t, r.trim()), "object" === GT(r) && r.forEach(function (e) {
        return iE(t, e.trim());
      })), i && (JT.states[t].note = i, JT.states[t].note.text = Um.sanitizeText(JT.states[t].note.text, Jv()));
    },
        nE = function nE() {
      JT = (KT = {
        root: {
          relations: [],
          states: {},
          documents: {}
        }
      }).root, JT = KT.root, tE = 0, oE = [];
    },
        rE = function rE(t, e, n) {
      var r = t,
          i = e,
          a = "default",
          o = "default";
      "[*]" === t && (r = "start" + ++tE, a = "start"), "[*]" === e && (i = "end" + tE, o = "end"), eE(r, a), eE(i, o), JT.relations.push({
        id1: r,
        id2: i,
        title: Um.sanitizeText(n, Jv())
      });
    },
        iE = function iE(t, e) {
      var n = JT.states[t],
          r = e;
      ":" === r[0] && (r = r.substr(1).trim()), n.descriptions.push(Um.sanitizeText(r, Jv()));
    },
        aE = 0,
        oE = [],
        sE = "TB";

    var cE = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().state;
      },
      addState: eE,
      clear: nE,
      getState: function getState(t) {
        return JT.states[t];
      },
      getStates: function getStates() {
        return JT.states;
      },
      getRelations: function getRelations() {
        return JT.relations;
      },
      getClasses: function getClasses() {
        return oE;
      },
      getDirection: function getDirection() {
        return sE;
      },
      addRelation: rE,
      getDividerId: function getDividerId() {
        return "divider-id-" + ++aE;
      },
      setDirection: function setDirection(t) {
        sE = t;
      },
      cleanupLabel: function cleanupLabel(t) {
        return ":" === t.substring(0, 1) ? t.substr(2).trim() : t.trim();
      },
      lineType: {
        LINE: 0,
        DOTTED_LINE: 1
      },
      relationType: {
        AGGREGATION: 0,
        EXTENSION: 1,
        COMPOSITION: 2,
        DEPENDENCY: 3
      },
      logDocuments: function logDocuments() {
        o.info("Documents = ", KT);
      },
      getRootDoc: function getRootDoc() {
        return ZT;
      },
      setRootDoc: function setRootDoc(t) {
        o.info("Setting root doc", t), ZT = t;
      },
      getRootDocV2: function getRootDocV2() {
        return QT({
          id: "root"
        }, {
          id: "root",
          doc: ZT
        }, !0), {
          id: "root",
          doc: ZT
        };
      },
      extract: function extract(t) {
        var e;
        e = t.doc ? t.doc : t, o.info(e), nE(), o.info("Extract", e), e.forEach(function (t) {
          "state" === t.stmt && eE(t.id, t.type, t.doc, t.description, t.note), "relation" === t.stmt && rE(t.state1.id, t.state2.id, t.description);
        });
      },
      trimColon: function trimColon(t) {
        return t && ":" === t[0] ? t.substr(1).trim() : t.trim();
      }
    };
    var uE = {};

    function lE(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var hE,
        fE = function fE(t, e, n) {
      var r,
          i = Jv().state.padding,
          a = 2 * Jv().state.padding,
          o = t.node().getBBox(),
          s = o.width,
          c = o.x,
          u = t.append("text").attr("x", 0).attr("y", Jv().state.titleShift).attr("font-size", Jv().state.fontSize).attr("class", "state-title").text(e.id),
          l = u.node().getBBox().width + a,
          h = Math.max(l, s);
      h === s && (h += a);
      var f = t.node().getBBox();
      e.doc, r = c - i, l > s && (r = (s - h) / 2 + i), Math.abs(c - f.x) < i && l > s && (r = c - (l - s) / 2);
      var d = 1 - Jv().state.textHeight;
      return t.insert("rect", ":first-child").attr("x", r).attr("y", d).attr("class", n ? "alt-composit" : "composit").attr("width", h).attr("height", f.height + Jv().state.textHeight + Jv().state.titleShift + 1).attr("rx", "0"), u.attr("x", r + i), l <= s && u.attr("x", c + (h - a) / 2 - l / 2 + i), t.insert("rect", ":first-child").attr("x", r).attr("y", Jv().state.titleShift - Jv().state.textHeight - Jv().state.padding).attr("width", h).attr("height", 3 * Jv().state.textHeight).attr("rx", Jv().state.radius), t.insert("rect", ":first-child").attr("x", r).attr("y", Jv().state.titleShift - Jv().state.textHeight - Jv().state.padding).attr("width", h).attr("height", f.height + 3 + 2 * Jv().state.textHeight).attr("rx", Jv().state.radius), t;
    },
        dE = function dE(t, e) {
      e.attr("class", "state-note");

      var n = e.append("rect").attr("x", 0).attr("y", Jv().state.padding),
          r = function (t, e, n, r) {
        var i = 0,
            a = r.append("text");
        a.style("text-anchor", "start"), a.attr("class", "noteText");

        var o,
            s = t.replace(/\r\n/g, "<br/>"),
            c = (s = s.replace(/\n/g, "<br/>")).split(Um.lineBreakRegex),
            u = 1.25 * Jv().state.noteMargin,
            l = function (t, e) {
          var _n9 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

          if (!_n9) {
            if (Array.isArray(t) || (_n9 = function (t, e) {
              if (t) {
                if ("string" == typeof t) return lE(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? lE(t, e) : void 0;
              }
            }(t)) || e && t && "number" == typeof t.length) {
              _n9 && (t = _n9);

              var r = 0,
                  i = function i() {};

              return {
                s: i,
                n: function n() {
                  return r >= t.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: t[r++]
                  };
                },
                e: function e(t) {
                  throw t;
                },
                f: i
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var a,
              o = !0,
              s = !1;
          return {
            s: function s() {
              _n9 = _n9.call(t);
            },
            n: function n() {
              var t = _n9.next();

              return o = t.done, t;
            },
            e: function e(t) {
              s = !0, a = t;
            },
            f: function f() {
              try {
                o || null == _n9["return"] || _n9["return"]();
              } finally {
                if (s) throw a;
              }
            }
          };
        }(c);

        try {
          for (l.s(); !(o = l.n()).done;) {
            var h = o.value.trim();

            if (h.length > 0) {
              var f = a.append("tspan");
              f.text(h), 0 === u && (u += f.node().getBBox().height), i += u, f.attr("x", 0 + Jv().state.noteMargin), f.attr("y", 0 + i + 1.25 * Jv().state.noteMargin);
            }
          }
        } catch (t) {
          l.e(t);
        } finally {
          l.f();
        }

        return {
          textWidth: a.node().getBBox().width,
          textHeight: i
        };
      }(t, 0, 0, e.append("g")),
          i = r.textWidth,
          a = r.textHeight;

      return n.attr("height", a + 2 * Jv().state.noteMargin), n.attr("width", i + 2 * Jv().state.noteMargin), n;
    },
        pE = function pE(t, e) {
      var n = e.id,
          r = {
        id: n,
        label: e.id,
        width: 0,
        height: 0
      },
          i = t.append("g").attr("id", n).attr("class", "stateGroup");
      "start" === e.type && function (t) {
        t.append("circle").attr("class", "start-state").attr("r", Jv().state.sizeUnit).attr("cx", Jv().state.padding + Jv().state.sizeUnit).attr("cy", Jv().state.padding + Jv().state.sizeUnit);
      }(i), "end" === e.type && function (t) {
        t.append("circle").attr("class", "end-state-outer").attr("r", Jv().state.sizeUnit + Jv().state.miniPadding).attr("cx", Jv().state.padding + Jv().state.sizeUnit + Jv().state.miniPadding).attr("cy", Jv().state.padding + Jv().state.sizeUnit + Jv().state.miniPadding), t.append("circle").attr("class", "end-state-inner").attr("r", Jv().state.sizeUnit).attr("cx", Jv().state.padding + Jv().state.sizeUnit + 2).attr("cy", Jv().state.padding + Jv().state.sizeUnit + 2);
      }(i), "fork" !== e.type && "join" !== e.type || function (t, e) {
        var n = Jv().state.forkWidth,
            r = Jv().state.forkHeight;

        if (e.parentId) {
          var i = n;
          n = r, r = i;
        }

        t.append("rect").style("stroke", "black").style("fill", "black").attr("width", n).attr("height", r).attr("x", Jv().state.padding).attr("y", Jv().state.padding);
      }(i, e), "note" === e.type && dE(e.note.text, i), "divider" === e.type && function (t) {
        t.append("line").style("stroke", "grey").style("stroke-dasharray", "3").attr("x1", Jv().state.textHeight).attr("class", "divider").attr("x2", 2 * Jv().state.textHeight).attr("y1", 0).attr("y2", 0);
      }(i), "default" === e.type && 0 === e.descriptions.length && function (t, e) {
        var n = t.append("text").attr("x", 2 * Jv().state.padding).attr("y", Jv().state.textHeight + 2 * Jv().state.padding).attr("font-size", Jv().state.fontSize).attr("class", "state-title").text(e.id).node().getBBox();
        t.insert("rect", ":first-child").attr("x", Jv().state.padding).attr("y", Jv().state.padding).attr("width", n.width + 2 * Jv().state.padding).attr("height", n.height + 2 * Jv().state.padding).attr("rx", Jv().state.radius);
      }(i, e), "default" === e.type && e.descriptions.length > 0 && function (t, e) {
        var n = t.append("text").attr("x", 2 * Jv().state.padding).attr("y", Jv().state.textHeight + 1.3 * Jv().state.padding).attr("font-size", Jv().state.fontSize).attr("class", "state-title").text(e.descriptions[0]).node().getBBox(),
            r = n.height,
            i = t.append("text").attr("x", Jv().state.padding).attr("y", r + .4 * Jv().state.padding + Jv().state.dividerMargin + Jv().state.textHeight).attr("class", "state-description"),
            a = !0,
            o = !0;
        e.descriptions.forEach(function (t) {
          a || (function (t, e, n) {
            var r = t.append("tspan").attr("x", 2 * Jv().state.padding).text(e);
            n || r.attr("dy", Jv().state.textHeight);
          }(i, t, o), o = !1), a = !1;
        });
        var s = t.append("line").attr("x1", Jv().state.padding).attr("y1", Jv().state.padding + r + Jv().state.dividerMargin / 2).attr("y2", Jv().state.padding + r + Jv().state.dividerMargin / 2).attr("class", "descr-divider"),
            c = i.node().getBBox(),
            u = Math.max(c.width, n.width);
        s.attr("x2", u + 3 * Jv().state.padding), t.insert("rect", ":first-child").attr("x", Jv().state.padding).attr("y", Jv().state.padding).attr("width", u + 2 * Jv().state.padding).attr("height", c.height + r + 2 * Jv().state.padding).attr("rx", Jv().state.radius);
      }(i, e);
      var a,
          o = i.node().getBBox();
      return r.width = o.width + 2 * Jv().state.padding, r.height = o.height + 2 * Jv().state.padding, a = r, uE[n] = a, r;
    },
        yE = 0;

    WT.parser.yy = cE;

    var gE = {},
        mE = function t(e, n, r, i, a, s) {
      var c,
          u = new (kb().Graph)({
        compound: !0,
        multigraph: !0
      }),
          l = !0;

      for (c = 0; c < e.length; c++) {
        if ("relation" === e[c].stmt) {
          l = !1;
          break;
        }
      }

      r ? u.setGraph({
        rankdir: "LR",
        multigraph: !0,
        compound: !0,
        ranker: "tight-tree",
        ranksep: l ? 1 : hE.edgeLengthFactor,
        nodeSep: l ? 1 : 50,
        isMultiGraph: !0
      }) : u.setGraph({
        rankdir: "TB",
        multigraph: !0,
        compound: !0,
        ranksep: l ? 1 : hE.edgeLengthFactor,
        nodeSep: l ? 1 : 50,
        ranker: "tight-tree",
        isMultiGraph: !0
      }), u.setDefaultEdgeLabel(function () {
        return {};
      }), cE.extract(e);

      for (var h = cE.getStates(), f = cE.getRelations(), d = Object.keys(h), p = 0; p < d.length; p++) {
        var y = h[d[p]];
        r && (y.parentId = r);
        var g = void 0;

        if (y.doc) {
          var m = n.append("g").attr("id", y.id).attr("class", "stateGroup");
          g = t(y.doc, m, y.id, !i, a, s);
          var v = (m = fE(m, y, i)).node().getBBox();
          g.width = v.width, g.height = v.height + hE.padding / 2, gE[y.id] = {
            y: hE.compositTitleSize
          };
        } else g = pE(n, y);

        if (y.note) {
          var b = {
            descriptions: [],
            id: y.id + "-note",
            note: y.note,
            type: "note"
          },
              _ = pE(n, b);

          "left of" === y.note.position ? (u.setNode(g.id + "-note", _), u.setNode(g.id, g)) : (u.setNode(g.id, g), u.setNode(g.id + "-note", _)), u.setParent(g.id, g.id + "-group"), u.setParent(g.id + "-note", g.id + "-group");
        } else u.setNode(g.id, g);
      }

      o.debug("Count=", u.nodeCount(), u);
      var x = 0;
      f.forEach(function (t) {
        var e;
        x++, o.debug("Setting edge", t), u.setEdge(t.id1, t.id2, {
          relation: t,
          width: (e = t.title, e ? e.length * hE.fontSizeFactor : 1),
          height: hE.labelHeight * Um.getRows(t.title).length,
          labelpos: "c"
        }, "id" + x);
      }), xb().layout(u), o.debug("Graph after layout", u.nodes());
      var w = n.node();
      u.nodes().forEach(function (t) {
        void 0 !== t && void 0 !== u.node(t) ? (o.warn("Node " + t + ": " + JSON.stringify(u.node(t))), a.select("#" + w.id + " #" + t).attr("transform", "translate(" + (u.node(t).x - u.node(t).width / 2) + "," + (u.node(t).y + (gE[t] ? gE[t].y : 0) - u.node(t).height / 2) + " )"), a.select("#" + w.id + " #" + t).attr("data-x-shift", u.node(t).x - u.node(t).width / 2), s.querySelectorAll("#" + w.id + " #" + t + " .divider").forEach(function (t) {
          var e = t.parentElement,
              n = 0,
              r = 0;
          e && (e.parentElement && (n = e.parentElement.getBBox().width), r = parseInt(e.getAttribute("data-x-shift"), 10), Number.isNaN(r) && (r = 0)), t.setAttribute("x1", 0 - r + 8), t.setAttribute("x2", n - r - 8);
        })) : o.debug("No Node " + t + ": " + JSON.stringify(u.node(t)));
      });
      var k = w.getBBox();
      u.edges().forEach(function (t) {
        void 0 !== t && void 0 !== u.edge(t) && (o.debug("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(u.edge(t))), function (t, e, n) {
          e.points = e.points.filter(function (t) {
            return !Number.isNaN(t.y);
          });
          var r = e.points,
              i = zu().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          }).curve(Vu),
              a = t.append("path").attr("d", i(r)).attr("id", "edge" + yE).attr("class", "transition"),
              s = "";

          if (Jv().state.arrowMarkerAbsolute && (s = (s = (s = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), a.attr("marker-end", "url(" + s + "#" + function (t) {
            switch (t) {
              case cE.relationType.AGGREGATION:
                return "aggregation";

              case cE.relationType.EXTENSION:
                return "extension";

              case cE.relationType.COMPOSITION:
                return "composition";

              case cE.relationType.DEPENDENCY:
                return "dependency";
            }
          }(cE.relationType.DEPENDENCY) + "End)"), void 0 !== n.title) {
            for (var c = t.append("g").attr("class", "stateLabel"), u = Hv.calcLabelPosition(e.points), l = u.x, h = u.y, f = Um.getRows(n.title), d = 0, p = [], y = 0, g = 0, m = 0; m <= f.length; m++) {
              var v = c.append("text").attr("text-anchor", "middle").text(f[m]).attr("x", l).attr("y", h + d),
                  b = v.node().getBBox();

              if (y = Math.max(y, b.width), g = Math.min(g, b.x), o.info(b.x, l, h + d), 0 === d) {
                var _ = v.node().getBBox();

                d = _.height, o.info("Title height", d, h);
              }

              p.push(v);
            }

            var x = d * f.length;

            if (f.length > 1) {
              var w = (f.length - 1) * d * .5;
              p.forEach(function (t, e) {
                return t.attr("y", h + e * d - w);
              }), x = d * f.length;
            }

            var k = c.node().getBBox();
            c.insert("rect", ":first-child").attr("class", "box").attr("x", l - y / 2 - Jv().state.padding / 2).attr("y", h - x / 2 - Jv().state.padding / 2 - 3.5).attr("width", y + Jv().state.padding).attr("height", x + Jv().state.padding), o.info(k);
          }

          yE++;
        }(n, u.edge(t), u.edge(t).relation));
      }), k = w.getBBox();
      var T = {
        id: r || "root",
        label: r || "root",
        width: 0,
        height: 0
      };
      return T.width = k.width + 2 * hE.padding, T.height = k.height + 2 * hE.padding, o.debug("Doc rendered", T, u), T;
    };

    var vE = function vE(t, e) {
      hE = Jv().state;
      var n,
          r = Jv().securityLevel;
      "sandbox" === r && (n = au("#i" + e));
      var i = au("sandbox" === r ? n.nodes()[0].contentDocument.body : "body"),
          a = "sandbox" === r ? n.nodes()[0].contentDocument : document;
      WT.parser.yy.clear(), WT.parser.parse(t), o.debug("Rendering diagram " + t);
      var s = i.select("[id='".concat(e, "']"));
      s.append("defs").append("marker").attr("id", "dependencyEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 19,7 L9,13 L14,7 L9,1 Z"), new (kb().Graph)({
        multigraph: !0,
        compound: !0,
        rankdir: "RL"
      }).setDefaultEdgeLabel(function () {
        return {};
      });
      var c = cE.getRootDoc();
      mE(c, s, void 0, !1, i, a);
      var u = hE.padding,
          l = s.node().getBBox(),
          h = l.width + 2 * u,
          f = l.height + 2 * u;
      zv(s, f, 1.75 * h, hE.useMaxWidth), s.attr("viewBox", "".concat(l.x - hE.padding, "  ").concat(l.y - hE.padding, " ") + h + " " + f);
    };

    var bE = {},
        _E = {},
        xE = function xE(t, e, n, r) {
      if ("root" !== n.id) {
        var i = "rect";
        !0 === n.start && (i = "start"), !1 === n.start && (i = "end"), "default" !== n.type && (i = n.type), _E[n.id] || (_E[n.id] = {
          id: n.id,
          shape: i,
          description: Um.sanitizeText(n.id, Jv()),
          classes: "statediagram-state"
        }), n.description && (Array.isArray(_E[n.id].description) ? (_E[n.id].shape = "rectWithTitle", _E[n.id].description.push(n.description)) : _E[n.id].description.length > 0 ? (_E[n.id].shape = "rectWithTitle", _E[n.id].description === n.id ? _E[n.id].description = [n.description] : _E[n.id].description = [_E[n.id].description, n.description]) : (_E[n.id].shape = "rect", _E[n.id].description = n.description), _E[n.id].description = Um.sanitizeTextOrArray(_E[n.id].description, Jv())), 1 === _E[n.id].description.length && "rectWithTitle" === _E[n.id].shape && (_E[n.id].shape = "rect"), !_E[n.id].type && n.doc && (o.info("Setting cluster for ", n.id, TE(n)), _E[n.id].type = "group", _E[n.id].dir = TE(n), _E[n.id].shape = "divider" === n.type ? "divider" : "roundedWithTitle", _E[n.id].classes = _E[n.id].classes + " " + (r ? "statediagram-cluster statediagram-cluster-alt" : "statediagram-cluster"));
        var a = {
          labelStyle: "",
          shape: _E[n.id].shape,
          labelText: _E[n.id].description,
          classes: _E[n.id].classes,
          style: "",
          id: n.id,
          dir: _E[n.id].dir,
          domId: "state-" + n.id + "-" + wE,
          type: _E[n.id].type,
          padding: 15
        };

        if (n.note) {
          var s = {
            labelStyle: "",
            shape: "note",
            labelText: n.note.text,
            classes: "statediagram-note",
            style: "",
            id: n.id + "----note-" + wE,
            domId: "state-" + n.id + "----note-" + wE,
            type: _E[n.id].type,
            padding: 15
          },
              c = {
            labelStyle: "",
            shape: "noteGroup",
            labelText: n.note.text,
            classes: _E[n.id].classes,
            style: "",
            id: n.id + "----parent",
            domId: "state-" + n.id + "----parent-" + wE,
            type: "group",
            padding: 0
          };
          wE++, t.setNode(n.id + "----parent", c), t.setNode(s.id, s), t.setNode(n.id, a), t.setParent(n.id, n.id + "----parent"), t.setParent(s.id, n.id + "----parent");
          var u = n.id,
              l = s.id;
          "left of" === n.note.position && (u = s.id, l = n.id), t.setEdge(u, l, {
            arrowhead: "none",
            arrowType: "",
            style: "fill:none",
            labelStyle: "",
            classes: "transition note-edge",
            arrowheadStyle: "fill: #333",
            labelpos: "c",
            labelType: "text",
            thickness: "normal"
          });
        } else t.setNode(n.id, a);
      }

      e && "root" !== e.id && (o.trace("Setting node ", n.id, " to be child of its parent ", e.id), t.setParent(n.id, e.id)), n.doc && (o.trace("Adding nodes children "), kE(t, n, n.doc, !r));
    },
        wE = 0,
        kE = function kE(t, e, n, r) {
      o.trace("items", n), n.forEach(function (n) {
        if ("state" === n.stmt || "default" === n.stmt) xE(t, e, n, r);else if ("relation" === n.stmt) {
          xE(t, e, n.state1, r), xE(t, e, n.state2, r);
          var i = {
            id: "edge" + wE,
            arrowhead: "normal",
            arrowTypeEnd: "arrow_barb",
            style: "fill:none",
            labelStyle: "",
            label: Um.sanitizeText(n.description, Jv()),
            arrowheadStyle: "fill: #333",
            labelpos: "c",
            labelType: "text",
            thickness: "normal",
            classes: "transition"
          },
              a = n.state1.id,
              o = n.state2.id;
          t.setEdge(a, o, i, wE), wE++;
        }
      });
    },
        TE = function TE(t, e) {
      var n = e || "TB";
      if (t.doc) for (var r = 0; r < t.doc.length; r++) {
        var i = t.doc[r];
        "dir" === i.stmt && (n = i.value);
      }
      return n;
    };

    var EE = function EE(t) {
      for (var e = Object.keys(t), n = 0; n < e.length; n++) {
        bE[e[n]] = t[e[n]];
      }
    };

    function CE(t) {
      return function (t) {
        if (Array.isArray(t)) return SE(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return SE(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? SE(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function SE(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    }

    var AE = "",
        ME = "",
        NE = [],
        DE = [],
        OE = [],
        BE = function BE() {
      for (var t = !0, e = 0; e < OE.length; e++) {
        OE[e].processed, t = t && OE[e].processed;
      }

      return t;
    };

    var LE = {
      parseDirective: function parseDirective(t, e, n) {
        uC.parseDirective(this, t, e, n);
      },
      getConfig: function getConfig() {
        return Jv().journey;
      },
      clear: function clear() {
        NE.length = 0, DE.length = 0, ME = "", AE = "", OE.length = 0;
      },
      setTitle: function setTitle(t) {
        AE = t;
      },
      getTitle: function getTitle() {
        return AE;
      },
      addSection: function addSection(t) {
        ME = t, NE.push(t);
      },
      getSections: function getSections() {
        return NE;
      },
      getTasks: function getTasks() {
        for (var t = BE(), e = 0; !t && e < 100;) {
          t = BE(), e++;
        }

        return DE.push.apply(DE, OE), DE;
      },
      addTask: function addTask(t, e) {
        var n = e.substr(1).split(":"),
            r = 0,
            i = [];
        1 === n.length ? (r = Number(n[0]), i = []) : (r = Number(n[0]), i = n[1].split(","));
        var a = i.map(function (t) {
          return t.trim();
        }),
            o = {
          section: ME,
          type: ME,
          people: a,
          task: t,
          score: r
        };
        OE.push(o);
      },
      addTaskOrg: function addTaskOrg(t) {
        var e = {
          section: ME,
          type: ME,
          description: t,
          task: t,
          classes: []
        };
        DE.push(e);
      },
      getActors: function getActors() {
        return t = [], DE.forEach(function (e) {
          e.people && t.push.apply(t, CE(e.people));
        }), CE(new Set(t)).sort();
        var t;
      }
    };

    var IE = n(9763),
        RE = n.n(IE),
        FE = function FE(t, e) {
      var n = t.append("rect");
      return n.attr("x", e.x), n.attr("y", e.y), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("width", e.width), n.attr("height", e.height), n.attr("rx", e.rx), n.attr("ry", e.ry), void 0 !== e["class"] && n.attr("class", e["class"]), n;
    },
        PE = function PE(t, e) {
      var n = t.append("circle");
      return n.attr("cx", e.cx), n.attr("cy", e.cy), n.attr("class", "actor-" + e.pos), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("r", e.r), void 0 !== n["class"] && n.attr("class", n["class"]), void 0 !== e.title && n.append("title").text(e.title), n;
    },
        jE = -1,
        YE = function () {
      function t(t, e, n, i, a, o, s, c) {
        r(e.append("text").attr("x", n + a / 2).attr("y", i + o / 2 + 5).style("font-color", c).style("text-anchor", "middle").text(t), s);
      }

      function e(t, e, n, i, a, o, s, c, u) {
        for (var l = c.taskFontSize, h = c.taskFontFamily, f = t.split(/<br\s*\/?>/gi), d = 0; d < f.length; d++) {
          var p = d * l - l * (f.length - 1) / 2,
              y = e.append("text").attr("x", n + a / 2).attr("y", i).attr("fill", u).style("text-anchor", "middle").style("font-size", l).style("font-family", h);
          y.append("tspan").attr("x", n + a / 2).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
        }
      }

      function n(t, n, i, a, o, s, c, u) {
        var l = n.append("switch"),
            h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).attr("position", "fixed").append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
        h.append("div").attr("class", "label").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, o, s, c, u), r(h, c);
      }

      function r(t, e) {
        for (var n in e) {
          n in e && t.attr(n, e[n]);
        }
      }

      return function (r) {
        return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
      };
    }();

    var zE = PE,
        UE = function UE(t, e, n) {
      var r = t.append("g"),
          i = {
        x: 0,
        y: 0,
        width: 100,
        anchor: "start",
        height: 100,
        rx: 0,
        ry: 0
      };
      i.x = e.x, i.y = e.y, i.fill = e.fill, i.width = n.width, i.height = n.height, i["class"] = "journey-section section-type-" + e.num, i.rx = 3, i.ry = 3, FE(r, i), YE(n)(e.text, r, i.x, i.y, i.width, i.height, {
        "class": "journey-section section-type-" + e.num
      }, n, e.colour);
    },
        qE = function qE(t, e) {
      var n = e.text.replace(/<br\s*\/?>/gi, " "),
          r = t.append("text");
      r.attr("x", e.x), r.attr("y", e.y), r.attr("class", "legend"), r.style("text-anchor", e.anchor), void 0 !== e["class"] && r.attr("class", e["class"]);
      var i = r.append("tspan");
      return i.attr("x", e.x + 2 * e.textMargin), i.text(n), r;
    },
        HE = function HE(t, e, n) {
      var r,
          i,
          a,
          o = e.x + n.width / 2,
          s = t.append("g");
      jE++, s.append("line").attr("id", "task" + jE).attr("x1", o).attr("y1", e.y).attr("x2", o).attr("y2", 450).attr("class", "task-line").attr("stroke-width", "1px").attr("stroke-dasharray", "4 2").attr("stroke", "#666"), r = s, i = {
        cx: o,
        cy: 300 + 30 * (5 - e.score),
        score: e.score
      }, r.append("circle").attr("cx", i.cx).attr("cy", i.cy).attr("class", "face").attr("r", 15).attr("stroke-width", 2).attr("overflow", "visible"), (a = r.append("g")).append("circle").attr("cx", i.cx - 5).attr("cy", i.cy - 5).attr("r", 1.5).attr("stroke-width", 2).attr("fill", "#666").attr("stroke", "#666"), a.append("circle").attr("cx", i.cx + 5).attr("cy", i.cy - 5).attr("r", 1.5).attr("stroke-width", 2).attr("fill", "#666").attr("stroke", "#666"), i.score > 3 ? function (t) {
        var e = Iu().startAngle(Math.PI / 2).endAngle(Math.PI / 2 * 3).innerRadius(7.5).outerRadius(15 / 2.2);
        t.append("path").attr("class", "mouth").attr("d", e).attr("transform", "translate(" + i.cx + "," + (i.cy + 2) + ")");
      }(a) : i.score < 3 ? function (t) {
        var e = Iu().startAngle(3 * Math.PI / 2).endAngle(Math.PI / 2 * 5).innerRadius(7.5).outerRadius(15 / 2.2);
        t.append("path").attr("class", "mouth").attr("d", e).attr("transform", "translate(" + i.cx + "," + (i.cy + 7) + ")");
      }(a) : function (t) {
        t.append("line").attr("class", "mouth").attr("stroke", 2).attr("x1", i.cx - 5).attr("y1", i.cy + 7).attr("x2", i.cx + 5).attr("y2", i.cy + 7).attr("class", "mouth").attr("stroke-width", "1px").attr("stroke", "#666");
      }(a);
      var c = {
        x: 0,
        y: 0,
        width: 100,
        anchor: "start",
        height: 100,
        rx: 0,
        ry: 0
      };
      c.x = e.x, c.y = e.y, c.fill = e.fill, c.width = n.width, c.height = n.height, c["class"] = "task task-type-" + e.num, c.rx = 3, c.ry = 3, FE(s, c);
      var u = e.x + 14;
      e.people.forEach(function (t) {
        var n = e.actors[t].color,
            r = {
          cx: u,
          cy: e.y,
          r: 7,
          fill: n,
          stroke: "#000",
          title: t,
          pos: e.actors[t].position
        };
        PE(s, r), u += 10;
      }), YE(n)(e.task, s, c.x, c.y, c.width, c.height, {
        "class": "task"
      }, n, e.colour);
    };

    IE.parser.yy = LE;
    var $E = {},
        WE = Jv().journey,
        VE = Jv().journey.leftMargin,
        GE = {
      data: {
        startx: void 0,
        stopx: void 0,
        starty: void 0,
        stopy: void 0
      },
      verticalPos: 0,
      sequenceItems: [],
      init: function init() {
        this.sequenceItems = [], this.data = {
          startx: void 0,
          stopx: void 0,
          starty: void 0,
          stopy: void 0
        }, this.verticalPos = 0;
      },
      updateVal: function updateVal(t, e, n, r) {
        void 0 === t[e] ? t[e] = n : t[e] = r(n, t[e]);
      },
      updateBounds: function updateBounds(t, e, n, r) {
        var i = Jv().journey,
            a = this,
            o = 0;
        this.sequenceItems.forEach(function (s) {
          o++;
          var c = a.sequenceItems.length - o + 1;
          a.updateVal(s, "starty", e - c * i.boxMargin, Math.min), a.updateVal(s, "stopy", r + c * i.boxMargin, Math.max), a.updateVal(GE.data, "startx", t - c * i.boxMargin, Math.min), a.updateVal(GE.data, "stopx", n + c * i.boxMargin, Math.max), a.updateVal(s, "startx", t - c * i.boxMargin, Math.min), a.updateVal(s, "stopx", n + c * i.boxMargin, Math.max), a.updateVal(GE.data, "starty", e - c * i.boxMargin, Math.min), a.updateVal(GE.data, "stopy", r + c * i.boxMargin, Math.max);
        });
      },
      insert: function insert(t, e, n, r) {
        var i = Math.min(t, n),
            a = Math.max(t, n),
            o = Math.min(e, r),
            s = Math.max(e, r);
        this.updateVal(GE.data, "startx", i, Math.min), this.updateVal(GE.data, "starty", o, Math.min), this.updateVal(GE.data, "stopx", a, Math.max), this.updateVal(GE.data, "stopy", s, Math.max), this.updateBounds(i, o, a, s);
      },
      bumpVerticalPos: function bumpVerticalPos(t) {
        this.verticalPos = this.verticalPos + t, this.data.stopy = this.verticalPos;
      },
      getVerticalPos: function getVerticalPos() {
        return this.verticalPos;
      },
      getBounds: function getBounds() {
        return this.data;
      }
    },
        XE = WE.sectionFills,
        ZE = WE.sectionColours;

    var QE = function QE(t) {
      Object.keys(t).forEach(function (e) {
        WE[e] = t[e];
      });
    },
        KE = function KE(t, e) {
      var n = Jv().journey;
      IE.parser.yy.clear(), IE.parser.parse(t + "\n");
      var r,
          i = Jv().securityLevel;
      "sandbox" === i && (r = au("#i" + e));
      var a = au("sandbox" === i ? r.nodes()[0].contentDocument.body : "body");
      "sandbox" === i ? r.nodes()[0].contentDocument : document, GE.init();
      var o = a.select("#" + e);
      o.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), o.append("defs").append("marker").attr("id", "arrowhead").attr("refX", 5).attr("refY", 2).attr("markerWidth", 6).attr("markerHeight", 4).attr("orient", "auto").append("path").attr("d", "M 0,0 V 4 L6,2 Z");
      var s = IE.parser.yy.getTasks(),
          c = IE.parser.yy.getTitle(),
          u = IE.parser.yy.getActors();

      for (var l in $E) {
        delete $E[l];
      }

      var h = 0;
      u.forEach(function (t) {
        $E[t] = {
          color: n.actorColours[h % n.actorColours.length],
          position: h
        }, h++;
      }), function (t) {
        var e = Jv().journey,
            n = 60;
        Object.keys($E).forEach(function (r) {
          var i = $E[r].color,
              a = {
            cx: 20,
            cy: n,
            r: 7,
            fill: i,
            stroke: "#000",
            pos: $E[r].position
          };
          zE(t, a);
          var o = {
            x: 40,
            y: n + 7,
            fill: "#666",
            text: r,
            textMargin: 5 | e.boxTextMargin
          };
          qE(t, o), n += 20;
        });
      }(o), GE.insert(0, 0, VE, 50 * Object.keys($E).length), function (t, e, n) {
        for (var r = Jv().journey, i = "", a = n + (2 * r.height + r.diagramMarginY), o = 0, s = "#CCC", c = "black", u = 0, l = 0; l < e.length; l++) {
          var h = e[l];

          if (i !== h.section) {
            s = XE[o % XE.length], u = o % XE.length, c = ZE[o % ZE.length];
            var f = {
              x: l * r.taskMargin + l * r.width + VE,
              y: 50,
              text: h.section,
              fill: s,
              num: u,
              colour: c
            };
            UE(t, f, r), i = h.section, o++;
          }

          var d = h.people.reduce(function (t, e) {
            return $E[e] && (t[e] = $E[e]), t;
          }, {});
          h.x = l * r.taskMargin + l * r.width + VE, h.y = a, h.width = r.diagramMarginX, h.height = r.diagramMarginY, h.colour = c, h.fill = s, h.num = u, h.actors = d, HE(t, h, r), GE.insert(h.x, h.y, h.x + h.width + r.taskMargin, 450);
        }
      }(o, s, 0);
      var f = GE.getBounds();
      c && o.append("text").text(c).attr("x", VE).attr("font-size", "4ex").attr("font-weight", "bold").attr("y", 25);
      var d = f.stopy - f.starty + 2 * n.diagramMarginY,
          p = VE + f.stopx + 2 * n.diagramMarginX;
      zv(o, d, p, n.useMaxWidth), o.append("line").attr("x1", VE).attr("y1", 4 * n.height).attr("x2", p - VE - 4).attr("y2", 4 * n.height).attr("stroke-width", 4).attr("stroke", "black").attr("marker-end", "url(#arrowhead)");
      var y = c ? 70 : 0;
      o.attr("viewBox", "".concat(f.startx, " -25 ").concat(p, " ").concat(d + y)), o.attr("preserveAspectRatio", "xMinYMin meet"), o.attr("height", d + y + 25);
    };

    var JE = {};

    var tC = function tC(t) {
      return "g.classGroup text {\n  fill: ".concat(t.nodeBorder, ";\n  fill: ").concat(t.classText, ";\n  stroke: none;\n  font-family: ").concat(t.fontFamily, ";\n  font-size: 10px;\n\n  .title {\n    font-weight: bolder;\n  }\n\n}\n\n.nodeLabel, .edgeLabel {\n  color: ").concat(t.classText, ";\n}\n.edgeLabel .label rect {\n  fill: ").concat(t.mainBkg, ";\n}\n.label text {\n  fill: ").concat(t.classText, ";\n}\n.edgeLabel .label span {\n  background: ").concat(t.mainBkg, ";\n}\n\n.classTitle {\n  font-weight: bolder;\n}\n.node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n\n.divider {\n  stroke: ").concat(t.nodeBorder, ";\n  stroke: 1;\n}\n\ng.clickable {\n  cursor: pointer;\n}\n\ng.classGroup rect {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.nodeBorder, ";\n}\n\ng.classGroup line {\n  stroke: ").concat(t.nodeBorder, ";\n  stroke-width: 1;\n}\n\n.classLabel .box {\n  stroke: none;\n  stroke-width: 0;\n  fill: ").concat(t.mainBkg, ";\n  opacity: 0.5;\n}\n\n.classLabel .label {\n  fill: ").concat(t.nodeBorder, ";\n  font-size: 10px;\n}\n\n.relation {\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n  fill: none;\n}\n\n.dashed-line{\n  stroke-dasharray: 3;\n}\n\n#compositionStart, .composition {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#compositionEnd, .composition {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#dependencyStart, .dependency {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#dependencyStart, .dependency {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#extensionStart, .extension {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#extensionEnd, .extension {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#aggregationStart, .aggregation {\n  fill: ").concat(t.mainBkg, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#aggregationEnd, .aggregation {\n  fill: ").concat(t.mainBkg, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n.edgeTerminals {\n  font-size: 11px;\n}\n\n");
    },
        eC = function eC(t) {
      return ".label {\n    font-family: ".concat(t.fontFamily, ";\n    color: ").concat(t.nodeTextColor || t.textColor, ";\n  }\n  .cluster-label text {\n    fill: ").concat(t.titleColor, ";\n  }\n  .cluster-label span {\n    color: ").concat(t.titleColor, ";\n  }\n\n  .label text,span {\n    fill: ").concat(t.nodeTextColor || t.textColor, ";\n    color: ").concat(t.nodeTextColor || t.textColor, ";\n  }\n\n  .node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n  .node .label {\n    text-align: center;\n  }\n  .node.clickable {\n    cursor: pointer;\n  }\n\n  .arrowheadPath {\n    fill: ").concat(t.arrowheadColor, ";\n  }\n\n  .edgePath .path {\n    stroke: ").concat(t.lineColor, ";\n    stroke-width: 2.0px;\n  }\n\n  .flowchart-link {\n    stroke: ").concat(t.lineColor, ";\n    fill: none;\n  }\n\n  .edgeLabel {\n    background-color: ").concat(t.edgeLabelBackground, ";\n    rect {\n      opacity: 0.5;\n      background-color: ").concat(t.edgeLabelBackground, ";\n      fill: ").concat(t.edgeLabelBackground, ";\n    }\n    text-align: center;\n  }\n\n  .cluster rect {\n    fill: ").concat(t.clusterBkg, ";\n    stroke: ").concat(t.clusterBorder, ";\n    stroke-width: 1px;\n  }\n\n  .cluster text {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .cluster span {\n    color: ").concat(t.titleColor, ";\n  }\n  /* .cluster div {\n    color: ").concat(t.titleColor, ";\n  } */\n\n  div.mermaidTooltip {\n    position: absolute;\n    text-align: center;\n    max-width: 200px;\n    padding: 2px;\n    font-family: ").concat(t.fontFamily, ";\n    font-size: 12px;\n    background: ").concat(t.tertiaryColor, ";\n    border: 1px solid ").concat(t.border2, ";\n    border-radius: 2px;\n    pointer-events: none;\n    z-index: 100;\n  }\n");
    },
        nC = function nC(t) {
      return "\ndefs #statediagram-barbEnd {\n    fill: ".concat(t.transitionColor, ";\n    stroke: ").concat(t.transitionColor, ";\n  }\ng.stateGroup text {\n  fill: ").concat(t.nodeBorder, ";\n  stroke: none;\n  font-size: 10px;\n}\ng.stateGroup text {\n  fill: ").concat(t.textColor, ";\n  stroke: none;\n  font-size: 10px;\n\n}\ng.stateGroup .state-title {\n  font-weight: bolder;\n  fill: ").concat(t.stateLabelColor, ";\n}\n\ng.stateGroup rect {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.nodeBorder, ";\n}\n\ng.stateGroup line {\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n}\n\n.transition {\n  stroke: ").concat(t.transitionColor, ";\n  stroke-width: 1;\n  fill: none;\n}\n\n.stateGroup .composit {\n  fill: ").concat(t.background, ";\n  border-bottom: 1px\n}\n\n.stateGroup .alt-composit {\n  fill: #e0e0e0;\n  border-bottom: 1px\n}\n\n.state-note {\n  stroke: ").concat(t.noteBorderColor, ";\n  fill: ").concat(t.noteBkgColor, ";\n\n  text {\n    fill: ").concat(t.noteTextColor, ";\n    stroke: none;\n    font-size: 10px;\n  }\n}\n\n.stateLabel .box {\n  stroke: none;\n  stroke-width: 0;\n  fill: ").concat(t.mainBkg, ";\n  opacity: 0.5;\n}\n\n.edgeLabel .label rect {\n  fill: ").concat(t.labelBackgroundColor, ";\n  opacity: 0.5;\n}\n.edgeLabel .label text {\n  fill: ").concat(t.transitionLabelColor || t.tertiaryTextColor, ";\n}\n.label div .edgeLabel {\n  color: ").concat(t.transitionLabelColor || t.tertiaryTextColor, ";\n}\n\n.stateLabel text {\n  fill: ").concat(t.stateLabelColor, ";\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.node circle.state-start {\n  fill: ").concat(t.specialStateColor, ";\n  stroke: ").concat(t.specialStateColor, ";\n}\n\n.node .fork-join {\n  fill: ").concat(t.specialStateColor, ";\n  stroke: ").concat(t.specialStateColor, ";\n}\n\n.node circle.state-end {\n  fill: ").concat(t.innerEndBackground, ";\n  stroke: ").concat(t.background, ";\n  stroke-width: 1.5\n}\n.end-state-inner {\n  fill: ").concat(t.compositeBackground || t.background, ";\n  // stroke: ").concat(t.background, ";\n  stroke-width: 1.5\n}\n\n.node rect {\n  fill: ").concat(t.stateBkg || t.mainBkg, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n  stroke-width: 1px;\n}\n.node polygon {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";;\n  stroke-width: 1px;\n}\n#statediagram-barbEnd {\n  fill: ").concat(t.lineColor, ";\n}\n\n.statediagram-cluster rect {\n  fill: ").concat(t.compositeTitleBackground, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n  stroke-width: 1px;\n}\n\n.cluster-label, .nodeLabel {\n  color: ").concat(t.stateLabelColor, ";\n}\n\n.statediagram-cluster rect.outer {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-state .divider {\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n}\n\n.statediagram-state .title-state {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-cluster.statediagram-cluster .inner {\n  fill: ").concat(t.compositeBackground || t.background, ";\n}\n.statediagram-cluster.statediagram-cluster-alt .inner {\n  fill: ").concat(t.altBackground ? t.altBackground : "#efefef", ";\n}\n\n.statediagram-cluster .inner {\n  rx:0;\n  ry:0;\n}\n\n.statediagram-state rect.basic {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-state rect.divider {\n  stroke-dasharray: 10,10;\n  fill: ").concat(t.altBackground ? t.altBackground : "#efefef", ";\n}\n\n.note-edge {\n  stroke-dasharray: 5;\n}\n\n.statediagram-note rect {\n  fill: ").concat(t.noteBkgColor, ";\n  stroke: ").concat(t.noteBorderColor, ";\n  stroke-width: 1px;\n  rx: 0;\n  ry: 0;\n}\n.statediagram-note rect {\n  fill: ").concat(t.noteBkgColor, ";\n  stroke: ").concat(t.noteBorderColor, ";\n  stroke-width: 1px;\n  rx: 0;\n  ry: 0;\n}\n\n.statediagram-note text {\n  fill: ").concat(t.noteTextColor, ";\n}\n\n.statediagram-note .nodeLabel {\n  color: ").concat(t.noteTextColor, ";\n}\n.statediagram .edgeLabel {\n  color: red; // ").concat(t.noteTextColor, ";\n}\n\n#dependencyStart, #dependencyEnd {\n  fill: ").concat(t.lineColor, ";\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n}\n");
    };

    var rC = {
      flowchart: eC,
      "flowchart-v2": eC,
      sequence: function sequence(t) {
        return ".actor {\n    stroke: ".concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n  }\n\n  text.actor > tspan {\n    fill: ").concat(t.actorTextColor, ";\n    stroke: none;\n  }\n\n  .actor-line {\n    stroke: ").concat(t.actorLineColor, ";\n  }\n\n  .messageLine0 {\n    stroke-width: 1.5;\n    stroke-dasharray: none;\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .messageLine1 {\n    stroke-width: 1.5;\n    stroke-dasharray: 2, 2;\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  #arrowhead path {\n    fill: ").concat(t.signalColor, ";\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .sequenceNumber {\n    fill: ").concat(t.sequenceNumberColor, ";\n  }\n\n  #sequencenumber {\n    fill: ").concat(t.signalColor, ";\n  }\n\n  #crosshead path {\n    fill: ").concat(t.signalColor, ";\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .messageText {\n    fill: ").concat(t.signalTextColor, ";\n    stroke: ").concat(t.signalTextColor, ";\n  }\n\n  .labelBox {\n    stroke: ").concat(t.labelBoxBorderColor, ";\n    fill: ").concat(t.labelBoxBkgColor, ";\n  }\n\n  .labelText, .labelText > tspan {\n    fill: ").concat(t.labelTextColor, ";\n    stroke: none;\n  }\n\n  .loopText, .loopText > tspan {\n    fill: ").concat(t.loopTextColor, ";\n    stroke: none;\n  }\n\n  .loopLine {\n    stroke-width: 2px;\n    stroke-dasharray: 2, 2;\n    stroke: ").concat(t.labelBoxBorderColor, ";\n    fill: ").concat(t.labelBoxBorderColor, ";\n  }\n\n  .note {\n    //stroke: #decc93;\n    stroke: ").concat(t.noteBorderColor, ";\n    fill: ").concat(t.noteBkgColor, ";\n  }\n\n  .noteText, .noteText > tspan {\n    fill: ").concat(t.noteTextColor, ";\n    stroke: none;\n  }\n\n  .activation0 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .activation1 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .activation2 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .actorPopupMenu {\n    position: absolute;\n  }\n\n  .actorPopupMenuPanel {\n    position: absolute;\n    fill: ").concat(t.actorBkg, ";\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));\n}\n  .actor-man line {\n    stroke: ").concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n  }\n  .actor-man circle, line {\n    stroke: ").concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n    stroke-width: 2px;\n  }\n");
      },
      gantt: function gantt(t) {
        return '\n  .mermaid-main-font {\n    font-family: "trebuchet ms", verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n  .exclude-range {\n    fill: '.concat(t.excludeBkgColor, ";\n  }\n\n  .section {\n    stroke: none;\n    opacity: 0.2;\n  }\n\n  .section0 {\n    fill: ").concat(t.sectionBkgColor, ";\n  }\n\n  .section2 {\n    fill: ").concat(t.sectionBkgColor2, ";\n  }\n\n  .section1,\n  .section3 {\n    fill: ").concat(t.altSectionBkgColor, ";\n    opacity: 0.2;\n  }\n\n  .sectionTitle0 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle1 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle2 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle3 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle {\n    text-anchor: start;\n    // font-size: ").concat(t.ganttFontSize, ";\n    // text-height: 14px;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n\n  }\n\n\n  /* Grid and axis */\n\n  .grid .tick {\n    stroke: ").concat(t.gridColor, ";\n    opacity: 0.8;\n    shape-rendering: crispEdges;\n    text {\n      font-family: ").concat(t.fontFamily, ";\n      fill: ").concat(t.textColor, ";\n    }\n  }\n\n  .grid path {\n    stroke-width: 0;\n  }\n\n\n  /* Today line */\n\n  .today {\n    fill: none;\n    stroke: ").concat(t.todayLineColor, ";\n    stroke-width: 2px;\n  }\n\n\n  /* Task styling */\n\n  /* Default task */\n\n  .task {\n    stroke-width: 2;\n  }\n\n  .taskText {\n    text-anchor: middle;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n\n  // .taskText:not([font-size]) {\n  //   font-size: ").concat(t.ganttFontSize, ";\n  // }\n\n  .taskTextOutsideRight {\n    fill: ").concat(t.taskTextDarkColor, ";\n    text-anchor: start;\n    // font-size: ").concat(t.ganttFontSize, ";\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n\n  }\n\n  .taskTextOutsideLeft {\n    fill: ").concat(t.taskTextDarkColor, ";\n    text-anchor: end;\n    // font-size: ").concat(t.ganttFontSize, ";\n  }\n\n  /* Special case clickable */\n  .task.clickable {\n    cursor: pointer;\n  }\n  .taskText.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  .taskTextOutsideLeft.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  .taskTextOutsideRight.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  /* Specific task settings for the sections*/\n\n  .taskText0,\n  .taskText1,\n  .taskText2,\n  .taskText3 {\n    fill: ").concat(t.taskTextColor, ";\n  }\n\n  .task0,\n  .task1,\n  .task2,\n  .task3 {\n    fill: ").concat(t.taskBkgColor, ";\n    stroke: ").concat(t.taskBorderColor, ";\n  }\n\n  .taskTextOutside0,\n  .taskTextOutside2\n  {\n    fill: ").concat(t.taskTextOutsideColor, ";\n  }\n\n  .taskTextOutside1,\n  .taskTextOutside3 {\n    fill: ").concat(t.taskTextOutsideColor, ";\n  }\n\n\n  /* Active task */\n\n  .active0,\n  .active1,\n  .active2,\n  .active3 {\n    fill: ").concat(t.activeTaskBkgColor, ";\n    stroke: ").concat(t.activeTaskBorderColor, ";\n  }\n\n  .activeText0,\n  .activeText1,\n  .activeText2,\n  .activeText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n\n  /* Completed task */\n\n  .done0,\n  .done1,\n  .done2,\n  .done3 {\n    stroke: ").concat(t.doneTaskBorderColor, ";\n    fill: ").concat(t.doneTaskBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .doneText0,\n  .doneText1,\n  .doneText2,\n  .doneText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n\n  /* Tasks on the critical line */\n\n  .crit0,\n  .crit1,\n  .crit2,\n  .crit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.critBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .activeCrit0,\n  .activeCrit1,\n  .activeCrit2,\n  .activeCrit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.activeTaskBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .doneCrit0,\n  .doneCrit1,\n  .doneCrit2,\n  .doneCrit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.doneTaskBkgColor, ";\n    stroke-width: 2;\n    cursor: pointer;\n    shape-rendering: crispEdges;\n  }\n\n  .milestone {\n    transform: rotate(45deg) scale(0.8,0.8);\n  }\n\n  .milestoneText {\n    font-style: italic;\n  }\n  .doneCritText0,\n  .doneCritText1,\n  .doneCritText2,\n  .doneCritText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n  .activeCritText0,\n  .activeCritText1,\n  .activeCritText2,\n  .activeCritText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n  .titleText {\n    text-anchor: middle;\n    font-size: 18px;\n    fill: ").concat(t.textColor, "    ;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n");
      },
      classDiagram: tC,
      "classDiagram-v2": tC,
      "class": tC,
      stateDiagram: nC,
      state: nC,
      git: function git() {
        return "\n  .commit-id,\n  .commit-msg,\n  .branch-label {\n    fill: lightgrey;\n    color: lightgrey;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n";
      },
      info: function info() {
        return "";
      },
      pie: function pie(t) {
        return "\n  .pieCircle{\n    stroke: ".concat(t.pieStrokeColor, ";\n    stroke-width : ").concat(t.pieStrokeWidth, ";\n    opacity : ").concat(t.pieOpacity, ";\n  }\n  .pieTitleText {\n    text-anchor: middle;\n    font-size: ").concat(t.pieTitleTextSize, ";\n    fill: ").concat(t.pieTitleTextColor, ";\n    font-family: ").concat(t.fontFamily, ";\n  }\n  .slice {\n    font-family: ").concat(t.fontFamily, ";\n    fill: ").concat(t.pieSectionTextColor, ";\n    font-size:").concat(t.pieSectionTextSize, ";\n    // fill: white;\n  }\n  .legend text {\n    fill: ").concat(t.pieLegendTextColor, ";\n    font-family: ").concat(t.fontFamily, ";\n    font-size: ").concat(t.pieLegendTextSize, ";\n  }\n");
      },
      er: function er(t) {
        return "\n  .entityBox {\n    fill: ".concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .attributeBoxOdd {\n    fill: #ffffff;\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .attributeBoxEven {\n    fill: #f2f2f2;\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .relationshipLabelBox {\n    fill: ").concat(t.tertiaryColor, ";\n    opacity: 0.7;\n    background-color: ").concat(t.tertiaryColor, ";\n      rect {\n        opacity: 0.5;\n      }\n  }\n\n    .relationshipLine {\n      stroke: ").concat(t.lineColor, ";\n    }\n");
      },
      journey: function journey(t) {
        return ".label {\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n    color: ".concat(t.textColor, ";\n  }\n  .mouth {\n    stroke: #666;\n  }\n\n  line {\n    stroke: ").concat(t.textColor, "\n  }\n\n  .legend {\n    fill: ").concat(t.textColor, ";\n  }\n\n  .label text {\n    fill: #333;\n  }\n  .label {\n    color: ").concat(t.textColor, "\n  }\n\n  .face {\n    ").concat(t.faceColor ? "fill: ".concat(t.faceColor) : "fill: #FFF8DC", ";\n    stroke: #999;\n  }\n\n  .node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n  .node .label {\n    text-align: center;\n  }\n  .node.clickable {\n    cursor: pointer;\n  }\n\n  .arrowheadPath {\n    fill: ").concat(t.arrowheadColor, ";\n  }\n\n  .edgePath .path {\n    stroke: ").concat(t.lineColor, ";\n    stroke-width: 1.5px;\n  }\n\n  .flowchart-link {\n    stroke: ").concat(t.lineColor, ";\n    fill: none;\n  }\n\n  .edgeLabel {\n    background-color: ").concat(t.edgeLabelBackground, ";\n    rect {\n      opacity: 0.5;\n    }\n    text-align: center;\n  }\n\n  .cluster rect {\n  }\n\n  .cluster text {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  div.mermaidTooltip {\n    position: absolute;\n    text-align: center;\n    max-width: 200px;\n    padding: 2px;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n    font-size: 12px;\n    background: ").concat(t.tertiaryColor, ";\n    border: 1px solid ").concat(t.border2, ";\n    border-radius: 2px;\n    pointer-events: none;\n    z-index: 100;\n  }\n\n  .task-type-0, .section-type-0  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType0) : "", ";\n  }\n  .task-type-1, .section-type-1  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType1) : "", ";\n  }\n  .task-type-2, .section-type-2  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType2) : "", ";\n  }\n  .task-type-3, .section-type-3  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType3) : "", ";\n  }\n  .task-type-4, .section-type-4  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType4) : "", ";\n  }\n  .task-type-5, .section-type-5  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType5) : "", ";\n  }\n  .task-type-6, .section-type-6  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType6) : "", ";\n  }\n  .task-type-7, .section-type-7  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType7) : "", ";\n  }\n\n  .actor-0 {\n    ").concat(t.actor0 ? "fill: ".concat(t.actor0) : "", ";\n  }\n  .actor-1 {\n    ").concat(t.actor1 ? "fill: ".concat(t.actor1) : "", ";\n  }\n  .actor-2 {\n    ").concat(t.actor2 ? "fill: ".concat(t.actor2) : "", ";\n  }\n  .actor-3 {\n    ").concat(t.actor3 ? "fill: ".concat(t.actor3) : "", ";\n  }\n  .actor-4 {\n    ").concat(t.actor4 ? "fill: ".concat(t.actor4) : "", ";\n  }\n  .actor-5 {\n    ").concat(t.actor5 ? "fill: ".concat(t.actor5) : "", ";\n  }\n\n  }\n");
      },
      requirement: function requirement(t) {
        return "\n\n  marker {\n    fill: ".concat(t.relationColor, ";\n    stroke: ").concat(t.relationColor, ";\n  }\n\n  marker.cross {\n    stroke: ").concat(t.lineColor, ";\n  }\n\n  svg {\n    font-family: ").concat(t.fontFamily, ";\n    font-size: ").concat(t.fontSize, ";\n  }\n\n  .reqBox {\n    fill: ").concat(t.requirementBackground, ";\n    fill-opacity: 100%;\n    stroke: ").concat(t.requirementBorderColor, ";\n    stroke-width: ").concat(t.requirementBorderSize, ";\n  }\n  \n  .reqTitle, .reqLabel{\n    fill:  ").concat(t.requirementTextColor, ";\n  }\n  .reqLabelBox {\n    fill: ").concat(t.relationLabelBackground, ";\n    fill-opacity: 100%;\n  }\n\n  .req-title-line {\n    stroke: ").concat(t.requirementBorderColor, ";\n    stroke-width: ").concat(t.requirementBorderSize, ";\n  }\n  .relationshipLine {\n    stroke: ").concat(t.relationColor, ";\n    stroke-width: 1;\n  }\n  .relationshipLabel {\n    fill: ").concat(t.relationLabelColor, ";\n  }\n\n");
      }
    };

    function iC(t) {
      return iC = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, iC(t);
    }

    var aC = function aC(t) {
      var e = t;
      return (e = (e = e.replace(/ﬂ°°/g, function () {
        return "&#";
      })).replace(/ﬂ°/g, function () {
        return "&";
      })).replace(/¶ß/g, function () {
        return ";";
      });
    },
        oC = {};

    function sC(t) {
      var e;
      Qw(t.git), Fx(t.flowchart), Yx(t.flowchart), void 0 !== t.sequenceDiagram && $T.setConf(Lv(t.sequence, t.sequenceDiagram)), $T.setConf(t.sequence), t.gantt, Pb(t["class"]), t.state, EE(t.state), ik(t["class"]), U_(t.er), QE(t.journey), Nk(t.requirement), e = t["class"], Object.keys(e).forEach(function (t) {
        JE[t] = e[t];
      });
    }

    var cC = Object.freeze({
      render: function render(t, e, n, r) {
        nb();
        var i = e,
            a = Hv.detectInit(i);
        a && (Uv(a), eb(a));
        var s = Jv();
        e.length > s.maxTextSize && (i = "graph TB;a[Maximum text size in diagram exceeded];style a fill:#faa");
        var c = au("body");

        if (void 0 !== r) {
          if ("sandbox" === s.securityLevel) {
            var u = au("body").append("iframe").attr("id", "i" + t).attr("style", "width: 100%; height: 100%;").attr("sandbox", "");
            (c = au(u.nodes()[0].contentDocument.body)).node().style.margin = 0;
          }

          if (r.innerHTML = "", "sandbox" === s.securityLevel) {
            var l = au(r).append("iframe").attr("id", "i" + t).attr("style", "width: 100%; height: 100%;").attr("sandbox", "");
            (c = au(l.nodes()[0].contentDocument.body)).node().style.margin = 0;
          } else c = au(r);

          c.append("div").attr("id", "d" + t).attr("style", "font-family: " + s.fontFamily).append("svg").attr("id", t).attr("width", "100%").attr("xmlns", "http://www.w3.org/2000/svg").append("g");
        } else {
          var h,
              f = document.getElementById(t);

          if (f && f.remove(), (h = "sandbox" !== s.securityLevel ? document.querySelector("#d" + t) : document.querySelector("#i" + t)) && h.remove(), "sandbox" === s.securityLevel) {
            var d = au("body").append("iframe").attr("id", "i" + t).attr("style", "width: 100%; height: 100%;").attr("sandbox", "");
            (c = au(d.nodes()[0].contentDocument.body)).node().style.margin = 0;
          } else c = au("body");

          c.append("div").attr("id", "d" + t).append("svg").attr("id", t).attr("width", "100%").attr("xmlns", "http://www.w3.org/2000/svg").append("g");
        }

        i = i.replace(/style.*:\S*#.*;/g, function (t) {
          return t.substring(0, t.length - 1);
        }).replace(/classDef.*:\S*#.*;/g, function (t) {
          return t.substring(0, t.length - 1);
        }).replace(/#\w+;/g, function (t) {
          var e = t.substring(1, t.length - 1);
          return /^\+?\d+$/.test(e) ? "ﬂ°°" + e + "¶ß" : "ﬂ°" + e + "¶ß";
        });
        var p = c.select("#d" + t).node(),
            y = Hv.detectType(i, s),
            g = p.firstChild,
            m = g.firstChild,
            v = "";

        if (void 0 !== s.themeCSS && (v += "\n".concat(s.themeCSS)), void 0 !== s.fontFamily && (v += "\n:root { --mermaid-font-family: ".concat(s.fontFamily, "}")), void 0 !== s.altFontFamily && (v += "\n:root { --mermaid-alt-font-family: ".concat(s.altFontFamily, "}")), "flowchart" === y || "flowchart-v2" === y || "graph" === y) {
          var b = function (t) {
            o.info("Extracting classes"), gx.clear();

            try {
              var e = vx().parser;
              return e.yy = gx, e.parse(t), gx.getClasses();
            } catch (t) {
              return;
            }
          }(i),
              _ = s.htmlLabels || s.flowchart.htmlLabels;

          for (var x in b) {
            _ ? (v += "\n.".concat(x, " > * { ").concat(b[x].styles.join(" !important; "), " !important; }"), v += "\n.".concat(x, " span { ").concat(b[x].styles.join(" !important; "), " !important; }")) : (v += "\n.".concat(x, " path { ").concat(b[x].styles.join(" !important; "), " !important; }"), v += "\n.".concat(x, " rect { ").concat(b[x].styles.join(" !important; "), " !important; }"), v += "\n.".concat(x, " polygon { ").concat(b[x].styles.join(" !important; "), " !important; }"), v += "\n.".concat(x, " ellipse { ").concat(b[x].styles.join(" !important; "), " !important; }"), v += "\n.".concat(x, " circle { ").concat(b[x].styles.join(" !important; "), " !important; }"), b[x].textStyles && (v += "\n.".concat(x, " tspan { ").concat(b[x].textStyles.join(" !important; "), " !important; }")));
          }
        }

        var w = function (t, e) {
          return am(Cm("".concat(t, "{").concat(e, "}")), om);
        }("#".concat(t), function (t, e, n) {
          return " {\n    font-family: ".concat(n.fontFamily, ";\n    font-size: ").concat(n.fontSize, ";\n    fill: ").concat(n.textColor, "\n  }\n\n  /* Classes common for multiple diagrams */\n\n  .error-icon {\n    fill: ").concat(n.errorBkgColor, ";\n  }\n  .error-text {\n    fill: ").concat(n.errorTextColor, ";\n    stroke: ").concat(n.errorTextColor, ";\n  }\n\n  .edge-thickness-normal {\n    stroke-width: 2px;\n  }\n  .edge-thickness-thick {\n    stroke-width: 3.5px\n  }\n  .edge-pattern-solid {\n    stroke-dasharray: 0;\n  }\n\n  .edge-pattern-dashed{\n    stroke-dasharray: 3;\n  }\n  .edge-pattern-dotted {\n    stroke-dasharray: 2;\n  }\n\n  .marker {\n    fill: ").concat(n.lineColor, ";\n    stroke: ").concat(n.lineColor, ";\n  }\n  .marker.cross {\n    stroke: ").concat(n.lineColor, ";\n  }\n\n  svg {\n    font-family: ").concat(n.fontFamily, ";\n    font-size: ").concat(n.fontSize, ";\n  }\n\n  ").concat(rC[t](n), "\n\n  ").concat(e, "\n");
        }(y, v, s.themeVariables)),
            k = document.createElement("style");

        k.innerHTML = "#".concat(t, " ") + w, g.insertBefore(k, m);

        try {
          switch (y) {
            case "git":
              s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, Qw(s.git), function (t, e, n) {
                try {
                  var r = zw().parser;
                  r.yy = Pw, r.yy.clear();
                  var i,
                      a = Jv().securityLevel;
                  "sandbox" === a && (i = au("#i" + e));
                  var s = au("sandbox" === a ? i.nodes()[0].contentDocument.body : "body");
                  "sandbox" === a ? i.nodes()[0].contentDocument : document, o.debug("in gitgraph renderer", t + "\n", "id:", e, n), r.parse(t + "\n"), qw = Object.assign(qw, Hw, Pw.getOptions()), o.debug("effective options", qw);
                  var c = Pw.getDirection();
                  Uw = Pw.getCommits();
                  var u = Pw.getBranchesAsObjArray();
                  "BT" === c && (qw.nodeLabel.x = u.length * qw.branchOffset, qw.nodeLabel.width = "100%", qw.nodeLabel.y = -2 * qw.nodeRadius);
                  var l = s.select('[id="'.concat(e, '"]'));

                  for (var h in function (t) {
                    t.append("defs").append("g").attr("id", "def-commit").append("circle").attr("r", qw.nodeRadius).attr("cx", 0).attr("cy", 0), t.select("#def-commit").append("foreignObject").attr("width", qw.nodeLabel.width).attr("height", qw.nodeLabel.height).attr("x", qw.nodeLabel.x).attr("y", qw.nodeLabel.y).attr("class", "node-label").attr("requiredFeatures", "http://www.w3.org/TR/SVG11/feature#Extensibility").append("p").html("");
                  }(l), jw = 1, u) {
                    var f = u[h];
                    Xw(l, f.commit.id, u, c), Zw(l, f.commit, c), jw++;
                  }

                  l.attr("height", function () {
                    return "BT" === c ? Object.keys(Uw).length * qw.nodeSpacing : (u.length + 1) * qw.branchOffset;
                  });
                } catch (t) {
                  o.error("Error while rendering gitgraph"), o.error(t.message);
                }
              }(i, t, !1);
              break;

            case "flowchart":
              s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, Fx(s.flowchart), Px(i, t);
              break;

            case "flowchart-v2":
              s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, Yx(s.flowchart), zx(i, t);
              break;

            case "sequence":
              s.sequence.arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.sequenceDiagram ? ($T.setConf(Object.assign(s.sequence, s.sequenceDiagram)), console.error("`mermaid config.sequenceDiagram` has been renamed to `config.sequence`. Please update your mermaid config.")) : $T.setConf(s.sequence), $T.draw(i, t);
              break;

            case "gantt":
              s.gantt.arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.gantt, Ew(i, t);
              break;

            case "class":
              s["class"].arrowMarkerAbsolute = s.arrowMarkerAbsolute, Pb(s["class"]), jb(i, t);
              break;

            case "classDiagram":
              s["class"].arrowMarkerAbsolute = s.arrowMarkerAbsolute, function (t) {
                Object.keys(t).forEach(function (e) {
                  A_[e] = t[e];
                });
              }(s["class"]), function (t, e) {
                o.info("Drawing class - ", e), bb.clear(), Tb.parser.parse(t);
                var n = Jv().flowchart,
                    r = Jv().securityLevel;
                o.info("config:", n);
                var i,
                    a = n.nodeSpacing || 50,
                    s = n.rankSpacing || 50,
                    c = new (kb().Graph)({
                  multigraph: !0,
                  compound: !0
                }).setGraph({
                  rankdir: bb.getDirection(),
                  nodesep: a,
                  ranksep: s,
                  marginx: 8,
                  marginy: 8
                }).setDefaultEdgeLabel(function () {
                  return {};
                }),
                    u = bb.getClasses(),
                    l = bb.getRelations();
                o.info(l), function (t, e) {
                  var n = Object.keys(t);
                  o.info("keys:", n), o.info(t), n.forEach(function (n) {
                    var r = t[n],
                        i = "";
                    r.cssClasses.length > 0 && (i = i + " " + r.cssClasses.join(" "));
                    var a,
                        s,
                        c = {
                      labelStyle: ""
                    },
                        u = void 0 !== r.text ? r.text : r.id;
                    r.type, s = "class_box", e.setNode(r.id, {
                      labelStyle: c.labelStyle,
                      shape: s,
                      labelText: (a = u, Um.sanitizeText(a, Jv())),
                      classData: r,
                      rx: 0,
                      ry: 0,
                      "class": i,
                      style: c.style,
                      id: r.id,
                      domId: r.domId,
                      haveCallback: r.haveCallback,
                      link: r.link,
                      width: "group" === r.type ? 500 : void 0,
                      type: r.type,
                      padding: Jv().flowchart.padding
                    }), o.info("setNode", {
                      labelStyle: c.labelStyle,
                      shape: s,
                      labelText: u,
                      rx: 0,
                      ry: 0,
                      "class": i,
                      style: c.style,
                      id: r.id,
                      width: "group" === r.type ? 500 : void 0,
                      type: r.type,
                      padding: Jv().flowchart.padding
                    });
                  });
                }(u, c), function (t, e) {
                  var n = 0;
                  t.forEach(function (r) {
                    n++;
                    var i = {
                      classes: "relation"
                    };
                    i.pattern = 1 == r.relation.lineType ? "dashed" : "solid", i.id = "id" + n, "arrow_open" === r.type ? i.arrowhead = "none" : i.arrowhead = "normal", o.info(i, r), i.startLabelRight = "none" === r.relationTitle1 ? "" : r.relationTitle1, i.endLabelLeft = "none" === r.relationTitle2 ? "" : r.relationTitle2, i.arrowTypeStart = M_(r.relation.type1), i.arrowTypeEnd = M_(r.relation.type2);
                    var a = "",
                        s = "";

                    if (void 0 !== r.style) {
                      var c = Nv(r.style);
                      a = c.style, s = c.labelStyle;
                    } else a = "fill:none";

                    i.style = a, i.labelStyle = s, void 0 !== r.interpolate ? i.curve = Av(r.interpolate, Pu) : void 0 !== t.defaultInterpolate ? i.curve = Av(t.defaultInterpolate, Pu) : i.curve = Av(A_.curve, Pu), r.text = r.title, void 0 === r.text ? void 0 !== r.style && (i.arrowheadStyle = "fill: #333") : (i.arrowheadStyle = "fill: #333", i.labelpos = "c", Jv().flowchart.htmlLabels ? (i.labelType = "html", i.label = '<span class="edgeLabel">' + r.text + "</span>") : (i.labelType = "text", i.label = r.text.replace(Um.lineBreakRegex, "\n"), void 0 === r.style && (i.style = i.style || "stroke: #333; stroke-width: 1.5px;fill:none"), i.labelStyle = i.labelStyle.replace("color:", "fill:"))), e.setEdge(r.id1, r.id2, i, n);
                  });
                }(l, c), "sandbox" === r && (i = au("#i" + e));
                var h = au("sandbox" === r ? i.nodes()[0].contentDocument.body : "body"),
                    f = h.select('[id="'.concat(e, '"]'));
                f.attr("xmlns:xlink", "http://www.w3.org/1999/xlink");
                var d = h.select("#" + e + " g");
                S_(d, c, ["aggregation", "extension", "composition", "dependency"], "classDiagram", e);
                var p = f.node().getBBox(),
                    y = p.width + 16,
                    g = p.height + 16;
                if (o.debug("new ViewBox 0 0 ".concat(y, " ").concat(g), "translate(".concat(8 - c._label.marginx, ", ").concat(8 - c._label.marginy, ")")), zv(f, g, y, n.useMaxWidth), f.attr("viewBox", "0 0 ".concat(y, " ").concat(g)), f.select("g").attr("transform", "translate(".concat(8 - c._label.marginx, ", ").concat(8 - p.y, ")")), !n.htmlLabels) for (var m = "sandbox" === r ? i.nodes()[0].contentDocument : document, v = m.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), b = 0; b < v.length; b++) {
                  var _ = v[b],
                      x = _.getBBox(),
                      w = m.createElementNS("http://www.w3.org/2000/svg", "rect");

                  w.setAttribute("rx", 0), w.setAttribute("ry", 0), w.setAttribute("width", x.width), w.setAttribute("height", x.height), _.insertBefore(w, _.firstChild);
                }
              }(i, t);
              break;

            case "state":
              s["class"].arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.state, vE(i, t);
              break;

            case "stateDiagram":
              s["class"].arrowMarkerAbsolute = s.arrowMarkerAbsolute, EE(s.state), function (t, e) {
                o.info("Drawing state diagram (v2)", e), cE.clear(), _E = {};
                var n = VT().parser;
                n.yy = cE, n.parse(t);
                var r = cE.getDirection();
                void 0 === r && (r = "LR");
                var i = Jv().state,
                    a = i.nodeSpacing || 50,
                    s = i.rankSpacing || 50,
                    c = Jv().securityLevel;
                o.info(cE.getRootDocV2()), cE.extract(cE.getRootDocV2()), o.info(cE.getRootDocV2());
                var u,
                    l = new (kb().Graph)({
                  multigraph: !0,
                  compound: !0
                }).setGraph({
                  rankdir: TE(cE.getRootDocV2()),
                  nodesep: a,
                  ranksep: s,
                  marginx: 8,
                  marginy: 8
                }).setDefaultEdgeLabel(function () {
                  return {};
                });
                xE(l, void 0, cE.getRootDocV2(), !0), "sandbox" === c && (u = au("#i" + e));
                var h = au("sandbox" === c ? u.nodes()[0].contentDocument.body : "body"),
                    f = ("sandbox" === c ? u.nodes()[0].contentDocument : document, h.select('[id="'.concat(e, '"]'))),
                    d = h.select("#" + e + " g");
                S_(d, l, ["barb"], "statediagram", e);
                var p = f.node().getBBox(),
                    y = p.width + 16,
                    g = p.height + 16;
                f.attr("class", "statediagram");
                var m = f.node().getBBox();
                zv(f, g, 1.75 * y, i.useMaxWidth);
                var v = "".concat(m.x - 8, " ").concat(m.y - 8, " ").concat(y, " ").concat(g);
                o.debug("viewBox ".concat(v)), f.attr("viewBox", v);

                for (var b = document.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), _ = 0; _ < b.length; _++) {
                  var x = b[_],
                      w = x.getBBox(),
                      k = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                  k.setAttribute("rx", 0), k.setAttribute("ry", 0), k.setAttribute("width", w.width), k.setAttribute("height", w.height), x.insertBefore(k, x.firstChild);
                }
              }(i, t);
              break;

            case "info":
              s["class"].arrowMarkerAbsolute = s.arrowMarkerAbsolute, ik(s["class"]), function (t, e, n) {
                try {
                  var r = nk().parser;
                  r.yy = tk, o.debug("Renering info diagram\n" + t);
                  var i,
                      a = Jv().securityLevel;
                  "sandbox" === a && (i = au("#i" + e));
                  var s = au("sandbox" === a ? i.nodes()[0].contentDocument.body : "body");
                  "sandbox" === a ? i.nodes()[0].contentDocument : document, r.parse(t), o.debug("Parsed info diagram");
                  var c = s.select("#" + e);
                  c.append("g").append("text").attr("x", 100).attr("y", 40).attr("class", "version").attr("font-size", "32px").style("text-anchor", "middle").text("v " + n), c.attr("height", 100), c.attr("width", 400);
                } catch (t) {
                  o.error("Error while rendering info diagram"), o.error(t.message);
                }
              }(i, t, Dm);
              break;

            case "pie":
              dk(i, t);
              break;

            case "er":
              U_(s.er), q_(i, t);
              break;

            case "journey":
              QE(s.journey), KE(i, t);
              break;

            case "requirement":
              Nk(s.requirement), Dk(i, t);
          }
        } catch (e) {
          throw function (t, e) {
            try {
              o.debug("Renering svg for syntax error\n");
              var n = au("#" + t),
                  r = n.append("g");
              r.append("path").attr("class", "error-icon").attr("d", "m411.313,123.313c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32-9.375,9.375-20.688-20.688c-12.484-12.5-32.766-12.5-45.25,0l-16,16c-1.261,1.261-2.304,2.648-3.31,4.051-21.739-8.561-45.324-13.426-70.065-13.426-105.867,0-192,86.133-192,192s86.133,192 192,192 192-86.133 192-192c0-24.741-4.864-48.327-13.426-70.065 1.402-1.007 2.79-2.049 4.051-3.31l16-16c12.5-12.492 12.5-32.758 0-45.25l-20.688-20.688 9.375-9.375 32.001-31.999zm-219.313,100.687c-52.938,0-96,43.063-96,96 0,8.836-7.164,16-16,16s-16-7.164-16-16c0-70.578 57.422-128 128-128 8.836,0 16,7.164 16,16s-7.164,16-16,16z"), r.append("path").attr("class", "error-icon").attr("d", "m459.02,148.98c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l16,16c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16.001-16z"), r.append("path").attr("class", "error-icon").attr("d", "m340.395,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16-16c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l15.999,16z"), r.append("path").attr("class", "error-icon").attr("d", "m400,64c8.844,0 16-7.164 16-16v-32c0-8.836-7.156-16-16-16-8.844,0-16,7.164-16,16v32c0,8.836 7.156,16 16,16z"), r.append("path").attr("class", "error-icon").attr("d", "m496,96.586h-32c-8.844,0-16,7.164-16,16 0,8.836 7.156,16 16,16h32c8.844,0 16-7.164 16-16 0-8.836-7.156-16-16-16z"), r.append("path").attr("class", "error-icon").attr("d", "m436.98,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688l32-32c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32c-6.251,6.25-6.251,16.375-0.001,22.625z"), r.append("text").attr("class", "error-text").attr("x", 1240).attr("y", 250).attr("font-size", "150px").style("text-anchor", "middle").text("Syntax error in graph"), r.append("text").attr("class", "error-text").attr("x", 1050).attr("y", 400).attr("font-size", "100px").style("text-anchor", "middle").text("mermaid version " + e), n.attr("height", 100), n.attr("width", 400), n.attr("viewBox", "768 0 512 512");
            } catch (t) {
              o.error("Error while rendering info diagram"), o.error(t.message);
            }
          }(t, Dm), e;
        }

        c.select('[id="'.concat(t, '"]')).selectAll("foreignobject > *").attr("xmlns", "http://www.w3.org/1999/xhtml");
        var T = c.select("#d" + t).node().innerHTML;

        if (o.debug("cnf.arrowMarkerAbsolute", s.arrowMarkerAbsolute), s.arrowMarkerAbsolute && "false" !== s.arrowMarkerAbsolute || "sandbox" === s.arrowMarkerAbsolute || (T = T.replace(/marker-end="url\(.*?#/g, 'marker-end="url(#', "g")), T = (T = aC(T)).replace(/<br>/g, "<br/>"), "sandbox" === s.securityLevel) {
          var E = c.select("#d" + t + " svg").node(),
              C = "100%";
          E && (C = E.viewBox.baseVal.height + "px"), T = '<iframe style="width:'.concat("100%", ";height:").concat(C, ';border:0;margin:0;" src="data:text/html;base64,').concat(btoa('<body style="margin:0">' + T + "</body>"), '" sandbox="allow-top-navigation-by-user-activation allow-popups">\n  The “iframe” tag is not supported by your browser.\n</iframe>');
        }

        if (void 0 !== n) switch (y) {
          case "flowchart":
          case "flowchart-v2":
            n(T, gx.bindFunctions);
            break;

          case "gantt":
            n(T, _w.bindFunctions);
            break;

          case "class":
          case "classDiagram":
            n(T, bb.bindFunctions);
            break;

          default:
            n(T);
        } else o.debug("CB = undefined!");
        nT.forEach(function (t) {
          t();
        }), nT = [];
        var S = "sandbox" === s.securityLevel ? "#i" + t : "#d" + t,
            A = au(S).node();
        return null !== A && "function" == typeof A.remove && au(S).node().remove(), T;
      },
      parse: function parse(t) {
        var e = Jv(),
            n = Hv.detectInit(t, e);
        n && o.debug("reinit ", n);
        var r,
            i = Hv.detectType(t, e);

        switch (o.debug("Type " + i), i) {
          case "git":
            (r = zw()).parser.yy = Pw;
            break;

          case "flowchart":
          case "flowchart-v2":
            gx.clear(), (r = vx()).parser.yy = gx;
            break;

          case "sequence":
            (r = Bk()).parser.yy = eT;
            break;

          case "gantt":
            (r = Tw()).parser.yy = _w;
            break;

          case "class":
          case "classDiagram":
            (r = Eb()).parser.yy = bb;
            break;

          case "state":
          case "stateDiagram":
            (r = VT()).parser.yy = cE;
            break;

          case "info":
            o.debug("info info info"), (r = nk()).parser.yy = tk;
            break;

          case "pie":
            o.debug("pie"), (r = ok()).parser.yy = lk;
            break;

          case "er":
            o.debug("er"), (r = R_()).parser.yy = L_;
            break;

          case "journey":
            o.debug("Journey"), (r = RE()).parser.yy = LE;
            break;

          case "requirement":
          case "requirementDiagram":
            o.debug("RequirementDiagram"), (r = yk()).parser.yy = xk;
        }

        return r.parser.yy.graphType = i, r.parser.yy.parseError = function (t, e) {
          throw {
            str: t,
            hash: e
          };
        }, r.parse(t), r;
      },
      parseDirective: function parseDirective(t, e, n, r) {
        try {
          if (void 0 !== e) switch (e = e.trim(), n) {
            case "open_directive":
              oC = {};
              break;

            case "type_directive":
              oC.type = e.toLowerCase();
              break;

            case "arg_directive":
              oC.args = JSON.parse(e);
              break;

            case "close_directive":
              (function (t, e, n) {
                switch (o.debug("Directive type=".concat(e.type, " with args:"), e.args), e.type) {
                  case "init":
                  case "initialize":
                    ["config"].forEach(function (t) {
                      void 0 !== e.args[t] && ("flowchart-v2" === n && (n = "flowchart"), e.args[n] = e.args[t], delete e.args[t]);
                    }), o.debug("sanitize in handleDirective", e.args), Uv(e.args), o.debug("sanitize in handleDirective (done)", e.args), e.args, eb(e.args);
                    break;

                  case "wrap":
                  case "nowrap":
                    t && t.setWrap && t.setWrap("wrap" === e.type);
                    break;

                  case "themeCss":
                    o.warn("themeCss encountered");
                    break;

                  default:
                    o.warn("Unhandled directive: source: '%%{".concat(e.type, ": ").concat(JSON.stringify(e.args ? e.args : {}), "}%%"), e);
                }
              })(t, oC, r), oC = null;
          }
        } catch (t) {
          o.error("Error while rendering sequenceDiagram directive: ".concat(e, " jison context: ").concat(n)), o.error(t.message);
        }
      },
      initialize: function initialize(t) {
        t && t.fontFamily && (t.themeVariables && t.themeVariables.fontFamily || (t.themeVariables = {
          fontFamily: t.fontFamily
        })), function (t) {
          Wv = Lv({}, t);
        }(t), t && t.theme && ov[t.theme] ? t.themeVariables = ov[t.theme].getThemeVariables(t.themeVariables) : t && (t.themeVariables = ov["default"].getThemeVariables(t.themeVariables));
        var e = "object" === iC(t) ? function (t) {
          return Gv = Lv({}, Vv), Gv = Lv(Gv, t), t.theme && (Gv.themeVariables = ov[t.theme].getThemeVariables(t.themeVariables)), Zv = Qv(Gv, Xv), Gv;
        }(t) : Kv();
        sC(e), s(e.logLevel);
      },
      reinitialize: function reinitialize() {},
      getConfig: Jv,
      setConfig: function setConfig(t) {
        return Lv(Zv, t), Jv();
      },
      getSiteConfig: Kv,
      updateSiteConfig: function updateSiteConfig(t) {
        return Gv = Lv(Gv, t), Qv(Gv, Xv), Gv;
      },
      reset: function reset() {
        nb();
      },
      globalReset: function globalReset() {
        nb(), sC(Jv());
      },
      defaultConfig: Vv
    });
    s(Jv().logLevel), nb(Jv());
    var uC = cC;

    var lC = function lC() {
      hC.startOnLoad ? uC.getConfig().startOnLoad && hC.init() : void 0 === hC.startOnLoad && (o.debug("In start, no config"), uC.getConfig().startOnLoad && hC.init());
    };

    "undefined" != typeof document && window.addEventListener("load", function () {
      lC();
    }, !1);
    var hC = {
      startOnLoad: !0,
      htmlLabels: !0,
      mermaidAPI: uC,
      parse: uC.parse,
      render: uC.render,
      init: function init() {
        var t,
            e,
            n = this,
            r = uC.getConfig();
        arguments.length >= 2 ? (void 0 !== arguments[0] && (hC.sequenceConfig = arguments[0]), t = arguments[1]) : t = arguments[0], "function" == typeof arguments[arguments.length - 1] ? (e = arguments[arguments.length - 1], o.debug("Callback function found")) : void 0 !== r.mermaid && ("function" == typeof r.mermaid.callback ? (e = r.mermaid.callback, o.debug("Callback function found")) : o.debug("No Callback function found")), t = void 0 === t ? document.querySelectorAll(".mermaid") : "string" == typeof t ? document.querySelectorAll(t) : t instanceof window.Node ? [t] : t, o.debug("Start On Load before: " + hC.startOnLoad), void 0 !== hC.startOnLoad && (o.debug("Start On Load inner: " + hC.startOnLoad), uC.updateSiteConfig({
          startOnLoad: hC.startOnLoad
        })), void 0 !== hC.ganttConfig && uC.updateSiteConfig({
          gantt: hC.ganttConfig
        });

        for (var i, a = new Hv.initIdGeneratior(r.deterministicIds, r.deterministicIDSeed), s = function s(r) {
          var s = t[r];
          if (s.getAttribute("data-processed")) return "continue";
          s.setAttribute("data-processed", !0);
          var c = "mermaid-".concat(a.next());
          i = s.innerHTML, i = Hv.entityDecode(i).trim().replace(/<br\s*\/?>/gi, "<br/>");
          var u = Hv.detectInit(i);
          u && o.debug("Detected early reinit: ", u);

          try {
            uC.render(c, i, function (t, n) {
              s.innerHTML = t, void 0 !== e && e(c), n && n(s);
            }, s);
          } catch (t) {
            o.warn("Syntax Error rendering"), o.warn(t), n.parseError && n.parseError(t);
          }
        }, c = 0; c < t.length; c++) {
          s(c);
        }
      },
      initialize: function initialize(t) {
        void 0 !== t.mermaid && (void 0 !== t.mermaid.startOnLoad && (hC.startOnLoad = t.mermaid.startOnLoad), void 0 !== t.mermaid.htmlLabels && (hC.htmlLabels = "false" !== t.mermaid.htmlLabels && !1 !== t.mermaid.htmlLabels)), uC.initialize(t);
      },
      contentLoaded: lC
    };
    var fC = hC;
  },
  4949: function _(t, e, n) {
    t.exports = {
      graphlib: n(6614),
      dagre: n(1463),
      intersect: n(8114),
      render: n(5787),
      util: n(8355),
      version: n(5689)
    };
  },
  9144: function _(t, e, n) {
    var r = n(8355);

    function i(t, e, n, i) {
      var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
      r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
    }

    t.exports = {
      "default": i,
      normal: i,
      vee: function vee(t, e, n, i) {
        var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 L 4 5 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
        r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
      },
      undirected: function undirected(t, e, n, i) {
        var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 5 L 10 5").style("stroke-width", 1).style("stroke-dasharray", "1,0");
        r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
      }
    };
  },
  5632: function _(t, e, n) {
    var r = n(8355),
        i = n(4322),
        a = n(1322);

    t.exports = function (t, e) {
      var n,
          o = e.nodes().filter(function (t) {
        return r.isSubgraph(e, t);
      }),
          s = t.selectAll("g.cluster").data(o, function (t) {
        return t;
      });
      return s.selectAll("*").remove(), s.enter().append("g").attr("class", "cluster").attr("id", function (t) {
        return e.node(t).id;
      }).style("opacity", 0), s = t.selectAll("g.cluster"), r.applyTransition(s, e).style("opacity", 1), s.each(function (t) {
        var n = e.node(t),
            r = i.select(this);
        i.select(this).append("rect");
        var o = r.append("g").attr("class", "label");
        a(o, n, n.clusterLabelPos);
      }), s.selectAll("rect").each(function (t) {
        var n = e.node(t),
            a = i.select(this);
        r.applyStyle(a, n.style);
      }), n = s.exit ? s.exit() : s.selectAll(null), r.applyTransition(n, e).style("opacity", 0).remove(), s;
    };
  },
  6315: function _(t, e, n) {
    var r = n(1034),
        i = n(1322),
        a = n(8355),
        o = n(4322);

    t.exports = function (t, e) {
      var n,
          s = t.selectAll("g.edgeLabel").data(e.edges(), function (t) {
        return a.edgeToId(t);
      }).classed("update", !0);
      return s.exit().remove(), s.enter().append("g").classed("edgeLabel", !0).style("opacity", 0), (s = t.selectAll("g.edgeLabel")).each(function (t) {
        var n = o.select(this);
        n.select(".label").remove();
        var a = e.edge(t),
            s = i(n, e.edge(t), 0, 0).classed("label", !0),
            c = s.node().getBBox();
        a.labelId && s.attr("id", a.labelId), r.has(a, "width") || (a.width = c.width), r.has(a, "height") || (a.height = c.height);
      }), n = s.exit ? s.exit() : s.selectAll(null), a.applyTransition(n, e).style("opacity", 0).remove(), s;
    };
  },
  940: function _(t, e, n) {
    var r = n(1034),
        i = n(7584),
        a = n(8355),
        o = n(4322);

    function s(t, e) {
      var n = (o.line || o.svg.line)().x(function (t) {
        return t.x;
      }).y(function (t) {
        return t.y;
      });
      return (n.curve || n.interpolate)(t.curve), n(e);
    }

    t.exports = function (t, e, n) {
      var c = t.selectAll("g.edgePath").data(e.edges(), function (t) {
        return a.edgeToId(t);
      }).classed("update", !0),
          u = function (t, e) {
        var n = t.enter().append("g").attr("class", "edgePath").style("opacity", 0);
        return n.append("path").attr("class", "path").attr("d", function (t) {
          var n = e.edge(t),
              i = e.node(t.v).elem;
          return s(n, r.range(n.points.length).map(function () {
            return e = (t = i).getBBox(), {
              x: (n = t.ownerSVGElement.getScreenCTM().inverse().multiply(t.getScreenCTM()).translate(e.width / 2, e.height / 2)).e,
              y: n.f
            };
            var t, e, n;
          }));
        }), n.append("defs"), n;
      }(c, e);

      !function (t, e) {
        var n = t.exit();
        a.applyTransition(n, e).style("opacity", 0).remove();
      }(c, e);
      var l = void 0 !== c.merge ? c.merge(u) : c;
      return a.applyTransition(l, e).style("opacity", 1), l.each(function (t) {
        var n = o.select(this),
            r = e.edge(t);
        r.elem = this, r.id && n.attr("id", r.id), a.applyClass(n, r["class"], (n.classed("update") ? "update " : "") + "edgePath");
      }), l.selectAll("path.path").each(function (t) {
        var n = e.edge(t);
        n.arrowheadId = r.uniqueId("arrowhead");
        var c = o.select(this).attr("marker-end", function () {
          return "url(" + (t = location.href, e = n.arrowheadId, t.split("#")[0] + "#" + e + ")");
          var t, e;
        }).style("fill", "none");
        a.applyTransition(c, e).attr("d", function (t) {
          return function (t, e) {
            var n = t.edge(e),
                r = t.node(e.v),
                a = t.node(e.w),
                o = n.points.slice(1, n.points.length - 1);
            return o.unshift(i(r, o[0])), o.push(i(a, o[o.length - 1])), s(n, o);
          }(e, t);
        }), a.applyStyle(c, n.style);
      }), l.selectAll("defs *").remove(), l.selectAll("defs").each(function (t) {
        var r = e.edge(t);
        (0, n[r.arrowhead])(o.select(this), r.arrowheadId, r, "arrowhead");
      }), l;
    };
  },
  607: function _(t, e, n) {
    var r = n(1034),
        i = n(1322),
        a = n(8355),
        o = n(4322);

    t.exports = function (t, e, n) {
      var s,
          c = e.nodes().filter(function (t) {
        return !a.isSubgraph(e, t);
      }),
          u = t.selectAll("g.node").data(c, function (t) {
        return t;
      }).classed("update", !0);
      return u.exit().remove(), u.enter().append("g").attr("class", "node").style("opacity", 0), (u = t.selectAll("g.node")).each(function (t) {
        var s = e.node(t),
            c = o.select(this);
        a.applyClass(c, s["class"], (c.classed("update") ? "update " : "") + "node"), c.select("g.label").remove();
        var u = c.append("g").attr("class", "label"),
            l = i(u, s),
            h = n[s.shape],
            f = r.pick(l.node().getBBox(), "width", "height");
        s.elem = this, s.id && c.attr("id", s.id), s.labelId && u.attr("id", s.labelId), r.has(s, "width") && (f.width = s.width), r.has(s, "height") && (f.height = s.height), f.width += s.paddingLeft + s.paddingRight, f.height += s.paddingTop + s.paddingBottom, u.attr("transform", "translate(" + (s.paddingLeft - s.paddingRight) / 2 + "," + (s.paddingTop - s.paddingBottom) / 2 + ")");
        var d = o.select(this);
        d.select(".label-container").remove();
        var p = h(d, f, s).classed("label-container", !0);
        a.applyStyle(p, s.style);
        var y = p.node().getBBox();
        s.width = y.width, s.height = y.height;
      }), s = u.exit ? u.exit() : u.selectAll(null), a.applyTransition(s, e).style("opacity", 0).remove(), u;
    };
  },
  4322: function _(t, e, n) {
    var r;
    if (!r) try {
      r = n(7188);
    } catch (t) {}
    r || (r = window.d3), t.exports = r;
  },
  1463: function _(t, e, n) {
    var r;

    try {
      r = n(681);
    } catch (t) {}

    r || (r = window.dagre), t.exports = r;
  },
  6614: function _(t, e, n) {
    var r;

    try {
      r = n(8282);
    } catch (t) {}

    r || (r = window.graphlib), t.exports = r;
  },
  8114: function _(t, e, n) {
    t.exports = {
      node: n(7584),
      circle: n(6587),
      ellipse: n(3260),
      polygon: n(5337),
      rect: n(8049)
    };
  },
  6587: function _(t, e, n) {
    var r = n(3260);

    t.exports = function (t, e, n) {
      return r(t, e, e, n);
    };
  },
  3260: function _(t) {
    t.exports = function (t, e, n, r) {
      var i = t.x,
          a = t.y,
          o = i - r.x,
          s = a - r.y,
          c = Math.sqrt(e * e * s * s + n * n * o * o),
          u = Math.abs(e * n * o / c);
      r.x < i && (u = -u);
      var l = Math.abs(e * n * s / c);
      return r.y < a && (l = -l), {
        x: i + u,
        y: a + l
      };
    };
  },
  6808: function _(t) {
    function e(t, e) {
      return t * e > 0;
    }

    t.exports = function (t, n, r, i) {
      var a, o, s, c, u, l, h, f, d, p, y, g, m;
      if (!(a = n.y - t.y, s = t.x - n.x, u = n.x * t.y - t.x * n.y, d = a * r.x + s * r.y + u, p = a * i.x + s * i.y + u, 0 !== d && 0 !== p && e(d, p) || (o = i.y - r.y, c = r.x - i.x, l = i.x * r.y - r.x * i.y, h = o * t.x + c * t.y + l, f = o * n.x + c * n.y + l, 0 !== h && 0 !== f && e(h, f) || 0 == (y = a * c - o * s)))) return g = Math.abs(y / 2), {
        x: (m = s * l - c * u) < 0 ? (m - g) / y : (m + g) / y,
        y: (m = o * u - a * l) < 0 ? (m - g) / y : (m + g) / y
      };
    };
  },
  7584: function _(t) {
    t.exports = function (t, e) {
      return t.intersect(e);
    };
  },
  5337: function _(t, e, n) {
    var r = n(6808);

    t.exports = function (t, e, n) {
      var i = t.x,
          a = t.y,
          o = [],
          s = Number.POSITIVE_INFINITY,
          c = Number.POSITIVE_INFINITY;
      e.forEach(function (t) {
        s = Math.min(s, t.x), c = Math.min(c, t.y);
      });

      for (var u = i - t.width / 2 - s, l = a - t.height / 2 - c, h = 0; h < e.length; h++) {
        var f = e[h],
            d = e[h < e.length - 1 ? h + 1 : 0],
            p = r(t, n, {
          x: u + f.x,
          y: l + f.y
        }, {
          x: u + d.x,
          y: l + d.y
        });
        p && o.push(p);
      }

      return o.length ? (o.length > 1 && o.sort(function (t, e) {
        var r = t.x - n.x,
            i = t.y - n.y,
            a = Math.sqrt(r * r + i * i),
            o = e.x - n.x,
            s = e.y - n.y,
            c = Math.sqrt(o * o + s * s);
        return a < c ? -1 : a === c ? 0 : 1;
      }), o[0]) : (console.log("NO INTERSECTION FOUND, RETURN NODE CENTER", t), t);
    };
  },
  8049: function _(t) {
    t.exports = function (t, e) {
      var n,
          r,
          i = t.x,
          a = t.y,
          o = e.x - i,
          s = e.y - a,
          c = t.width / 2,
          u = t.height / 2;
      return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = 0 === s ? 0 : u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = 0 === o ? 0 : c * s / o), {
        x: i + n,
        y: a + r
      };
    };
  },
  8284: function _(t, e, n) {
    var r = n(8355);

    t.exports = function (t, e) {
      var n = t.append("foreignObject").attr("width", "100000"),
          i = n.append("xhtml:div");
      i.attr("xmlns", "http://www.w3.org/1999/xhtml");
      var a = e.label;

      switch (_typeof(a)) {
        case "function":
          i.insert(a);
          break;

        case "object":
          i.insert(function () {
            return a;
          });
          break;

        default:
          i.html(a);
      }

      r.applyStyle(i, e.labelStyle), i.style("display", "inline-block"), i.style("white-space", "nowrap");
      var o = i.node().getBoundingClientRect();
      return n.attr("width", o.width).attr("height", o.height), n;
    };
  },
  1322: function _(t, e, n) {
    var r = n(7318),
        i = n(8284),
        a = n(8287);

    t.exports = function (t, e, n) {
      var o = e.label,
          s = t.append("g");
      "svg" === e.labelType ? a(s, e) : "string" != typeof o || "html" === e.labelType ? i(s, e) : r(s, e);
      var c,
          u = s.node().getBBox();

      switch (n) {
        case "top":
          c = -e.height / 2;
          break;

        case "bottom":
          c = e.height / 2 - u.height;
          break;

        default:
          c = -u.height / 2;
      }

      return s.attr("transform", "translate(" + -u.width / 2 + "," + c + ")"), s;
    };
  },
  8287: function _(t, e, n) {
    var r = n(8355);

    t.exports = function (t, e) {
      var n = t;
      return n.node().appendChild(e.label), r.applyStyle(n, e.labelStyle), n;
    };
  },
  7318: function _(t, e, n) {
    var r = n(8355);

    t.exports = function (t, e) {
      for (var n = t.append("text"), i = function (t) {
        for (var e, n = "", r = !1, i = 0; i < t.length; ++i) {
          e = t[i], r ? (n += "n" === e ? "\n" : e, r = !1) : "\\" === e ? r = !0 : n += e;
        }

        return n;
      }(e.label).split("\n"), a = 0; a < i.length; a++) {
        n.append("tspan").attr("xml:space", "preserve").attr("dy", "1em").attr("x", "1").text(i[a]);
      }

      return r.applyStyle(n, e.labelStyle), n;
    };
  },
  1034: function _(t, e, n) {
    var r;

    try {
      r = {
        defaults: n(1747),
        each: n(6073),
        isFunction: n(3560),
        isPlainObject: n(8630),
        pick: n(9722),
        has: n(8721),
        range: n(6026),
        uniqueId: n(3955)
      };
    } catch (t) {}

    r || (r = window._), t.exports = r;
  },
  6381: function _(t, e, n) {
    var r = n(8355),
        i = n(4322);

    t.exports = function (t, e) {
      var n = t.filter(function () {
        return !i.select(this).classed("update");
      });

      function a(t) {
        var n = e.node(t);
        return "translate(" + n.x + "," + n.y + ")";
      }

      n.attr("transform", a), r.applyTransition(t, e).style("opacity", 1).attr("transform", a), r.applyTransition(n.selectAll("rect"), e).attr("width", function (t) {
        return e.node(t).width;
      }).attr("height", function (t) {
        return e.node(t).height;
      }).attr("x", function (t) {
        return -e.node(t).width / 2;
      }).attr("y", function (t) {
        return -e.node(t).height / 2;
      });
    };
  },
  4577: function _(t, e, n) {
    var r = n(8355),
        i = n(4322),
        a = n(1034);

    t.exports = function (t, e) {
      function n(t) {
        var n = e.edge(t);
        return a.has(n, "x") ? "translate(" + n.x + "," + n.y + ")" : "";
      }

      t.filter(function () {
        return !i.select(this).classed("update");
      }).attr("transform", n), r.applyTransition(t, e).style("opacity", 1).attr("transform", n);
    };
  },
  4849: function _(t, e, n) {
    var r = n(8355),
        i = n(4322);

    t.exports = function (t, e) {
      function n(t) {
        var n = e.node(t);
        return "translate(" + n.x + "," + n.y + ")";
      }

      t.filter(function () {
        return !i.select(this).classed("update");
      }).attr("transform", n), r.applyTransition(t, e).style("opacity", 1).attr("transform", n);
    };
  },
  5787: function _(t, e, n) {
    var r = n(1034),
        i = n(4322),
        a = n(1463).layout;

    t.exports = function () {
      var t = n(607),
          e = n(5632),
          i = n(6315),
          u = n(940),
          l = n(4849),
          h = n(4577),
          f = n(6381),
          d = n(4418),
          p = n(9144),
          y = function y(n, _y2) {
        !function (t) {
          t.nodes().forEach(function (e) {
            var n = t.node(e);
            r.has(n, "label") || t.children(e).length || (n.label = e), r.has(n, "paddingX") && r.defaults(n, {
              paddingLeft: n.paddingX,
              paddingRight: n.paddingX
            }), r.has(n, "paddingY") && r.defaults(n, {
              paddingTop: n.paddingY,
              paddingBottom: n.paddingY
            }), r.has(n, "padding") && r.defaults(n, {
              paddingLeft: n.padding,
              paddingRight: n.padding,
              paddingTop: n.padding,
              paddingBottom: n.padding
            }), r.defaults(n, o), r.each(["paddingLeft", "paddingRight", "paddingTop", "paddingBottom"], function (t) {
              n[t] = Number(n[t]);
            }), r.has(n, "width") && (n._prevWidth = n.width), r.has(n, "height") && (n._prevHeight = n.height);
          }), t.edges().forEach(function (e) {
            var n = t.edge(e);
            r.has(n, "label") || (n.label = ""), r.defaults(n, s);
          });
        }(_y2);

        var g = c(n, "output"),
            m = c(g, "clusters"),
            v = c(g, "edgePaths"),
            b = i(c(g, "edgeLabels"), _y2),
            _ = t(c(g, "nodes"), _y2, d);

        a(_y2), l(_, _y2), h(b, _y2), u(v, _y2, p);
        var x = e(m, _y2);
        f(x, _y2), function (t) {
          r.each(t.nodes(), function (e) {
            var n = t.node(e);
            r.has(n, "_prevWidth") ? n.width = n._prevWidth : delete n.width, r.has(n, "_prevHeight") ? n.height = n._prevHeight : delete n.height, delete n._prevWidth, delete n._prevHeight;
          });
        }(_y2);
      };

      return y.createNodes = function (e) {
        return arguments.length ? (t = e, y) : t;
      }, y.createClusters = function (t) {
        return arguments.length ? (e = t, y) : e;
      }, y.createEdgeLabels = function (t) {
        return arguments.length ? (i = t, y) : i;
      }, y.createEdgePaths = function (t) {
        return arguments.length ? (u = t, y) : u;
      }, y.shapes = function (t) {
        return arguments.length ? (d = t, y) : d;
      }, y.arrows = function (t) {
        return arguments.length ? (p = t, y) : p;
      }, y;
    };

    var o = {
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      rx: 0,
      ry: 0,
      shape: "rect"
    },
        s = {
      arrowhead: "normal",
      curve: i.curveLinear
    };

    function c(t, e) {
      var n = t.select("g." + e);
      return n.empty() && (n = t.append("g").attr("class", e)), n;
    }
  },
  4418: function _(t, e, n) {
    var r = n(8049),
        i = n(3260),
        a = n(6587),
        o = n(5337);
    t.exports = {
      rect: function rect(t, e, n) {
        var i = t.insert("rect", ":first-child").attr("rx", n.rx).attr("ry", n.ry).attr("x", -e.width / 2).attr("y", -e.height / 2).attr("width", e.width).attr("height", e.height);
        return n.intersect = function (t) {
          return r(n, t);
        }, i;
      },
      ellipse: function ellipse(t, e, n) {
        var r = e.width / 2,
            a = e.height / 2,
            o = t.insert("ellipse", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("rx", r).attr("ry", a);
        return n.intersect = function (t) {
          return i(n, r, a, t);
        }, o;
      },
      circle: function circle(t, e, n) {
        var r = Math.max(e.width, e.height) / 2,
            i = t.insert("circle", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("r", r);
        return n.intersect = function (t) {
          return a(n, r, t);
        }, i;
      },
      diamond: function diamond(t, e, n) {
        var r = e.width * Math.SQRT2 / 2,
            i = e.height * Math.SQRT2 / 2,
            a = [{
          x: 0,
          y: -i
        }, {
          x: -r,
          y: 0
        }, {
          x: 0,
          y: i
        }, {
          x: r,
          y: 0
        }],
            s = t.insert("polygon", ":first-child").attr("points", a.map(function (t) {
          return t.x + "," + t.y;
        }).join(" "));
        return n.intersect = function (t) {
          return o(n, a, t);
        }, s;
      }
    };
  },
  8355: function _(t, e, n) {
    var r = n(1034);
    t.exports = {
      isSubgraph: function isSubgraph(t, e) {
        return !!t.children(e).length;
      },
      edgeToId: function edgeToId(t) {
        return a(t.v) + ":" + a(t.w) + ":" + a(t.name);
      },
      applyStyle: function applyStyle(t, e) {
        e && t.attr("style", e);
      },
      applyClass: function applyClass(t, e, n) {
        e && t.attr("class", e).attr("class", n + " " + t.attr("class"));
      },
      applyTransition: function applyTransition(t, e) {
        var n = e.graph();

        if (r.isPlainObject(n)) {
          var i = n.transition;
          if (r.isFunction(i)) return i(t);
        }

        return t;
      }
    };
    var i = /:/g;

    function a(t) {
      return t ? String(t).replace(i, "\\:") : "";
    }
  },
  5689: function _(t) {
    t.exports = "0.6.4";
  },
  7188: function _(t, e, n) {
    n.r(e), n.d(e, {
      FormatSpecifier: function FormatSpecifier() {
        return uc;
      },
      active: function active() {
        return Jr;
      },
      arc: function arc() {
        return fx;
      },
      area: function area() {
        return vx;
      },
      areaRadial: function areaRadial() {
        return Sx;
      },
      ascending: function ascending() {
        return i;
      },
      autoType: function autoType() {
        return Fo;
      },
      axisBottom: function axisBottom() {
        return it;
      },
      axisLeft: function axisLeft() {
        return at;
      },
      axisRight: function axisRight() {
        return rt;
      },
      axisTop: function axisTop() {
        return nt;
      },
      bisect: function bisect() {
        return u;
      },
      bisectLeft: function bisectLeft() {
        return c;
      },
      bisectRight: function bisectRight() {
        return s;
      },
      bisector: function bisector() {
        return a;
      },
      blob: function blob() {
        return ms;
      },
      brush: function brush() {
        return Ai;
      },
      brushSelection: function brushSelection() {
        return Ei;
      },
      brushX: function brushX() {
        return Ci;
      },
      brushY: function brushY() {
        return Si;
      },
      buffer: function buffer() {
        return bs;
      },
      chord: function chord() {
        return Fi;
      },
      clientPoint: function clientPoint() {
        return Dn;
      },
      cluster: function cluster() {
        return Sd;
      },
      color: function color() {
        return Ve;
      },
      contourDensity: function contourDensity() {
        return oo;
      },
      contours: function contours() {
        return to;
      },
      create: function create() {
        return j_;
      },
      creator: function creator() {
        return ie;
      },
      cross: function cross() {
        return f;
      },
      csv: function csv() {
        return Ts;
      },
      csvFormat: function csvFormat() {
        return To;
      },
      csvFormatBody: function csvFormatBody() {
        return Eo;
      },
      csvFormatRow: function csvFormatRow() {
        return So;
      },
      csvFormatRows: function csvFormatRows() {
        return Co;
      },
      csvFormatValue: function csvFormatValue() {
        return Ao;
      },
      csvParse: function csvParse() {
        return wo;
      },
      csvParseRows: function csvParseRows() {
        return ko;
      },
      cubehelix: function cubehelix() {
        return Ha;
      },
      curveBasis: function curveBasis() {
        return sw;
      },
      curveBasisClosed: function curveBasisClosed() {
        return uw;
      },
      curveBasisOpen: function curveBasisOpen() {
        return hw;
      },
      curveBundle: function curveBundle() {
        return dw;
      },
      curveCardinal: function curveCardinal() {
        return gw;
      },
      curveCardinalClosed: function curveCardinalClosed() {
        return vw;
      },
      curveCardinalOpen: function curveCardinalOpen() {
        return _w;
      },
      curveCatmullRom: function curveCatmullRom() {
        return kw;
      },
      curveCatmullRomClosed: function curveCatmullRomClosed() {
        return Ew;
      },
      curveCatmullRomOpen: function curveCatmullRomOpen() {
        return Sw;
      },
      curveLinear: function curveLinear() {
        return px;
      },
      curveLinearClosed: function curveLinearClosed() {
        return Mw;
      },
      curveMonotoneX: function curveMonotoneX() {
        return Fw;
      },
      curveMonotoneY: function curveMonotoneY() {
        return Pw;
      },
      curveNatural: function curveNatural() {
        return zw;
      },
      curveStep: function curveStep() {
        return qw;
      },
      curveStepAfter: function curveStepAfter() {
        return $w;
      },
      curveStepBefore: function curveStepBefore() {
        return Hw;
      },
      customEvent: function customEvent() {
        return ge;
      },
      descending: function descending() {
        return d;
      },
      deviation: function deviation() {
        return g;
      },
      dispatch: function dispatch() {
        return ft;
      },
      drag: function drag() {
        return po;
      },
      dragDisable: function dragDisable() {
        return Se;
      },
      dragEnable: function dragEnable() {
        return Ae;
      },
      dsv: function dsv() {
        return ks;
      },
      dsvFormat: function dsvFormat() {
        return _o;
      },
      easeBack: function easeBack() {
        return hs;
      },
      easeBackIn: function easeBackIn() {
        return us;
      },
      easeBackInOut: function easeBackInOut() {
        return hs;
      },
      easeBackOut: function easeBackOut() {
        return ls;
      },
      easeBounce: function easeBounce() {
        return os;
      },
      easeBounceIn: function easeBounceIn() {
        return as;
      },
      easeBounceInOut: function easeBounceInOut() {
        return ss;
      },
      easeBounceOut: function easeBounceOut() {
        return os;
      },
      easeCircle: function easeCircle() {
        return rs;
      },
      easeCircleIn: function easeCircleIn() {
        return es;
      },
      easeCircleInOut: function easeCircleInOut() {
        return rs;
      },
      easeCircleOut: function easeCircleOut() {
        return ns;
      },
      easeCubic: function easeCubic() {
        return Xr;
      },
      easeCubicIn: function easeCubicIn() {
        return Vr;
      },
      easeCubicInOut: function easeCubicInOut() {
        return Xr;
      },
      easeCubicOut: function easeCubicOut() {
        return Gr;
      },
      easeElastic: function easeElastic() {
        return ps;
      },
      easeElasticIn: function easeElasticIn() {
        return ds;
      },
      easeElasticInOut: function easeElasticInOut() {
        return ys;
      },
      easeElasticOut: function easeElasticOut() {
        return ps;
      },
      easeExp: function easeExp() {
        return ts;
      },
      easeExpIn: function easeExpIn() {
        return Ko;
      },
      easeExpInOut: function easeExpInOut() {
        return ts;
      },
      easeExpOut: function easeExpOut() {
        return Jo;
      },
      easeLinear: function easeLinear() {
        return jo;
      },
      easePoly: function easePoly() {
        return $o;
      },
      easePolyIn: function easePolyIn() {
        return qo;
      },
      easePolyInOut: function easePolyInOut() {
        return $o;
      },
      easePolyOut: function easePolyOut() {
        return Ho;
      },
      easeQuad: function easeQuad() {
        return Uo;
      },
      easeQuadIn: function easeQuadIn() {
        return Yo;
      },
      easeQuadInOut: function easeQuadInOut() {
        return Uo;
      },
      easeQuadOut: function easeQuadOut() {
        return zo;
      },
      easeSin: function easeSin() {
        return Zo;
      },
      easeSinIn: function easeSinIn() {
        return Go;
      },
      easeSinInOut: function easeSinInOut() {
        return Zo;
      },
      easeSinOut: function easeSinOut() {
        return Xo;
      },
      entries: function entries() {
        return pa;
      },
      event: function event() {
        return le;
      },
      extent: function extent() {
        return m;
      },
      forceCenter: function forceCenter() {
        return Bs;
      },
      forceCollide: function forceCollide() {
        return Ws;
      },
      forceLink: function forceLink() {
        return Xs;
      },
      forceManyBody: function forceManyBody() {
        return tc;
      },
      forceRadial: function forceRadial() {
        return ec;
      },
      forceSimulation: function forceSimulation() {
        return Js;
      },
      forceX: function forceX() {
        return nc;
      },
      forceY: function forceY() {
        return rc;
      },
      format: function format() {
        return pc;
      },
      formatDefaultLocale: function formatDefaultLocale() {
        return bc;
      },
      formatLocale: function formatLocale() {
        return vc;
      },
      formatPrefix: function formatPrefix() {
        return yc;
      },
      formatSpecifier: function formatSpecifier() {
        return cc;
      },
      geoAlbers: function geoAlbers() {
        return Uf;
      },
      geoAlbersUsa: function geoAlbersUsa() {
        return qf;
      },
      geoArea: function geoArea() {
        return yu;
      },
      geoAzimuthalEqualArea: function geoAzimuthalEqualArea() {
        return Vf;
      },
      geoAzimuthalEqualAreaRaw: function geoAzimuthalEqualAreaRaw() {
        return Wf;
      },
      geoAzimuthalEquidistant: function geoAzimuthalEquidistant() {
        return Xf;
      },
      geoAzimuthalEquidistantRaw: function geoAzimuthalEquidistantRaw() {
        return Gf;
      },
      geoBounds: function geoBounds() {
        return sl;
      },
      geoCentroid: function geoCentroid() {
        return bl;
      },
      geoCircle: function geoCircle() {
        return Nl;
      },
      geoClipAntimeridian: function geoClipAntimeridian() {
        return Ul;
      },
      geoClipCircle: function geoClipCircle() {
        return ql;
      },
      geoClipExtent: function geoClipExtent() {
        return Vl;
      },
      geoClipRectangle: function geoClipRectangle() {
        return Wl;
      },
      geoConicConformal: function geoConicConformal() {
        return ed;
      },
      geoConicConformalRaw: function geoConicConformalRaw() {
        return td;
      },
      geoConicEqualArea: function geoConicEqualArea() {
        return zf;
      },
      geoConicEqualAreaRaw: function geoConicEqualAreaRaw() {
        return Yf;
      },
      geoConicEquidistant: function geoConicEquidistant() {
        return ad;
      },
      geoConicEquidistantRaw: function geoConicEquidistantRaw() {
        return id;
      },
      geoContains: function geoContains() {
        return ph;
      },
      geoDistance: function geoDistance() {
        return ah;
      },
      geoEqualEarth: function geoEqualEarth() {
        return fd;
      },
      geoEqualEarthRaw: function geoEqualEarthRaw() {
        return hd;
      },
      geoEquirectangular: function geoEquirectangular() {
        return rd;
      },
      geoEquirectangularRaw: function geoEquirectangularRaw() {
        return nd;
      },
      geoGnomonic: function geoGnomonic() {
        return pd;
      },
      geoGnomonicRaw: function geoGnomonicRaw() {
        return dd;
      },
      geoGraticule: function geoGraticule() {
        return mh;
      },
      geoGraticule10: function geoGraticule10() {
        return vh;
      },
      geoIdentity: function geoIdentity() {
        return yd;
      },
      geoInterpolate: function geoInterpolate() {
        return bh;
      },
      geoLength: function geoLength() {
        return nh;
      },
      geoMercator: function geoMercator() {
        return Qf;
      },
      geoMercatorRaw: function geoMercatorRaw() {
        return Zf;
      },
      geoNaturalEarth1: function geoNaturalEarth1() {
        return md;
      },
      geoNaturalEarth1Raw: function geoNaturalEarth1Raw() {
        return gd;
      },
      geoOrthographic: function geoOrthographic() {
        return bd;
      },
      geoOrthographicRaw: function geoOrthographicRaw() {
        return vd;
      },
      geoPath: function geoPath() {
        return kf;
      },
      geoProjection: function geoProjection() {
        return Ff;
      },
      geoProjectionMutator: function geoProjectionMutator() {
        return Pf;
      },
      geoRotation: function geoRotation() {
        return Sl;
      },
      geoStereographic: function geoStereographic() {
        return xd;
      },
      geoStereographicRaw: function geoStereographicRaw() {
        return _d;
      },
      geoStream: function geoStream() {
        return nu;
      },
      geoTransform: function geoTransform() {
        return Tf;
      },
      geoTransverseMercator: function geoTransverseMercator() {
        return kd;
      },
      geoTransverseMercatorRaw: function geoTransverseMercatorRaw() {
        return wd;
      },
      gray: function gray() {
        return ka;
      },
      hcl: function hcl() {
        return Oa;
      },
      hierarchy: function hierarchy() {
        return Md;
      },
      histogram: function histogram() {
        return D;
      },
      hsl: function hsl() {
        return an;
      },
      html: function html() {
        return Ds;
      },
      image: function image() {
        return Cs;
      },
      interpolate: function interpolate() {
        return Mn;
      },
      interpolateArray: function interpolateArray() {
        return xn;
      },
      interpolateBasis: function interpolateBasis() {
        return un;
      },
      interpolateBasisClosed: function interpolateBasisClosed() {
        return ln;
      },
      interpolateBlues: function interpolateBlues() {
        return f_;
      },
      interpolateBrBG: function interpolateBrBG() {
        return Tb;
      },
      interpolateBuGn: function interpolateBuGn() {
        return Ub;
      },
      interpolateBuPu: function interpolateBuPu() {
        return Hb;
      },
      interpolateCividis: function interpolateCividis() {
        return k_;
      },
      interpolateCool: function interpolateCool() {
        return C_;
      },
      interpolateCubehelix: function interpolateCubehelix() {
        return zp;
      },
      interpolateCubehelixDefault: function interpolateCubehelixDefault() {
        return T_;
      },
      interpolateCubehelixLong: function interpolateCubehelixLong() {
        return Up;
      },
      interpolateDate: function interpolateDate() {
        return kn;
      },
      interpolateDiscrete: function interpolateDiscrete() {
        return Sp;
      },
      interpolateGnBu: function interpolateGnBu() {
        return Wb;
      },
      interpolateGreens: function interpolateGreens() {
        return p_;
      },
      interpolateGreys: function interpolateGreys() {
        return g_;
      },
      interpolateHcl: function interpolateHcl() {
        return Pp;
      },
      interpolateHclLong: function interpolateHclLong() {
        return jp;
      },
      interpolateHsl: function interpolateHsl() {
        return Lp;
      },
      interpolateHslLong: function interpolateHslLong() {
        return Ip;
      },
      interpolateHue: function interpolateHue() {
        return Ap;
      },
      interpolateInferno: function interpolateInferno() {
        return F_;
      },
      interpolateLab: function interpolateLab() {
        return Rp;
      },
      interpolateMagma: function interpolateMagma() {
        return R_;
      },
      interpolateNumber: function interpolateNumber() {
        return Tn;
      },
      interpolateNumberArray: function interpolateNumberArray() {
        return bn;
      },
      interpolateObject: function interpolateObject() {
        return En;
      },
      interpolateOrRd: function interpolateOrRd() {
        return Gb;
      },
      interpolateOranges: function interpolateOranges() {
        return w_;
      },
      interpolatePRGn: function interpolatePRGn() {
        return Cb;
      },
      interpolatePiYG: function interpolatePiYG() {
        return Ab;
      },
      interpolatePlasma: function interpolatePlasma() {
        return P_;
      },
      interpolatePuBu: function interpolatePuBu() {
        return Kb;
      },
      interpolatePuBuGn: function interpolatePuBuGn() {
        return Zb;
      },
      interpolatePuOr: function interpolatePuOr() {
        return Nb;
      },
      interpolatePuRd: function interpolatePuRd() {
        return t_;
      },
      interpolatePurples: function interpolatePurples() {
        return v_;
      },
      interpolateRainbow: function interpolateRainbow() {
        return A_;
      },
      interpolateRdBu: function interpolateRdBu() {
        return Ob;
      },
      interpolateRdGy: function interpolateRdGy() {
        return Lb;
      },
      interpolateRdPu: function interpolateRdPu() {
        return n_;
      },
      interpolateRdYlBu: function interpolateRdYlBu() {
        return Rb;
      },
      interpolateRdYlGn: function interpolateRdYlGn() {
        return Pb;
      },
      interpolateReds: function interpolateReds() {
        return __;
      },
      interpolateRgb: function interpolateRgb() {
        return yn;
      },
      interpolateRgbBasis: function interpolateRgbBasis() {
        return mn;
      },
      interpolateRgbBasisClosed: function interpolateRgbBasisClosed() {
        return vn;
      },
      interpolateRound: function interpolateRound() {
        return Mp;
      },
      interpolateSinebow: function interpolateSinebow() {
        return O_;
      },
      interpolateSpectral: function interpolateSpectral() {
        return Yb;
      },
      interpolateString: function interpolateString() {
        return An;
      },
      interpolateTransformCss: function interpolateTransformCss() {
        return pr;
      },
      interpolateTransformSvg: function interpolateTransformSvg() {
        return yr;
      },
      interpolateTurbo: function interpolateTurbo() {
        return B_;
      },
      interpolateViridis: function interpolateViridis() {
        return I_;
      },
      interpolateWarm: function interpolateWarm() {
        return E_;
      },
      interpolateYlGn: function interpolateYlGn() {
        return o_;
      },
      interpolateYlGnBu: function interpolateYlGnBu() {
        return i_;
      },
      interpolateYlOrBr: function interpolateYlOrBr() {
        return c_;
      },
      interpolateYlOrRd: function interpolateYlOrRd() {
        return l_;
      },
      interpolateZoom: function interpolateZoom() {
        return Op;
      },
      interrupt: function interrupt() {
        return ar;
      },
      interval: function interval() {
        return fk;
      },
      isoFormat: function isoFormat() {
        return uk;
      },
      isoParse: function isoParse() {
        return hk;
      },
      json: function json() {
        return As;
      },
      keys: function keys() {
        return fa;
      },
      lab: function lab() {
        return Ta;
      },
      lch: function lch() {
        return Da;
      },
      line: function line() {
        return mx;
      },
      lineRadial: function lineRadial() {
        return Cx;
      },
      linkHorizontal: function linkHorizontal() {
        return Rx;
      },
      linkRadial: function linkRadial() {
        return Px;
      },
      linkVertical: function linkVertical() {
        return Fx;
      },
      local: function local() {
        return z_;
      },
      map: function map() {
        return na;
      },
      matcher: function matcher() {
        return mt;
      },
      max: function max() {
        return I;
      },
      mean: function mean() {
        return R;
      },
      median: function median() {
        return F;
      },
      merge: function merge() {
        return P;
      },
      min: function min() {
        return j;
      },
      mouse: function mouse() {
        return Bn;
      },
      namespace: function namespace() {
        return Et;
      },
      namespaces: function namespaces() {
        return Tt;
      },
      nest: function nest() {
        return ra;
      },
      now: function now() {
        return Hn;
      },
      pack: function pack() {
        return tp;
      },
      packEnclose: function packEnclose() {
        return Id;
      },
      packSiblings: function packSiblings() {
        return Gd;
      },
      pairs: function pairs() {
        return l;
      },
      partition: function partition() {
        return op;
      },
      path: function path() {
        return Wi;
      },
      permute: function permute() {
        return Y;
      },
      pie: function pie() {
        return xx;
      },
      piecewise: function piecewise() {
        return qp;
      },
      pointRadial: function pointRadial() {
        return Ax;
      },
      polygonArea: function polygonArea() {
        return $p;
      },
      polygonCentroid: function polygonCentroid() {
        return Wp;
      },
      polygonContains: function polygonContains() {
        return Qp;
      },
      polygonHull: function polygonHull() {
        return Zp;
      },
      polygonLength: function polygonLength() {
        return Kp;
      },
      precisionFixed: function precisionFixed() {
        return _c;
      },
      precisionPrefix: function precisionPrefix() {
        return xc;
      },
      precisionRound: function precisionRound() {
        return wc;
      },
      quadtree: function quadtree() {
        return Ys;
      },
      quantile: function quantile() {
        return O;
      },
      quantize: function quantize() {
        return Hp;
      },
      radialArea: function radialArea() {
        return Sx;
      },
      radialLine: function radialLine() {
        return Cx;
      },
      randomBates: function randomBates() {
        return iy;
      },
      randomExponential: function randomExponential() {
        return ay;
      },
      randomIrwinHall: function randomIrwinHall() {
        return ry;
      },
      randomLogNormal: function randomLogNormal() {
        return ny;
      },
      randomNormal: function randomNormal() {
        return ey;
      },
      randomUniform: function randomUniform() {
        return ty;
      },
      range: function range() {
        return k;
      },
      rgb: function rgb() {
        return Qe;
      },
      ribbon: function ribbon() {
        return Ki;
      },
      scaleBand: function scaleBand() {
        return dy;
      },
      scaleDiverging: function scaleDiverging() {
        return ob;
      },
      scaleDivergingLog: function scaleDivergingLog() {
        return sb;
      },
      scaleDivergingPow: function scaleDivergingPow() {
        return ub;
      },
      scaleDivergingSqrt: function scaleDivergingSqrt() {
        return lb;
      },
      scaleDivergingSymlog: function scaleDivergingSymlog() {
        return cb;
      },
      scaleIdentity: function scaleIdentity() {
        return My;
      },
      scaleImplicit: function scaleImplicit() {
        return hy;
      },
      scaleLinear: function scaleLinear() {
        return Ay;
      },
      scaleLog: function scaleLog() {
        return Py;
      },
      scaleOrdinal: function scaleOrdinal() {
        return fy;
      },
      scalePoint: function scalePoint() {
        return yy;
      },
      scalePow: function scalePow() {
        return Vy;
      },
      scaleQuantile: function scaleQuantile() {
        return Xy;
      },
      scaleQuantize: function scaleQuantize() {
        return Zy;
      },
      scaleSequential: function scaleSequential() {
        return Jv;
      },
      scaleSequentialLog: function scaleSequentialLog() {
        return tb;
      },
      scaleSequentialPow: function scaleSequentialPow() {
        return nb;
      },
      scaleSequentialQuantile: function scaleSequentialQuantile() {
        return ib;
      },
      scaleSequentialSqrt: function scaleSequentialSqrt() {
        return rb;
      },
      scaleSequentialSymlog: function scaleSequentialSymlog() {
        return eb;
      },
      scaleSqrt: function scaleSqrt() {
        return Gy;
      },
      scaleSymlog: function scaleSymlog() {
        return Uy;
      },
      scaleThreshold: function scaleThreshold() {
        return Qy;
      },
      scaleTime: function scaleTime() {
        return Yv;
      },
      scaleUtc: function scaleUtc() {
        return Zv;
      },
      scan: function scan() {
        return z;
      },
      schemeAccent: function schemeAccent() {
        return db;
      },
      schemeBlues: function schemeBlues() {
        return h_;
      },
      schemeBrBG: function schemeBrBG() {
        return kb;
      },
      schemeBuGn: function schemeBuGn() {
        return zb;
      },
      schemeBuPu: function schemeBuPu() {
        return qb;
      },
      schemeCategory10: function schemeCategory10() {
        return fb;
      },
      schemeDark2: function schemeDark2() {
        return pb;
      },
      schemeGnBu: function schemeGnBu() {
        return $b;
      },
      schemeGreens: function schemeGreens() {
        return d_;
      },
      schemeGreys: function schemeGreys() {
        return y_;
      },
      schemeOrRd: function schemeOrRd() {
        return Vb;
      },
      schemeOranges: function schemeOranges() {
        return x_;
      },
      schemePRGn: function schemePRGn() {
        return Eb;
      },
      schemePaired: function schemePaired() {
        return yb;
      },
      schemePastel1: function schemePastel1() {
        return gb;
      },
      schemePastel2: function schemePastel2() {
        return mb;
      },
      schemePiYG: function schemePiYG() {
        return Sb;
      },
      schemePuBu: function schemePuBu() {
        return Qb;
      },
      schemePuBuGn: function schemePuBuGn() {
        return Xb;
      },
      schemePuOr: function schemePuOr() {
        return Mb;
      },
      schemePuRd: function schemePuRd() {
        return Jb;
      },
      schemePurples: function schemePurples() {
        return m_;
      },
      schemeRdBu: function schemeRdBu() {
        return Db;
      },
      schemeRdGy: function schemeRdGy() {
        return Bb;
      },
      schemeRdPu: function schemeRdPu() {
        return e_;
      },
      schemeRdYlBu: function schemeRdYlBu() {
        return Ib;
      },
      schemeRdYlGn: function schemeRdYlGn() {
        return Fb;
      },
      schemeReds: function schemeReds() {
        return b_;
      },
      schemeSet1: function schemeSet1() {
        return vb;
      },
      schemeSet2: function schemeSet2() {
        return bb;
      },
      schemeSet3: function schemeSet3() {
        return _b;
      },
      schemeSpectral: function schemeSpectral() {
        return jb;
      },
      schemeTableau10: function schemeTableau10() {
        return xb;
      },
      schemeYlGn: function schemeYlGn() {
        return a_;
      },
      schemeYlGnBu: function schemeYlGnBu() {
        return r_;
      },
      schemeYlOrBr: function schemeYlOrBr() {
        return s_;
      },
      schemeYlOrRd: function schemeYlOrRd() {
        return u_;
      },
      select: function select() {
        return Te;
      },
      selectAll: function selectAll() {
        return q_;
      },
      selection: function selection() {
        return ke;
      },
      selector: function selector() {
        return pt;
      },
      selectorAll: function selectorAll() {
        return gt;
      },
      set: function set() {
        return ha;
      },
      shuffle: function shuffle() {
        return U;
      },
      stack: function stack() {
        return Xw;
      },
      stackOffsetDiverging: function stackOffsetDiverging() {
        return Qw;
      },
      stackOffsetExpand: function stackOffsetExpand() {
        return Zw;
      },
      stackOffsetNone: function stackOffsetNone() {
        return Ww;
      },
      stackOffsetSilhouette: function stackOffsetSilhouette() {
        return Kw;
      },
      stackOffsetWiggle: function stackOffsetWiggle() {
        return Jw;
      },
      stackOrderAppearance: function stackOrderAppearance() {
        return tk;
      },
      stackOrderAscending: function stackOrderAscending() {
        return nk;
      },
      stackOrderDescending: function stackOrderDescending() {
        return ik;
      },
      stackOrderInsideOut: function stackOrderInsideOut() {
        return ak;
      },
      stackOrderNone: function stackOrderNone() {
        return Vw;
      },
      stackOrderReverse: function stackOrderReverse() {
        return ok;
      },
      stratify: function stratify() {
        return hp;
      },
      style: function style() {
        return Rt;
      },
      sum: function sum() {
        return q;
      },
      svg: function svg() {
        return Os;
      },
      symbol: function symbol() {
        return rw;
      },
      symbolCircle: function symbolCircle() {
        return jx;
      },
      symbolCross: function symbolCross() {
        return Yx;
      },
      symbolDiamond: function symbolDiamond() {
        return qx;
      },
      symbolSquare: function symbolSquare() {
        return Gx;
      },
      symbolStar: function symbolStar() {
        return Vx;
      },
      symbolTriangle: function symbolTriangle() {
        return Zx;
      },
      symbolWye: function symbolWye() {
        return ew;
      },
      symbols: function symbols() {
        return nw;
      },
      text: function text() {
        return xs;
      },
      thresholdFreedmanDiaconis: function thresholdFreedmanDiaconis() {
        return B;
      },
      thresholdScott: function thresholdScott() {
        return L;
      },
      thresholdSturges: function thresholdSturges() {
        return N;
      },
      tickFormat: function tickFormat() {
        return Cy;
      },
      tickIncrement: function tickIncrement() {
        return A;
      },
      tickStep: function tickStep() {
        return M;
      },
      ticks: function ticks() {
        return S;
      },
      timeDay: function timeDay() {
        return Ag;
      },
      timeDays: function timeDays() {
        return Mg;
      },
      timeFormat: function timeFormat() {
        return pm;
      },
      timeFormatDefaultLocale: function timeFormatDefaultLocale() {
        return Iv;
      },
      timeFormatLocale: function timeFormatLocale() {
        return fm;
      },
      timeFriday: function timeFriday() {
        return vg;
      },
      timeFridays: function timeFridays() {
        return Eg;
      },
      timeHour: function timeHour() {
        return Dg;
      },
      timeHours: function timeHours() {
        return Og;
      },
      timeInterval: function timeInterval() {
        return tg;
      },
      timeMillisecond: function timeMillisecond() {
        return Yg;
      },
      timeMilliseconds: function timeMilliseconds() {
        return zg;
      },
      timeMinute: function timeMinute() {
        return Lg;
      },
      timeMinutes: function timeMinutes() {
        return Ig;
      },
      timeMonday: function timeMonday() {
        return pg;
      },
      timeMondays: function timeMondays() {
        return xg;
      },
      timeMonth: function timeMonth() {
        return ag;
      },
      timeMonths: function timeMonths() {
        return og;
      },
      timeParse: function timeParse() {
        return ym;
      },
      timeSaturday: function timeSaturday() {
        return bg;
      },
      timeSaturdays: function timeSaturdays() {
        return Cg;
      },
      timeSecond: function timeSecond() {
        return Fg;
      },
      timeSeconds: function timeSeconds() {
        return Pg;
      },
      timeSunday: function timeSunday() {
        return dg;
      },
      timeSundays: function timeSundays() {
        return _g;
      },
      timeThursday: function timeThursday() {
        return mg;
      },
      timeThursdays: function timeThursdays() {
        return Tg;
      },
      timeTuesday: function timeTuesday() {
        return yg;
      },
      timeTuesdays: function timeTuesdays() {
        return wg;
      },
      timeWednesday: function timeWednesday() {
        return gg;
      },
      timeWednesdays: function timeWednesdays() {
        return kg;
      },
      timeWeek: function timeWeek() {
        return dg;
      },
      timeWeeks: function timeWeeks() {
        return _g;
      },
      timeYear: function timeYear() {
        return ng;
      },
      timeYears: function timeYears() {
        return rg;
      },
      timeout: function timeout() {
        return Kn;
      },
      timer: function timer() {
        return Vn;
      },
      timerFlush: function timerFlush() {
        return Gn;
      },
      touch: function touch() {
        return On;
      },
      touches: function touches() {
        return H_;
      },
      transition: function transition() {
        return Hr;
      },
      transpose: function transpose() {
        return H;
      },
      tree: function tree() {
        return vp;
      },
      treemap: function treemap() {
        return kp;
      },
      treemapBinary: function treemapBinary() {
        return Tp;
      },
      treemapDice: function treemapDice() {
        return ap;
      },
      treemapResquarify: function treemapResquarify() {
        return Cp;
      },
      treemapSlice: function treemapSlice() {
        return bp;
      },
      treemapSliceDice: function treemapSliceDice() {
        return Ep;
      },
      treemapSquarify: function treemapSquarify() {
        return wp;
      },
      tsv: function tsv() {
        return Es;
      },
      tsvFormat: function tsvFormat() {
        return Oo;
      },
      tsvFormatBody: function tsvFormatBody() {
        return Bo;
      },
      tsvFormatRow: function tsvFormatRow() {
        return Io;
      },
      tsvFormatRows: function tsvFormatRows() {
        return Lo;
      },
      tsvFormatValue: function tsvFormatValue() {
        return Ro;
      },
      tsvParse: function tsvParse() {
        return No;
      },
      tsvParseRows: function tsvParseRows() {
        return Do;
      },
      utcDay: function utcDay() {
        return im;
      },
      utcDays: function utcDays() {
        return am;
      },
      utcFormat: function utcFormat() {
        return gm;
      },
      utcFriday: function utcFriday() {
        return Gg;
      },
      utcFridays: function utcFridays() {
        return em;
      },
      utcHour: function utcHour() {
        return $v;
      },
      utcHours: function utcHours() {
        return Wv;
      },
      utcMillisecond: function utcMillisecond() {
        return Yg;
      },
      utcMilliseconds: function utcMilliseconds() {
        return zg;
      },
      utcMinute: function utcMinute() {
        return Gv;
      },
      utcMinutes: function utcMinutes() {
        return Xv;
      },
      utcMonday: function utcMonday() {
        return Hg;
      },
      utcMondays: function utcMondays() {
        return Qg;
      },
      utcMonth: function utcMonth() {
        return Uv;
      },
      utcMonths: function utcMonths() {
        return qv;
      },
      utcParse: function utcParse() {
        return mm;
      },
      utcSaturday: function utcSaturday() {
        return Xg;
      },
      utcSaturdays: function utcSaturdays() {
        return nm;
      },
      utcSecond: function utcSecond() {
        return Fg;
      },
      utcSeconds: function utcSeconds() {
        return Pg;
      },
      utcSunday: function utcSunday() {
        return qg;
      },
      utcSundays: function utcSundays() {
        return Zg;
      },
      utcThursday: function utcThursday() {
        return Vg;
      },
      utcThursdays: function utcThursdays() {
        return tm;
      },
      utcTuesday: function utcTuesday() {
        return $g;
      },
      utcTuesdays: function utcTuesdays() {
        return Kg;
      },
      utcWednesday: function utcWednesday() {
        return Wg;
      },
      utcWednesdays: function utcWednesdays() {
        return Jg;
      },
      utcWeek: function utcWeek() {
        return qg;
      },
      utcWeeks: function utcWeeks() {
        return Zg;
      },
      utcYear: function utcYear() {
        return sm;
      },
      utcYears: function utcYears() {
        return cm;
      },
      values: function values() {
        return da;
      },
      variance: function variance() {
        return y;
      },
      version: function version() {
        return r;
      },
      voronoi: function voronoi() {
        return Kk;
      },
      window: function window() {
        return Ot;
      },
      xml: function xml() {
        return Ns;
      },
      zip: function zip() {
        return W;
      },
      zoom: function zoom() {
        return fT;
      },
      zoomIdentity: function zoomIdentity() {
        return nT;
      },
      zoomTransform: function zoomTransform() {
        return rT;
      }
    });
    var r = "5.16.0";

    function i(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    function a(t) {
      var e;
      return 1 === t.length && (e = t, t = function t(_t17, n) {
        return i(e(_t17), n);
      }), {
        left: function left(e, n, r, i) {
          for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
            var a = r + i >>> 1;
            t(e[a], n) < 0 ? r = a + 1 : i = a;
          }

          return r;
        },
        right: function right(e, n, r, i) {
          for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
            var a = r + i >>> 1;
            t(e[a], n) > 0 ? i = a : r = a + 1;
          }

          return r;
        }
      };
    }

    var o = a(i),
        s = o.right,
        c = o.left;
    var u = s;

    function l(t, e) {
      null == e && (e = h);

      for (var n = 0, r = t.length - 1, i = t[0], a = new Array(r < 0 ? 0 : r); n < r;) {
        a[n] = e(i, i = t[++n]);
      }

      return a;
    }

    function h(t, e) {
      return [t, e];
    }

    function f(t, e, n) {
      var r,
          i,
          a,
          o,
          s = t.length,
          c = e.length,
          u = new Array(s * c);

      for (null == n && (n = h), r = a = 0; r < s; ++r) {
        for (o = t[r], i = 0; i < c; ++i, ++a) {
          u[a] = n(o, e[i]);
        }
      }

      return u;
    }

    function d(t, e) {
      return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
    }

    function p(t) {
      return null === t ? NaN : +t;
    }

    function y(t, e) {
      var n,
          r,
          i = t.length,
          a = 0,
          o = -1,
          s = 0,
          c = 0;
      if (null == e) for (; ++o < i;) {
        isNaN(n = p(t[o])) || (c += (r = n - s) * (n - (s += r / ++a)));
      } else for (; ++o < i;) {
        isNaN(n = p(e(t[o], o, t))) || (c += (r = n - s) * (n - (s += r / ++a)));
      }
      if (a > 1) return c / (a - 1);
    }

    function g(t, e) {
      var n = y(t, e);
      return n ? Math.sqrt(n) : n;
    }

    function m(t, e) {
      var n,
          r,
          i,
          a = t.length,
          o = -1;

      if (null == e) {
        for (; ++o < a;) {
          if (null != (n = t[o]) && n >= n) for (r = i = n; ++o < a;) {
            null != (n = t[o]) && (r > n && (r = n), i < n && (i = n));
          }
        }
      } else for (; ++o < a;) {
        if (null != (n = e(t[o], o, t)) && n >= n) for (r = i = n; ++o < a;) {
          null != (n = e(t[o], o, t)) && (r > n && (r = n), i < n && (i = n));
        }
      }

      return [r, i];
    }

    var v = Array.prototype,
        b = v.slice,
        _ = v.map;

    function x(t) {
      return function () {
        return t;
      };
    }

    function w(t) {
      return t;
    }

    function k(t, e, n) {
      t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;

      for (var r = -1, i = 0 | Math.max(0, Math.ceil((e - t) / n)), a = new Array(i); ++r < i;) {
        a[r] = t + r * n;
      }

      return a;
    }

    var T = Math.sqrt(50),
        E = Math.sqrt(10),
        C = Math.sqrt(2);

    function S(t, e, n) {
      var r,
          i,
          a,
          o,
          s = -1;
      if (n = +n, (t = +t) == (e = +e) && n > 0) return [t];
      if ((r = e < t) && (i = t, t = e, e = i), 0 === (o = A(t, e, n)) || !isFinite(o)) return [];
      if (o > 0) for (t = Math.ceil(t / o), e = Math.floor(e / o), a = new Array(i = Math.ceil(e - t + 1)); ++s < i;) {
        a[s] = (t + s) * o;
      } else for (t = Math.floor(t * o), e = Math.ceil(e * o), a = new Array(i = Math.ceil(t - e + 1)); ++s < i;) {
        a[s] = (t - s) / o;
      }
      return r && a.reverse(), a;
    }

    function A(t, e, n) {
      var r = (e - t) / Math.max(0, n),
          i = Math.floor(Math.log(r) / Math.LN10),
          a = r / Math.pow(10, i);
      return i >= 0 ? (a >= T ? 10 : a >= E ? 5 : a >= C ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= T ? 10 : a >= E ? 5 : a >= C ? 2 : 1);
    }

    function M(t, e, n) {
      var r = Math.abs(e - t) / Math.max(0, n),
          i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
          a = r / i;
      return a >= T ? i *= 10 : a >= E ? i *= 5 : a >= C && (i *= 2), e < t ? -i : i;
    }

    function N(t) {
      return Math.ceil(Math.log(t.length) / Math.LN2) + 1;
    }

    function D() {
      var t = w,
          e = m,
          n = N;

      function r(r) {
        var i,
            a,
            o = r.length,
            s = new Array(o);

        for (i = 0; i < o; ++i) {
          s[i] = t(r[i], i, r);
        }

        var c = e(s),
            l = c[0],
            h = c[1],
            f = n(s, l, h);
        Array.isArray(f) || (f = M(l, h, f), f = k(Math.ceil(l / f) * f, h, f));

        for (var d = f.length; f[0] <= l;) {
          f.shift(), --d;
        }

        for (; f[d - 1] > h;) {
          f.pop(), --d;
        }

        var p,
            y = new Array(d + 1);

        for (i = 0; i <= d; ++i) {
          (p = y[i] = []).x0 = i > 0 ? f[i - 1] : l, p.x1 = i < d ? f[i] : h;
        }

        for (i = 0; i < o; ++i) {
          l <= (a = s[i]) && a <= h && y[u(f, a, 0, d)].push(r[i]);
        }

        return y;
      }

      return r.value = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : x(e), r) : t;
      }, r.domain = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : x([t[0], t[1]]), r) : e;
      }, r.thresholds = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : Array.isArray(t) ? x(b.call(t)) : x(t), r) : n;
      }, r;
    }

    function O(t, e, n) {
      if (null == n && (n = p), r = t.length) {
        if ((e = +e) <= 0 || r < 2) return +n(t[0], 0, t);
        if (e >= 1) return +n(t[r - 1], r - 1, t);
        var r,
            i = (r - 1) * e,
            a = Math.floor(i),
            o = +n(t[a], a, t);
        return o + (+n(t[a + 1], a + 1, t) - o) * (i - a);
      }
    }

    function B(t, e, n) {
      return t = _.call(t, p).sort(i), Math.ceil((n - e) / (2 * (O(t, .75) - O(t, .25)) * Math.pow(t.length, -1 / 3)));
    }

    function L(t, e, n) {
      return Math.ceil((n - e) / (3.5 * g(t) * Math.pow(t.length, -1 / 3)));
    }

    function I(t, e) {
      var n,
          r,
          i = t.length,
          a = -1;

      if (null == e) {
        for (; ++a < i;) {
          if (null != (n = t[a]) && n >= n) for (r = n; ++a < i;) {
            null != (n = t[a]) && n > r && (r = n);
          }
        }
      } else for (; ++a < i;) {
        if (null != (n = e(t[a], a, t)) && n >= n) for (r = n; ++a < i;) {
          null != (n = e(t[a], a, t)) && n > r && (r = n);
        }
      }

      return r;
    }

    function R(t, e) {
      var n,
          r = t.length,
          i = r,
          a = -1,
          o = 0;
      if (null == e) for (; ++a < r;) {
        isNaN(n = p(t[a])) ? --i : o += n;
      } else for (; ++a < r;) {
        isNaN(n = p(e(t[a], a, t))) ? --i : o += n;
      }
      if (i) return o / i;
    }

    function F(t, e) {
      var n,
          r = t.length,
          a = -1,
          o = [];
      if (null == e) for (; ++a < r;) {
        isNaN(n = p(t[a])) || o.push(n);
      } else for (; ++a < r;) {
        isNaN(n = p(e(t[a], a, t))) || o.push(n);
      }
      return O(o.sort(i), .5);
    }

    function P(t) {
      for (var e, n, r, i = t.length, a = -1, o = 0; ++a < i;) {
        o += t[a].length;
      }

      for (n = new Array(o); --i >= 0;) {
        for (e = (r = t[i]).length; --e >= 0;) {
          n[--o] = r[e];
        }
      }

      return n;
    }

    function j(t, e) {
      var n,
          r,
          i = t.length,
          a = -1;

      if (null == e) {
        for (; ++a < i;) {
          if (null != (n = t[a]) && n >= n) for (r = n; ++a < i;) {
            null != (n = t[a]) && r > n && (r = n);
          }
        }
      } else for (; ++a < i;) {
        if (null != (n = e(t[a], a, t)) && n >= n) for (r = n; ++a < i;) {
          null != (n = e(t[a], a, t)) && r > n && (r = n);
        }
      }

      return r;
    }

    function Y(t, e) {
      for (var n = e.length, r = new Array(n); n--;) {
        r[n] = t[e[n]];
      }

      return r;
    }

    function z(t, e) {
      if (n = t.length) {
        var n,
            r,
            a = 0,
            o = 0,
            s = t[o];

        for (null == e && (e = i); ++a < n;) {
          (e(r = t[a], s) < 0 || 0 !== e(s, s)) && (s = r, o = a);
        }

        return 0 === e(s, s) ? o : void 0;
      }
    }

    function U(t, e, n) {
      for (var r, i, a = (null == n ? t.length : n) - (e = null == e ? 0 : +e); a;) {
        i = Math.random() * a-- | 0, r = t[a + e], t[a + e] = t[i + e], t[i + e] = r;
      }

      return t;
    }

    function q(t, e) {
      var n,
          r = t.length,
          i = -1,
          a = 0;
      if (null == e) for (; ++i < r;) {
        (n = +t[i]) && (a += n);
      } else for (; ++i < r;) {
        (n = +e(t[i], i, t)) && (a += n);
      }
      return a;
    }

    function H(t) {
      if (!(i = t.length)) return [];

      for (var e = -1, n = j(t, $), r = new Array(n); ++e < n;) {
        for (var i, a = -1, o = r[e] = new Array(i); ++a < i;) {
          o[a] = t[a][e];
        }
      }

      return r;
    }

    function $(t) {
      return t.length;
    }

    function W() {
      return H(arguments);
    }

    var V = Array.prototype.slice;

    function G(t) {
      return t;
    }

    var X = 1e-6;

    function Z(t) {
      return "translate(" + (t + .5) + ",0)";
    }

    function Q(t) {
      return "translate(0," + (t + .5) + ")";
    }

    function K(t) {
      return function (e) {
        return +t(e);
      };
    }

    function J(t) {
      var e = Math.max(0, t.bandwidth() - 1) / 2;
      return t.round() && (e = Math.round(e)), function (n) {
        return +t(n) + e;
      };
    }

    function tt() {
      return !this.__axis;
    }

    function et(t, e) {
      var n = [],
          r = null,
          i = null,
          a = 6,
          o = 6,
          s = 3,
          c = 1 === t || 4 === t ? -1 : 1,
          u = 4 === t || 2 === t ? "x" : "y",
          l = 1 === t || 3 === t ? Z : Q;

      function h(h) {
        var f = null == r ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r,
            d = null == i ? e.tickFormat ? e.tickFormat.apply(e, n) : G : i,
            p = Math.max(a, 0) + s,
            y = e.range(),
            g = +y[0] + .5,
            m = +y[y.length - 1] + .5,
            v = (e.bandwidth ? J : K)(e.copy()),
            b = h.selection ? h.selection() : h,
            _ = b.selectAll(".domain").data([null]),
            x = b.selectAll(".tick").data(f, e).order(),
            w = x.exit(),
            k = x.enter().append("g").attr("class", "tick"),
            T = x.select("line"),
            E = x.select("text");

        _ = _.merge(_.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), x = x.merge(k), T = T.merge(k.append("line").attr("stroke", "currentColor").attr(u + "2", c * a)), E = E.merge(k.append("text").attr("fill", "currentColor").attr(u, c * p).attr("dy", 1 === t ? "0em" : 3 === t ? "0.71em" : "0.32em")), h !== b && (_ = _.transition(h), x = x.transition(h), T = T.transition(h), E = E.transition(h), w = w.transition(h).attr("opacity", X).attr("transform", function (t) {
          return isFinite(t = v(t)) ? l(t) : this.getAttribute("transform");
        }), k.attr("opacity", X).attr("transform", function (t) {
          var e = this.parentNode.__axis;
          return l(e && isFinite(e = e(t)) ? e : v(t));
        })), w.remove(), _.attr("d", 4 === t || 2 == t ? o ? "M" + c * o + "," + g + "H0.5V" + m + "H" + c * o : "M0.5," + g + "V" + m : o ? "M" + g + "," + c * o + "V0.5H" + m + "V" + c * o : "M" + g + ",0.5H" + m), x.attr("opacity", 1).attr("transform", function (t) {
          return l(v(t));
        }), T.attr(u + "2", c * a), E.attr(u, c * p).text(d), b.filter(tt).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === t ? "start" : 4 === t ? "end" : "middle"), b.each(function () {
          this.__axis = v;
        });
      }

      return h.scale = function (t) {
        return arguments.length ? (e = t, h) : e;
      }, h.ticks = function () {
        return n = V.call(arguments), h;
      }, h.tickArguments = function (t) {
        return arguments.length ? (n = null == t ? [] : V.call(t), h) : n.slice();
      }, h.tickValues = function (t) {
        return arguments.length ? (r = null == t ? null : V.call(t), h) : r && r.slice();
      }, h.tickFormat = function (t) {
        return arguments.length ? (i = t, h) : i;
      }, h.tickSize = function (t) {
        return arguments.length ? (a = o = +t, h) : a;
      }, h.tickSizeInner = function (t) {
        return arguments.length ? (a = +t, h) : a;
      }, h.tickSizeOuter = function (t) {
        return arguments.length ? (o = +t, h) : o;
      }, h.tickPadding = function (t) {
        return arguments.length ? (s = +t, h) : s;
      }, h;
    }

    function nt(t) {
      return et(1, t);
    }

    function rt(t) {
      return et(2, t);
    }

    function it(t) {
      return et(3, t);
    }

    function at(t) {
      return et(4, t);
    }

    var ot = {
      value: function value() {}
    };

    function st() {
      for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
        if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        r[t] = [];
      }

      return new ct(r);
    }

    function ct(t) {
      this._ = t;
    }

    function ut(t, e) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var n = "",
            r = t.indexOf(".");
        if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: n
        };
      });
    }

    function lt(t, e) {
      for (var n, r = 0, i = t.length; r < i; ++r) {
        if ((n = t[r]).name === e) return n.value;
      }
    }

    function ht(t, e, n) {
      for (var r = 0, i = t.length; r < i; ++r) {
        if (t[r].name === e) {
          t[r] = ot, t = t.slice(0, r).concat(t.slice(r + 1));
          break;
        }
      }

      return null != n && t.push({
        name: e,
        value: n
      }), t;
    }

    ct.prototype = st.prototype = {
      constructor: ct,
      on: function on(t, e) {
        var n,
            r = this._,
            i = ut(t + "", r),
            a = -1,
            o = i.length;

        if (!(arguments.length < 2)) {
          if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

          for (; ++a < o;) {
            if (n = (t = i[a]).type) r[n] = ht(r[n], t.name, e);else if (null == e) for (n in r) {
              r[n] = ht(r[n], t.name, null);
            }
          }

          return this;
        }

        for (; ++a < o;) {
          if ((n = (t = i[a]).type) && (n = lt(r[n], t.name))) return n;
        }
      },
      copy: function copy() {
        var t = {},
            e = this._;

        for (var n in e) {
          t[n] = e[n].slice();
        }

        return new ct(t);
      },
      call: function call(t, e) {
        if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
          i[a] = arguments[a + 2];
        }
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
          r[a].value.apply(e, i);
        }
      },
      apply: function apply(t, e, n) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
          r[i].value.apply(e, n);
        }
      }
    };
    var ft = st;

    function dt() {}

    function pt(t) {
      return null == t ? dt : function () {
        return this.querySelector(t);
      };
    }

    function yt() {
      return [];
    }

    function gt(t) {
      return null == t ? yt : function () {
        return this.querySelectorAll(t);
      };
    }

    function mt(t) {
      return function () {
        return this.matches(t);
      };
    }

    function vt(t) {
      return new Array(t.length);
    }

    function bt(t, e) {
      this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
    }

    function _t(t, e, n, r, i, a) {
      for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
        (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new bt(t, a[s]);
      }

      for (; s < c; ++s) {
        (o = e[s]) && (i[s] = o);
      }
    }

    function xt(t, e, n, r, i, a, o) {
      var s,
          c,
          u,
          l = {},
          h = e.length,
          f = a.length,
          d = new Array(h);

      for (s = 0; s < h; ++s) {
        (c = e[s]) && (d[s] = u = "$" + o.call(c, c.__data__, s, e), u in l ? i[s] = c : l[u] = c);
      }

      for (s = 0; s < f; ++s) {
        (c = l[u = "$" + o.call(t, a[s], s, a)]) ? (r[s] = c, c.__data__ = a[s], l[u] = null) : n[s] = new bt(t, a[s]);
      }

      for (s = 0; s < h; ++s) {
        (c = e[s]) && l[d[s]] === c && (i[s] = c);
      }
    }

    function wt(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }

    bt.prototype = {
      constructor: bt,
      appendChild: function appendChild(t) {
        return this._parent.insertBefore(t, this._next);
      },
      insertBefore: function insertBefore(t, e) {
        return this._parent.insertBefore(t, e);
      },
      querySelector: function querySelector(t) {
        return this._parent.querySelector(t);
      },
      querySelectorAll: function querySelectorAll(t) {
        return this._parent.querySelectorAll(t);
      }
    };
    var kt = "http://www.w3.org/1999/xhtml";
    var Tt = {
      svg: "http://www.w3.org/2000/svg",
      xhtml: kt,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };

    function Et(t) {
      var e = t += "",
          n = e.indexOf(":");
      return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), Tt.hasOwnProperty(e) ? {
        space: Tt[e],
        local: t
      } : t;
    }

    function Ct(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function St(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function At(t, e) {
      return function () {
        this.setAttribute(t, e);
      };
    }

    function Mt(t, e) {
      return function () {
        this.setAttributeNS(t.space, t.local, e);
      };
    }

    function Nt(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
      };
    }

    function Dt(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
      };
    }

    function Ot(t) {
      return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
    }

    function Bt(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function Lt(t, e, n) {
      return function () {
        this.style.setProperty(t, e, n);
      };
    }

    function It(t, e, n) {
      return function () {
        var r = e.apply(this, arguments);
        null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
      };
    }

    function Rt(t, e) {
      return t.style.getPropertyValue(e) || Ot(t).getComputedStyle(t, null).getPropertyValue(e);
    }

    function Ft(t) {
      return function () {
        delete this[t];
      };
    }

    function Pt(t, e) {
      return function () {
        this[t] = e;
      };
    }

    function jt(t, e) {
      return function () {
        var n = e.apply(this, arguments);
        null == n ? delete this[t] : this[t] = n;
      };
    }

    function Yt(t) {
      return t.trim().split(/^|\s+/);
    }

    function zt(t) {
      return t.classList || new Ut(t);
    }

    function Ut(t) {
      this._node = t, this._names = Yt(t.getAttribute("class") || "");
    }

    function qt(t, e) {
      for (var n = zt(t), r = -1, i = e.length; ++r < i;) {
        n.add(e[r]);
      }
    }

    function Ht(t, e) {
      for (var n = zt(t), r = -1, i = e.length; ++r < i;) {
        n.remove(e[r]);
      }
    }

    function $t(t) {
      return function () {
        qt(this, t);
      };
    }

    function Wt(t) {
      return function () {
        Ht(this, t);
      };
    }

    function Vt(t, e) {
      return function () {
        (e.apply(this, arguments) ? qt : Ht)(this, t);
      };
    }

    function Gt() {
      this.textContent = "";
    }

    function Xt(t) {
      return function () {
        this.textContent = t;
      };
    }

    function Zt(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.textContent = null == e ? "" : e;
      };
    }

    function Qt() {
      this.innerHTML = "";
    }

    function Kt(t) {
      return function () {
        this.innerHTML = t;
      };
    }

    function Jt(t) {
      return function () {
        var e = t.apply(this, arguments);
        this.innerHTML = null == e ? "" : e;
      };
    }

    function te() {
      this.nextSibling && this.parentNode.appendChild(this);
    }

    function ee() {
      this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }

    function ne(t) {
      return function () {
        var e = this.ownerDocument,
            n = this.namespaceURI;
        return n === kt && e.documentElement.namespaceURI === kt ? e.createElement(t) : e.createElementNS(n, t);
      };
    }

    function re(t) {
      return function () {
        return this.ownerDocument.createElementNS(t.space, t.local);
      };
    }

    function ie(t) {
      var e = Et(t);
      return (e.local ? re : ne)(e);
    }

    function ae() {
      return null;
    }

    function oe() {
      var t = this.parentNode;
      t && t.removeChild(this);
    }

    function se() {
      var t = this.cloneNode(!1),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    function ce() {
      var t = this.cloneNode(!0),
          e = this.parentNode;
      return e ? e.insertBefore(t, this.nextSibling) : t;
    }

    Ut.prototype = {
      add: function add(t) {
        this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
      },
      remove: function remove(t) {
        var e = this._names.indexOf(t);

        e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
      },
      contains: function contains(t) {
        return this._names.indexOf(t) >= 0;
      }
    };
    var ue = {},
        le = null;

    function he(t, e, n) {
      return t = fe(t, e, n), function (e) {
        var n = e.relatedTarget;
        n && (n === this || 8 & n.compareDocumentPosition(this)) || t.call(this, e);
      };
    }

    function fe(t, e, n) {
      return function (r) {
        var i = le;
        le = r;

        try {
          t.call(this, this.__data__, e, n);
        } finally {
          le = i;
        }
      };
    }

    function de(t) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var e = "",
            n = t.indexOf(".");
        return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
          type: t,
          name: e
        };
      });
    }

    function pe(t) {
      return function () {
        var e = this.__on;

        if (e) {
          for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
            n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.capture);
          }

          ++i ? e.length = i : delete this.__on;
        }
      };
    }

    function ye(t, e, n) {
      var r = ue.hasOwnProperty(t.type) ? he : fe;
      return function (i, a, o) {
        var s,
            c = this.__on,
            u = r(e, a, o);
        if (c) for (var l = 0, h = c.length; l < h; ++l) {
          if ((s = c[l]).type === t.type && s.name === t.name) return this.removeEventListener(s.type, s.listener, s.capture), this.addEventListener(s.type, s.listener = u, s.capture = n), void (s.value = e);
        }
        this.addEventListener(t.type, u, n), s = {
          type: t.type,
          name: t.name,
          value: e,
          listener: u,
          capture: n
        }, c ? c.push(s) : this.__on = [s];
      };
    }

    function ge(t, e, n, r) {
      var i = le;
      t.sourceEvent = le, le = t;

      try {
        return e.apply(n, r);
      } finally {
        le = i;
      }
    }

    function me(t, e, n) {
      var r = Ot(t),
          i = r.CustomEvent;
      "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
    }

    function ve(t, e) {
      return function () {
        return me(this, t, e);
      };
    }

    function be(t, e) {
      return function () {
        return me(this, t, e.apply(this, arguments));
      };
    }

    "undefined" != typeof document && ("onmouseenter" in document.documentElement || (ue = {
      mouseenter: "mouseover",
      mouseleave: "mouseout"
    }));
    var _e = [null];

    function xe(t, e) {
      this._groups = t, this._parents = e;
    }

    function we() {
      return new xe([[document.documentElement]], _e);
    }

    xe.prototype = we.prototype = {
      constructor: xe,
      select: function select(t) {
        "function" != typeof t && (t = pt(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
            (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
          }
        }

        return new xe(r, this._parents);
      },
      selectAll: function selectAll(t) {
        "function" != typeof t && (t = gt(t));

        for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
          for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
            (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
          }
        }

        return new xe(r, i);
      },
      filter: function filter(t) {
        "function" != typeof t && (t = mt(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new xe(r, this._parents);
      },
      data: function data(t, e) {
        if (!t) return p = new Array(this.size()), l = -1, this.each(function (t) {
          p[++l] = t;
        }), p;
        var n,
            r = e ? xt : _t,
            i = this._parents,
            a = this._groups;
        "function" != typeof t && (n = t, t = function t() {
          return n;
        });

        for (var o = a.length, s = new Array(o), c = new Array(o), u = new Array(o), l = 0; l < o; ++l) {
          var h = i[l],
              f = a[l],
              d = f.length,
              p = t.call(h, h && h.__data__, l, i),
              y = p.length,
              g = c[l] = new Array(y),
              m = s[l] = new Array(y);
          r(h, f, g, m, u[l] = new Array(d), p, e);

          for (var v, b, _ = 0, x = 0; _ < y; ++_) {
            if (v = g[_]) {
              for (_ >= x && (x = _ + 1); !(b = m[x]) && ++x < y;) {
                ;
              }

              v._next = b || null;
            }
          }
        }

        return (s = new xe(s, i))._enter = c, s._exit = u, s;
      },
      enter: function enter() {
        return new xe(this._enter || this._groups.map(vt), this._parents);
      },
      exit: function exit() {
        return new xe(this._exit || this._groups.map(vt), this._parents);
      },
      join: function join(t, e, n) {
        var r = this.enter(),
            i = this,
            a = this.exit();
        return r = "function" == typeof t ? t(r) : r.append(t + ""), null != e && (i = e(i)), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
      },
      merge: function merge(t) {
        for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
          for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
            (c = u[d] || l[d]) && (f[d] = c);
          }
        }

        for (; s < r; ++s) {
          o[s] = e[s];
        }

        return new xe(o, this._parents);
      },
      order: function order() {
        for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
          for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
            (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
          }
        }

        return this;
      },
      sort: function sort(t) {
        function e(e, n) {
          return e && n ? t(e.__data__, n.__data__) : !e - !n;
        }

        t || (t = wt);

        for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
          for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
            (o = s[l]) && (u[l] = o);
          }

          u.sort(e);
        }

        return new xe(i, this._parents).order();
      },
      call: function call() {
        var t = arguments[0];
        return arguments[0] = this, t.apply(null, arguments), this;
      },
      nodes: function nodes() {
        var t = new Array(this.size()),
            e = -1;
        return this.each(function () {
          t[++e] = this;
        }), t;
      },
      node: function node() {
        for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
          for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
            var o = r[i];
            if (o) return o;
          }
        }

        return null;
      },
      size: function size() {
        var t = 0;
        return this.each(function () {
          ++t;
        }), t;
      },
      empty: function empty() {
        return !this.node();
      },
      each: function each(t) {
        for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
          for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
            (i = a[o]) && t.call(i, i.__data__, o, a);
          }
        }

        return this;
      },
      attr: function attr(t, e) {
        var n = Et(t);

        if (arguments.length < 2) {
          var r = this.node();
          return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
        }

        return this.each((null == e ? n.local ? St : Ct : "function" == typeof e ? n.local ? Dt : Nt : n.local ? Mt : At)(n, e));
      },
      style: function style(t, e, n) {
        return arguments.length > 1 ? this.each((null == e ? Bt : "function" == typeof e ? It : Lt)(t, e, null == n ? "" : n)) : Rt(this.node(), t);
      },
      property: function property(t, e) {
        return arguments.length > 1 ? this.each((null == e ? Ft : "function" == typeof e ? jt : Pt)(t, e)) : this.node()[t];
      },
      classed: function classed(t, e) {
        var n = Yt(t + "");

        if (arguments.length < 2) {
          for (var r = zt(this.node()), i = -1, a = n.length; ++i < a;) {
            if (!r.contains(n[i])) return !1;
          }

          return !0;
        }

        return this.each(("function" == typeof e ? Vt : e ? $t : Wt)(n, e));
      },
      text: function text(t) {
        return arguments.length ? this.each(null == t ? Gt : ("function" == typeof t ? Zt : Xt)(t)) : this.node().textContent;
      },
      html: function html(t) {
        return arguments.length ? this.each(null == t ? Qt : ("function" == typeof t ? Jt : Kt)(t)) : this.node().innerHTML;
      },
      raise: function raise() {
        return this.each(te);
      },
      lower: function lower() {
        return this.each(ee);
      },
      append: function append(t) {
        var e = "function" == typeof t ? t : ie(t);
        return this.select(function () {
          return this.appendChild(e.apply(this, arguments));
        });
      },
      insert: function insert(t, e) {
        var n = "function" == typeof t ? t : ie(t),
            r = null == e ? ae : "function" == typeof e ? e : pt(e);
        return this.select(function () {
          return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
        });
      },
      remove: function remove() {
        return this.each(oe);
      },
      clone: function clone(t) {
        return this.select(t ? ce : se);
      },
      datum: function datum(t) {
        return arguments.length ? this.property("__data__", t) : this.node().__data__;
      },
      on: function on(t, e, n) {
        var r,
            i,
            a = de(t + ""),
            o = a.length;

        if (!(arguments.length < 2)) {
          for (s = e ? ye : pe, null == n && (n = !1), r = 0; r < o; ++r) {
            this.each(s(a[r], e, n));
          }

          return this;
        }

        var s = this.node().__on;

        if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
          for (r = 0, c = s[u]; r < o; ++r) {
            if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
          }
        }
      },
      dispatch: function dispatch(t, e) {
        return this.each(("function" == typeof e ? be : ve)(t, e));
      }
    };
    var ke = we;

    function Te(t) {
      return "string" == typeof t ? new xe([[document.querySelector(t)]], [document.documentElement]) : new xe([[t]], _e);
    }

    function Ee() {
      le.stopImmediatePropagation();
    }

    function Ce() {
      le.preventDefault(), le.stopImmediatePropagation();
    }

    function Se(t) {
      var e = t.document.documentElement,
          n = Te(t).on("dragstart.drag", Ce, !0);
      "onselectstart" in e ? n.on("selectstart.drag", Ce, !0) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
    }

    function Ae(t, e) {
      var n = t.document.documentElement,
          r = Te(t).on("dragstart.drag", null);
      e && (r.on("click.drag", Ce, !0), setTimeout(function () {
        r.on("click.drag", null);
      }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
    }

    function Me(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    }

    function Ne(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function De() {}

    var Oe = .7,
        Be = 1 / Oe,
        Le = "\\s*([+-]?\\d+)\\s*",
        Ie = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        Re = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        Fe = /^#([0-9a-f]{3,8})$/,
        Pe = new RegExp("^rgb\\(" + [Le, Le, Le] + "\\)$"),
        je = new RegExp("^rgb\\(" + [Re, Re, Re] + "\\)$"),
        Ye = new RegExp("^rgba\\(" + [Le, Le, Le, Ie] + "\\)$"),
        ze = new RegExp("^rgba\\(" + [Re, Re, Re, Ie] + "\\)$"),
        Ue = new RegExp("^hsl\\(" + [Ie, Re, Re] + "\\)$"),
        qe = new RegExp("^hsla\\(" + [Ie, Re, Re, Ie] + "\\)$"),
        He = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function $e() {
      return this.rgb().formatHex();
    }

    function We() {
      return this.rgb().formatRgb();
    }

    function Ve(t) {
      var e, n;
      return t = (t + "").trim().toLowerCase(), (e = Fe.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? Ge(e) : 3 === n ? new Ke(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Xe(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Xe(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Pe.exec(t)) ? new Ke(e[1], e[2], e[3], 1) : (e = je.exec(t)) ? new Ke(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Ye.exec(t)) ? Xe(e[1], e[2], e[3], e[4]) : (e = ze.exec(t)) ? Xe(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Ue.exec(t)) ? nn(e[1], e[2] / 100, e[3] / 100, 1) : (e = qe.exec(t)) ? nn(e[1], e[2] / 100, e[3] / 100, e[4]) : He.hasOwnProperty(t) ? Ge(He[t]) : "transparent" === t ? new Ke(NaN, NaN, NaN, 0) : null;
    }

    function Ge(t) {
      return new Ke(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function Xe(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new Ke(t, e, n, r);
    }

    function Ze(t) {
      return t instanceof De || (t = Ve(t)), t ? new Ke((t = t.rgb()).r, t.g, t.b, t.opacity) : new Ke();
    }

    function Qe(t, e, n, r) {
      return 1 === arguments.length ? Ze(t) : new Ke(t, e, n, null == r ? 1 : r);
    }

    function Ke(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function Je() {
      return "#" + en(this.r) + en(this.g) + en(this.b);
    }

    function tn() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function en(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function nn(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new on(t, e, n, r);
    }

    function rn(t) {
      if (t instanceof on) return new on(t.h, t.s, t.l, t.opacity);
      if (t instanceof De || (t = Ve(t)), !t) return new on();
      if (t instanceof on) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          o = NaN,
          s = a - i,
          c = (a + i) / 2;
      return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new on(o, s, c, t.opacity);
    }

    function an(t, e, n, r) {
      return 1 === arguments.length ? rn(t) : new on(t, e, n, null == r ? 1 : r);
    }

    function on(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function sn(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    function cn(t, e, n, r, i) {
      var a = t * t,
          o = a * t;
      return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
    }

    function un(t) {
      var e = t.length - 1;
      return function (n) {
        var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
            i = t[r],
            a = t[r + 1],
            o = r > 0 ? t[r - 1] : 2 * i - a,
            s = r < e - 1 ? t[r + 2] : 2 * a - i;
        return cn((n - r / e) * e, o, i, a, s);
      };
    }

    function ln(t) {
      var e = t.length;
      return function (n) {
        var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
            i = t[(r + e - 1) % e],
            a = t[r % e],
            o = t[(r + 1) % e],
            s = t[(r + 2) % e];
        return cn((n - r / e) * e, i, a, o, s);
      };
    }

    function hn(t) {
      return function () {
        return t;
      };
    }

    function fn(t, e) {
      return function (n) {
        return t + n * e;
      };
    }

    function dn(t, e) {
      var n = e - t;
      return n ? fn(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : hn(isNaN(t) ? e : t);
    }

    function pn(t, e) {
      var n = e - t;
      return n ? fn(t, n) : hn(isNaN(t) ? e : t);
    }

    Me(De, Ve, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: $e,
      formatHex: $e,
      formatHsl: function formatHsl() {
        return rn(this).formatHsl();
      },
      formatRgb: We,
      toString: We
    }), Me(Ke, Qe, Ne(De, {
      brighter: function brighter(t) {
        return t = null == t ? Be : Math.pow(Be, t), new Ke(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Oe : Math.pow(Oe, t), new Ke(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: Je,
      formatHex: Je,
      formatRgb: tn,
      toString: tn
    })), Me(on, an, Ne(De, {
      brighter: function brighter(t) {
        return t = null == t ? Be : Math.pow(Be, t), new on(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Oe : Math.pow(Oe, t), new on(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new Ke(sn(t >= 240 ? t - 240 : t + 120, i, r), sn(t, i, r), sn(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));

    var yn = function t(e) {
      var n = function (t) {
        return 1 == (t = +t) ? pn : function (e, n) {
          return n - e ? function (t, e, n) {
            return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
              return Math.pow(t + r * e, n);
            };
          }(e, n, t) : hn(isNaN(e) ? n : e);
        };
      }(e);

      function r(t, e) {
        var r = n((t = Qe(t)).r, (e = Qe(e)).r),
            i = n(t.g, e.g),
            a = n(t.b, e.b),
            o = pn(t.opacity, e.opacity);
        return function (e) {
          return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
        };
      }

      return r.gamma = t, r;
    }(1);

    function gn(t) {
      return function (e) {
        var n,
            r,
            i = e.length,
            a = new Array(i),
            o = new Array(i),
            s = new Array(i);

        for (n = 0; n < i; ++n) {
          r = Qe(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
        }

        return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
          return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
        };
      };
    }

    var mn = gn(un),
        vn = gn(ln);

    function bn(t, e) {
      e || (e = []);
      var n,
          r = t ? Math.min(e.length, t.length) : 0,
          i = e.slice();
      return function (a) {
        for (n = 0; n < r; ++n) {
          i[n] = t[n] * (1 - a) + e[n] * a;
        }

        return i;
      };
    }

    function _n(t) {
      return ArrayBuffer.isView(t) && !(t instanceof DataView);
    }

    function xn(t, e) {
      return (_n(e) ? bn : wn)(t, e);
    }

    function wn(t, e) {
      var n,
          r = e ? e.length : 0,
          i = t ? Math.min(r, t.length) : 0,
          a = new Array(i),
          o = new Array(r);

      for (n = 0; n < i; ++n) {
        a[n] = Mn(t[n], e[n]);
      }

      for (; n < r; ++n) {
        o[n] = e[n];
      }

      return function (t) {
        for (n = 0; n < i; ++n) {
          o[n] = a[n](t);
        }

        return o;
      };
    }

    function kn(t, e) {
      var n = new Date();
      return t = +t, e = +e, function (r) {
        return n.setTime(t * (1 - r) + e * r), n;
      };
    }

    function Tn(t, e) {
      return t = +t, e = +e, function (n) {
        return t * (1 - n) + e * n;
      };
    }

    function En(t, e) {
      var n,
          r = {},
          i = {};

      for (n in null !== t && "object" == _typeof(t) || (t = {}), null !== e && "object" == _typeof(e) || (e = {}), e) {
        n in t ? r[n] = Mn(t[n], e[n]) : i[n] = e[n];
      }

      return function (t) {
        for (n in r) {
          i[n] = r[n](t);
        }

        return i;
      };
    }

    var Cn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        Sn = new RegExp(Cn.source, "g");

    function An(t, e) {
      var n,
          r,
          i,
          a = Cn.lastIndex = Sn.lastIndex = 0,
          o = -1,
          s = [],
          c = [];

      for (t += "", e += ""; (n = Cn.exec(t)) && (r = Sn.exec(e));) {
        (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
          i: o,
          x: Tn(n, r)
        })), a = Sn.lastIndex;
      }

      return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          s[(n = c[r]).i] = n.x(t);
        }

        return s.join("");
      });
    }

    function Mn(t, e) {
      var n,
          r = _typeof(e);

      return null == e || "boolean" === r ? hn(e) : ("number" === r ? Tn : "string" === r ? (n = Ve(e)) ? (e = n, yn) : An : e instanceof Ve ? yn : e instanceof Date ? kn : _n(e) ? bn : Array.isArray(e) ? wn : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? En : Tn)(t, e);
    }

    function Nn() {
      for (var t, e = le; t = e.sourceEvent;) {
        e = t;
      }

      return e;
    }

    function Dn(t, e) {
      var n = t.ownerSVGElement || t;

      if (n.createSVGPoint) {
        var r = n.createSVGPoint();
        return r.x = e.clientX, r.y = e.clientY, [(r = r.matrixTransform(t.getScreenCTM().inverse())).x, r.y];
      }

      var i = t.getBoundingClientRect();
      return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
    }

    function On(t, e, n) {
      arguments.length < 3 && (n = e, e = Nn().changedTouches);

      for (var r, i = 0, a = e ? e.length : 0; i < a; ++i) {
        if ((r = e[i]).identifier === n) return Dn(t, r);
      }

      return null;
    }

    function Bn(t) {
      var e = Nn();
      return e.changedTouches && (e = e.changedTouches[0]), Dn(t, e);
    }

    var Ln,
        In,
        Rn = 0,
        Fn = 0,
        Pn = 0,
        jn = 0,
        Yn = 0,
        zn = 0,
        Un = "object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && performance.now ? performance : Date,
        qn = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
      setTimeout(t, 17);
    };

    function Hn() {
      return Yn || (qn($n), Yn = Un.now() + zn);
    }

    function $n() {
      Yn = 0;
    }

    function Wn() {
      this._call = this._time = this._next = null;
    }

    function Vn(t, e, n) {
      var r = new Wn();
      return r.restart(t, e, n), r;
    }

    function Gn() {
      Hn(), ++Rn;

      for (var t, e = Ln; e;) {
        (t = Yn - e._time) >= 0 && e._call.call(null, t), e = e._next;
      }

      --Rn;
    }

    function Xn() {
      Yn = (jn = Un.now()) + zn, Rn = Fn = 0;

      try {
        Gn();
      } finally {
        Rn = 0, function () {
          for (var t, e, n = Ln, r = 1 / 0; n;) {
            n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Ln = e);
          }

          In = t, Qn(r);
        }(), Yn = 0;
      }
    }

    function Zn() {
      var t = Un.now(),
          e = t - jn;
      e > 1e3 && (zn -= e, jn = t);
    }

    function Qn(t) {
      Rn || (Fn && (Fn = clearTimeout(Fn)), t - Yn > 24 ? (t < 1 / 0 && (Fn = setTimeout(Xn, t - Un.now() - zn)), Pn && (Pn = clearInterval(Pn))) : (Pn || (jn = Un.now(), Pn = setInterval(Zn, 1e3)), Rn = 1, qn(Xn)));
    }

    function Kn(t, e, n) {
      var r = new Wn();
      return e = null == e ? 0 : +e, r.restart(function (n) {
        r.stop(), t(n + e);
      }, e, n), r;
    }

    Wn.prototype = Vn.prototype = {
      constructor: Wn,
      restart: function restart(t, e, n) {
        if ("function" != typeof t) throw new TypeError("callback is not a function");
        n = (null == n ? Hn() : +n) + (null == e ? 0 : +e), this._next || In === this || (In ? In._next = this : Ln = this, In = this), this._call = t, this._time = n, Qn();
      },
      stop: function stop() {
        this._call && (this._call = null, this._time = 1 / 0, Qn());
      }
    };
    var Jn = ft("start", "end", "cancel", "interrupt"),
        tr = [];

    function er(t, e, n, r, i, a) {
      var o = t.__transition;

      if (o) {
        if (n in o) return;
      } else t.__transition = {};

      !function (t, e, n) {
        var r,
            i = t.__transition;

        function a(c) {
          var u, l, h, f;
          if (1 !== n.state) return s();

          for (u in i) {
            if ((f = i[u]).name === n.name) {
              if (3 === f.state) return Kn(a);
              4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
            }
          }

          if (Kn(function () {
            3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
          }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
            for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
              (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
            }

            r.length = l + 1;
          }
        }

        function o(e) {
          for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
            r[a].call(t, i);
          }

          5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
        }

        function s() {
          for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
            return;
          }

          delete t.__transition;
        }

        i[e] = n, n.timer = Vn(function (t) {
          n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
        }, 0, n.time);
      }(t, n, {
        name: e,
        index: r,
        group: i,
        on: Jn,
        tween: tr,
        time: a.time,
        delay: a.delay,
        duration: a.duration,
        ease: a.ease,
        timer: null,
        state: 0
      });
    }

    function nr(t, e) {
      var n = ir(t, e);
      if (n.state > 0) throw new Error("too late; already scheduled");
      return n;
    }

    function rr(t, e) {
      var n = ir(t, e);
      if (n.state > 3) throw new Error("too late; already running");
      return n;
    }

    function ir(t, e) {
      var n = t.__transition;
      if (!n || !(n = n[e])) throw new Error("transition not found");
      return n;
    }

    function ar(t, e) {
      var n,
          r,
          i,
          a = t.__transition,
          o = !0;

      if (a) {
        for (i in e = null == e ? null : e + "", a) {
          (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
        }

        o && delete t.__transition;
      }
    }

    var or,
        sr,
        cr,
        ur,
        lr = 180 / Math.PI,
        hr = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };

    function fr(t, e, n, r, i, a) {
      var o, s, c;
      return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
        translateX: i,
        translateY: a,
        rotate: Math.atan2(e, t) * lr,
        skewX: Math.atan(c) * lr,
        scaleX: o,
        scaleY: s
      };
    }

    function dr(t, e, n, r) {
      function i(t) {
        return t.length ? t.pop() + " " : "";
      }

      return function (a, o) {
        var s = [],
            c = [];
        return a = t(a), o = t(o), function (t, r, i, a, o, s) {
          if (t !== i || r !== a) {
            var c = o.push("translate(", null, e, null, n);
            s.push({
              i: c - 4,
              x: Tn(t, i)
            }, {
              i: c - 2,
              x: Tn(r, a)
            });
          } else (i || a) && o.push("translate(" + i + e + a + n);
        }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
          t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
            i: n.push(i(n) + "rotate(", null, r) - 2,
            x: Tn(t, e)
          })) : e && n.push(i(n) + "rotate(" + e + r);
        }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
          t !== e ? a.push({
            i: n.push(i(n) + "skewX(", null, r) - 2,
            x: Tn(t, e)
          }) : e && n.push(i(n) + "skewX(" + e + r);
        }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
          if (t !== n || e !== r) {
            var s = a.push(i(a) + "scale(", null, ",", null, ")");
            o.push({
              i: s - 4,
              x: Tn(t, n)
            }, {
              i: s - 2,
              x: Tn(e, r)
            });
          } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
        }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
          for (var e, n = -1, r = c.length; ++n < r;) {
            s[(e = c[n]).i] = e.x(t);
          }

          return s.join("");
        };
      };
    }

    var pr = dr(function (t) {
      return "none" === t ? hr : (or || (or = document.createElement("DIV"), sr = document.documentElement, cr = document.defaultView), or.style.transform = t, t = cr.getComputedStyle(sr.appendChild(or), null).getPropertyValue("transform"), sr.removeChild(or), fr(+(t = t.slice(7, -1).split(","))[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
    }, "px, ", "px)", "deg)"),
        yr = dr(function (t) {
      return null == t ? hr : (ur || (ur = document.createElementNS("http://www.w3.org/2000/svg", "g")), ur.setAttribute("transform", t), (t = ur.transform.baseVal.consolidate()) ? fr((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : hr);
    }, ", ", ")", ")");

    function gr(t, e) {
      var n, r;
      return function () {
        var i = rr(this, t),
            a = i.tween;
        if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
          if (r[o].name === e) {
            (r = r.slice()).splice(o, 1);
            break;
          }
        }
        i.tween = r;
      };
    }

    function mr(t, e, n) {
      var r, i;
      if ("function" != typeof n) throw new Error();
      return function () {
        var a = rr(this, t),
            o = a.tween;

        if (o !== r) {
          i = (r = o).slice();

          for (var s = {
            name: e,
            value: n
          }, c = 0, u = i.length; c < u; ++c) {
            if (i[c].name === e) {
              i[c] = s;
              break;
            }
          }

          c === u && i.push(s);
        }

        a.tween = i;
      };
    }

    function vr(t, e, n) {
      var r = t._id;
      return t.each(function () {
        var t = rr(this, r);
        (t.value || (t.value = {}))[e] = n.apply(this, arguments);
      }), function (t) {
        return ir(t, r).value[e];
      };
    }

    function br(t, e) {
      var n;
      return ("number" == typeof e ? Tn : e instanceof Ve ? yn : (n = Ve(e)) ? (e = n, yn) : An)(t, e);
    }

    function _r(t) {
      return function () {
        this.removeAttribute(t);
      };
    }

    function xr(t) {
      return function () {
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function wr(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttribute(t);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function kr(t, e, n) {
      var r,
          i,
          a = n + "";
      return function () {
        var o = this.getAttributeNS(t.space, t.local);
        return o === a ? null : o === r ? i : i = e(r = o, n);
      };
    }

    function Tr(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttribute(t);
      };
    }

    function Er(t, e, n) {
      var r, i, a;
      return function () {
        var o,
            s,
            c = n(this);
        if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
        this.removeAttributeNS(t.space, t.local);
      };
    }

    function Cr(t, e) {
      return function (n) {
        this.setAttribute(t, e.call(this, n));
      };
    }

    function Sr(t, e) {
      return function (n) {
        this.setAttributeNS(t.space, t.local, e.call(this, n));
      };
    }

    function Ar(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && Sr(t, i)), n;
      }

      return i._value = e, i;
    }

    function Mr(t, e) {
      var n, r;

      function i() {
        var i = e.apply(this, arguments);
        return i !== r && (n = (r = i) && Cr(t, i)), n;
      }

      return i._value = e, i;
    }

    function Nr(t, e) {
      return function () {
        nr(this, t).delay = +e.apply(this, arguments);
      };
    }

    function Dr(t, e) {
      return e = +e, function () {
        nr(this, t).delay = e;
      };
    }

    function Or(t, e) {
      return function () {
        rr(this, t).duration = +e.apply(this, arguments);
      };
    }

    function Br(t, e) {
      return e = +e, function () {
        rr(this, t).duration = e;
      };
    }

    function Lr(t, e) {
      if ("function" != typeof e) throw new Error();
      return function () {
        rr(this, t).ease = e;
      };
    }

    function Ir(t, e, n) {
      var r,
          i,
          a = function (t) {
        return (t + "").trim().split(/^|\s+/).every(function (t) {
          var e = t.indexOf(".");
          return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
        });
      }(e) ? nr : rr;
      return function () {
        var o = a(this, t),
            s = o.on;
        s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
      };
    }

    var Rr = ke.prototype.constructor;

    function Fr(t) {
      return function () {
        this.style.removeProperty(t);
      };
    }

    function Pr(t, e, n) {
      return function (r) {
        this.style.setProperty(t, e.call(this, r), n);
      };
    }

    function jr(t, e, n) {
      var r, i;

      function a() {
        var a = e.apply(this, arguments);
        return a !== i && (r = (i = a) && Pr(t, a, n)), r;
      }

      return a._value = e, a;
    }

    function Yr(t) {
      return function (e) {
        this.textContent = t.call(this, e);
      };
    }

    function zr(t) {
      var e, n;

      function r() {
        var r = t.apply(this, arguments);
        return r !== n && (e = (n = r) && Yr(r)), e;
      }

      return r._value = t, r;
    }

    var Ur = 0;

    function qr(t, e, n, r) {
      this._groups = t, this._parents = e, this._name = n, this._id = r;
    }

    function Hr(t) {
      return ke().transition(t);
    }

    function $r() {
      return ++Ur;
    }

    var Wr = ke.prototype;

    function Vr(t) {
      return t * t * t;
    }

    function Gr(t) {
      return --t * t * t + 1;
    }

    function Xr(t) {
      return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
    }

    qr.prototype = Hr.prototype = {
      constructor: qr,
      select: function select(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = pt(t));

        for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
          for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
            (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, er(h[f], e, n, f, h, ir(s, n)));
          }
        }

        return new qr(a, this._parents, e, n);
      },
      selectAll: function selectAll(t) {
        var e = this._name,
            n = this._id;
        "function" != typeof t && (t = gt(t));

        for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
          for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
            if (c = u[h]) {
              for (var f, d = t.call(c, c.__data__, h, u), p = ir(c, n), y = 0, g = d.length; y < g; ++y) {
                (f = d[y]) && er(f, e, n, y, d, p);
              }

              a.push(d), o.push(c);
            }
          }
        }

        return new qr(a, o, e, n);
      },
      filter: function filter(t) {
        "function" != typeof t && (t = mt(t));

        for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
          for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
            (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
          }
        }

        return new qr(r, this._parents, this._name, this._id);
      },
      merge: function merge(t) {
        if (t._id !== this._id) throw new Error();

        for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
          for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
            (c = u[d] || l[d]) && (f[d] = c);
          }
        }

        for (; s < r; ++s) {
          o[s] = e[s];
        }

        return new qr(o, this._parents, this._name, this._id);
      },
      selection: function selection() {
        return new Rr(this._groups, this._parents);
      },
      transition: function transition() {
        for (var t = this._name, e = this._id, n = $r(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
          for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
            if (o = s[u]) {
              var l = ir(o, e);
              er(o, t, n, u, s, {
                time: l.time + l.delay + l.duration,
                delay: 0,
                duration: l.duration,
                ease: l.ease
              });
            }
          }
        }

        return new qr(r, this._parents, t, n);
      },
      call: Wr.call,
      nodes: Wr.nodes,
      node: Wr.node,
      size: Wr.size,
      empty: Wr.empty,
      each: Wr.each,
      on: function on(t, e) {
        var n = this._id;
        return arguments.length < 2 ? ir(this.node(), n).on.on(t) : this.each(Ir(n, t, e));
      },
      attr: function attr(t, e) {
        var n = Et(t),
            r = "transform" === n ? yr : br;
        return this.attrTween(t, "function" == typeof e ? (n.local ? Er : Tr)(n, r, vr(this, "attr." + t, e)) : null == e ? (n.local ? xr : _r)(n) : (n.local ? kr : wr)(n, r, e));
      },
      attrTween: function attrTween(t, e) {
        var n = "attr." + t;
        if (arguments.length < 2) return (n = this.tween(n)) && n._value;
        if (null == e) return this.tween(n, null);
        if ("function" != typeof e) throw new Error();
        var r = Et(t);
        return this.tween(n, (r.local ? Ar : Mr)(r, e));
      },
      style: function style(t, e, n) {
        var r = "transform" == (t += "") ? pr : br;
        return null == e ? this.styleTween(t, function (t, e) {
          var n, r, i;
          return function () {
            var a = Rt(this, t),
                o = (this.style.removeProperty(t), Rt(this, t));
            return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
          };
        }(t, r)).on("end.style." + t, Fr(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
          var r, i, a;
          return function () {
            var o = Rt(this, t),
                s = n(this),
                c = s + "";
            return null == s && (this.style.removeProperty(t), c = s = Rt(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
          };
        }(t, r, vr(this, "style." + t, e))).each(function (t, e) {
          var n,
              r,
              i,
              a,
              o = "style." + e,
              s = "end." + o;
          return function () {
            var c = rr(this, t),
                u = c.on,
                l = null == c.value[o] ? a || (a = Fr(e)) : void 0;
            u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
          };
        }(this._id, t)) : this.styleTween(t, function (t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = Rt(this, t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }(t, r, e), n).on("end.style." + t, null);
      },
      styleTween: function styleTween(t, e, n) {
        var r = "style." + (t += "");
        if (arguments.length < 2) return (r = this.tween(r)) && r._value;
        if (null == e) return this.tween(r, null);
        if ("function" != typeof e) throw new Error();
        return this.tween(r, jr(t, e, null == n ? "" : n));
      },
      text: function text(t) {
        return this.tween("text", "function" == typeof t ? function (t) {
          return function () {
            var e = t(this);
            this.textContent = null == e ? "" : e;
          };
        }(vr(this, "text", t)) : function (t) {
          return function () {
            this.textContent = t;
          };
        }(null == t ? "" : t + ""));
      },
      textTween: function textTween(t) {
        var e = "text";
        if (arguments.length < 1) return (e = this.tween(e)) && e._value;
        if (null == t) return this.tween(e, null);
        if ("function" != typeof t) throw new Error();
        return this.tween(e, zr(t));
      },
      remove: function remove() {
        return this.on("end.remove", function (t) {
          return function () {
            var e = this.parentNode;

            for (var n in this.__transition) {
              if (+n !== t) return;
            }

            e && e.removeChild(this);
          };
        }(this._id));
      },
      tween: function tween(t, e) {
        var n = this._id;

        if (t += "", arguments.length < 2) {
          for (var r, i = ir(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
            if ((r = i[a]).name === t) return r.value;
          }

          return null;
        }

        return this.each((null == e ? gr : mr)(n, t, e));
      },
      delay: function delay(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? Nr : Dr)(e, t)) : ir(this.node(), e).delay;
      },
      duration: function duration(t) {
        var e = this._id;
        return arguments.length ? this.each(("function" == typeof t ? Or : Br)(e, t)) : ir(this.node(), e).duration;
      },
      ease: function ease(t) {
        var e = this._id;
        return arguments.length ? this.each(Lr(e, t)) : ir(this.node(), e).ease;
      },
      end: function end() {
        var t,
            e,
            n = this,
            r = n._id,
            i = n.size();
        return new Promise(function (a, o) {
          var s = {
            value: o
          },
              c = {
            value: function value() {
              0 == --i && a();
            }
          };
          n.each(function () {
            var n = rr(this, r),
                i = n.on;
            i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
          });
        });
      }
    };
    var Zr = {
      time: null,
      delay: 0,
      duration: 250,
      ease: Xr
    };

    function Qr(t, e) {
      for (var n; !(n = t.__transition) || !(n = n[e]);) {
        if (!(t = t.parentNode)) return Zr.time = Hn(), Zr;
      }

      return n;
    }

    ke.prototype.interrupt = function (t) {
      return this.each(function () {
        ar(this, t);
      });
    }, ke.prototype.transition = function (t) {
      var e, n;
      t instanceof qr ? (e = t._id, t = t._name) : (e = $r(), (n = Zr).time = Hn(), t = null == t ? null : t + "");

      for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
        for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
          (o = s[u]) && er(o, t, e, u, s, n || Qr(o, e));
        }
      }

      return new qr(r, this._parents, t, e);
    };
    var Kr = [null];

    function Jr(t, e) {
      var n,
          r,
          i = t.__transition;
      if (i) for (r in e = null == e ? null : e + "", i) {
        if ((n = i[r]).state > 1 && n.name === e) return new qr([[t]], Kr, e, +r);
      }
      return null;
    }

    function ti(t) {
      return function () {
        return t;
      };
    }

    function ei(t, e, n) {
      this.target = t, this.type = e, this.selection = n;
    }

    function ni() {
      le.stopImmediatePropagation();
    }

    function ri() {
      le.preventDefault(), le.stopImmediatePropagation();
    }

    var ii = {
      name: "drag"
    },
        ai = {
      name: "space"
    },
        oi = {
      name: "handle"
    },
        si = {
      name: "center"
    };

    function ci(t) {
      return [+t[0], +t[1]];
    }

    function ui(t) {
      return [ci(t[0]), ci(t[1])];
    }

    function li(t) {
      return function (e) {
        return On(e, le.touches, t);
      };
    }

    var hi = {
      name: "x",
      handles: ["w", "e"].map(bi),
      input: function input(t, e) {
        return null == t ? null : [[+t[0], e[0][1]], [+t[1], e[1][1]]];
      },
      output: function output(t) {
        return t && [t[0][0], t[1][0]];
      }
    },
        fi = {
      name: "y",
      handles: ["n", "s"].map(bi),
      input: function input(t, e) {
        return null == t ? null : [[e[0][0], +t[0]], [e[1][0], +t[1]]];
      },
      output: function output(t) {
        return t && [t[0][1], t[1][1]];
      }
    },
        di = {
      name: "xy",
      handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(bi),
      input: function input(t) {
        return null == t ? null : ui(t);
      },
      output: function output(t) {
        return t;
      }
    },
        pi = {
      overlay: "crosshair",
      selection: "move",
      n: "ns-resize",
      e: "ew-resize",
      s: "ns-resize",
      w: "ew-resize",
      nw: "nwse-resize",
      ne: "nesw-resize",
      se: "nwse-resize",
      sw: "nesw-resize"
    },
        yi = {
      e: "w",
      w: "e",
      nw: "ne",
      ne: "nw",
      se: "sw",
      sw: "se"
    },
        gi = {
      n: "s",
      s: "n",
      nw: "sw",
      ne: "se",
      se: "ne",
      sw: "nw"
    },
        mi = {
      overlay: 1,
      selection: 1,
      n: null,
      e: 1,
      s: null,
      w: -1,
      nw: -1,
      ne: 1,
      se: 1,
      sw: -1
    },
        vi = {
      overlay: 1,
      selection: 1,
      n: -1,
      e: null,
      s: 1,
      w: null,
      nw: -1,
      ne: -1,
      se: 1,
      sw: 1
    };

    function bi(t) {
      return {
        type: t
      };
    }

    function _i() {
      return !le.ctrlKey && !le.button;
    }

    function xi() {
      var t = this.ownerSVGElement || this;
      return t.hasAttribute("viewBox") ? [[(t = t.viewBox.baseVal).x, t.y], [t.x + t.width, t.y + t.height]] : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
    }

    function wi() {
      return navigator.maxTouchPoints || "ontouchstart" in this;
    }

    function ki(t) {
      for (; !t.__brush;) {
        if (!(t = t.parentNode)) return;
      }

      return t.__brush;
    }

    function Ti(t) {
      return t[0][0] === t[1][0] || t[0][1] === t[1][1];
    }

    function Ei(t) {
      var e = t.__brush;
      return e ? e.dim.output(e.selection) : null;
    }

    function Ci() {
      return Mi(hi);
    }

    function Si() {
      return Mi(fi);
    }

    function Ai() {
      return Mi(di);
    }

    function Mi(t) {
      var e,
          n = xi,
          r = _i,
          i = wi,
          a = !0,
          o = ft("start", "brush", "end"),
          s = 6;

      function c(e) {
        var n = e.property("__brush", y).selectAll(".overlay").data([bi("overlay")]);
        n.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", pi.overlay).merge(n).each(function () {
          var t = ki(this).extent;
          Te(this).attr("x", t[0][0]).attr("y", t[0][1]).attr("width", t[1][0] - t[0][0]).attr("height", t[1][1] - t[0][1]);
        }), e.selectAll(".selection").data([bi("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", pi.selection).attr("fill", "#777").attr("fill-opacity", .3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var r = e.selectAll(".handle").data(t.handles, function (t) {
          return t.type;
        });
        r.exit().remove(), r.enter().append("rect").attr("class", function (t) {
          return "handle handle--" + t.type;
        }).attr("cursor", function (t) {
          return pi[t.type];
        }), e.each(u).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", f).filter(i).on("touchstart.brush", f).on("touchmove.brush", d).on("touchend.brush touchcancel.brush", p).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
      }

      function u() {
        var t = Te(this),
            e = ki(this).selection;
        e ? (t.selectAll(".selection").style("display", null).attr("x", e[0][0]).attr("y", e[0][1]).attr("width", e[1][0] - e[0][0]).attr("height", e[1][1] - e[0][1]), t.selectAll(".handle").style("display", null).attr("x", function (t) {
          return "e" === t.type[t.type.length - 1] ? e[1][0] - s / 2 : e[0][0] - s / 2;
        }).attr("y", function (t) {
          return "s" === t.type[0] ? e[1][1] - s / 2 : e[0][1] - s / 2;
        }).attr("width", function (t) {
          return "n" === t.type || "s" === t.type ? e[1][0] - e[0][0] + s : s;
        }).attr("height", function (t) {
          return "e" === t.type || "w" === t.type ? e[1][1] - e[0][1] + s : s;
        })) : t.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
      }

      function l(t, e, n) {
        var r = t.__brush.emitter;
        return !r || n && r.clean ? new h(t, e, n) : r;
      }

      function h(t, e, n) {
        this.that = t, this.args = e, this.state = t.__brush, this.active = 0, this.clean = n;
      }

      function f() {
        if ((!e || le.touches) && r.apply(this, arguments)) {
          var n,
              i,
              o,
              s,
              c,
              h,
              f,
              d,
              p,
              y,
              g,
              m = this,
              v = le.target.__data__.type,
              b = "selection" === (a && le.metaKey ? v = "overlay" : v) ? ii : a && le.altKey ? si : oi,
              _ = t === fi ? null : mi[v],
              x = t === hi ? null : vi[v],
              w = ki(m),
              k = w.extent,
              T = w.selection,
              E = k[0][0],
              C = k[0][1],
              S = k[1][0],
              A = k[1][1],
              M = 0,
              N = 0,
              D = _ && x && a && le.shiftKey,
              O = le.touches ? li(le.changedTouches[0].identifier) : Bn,
              B = O(m),
              L = B,
              I = l(m, arguments, !0).beforestart();

          "overlay" === v ? (T && (p = !0), w.selection = T = [[n = t === fi ? E : B[0], o = t === hi ? C : B[1]], [c = t === fi ? S : n, f = t === hi ? A : o]]) : (n = T[0][0], o = T[0][1], c = T[1][0], f = T[1][1]), i = n, s = o, h = c, d = f;
          var R = Te(m).attr("pointer-events", "none"),
              F = R.selectAll(".overlay").attr("cursor", pi[v]);
          if (le.touches) I.moved = j, I.ended = z;else {
            var P = Te(le.view).on("mousemove.brush", j, !0).on("mouseup.brush", z, !0);
            a && P.on("keydown.brush", U, !0).on("keyup.brush", q, !0), Se(le.view);
          }
          ni(), ar(m), u.call(m), I.start();
        }

        function j() {
          var t = O(m);
          !D || y || g || (Math.abs(t[0] - L[0]) > Math.abs(t[1] - L[1]) ? g = !0 : y = !0), L = t, p = !0, ri(), Y();
        }

        function Y() {
          var t;

          switch (M = L[0] - B[0], N = L[1] - B[1], b) {
            case ai:
            case ii:
              _ && (M = Math.max(E - n, Math.min(S - c, M)), i = n + M, h = c + M), x && (N = Math.max(C - o, Math.min(A - f, N)), s = o + N, d = f + N);
              break;

            case oi:
              _ < 0 ? (M = Math.max(E - n, Math.min(S - n, M)), i = n + M, h = c) : _ > 0 && (M = Math.max(E - c, Math.min(S - c, M)), i = n, h = c + M), x < 0 ? (N = Math.max(C - o, Math.min(A - o, N)), s = o + N, d = f) : x > 0 && (N = Math.max(C - f, Math.min(A - f, N)), s = o, d = f + N);
              break;

            case si:
              _ && (i = Math.max(E, Math.min(S, n - M * _)), h = Math.max(E, Math.min(S, c + M * _))), x && (s = Math.max(C, Math.min(A, o - N * x)), d = Math.max(C, Math.min(A, f + N * x)));
          }

          h < i && (_ *= -1, t = n, n = c, c = t, t = i, i = h, h = t, v in yi && F.attr("cursor", pi[v = yi[v]])), d < s && (x *= -1, t = o, o = f, f = t, t = s, s = d, d = t, v in gi && F.attr("cursor", pi[v = gi[v]])), w.selection && (T = w.selection), y && (i = T[0][0], h = T[1][0]), g && (s = T[0][1], d = T[1][1]), T[0][0] === i && T[0][1] === s && T[1][0] === h && T[1][1] === d || (w.selection = [[i, s], [h, d]], u.call(m), I.brush());
        }

        function z() {
          if (ni(), le.touches) {
            if (le.touches.length) return;
            e && clearTimeout(e), e = setTimeout(function () {
              e = null;
            }, 500);
          } else Ae(le.view, p), P.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);

          R.attr("pointer-events", "all"), F.attr("cursor", pi.overlay), w.selection && (T = w.selection), Ti(T) && (w.selection = null, u.call(m)), I.end();
        }

        function U() {
          switch (le.keyCode) {
            case 16:
              D = _ && x;
              break;

            case 18:
              b === oi && (_ && (c = h - M * _, n = i + M * _), x && (f = d - N * x, o = s + N * x), b = si, Y());
              break;

            case 32:
              b !== oi && b !== si || (_ < 0 ? c = h - M : _ > 0 && (n = i - M), x < 0 ? f = d - N : x > 0 && (o = s - N), b = ai, F.attr("cursor", pi.selection), Y());
              break;

            default:
              return;
          }

          ri();
        }

        function q() {
          switch (le.keyCode) {
            case 16:
              D && (y = g = D = !1, Y());
              break;

            case 18:
              b === si && (_ < 0 ? c = h : _ > 0 && (n = i), x < 0 ? f = d : x > 0 && (o = s), b = oi, Y());
              break;

            case 32:
              b === ai && (le.altKey ? (_ && (c = h - M * _, n = i + M * _), x && (f = d - N * x, o = s + N * x), b = si) : (_ < 0 ? c = h : _ > 0 && (n = i), x < 0 ? f = d : x > 0 && (o = s), b = oi), F.attr("cursor", pi[v]), Y());
              break;

            default:
              return;
          }

          ri();
        }
      }

      function d() {
        l(this, arguments).moved();
      }

      function p() {
        l(this, arguments).ended();
      }

      function y() {
        var e = this.__brush || {
          selection: null
        };
        return e.extent = ui(n.apply(this, arguments)), e.dim = t, e;
      }

      return c.move = function (e, n) {
        e.selection ? e.on("start.brush", function () {
          l(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function () {
          l(this, arguments).end();
        }).tween("brush", function () {
          var e = this,
              r = e.__brush,
              i = l(e, arguments),
              a = r.selection,
              o = t.input("function" == typeof n ? n.apply(this, arguments) : n, r.extent),
              s = Mn(a, o);

          function c(t) {
            r.selection = 1 === t && null === o ? null : s(t), u.call(e), i.brush();
          }

          return null !== a && null !== o ? c : c(1);
        }) : e.each(function () {
          var e = this,
              r = arguments,
              i = e.__brush,
              a = t.input("function" == typeof n ? n.apply(e, r) : n, i.extent),
              o = l(e, r).beforestart();
          ar(e), i.selection = null === a ? null : a, u.call(e), o.start().brush().end();
        });
      }, c.clear = function (t) {
        c.move(t, null);
      }, h.prototype = {
        beforestart: function beforestart() {
          return 1 == ++this.active && (this.state.emitter = this, this.starting = !0), this;
        },
        start: function start() {
          return this.starting ? (this.starting = !1, this.emit("start")) : this.emit("brush"), this;
        },
        brush: function brush() {
          return this.emit("brush"), this;
        },
        end: function end() {
          return 0 == --this.active && (delete this.state.emitter, this.emit("end")), this;
        },
        emit: function emit(e) {
          ge(new ei(c, e, t.output(this.state.selection)), o.apply, o, [e, this.that, this.args]);
        }
      }, c.extent = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : ti(ui(t)), c) : n;
      }, c.filter = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : ti(!!t), c) : r;
      }, c.touchable = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : ti(!!t), c) : i;
      }, c.handleSize = function (t) {
        return arguments.length ? (s = +t, c) : s;
      }, c.keyModifiers = function (t) {
        return arguments.length ? (a = !!t, c) : a;
      }, c.on = function () {
        var t = o.on.apply(o, arguments);
        return t === o ? c : t;
      }, c;
    }

    var Ni = Math.cos,
        Di = Math.sin,
        Oi = Math.PI,
        Bi = Oi / 2,
        Li = 2 * Oi,
        Ii = Math.max;

    function Ri(t) {
      return function (e, n) {
        return t(e.source.value + e.target.value, n.source.value + n.target.value);
      };
    }

    function Fi() {
      var t = 0,
          e = null,
          n = null,
          r = null;

      function i(i) {
        var a,
            o,
            s,
            c,
            u,
            l,
            h = i.length,
            f = [],
            d = k(h),
            p = [],
            y = [],
            g = y.groups = new Array(h),
            m = new Array(h * h);

        for (a = 0, u = -1; ++u < h;) {
          for (o = 0, l = -1; ++l < h;) {
            o += i[u][l];
          }

          f.push(o), p.push(k(h)), a += o;
        }

        for (e && d.sort(function (t, n) {
          return e(f[t], f[n]);
        }), n && p.forEach(function (t, e) {
          t.sort(function (t, r) {
            return n(i[e][t], i[e][r]);
          });
        }), c = (a = Ii(0, Li - t * h) / a) ? t : Li / h, o = 0, u = -1; ++u < h;) {
          for (s = o, l = -1; ++l < h;) {
            var v = d[u],
                b = p[v][l],
                _ = i[v][b],
                x = o,
                w = o += _ * a;
            m[b * h + v] = {
              index: v,
              subindex: b,
              startAngle: x,
              endAngle: w,
              value: _
            };
          }

          g[v] = {
            index: v,
            startAngle: s,
            endAngle: o,
            value: f[v]
          }, o += c;
        }

        for (u = -1; ++u < h;) {
          for (l = u - 1; ++l < h;) {
            var T = m[l * h + u],
                E = m[u * h + l];
            (T.value || E.value) && y.push(T.value < E.value ? {
              source: E,
              target: T
            } : {
              source: T,
              target: E
            });
          }
        }

        return r ? y.sort(r) : y;
      }

      return i.padAngle = function (e) {
        return arguments.length ? (t = Ii(0, e), i) : t;
      }, i.sortGroups = function (t) {
        return arguments.length ? (e = t, i) : e;
      }, i.sortSubgroups = function (t) {
        return arguments.length ? (n = t, i) : n;
      }, i.sortChords = function (t) {
        return arguments.length ? (null == t ? r = null : (r = Ri(t))._ = t, i) : r && r._;
      }, i;
    }

    var Pi = Array.prototype.slice;

    function ji(t) {
      return function () {
        return t;
      };
    }

    var Yi = Math.PI,
        zi = 2 * Yi,
        Ui = 1e-6,
        qi = zi - Ui;

    function Hi() {
      this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
    }

    function $i() {
      return new Hi();
    }

    Hi.prototype = $i.prototype = {
      constructor: Hi,
      moveTo: function moveTo(t, e) {
        this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
      },
      closePath: function closePath() {
        null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
      },
      lineTo: function lineTo(t, e) {
        this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
      },
      quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
        this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
      },
      bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
        this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
      },
      arcTo: function arcTo(t, e, n, r, i) {
        t = +t, e = +e, n = +n, r = +r, i = +i;
        var a = this._x1,
            o = this._y1,
            s = n - t,
            c = r - e,
            u = a - t,
            l = o - e,
            h = u * u + l * l;
        if (i < 0) throw new Error("negative radius: " + i);
        if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (h > Ui) if (Math.abs(l * s - c * u) > Ui && i) {
          var f = n - a,
              d = r - o,
              p = s * s + c * c,
              y = f * f + d * d,
              g = Math.sqrt(p),
              m = Math.sqrt(h),
              v = i * Math.tan((Yi - Math.acos((p + h - y) / (2 * g * m))) / 2),
              b = v / m,
              _ = v / g;

          Math.abs(b - 1) > Ui && (this._ += "L" + (t + b * u) + "," + (e + b * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > u * d) + "," + (this._x1 = t + _ * s) + "," + (this._y1 = e + _ * c);
        } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
      },
      arc: function arc(t, e, n, r, i, a) {
        t = +t, e = +e, a = !!a;
        var o = (n = +n) * Math.cos(r),
            s = n * Math.sin(r),
            c = t + o,
            u = e + s,
            l = 1 ^ a,
            h = a ? r - i : i - r;
        if (n < 0) throw new Error("negative radius: " + n);
        null === this._x1 ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > Ui || Math.abs(this._y1 - u) > Ui) && (this._ += "L" + c + "," + u), n && (h < 0 && (h = h % zi + zi), h > qi ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : h > Ui && (this._ += "A" + n + "," + n + ",0," + +(h >= Yi) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
      },
      rect: function rect(t, e, n, r) {
        this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
      },
      toString: function toString() {
        return this._;
      }
    };
    var Wi = $i;

    function Vi(t) {
      return t.source;
    }

    function Gi(t) {
      return t.target;
    }

    function Xi(t) {
      return t.radius;
    }

    function Zi(t) {
      return t.startAngle;
    }

    function Qi(t) {
      return t.endAngle;
    }

    function Ki() {
      var t = Vi,
          e = Gi,
          n = Xi,
          r = Zi,
          i = Qi,
          a = null;

      function o() {
        var o,
            s = Pi.call(arguments),
            c = t.apply(this, s),
            u = e.apply(this, s),
            l = +n.apply(this, (s[0] = c, s)),
            h = r.apply(this, s) - Bi,
            f = i.apply(this, s) - Bi,
            d = l * Ni(h),
            p = l * Di(h),
            y = +n.apply(this, (s[0] = u, s)),
            g = r.apply(this, s) - Bi,
            m = i.apply(this, s) - Bi;
        if (a || (a = o = Wi()), a.moveTo(d, p), a.arc(0, 0, l, h, f), h === g && f === m || (a.quadraticCurveTo(0, 0, y * Ni(g), y * Di(g)), a.arc(0, 0, y, g, m)), a.quadraticCurveTo(0, 0, d, p), a.closePath(), o) return a = null, o + "" || null;
      }

      return o.radius = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : ji(+t), o) : n;
      }, o.startAngle = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : ji(+t), o) : r;
      }, o.endAngle = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : ji(+t), o) : i;
      }, o.source = function (e) {
        return arguments.length ? (t = e, o) : t;
      }, o.target = function (t) {
        return arguments.length ? (e = t, o) : e;
      }, o.context = function (t) {
        return arguments.length ? (a = null == t ? null : t, o) : a;
      }, o;
    }

    var Ji = "$";

    function ta() {}

    function ea(t, e) {
      var n = new ta();
      if (t instanceof ta) t.each(function (t, e) {
        n.set(e, t);
      });else if (Array.isArray(t)) {
        var r,
            i = -1,
            a = t.length;
        if (null == e) for (; ++i < a;) {
          n.set(i, t[i]);
        } else for (; ++i < a;) {
          n.set(e(r = t[i], i, t), r);
        }
      } else if (t) for (var o in t) {
        n.set(o, t[o]);
      }
      return n;
    }

    ta.prototype = ea.prototype = {
      constructor: ta,
      has: function has(t) {
        return Ji + t in this;
      },
      get: function get(t) {
        return this[Ji + t];
      },
      set: function set(t, e) {
        return this[Ji + t] = e, this;
      },
      remove: function remove(t) {
        var e = Ji + t;
        return e in this && delete this[e];
      },
      clear: function clear() {
        for (var t in this) {
          t[0] === Ji && delete this[t];
        }
      },
      keys: function keys() {
        var t = [];

        for (var e in this) {
          e[0] === Ji && t.push(e.slice(1));
        }

        return t;
      },
      values: function values() {
        var t = [];

        for (var e in this) {
          e[0] === Ji && t.push(this[e]);
        }

        return t;
      },
      entries: function entries() {
        var t = [];

        for (var e in this) {
          e[0] === Ji && t.push({
            key: e.slice(1),
            value: this[e]
          });
        }

        return t;
      },
      size: function size() {
        var t = 0;

        for (var e in this) {
          e[0] === Ji && ++t;
        }

        return t;
      },
      empty: function empty() {
        for (var t in this) {
          if (t[0] === Ji) return !1;
        }

        return !0;
      },
      each: function each(t) {
        for (var e in this) {
          e[0] === Ji && t(this[e], e.slice(1), this);
        }
      }
    };
    var na = ea;

    function ra() {
      var t,
          e,
          n,
          r = [],
          i = [];

      function a(n, i, o, s) {
        if (i >= r.length) return null != t && n.sort(t), null != e ? e(n) : n;

        for (var c, u, l, h = -1, f = n.length, d = r[i++], p = na(), y = o(); ++h < f;) {
          (l = p.get(c = d(u = n[h]) + "")) ? l.push(u) : p.set(c, [u]);
        }

        return p.each(function (t, e) {
          s(y, e, a(t, i, o, s));
        }), y;
      }

      function o(t, n) {
        if (++n > r.length) return t;
        var a,
            s = i[n - 1];
        return null != e && n >= r.length ? a = t.entries() : (a = [], t.each(function (t, e) {
          a.push({
            key: e,
            values: o(t, n)
          });
        })), null != s ? a.sort(function (t, e) {
          return s(t.key, e.key);
        }) : a;
      }

      return n = {
        object: function object(t) {
          return a(t, 0, ia, aa);
        },
        map: function map(t) {
          return a(t, 0, oa, sa);
        },
        entries: function entries(t) {
          return o(a(t, 0, oa, sa), 0);
        },
        key: function key(t) {
          return r.push(t), n;
        },
        sortKeys: function sortKeys(t) {
          return i[r.length - 1] = t, n;
        },
        sortValues: function sortValues(e) {
          return t = e, n;
        },
        rollup: function rollup(t) {
          return e = t, n;
        }
      };
    }

    function ia() {
      return {};
    }

    function aa(t, e, n) {
      t[e] = n;
    }

    function oa() {
      return na();
    }

    function sa(t, e, n) {
      t.set(e, n);
    }

    function ca() {}

    var ua = na.prototype;

    function la(t, e) {
      var n = new ca();
      if (t instanceof ca) t.each(function (t) {
        n.add(t);
      });else if (t) {
        var r = -1,
            i = t.length;
        if (null == e) for (; ++r < i;) {
          n.add(t[r]);
        } else for (; ++r < i;) {
          n.add(e(t[r], r, t));
        }
      }
      return n;
    }

    ca.prototype = la.prototype = {
      constructor: ca,
      has: ua.has,
      add: function add(t) {
        return this[Ji + (t += "")] = t, this;
      },
      remove: ua.remove,
      clear: ua.clear,
      values: ua.keys,
      size: ua.size,
      empty: ua.empty,
      each: ua.each
    };
    var ha = la;

    function fa(t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e;
    }

    function da(t) {
      var e = [];

      for (var n in t) {
        e.push(t[n]);
      }

      return e;
    }

    function pa(t) {
      var e = [];

      for (var n in t) {
        e.push({
          key: n,
          value: t[n]
        });
      }

      return e;
    }

    var ya = Math.PI / 180,
        ga = 180 / Math.PI,
        ma = .96422,
        va = .82521,
        ba = 4 / 29,
        _a = 6 / 29,
        xa = 3 * _a * _a;

    function wa(t) {
      if (t instanceof Ea) return new Ea(t.l, t.a, t.b, t.opacity);
      if (t instanceof Ba) return La(t);
      t instanceof Ke || (t = Ze(t));
      var e,
          n,
          r = Ma(t.r),
          i = Ma(t.g),
          a = Ma(t.b),
          o = Ca((.2225045 * r + .7168786 * i + .0606169 * a) / 1);
      return r === i && i === a ? e = n = o : (e = Ca((.4360747 * r + .3850649 * i + .1430804 * a) / ma), n = Ca((.0139322 * r + .0971045 * i + .7141733 * a) / va)), new Ea(116 * o - 16, 500 * (e - o), 200 * (o - n), t.opacity);
    }

    function ka(t, e) {
      return new Ea(t, 0, 0, null == e ? 1 : e);
    }

    function Ta(t, e, n, r) {
      return 1 === arguments.length ? wa(t) : new Ea(t, e, n, null == r ? 1 : r);
    }

    function Ea(t, e, n, r) {
      this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
    }

    function Ca(t) {
      return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / xa + ba;
    }

    function Sa(t) {
      return t > _a ? t * t * t : xa * (t - ba);
    }

    function Aa(t) {
      return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
    }

    function Ma(t) {
      return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    }

    function Na(t) {
      if (t instanceof Ba) return new Ba(t.h, t.c, t.l, t.opacity);
      if (t instanceof Ea || (t = wa(t)), 0 === t.a && 0 === t.b) return new Ba(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
      var e = Math.atan2(t.b, t.a) * ga;
      return new Ba(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
    }

    function Da(t, e, n, r) {
      return 1 === arguments.length ? Na(t) : new Ba(n, e, t, null == r ? 1 : r);
    }

    function Oa(t, e, n, r) {
      return 1 === arguments.length ? Na(t) : new Ba(t, e, n, null == r ? 1 : r);
    }

    function Ba(t, e, n, r) {
      this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
    }

    function La(t) {
      if (isNaN(t.h)) return new Ea(t.l, 0, 0, t.opacity);
      var e = t.h * ya;
      return new Ea(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
    }

    Me(Ea, Ta, Ne(De, {
      brighter: function brighter(t) {
        return new Ea(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      darker: function darker(t) {
        return new Ea(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      rgb: function rgb() {
        var t = (this.l + 16) / 116,
            e = isNaN(this.a) ? t : t + this.a / 500,
            n = isNaN(this.b) ? t : t - this.b / 200;
        return new Ke(Aa(3.1338561 * (e = ma * Sa(e)) - 1.6168667 * (t = 1 * Sa(t)) - .4906146 * (n = va * Sa(n))), Aa(-.9787684 * e + 1.9161415 * t + .033454 * n), Aa(.0719453 * e - .2289914 * t + 1.4052427 * n), this.opacity);
      }
    })), Me(Ba, Oa, Ne(De, {
      brighter: function brighter(t) {
        return new Ba(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
      },
      darker: function darker(t) {
        return new Ba(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
      },
      rgb: function rgb() {
        return La(this).rgb();
      }
    }));
    var Ia = -.14861,
        Ra = 1.78277,
        Fa = -.29227,
        Pa = -.90649,
        ja = 1.97294,
        Ya = ja * Pa,
        za = ja * Ra,
        Ua = Ra * Fa - Pa * Ia;

    function qa(t) {
      if (t instanceof $a) return new $a(t.h, t.s, t.l, t.opacity);
      t instanceof Ke || (t = Ze(t));
      var e = t.r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = (Ua * r + Ya * e - za * n) / (Ua + Ya - za),
          a = r - i,
          o = (ja * (n - i) - Fa * a) / Pa,
          s = Math.sqrt(o * o + a * a) / (ja * i * (1 - i)),
          c = s ? Math.atan2(o, a) * ga - 120 : NaN;
      return new $a(c < 0 ? c + 360 : c, s, i, t.opacity);
    }

    function Ha(t, e, n, r) {
      return 1 === arguments.length ? qa(t) : new $a(t, e, n, null == r ? 1 : r);
    }

    function $a(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    Me($a, Ha, Ne(De, {
      brighter: function brighter(t) {
        return t = null == t ? Be : Math.pow(Be, t), new $a(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? Oe : Math.pow(Oe, t), new $a(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = isNaN(this.h) ? 0 : (this.h + 120) * ya,
            e = +this.l,
            n = isNaN(this.s) ? 0 : this.s * e * (1 - e),
            r = Math.cos(t),
            i = Math.sin(t);
        return new Ke(255 * (e + n * (Ia * r + Ra * i)), 255 * (e + n * (Fa * r + Pa * i)), 255 * (e + n * (ja * r)), this.opacity);
      }
    }));
    var Wa = Array.prototype.slice;

    function Va(t, e) {
      return t - e;
    }

    function Ga(t) {
      return function () {
        return t;
      };
    }

    function Xa(t, e) {
      for (var n, r = -1, i = e.length; ++r < i;) {
        if (n = Za(t, e[r])) return n;
      }

      return 0;
    }

    function Za(t, e) {
      for (var n = e[0], r = e[1], i = -1, a = 0, o = t.length, s = o - 1; a < o; s = a++) {
        var c = t[a],
            u = c[0],
            l = c[1],
            h = t[s],
            f = h[0],
            d = h[1];
        if (Qa(c, h, e)) return 0;
        l > r != d > r && n < (f - u) * (r - l) / (d - l) + u && (i = -i);
      }

      return i;
    }

    function Qa(t, e, n) {
      var r, i, a, o;
      return function (t, e, n) {
        return (e[0] - t[0]) * (n[1] - t[1]) == (n[0] - t[0]) * (e[1] - t[1]);
      }(t, e, n) && (i = t[r = +(t[0] === e[0])], a = n[r], o = e[r], i <= a && a <= o || o <= a && a <= i);
    }

    function Ka() {}

    var Ja = [[], [[[1, 1.5], [.5, 1]]], [[[1.5, 1], [1, 1.5]]], [[[1.5, 1], [.5, 1]]], [[[1, .5], [1.5, 1]]], [[[1, 1.5], [.5, 1]], [[1, .5], [1.5, 1]]], [[[1, .5], [1, 1.5]]], [[[1, .5], [.5, 1]]], [[[.5, 1], [1, .5]]], [[[1, 1.5], [1, .5]]], [[[.5, 1], [1, .5]], [[1.5, 1], [1, 1.5]]], [[[1.5, 1], [1, .5]]], [[[.5, 1], [1.5, 1]]], [[[1, 1.5], [1.5, 1]]], [[[.5, 1], [1, 1.5]]], []];

    function to() {
      var t = 1,
          e = 1,
          n = N,
          r = s;

      function i(t) {
        var e = n(t);
        if (Array.isArray(e)) e = e.slice().sort(Va);else {
          var r = m(t),
              i = r[0],
              o = r[1];
          e = M(i, o, e), e = k(Math.floor(i / e) * e, Math.floor(o / e) * e, e);
        }
        return e.map(function (e) {
          return a(t, e);
        });
      }

      function a(n, i) {
        var a = [],
            s = [];
        return function (n, r, i) {
          var a,
              s,
              c,
              u,
              l,
              h,
              f = new Array(),
              d = new Array();

          for (a = s = -1, u = n[0] >= r, Ja[u << 1].forEach(p); ++a < t - 1;) {
            c = u, u = n[a + 1] >= r, Ja[c | u << 1].forEach(p);
          }

          for (Ja[u << 0].forEach(p); ++s < e - 1;) {
            for (a = -1, u = n[s * t + t] >= r, l = n[s * t] >= r, Ja[u << 1 | l << 2].forEach(p); ++a < t - 1;) {
              c = u, u = n[s * t + t + a + 1] >= r, h = l, l = n[s * t + a + 1] >= r, Ja[c | u << 1 | l << 2 | h << 3].forEach(p);
            }

            Ja[u | l << 3].forEach(p);
          }

          for (a = -1, l = n[s * t] >= r, Ja[l << 2].forEach(p); ++a < t - 1;) {
            h = l, l = n[s * t + a + 1] >= r, Ja[l << 2 | h << 3].forEach(p);
          }

          function p(t) {
            var e,
                n,
                r = [t[0][0] + a, t[0][1] + s],
                c = [t[1][0] + a, t[1][1] + s],
                u = o(r),
                l = o(c);
            (e = d[u]) ? (n = f[l]) ? (delete d[e.end], delete f[n.start], e === n ? (e.ring.push(c), i(e.ring)) : f[e.start] = d[n.end] = {
              start: e.start,
              end: n.end,
              ring: e.ring.concat(n.ring)
            }) : (delete d[e.end], e.ring.push(c), d[e.end = l] = e) : (e = f[l]) ? (n = d[u]) ? (delete f[e.start], delete d[n.end], e === n ? (e.ring.push(c), i(e.ring)) : f[n.start] = d[e.end] = {
              start: n.start,
              end: e.end,
              ring: n.ring.concat(e.ring)
            }) : (delete f[e.start], e.ring.unshift(r), f[e.start = u] = e) : f[u] = d[l] = {
              start: u,
              end: l,
              ring: [r, c]
            };
          }

          Ja[l << 3].forEach(p);
        }(n, i, function (t) {
          r(t, n, i), function (t) {
            for (var e = 0, n = t.length, r = t[n - 1][1] * t[0][0] - t[n - 1][0] * t[0][1]; ++e < n;) {
              r += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
            }

            return r;
          }(t) > 0 ? a.push([t]) : s.push(t);
        }), s.forEach(function (t) {
          for (var e, n = 0, r = a.length; n < r; ++n) {
            if (-1 !== Xa((e = a[n])[0], t)) return void e.push(t);
          }
        }), {
          type: "MultiPolygon",
          value: i,
          coordinates: a
        };
      }

      function o(e) {
        return 2 * e[0] + e[1] * (t + 1) * 4;
      }

      function s(n, r, i) {
        n.forEach(function (n) {
          var a,
              o = n[0],
              s = n[1],
              c = 0 | o,
              u = 0 | s,
              l = r[u * t + c];
          o > 0 && o < t && c === o && (a = r[u * t + c - 1], n[0] = o + (i - a) / (l - a) - .5), s > 0 && s < e && u === s && (a = r[(u - 1) * t + c], n[1] = s + (i - a) / (l - a) - .5);
        });
      }

      return i.contour = a, i.size = function (n) {
        if (!arguments.length) return [t, e];
        var r = Math.ceil(n[0]),
            a = Math.ceil(n[1]);
        if (!(r > 0 && a > 0)) throw new Error("invalid size");
        return t = r, e = a, i;
      }, i.thresholds = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : Array.isArray(t) ? Ga(Wa.call(t)) : Ga(t), i) : n;
      }, i.smooth = function (t) {
        return arguments.length ? (r = t ? s : Ka, i) : r === s;
      }, i;
    }

    function eo(t, e, n) {
      for (var r = t.width, i = t.height, a = 1 + (n << 1), o = 0; o < i; ++o) {
        for (var s = 0, c = 0; s < r + n; ++s) {
          s < r && (c += t.data[s + o * r]), s >= n && (s >= a && (c -= t.data[s - a + o * r]), e.data[s - n + o * r] = c / Math.min(s + 1, r - 1 + a - s, a));
        }
      }
    }

    function no(t, e, n) {
      for (var r = t.width, i = t.height, a = 1 + (n << 1), o = 0; o < r; ++o) {
        for (var s = 0, c = 0; s < i + n; ++s) {
          s < i && (c += t.data[o + s * r]), s >= n && (s >= a && (c -= t.data[o + (s - a) * r]), e.data[o + (s - n) * r] = c / Math.min(s + 1, i - 1 + a - s, a));
        }
      }
    }

    function ro(t) {
      return t[0];
    }

    function io(t) {
      return t[1];
    }

    function ao() {
      return 1;
    }

    function oo() {
      var t = ro,
          e = io,
          n = ao,
          r = 960,
          i = 500,
          a = 20,
          o = 2,
          s = 3 * a,
          c = r + 2 * s >> o,
          u = i + 2 * s >> o,
          l = Ga(20);

      function h(r) {
        var i = new Float32Array(c * u),
            h = new Float32Array(c * u);
        r.forEach(function (r, a, l) {
          var h = +t(r, a, l) + s >> o,
              f = +e(r, a, l) + s >> o,
              d = +n(r, a, l);
          h >= 0 && h < c && f >= 0 && f < u && (i[h + f * c] += d);
        }), eo({
          width: c,
          height: u,
          data: i
        }, {
          width: c,
          height: u,
          data: h
        }, a >> o), no({
          width: c,
          height: u,
          data: h
        }, {
          width: c,
          height: u,
          data: i
        }, a >> o), eo({
          width: c,
          height: u,
          data: i
        }, {
          width: c,
          height: u,
          data: h
        }, a >> o), no({
          width: c,
          height: u,
          data: h
        }, {
          width: c,
          height: u,
          data: i
        }, a >> o), eo({
          width: c,
          height: u,
          data: i
        }, {
          width: c,
          height: u,
          data: h
        }, a >> o), no({
          width: c,
          height: u,
          data: h
        }, {
          width: c,
          height: u,
          data: i
        }, a >> o);
        var d = l(i);

        if (!Array.isArray(d)) {
          var p = I(i);
          d = M(0, p, d), (d = k(0, Math.floor(p / d) * d, d)).shift();
        }

        return to().thresholds(d).size([c, u])(i).map(f);
      }

      function f(t) {
        return t.value *= Math.pow(2, -2 * o), t.coordinates.forEach(d), t;
      }

      function d(t) {
        t.forEach(p);
      }

      function p(t) {
        t.forEach(y);
      }

      function y(t) {
        t[0] = t[0] * Math.pow(2, o) - s, t[1] = t[1] * Math.pow(2, o) - s;
      }

      function g() {
        return c = r + 2 * (s = 3 * a) >> o, u = i + 2 * s >> o, h;
      }

      return h.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ga(+e), h) : t;
      }, h.y = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Ga(+t), h) : e;
      }, h.weight = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : Ga(+t), h) : n;
      }, h.size = function (t) {
        if (!arguments.length) return [r, i];
        var e = Math.ceil(t[0]),
            n = Math.ceil(t[1]);
        if (!(e >= 0 || e >= 0)) throw new Error("invalid size");
        return r = e, i = n, g();
      }, h.cellSize = function (t) {
        if (!arguments.length) return 1 << o;
        if (!((t = +t) >= 1)) throw new Error("invalid cell size");
        return o = Math.floor(Math.log(t) / Math.LN2), g();
      }, h.thresholds = function (t) {
        return arguments.length ? (l = "function" == typeof t ? t : Array.isArray(t) ? Ga(Wa.call(t)) : Ga(t), h) : l;
      }, h.bandwidth = function (t) {
        if (!arguments.length) return Math.sqrt(a * (a + 1));
        if (!((t = +t) >= 0)) throw new Error("invalid bandwidth");
        return a = Math.round((Math.sqrt(4 * t * t + 1) - 1) / 2), g();
      }, h;
    }

    function so(t) {
      return function () {
        return t;
      };
    }

    function co(t, e, n, r, i, a, o, s, c, u) {
      this.target = t, this.type = e, this.subject = n, this.identifier = r, this.active = i, this.x = a, this.y = o, this.dx = s, this.dy = c, this._ = u;
    }

    function uo() {
      return !le.ctrlKey && !le.button;
    }

    function lo() {
      return this.parentNode;
    }

    function ho(t) {
      return null == t ? {
        x: le.x,
        y: le.y
      } : t;
    }

    function fo() {
      return navigator.maxTouchPoints || "ontouchstart" in this;
    }

    function po() {
      var t,
          e,
          n,
          r,
          i = uo,
          a = lo,
          o = ho,
          s = fo,
          c = {},
          u = ft("start", "drag", "end"),
          l = 0,
          h = 0;

      function f(t) {
        t.on("mousedown.drag", d).filter(s).on("touchstart.drag", g).on("touchmove.drag", m).on("touchend.drag touchcancel.drag", v).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
      }

      function d() {
        if (!r && i.apply(this, arguments)) {
          var o = b("mouse", a.apply(this, arguments), Bn, this, arguments);
          o && (Te(le.view).on("mousemove.drag", p, !0).on("mouseup.drag", y, !0), Se(le.view), Ee(), n = !1, t = le.clientX, e = le.clientY, o("start"));
        }
      }

      function p() {
        if (Ce(), !n) {
          var r = le.clientX - t,
              i = le.clientY - e;
          n = r * r + i * i > h;
        }

        c.mouse("drag");
      }

      function y() {
        Te(le.view).on("mousemove.drag mouseup.drag", null), Ae(le.view, n), Ce(), c.mouse("end");
      }

      function g() {
        if (i.apply(this, arguments)) {
          var t,
              e,
              n = le.changedTouches,
              r = a.apply(this, arguments),
              o = n.length;

          for (t = 0; t < o; ++t) {
            (e = b(n[t].identifier, r, On, this, arguments)) && (Ee(), e("start"));
          }
        }
      }

      function m() {
        var t,
            e,
            n = le.changedTouches,
            r = n.length;

        for (t = 0; t < r; ++t) {
          (e = c[n[t].identifier]) && (Ce(), e("drag"));
        }
      }

      function v() {
        var t,
            e,
            n = le.changedTouches,
            i = n.length;

        for (r && clearTimeout(r), r = setTimeout(function () {
          r = null;
        }, 500), t = 0; t < i; ++t) {
          (e = c[n[t].identifier]) && (Ee(), e("end"));
        }
      }

      function b(t, e, n, r, i) {
        var a,
            s,
            h,
            d = n(e, t),
            p = u.copy();
        if (ge(new co(f, "beforestart", a, t, l, d[0], d[1], 0, 0, p), function () {
          return null != (le.subject = a = o.apply(r, i)) && (s = a.x - d[0] || 0, h = a.y - d[1] || 0, !0);
        })) return function o(u) {
          var y,
              g = d;

          switch (u) {
            case "start":
              c[t] = o, y = l++;
              break;

            case "end":
              delete c[t], --l;

            case "drag":
              d = n(e, t), y = l;
          }

          ge(new co(f, u, a, t, y, d[0] + s, d[1] + h, d[0] - g[0], d[1] - g[1], p), p.apply, p, [u, r, i]);
        };
      }

      return f.filter = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : so(!!t), f) : i;
      }, f.container = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : so(t), f) : a;
      }, f.subject = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : so(t), f) : o;
      }, f.touchable = function (t) {
        return arguments.length ? (s = "function" == typeof t ? t : so(!!t), f) : s;
      }, f.on = function () {
        var t = u.on.apply(u, arguments);
        return t === u ? f : t;
      }, f.clickDistance = function (t) {
        return arguments.length ? (h = (t = +t) * t, f) : Math.sqrt(h);
      }, f;
    }

    co.prototype.on = function () {
      var t = this._.on.apply(this._, arguments);

      return t === this._ ? this : t;
    };

    var yo = {},
        go = {};

    function mo(t) {
      return new Function("d", "return {" + t.map(function (t, e) {
        return JSON.stringify(t) + ": d[" + e + '] || ""';
      }).join(",") + "}");
    }

    function vo(t) {
      var e = Object.create(null),
          n = [];
      return t.forEach(function (t) {
        for (var r in t) {
          r in e || n.push(e[r] = r);
        }
      }), n;
    }

    function bo(t, e) {
      var n = t + "",
          r = n.length;
      return r < e ? new Array(e - r + 1).join(0) + n : n;
    }

    function _o(t) {
      var e = new RegExp('["' + t + "\n\r]"),
          n = t.charCodeAt(0);

      function r(t, e) {
        var r,
            i = [],
            a = t.length,
            o = 0,
            s = 0,
            c = a <= 0,
            u = !1;

        function l() {
          if (c) return go;
          if (u) return u = !1, yo;
          var e,
              r,
              i = o;

          if (34 === t.charCodeAt(i)) {
            for (; o++ < a && 34 !== t.charCodeAt(o) || 34 === t.charCodeAt(++o);) {
              ;
            }

            return (e = o) >= a ? c = !0 : 10 === (r = t.charCodeAt(o++)) ? u = !0 : 13 === r && (u = !0, 10 === t.charCodeAt(o) && ++o), t.slice(i + 1, e - 1).replace(/""/g, '"');
          }

          for (; o < a;) {
            if (10 === (r = t.charCodeAt(e = o++))) u = !0;else if (13 === r) u = !0, 10 === t.charCodeAt(o) && ++o;else if (r !== n) continue;
            return t.slice(i, e);
          }

          return c = !0, t.slice(i, a);
        }

        for (10 === t.charCodeAt(a - 1) && --a, 13 === t.charCodeAt(a - 1) && --a; (r = l()) !== go;) {
          for (var h = []; r !== yo && r !== go;) {
            h.push(r), r = l();
          }

          e && null == (h = e(h, s++)) || i.push(h);
        }

        return i;
      }

      function i(e, n) {
        return e.map(function (e) {
          return n.map(function (t) {
            return o(e[t]);
          }).join(t);
        });
      }

      function a(e) {
        return e.map(o).join(t);
      }

      function o(t) {
        return null == t ? "" : t instanceof Date ? function (t) {
          var e = t.getUTCHours(),
              n = t.getUTCMinutes(),
              r = t.getUTCSeconds(),
              i = t.getUTCMilliseconds();
          return isNaN(t) ? "Invalid Date" : function (t) {
            return t < 0 ? "-" + bo(-t, 6) : t > 9999 ? "+" + bo(t, 6) : bo(t, 4);
          }(t.getUTCFullYear()) + "-" + bo(t.getUTCMonth() + 1, 2) + "-" + bo(t.getUTCDate(), 2) + (i ? "T" + bo(e, 2) + ":" + bo(n, 2) + ":" + bo(r, 2) + "." + bo(i, 3) + "Z" : r ? "T" + bo(e, 2) + ":" + bo(n, 2) + ":" + bo(r, 2) + "Z" : n || e ? "T" + bo(e, 2) + ":" + bo(n, 2) + "Z" : "");
        }(t) : e.test(t += "") ? '"' + t.replace(/"/g, '""') + '"' : t;
      }

      return {
        parse: function parse(t, e) {
          var n,
              i,
              a = r(t, function (t, r) {
            if (n) return n(t, r - 1);
            i = t, n = e ? function (t, e) {
              var n = mo(t);
              return function (r, i) {
                return e(n(r), i, t);
              };
            }(t, e) : mo(t);
          });
          return a.columns = i || [], a;
        },
        parseRows: r,
        format: function format(e, n) {
          return null == n && (n = vo(e)), [n.map(o).join(t)].concat(i(e, n)).join("\n");
        },
        formatBody: function formatBody(t, e) {
          return null == e && (e = vo(t)), i(t, e).join("\n");
        },
        formatRows: function formatRows(t) {
          return t.map(a).join("\n");
        },
        formatRow: a,
        formatValue: o
      };
    }

    var xo = _o(","),
        wo = xo.parse,
        ko = xo.parseRows,
        To = xo.format,
        Eo = xo.formatBody,
        Co = xo.formatRows,
        So = xo.formatRow,
        Ao = xo.formatValue,
        Mo = _o("\t"),
        No = Mo.parse,
        Do = Mo.parseRows,
        Oo = Mo.format,
        Bo = Mo.formatBody,
        Lo = Mo.formatRows,
        Io = Mo.formatRow,
        Ro = Mo.formatValue;

    function Fo(t) {
      for (var e in t) {
        var n,
            r,
            i = t[e].trim();
        if (i) {
          if ("true" === i) i = !0;else if ("false" === i) i = !1;else if ("NaN" === i) i = NaN;else if (isNaN(n = +i)) {
            if (!(r = i.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/))) continue;
            Po && r[4] && !r[7] && (i = i.replace(/-/g, "/").replace(/T/, " ")), i = new Date(i);
          } else i = n;
        } else i = null;
        t[e] = i;
      }

      return t;
    }

    var Po = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

    function jo(t) {
      return +t;
    }

    function Yo(t) {
      return t * t;
    }

    function zo(t) {
      return t * (2 - t);
    }

    function Uo(t) {
      return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
    }

    var qo = function t(e) {
      function n(t) {
        return Math.pow(t, e);
      }

      return e = +e, n.exponent = t, n;
    }(3),
        Ho = function t(e) {
      function n(t) {
        return 1 - Math.pow(1 - t, e);
      }

      return e = +e, n.exponent = t, n;
    }(3),
        $o = function t(e) {
      function n(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
      }

      return e = +e, n.exponent = t, n;
    }(3),
        Wo = Math.PI,
        Vo = Wo / 2;

    function Go(t) {
      return 1 == +t ? 1 : 1 - Math.cos(t * Vo);
    }

    function Xo(t) {
      return Math.sin(t * Vo);
    }

    function Zo(t) {
      return (1 - Math.cos(Wo * t)) / 2;
    }

    function Qo(t) {
      return 1.0009775171065494 * (Math.pow(2, -10 * t) - .0009765625);
    }

    function Ko(t) {
      return Qo(1 - +t);
    }

    function Jo(t) {
      return 1 - Qo(t);
    }

    function ts(t) {
      return ((t *= 2) <= 1 ? Qo(1 - t) : 2 - Qo(t - 1)) / 2;
    }

    function es(t) {
      return 1 - Math.sqrt(1 - t * t);
    }

    function ns(t) {
      return Math.sqrt(1 - --t * t);
    }

    function rs(t) {
      return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
    }

    var is = 7.5625;

    function as(t) {
      return 1 - os(1 - t);
    }

    function os(t) {
      return (t = +t) < .36363636363636365 ? is * t * t : t < .7272727272727273 ? is * (t -= .5454545454545454) * t + .75 : t < .9090909090909091 ? is * (t -= .8181818181818182) * t + .9375 : is * (t -= .9545454545454546) * t + .984375;
    }

    function ss(t) {
      return ((t *= 2) <= 1 ? 1 - os(1 - t) : os(t - 1) + 1) / 2;
    }

    var cs = 1.70158,
        us = function t(e) {
      function n(t) {
        return (t = +t) * t * (e * (t - 1) + t);
      }

      return e = +e, n.overshoot = t, n;
    }(cs),
        ls = function t(e) {
      function n(t) {
        return --t * t * ((t + 1) * e + t) + 1;
      }

      return e = +e, n.overshoot = t, n;
    }(cs),
        hs = function t(e) {
      function n(t) {
        return ((t *= 2) < 1 ? t * t * ((e + 1) * t - e) : (t -= 2) * t * ((e + 1) * t + e) + 2) / 2;
      }

      return e = +e, n.overshoot = t, n;
    }(cs),
        fs = 2 * Math.PI,
        ds = function t(e, n) {
      var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= fs);

      function i(t) {
        return e * Qo(- --t) * Math.sin((r - t) / n);
      }

      return i.amplitude = function (e) {
        return t(e, n * fs);
      }, i.period = function (n) {
        return t(e, n);
      }, i;
    }(1, .3),
        ps = function t(e, n) {
      var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= fs);

      function i(t) {
        return 1 - e * Qo(t = +t) * Math.sin((t + r) / n);
      }

      return i.amplitude = function (e) {
        return t(e, n * fs);
      }, i.period = function (n) {
        return t(e, n);
      }, i;
    }(1, .3),
        ys = function t(e, n) {
      var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= fs);

      function i(t) {
        return ((t = 2 * t - 1) < 0 ? e * Qo(-t) * Math.sin((r - t) / n) : 2 - e * Qo(t) * Math.sin((r + t) / n)) / 2;
      }

      return i.amplitude = function (e) {
        return t(e, n * fs);
      }, i.period = function (n) {
        return t(e, n);
      }, i;
    }(1, .3);

    function gs(t) {
      if (!t.ok) throw new Error(t.status + " " + t.statusText);
      return t.blob();
    }

    function ms(t, e) {
      return fetch(t, e).then(gs);
    }

    function vs(t) {
      if (!t.ok) throw new Error(t.status + " " + t.statusText);
      return t.arrayBuffer();
    }

    function bs(t, e) {
      return fetch(t, e).then(vs);
    }

    function _s(t) {
      if (!t.ok) throw new Error(t.status + " " + t.statusText);
      return t.text();
    }

    function xs(t, e) {
      return fetch(t, e).then(_s);
    }

    function ws(t) {
      return function (e, n, r) {
        return 2 === arguments.length && "function" == typeof n && (r = n, n = void 0), xs(e, n).then(function (e) {
          return t(e, r);
        });
      };
    }

    function ks(t, e, n, r) {
      3 === arguments.length && "function" == typeof n && (r = n, n = void 0);

      var i = _o(t);

      return xs(e, n).then(function (t) {
        return i.parse(t, r);
      });
    }

    var Ts = ws(wo),
        Es = ws(No);

    function Cs(t, e) {
      return new Promise(function (n, r) {
        var i = new Image();

        for (var a in e) {
          i[a] = e[a];
        }

        i.onerror = r, i.onload = function () {
          n(i);
        }, i.src = t;
      });
    }

    function Ss(t) {
      if (!t.ok) throw new Error(t.status + " " + t.statusText);
      if (204 !== t.status && 205 !== t.status) return t.json();
    }

    function As(t, e) {
      return fetch(t, e).then(Ss);
    }

    function Ms(t) {
      return function (e, n) {
        return xs(e, n).then(function (e) {
          return new DOMParser().parseFromString(e, t);
        });
      };
    }

    var Ns = Ms("application/xml");
    var Ds = Ms("text/html"),
        Os = Ms("image/svg+xml");

    function Bs(t, e) {
      var n;

      function r() {
        var r,
            i,
            a = n.length,
            o = 0,
            s = 0;

        for (r = 0; r < a; ++r) {
          o += (i = n[r]).x, s += i.y;
        }

        for (o = o / a - t, s = s / a - e, r = 0; r < a; ++r) {
          (i = n[r]).x -= o, i.y -= s;
        }
      }

      return null == t && (t = 0), null == e && (e = 0), r.initialize = function (t) {
        n = t;
      }, r.x = function (e) {
        return arguments.length ? (t = +e, r) : t;
      }, r.y = function (t) {
        return arguments.length ? (e = +t, r) : e;
      }, r;
    }

    function Ls(t) {
      return function () {
        return t;
      };
    }

    function Is() {
      return 1e-6 * (Math.random() - .5);
    }

    function Rs(t, e, n, r) {
      if (isNaN(e) || isNaN(n)) return t;
      var i,
          a,
          o,
          s,
          c,
          u,
          l,
          h,
          f,
          d = t._root,
          p = {
        data: r
      },
          y = t._x0,
          g = t._y0,
          m = t._x1,
          v = t._y1;
      if (!d) return t._root = p, t;

      for (; d.length;) {
        if ((u = e >= (a = (y + m) / 2)) ? y = a : m = a, (l = n >= (o = (g + v) / 2)) ? g = o : v = o, i = d, !(d = d[h = l << 1 | u])) return i[h] = p, t;
      }

      if (s = +t._x.call(null, d.data), c = +t._y.call(null, d.data), e === s && n === c) return p.next = d, i ? i[h] = p : t._root = p, t;

      do {
        i = i ? i[h] = new Array(4) : t._root = new Array(4), (u = e >= (a = (y + m) / 2)) ? y = a : m = a, (l = n >= (o = (g + v) / 2)) ? g = o : v = o;
      } while ((h = l << 1 | u) == (f = (c >= o) << 1 | s >= a));

      return i[f] = d, i[h] = p, t;
    }

    function Fs(t, e, n, r, i) {
      this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = i;
    }

    function Ps(t) {
      return t[0];
    }

    function js(t) {
      return t[1];
    }

    function Ys(t, e, n) {
      var r = new zs(null == e ? Ps : e, null == n ? js : n, NaN, NaN, NaN, NaN);
      return null == t ? r : r.addAll(t);
    }

    function zs(t, e, n, r, i, a) {
      this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this._root = void 0;
    }

    function Us(t) {
      for (var e = {
        data: t.data
      }, n = e; t = t.next;) {
        n = n.next = {
          data: t.data
        };
      }

      return e;
    }

    var qs = Ys.prototype = zs.prototype;

    function Hs(t) {
      return t.x + t.vx;
    }

    function $s(t) {
      return t.y + t.vy;
    }

    function Ws(t) {
      var e,
          n,
          r = 1,
          i = 1;

      function a() {
        for (var t, a, s, c, u, l, h, f = e.length, d = 0; d < i; ++d) {
          for (a = Ys(e, Hs, $s).visitAfter(o), t = 0; t < f; ++t) {
            s = e[t], l = n[s.index], h = l * l, c = s.x + s.vx, u = s.y + s.vy, a.visit(p);
          }
        }

        function p(t, e, n, i, a) {
          var o = t.data,
              f = t.r,
              d = l + f;
          if (!o) return e > c + d || i < c - d || n > u + d || a < u - d;

          if (o.index > s.index) {
            var p = c - o.x - o.vx,
                y = u - o.y - o.vy,
                g = p * p + y * y;
            g < d * d && (0 === p && (g += (p = Is()) * p), 0 === y && (g += (y = Is()) * y), g = (d - (g = Math.sqrt(g))) / g * r, s.vx += (p *= g) * (d = (f *= f) / (h + f)), s.vy += (y *= g) * d, o.vx -= p * (d = 1 - d), o.vy -= y * d);
          }
        }
      }

      function o(t) {
        if (t.data) return t.r = n[t.data.index];

        for (var e = t.r = 0; e < 4; ++e) {
          t[e] && t[e].r > t.r && (t.r = t[e].r);
        }
      }

      function s() {
        if (e) {
          var r,
              i,
              a = e.length;

          for (n = new Array(a), r = 0; r < a; ++r) {
            i = e[r], n[i.index] = +t(i, r, e);
          }
        }
      }

      return "function" != typeof t && (t = Ls(null == t ? 1 : +t)), a.initialize = function (t) {
        e = t, s();
      }, a.iterations = function (t) {
        return arguments.length ? (i = +t, a) : i;
      }, a.strength = function (t) {
        return arguments.length ? (r = +t, a) : r;
      }, a.radius = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ls(+e), s(), a) : t;
      }, a;
    }

    function Vs(t) {
      return t.index;
    }

    function Gs(t, e) {
      var n = t.get(e);
      if (!n) throw new Error("missing: " + e);
      return n;
    }

    function Xs(t) {
      var e,
          n,
          r,
          i,
          a,
          o = Vs,
          s = function s(t) {
        return 1 / Math.min(i[t.source.index], i[t.target.index]);
      },
          c = Ls(30),
          u = 1;

      function l(r) {
        for (var i = 0, o = t.length; i < u; ++i) {
          for (var s, c, l, h, f, d, p, y = 0; y < o; ++y) {
            c = (s = t[y]).source, h = (l = s.target).x + l.vx - c.x - c.vx || Is(), f = l.y + l.vy - c.y - c.vy || Is(), h *= d = ((d = Math.sqrt(h * h + f * f)) - n[y]) / d * r * e[y], f *= d, l.vx -= h * (p = a[y]), l.vy -= f * p, c.vx += h * (p = 1 - p), c.vy += f * p;
          }
        }
      }

      function h() {
        if (r) {
          var s,
              c,
              u = r.length,
              l = t.length,
              h = na(r, o);

          for (s = 0, i = new Array(u); s < l; ++s) {
            (c = t[s]).index = s, "object" != _typeof(c.source) && (c.source = Gs(h, c.source)), "object" != _typeof(c.target) && (c.target = Gs(h, c.target)), i[c.source.index] = (i[c.source.index] || 0) + 1, i[c.target.index] = (i[c.target.index] || 0) + 1;
          }

          for (s = 0, a = new Array(l); s < l; ++s) {
            c = t[s], a[s] = i[c.source.index] / (i[c.source.index] + i[c.target.index]);
          }

          e = new Array(l), f(), n = new Array(l), d();
        }
      }

      function f() {
        if (r) for (var n = 0, i = t.length; n < i; ++n) {
          e[n] = +s(t[n], n, t);
        }
      }

      function d() {
        if (r) for (var e = 0, i = t.length; e < i; ++e) {
          n[e] = +c(t[e], e, t);
        }
      }

      return null == t && (t = []), l.initialize = function (t) {
        r = t, h();
      }, l.links = function (e) {
        return arguments.length ? (t = e, h(), l) : t;
      }, l.id = function (t) {
        return arguments.length ? (o = t, l) : o;
      }, l.iterations = function (t) {
        return arguments.length ? (u = +t, l) : u;
      }, l.strength = function (t) {
        return arguments.length ? (s = "function" == typeof t ? t : Ls(+t), f(), l) : s;
      }, l.distance = function (t) {
        return arguments.length ? (c = "function" == typeof t ? t : Ls(+t), d(), l) : c;
      }, l;
    }

    function Zs(t) {
      return t.x;
    }

    function Qs(t) {
      return t.y;
    }

    qs.copy = function () {
      var t,
          e,
          n = new zs(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
          r = this._root;
      if (!r) return n;
      if (!r.length) return n._root = Us(r), n;

      for (t = [{
        source: r,
        target: n._root = new Array(4)
      }]; r = t.pop();) {
        for (var i = 0; i < 4; ++i) {
          (e = r.source[i]) && (e.length ? t.push({
            source: e,
            target: r.target[i] = new Array(4)
          }) : r.target[i] = Us(e));
        }
      }

      return n;
    }, qs.add = function (t) {
      var e = +this._x.call(null, t),
          n = +this._y.call(null, t);
      return Rs(this.cover(e, n), e, n, t);
    }, qs.addAll = function (t) {
      var e,
          n,
          r,
          i,
          a = t.length,
          o = new Array(a),
          s = new Array(a),
          c = 1 / 0,
          u = 1 / 0,
          l = -1 / 0,
          h = -1 / 0;

      for (n = 0; n < a; ++n) {
        isNaN(r = +this._x.call(null, e = t[n])) || isNaN(i = +this._y.call(null, e)) || (o[n] = r, s[n] = i, r < c && (c = r), r > l && (l = r), i < u && (u = i), i > h && (h = i));
      }

      if (c > l || u > h) return this;

      for (this.cover(c, u).cover(l, h), n = 0; n < a; ++n) {
        Rs(this, o[n], s[n], t[n]);
      }

      return this;
    }, qs.cover = function (t, e) {
      if (isNaN(t = +t) || isNaN(e = +e)) return this;
      var n = this._x0,
          r = this._y0,
          i = this._x1,
          a = this._y1;
      if (isNaN(n)) i = (n = Math.floor(t)) + 1, a = (r = Math.floor(e)) + 1;else {
        for (var o, s, c = i - n, u = this._root; n > t || t >= i || r > e || e >= a;) {
          switch (s = (e < r) << 1 | t < n, (o = new Array(4))[s] = u, u = o, c *= 2, s) {
            case 0:
              i = n + c, a = r + c;
              break;

            case 1:
              n = i - c, a = r + c;
              break;

            case 2:
              i = n + c, r = a - c;
              break;

            case 3:
              n = i - c, r = a - c;
          }
        }

        this._root && this._root.length && (this._root = u);
      }
      return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this;
    }, qs.data = function () {
      var t = [];
      return this.visit(function (e) {
        if (!e.length) do {
          t.push(e.data);
        } while (e = e.next);
      }), t;
    }, qs.extent = function (t) {
      return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
    }, qs.find = function (t, e, n) {
      var r,
          i,
          a,
          o,
          s,
          c,
          u,
          l = this._x0,
          h = this._y0,
          f = this._x1,
          d = this._y1,
          p = [],
          y = this._root;

      for (y && p.push(new Fs(y, l, h, f, d)), null == n ? n = 1 / 0 : (l = t - n, h = e - n, f = t + n, d = e + n, n *= n); c = p.pop();) {
        if (!(!(y = c.node) || (i = c.x0) > f || (a = c.y0) > d || (o = c.x1) < l || (s = c.y1) < h)) if (y.length) {
          var g = (i + o) / 2,
              m = (a + s) / 2;
          p.push(new Fs(y[3], g, m, o, s), new Fs(y[2], i, m, g, s), new Fs(y[1], g, a, o, m), new Fs(y[0], i, a, g, m)), (u = (e >= m) << 1 | t >= g) && (c = p[p.length - 1], p[p.length - 1] = p[p.length - 1 - u], p[p.length - 1 - u] = c);
        } else {
          var v = t - +this._x.call(null, y.data),
              b = e - +this._y.call(null, y.data),
              _ = v * v + b * b;

          if (_ < n) {
            var x = Math.sqrt(n = _);
            l = t - x, h = e - x, f = t + x, d = e + x, r = y.data;
          }
        }
      }

      return r;
    }, qs.remove = function (t) {
      if (isNaN(a = +this._x.call(null, t)) || isNaN(o = +this._y.call(null, t))) return this;
      var e,
          n,
          r,
          i,
          a,
          o,
          s,
          c,
          u,
          l,
          h,
          f,
          d = this._root,
          p = this._x0,
          y = this._y0,
          g = this._x1,
          m = this._y1;
      if (!d) return this;
      if (d.length) for (;;) {
        if ((u = a >= (s = (p + g) / 2)) ? p = s : g = s, (l = o >= (c = (y + m) / 2)) ? y = c : m = c, e = d, !(d = d[h = l << 1 | u])) return this;
        if (!d.length) break;
        (e[h + 1 & 3] || e[h + 2 & 3] || e[h + 3 & 3]) && (n = e, f = h);
      }

      for (; d.data !== t;) {
        if (r = d, !(d = d.next)) return this;
      }

      return (i = d.next) && delete d.next, r ? (i ? r.next = i : delete r.next, this) : e ? (i ? e[h] = i : delete e[h], (d = e[0] || e[1] || e[2] || e[3]) && d === (e[3] || e[2] || e[1] || e[0]) && !d.length && (n ? n[f] = d : this._root = d), this) : (this._root = i, this);
    }, qs.removeAll = function (t) {
      for (var e = 0, n = t.length; e < n; ++e) {
        this.remove(t[e]);
      }

      return this;
    }, qs.root = function () {
      return this._root;
    }, qs.size = function () {
      var t = 0;
      return this.visit(function (e) {
        if (!e.length) do {
          ++t;
        } while (e = e.next);
      }), t;
    }, qs.visit = function (t) {
      var e,
          n,
          r,
          i,
          a,
          o,
          s = [],
          c = this._root;

      for (c && s.push(new Fs(c, this._x0, this._y0, this._x1, this._y1)); e = s.pop();) {
        if (!t(c = e.node, r = e.x0, i = e.y0, a = e.x1, o = e.y1) && c.length) {
          var u = (r + a) / 2,
              l = (i + o) / 2;
          (n = c[3]) && s.push(new Fs(n, u, l, a, o)), (n = c[2]) && s.push(new Fs(n, r, l, u, o)), (n = c[1]) && s.push(new Fs(n, u, i, a, l)), (n = c[0]) && s.push(new Fs(n, r, i, u, l));
        }
      }

      return this;
    }, qs.visitAfter = function (t) {
      var e,
          n = [],
          r = [];

      for (this._root && n.push(new Fs(this._root, this._x0, this._y0, this._x1, this._y1)); e = n.pop();) {
        var i = e.node;

        if (i.length) {
          var a,
              o = e.x0,
              s = e.y0,
              c = e.x1,
              u = e.y1,
              l = (o + c) / 2,
              h = (s + u) / 2;
          (a = i[0]) && n.push(new Fs(a, o, s, l, h)), (a = i[1]) && n.push(new Fs(a, l, s, c, h)), (a = i[2]) && n.push(new Fs(a, o, h, l, u)), (a = i[3]) && n.push(new Fs(a, l, h, c, u));
        }

        r.push(e);
      }

      for (; e = r.pop();) {
        t(e.node, e.x0, e.y0, e.x1, e.y1);
      }

      return this;
    }, qs.x = function (t) {
      return arguments.length ? (this._x = t, this) : this._x;
    }, qs.y = function (t) {
      return arguments.length ? (this._y = t, this) : this._y;
    };
    var Ks = Math.PI * (3 - Math.sqrt(5));

    function Js(t) {
      var e,
          n = 1,
          r = .001,
          i = 1 - Math.pow(r, 1 / 300),
          a = 0,
          o = .6,
          s = na(),
          c = Vn(l),
          u = ft("tick", "end");

      function l() {
        h(), u.call("tick", e), n < r && (c.stop(), u.call("end", e));
      }

      function h(r) {
        var c,
            u,
            l = t.length;
        void 0 === r && (r = 1);

        for (var h = 0; h < r; ++h) {
          for (n += (a - n) * i, s.each(function (t) {
            t(n);
          }), c = 0; c < l; ++c) {
            null == (u = t[c]).fx ? u.x += u.vx *= o : (u.x = u.fx, u.vx = 0), null == u.fy ? u.y += u.vy *= o : (u.y = u.fy, u.vy = 0);
          }
        }

        return e;
      }

      function f() {
        for (var e, n = 0, r = t.length; n < r; ++n) {
          if ((e = t[n]).index = n, null != e.fx && (e.x = e.fx), null != e.fy && (e.y = e.fy), isNaN(e.x) || isNaN(e.y)) {
            var i = 10 * Math.sqrt(n),
                a = n * Ks;
            e.x = i * Math.cos(a), e.y = i * Math.sin(a);
          }

          (isNaN(e.vx) || isNaN(e.vy)) && (e.vx = e.vy = 0);
        }
      }

      function d(e) {
        return e.initialize && e.initialize(t), e;
      }

      return null == t && (t = []), f(), e = {
        tick: h,
        restart: function restart() {
          return c.restart(l), e;
        },
        stop: function stop() {
          return c.stop(), e;
        },
        nodes: function nodes(n) {
          return arguments.length ? (t = n, f(), s.each(d), e) : t;
        },
        alpha: function alpha(t) {
          return arguments.length ? (n = +t, e) : n;
        },
        alphaMin: function alphaMin(t) {
          return arguments.length ? (r = +t, e) : r;
        },
        alphaDecay: function alphaDecay(t) {
          return arguments.length ? (i = +t, e) : +i;
        },
        alphaTarget: function alphaTarget(t) {
          return arguments.length ? (a = +t, e) : a;
        },
        velocityDecay: function velocityDecay(t) {
          return arguments.length ? (o = 1 - t, e) : 1 - o;
        },
        force: function force(t, n) {
          return arguments.length > 1 ? (null == n ? s.remove(t) : s.set(t, d(n)), e) : s.get(t);
        },
        find: function find(e, n, r) {
          var i,
              a,
              o,
              s,
              c,
              u = 0,
              l = t.length;

          for (null == r ? r = 1 / 0 : r *= r, u = 0; u < l; ++u) {
            (o = (i = e - (s = t[u]).x) * i + (a = n - s.y) * a) < r && (c = s, r = o);
          }

          return c;
        },
        on: function on(t, n) {
          return arguments.length > 1 ? (u.on(t, n), e) : u.on(t);
        }
      };
    }

    function tc() {
      var t,
          e,
          n,
          r,
          i = Ls(-30),
          a = 1,
          o = 1 / 0,
          s = .81;

      function c(r) {
        var i,
            a = t.length,
            o = Ys(t, Zs, Qs).visitAfter(l);

        for (n = r, i = 0; i < a; ++i) {
          e = t[i], o.visit(h);
        }
      }

      function u() {
        if (t) {
          var e,
              n,
              a = t.length;

          for (r = new Array(a), e = 0; e < a; ++e) {
            n = t[e], r[n.index] = +i(n, e, t);
          }
        }
      }

      function l(t) {
        var e,
            n,
            i,
            a,
            o,
            s = 0,
            c = 0;

        if (t.length) {
          for (i = a = o = 0; o < 4; ++o) {
            (e = t[o]) && (n = Math.abs(e.value)) && (s += e.value, c += n, i += n * e.x, a += n * e.y);
          }

          t.x = i / c, t.y = a / c;
        } else {
          (e = t).x = e.data.x, e.y = e.data.y;

          do {
            s += r[e.data.index];
          } while (e = e.next);
        }

        t.value = s;
      }

      function h(t, i, c, u) {
        if (!t.value) return !0;
        var l = t.x - e.x,
            h = t.y - e.y,
            f = u - i,
            d = l * l + h * h;
        if (f * f / s < d) return d < o && (0 === l && (d += (l = Is()) * l), 0 === h && (d += (h = Is()) * h), d < a && (d = Math.sqrt(a * d)), e.vx += l * t.value * n / d, e.vy += h * t.value * n / d), !0;

        if (!(t.length || d >= o)) {
          (t.data !== e || t.next) && (0 === l && (d += (l = Is()) * l), 0 === h && (d += (h = Is()) * h), d < a && (d = Math.sqrt(a * d)));

          do {
            t.data !== e && (f = r[t.data.index] * n / d, e.vx += l * f, e.vy += h * f);
          } while (t = t.next);
        }
      }

      return c.initialize = function (e) {
        t = e, u();
      }, c.strength = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : Ls(+t), u(), c) : i;
      }, c.distanceMin = function (t) {
        return arguments.length ? (a = t * t, c) : Math.sqrt(a);
      }, c.distanceMax = function (t) {
        return arguments.length ? (o = t * t, c) : Math.sqrt(o);
      }, c.theta = function (t) {
        return arguments.length ? (s = t * t, c) : Math.sqrt(s);
      }, c;
    }

    function ec(t, e, n) {
      var r,
          i,
          a,
          o = Ls(.1);

      function s(t) {
        for (var o = 0, s = r.length; o < s; ++o) {
          var c = r[o],
              u = c.x - e || 1e-6,
              l = c.y - n || 1e-6,
              h = Math.sqrt(u * u + l * l),
              f = (a[o] - h) * i[o] * t / h;
          c.vx += u * f, c.vy += l * f;
        }
      }

      function c() {
        if (r) {
          var e,
              n = r.length;

          for (i = new Array(n), a = new Array(n), e = 0; e < n; ++e) {
            a[e] = +t(r[e], e, r), i[e] = isNaN(a[e]) ? 0 : +o(r[e], e, r);
          }
        }
      }

      return "function" != typeof t && (t = Ls(+t)), null == e && (e = 0), null == n && (n = 0), s.initialize = function (t) {
        r = t, c();
      }, s.strength = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : Ls(+t), c(), s) : o;
      }, s.radius = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ls(+e), c(), s) : t;
      }, s.x = function (t) {
        return arguments.length ? (e = +t, s) : e;
      }, s.y = function (t) {
        return arguments.length ? (n = +t, s) : n;
      }, s;
    }

    function nc(t) {
      var e,
          n,
          r,
          i = Ls(.1);

      function a(t) {
        for (var i, a = 0, o = e.length; a < o; ++a) {
          (i = e[a]).vx += (r[a] - i.x) * n[a] * t;
        }
      }

      function o() {
        if (e) {
          var a,
              o = e.length;

          for (n = new Array(o), r = new Array(o), a = 0; a < o; ++a) {
            n[a] = isNaN(r[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
          }
        }
      }

      return "function" != typeof t && (t = Ls(null == t ? 0 : +t)), a.initialize = function (t) {
        e = t, o();
      }, a.strength = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : Ls(+t), o(), a) : i;
      }, a.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ls(+e), o(), a) : t;
      }, a;
    }

    function rc(t) {
      var e,
          n,
          r,
          i = Ls(.1);

      function a(t) {
        for (var i, a = 0, o = e.length; a < o; ++a) {
          (i = e[a]).vy += (r[a] - i.y) * n[a] * t;
        }
      }

      function o() {
        if (e) {
          var a,
              o = e.length;

          for (n = new Array(o), r = new Array(o), a = 0; a < o; ++a) {
            n[a] = isNaN(r[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
          }
        }
      }

      return "function" != typeof t && (t = Ls(null == t ? 0 : +t)), a.initialize = function (t) {
        e = t, o();
      }, a.strength = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : Ls(+t), o(), a) : i;
      }, a.y = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ls(+e), o(), a) : t;
      }, a;
    }

    function ic(t, e) {
      if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
      var n,
          r = t.slice(0, n);
      return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
    }

    function ac(t) {
      return (t = ic(Math.abs(t))) ? t[1] : NaN;
    }

    var oc,
        sc = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

    function cc(t) {
      if (!(e = sc.exec(t))) throw new Error("invalid format: " + t);
      var e;
      return new uc({
        fill: e[1],
        align: e[2],
        sign: e[3],
        symbol: e[4],
        zero: e[5],
        width: e[6],
        comma: e[7],
        precision: e[8] && e[8].slice(1),
        trim: e[9],
        type: e[10]
      });
    }

    function uc(t) {
      this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
    }

    function lc(t, e) {
      var n = ic(t, e);
      if (!n) return t + "";
      var r = n[0],
          i = n[1];
      return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
    }

    cc.prototype = uc.prototype, uc.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    };
    var hc = {
      "%": function _(t, e) {
        return (100 * t).toFixed(e);
      },
      b: function b(t) {
        return Math.round(t).toString(2);
      },
      c: function c(t) {
        return t + "";
      },
      d: function d(t) {
        return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
      },
      e: function e(t, _e10) {
        return t.toExponential(_e10);
      },
      f: function f(t, e) {
        return t.toFixed(e);
      },
      g: function g(t, e) {
        return t.toPrecision(e);
      },
      o: function o(t) {
        return Math.round(t).toString(8);
      },
      p: function p(t, e) {
        return lc(100 * t, e);
      },
      r: lc,
      s: function s(t, e) {
        var n = ic(t, e);
        if (!n) return t + "";
        var r = n[0],
            i = n[1],
            a = i - (oc = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
            o = r.length;
        return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + ic(t, Math.max(0, e + a - 1))[0];
      },
      X: function X(t) {
        return Math.round(t).toString(16).toUpperCase();
      },
      x: function x(t) {
        return Math.round(t).toString(16);
      }
    };

    function fc(t) {
      return t;
    }

    var dc,
        pc,
        yc,
        gc = Array.prototype.map,
        mc = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

    function vc(t) {
      var e,
          n,
          r = void 0 === t.grouping || void 0 === t.thousands ? fc : (e = gc.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
        for (var i = t.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(t.substring(i -= s, i + s)), !((c += s + 1) > r));) {
          s = e[o = (o + 1) % e.length];
        }

        return a.reverse().join(n);
      }),
          i = void 0 === t.currency ? "" : t.currency[0] + "",
          a = void 0 === t.currency ? "" : t.currency[1] + "",
          o = void 0 === t.decimal ? "." : t.decimal + "",
          s = void 0 === t.numerals ? fc : function (t) {
        return function (e) {
          return e.replace(/[0-9]/g, function (e) {
            return t[+e];
          });
        };
      }(gc.call(t.numerals, String)),
          c = void 0 === t.percent ? "%" : t.percent + "",
          u = void 0 === t.minus ? "-" : t.minus + "",
          l = void 0 === t.nan ? "NaN" : t.nan + "";

      function h(t) {
        var e = (t = cc(t)).fill,
            n = t.align,
            h = t.sign,
            f = t.symbol,
            d = t.zero,
            p = t.width,
            y = t.comma,
            g = t.precision,
            m = t.trim,
            v = t.type;
        "n" === v ? (y = !0, v = "g") : hc[v] || (void 0 === g && (g = 12), m = !0, v = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");

        var b = "$" === f ? i : "#" === f && /[boxX]/.test(v) ? "0" + v.toLowerCase() : "",
            _ = "$" === f ? a : /[%p]/.test(v) ? c : "",
            x = hc[v],
            w = /[defgprs%]/.test(v);

        function k(t) {
          var i,
              a,
              c,
              f = b,
              k = _;
          if ("c" === v) k = x(t) + k, t = "";else {
            var T = (t = +t) < 0 || 1 / t < 0;
            if (t = isNaN(t) ? l : x(Math.abs(t), g), m && (t = function (t) {
              t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
                switch (t[r]) {
                  case ".":
                    i = e = r;
                    break;

                  case "0":
                    0 === i && (i = r), e = r;
                    break;

                  default:
                    if (!+t[r]) break t;
                    i > 0 && (i = 0);
                }
              }

              return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
            }(t)), T && 0 == +t && "+" !== h && (T = !1), f = (T ? "(" === h ? h : u : "-" === h || "(" === h ? "" : h) + f, k = ("s" === v ? mc[8 + oc / 3] : "") + k + (T && "(" === h ? ")" : ""), w) for (i = -1, a = t.length; ++i < a;) {
              if (48 > (c = t.charCodeAt(i)) || c > 57) {
                k = (46 === c ? o + t.slice(i + 1) : t.slice(i)) + k, t = t.slice(0, i);
                break;
              }
            }
          }
          y && !d && (t = r(t, 1 / 0));
          var E = f.length + t.length + k.length,
              C = E < p ? new Array(p - E + 1).join(e) : "";

          switch (y && d && (t = r(C + t, C.length ? p - k.length : 1 / 0), C = ""), n) {
            case "<":
              t = f + t + k + C;
              break;

            case "=":
              t = f + C + t + k;
              break;

            case "^":
              t = C.slice(0, E = C.length >> 1) + f + t + k + C.slice(E);
              break;

            default:
              t = C + f + t + k;
          }

          return s(t);
        }

        return g = void 0 === g ? 6 : /[gprs]/.test(v) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), k.toString = function () {
          return t + "";
        }, k;
      }

      return {
        format: h,
        formatPrefix: function formatPrefix(t, e) {
          var n = h(((t = cc(t)).type = "f", t)),
              r = 3 * Math.max(-8, Math.min(8, Math.floor(ac(e) / 3))),
              i = Math.pow(10, -r),
              a = mc[8 + r / 3];
          return function (t) {
            return n(i * t) + a;
          };
        }
      };
    }

    function bc(t) {
      return dc = vc(t), pc = dc.format, yc = dc.formatPrefix, dc;
    }

    function _c(t) {
      return Math.max(0, -ac(Math.abs(t)));
    }

    function xc(t, e) {
      return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(ac(e) / 3))) - ac(Math.abs(t)));
    }

    function wc(t, e) {
      return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, ac(e) - ac(t)) + 1;
    }

    function kc() {
      return new Tc();
    }

    function Tc() {
      this.reset();
    }

    bc({
      decimal: ".",
      thousands: ",",
      grouping: [3],
      currency: ["$", ""],
      minus: "-"
    }), Tc.prototype = {
      constructor: Tc,
      reset: function reset() {
        this.s = this.t = 0;
      },
      add: function add(t) {
        Cc(Ec, t, this.t), Cc(this, Ec.s, this.s), this.s ? this.t += Ec.t : this.s = Ec.t;
      },
      valueOf: function valueOf() {
        return this.s;
      }
    };
    var Ec = new Tc();

    function Cc(t, e, n) {
      var r = t.s = e + n,
          i = r - e,
          a = r - i;
      t.t = e - a + (n - i);
    }

    var Sc = 1e-6,
        Ac = 1e-12,
        Mc = Math.PI,
        Nc = Mc / 2,
        Dc = Mc / 4,
        Oc = 2 * Mc,
        Bc = 180 / Mc,
        Lc = Mc / 180,
        Ic = Math.abs,
        Rc = Math.atan,
        Fc = Math.atan2,
        Pc = Math.cos,
        jc = Math.ceil,
        Yc = Math.exp,
        zc = Math.log,
        Uc = Math.pow,
        qc = Math.sin,
        Hc = Math.sign || function (t) {
      return t > 0 ? 1 : t < 0 ? -1 : 0;
    },
        $c = Math.sqrt,
        Wc = Math.tan;

    function Vc(t) {
      return t > 1 ? 0 : t < -1 ? Mc : Math.acos(t);
    }

    function Gc(t) {
      return t > 1 ? Nc : t < -1 ? -Nc : Math.asin(t);
    }

    function Xc(t) {
      return (t = qc(t / 2)) * t;
    }

    function Zc() {}

    function Qc(t, e) {
      t && Jc.hasOwnProperty(t.type) && Jc[t.type](t, e);
    }

    var Kc = {
      Feature: function Feature(t, e) {
        Qc(t.geometry, e);
      },
      FeatureCollection: function FeatureCollection(t, e) {
        for (var n = t.features, r = -1, i = n.length; ++r < i;) {
          Qc(n[r].geometry, e);
        }
      }
    },
        Jc = {
      Sphere: function Sphere(t, e) {
        e.sphere();
      },
      Point: function Point(t, e) {
        t = t.coordinates, e.point(t[0], t[1], t[2]);
      },
      MultiPoint: function MultiPoint(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          t = n[r], e.point(t[0], t[1], t[2]);
        }
      },
      LineString: function LineString(t, e) {
        tu(t.coordinates, e, 0);
      },
      MultiLineString: function MultiLineString(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          tu(n[r], e, 0);
        }
      },
      Polygon: function Polygon(t, e) {
        eu(t.coordinates, e);
      },
      MultiPolygon: function MultiPolygon(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          eu(n[r], e);
        }
      },
      GeometryCollection: function GeometryCollection(t, e) {
        for (var n = t.geometries, r = -1, i = n.length; ++r < i;) {
          Qc(n[r], e);
        }
      }
    };

    function tu(t, e, n) {
      var r,
          i = -1,
          a = t.length - n;

      for (e.lineStart(); ++i < a;) {
        r = t[i], e.point(r[0], r[1], r[2]);
      }

      e.lineEnd();
    }

    function eu(t, e) {
      var n = -1,
          r = t.length;

      for (e.polygonStart(); ++n < r;) {
        tu(t[n], e, 1);
      }

      e.polygonEnd();
    }

    function nu(t, e) {
      t && Kc.hasOwnProperty(t.type) ? Kc[t.type](t, e) : Qc(t, e);
    }

    var ru,
        iu,
        au,
        ou,
        su,
        cu = kc(),
        uu = kc(),
        lu = {
      point: Zc,
      lineStart: Zc,
      lineEnd: Zc,
      polygonStart: function polygonStart() {
        cu.reset(), lu.lineStart = hu, lu.lineEnd = fu;
      },
      polygonEnd: function polygonEnd() {
        var t = +cu;
        uu.add(t < 0 ? Oc + t : t), this.lineStart = this.lineEnd = this.point = Zc;
      },
      sphere: function sphere() {
        uu.add(Oc);
      }
    };

    function hu() {
      lu.point = du;
    }

    function fu() {
      pu(ru, iu);
    }

    function du(t, e) {
      lu.point = pu, ru = t, iu = e, au = t *= Lc, ou = Pc(e = (e *= Lc) / 2 + Dc), su = qc(e);
    }

    function pu(t, e) {
      var n = (t *= Lc) - au,
          r = n >= 0 ? 1 : -1,
          i = r * n,
          a = Pc(e = (e *= Lc) / 2 + Dc),
          o = qc(e),
          s = su * o,
          c = ou * a + s * Pc(i),
          u = s * r * qc(i);
      cu.add(Fc(u, c)), au = t, ou = a, su = o;
    }

    function yu(t) {
      return uu.reset(), nu(t, lu), 2 * uu;
    }

    function gu(t) {
      return [Fc(t[1], t[0]), Gc(t[2])];
    }

    function mu(t) {
      var e = t[0],
          n = t[1],
          r = Pc(n);
      return [r * Pc(e), r * qc(e), qc(n)];
    }

    function vu(t, e) {
      return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }

    function bu(t, e) {
      return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
    }

    function _u(t, e) {
      t[0] += e[0], t[1] += e[1], t[2] += e[2];
    }

    function xu(t, e) {
      return [t[0] * e, t[1] * e, t[2] * e];
    }

    function wu(t) {
      var e = $c(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
      t[0] /= e, t[1] /= e, t[2] /= e;
    }

    var ku,
        Tu,
        Eu,
        Cu,
        Su,
        Au,
        Mu,
        Nu,
        Du,
        Ou,
        Bu,
        Lu,
        Iu,
        Ru,
        Fu,
        Pu,
        ju,
        Yu,
        zu,
        Uu,
        qu,
        Hu,
        $u,
        Wu,
        Vu,
        Gu,
        Xu = kc(),
        Zu = {
      point: Qu,
      lineStart: Ju,
      lineEnd: tl,
      polygonStart: function polygonStart() {
        Zu.point = el, Zu.lineStart = nl, Zu.lineEnd = rl, Xu.reset(), lu.polygonStart();
      },
      polygonEnd: function polygonEnd() {
        lu.polygonEnd(), Zu.point = Qu, Zu.lineStart = Ju, Zu.lineEnd = tl, cu < 0 ? (ku = -(Eu = 180), Tu = -(Cu = 90)) : Xu > Sc ? Cu = 90 : Xu < -1e-6 && (Tu = -90), Ou[0] = ku, Ou[1] = Eu;
      },
      sphere: function sphere() {
        ku = -(Eu = 180), Tu = -(Cu = 90);
      }
    };

    function Qu(t, e) {
      Du.push(Ou = [ku = t, Eu = t]), e < Tu && (Tu = e), e > Cu && (Cu = e);
    }

    function Ku(t, e) {
      var n = mu([t * Lc, e * Lc]);

      if (Nu) {
        var r = bu(Nu, n),
            i = bu([r[1], -r[0], 0], r);
        wu(i), i = gu(i);
        var a,
            o = t - Su,
            s = o > 0 ? 1 : -1,
            c = i[0] * Bc * s,
            u = Ic(o) > 180;
        u ^ (s * Su < c && c < s * t) ? (a = i[1] * Bc) > Cu && (Cu = a) : u ^ (s * Su < (c = (c + 360) % 360 - 180) && c < s * t) ? (a = -i[1] * Bc) < Tu && (Tu = a) : (e < Tu && (Tu = e), e > Cu && (Cu = e)), u ? t < Su ? il(ku, t) > il(ku, Eu) && (Eu = t) : il(t, Eu) > il(ku, Eu) && (ku = t) : Eu >= ku ? (t < ku && (ku = t), t > Eu && (Eu = t)) : t > Su ? il(ku, t) > il(ku, Eu) && (Eu = t) : il(t, Eu) > il(ku, Eu) && (ku = t);
      } else Du.push(Ou = [ku = t, Eu = t]);

      e < Tu && (Tu = e), e > Cu && (Cu = e), Nu = n, Su = t;
    }

    function Ju() {
      Zu.point = Ku;
    }

    function tl() {
      Ou[0] = ku, Ou[1] = Eu, Zu.point = Qu, Nu = null;
    }

    function el(t, e) {
      if (Nu) {
        var n = t - Su;
        Xu.add(Ic(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
      } else Au = t, Mu = e;

      lu.point(t, e), Ku(t, e);
    }

    function nl() {
      lu.lineStart();
    }

    function rl() {
      el(Au, Mu), lu.lineEnd(), Ic(Xu) > Sc && (ku = -(Eu = 180)), Ou[0] = ku, Ou[1] = Eu, Nu = null;
    }

    function il(t, e) {
      return (e -= t) < 0 ? e + 360 : e;
    }

    function al(t, e) {
      return t[0] - e[0];
    }

    function ol(t, e) {
      return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
    }

    function sl(t) {
      var e, n, r, i, a, o, s;

      if (Cu = Eu = -(ku = Tu = 1 / 0), Du = [], nu(t, Zu), n = Du.length) {
        for (Du.sort(al), e = 1, a = [r = Du[0]]; e < n; ++e) {
          ol(r, (i = Du[e])[0]) || ol(r, i[1]) ? (il(r[0], i[1]) > il(r[0], r[1]) && (r[1] = i[1]), il(i[0], r[1]) > il(r[0], r[1]) && (r[0] = i[0])) : a.push(r = i);
        }

        for (o = -1 / 0, e = 0, r = a[n = a.length - 1]; e <= n; r = i, ++e) {
          i = a[e], (s = il(r[1], i[0])) > o && (o = s, ku = i[0], Eu = r[1]);
        }
      }

      return Du = Ou = null, ku === 1 / 0 || Tu === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[ku, Tu], [Eu, Cu]];
    }

    var cl = {
      sphere: Zc,
      point: ul,
      lineStart: hl,
      lineEnd: pl,
      polygonStart: function polygonStart() {
        cl.lineStart = yl, cl.lineEnd = gl;
      },
      polygonEnd: function polygonEnd() {
        cl.lineStart = hl, cl.lineEnd = pl;
      }
    };

    function ul(t, e) {
      t *= Lc;
      var n = Pc(e *= Lc);
      ll(n * Pc(t), n * qc(t), qc(e));
    }

    function ll(t, e, n) {
      ++Bu, Iu += (t - Iu) / Bu, Ru += (e - Ru) / Bu, Fu += (n - Fu) / Bu;
    }

    function hl() {
      cl.point = fl;
    }

    function fl(t, e) {
      t *= Lc;
      var n = Pc(e *= Lc);
      Wu = n * Pc(t), Vu = n * qc(t), Gu = qc(e), cl.point = dl, ll(Wu, Vu, Gu);
    }

    function dl(t, e) {
      t *= Lc;
      var n = Pc(e *= Lc),
          r = n * Pc(t),
          i = n * qc(t),
          a = qc(e),
          o = Fc($c((o = Vu * a - Gu * i) * o + (o = Gu * r - Wu * a) * o + (o = Wu * i - Vu * r) * o), Wu * r + Vu * i + Gu * a);
      Lu += o, Pu += o * (Wu + (Wu = r)), ju += o * (Vu + (Vu = i)), Yu += o * (Gu + (Gu = a)), ll(Wu, Vu, Gu);
    }

    function pl() {
      cl.point = ul;
    }

    function yl() {
      cl.point = ml;
    }

    function gl() {
      vl(Hu, $u), cl.point = ul;
    }

    function ml(t, e) {
      Hu = t, $u = e, t *= Lc, e *= Lc, cl.point = vl;
      var n = Pc(e);
      Wu = n * Pc(t), Vu = n * qc(t), Gu = qc(e), ll(Wu, Vu, Gu);
    }

    function vl(t, e) {
      t *= Lc;
      var n = Pc(e *= Lc),
          r = n * Pc(t),
          i = n * qc(t),
          a = qc(e),
          o = Vu * a - Gu * i,
          s = Gu * r - Wu * a,
          c = Wu * i - Vu * r,
          u = $c(o * o + s * s + c * c),
          l = Gc(u),
          h = u && -l / u;
      zu += h * o, Uu += h * s, qu += h * c, Lu += l, Pu += l * (Wu + (Wu = r)), ju += l * (Vu + (Vu = i)), Yu += l * (Gu + (Gu = a)), ll(Wu, Vu, Gu);
    }

    function bl(t) {
      Bu = Lu = Iu = Ru = Fu = Pu = ju = Yu = zu = Uu = qu = 0, nu(t, cl);
      var e = zu,
          n = Uu,
          r = qu,
          i = e * e + n * n + r * r;
      return i < Ac && (e = Pu, n = ju, r = Yu, Lu < Sc && (e = Iu, n = Ru, r = Fu), (i = e * e + n * n + r * r) < Ac) ? [NaN, NaN] : [Fc(n, e) * Bc, Gc(r / $c(i)) * Bc];
    }

    function _l(t) {
      return function () {
        return t;
      };
    }

    function xl(t, e) {
      function n(n, r) {
        return n = t(n, r), e(n[0], n[1]);
      }

      return t.invert && e.invert && (n.invert = function (n, r) {
        return (n = e.invert(n, r)) && t.invert(n[0], n[1]);
      }), n;
    }

    function wl(t, e) {
      return [Ic(t) > Mc ? t + Math.round(-t / Oc) * Oc : t, e];
    }

    function kl(t, e, n) {
      return (t %= Oc) ? e || n ? xl(El(t), Cl(e, n)) : El(t) : e || n ? Cl(e, n) : wl;
    }

    function Tl(t) {
      return function (e, n) {
        return [(e += t) > Mc ? e - Oc : e < -Mc ? e + Oc : e, n];
      };
    }

    function El(t) {
      var e = Tl(t);
      return e.invert = Tl(-t), e;
    }

    function Cl(t, e) {
      var n = Pc(t),
          r = qc(t),
          i = Pc(e),
          a = qc(e);

      function o(t, e) {
        var o = Pc(e),
            s = Pc(t) * o,
            c = qc(t) * o,
            u = qc(e),
            l = u * n + s * r;
        return [Fc(c * i - l * a, s * n - u * r), Gc(l * i + c * a)];
      }

      return o.invert = function (t, e) {
        var o = Pc(e),
            s = Pc(t) * o,
            c = qc(t) * o,
            u = qc(e),
            l = u * i - c * a;
        return [Fc(c * i + u * a, s * n + l * r), Gc(l * n - s * r)];
      }, o;
    }

    function Sl(t) {
      function e(e) {
        return (e = t(e[0] * Lc, e[1] * Lc))[0] *= Bc, e[1] *= Bc, e;
      }

      return t = kl(t[0] * Lc, t[1] * Lc, t.length > 2 ? t[2] * Lc : 0), e.invert = function (e) {
        return (e = t.invert(e[0] * Lc, e[1] * Lc))[0] *= Bc, e[1] *= Bc, e;
      }, e;
    }

    function Al(t, e, n, r, i, a) {
      if (n) {
        var o = Pc(e),
            s = qc(e),
            c = r * n;
        null == i ? (i = e + r * Oc, a = e - c / 2) : (i = Ml(o, i), a = Ml(o, a), (r > 0 ? i < a : i > a) && (i += r * Oc));

        for (var u, l = i; r > 0 ? l > a : l < a; l -= c) {
          u = gu([o, -s * Pc(l), -s * qc(l)]), t.point(u[0], u[1]);
        }
      }
    }

    function Ml(t, e) {
      (e = mu(e))[0] -= t, wu(e);
      var n = Vc(-e[1]);
      return ((-e[2] < 0 ? -n : n) + Oc - Sc) % Oc;
    }

    function Nl() {
      var t,
          e,
          n = _l([0, 0]),
          r = _l(90),
          i = _l(6),
          a = {
        point: function point(n, r) {
          t.push(n = e(n, r)), n[0] *= Bc, n[1] *= Bc;
        }
      };

      function o() {
        var o = n.apply(this, arguments),
            s = r.apply(this, arguments) * Lc,
            c = i.apply(this, arguments) * Lc;
        return t = [], e = kl(-o[0] * Lc, -o[1] * Lc, 0).invert, Al(a, s, c, 1), o = {
          type: "Polygon",
          coordinates: [t]
        }, t = e = null, o;
      }

      return o.center = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : _l([+t[0], +t[1]]), o) : n;
      }, o.radius = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : _l(+t), o) : r;
      }, o.precision = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : _l(+t), o) : i;
      }, o;
    }

    function Dl() {
      var t,
          e = [];
      return {
        point: function point(e, n, r) {
          t.push([e, n, r]);
        },
        lineStart: function lineStart() {
          e.push(t = []);
        },
        lineEnd: Zc,
        rejoin: function rejoin() {
          e.length > 1 && e.push(e.pop().concat(e.shift()));
        },
        result: function result() {
          var n = e;
          return e = [], t = null, n;
        }
      };
    }

    function Ol(t, e) {
      return Ic(t[0] - e[0]) < Sc && Ic(t[1] - e[1]) < Sc;
    }

    function Bl(t, e, n, r) {
      this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
    }

    function Ll(t, e, n, r, i) {
      var a,
          o,
          s = [],
          c = [];

      if (t.forEach(function (t) {
        if (!((e = t.length - 1) <= 0)) {
          var e,
              n,
              r = t[0],
              o = t[e];

          if (Ol(r, o)) {
            if (!r[2] && !o[2]) {
              for (i.lineStart(), a = 0; a < e; ++a) {
                i.point((r = t[a])[0], r[1]);
              }

              return void i.lineEnd();
            }

            o[0] += 2e-6;
          }

          s.push(n = new Bl(r, t, null, !0)), c.push(n.o = new Bl(r, null, n, !1)), s.push(n = new Bl(o, t, null, !1)), c.push(n.o = new Bl(o, null, n, !0));
        }
      }), s.length) {
        for (c.sort(e), Il(s), Il(c), a = 0, o = c.length; a < o; ++a) {
          c[a].e = n = !n;
        }

        for (var u, l, h = s[0];;) {
          for (var f = h, d = !0; f.v;) {
            if ((f = f.n) === h) return;
          }

          u = f.z, i.lineStart();

          do {
            if (f.v = f.o.v = !0, f.e) {
              if (d) for (a = 0, o = u.length; a < o; ++a) {
                i.point((l = u[a])[0], l[1]);
              } else r(f.x, f.n.x, 1, i);
              f = f.n;
            } else {
              if (d) for (u = f.p.z, a = u.length - 1; a >= 0; --a) {
                i.point((l = u[a])[0], l[1]);
              } else r(f.x, f.p.x, -1, i);
              f = f.p;
            }

            u = (f = f.o).z, d = !d;
          } while (!f.v);

          i.lineEnd();
        }
      }
    }

    function Il(t) {
      if (e = t.length) {
        for (var e, n, r = 0, i = t[0]; ++r < e;) {
          i.n = n = t[r], n.p = i, i = n;
        }

        i.n = n = t[0], n.p = i;
      }
    }

    wl.invert = wl;
    var Rl = kc();

    function Fl(t) {
      return Ic(t[0]) <= Mc ? t[0] : Hc(t[0]) * ((Ic(t[0]) + Mc) % Oc - Mc);
    }

    function Pl(t, e) {
      var n = Fl(e),
          r = e[1],
          i = qc(r),
          a = [qc(n), -Pc(n), 0],
          o = 0,
          s = 0;
      Rl.reset(), 1 === i ? r = Nc + Sc : -1 === i && (r = -Nc - Sc);

      for (var c = 0, u = t.length; c < u; ++c) {
        if (h = (l = t[c]).length) for (var l, h, f = l[h - 1], d = Fl(f), p = f[1] / 2 + Dc, y = qc(p), g = Pc(p), m = 0; m < h; ++m, d = b, y = x, g = w, f = v) {
          var v = l[m],
              b = Fl(v),
              _ = v[1] / 2 + Dc,
              x = qc(_),
              w = Pc(_),
              k = b - d,
              T = k >= 0 ? 1 : -1,
              E = T * k,
              C = E > Mc,
              S = y * x;

          if (Rl.add(Fc(S * T * qc(E), g * w + S * Pc(E))), o += C ? k + T * Oc : k, C ^ d >= n ^ b >= n) {
            var A = bu(mu(f), mu(v));
            wu(A);
            var M = bu(a, A);
            wu(M);
            var N = (C ^ k >= 0 ? -1 : 1) * Gc(M[2]);
            (r > N || r === N && (A[0] || A[1])) && (s += C ^ k >= 0 ? 1 : -1);
          }
        }
      }

      return (o < -1e-6 || o < Sc && Rl < -1e-6) ^ 1 & s;
    }

    function jl(t, e, n, r) {
      return function (i) {
        var a,
            o,
            s,
            c = e(i),
            u = Dl(),
            l = e(u),
            h = !1,
            f = {
          point: d,
          lineStart: y,
          lineEnd: g,
          polygonStart: function polygonStart() {
            f.point = m, f.lineStart = v, f.lineEnd = b, o = [], a = [];
          },
          polygonEnd: function polygonEnd() {
            f.point = d, f.lineStart = y, f.lineEnd = g, o = P(o);
            var t = Pl(a, r);
            o.length ? (h || (i.polygonStart(), h = !0), Ll(o, zl, t, n, i)) : t && (h || (i.polygonStart(), h = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), h && (i.polygonEnd(), h = !1), o = a = null;
          },
          sphere: function sphere() {
            i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
          }
        };

        function d(e, n) {
          t(e, n) && i.point(e, n);
        }

        function p(t, e) {
          c.point(t, e);
        }

        function y() {
          f.point = p, c.lineStart();
        }

        function g() {
          f.point = d, c.lineEnd();
        }

        function m(t, e) {
          s.push([t, e]), l.point(t, e);
        }

        function v() {
          l.lineStart(), s = [];
        }

        function b() {
          m(s[0][0], s[0][1]), l.lineEnd();
          var t,
              e,
              n,
              r,
              c = l.clean(),
              f = u.result(),
              d = f.length;
          if (s.pop(), a.push(s), s = null, d) if (1 & c) {
            if ((e = (n = f[0]).length - 1) > 0) {
              for (h || (i.polygonStart(), h = !0), i.lineStart(), t = 0; t < e; ++t) {
                i.point((r = n[t])[0], r[1]);
              }

              i.lineEnd();
            }
          } else d > 1 && 2 & c && f.push(f.pop().concat(f.shift())), o.push(f.filter(Yl));
        }

        return f;
      };
    }

    function Yl(t) {
      return t.length > 1;
    }

    function zl(t, e) {
      return ((t = t.x)[0] < 0 ? t[1] - Nc - Sc : Nc - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Nc - Sc : Nc - e[1]);
    }

    var Ul = jl(function () {
      return !0;
    }, function (t) {
      var e,
          n = NaN,
          r = NaN,
          i = NaN;
      return {
        lineStart: function lineStart() {
          t.lineStart(), e = 1;
        },
        point: function point(a, o) {
          var s = a > 0 ? Mc : -Mc,
              c = Ic(a - n);
          Ic(c - Mc) < Sc ? (t.point(n, r = (r + o) / 2 > 0 ? Nc : -Nc), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(s, r), t.point(a, r), e = 0) : i !== s && c >= Mc && (Ic(n - i) < Sc && (n -= i * Sc), Ic(a - s) < Sc && (a -= s * Sc), r = function (t, e, n, r) {
            var i,
                a,
                o = qc(t - n);
            return Ic(o) > Sc ? Rc((qc(e) * (a = Pc(r)) * qc(n) - qc(r) * (i = Pc(e)) * qc(t)) / (i * a * o)) : (e + r) / 2;
          }(n, r, a, o), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(s, r), e = 0), t.point(n = a, r = o), i = s;
        },
        lineEnd: function lineEnd() {
          t.lineEnd(), n = r = NaN;
        },
        clean: function clean() {
          return 2 - e;
        }
      };
    }, function (t, e, n, r) {
      var i;
      if (null == t) i = n * Nc, r.point(-Mc, i), r.point(0, i), r.point(Mc, i), r.point(Mc, 0), r.point(Mc, -i), r.point(0, -i), r.point(-Mc, -i), r.point(-Mc, 0), r.point(-Mc, i);else if (Ic(t[0] - e[0]) > Sc) {
        var a = t[0] < e[0] ? Mc : -Mc;
        i = n * a / 2, r.point(-a, i), r.point(0, i), r.point(a, i);
      } else r.point(e[0], e[1]);
    }, [-Mc, -Nc]);

    function ql(t) {
      var e = Pc(t),
          n = 6 * Lc,
          r = e > 0,
          i = Ic(e) > Sc;

      function a(t, n) {
        return Pc(t) * Pc(n) > e;
      }

      function o(t, n, r) {
        var i = [1, 0, 0],
            a = bu(mu(t), mu(n)),
            o = vu(a, a),
            s = a[0],
            c = o - s * s;
        if (!c) return !r && t;
        var u = e * o / c,
            l = -e * s / c,
            h = bu(i, a),
            f = xu(i, u);

        _u(f, xu(a, l));

        var d = h,
            p = vu(f, d),
            y = vu(d, d),
            g = p * p - y * (vu(f, f) - 1);

        if (!(g < 0)) {
          var m = $c(g),
              v = xu(d, (-p - m) / y);
          if (_u(v, f), v = gu(v), !r) return v;
          var b,
              _ = t[0],
              x = n[0],
              w = t[1],
              k = n[1];
          x < _ && (b = _, _ = x, x = b);
          var T = x - _,
              E = Ic(T - Mc) < Sc;

          if (!E && k < w && (b = w, w = k, k = b), E || T < Sc ? E ? w + k > 0 ^ v[1] < (Ic(v[0] - _) < Sc ? w : k) : w <= v[1] && v[1] <= k : T > Mc ^ (_ <= v[0] && v[0] <= x)) {
            var C = xu(d, (-p + m) / y);
            return _u(C, f), [v, gu(C)];
          }
        }
      }

      function s(e, n) {
        var i = r ? t : Mc - t,
            a = 0;
        return e < -i ? a |= 1 : e > i && (a |= 2), n < -i ? a |= 4 : n > i && (a |= 8), a;
      }

      return jl(a, function (t) {
        var e, n, c, u, l;
        return {
          lineStart: function lineStart() {
            u = c = !1, l = 1;
          },
          point: function point(h, f) {
            var d,
                p = [h, f],
                y = a(h, f),
                g = r ? y ? 0 : s(h, f) : y ? s(h + (h < 0 ? Mc : -Mc), f) : 0;
            if (!e && (u = c = y) && t.lineStart(), y !== c && (!(d = o(e, p)) || Ol(e, d) || Ol(p, d)) && (p[2] = 1), y !== c) l = 0, y ? (t.lineStart(), d = o(p, e), t.point(d[0], d[1])) : (d = o(e, p), t.point(d[0], d[1], 2), t.lineEnd()), e = d;else if (i && e && r ^ y) {
              var m;
              g & n || !(m = o(p, e, !0)) || (l = 0, r ? (t.lineStart(), t.point(m[0][0], m[0][1]), t.point(m[1][0], m[1][1]), t.lineEnd()) : (t.point(m[1][0], m[1][1]), t.lineEnd(), t.lineStart(), t.point(m[0][0], m[0][1], 3)));
            }
            !y || e && Ol(e, p) || t.point(p[0], p[1]), e = p, c = y, n = g;
          },
          lineEnd: function lineEnd() {
            c && t.lineEnd(), e = null;
          },
          clean: function clean() {
            return l | (u && c) << 1;
          }
        };
      }, function (e, r, i, a) {
        Al(a, t, n, i, e, r);
      }, r ? [0, -t] : [-Mc, t - Mc]);
    }

    var Hl = 1e9,
        $l = -Hl;

    function Wl(t, e, n, r) {
      function i(i, a) {
        return t <= i && i <= n && e <= a && a <= r;
      }

      function a(i, a, s, u) {
        var l = 0,
            h = 0;
        if (null == i || (l = o(i, s)) !== (h = o(a, s)) || c(i, a) < 0 ^ s > 0) do {
          u.point(0 === l || 3 === l ? t : n, l > 1 ? r : e);
        } while ((l = (l + s + 4) % 4) !== h);else u.point(a[0], a[1]);
      }

      function o(r, i) {
        return Ic(r[0] - t) < Sc ? i > 0 ? 0 : 3 : Ic(r[0] - n) < Sc ? i > 0 ? 2 : 1 : Ic(r[1] - e) < Sc ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
      }

      function s(t, e) {
        return c(t.x, e.x);
      }

      function c(t, e) {
        var n = o(t, 1),
            r = o(e, 1);
        return n !== r ? n - r : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0];
      }

      return function (o) {
        var c,
            u,
            l,
            h,
            f,
            d,
            p,
            y,
            g,
            m,
            v,
            b = o,
            _ = Dl(),
            x = {
          point: w,
          lineStart: function lineStart() {
            x.point = k, u && u.push(l = []), m = !0, g = !1, p = y = NaN;
          },
          lineEnd: function lineEnd() {
            c && (k(h, f), d && g && _.rejoin(), c.push(_.result())), x.point = w, g && b.lineEnd();
          },
          polygonStart: function polygonStart() {
            b = _, c = [], u = [], v = !0;
          },
          polygonEnd: function polygonEnd() {
            var e = function () {
              for (var e = 0, n = 0, i = u.length; n < i; ++n) {
                for (var a, o, s = u[n], c = 1, l = s.length, h = s[0], f = h[0], d = h[1]; c < l; ++c) {
                  a = f, o = d, f = (h = s[c])[0], d = h[1], o <= r ? d > r && (f - a) * (r - o) > (d - o) * (t - a) && ++e : d <= r && (f - a) * (r - o) < (d - o) * (t - a) && --e;
                }
              }

              return e;
            }(),
                n = v && e,
                i = (c = P(c)).length;

            (n || i) && (o.polygonStart(), n && (o.lineStart(), a(null, null, 1, o), o.lineEnd()), i && Ll(c, s, e, a, o), o.polygonEnd()), b = o, c = u = l = null;
          }
        };

        function w(t, e) {
          i(t, e) && b.point(t, e);
        }

        function k(a, o) {
          var s = i(a, o);
          if (u && l.push([a, o]), m) h = a, f = o, d = s, m = !1, s && (b.lineStart(), b.point(a, o));else if (s && g) b.point(a, o);else {
            var c = [p = Math.max($l, Math.min(Hl, p)), y = Math.max($l, Math.min(Hl, y))],
                _ = [a = Math.max($l, Math.min(Hl, a)), o = Math.max($l, Math.min(Hl, o))];
            !function (t, e, n, r, i, a) {
              var o,
                  s = t[0],
                  c = t[1],
                  u = 0,
                  l = 1,
                  h = e[0] - s,
                  f = e[1] - c;

              if (o = n - s, h || !(o > 0)) {
                if (o /= h, h < 0) {
                  if (o < u) return;
                  o < l && (l = o);
                } else if (h > 0) {
                  if (o > l) return;
                  o > u && (u = o);
                }

                if (o = i - s, h || !(o < 0)) {
                  if (o /= h, h < 0) {
                    if (o > l) return;
                    o > u && (u = o);
                  } else if (h > 0) {
                    if (o < u) return;
                    o < l && (l = o);
                  }

                  if (o = r - c, f || !(o > 0)) {
                    if (o /= f, f < 0) {
                      if (o < u) return;
                      o < l && (l = o);
                    } else if (f > 0) {
                      if (o > l) return;
                      o > u && (u = o);
                    }

                    if (o = a - c, f || !(o < 0)) {
                      if (o /= f, f < 0) {
                        if (o > l) return;
                        o > u && (u = o);
                      } else if (f > 0) {
                        if (o < u) return;
                        o < l && (l = o);
                      }

                      return u > 0 && (t[0] = s + u * h, t[1] = c + u * f), l < 1 && (e[0] = s + l * h, e[1] = c + l * f), !0;
                    }
                  }
                }
              }
            }(c, _, t, e, n, r) ? s && (b.lineStart(), b.point(a, o), v = !1) : (g || (b.lineStart(), b.point(c[0], c[1])), b.point(_[0], _[1]), s || b.lineEnd(), v = !1);
          }
          p = a, y = o, g = s;
        }

        return x;
      };
    }

    function Vl() {
      var t,
          e,
          n,
          r = 0,
          i = 0,
          a = 960,
          o = 500;
      return n = {
        stream: function stream(n) {
          return t && e === n ? t : t = Wl(r, i, a, o)(e = n);
        },
        extent: function extent(s) {
          return arguments.length ? (r = +s[0][0], i = +s[0][1], a = +s[1][0], o = +s[1][1], t = e = null, n) : [[r, i], [a, o]];
        }
      };
    }

    var Gl,
        Xl,
        Zl,
        Ql = kc(),
        Kl = {
      sphere: Zc,
      point: Zc,
      lineStart: function lineStart() {
        Kl.point = th, Kl.lineEnd = Jl;
      },
      lineEnd: Zc,
      polygonStart: Zc,
      polygonEnd: Zc
    };

    function Jl() {
      Kl.point = Kl.lineEnd = Zc;
    }

    function th(t, e) {
      Gl = t *= Lc, Xl = qc(e *= Lc), Zl = Pc(e), Kl.point = eh;
    }

    function eh(t, e) {
      t *= Lc;
      var n = qc(e *= Lc),
          r = Pc(e),
          i = Ic(t - Gl),
          a = Pc(i),
          o = r * qc(i),
          s = Zl * n - Xl * r * a,
          c = Xl * n + Zl * r * a;
      Ql.add(Fc($c(o * o + s * s), c)), Gl = t, Xl = n, Zl = r;
    }

    function nh(t) {
      return Ql.reset(), nu(t, Kl), +Ql;
    }

    var rh = [null, null],
        ih = {
      type: "LineString",
      coordinates: rh
    };

    function ah(t, e) {
      return rh[0] = t, rh[1] = e, nh(ih);
    }

    var oh = {
      Feature: function Feature(t, e) {
        return ch(t.geometry, e);
      },
      FeatureCollection: function FeatureCollection(t, e) {
        for (var n = t.features, r = -1, i = n.length; ++r < i;) {
          if (ch(n[r].geometry, e)) return !0;
        }

        return !1;
      }
    },
        sh = {
      Sphere: function Sphere() {
        return !0;
      },
      Point: function Point(t, e) {
        return uh(t.coordinates, e);
      },
      MultiPoint: function MultiPoint(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          if (uh(n[r], e)) return !0;
        }

        return !1;
      },
      LineString: function LineString(t, e) {
        return lh(t.coordinates, e);
      },
      MultiLineString: function MultiLineString(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          if (lh(n[r], e)) return !0;
        }

        return !1;
      },
      Polygon: function Polygon(t, e) {
        return hh(t.coordinates, e);
      },
      MultiPolygon: function MultiPolygon(t, e) {
        for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
          if (hh(n[r], e)) return !0;
        }

        return !1;
      },
      GeometryCollection: function GeometryCollection(t, e) {
        for (var n = t.geometries, r = -1, i = n.length; ++r < i;) {
          if (ch(n[r], e)) return !0;
        }

        return !1;
      }
    };

    function ch(t, e) {
      return !(!t || !sh.hasOwnProperty(t.type)) && sh[t.type](t, e);
    }

    function uh(t, e) {
      return 0 === ah(t, e);
    }

    function lh(t, e) {
      for (var n, r, i, a = 0, o = t.length; a < o; a++) {
        if (0 === (r = ah(t[a], e))) return !0;
        if (a > 0 && (i = ah(t[a], t[a - 1])) > 0 && n <= i && r <= i && (n + r - i) * (1 - Math.pow((n - r) / i, 2)) < Ac * i) return !0;
        n = r;
      }

      return !1;
    }

    function hh(t, e) {
      return !!Pl(t.map(fh), dh(e));
    }

    function fh(t) {
      return (t = t.map(dh)).pop(), t;
    }

    function dh(t) {
      return [t[0] * Lc, t[1] * Lc];
    }

    function ph(t, e) {
      return (t && oh.hasOwnProperty(t.type) ? oh[t.type] : ch)(t, e);
    }

    function yh(t, e, n) {
      var r = k(t, e - Sc, n).concat(e);
      return function (t) {
        return r.map(function (e) {
          return [t, e];
        });
      };
    }

    function gh(t, e, n) {
      var r = k(t, e - Sc, n).concat(e);
      return function (t) {
        return r.map(function (e) {
          return [e, t];
        });
      };
    }

    function mh() {
      var t,
          e,
          n,
          r,
          i,
          a,
          o,
          s,
          c,
          u,
          l,
          h,
          f = 10,
          d = f,
          p = 90,
          y = 360,
          g = 2.5;

      function m() {
        return {
          type: "MultiLineString",
          coordinates: v()
        };
      }

      function v() {
        return k(jc(r / p) * p, n, p).map(l).concat(k(jc(s / y) * y, o, y).map(h)).concat(k(jc(e / f) * f, t, f).filter(function (t) {
          return Ic(t % p) > Sc;
        }).map(c)).concat(k(jc(a / d) * d, i, d).filter(function (t) {
          return Ic(t % y) > Sc;
        }).map(u));
      }

      return m.lines = function () {
        return v().map(function (t) {
          return {
            type: "LineString",
            coordinates: t
          };
        });
      }, m.outline = function () {
        return {
          type: "Polygon",
          coordinates: [l(r).concat(h(o).slice(1), l(n).reverse().slice(1), h(s).reverse().slice(1))]
        };
      }, m.extent = function (t) {
        return arguments.length ? m.extentMajor(t).extentMinor(t) : m.extentMinor();
      }, m.extentMajor = function (t) {
        return arguments.length ? (r = +t[0][0], n = +t[1][0], s = +t[0][1], o = +t[1][1], r > n && (t = r, r = n, n = t), s > o && (t = s, s = o, o = t), m.precision(g)) : [[r, s], [n, o]];
      }, m.extentMinor = function (n) {
        return arguments.length ? (e = +n[0][0], t = +n[1][0], a = +n[0][1], i = +n[1][1], e > t && (n = e, e = t, t = n), a > i && (n = a, a = i, i = n), m.precision(g)) : [[e, a], [t, i]];
      }, m.step = function (t) {
        return arguments.length ? m.stepMajor(t).stepMinor(t) : m.stepMinor();
      }, m.stepMajor = function (t) {
        return arguments.length ? (p = +t[0], y = +t[1], m) : [p, y];
      }, m.stepMinor = function (t) {
        return arguments.length ? (f = +t[0], d = +t[1], m) : [f, d];
      }, m.precision = function (f) {
        return arguments.length ? (g = +f, c = yh(a, i, 90), u = gh(e, t, g), l = yh(s, o, 90), h = gh(r, n, g), m) : g;
      }, m.extentMajor([[-180, -89.999999], [180, 89.999999]]).extentMinor([[-180, -80.000001], [180, 80.000001]]);
    }

    function vh() {
      return mh()();
    }

    function bh(t, e) {
      var n = t[0] * Lc,
          r = t[1] * Lc,
          i = e[0] * Lc,
          a = e[1] * Lc,
          o = Pc(r),
          s = qc(r),
          c = Pc(a),
          u = qc(a),
          l = o * Pc(n),
          h = o * qc(n),
          f = c * Pc(i),
          d = c * qc(i),
          p = 2 * Gc($c(Xc(a - r) + o * c * Xc(i - n))),
          y = qc(p),
          g = p ? function (t) {
        var e = qc(t *= p) / y,
            n = qc(p - t) / y,
            r = n * l + e * f,
            i = n * h + e * d,
            a = n * s + e * u;
        return [Fc(i, r) * Bc, Fc(a, $c(r * r + i * i)) * Bc];
      } : function () {
        return [n * Bc, r * Bc];
      };
      return g.distance = p, g;
    }

    function _h(t) {
      return t;
    }

    var xh,
        wh,
        kh,
        Th,
        Eh = kc(),
        Ch = kc(),
        Sh = {
      point: Zc,
      lineStart: Zc,
      lineEnd: Zc,
      polygonStart: function polygonStart() {
        Sh.lineStart = Ah, Sh.lineEnd = Dh;
      },
      polygonEnd: function polygonEnd() {
        Sh.lineStart = Sh.lineEnd = Sh.point = Zc, Eh.add(Ic(Ch)), Ch.reset();
      },
      result: function result() {
        var t = Eh / 2;
        return Eh.reset(), t;
      }
    };

    function Ah() {
      Sh.point = Mh;
    }

    function Mh(t, e) {
      Sh.point = Nh, xh = kh = t, wh = Th = e;
    }

    function Nh(t, e) {
      Ch.add(Th * t - kh * e), kh = t, Th = e;
    }

    function Dh() {
      Nh(xh, wh);
    }

    var Oh = Sh;
    var Bh = 1 / 0,
        Lh = Bh,
        Ih = -Bh,
        Rh = Ih,
        Fh = {
      point: function point(t, e) {
        t < Bh && (Bh = t), t > Ih && (Ih = t), e < Lh && (Lh = e), e > Rh && (Rh = e);
      },
      lineStart: Zc,
      lineEnd: Zc,
      polygonStart: Zc,
      polygonEnd: Zc,
      result: function result() {
        var t = [[Bh, Lh], [Ih, Rh]];
        return Ih = Rh = -(Lh = Bh = 1 / 0), t;
      }
    };
    var Ph = Fh;
    var jh,
        Yh,
        zh,
        Uh,
        qh = 0,
        Hh = 0,
        $h = 0,
        Wh = 0,
        Vh = 0,
        Gh = 0,
        Xh = 0,
        Zh = 0,
        Qh = 0,
        Kh = {
      point: Jh,
      lineStart: tf,
      lineEnd: rf,
      polygonStart: function polygonStart() {
        Kh.lineStart = af, Kh.lineEnd = of;
      },
      polygonEnd: function polygonEnd() {
        Kh.point = Jh, Kh.lineStart = tf, Kh.lineEnd = rf;
      },
      result: function result() {
        var t = Qh ? [Xh / Qh, Zh / Qh] : Gh ? [Wh / Gh, Vh / Gh] : $h ? [qh / $h, Hh / $h] : [NaN, NaN];
        return qh = Hh = $h = Wh = Vh = Gh = Xh = Zh = Qh = 0, t;
      }
    };

    function Jh(t, e) {
      qh += t, Hh += e, ++$h;
    }

    function tf() {
      Kh.point = ef;
    }

    function ef(t, e) {
      Kh.point = nf, Jh(zh = t, Uh = e);
    }

    function nf(t, e) {
      var n = t - zh,
          r = e - Uh,
          i = $c(n * n + r * r);
      Wh += i * (zh + t) / 2, Vh += i * (Uh + e) / 2, Gh += i, Jh(zh = t, Uh = e);
    }

    function rf() {
      Kh.point = Jh;
    }

    function af() {
      Kh.point = sf;
    }

    function of() {
      cf(jh, Yh);
    }

    function sf(t, e) {
      Kh.point = cf, Jh(jh = zh = t, Yh = Uh = e);
    }

    function cf(t, e) {
      var n = t - zh,
          r = e - Uh,
          i = $c(n * n + r * r);
      Wh += i * (zh + t) / 2, Vh += i * (Uh + e) / 2, Gh += i, Xh += (i = Uh * t - zh * e) * (zh + t), Zh += i * (Uh + e), Qh += 3 * i, Jh(zh = t, Uh = e);
    }

    var uf = Kh;

    function lf(t) {
      this._context = t;
    }

    lf.prototype = {
      _radius: 4.5,
      pointRadius: function pointRadius(t) {
        return this._radius = t, this;
      },
      polygonStart: function polygonStart() {
        this._line = 0;
      },
      polygonEnd: function polygonEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 === this._line && this._context.closePath(), this._point = NaN;
      },
      point: function point(t, e) {
        switch (this._point) {
          case 0:
            this._context.moveTo(t, e), this._point = 1;
            break;

          case 1:
            this._context.lineTo(t, e);

            break;

          default:
            this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Oc);
        }
      },
      result: Zc
    };
    var hf,
        ff,
        df,
        pf,
        yf,
        gf = kc(),
        mf = {
      point: Zc,
      lineStart: function lineStart() {
        mf.point = vf;
      },
      lineEnd: function lineEnd() {
        hf && bf(ff, df), mf.point = Zc;
      },
      polygonStart: function polygonStart() {
        hf = !0;
      },
      polygonEnd: function polygonEnd() {
        hf = null;
      },
      result: function result() {
        var t = +gf;
        return gf.reset(), t;
      }
    };

    function vf(t, e) {
      mf.point = bf, ff = pf = t, df = yf = e;
    }

    function bf(t, e) {
      pf -= t, yf -= e, gf.add($c(pf * pf + yf * yf)), pf = t, yf = e;
    }

    var _f = mf;

    function xf() {
      this._string = [];
    }

    function wf(t) {
      return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
    }

    function kf(t, e) {
      var n,
          r,
          i = 4.5;

      function a(t) {
        return t && ("function" == typeof i && r.pointRadius(+i.apply(this, arguments)), nu(t, n(r))), r.result();
      }

      return a.area = function (t) {
        return nu(t, n(Oh)), Oh.result();
      }, a.measure = function (t) {
        return nu(t, n(_f)), _f.result();
      }, a.bounds = function (t) {
        return nu(t, n(Ph)), Ph.result();
      }, a.centroid = function (t) {
        return nu(t, n(uf)), uf.result();
      }, a.projection = function (e) {
        return arguments.length ? (n = null == e ? (t = null, _h) : (t = e).stream, a) : t;
      }, a.context = function (t) {
        return arguments.length ? (r = null == t ? (e = null, new xf()) : new lf(e = t), "function" != typeof i && r.pointRadius(i), a) : e;
      }, a.pointRadius = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : (r.pointRadius(+t), +t), a) : i;
      }, a.projection(t).context(e);
    }

    function Tf(t) {
      return {
        stream: Ef(t)
      };
    }

    function Ef(t) {
      return function (e) {
        var n = new Cf();

        for (var r in t) {
          n[r] = t[r];
        }

        return n.stream = e, n;
      };
    }

    function Cf() {}

    function Sf(t, e, n) {
      var r = t.clipExtent && t.clipExtent();
      return t.scale(150).translate([0, 0]), null != r && t.clipExtent(null), nu(n, t.stream(Ph)), e(Ph.result()), null != r && t.clipExtent(r), t;
    }

    function Af(t, e, n) {
      return Sf(t, function (n) {
        var r = e[1][0] - e[0][0],
            i = e[1][1] - e[0][1],
            a = Math.min(r / (n[1][0] - n[0][0]), i / (n[1][1] - n[0][1])),
            o = +e[0][0] + (r - a * (n[1][0] + n[0][0])) / 2,
            s = +e[0][1] + (i - a * (n[1][1] + n[0][1])) / 2;
        t.scale(150 * a).translate([o, s]);
      }, n);
    }

    function Mf(t, e, n) {
      return Af(t, [[0, 0], e], n);
    }

    function Nf(t, e, n) {
      return Sf(t, function (n) {
        var r = +e,
            i = r / (n[1][0] - n[0][0]),
            a = (r - i * (n[1][0] + n[0][0])) / 2,
            o = -i * n[0][1];
        t.scale(150 * i).translate([a, o]);
      }, n);
    }

    function Df(t, e, n) {
      return Sf(t, function (n) {
        var r = +e,
            i = r / (n[1][1] - n[0][1]),
            a = -i * n[0][0],
            o = (r - i * (n[1][1] + n[0][1])) / 2;
        t.scale(150 * i).translate([a, o]);
      }, n);
    }

    xf.prototype = {
      _radius: 4.5,
      _circle: wf(4.5),
      pointRadius: function pointRadius(t) {
        return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
      },
      polygonStart: function polygonStart() {
        this._line = 0;
      },
      polygonEnd: function polygonEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 === this._line && this._string.push("Z"), this._point = NaN;
      },
      point: function point(t, e) {
        switch (this._point) {
          case 0:
            this._string.push("M", t, ",", e), this._point = 1;
            break;

          case 1:
            this._string.push("L", t, ",", e);

            break;

          default:
            null == this._circle && (this._circle = wf(this._radius)), this._string.push("M", t, ",", e, this._circle);
        }
      },
      result: function result() {
        if (this._string.length) {
          var t = this._string.join("");

          return this._string = [], t;
        }

        return null;
      }
    }, Cf.prototype = {
      constructor: Cf,
      point: function point(t, e) {
        this.stream.point(t, e);
      },
      sphere: function sphere() {
        this.stream.sphere();
      },
      lineStart: function lineStart() {
        this.stream.lineStart();
      },
      lineEnd: function lineEnd() {
        this.stream.lineEnd();
      },
      polygonStart: function polygonStart() {
        this.stream.polygonStart();
      },
      polygonEnd: function polygonEnd() {
        this.stream.polygonEnd();
      }
    };
    var Of = Pc(30 * Lc);

    function Bf(t, e) {
      return +e ? function (t, e) {
        function n(r, i, a, o, s, c, u, l, h, f, d, p, y, g) {
          var m = u - r,
              v = l - i,
              b = m * m + v * v;

          if (b > 4 * e && y--) {
            var _ = o + f,
                x = s + d,
                w = c + p,
                k = $c(_ * _ + x * x + w * w),
                T = Gc(w /= k),
                E = Ic(Ic(w) - 1) < Sc || Ic(a - h) < Sc ? (a + h) / 2 : Fc(x, _),
                C = t(E, T),
                S = C[0],
                A = C[1],
                M = S - r,
                N = A - i,
                D = v * M - m * N;

            (D * D / b > e || Ic((m * M + v * N) / b - .5) > .3 || o * f + s * d + c * p < Of) && (n(r, i, a, o, s, c, S, A, E, _ /= k, x /= k, w, y, g), g.point(S, A), n(S, A, E, _, x, w, u, l, h, f, d, p, y, g));
          }
        }

        return function (e) {
          var r,
              i,
              a,
              o,
              s,
              c,
              u,
              l,
              h,
              f,
              d,
              p,
              y = {
            point: g,
            lineStart: m,
            lineEnd: b,
            polygonStart: function polygonStart() {
              e.polygonStart(), y.lineStart = _;
            },
            polygonEnd: function polygonEnd() {
              e.polygonEnd(), y.lineStart = m;
            }
          };

          function g(n, r) {
            n = t(n, r), e.point(n[0], n[1]);
          }

          function m() {
            l = NaN, y.point = v, e.lineStart();
          }

          function v(r, i) {
            var a = mu([r, i]),
                o = t(r, i);
            n(l, h, u, f, d, p, l = o[0], h = o[1], u = r, f = a[0], d = a[1], p = a[2], 16, e), e.point(l, h);
          }

          function b() {
            y.point = g, e.lineEnd();
          }

          function _() {
            m(), y.point = x, y.lineEnd = w;
          }

          function x(t, e) {
            v(r = t, e), i = l, a = h, o = f, s = d, c = p, y.point = v;
          }

          function w() {
            n(l, h, u, f, d, p, i, a, r, o, s, c, 16, e), y.lineEnd = b, b();
          }

          return y;
        };
      }(t, e) : function (t) {
        return Ef({
          point: function point(e, n) {
            e = t(e, n), this.stream.point(e[0], e[1]);
          }
        });
      }(t);
    }

    var Lf = Ef({
      point: function point(t, e) {
        this.stream.point(t * Lc, e * Lc);
      }
    });

    function If(t, e, n, r, i) {
      function a(a, o) {
        return [e + t * (a *= r), n - t * (o *= i)];
      }

      return a.invert = function (a, o) {
        return [(a - e) / t * r, (n - o) / t * i];
      }, a;
    }

    function Rf(t, e, n, r, i, a) {
      var o = Pc(a),
          s = qc(a),
          c = o * t,
          u = s * t,
          l = o / t,
          h = s / t,
          f = (s * n - o * e) / t,
          d = (s * e + o * n) / t;

      function p(t, a) {
        return [c * (t *= r) - u * (a *= i) + e, n - u * t - c * a];
      }

      return p.invert = function (t, e) {
        return [r * (l * t - h * e + f), i * (d - h * t - l * e)];
      }, p;
    }

    function Ff(t) {
      return Pf(function () {
        return t;
      })();
    }

    function Pf(t) {
      var e,
          n,
          r,
          i,
          a,
          o,
          s,
          c,
          u,
          l,
          h = 150,
          f = 480,
          d = 250,
          p = 0,
          y = 0,
          g = 0,
          m = 0,
          v = 0,
          b = 0,
          _ = 1,
          x = 1,
          w = null,
          k = Ul,
          T = null,
          E = _h,
          C = .5;

      function S(t) {
        return c(t[0] * Lc, t[1] * Lc);
      }

      function A(t) {
        return (t = c.invert(t[0], t[1])) && [t[0] * Bc, t[1] * Bc];
      }

      function M() {
        var t = Rf(h, 0, 0, _, x, b).apply(null, e(p, y)),
            r = (b ? Rf : If)(h, f - t[0], d - t[1], _, x, b);
        return n = kl(g, m, v), s = xl(e, r), c = xl(n, s), o = Bf(s, C), N();
      }

      function N() {
        return u = l = null, S;
      }

      return S.stream = function (t) {
        return u && l === t ? u : u = Lf(function (t) {
          return Ef({
            point: function point(e, n) {
              var r = t(e, n);
              return this.stream.point(r[0], r[1]);
            }
          });
        }(n)(k(o(E(l = t)))));
      }, S.preclip = function (t) {
        return arguments.length ? (k = t, w = void 0, N()) : k;
      }, S.postclip = function (t) {
        return arguments.length ? (E = t, T = r = i = a = null, N()) : E;
      }, S.clipAngle = function (t) {
        return arguments.length ? (k = +t ? ql(w = t * Lc) : (w = null, Ul), N()) : w * Bc;
      }, S.clipExtent = function (t) {
        return arguments.length ? (E = null == t ? (T = r = i = a = null, _h) : Wl(T = +t[0][0], r = +t[0][1], i = +t[1][0], a = +t[1][1]), N()) : null == T ? null : [[T, r], [i, a]];
      }, S.scale = function (t) {
        return arguments.length ? (h = +t, M()) : h;
      }, S.translate = function (t) {
        return arguments.length ? (f = +t[0], d = +t[1], M()) : [f, d];
      }, S.center = function (t) {
        return arguments.length ? (p = t[0] % 360 * Lc, y = t[1] % 360 * Lc, M()) : [p * Bc, y * Bc];
      }, S.rotate = function (t) {
        return arguments.length ? (g = t[0] % 360 * Lc, m = t[1] % 360 * Lc, v = t.length > 2 ? t[2] % 360 * Lc : 0, M()) : [g * Bc, m * Bc, v * Bc];
      }, S.angle = function (t) {
        return arguments.length ? (b = t % 360 * Lc, M()) : b * Bc;
      }, S.reflectX = function (t) {
        return arguments.length ? (_ = t ? -1 : 1, M()) : _ < 0;
      }, S.reflectY = function (t) {
        return arguments.length ? (x = t ? -1 : 1, M()) : x < 0;
      }, S.precision = function (t) {
        return arguments.length ? (o = Bf(s, C = t * t), N()) : $c(C);
      }, S.fitExtent = function (t, e) {
        return Af(S, t, e);
      }, S.fitSize = function (t, e) {
        return Mf(S, t, e);
      }, S.fitWidth = function (t, e) {
        return Nf(S, t, e);
      }, S.fitHeight = function (t, e) {
        return Df(S, t, e);
      }, function () {
        return e = t.apply(this, arguments), S.invert = e.invert && A, M();
      };
    }

    function jf(t) {
      var e = 0,
          n = Mc / 3,
          r = Pf(t),
          i = r(e, n);
      return i.parallels = function (t) {
        return arguments.length ? r(e = t[0] * Lc, n = t[1] * Lc) : [e * Bc, n * Bc];
      }, i;
    }

    function Yf(t, e) {
      var n = qc(t),
          r = (n + qc(e)) / 2;
      if (Ic(r) < Sc) return function (t) {
        var e = Pc(t);

        function n(t, n) {
          return [t * e, qc(n) / e];
        }

        return n.invert = function (t, n) {
          return [t / e, Gc(n * e)];
        }, n;
      }(t);
      var i = 1 + n * (2 * r - n),
          a = $c(i) / r;

      function o(t, e) {
        var n = $c(i - 2 * r * qc(e)) / r;
        return [n * qc(t *= r), a - n * Pc(t)];
      }

      return o.invert = function (t, e) {
        var n = a - e,
            o = Fc(t, Ic(n)) * Hc(n);
        return n * r < 0 && (o -= Mc * Hc(t) * Hc(n)), [o / r, Gc((i - (t * t + n * n) * r * r) / (2 * r))];
      }, o;
    }

    function zf() {
      return jf(Yf).scale(155.424).center([0, 33.6442]);
    }

    function Uf() {
      return zf().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-.6, 38.7]);
    }

    function qf() {
      var t,
          e,
          n,
          r,
          i,
          a,
          o = Uf(),
          s = zf().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
          c = zf().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
          u = {
        point: function point(t, e) {
          a = [t, e];
        }
      };

      function l(t) {
        var e = t[0],
            o = t[1];
        return a = null, n.point(e, o), a || (r.point(e, o), a) || (i.point(e, o), a);
      }

      function h() {
        return t = e = null, l;
      }

      return l.invert = function (t) {
        var e = o.scale(),
            n = o.translate(),
            r = (t[0] - n[0]) / e,
            i = (t[1] - n[1]) / e;
        return (i >= .12 && i < .234 && r >= -.425 && r < -.214 ? s : i >= .166 && i < .234 && r >= -.214 && r < -.115 ? c : o).invert(t);
      }, l.stream = function (n) {
        return t && e === n ? t : (r = [o.stream(e = n), s.stream(n), c.stream(n)], i = r.length, t = {
          point: function point(t, e) {
            for (var n = -1; ++n < i;) {
              r[n].point(t, e);
            }
          },
          sphere: function sphere() {
            for (var t = -1; ++t < i;) {
              r[t].sphere();
            }
          },
          lineStart: function lineStart() {
            for (var t = -1; ++t < i;) {
              r[t].lineStart();
            }
          },
          lineEnd: function lineEnd() {
            for (var t = -1; ++t < i;) {
              r[t].lineEnd();
            }
          },
          polygonStart: function polygonStart() {
            for (var t = -1; ++t < i;) {
              r[t].polygonStart();
            }
          },
          polygonEnd: function polygonEnd() {
            for (var t = -1; ++t < i;) {
              r[t].polygonEnd();
            }
          }
        });
        var r, i;
      }, l.precision = function (t) {
        return arguments.length ? (o.precision(t), s.precision(t), c.precision(t), h()) : o.precision();
      }, l.scale = function (t) {
        return arguments.length ? (o.scale(t), s.scale(.35 * t), c.scale(t), l.translate(o.translate())) : o.scale();
      }, l.translate = function (t) {
        if (!arguments.length) return o.translate();
        var e = o.scale(),
            a = +t[0],
            l = +t[1];
        return n = o.translate(t).clipExtent([[a - .455 * e, l - .238 * e], [a + .455 * e, l + .238 * e]]).stream(u), r = s.translate([a - .307 * e, l + .201 * e]).clipExtent([[a - .425 * e + Sc, l + .12 * e + Sc], [a - .214 * e - Sc, l + .234 * e - Sc]]).stream(u), i = c.translate([a - .205 * e, l + .212 * e]).clipExtent([[a - .214 * e + Sc, l + .166 * e + Sc], [a - .115 * e - Sc, l + .234 * e - Sc]]).stream(u), h();
      }, l.fitExtent = function (t, e) {
        return Af(l, t, e);
      }, l.fitSize = function (t, e) {
        return Mf(l, t, e);
      }, l.fitWidth = function (t, e) {
        return Nf(l, t, e);
      }, l.fitHeight = function (t, e) {
        return Df(l, t, e);
      }, l.scale(1070);
    }

    function Hf(t) {
      return function (e, n) {
        var r = Pc(e),
            i = Pc(n),
            a = t(r * i);
        return [a * i * qc(e), a * qc(n)];
      };
    }

    function $f(t) {
      return function (e, n) {
        var r = $c(e * e + n * n),
            i = t(r),
            a = qc(i),
            o = Pc(i);
        return [Fc(e * a, r * o), Gc(r && n * a / r)];
      };
    }

    var Wf = Hf(function (t) {
      return $c(2 / (1 + t));
    });

    function Vf() {
      return Ff(Wf).scale(124.75).clipAngle(179.999);
    }

    Wf.invert = $f(function (t) {
      return 2 * Gc(t / 2);
    });
    var Gf = Hf(function (t) {
      return (t = Vc(t)) && t / qc(t);
    });

    function Xf() {
      return Ff(Gf).scale(79.4188).clipAngle(179.999);
    }

    function Zf(t, e) {
      return [t, zc(Wc((Nc + e) / 2))];
    }

    function Qf() {
      return Kf(Zf).scale(961 / Oc);
    }

    function Kf(t) {
      var e,
          n,
          r,
          i = Ff(t),
          a = i.center,
          o = i.scale,
          s = i.translate,
          c = i.clipExtent,
          u = null;

      function l() {
        var a = Mc * o(),
            s = i(Sl(i.rotate()).invert([0, 0]));
        return c(null == u ? [[s[0] - a, s[1] - a], [s[0] + a, s[1] + a]] : t === Zf ? [[Math.max(s[0] - a, u), e], [Math.min(s[0] + a, n), r]] : [[u, Math.max(s[1] - a, e)], [n, Math.min(s[1] + a, r)]]);
      }

      return i.scale = function (t) {
        return arguments.length ? (o(t), l()) : o();
      }, i.translate = function (t) {
        return arguments.length ? (s(t), l()) : s();
      }, i.center = function (t) {
        return arguments.length ? (a(t), l()) : a();
      }, i.clipExtent = function (t) {
        return arguments.length ? (null == t ? u = e = n = r = null : (u = +t[0][0], e = +t[0][1], n = +t[1][0], r = +t[1][1]), l()) : null == u ? null : [[u, e], [n, r]];
      }, l();
    }

    function Jf(t) {
      return Wc((Nc + t) / 2);
    }

    function td(t, e) {
      var n = Pc(t),
          r = t === e ? qc(t) : zc(n / Pc(e)) / zc(Jf(e) / Jf(t)),
          i = n * Uc(Jf(t), r) / r;
      if (!r) return Zf;

      function a(t, e) {
        i > 0 ? e < -Nc + Sc && (e = -Nc + Sc) : e > Nc - Sc && (e = Nc - Sc);
        var n = i / Uc(Jf(e), r);
        return [n * qc(r * t), i - n * Pc(r * t)];
      }

      return a.invert = function (t, e) {
        var n = i - e,
            a = Hc(r) * $c(t * t + n * n),
            o = Fc(t, Ic(n)) * Hc(n);
        return n * r < 0 && (o -= Mc * Hc(t) * Hc(n)), [o / r, 2 * Rc(Uc(i / a, 1 / r)) - Nc];
      }, a;
    }

    function ed() {
      return jf(td).scale(109.5).parallels([30, 30]);
    }

    function nd(t, e) {
      return [t, e];
    }

    function rd() {
      return Ff(nd).scale(152.63);
    }

    function id(t, e) {
      var n = Pc(t),
          r = t === e ? qc(t) : (n - Pc(e)) / (e - t),
          i = n / r + t;
      if (Ic(r) < Sc) return nd;

      function a(t, e) {
        var n = i - e,
            a = r * t;
        return [n * qc(a), i - n * Pc(a)];
      }

      return a.invert = function (t, e) {
        var n = i - e,
            a = Fc(t, Ic(n)) * Hc(n);
        return n * r < 0 && (a -= Mc * Hc(t) * Hc(n)), [a / r, i - Hc(r) * $c(t * t + n * n)];
      }, a;
    }

    function ad() {
      return jf(id).scale(131.154).center([0, 13.9389]);
    }

    Gf.invert = $f(function (t) {
      return t;
    }), Zf.invert = function (t, e) {
      return [t, 2 * Rc(Yc(e)) - Nc];
    }, nd.invert = nd;
    var od = 1.340264,
        sd = -.081106,
        cd = 893e-6,
        ud = .003796,
        ld = $c(3) / 2;

    function hd(t, e) {
      var n = Gc(ld * qc(e)),
          r = n * n,
          i = r * r * r;
      return [t * Pc(n) / (ld * (od + 3 * sd * r + i * (7 * cd + 9 * ud * r))), n * (od + sd * r + i * (cd + ud * r))];
    }

    function fd() {
      return Ff(hd).scale(177.158);
    }

    function dd(t, e) {
      var n = Pc(e),
          r = Pc(t) * n;
      return [n * qc(t) / r, qc(e) / r];
    }

    function pd() {
      return Ff(dd).scale(144.049).clipAngle(60);
    }

    function yd() {
      var t,
          e,
          n,
          r,
          i,
          a,
          o,
          s = 1,
          c = 0,
          u = 0,
          l = 1,
          h = 1,
          f = 0,
          d = null,
          p = 1,
          y = 1,
          g = Ef({
        point: function point(t, e) {
          var n = b([t, e]);
          this.stream.point(n[0], n[1]);
        }
      }),
          m = _h;

      function v() {
        return p = s * l, y = s * h, a = o = null, b;
      }

      function b(n) {
        var r = n[0] * p,
            i = n[1] * y;

        if (f) {
          var a = i * t - r * e;
          r = r * t + i * e, i = a;
        }

        return [r + c, i + u];
      }

      return b.invert = function (n) {
        var r = n[0] - c,
            i = n[1] - u;

        if (f) {
          var a = i * t + r * e;
          r = r * t - i * e, i = a;
        }

        return [r / p, i / y];
      }, b.stream = function (t) {
        return a && o === t ? a : a = g(m(o = t));
      }, b.postclip = function (t) {
        return arguments.length ? (m = t, d = n = r = i = null, v()) : m;
      }, b.clipExtent = function (t) {
        return arguments.length ? (m = null == t ? (d = n = r = i = null, _h) : Wl(d = +t[0][0], n = +t[0][1], r = +t[1][0], i = +t[1][1]), v()) : null == d ? null : [[d, n], [r, i]];
      }, b.scale = function (t) {
        return arguments.length ? (s = +t, v()) : s;
      }, b.translate = function (t) {
        return arguments.length ? (c = +t[0], u = +t[1], v()) : [c, u];
      }, b.angle = function (n) {
        return arguments.length ? (e = qc(f = n % 360 * Lc), t = Pc(f), v()) : f * Bc;
      }, b.reflectX = function (t) {
        return arguments.length ? (l = t ? -1 : 1, v()) : l < 0;
      }, b.reflectY = function (t) {
        return arguments.length ? (h = t ? -1 : 1, v()) : h < 0;
      }, b.fitExtent = function (t, e) {
        return Af(b, t, e);
      }, b.fitSize = function (t, e) {
        return Mf(b, t, e);
      }, b.fitWidth = function (t, e) {
        return Nf(b, t, e);
      }, b.fitHeight = function (t, e) {
        return Df(b, t, e);
      }, b;
    }

    function gd(t, e) {
      var n = e * e,
          r = n * n;
      return [t * (.8707 - .131979 * n + r * (r * (.003971 * n - .001529 * r) - .013791)), e * (1.007226 + n * (.015085 + r * (.028874 * n - .044475 - .005916 * r)))];
    }

    function md() {
      return Ff(gd).scale(175.295);
    }

    function vd(t, e) {
      return [Pc(e) * qc(t), qc(e)];
    }

    function bd() {
      return Ff(vd).scale(249.5).clipAngle(90.000001);
    }

    function _d(t, e) {
      var n = Pc(e),
          r = 1 + Pc(t) * n;
      return [n * qc(t) / r, qc(e) / r];
    }

    function xd() {
      return Ff(_d).scale(250).clipAngle(142);
    }

    function wd(t, e) {
      return [zc(Wc((Nc + e) / 2)), -t];
    }

    function kd() {
      var t = Kf(wd),
          e = t.center,
          n = t.rotate;
      return t.center = function (t) {
        return arguments.length ? e([-t[1], t[0]]) : [(t = e())[1], -t[0]];
      }, t.rotate = function (t) {
        return arguments.length ? n([t[0], t[1], t.length > 2 ? t[2] + 90 : 90]) : [(t = n())[0], t[1], t[2] - 90];
      }, n([0, 0, 90]).scale(159.155);
    }

    function Td(t, e) {
      return t.parent === e.parent ? 1 : 2;
    }

    function Ed(t, e) {
      return t + e.x;
    }

    function Cd(t, e) {
      return Math.max(t, e.y);
    }

    function Sd() {
      var t = Td,
          e = 1,
          n = 1,
          r = !1;

      function i(i) {
        var a,
            o = 0;
        i.eachAfter(function (e) {
          var n = e.children;
          n ? (e.x = function (t) {
            return t.reduce(Ed, 0) / t.length;
          }(n), e.y = function (t) {
            return 1 + t.reduce(Cd, 0);
          }(n)) : (e.x = a ? o += t(e, a) : 0, e.y = 0, a = e);
        });

        var s = function (t) {
          for (var e; e = t.children;) {
            t = e[0];
          }

          return t;
        }(i),
            c = function (t) {
          for (var e; e = t.children;) {
            t = e[e.length - 1];
          }

          return t;
        }(i),
            u = s.x - t(s, c) / 2,
            l = c.x + t(c, s) / 2;

        return i.eachAfter(r ? function (t) {
          t.x = (t.x - i.x) * e, t.y = (i.y - t.y) * n;
        } : function (t) {
          t.x = (t.x - u) / (l - u) * e, t.y = (1 - (i.y ? t.y / i.y : 1)) * n;
        });
      }

      return i.separation = function (e) {
        return arguments.length ? (t = e, i) : t;
      }, i.size = function (t) {
        return arguments.length ? (r = !1, e = +t[0], n = +t[1], i) : r ? null : [e, n];
      }, i.nodeSize = function (t) {
        return arguments.length ? (r = !0, e = +t[0], n = +t[1], i) : r ? [e, n] : null;
      }, i;
    }

    function Ad(t) {
      var e = 0,
          n = t.children,
          r = n && n.length;
      if (r) for (; --r >= 0;) {
        e += n[r].value;
      } else e = 1;
      t.value = e;
    }

    function Md(t, e) {
      var n,
          r,
          i,
          a,
          o,
          s = new Bd(t),
          c = +t.value && (s.value = t.value),
          u = [s];

      for (null == e && (e = Nd); n = u.pop();) {
        if (c && (n.value = +n.data.value), (i = e(n.data)) && (o = i.length)) for (n.children = new Array(o), a = o - 1; a >= 0; --a) {
          u.push(r = n.children[a] = new Bd(i[a])), r.parent = n, r.depth = n.depth + 1;
        }
      }

      return s.eachBefore(Od);
    }

    function Nd(t) {
      return t.children;
    }

    function Dd(t) {
      t.data = t.data.data;
    }

    function Od(t) {
      var e = 0;

      do {
        t.height = e;
      } while ((t = t.parent) && t.height < ++e);
    }

    function Bd(t) {
      this.data = t, this.depth = this.height = 0, this.parent = null;
    }

    hd.invert = function (t, e) {
      for (var n, r = e, i = r * r, a = i * i * i, o = 0; o < 12 && (a = (i = (r -= n = (r * (od + sd * i + a * (cd + ud * i)) - e) / (od + 3 * sd * i + a * (7 * cd + 9 * ud * i))) * r) * i * i, !(Ic(n) < Ac)); ++o) {
        ;
      }

      return [ld * t * (od + 3 * sd * i + a * (7 * cd + 9 * ud * i)) / Pc(r), Gc(qc(r) / ld)];
    }, dd.invert = $f(Rc), gd.invert = function (t, e) {
      var n,
          r = e,
          i = 25;

      do {
        var a = r * r,
            o = a * a;
        r -= n = (r * (1.007226 + a * (.015085 + o * (.028874 * a - .044475 - .005916 * o))) - e) / (1.007226 + a * (.045255 + o * (.259866 * a - .311325 - .005916 * 11 * o)));
      } while (Ic(n) > Sc && --i > 0);

      return [t / (.8707 + (a = r * r) * (a * (a * a * a * (.003971 - .001529 * a) - .013791) - .131979)), r];
    }, vd.invert = $f(Gc), _d.invert = $f(function (t) {
      return 2 * Rc(t);
    }), wd.invert = function (t, e) {
      return [-e, 2 * Rc(Yc(t)) - Nc];
    }, Bd.prototype = Md.prototype = {
      constructor: Bd,
      count: function count() {
        return this.eachAfter(Ad);
      },
      each: function each(t) {
        var e,
            n,
            r,
            i,
            a = this,
            o = [a];

        do {
          for (e = o.reverse(), o = []; a = e.pop();) {
            if (t(a), n = a.children) for (r = 0, i = n.length; r < i; ++r) {
              o.push(n[r]);
            }
          }
        } while (o.length);

        return this;
      },
      eachAfter: function eachAfter(t) {
        for (var e, n, r, i = this, a = [i], o = []; i = a.pop();) {
          if (o.push(i), e = i.children) for (n = 0, r = e.length; n < r; ++n) {
            a.push(e[n]);
          }
        }

        for (; i = o.pop();) {
          t(i);
        }

        return this;
      },
      eachBefore: function eachBefore(t) {
        for (var e, n, r = this, i = [r]; r = i.pop();) {
          if (t(r), e = r.children) for (n = e.length - 1; n >= 0; --n) {
            i.push(e[n]);
          }
        }

        return this;
      },
      sum: function sum(t) {
        return this.eachAfter(function (e) {
          for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0;) {
            n += r[i].value;
          }

          e.value = n;
        });
      },
      sort: function sort(t) {
        return this.eachBefore(function (e) {
          e.children && e.children.sort(t);
        });
      },
      path: function path(t) {
        for (var e = this, n = function (t, e) {
          if (t === e) return t;
          var n = t.ancestors(),
              r = e.ancestors(),
              i = null;

          for (t = n.pop(), e = r.pop(); t === e;) {
            i = t, t = n.pop(), e = r.pop();
          }

          return i;
        }(e, t), r = [e]; e !== n;) {
          e = e.parent, r.push(e);
        }

        for (var i = r.length; t !== n;) {
          r.splice(i, 0, t), t = t.parent;
        }

        return r;
      },
      ancestors: function ancestors() {
        for (var t = this, e = [t]; t = t.parent;) {
          e.push(t);
        }

        return e;
      },
      descendants: function descendants() {
        var t = [];
        return this.each(function (e) {
          t.push(e);
        }), t;
      },
      leaves: function leaves() {
        var t = [];
        return this.eachBefore(function (e) {
          e.children || t.push(e);
        }), t;
      },
      links: function links() {
        var t = this,
            e = [];
        return t.each(function (n) {
          n !== t && e.push({
            source: n.parent,
            target: n
          });
        }), e;
      },
      copy: function copy() {
        return Md(this).eachBefore(Dd);
      }
    };
    var Ld = Array.prototype.slice;

    function Id(t) {
      for (var e, n, r = 0, i = (t = function (t) {
        for (var e, n, r = t.length; r;) {
          n = Math.random() * r-- | 0, e = t[r], t[r] = t[n], t[n] = e;
        }

        return t;
      }(Ld.call(t))).length, a = []; r < i;) {
        e = t[r], n && Pd(n, e) ? ++r : (n = Yd(a = Rd(a, e)), r = 0);
      }

      return n;
    }

    function Rd(t, e) {
      var n, r;
      if (jd(e, t)) return [e];

      for (n = 0; n < t.length; ++n) {
        if (Fd(e, t[n]) && jd(zd(t[n], e), t)) return [t[n], e];
      }

      for (n = 0; n < t.length - 1; ++n) {
        for (r = n + 1; r < t.length; ++r) {
          if (Fd(zd(t[n], t[r]), e) && Fd(zd(t[n], e), t[r]) && Fd(zd(t[r], e), t[n]) && jd(Ud(t[n], t[r], e), t)) return [t[n], t[r], e];
        }
      }

      throw new Error();
    }

    function Fd(t, e) {
      var n = t.r - e.r,
          r = e.x - t.x,
          i = e.y - t.y;
      return n < 0 || n * n < r * r + i * i;
    }

    function Pd(t, e) {
      var n = t.r - e.r + 1e-6,
          r = e.x - t.x,
          i = e.y - t.y;
      return n > 0 && n * n > r * r + i * i;
    }

    function jd(t, e) {
      for (var n = 0; n < e.length; ++n) {
        if (!Pd(t, e[n])) return !1;
      }

      return !0;
    }

    function Yd(t) {
      switch (t.length) {
        case 1:
          return function (t) {
            return {
              x: t.x,
              y: t.y,
              r: t.r
            };
          }(t[0]);

        case 2:
          return zd(t[0], t[1]);

        case 3:
          return Ud(t[0], t[1], t[2]);
      }
    }

    function zd(t, e) {
      var n = t.x,
          r = t.y,
          i = t.r,
          a = e.x,
          o = e.y,
          s = e.r,
          c = a - n,
          u = o - r,
          l = s - i,
          h = Math.sqrt(c * c + u * u);
      return {
        x: (n + a + c / h * l) / 2,
        y: (r + o + u / h * l) / 2,
        r: (h + i + s) / 2
      };
    }

    function Ud(t, e, n) {
      var r = t.x,
          i = t.y,
          a = t.r,
          o = e.x,
          s = e.y,
          c = e.r,
          u = n.x,
          l = n.y,
          h = n.r,
          f = r - o,
          d = r - u,
          p = i - s,
          y = i - l,
          g = c - a,
          m = h - a,
          v = r * r + i * i - a * a,
          b = v - o * o - s * s + c * c,
          _ = v - u * u - l * l + h * h,
          x = d * p - f * y,
          w = (p * _ - y * b) / (2 * x) - r,
          k = (y * g - p * m) / x,
          T = (d * b - f * _) / (2 * x) - i,
          E = (f * m - d * g) / x,
          C = k * k + E * E - 1,
          S = 2 * (a + w * k + T * E),
          A = w * w + T * T - a * a,
          M = -(C ? (S + Math.sqrt(S * S - 4 * C * A)) / (2 * C) : A / S);

      return {
        x: r + w + k * M,
        y: i + T + E * M,
        r: M
      };
    }

    function qd(t, e, n) {
      var r,
          i,
          a,
          o,
          s = t.x - e.x,
          c = t.y - e.y,
          u = s * s + c * c;
      u ? (i = e.r + n.r, i *= i, o = t.r + n.r, i > (o *= o) ? (r = (u + o - i) / (2 * u), a = Math.sqrt(Math.max(0, o / u - r * r)), n.x = t.x - r * s - a * c, n.y = t.y - r * c + a * s) : (r = (u + i - o) / (2 * u), a = Math.sqrt(Math.max(0, i / u - r * r)), n.x = e.x + r * s - a * c, n.y = e.y + r * c + a * s)) : (n.x = e.x + n.r, n.y = e.y);
    }

    function Hd(t, e) {
      var n = t.r + e.r - 1e-6,
          r = e.x - t.x,
          i = e.y - t.y;
      return n > 0 && n * n > r * r + i * i;
    }

    function $d(t) {
      var e = t._,
          n = t.next._,
          r = e.r + n.r,
          i = (e.x * n.r + n.x * e.r) / r,
          a = (e.y * n.r + n.y * e.r) / r;
      return i * i + a * a;
    }

    function Wd(t) {
      this._ = t, this.next = null, this.previous = null;
    }

    function Vd(t) {
      if (!(i = t.length)) return 0;
      var e, n, r, i, a, o, s, c, u, l, h;
      if ((e = t[0]).x = 0, e.y = 0, !(i > 1)) return e.r;
      if (n = t[1], e.x = -n.r, n.x = e.r, n.y = 0, !(i > 2)) return e.r + n.r;
      qd(n, e, r = t[2]), e = new Wd(e), n = new Wd(n), r = new Wd(r), e.next = r.previous = n, n.next = e.previous = r, r.next = n.previous = e;

      t: for (s = 3; s < i; ++s) {
        qd(e._, n._, r = t[s]), r = new Wd(r), c = n.next, u = e.previous, l = n._.r, h = e._.r;

        do {
          if (l <= h) {
            if (Hd(c._, r._)) {
              n = c, e.next = n, n.previous = e, --s;
              continue t;
            }

            l += c._.r, c = c.next;
          } else {
            if (Hd(u._, r._)) {
              (e = u).next = n, n.previous = e, --s;
              continue t;
            }

            h += u._.r, u = u.previous;
          }
        } while (c !== u.next);

        for (r.previous = e, r.next = n, e.next = n.previous = n = r, a = $d(e); (r = r.next) !== n;) {
          (o = $d(r)) < a && (e = r, a = o);
        }

        n = e.next;
      }

      for (e = [n._], r = n; (r = r.next) !== n;) {
        e.push(r._);
      }

      for (r = Id(e), s = 0; s < i; ++s) {
        (e = t[s]).x -= r.x, e.y -= r.y;
      }

      return r.r;
    }

    function Gd(t) {
      return Vd(t), t;
    }

    function Xd(t) {
      return null == t ? null : Zd(t);
    }

    function Zd(t) {
      if ("function" != typeof t) throw new Error();
      return t;
    }

    function Qd() {
      return 0;
    }

    function Kd(t) {
      return function () {
        return t;
      };
    }

    function Jd(t) {
      return Math.sqrt(t.value);
    }

    function tp() {
      var t = null,
          e = 1,
          n = 1,
          r = Qd;

      function i(i) {
        return i.x = e / 2, i.y = n / 2, t ? i.eachBefore(ep(t)).eachAfter(np(r, .5)).eachBefore(rp(1)) : i.eachBefore(ep(Jd)).eachAfter(np(Qd, 1)).eachAfter(np(r, i.r / Math.min(e, n))).eachBefore(rp(Math.min(e, n) / (2 * i.r))), i;
      }

      return i.radius = function (e) {
        return arguments.length ? (t = Xd(e), i) : t;
      }, i.size = function (t) {
        return arguments.length ? (e = +t[0], n = +t[1], i) : [e, n];
      }, i.padding = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : Kd(+t), i) : r;
      }, i;
    }

    function ep(t) {
      return function (e) {
        e.children || (e.r = Math.max(0, +t(e) || 0));
      };
    }

    function np(t, e) {
      return function (n) {
        if (r = n.children) {
          var r,
              i,
              a,
              o = r.length,
              s = t(n) * e || 0;
          if (s) for (i = 0; i < o; ++i) {
            r[i].r += s;
          }
          if (a = Vd(r), s) for (i = 0; i < o; ++i) {
            r[i].r -= s;
          }
          n.r = a + s;
        }
      };
    }

    function rp(t) {
      return function (e) {
        var n = e.parent;
        e.r *= t, n && (e.x = n.x + t * e.x, e.y = n.y + t * e.y);
      };
    }

    function ip(t) {
      t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
    }

    function ap(t, e, n, r, i) {
      for (var a, o = t.children, s = -1, c = o.length, u = t.value && (r - e) / t.value; ++s < c;) {
        (a = o[s]).y0 = n, a.y1 = i, a.x0 = e, a.x1 = e += a.value * u;
      }
    }

    function op() {
      var t = 1,
          e = 1,
          n = 0,
          r = !1;

      function i(i) {
        var a = i.height + 1;
        return i.x0 = i.y0 = n, i.x1 = t, i.y1 = e / a, i.eachBefore(function (t, e) {
          return function (r) {
            r.children && ap(r, r.x0, t * (r.depth + 1) / e, r.x1, t * (r.depth + 2) / e);
            var i = r.x0,
                a = r.y0,
                o = r.x1 - n,
                s = r.y1 - n;
            o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), r.x0 = i, r.y0 = a, r.x1 = o, r.y1 = s;
          };
        }(e, a)), r && i.eachBefore(ip), i;
      }

      return i.round = function (t) {
        return arguments.length ? (r = !!t, i) : r;
      }, i.size = function (n) {
        return arguments.length ? (t = +n[0], e = +n[1], i) : [t, e];
      }, i.padding = function (t) {
        return arguments.length ? (n = +t, i) : n;
      }, i;
    }

    var sp = {
      depth: -1
    },
        cp = {};

    function up(t) {
      return t.id;
    }

    function lp(t) {
      return t.parentId;
    }

    function hp() {
      var t = up,
          e = lp;

      function n(n) {
        var r,
            i,
            a,
            o,
            s,
            c,
            u,
            l = n.length,
            h = new Array(l),
            f = {};

        for (i = 0; i < l; ++i) {
          r = n[i], s = h[i] = new Bd(r), null != (c = t(r, i, n)) && (c += "") && (f[u = "$" + (s.id = c)] = u in f ? cp : s);
        }

        for (i = 0; i < l; ++i) {
          if (s = h[i], null != (c = e(n[i], i, n)) && (c += "")) {
            if (!(o = f["$" + c])) throw new Error("missing: " + c);
            if (o === cp) throw new Error("ambiguous: " + c);
            o.children ? o.children.push(s) : o.children = [s], s.parent = o;
          } else {
            if (a) throw new Error("multiple roots");
            a = s;
          }
        }

        if (!a) throw new Error("no root");
        if (a.parent = sp, a.eachBefore(function (t) {
          t.depth = t.parent.depth + 1, --l;
        }).eachBefore(Od), a.parent = null, l > 0) throw new Error("cycle");
        return a;
      }

      return n.id = function (e) {
        return arguments.length ? (t = Zd(e), n) : t;
      }, n.parentId = function (t) {
        return arguments.length ? (e = Zd(t), n) : e;
      }, n;
    }

    function fp(t, e) {
      return t.parent === e.parent ? 1 : 2;
    }

    function dp(t) {
      var e = t.children;
      return e ? e[0] : t.t;
    }

    function pp(t) {
      var e = t.children;
      return e ? e[e.length - 1] : t.t;
    }

    function yp(t, e, n) {
      var r = n / (e.i - t.i);
      e.c -= r, e.s += n, t.c += r, e.z += n, e.m += n;
    }

    function gp(t, e, n) {
      return t.a.parent === e.parent ? t.a : n;
    }

    function mp(t, e) {
      this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
    }

    function vp() {
      var t = fp,
          e = 1,
          n = 1,
          r = null;

      function i(i) {
        var c = function (t) {
          for (var e, n, r, i, a, o = new mp(t, 0), s = [o]; e = s.pop();) {
            if (r = e._.children) for (e.children = new Array(a = r.length), i = a - 1; i >= 0; --i) {
              s.push(n = e.children[i] = new mp(r[i], i)), n.parent = e;
            }
          }

          return (o.parent = new mp(null, 0)).children = [o], o;
        }(i);

        if (c.eachAfter(a), c.parent.m = -c.z, c.eachBefore(o), r) i.eachBefore(s);else {
          var u = i,
              l = i,
              h = i;
          i.eachBefore(function (t) {
            t.x < u.x && (u = t), t.x > l.x && (l = t), t.depth > h.depth && (h = t);
          });
          var f = u === l ? 1 : t(u, l) / 2,
              d = f - u.x,
              p = e / (l.x + f + d),
              y = n / (h.depth || 1);
          i.eachBefore(function (t) {
            t.x = (t.x + d) * p, t.y = t.depth * y;
          });
        }
        return i;
      }

      function a(e) {
        var n = e.children,
            r = e.parent.children,
            i = e.i ? r[e.i - 1] : null;

        if (n) {
          !function (t) {
            for (var e, n = 0, r = 0, i = t.children, a = i.length; --a >= 0;) {
              (e = i[a]).z += n, e.m += n, n += e.s + (r += e.c);
            }
          }(e);
          var a = (n[0].z + n[n.length - 1].z) / 2;
          i ? (e.z = i.z + t(e._, i._), e.m = e.z - a) : e.z = a;
        } else i && (e.z = i.z + t(e._, i._));

        e.parent.A = function (e, n, r) {
          if (n) {
            for (var i, a = e, o = e, s = n, c = a.parent.children[0], u = a.m, l = o.m, h = s.m, f = c.m; s = pp(s), a = dp(a), s && a;) {
              c = dp(c), (o = pp(o)).a = e, (i = s.z + h - a.z - u + t(s._, a._)) > 0 && (yp(gp(s, e, r), e, i), u += i, l += i), h += s.m, u += a.m, f += c.m, l += o.m;
            }

            s && !pp(o) && (o.t = s, o.m += h - l), a && !dp(c) && (c.t = a, c.m += u - f, r = e);
          }

          return r;
        }(e, i, e.parent.A || r[0]);
      }

      function o(t) {
        t._.x = t.z + t.parent.m, t.m += t.parent.m;
      }

      function s(t) {
        t.x *= e, t.y = t.depth * n;
      }

      return i.separation = function (e) {
        return arguments.length ? (t = e, i) : t;
      }, i.size = function (t) {
        return arguments.length ? (r = !1, e = +t[0], n = +t[1], i) : r ? null : [e, n];
      }, i.nodeSize = function (t) {
        return arguments.length ? (r = !0, e = +t[0], n = +t[1], i) : r ? [e, n] : null;
      }, i;
    }

    function bp(t, e, n, r, i) {
      for (var a, o = t.children, s = -1, c = o.length, u = t.value && (i - n) / t.value; ++s < c;) {
        (a = o[s]).x0 = e, a.x1 = r, a.y0 = n, a.y1 = n += a.value * u;
      }
    }

    mp.prototype = Object.create(Bd.prototype);

    var _p = (1 + Math.sqrt(5)) / 2;

    function xp(t, e, n, r, i, a) {
      for (var o, s, c, u, l, h, f, d, p, y, g, m = [], v = e.children, b = 0, _ = 0, x = v.length, w = e.value; b < x;) {
        c = i - n, u = a - r;

        do {
          l = v[_++].value;
        } while (!l && _ < x);

        for (h = f = l, g = l * l * (y = Math.max(u / c, c / u) / (w * t)), p = Math.max(f / g, g / h); _ < x; ++_) {
          if (l += s = v[_].value, s < h && (h = s), s > f && (f = s), g = l * l * y, (d = Math.max(f / g, g / h)) > p) {
            l -= s;
            break;
          }

          p = d;
        }

        m.push(o = {
          value: l,
          dice: c < u,
          children: v.slice(b, _)
        }), o.dice ? ap(o, n, r, i, w ? r += u * l / w : a) : bp(o, n, r, w ? n += c * l / w : i, a), w -= l, b = _;
      }

      return m;
    }

    var wp = function t(e) {
      function n(t, n, r, i, a) {
        xp(e, t, n, r, i, a);
      }

      return n.ratio = function (e) {
        return t((e = +e) > 1 ? e : 1);
      }, n;
    }(_p);

    function kp() {
      var t = wp,
          e = !1,
          n = 1,
          r = 1,
          i = [0],
          a = Qd,
          o = Qd,
          s = Qd,
          c = Qd,
          u = Qd;

      function l(t) {
        return t.x0 = t.y0 = 0, t.x1 = n, t.y1 = r, t.eachBefore(h), i = [0], e && t.eachBefore(ip), t;
      }

      function h(e) {
        var n = i[e.depth],
            r = e.x0 + n,
            l = e.y0 + n,
            h = e.x1 - n,
            f = e.y1 - n;
        h < r && (r = h = (r + h) / 2), f < l && (l = f = (l + f) / 2), e.x0 = r, e.y0 = l, e.x1 = h, e.y1 = f, e.children && (n = i[e.depth + 1] = a(e) / 2, r += u(e) - n, l += o(e) - n, (h -= s(e) - n) < r && (r = h = (r + h) / 2), (f -= c(e) - n) < l && (l = f = (l + f) / 2), t(e, r, l, h, f));
      }

      return l.round = function (t) {
        return arguments.length ? (e = !!t, l) : e;
      }, l.size = function (t) {
        return arguments.length ? (n = +t[0], r = +t[1], l) : [n, r];
      }, l.tile = function (e) {
        return arguments.length ? (t = Zd(e), l) : t;
      }, l.padding = function (t) {
        return arguments.length ? l.paddingInner(t).paddingOuter(t) : l.paddingInner();
      }, l.paddingInner = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : Kd(+t), l) : a;
      }, l.paddingOuter = function (t) {
        return arguments.length ? l.paddingTop(t).paddingRight(t).paddingBottom(t).paddingLeft(t) : l.paddingTop();
      }, l.paddingTop = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : Kd(+t), l) : o;
      }, l.paddingRight = function (t) {
        return arguments.length ? (s = "function" == typeof t ? t : Kd(+t), l) : s;
      }, l.paddingBottom = function (t) {
        return arguments.length ? (c = "function" == typeof t ? t : Kd(+t), l) : c;
      }, l.paddingLeft = function (t) {
        return arguments.length ? (u = "function" == typeof t ? t : Kd(+t), l) : u;
      }, l;
    }

    function Tp(t, e, n, r, i) {
      var a,
          o,
          s = t.children,
          c = s.length,
          u = new Array(c + 1);

      for (u[0] = o = a = 0; a < c; ++a) {
        u[a + 1] = o += s[a].value;
      }

      !function t(e, n, r, i, a, o, c) {
        if (e >= n - 1) {
          var l = s[e];
          return l.x0 = i, l.y0 = a, l.x1 = o, void (l.y1 = c);
        }

        for (var h = u[e], f = r / 2 + h, d = e + 1, p = n - 1; d < p;) {
          var y = d + p >>> 1;
          u[y] < f ? d = y + 1 : p = y;
        }

        f - u[d - 1] < u[d] - f && e + 1 < d && --d;
        var g = u[d] - h,
            m = r - g;

        if (o - i > c - a) {
          var v = (i * m + o * g) / r;
          t(e, d, g, i, a, v, c), t(d, n, m, v, a, o, c);
        } else {
          var b = (a * m + c * g) / r;
          t(e, d, g, i, a, o, b), t(d, n, m, i, b, o, c);
        }
      }(0, c, t.value, e, n, r, i);
    }

    function Ep(t, e, n, r, i) {
      (1 & t.depth ? bp : ap)(t, e, n, r, i);
    }

    var Cp = function t(e) {
      function n(t, n, r, i, a) {
        if ((o = t._squarify) && o.ratio === e) for (var o, s, c, u, l, h = -1, f = o.length, d = t.value; ++h < f;) {
          for (c = (s = o[h]).children, u = s.value = 0, l = c.length; u < l; ++u) {
            s.value += c[u].value;
          }

          s.dice ? ap(s, n, r, i, r += (a - r) * s.value / d) : bp(s, n, r, n += (i - n) * s.value / d, a), d -= s.value;
        } else t._squarify = o = xp(e, t, n, r, i, a), o.ratio = e;
      }

      return n.ratio = function (e) {
        return t((e = +e) > 1 ? e : 1);
      }, n;
    }(_p);

    function Sp(t) {
      var e = t.length;
      return function (n) {
        return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
      };
    }

    function Ap(t, e) {
      var n = dn(+t, +e);
      return function (t) {
        var e = n(t);
        return e - 360 * Math.floor(e / 360);
      };
    }

    function Mp(t, e) {
      return t = +t, e = +e, function (n) {
        return Math.round(t * (1 - n) + e * n);
      };
    }

    var Np = Math.SQRT2;

    function Dp(t) {
      return ((t = Math.exp(t)) + 1 / t) / 2;
    }

    function Op(t, e) {
      var n,
          r,
          i = t[0],
          a = t[1],
          o = t[2],
          s = e[0],
          c = e[1],
          u = e[2],
          l = s - i,
          h = c - a,
          f = l * l + h * h;
      if (f < 1e-12) r = Math.log(u / o) / Np, n = function n(t) {
        return [i + t * l, a + t * h, o * Math.exp(Np * t * r)];
      };else {
        var d = Math.sqrt(f),
            p = (u * u - o * o + 4 * f) / (2 * o * 2 * d),
            y = (u * u - o * o - 4 * f) / (2 * u * 2 * d),
            g = Math.log(Math.sqrt(p * p + 1) - p),
            m = Math.log(Math.sqrt(y * y + 1) - y);
        r = (m - g) / Np, n = function n(t) {
          var e,
              n = t * r,
              s = Dp(g),
              c = o / (2 * d) * (s * (e = Np * n + g, ((e = Math.exp(2 * e)) - 1) / (e + 1)) - function (t) {
            return ((t = Math.exp(t)) - 1 / t) / 2;
          }(g));

          return [i + c * l, a + c * h, o * s / Dp(Np * n + g)];
        };
      }
      return n.duration = 1e3 * r, n;
    }

    function Bp(t) {
      return function (e, n) {
        var r = t((e = an(e)).h, (n = an(n)).h),
            i = pn(e.s, n.s),
            a = pn(e.l, n.l),
            o = pn(e.opacity, n.opacity);
        return function (t) {
          return e.h = r(t), e.s = i(t), e.l = a(t), e.opacity = o(t), e + "";
        };
      };
    }

    var Lp = Bp(dn);
    var Ip = Bp(pn);

    function Rp(t, e) {
      var n = pn((t = Ta(t)).l, (e = Ta(e)).l),
          r = pn(t.a, e.a),
          i = pn(t.b, e.b),
          a = pn(t.opacity, e.opacity);
      return function (e) {
        return t.l = n(e), t.a = r(e), t.b = i(e), t.opacity = a(e), t + "";
      };
    }

    function Fp(t) {
      return function (e, n) {
        var r = t((e = Oa(e)).h, (n = Oa(n)).h),
            i = pn(e.c, n.c),
            a = pn(e.l, n.l),
            o = pn(e.opacity, n.opacity);
        return function (t) {
          return e.h = r(t), e.c = i(t), e.l = a(t), e.opacity = o(t), e + "";
        };
      };
    }

    var Pp = Fp(dn);
    var jp = Fp(pn);

    function Yp(t) {
      return function e(n) {
        function r(e, r) {
          var i = t((e = Ha(e)).h, (r = Ha(r)).h),
              a = pn(e.s, r.s),
              o = pn(e.l, r.l),
              s = pn(e.opacity, r.opacity);
          return function (t) {
            return e.h = i(t), e.s = a(t), e.l = o(Math.pow(t, n)), e.opacity = s(t), e + "";
          };
        }

        return n = +n, r.gamma = e, r;
      }(1);
    }

    var zp = Yp(dn);
    var Up = Yp(pn);

    function qp(t, e) {
      for (var n = 0, r = e.length - 1, i = e[0], a = new Array(r < 0 ? 0 : r); n < r;) {
        a[n] = t(i, i = e[++n]);
      }

      return function (t) {
        var e = Math.max(0, Math.min(r - 1, Math.floor(t *= r)));
        return a[e](t - e);
      };
    }

    function Hp(t, e) {
      for (var n = new Array(e), r = 0; r < e; ++r) {
        n[r] = t(r / (e - 1));
      }

      return n;
    }

    function $p(t) {
      for (var e, n = -1, r = t.length, i = t[r - 1], a = 0; ++n < r;) {
        e = i, i = t[n], a += e[1] * i[0] - e[0] * i[1];
      }

      return a / 2;
    }

    function Wp(t) {
      for (var e, n, r = -1, i = t.length, a = 0, o = 0, s = t[i - 1], c = 0; ++r < i;) {
        e = s, s = t[r], c += n = e[0] * s[1] - s[0] * e[1], a += (e[0] + s[0]) * n, o += (e[1] + s[1]) * n;
      }

      return [a / (c *= 3), o / c];
    }

    function Vp(t, e, n) {
      return (e[0] - t[0]) * (n[1] - t[1]) - (e[1] - t[1]) * (n[0] - t[0]);
    }

    function Gp(t, e) {
      return t[0] - e[0] || t[1] - e[1];
    }

    function Xp(t) {
      for (var e = t.length, n = [0, 1], r = 2, i = 2; i < e; ++i) {
        for (; r > 1 && Vp(t[n[r - 2]], t[n[r - 1]], t[i]) <= 0;) {
          --r;
        }

        n[r++] = i;
      }

      return n.slice(0, r);
    }

    function Zp(t) {
      if ((n = t.length) < 3) return null;
      var e,
          n,
          r = new Array(n),
          i = new Array(n);

      for (e = 0; e < n; ++e) {
        r[e] = [+t[e][0], +t[e][1], e];
      }

      for (r.sort(Gp), e = 0; e < n; ++e) {
        i[e] = [r[e][0], -r[e][1]];
      }

      var a = Xp(r),
          o = Xp(i),
          s = o[0] === a[0],
          c = o[o.length - 1] === a[a.length - 1],
          u = [];

      for (e = a.length - 1; e >= 0; --e) {
        u.push(t[r[a[e]][2]]);
      }

      for (e = +s; e < o.length - c; ++e) {
        u.push(t[r[o[e]][2]]);
      }

      return u;
    }

    function Qp(t, e) {
      for (var n, r, i = t.length, a = t[i - 1], o = e[0], s = e[1], c = a[0], u = a[1], l = !1, h = 0; h < i; ++h) {
        n = (a = t[h])[0], (r = a[1]) > s != u > s && o < (c - n) * (s - r) / (u - r) + n && (l = !l), c = n, u = r;
      }

      return l;
    }

    function Kp(t) {
      for (var e, n, r = -1, i = t.length, a = t[i - 1], o = a[0], s = a[1], c = 0; ++r < i;) {
        e = o, n = s, e -= o = (a = t[r])[0], n -= s = a[1], c += Math.sqrt(e * e + n * n);
      }

      return c;
    }

    function Jp() {
      return Math.random();
    }

    var ty = function t(e) {
      function n(t, n) {
        return t = null == t ? 0 : +t, n = null == n ? 1 : +n, 1 === arguments.length ? (n = t, t = 0) : n -= t, function () {
          return e() * n + t;
        };
      }

      return n.source = t, n;
    }(Jp),
        ey = function t(e) {
      function n(t, n) {
        var r, i;
        return t = null == t ? 0 : +t, n = null == n ? 1 : +n, function () {
          var a;
          if (null != r) a = r, r = null;else do {
            r = 2 * e() - 1, a = 2 * e() - 1, i = r * r + a * a;
          } while (!i || i > 1);
          return t + n * a * Math.sqrt(-2 * Math.log(i) / i);
        };
      }

      return n.source = t, n;
    }(Jp),
        ny = function t(e) {
      function n() {
        var t = ey.source(e).apply(this, arguments);
        return function () {
          return Math.exp(t());
        };
      }

      return n.source = t, n;
    }(Jp),
        ry = function t(e) {
      function n(t) {
        return function () {
          for (var n = 0, r = 0; r < t; ++r) {
            n += e();
          }

          return n;
        };
      }

      return n.source = t, n;
    }(Jp),
        iy = function t(e) {
      function n(t) {
        var n = ry.source(e)(t);
        return function () {
          return n() / t;
        };
      }

      return n.source = t, n;
    }(Jp),
        ay = function t(e) {
      function n(t) {
        return function () {
          return -Math.log(1 - e()) / t;
        };
      }

      return n.source = t, n;
    }(Jp);

    function oy(t, e) {
      switch (arguments.length) {
        case 0:
          break;

        case 1:
          this.range(t);
          break;

        default:
          this.range(e).domain(t);
      }

      return this;
    }

    function sy(t, e) {
      switch (arguments.length) {
        case 0:
          break;

        case 1:
          this.interpolator(t);
          break;

        default:
          this.interpolator(e).domain(t);
      }

      return this;
    }

    var cy = Array.prototype,
        uy = cy.map,
        ly = cy.slice,
        hy = {
      name: "implicit"
    };

    function fy() {
      var t = na(),
          e = [],
          n = [],
          r = hy;

      function i(i) {
        var a = i + "",
            o = t.get(a);

        if (!o) {
          if (r !== hy) return r;
          t.set(a, o = e.push(i));
        }

        return n[(o - 1) % n.length];
      }

      return i.domain = function (n) {
        if (!arguments.length) return e.slice();
        e = [], t = na();

        for (var r, a, o = -1, s = n.length; ++o < s;) {
          t.has(a = (r = n[o]) + "") || t.set(a, e.push(r));
        }

        return i;
      }, i.range = function (t) {
        return arguments.length ? (n = ly.call(t), i) : n.slice();
      }, i.unknown = function (t) {
        return arguments.length ? (r = t, i) : r;
      }, i.copy = function () {
        return fy(e, n).unknown(r);
      }, oy.apply(i, arguments), i;
    }

    function dy() {
      var t,
          e,
          n = fy().unknown(void 0),
          r = n.domain,
          i = n.range,
          a = [0, 1],
          o = !1,
          s = 0,
          c = 0,
          u = .5;

      function l() {
        var n = r().length,
            l = a[1] < a[0],
            h = a[l - 0],
            f = a[1 - l];
        t = (f - h) / Math.max(1, n - s + 2 * c), o && (t = Math.floor(t)), h += (f - h - t * (n - s)) * u, e = t * (1 - s), o && (h = Math.round(h), e = Math.round(e));
        var d = k(n).map(function (e) {
          return h + t * e;
        });
        return i(l ? d.reverse() : d);
      }

      return delete n.unknown, n.domain = function (t) {
        return arguments.length ? (r(t), l()) : r();
      }, n.range = function (t) {
        return arguments.length ? (a = [+t[0], +t[1]], l()) : a.slice();
      }, n.rangeRound = function (t) {
        return a = [+t[0], +t[1]], o = !0, l();
      }, n.bandwidth = function () {
        return e;
      }, n.step = function () {
        return t;
      }, n.round = function (t) {
        return arguments.length ? (o = !!t, l()) : o;
      }, n.padding = function (t) {
        return arguments.length ? (s = Math.min(1, c = +t), l()) : s;
      }, n.paddingInner = function (t) {
        return arguments.length ? (s = Math.min(1, t), l()) : s;
      }, n.paddingOuter = function (t) {
        return arguments.length ? (c = +t, l()) : c;
      }, n.align = function (t) {
        return arguments.length ? (u = Math.max(0, Math.min(1, t)), l()) : u;
      }, n.copy = function () {
        return dy(r(), a).round(o).paddingInner(s).paddingOuter(c).align(u);
      }, oy.apply(l(), arguments);
    }

    function py(t) {
      var e = t.copy;
      return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function () {
        return py(e());
      }, t;
    }

    function yy() {
      return py(dy.apply(null, arguments).paddingInner(1));
    }

    function gy(t) {
      return +t;
    }

    var my = [0, 1];

    function vy(t) {
      return t;
    }

    function by(t, e) {
      return (e -= t = +t) ? function (n) {
        return (n - t) / e;
      } : (n = isNaN(e) ? NaN : .5, function () {
        return n;
      });
      var n;
    }

    function _y(t) {
      var e,
          n = t[0],
          r = t[t.length - 1];
      return n > r && (e = n, n = r, r = e), function (t) {
        return Math.max(n, Math.min(r, t));
      };
    }

    function xy(t, e, n) {
      var r = t[0],
          i = t[1],
          a = e[0],
          o = e[1];
      return i < r ? (r = by(i, r), a = n(o, a)) : (r = by(r, i), a = n(a, o)), function (t) {
        return a(r(t));
      };
    }

    function wy(t, e, n) {
      var r = Math.min(t.length, e.length) - 1,
          i = new Array(r),
          a = new Array(r),
          o = -1;

      for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r;) {
        i[o] = by(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
      }

      return function (e) {
        var n = u(t, e, 1, r) - 1;
        return a[n](i[n](e));
      };
    }

    function ky(t, e) {
      return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
    }

    function Ty() {
      var t,
          e,
          n,
          r,
          i,
          a,
          o = my,
          s = my,
          c = Mn,
          u = vy;

      function l() {
        return r = Math.min(o.length, s.length) > 2 ? wy : xy, i = a = null, h;
      }

      function h(e) {
        return isNaN(e = +e) ? n : (i || (i = r(o.map(t), s, c)))(t(u(e)));
      }

      return h.invert = function (n) {
        return u(e((a || (a = r(s, o.map(t), Tn)))(n)));
      }, h.domain = function (t) {
        return arguments.length ? (o = uy.call(t, gy), u === vy || (u = _y(o)), l()) : o.slice();
      }, h.range = function (t) {
        return arguments.length ? (s = ly.call(t), l()) : s.slice();
      }, h.rangeRound = function (t) {
        return s = ly.call(t), c = Mp, l();
      }, h.clamp = function (t) {
        return arguments.length ? (u = t ? _y(o) : vy, h) : u !== vy;
      }, h.interpolate = function (t) {
        return arguments.length ? (c = t, l()) : c;
      }, h.unknown = function (t) {
        return arguments.length ? (n = t, h) : n;
      }, function (n, r) {
        return t = n, e = r, l();
      };
    }

    function Ey(t, e) {
      return Ty()(t, e);
    }

    function Cy(t, e, n, r) {
      var i,
          a = M(t, e, n);

      switch ((r = cc(null == r ? ",f" : r)).type) {
        case "s":
          var o = Math.max(Math.abs(t), Math.abs(e));
          return null != r.precision || isNaN(i = xc(a, o)) || (r.precision = i), yc(r, o);

        case "":
        case "e":
        case "g":
        case "p":
        case "r":
          null != r.precision || isNaN(i = wc(a, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
          break;

        case "f":
        case "%":
          null != r.precision || isNaN(i = _c(a)) || (r.precision = i - 2 * ("%" === r.type));
      }

      return pc(r);
    }

    function Sy(t) {
      var e = t.domain;
      return t.ticks = function (t) {
        var n = e();
        return S(n[0], n[n.length - 1], null == t ? 10 : t);
      }, t.tickFormat = function (t, n) {
        var r = e();
        return Cy(r[0], r[r.length - 1], null == t ? 10 : t, n);
      }, t.nice = function (n) {
        null == n && (n = 10);
        var r,
            i = e(),
            a = 0,
            o = i.length - 1,
            s = i[a],
            c = i[o];
        return c < s && (r = s, s = c, c = r, r = a, a = o, o = r), (r = A(s, c, n)) > 0 ? r = A(s = Math.floor(s / r) * r, c = Math.ceil(c / r) * r, n) : r < 0 && (r = A(s = Math.ceil(s * r) / r, c = Math.floor(c * r) / r, n)), r > 0 ? (i[a] = Math.floor(s / r) * r, i[o] = Math.ceil(c / r) * r, e(i)) : r < 0 && (i[a] = Math.ceil(s * r) / r, i[o] = Math.floor(c * r) / r, e(i)), t;
      }, t;
    }

    function Ay() {
      var t = Ey(vy, vy);
      return t.copy = function () {
        return ky(t, Ay());
      }, oy.apply(t, arguments), Sy(t);
    }

    function My(t) {
      var e;

      function n(t) {
        return isNaN(t = +t) ? e : t;
      }

      return n.invert = n, n.domain = n.range = function (e) {
        return arguments.length ? (t = uy.call(e, gy), n) : t.slice();
      }, n.unknown = function (t) {
        return arguments.length ? (e = t, n) : e;
      }, n.copy = function () {
        return My(t).unknown(e);
      }, t = arguments.length ? uy.call(t, gy) : [0, 1], Sy(n);
    }

    function Ny(t, e) {
      var n,
          r = 0,
          i = (t = t.slice()).length - 1,
          a = t[r],
          o = t[i];
      return o < a && (n = r, r = i, i = n, n = a, a = o, o = n), t[r] = e.floor(a), t[i] = e.ceil(o), t;
    }

    function Dy(t) {
      return Math.log(t);
    }

    function Oy(t) {
      return Math.exp(t);
    }

    function By(t) {
      return -Math.log(-t);
    }

    function Ly(t) {
      return -Math.exp(-t);
    }

    function Iy(t) {
      return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
    }

    function Ry(t) {
      return function (e) {
        return -t(-e);
      };
    }

    function Fy(t) {
      var e,
          n,
          r = t(Dy, Oy),
          i = r.domain,
          a = 10;

      function o() {
        return e = function (t) {
          return t === Math.E ? Math.log : 10 === t && Math.log10 || 2 === t && Math.log2 || (t = Math.log(t), function (e) {
            return Math.log(e) / t;
          });
        }(a), n = function (t) {
          return 10 === t ? Iy : t === Math.E ? Math.exp : function (e) {
            return Math.pow(t, e);
          };
        }(a), i()[0] < 0 ? (e = Ry(e), n = Ry(n), t(By, Ly)) : t(Dy, Oy), r;
      }

      return r.base = function (t) {
        return arguments.length ? (a = +t, o()) : a;
      }, r.domain = function (t) {
        return arguments.length ? (i(t), o()) : i();
      }, r.ticks = function (t) {
        var r,
            o = i(),
            s = o[0],
            c = o[o.length - 1];
        (r = c < s) && (f = s, s = c, c = f);
        var u,
            l,
            h,
            f = e(s),
            d = e(c),
            p = null == t ? 10 : +t,
            y = [];

        if (!(a % 1) && d - f < p) {
          if (f = Math.round(f) - 1, d = Math.round(d) + 1, s > 0) {
            for (; f < d; ++f) {
              for (l = 1, u = n(f); l < a; ++l) {
                if (!((h = u * l) < s)) {
                  if (h > c) break;
                  y.push(h);
                }
              }
            }
          } else for (; f < d; ++f) {
            for (l = a - 1, u = n(f); l >= 1; --l) {
              if (!((h = u * l) < s)) {
                if (h > c) break;
                y.push(h);
              }
            }
          }
        } else y = S(f, d, Math.min(d - f, p)).map(n);

        return r ? y.reverse() : y;
      }, r.tickFormat = function (t, i) {
        if (null == i && (i = 10 === a ? ".0e" : ","), "function" != typeof i && (i = pc(i)), t === 1 / 0) return i;
        null == t && (t = 10);
        var o = Math.max(1, a * t / r.ticks().length);
        return function (t) {
          var r = t / n(Math.round(e(t)));
          return r * a < a - .5 && (r *= a), r <= o ? i(t) : "";
        };
      }, r.nice = function () {
        return i(Ny(i(), {
          floor: function floor(t) {
            return n(Math.floor(e(t)));
          },
          ceil: function ceil(t) {
            return n(Math.ceil(e(t)));
          }
        }));
      }, r;
    }

    function Py() {
      var t = Fy(Ty()).domain([1, 10]);
      return t.copy = function () {
        return ky(t, Py()).base(t.base());
      }, oy.apply(t, arguments), t;
    }

    function jy(t) {
      return function (e) {
        return Math.sign(e) * Math.log1p(Math.abs(e / t));
      };
    }

    function Yy(t) {
      return function (e) {
        return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
      };
    }

    function zy(t) {
      var e = 1,
          n = t(jy(e), Yy(e));
      return n.constant = function (n) {
        return arguments.length ? t(jy(e = +n), Yy(e)) : e;
      }, Sy(n);
    }

    function Uy() {
      var t = zy(Ty());
      return t.copy = function () {
        return ky(t, Uy()).constant(t.constant());
      }, oy.apply(t, arguments);
    }

    function qy(t) {
      return function (e) {
        return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
      };
    }

    function Hy(t) {
      return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
    }

    function $y(t) {
      return t < 0 ? -t * t : t * t;
    }

    function Wy(t) {
      var e = t(vy, vy),
          n = 1;

      function r() {
        return 1 === n ? t(vy, vy) : .5 === n ? t(Hy, $y) : t(qy(n), qy(1 / n));
      }

      return e.exponent = function (t) {
        return arguments.length ? (n = +t, r()) : n;
      }, Sy(e);
    }

    function Vy() {
      var t = Wy(Ty());
      return t.copy = function () {
        return ky(t, Vy()).exponent(t.exponent());
      }, oy.apply(t, arguments), t;
    }

    function Gy() {
      return Vy.apply(null, arguments).exponent(.5);
    }

    function Xy() {
      var t,
          e = [],
          n = [],
          r = [];

      function a() {
        var t = 0,
            i = Math.max(1, n.length);

        for (r = new Array(i - 1); ++t < i;) {
          r[t - 1] = O(e, t / i);
        }

        return o;
      }

      function o(e) {
        return isNaN(e = +e) ? t : n[u(r, e)];
      }

      return o.invertExtent = function (t) {
        var i = n.indexOf(t);
        return i < 0 ? [NaN, NaN] : [i > 0 ? r[i - 1] : e[0], i < r.length ? r[i] : e[e.length - 1]];
      }, o.domain = function (t) {
        if (!arguments.length) return e.slice();
        e = [];

        for (var n, r = 0, o = t.length; r < o; ++r) {
          null == (n = t[r]) || isNaN(n = +n) || e.push(n);
        }

        return e.sort(i), a();
      }, o.range = function (t) {
        return arguments.length ? (n = ly.call(t), a()) : n.slice();
      }, o.unknown = function (e) {
        return arguments.length ? (t = e, o) : t;
      }, o.quantiles = function () {
        return r.slice();
      }, o.copy = function () {
        return Xy().domain(e).range(n).unknown(t);
      }, oy.apply(o, arguments);
    }

    function Zy() {
      var t,
          e = 0,
          n = 1,
          r = 1,
          i = [.5],
          a = [0, 1];

      function o(e) {
        return e <= e ? a[u(i, e, 0, r)] : t;
      }

      function s() {
        var t = -1;

        for (i = new Array(r); ++t < r;) {
          i[t] = ((t + 1) * n - (t - r) * e) / (r + 1);
        }

        return o;
      }

      return o.domain = function (t) {
        return arguments.length ? (e = +t[0], n = +t[1], s()) : [e, n];
      }, o.range = function (t) {
        return arguments.length ? (r = (a = ly.call(t)).length - 1, s()) : a.slice();
      }, o.invertExtent = function (t) {
        var o = a.indexOf(t);
        return o < 0 ? [NaN, NaN] : o < 1 ? [e, i[0]] : o >= r ? [i[r - 1], n] : [i[o - 1], i[o]];
      }, o.unknown = function (e) {
        return arguments.length ? (t = e, o) : o;
      }, o.thresholds = function () {
        return i.slice();
      }, o.copy = function () {
        return Zy().domain([e, n]).range(a).unknown(t);
      }, oy.apply(Sy(o), arguments);
    }

    function Qy() {
      var t,
          e = [.5],
          n = [0, 1],
          r = 1;

      function i(i) {
        return i <= i ? n[u(e, i, 0, r)] : t;
      }

      return i.domain = function (t) {
        return arguments.length ? (e = ly.call(t), r = Math.min(e.length, n.length - 1), i) : e.slice();
      }, i.range = function (t) {
        return arguments.length ? (n = ly.call(t), r = Math.min(e.length, n.length - 1), i) : n.slice();
      }, i.invertExtent = function (t) {
        var r = n.indexOf(t);
        return [e[r - 1], e[r]];
      }, i.unknown = function (e) {
        return arguments.length ? (t = e, i) : t;
      }, i.copy = function () {
        return Qy().domain(e).range(n).unknown(t);
      }, oy.apply(i, arguments);
    }

    var Ky = new Date(),
        Jy = new Date();

    function tg(t, e, n, r) {
      function i(e) {
        return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
      }

      return i.floor = function (e) {
        return t(e = new Date(+e)), e;
      }, i.ceil = function (n) {
        return t(n = new Date(n - 1)), e(n, 1), t(n), n;
      }, i.round = function (t) {
        var e = i(t),
            n = i.ceil(t);
        return t - e < n - t ? e : n;
      }, i.offset = function (t, n) {
        return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
      }, i.range = function (n, r, a) {
        var o,
            s = [];
        if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

        do {
          s.push(o = new Date(+n)), e(n, a), t(n);
        } while (o < n && n < r);

        return s;
      }, i.filter = function (n) {
        return tg(function (e) {
          if (e >= e) for (; t(e), !n(e);) {
            e.setTime(e - 1);
          }
        }, function (t, r) {
          if (t >= t) if (r < 0) for (; ++r <= 0;) {
            for (; e(t, -1), !n(t);) {
              ;
            }
          } else for (; --r >= 0;) {
            for (; e(t, 1), !n(t);) {
              ;
            }
          }
        });
      }, n && (i.count = function (e, r) {
        return Ky.setTime(+e), Jy.setTime(+r), t(Ky), t(Jy), Math.floor(n(Ky, Jy));
      }, i.every = function (t) {
        return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
          return r(e) % t == 0;
        } : function (e) {
          return i.count(0, e) % t == 0;
        }) : i : null;
      }), i;
    }

    var eg = tg(function (t) {
      t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setFullYear(t.getFullYear() + e);
    }, function (t, e) {
      return e.getFullYear() - t.getFullYear();
    }, function (t) {
      return t.getFullYear();
    });

    eg.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? tg(function (e) {
        e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setFullYear(e.getFullYear() + n * t);
      }) : null;
    };

    var ng = eg;
    var rg = eg.range,
        ig = tg(function (t) {
      t.setDate(1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setMonth(t.getMonth() + e);
    }, function (t, e) {
      return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
    }, function (t) {
      return t.getMonth();
    });
    var ag = ig;
    var og = ig.range,
        sg = 1e3,
        cg = 6e4,
        ug = 36e5,
        lg = 864e5,
        hg = 6048e5;

    function fg(t) {
      return tg(function (e) {
        e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setDate(t.getDate() + 7 * e);
      }, function (t, e) {
        return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * cg) / hg;
      });
    }

    var dg = fg(0),
        pg = fg(1),
        yg = fg(2),
        gg = fg(3),
        mg = fg(4),
        vg = fg(5),
        bg = fg(6),
        _g = dg.range,
        xg = pg.range,
        wg = yg.range,
        kg = gg.range,
        Tg = mg.range,
        Eg = vg.range,
        Cg = bg.range,
        Sg = tg(function (t) {
      t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setDate(t.getDate() + e);
    }, function (t, e) {
      return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * cg) / lg;
    }, function (t) {
      return t.getDate() - 1;
    });
    var Ag = Sg;
    var Mg = Sg.range,
        Ng = tg(function (t) {
      t.setTime(t - t.getMilliseconds() - t.getSeconds() * sg - t.getMinutes() * cg);
    }, function (t, e) {
      t.setTime(+t + e * ug);
    }, function (t, e) {
      return (e - t) / ug;
    }, function (t) {
      return t.getHours();
    });
    var Dg = Ng;
    var Og = Ng.range,
        Bg = tg(function (t) {
      t.setTime(t - t.getMilliseconds() - t.getSeconds() * sg);
    }, function (t, e) {
      t.setTime(+t + e * cg);
    }, function (t, e) {
      return (e - t) / cg;
    }, function (t) {
      return t.getMinutes();
    });
    var Lg = Bg;
    var Ig = Bg.range,
        Rg = tg(function (t) {
      t.setTime(t - t.getMilliseconds());
    }, function (t, e) {
      t.setTime(+t + e * sg);
    }, function (t, e) {
      return (e - t) / sg;
    }, function (t) {
      return t.getUTCSeconds();
    });
    var Fg = Rg;
    var Pg = Rg.range,
        jg = tg(function () {}, function (t, e) {
      t.setTime(+t + e);
    }, function (t, e) {
      return e - t;
    });

    jg.every = function (t) {
      return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? tg(function (e) {
        e.setTime(Math.floor(e / t) * t);
      }, function (e, n) {
        e.setTime(+e + n * t);
      }, function (e, n) {
        return (n - e) / t;
      }) : jg : null;
    };

    var Yg = jg;
    var zg = jg.range;

    function Ug(t) {
      return tg(function (e) {
        e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setUTCDate(t.getUTCDate() + 7 * e);
      }, function (t, e) {
        return (e - t) / hg;
      });
    }

    var qg = Ug(0),
        Hg = Ug(1),
        $g = Ug(2),
        Wg = Ug(3),
        Vg = Ug(4),
        Gg = Ug(5),
        Xg = Ug(6),
        Zg = qg.range,
        Qg = Hg.range,
        Kg = $g.range,
        Jg = Wg.range,
        tm = Vg.range,
        em = Gg.range,
        nm = Xg.range,
        rm = tg(function (t) {
      t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCDate(t.getUTCDate() + e);
    }, function (t, e) {
      return (e - t) / lg;
    }, function (t) {
      return t.getUTCDate() - 1;
    });
    var im = rm;
    var am = rm.range,
        om = tg(function (t) {
      t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCFullYear(t.getUTCFullYear() + e);
    }, function (t, e) {
      return e.getUTCFullYear() - t.getUTCFullYear();
    }, function (t) {
      return t.getUTCFullYear();
    });

    om.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? tg(function (e) {
        e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setUTCFullYear(e.getUTCFullYear() + n * t);
      }) : null;
    };

    var sm = om;
    var cm = om.range;

    function um(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
        return e.setFullYear(t.y), e;
      }

      return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
    }

    function lm(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
        return e.setUTCFullYear(t.y), e;
      }

      return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
    }

    function hm(t, e, n) {
      return {
        y: t,
        m: e,
        d: n,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    function fm(t) {
      var e = t.dateTime,
          n = t.date,
          r = t.time,
          i = t.periods,
          a = t.days,
          o = t.shortDays,
          s = t.months,
          c = t.shortMonths,
          u = Tm(i),
          l = Em(i),
          h = Tm(a),
          f = Em(a),
          d = Tm(o),
          p = Em(o),
          y = Tm(s),
          g = Em(s),
          m = Tm(c),
          v = Em(c),
          b = {
        a: function a(t) {
          return o[t.getDay()];
        },
        A: function A(t) {
          return a[t.getDay()];
        },
        b: function b(t) {
          return c[t.getMonth()];
        },
        B: function B(t) {
          return s[t.getMonth()];
        },
        c: null,
        d: Wm,
        e: Wm,
        f: Qm,
        g: cv,
        G: lv,
        H: Vm,
        I: Gm,
        j: Xm,
        L: Zm,
        m: Km,
        M: Jm,
        p: function p(t) {
          return i[+(t.getHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getMonth() / 3);
        },
        Q: Bv,
        s: Lv,
        S: tv,
        u: ev,
        U: nv,
        V: iv,
        w: av,
        W: ov,
        x: null,
        X: null,
        y: sv,
        Y: uv,
        Z: hv,
        "%": Ov
      },
          _ = {
        a: function a(t) {
          return o[t.getUTCDay()];
        },
        A: function A(t) {
          return a[t.getUTCDay()];
        },
        b: function b(t) {
          return c[t.getUTCMonth()];
        },
        B: function B(t) {
          return s[t.getUTCMonth()];
        },
        c: null,
        d: fv,
        e: fv,
        f: mv,
        g: Av,
        G: Nv,
        H: dv,
        I: pv,
        j: yv,
        L: gv,
        m: vv,
        M: bv,
        p: function p(t) {
          return i[+(t.getUTCHours() >= 12)];
        },
        q: function q(t) {
          return 1 + ~~(t.getUTCMonth() / 3);
        },
        Q: Bv,
        s: Lv,
        S: _v,
        u: xv,
        U: wv,
        V: Tv,
        w: Ev,
        W: Cv,
        x: null,
        X: null,
        y: Sv,
        Y: Mv,
        Z: Dv,
        "%": Ov
      },
          x = {
        a: function a(t, e, n) {
          var r = d.exec(e.slice(n));
          return r ? (t.w = p[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        A: function A(t, e, n) {
          var r = h.exec(e.slice(n));
          return r ? (t.w = f[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        b: function b(t, e, n) {
          var r = m.exec(e.slice(n));
          return r ? (t.m = v[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        B: function B(t, e, n) {
          var r = y.exec(e.slice(n));
          return r ? (t.m = g[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        c: function c(t, n, r) {
          return T(t, e, n, r);
        },
        d: Rm,
        e: Rm,
        f: Um,
        g: Om,
        G: Dm,
        H: Pm,
        I: Pm,
        j: Fm,
        L: zm,
        m: Im,
        M: jm,
        p: function p(t, e, n) {
          var r = u.exec(e.slice(n));
          return r ? (t.p = l[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        q: Lm,
        Q: Hm,
        s: $m,
        S: Ym,
        u: Sm,
        U: Am,
        V: Mm,
        w: Cm,
        W: Nm,
        x: function x(t, e, r) {
          return T(t, n, e, r);
        },
        X: function X(t, e, n) {
          return T(t, r, e, n);
        },
        y: Om,
        Y: Dm,
        Z: Bm,
        "%": qm
      };

      function w(t, e) {
        return function (n) {
          var r,
              i,
              a,
              o = [],
              s = -1,
              c = 0,
              u = t.length;

          for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
            37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = vm[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
          }

          return o.push(t.slice(c, s)), o.join("");
        };
      }

      function k(t, e) {
        return function (n) {
          var r,
              i,
              a = hm(1900, void 0, 1);
          if (T(a, t, n += "", 0) != n.length) return null;
          if ("Q" in a) return new Date(a.Q);
          if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

          if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
            if (a.V < 1 || a.V > 53) return null;
            "w" in a || (a.w = 1), "Z" in a ? (i = (r = lm(hm(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? Hg.ceil(r) : Hg(r), r = im.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = um(hm(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? pg.ceil(r) : pg(r), r = Ag.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
          } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? lm(hm(a.y, 0, 1)).getUTCDay() : um(hm(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

          return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, lm(a)) : um(a);
        };
      }

      function T(t, e, n, r) {
        for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
          if (r >= c) return -1;

          if (37 === (i = e.charCodeAt(o++))) {
            if (i = e.charAt(o++), !(a = x[i in vm ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
          } else if (i != n.charCodeAt(r++)) return -1;
        }

        return r;
      }

      return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
        format: function format(t) {
          var e = w(t += "", b);
          return e.toString = function () {
            return t;
          }, e;
        },
        parse: function parse(t) {
          var e = k(t += "", !1);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcFormat: function utcFormat(t) {
          var e = w(t += "", _);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcParse: function utcParse(t) {
          var e = k(t += "", !0);
          return e.toString = function () {
            return t;
          }, e;
        }
      };
    }

    var dm,
        pm,
        ym,
        gm,
        mm,
        vm = {
      "-": "",
      _: " ",
      0: "0"
    },
        bm = /^\s*\d+/,
        _m = /^%/,
        xm = /[\\^$*+?|[\]().{}]/g;

    function wm(t, e, n) {
      var r = t < 0 ? "-" : "",
          i = (r ? -t : t) + "",
          a = i.length;
      return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
    }

    function km(t) {
      return t.replace(xm, "\\$&");
    }

    function Tm(t) {
      return new RegExp("^(?:" + t.map(km).join("|") + ")", "i");
    }

    function Em(t) {
      for (var e = {}, n = -1, r = t.length; ++n < r;) {
        e[t[n].toLowerCase()] = n;
      }

      return e;
    }

    function Cm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 1));
      return r ? (t.w = +r[0], n + r[0].length) : -1;
    }

    function Sm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 1));
      return r ? (t.u = +r[0], n + r[0].length) : -1;
    }

    function Am(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.U = +r[0], n + r[0].length) : -1;
    }

    function Mm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.V = +r[0], n + r[0].length) : -1;
    }

    function Nm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.W = +r[0], n + r[0].length) : -1;
    }

    function Dm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 4));
      return r ? (t.y = +r[0], n + r[0].length) : -1;
    }

    function Om(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    }

    function Bm(t, e, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
      return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    }

    function Lm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 1));
      return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
    }

    function Im(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
    }

    function Rm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.d = +r[0], n + r[0].length) : -1;
    }

    function Fm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 3));
      return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
    }

    function Pm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.H = +r[0], n + r[0].length) : -1;
    }

    function jm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.M = +r[0], n + r[0].length) : -1;
    }

    function Ym(t, e, n) {
      var r = bm.exec(e.slice(n, n + 2));
      return r ? (t.S = +r[0], n + r[0].length) : -1;
    }

    function zm(t, e, n) {
      var r = bm.exec(e.slice(n, n + 3));
      return r ? (t.L = +r[0], n + r[0].length) : -1;
    }

    function Um(t, e, n) {
      var r = bm.exec(e.slice(n, n + 6));
      return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    }

    function qm(t, e, n) {
      var r = _m.exec(e.slice(n, n + 1));

      return r ? n + r[0].length : -1;
    }

    function Hm(t, e, n) {
      var r = bm.exec(e.slice(n));
      return r ? (t.Q = +r[0], n + r[0].length) : -1;
    }

    function $m(t, e, n) {
      var r = bm.exec(e.slice(n));
      return r ? (t.s = +r[0], n + r[0].length) : -1;
    }

    function Wm(t, e) {
      return wm(t.getDate(), e, 2);
    }

    function Vm(t, e) {
      return wm(t.getHours(), e, 2);
    }

    function Gm(t, e) {
      return wm(t.getHours() % 12 || 12, e, 2);
    }

    function Xm(t, e) {
      return wm(1 + Ag.count(ng(t), t), e, 3);
    }

    function Zm(t, e) {
      return wm(t.getMilliseconds(), e, 3);
    }

    function Qm(t, e) {
      return Zm(t, e) + "000";
    }

    function Km(t, e) {
      return wm(t.getMonth() + 1, e, 2);
    }

    function Jm(t, e) {
      return wm(t.getMinutes(), e, 2);
    }

    function tv(t, e) {
      return wm(t.getSeconds(), e, 2);
    }

    function ev(t) {
      var e = t.getDay();
      return 0 === e ? 7 : e;
    }

    function nv(t, e) {
      return wm(dg.count(ng(t) - 1, t), e, 2);
    }

    function rv(t) {
      var e = t.getDay();
      return e >= 4 || 0 === e ? mg(t) : mg.ceil(t);
    }

    function iv(t, e) {
      return t = rv(t), wm(mg.count(ng(t), t) + (4 === ng(t).getDay()), e, 2);
    }

    function av(t) {
      return t.getDay();
    }

    function ov(t, e) {
      return wm(pg.count(ng(t) - 1, t), e, 2);
    }

    function sv(t, e) {
      return wm(t.getFullYear() % 100, e, 2);
    }

    function cv(t, e) {
      return wm((t = rv(t)).getFullYear() % 100, e, 2);
    }

    function uv(t, e) {
      return wm(t.getFullYear() % 1e4, e, 4);
    }

    function lv(t, e) {
      var n = t.getDay();
      return wm((t = n >= 4 || 0 === n ? mg(t) : mg.ceil(t)).getFullYear() % 1e4, e, 4);
    }

    function hv(t) {
      var e = t.getTimezoneOffset();
      return (e > 0 ? "-" : (e *= -1, "+")) + wm(e / 60 | 0, "0", 2) + wm(e % 60, "0", 2);
    }

    function fv(t, e) {
      return wm(t.getUTCDate(), e, 2);
    }

    function dv(t, e) {
      return wm(t.getUTCHours(), e, 2);
    }

    function pv(t, e) {
      return wm(t.getUTCHours() % 12 || 12, e, 2);
    }

    function yv(t, e) {
      return wm(1 + im.count(sm(t), t), e, 3);
    }

    function gv(t, e) {
      return wm(t.getUTCMilliseconds(), e, 3);
    }

    function mv(t, e) {
      return gv(t, e) + "000";
    }

    function vv(t, e) {
      return wm(t.getUTCMonth() + 1, e, 2);
    }

    function bv(t, e) {
      return wm(t.getUTCMinutes(), e, 2);
    }

    function _v(t, e) {
      return wm(t.getUTCSeconds(), e, 2);
    }

    function xv(t) {
      var e = t.getUTCDay();
      return 0 === e ? 7 : e;
    }

    function wv(t, e) {
      return wm(qg.count(sm(t) - 1, t), e, 2);
    }

    function kv(t) {
      var e = t.getUTCDay();
      return e >= 4 || 0 === e ? Vg(t) : Vg.ceil(t);
    }

    function Tv(t, e) {
      return t = kv(t), wm(Vg.count(sm(t), t) + (4 === sm(t).getUTCDay()), e, 2);
    }

    function Ev(t) {
      return t.getUTCDay();
    }

    function Cv(t, e) {
      return wm(Hg.count(sm(t) - 1, t), e, 2);
    }

    function Sv(t, e) {
      return wm(t.getUTCFullYear() % 100, e, 2);
    }

    function Av(t, e) {
      return wm((t = kv(t)).getUTCFullYear() % 100, e, 2);
    }

    function Mv(t, e) {
      return wm(t.getUTCFullYear() % 1e4, e, 4);
    }

    function Nv(t, e) {
      var n = t.getUTCDay();
      return wm((t = n >= 4 || 0 === n ? Vg(t) : Vg.ceil(t)).getUTCFullYear() % 1e4, e, 4);
    }

    function Dv() {
      return "+0000";
    }

    function Ov() {
      return "%";
    }

    function Bv(t) {
      return +t;
    }

    function Lv(t) {
      return Math.floor(+t / 1e3);
    }

    function Iv(t) {
      return dm = fm(t), pm = dm.format, ym = dm.parse, gm = dm.utcFormat, mm = dm.utcParse, dm;
    }

    Iv({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    });
    var Rv = 31536e6;

    function Fv(t) {
      return new Date(t);
    }

    function Pv(t) {
      return t instanceof Date ? +t : +new Date(+t);
    }

    function jv(t, e, n, r, i, o, s, c, u) {
      var l = Ey(vy, vy),
          h = l.invert,
          f = l.domain,
          d = u(".%L"),
          p = u(":%S"),
          y = u("%I:%M"),
          g = u("%I %p"),
          m = u("%a %d"),
          v = u("%b %d"),
          b = u("%B"),
          _ = u("%Y"),
          x = [[s, 1, 1e3], [s, 5, 5e3], [s, 15, 15e3], [s, 30, 3e4], [o, 1, 6e4], [o, 5, 3e5], [o, 15, 9e5], [o, 30, 18e5], [i, 1, 36e5], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, 864e5], [r, 2, 1728e5], [n, 1, 6048e5], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, Rv]];

      function w(a) {
        return (s(a) < a ? d : o(a) < a ? p : i(a) < a ? y : r(a) < a ? g : e(a) < a ? n(a) < a ? m : v : t(a) < a ? b : _)(a);
      }

      function k(e, n, r, i) {
        if (null == e && (e = 10), "number" == typeof e) {
          var o = Math.abs(r - n) / e,
              s = a(function (t) {
            return t[2];
          }).right(x, o);
          s === x.length ? (i = M(n / Rv, r / Rv, e), e = t) : s ? (i = (s = x[o / x[s - 1][2] < x[s][2] / o ? s - 1 : s])[1], e = s[0]) : (i = Math.max(M(n, r, e), 1), e = c);
        }

        return null == i ? e : e.every(i);
      }

      return l.invert = function (t) {
        return new Date(h(t));
      }, l.domain = function (t) {
        return arguments.length ? f(uy.call(t, Pv)) : f().map(Fv);
      }, l.ticks = function (t, e) {
        var n,
            r = f(),
            i = r[0],
            a = r[r.length - 1],
            o = a < i;
        return o && (n = i, i = a, a = n), n = (n = k(t, i, a, e)) ? n.range(i, a + 1) : [], o ? n.reverse() : n;
      }, l.tickFormat = function (t, e) {
        return null == e ? w : u(e);
      }, l.nice = function (t, e) {
        var n = f();
        return (t = k(t, n[0], n[n.length - 1], e)) ? f(Ny(n, t)) : l;
      }, l.copy = function () {
        return ky(l, jv(t, e, n, r, i, o, s, c, u));
      }, l;
    }

    function Yv() {
      return oy.apply(jv(ng, ag, dg, Ag, Dg, Lg, Fg, Yg, pm).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
    }

    var zv = tg(function (t) {
      t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCMonth(t.getUTCMonth() + e);
    }, function (t, e) {
      return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
    }, function (t) {
      return t.getUTCMonth();
    });
    var Uv = zv;
    var qv = zv.range,
        Hv = tg(function (t) {
      t.setUTCMinutes(0, 0, 0);
    }, function (t, e) {
      t.setTime(+t + e * ug);
    }, function (t, e) {
      return (e - t) / ug;
    }, function (t) {
      return t.getUTCHours();
    });
    var $v = Hv;
    var Wv = Hv.range,
        Vv = tg(function (t) {
      t.setUTCSeconds(0, 0);
    }, function (t, e) {
      t.setTime(+t + e * cg);
    }, function (t, e) {
      return (e - t) / cg;
    }, function (t) {
      return t.getUTCMinutes();
    });
    var Gv = Vv;
    var Xv = Vv.range;

    function Zv() {
      return oy.apply(jv(sm, Uv, qg, im, $v, Gv, Fg, Yg, gm).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
    }

    function Qv() {
      var t,
          e,
          n,
          r,
          i,
          a = 0,
          o = 1,
          s = vy,
          c = !1;

      function u(e) {
        return isNaN(e = +e) ? i : s(0 === n ? .5 : (e = (r(e) - t) * n, c ? Math.max(0, Math.min(1, e)) : e));
      }

      return u.domain = function (i) {
        return arguments.length ? (t = r(a = +i[0]), e = r(o = +i[1]), n = t === e ? 0 : 1 / (e - t), u) : [a, o];
      }, u.clamp = function (t) {
        return arguments.length ? (c = !!t, u) : c;
      }, u.interpolator = function (t) {
        return arguments.length ? (s = t, u) : s;
      }, u.unknown = function (t) {
        return arguments.length ? (i = t, u) : i;
      }, function (i) {
        return r = i, t = i(a), e = i(o), n = t === e ? 0 : 1 / (e - t), u;
      };
    }

    function Kv(t, e) {
      return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
    }

    function Jv() {
      var t = Sy(Qv()(vy));
      return t.copy = function () {
        return Kv(t, Jv());
      }, sy.apply(t, arguments);
    }

    function tb() {
      var t = Fy(Qv()).domain([1, 10]);
      return t.copy = function () {
        return Kv(t, tb()).base(t.base());
      }, sy.apply(t, arguments);
    }

    function eb() {
      var t = zy(Qv());
      return t.copy = function () {
        return Kv(t, eb()).constant(t.constant());
      }, sy.apply(t, arguments);
    }

    function nb() {
      var t = Wy(Qv());
      return t.copy = function () {
        return Kv(t, nb()).exponent(t.exponent());
      }, sy.apply(t, arguments);
    }

    function rb() {
      return nb.apply(null, arguments).exponent(.5);
    }

    function ib() {
      var t = [],
          e = vy;

      function n(n) {
        if (!isNaN(n = +n)) return e((u(t, n) - 1) / (t.length - 1));
      }

      return n.domain = function (e) {
        if (!arguments.length) return t.slice();
        t = [];

        for (var r, a = 0, o = e.length; a < o; ++a) {
          null == (r = e[a]) || isNaN(r = +r) || t.push(r);
        }

        return t.sort(i), n;
      }, n.interpolator = function (t) {
        return arguments.length ? (e = t, n) : e;
      }, n.copy = function () {
        return ib(e).domain(t);
      }, sy.apply(n, arguments);
    }

    function ab() {
      var t,
          e,
          n,
          r,
          i,
          a,
          o,
          s = 0,
          c = .5,
          u = 1,
          l = vy,
          h = !1;

      function f(t) {
        return isNaN(t = +t) ? o : (t = .5 + ((t = +a(t)) - e) * (t < e ? r : i), l(h ? Math.max(0, Math.min(1, t)) : t));
      }

      return f.domain = function (o) {
        return arguments.length ? (t = a(s = +o[0]), e = a(c = +o[1]), n = a(u = +o[2]), r = t === e ? 0 : .5 / (e - t), i = e === n ? 0 : .5 / (n - e), f) : [s, c, u];
      }, f.clamp = function (t) {
        return arguments.length ? (h = !!t, f) : h;
      }, f.interpolator = function (t) {
        return arguments.length ? (l = t, f) : l;
      }, f.unknown = function (t) {
        return arguments.length ? (o = t, f) : o;
      }, function (o) {
        return a = o, t = o(s), e = o(c), n = o(u), r = t === e ? 0 : .5 / (e - t), i = e === n ? 0 : .5 / (n - e), f;
      };
    }

    function ob() {
      var t = Sy(ab()(vy));
      return t.copy = function () {
        return Kv(t, ob());
      }, sy.apply(t, arguments);
    }

    function sb() {
      var t = Fy(ab()).domain([.1, 1, 10]);
      return t.copy = function () {
        return Kv(t, sb()).base(t.base());
      }, sy.apply(t, arguments);
    }

    function cb() {
      var t = zy(ab());
      return t.copy = function () {
        return Kv(t, cb()).constant(t.constant());
      }, sy.apply(t, arguments);
    }

    function ub() {
      var t = Wy(ab());
      return t.copy = function () {
        return Kv(t, ub()).exponent(t.exponent());
      }, sy.apply(t, arguments);
    }

    function lb() {
      return ub.apply(null, arguments).exponent(.5);
    }

    function hb(t) {
      for (var e = t.length / 6 | 0, n = new Array(e), r = 0; r < e;) {
        n[r] = "#" + t.slice(6 * r, 6 * ++r);
      }

      return n;
    }

    var fb = hb("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"),
        db = hb("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"),
        pb = hb("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"),
        yb = hb("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"),
        gb = hb("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"),
        mb = hb("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"),
        vb = hb("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"),
        bb = hb("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"),
        _b = hb("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"),
        xb = hb("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

    function wb(t) {
      return mn(t[t.length - 1]);
    }

    var kb = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(hb);
    var Tb = wb(kb);
    var Eb = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(hb);
    var Cb = wb(Eb);
    var Sb = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(hb);
    var Ab = wb(Sb);
    var Mb = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(hb);
    var Nb = wb(Mb);
    var Db = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(hb);
    var Ob = wb(Db);
    var Bb = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(hb);
    var Lb = wb(Bb);
    var Ib = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(hb);
    var Rb = wb(Ib);
    var Fb = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(hb);
    var Pb = wb(Fb);
    var jb = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(hb);
    var Yb = wb(jb);
    var zb = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(hb);
    var Ub = wb(zb);
    var qb = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(hb);
    var Hb = wb(qb);
    var $b = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(hb);
    var Wb = wb($b);
    var Vb = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(hb);
    var Gb = wb(Vb);
    var Xb = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(hb);
    var Zb = wb(Xb);
    var Qb = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(hb);
    var Kb = wb(Qb);
    var Jb = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(hb);
    var t_ = wb(Jb);
    var e_ = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(hb);
    var n_ = wb(e_);
    var r_ = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(hb);
    var i_ = wb(r_);
    var a_ = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(hb);
    var o_ = wb(a_);
    var s_ = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(hb);
    var c_ = wb(s_);
    var u_ = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(hb);
    var l_ = wb(u_);
    var h_ = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(hb);
    var f_ = wb(h_);
    var d_ = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(hb);
    var p_ = wb(d_);
    var y_ = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(hb);
    var g_ = wb(y_);
    var m_ = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(hb);
    var v_ = wb(m_);
    var b_ = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(hb);

    var __ = wb(b_);

    var x_ = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(hb);
    var w_ = wb(x_);

    function k_(t) {
      return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - 2710.57 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - 67.37 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - 2475.67 * t))))))) + ")";
    }

    var T_ = Up(Ha(300, .5, 0), Ha(-240, .5, 1));
    var E_ = Up(Ha(-100, .75, .35), Ha(80, 1.5, .8)),
        C_ = Up(Ha(260, .75, .35), Ha(80, 1.5, .8)),
        S_ = Ha();

    function A_(t) {
      (t < 0 || t > 1) && (t -= Math.floor(t));
      var e = Math.abs(t - .5);
      return S_.h = 360 * t - 100, S_.s = 1.5 - 1.5 * e, S_.l = .8 - .9 * e, S_ + "";
    }

    var M_ = Qe(),
        N_ = Math.PI / 3,
        D_ = 2 * Math.PI / 3;

    function O_(t) {
      var e;
      return t = (.5 - t) * Math.PI, M_.r = 255 * (e = Math.sin(t)) * e, M_.g = 255 * (e = Math.sin(t + N_)) * e, M_.b = 255 * (e = Math.sin(t + D_)) * e, M_ + "";
    }

    function B_(t) {
      return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - 14825.05 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + 707.56 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - 6838.66 * t))))))) + ")";
    }

    function L_(t) {
      var e = t.length;
      return function (n) {
        return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
      };
    }

    var I_ = L_(hb("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
    var R_ = L_(hb("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),
        F_ = L_(hb("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),
        P_ = L_(hb("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

    function j_(t) {
      return Te(ie(t).call(document.documentElement));
    }

    var Y_ = 0;

    function z_() {
      return new U_();
    }

    function U_() {
      this._ = "@" + (++Y_).toString(36);
    }

    function q_(t) {
      return "string" == typeof t ? new xe([document.querySelectorAll(t)], [document.documentElement]) : new xe([null == t ? [] : t], _e);
    }

    function H_(t, e) {
      null == e && (e = Nn().touches);

      for (var n = 0, r = e ? e.length : 0, i = new Array(r); n < r; ++n) {
        i[n] = Dn(t, e[n]);
      }

      return i;
    }

    function $_(t) {
      return function () {
        return t;
      };
    }

    U_.prototype = z_.prototype = {
      constructor: U_,
      get: function get(t) {
        for (var e = this._; !(e in t);) {
          if (!(t = t.parentNode)) return;
        }

        return t[e];
      },
      set: function set(t, e) {
        return t[this._] = e;
      },
      remove: function remove(t) {
        return this._ in t && delete t[this._];
      },
      toString: function toString() {
        return this._;
      }
    };
    var W_ = Math.abs,
        V_ = Math.atan2,
        G_ = Math.cos,
        X_ = Math.max,
        Z_ = Math.min,
        Q_ = Math.sin,
        K_ = Math.sqrt,
        J_ = 1e-12,
        tx = Math.PI,
        ex = tx / 2,
        nx = 2 * tx;

    function rx(t) {
      return t > 1 ? 0 : t < -1 ? tx : Math.acos(t);
    }

    function ix(t) {
      return t >= 1 ? ex : t <= -1 ? -ex : Math.asin(t);
    }

    function ax(t) {
      return t.innerRadius;
    }

    function ox(t) {
      return t.outerRadius;
    }

    function sx(t) {
      return t.startAngle;
    }

    function cx(t) {
      return t.endAngle;
    }

    function ux(t) {
      return t && t.padAngle;
    }

    function lx(t, e, n, r, i, a, o, s) {
      var c = n - t,
          u = r - e,
          l = o - i,
          h = s - a,
          f = h * c - l * u;
      if (!(f * f < J_)) return [t + (f = (l * (e - a) - h * (t - i)) / f) * c, e + f * u];
    }

    function hx(t, e, n, r, i, a, o) {
      var s = t - n,
          c = e - r,
          u = (o ? a : -a) / K_(s * s + c * c),
          l = u * c,
          h = -u * s,
          f = t + l,
          d = e + h,
          p = n + l,
          y = r + h,
          g = (f + p) / 2,
          m = (d + y) / 2,
          v = p - f,
          b = y - d,
          _ = v * v + b * b,
          x = i - a,
          w = f * y - p * d,
          k = (b < 0 ? -1 : 1) * K_(X_(0, x * x * _ - w * w)),
          T = (w * b - v * k) / _,
          E = (-w * v - b * k) / _,
          C = (w * b + v * k) / _,
          S = (-w * v + b * k) / _,
          A = T - g,
          M = E - m,
          N = C - g,
          D = S - m;

      return A * A + M * M > N * N + D * D && (T = C, E = S), {
        cx: T,
        cy: E,
        x01: -l,
        y01: -h,
        x11: T * (i / x - 1),
        y11: E * (i / x - 1)
      };
    }

    function fx() {
      var t = ax,
          e = ox,
          n = $_(0),
          r = null,
          i = sx,
          a = cx,
          o = ux,
          s = null;

      function c() {
        var c,
            u,
            l = +t.apply(this, arguments),
            h = +e.apply(this, arguments),
            f = i.apply(this, arguments) - ex,
            d = a.apply(this, arguments) - ex,
            p = W_(d - f),
            y = d > f;
        if (s || (s = c = Wi()), h < l && (u = h, h = l, l = u), h > J_) {
          if (p > nx - J_) s.moveTo(h * G_(f), h * Q_(f)), s.arc(0, 0, h, f, d, !y), l > J_ && (s.moveTo(l * G_(d), l * Q_(d)), s.arc(0, 0, l, d, f, y));else {
            var g,
                m,
                v = f,
                b = d,
                _ = f,
                x = d,
                w = p,
                k = p,
                T = o.apply(this, arguments) / 2,
                E = T > J_ && (r ? +r.apply(this, arguments) : K_(l * l + h * h)),
                C = Z_(W_(h - l) / 2, +n.apply(this, arguments)),
                S = C,
                A = C;

            if (E > J_) {
              var M = ix(E / l * Q_(T)),
                  N = ix(E / h * Q_(T));
              (w -= 2 * M) > J_ ? (_ += M *= y ? 1 : -1, x -= M) : (w = 0, _ = x = (f + d) / 2), (k -= 2 * N) > J_ ? (v += N *= y ? 1 : -1, b -= N) : (k = 0, v = b = (f + d) / 2);
            }

            var D = h * G_(v),
                O = h * Q_(v),
                B = l * G_(x),
                L = l * Q_(x);

            if (C > J_) {
              var I,
                  R = h * G_(b),
                  F = h * Q_(b),
                  P = l * G_(_),
                  j = l * Q_(_);

              if (p < tx && (I = lx(D, O, P, j, R, F, B, L))) {
                var Y = D - I[0],
                    z = O - I[1],
                    U = R - I[0],
                    q = F - I[1],
                    H = 1 / Q_(rx((Y * U + z * q) / (K_(Y * Y + z * z) * K_(U * U + q * q))) / 2),
                    $ = K_(I[0] * I[0] + I[1] * I[1]);
                S = Z_(C, (l - $) / (H - 1)), A = Z_(C, (h - $) / (H + 1));
              }
            }

            k > J_ ? A > J_ ? (g = hx(P, j, D, O, h, A, y), m = hx(R, F, B, L, h, A, y), s.moveTo(g.cx + g.x01, g.cy + g.y01), A < C ? s.arc(g.cx, g.cy, A, V_(g.y01, g.x01), V_(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, A, V_(g.y01, g.x01), V_(g.y11, g.x11), !y), s.arc(0, 0, h, V_(g.cy + g.y11, g.cx + g.x11), V_(m.cy + m.y11, m.cx + m.x11), !y), s.arc(m.cx, m.cy, A, V_(m.y11, m.x11), V_(m.y01, m.x01), !y))) : (s.moveTo(D, O), s.arc(0, 0, h, v, b, !y)) : s.moveTo(D, O), l > J_ && w > J_ ? S > J_ ? (g = hx(B, L, R, F, l, -S, y), m = hx(D, O, P, j, l, -S, y), s.lineTo(g.cx + g.x01, g.cy + g.y01), S < C ? s.arc(g.cx, g.cy, S, V_(g.y01, g.x01), V_(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, S, V_(g.y01, g.x01), V_(g.y11, g.x11), !y), s.arc(0, 0, l, V_(g.cy + g.y11, g.cx + g.x11), V_(m.cy + m.y11, m.cx + m.x11), y), s.arc(m.cx, m.cy, S, V_(m.y11, m.x11), V_(m.y01, m.x01), !y))) : s.arc(0, 0, l, x, _, y) : s.lineTo(B, L);
          }
        } else s.moveTo(0, 0);
        if (s.closePath(), c) return s = null, c + "" || null;
      }

      return c.centroid = function () {
        var n = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
            r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - tx / 2;
        return [G_(r) * n, Q_(r) * n];
      }, c.innerRadius = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(+e), c) : t;
      }, c.outerRadius = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : $_(+t), c) : e;
      }, c.cornerRadius = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : $_(+t), c) : n;
      }, c.padRadius = function (t) {
        return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : $_(+t), c) : r;
      }, c.startAngle = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : $_(+t), c) : i;
      }, c.endAngle = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : $_(+t), c) : a;
      }, c.padAngle = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : $_(+t), c) : o;
      }, c.context = function (t) {
        return arguments.length ? (s = null == t ? null : t, c) : s;
      }, c;
    }

    function dx(t) {
      this._context = t;
    }

    function px(t) {
      return new dx(t);
    }

    function yx(t) {
      return t[0];
    }

    function gx(t) {
      return t[1];
    }

    function mx() {
      var t = yx,
          e = gx,
          n = $_(!0),
          r = null,
          i = px,
          a = null;

      function o(o) {
        var s,
            c,
            u,
            l = o.length,
            h = !1;

        for (null == r && (a = i(u = Wi())), s = 0; s <= l; ++s) {
          !(s < l && n(c = o[s], s, o)) === h && ((h = !h) ? a.lineStart() : a.lineEnd()), h && a.point(+t(c, s, o), +e(c, s, o));
        }

        if (u) return a = null, u + "" || null;
      }

      return o.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(+e), o) : t;
      }, o.y = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : $_(+t), o) : e;
      }, o.defined = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : $_(!!t), o) : n;
      }, o.curve = function (t) {
        return arguments.length ? (i = t, null != r && (a = i(r)), o) : i;
      }, o.context = function (t) {
        return arguments.length ? (null == t ? r = a = null : a = i(r = t), o) : r;
      }, o;
    }

    function vx() {
      var t = yx,
          e = null,
          n = $_(0),
          r = gx,
          i = $_(!0),
          a = null,
          o = px,
          s = null;

      function c(c) {
        var u,
            l,
            h,
            f,
            d,
            p = c.length,
            y = !1,
            g = new Array(p),
            m = new Array(p);

        for (null == a && (s = o(d = Wi())), u = 0; u <= p; ++u) {
          if (!(u < p && i(f = c[u], u, c)) === y) if (y = !y) l = u, s.areaStart(), s.lineStart();else {
            for (s.lineEnd(), s.lineStart(), h = u - 1; h >= l; --h) {
              s.point(g[h], m[h]);
            }

            s.lineEnd(), s.areaEnd();
          }
          y && (g[u] = +t(f, u, c), m[u] = +n(f, u, c), s.point(e ? +e(f, u, c) : g[u], r ? +r(f, u, c) : m[u]));
        }

        if (d) return s = null, d + "" || null;
      }

      function u() {
        return mx().defined(i).curve(o).context(a);
      }

      return c.x = function (n) {
        return arguments.length ? (t = "function" == typeof n ? n : $_(+n), e = null, c) : t;
      }, c.x0 = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(+e), c) : t;
      }, c.x1 = function (t) {
        return arguments.length ? (e = null == t ? null : "function" == typeof t ? t : $_(+t), c) : e;
      }, c.y = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : $_(+t), r = null, c) : n;
      }, c.y0 = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : $_(+t), c) : n;
      }, c.y1 = function (t) {
        return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : $_(+t), c) : r;
      }, c.lineX0 = c.lineY0 = function () {
        return u().x(t).y(n);
      }, c.lineY1 = function () {
        return u().x(t).y(r);
      }, c.lineX1 = function () {
        return u().x(e).y(n);
      }, c.defined = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : $_(!!t), c) : i;
      }, c.curve = function (t) {
        return arguments.length ? (o = t, null != a && (s = o(a)), c) : o;
      }, c.context = function (t) {
        return arguments.length ? (null == t ? a = s = null : s = o(a = t), c) : a;
      }, c;
    }

    function bx(t, e) {
      return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
    }

    function _x(t) {
      return t;
    }

    function xx() {
      var t = _x,
          e = bx,
          n = null,
          r = $_(0),
          i = $_(nx),
          a = $_(0);

      function o(o) {
        var s,
            c,
            u,
            l,
            h,
            f = o.length,
            d = 0,
            p = new Array(f),
            y = new Array(f),
            g = +r.apply(this, arguments),
            m = Math.min(nx, Math.max(-nx, i.apply(this, arguments) - g)),
            v = Math.min(Math.abs(m) / f, a.apply(this, arguments)),
            b = v * (m < 0 ? -1 : 1);

        for (s = 0; s < f; ++s) {
          (h = y[p[s] = s] = +t(o[s], s, o)) > 0 && (d += h);
        }

        for (null != e ? p.sort(function (t, n) {
          return e(y[t], y[n]);
        }) : null != n && p.sort(function (t, e) {
          return n(o[t], o[e]);
        }), s = 0, u = d ? (m - f * b) / d : 0; s < f; ++s, g = l) {
          c = p[s], l = g + ((h = y[c]) > 0 ? h * u : 0) + b, y[c] = {
            data: o[c],
            index: s,
            value: h,
            startAngle: g,
            endAngle: l,
            padAngle: v
          };
        }

        return y;
      }

      return o.value = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(+e), o) : t;
      }, o.sortValues = function (t) {
        return arguments.length ? (e = t, n = null, o) : e;
      }, o.sort = function (t) {
        return arguments.length ? (n = t, e = null, o) : n;
      }, o.startAngle = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : $_(+t), o) : r;
      }, o.endAngle = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : $_(+t), o) : i;
      }, o.padAngle = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : $_(+t), o) : a;
      }, o;
    }

    dx.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;

          default:
            this._context.lineTo(t, e);

        }
      }
    };
    var wx = Tx(px);

    function kx(t) {
      this._curve = t;
    }

    function Tx(t) {
      function e(e) {
        return new kx(t(e));
      }

      return e._curve = t, e;
    }

    function Ex(t) {
      var e = t.curve;
      return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t.curve = function (t) {
        return arguments.length ? e(Tx(t)) : e()._curve;
      }, t;
    }

    function Cx() {
      return Ex(mx().curve(wx));
    }

    function Sx() {
      var t = vx().curve(wx),
          e = t.curve,
          n = t.lineX0,
          r = t.lineX1,
          i = t.lineY0,
          a = t.lineY1;
      return t.angle = t.x, delete t.x, t.startAngle = t.x0, delete t.x0, t.endAngle = t.x1, delete t.x1, t.radius = t.y, delete t.y, t.innerRadius = t.y0, delete t.y0, t.outerRadius = t.y1, delete t.y1, t.lineStartAngle = function () {
        return Ex(n());
      }, delete t.lineX0, t.lineEndAngle = function () {
        return Ex(r());
      }, delete t.lineX1, t.lineInnerRadius = function () {
        return Ex(i());
      }, delete t.lineY0, t.lineOuterRadius = function () {
        return Ex(a());
      }, delete t.lineY1, t.curve = function (t) {
        return arguments.length ? e(Tx(t)) : e()._curve;
      }, t;
    }

    function Ax(t, e) {
      return [(e = +e) * Math.cos(t -= Math.PI / 2), e * Math.sin(t)];
    }

    kx.prototype = {
      areaStart: function areaStart() {
        this._curve.areaStart();
      },
      areaEnd: function areaEnd() {
        this._curve.areaEnd();
      },
      lineStart: function lineStart() {
        this._curve.lineStart();
      },
      lineEnd: function lineEnd() {
        this._curve.lineEnd();
      },
      point: function point(t, e) {
        this._curve.point(e * Math.sin(t), e * -Math.cos(t));
      }
    };
    var Mx = Array.prototype.slice;

    function Nx(t) {
      return t.source;
    }

    function Dx(t) {
      return t.target;
    }

    function Ox(t) {
      var e = Nx,
          n = Dx,
          r = yx,
          i = gx,
          a = null;

      function o() {
        var o,
            s = Mx.call(arguments),
            c = e.apply(this, s),
            u = n.apply(this, s);
        if (a || (a = o = Wi()), t(a, +r.apply(this, (s[0] = c, s)), +i.apply(this, s), +r.apply(this, (s[0] = u, s)), +i.apply(this, s)), o) return a = null, o + "" || null;
      }

      return o.source = function (t) {
        return arguments.length ? (e = t, o) : e;
      }, o.target = function (t) {
        return arguments.length ? (n = t, o) : n;
      }, o.x = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : $_(+t), o) : r;
      }, o.y = function (t) {
        return arguments.length ? (i = "function" == typeof t ? t : $_(+t), o) : i;
      }, o.context = function (t) {
        return arguments.length ? (a = null == t ? null : t, o) : a;
      }, o;
    }

    function Bx(t, e, n, r, i) {
      t.moveTo(e, n), t.bezierCurveTo(e = (e + r) / 2, n, e, i, r, i);
    }

    function Lx(t, e, n, r, i) {
      t.moveTo(e, n), t.bezierCurveTo(e, n = (n + i) / 2, r, n, r, i);
    }

    function Ix(t, e, n, r, i) {
      var a = Ax(e, n),
          o = Ax(e, n = (n + i) / 2),
          s = Ax(r, n),
          c = Ax(r, i);
      t.moveTo(a[0], a[1]), t.bezierCurveTo(o[0], o[1], s[0], s[1], c[0], c[1]);
    }

    function Rx() {
      return Ox(Bx);
    }

    function Fx() {
      return Ox(Lx);
    }

    function Px() {
      var t = Ox(Ix);
      return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t;
    }

    var jx = {
      draw: function draw(t, e) {
        var n = Math.sqrt(e / tx);
        t.moveTo(n, 0), t.arc(0, 0, n, 0, nx);
      }
    },
        Yx = {
      draw: function draw(t, e) {
        var n = Math.sqrt(e / 5) / 2;
        t.moveTo(-3 * n, -n), t.lineTo(-n, -n), t.lineTo(-n, -3 * n), t.lineTo(n, -3 * n), t.lineTo(n, -n), t.lineTo(3 * n, -n), t.lineTo(3 * n, n), t.lineTo(n, n), t.lineTo(n, 3 * n), t.lineTo(-n, 3 * n), t.lineTo(-n, n), t.lineTo(-3 * n, n), t.closePath();
      }
    };
    var zx = Math.sqrt(1 / 3),
        Ux = 2 * zx;
    var qx = {
      draw: function draw(t, e) {
        var n = Math.sqrt(e / Ux),
            r = n * zx;
        t.moveTo(0, -n), t.lineTo(r, 0), t.lineTo(0, n), t.lineTo(-r, 0), t.closePath();
      }
    };
    var Hx = Math.sin(tx / 10) / Math.sin(7 * tx / 10),
        $x = Math.sin(nx / 10) * Hx,
        Wx = -Math.cos(nx / 10) * Hx;
    var Vx = {
      draw: function draw(t, e) {
        var n = Math.sqrt(.8908130915292852 * e),
            r = $x * n,
            i = Wx * n;
        t.moveTo(0, -n), t.lineTo(r, i);

        for (var a = 1; a < 5; ++a) {
          var o = nx * a / 5,
              s = Math.cos(o),
              c = Math.sin(o);
          t.lineTo(c * n, -s * n), t.lineTo(s * r - c * i, c * r + s * i);
        }

        t.closePath();
      }
    },
        Gx = {
      draw: function draw(t, e) {
        var n = Math.sqrt(e),
            r = -n / 2;
        t.rect(r, r, n, n);
      }
    };
    var Xx = Math.sqrt(3);
    var Zx = {
      draw: function draw(t, e) {
        var n = -Math.sqrt(e / (3 * Xx));
        t.moveTo(0, 2 * n), t.lineTo(-Xx * n, -n), t.lineTo(Xx * n, -n), t.closePath();
      }
    };
    var Qx = -.5,
        Kx = Math.sqrt(3) / 2,
        Jx = 1 / Math.sqrt(12),
        tw = 3 * (Jx / 2 + 1);
    var ew = {
      draw: function draw(t, e) {
        var n = Math.sqrt(e / tw),
            r = n / 2,
            i = n * Jx,
            a = r,
            o = n * Jx + n,
            s = -a,
            c = o;
        t.moveTo(r, i), t.lineTo(a, o), t.lineTo(s, c), t.lineTo(Qx * r - Kx * i, Kx * r + Qx * i), t.lineTo(Qx * a - Kx * o, Kx * a + Qx * o), t.lineTo(Qx * s - Kx * c, Kx * s + Qx * c), t.lineTo(Qx * r + Kx * i, Qx * i - Kx * r), t.lineTo(Qx * a + Kx * o, Qx * o - Kx * a), t.lineTo(Qx * s + Kx * c, Qx * c - Kx * s), t.closePath();
      }
    };
    var nw = [jx, Yx, qx, Gx, Vx, Zx, ew];

    function rw() {
      var t = $_(jx),
          e = $_(64),
          n = null;

      function r() {
        var r;
        if (n || (n = r = Wi()), t.apply(this, arguments).draw(n, +e.apply(this, arguments)), r) return n = null, r + "" || null;
      }

      return r.type = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(e), r) : t;
      }, r.size = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : $_(+t), r) : e;
      }, r.context = function (t) {
        return arguments.length ? (n = null == t ? null : t, r) : n;
      }, r;
    }

    function iw() {}

    function aw(t, e, n) {
      t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
    }

    function ow(t) {
      this._context = t;
    }

    function sw(t) {
      return new ow(t);
    }

    function cw(t) {
      this._context = t;
    }

    function uw(t) {
      return new cw(t);
    }

    function lw(t) {
      this._context = t;
    }

    function hw(t) {
      return new lw(t);
    }

    function fw(t, e) {
      this._basis = new ow(t), this._beta = e;
    }

    ow.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 3:
            aw(this, this._x1, this._y1);

          case 2:
            this._context.lineTo(this._x1, this._y1);

        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

          default:
            aw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, cw.prototype = {
      areaStart: iw,
      areaEnd: iw,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x2, this._y2), this._context.closePath();
            break;

          case 2:
            this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
            break;

          case 3:
            this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        }
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._x2 = t, this._y2 = e;
            break;

          case 1:
            this._point = 2, this._x3 = t, this._y3 = e;
            break;

          case 2:
            this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
            break;

          default:
            aw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, lw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3;
            var n = (this._x0 + 4 * this._x1 + t) / 6,
                r = (this._y0 + 4 * this._y1 + e) / 6;
            this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
            break;

          case 3:
            this._point = 4;

          default:
            aw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
      }
    }, fw.prototype = {
      lineStart: function lineStart() {
        this._x = [], this._y = [], this._basis.lineStart();
      },
      lineEnd: function lineEnd() {
        var t = this._x,
            e = this._y,
            n = t.length - 1;
        if (n > 0) for (var r, i = t[0], a = e[0], o = t[n] - i, s = e[n] - a, c = -1; ++c <= n;) {
          r = c / n, this._basis.point(this._beta * t[c] + (1 - this._beta) * (i + r * o), this._beta * e[c] + (1 - this._beta) * (a + r * s));
        }
        this._x = this._y = null, this._basis.lineEnd();
      },
      point: function point(t, e) {
        this._x.push(+t), this._y.push(+e);
      }
    };

    var dw = function t(e) {
      function n(t) {
        return 1 === e ? new ow(t) : new fw(t, e);
      }

      return n.beta = function (e) {
        return t(+e);
      }, n;
    }(.85);

    function pw(t, e, n) {
      t._context.bezierCurveTo(t._x1 + t._k * (t._x2 - t._x0), t._y1 + t._k * (t._y2 - t._y0), t._x2 + t._k * (t._x1 - e), t._y2 + t._k * (t._y1 - n), t._x2, t._y2);
    }

    function yw(t, e) {
      this._context = t, this._k = (1 - e) / 6;
    }

    yw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);

            break;

          case 3:
            pw(this, this._x1, this._y1);
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2, this._x1 = t, this._y1 = e;
            break;

          case 2:
            this._point = 3;

          default:
            pw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var gw = function t(e) {
      function n(t) {
        return new yw(t, e);
      }

      return n.tension = function (e) {
        return t(+e);
      }, n;
    }(0);

    function mw(t, e) {
      this._context = t, this._k = (1 - e) / 6;
    }

    mw.prototype = {
      areaStart: iw,
      areaEnd: iw,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x3, this._y3), this._context.closePath();
            break;

          case 2:
            this._context.lineTo(this._x3, this._y3), this._context.closePath();
            break;

          case 3:
            this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        }
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._x3 = t, this._y3 = e;
            break;

          case 1:
            this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
            break;

          case 2:
            this._point = 3, this._x5 = t, this._y5 = e;
            break;

          default:
            pw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var vw = function t(e) {
      function n(t) {
        return new mw(t, e);
      }

      return n.tension = function (e) {
        return t(+e);
      }, n;
    }(0);

    function bw(t, e) {
      this._context = t, this._k = (1 - e) / 6;
    }

    bw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;

          case 3:
            this._point = 4;

          default:
            pw(this, t, e);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var _w = function t(e) {
      function n(t) {
        return new bw(t, e);
      }

      return n.tension = function (e) {
        return t(+e);
      }, n;
    }(0);

    function xw(t, e, n) {
      var r = t._x1,
          i = t._y1,
          a = t._x2,
          o = t._y2;

      if (t._l01_a > J_) {
        var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a,
            c = 3 * t._l01_a * (t._l01_a + t._l12_a);
        r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / c, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / c;
      }

      if (t._l23_a > J_) {
        var u = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a,
            l = 3 * t._l23_a * (t._l23_a + t._l12_a);
        a = (a * u + t._x1 * t._l23_2a - e * t._l12_2a) / l, o = (o * u + t._y1 * t._l23_2a - n * t._l12_2a) / l;
      }

      t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
    }

    function ww(t, e) {
      this._context = t, this._alpha = e;
    }

    ww.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);

            break;

          case 3:
            this.point(this._x2, this._y2);
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        if (t = +t, e = +e, this._point) {
          var n = this._x2 - t,
              r = this._y2 - e;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3;

          default:
            xw(this, t, e);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var kw = function t(e) {
      function n(t) {
        return e ? new ww(t, e) : new yw(t, 0);
      }

      return n.alpha = function (e) {
        return t(+e);
      }, n;
    }(.5);

    function Tw(t, e) {
      this._context = t, this._alpha = e;
    }

    Tw.prototype = {
      areaStart: iw,
      areaEnd: iw,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x3, this._y3), this._context.closePath();
            break;

          case 2:
            this._context.lineTo(this._x3, this._y3), this._context.closePath();
            break;

          case 3:
            this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        }
      },
      point: function point(t, e) {
        if (t = +t, e = +e, this._point) {
          var n = this._x2 - t,
              r = this._y2 - e;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1, this._x3 = t, this._y3 = e;
            break;

          case 1:
            this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
            break;

          case 2:
            this._point = 3, this._x5 = t, this._y5 = e;
            break;

          default:
            xw(this, t, e);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var Ew = function t(e) {
      function n(t) {
        return e ? new Tw(t, e) : new mw(t, 0);
      }

      return n.alpha = function (e) {
        return t(+e);
      }, n;
    }(.5);

    function Cw(t, e) {
      this._context = t, this._alpha = e;
    }

    Cw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        if (t = +t, e = +e, this._point) {
          var n = this._x2 - t,
              r = this._y2 - e;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;

          case 3:
            this._point = 4;

          default:
            xw(this, t, e);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
      }
    };

    var Sw = function t(e) {
      function n(t) {
        return e ? new Cw(t, e) : new bw(t, 0);
      }

      return n.alpha = function (e) {
        return t(+e);
      }, n;
    }(.5);

    function Aw(t) {
      this._context = t;
    }

    function Mw(t) {
      return new Aw(t);
    }

    function Nw(t) {
      return t < 0 ? -1 : 1;
    }

    function Dw(t, e, n) {
      var r = t._x1 - t._x0,
          i = e - t._x1,
          a = (t._y1 - t._y0) / (r || i < 0 && -0),
          o = (n - t._y1) / (i || r < 0 && -0),
          s = (a * i + o * r) / (r + i);
      return (Nw(a) + Nw(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
    }

    function Ow(t, e) {
      var n = t._x1 - t._x0;
      return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
    }

    function Bw(t, e, n) {
      var r = t._x0,
          i = t._y0,
          a = t._x1,
          o = t._y1,
          s = (a - r) / 3;

      t._context.bezierCurveTo(r + s, i + s * e, a - s, o - s * n, a, o);
    }

    function Lw(t) {
      this._context = t;
    }

    function Iw(t) {
      this._context = new Rw(t);
    }

    function Rw(t) {
      this._context = t;
    }

    function Fw(t) {
      return new Lw(t);
    }

    function Pw(t) {
      return new Iw(t);
    }

    function jw(t) {
      this._context = t;
    }

    function Yw(t) {
      var e,
          n,
          r = t.length - 1,
          i = new Array(r),
          a = new Array(r),
          o = new Array(r);

      for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
        i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
      }

      for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
        n = i[e] / a[e - 1], a[e] -= n, o[e] -= n * o[e - 1];
      }

      for (i[r - 1] = o[r - 1] / a[r - 1], e = r - 2; e >= 0; --e) {
        i[e] = (o[e] - i[e + 1]) / a[e];
      }

      for (a[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
        a[e] = 2 * t[e + 1] - i[e + 1];
      }

      return [i, a];
    }

    function zw(t) {
      return new jw(t);
    }

    function Uw(t, e) {
      this._context = t, this._t = e;
    }

    function qw(t) {
      return new Uw(t, .5);
    }

    function Hw(t) {
      return new Uw(t, 0);
    }

    function $w(t) {
      return new Uw(t, 1);
    }

    function Ww(t, e) {
      if ((i = t.length) > 1) for (var n, r, i, a = 1, o = t[e[0]], s = o.length; a < i; ++a) {
        for (r = o, o = t[e[a]], n = 0; n < s; ++n) {
          o[n][1] += o[n][0] = isNaN(r[n][1]) ? r[n][0] : r[n][1];
        }
      }
    }

    function Vw(t) {
      for (var e = t.length, n = new Array(e); --e >= 0;) {
        n[e] = e;
      }

      return n;
    }

    function Gw(t, e) {
      return t[e];
    }

    function Xw() {
      var t = $_([]),
          e = Vw,
          n = Ww,
          r = Gw;

      function i(i) {
        var a,
            o,
            s = t.apply(this, arguments),
            c = i.length,
            u = s.length,
            l = new Array(u);

        for (a = 0; a < u; ++a) {
          for (var h, f = s[a], d = l[a] = new Array(c), p = 0; p < c; ++p) {
            d[p] = h = [0, +r(i[p], f, p, i)], h.data = i[p];
          }

          d.key = f;
        }

        for (a = 0, o = e(l); a < u; ++a) {
          l[o[a]].index = a;
        }

        return n(l, o), l;
      }

      return i.keys = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : $_(Mx.call(e)), i) : t;
      }, i.value = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : $_(+t), i) : r;
      }, i.order = function (t) {
        return arguments.length ? (e = null == t ? Vw : "function" == typeof t ? t : $_(Mx.call(t)), i) : e;
      }, i.offset = function (t) {
        return arguments.length ? (n = null == t ? Ww : t, i) : n;
      }, i;
    }

    function Zw(t, e) {
      if ((r = t.length) > 0) {
        for (var n, r, i, a = 0, o = t[0].length; a < o; ++a) {
          for (i = n = 0; n < r; ++n) {
            i += t[n][a][1] || 0;
          }

          if (i) for (n = 0; n < r; ++n) {
            t[n][a][1] /= i;
          }
        }

        Ww(t, e);
      }
    }

    function Qw(t, e) {
      if ((s = t.length) > 0) for (var n, r, i, a, o, s, c = 0, u = t[e[0]].length; c < u; ++c) {
        for (a = o = 0, n = 0; n < s; ++n) {
          (i = (r = t[e[n]][c])[1] - r[0]) > 0 ? (r[0] = a, r[1] = a += i) : i < 0 ? (r[1] = o, r[0] = o += i) : (r[0] = 0, r[1] = i);
        }
      }
    }

    function Kw(t, e) {
      if ((n = t.length) > 0) {
        for (var n, r = 0, i = t[e[0]], a = i.length; r < a; ++r) {
          for (var o = 0, s = 0; o < n; ++o) {
            s += t[o][r][1] || 0;
          }

          i[r][1] += i[r][0] = -s / 2;
        }

        Ww(t, e);
      }
    }

    function Jw(t, e) {
      if ((i = t.length) > 0 && (r = (n = t[e[0]]).length) > 0) {
        for (var n, r, i, a = 0, o = 1; o < r; ++o) {
          for (var s = 0, c = 0, u = 0; s < i; ++s) {
            for (var l = t[e[s]], h = l[o][1] || 0, f = (h - (l[o - 1][1] || 0)) / 2, d = 0; d < s; ++d) {
              var p = t[e[d]];
              f += (p[o][1] || 0) - (p[o - 1][1] || 0);
            }

            c += h, u += f * h;
          }

          n[o - 1][1] += n[o - 1][0] = a, c && (a -= u / c);
        }

        n[o - 1][1] += n[o - 1][0] = a, Ww(t, e);
      }
    }

    function tk(t) {
      var e = t.map(ek);
      return Vw(t).sort(function (t, n) {
        return e[t] - e[n];
      });
    }

    function ek(t) {
      for (var e, n = -1, r = 0, i = t.length, a = -1 / 0; ++n < i;) {
        (e = +t[n][1]) > a && (a = e, r = n);
      }

      return r;
    }

    function nk(t) {
      var e = t.map(rk);
      return Vw(t).sort(function (t, n) {
        return e[t] - e[n];
      });
    }

    function rk(t) {
      for (var e, n = 0, r = -1, i = t.length; ++r < i;) {
        (e = +t[r][1]) && (n += e);
      }

      return n;
    }

    function ik(t) {
      return nk(t).reverse();
    }

    function ak(t) {
      var e,
          n,
          r = t.length,
          i = t.map(rk),
          a = tk(t),
          o = 0,
          s = 0,
          c = [],
          u = [];

      for (e = 0; e < r; ++e) {
        n = a[e], o < s ? (o += i[n], c.push(n)) : (s += i[n], u.push(n));
      }

      return u.reverse().concat(c);
    }

    function ok(t) {
      return Vw(t).reverse();
    }

    Aw.prototype = {
      areaStart: iw,
      areaEnd: iw,
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        this._point && this._context.closePath();
      },
      point: function point(t, e) {
        t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
      }
    }, Lw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x1, this._y1);

            break;

          case 3:
            Bw(this, this._t0, Ow(this, this._t0));
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(t, e) {
        var n = NaN;

        if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
          switch (this._point) {
            case 0:
              this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
              break;

            case 1:
              this._point = 2;
              break;

            case 2:
              this._point = 3, Bw(this, Ow(this, n = Dw(this, t, e)), n);
              break;

            default:
              Bw(this, this._t0, n = Dw(this, t, e));
          }

          this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
        }
      }
    }, (Iw.prototype = Object.create(Lw.prototype)).point = function (t, e) {
      Lw.prototype.point.call(this, e, t);
    }, Rw.prototype = {
      moveTo: function moveTo(t, e) {
        this._context.moveTo(e, t);
      },
      closePath: function closePath() {
        this._context.closePath();
      },
      lineTo: function lineTo(t, e) {
        this._context.lineTo(e, t);
      },
      bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
        this._context.bezierCurveTo(e, t, r, n, a, i);
      }
    }, jw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = [], this._y = [];
      },
      lineEnd: function lineEnd() {
        var t = this._x,
            e = this._y,
            n = t.length;
        if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = Yw(t), i = Yw(e), a = 0, o = 1; o < n; ++a, ++o) {
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], t[o], e[o]);
        }
        (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
      },
      point: function point(t, e) {
        this._x.push(+t), this._y.push(+e);
      }
    }, Uw.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = this._y = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
      },
      point: function point(t, e) {
        switch (t = +t, e = +e, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;

          default:
            if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
              var n = this._x * (1 - this._t) + t * this._t;
              this._context.lineTo(n, this._y), this._context.lineTo(n, e);
            }
        }

        this._x = t, this._y = e;
      }
    };
    var sk = "%Y-%m-%dT%H:%M:%S.%LZ",
        ck = Date.prototype.toISOString ? function (t) {
      return t.toISOString();
    } : gm(sk);
    var uk = ck;
    var lk = +new Date("2000-01-01T00:00:00.000Z") ? function (t) {
      var e = new Date(t);
      return isNaN(e) ? null : e;
    } : mm(sk);
    var hk = lk;

    function fk(t, e, n) {
      var r = new Wn(),
          i = e;
      return null == e ? (r.restart(t, e, n), r) : (e = +e, n = null == n ? Hn() : +n, r.restart(function a(o) {
        o += i, r.restart(a, i += e, n), t(o);
      }, e, n), r);
    }

    function dk(t) {
      return function () {
        return t;
      };
    }

    function pk(t) {
      return t[0];
    }

    function yk(t) {
      return t[1];
    }

    function gk() {
      this._ = null;
    }

    function mk(t) {
      t.U = t.C = t.L = t.R = t.P = t.N = null;
    }

    function vk(t, e) {
      var n = e,
          r = e.R,
          i = n.U;
      i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
    }

    function bk(t, e) {
      var n = e,
          r = e.L,
          i = n.U;
      i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
    }

    function _k(t) {
      for (; t.L;) {
        t = t.L;
      }

      return t;
    }

    gk.prototype = {
      constructor: gk,
      insert: function insert(t, e) {
        var n, r, i;

        if (t) {
          if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
            for (t = t.R; t.L;) {
              t = t.L;
            }

            t.L = e;
          } else t.R = e;

          n = t;
        } else this._ ? (t = _k(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);

        for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;) {
          n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.R && (vk(this, n), n = (t = n).U), n.C = !1, r.C = !0, bk(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.L && (bk(this, n), n = (t = n).U), n.C = !1, r.C = !0, vk(this, r)), n = t.U;
        }

        this._.C = !1;
      },
      remove: function remove(t) {
        t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
        var e,
            n,
            r,
            i = t.U,
            a = t.L,
            o = t.R;
        if (n = a ? o ? _k(o) : a : o, i ? i.L === t ? i.L = n : i.R = n : this._ = n, a && o ? (r = n.C, n.C = t.C, n.L = a, a.U = n, n !== o ? (i = n.U, n.U = t.U, t = n.R, i.L = t, n.R = o, o.U = n) : (n.U = i, i = n, t = n.R)) : (r = t.C, t = n), t && (t.U = i), !r) if (t && t.C) t.C = !1;else {
          do {
            if (t === this._) break;

            if (t === i.L) {
              if ((e = i.R).C && (e.C = !1, i.C = !0, vk(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
                e.R && e.R.C || (e.L.C = !1, e.C = !0, bk(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, vk(this, i), t = this._;
                break;
              }
            } else if ((e = i.L).C && (e.C = !1, i.C = !0, bk(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
              e.L && e.L.C || (e.R.C = !1, e.C = !0, vk(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, bk(this, i), t = this._;
              break;
            }

            e.C = !0, t = i, i = i.U;
          } while (!t.C);

          t && (t.C = !1);
        }
      }
    };
    var xk = gk;

    function wk(t, e, n, r) {
      var i = [null, null],
          a = Wk.push(i) - 1;
      return i.left = t, i.right = e, n && Tk(i, t, e, n), r && Tk(i, e, t, r), Hk[t.index].halfedges.push(a), Hk[e.index].halfedges.push(a), i;
    }

    function kk(t, e, n) {
      var r = [e, n];
      return r.left = t, r;
    }

    function Tk(t, e, n, r) {
      t[0] || t[1] ? t.left === n ? t[1] = r : t[0] = r : (t[0] = r, t.left = e, t.right = n);
    }

    function Ek(t, e, n, r, i) {
      var a,
          o = t[0],
          s = t[1],
          c = o[0],
          u = o[1],
          l = 0,
          h = 1,
          f = s[0] - c,
          d = s[1] - u;

      if (a = e - c, f || !(a > 0)) {
        if (a /= f, f < 0) {
          if (a < l) return;
          a < h && (h = a);
        } else if (f > 0) {
          if (a > h) return;
          a > l && (l = a);
        }

        if (a = r - c, f || !(a < 0)) {
          if (a /= f, f < 0) {
            if (a > h) return;
            a > l && (l = a);
          } else if (f > 0) {
            if (a < l) return;
            a < h && (h = a);
          }

          if (a = n - u, d || !(a > 0)) {
            if (a /= d, d < 0) {
              if (a < l) return;
              a < h && (h = a);
            } else if (d > 0) {
              if (a > h) return;
              a > l && (l = a);
            }

            if (a = i - u, d || !(a < 0)) {
              if (a /= d, d < 0) {
                if (a > h) return;
                a > l && (l = a);
              } else if (d > 0) {
                if (a < l) return;
                a < h && (h = a);
              }

              return !(l > 0 || h < 1) || (l > 0 && (t[0] = [c + l * f, u + l * d]), h < 1 && (t[1] = [c + h * f, u + h * d]), !0);
            }
          }
        }
      }
    }

    function Ck(t, e, n, r, i) {
      var a = t[1];
      if (a) return !0;
      var o,
          s,
          c = t[0],
          u = t.left,
          l = t.right,
          h = u[0],
          f = u[1],
          d = l[0],
          p = l[1],
          y = (h + d) / 2,
          g = (f + p) / 2;

      if (p === f) {
        if (y < e || y >= r) return;

        if (h > d) {
          if (c) {
            if (c[1] >= i) return;
          } else c = [y, n];

          a = [y, i];
        } else {
          if (c) {
            if (c[1] < n) return;
          } else c = [y, i];

          a = [y, n];
        }
      } else if (s = g - (o = (h - d) / (p - f)) * y, o < -1 || o > 1) {
        if (h > d) {
          if (c) {
            if (c[1] >= i) return;
          } else c = [(n - s) / o, n];

          a = [(i - s) / o, i];
        } else {
          if (c) {
            if (c[1] < n) return;
          } else c = [(i - s) / o, i];

          a = [(n - s) / o, n];
        }
      } else if (f < p) {
        if (c) {
          if (c[0] >= r) return;
        } else c = [e, o * e + s];

        a = [r, o * r + s];
      } else {
        if (c) {
          if (c[0] < e) return;
        } else c = [r, o * r + s];

        a = [e, o * e + s];
      }

      return t[0] = c, t[1] = a, !0;
    }

    function Sk(t, e) {
      var n = t.site,
          r = e.left,
          i = e.right;
      return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = e[1], i = e[0]) : (r = e[0], i = e[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
    }

    function Ak(t, e) {
      return e[+(e.left !== t.site)];
    }

    function Mk(t, e) {
      return e[+(e.left === t.site)];
    }

    var Nk,
        Dk = [];

    function Ok() {
      mk(this), this.x = this.y = this.arc = this.site = this.cy = null;
    }

    function Bk(t) {
      var e = t.P,
          n = t.N;

      if (e && n) {
        var r = e.site,
            i = t.site,
            a = n.site;

        if (r !== a) {
          var o = i[0],
              s = i[1],
              c = r[0] - o,
              u = r[1] - s,
              l = a[0] - o,
              h = a[1] - s,
              f = 2 * (c * h - u * l);

          if (!(f >= -Gk)) {
            var d = c * c + u * u,
                p = l * l + h * h,
                y = (h * d - u * p) / f,
                g = (c * p - l * d) / f,
                m = Dk.pop() || new Ok();
            m.arc = t, m.site = i, m.x = y + o, m.y = (m.cy = g + s) + Math.sqrt(y * y + g * g), t.circle = m;

            for (var v = null, b = $k._; b;) {
              if (m.y < b.y || m.y === b.y && m.x <= b.x) {
                if (!b.L) {
                  v = b.P;
                  break;
                }

                b = b.L;
              } else {
                if (!b.R) {
                  v = b;
                  break;
                }

                b = b.R;
              }
            }

            $k.insert(v, m), v || (Nk = m);
          }
        }
      }
    }

    function Lk(t) {
      var e = t.circle;
      e && (e.P || (Nk = e.N), $k.remove(e), Dk.push(e), mk(e), t.circle = null);
    }

    var Ik = [];

    function Rk() {
      mk(this), this.edge = this.site = this.circle = null;
    }

    function Fk(t) {
      var e = Ik.pop() || new Rk();
      return e.site = t, e;
    }

    function Pk(t) {
      Lk(t), qk.remove(t), Ik.push(t), mk(t);
    }

    function jk(t) {
      var e = t.circle,
          n = e.x,
          r = e.cy,
          i = [n, r],
          a = t.P,
          o = t.N,
          s = [t];
      Pk(t);

      for (var c = a; c.circle && Math.abs(n - c.circle.x) < Vk && Math.abs(r - c.circle.cy) < Vk;) {
        a = c.P, s.unshift(c), Pk(c), c = a;
      }

      s.unshift(c), Lk(c);

      for (var u = o; u.circle && Math.abs(n - u.circle.x) < Vk && Math.abs(r - u.circle.cy) < Vk;) {
        o = u.N, s.push(u), Pk(u), u = o;
      }

      s.push(u), Lk(u);
      var l,
          h = s.length;

      for (l = 1; l < h; ++l) {
        u = s[l], c = s[l - 1], Tk(u.edge, c.site, u.site, i);
      }

      c = s[0], (u = s[h - 1]).edge = wk(c.site, u.site, null, i), Bk(c), Bk(u);
    }

    function Yk(t) {
      for (var e, n, r, i, a = t[0], o = t[1], s = qk._; s;) {
        if ((r = zk(s, o) - a) > Vk) s = s.L;else {
          if (!((i = a - Uk(s, o)) > Vk)) {
            r > -Vk ? (e = s.P, n = s) : i > -Vk ? (e = s, n = s.N) : e = n = s;
            break;
          }

          if (!s.R) {
            e = s;
            break;
          }

          s = s.R;
        }
      }

      !function (t) {
        Hk[t.index] = {
          site: t,
          halfedges: []
        };
      }(t);
      var c = Fk(t);

      if (qk.insert(e, c), e || n) {
        if (e === n) return Lk(e), n = Fk(e.site), qk.insert(c, n), c.edge = n.edge = wk(e.site, c.site), Bk(e), void Bk(n);

        if (n) {
          Lk(e), Lk(n);
          var u = e.site,
              l = u[0],
              h = u[1],
              f = t[0] - l,
              d = t[1] - h,
              p = n.site,
              y = p[0] - l,
              g = p[1] - h,
              m = 2 * (f * g - d * y),
              v = f * f + d * d,
              b = y * y + g * g,
              _ = [(g * v - d * b) / m + l, (f * b - y * v) / m + h];
          Tk(n.edge, u, p, _), c.edge = wk(u, t, null, _), n.edge = wk(t, p, null, _), Bk(e), Bk(n);
        } else c.edge = wk(e.site, c.site);
      }
    }

    function zk(t, e) {
      var n = t.site,
          r = n[0],
          i = n[1],
          a = i - e;
      if (!a) return r;
      var o = t.P;
      if (!o) return -1 / 0;
      var s = (n = o.site)[0],
          c = n[1],
          u = c - e;
      if (!u) return s;
      var l = s - r,
          h = 1 / a - 1 / u,
          f = l / u;
      return h ? (-f + Math.sqrt(f * f - 2 * h * (l * l / (-2 * u) - c + u / 2 + i - a / 2))) / h + r : (r + s) / 2;
    }

    function Uk(t, e) {
      var n = t.N;
      if (n) return zk(n, e);
      var r = t.site;
      return r[1] === e ? r[0] : 1 / 0;
    }

    var qk,
        Hk,
        $k,
        Wk,
        Vk = 1e-6,
        Gk = 1e-12;

    function Xk(t, e, n) {
      return (t[0] - n[0]) * (e[1] - t[1]) - (t[0] - e[0]) * (n[1] - t[1]);
    }

    function Zk(t, e) {
      return e[1] - t[1] || e[0] - t[0];
    }

    function Qk(t, e) {
      var n,
          r,
          i,
          a = t.sort(Zk).pop();

      for (Wk = [], Hk = new Array(t.length), qk = new xk(), $k = new xk();;) {
        if (i = Nk, a && (!i || a[1] < i.y || a[1] === i.y && a[0] < i.x)) a[0] === n && a[1] === r || (Yk(a), n = a[0], r = a[1]), a = t.pop();else {
          if (!i) break;
          jk(i.arc);
        }
      }

      if (function () {
        for (var t, e, n, r, i = 0, a = Hk.length; i < a; ++i) {
          if ((t = Hk[i]) && (r = (e = t.halfedges).length)) {
            var o = new Array(r),
                s = new Array(r);

            for (n = 0; n < r; ++n) {
              o[n] = n, s[n] = Sk(t, Wk[e[n]]);
            }

            for (o.sort(function (t, e) {
              return s[e] - s[t];
            }), n = 0; n < r; ++n) {
              s[n] = e[o[n]];
            }

            for (n = 0; n < r; ++n) {
              e[n] = s[n];
            }
          }
        }
      }(), e) {
        var o = +e[0][0],
            s = +e[0][1],
            c = +e[1][0],
            u = +e[1][1];
        !function (t, e, n, r) {
          for (var i, a = Wk.length; a--;) {
            Ck(i = Wk[a], t, e, n, r) && Ek(i, t, e, n, r) && (Math.abs(i[0][0] - i[1][0]) > Vk || Math.abs(i[0][1] - i[1][1]) > Vk) || delete Wk[a];
          }
        }(o, s, c, u), function (t, e, n, r) {
          var i,
              a,
              o,
              s,
              c,
              u,
              l,
              h,
              f,
              d,
              p,
              y,
              g = Hk.length,
              m = !0;

          for (i = 0; i < g; ++i) {
            if (a = Hk[i]) {
              for (o = a.site, s = (c = a.halfedges).length; s--;) {
                Wk[c[s]] || c.splice(s, 1);
              }

              for (s = 0, u = c.length; s < u;) {
                p = (d = Mk(a, Wk[c[s]]))[0], y = d[1], h = (l = Ak(a, Wk[c[++s % u]]))[0], f = l[1], (Math.abs(p - h) > Vk || Math.abs(y - f) > Vk) && (c.splice(s, 0, Wk.push(kk(o, d, Math.abs(p - t) < Vk && r - y > Vk ? [t, Math.abs(h - t) < Vk ? f : r] : Math.abs(y - r) < Vk && n - p > Vk ? [Math.abs(f - r) < Vk ? h : n, r] : Math.abs(p - n) < Vk && y - e > Vk ? [n, Math.abs(h - n) < Vk ? f : e] : Math.abs(y - e) < Vk && p - t > Vk ? [Math.abs(f - e) < Vk ? h : t, e] : null)) - 1), ++u);
              }

              u && (m = !1);
            }
          }

          if (m) {
            var v,
                b,
                _,
                x = 1 / 0;

            for (i = 0, m = null; i < g; ++i) {
              (a = Hk[i]) && (_ = (v = (o = a.site)[0] - t) * v + (b = o[1] - e) * b) < x && (x = _, m = a);
            }

            if (m) {
              var w = [t, e],
                  k = [t, r],
                  T = [n, r],
                  E = [n, e];
              m.halfedges.push(Wk.push(kk(o = m.site, w, k)) - 1, Wk.push(kk(o, k, T)) - 1, Wk.push(kk(o, T, E)) - 1, Wk.push(kk(o, E, w)) - 1);
            }
          }

          for (i = 0; i < g; ++i) {
            (a = Hk[i]) && (a.halfedges.length || delete Hk[i]);
          }
        }(o, s, c, u);
      }

      this.edges = Wk, this.cells = Hk, qk = $k = Wk = Hk = null;
    }

    function Kk() {
      var t = pk,
          e = yk,
          n = null;

      function r(r) {
        return new Qk(r.map(function (n, i) {
          var a = [Math.round(t(n, i, r) / Vk) * Vk, Math.round(e(n, i, r) / Vk) * Vk];
          return a.index = i, a.data = n, a;
        }), n);
      }

      return r.polygons = function (t) {
        return r(t).polygons();
      }, r.links = function (t) {
        return r(t).links();
      }, r.triangles = function (t) {
        return r(t).triangles();
      }, r.x = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : dk(+e), r) : t;
      }, r.y = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : dk(+t), r) : e;
      }, r.extent = function (t) {
        return arguments.length ? (n = null == t ? null : [[+t[0][0], +t[0][1]], [+t[1][0], +t[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
      }, r.size = function (t) {
        return arguments.length ? (n = null == t ? null : [[0, 0], [+t[0], +t[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
      }, r;
    }

    function Jk(t) {
      return function () {
        return t;
      };
    }

    function tT(t, e, n) {
      this.target = t, this.type = e, this.transform = n;
    }

    function eT(t, e, n) {
      this.k = t, this.x = e, this.y = n;
    }

    Qk.prototype = {
      constructor: Qk,
      polygons: function polygons() {
        var t = this.edges;
        return this.cells.map(function (e) {
          var n = e.halfedges.map(function (n) {
            return Ak(e, t[n]);
          });
          return n.data = e.site.data, n;
        });
      },
      triangles: function triangles() {
        var t = [],
            e = this.edges;
        return this.cells.forEach(function (n, r) {
          if (a = (i = n.halfedges).length) for (var i, a, o, s = n.site, c = -1, u = e[i[a - 1]], l = u.left === s ? u.right : u.left; ++c < a;) {
            o = l, l = (u = e[i[c]]).left === s ? u.right : u.left, o && l && r < o.index && r < l.index && Xk(s, o, l) < 0 && t.push([s.data, o.data, l.data]);
          }
        }), t;
      },
      links: function links() {
        return this.edges.filter(function (t) {
          return t.right;
        }).map(function (t) {
          return {
            source: t.left.data,
            target: t.right.data
          };
        });
      },
      find: function find(t, e, n) {
        for (var r, i, a = this, o = a._found || 0, s = a.cells.length; !(i = a.cells[o]);) {
          if (++o >= s) return null;
        }

        var c = t - i.site[0],
            u = e - i.site[1],
            l = c * c + u * u;

        do {
          i = a.cells[r = o], o = null, i.halfedges.forEach(function (n) {
            var r = a.edges[n],
                s = r.left;

            if (s !== i.site && s || (s = r.right)) {
              var c = t - s[0],
                  u = e - s[1],
                  h = c * c + u * u;
              h < l && (l = h, o = s.index);
            }
          });
        } while (null !== o);

        return a._found = r, null == n || l <= n * n ? i.site : null;
      }
    }, eT.prototype = {
      constructor: eT,
      scale: function scale(t) {
        return 1 === t ? this : new eT(this.k * t, this.x, this.y);
      },
      translate: function translate(t, e) {
        return 0 === t & 0 === e ? this : new eT(this.k, this.x + this.k * t, this.y + this.k * e);
      },
      apply: function apply(t) {
        return [t[0] * this.k + this.x, t[1] * this.k + this.y];
      },
      applyX: function applyX(t) {
        return t * this.k + this.x;
      },
      applyY: function applyY(t) {
        return t * this.k + this.y;
      },
      invert: function invert(t) {
        return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
      },
      invertX: function invertX(t) {
        return (t - this.x) / this.k;
      },
      invertY: function invertY(t) {
        return (t - this.y) / this.k;
      },
      rescaleX: function rescaleX(t) {
        return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
      },
      rescaleY: function rescaleY(t) {
        return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
      },
      toString: function toString() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
      }
    };
    var nT = new eT(1, 0, 0);

    function rT(t) {
      for (; !t.__zoom;) {
        if (!(t = t.parentNode)) return nT;
      }

      return t.__zoom;
    }

    function iT() {
      le.stopImmediatePropagation();
    }

    function aT() {
      le.preventDefault(), le.stopImmediatePropagation();
    }

    function oT() {
      return !le.ctrlKey && !le.button;
    }

    function sT() {
      var t = this;
      return t instanceof SVGElement ? (t = t.ownerSVGElement || t).hasAttribute("viewBox") ? [[(t = t.viewBox.baseVal).x, t.y], [t.x + t.width, t.y + t.height]] : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]] : [[0, 0], [t.clientWidth, t.clientHeight]];
    }

    function cT() {
      return this.__zoom || nT;
    }

    function uT() {
      return -le.deltaY * (1 === le.deltaMode ? .05 : le.deltaMode ? 1 : .002);
    }

    function lT() {
      return navigator.maxTouchPoints || "ontouchstart" in this;
    }

    function hT(t, e, n) {
      var r = t.invertX(e[0][0]) - n[0][0],
          i = t.invertX(e[1][0]) - n[1][0],
          a = t.invertY(e[0][1]) - n[0][1],
          o = t.invertY(e[1][1]) - n[1][1];
      return t.translate(i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i), o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o));
    }

    function fT() {
      var t,
          e,
          n = oT,
          r = sT,
          i = hT,
          a = uT,
          o = lT,
          s = [0, 1 / 0],
          c = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]],
          u = 250,
          l = Op,
          h = ft("start", "zoom", "end"),
          f = 500,
          d = 0;

      function p(t) {
        t.property("__zoom", cT).on("wheel.zoom", x).on("mousedown.zoom", w).on("dblclick.zoom", k).filter(o).on("touchstart.zoom", T).on("touchmove.zoom", E).on("touchend.zoom touchcancel.zoom", C).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
      }

      function y(t, e) {
        return (e = Math.max(s[0], Math.min(s[1], e))) === t.k ? t : new eT(e, t.x, t.y);
      }

      function g(t, e, n) {
        var r = e[0] - n[0] * t.k,
            i = e[1] - n[1] * t.k;
        return r === t.x && i === t.y ? t : new eT(t.k, r, i);
      }

      function m(t) {
        return [(+t[0][0] + +t[1][0]) / 2, (+t[0][1] + +t[1][1]) / 2];
      }

      function v(t, e, n) {
        t.on("start.zoom", function () {
          b(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function () {
          b(this, arguments).end();
        }).tween("zoom", function () {
          var t = this,
              i = arguments,
              a = b(t, i),
              o = r.apply(t, i),
              s = null == n ? m(o) : "function" == typeof n ? n.apply(t, i) : n,
              c = Math.max(o[1][0] - o[0][0], o[1][1] - o[0][1]),
              u = t.__zoom,
              h = "function" == typeof e ? e.apply(t, i) : e,
              f = l(u.invert(s).concat(c / u.k), h.invert(s).concat(c / h.k));
          return function (t) {
            if (1 === t) t = h;else {
              var e = f(t),
                  n = c / e[2];
              t = new eT(n, s[0] - e[0] * n, s[1] - e[1] * n);
            }
            a.zoom(null, t);
          };
        });
      }

      function b(t, e, n) {
        return !n && t.__zooming || new _(t, e);
      }

      function _(t, e) {
        this.that = t, this.args = e, this.active = 0, this.extent = r.apply(t, e), this.taps = 0;
      }

      function x() {
        if (n.apply(this, arguments)) {
          var t = b(this, arguments),
              e = this.__zoom,
              r = Math.max(s[0], Math.min(s[1], e.k * Math.pow(2, a.apply(this, arguments)))),
              o = Bn(this);
          if (t.wheel) t.mouse[0][0] === o[0] && t.mouse[0][1] === o[1] || (t.mouse[1] = e.invert(t.mouse[0] = o)), clearTimeout(t.wheel);else {
            if (e.k === r) return;
            t.mouse = [o, e.invert(o)], ar(this), t.start();
          }
          aT(), t.wheel = setTimeout(u, 150), t.zoom("mouse", i(g(y(e, r), t.mouse[0], t.mouse[1]), t.extent, c));
        }

        function u() {
          t.wheel = null, t.end();
        }
      }

      function w() {
        if (!e && n.apply(this, arguments)) {
          var t = b(this, arguments, !0),
              r = Te(le.view).on("mousemove.zoom", u, !0).on("mouseup.zoom", l, !0),
              a = Bn(this),
              o = le.clientX,
              s = le.clientY;
          Se(le.view), iT(), t.mouse = [a, this.__zoom.invert(a)], ar(this), t.start();
        }

        function u() {
          if (aT(), !t.moved) {
            var e = le.clientX - o,
                n = le.clientY - s;
            t.moved = e * e + n * n > d;
          }

          t.zoom("mouse", i(g(t.that.__zoom, t.mouse[0] = Bn(t.that), t.mouse[1]), t.extent, c));
        }

        function l() {
          r.on("mousemove.zoom mouseup.zoom", null), Ae(le.view, t.moved), aT(), t.end();
        }
      }

      function k() {
        if (n.apply(this, arguments)) {
          var t = this.__zoom,
              e = Bn(this),
              a = t.invert(e),
              o = t.k * (le.shiftKey ? .5 : 2),
              s = i(g(y(t, o), e, a), r.apply(this, arguments), c);
          aT(), u > 0 ? Te(this).transition().duration(u).call(v, s, e) : Te(this).call(p.transform, s);
        }
      }

      function T() {
        if (n.apply(this, arguments)) {
          var e,
              r,
              i,
              a,
              o = le.touches,
              s = o.length,
              c = b(this, arguments, le.changedTouches.length === s);

          for (iT(), r = 0; r < s; ++r) {
            a = [a = On(this, o, (i = o[r]).identifier), this.__zoom.invert(a), i.identifier], c.touch0 ? c.touch1 || c.touch0[2] === a[2] || (c.touch1 = a, c.taps = 0) : (c.touch0 = a, e = !0, c.taps = 1 + !!t);
          }

          t && (t = clearTimeout(t)), e && (c.taps < 2 && (t = setTimeout(function () {
            t = null;
          }, f)), ar(this), c.start());
        }
      }

      function E() {
        if (this.__zooming) {
          var e,
              n,
              r,
              a,
              o = b(this, arguments),
              s = le.changedTouches,
              u = s.length;

          for (aT(), t && (t = clearTimeout(t)), o.taps = 0, e = 0; e < u; ++e) {
            r = On(this, s, (n = s[e]).identifier), o.touch0 && o.touch0[2] === n.identifier ? o.touch0[0] = r : o.touch1 && o.touch1[2] === n.identifier && (o.touch1[0] = r);
          }

          if (n = o.that.__zoom, o.touch1) {
            var l = o.touch0[0],
                h = o.touch0[1],
                f = o.touch1[0],
                d = o.touch1[1],
                p = (p = f[0] - l[0]) * p + (p = f[1] - l[1]) * p,
                m = (m = d[0] - h[0]) * m + (m = d[1] - h[1]) * m;
            n = y(n, Math.sqrt(p / m)), r = [(l[0] + f[0]) / 2, (l[1] + f[1]) / 2], a = [(h[0] + d[0]) / 2, (h[1] + d[1]) / 2];
          } else {
            if (!o.touch0) return;
            r = o.touch0[0], a = o.touch0[1];
          }

          o.zoom("touch", i(g(n, r, a), o.extent, c));
        }
      }

      function C() {
        if (this.__zooming) {
          var t,
              n,
              r = b(this, arguments),
              i = le.changedTouches,
              a = i.length;

          for (iT(), e && clearTimeout(e), e = setTimeout(function () {
            e = null;
          }, f), t = 0; t < a; ++t) {
            n = i[t], r.touch0 && r.touch0[2] === n.identifier ? delete r.touch0 : r.touch1 && r.touch1[2] === n.identifier && delete r.touch1;
          }

          if (r.touch1 && !r.touch0 && (r.touch0 = r.touch1, delete r.touch1), r.touch0) r.touch0[1] = this.__zoom.invert(r.touch0[0]);else if (r.end(), 2 === r.taps) {
            var o = Te(this).on("dblclick.zoom");
            o && o.apply(this, arguments);
          }
        }
      }

      return p.transform = function (t, e, n) {
        var r = t.selection ? t.selection() : t;
        r.property("__zoom", cT), t !== r ? v(t, e, n) : r.interrupt().each(function () {
          b(this, arguments).start().zoom(null, "function" == typeof e ? e.apply(this, arguments) : e).end();
        });
      }, p.scaleBy = function (t, e, n) {
        p.scaleTo(t, function () {
          var t = this.__zoom.k,
              n = "function" == typeof e ? e.apply(this, arguments) : e;
          return t * n;
        }, n);
      }, p.scaleTo = function (t, e, n) {
        p.transform(t, function () {
          var t = r.apply(this, arguments),
              a = this.__zoom,
              o = null == n ? m(t) : "function" == typeof n ? n.apply(this, arguments) : n,
              s = a.invert(o),
              u = "function" == typeof e ? e.apply(this, arguments) : e;
          return i(g(y(a, u), o, s), t, c);
        }, n);
      }, p.translateBy = function (t, e, n) {
        p.transform(t, function () {
          return i(this.__zoom.translate("function" == typeof e ? e.apply(this, arguments) : e, "function" == typeof n ? n.apply(this, arguments) : n), r.apply(this, arguments), c);
        });
      }, p.translateTo = function (t, e, n, a) {
        p.transform(t, function () {
          var t = r.apply(this, arguments),
              o = this.__zoom,
              s = null == a ? m(t) : "function" == typeof a ? a.apply(this, arguments) : a;
          return i(nT.translate(s[0], s[1]).scale(o.k).translate("function" == typeof e ? -e.apply(this, arguments) : -e, "function" == typeof n ? -n.apply(this, arguments) : -n), t, c);
        }, a);
      }, _.prototype = {
        start: function start() {
          return 1 == ++this.active && (this.that.__zooming = this, this.emit("start")), this;
        },
        zoom: function zoom(t, e) {
          return this.mouse && "mouse" !== t && (this.mouse[1] = e.invert(this.mouse[0])), this.touch0 && "touch" !== t && (this.touch0[1] = e.invert(this.touch0[0])), this.touch1 && "touch" !== t && (this.touch1[1] = e.invert(this.touch1[0])), this.that.__zoom = e, this.emit("zoom"), this;
        },
        end: function end() {
          return 0 == --this.active && (delete this.that.__zooming, this.emit("end")), this;
        },
        emit: function emit(t) {
          ge(new tT(p, t, this.that.__zoom), h.apply, h, [t, this.that, this.args]);
        }
      }, p.wheelDelta = function (t) {
        return arguments.length ? (a = "function" == typeof t ? t : Jk(+t), p) : a;
      }, p.filter = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : Jk(!!t), p) : n;
      }, p.touchable = function (t) {
        return arguments.length ? (o = "function" == typeof t ? t : Jk(!!t), p) : o;
      }, p.extent = function (t) {
        return arguments.length ? (r = "function" == typeof t ? t : Jk([[+t[0][0], +t[0][1]], [+t[1][0], +t[1][1]]]), p) : r;
      }, p.scaleExtent = function (t) {
        return arguments.length ? (s[0] = +t[0], s[1] = +t[1], p) : [s[0], s[1]];
      }, p.translateExtent = function (t) {
        return arguments.length ? (c[0][0] = +t[0][0], c[1][0] = +t[1][0], c[0][1] = +t[0][1], c[1][1] = +t[1][1], p) : [[c[0][0], c[0][1]], [c[1][0], c[1][1]]];
      }, p.constrain = function (t) {
        return arguments.length ? (i = t, p) : i;
      }, p.duration = function (t) {
        return arguments.length ? (u = +t, p) : u;
      }, p.interpolate = function (t) {
        return arguments.length ? (l = t, p) : l;
      }, p.on = function () {
        var t = h.on.apply(h, arguments);
        return t === h ? p : t;
      }, p.clickDistance = function (t) {
        return arguments.length ? (d = (t = +t) * t, p) : Math.sqrt(d);
      }, p;
    }

    rT.prototype = eT.prototype;
  },
  681: function _(t, e, n) {
    t.exports = {
      graphlib: n(574),
      layout: n(8123),
      debug: n(7570),
      util: {
        time: n(1138).time,
        notime: n(1138).notime
      },
      version: n(8177)
    };
  },
  1207: function _(t, e, n) {
    var r = n(8436),
        i = n(4079);
    t.exports = {
      run: function run(t) {
        var e = "greedy" === t.graph().acyclicer ? i(t, function (t) {
          return function (e) {
            return t.edge(e).weight;
          };
        }(t)) : function (t) {
          var e = [],
              n = {},
              i = {};
          return r.forEach(t.nodes(), function a(o) {
            r.has(i, o) || (i[o] = !0, n[o] = !0, r.forEach(t.outEdges(o), function (t) {
              r.has(n, t.w) ? e.push(t) : a(t.w);
            }), delete n[o]);
          }), e;
        }(t);
        r.forEach(e, function (e) {
          var n = t.edge(e);
          t.removeEdge(e), n.forwardName = e.name, n.reversed = !0, t.setEdge(e.w, e.v, n, r.uniqueId("rev"));
        });
      },
      undo: function undo(t) {
        r.forEach(t.edges(), function (e) {
          var n = t.edge(e);

          if (n.reversed) {
            t.removeEdge(e);
            var r = n.forwardName;
            delete n.reversed, delete n.forwardName, t.setEdge(e.w, e.v, n, r);
          }
        });
      }
    };
  },
  1133: function _(t, e, n) {
    var r = n(8436),
        i = n(1138);

    function a(t, e, n, r, a, o) {
      var s = {
        width: 0,
        height: 0,
        rank: o,
        borderType: e
      },
          c = a[e][o - 1],
          u = i.addDummyNode(t, "border", s, n);
      a[e][o] = u, t.setParent(u, r), c && t.setEdge(c, u, {
        weight: 1
      });
    }

    t.exports = function (t) {
      r.forEach(t.children(), function e(n) {
        var i = t.children(n),
            o = t.node(n);

        if (i.length && r.forEach(i, e), r.has(o, "minRank")) {
          o.borderLeft = [], o.borderRight = [];

          for (var s = o.minRank, c = o.maxRank + 1; s < c; ++s) {
            a(t, "borderLeft", "_bl", n, o, s), a(t, "borderRight", "_br", n, o, s);
          }
        }
      });
    };
  },
  3258: function _(t, e, n) {
    var r = n(8436);

    function i(t) {
      r.forEach(t.nodes(), function (e) {
        a(t.node(e));
      }), r.forEach(t.edges(), function (e) {
        a(t.edge(e));
      });
    }

    function a(t) {
      var e = t.width;
      t.width = t.height, t.height = e;
    }

    function o(t) {
      t.y = -t.y;
    }

    function s(t) {
      var e = t.x;
      t.x = t.y, t.y = e;
    }

    t.exports = {
      adjust: function adjust(t) {
        var e = t.graph().rankdir.toLowerCase();
        "lr" !== e && "rl" !== e || i(t);
      },
      undo: function undo(t) {
        var e = t.graph().rankdir.toLowerCase();
        "bt" !== e && "rl" !== e || function (t) {
          r.forEach(t.nodes(), function (e) {
            o(t.node(e));
          }), r.forEach(t.edges(), function (e) {
            var n = t.edge(e);
            r.forEach(n.points, o), r.has(n, "y") && o(n);
          });
        }(t), "lr" !== e && "rl" !== e || (function (t) {
          r.forEach(t.nodes(), function (e) {
            s(t.node(e));
          }), r.forEach(t.edges(), function (e) {
            var n = t.edge(e);
            r.forEach(n.points, s), r.has(n, "x") && s(n);
          });
        }(t), i(t));
      }
    };
  },
  7822: function _(t) {
    function e() {
      var t = {};
      t._next = t._prev = t, this._sentinel = t;
    }

    function n(t) {
      t._prev._next = t._next, t._next._prev = t._prev, delete t._next, delete t._prev;
    }

    function r(t, e) {
      if ("_next" !== t && "_prev" !== t) return e;
    }

    t.exports = e, e.prototype.dequeue = function () {
      var t = this._sentinel,
          e = t._prev;
      if (e !== t) return n(e), e;
    }, e.prototype.enqueue = function (t) {
      var e = this._sentinel;
      t._prev && t._next && n(t), t._next = e._next, e._next._prev = t, e._next = t, t._prev = e;
    }, e.prototype.toString = function () {
      for (var t = [], e = this._sentinel, n = e._prev; n !== e;) {
        t.push(JSON.stringify(n, r)), n = n._prev;
      }

      return "[" + t.join(", ") + "]";
    };
  },
  7570: function _(t, e, n) {
    var r = n(8436),
        i = n(1138),
        a = n(574).Graph;
    t.exports = {
      debugOrdering: function debugOrdering(t) {
        var e = i.buildLayerMatrix(t),
            n = new a({
          compound: !0,
          multigraph: !0
        }).setGraph({});
        return r.forEach(t.nodes(), function (e) {
          n.setNode(e, {
            label: e
          }), n.setParent(e, "layer" + t.node(e).rank);
        }), r.forEach(t.edges(), function (t) {
          n.setEdge(t.v, t.w, {}, t.name);
        }), r.forEach(e, function (t, e) {
          var i = "layer" + e;
          n.setNode(i, {
            rank: "same"
          }), r.reduce(t, function (t, e) {
            return n.setEdge(t, e, {
              style: "invis"
            }), e;
          });
        }), n;
      }
    };
  },
  574: function _(t, e, n) {
    var r;

    try {
      r = n(8282);
    } catch (t) {}

    r || (r = window.graphlib), t.exports = r;
  },
  4079: function _(t, e, n) {
    var r = n(8436),
        i = n(574).Graph,
        a = n(7822);

    t.exports = function (t, e) {
      if (t.nodeCount() <= 1) return [];

      var n = function (t, e) {
        var n = new i(),
            o = 0,
            s = 0;
        r.forEach(t.nodes(), function (t) {
          n.setNode(t, {
            v: t,
            "in": 0,
            out: 0
          });
        }), r.forEach(t.edges(), function (t) {
          var r = n.edge(t.v, t.w) || 0,
              i = e(t),
              a = r + i;
          n.setEdge(t.v, t.w, a), s = Math.max(s, n.node(t.v).out += i), o = Math.max(o, n.node(t.w)["in"] += i);
        });
        var u = r.range(s + o + 3).map(function () {
          return new a();
        }),
            l = o + 1;
        return r.forEach(n.nodes(), function (t) {
          c(u, l, n.node(t));
        }), {
          graph: n,
          buckets: u,
          zeroIdx: l
        };
      }(t, e || o),
          u = function (t, e, n) {
        for (var r, i = [], a = e[e.length - 1], o = e[0]; t.nodeCount();) {
          for (; r = o.dequeue();) {
            s(t, e, n, r);
          }

          for (; r = a.dequeue();) {
            s(t, e, n, r);
          }

          if (t.nodeCount()) for (var c = e.length - 2; c > 0; --c) {
            if (r = e[c].dequeue()) {
              i = i.concat(s(t, e, n, r, !0));
              break;
            }
          }
        }

        return i;
      }(n.graph, n.buckets, n.zeroIdx);

      return r.flatten(r.map(u, function (e) {
        return t.outEdges(e.v, e.w);
      }), !0);
    };

    var o = r.constant(1);

    function s(t, e, n, i, a) {
      var o = a ? [] : void 0;
      return r.forEach(t.inEdges(i.v), function (r) {
        var i = t.edge(r),
            s = t.node(r.v);
        a && o.push({
          v: r.v,
          w: r.w
        }), s.out -= i, c(e, n, s);
      }), r.forEach(t.outEdges(i.v), function (r) {
        var i = t.edge(r),
            a = r.w,
            o = t.node(a);
        o["in"] -= i, c(e, n, o);
      }), t.removeNode(i.v), o;
    }

    function c(t, e, n) {
      n.out ? n["in"] ? t[n.out - n["in"] + e].enqueue(n) : t[t.length - 1].enqueue(n) : t[0].enqueue(n);
    }
  },
  8123: function _(t, e, n) {
    var r = n(8436),
        i = n(1207),
        a = n(5995),
        o = n(8093),
        s = n(1138).normalizeRanks,
        c = n(4219),
        u = n(1138).removeEmptyRanks,
        l = n(2981),
        h = n(1133),
        f = n(3258),
        d = n(3408),
        p = n(7873),
        y = n(1138),
        g = n(574).Graph;

    t.exports = function (t, e) {
      var n = e && e.debugTiming ? y.time : y.notime;
      n("layout", function () {
        var e = n("  buildLayoutGraph", function () {
          return function (t) {
            var e = new g({
              multigraph: !0,
              compound: !0
            }),
                n = C(t.graph());
            return e.setGraph(r.merge({}, v, E(n, m), r.pick(n, b))), r.forEach(t.nodes(), function (n) {
              var i = C(t.node(n));
              e.setNode(n, r.defaults(E(i, _), x)), e.setParent(n, t.parent(n));
            }), r.forEach(t.edges(), function (n) {
              var i = C(t.edge(n));
              e.setEdge(n, r.merge({}, k, E(i, w), r.pick(i, T)));
            }), e;
          }(t);
        });
        n("  runLayout", function () {
          !function (t, e) {
            e("    makeSpaceForEdgeLabels", function () {
              !function (t) {
                var e = t.graph();
                e.ranksep /= 2, r.forEach(t.edges(), function (n) {
                  var r = t.edge(n);
                  r.minlen *= 2, "c" !== r.labelpos.toLowerCase() && ("TB" === e.rankdir || "BT" === e.rankdir ? r.width += r.labeloffset : r.height += r.labeloffset);
                });
              }(t);
            }), e("    removeSelfEdges", function () {
              !function (t) {
                r.forEach(t.edges(), function (e) {
                  if (e.v === e.w) {
                    var n = t.node(e.v);
                    n.selfEdges || (n.selfEdges = []), n.selfEdges.push({
                      e: e,
                      label: t.edge(e)
                    }), t.removeEdge(e);
                  }
                });
              }(t);
            }), e("    acyclic", function () {
              i.run(t);
            }), e("    nestingGraph.run", function () {
              l.run(t);
            }), e("    rank", function () {
              o(y.asNonCompoundGraph(t));
            }), e("    injectEdgeLabelProxies", function () {
              !function (t) {
                r.forEach(t.edges(), function (e) {
                  var n = t.edge(e);

                  if (n.width && n.height) {
                    var r = t.node(e.v),
                        i = {
                      rank: (t.node(e.w).rank - r.rank) / 2 + r.rank,
                      e: e
                    };
                    y.addDummyNode(t, "edge-proxy", i, "_ep");
                  }
                });
              }(t);
            }), e("    removeEmptyRanks", function () {
              u(t);
            }), e("    nestingGraph.cleanup", function () {
              l.cleanup(t);
            }), e("    normalizeRanks", function () {
              s(t);
            }), e("    assignRankMinMax", function () {
              !function (t) {
                var e = 0;
                r.forEach(t.nodes(), function (n) {
                  var i = t.node(n);
                  i.borderTop && (i.minRank = t.node(i.borderTop).rank, i.maxRank = t.node(i.borderBottom).rank, e = r.max(e, i.maxRank));
                }), t.graph().maxRank = e;
              }(t);
            }), e("    removeEdgeLabelProxies", function () {
              !function (t) {
                r.forEach(t.nodes(), function (e) {
                  var n = t.node(e);
                  "edge-proxy" === n.dummy && (t.edge(n.e).labelRank = n.rank, t.removeNode(e));
                });
              }(t);
            }), e("    normalize.run", function () {
              a.run(t);
            }), e("    parentDummyChains", function () {
              c(t);
            }), e("    addBorderSegments", function () {
              h(t);
            }), e("    order", function () {
              d(t);
            }), e("    insertSelfEdges", function () {
              !function (t) {
                var e = y.buildLayerMatrix(t);
                r.forEach(e, function (e) {
                  var n = 0;
                  r.forEach(e, function (e, i) {
                    var a = t.node(e);
                    a.order = i + n, r.forEach(a.selfEdges, function (e) {
                      y.addDummyNode(t, "selfedge", {
                        width: e.label.width,
                        height: e.label.height,
                        rank: a.rank,
                        order: i + ++n,
                        e: e.e,
                        label: e.label
                      }, "_se");
                    }), delete a.selfEdges;
                  });
                });
              }(t);
            }), e("    adjustCoordinateSystem", function () {
              f.adjust(t);
            }), e("    position", function () {
              p(t);
            }), e("    positionSelfEdges", function () {
              !function (t) {
                r.forEach(t.nodes(), function (e) {
                  var n = t.node(e);

                  if ("selfedge" === n.dummy) {
                    var r = t.node(n.e.v),
                        i = r.x + r.width / 2,
                        a = r.y,
                        o = n.x - i,
                        s = r.height / 2;
                    t.setEdge(n.e, n.label), t.removeNode(e), n.label.points = [{
                      x: i + 2 * o / 3,
                      y: a - s
                    }, {
                      x: i + 5 * o / 6,
                      y: a - s
                    }, {
                      x: i + o,
                      y: a
                    }, {
                      x: i + 5 * o / 6,
                      y: a + s
                    }, {
                      x: i + 2 * o / 3,
                      y: a + s
                    }], n.label.x = n.x, n.label.y = n.y;
                  }
                });
              }(t);
            }), e("    removeBorderNodes", function () {
              !function (t) {
                r.forEach(t.nodes(), function (e) {
                  if (t.children(e).length) {
                    var n = t.node(e),
                        i = t.node(n.borderTop),
                        a = t.node(n.borderBottom),
                        o = t.node(r.last(n.borderLeft)),
                        s = t.node(r.last(n.borderRight));
                    n.width = Math.abs(s.x - o.x), n.height = Math.abs(a.y - i.y), n.x = o.x + n.width / 2, n.y = i.y + n.height / 2;
                  }
                }), r.forEach(t.nodes(), function (e) {
                  "border" === t.node(e).dummy && t.removeNode(e);
                });
              }(t);
            }), e("    normalize.undo", function () {
              a.undo(t);
            }), e("    fixupEdgeLabelCoords", function () {
              !function (t) {
                r.forEach(t.edges(), function (e) {
                  var n = t.edge(e);
                  if (r.has(n, "x")) switch ("l" !== n.labelpos && "r" !== n.labelpos || (n.width -= n.labeloffset), n.labelpos) {
                    case "l":
                      n.x -= n.width / 2 + n.labeloffset;
                      break;

                    case "r":
                      n.x += n.width / 2 + n.labeloffset;
                  }
                });
              }(t);
            }), e("    undoCoordinateSystem", function () {
              f.undo(t);
            }), e("    translateGraph", function () {
              !function (t) {
                var e = Number.POSITIVE_INFINITY,
                    n = 0,
                    i = Number.POSITIVE_INFINITY,
                    a = 0,
                    o = t.graph(),
                    s = o.marginx || 0,
                    c = o.marginy || 0;

                function u(t) {
                  var r = t.x,
                      o = t.y,
                      s = t.width,
                      c = t.height;
                  e = Math.min(e, r - s / 2), n = Math.max(n, r + s / 2), i = Math.min(i, o - c / 2), a = Math.max(a, o + c / 2);
                }

                r.forEach(t.nodes(), function (e) {
                  u(t.node(e));
                }), r.forEach(t.edges(), function (e) {
                  var n = t.edge(e);
                  r.has(n, "x") && u(n);
                }), e -= s, i -= c, r.forEach(t.nodes(), function (n) {
                  var r = t.node(n);
                  r.x -= e, r.y -= i;
                }), r.forEach(t.edges(), function (n) {
                  var a = t.edge(n);
                  r.forEach(a.points, function (t) {
                    t.x -= e, t.y -= i;
                  }), r.has(a, "x") && (a.x -= e), r.has(a, "y") && (a.y -= i);
                }), o.width = n - e + s, o.height = a - i + c;
              }(t);
            }), e("    assignNodeIntersects", function () {
              !function (t) {
                r.forEach(t.edges(), function (e) {
                  var n,
                      r,
                      i = t.edge(e),
                      a = t.node(e.v),
                      o = t.node(e.w);
                  i.points ? (n = i.points[0], r = i.points[i.points.length - 1]) : (i.points = [], n = o, r = a), i.points.unshift(y.intersectRect(a, n)), i.points.push(y.intersectRect(o, r));
                });
              }(t);
            }), e("    reversePoints", function () {
              !function (t) {
                r.forEach(t.edges(), function (e) {
                  var n = t.edge(e);
                  n.reversed && n.points.reverse();
                });
              }(t);
            }), e("    acyclic.undo", function () {
              i.undo(t);
            });
          }(e, n);
        }), n("  updateInputGraph", function () {
          !function (t, e) {
            r.forEach(t.nodes(), function (n) {
              var r = t.node(n),
                  i = e.node(n);
              r && (r.x = i.x, r.y = i.y, e.children(n).length && (r.width = i.width, r.height = i.height));
            }), r.forEach(t.edges(), function (n) {
              var i = t.edge(n),
                  a = e.edge(n);
              i.points = a.points, r.has(a, "x") && (i.x = a.x, i.y = a.y);
            }), t.graph().width = e.graph().width, t.graph().height = e.graph().height;
          }(t, e);
        });
      });
    };

    var m = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"],
        v = {
      ranksep: 50,
      edgesep: 20,
      nodesep: 50,
      rankdir: "tb"
    },
        b = ["acyclicer", "ranker", "rankdir", "align"],
        _ = ["width", "height"],
        x = {
      width: 0,
      height: 0
    },
        w = ["minlen", "weight", "width", "height", "labeloffset"],
        k = {
      minlen: 1,
      weight: 1,
      width: 0,
      height: 0,
      labeloffset: 10,
      labelpos: "r"
    },
        T = ["labelpos"];

    function E(t, e) {
      return r.mapValues(r.pick(t, e), Number);
    }

    function C(t) {
      var e = {};
      return r.forEach(t, function (t, n) {
        e[n.toLowerCase()] = t;
      }), e;
    }
  },
  8436: function _(t, e, n) {
    var r;

    try {
      r = {
        cloneDeep: n(361),
        constant: n(5703),
        defaults: n(1747),
        each: n(6073),
        filter: n(3105),
        find: n(3311),
        flatten: n(5564),
        forEach: n(4486),
        forIn: n(2620),
        has: n(8721),
        isUndefined: n(2353),
        last: n(928),
        map: n(5161),
        mapValues: n(6604),
        max: n(6162),
        merge: n(3857),
        min: n(3632),
        minBy: n(2762),
        now: n(7771),
        pick: n(9722),
        range: n(6026),
        reduce: n(4061),
        sortBy: n(9734),
        uniqueId: n(3955),
        values: n(2628),
        zipObject: n(7287)
      };
    } catch (t) {}

    r || (r = window._), t.exports = r;
  },
  2981: function _(t, e, n) {
    var r = n(8436),
        i = n(1138);

    function a(t, e, n, o, s, c, u) {
      var l = t.children(u);

      if (l.length) {
        var h = i.addBorderNode(t, "_bt"),
            f = i.addBorderNode(t, "_bb"),
            d = t.node(u);
        t.setParent(h, u), d.borderTop = h, t.setParent(f, u), d.borderBottom = f, r.forEach(l, function (r) {
          a(t, e, n, o, s, c, r);
          var i = t.node(r),
              l = i.borderTop ? i.borderTop : r,
              d = i.borderBottom ? i.borderBottom : r,
              p = i.borderTop ? o : 2 * o,
              y = l !== d ? 1 : s - c[u] + 1;
          t.setEdge(h, l, {
            weight: p,
            minlen: y,
            nestingEdge: !0
          }), t.setEdge(d, f, {
            weight: p,
            minlen: y,
            nestingEdge: !0
          });
        }), t.parent(u) || t.setEdge(e, h, {
          weight: 0,
          minlen: s + c[u]
        });
      } else u !== e && t.setEdge(e, u, {
        weight: 0,
        minlen: n
      });
    }

    t.exports = {
      run: function run(t) {
        var e = i.addDummyNode(t, "root", {}, "_root"),
            n = function (t) {
          var e = {};

          function n(i, a) {
            var o = t.children(i);
            o && o.length && r.forEach(o, function (t) {
              n(t, a + 1);
            }), e[i] = a;
          }

          return r.forEach(t.children(), function (t) {
            n(t, 1);
          }), e;
        }(t),
            o = r.max(r.values(n)) - 1,
            s = 2 * o + 1;

        t.graph().nestingRoot = e, r.forEach(t.edges(), function (e) {
          t.edge(e).minlen *= s;
        });

        var c = function (t) {
          return r.reduce(t.edges(), function (e, n) {
            return e + t.edge(n).weight;
          }, 0);
        }(t) + 1;

        r.forEach(t.children(), function (r) {
          a(t, e, s, c, o, n, r);
        }), t.graph().nodeRankFactor = s;
      },
      cleanup: function cleanup(t) {
        var e = t.graph();
        t.removeNode(e.nestingRoot), delete e.nestingRoot, r.forEach(t.edges(), function (e) {
          t.edge(e).nestingEdge && t.removeEdge(e);
        });
      }
    };
  },
  5995: function _(t, e, n) {
    var r = n(8436),
        i = n(1138);
    t.exports = {
      run: function run(t) {
        t.graph().dummyChains = [], r.forEach(t.edges(), function (e) {
          !function (t, e) {
            var n,
                r,
                a,
                o = e.v,
                s = t.node(o).rank,
                c = e.w,
                u = t.node(c).rank,
                l = e.name,
                h = t.edge(e),
                f = h.labelRank;

            if (u !== s + 1) {
              for (t.removeEdge(e), a = 0, ++s; s < u; ++a, ++s) {
                h.points = [], r = {
                  width: 0,
                  height: 0,
                  edgeLabel: h,
                  edgeObj: e,
                  rank: s
                }, n = i.addDummyNode(t, "edge", r, "_d"), s === f && (r.width = h.width, r.height = h.height, r.dummy = "edge-label", r.labelpos = h.labelpos), t.setEdge(o, n, {
                  weight: h.weight
                }, l), 0 === a && t.graph().dummyChains.push(n), o = n;
              }

              t.setEdge(o, c, {
                weight: h.weight
              }, l);
            }
          }(t, e);
        });
      },
      undo: function undo(t) {
        r.forEach(t.graph().dummyChains, function (e) {
          var n,
              r = t.node(e),
              i = r.edgeLabel;

          for (t.setEdge(r.edgeObj, i); r.dummy;) {
            n = t.successors(e)[0], t.removeNode(e), i.points.push({
              x: r.x,
              y: r.y
            }), "edge-label" === r.dummy && (i.x = r.x, i.y = r.y, i.width = r.width, i.height = r.height), e = n, r = t.node(e);
          }
        });
      }
    };
  },
  5093: function _(t, e, n) {
    var r = n(8436);

    t.exports = function (t, e, n) {
      var i,
          a = {};
      r.forEach(n, function (n) {
        for (var r, o, s = t.parent(n); s;) {
          if ((r = t.parent(s)) ? (o = a[r], a[r] = s) : (o = i, i = s), o && o !== s) return void e.setEdge(o, s);
          s = r;
        }
      });
    };
  },
  5439: function _(t, e, n) {
    var r = n(8436);

    t.exports = function (t, e) {
      return r.map(e, function (e) {
        var n = t.inEdges(e);

        if (n.length) {
          var i = r.reduce(n, function (e, n) {
            var r = t.edge(n),
                i = t.node(n.v);
            return {
              sum: e.sum + r.weight * i.order,
              weight: e.weight + r.weight
            };
          }, {
            sum: 0,
            weight: 0
          });
          return {
            v: e,
            barycenter: i.sum / i.weight,
            weight: i.weight
          };
        }

        return {
          v: e
        };
      });
    };
  },
  3128: function _(t, e, n) {
    var r = n(8436),
        i = n(574).Graph;

    t.exports = function (t, e, n) {
      var a = function (t) {
        for (var e; t.hasNode(e = r.uniqueId("_root"));) {
          ;
        }

        return e;
      }(t),
          o = new i({
        compound: !0
      }).setGraph({
        root: a
      }).setDefaultNodeLabel(function (e) {
        return t.node(e);
      });

      return r.forEach(t.nodes(), function (i) {
        var s = t.node(i),
            c = t.parent(i);
        (s.rank === e || s.minRank <= e && e <= s.maxRank) && (o.setNode(i), o.setParent(i, c || a), r.forEach(t[n](i), function (e) {
          var n = e.v === i ? e.w : e.v,
              a = o.edge(n, i),
              s = r.isUndefined(a) ? 0 : a.weight;
          o.setEdge(n, i, {
            weight: t.edge(e).weight + s
          });
        }), r.has(s, "minRank") && o.setNode(i, {
          borderLeft: s.borderLeft[e],
          borderRight: s.borderRight[e]
        }));
      }), o;
    };
  },
  6630: function _(t, e, n) {
    var r = n(8436);

    function i(t, e, n) {
      for (var i = r.zipObject(n, r.map(n, function (t, e) {
        return e;
      })), a = r.flatten(r.map(e, function (e) {
        return r.sortBy(r.map(t.outEdges(e), function (e) {
          return {
            pos: i[e.w],
            weight: t.edge(e).weight
          };
        }), "pos");
      }), !0), o = 1; o < n.length;) {
        o <<= 1;
      }

      var s = 2 * o - 1;
      o -= 1;
      var c = r.map(new Array(s), function () {
        return 0;
      }),
          u = 0;
      return r.forEach(a.forEach(function (t) {
        var e = t.pos + o;
        c[e] += t.weight;

        for (var n = 0; e > 0;) {
          e % 2 && (n += c[e + 1]), c[e = e - 1 >> 1] += t.weight;
        }

        u += t.weight * n;
      })), u;
    }

    t.exports = function (t, e) {
      for (var n = 0, r = 1; r < e.length; ++r) {
        n += i(t, e[r - 1], e[r]);
      }

      return n;
    };
  },
  3408: function _(t, e, n) {
    var r = n(8436),
        i = n(2588),
        a = n(6630),
        o = n(1026),
        s = n(3128),
        c = n(5093),
        u = n(574).Graph,
        l = n(1138);

    function h(t, e, n) {
      return r.map(e, function (e) {
        return s(t, e, n);
      });
    }

    function f(t, e) {
      var n = new u();
      r.forEach(t, function (t) {
        var i = t.graph().root,
            a = o(t, i, n, e);
        r.forEach(a.vs, function (e, n) {
          t.node(e).order = n;
        }), c(t, n, a.vs);
      });
    }

    function d(t, e) {
      r.forEach(e, function (e) {
        r.forEach(e, function (e, n) {
          t.node(e).order = n;
        });
      });
    }

    t.exports = function (t) {
      var e = l.maxRank(t),
          n = h(t, r.range(1, e + 1), "inEdges"),
          o = h(t, r.range(e - 1, -1, -1), "outEdges"),
          s = i(t);
      d(t, s);

      for (var c, u = Number.POSITIVE_INFINITY, p = 0, y = 0; y < 4; ++p, ++y) {
        f(p % 2 ? n : o, p % 4 >= 2), s = l.buildLayerMatrix(t);
        var g = a(t, s);
        g < u && (y = 0, c = r.cloneDeep(s), u = g);
      }

      d(t, c);
    };
  },
  2588: function _(t, e, n) {
    var r = n(8436);

    t.exports = function (t) {
      var e = {},
          n = r.filter(t.nodes(), function (e) {
        return !t.children(e).length;
      }),
          i = r.max(r.map(n, function (e) {
        return t.node(e).rank;
      })),
          a = r.map(r.range(i + 1), function () {
        return [];
      }),
          o = r.sortBy(n, function (e) {
        return t.node(e).rank;
      });
      return r.forEach(o, function n(i) {
        if (!r.has(e, i)) {
          e[i] = !0;
          var o = t.node(i);
          a[o.rank].push(i), r.forEach(t.successors(i), n);
        }
      }), a;
    };
  },
  9567: function _(t, e, n) {
    var r = n(8436);

    t.exports = function (t, e) {
      var n = {};
      return r.forEach(t, function (t, e) {
        var i = n[t.v] = {
          indegree: 0,
          "in": [],
          out: [],
          vs: [t.v],
          i: e
        };
        r.isUndefined(t.barycenter) || (i.barycenter = t.barycenter, i.weight = t.weight);
      }), r.forEach(e.edges(), function (t) {
        var e = n[t.v],
            i = n[t.w];
        r.isUndefined(e) || r.isUndefined(i) || (i.indegree++, e.out.push(n[t.w]));
      }), function (t) {
        var e = [];

        function n(t) {
          return function (e) {
            var n, i, a, o;
            e.merged || (r.isUndefined(e.barycenter) || r.isUndefined(t.barycenter) || e.barycenter >= t.barycenter) && (i = e, a = 0, o = 0, (n = t).weight && (a += n.barycenter * n.weight, o += n.weight), i.weight && (a += i.barycenter * i.weight, o += i.weight), n.vs = i.vs.concat(n.vs), n.barycenter = a / o, n.weight = o, n.i = Math.min(i.i, n.i), i.merged = !0);
          };
        }

        function i(e) {
          return function (n) {
            n["in"].push(e), 0 == --n.indegree && t.push(n);
          };
        }

        for (; t.length;) {
          var a = t.pop();
          e.push(a), r.forEach(a["in"].reverse(), n(a)), r.forEach(a.out, i(a));
        }

        return r.map(r.filter(e, function (t) {
          return !t.merged;
        }), function (t) {
          return r.pick(t, ["vs", "i", "barycenter", "weight"]);
        });
      }(r.filter(n, function (t) {
        return !t.indegree;
      }));
    };
  },
  1026: function _(t, e, n) {
    var r = n(8436),
        i = n(5439),
        a = n(9567),
        o = n(7304);

    t.exports = function t(e, n, s, c) {
      var u = e.children(n),
          l = e.node(n),
          h = l ? l.borderLeft : void 0,
          f = l ? l.borderRight : void 0,
          d = {};
      h && (u = r.filter(u, function (t) {
        return t !== h && t !== f;
      }));
      var p = i(e, u);
      r.forEach(p, function (n) {
        if (e.children(n.v).length) {
          var i = t(e, n.v, s, c);
          d[n.v] = i, r.has(i, "barycenter") && (a = n, o = i, r.isUndefined(a.barycenter) ? (a.barycenter = o.barycenter, a.weight = o.weight) : (a.barycenter = (a.barycenter * a.weight + o.barycenter * o.weight) / (a.weight + o.weight), a.weight += o.weight));
        }

        var a, o;
      });
      var y = a(p, s);
      !function (t, e) {
        r.forEach(t, function (t) {
          t.vs = r.flatten(t.vs.map(function (t) {
            return e[t] ? e[t].vs : t;
          }), !0);
        });
      }(y, d);
      var g = o(y, c);

      if (h && (g.vs = r.flatten([h, g.vs, f], !0), e.predecessors(h).length)) {
        var m = e.node(e.predecessors(h)[0]),
            v = e.node(e.predecessors(f)[0]);
        r.has(g, "barycenter") || (g.barycenter = 0, g.weight = 0), g.barycenter = (g.barycenter * g.weight + m.order + v.order) / (g.weight + 2), g.weight += 2;
      }

      return g;
    };
  },
  7304: function _(t, e, n) {
    var r = n(8436),
        i = n(1138);

    function a(t, e, n) {
      for (var i; e.length && (i = r.last(e)).i <= n;) {
        e.pop(), t.push(i.vs), n++;
      }

      return n;
    }

    t.exports = function (t, e) {
      var n,
          o = i.partition(t, function (t) {
        return r.has(t, "barycenter");
      }),
          s = o.lhs,
          c = r.sortBy(o.rhs, function (t) {
        return -t.i;
      }),
          u = [],
          l = 0,
          h = 0,
          f = 0;
      s.sort((n = !!e, function (t, e) {
        return t.barycenter < e.barycenter ? -1 : t.barycenter > e.barycenter ? 1 : n ? e.i - t.i : t.i - e.i;
      })), f = a(u, c, f), r.forEach(s, function (t) {
        f += t.vs.length, u.push(t.vs), l += t.barycenter * t.weight, h += t.weight, f = a(u, c, f);
      });
      var d = {
        vs: r.flatten(u, !0)
      };
      return h && (d.barycenter = l / h, d.weight = h), d;
    };
  },
  4219: function _(t, e, n) {
    var r = n(8436);

    t.exports = function (t) {
      var e = function (t) {
        var e = {},
            n = 0;
        return r.forEach(t.children(), function i(a) {
          var o = n;
          r.forEach(t.children(a), i), e[a] = {
            low: o,
            lim: n++
          };
        }), e;
      }(t);

      r.forEach(t.graph().dummyChains, function (n) {
        for (var r = t.node(n), i = r.edgeObj, a = function (t, e, n, r) {
          var i,
              a,
              o = [],
              s = [],
              c = Math.min(e[n].low, e[r].low),
              u = Math.max(e[n].lim, e[r].lim);
          i = n;

          do {
            i = t.parent(i), o.push(i);
          } while (i && (e[i].low > c || u > e[i].lim));

          for (a = i, i = r; (i = t.parent(i)) !== a;) {
            s.push(i);
          }

          return {
            path: o.concat(s.reverse()),
            lca: a
          };
        }(t, e, i.v, i.w), o = a.path, s = a.lca, c = 0, u = o[c], l = !0; n !== i.w;) {
          if (r = t.node(n), l) {
            for (; (u = o[c]) !== s && t.node(u).maxRank < r.rank;) {
              c++;
            }

            u === s && (l = !1);
          }

          if (!l) {
            for (; c < o.length - 1 && t.node(u = o[c + 1]).minRank <= r.rank;) {
              c++;
            }

            u = o[c];
          }

          t.setParent(n, u), n = t.successors(n)[0];
        }
      });
    };
  },
  3573: function _(t, e, n) {
    var r = n(8436),
        i = n(574).Graph,
        a = n(1138);

    function o(t, e) {
      var n = {};
      return r.reduce(e, function (e, i) {
        var a = 0,
            o = 0,
            s = e.length,
            u = r.last(i);
        return r.forEach(i, function (e, l) {
          var h = function (t, e) {
            if (t.node(e).dummy) return r.find(t.predecessors(e), function (e) {
              return t.node(e).dummy;
            });
          }(t, e),
              f = h ? t.node(h).order : s;

          (h || e === u) && (r.forEach(i.slice(o, l + 1), function (e) {
            r.forEach(t.predecessors(e), function (r) {
              var i = t.node(r),
                  o = i.order;
              !(o < a || f < o) || i.dummy && t.node(e).dummy || c(n, r, e);
            });
          }), o = l + 1, a = f);
        }), i;
      }), n;
    }

    function s(t, e) {
      var n = {};

      function i(e, i, a, o, s) {
        var u;
        r.forEach(r.range(i, a), function (i) {
          u = e[i], t.node(u).dummy && r.forEach(t.predecessors(u), function (e) {
            var r = t.node(e);
            r.dummy && (r.order < o || r.order > s) && c(n, e, u);
          });
        });
      }

      return r.reduce(e, function (e, n) {
        var a,
            o = -1,
            s = 0;
        return r.forEach(n, function (r, c) {
          if ("border" === t.node(r).dummy) {
            var u = t.predecessors(r);
            u.length && (a = t.node(u[0]).order, i(n, s, c, o, a), s = c, o = a);
          }

          i(n, s, n.length, a, e.length);
        }), n;
      }), n;
    }

    function c(t, e, n) {
      if (e > n) {
        var r = e;
        e = n, n = r;
      }

      var i = t[e];
      i || (t[e] = i = {}), i[n] = !0;
    }

    function u(t, e, n) {
      if (e > n) {
        var i = e;
        e = n, n = i;
      }

      return r.has(t[e], n);
    }

    function l(t, e, n, i) {
      var a = {},
          o = {},
          s = {};
      return r.forEach(e, function (t) {
        r.forEach(t, function (t, e) {
          a[t] = t, o[t] = t, s[t] = e;
        });
      }), r.forEach(e, function (t) {
        var e = -1;
        r.forEach(t, function (t) {
          var c = i(t);

          if (c.length) {
            c = r.sortBy(c, function (t) {
              return s[t];
            });

            for (var l = (c.length - 1) / 2, h = Math.floor(l), f = Math.ceil(l); h <= f; ++h) {
              var d = c[h];
              o[t] === t && e < s[d] && !u(n, t, d) && (o[d] = t, o[t] = a[t] = a[d], e = s[d]);
            }
          }
        });
      }), {
        root: a,
        align: o
      };
    }

    function h(t, e, n, a, o) {
      var s = {},
          c = function (t, e, n, a) {
        var o = new i(),
            s = t.graph(),
            c = function (t, e, n) {
          return function (i, a, o) {
            var s,
                c = i.node(a),
                u = i.node(o),
                l = 0;
            if (l += c.width / 2, r.has(c, "labelpos")) switch (c.labelpos.toLowerCase()) {
              case "l":
                s = -c.width / 2;
                break;

              case "r":
                s = c.width / 2;
            }
            if (s && (l += n ? s : -s), s = 0, l += (c.dummy ? e : t) / 2, l += (u.dummy ? e : t) / 2, l += u.width / 2, r.has(u, "labelpos")) switch (u.labelpos.toLowerCase()) {
              case "l":
                s = u.width / 2;
                break;

              case "r":
                s = -u.width / 2;
            }
            return s && (l += n ? s : -s), s = 0, l;
          };
        }(s.nodesep, s.edgesep, a);

        return r.forEach(e, function (e) {
          var i;
          r.forEach(e, function (e) {
            var r = n[e];

            if (o.setNode(r), i) {
              var a = n[i],
                  s = o.edge(a, r);
              o.setEdge(a, r, Math.max(c(t, e, i), s || 0));
            }

            i = e;
          });
        }), o;
      }(t, e, n, o),
          u = o ? "borderLeft" : "borderRight";

      function l(t, e) {
        for (var n = c.nodes(), r = n.pop(), i = {}; r;) {
          i[r] ? t(r) : (i[r] = !0, n.push(r), n = n.concat(e(r))), r = n.pop();
        }
      }

      return l(function (t) {
        s[t] = c.inEdges(t).reduce(function (t, e) {
          return Math.max(t, s[e.v] + c.edge(e));
        }, 0);
      }, c.predecessors.bind(c)), l(function (e) {
        var n = c.outEdges(e).reduce(function (t, e) {
          return Math.min(t, s[e.w] - c.edge(e));
        }, Number.POSITIVE_INFINITY),
            r = t.node(e);
        n !== Number.POSITIVE_INFINITY && r.borderType !== u && (s[e] = Math.max(s[e], n));
      }, c.successors.bind(c)), r.forEach(a, function (t) {
        s[t] = s[n[t]];
      }), s;
    }

    function f(t, e) {
      return r.minBy(r.values(e), function (e) {
        var n = Number.NEGATIVE_INFINITY,
            i = Number.POSITIVE_INFINITY;
        return r.forIn(e, function (e, r) {
          var a = function (t, e) {
            return t.node(e).width;
          }(t, r) / 2;

          n = Math.max(e + a, n), i = Math.min(e - a, i);
        }), n - i;
      });
    }

    function d(t, e) {
      var n = r.values(e),
          i = r.min(n),
          a = r.max(n);
      r.forEach(["u", "d"], function (n) {
        r.forEach(["l", "r"], function (o) {
          var s,
              c = n + o,
              u = t[c];

          if (u !== e) {
            var l = r.values(u);
            (s = "l" === o ? i - r.min(l) : a - r.max(l)) && (t[c] = r.mapValues(u, function (t) {
              return t + s;
            }));
          }
        });
      });
    }

    function p(t, e) {
      return r.mapValues(t.ul, function (n, i) {
        if (e) return t[e.toLowerCase()][i];
        var a = r.sortBy(r.map(t, i));
        return (a[1] + a[2]) / 2;
      });
    }

    t.exports = {
      positionX: function positionX(t) {
        var e,
            n = a.buildLayerMatrix(t),
            i = r.merge(o(t, n), s(t, n)),
            c = {};
        r.forEach(["u", "d"], function (a) {
          e = "u" === a ? n : r.values(n).reverse(), r.forEach(["l", "r"], function (n) {
            "r" === n && (e = r.map(e, function (t) {
              return r.values(t).reverse();
            }));
            var o = ("u" === a ? t.predecessors : t.successors).bind(t),
                s = l(0, e, i, o),
                u = h(t, e, s.root, s.align, "r" === n);
            "r" === n && (u = r.mapValues(u, function (t) {
              return -t;
            })), c[a + n] = u;
          });
        });
        var u = f(t, c);
        return d(c, u), p(c, t.graph().align);
      },
      findType1Conflicts: o,
      findType2Conflicts: s,
      addConflict: c,
      hasConflict: u,
      verticalAlignment: l,
      horizontalCompaction: h,
      alignCoordinates: d,
      findSmallestWidthAlignment: f,
      balance: p
    };
  },
  7873: function _(t, e, n) {
    var r = n(8436),
        i = n(1138),
        a = n(3573).positionX;

    t.exports = function (t) {
      (function (t) {
        var e = i.buildLayerMatrix(t),
            n = t.graph().ranksep,
            a = 0;
        r.forEach(e, function (e) {
          var i = r.max(r.map(e, function (e) {
            return t.node(e).height;
          }));
          r.forEach(e, function (e) {
            t.node(e).y = a + i / 2;
          }), a += i + n;
        });
      })(t = i.asNonCompoundGraph(t)), r.forEach(a(t), function (e, n) {
        t.node(n).x = e;
      });
    };
  },
  300: function _(t, e, n) {
    var r = n(8436),
        i = n(574).Graph,
        a = n(6681).slack;

    function o(t, e) {
      return r.forEach(t.nodes(), function n(i) {
        r.forEach(e.nodeEdges(i), function (r) {
          var o = r.v,
              s = i === o ? r.w : o;
          t.hasNode(s) || a(e, r) || (t.setNode(s, {}), t.setEdge(i, s, {}), n(s));
        });
      }), t.nodeCount();
    }

    function s(t, e) {
      return r.minBy(e.edges(), function (n) {
        if (t.hasNode(n.v) !== t.hasNode(n.w)) return a(e, n);
      });
    }

    function c(t, e, n) {
      r.forEach(t.nodes(), function (t) {
        e.node(t).rank += n;
      });
    }

    t.exports = function (t) {
      var e,
          n,
          r = new i({
        directed: !1
      }),
          u = t.nodes()[0],
          l = t.nodeCount();

      for (r.setNode(u, {}); o(r, t) < l;) {
        e = s(r, t), n = r.hasNode(e.v) ? a(t, e) : -a(t, e), c(r, t, n);
      }

      return r;
    };
  },
  8093: function _(t, e, n) {
    var r = n(6681).longestPath,
        i = n(300),
        a = n(2472);

    t.exports = function (t) {
      switch (t.graph().ranker) {
        case "network-simplex":
        default:
          !function (t) {
            a(t);
          }(t);
          break;

        case "tight-tree":
          !function (t) {
            r(t), i(t);
          }(t);
          break;

        case "longest-path":
          o(t);
      }
    };

    var o = r;
  },
  2472: function _(t, e, n) {
    var r = n(8436),
        i = n(300),
        a = n(6681).slack,
        o = n(6681).longestPath,
        s = n(574).alg.preorder,
        c = n(574).alg.postorder,
        u = n(1138).simplify;

    function l(t) {
      t = u(t), o(t);
      var e,
          n = i(t);

      for (d(n), h(n, t); e = y(n);) {
        m(n, t, e, g(n, t, e));
      }
    }

    function h(t, e) {
      var n = c(t, t.nodes());
      n = n.slice(0, n.length - 1), r.forEach(n, function (n) {
        !function (t, e, n) {
          var r = t.node(n).parent;
          t.edge(n, r).cutvalue = f(t, e, n);
        }(t, e, n);
      });
    }

    function f(t, e, n) {
      var i = t.node(n).parent,
          a = !0,
          o = e.edge(n, i),
          s = 0;
      return o || (a = !1, o = e.edge(i, n)), s = o.weight, r.forEach(e.nodeEdges(n), function (r) {
        var o,
            c,
            u = r.v === n,
            l = u ? r.w : r.v;

        if (l !== i) {
          var h = u === a,
              f = e.edge(r).weight;

          if (s += h ? f : -f, o = n, c = l, t.hasEdge(o, c)) {
            var d = t.edge(n, l).cutvalue;
            s += h ? -d : d;
          }
        }
      }), s;
    }

    function d(t, e) {
      arguments.length < 2 && (e = t.nodes()[0]), p(t, {}, 1, e);
    }

    function p(t, e, n, i, a) {
      var o = n,
          s = t.node(i);
      return e[i] = !0, r.forEach(t.neighbors(i), function (a) {
        r.has(e, a) || (n = p(t, e, n, a, i));
      }), s.low = o, s.lim = n++, a ? s.parent = a : delete s.parent, n;
    }

    function y(t) {
      return r.find(t.edges(), function (e) {
        return t.edge(e).cutvalue < 0;
      });
    }

    function g(t, e, n) {
      var i = n.v,
          o = n.w;
      e.hasEdge(i, o) || (i = n.w, o = n.v);
      var s = t.node(i),
          c = t.node(o),
          u = s,
          l = !1;
      s.lim > c.lim && (u = c, l = !0);
      var h = r.filter(e.edges(), function (e) {
        return l === v(0, t.node(e.v), u) && l !== v(0, t.node(e.w), u);
      });
      return r.minBy(h, function (t) {
        return a(e, t);
      });
    }

    function m(t, e, n, i) {
      var a = n.v,
          o = n.w;
      t.removeEdge(a, o), t.setEdge(i.v, i.w, {}), d(t), h(t, e), function (t, e) {
        var n = r.find(t.nodes(), function (t) {
          return !e.node(t).parent;
        }),
            i = s(t, n);
        i = i.slice(1), r.forEach(i, function (n) {
          var r = t.node(n).parent,
              i = e.edge(n, r),
              a = !1;
          i || (i = e.edge(r, n), a = !0), e.node(n).rank = e.node(r).rank + (a ? i.minlen : -i.minlen);
        });
      }(t, e);
    }

    function v(t, e, n) {
      return n.low <= e.lim && e.lim <= n.lim;
    }

    t.exports = l, l.initLowLimValues = d, l.initCutValues = h, l.calcCutValue = f, l.leaveEdge = y, l.enterEdge = g, l.exchangeEdges = m;
  },
  6681: function _(t, e, n) {
    var r = n(8436);
    t.exports = {
      longestPath: function longestPath(t) {
        var e = {};
        r.forEach(t.sources(), function n(i) {
          var a = t.node(i);
          if (r.has(e, i)) return a.rank;
          e[i] = !0;
          var o = r.min(r.map(t.outEdges(i), function (e) {
            return n(e.w) - t.edge(e).minlen;
          }));
          return o !== Number.POSITIVE_INFINITY && null != o || (o = 0), a.rank = o;
        });
      },
      slack: function slack(t, e) {
        return t.node(e.w).rank - t.node(e.v).rank - t.edge(e).minlen;
      }
    };
  },
  1138: function _(t, e, n) {
    var r = n(8436),
        i = n(574).Graph;

    function a(t, e, n, i) {
      var a;

      do {
        a = r.uniqueId(i);
      } while (t.hasNode(a));

      return n.dummy = e, t.setNode(a, n), a;
    }

    function o(t) {
      return r.max(r.map(t.nodes(), function (e) {
        var n = t.node(e).rank;
        if (!r.isUndefined(n)) return n;
      }));
    }

    t.exports = {
      addDummyNode: a,
      simplify: function simplify(t) {
        var e = new i().setGraph(t.graph());
        return r.forEach(t.nodes(), function (n) {
          e.setNode(n, t.node(n));
        }), r.forEach(t.edges(), function (n) {
          var r = e.edge(n.v, n.w) || {
            weight: 0,
            minlen: 1
          },
              i = t.edge(n);
          e.setEdge(n.v, n.w, {
            weight: r.weight + i.weight,
            minlen: Math.max(r.minlen, i.minlen)
          });
        }), e;
      },
      asNonCompoundGraph: function asNonCompoundGraph(t) {
        var e = new i({
          multigraph: t.isMultigraph()
        }).setGraph(t.graph());
        return r.forEach(t.nodes(), function (n) {
          t.children(n).length || e.setNode(n, t.node(n));
        }), r.forEach(t.edges(), function (n) {
          e.setEdge(n, t.edge(n));
        }), e;
      },
      successorWeights: function successorWeights(t) {
        var e = r.map(t.nodes(), function (e) {
          var n = {};
          return r.forEach(t.outEdges(e), function (e) {
            n[e.w] = (n[e.w] || 0) + t.edge(e).weight;
          }), n;
        });
        return r.zipObject(t.nodes(), e);
      },
      predecessorWeights: function predecessorWeights(t) {
        var e = r.map(t.nodes(), function (e) {
          var n = {};
          return r.forEach(t.inEdges(e), function (e) {
            n[e.v] = (n[e.v] || 0) + t.edge(e).weight;
          }), n;
        });
        return r.zipObject(t.nodes(), e);
      },
      intersectRect: function intersectRect(t, e) {
        var n,
            r,
            i = t.x,
            a = t.y,
            o = e.x - i,
            s = e.y - a,
            c = t.width / 2,
            u = t.height / 2;
        if (!o && !s) throw new Error("Not possible to find intersection inside of the rectangle");
        return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = c * s / o), {
          x: i + n,
          y: a + r
        };
      },
      buildLayerMatrix: function buildLayerMatrix(t) {
        var e = r.map(r.range(o(t) + 1), function () {
          return [];
        });
        return r.forEach(t.nodes(), function (n) {
          var i = t.node(n),
              a = i.rank;
          r.isUndefined(a) || (e[a][i.order] = n);
        }), e;
      },
      normalizeRanks: function normalizeRanks(t) {
        var e = r.min(r.map(t.nodes(), function (e) {
          return t.node(e).rank;
        }));
        r.forEach(t.nodes(), function (n) {
          var i = t.node(n);
          r.has(i, "rank") && (i.rank -= e);
        });
      },
      removeEmptyRanks: function removeEmptyRanks(t) {
        var e = r.min(r.map(t.nodes(), function (e) {
          return t.node(e).rank;
        })),
            n = [];
        r.forEach(t.nodes(), function (r) {
          var i = t.node(r).rank - e;
          n[i] || (n[i] = []), n[i].push(r);
        });
        var i = 0,
            a = t.graph().nodeRankFactor;
        r.forEach(n, function (e, n) {
          r.isUndefined(e) && n % a != 0 ? --i : i && r.forEach(e, function (e) {
            t.node(e).rank += i;
          });
        });
      },
      addBorderNode: function addBorderNode(t, e, n, r) {
        var i = {
          width: 0,
          height: 0
        };
        return arguments.length >= 4 && (i.rank = n, i.order = r), a(t, "border", i, e);
      },
      maxRank: o,
      partition: function partition(t, e) {
        var n = {
          lhs: [],
          rhs: []
        };
        return r.forEach(t, function (t) {
          e(t) ? n.lhs.push(t) : n.rhs.push(t);
        }), n;
      },
      time: function time(t, e) {
        var n = r.now();

        try {
          return e();
        } finally {
          console.log(t + " time: " + (r.now() - n) + "ms");
        }
      },
      notime: function notime(t, e) {
        return e();
      }
    };
  },
  8177: function _(t) {
    t.exports = "0.8.5";
  },
  7856: function _(t) {
    t.exports = function () {
      var t = Object.hasOwnProperty,
          e = Object.setPrototypeOf,
          n = Object.isFrozen,
          r = Object.getPrototypeOf,
          i = Object.getOwnPropertyDescriptor,
          a = Object.freeze,
          o = Object.seal,
          s = Object.create,
          c = "undefined" != typeof Reflect && Reflect,
          u = c.apply,
          l = c.construct;
      u || (u = function u(t, e, n) {
        return t.apply(e, n);
      }), a || (a = function a(t) {
        return t;
      }), o || (o = function o(t) {
        return t;
      }), l || (l = function l(t, e) {
        return new (Function.prototype.bind.apply(t, [null].concat(function (t) {
          if (Array.isArray(t)) {
            for (var e = 0, n = Array(t.length); e < t.length; e++) {
              n[e] = t[e];
            }

            return n;
          }

          return Array.from(t);
        }(e))))();
      });

      var h,
          f = w(Array.prototype.forEach),
          d = w(Array.prototype.pop),
          p = w(Array.prototype.push),
          y = w(String.prototype.toLowerCase),
          g = w(String.prototype.match),
          m = w(String.prototype.replace),
          v = w(String.prototype.indexOf),
          b = w(String.prototype.trim),
          _ = w(RegExp.prototype.test),
          x = (h = TypeError, function () {
        for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
          e[n] = arguments[n];
        }

        return l(h, e);
      });

      function w(t) {
        return function (e) {
          for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
            r[i - 1] = arguments[i];
          }

          return u(t, e, r);
        };
      }

      function k(t, r) {
        e && e(t, null);

        for (var i = r.length; i--;) {
          var a = r[i];

          if ("string" == typeof a) {
            var o = y(a);
            o !== a && (n(r) || (r[i] = o), a = o);
          }

          t[a] = !0;
        }

        return t;
      }

      function T(e) {
        var n = s(null),
            r = void 0;

        for (r in e) {
          u(t, e, [r]) && (n[r] = e[r]);
        }

        return n;
      }

      function E(t, e) {
        for (; null !== t;) {
          var n = i(t, e);

          if (n) {
            if (n.get) return w(n.get);
            if ("function" == typeof n.value) return w(n.value);
          }

          t = r(t);
        }

        return function (t) {
          return console.warn("fallback value for", t), null;
        };
      }

      var C = a(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
          S = a(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
          A = a(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
          M = a(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
          N = a(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]),
          D = a(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
          O = a(["#text"]),
          B = a(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
          L = a(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
          I = a(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
          R = a(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
          F = o(/\{\{[\s\S]*|[\s\S]*\}\}/gm),
          P = o(/<%[\s\S]*|[\s\S]*%>/gm),
          j = o(/^data-[\-\w.\u00B7-\uFFFF]/),
          Y = o(/^aria-[\-\w]+$/),
          z = o(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
          U = o(/^(?:\w+script|data):/i),
          q = o(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
          H = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      };

      function $(t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = Array(t.length); e < t.length; e++) {
            n[e] = t[e];
          }

          return n;
        }

        return Array.from(t);
      }

      var W = function W() {
        return "undefined" == typeof window ? null : window;
      },
          V = function V(t, e) {
        if ("object" !== (void 0 === t ? "undefined" : H(t)) || "function" != typeof t.createPolicy) return null;
        var n = null,
            r = "data-tt-policy-suffix";
        e.currentScript && e.currentScript.hasAttribute(r) && (n = e.currentScript.getAttribute(r));
        var i = "dompurify" + (n ? "#" + n : "");

        try {
          return t.createPolicy(i, {
            createHTML: function createHTML(t) {
              return t;
            }
          });
        } catch (t) {
          return console.warn("TrustedTypes policy " + i + " could not be created."), null;
        }
      };

      return function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : W(),
            n = function n(e) {
          return t(e);
        };

        if (n.version = "2.3.5", n.removed = [], !e || !e.document || 9 !== e.document.nodeType) return n.isSupported = !1, n;
        var r = e.document,
            i = e.document,
            o = e.DocumentFragment,
            s = e.HTMLTemplateElement,
            c = e.Node,
            u = e.Element,
            l = e.NodeFilter,
            h = e.NamedNodeMap,
            w = void 0 === h ? e.NamedNodeMap || e.MozNamedAttrMap : h,
            G = e.HTMLFormElement,
            X = e.DOMParser,
            Z = e.trustedTypes,
            Q = u.prototype,
            K = E(Q, "cloneNode"),
            J = E(Q, "nextSibling"),
            tt = E(Q, "childNodes"),
            et = E(Q, "parentNode");

        if ("function" == typeof s) {
          var nt = i.createElement("template");
          nt.content && nt.content.ownerDocument && (i = nt.content.ownerDocument);
        }

        var rt = V(Z, r),
            it = rt ? rt.createHTML("") : "",
            at = i,
            ot = at.implementation,
            st = at.createNodeIterator,
            ct = at.createDocumentFragment,
            ut = at.getElementsByTagName,
            lt = r.importNode,
            ht = {};

        try {
          ht = T(i).documentMode ? i.documentMode : {};
        } catch (t) {}

        var ft = {};
        n.isSupported = "function" == typeof et && ot && void 0 !== ot.createHTMLDocument && 9 !== ht;

        var dt = F,
            pt = P,
            yt = j,
            gt = Y,
            mt = U,
            vt = q,
            bt = z,
            _t = null,
            xt = k({}, [].concat($(C), $(S), $(A), $(N), $(O))),
            wt = null,
            kt = k({}, [].concat($(B), $(L), $(I), $(R))),
            Tt = Object.seal(Object.create(null, {
          tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1
          }
        })),
            Et = null,
            Ct = null,
            St = !0,
            At = !0,
            Mt = !1,
            Nt = !1,
            Dt = !1,
            Ot = !1,
            Bt = !1,
            Lt = !1,
            It = !1,
            Rt = !1,
            Ft = !0,
            Pt = !0,
            jt = !1,
            Yt = {},
            zt = null,
            Ut = k({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
            qt = null,
            Ht = k({}, ["audio", "video", "img", "source", "image", "track"]),
            $t = null,
            Wt = k({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
            Vt = "http://www.w3.org/1998/Math/MathML",
            Gt = "http://www.w3.org/2000/svg",
            Xt = "http://www.w3.org/1999/xhtml",
            Zt = Xt,
            Qt = !1,
            Kt = void 0,
            Jt = ["application/xhtml+xml", "text/html"],
            te = "text/html",
            ee = void 0,
            ne = null,
            re = i.createElement("form"),
            ie = function ie(t) {
          return t instanceof RegExp || t instanceof Function;
        },
            ae = function ae(t) {
          ne && ne === t || (t && "object" === (void 0 === t ? "undefined" : H(t)) || (t = {}), t = T(t), _t = "ALLOWED_TAGS" in t ? k({}, t.ALLOWED_TAGS) : xt, wt = "ALLOWED_ATTR" in t ? k({}, t.ALLOWED_ATTR) : kt, $t = "ADD_URI_SAFE_ATTR" in t ? k(T(Wt), t.ADD_URI_SAFE_ATTR) : Wt, qt = "ADD_DATA_URI_TAGS" in t ? k(T(Ht), t.ADD_DATA_URI_TAGS) : Ht, zt = "FORBID_CONTENTS" in t ? k({}, t.FORBID_CONTENTS) : Ut, Et = "FORBID_TAGS" in t ? k({}, t.FORBID_TAGS) : {}, Ct = "FORBID_ATTR" in t ? k({}, t.FORBID_ATTR) : {}, Yt = "USE_PROFILES" in t && t.USE_PROFILES, St = !1 !== t.ALLOW_ARIA_ATTR, At = !1 !== t.ALLOW_DATA_ATTR, Mt = t.ALLOW_UNKNOWN_PROTOCOLS || !1, Nt = t.SAFE_FOR_TEMPLATES || !1, Dt = t.WHOLE_DOCUMENT || !1, Lt = t.RETURN_DOM || !1, It = t.RETURN_DOM_FRAGMENT || !1, Rt = t.RETURN_TRUSTED_TYPE || !1, Bt = t.FORCE_BODY || !1, Ft = !1 !== t.SANITIZE_DOM, Pt = !1 !== t.KEEP_CONTENT, jt = t.IN_PLACE || !1, bt = t.ALLOWED_URI_REGEXP || bt, Zt = t.NAMESPACE || Xt, t.CUSTOM_ELEMENT_HANDLING && ie(t.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Tt.tagNameCheck = t.CUSTOM_ELEMENT_HANDLING.tagNameCheck), t.CUSTOM_ELEMENT_HANDLING && ie(t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Tt.attributeNameCheck = t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), t.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (Tt.allowCustomizedBuiltInElements = t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Kt = Kt = -1 === Jt.indexOf(t.PARSER_MEDIA_TYPE) ? te : t.PARSER_MEDIA_TYPE, ee = "application/xhtml+xml" === Kt ? function (t) {
            return t;
          } : y, Nt && (At = !1), It && (Lt = !0), Yt && (_t = k({}, [].concat($(O))), wt = [], !0 === Yt.html && (k(_t, C), k(wt, B)), !0 === Yt.svg && (k(_t, S), k(wt, L), k(wt, R)), !0 === Yt.svgFilters && (k(_t, A), k(wt, L), k(wt, R)), !0 === Yt.mathMl && (k(_t, N), k(wt, I), k(wt, R))), t.ADD_TAGS && (_t === xt && (_t = T(_t)), k(_t, t.ADD_TAGS)), t.ADD_ATTR && (wt === kt && (wt = T(wt)), k(wt, t.ADD_ATTR)), t.ADD_URI_SAFE_ATTR && k($t, t.ADD_URI_SAFE_ATTR), t.FORBID_CONTENTS && (zt === Ut && (zt = T(zt)), k(zt, t.FORBID_CONTENTS)), Pt && (_t["#text"] = !0), Dt && k(_t, ["html", "head", "body"]), _t.table && (k(_t, ["tbody"]), delete Et.tbody), a && a(t), ne = t);
        },
            oe = k({}, ["mi", "mo", "mn", "ms", "mtext"]),
            se = k({}, ["foreignobject", "desc", "title", "annotation-xml"]),
            ce = k({}, S);

        k(ce, A), k(ce, M);
        var ue = k({}, N);
        k(ue, D);

        var le = function le(t) {
          var e = et(t);
          e && e.tagName || (e = {
            namespaceURI: Xt,
            tagName: "template"
          });
          var n = y(t.tagName),
              r = y(e.tagName);
          if (t.namespaceURI === Gt) return e.namespaceURI === Xt ? "svg" === n : e.namespaceURI === Vt ? "svg" === n && ("annotation-xml" === r || oe[r]) : Boolean(ce[n]);
          if (t.namespaceURI === Vt) return e.namespaceURI === Xt ? "math" === n : e.namespaceURI === Gt ? "math" === n && se[r] : Boolean(ue[n]);

          if (t.namespaceURI === Xt) {
            if (e.namespaceURI === Gt && !se[r]) return !1;
            if (e.namespaceURI === Vt && !oe[r]) return !1;
            var i = k({}, ["title", "style", "font", "a", "script"]);
            return !ue[n] && (i[n] || !ce[n]);
          }

          return !1;
        },
            he = function he(t) {
          p(n.removed, {
            element: t
          });

          try {
            t.parentNode.removeChild(t);
          } catch (e) {
            try {
              t.outerHTML = it;
            } catch (e) {
              t.remove();
            }
          }
        },
            fe = function fe(t, e) {
          try {
            p(n.removed, {
              attribute: e.getAttributeNode(t),
              from: e
            });
          } catch (t) {
            p(n.removed, {
              attribute: null,
              from: e
            });
          }

          if (e.removeAttribute(t), "is" === t && !wt[t]) if (Lt || It) try {
            he(e);
          } catch (t) {} else try {
            e.setAttribute(t, "");
          } catch (t) {}
        },
            de = function de(t) {
          var e = void 0,
              n = void 0;
          if (Bt) t = "<remove></remove>" + t;else {
            var r = g(t, /^[\r\n\t ]+/);
            n = r && r[0];
          }
          "application/xhtml+xml" === Kt && (t = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + t + "</body></html>");
          var a = rt ? rt.createHTML(t) : t;
          if (Zt === Xt) try {
            e = new X().parseFromString(a, Kt);
          } catch (t) {}

          if (!e || !e.documentElement) {
            e = ot.createDocument(Zt, "template", null);

            try {
              e.documentElement.innerHTML = Qt ? "" : a;
            } catch (t) {}
          }

          var o = e.body || e.documentElement;
          return t && n && o.insertBefore(i.createTextNode(n), o.childNodes[0] || null), Zt === Xt ? ut.call(e, Dt ? "html" : "body")[0] : Dt ? e.documentElement : o;
        },
            pe = function pe(t) {
          return st.call(t.ownerDocument || t, t, l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT, null, !1);
        },
            ye = function ye(t) {
          return t instanceof G && ("string" != typeof t.nodeName || "string" != typeof t.textContent || "function" != typeof t.removeChild || !(t.attributes instanceof w) || "function" != typeof t.removeAttribute || "function" != typeof t.setAttribute || "string" != typeof t.namespaceURI || "function" != typeof t.insertBefore);
        },
            ge = function ge(t) {
          return "object" === (void 0 === c ? "undefined" : H(c)) ? t instanceof c : t && "object" === (void 0 === t ? "undefined" : H(t)) && "number" == typeof t.nodeType && "string" == typeof t.nodeName;
        },
            me = function me(t, e, r) {
          ft[t] && f(ft[t], function (t) {
            t.call(n, e, r, ne);
          });
        },
            ve = function ve(t) {
          var e = void 0;
          if (me("beforeSanitizeElements", t, null), ye(t)) return he(t), !0;
          if (g(t.nodeName, /[\u0080-\uFFFF]/)) return he(t), !0;
          var r = ee(t.nodeName);
          if (me("uponSanitizeElement", t, {
            tagName: r,
            allowedTags: _t
          }), !ge(t.firstElementChild) && (!ge(t.content) || !ge(t.content.firstElementChild)) && _(/<[/\w]/g, t.innerHTML) && _(/<[/\w]/g, t.textContent)) return he(t), !0;
          if ("select" === r && _(/<template/i, t.innerHTML)) return he(t), !0;

          if (!_t[r] || Et[r]) {
            if (Pt && !zt[r]) {
              var i = et(t) || t.parentNode,
                  a = tt(t) || t.childNodes;
              if (a && i) for (var o = a.length - 1; o >= 0; --o) {
                i.insertBefore(K(a[o], !0), J(t));
              }
            }

            if (!Et[r] && _e(r)) {
              if (Tt.tagNameCheck instanceof RegExp && _(Tt.tagNameCheck, r)) return !1;
              if (Tt.tagNameCheck instanceof Function && Tt.tagNameCheck(r)) return !1;
            }

            return he(t), !0;
          }

          return t instanceof u && !le(t) ? (he(t), !0) : "noscript" !== r && "noembed" !== r || !_(/<\/no(script|embed)/i, t.innerHTML) ? (Nt && 3 === t.nodeType && (e = t.textContent, e = m(e, dt, " "), e = m(e, pt, " "), t.textContent !== e && (p(n.removed, {
            element: t.cloneNode()
          }), t.textContent = e)), me("afterSanitizeElements", t, null), !1) : (he(t), !0);
        },
            be = function be(t, e, n) {
          if (Ft && ("id" === e || "name" === e) && (n in i || n in re)) return !1;
          if (At && !Ct[e] && _(yt, e)) ;else if (St && _(gt, e)) ;else if (!wt[e] || Ct[e]) {
            if (!(_e(t) && (Tt.tagNameCheck instanceof RegExp && _(Tt.tagNameCheck, t) || Tt.tagNameCheck instanceof Function && Tt.tagNameCheck(t)) && (Tt.attributeNameCheck instanceof RegExp && _(Tt.attributeNameCheck, e) || Tt.attributeNameCheck instanceof Function && Tt.attributeNameCheck(e)) || "is" === e && Tt.allowCustomizedBuiltInElements && (Tt.tagNameCheck instanceof RegExp && _(Tt.tagNameCheck, n) || Tt.tagNameCheck instanceof Function && Tt.tagNameCheck(n)))) return !1;
          } else if ($t[e]) ;else if (_(bt, m(n, vt, ""))) ;else if ("src" !== e && "xlink:href" !== e && "href" !== e || "script" === t || 0 !== v(n, "data:") || !qt[t]) if (Mt && !_(mt, m(n, vt, ""))) ;else if (n) return !1;
          return !0;
        },
            _e = function _e(t) {
          return t.indexOf("-") > 0;
        },
            xe = function xe(t) {
          var e = void 0,
              r = void 0,
              i = void 0,
              a = void 0;
          me("beforeSanitizeAttributes", t, null);
          var o = t.attributes;

          if (o) {
            var s = {
              attrName: "",
              attrValue: "",
              keepAttr: !0,
              allowedAttributes: wt
            };

            for (a = o.length; a--;) {
              var c = e = o[a],
                  u = c.name,
                  l = c.namespaceURI;
              if (r = b(e.value), i = ee(u), s.attrName = i, s.attrValue = r, s.keepAttr = !0, s.forceKeepAttr = void 0, me("uponSanitizeAttribute", t, s), r = s.attrValue, !s.forceKeepAttr && (fe(u, t), s.keepAttr)) if (_(/\/>/i, r)) fe(u, t);else {
                Nt && (r = m(r, dt, " "), r = m(r, pt, " "));
                var h = ee(t.nodeName);
                if (be(h, i, r)) try {
                  l ? t.setAttributeNS(l, u, r) : t.setAttribute(u, r), d(n.removed);
                } catch (t) {}
              }
            }

            me("afterSanitizeAttributes", t, null);
          }
        },
            we = function t(e) {
          var n = void 0,
              r = pe(e);

          for (me("beforeSanitizeShadowDOM", e, null); n = r.nextNode();) {
            me("uponSanitizeShadowNode", n, null), ve(n) || (n.content instanceof o && t(n.content), xe(n));
          }

          me("afterSanitizeShadowDOM", e, null);
        };

        return n.sanitize = function (t, i) {
          var a = void 0,
              s = void 0,
              u = void 0,
              l = void 0,
              h = void 0;

          if ((Qt = !t) && (t = "\x3c!--\x3e"), "string" != typeof t && !ge(t)) {
            if ("function" != typeof t.toString) throw x("toString is not a function");
            if ("string" != typeof (t = t.toString())) throw x("dirty is not a string, aborting");
          }

          if (!n.isSupported) {
            if ("object" === H(e.toStaticHTML) || "function" == typeof e.toStaticHTML) {
              if ("string" == typeof t) return e.toStaticHTML(t);
              if (ge(t)) return e.toStaticHTML(t.outerHTML);
            }

            return t;
          }

          if (Ot || ae(i), n.removed = [], "string" == typeof t && (jt = !1), jt) {
            if (t.nodeName) {
              var f = ee(t.nodeName);
              if (!_t[f] || Et[f]) throw x("root node is forbidden and cannot be sanitized in-place");
            }
          } else if (t instanceof c) 1 === (s = (a = de("\x3c!----\x3e")).ownerDocument.importNode(t, !0)).nodeType && "BODY" === s.nodeName || "HTML" === s.nodeName ? a = s : a.appendChild(s);else {
            if (!Lt && !Nt && !Dt && -1 === t.indexOf("<")) return rt && Rt ? rt.createHTML(t) : t;
            if (!(a = de(t))) return Lt ? null : Rt ? it : "";
          }

          a && Bt && he(a.firstChild);

          for (var d = pe(jt ? t : a); u = d.nextNode();) {
            3 === u.nodeType && u === l || ve(u) || (u.content instanceof o && we(u.content), xe(u), l = u);
          }

          if (l = null, jt) return t;

          if (Lt) {
            if (It) for (h = ct.call(a.ownerDocument); a.firstChild;) {
              h.appendChild(a.firstChild);
            } else h = a;
            return wt.shadowroot && (h = lt.call(r, h, !0)), h;
          }

          var p = Dt ? a.outerHTML : a.innerHTML;
          return Nt && (p = m(p, dt, " "), p = m(p, pt, " ")), rt && Rt ? rt.createHTML(p) : p;
        }, n.setConfig = function (t) {
          ae(t), Ot = !0;
        }, n.clearConfig = function () {
          ne = null, Ot = !1;
        }, n.isValidAttribute = function (t, e, n) {
          ne || ae({});
          var r = ee(t),
              i = ee(e);
          return be(r, i, n);
        }, n.addHook = function (t, e) {
          "function" == typeof e && (ft[t] = ft[t] || [], p(ft[t], e));
        }, n.removeHook = function (t) {
          ft[t] && d(ft[t]);
        }, n.removeHooks = function (t) {
          ft[t] && (ft[t] = []);
        }, n.removeAllHooks = function () {
          ft = {};
        }, n;
      }();
    }();
  },
  8282: function _(t, e, n) {
    var r = n(2354);
    t.exports = {
      Graph: r.Graph,
      json: n(8974),
      alg: n(2440),
      version: r.version
    };
  },
  2842: function _(t, e, n) {
    var r = n(9126);

    t.exports = function (t) {
      var e,
          n = {},
          i = [];

      function a(i) {
        r.has(n, i) || (n[i] = !0, e.push(i), r.each(t.successors(i), a), r.each(t.predecessors(i), a));
      }

      return r.each(t.nodes(), function (t) {
        e = [], a(t), e.length && i.push(e);
      }), i;
    };
  },
  3984: function _(t, e, n) {
    var r = n(9126);

    function i(t, e, n, a, o, s) {
      r.has(a, e) || (a[e] = !0, n || s.push(e), r.each(o(e), function (e) {
        i(t, e, n, a, o, s);
      }), n && s.push(e));
    }

    t.exports = function (t, e, n) {
      r.isArray(e) || (e = [e]);
      var a = (t.isDirected() ? t.successors : t.neighbors).bind(t),
          o = [],
          s = {};
      return r.each(e, function (e) {
        if (!t.hasNode(e)) throw new Error("Graph does not have node: " + e);
        i(t, e, "post" === n, s, a, o);
      }), o;
    };
  },
  4847: function _(t, e, n) {
    var r = n(3763),
        i = n(9126);

    t.exports = function (t, e, n) {
      return i.transform(t.nodes(), function (i, a) {
        i[a] = r(t, a, e, n);
      }, {});
    };
  },
  3763: function _(t, e, n) {
    var r = n(9126),
        i = n(9675);

    t.exports = function (t, e, n, r) {
      return function (t, e, n, r) {
        var a,
            o,
            s = {},
            c = new i(),
            u = function u(t) {
          var e = t.v !== a ? t.v : t.w,
              r = s[e],
              i = n(t),
              u = o.distance + i;
          if (i < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + t + " Weight: " + i);
          u < r.distance && (r.distance = u, r.predecessor = a, c.decrease(e, u));
        };

        for (t.nodes().forEach(function (t) {
          var n = t === e ? 0 : Number.POSITIVE_INFINITY;
          s[t] = {
            distance: n
          }, c.add(t, n);
        }); c.size() > 0 && (a = c.removeMin(), (o = s[a]).distance !== Number.POSITIVE_INFINITY);) {
          r(a).forEach(u);
        }

        return s;
      }(t, String(e), n || a, r || function (e) {
        return t.outEdges(e);
      });
    };

    var a = r.constant(1);
  },
  9096: function _(t, e, n) {
    var r = n(9126),
        i = n(5023);

    t.exports = function (t) {
      return r.filter(i(t), function (e) {
        return e.length > 1 || 1 === e.length && t.hasEdge(e[0], e[0]);
      });
    };
  },
  8924: function _(t, e, n) {
    var r = n(9126);

    t.exports = function (t, e, n) {
      return function (t, e, n) {
        var r = {},
            i = t.nodes();
        return i.forEach(function (t) {
          r[t] = {}, r[t][t] = {
            distance: 0
          }, i.forEach(function (e) {
            t !== e && (r[t][e] = {
              distance: Number.POSITIVE_INFINITY
            });
          }), n(t).forEach(function (n) {
            var i = n.v === t ? n.w : n.v,
                a = e(n);
            r[t][i] = {
              distance: a,
              predecessor: t
            };
          });
        }), i.forEach(function (t) {
          var e = r[t];
          i.forEach(function (n) {
            var a = r[n];
            i.forEach(function (n) {
              var r = a[t],
                  i = e[n],
                  o = a[n],
                  s = r.distance + i.distance;
              s < o.distance && (o.distance = s, o.predecessor = i.predecessor);
            });
          });
        }), r;
      }(t, e || i, n || function (e) {
        return t.outEdges(e);
      });
    };

    var i = r.constant(1);
  },
  2440: function _(t, e, n) {
    t.exports = {
      components: n(2842),
      dijkstra: n(3763),
      dijkstraAll: n(4847),
      findCycles: n(9096),
      floydWarshall: n(8924),
      isAcyclic: n(2707),
      postorder: n(8828),
      preorder: n(2648),
      prim: n(514),
      tarjan: n(5023),
      topsort: n(2166)
    };
  },
  2707: function _(t, e, n) {
    var r = n(2166);

    t.exports = function (t) {
      try {
        r(t);
      } catch (t) {
        if (t instanceof r.CycleException) return !1;
        throw t;
      }

      return !0;
    };
  },
  8828: function _(t, e, n) {
    var r = n(3984);

    t.exports = function (t, e) {
      return r(t, e, "post");
    };
  },
  2648: function _(t, e, n) {
    var r = n(3984);

    t.exports = function (t, e) {
      return r(t, e, "pre");
    };
  },
  514: function _(t, e, n) {
    var r = n(9126),
        i = n(771),
        a = n(9675);

    t.exports = function (t, e) {
      var n,
          o = new i(),
          s = {},
          c = new a();

      function u(t) {
        var r = t.v === n ? t.w : t.v,
            i = c.priority(r);

        if (void 0 !== i) {
          var a = e(t);
          a < i && (s[r] = n, c.decrease(r, a));
        }
      }

      if (0 === t.nodeCount()) return o;
      r.each(t.nodes(), function (t) {
        c.add(t, Number.POSITIVE_INFINITY), o.setNode(t);
      }), c.decrease(t.nodes()[0], 0);

      for (var l = !1; c.size() > 0;) {
        if (n = c.removeMin(), r.has(s, n)) o.setEdge(n, s[n]);else {
          if (l) throw new Error("Input graph is not connected: " + t);
          l = !0;
        }
        t.nodeEdges(n).forEach(u);
      }

      return o;
    };
  },
  5023: function _(t, e, n) {
    var r = n(9126);

    t.exports = function (t) {
      var e = 0,
          n = [],
          i = {},
          a = [];

      function o(s) {
        var c = i[s] = {
          onStack: !0,
          lowlink: e,
          index: e++
        };

        if (n.push(s), t.successors(s).forEach(function (t) {
          r.has(i, t) ? i[t].onStack && (c.lowlink = Math.min(c.lowlink, i[t].index)) : (o(t), c.lowlink = Math.min(c.lowlink, i[t].lowlink));
        }), c.lowlink === c.index) {
          var u,
              l = [];

          do {
            u = n.pop(), i[u].onStack = !1, l.push(u);
          } while (s !== u);

          a.push(l);
        }
      }

      return t.nodes().forEach(function (t) {
        r.has(i, t) || o(t);
      }), a;
    };
  },
  2166: function _(t, e, n) {
    var r = n(9126);

    function i(t) {
      var e = {},
          n = {},
          i = [];
      if (r.each(t.sinks(), function o(s) {
        if (r.has(n, s)) throw new a();
        r.has(e, s) || (n[s] = !0, e[s] = !0, r.each(t.predecessors(s), o), delete n[s], i.push(s));
      }), r.size(e) !== t.nodeCount()) throw new a();
      return i;
    }

    function a() {}

    t.exports = i, i.CycleException = a, a.prototype = new Error();
  },
  9675: function _(t, e, n) {
    var r = n(9126);

    function i() {
      this._arr = [], this._keyIndices = {};
    }

    t.exports = i, i.prototype.size = function () {
      return this._arr.length;
    }, i.prototype.keys = function () {
      return this._arr.map(function (t) {
        return t.key;
      });
    }, i.prototype.has = function (t) {
      return r.has(this._keyIndices, t);
    }, i.prototype.priority = function (t) {
      var e = this._keyIndices[t];
      if (void 0 !== e) return this._arr[e].priority;
    }, i.prototype.min = function () {
      if (0 === this.size()) throw new Error("Queue underflow");
      return this._arr[0].key;
    }, i.prototype.add = function (t, e) {
      var n = this._keyIndices;

      if (t = String(t), !r.has(n, t)) {
        var i = this._arr,
            a = i.length;
        return n[t] = a, i.push({
          key: t,
          priority: e
        }), this._decrease(a), !0;
      }

      return !1;
    }, i.prototype.removeMin = function () {
      this._swap(0, this._arr.length - 1);

      var t = this._arr.pop();

      return delete this._keyIndices[t.key], this._heapify(0), t.key;
    }, i.prototype.decrease = function (t, e) {
      var n = this._keyIndices[t];
      if (e > this._arr[n].priority) throw new Error("New priority is greater than current priority. Key: " + t + " Old: " + this._arr[n].priority + " New: " + e);
      this._arr[n].priority = e, this._decrease(n);
    }, i.prototype._heapify = function (t) {
      var e = this._arr,
          n = 2 * t,
          r = n + 1,
          i = t;
      n < e.length && (i = e[n].priority < e[i].priority ? n : i, r < e.length && (i = e[r].priority < e[i].priority ? r : i), i !== t && (this._swap(t, i), this._heapify(i)));
    }, i.prototype._decrease = function (t) {
      for (var e, n = this._arr, r = n[t].priority; 0 !== t && !(n[e = t >> 1].priority < r);) {
        this._swap(t, e), t = e;
      }
    }, i.prototype._swap = function (t, e) {
      var n = this._arr,
          r = this._keyIndices,
          i = n[t],
          a = n[e];
      n[t] = a, n[e] = i, r[a.key] = t, r[i.key] = e;
    };
  },
  771: function _(t, e, n) {
    var r = n(9126);
    t.exports = a;
    var i = "\0";

    function a(t) {
      this._isDirected = !r.has(t, "directed") || t.directed, this._isMultigraph = !!r.has(t, "multigraph") && t.multigraph, this._isCompound = !!r.has(t, "compound") && t.compound, this._label = void 0, this._defaultNodeLabelFn = r.constant(void 0), this._defaultEdgeLabelFn = r.constant(void 0), this._nodes = {}, this._isCompound && (this._parent = {}, this._children = {}, this._children["\0"] = {}), this._in = {}, this._preds = {}, this._out = {}, this._sucs = {}, this._edgeObjs = {}, this._edgeLabels = {};
    }

    function o(t, e) {
      t[e] ? t[e]++ : t[e] = 1;
    }

    function s(t, e) {
      --t[e] || delete t[e];
    }

    function c(t, e, n, i) {
      var a = "" + e,
          o = "" + n;

      if (!t && a > o) {
        var s = a;
        a = o, o = s;
      }

      return a + "" + o + "" + (r.isUndefined(i) ? "\0" : i);
    }

    function u(t, e, n, r) {
      var i = "" + e,
          a = "" + n;

      if (!t && i > a) {
        var o = i;
        i = a, a = o;
      }

      var s = {
        v: i,
        w: a
      };
      return r && (s.name = r), s;
    }

    function l(t, e) {
      return c(t, e.v, e.w, e.name);
    }

    a.prototype._nodeCount = 0, a.prototype._edgeCount = 0, a.prototype.isDirected = function () {
      return this._isDirected;
    }, a.prototype.isMultigraph = function () {
      return this._isMultigraph;
    }, a.prototype.isCompound = function () {
      return this._isCompound;
    }, a.prototype.setGraph = function (t) {
      return this._label = t, this;
    }, a.prototype.graph = function () {
      return this._label;
    }, a.prototype.setDefaultNodeLabel = function (t) {
      return r.isFunction(t) || (t = r.constant(t)), this._defaultNodeLabelFn = t, this;
    }, a.prototype.nodeCount = function () {
      return this._nodeCount;
    }, a.prototype.nodes = function () {
      return r.keys(this._nodes);
    }, a.prototype.sources = function () {
      var t = this;
      return r.filter(this.nodes(), function (e) {
        return r.isEmpty(t._in[e]);
      });
    }, a.prototype.sinks = function () {
      var t = this;
      return r.filter(this.nodes(), function (e) {
        return r.isEmpty(t._out[e]);
      });
    }, a.prototype.setNodes = function (t, e) {
      var n = arguments,
          i = this;
      return r.each(t, function (t) {
        n.length > 1 ? i.setNode(t, e) : i.setNode(t);
      }), this;
    }, a.prototype.setNode = function (t, e) {
      return r.has(this._nodes, t) ? (arguments.length > 1 && (this._nodes[t] = e), this) : (this._nodes[t] = arguments.length > 1 ? e : this._defaultNodeLabelFn(t), this._isCompound && (this._parent[t] = i, this._children[t] = {}, this._children["\0"][t] = !0), this._in[t] = {}, this._preds[t] = {}, this._out[t] = {}, this._sucs[t] = {}, ++this._nodeCount, this);
    }, a.prototype.node = function (t) {
      return this._nodes[t];
    }, a.prototype.hasNode = function (t) {
      return r.has(this._nodes, t);
    }, a.prototype.removeNode = function (t) {
      var e = this;

      if (r.has(this._nodes, t)) {
        var n = function n(t) {
          e.removeEdge(e._edgeObjs[t]);
        };

        delete this._nodes[t], this._isCompound && (this._removeFromParentsChildList(t), delete this._parent[t], r.each(this.children(t), function (t) {
          e.setParent(t);
        }), delete this._children[t]), r.each(r.keys(this._in[t]), n), delete this._in[t], delete this._preds[t], r.each(r.keys(this._out[t]), n), delete this._out[t], delete this._sucs[t], --this._nodeCount;
      }

      return this;
    }, a.prototype.setParent = function (t, e) {
      if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
      if (r.isUndefined(e)) e = i;else {
        for (var n = e += ""; !r.isUndefined(n); n = this.parent(n)) {
          if (n === t) throw new Error("Setting " + e + " as parent of " + t + " would create a cycle");
        }

        this.setNode(e);
      }
      return this.setNode(t), this._removeFromParentsChildList(t), this._parent[t] = e, this._children[e][t] = !0, this;
    }, a.prototype._removeFromParentsChildList = function (t) {
      delete this._children[this._parent[t]][t];
    }, a.prototype.parent = function (t) {
      if (this._isCompound) {
        var e = this._parent[t];
        if (e !== i) return e;
      }
    }, a.prototype.children = function (t) {
      if (r.isUndefined(t) && (t = i), this._isCompound) {
        var e = this._children[t];
        if (e) return r.keys(e);
      } else {
        if (t === i) return this.nodes();
        if (this.hasNode(t)) return [];
      }
    }, a.prototype.predecessors = function (t) {
      var e = this._preds[t];
      if (e) return r.keys(e);
    }, a.prototype.successors = function (t) {
      var e = this._sucs[t];
      if (e) return r.keys(e);
    }, a.prototype.neighbors = function (t) {
      var e = this.predecessors(t);
      if (e) return r.union(e, this.successors(t));
    }, a.prototype.isLeaf = function (t) {
      return 0 === (this.isDirected() ? this.successors(t) : this.neighbors(t)).length;
    }, a.prototype.filterNodes = function (t) {
      var e = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
      });
      e.setGraph(this.graph());
      var n = this;
      r.each(this._nodes, function (n, r) {
        t(r) && e.setNode(r, n);
      }), r.each(this._edgeObjs, function (t) {
        e.hasNode(t.v) && e.hasNode(t.w) && e.setEdge(t, n.edge(t));
      });
      var i = {};

      function a(t) {
        var r = n.parent(t);
        return void 0 === r || e.hasNode(r) ? (i[t] = r, r) : r in i ? i[r] : a(r);
      }

      return this._isCompound && r.each(e.nodes(), function (t) {
        e.setParent(t, a(t));
      }), e;
    }, a.prototype.setDefaultEdgeLabel = function (t) {
      return r.isFunction(t) || (t = r.constant(t)), this._defaultEdgeLabelFn = t, this;
    }, a.prototype.edgeCount = function () {
      return this._edgeCount;
    }, a.prototype.edges = function () {
      return r.values(this._edgeObjs);
    }, a.prototype.setPath = function (t, e) {
      var n = this,
          i = arguments;
      return r.reduce(t, function (t, r) {
        return i.length > 1 ? n.setEdge(t, r, e) : n.setEdge(t, r), r;
      }), this;
    }, a.prototype.setEdge = function () {
      var t,
          e,
          n,
          i,
          a = !1,
          s = arguments[0];
      "object" == _typeof(s) && null !== s && "v" in s ? (t = s.v, e = s.w, n = s.name, 2 === arguments.length && (i = arguments[1], a = !0)) : (t = s, e = arguments[1], n = arguments[3], arguments.length > 2 && (i = arguments[2], a = !0)), t = "" + t, e = "" + e, r.isUndefined(n) || (n = "" + n);
      var l = c(this._isDirected, t, e, n);
      if (r.has(this._edgeLabels, l)) return a && (this._edgeLabels[l] = i), this;
      if (!r.isUndefined(n) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
      this.setNode(t), this.setNode(e), this._edgeLabels[l] = a ? i : this._defaultEdgeLabelFn(t, e, n);
      var h = u(this._isDirected, t, e, n);
      return t = h.v, e = h.w, Object.freeze(h), this._edgeObjs[l] = h, o(this._preds[e], t), o(this._sucs[t], e), this._in[e][l] = h, this._out[t][l] = h, this._edgeCount++, this;
    }, a.prototype.edge = function (t, e, n) {
      var r = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n);
      return this._edgeLabels[r];
    }, a.prototype.hasEdge = function (t, e, n) {
      var i = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n);
      return r.has(this._edgeLabels, i);
    }, a.prototype.removeEdge = function (t, e, n) {
      var r = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n),
          i = this._edgeObjs[r];
      return i && (t = i.v, e = i.w, delete this._edgeLabels[r], delete this._edgeObjs[r], s(this._preds[e], t), s(this._sucs[t], e), delete this._in[e][r], delete this._out[t][r], this._edgeCount--), this;
    }, a.prototype.inEdges = function (t, e) {
      var n = this._in[t];

      if (n) {
        var i = r.values(n);
        return e ? r.filter(i, function (t) {
          return t.v === e;
        }) : i;
      }
    }, a.prototype.outEdges = function (t, e) {
      var n = this._out[t];

      if (n) {
        var i = r.values(n);
        return e ? r.filter(i, function (t) {
          return t.w === e;
        }) : i;
      }
    }, a.prototype.nodeEdges = function (t, e) {
      var n = this.inEdges(t, e);
      if (n) return n.concat(this.outEdges(t, e));
    };
  },
  2354: function _(t, e, n) {
    t.exports = {
      Graph: n(771),
      version: n(9631)
    };
  },
  8974: function _(t, e, n) {
    var r = n(9126),
        i = n(771);

    function a(t) {
      return r.map(t.nodes(), function (e) {
        var n = t.node(e),
            i = t.parent(e),
            a = {
          v: e
        };
        return r.isUndefined(n) || (a.value = n), r.isUndefined(i) || (a.parent = i), a;
      });
    }

    function o(t) {
      return r.map(t.edges(), function (e) {
        var n = t.edge(e),
            i = {
          v: e.v,
          w: e.w
        };
        return r.isUndefined(e.name) || (i.name = e.name), r.isUndefined(n) || (i.value = n), i;
      });
    }

    t.exports = {
      write: function write(t) {
        var e = {
          options: {
            directed: t.isDirected(),
            multigraph: t.isMultigraph(),
            compound: t.isCompound()
          },
          nodes: a(t),
          edges: o(t)
        };
        return r.isUndefined(t.graph()) || (e.value = r.clone(t.graph())), e;
      },
      read: function read(t) {
        var e = new i(t.options).setGraph(t.value);
        return r.each(t.nodes, function (t) {
          e.setNode(t.v, t.value), t.parent && e.setParent(t.v, t.parent);
        }), r.each(t.edges, function (t) {
          e.setEdge({
            v: t.v,
            w: t.w,
            name: t.name
          }, t.value);
        }), e;
      }
    };
  },
  9126: function _(t, e, n) {
    var r;

    try {
      r = {
        clone: n(6678),
        constant: n(5703),
        each: n(6073),
        filter: n(3105),
        has: n(8721),
        isArray: n(1469),
        isEmpty: n(1609),
        isFunction: n(3560),
        isUndefined: n(2353),
        keys: n(3674),
        map: n(5161),
        reduce: n(4061),
        size: n(4238),
        transform: n(8718),
        union: n(3386),
        values: n(2628)
      };
    } catch (t) {}

    r || (r = window._), t.exports = r;
  },
  9631: function _(t) {
    t.exports = "2.1.8";
  },
  1773: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = n(1083),
        i = n(7628),
        a = function () {
      function t(t, e) {
        this.color = e, this.changed = !1, this.data = t, this.type = new i["default"]();
      }

      return t.prototype.set = function (t, e) {
        return this.color = e, this.changed = !1, this.data = t, this.type.type = 0, this;
      }, t.prototype._ensureHSL = function () {
        var t = this.data,
            e = t.h,
            n = t.s,
            i = t.l;
        void 0 === e && (t.h = r["default"].channel.rgb2hsl(t, "h")), void 0 === n && (t.s = r["default"].channel.rgb2hsl(t, "s")), void 0 === i && (t.l = r["default"].channel.rgb2hsl(t, "l"));
      }, t.prototype._ensureRGB = function () {
        var t = this.data,
            e = t.r,
            n = t.g,
            i = t.b;
        void 0 === e && (t.r = r["default"].channel.hsl2rgb(t, "r")), void 0 === n && (t.g = r["default"].channel.hsl2rgb(t, "g")), void 0 === i && (t.b = r["default"].channel.hsl2rgb(t, "b"));
      }, Object.defineProperty(t.prototype, "r", {
        get: function get() {
          var t = this.data,
              e = t.r;
          return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r["default"].channel.hsl2rgb(t, "r")) : e;
        },
        set: function set(t) {
          this.type.set(1), this.changed = !0, this.data.r = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "g", {
        get: function get() {
          var t = this.data,
              e = t.g;
          return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r["default"].channel.hsl2rgb(t, "g")) : e;
        },
        set: function set(t) {
          this.type.set(1), this.changed = !0, this.data.g = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "b", {
        get: function get() {
          var t = this.data,
              e = t.b;
          return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r["default"].channel.hsl2rgb(t, "b")) : e;
        },
        set: function set(t) {
          this.type.set(1), this.changed = !0, this.data.b = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "h", {
        get: function get() {
          var t = this.data,
              e = t.h;
          return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r["default"].channel.rgb2hsl(t, "h")) : e;
        },
        set: function set(t) {
          this.type.set(2), this.changed = !0, this.data.h = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "s", {
        get: function get() {
          var t = this.data,
              e = t.s;
          return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r["default"].channel.rgb2hsl(t, "s")) : e;
        },
        set: function set(t) {
          this.type.set(2), this.changed = !0, this.data.s = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "l", {
        get: function get() {
          var t = this.data,
              e = t.l;
          return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r["default"].channel.rgb2hsl(t, "l")) : e;
        },
        set: function set(t) {
          this.type.set(2), this.changed = !0, this.data.l = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "a", {
        get: function get() {
          return this.data.a;
        },
        set: function set(t) {
          this.changed = !0, this.data.a = t;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }();

    e["default"] = a;
  },
  8167: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = new (n(1773)["default"])({
      r: 0,
      g: 0,
      b: 0,
      a: 0
    }, "transparent");
    e["default"] = r;
  },
  7628: function _(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t() {
        this.type = 0;
      }

      return t.prototype.get = function () {
        return this.type;
      }, t.prototype.set = function (t) {
        if (this.type && this.type !== t) throw new Error("Cannot change both RGB and HSL channels at the same time");
        this.type = t;
      }, t.prototype.reset = function () {
        this.type = 0;
      }, t.prototype.is = function (t) {
        return this.type === t;
      }, t;
    }();

    e["default"] = n;
  },
  1655: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(8167),
        i = n(6061),
        a = {
      re: /^#((?:[a-f0-9]{2}){2,4}|[a-f0-9]{3})$/i,
      parse: function parse(t) {
        if (35 === t.charCodeAt(0)) {
          var e = t.match(a.re);

          if (e) {
            var n = e[1],
                i = parseInt(n, 16),
                o = n.length,
                s = o % 4 == 0,
                c = o > 4,
                u = c ? 1 : 17,
                l = c ? 8 : 4,
                h = s ? 0 : -1,
                f = c ? 255 : 15;
            return r["default"].set({
              r: (i >> l * (h + 3) & f) * u,
              g: (i >> l * (h + 2) & f) * u,
              b: (i >> l * (h + 1) & f) * u,
              a: s ? (i & f) * u / 255 : 1
            }, t);
          }
        }
      },
      stringify: function stringify(t) {
        var e = t.r,
            n = t.g,
            r = t.b,
            a = t.a;
        return a < 1 ? "#" + i.DEC2HEX[Math.round(e)] + i.DEC2HEX[Math.round(n)] + i.DEC2HEX[Math.round(r)] + i.DEC2HEX[Math.round(255 * a)] : "#" + i.DEC2HEX[Math.round(e)] + i.DEC2HEX[Math.round(n)] + i.DEC2HEX[Math.round(r)];
      }
    };
    e["default"] = a;
  },
  8589: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(8167),
        a = {
      re: /^hsla?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(?:deg|grad|rad|turn)?)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(%)?))?\s*?\)$/i,
      hueRe: /^(.+?)(deg|grad|rad|turn)$/i,
      _hue2deg: function _hue2deg(t) {
        var e = t.match(a.hueRe);

        if (e) {
          var n = e[1];

          switch (e[2]) {
            case "grad":
              return r["default"].channel.clamp.h(.9 * parseFloat(n));

            case "rad":
              return r["default"].channel.clamp.h(180 * parseFloat(n) / Math.PI);

            case "turn":
              return r["default"].channel.clamp.h(360 * parseFloat(n));
          }
        }

        return r["default"].channel.clamp.h(parseFloat(t));
      },
      parse: function parse(t) {
        var e = t.charCodeAt(0);

        if (104 === e || 72 === e) {
          var n = t.match(a.re);

          if (n) {
            var o = n[1],
                s = n[2],
                c = n[3],
                u = n[4],
                l = n[5];
            return i["default"].set({
              h: a._hue2deg(o),
              s: r["default"].channel.clamp.s(parseFloat(s)),
              l: r["default"].channel.clamp.l(parseFloat(c)),
              a: u ? r["default"].channel.clamp.a(l ? parseFloat(u) / 100 : parseFloat(u)) : 1
            }, t);
          }
        }
      },
      stringify: function stringify(t) {
        var e = t.h,
            n = t.s,
            i = t.l,
            a = t.a;
        return a < 1 ? "hsla(" + r["default"].lang.round(e) + ", " + r["default"].lang.round(n) + "%, " + r["default"].lang.round(i) + "%, " + a + ")" : "hsl(" + r["default"].lang.round(e) + ", " + r["default"].lang.round(n) + "%, " + r["default"].lang.round(i) + "%)";
      }
    };
    e["default"] = a;
  },
  2191: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1655),
        i = n(7538),
        a = n(6762),
        o = n(8589),
        s = {
      format: {
        keyword: i["default"],
        hex: r["default"],
        rgb: a["default"],
        rgba: a["default"],
        hsl: o["default"],
        hsla: o["default"]
      },
      parse: function parse(t) {
        if ("string" != typeof t) return t;
        var e = r["default"].parse(t) || a["default"].parse(t) || o["default"].parse(t) || i["default"].parse(t);
        if (e) return e;
        throw new Error('Unsupported color format: "' + t + '"');
      },
      stringify: function stringify(t) {
        return !t.changed && t.color ? t.color : t.type.is(2) || void 0 === t.data.r ? o["default"].stringify(t) : t.a < 1 || !Number.isInteger(t.r) || !Number.isInteger(t.g) || !Number.isInteger(t.b) ? a["default"].stringify(t) : r["default"].stringify(t);
      }
    };
    e["default"] = s;
  },
  7538: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1655),
        i = {
      colors: {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyanaqua: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        transparent: "#00000000",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
      },
      parse: function parse(t) {
        t = t.toLowerCase();
        var e = i.colors[t];
        if (e) return r["default"].parse(e);
      },
      stringify: function stringify(t) {
        var e = r["default"].stringify(t);

        for (var n in i.colors) {
          if (i.colors[n] === e) return n;
        }
      }
    };
    e["default"] = i;
  },
  6762: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(8167),
        a = {
      re: /^rgba?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?)))?\s*?\)$/i,
      parse: function parse(t) {
        var e = t.charCodeAt(0);

        if (114 === e || 82 === e) {
          var n = t.match(a.re);

          if (n) {
            var o = n[1],
                s = n[2],
                c = n[3],
                u = n[4],
                l = n[5],
                h = n[6],
                f = n[7],
                d = n[8];
            return i["default"].set({
              r: r["default"].channel.clamp.r(s ? 2.55 * parseFloat(o) : parseFloat(o)),
              g: r["default"].channel.clamp.g(u ? 2.55 * parseFloat(c) : parseFloat(c)),
              b: r["default"].channel.clamp.b(h ? 2.55 * parseFloat(l) : parseFloat(l)),
              a: f ? r["default"].channel.clamp.a(d ? parseFloat(f) / 100 : parseFloat(f)) : 1
            }, t);
          }
        }
      },
      stringify: function stringify(t) {
        var e = t.r,
            n = t.g,
            i = t.b,
            a = t.a;
        return a < 1 ? "rgba(" + r["default"].lang.round(e) + ", " + r["default"].lang.round(n) + ", " + r["default"].lang.round(i) + ", " + r["default"].lang.round(a) + ")" : "rgb(" + r["default"].lang.round(e) + ", " + r["default"].lang.round(n) + ", " + r["default"].lang.round(i) + ")";
      }
    };
    e["default"] = a;
  },
  6061: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = {};
    e.DEC2HEX = i;

    for (var a = 0; a <= 255; a++) {
      i[a] = r["default"].unit.dec2hex(a);
    }
  },
  8613: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), function (t) {
      for (var n in t) {
        e.hasOwnProperty(n) || (e[n] = t[n]);
      }
    }(n(1203));
  },
  5371: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191),
        i = n(418);

    e["default"] = function (t, e) {
      var n = r["default"].parse(t),
          a = {};

      for (var o in e) {
        e[o] && (a[o] = n[o] + e[o]);
      }

      return i["default"](t, a);
    };
  },
  1416: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(2191);

    e["default"] = function (t, e, n) {
      var a = i["default"].parse(t),
          o = a[e],
          s = r["default"].channel.clamp[e](o + n);
      return o !== s && (a[e] = s), i["default"].stringify(a);
    };
  },
  9353: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "a");
    };
  },
  3394: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "b");
    };
  },
  418: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(2191);

    e["default"] = function (t, e) {
      var n = i["default"].parse(t);

      for (var a in e) {
        n[a] = r["default"].channel.clamp[a](e[a]);
      }

      return i["default"].stringify(n);
    };
  },
  6197: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(2191);

    e["default"] = function (t, e) {
      return r["default"].lang.round(i["default"].parse(t)[e]);
    };
  },
  7361: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t) {
      return r["default"](t, "h", 180);
    };
  },
  3042: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(8346);

    e["default"] = function (t, e) {
      var n = i["default"](t),
          a = i["default"](e),
          o = Math.max(n, a),
          s = Math.min(n, a),
          c = (o + Number.EPSILON) / (s + Number.EPSILON);
      return r["default"].lang.round(r["default"].lang.clamp(c, 1, 10));
    };
  },
  1364: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "l", -e);
    };
  },
  9610: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "s", -e);
    };
  },
  572: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(418);

    e["default"] = function (t) {
      return r["default"](t, {
        s: 0
      });
    };
  },
  2299: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "g");
    };
  },
  3116: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(8167),
        a = n(2191);

    e["default"] = function (t, e, n, o) {
      void 0 === o && (o = 1);
      var s = i["default"].set({
        h: r["default"].channel.clamp.h(t),
        s: r["default"].channel.clamp.s(e),
        l: r["default"].channel.clamp.l(n),
        a: r["default"].channel.clamp.a(o)
      });
      return a["default"].stringify(s);
    };
  },
  3008: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "h");
    };
  },
  1203: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6538);
    e.hex = r["default"];
    var i = n(6538);
    e.rgb = i["default"];
    var a = n(6538);
    e.rgba = a["default"];
    var o = n(3116);
    e.hsl = o["default"];
    var s = n(3116);
    e.hsla = s["default"];
    var c = n(2619);
    e.toKeyword = c["default"];
    var u = n(4307);
    e.toHex = u["default"];
    var l = n(4125);
    e.toRgba = l["default"];
    var h = n(7329);
    e.toHsla = h["default"];
    var f = n(6197);
    e.channel = f["default"];
    var d = n(9640);
    e.red = d["default"];
    var p = n(2299);
    e.green = p["default"];
    var y = n(3394);
    e.blue = y["default"];
    var g = n(3008);
    e.hue = g["default"];
    var m = n(6451);
    e.saturation = m["default"];
    var v = n(9235);
    e.lightness = v["default"];
    var b = n(9353);
    e.alpha = b["default"];

    var _ = n(9353);

    e.opacity = _["default"];
    var x = n(3042);
    e.contrast = x["default"];
    var w = n(8346);
    e.luminance = w["default"];
    var k = n(4117);
    e.isDark = k["default"];
    var T = n(2224);
    e.isLight = T["default"];
    var E = n(585);
    e.isValid = E["default"];
    var C = n(1080);
    e.saturate = C["default"];
    var S = n(9610);
    e.desaturate = S["default"];
    var A = n(3235);
    e.lighten = A["default"];
    var M = n(1364);
    e.darken = M["default"];
    var N = n(7189);
    e.opacify = N["default"];
    var D = n(7189);
    e.fadeIn = D["default"];
    var O = n(4989);
    e.transparentize = O["default"];
    var B = n(4989);
    e.fadeOut = B["default"];
    var L = n(7361);
    e.complement = L["default"];
    var I = n(572);
    e.grayscale = I["default"];
    var R = n(5371);
    e.adjust = R["default"];
    var F = n(418);
    e.change = F["default"];
    var P = n(566);
    e.invert = P["default"];
    var j = n(1861);
    e.mix = j["default"];
    var Y = n(7081);
    e.scale = Y["default"];
  },
  566: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191),
        i = n(1861);

    e["default"] = function (t, e) {
      void 0 === e && (e = 100);
      var n = r["default"].parse(t);
      return n.r = 255 - n.r, n.g = 255 - n.g, n.b = 255 - n.b, i["default"](n, t, e);
    };
  },
  4117: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2224);

    e["default"] = function (t) {
      return !r["default"](t);
    };
  },
  2224: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(8346);

    e["default"] = function (t) {
      return r["default"](t) >= .5;
    };
  },
  585: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191);

    e["default"] = function (t) {
      try {
        return r["default"].parse(t), !0;
      } catch (t) {
        return !1;
      }
    };
  },
  3235: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "l", e);
    };
  },
  9235: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "l");
    };
  },
  8346: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(2191);

    e["default"] = function (t) {
      var e = i["default"].parse(t),
          n = e.r,
          a = e.g,
          o = e.b,
          s = .2126 * r["default"].channel.toLinear(n) + .7152 * r["default"].channel.toLinear(a) + .0722 * r["default"].channel.toLinear(o);
      return r["default"].lang.round(s);
    };
  },
  1861: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191),
        i = n(6538);

    e["default"] = function (t, e, n) {
      void 0 === n && (n = 50);

      var a = r["default"].parse(t),
          o = a.r,
          s = a.g,
          c = a.b,
          u = a.a,
          l = r["default"].parse(e),
          h = l.r,
          f = l.g,
          d = l.b,
          p = l.a,
          y = n / 100,
          g = 2 * y - 1,
          m = u - p,
          v = ((g * m == -1 ? g : (g + m) / (1 + g * m)) + 1) / 2,
          b = 1 - v,
          _ = o * v + h * b,
          x = s * v + f * b,
          w = c * v + d * b,
          k = u * y + p * (1 - y);

      return i["default"](_, x, w, k);
    };
  },
  7189: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "a", e);
    };
  },
  9640: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "r");
    };
  },
  6538: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(8167),
        a = n(2191),
        o = n(418);

    e["default"] = function (t, e, n, s) {
      if (void 0 === n && (n = 0), void 0 === s && (s = 1), "number" != typeof t) return o["default"](t, {
        a: e
      });
      var c = i["default"].set({
        r: r["default"].channel.clamp.r(t),
        g: r["default"].channel.clamp.g(e),
        b: r["default"].channel.clamp.b(n),
        a: r["default"].channel.clamp.a(s)
      });
      return a["default"].stringify(c);
    };
  },
  1080: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "s", e);
    };
  },
  6451: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(6197);

    e["default"] = function (t) {
      return r["default"](t, "s");
    };
  },
  7081: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1083),
        i = n(2191),
        a = n(5371);

    e["default"] = function (t, e) {
      var n,
          o,
          s,
          c = i["default"].parse(t),
          u = {};

      for (var l in e) {
        u[l] = (n = c[l], o = e[l], s = r["default"].channel.max[l], o > 0 ? (s - n) * o / 100 : n * o / 100);
      }

      return a["default"](t, u);
    };
  },
  4307: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191);

    e["default"] = function (t) {
      return r["default"].format.hex.stringify(r["default"].parse(t));
    };
  },
  7329: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191);

    e["default"] = function (t) {
      return r["default"].format.hsla.stringify(r["default"].parse(t));
    };
  },
  2619: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191);

    e["default"] = function (t) {
      return r["default"].format.keyword.stringify(r["default"].parse(t));
    };
  },
  4125: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2191);

    e["default"] = function (t) {
      return r["default"].format.rgba.stringify(r["default"].parse(t));
    };
  },
  4989: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(1416);

    e["default"] = function (t, e) {
      return r["default"](t, "a", -e);
    };
  },
  7994: function _(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = {
      min: {
        r: 0,
        g: 0,
        b: 0,
        s: 0,
        l: 0,
        a: 0
      },
      max: {
        r: 255,
        g: 255,
        b: 255,
        h: 360,
        s: 100,
        l: 100,
        a: 1
      },
      clamp: {
        r: function r(t) {
          return t >= 255 ? 255 : t < 0 ? 0 : t;
        },
        g: function g(t) {
          return t >= 255 ? 255 : t < 0 ? 0 : t;
        },
        b: function b(t) {
          return t >= 255 ? 255 : t < 0 ? 0 : t;
        },
        h: function h(t) {
          return t % 360;
        },
        s: function s(t) {
          return t >= 100 ? 100 : t < 0 ? 0 : t;
        },
        l: function l(t) {
          return t >= 100 ? 100 : t < 0 ? 0 : t;
        },
        a: function a(t) {
          return t >= 1 ? 1 : t < 0 ? 0 : t;
        }
      },
      toLinear: function toLinear(t) {
        var e = t / 255;
        return t > .03928 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92;
      },
      hue2rgb: function hue2rgb(t, e, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
      },
      hsl2rgb: function hsl2rgb(t, e) {
        var r = t.h,
            i = t.s,
            a = t.l;
        if (!i) return 2.55 * a;
        r /= 360, i /= 100;
        var o = (a /= 100) < .5 ? a * (1 + i) : a + i - a * i,
            s = 2 * a - o;

        switch (e) {
          case "r":
            return 255 * n.hue2rgb(s, o, r + 1 / 3);

          case "g":
            return 255 * n.hue2rgb(s, o, r);

          case "b":
            return 255 * n.hue2rgb(s, o, r - 1 / 3);
        }
      },
      rgb2hsl: function rgb2hsl(t, e) {
        var n = t.r,
            r = t.g,
            i = t.b;
        n /= 255, r /= 255, i /= 255;
        var a = Math.max(n, r, i),
            o = Math.min(n, r, i),
            s = (a + o) / 2;
        if ("l" === e) return 100 * s;
        if (a === o) return 0;
        var c = a - o;
        if ("s" === e) return 100 * (s > .5 ? c / (2 - a - o) : c / (a + o));

        switch (a) {
          case n:
            return 60 * ((r - i) / c + (r < i ? 6 : 0));

          case r:
            return 60 * ((i - n) / c + 2);

          case i:
            return 60 * ((n - r) / c + 4);

          default:
            return -1;
        }
      }
    };
    e["default"] = n;
  },
  1083: function _(t, e, n) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(7994),
        i = n(4027),
        a = n(318),
        o = {
      channel: r["default"],
      lang: i["default"],
      unit: a["default"]
    };
    e["default"] = o;
  },
  4027: function _(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = {
      clamp: function clamp(t, e, n) {
        return e > n ? Math.min(e, Math.max(n, t)) : Math.min(n, Math.max(e, t));
      },
      round: function round(t) {
        return Math.round(1e10 * t) / 1e10;
      }
    };
    e["default"] = n;
  },
  318: function _(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = {
      dec2hex: function dec2hex(t) {
        var e = Math.round(t).toString(16);
        return e.length > 1 ? e : "0" + e;
      }
    };
    e["default"] = n;
  },
  8552: function _(t, e, n) {
    var r = n(852)(n(5639), "DataView");
    t.exports = r;
  },
  1989: function _(t, e, n) {
    var r = n(1789),
        i = n(401),
        a = n(7667),
        o = n(1327),
        s = n(1866);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype["delete"] = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
  },
  8407: function _(t, e, n) {
    var r = n(7040),
        i = n(2188),
        a = n(2117),
        o = n(7518),
        s = n(4705);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype["delete"] = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
  },
  7071: function _(t, e, n) {
    var r = n(852)(n(5639), "Map");
    t.exports = r;
  },
  3369: function _(t, e, n) {
    var r = n(4785),
        i = n(1285),
        a = n(6e3),
        o = n(9916),
        s = n(5265);

    function c(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype["delete"] = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
  },
  3818: function _(t, e, n) {
    var r = n(852)(n(5639), "Promise");
    t.exports = r;
  },
  8525: function _(t, e, n) {
    var r = n(852)(n(5639), "Set");
    t.exports = r;
  },
  8668: function _(t, e, n) {
    var r = n(3369),
        i = n(619),
        a = n(2385);

    function o(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new r(); ++e < n;) {
        this.add(t[e]);
      }
    }

    o.prototype.add = o.prototype.push = i, o.prototype.has = a, t.exports = o;
  },
  6384: function _(t, e, n) {
    var r = n(8407),
        i = n(7465),
        a = n(3779),
        o = n(7599),
        s = n(4758),
        c = n(4309);

    function u(t) {
      var e = this.__data__ = new r(t);
      this.size = e.size;
    }

    u.prototype.clear = i, u.prototype["delete"] = a, u.prototype.get = o, u.prototype.has = s, u.prototype.set = c, t.exports = u;
  },
  2705: function _(t, e, n) {
    var r = n(5639).Symbol;
    t.exports = r;
  },
  1149: function _(t, e, n) {
    var r = n(5639).Uint8Array;
    t.exports = r;
  },
  577: function _(t, e, n) {
    var r = n(852)(n(5639), "WeakMap");
    t.exports = r;
  },
  6874: function _(t) {
    t.exports = function (t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    };
  },
  7412: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    };
  },
  4963: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, i = 0, a = []; ++n < r;) {
        var o = t[n];
        e(o, n, t) && (a[i++] = o);
      }

      return a;
    };
  },
  7443: function _(t, e, n) {
    var r = n(2118);

    t.exports = function (t, e) {
      return !(null == t || !t.length) && r(t, e, 0) > -1;
    };
  },
  1196: function _(t) {
    t.exports = function (t, e, n) {
      for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
        if (n(e, t[r])) return !0;
      }

      return !1;
    };
  },
  4636: function _(t, e, n) {
    var r = n(2545),
        i = n(5694),
        a = n(1469),
        o = n(4144),
        s = n(5776),
        c = n(6719),
        u = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      var n = a(t),
          l = !n && i(t),
          h = !n && !l && o(t),
          f = !n && !l && !h && c(t),
          d = n || l || h || f,
          p = d ? r(t.length, String) : [],
          y = p.length;

      for (var g in t) {
        !e && !u.call(t, g) || d && ("length" == g || h && ("offset" == g || "parent" == g) || f && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || s(g, y)) || p.push(g);
      }

      return p;
    };
  },
  9932: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
        i[n] = e(t[n], n, t);
      }

      return i;
    };
  },
  2488: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = e.length, i = t.length; ++n < r;) {
        t[i + n] = e[n];
      }

      return t;
    };
  },
  2663: function _(t) {
    t.exports = function (t, e, n, r) {
      var i = -1,
          a = null == t ? 0 : t.length;

      for (r && a && (n = t[++i]); ++i < a;) {
        n = e(n, t[i], i, t);
      }

      return n;
    };
  },
  2908: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };
  },
  8983: function _(t, e, n) {
    var r = n(371)("length");
    t.exports = r;
  },
  6556: function _(t, e, n) {
    var r = n(9465),
        i = n(7813);

    t.exports = function (t, e, n) {
      (void 0 !== n && !i(t[e], n) || void 0 === n && !(e in t)) && r(t, e, n);
    };
  },
  4865: function _(t, e, n) {
    var r = n(9465),
        i = n(7813),
        a = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n) {
      var o = t[e];
      a.call(t, e) && i(o, n) && (void 0 !== n || e in t) || r(t, e, n);
    };
  },
  8470: function _(t, e, n) {
    var r = n(7813);

    t.exports = function (t, e) {
      for (var n = t.length; n--;) {
        if (r(t[n][0], e)) return n;
      }

      return -1;
    };
  },
  4037: function _(t, e, n) {
    var r = n(8363),
        i = n(3674);

    t.exports = function (t, e) {
      return t && r(e, i(e), t);
    };
  },
  3886: function _(t, e, n) {
    var r = n(8363),
        i = n(1704);

    t.exports = function (t, e) {
      return t && r(e, i(e), t);
    };
  },
  9465: function _(t, e, n) {
    var r = n(8777);

    t.exports = function (t, e, n) {
      "__proto__" == e && r ? r(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
  },
  5990: function _(t, e, n) {
    var r = n(6384),
        i = n(7412),
        a = n(4865),
        o = n(4037),
        s = n(3886),
        c = n(4626),
        u = n(278),
        l = n(8805),
        h = n(1911),
        f = n(8234),
        d = n(6904),
        p = n(4160),
        y = n(3824),
        g = n(9148),
        m = n(8517),
        v = n(1469),
        b = n(4144),
        _ = n(6688),
        x = n(3218),
        w = n(2928),
        k = n(3674),
        T = n(1704),
        E = "[object Arguments]",
        C = "[object Function]",
        S = "[object Object]",
        A = {};

    A[E] = A["[object Array]"] = A["[object ArrayBuffer]"] = A["[object DataView]"] = A["[object Boolean]"] = A["[object Date]"] = A["[object Float32Array]"] = A["[object Float64Array]"] = A["[object Int8Array]"] = A["[object Int16Array]"] = A["[object Int32Array]"] = A["[object Map]"] = A["[object Number]"] = A[S] = A["[object RegExp]"] = A["[object Set]"] = A["[object String]"] = A["[object Symbol]"] = A["[object Uint8Array]"] = A["[object Uint8ClampedArray]"] = A["[object Uint16Array]"] = A["[object Uint32Array]"] = !0, A["[object Error]"] = A[C] = A["[object WeakMap]"] = !1, t.exports = function t(e, n, M, N, D, O) {
      var B,
          L = 1 & n,
          I = 2 & n,
          R = 4 & n;
      if (M && (B = D ? M(e, N, D, O) : M(e)), void 0 !== B) return B;
      if (!x(e)) return e;
      var F = v(e);

      if (F) {
        if (B = y(e), !L) return u(e, B);
      } else {
        var P = p(e),
            j = P == C || "[object GeneratorFunction]" == P;
        if (b(e)) return c(e, L);

        if (P == S || P == E || j && !D) {
          if (B = I || j ? {} : m(e), !L) return I ? h(e, s(B, e)) : l(e, o(B, e));
        } else {
          if (!A[P]) return D ? e : {};
          B = g(e, P, L);
        }
      }

      O || (O = new r());
      var Y = O.get(e);
      if (Y) return Y;
      O.set(e, B), w(e) ? e.forEach(function (r) {
        B.add(t(r, n, M, r, e, O));
      }) : _(e) && e.forEach(function (r, i) {
        B.set(i, t(r, n, M, i, e, O));
      });
      var z = F ? void 0 : (R ? I ? d : f : I ? T : k)(e);
      return i(z || e, function (r, i) {
        z && (r = e[i = r]), a(B, i, t(r, n, M, i, e, O));
      }), B;
    };
  },
  3118: function _(t, e, n) {
    var r = n(3218),
        i = Object.create,
        a = function () {
      function t() {}

      return function (e) {
        if (!r(e)) return {};
        if (i) return i(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    t.exports = a;
  },
  9881: function _(t, e, n) {
    var r = n(7816),
        i = n(9291)(r);
    t.exports = i;
  },
  6029: function _(t, e, n) {
    var r = n(3448);

    t.exports = function (t, e, n) {
      for (var i = -1, a = t.length; ++i < a;) {
        var o = t[i],
            s = e(o);
        if (null != s && (void 0 === c ? s == s && !r(s) : n(s, c))) var c = s,
            u = o;
      }

      return u;
    };
  },
  760: function _(t, e, n) {
    var r = n(9881);

    t.exports = function (t, e) {
      var n = [];
      return r(t, function (t, r, i) {
        e(t, r, i) && n.push(t);
      }), n;
    };
  },
  1848: function _(t) {
    t.exports = function (t, e, n, r) {
      for (var i = t.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) {
        if (e(t[a], a, t)) return a;
      }

      return -1;
    };
  },
  1078: function _(t, e, n) {
    var r = n(2488),
        i = n(7285);

    t.exports = function t(e, n, a, o, s) {
      var c = -1,
          u = e.length;

      for (a || (a = i), s || (s = []); ++c < u;) {
        var l = e[c];
        n > 0 && a(l) ? n > 1 ? t(l, n - 1, a, o, s) : r(s, l) : o || (s[s.length] = l);
      }

      return s;
    };
  },
  8483: function _(t, e, n) {
    var r = n(5063)();
    t.exports = r;
  },
  7816: function _(t, e, n) {
    var r = n(8483),
        i = n(3674);

    t.exports = function (t, e) {
      return t && r(t, e, i);
    };
  },
  7786: function _(t, e, n) {
    var r = n(1811),
        i = n(327);

    t.exports = function (t, e) {
      for (var n = 0, a = (e = r(e, t)).length; null != t && n < a;) {
        t = t[i(e[n++])];
      }

      return n && n == a ? t : void 0;
    };
  },
  8866: function _(t, e, n) {
    var r = n(2488),
        i = n(1469);

    t.exports = function (t, e, n) {
      var a = e(t);
      return i(t) ? a : r(a, n(t));
    };
  },
  4239: function _(t, e, n) {
    var r = n(2705),
        i = n(9607),
        a = n(2333),
        o = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : o && o in Object(t) ? i(t) : a(t);
    };
  },
  3325: function _(t) {
    t.exports = function (t, e) {
      return t > e;
    };
  },
  8565: function _(t) {
    var e = Object.prototype.hasOwnProperty;

    t.exports = function (t, n) {
      return null != t && e.call(t, n);
    };
  },
  13: function _(t) {
    t.exports = function (t, e) {
      return null != t && e in Object(t);
    };
  },
  2118: function _(t, e, n) {
    var r = n(1848),
        i = n(2722),
        a = n(2351);

    t.exports = function (t, e, n) {
      return e == e ? a(t, e, n) : r(t, i, n);
    };
  },
  9454: function _(t, e, n) {
    var r = n(4239),
        i = n(7005);

    t.exports = function (t) {
      return i(t) && "[object Arguments]" == r(t);
    };
  },
  939: function _(t, e, n) {
    var r = n(2492),
        i = n(7005);

    t.exports = function t(e, n, a, o, s) {
      return e === n || (null == e || null == n || !i(e) && !i(n) ? e != e && n != n : r(e, n, a, o, t, s));
    };
  },
  2492: function _(t, e, n) {
    var r = n(6384),
        i = n(7114),
        a = n(8351),
        o = n(6096),
        s = n(4160),
        c = n(1469),
        u = n(4144),
        l = n(6719),
        h = "[object Arguments]",
        f = "[object Array]",
        d = "[object Object]",
        p = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, y, g, m) {
      var v = c(t),
          b = c(e),
          _ = v ? f : s(t),
          x = b ? f : s(e),
          w = (_ = _ == h ? d : _) == d,
          k = (x = x == h ? d : x) == d,
          T = _ == x;

      if (T && u(t)) {
        if (!u(e)) return !1;
        v = !0, w = !1;
      }

      if (T && !w) return m || (m = new r()), v || l(t) ? i(t, e, n, y, g, m) : a(t, e, _, n, y, g, m);

      if (!(1 & n)) {
        var E = w && p.call(t, "__wrapped__"),
            C = k && p.call(e, "__wrapped__");

        if (E || C) {
          var S = E ? t.value() : t,
              A = C ? e.value() : e;
          return m || (m = new r()), g(S, A, n, y, m);
        }
      }

      return !!T && (m || (m = new r()), o(t, e, n, y, g, m));
    };
  },
  5588: function _(t, e, n) {
    var r = n(4160),
        i = n(7005);

    t.exports = function (t) {
      return i(t) && "[object Map]" == r(t);
    };
  },
  2958: function _(t, e, n) {
    var r = n(6384),
        i = n(939);

    t.exports = function (t, e, n, a) {
      var o = n.length,
          s = o,
          c = !a;
      if (null == t) return !s;

      for (t = Object(t); o--;) {
        var u = n[o];
        if (c && u[2] ? u[1] !== t[u[0]] : !(u[0] in t)) return !1;
      }

      for (; ++o < s;) {
        var l = (u = n[o])[0],
            h = t[l],
            f = u[1];

        if (c && u[2]) {
          if (void 0 === h && !(l in t)) return !1;
        } else {
          var d = new r();
          if (a) var p = a(h, f, l, t, e, d);
          if (!(void 0 === p ? i(f, h, 3, a, d) : p)) return !1;
        }
      }

      return !0;
    };
  },
  2722: function _(t) {
    t.exports = function (t) {
      return t != t;
    };
  },
  8458: function _(t, e, n) {
    var r = n(3560),
        i = n(5346),
        a = n(3218),
        o = n(346),
        s = /^\[object .+?Constructor\]$/,
        c = Function.prototype,
        u = Object.prototype,
        l = c.toString,
        h = u.hasOwnProperty,
        f = RegExp("^" + l.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    t.exports = function (t) {
      return !(!a(t) || i(t)) && (r(t) ? f : s).test(o(t));
    };
  },
  9221: function _(t, e, n) {
    var r = n(4160),
        i = n(7005);

    t.exports = function (t) {
      return i(t) && "[object Set]" == r(t);
    };
  },
  8749: function _(t, e, n) {
    var r = n(4239),
        i = n(1780),
        a = n(7005),
        o = {};
    o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, t.exports = function (t) {
      return a(t) && i(t.length) && !!o[r(t)];
    };
  },
  7206: function _(t, e, n) {
    var r = n(1573),
        i = n(6432),
        a = n(6557),
        o = n(1469),
        s = n(9601);

    t.exports = function (t) {
      return "function" == typeof t ? t : null == t ? a : "object" == _typeof(t) ? o(t) ? i(t[0], t[1]) : r(t) : s(t);
    };
  },
  280: function _(t, e, n) {
    var r = n(5726),
        i = n(6916),
        a = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return i(t);
      var e = [];

      for (var n in Object(t)) {
        a.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };
  },
  313: function _(t, e, n) {
    var r = n(3218),
        i = n(5726),
        a = n(3498),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return a(t);
      var e = i(t),
          n = [];

      for (var s in t) {
        ("constructor" != s || !e && o.call(t, s)) && n.push(s);
      }

      return n;
    };
  },
  433: function _(t) {
    t.exports = function (t, e) {
      return t < e;
    };
  },
  9199: function _(t, e, n) {
    var r = n(9881),
        i = n(8612);

    t.exports = function (t, e) {
      var n = -1,
          a = i(t) ? Array(t.length) : [];
      return r(t, function (t, r, i) {
        a[++n] = e(t, r, i);
      }), a;
    };
  },
  1573: function _(t, e, n) {
    var r = n(2958),
        i = n(1499),
        a = n(2634);

    t.exports = function (t) {
      var e = i(t);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (n) {
        return n === t || r(n, t, e);
      };
    };
  },
  6432: function _(t, e, n) {
    var r = n(939),
        i = n(1917),
        a = n(9095),
        o = n(5403),
        s = n(9162),
        c = n(2634),
        u = n(327);

    t.exports = function (t, e) {
      return o(t) && s(e) ? c(u(t), e) : function (n) {
        var o = i(n, t);
        return void 0 === o && o === e ? a(n, t) : r(e, o, 3);
      };
    };
  },
  2980: function _(t, e, n) {
    var r = n(6384),
        i = n(6556),
        a = n(8483),
        o = n(9783),
        s = n(3218),
        c = n(1704),
        u = n(6390);

    t.exports = function t(e, n, l, h, f) {
      e !== n && a(n, function (a, c) {
        if (f || (f = new r()), s(a)) o(e, n, c, l, t, h, f);else {
          var d = h ? h(u(e, c), a, c + "", e, n, f) : void 0;
          void 0 === d && (d = a), i(e, c, d);
        }
      }, c);
    };
  },
  9783: function _(t, e, n) {
    var r = n(6556),
        i = n(4626),
        a = n(7133),
        o = n(278),
        s = n(8517),
        c = n(5694),
        u = n(1469),
        l = n(9246),
        h = n(4144),
        f = n(3560),
        d = n(3218),
        p = n(8630),
        y = n(6719),
        g = n(6390),
        m = n(3678);

    t.exports = function (t, e, n, v, b, _, x) {
      var w = g(t, n),
          k = g(e, n),
          T = x.get(k);
      if (T) r(t, n, T);else {
        var E = _ ? _(w, k, n + "", t, e, x) : void 0,
            C = void 0 === E;

        if (C) {
          var S = u(k),
              A = !S && h(k),
              M = !S && !A && y(k);
          E = k, S || A || M ? u(w) ? E = w : l(w) ? E = o(w) : A ? (C = !1, E = i(k, !0)) : M ? (C = !1, E = a(k, !0)) : E = [] : p(k) || c(k) ? (E = w, c(w) ? E = m(w) : d(w) && !f(w) || (E = s(k))) : C = !1;
        }

        C && (x.set(k, E), b(E, k, v, _, x), x["delete"](k)), r(t, n, E);
      }
    };
  },
  9556: function _(t, e, n) {
    var r = n(9932),
        i = n(7786),
        a = n(7206),
        o = n(9199),
        s = n(1131),
        c = n(1717),
        u = n(5022),
        l = n(6557),
        h = n(1469);

    t.exports = function (t, e, n) {
      e = e.length ? r(e, function (t) {
        return h(t) ? function (e) {
          return i(e, 1 === t.length ? t[0] : t);
        } : t;
      }) : [l];
      var f = -1;
      e = r(e, c(a));
      var d = o(t, function (t, n, i) {
        return {
          criteria: r(e, function (e) {
            return e(t);
          }),
          index: ++f,
          value: t
        };
      });
      return s(d, function (t, e) {
        return u(t, e, n);
      });
    };
  },
  5970: function _(t, e, n) {
    var r = n(3012),
        i = n(9095);

    t.exports = function (t, e) {
      return r(t, e, function (e, n) {
        return i(t, n);
      });
    };
  },
  3012: function _(t, e, n) {
    var r = n(7786),
        i = n(611),
        a = n(1811);

    t.exports = function (t, e, n) {
      for (var o = -1, s = e.length, c = {}; ++o < s;) {
        var u = e[o],
            l = r(t, u);
        n(l, u) && i(c, a(u, t), l);
      }

      return c;
    };
  },
  371: function _(t) {
    t.exports = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    };
  },
  9152: function _(t, e, n) {
    var r = n(7786);

    t.exports = function (t) {
      return function (e) {
        return r(e, t);
      };
    };
  },
  98: function _(t) {
    var e = Math.ceil,
        n = Math.max;

    t.exports = function (t, r, i, a) {
      for (var o = -1, s = n(e((r - t) / (i || 1)), 0), c = Array(s); s--;) {
        c[a ? s : ++o] = t, t += i;
      }

      return c;
    };
  },
  107: function _(t) {
    t.exports = function (t, e, n, r, i) {
      return i(t, function (t, i, a) {
        n = r ? (r = !1, t) : e(n, t, i, a);
      }), n;
    };
  },
  5976: function _(t, e, n) {
    var r = n(6557),
        i = n(5357),
        a = n(61);

    t.exports = function (t, e) {
      return a(i(t, e, r), t + "");
    };
  },
  611: function _(t, e, n) {
    var r = n(4865),
        i = n(1811),
        a = n(5776),
        o = n(3218),
        s = n(327);

    t.exports = function (t, e, n, c) {
      if (!o(t)) return t;

      for (var u = -1, l = (e = i(e, t)).length, h = l - 1, f = t; null != f && ++u < l;) {
        var d = s(e[u]),
            p = n;
        if ("__proto__" === d || "constructor" === d || "prototype" === d) return t;

        if (u != h) {
          var y = f[d];
          void 0 === (p = c ? c(y, d, f) : void 0) && (p = o(y) ? y : a(e[u + 1]) ? [] : {});
        }

        r(f, d, p), f = f[d];
      }

      return t;
    };
  },
  6560: function _(t, e, n) {
    var r = n(5703),
        i = n(8777),
        a = n(6557),
        o = i ? function (t, e) {
      return i(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: r(e),
        writable: !0
      });
    } : a;
    t.exports = o;
  },
  1131: function _(t) {
    t.exports = function (t, e) {
      var n = t.length;

      for (t.sort(e); n--;) {
        t[n] = t[n].value;
      }

      return t;
    };
  },
  2545: function _(t) {
    t.exports = function (t, e) {
      for (var n = -1, r = Array(t); ++n < t;) {
        r[n] = e(n);
      }

      return r;
    };
  },
  531: function _(t, e, n) {
    var r = n(2705),
        i = n(9932),
        a = n(1469),
        o = n(3448),
        s = r ? r.prototype : void 0,
        c = s ? s.toString : void 0;

    t.exports = function t(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return i(e, t) + "";
      if (o(e)) return c ? c.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
    };
  },
  7561: function _(t, e, n) {
    var r = n(7990),
        i = /^\s+/;

    t.exports = function (t) {
      return t ? t.slice(0, r(t) + 1).replace(i, "") : t;
    };
  },
  1717: function _(t) {
    t.exports = function (t) {
      return function (e) {
        return t(e);
      };
    };
  },
  5652: function _(t, e, n) {
    var r = n(8668),
        i = n(7443),
        a = n(1196),
        o = n(4757),
        s = n(3593),
        c = n(1814);

    t.exports = function (t, e, n) {
      var u = -1,
          l = i,
          h = t.length,
          f = !0,
          d = [],
          p = d;
      if (n) f = !1, l = a;else if (h >= 200) {
        var y = e ? null : s(t);
        if (y) return c(y);
        f = !1, l = o, p = new r();
      } else p = e ? [] : d;

      t: for (; ++u < h;) {
        var g = t[u],
            m = e ? e(g) : g;

        if (g = n || 0 !== g ? g : 0, f && m == m) {
          for (var v = p.length; v--;) {
            if (p[v] === m) continue t;
          }

          e && p.push(m), d.push(g);
        } else l(p, m, n) || (p !== d && p.push(m), d.push(g));
      }

      return d;
    };
  },
  7415: function _(t, e, n) {
    var r = n(9932);

    t.exports = function (t, e) {
      return r(e, function (e) {
        return t[e];
      });
    };
  },
  1757: function _(t) {
    t.exports = function (t, e, n) {
      for (var r = -1, i = t.length, a = e.length, o = {}; ++r < i;) {
        var s = r < a ? e[r] : void 0;
        n(o, t[r], s);
      }

      return o;
    };
  },
  4757: function _(t) {
    t.exports = function (t, e) {
      return t.has(e);
    };
  },
  4290: function _(t, e, n) {
    var r = n(6557);

    t.exports = function (t) {
      return "function" == typeof t ? t : r;
    };
  },
  1811: function _(t, e, n) {
    var r = n(1469),
        i = n(5403),
        a = n(5514),
        o = n(9833);

    t.exports = function (t, e) {
      return r(t) ? t : i(t, e) ? [t] : a(o(t));
    };
  },
  4318: function _(t, e, n) {
    var r = n(1149);

    t.exports = function (t) {
      var e = new t.constructor(t.byteLength);
      return new r(e).set(new r(t)), e;
    };
  },
  4626: function _(t, e, n) {
    t = n.nmd(t);
    var r = n(5639),
        i = e && !e.nodeType && e,
        a = i && t && !t.nodeType && t,
        o = a && a.exports === i ? r.Buffer : void 0,
        s = o ? o.allocUnsafe : void 0;

    t.exports = function (t, e) {
      if (e) return t.slice();
      var n = t.length,
          r = s ? s(n) : new t.constructor(n);
      return t.copy(r), r;
    };
  },
  7157: function _(t, e, n) {
    var r = n(4318);

    t.exports = function (t, e) {
      var n = e ? r(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    };
  },
  3147: function _(t) {
    var e = /\w*$/;

    t.exports = function (t) {
      var n = new t.constructor(t.source, e.exec(t));
      return n.lastIndex = t.lastIndex, n;
    };
  },
  419: function _(t, e, n) {
    var r = n(2705),
        i = r ? r.prototype : void 0,
        a = i ? i.valueOf : void 0;

    t.exports = function (t) {
      return a ? Object(a.call(t)) : {};
    };
  },
  7133: function _(t, e, n) {
    var r = n(4318);

    t.exports = function (t, e) {
      var n = e ? r(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
  },
  6393: function _(t, e, n) {
    var r = n(3448);

    t.exports = function (t, e) {
      if (t !== e) {
        var n = void 0 !== t,
            i = null === t,
            a = t == t,
            o = r(t),
            s = void 0 !== e,
            c = null === e,
            u = e == e,
            l = r(e);
        if (!c && !l && !o && t > e || o && s && u && !c && !l || i && s && u || !n && u || !a) return 1;
        if (!i && !o && !l && t < e || l && n && a && !i && !o || c && n && a || !s && a || !u) return -1;
      }

      return 0;
    };
  },
  5022: function _(t, e, n) {
    var r = n(6393);

    t.exports = function (t, e, n) {
      for (var i = -1, a = t.criteria, o = e.criteria, s = a.length, c = n.length; ++i < s;) {
        var u = r(a[i], o[i]);
        if (u) return i >= c ? u : u * ("desc" == n[i] ? -1 : 1);
      }

      return t.index - e.index;
    };
  },
  278: function _(t) {
    t.exports = function (t, e) {
      var n = -1,
          r = t.length;

      for (e || (e = Array(r)); ++n < r;) {
        e[n] = t[n];
      }

      return e;
    };
  },
  8363: function _(t, e, n) {
    var r = n(4865),
        i = n(9465);

    t.exports = function (t, e, n, a) {
      var o = !n;
      n || (n = {});

      for (var s = -1, c = e.length; ++s < c;) {
        var u = e[s],
            l = a ? a(n[u], t[u], u, n, t) : void 0;
        void 0 === l && (l = t[u]), o ? i(n, u, l) : r(n, u, l);
      }

      return n;
    };
  },
  8805: function _(t, e, n) {
    var r = n(8363),
        i = n(9551);

    t.exports = function (t, e) {
      return r(t, i(t), e);
    };
  },
  1911: function _(t, e, n) {
    var r = n(8363),
        i = n(1442);

    t.exports = function (t, e) {
      return r(t, i(t), e);
    };
  },
  4429: function _(t, e, n) {
    var r = n(5639)["__core-js_shared__"];
    t.exports = r;
  },
  1750: function _(t, e, n) {
    var r = n(5976),
        i = n(6612);

    t.exports = function (t) {
      return r(function (e, n) {
        var r = -1,
            a = n.length,
            o = a > 1 ? n[a - 1] : void 0,
            s = a > 2 ? n[2] : void 0;

        for (o = t.length > 3 && "function" == typeof o ? (a--, o) : void 0, s && i(n[0], n[1], s) && (o = a < 3 ? void 0 : o, a = 1), e = Object(e); ++r < a;) {
          var c = n[r];
          c && t(e, c, r, o);
        }

        return e;
      });
    };
  },
  9291: function _(t, e, n) {
    var r = n(8612);

    t.exports = function (t, e) {
      return function (n, i) {
        if (null == n) return n;
        if (!r(n)) return t(n, i);

        for (var a = n.length, o = e ? a : -1, s = Object(n); (e ? o-- : ++o < a) && !1 !== i(s[o], o, s);) {
          ;
        }

        return n;
      };
    };
  },
  5063: function _(t) {
    t.exports = function (t) {
      return function (e, n, r) {
        for (var i = -1, a = Object(e), o = r(e), s = o.length; s--;) {
          var c = o[t ? s : ++i];
          if (!1 === n(a[c], c, a)) break;
        }

        return e;
      };
    };
  },
  7740: function _(t, e, n) {
    var r = n(7206),
        i = n(8612),
        a = n(3674);

    t.exports = function (t) {
      return function (e, n, o) {
        var s = Object(e);

        if (!i(e)) {
          var c = r(n, 3);
          e = a(e), n = function n(t) {
            return c(s[t], t, s);
          };
        }

        var u = t(e, n, o);
        return u > -1 ? s[c ? e[u] : u] : void 0;
      };
    };
  },
  7445: function _(t, e, n) {
    var r = n(98),
        i = n(6612),
        a = n(8601);

    t.exports = function (t) {
      return function (e, n, o) {
        return o && "number" != typeof o && i(e, n, o) && (n = o = void 0), e = a(e), void 0 === n ? (n = e, e = 0) : n = a(n), o = void 0 === o ? e < n ? 1 : -1 : a(o), r(e, n, o, t);
      };
    };
  },
  3593: function _(t, e, n) {
    var r = n(8525),
        i = n(308),
        a = n(1814),
        o = r && 1 / a(new r([, -0]))[1] == 1 / 0 ? function (t) {
      return new r(t);
    } : i;
    t.exports = o;
  },
  8777: function _(t, e, n) {
    var r = n(852),
        i = function () {
      try {
        var t = r(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    t.exports = i;
  },
  7114: function _(t, e, n) {
    var r = n(8668),
        i = n(2908),
        a = n(4757);

    t.exports = function (t, e, n, o, s, c) {
      var u = 1 & n,
          l = t.length,
          h = e.length;
      if (l != h && !(u && h > l)) return !1;
      var f = c.get(t),
          d = c.get(e);
      if (f && d) return f == e && d == t;
      var p = -1,
          y = !0,
          g = 2 & n ? new r() : void 0;

      for (c.set(t, e), c.set(e, t); ++p < l;) {
        var m = t[p],
            v = e[p];
        if (o) var b = u ? o(v, m, p, e, t, c) : o(m, v, p, t, e, c);

        if (void 0 !== b) {
          if (b) continue;
          y = !1;
          break;
        }

        if (g) {
          if (!i(e, function (t, e) {
            if (!a(g, e) && (m === t || s(m, t, n, o, c))) return g.push(e);
          })) {
            y = !1;
            break;
          }
        } else if (m !== v && !s(m, v, n, o, c)) {
          y = !1;
          break;
        }
      }

      return c["delete"](t), c["delete"](e), y;
    };
  },
  8351: function _(t, e, n) {
    var r = n(2705),
        i = n(1149),
        a = n(7813),
        o = n(7114),
        s = n(8776),
        c = n(1814),
        u = r ? r.prototype : void 0,
        l = u ? u.valueOf : void 0;

    t.exports = function (t, e, n, r, u, h, f) {
      switch (n) {
        case "[object DataView]":
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case "[object ArrayBuffer]":
          return !(t.byteLength != e.byteLength || !h(new i(t), new i(e)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return a(+t, +e);

        case "[object Error]":
          return t.name == e.name && t.message == e.message;

        case "[object RegExp]":
        case "[object String]":
          return t == e + "";

        case "[object Map]":
          var d = s;

        case "[object Set]":
          var p = 1 & r;
          if (d || (d = c), t.size != e.size && !p) return !1;
          var y = f.get(t);
          if (y) return y == e;
          r |= 2, f.set(t, e);
          var g = o(d(t), d(e), r, u, h, f);
          return f["delete"](t), g;

        case "[object Symbol]":
          if (l) return l.call(t) == l.call(e);
      }

      return !1;
    };
  },
  6096: function _(t, e, n) {
    var r = n(8234),
        i = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, a, o, s) {
      var c = 1 & n,
          u = r(t),
          l = u.length;
      if (l != r(e).length && !c) return !1;

      for (var h = l; h--;) {
        var f = u[h];
        if (!(c ? f in e : i.call(e, f))) return !1;
      }

      var d = s.get(t),
          p = s.get(e);
      if (d && p) return d == e && p == t;
      var y = !0;
      s.set(t, e), s.set(e, t);

      for (var g = c; ++h < l;) {
        var m = t[f = u[h]],
            v = e[f];
        if (a) var b = c ? a(v, m, f, e, t, s) : a(m, v, f, t, e, s);

        if (!(void 0 === b ? m === v || o(m, v, n, a, s) : b)) {
          y = !1;
          break;
        }

        g || (g = "constructor" == f);
      }

      if (y && !g) {
        var _ = t.constructor,
            x = e.constructor;
        _ == x || !("constructor" in t) || !("constructor" in e) || "function" == typeof _ && _ instanceof _ && "function" == typeof x && x instanceof x || (y = !1);
      }

      return s["delete"](t), s["delete"](e), y;
    };
  },
  9021: function _(t, e, n) {
    var r = n(5564),
        i = n(5357),
        a = n(61);

    t.exports = function (t) {
      return a(i(t, void 0, r), t + "");
    };
  },
  1957: function _(t, e, n) {
    var r = "object" == _typeof(n.g) && n.g && n.g.Object === Object && n.g;
    t.exports = r;
  },
  8234: function _(t, e, n) {
    var r = n(8866),
        i = n(9551),
        a = n(3674);

    t.exports = function (t) {
      return r(t, a, i);
    };
  },
  6904: function _(t, e, n) {
    var r = n(8866),
        i = n(1442),
        a = n(1704);

    t.exports = function (t) {
      return r(t, a, i);
    };
  },
  5050: function _(t, e, n) {
    var r = n(7019);

    t.exports = function (t, e) {
      var n = t.__data__;
      return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
  },
  1499: function _(t, e, n) {
    var r = n(9162),
        i = n(3674);

    t.exports = function (t) {
      for (var e = i(t), n = e.length; n--;) {
        var a = e[n],
            o = t[a];
        e[n] = [a, o, r(o)];
      }

      return e;
    };
  },
  852: function _(t, e, n) {
    var r = n(8458),
        i = n(7801);

    t.exports = function (t, e) {
      var n = i(t, e);
      return r(n) ? n : void 0;
    };
  },
  5924: function _(t, e, n) {
    var r = n(5569)(Object.getPrototypeOf, Object);
    t.exports = r;
  },
  9607: function _(t, e, n) {
    var r = n(2705),
        i = Object.prototype,
        a = i.hasOwnProperty,
        o = i.toString,
        s = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      var e = a.call(t, s),
          n = t[s];

      try {
        t[s] = void 0;
        var r = !0;
      } catch (t) {}

      var i = o.call(t);
      return r && (e ? t[s] = n : delete t[s]), i;
    };
  },
  9551: function _(t, e, n) {
    var r = n(4963),
        i = n(479),
        a = Object.prototype.propertyIsEnumerable,
        o = Object.getOwnPropertySymbols,
        s = o ? function (t) {
      return null == t ? [] : (t = Object(t), r(o(t), function (e) {
        return a.call(t, e);
      }));
    } : i;
    t.exports = s;
  },
  1442: function _(t, e, n) {
    var r = n(2488),
        i = n(5924),
        a = n(9551),
        o = n(479),
        s = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        r(e, a(t)), t = i(t);
      }

      return e;
    } : o;
    t.exports = s;
  },
  4160: function _(t, e, n) {
    var r = n(8552),
        i = n(7071),
        a = n(3818),
        o = n(8525),
        s = n(577),
        c = n(4239),
        u = n(346),
        l = "[object Map]",
        h = "[object Promise]",
        f = "[object Set]",
        d = "[object WeakMap]",
        p = "[object DataView]",
        y = u(r),
        g = u(i),
        m = u(a),
        v = u(o),
        b = u(s),
        _ = c;
    (r && _(new r(new ArrayBuffer(1))) != p || i && _(new i()) != l || a && _(a.resolve()) != h || o && _(new o()) != f || s && _(new s()) != d) && (_ = function _(t) {
      var e = c(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          r = n ? u(n) : "";
      if (r) switch (r) {
        case y:
          return p;

        case g:
          return l;

        case m:
          return h;

        case v:
          return f;

        case b:
          return d;
      }
      return e;
    }), t.exports = _;
  },
  7801: function _(t) {
    t.exports = function (t, e) {
      return null == t ? void 0 : t[e];
    };
  },
  222: function _(t, e, n) {
    var r = n(1811),
        i = n(5694),
        a = n(1469),
        o = n(5776),
        s = n(1780),
        c = n(327);

    t.exports = function (t, e, n) {
      for (var u = -1, l = (e = r(e, t)).length, h = !1; ++u < l;) {
        var f = c(e[u]);
        if (!(h = null != t && n(t, f))) break;
        t = t[f];
      }

      return h || ++u != l ? h : !!(l = null == t ? 0 : t.length) && s(l) && o(f, l) && (a(t) || i(t));
    };
  },
  2689: function _(t) {
    var e = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    t.exports = function (t) {
      return e.test(t);
    };
  },
  1789: function _(t, e, n) {
    var r = n(4536);

    t.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  },
  401: function _(t) {
    t.exports = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
  },
  7667: function _(t, e, n) {
    var r = n(4536),
        i = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;

      if (r) {
        var n = e[t];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }

      return i.call(e, t) ? e[t] : void 0;
    };
  },
  1327: function _(t, e, n) {
    var r = n(4536),
        i = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;
      return r ? void 0 !== e[t] : i.call(e, t);
    };
  },
  1866: function _(t, e, n) {
    var r = n(4536);

    t.exports = function (t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
  },
  3824: function _(t) {
    var e = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var n = t.length,
          r = new t.constructor(n);
      return n && "string" == typeof t[0] && e.call(t, "index") && (r.index = t.index, r.input = t.input), r;
    };
  },
  9148: function _(t, e, n) {
    var r = n(4318),
        i = n(7157),
        a = n(3147),
        o = n(419),
        s = n(7133);

    t.exports = function (t, e, n) {
      var c = t.constructor;

      switch (e) {
        case "[object ArrayBuffer]":
          return r(t);

        case "[object Boolean]":
        case "[object Date]":
          return new c(+t);

        case "[object DataView]":
          return i(t, n);

        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return s(t, n);

        case "[object Map]":
        case "[object Set]":
          return new c();

        case "[object Number]":
        case "[object String]":
          return new c(t);

        case "[object RegExp]":
          return a(t);

        case "[object Symbol]":
          return o(t);
      }
    };
  },
  8517: function _(t, e, n) {
    var r = n(3118),
        i = n(5924),
        a = n(5726);

    t.exports = function (t) {
      return "function" != typeof t.constructor || a(t) ? {} : r(i(t));
    };
  },
  7285: function _(t, e, n) {
    var r = n(2705),
        i = n(5694),
        a = n(1469),
        o = r ? r.isConcatSpreadable : void 0;

    t.exports = function (t) {
      return a(t) || i(t) || !!(o && t && t[o]);
    };
  },
  5776: function _(t) {
    var e = /^(?:0|[1-9]\d*)$/;

    t.exports = function (t, n) {
      var r = _typeof(t);

      return !!(n = null == n ? 9007199254740991 : n) && ("number" == r || "symbol" != r && e.test(t)) && t > -1 && t % 1 == 0 && t < n;
    };
  },
  6612: function _(t, e, n) {
    var r = n(7813),
        i = n(8612),
        a = n(5776),
        o = n(3218);

    t.exports = function (t, e, n) {
      if (!o(n)) return !1;

      var s = _typeof(e);

      return !!("number" == s ? i(n) && a(e, n.length) : "string" == s && e in n) && r(n[e], t);
    };
  },
  5403: function _(t, e, n) {
    var r = n(1469),
        i = n(3448),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        o = /^\w*$/;

    t.exports = function (t, e) {
      if (r(t)) return !1;

      var n = _typeof(t);

      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !i(t)) || o.test(t) || !a.test(t) || null != e && t in Object(e);
    };
  },
  7019: function _(t) {
    t.exports = function (t) {
      var e = _typeof(t);

      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
  },
  5346: function _(t, e, n) {
    var r,
        i = n(4429),
        a = (r = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    t.exports = function (t) {
      return !!a && a in t;
    };
  },
  5726: function _(t) {
    var e = Object.prototype;

    t.exports = function (t) {
      var n = t && t.constructor;
      return t === ("function" == typeof n && n.prototype || e);
    };
  },
  9162: function _(t, e, n) {
    var r = n(3218);

    t.exports = function (t) {
      return t == t && !r(t);
    };
  },
  7040: function _(t) {
    t.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  },
  2188: function _(t, e, n) {
    var r = n(8470),
        i = Array.prototype.splice;

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : i.call(e, n, 1), --this.size, 0));
    };
  },
  2117: function _(t, e, n) {
    var r = n(8470);

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
  },
  7518: function _(t, e, n) {
    var r = n(8470);

    t.exports = function (t) {
      return r(this.__data__, t) > -1;
    };
  },
  4705: function _(t, e, n) {
    var r = n(8470);

    t.exports = function (t, e) {
      var n = this.__data__,
          i = r(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };
  },
  4785: function _(t, e, n) {
    var r = n(1989),
        i = n(8407),
        a = n(7071);

    t.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || i)(),
        string: new r()
      };
    };
  },
  1285: function _(t, e, n) {
    var r = n(5050);

    t.exports = function (t) {
      var e = r(this, t)["delete"](t);
      return this.size -= e ? 1 : 0, e;
    };
  },
  6e3: function _(t, e, n) {
    var r = n(5050);

    t.exports = function (t) {
      return r(this, t).get(t);
    };
  },
  9916: function _(t, e, n) {
    var r = n(5050);

    t.exports = function (t) {
      return r(this, t).has(t);
    };
  },
  5265: function _(t, e, n) {
    var r = n(5050);

    t.exports = function (t, e) {
      var n = r(this, t),
          i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };
  },
  8776: function _(t) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, r) {
        n[++e] = [r, t];
      }), n;
    };
  },
  2634: function _(t) {
    t.exports = function (t, e) {
      return function (n) {
        return null != n && n[t] === e && (void 0 !== e || t in Object(n));
      };
    };
  },
  4523: function _(t, e, n) {
    var r = n(8306);

    t.exports = function (t) {
      var e = r(t, function (t) {
        return 500 === n.size && n.clear(), t;
      }),
          n = e.cache;
      return e;
    };
  },
  4536: function _(t, e, n) {
    var r = n(852)(Object, "create");
    t.exports = r;
  },
  6916: function _(t, e, n) {
    var r = n(5569)(Object.keys, Object);
    t.exports = r;
  },
  3498: function _(t) {
    t.exports = function (t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    };
  },
  1167: function _(t, e, n) {
    t = n.nmd(t);

    var r = n(1957),
        i = e && !e.nodeType && e,
        a = i && t && !t.nodeType && t,
        o = a && a.exports === i && r.process,
        s = function () {
      try {
        return a && a.require && a.require("util").types || o && o.binding && o.binding("util");
      } catch (t) {}
    }();

    t.exports = s;
  },
  2333: function _(t) {
    var e = Object.prototype.toString;

    t.exports = function (t) {
      return e.call(t);
    };
  },
  5569: function _(t) {
    t.exports = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    };
  },
  5357: function _(t, e, n) {
    var r = n(6874),
        i = Math.max;

    t.exports = function (t, e, n) {
      return e = i(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var a = arguments, o = -1, s = i(a.length - e, 0), c = Array(s); ++o < s;) {
          c[o] = a[e + o];
        }

        o = -1;

        for (var u = Array(e + 1); ++o < e;) {
          u[o] = a[o];
        }

        return u[e] = n(c), r(t, this, u);
      };
    };
  },
  5639: function _(t, e, n) {
    var r = n(1957),
        i = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        a = r || i || Function("return this")();
    t.exports = a;
  },
  6390: function _(t) {
    t.exports = function (t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    };
  },
  619: function _(t) {
    t.exports = function (t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    };
  },
  2385: function _(t) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  },
  1814: function _(t) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    };
  },
  61: function _(t, e, n) {
    var r = n(6560),
        i = n(1275)(r);
    t.exports = i;
  },
  1275: function _(t) {
    var e = Date.now;

    t.exports = function (t) {
      var n = 0,
          r = 0;
      return function () {
        var i = e(),
            a = 16 - (i - r);

        if (r = i, a > 0) {
          if (++n >= 800) return arguments[0];
        } else n = 0;

        return t.apply(void 0, arguments);
      };
    };
  },
  7465: function _(t, e, n) {
    var r = n(8407);

    t.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  },
  3779: function _(t) {
    t.exports = function (t) {
      var e = this.__data__,
          n = e["delete"](t);
      return this.size = e.size, n;
    };
  },
  7599: function _(t) {
    t.exports = function (t) {
      return this.__data__.get(t);
    };
  },
  4758: function _(t) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  },
  4309: function _(t, e, n) {
    var r = n(8407),
        i = n(7071),
        a = n(3369);

    t.exports = function (t, e) {
      var n = this.__data__;

      if (n instanceof r) {
        var o = n.__data__;
        if (!i || o.length < 199) return o.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new a(o);
      }

      return n.set(t, e), this.size = n.size, this;
    };
  },
  2351: function _(t) {
    t.exports = function (t, e, n) {
      for (var r = n - 1, i = t.length; ++r < i;) {
        if (t[r] === e) return r;
      }

      return -1;
    };
  },
  8016: function _(t, e, n) {
    var r = n(8983),
        i = n(2689),
        a = n(1903);

    t.exports = function (t) {
      return i(t) ? a(t) : r(t);
    };
  },
  5514: function _(t, e, n) {
    var r = n(4523),
        i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        o = r(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(i, function (t, n, r, i) {
        e.push(r ? i.replace(a, "$1") : n || t);
      }), e;
    });
    t.exports = o;
  },
  327: function _(t, e, n) {
    var r = n(3448);

    t.exports = function (t) {
      if ("string" == typeof t || r(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
    };
  },
  346: function _(t) {
    var e = Function.prototype.toString;

    t.exports = function (t) {
      if (null != t) {
        try {
          return e.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    };
  },
  7990: function _(t) {
    var e = /\s/;

    t.exports = function (t) {
      for (var n = t.length; n-- && e.test(t.charAt(n));) {
        ;
      }

      return n;
    };
  },
  1903: function _(t) {
    var e = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        n = "\\ud83c[\\udffb-\\udfff]",
        r = "[^\\ud800-\\udfff]",
        i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        a = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        o = "(?:" + e + "|" + n + ")?",
        s = "[\\ufe0e\\ufe0f]?",
        c = s + o + "(?:\\u200d(?:" + [r, i, a].join("|") + ")" + s + o + ")*",
        u = "(?:" + [r + e + "?", e, i, a, "[\\ud800-\\udfff]"].join("|") + ")",
        l = RegExp(n + "(?=" + n + ")|" + u + c, "g");

    t.exports = function (t) {
      for (var e = l.lastIndex = 0; l.test(t);) {
        ++e;
      }

      return e;
    };
  },
  6678: function _(t, e, n) {
    var r = n(5990);

    t.exports = function (t) {
      return r(t, 4);
    };
  },
  361: function _(t, e, n) {
    var r = n(5990);

    t.exports = function (t) {
      return r(t, 5);
    };
  },
  5703: function _(t) {
    t.exports = function (t) {
      return function () {
        return t;
      };
    };
  },
  1747: function _(t, e, n) {
    var r = n(5976),
        i = n(7813),
        a = n(6612),
        o = n(1704),
        s = Object.prototype,
        c = s.hasOwnProperty,
        u = r(function (t, e) {
      t = Object(t);
      var n = -1,
          r = e.length,
          u = r > 2 ? e[2] : void 0;

      for (u && a(e[0], e[1], u) && (r = 1); ++n < r;) {
        for (var l = e[n], h = o(l), f = -1, d = h.length; ++f < d;) {
          var p = h[f],
              y = t[p];
          (void 0 === y || i(y, s[p]) && !c.call(t, p)) && (t[p] = l[p]);
        }
      }

      return t;
    });
    t.exports = u;
  },
  6073: function _(t, e, n) {
    t.exports = n(4486);
  },
  7813: function _(t) {
    t.exports = function (t, e) {
      return t === e || t != t && e != e;
    };
  },
  3105: function _(t, e, n) {
    var r = n(4963),
        i = n(760),
        a = n(7206),
        o = n(1469);

    t.exports = function (t, e) {
      return (o(t) ? r : i)(t, a(e, 3));
    };
  },
  3311: function _(t, e, n) {
    var r = n(7740)(n(998));
    t.exports = r;
  },
  998: function _(t, e, n) {
    var r = n(1848),
        i = n(7206),
        a = n(554),
        o = Math.max;

    t.exports = function (t, e, n) {
      var s = null == t ? 0 : t.length;
      if (!s) return -1;
      var c = null == n ? 0 : a(n);
      return c < 0 && (c = o(s + c, 0)), r(t, i(e, 3), c);
    };
  },
  5564: function _(t, e, n) {
    var r = n(1078);

    t.exports = function (t) {
      return null != t && t.length ? r(t, 1) : [];
    };
  },
  4486: function _(t, e, n) {
    var r = n(7412),
        i = n(9881),
        a = n(4290),
        o = n(1469);

    t.exports = function (t, e) {
      return (o(t) ? r : i)(t, a(e));
    };
  },
  2620: function _(t, e, n) {
    var r = n(8483),
        i = n(4290),
        a = n(1704);

    t.exports = function (t, e) {
      return null == t ? t : r(t, i(e), a);
    };
  },
  1917: function _(t, e, n) {
    var r = n(7786);

    t.exports = function (t, e, n) {
      var i = null == t ? void 0 : r(t, e);
      return void 0 === i ? n : i;
    };
  },
  8721: function _(t, e, n) {
    var r = n(8565),
        i = n(222);

    t.exports = function (t, e) {
      return null != t && i(t, e, r);
    };
  },
  9095: function _(t, e, n) {
    var r = n(13),
        i = n(222);

    t.exports = function (t, e) {
      return null != t && i(t, e, r);
    };
  },
  6557: function _(t) {
    t.exports = function (t) {
      return t;
    };
  },
  5694: function _(t, e, n) {
    var r = n(9454),
        i = n(7005),
        a = Object.prototype,
        o = a.hasOwnProperty,
        s = a.propertyIsEnumerable,
        c = r(function () {
      return arguments;
    }()) ? r : function (t) {
      return i(t) && o.call(t, "callee") && !s.call(t, "callee");
    };
    t.exports = c;
  },
  1469: function _(t) {
    var e = Array.isArray;
    t.exports = e;
  },
  8612: function _(t, e, n) {
    var r = n(3560),
        i = n(1780);

    t.exports = function (t) {
      return null != t && i(t.length) && !r(t);
    };
  },
  9246: function _(t, e, n) {
    var r = n(8612),
        i = n(7005);

    t.exports = function (t) {
      return i(t) && r(t);
    };
  },
  4144: function _(t, e, n) {
    t = n.nmd(t);
    var r = n(5639),
        i = n(5062),
        a = e && !e.nodeType && e,
        o = a && t && !t.nodeType && t,
        s = o && o.exports === a ? r.Buffer : void 0,
        c = (s ? s.isBuffer : void 0) || i;
    t.exports = c;
  },
  1609: function _(t, e, n) {
    var r = n(280),
        i = n(4160),
        a = n(5694),
        o = n(1469),
        s = n(8612),
        c = n(4144),
        u = n(5726),
        l = n(6719),
        h = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (null == t) return !0;
      if (s(t) && (o(t) || "string" == typeof t || "function" == typeof t.splice || c(t) || l(t) || a(t))) return !t.length;
      var e = i(t);
      if ("[object Map]" == e || "[object Set]" == e) return !t.size;
      if (u(t)) return !r(t).length;

      for (var n in t) {
        if (h.call(t, n)) return !1;
      }

      return !0;
    };
  },
  3560: function _(t, e, n) {
    var r = n(4239),
        i = n(3218);

    t.exports = function (t) {
      if (!i(t)) return !1;
      var e = r(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
  },
  1780: function _(t) {
    t.exports = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
  },
  6688: function _(t, e, n) {
    var r = n(5588),
        i = n(1717),
        a = n(1167),
        o = a && a.isMap,
        s = o ? i(o) : r;
    t.exports = s;
  },
  3218: function _(t) {
    t.exports = function (t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    };
  },
  7005: function _(t) {
    t.exports = function (t) {
      return null != t && "object" == _typeof(t);
    };
  },
  8630: function _(t, e, n) {
    var r = n(4239),
        i = n(5924),
        a = n(7005),
        o = Function.prototype,
        s = Object.prototype,
        c = o.toString,
        u = s.hasOwnProperty,
        l = c.call(Object);

    t.exports = function (t) {
      if (!a(t) || "[object Object]" != r(t)) return !1;
      var e = i(t);
      if (null === e) return !0;
      var n = u.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && c.call(n) == l;
    };
  },
  2928: function _(t, e, n) {
    var r = n(9221),
        i = n(1717),
        a = n(1167),
        o = a && a.isSet,
        s = o ? i(o) : r;
    t.exports = s;
  },
  7037: function _(t, e, n) {
    var r = n(4239),
        i = n(1469),
        a = n(7005);

    t.exports = function (t) {
      return "string" == typeof t || !i(t) && a(t) && "[object String]" == r(t);
    };
  },
  3448: function _(t, e, n) {
    var r = n(4239),
        i = n(7005);

    t.exports = function (t) {
      return "symbol" == _typeof(t) || i(t) && "[object Symbol]" == r(t);
    };
  },
  6719: function _(t, e, n) {
    var r = n(8749),
        i = n(1717),
        a = n(1167),
        o = a && a.isTypedArray,
        s = o ? i(o) : r;
    t.exports = s;
  },
  2353: function _(t) {
    t.exports = function (t) {
      return void 0 === t;
    };
  },
  3674: function _(t, e, n) {
    var r = n(4636),
        i = n(280),
        a = n(8612);

    t.exports = function (t) {
      return a(t) ? r(t) : i(t);
    };
  },
  1704: function _(t, e, n) {
    var r = n(4636),
        i = n(313),
        a = n(8612);

    t.exports = function (t) {
      return a(t) ? r(t, !0) : i(t);
    };
  },
  928: function _(t) {
    t.exports = function (t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
  },
  5161: function _(t, e, n) {
    var r = n(9932),
        i = n(7206),
        a = n(9199),
        o = n(1469);

    t.exports = function (t, e) {
      return (o(t) ? r : a)(t, i(e, 3));
    };
  },
  6604: function _(t, e, n) {
    var r = n(9465),
        i = n(7816),
        a = n(7206);

    t.exports = function (t, e) {
      var n = {};
      return e = a(e, 3), i(t, function (t, i, a) {
        r(n, i, e(t, i, a));
      }), n;
    };
  },
  6162: function _(t, e, n) {
    var r = n(6029),
        i = n(3325),
        a = n(6557);

    t.exports = function (t) {
      return t && t.length ? r(t, a, i) : void 0;
    };
  },
  8306: function _(t, e, n) {
    var r = n(3369);

    function i(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

      var n = function n() {
        var r = arguments,
            i = e ? e.apply(this, r) : r[0],
            a = n.cache;
        if (a.has(i)) return a.get(i);
        var o = t.apply(this, r);
        return n.cache = a.set(i, o) || a, o;
      };

      return n.cache = new (i.Cache || r)(), n;
    }

    i.Cache = r, t.exports = i;
  },
  3857: function _(t, e, n) {
    var r = n(2980),
        i = n(1750)(function (t, e, n) {
      r(t, e, n);
    });
    t.exports = i;
  },
  3632: function _(t, e, n) {
    var r = n(6029),
        i = n(433),
        a = n(6557);

    t.exports = function (t) {
      return t && t.length ? r(t, a, i) : void 0;
    };
  },
  2762: function _(t, e, n) {
    var r = n(6029),
        i = n(7206),
        a = n(433);

    t.exports = function (t, e) {
      return t && t.length ? r(t, i(e, 2), a) : void 0;
    };
  },
  308: function _(t) {
    t.exports = function () {};
  },
  7771: function _(t, e, n) {
    var r = n(5639);

    t.exports = function () {
      return r.Date.now();
    };
  },
  9722: function _(t, e, n) {
    var r = n(5970),
        i = n(9021)(function (t, e) {
      return null == t ? {} : r(t, e);
    });
    t.exports = i;
  },
  9601: function _(t, e, n) {
    var r = n(371),
        i = n(9152),
        a = n(5403),
        o = n(327);

    t.exports = function (t) {
      return a(t) ? r(o(t)) : i(t);
    };
  },
  6026: function _(t, e, n) {
    var r = n(7445)();
    t.exports = r;
  },
  4061: function _(t, e, n) {
    var r = n(2663),
        i = n(9881),
        a = n(7206),
        o = n(107),
        s = n(1469);

    t.exports = function (t, e, n) {
      var c = s(t) ? r : o,
          u = arguments.length < 3;
      return c(t, a(e, 4), n, u, i);
    };
  },
  4238: function _(t, e, n) {
    var r = n(280),
        i = n(4160),
        a = n(8612),
        o = n(7037),
        s = n(8016);

    t.exports = function (t) {
      if (null == t) return 0;
      if (a(t)) return o(t) ? s(t) : t.length;
      var e = i(t);
      return "[object Map]" == e || "[object Set]" == e ? t.size : r(t).length;
    };
  },
  9734: function _(t, e, n) {
    var r = n(1078),
        i = n(9556),
        a = n(5976),
        o = n(6612),
        s = a(function (t, e) {
      if (null == t) return [];
      var n = e.length;
      return n > 1 && o(t, e[0], e[1]) ? e = [] : n > 2 && o(e[0], e[1], e[2]) && (e = [e[0]]), i(t, r(e, 1), []);
    });
    t.exports = s;
  },
  479: function _(t) {
    t.exports = function () {
      return [];
    };
  },
  5062: function _(t) {
    t.exports = function () {
      return !1;
    };
  },
  8601: function _(t, e, n) {
    var r = n(4841);

    t.exports = function (t) {
      return t ? Infinity === (t = r(t)) || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
    };
  },
  554: function _(t, e, n) {
    var r = n(8601);

    t.exports = function (t) {
      var e = r(t),
          n = e % 1;
      return e == e ? n ? e - n : e : 0;
    };
  },
  4841: function _(t, e, n) {
    var r = n(7561),
        i = n(3218),
        a = n(3448),
        o = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        u = parseInt;

    t.exports = function (t) {
      if ("number" == typeof t) return t;
      if (a(t)) return NaN;

      if (i(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = i(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = r(t);
      var n = s.test(t);
      return n || c.test(t) ? u(t.slice(2), n ? 2 : 8) : o.test(t) ? NaN : +t;
    };
  },
  3678: function _(t, e, n) {
    var r = n(8363),
        i = n(1704);

    t.exports = function (t) {
      return r(t, i(t));
    };
  },
  9833: function _(t, e, n) {
    var r = n(531);

    t.exports = function (t) {
      return null == t ? "" : r(t);
    };
  },
  8718: function _(t, e, n) {
    var r = n(7412),
        i = n(3118),
        a = n(7816),
        o = n(7206),
        s = n(5924),
        c = n(1469),
        u = n(4144),
        l = n(3560),
        h = n(3218),
        f = n(6719);

    t.exports = function (t, e, n) {
      var d = c(t),
          p = d || u(t) || f(t);

      if (e = o(e, 4), null == n) {
        var y = t && t.constructor;
        n = p ? d ? new y() : [] : h(t) && l(y) ? i(s(t)) : {};
      }

      return (p ? r : a)(t, function (t, r, i) {
        return e(n, t, r, i);
      }), n;
    };
  },
  3386: function _(t, e, n) {
    var r = n(1078),
        i = n(5976),
        a = n(5652),
        o = n(9246),
        s = i(function (t) {
      return a(r(t, 1, o, !0));
    });
    t.exports = s;
  },
  3955: function _(t, e, n) {
    var r = n(9833),
        i = 0;

    t.exports = function (t) {
      var e = ++i;
      return r(t) + e;
    };
  },
  2628: function _(t, e, n) {
    var r = n(7415),
        i = n(3674);

    t.exports = function (t) {
      return null == t ? [] : r(t, i(t));
    };
  },
  7287: function _(t, e, n) {
    var r = n(4865),
        i = n(1757);

    t.exports = function (t, e) {
      return i(t || [], e || [], r);
    };
  },
  9234: function _() {},
  1748: function _(t, e, n) {
    var r = {
      "./locale": 9234,
      "./locale.js": 9234
    };

    function i(t) {
      var e = a(t);
      return n(e);
    }

    function a(t) {
      if (!n.o(r, t)) {
        var e = new Error("Cannot find module '" + t + "'");
        throw e.code = "MODULE_NOT_FOUND", e;
      }

      return r[t];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, t.exports = i, i.id = 1748;
  },
  1941: function _(t, e, n) {
    (t = n.nmd(t)).exports = function () {
      var e, r;

      function i() {
        return e.apply(null, arguments);
      }

      function a(t) {
        return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t);
      }

      function o(t) {
        return null != t && "[object Object]" === Object.prototype.toString.call(t);
      }

      function s(t) {
        return void 0 === t;
      }

      function c(t) {
        return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t);
      }

      function u(t) {
        return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t);
      }

      function l(t, e) {
        var n,
            r = [];

        for (n = 0; n < t.length; ++n) {
          r.push(e(t[n], n));
        }

        return r;
      }

      function h(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      function f(t, e) {
        for (var n in e) {
          h(e, n) && (t[n] = e[n]);
        }

        return h(e, "toString") && (t.toString = e.toString), h(e, "valueOf") && (t.valueOf = e.valueOf), t;
      }

      function d(t, e, n, r) {
        return be(t, e, n, r, !0).utc();
      }

      function p(t) {
        return null == t._pf && (t._pf = {
          empty: !1,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: !1,
          invalidMonth: null,
          invalidFormat: !1,
          userInvalidated: !1,
          iso: !1,
          parsedDateParts: [],
          meridiem: null,
          rfc2822: !1,
          weekdayMismatch: !1
        }), t._pf;
      }

      function y(t) {
        if (null == t._isValid) {
          var e = p(t),
              n = r.call(e.parsedDateParts, function (t) {
            return null != t;
          }),
              i = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && n);
          if (t._strict && (i = i && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return i;
          t._isValid = i;
        }

        return t._isValid;
      }

      function g(t) {
        var e = d(NaN);
        return null != t ? f(p(e), t) : p(e).userInvalidated = !0, e;
      }

      r = Array.prototype.some ? Array.prototype.some : function (t) {
        for (var e = Object(this), n = e.length >>> 0, r = 0; r < n; r++) {
          if (r in e && t.call(this, e[r], r, e)) return !0;
        }

        return !1;
      };
      var m = i.momentProperties = [];

      function v(t, e) {
        var n, r, i;
        if (s(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), s(e._i) || (t._i = e._i), s(e._f) || (t._f = e._f), s(e._l) || (t._l = e._l), s(e._strict) || (t._strict = e._strict), s(e._tzm) || (t._tzm = e._tzm), s(e._isUTC) || (t._isUTC = e._isUTC), s(e._offset) || (t._offset = e._offset), s(e._pf) || (t._pf = p(e)), s(e._locale) || (t._locale = e._locale), 0 < m.length) for (n = 0; n < m.length; n++) {
          s(i = e[r = m[n]]) || (t[r] = i);
        }
        return t;
      }

      var b = !1;

      function _(t) {
        v(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === b && (b = !0, i.updateOffset(this), b = !1);
      }

      function x(t) {
        return t instanceof _ || null != t && null != t._isAMomentObject;
      }

      function w(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      }

      function k(t) {
        var e = +t,
            n = 0;
        return 0 !== e && isFinite(e) && (n = w(e)), n;
      }

      function T(t, e, n) {
        var r,
            i = Math.min(t.length, e.length),
            a = Math.abs(t.length - e.length),
            o = 0;

        for (r = 0; r < i; r++) {
          (n && t[r] !== e[r] || !n && k(t[r]) !== k(e[r])) && o++;
        }

        return o + a;
      }

      function E(t) {
        !1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t);
      }

      function C(t, e) {
        var n = !0;
        return f(function () {
          if (null != i.deprecationHandler && i.deprecationHandler(null, t), n) {
            for (var r, a = [], o = 0; o < arguments.length; o++) {
              if (r = "", "object" == _typeof(arguments[o])) {
                for (var s in r += "\n[" + o + "] ", arguments[0]) {
                  r += s + ": " + arguments[0][s] + ", ";
                }

                r = r.slice(0, -2);
              } else r = arguments[o];

              a.push(r);
            }

            E(t + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + new Error().stack), n = !1;
          }

          return e.apply(this, arguments);
        }, e);
      }

      var S,
          A = {};

      function M(t, e) {
        null != i.deprecationHandler && i.deprecationHandler(t, e), A[t] || (E(e), A[t] = !0);
      }

      function N(t) {
        return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t);
      }

      function D(t, e) {
        var n,
            r = f({}, t);

        for (n in e) {
          h(e, n) && (o(t[n]) && o(e[n]) ? (r[n] = {}, f(r[n], t[n]), f(r[n], e[n])) : null != e[n] ? r[n] = e[n] : delete r[n]);
        }

        for (n in t) {
          h(t, n) && !h(e, n) && o(t[n]) && (r[n] = f({}, r[n]));
        }

        return r;
      }

      function O(t) {
        null != t && this.set(t);
      }

      i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, S = Object.keys ? Object.keys : function (t) {
        var e,
            n = [];

        for (e in t) {
          h(t, e) && n.push(e);
        }

        return n;
      };
      var B = {};

      function L(t, e) {
        var n = t.toLowerCase();
        B[n] = B[n + "s"] = B[e] = t;
      }

      function I(t) {
        return "string" == typeof t ? B[t] || B[t.toLowerCase()] : void 0;
      }

      function R(t) {
        var e,
            n,
            r = {};

        for (n in t) {
          h(t, n) && (e = I(n)) && (r[e] = t[n]);
        }

        return r;
      }

      var F = {};

      function P(t, e) {
        F[t] = e;
      }

      function j(t, e, n) {
        var r = "" + Math.abs(t),
            i = e - r.length;
        return (0 <= t ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
      }

      var Y = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
          z = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
          U = {},
          q = {};

      function H(t, e, n, r) {
        var i = r;
        "string" == typeof r && (i = function i() {
          return this[r]();
        }), t && (q[t] = i), e && (q[e[0]] = function () {
          return j(i.apply(this, arguments), e[1], e[2]);
        }), n && (q[n] = function () {
          return this.localeData().ordinal(i.apply(this, arguments), t);
        });
      }

      function $(t, e) {
        return t.isValid() ? (e = W(e, t.localeData()), U[e] = U[e] || function (t) {
          var e,
              n,
              r,
              i = t.match(Y);

          for (e = 0, n = i.length; e < n; e++) {
            q[i[e]] ? i[e] = q[i[e]] : i[e] = (r = i[e]).match(/\[[\s\S]/) ? r.replace(/^\[|\]$/g, "") : r.replace(/\\/g, "");
          }

          return function (e) {
            var r,
                a = "";

            for (r = 0; r < n; r++) {
              a += N(i[r]) ? i[r].call(e, t) : i[r];
            }

            return a;
          };
        }(e), U[e](t)) : t.localeData().invalidDate();
      }

      function W(t, e) {
        var n = 5;

        function r(t) {
          return e.longDateFormat(t) || t;
        }

        for (z.lastIndex = 0; 0 <= n && z.test(t);) {
          t = t.replace(z, r), z.lastIndex = 0, n -= 1;
        }

        return t;
      }

      var V = /\d/,
          G = /\d\d/,
          X = /\d{3}/,
          Z = /\d{4}/,
          Q = /[+-]?\d{6}/,
          K = /\d\d?/,
          J = /\d\d\d\d?/,
          tt = /\d\d\d\d\d\d?/,
          et = /\d{1,3}/,
          nt = /\d{1,4}/,
          rt = /[+-]?\d{1,6}/,
          it = /\d+/,
          at = /[+-]?\d+/,
          ot = /Z|[+-]\d\d:?\d\d/gi,
          st = /Z|[+-]\d\d(?::?\d\d)?/gi,
          ct = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
          ut = {};

      function lt(t, e, n) {
        ut[t] = N(e) ? e : function (t, r) {
          return t && n ? n : e;
        };
      }

      function ht(t, e) {
        return h(ut, t) ? ut[t](e._strict, e._locale) : new RegExp(ft(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (t, e, n, r, i) {
          return e || n || r || i;
        })));
      }

      function ft(t) {
        return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      var dt = {};

      function pt(t, e) {
        var n,
            r = e;

        for ("string" == typeof t && (t = [t]), c(e) && (r = function r(t, n) {
          n[e] = k(t);
        }), n = 0; n < t.length; n++) {
          dt[t[n]] = r;
        }
      }

      function yt(t, e) {
        pt(t, function (t, n, r, i) {
          r._w = r._w || {}, e(t, r._w, r, i);
        });
      }

      function gt(t) {
        return mt(t) ? 366 : 365;
      }

      function mt(t) {
        return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
      }

      H("Y", 0, 0, function () {
        var t = this.year();
        return t <= 9999 ? "" + t : "+" + t;
      }), H(0, ["YY", 2], 0, function () {
        return this.year() % 100;
      }), H(0, ["YYYY", 4], 0, "year"), H(0, ["YYYYY", 5], 0, "year"), H(0, ["YYYYYY", 6, !0], 0, "year"), L("year", "y"), P("year", 1), lt("Y", at), lt("YY", K, G), lt("YYYY", nt, Z), lt("YYYYY", rt, Q), lt("YYYYYY", rt, Q), pt(["YYYYY", "YYYYYY"], 0), pt("YYYY", function (t, e) {
        e[0] = 2 === t.length ? i.parseTwoDigitYear(t) : k(t);
      }), pt("YY", function (t, e) {
        e[0] = i.parseTwoDigitYear(t);
      }), pt("Y", function (t, e) {
        e[0] = parseInt(t, 10);
      }), i.parseTwoDigitYear = function (t) {
        return k(t) + (68 < k(t) ? 1900 : 2e3);
      };

      var vt,
          bt = _t("FullYear", !0);

      function _t(t, e) {
        return function (n) {
          return null != n ? (wt(this, t, n), i.updateOffset(this, e), this) : xt(this, t);
        };
      }

      function xt(t, e) {
        return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN;
      }

      function wt(t, e, n) {
        t.isValid() && !isNaN(n) && ("FullYear" === e && mt(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](n, t.month(), kt(n, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](n));
      }

      function kt(t, e) {
        if (isNaN(t) || isNaN(e)) return NaN;
        var n = (e % 12 + 12) % 12;
        return t += (e - n) / 12, 1 === n ? mt(t) ? 29 : 28 : 31 - n % 7 % 2;
      }

      vt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
        var e;

        for (e = 0; e < this.length; ++e) {
          if (this[e] === t) return e;
        }

        return -1;
      }, H("M", ["MM", 2], "Mo", function () {
        return this.month() + 1;
      }), H("MMM", 0, 0, function (t) {
        return this.localeData().monthsShort(this, t);
      }), H("MMMM", 0, 0, function (t) {
        return this.localeData().months(this, t);
      }), L("month", "M"), P("month", 8), lt("M", K), lt("MM", K, G), lt("MMM", function (t, e) {
        return e.monthsShortRegex(t);
      }), lt("MMMM", function (t, e) {
        return e.monthsRegex(t);
      }), pt(["M", "MM"], function (t, e) {
        e[1] = k(t) - 1;
      }), pt(["MMM", "MMMM"], function (t, e, n, r) {
        var i = n._locale.monthsParse(t, r, n._strict);

        null != i ? e[1] = i : p(n).invalidMonth = t;
      });
      var Tt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
          Et = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          Ct = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

      function St(t, e) {
        var n;
        if (!t.isValid()) return t;
        if ("string" == typeof e) if (/^\d+$/.test(e)) e = k(e);else if (!c(e = t.localeData().monthsParse(e))) return t;
        return n = Math.min(t.date(), kt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, n), t;
      }

      function At(t) {
        return null != t ? (St(this, t), i.updateOffset(this, !0), this) : xt(this, "Month");
      }

      var Mt = ct,
          Nt = ct;

      function Dt() {
        function t(t, e) {
          return e.length - t.length;
        }

        var e,
            n,
            r = [],
            i = [],
            a = [];

        for (e = 0; e < 12; e++) {
          n = d([2e3, e]), r.push(this.monthsShort(n, "")), i.push(this.months(n, "")), a.push(this.months(n, "")), a.push(this.monthsShort(n, ""));
        }

        for (r.sort(t), i.sort(t), a.sort(t), e = 0; e < 12; e++) {
          r[e] = ft(r[e]), i[e] = ft(i[e]);
        }

        for (e = 0; e < 24; e++) {
          a[e] = ft(a[e]);
        }

        this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
      }

      function Ot(t) {
        var e;

        if (t < 100 && 0 <= t) {
          var n = Array.prototype.slice.call(arguments);
          n[0] = t + 400, e = new Date(Date.UTC.apply(null, n)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t);
        } else e = new Date(Date.UTC.apply(null, arguments));

        return e;
      }

      function Bt(t, e, n) {
        var r = 7 + e - n;
        return -(7 + Ot(t, 0, r).getUTCDay() - e) % 7 + r - 1;
      }

      function Lt(t, e, n, r, i) {
        var a,
            o,
            s = 1 + 7 * (e - 1) + (7 + n - r) % 7 + Bt(t, r, i);
        return o = s <= 0 ? gt(a = t - 1) + s : s > gt(t) ? (a = t + 1, s - gt(t)) : (a = t, s), {
          year: a,
          dayOfYear: o
        };
      }

      function It(t, e, n) {
        var r,
            i,
            a = Bt(t.year(), e, n),
            o = Math.floor((t.dayOfYear() - a - 1) / 7) + 1;
        return o < 1 ? r = o + Rt(i = t.year() - 1, e, n) : o > Rt(t.year(), e, n) ? (r = o - Rt(t.year(), e, n), i = t.year() + 1) : (i = t.year(), r = o), {
          week: r,
          year: i
        };
      }

      function Rt(t, e, n) {
        var r = Bt(t, e, n),
            i = Bt(t + 1, e, n);
        return (gt(t) - r + i) / 7;
      }

      function Ft(t, e) {
        return t.slice(e, 7).concat(t.slice(0, e));
      }

      H("w", ["ww", 2], "wo", "week"), H("W", ["WW", 2], "Wo", "isoWeek"), L("week", "w"), L("isoWeek", "W"), P("week", 5), P("isoWeek", 5), lt("w", K), lt("ww", K, G), lt("W", K), lt("WW", K, G), yt(["w", "ww", "W", "WW"], function (t, e, n, r) {
        e[r.substr(0, 1)] = k(t);
      }), H("d", 0, "do", "day"), H("dd", 0, 0, function (t) {
        return this.localeData().weekdaysMin(this, t);
      }), H("ddd", 0, 0, function (t) {
        return this.localeData().weekdaysShort(this, t);
      }), H("dddd", 0, 0, function (t) {
        return this.localeData().weekdays(this, t);
      }), H("e", 0, 0, "weekday"), H("E", 0, 0, "isoWeekday"), L("day", "d"), L("weekday", "e"), L("isoWeekday", "E"), P("day", 11), P("weekday", 11), P("isoWeekday", 11), lt("d", K), lt("e", K), lt("E", K), lt("dd", function (t, e) {
        return e.weekdaysMinRegex(t);
      }), lt("ddd", function (t, e) {
        return e.weekdaysShortRegex(t);
      }), lt("dddd", function (t, e) {
        return e.weekdaysRegex(t);
      }), yt(["dd", "ddd", "dddd"], function (t, e, n, r) {
        var i = n._locale.weekdaysParse(t, r, n._strict);

        null != i ? e.d = i : p(n).invalidWeekday = t;
      }), yt(["d", "e", "E"], function (t, e, n, r) {
        e[r] = k(t);
      });
      var Pt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          jt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          Yt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          zt = ct,
          Ut = ct,
          qt = ct;

      function Ht() {
        function t(t, e) {
          return e.length - t.length;
        }

        var e,
            n,
            r,
            i,
            a,
            o = [],
            s = [],
            c = [],
            u = [];

        for (e = 0; e < 7; e++) {
          n = d([2e3, 1]).day(e), r = this.weekdaysMin(n, ""), i = this.weekdaysShort(n, ""), a = this.weekdays(n, ""), o.push(r), s.push(i), c.push(a), u.push(r), u.push(i), u.push(a);
        }

        for (o.sort(t), s.sort(t), c.sort(t), u.sort(t), e = 0; e < 7; e++) {
          s[e] = ft(s[e]), c[e] = ft(c[e]), u[e] = ft(u[e]);
        }

        this._weekdaysRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
      }

      function $t() {
        return this.hours() % 12 || 12;
      }

      function Wt(t, e) {
        H(t, 0, 0, function () {
          return this.localeData().meridiem(this.hours(), this.minutes(), e);
        });
      }

      function Vt(t, e) {
        return e._meridiemParse;
      }

      H("H", ["HH", 2], 0, "hour"), H("h", ["hh", 2], 0, $t), H("k", ["kk", 2], 0, function () {
        return this.hours() || 24;
      }), H("hmm", 0, 0, function () {
        return "" + $t.apply(this) + j(this.minutes(), 2);
      }), H("hmmss", 0, 0, function () {
        return "" + $t.apply(this) + j(this.minutes(), 2) + j(this.seconds(), 2);
      }), H("Hmm", 0, 0, function () {
        return "" + this.hours() + j(this.minutes(), 2);
      }), H("Hmmss", 0, 0, function () {
        return "" + this.hours() + j(this.minutes(), 2) + j(this.seconds(), 2);
      }), Wt("a", !0), Wt("A", !1), L("hour", "h"), P("hour", 13), lt("a", Vt), lt("A", Vt), lt("H", K), lt("h", K), lt("k", K), lt("HH", K, G), lt("hh", K, G), lt("kk", K, G), lt("hmm", J), lt("hmmss", tt), lt("Hmm", J), lt("Hmmss", tt), pt(["H", "HH"], 3), pt(["k", "kk"], function (t, e, n) {
        var r = k(t);
        e[3] = 24 === r ? 0 : r;
      }), pt(["a", "A"], function (t, e, n) {
        n._isPm = n._locale.isPM(t), n._meridiem = t;
      }), pt(["h", "hh"], function (t, e, n) {
        e[3] = k(t), p(n).bigHour = !0;
      }), pt("hmm", function (t, e, n) {
        var r = t.length - 2;
        e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r)), p(n).bigHour = !0;
      }), pt("hmmss", function (t, e, n) {
        var r = t.length - 4,
            i = t.length - 2;
        e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r, 2)), e[5] = k(t.substr(i)), p(n).bigHour = !0;
      }), pt("Hmm", function (t, e, n) {
        var r = t.length - 2;
        e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r));
      }), pt("Hmmss", function (t, e, n) {
        var r = t.length - 4,
            i = t.length - 2;
        e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r, 2)), e[5] = k(t.substr(i));
      });

      var Gt,
          Xt = _t("Hours", !0),
          Zt = {
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        longDateFormat: {
          LTS: "h:mm:ss A",
          LT: "h:mm A",
          L: "MM/DD/YYYY",
          LL: "MMMM D, YYYY",
          LLL: "MMMM D, YYYY h:mm A",
          LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        invalidDate: "Invalid date",
        ordinal: "%d",
        dayOfMonthOrdinalParse: /\d{1,2}/,
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        months: Et,
        monthsShort: Ct,
        week: {
          dow: 0,
          doy: 6
        },
        weekdays: Pt,
        weekdaysMin: Yt,
        weekdaysShort: jt,
        meridiemParse: /[ap]\.?m?\.?/i
      },
          Qt = {},
          Kt = {};

      function Jt(t) {
        return t ? t.toLowerCase().replace("_", "-") : t;
      }

      function te(e) {
        var r = null;
        if (!Qt[e] && t && t.exports) try {
          r = Gt._abbr, n(1748)("./" + e), ee(r);
        } catch (e) {}
        return Qt[e];
      }

      function ee(t, e) {
        var n;
        return t && ((n = s(e) ? re(t) : ne(t, e)) ? Gt = n : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), Gt._abbr;
      }

      function ne(t, e) {
        if (null === e) return delete Qt[t], null;
        var n,
            r = Zt;
        if (e.abbr = t, null != Qt[t]) M("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = Qt[t]._config;else if (null != e.parentLocale) if (null != Qt[e.parentLocale]) r = Qt[e.parentLocale]._config;else {
          if (null == (n = te(e.parentLocale))) return Kt[e.parentLocale] || (Kt[e.parentLocale] = []), Kt[e.parentLocale].push({
            name: t,
            config: e
          }), null;
          r = n._config;
        }
        return Qt[t] = new O(D(r, e)), Kt[t] && Kt[t].forEach(function (t) {
          ne(t.name, t.config);
        }), ee(t), Qt[t];
      }

      function re(t) {
        var e;
        if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return Gt;

        if (!a(t)) {
          if (e = te(t)) return e;
          t = [t];
        }

        return function (t) {
          for (var e, n, r, i, a = 0; a < t.length;) {
            for (e = (i = Jt(t[a]).split("-")).length, n = (n = Jt(t[a + 1])) ? n.split("-") : null; 0 < e;) {
              if (r = te(i.slice(0, e).join("-"))) return r;
              if (n && n.length >= e && T(i, n, !0) >= e - 1) break;
              e--;
            }

            a++;
          }

          return Gt;
        }(t);
      }

      function ie(t) {
        var e,
            n = t._a;
        return n && -2 === p(t).overflow && (e = n[1] < 0 || 11 < n[1] ? 1 : n[2] < 1 || n[2] > kt(n[0], n[1]) ? 2 : n[3] < 0 || 24 < n[3] || 24 === n[3] && (0 !== n[4] || 0 !== n[5] || 0 !== n[6]) ? 3 : n[4] < 0 || 59 < n[4] ? 4 : n[5] < 0 || 59 < n[5] ? 5 : n[6] < 0 || 999 < n[6] ? 6 : -1, p(t)._overflowDayOfYear && (e < 0 || 2 < e) && (e = 2), p(t)._overflowWeeks && -1 === e && (e = 7), p(t)._overflowWeekday && -1 === e && (e = 8), p(t).overflow = e), t;
      }

      function ae(t, e, n) {
        return null != t ? t : null != e ? e : n;
      }

      function oe(t) {
        var e,
            n,
            r,
            a,
            o,
            s = [];

        if (!t._d) {
          var c, u;

          for (c = t, u = new Date(i.now()), r = c._useUTC ? [u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()] : [u.getFullYear(), u.getMonth(), u.getDate()], t._w && null == t._a[2] && null == t._a[1] && function (t) {
            var e, n, r, i, a, o, s, c;
            if (null != (e = t._w).GG || null != e.W || null != e.E) a = 1, o = 4, n = ae(e.GG, t._a[0], It(_e(), 1, 4).year), r = ae(e.W, 1), ((i = ae(e.E, 1)) < 1 || 7 < i) && (c = !0);else {
              a = t._locale._week.dow, o = t._locale._week.doy;
              var u = It(_e(), a, o);
              n = ae(e.gg, t._a[0], u.year), r = ae(e.w, u.week), null != e.d ? ((i = e.d) < 0 || 6 < i) && (c = !0) : null != e.e ? (i = e.e + a, (e.e < 0 || 6 < e.e) && (c = !0)) : i = a;
            }
            r < 1 || r > Rt(n, a, o) ? p(t)._overflowWeeks = !0 : null != c ? p(t)._overflowWeekday = !0 : (s = Lt(n, r, i, a, o), t._a[0] = s.year, t._dayOfYear = s.dayOfYear);
          }(t), null != t._dayOfYear && (o = ae(t._a[0], r[0]), (t._dayOfYear > gt(o) || 0 === t._dayOfYear) && (p(t)._overflowDayOfYear = !0), n = Ot(o, 0, t._dayOfYear), t._a[1] = n.getUTCMonth(), t._a[2] = n.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) {
            t._a[e] = s[e] = r[e];
          }

          for (; e < 7; e++) {
            t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
          }

          24 === t._a[3] && 0 === t._a[4] && 0 === t._a[5] && 0 === t._a[6] && (t._nextDay = !0, t._a[3] = 0), t._d = (t._useUTC ? Ot : function (t, e, n, r, i, a, o) {
            var s;
            return t < 100 && 0 <= t ? (s = new Date(t + 400, e, n, r, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(t)) : s = new Date(t, e, n, r, i, a, o), s;
          }).apply(null, s), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[3] = 24), t._w && void 0 !== t._w.d && t._w.d !== a && (p(t).weekdayMismatch = !0);
        }
      }

      var se = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          ce = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          ue = /Z|[+-]\d\d(?::?\d\d)?/,
          le = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
          he = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
          fe = /^\/?Date\((\-?\d+)/i;

      function de(t) {
        var e,
            n,
            r,
            i,
            a,
            o,
            s = t._i,
            c = se.exec(s) || ce.exec(s);

        if (c) {
          for (p(t).iso = !0, e = 0, n = le.length; e < n; e++) {
            if (le[e][1].exec(c[1])) {
              i = le[e][0], r = !1 !== le[e][2];
              break;
            }
          }

          if (null == i) return void (t._isValid = !1);

          if (c[3]) {
            for (e = 0, n = he.length; e < n; e++) {
              if (he[e][1].exec(c[3])) {
                a = (c[2] || " ") + he[e][0];
                break;
              }
            }

            if (null == a) return void (t._isValid = !1);
          }

          if (!r && null != a) return void (t._isValid = !1);

          if (c[4]) {
            if (!ue.exec(c[4])) return void (t._isValid = !1);
            o = "Z";
          }

          t._f = i + (a || "") + (o || ""), me(t);
        } else t._isValid = !1;
      }

      var pe = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
      var ye = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
      };

      function ge(t) {
        var e,
            n,
            r,
            i = pe.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));

        if (i) {
          var a = function (t, e, n, r, i, a) {
            var o = [function (t) {
              var e = parseInt(t, 10);
              return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
            }(t), Ct.indexOf(e), parseInt(n, 10), parseInt(r, 10), parseInt(i, 10)];
            return a && o.push(parseInt(a, 10)), o;
          }(i[4], i[3], i[2], i[5], i[6], i[7]);

          if (n = a, r = t, (e = i[1]) && jt.indexOf(e) !== new Date(n[0], n[1], n[2]).getDay() && (p(r).weekdayMismatch = !0, !(r._isValid = !1))) return;
          t._a = a, t._tzm = function (t, e, n) {
            if (t) return ye[t];
            if (e) return 0;
            var r = parseInt(n, 10),
                i = r % 100;
            return (r - i) / 100 * 60 + i;
          }(i[8], i[9], i[10]), t._d = Ot.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), p(t).rfc2822 = !0;
        } else t._isValid = !1;
      }

      function me(t) {
        if (t._f !== i.ISO_8601) {
          if (t._f !== i.RFC_2822) {
            t._a = [], p(t).empty = !0;
            var e,
                n,
                r,
                a,
                o,
                s,
                c,
                u,
                l = "" + t._i,
                f = l.length,
                d = 0;

            for (r = W(t._f, t._locale).match(Y) || [], e = 0; e < r.length; e++) {
              a = r[e], (n = (l.match(ht(a, t)) || [])[0]) && (0 < (o = l.substr(0, l.indexOf(n))).length && p(t).unusedInput.push(o), l = l.slice(l.indexOf(n) + n.length), d += n.length), q[a] ? (n ? p(t).empty = !1 : p(t).unusedTokens.push(a), s = a, u = t, null != (c = n) && h(dt, s) && dt[s](c, u._a, u, s)) : t._strict && !n && p(t).unusedTokens.push(a);
            }

            p(t).charsLeftOver = f - d, 0 < l.length && p(t).unusedInput.push(l), t._a[3] <= 12 && !0 === p(t).bigHour && 0 < t._a[3] && (p(t).bigHour = void 0), p(t).parsedDateParts = t._a.slice(0), p(t).meridiem = t._meridiem, t._a[3] = function (t, e, n) {
              var r;
              return null == n ? e : null != t.meridiemHour ? t.meridiemHour(e, n) : (null != t.isPM && ((r = t.isPM(n)) && e < 12 && (e += 12), r || 12 !== e || (e = 0)), e);
            }(t._locale, t._a[3], t._meridiem), oe(t), ie(t);
          } else ge(t);
        } else de(t);
      }

      function ve(t) {
        var e,
            n,
            r,
            h,
            d = t._i,
            m = t._f;
        return t._locale = t._locale || re(t._l), null === d || void 0 === m && "" === d ? g({
          nullInput: !0
        }) : ("string" == typeof d && (t._i = d = t._locale.preparse(d)), x(d) ? new _(ie(d)) : (u(d) ? t._d = d : a(m) ? function (t) {
          var e, n, r, i, a;
          if (0 === t._f.length) return p(t).invalidFormat = !0, t._d = new Date(NaN);

          for (i = 0; i < t._f.length; i++) {
            a = 0, e = v({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[i], me(e), y(e) && (a += p(e).charsLeftOver, a += 10 * p(e).unusedTokens.length, p(e).score = a, (null == r || a < r) && (r = a, n = e));
          }

          f(t, n || e);
        }(t) : m ? me(t) : s(n = (e = t)._i) ? e._d = new Date(i.now()) : u(n) ? e._d = new Date(n.valueOf()) : "string" == typeof n ? (r = e, null === (h = fe.exec(r._i)) ? (de(r), !1 === r._isValid && (delete r._isValid, ge(r), !1 === r._isValid && (delete r._isValid, i.createFromInputFallback(r)))) : r._d = new Date(+h[1])) : a(n) ? (e._a = l(n.slice(0), function (t) {
          return parseInt(t, 10);
        }), oe(e)) : o(n) ? function (t) {
          if (!t._d) {
            var e = R(t._i);
            t._a = l([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function (t) {
              return t && parseInt(t, 10);
            }), oe(t);
          }
        }(e) : c(n) ? e._d = new Date(n) : i.createFromInputFallback(e), y(t) || (t._d = null), t));
      }

      function be(t, e, n, r, i) {
        var s,
            c = {};
        return !0 !== n && !1 !== n || (r = n, n = void 0), (o(t) && function (t) {
          if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
          var e;

          for (e in t) {
            if (t.hasOwnProperty(e)) return !1;
          }

          return !0;
        }(t) || a(t) && 0 === t.length) && (t = void 0), c._isAMomentObject = !0, c._useUTC = c._isUTC = i, c._l = n, c._i = t, c._f = e, c._strict = r, (s = new _(ie(ve(c))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
      }

      function _e(t, e, n, r) {
        return be(t, e, n, r, !1);
      }

      i.createFromInputFallback = C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (t) {
        t._d = new Date(t._i + (t._useUTC ? " UTC" : ""));
      }), i.ISO_8601 = function () {}, i.RFC_2822 = function () {};
      var xe = C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var t = _e.apply(null, arguments);

        return this.isValid() && t.isValid() ? t < this ? this : t : g();
      }),
          we = C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var t = _e.apply(null, arguments);

        return this.isValid() && t.isValid() ? this < t ? this : t : g();
      });

      function ke(t, e) {
        var n, r;
        if (1 === e.length && a(e[0]) && (e = e[0]), !e.length) return _e();

        for (n = e[0], r = 1; r < e.length; ++r) {
          e[r].isValid() && !e[r][t](n) || (n = e[r]);
        }

        return n;
      }

      var Te = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

      function Ee(t) {
        var e = R(t),
            n = e.year || 0,
            r = e.quarter || 0,
            i = e.month || 0,
            a = e.week || e.isoWeek || 0,
            o = e.day || 0,
            s = e.hour || 0,
            c = e.minute || 0,
            u = e.second || 0,
            l = e.millisecond || 0;
        this._isValid = function (t) {
          for (var e in t) {
            if (-1 === vt.call(Te, e) || null != t[e] && isNaN(t[e])) return !1;
          }

          for (var n = !1, r = 0; r < Te.length; ++r) {
            if (t[Te[r]]) {
              if (n) return !1;
              parseFloat(t[Te[r]]) !== k(t[Te[r]]) && (n = !0);
            }
          }

          return !0;
        }(e), this._milliseconds = +l + 1e3 * u + 6e4 * c + 1e3 * s * 60 * 60, this._days = +o + 7 * a, this._months = +i + 3 * r + 12 * n, this._data = {}, this._locale = re(), this._bubble();
      }

      function Ce(t) {
        return t instanceof Ee;
      }

      function Se(t) {
        return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t);
      }

      function Ae(t, e) {
        H(t, 0, 0, function () {
          var t = this.utcOffset(),
              n = "+";
          return t < 0 && (t = -t, n = "-"), n + j(~~(t / 60), 2) + e + j(~~t % 60, 2);
        });
      }

      Ae("Z", ":"), Ae("ZZ", ""), lt("Z", st), lt("ZZ", st), pt(["Z", "ZZ"], function (t, e, n) {
        n._useUTC = !0, n._tzm = Ne(st, t);
      });
      var Me = /([\+\-]|\d\d)/gi;

      function Ne(t, e) {
        var n = (e || "").match(t);
        if (null === n) return null;
        var r = ((n[n.length - 1] || []) + "").match(Me) || ["-", 0, 0],
            i = 60 * r[1] + k(r[2]);
        return 0 === i ? 0 : "+" === r[0] ? i : -i;
      }

      function De(t, e) {
        var n, r;
        return e._isUTC ? (n = e.clone(), r = (x(t) || u(t) ? t.valueOf() : _e(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), i.updateOffset(n, !1), n) : _e(t).local();
      }

      function Oe(t) {
        return 15 * -Math.round(t._d.getTimezoneOffset() / 15);
      }

      function Be() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
      }

      i.updateOffset = function () {};

      var Le = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
          Ie = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

      function Re(t, e) {
        var n,
            r,
            i,
            a = t,
            o = null;
        return Ce(t) ? a = {
          ms: t._milliseconds,
          d: t._days,
          M: t._months
        } : c(t) ? (a = {}, e ? a[e] = t : a.milliseconds = t) : (o = Le.exec(t)) ? (n = "-" === o[1] ? -1 : 1, a = {
          y: 0,
          d: k(o[2]) * n,
          h: k(o[3]) * n,
          m: k(o[4]) * n,
          s: k(o[5]) * n,
          ms: k(Se(1e3 * o[6])) * n
        }) : (o = Ie.exec(t)) ? (n = "-" === o[1] ? -1 : 1, a = {
          y: Fe(o[2], n),
          M: Fe(o[3], n),
          w: Fe(o[4], n),
          d: Fe(o[5], n),
          h: Fe(o[6], n),
          m: Fe(o[7], n),
          s: Fe(o[8], n)
        }) : null == a ? a = {} : "object" == _typeof(a) && ("from" in a || "to" in a) && (i = function (t, e) {
          var n;
          return t.isValid() && e.isValid() ? (e = De(e, t), t.isBefore(e) ? n = Pe(t, e) : ((n = Pe(e, t)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
            milliseconds: 0,
            months: 0
          };
        }(_e(a.from), _e(a.to)), (a = {}).ms = i.milliseconds, a.M = i.months), r = new Ee(a), Ce(t) && h(t, "_locale") && (r._locale = t._locale), r;
      }

      function Fe(t, e) {
        var n = t && parseFloat(t.replace(",", "."));
        return (isNaN(n) ? 0 : n) * e;
      }

      function Pe(t, e) {
        var n = {};
        return n.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(n.months, "M").isAfter(e) && --n.months, n.milliseconds = +e - +t.clone().add(n.months, "M"), n;
      }

      function je(t, e) {
        return function (n, r) {
          var i;
          return null === r || isNaN(+r) || (M(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = n, n = r, r = i), Ye(this, Re(n = "string" == typeof n ? +n : n, r), t), this;
        };
      }

      function Ye(t, e, n, r) {
        var a = e._milliseconds,
            o = Se(e._days),
            s = Se(e._months);
        t.isValid() && (r = null == r || r, s && St(t, xt(t, "Month") + s * n), o && wt(t, "Date", xt(t, "Date") + o * n), a && t._d.setTime(t._d.valueOf() + a * n), r && i.updateOffset(t, o || s));
      }

      Re.fn = Ee.prototype, Re.invalid = function () {
        return Re(NaN);
      };
      var ze = je(1, "add"),
          Ue = je(-1, "subtract");

      function qe(t, e) {
        var n = 12 * (e.year() - t.year()) + (e.month() - t.month()),
            r = t.clone().add(n, "months");
        return -(n + (e - r < 0 ? (e - r) / (r - t.clone().add(n - 1, "months")) : (e - r) / (t.clone().add(n + 1, "months") - r))) || 0;
      }

      function He(t) {
        var e;
        return void 0 === t ? this._locale._abbr : (null != (e = re(t)) && (this._locale = e), this);
      }

      i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      var $e = C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (t) {
        return void 0 === t ? this.localeData() : this.locale(t);
      });

      function We() {
        return this._locale;
      }

      var Ve = 126227808e5;

      function Ge(t, e) {
        return (t % e + e) % e;
      }

      function Xe(t, e, n) {
        return t < 100 && 0 <= t ? new Date(t + 400, e, n) - Ve : new Date(t, e, n).valueOf();
      }

      function Ze(t, e, n) {
        return t < 100 && 0 <= t ? Date.UTC(t + 400, e, n) - Ve : Date.UTC(t, e, n);
      }

      function Qe(t, e) {
        H(0, [t, t.length], 0, e);
      }

      function Ke(t, e, n, r, i) {
        var a;
        return null == t ? It(this, r, i).year : ((a = Rt(t, r, i)) < e && (e = a), function (t, e, n, r, i) {
          var a = Lt(t, e, n, r, i),
              o = Ot(a.year, 0, a.dayOfYear);
          return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
        }.call(this, t, e, n, r, i));
      }

      H(0, ["gg", 2], 0, function () {
        return this.weekYear() % 100;
      }), H(0, ["GG", 2], 0, function () {
        return this.isoWeekYear() % 100;
      }), Qe("gggg", "weekYear"), Qe("ggggg", "weekYear"), Qe("GGGG", "isoWeekYear"), Qe("GGGGG", "isoWeekYear"), L("weekYear", "gg"), L("isoWeekYear", "GG"), P("weekYear", 1), P("isoWeekYear", 1), lt("G", at), lt("g", at), lt("GG", K, G), lt("gg", K, G), lt("GGGG", nt, Z), lt("gggg", nt, Z), lt("GGGGG", rt, Q), lt("ggggg", rt, Q), yt(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, n, r) {
        e[r.substr(0, 2)] = k(t);
      }), yt(["gg", "GG"], function (t, e, n, r) {
        e[r] = i.parseTwoDigitYear(t);
      }), H("Q", 0, "Qo", "quarter"), L("quarter", "Q"), P("quarter", 7), lt("Q", V), pt("Q", function (t, e) {
        e[1] = 3 * (k(t) - 1);
      }), H("D", ["DD", 2], "Do", "date"), L("date", "D"), P("date", 9), lt("D", K), lt("DD", K, G), lt("Do", function (t, e) {
        return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
      }), pt(["D", "DD"], 2), pt("Do", function (t, e) {
        e[2] = k(t.match(K)[0]);
      });

      var Je = _t("Date", !0);

      H("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), L("dayOfYear", "DDD"), P("dayOfYear", 4), lt("DDD", et), lt("DDDD", X), pt(["DDD", "DDDD"], function (t, e, n) {
        n._dayOfYear = k(t);
      }), H("m", ["mm", 2], 0, "minute"), L("minute", "m"), P("minute", 14), lt("m", K), lt("mm", K, G), pt(["m", "mm"], 4);

      var tn = _t("Minutes", !1);

      H("s", ["ss", 2], 0, "second"), L("second", "s"), P("second", 15), lt("s", K), lt("ss", K, G), pt(["s", "ss"], 5);

      var en,
          nn = _t("Seconds", !1);

      for (H("S", 0, 0, function () {
        return ~~(this.millisecond() / 100);
      }), H(0, ["SS", 2], 0, function () {
        return ~~(this.millisecond() / 10);
      }), H(0, ["SSS", 3], 0, "millisecond"), H(0, ["SSSS", 4], 0, function () {
        return 10 * this.millisecond();
      }), H(0, ["SSSSS", 5], 0, function () {
        return 100 * this.millisecond();
      }), H(0, ["SSSSSS", 6], 0, function () {
        return 1e3 * this.millisecond();
      }), H(0, ["SSSSSSS", 7], 0, function () {
        return 1e4 * this.millisecond();
      }), H(0, ["SSSSSSSS", 8], 0, function () {
        return 1e5 * this.millisecond();
      }), H(0, ["SSSSSSSSS", 9], 0, function () {
        return 1e6 * this.millisecond();
      }), L("millisecond", "ms"), P("millisecond", 16), lt("S", et, V), lt("SS", et, G), lt("SSS", et, X), en = "SSSS"; en.length <= 9; en += "S") {
        lt(en, it);
      }

      function rn(t, e) {
        e[6] = k(1e3 * ("0." + t));
      }

      for (en = "S"; en.length <= 9; en += "S") {
        pt(en, rn);
      }

      var an = _t("Milliseconds", !1);

      H("z", 0, 0, "zoneAbbr"), H("zz", 0, 0, "zoneName");
      var on = _.prototype;

      function sn(t) {
        return t;
      }

      on.add = ze, on.calendar = function (t, e) {
        var n = t || _e(),
            r = De(n, this).startOf("day"),
            a = i.calendarFormat(this, r) || "sameElse",
            o = e && (N(e[a]) ? e[a].call(this, n) : e[a]);

        return this.format(o || this.localeData().calendar(a, this, _e(n)));
      }, on.clone = function () {
        return new _(this);
      }, on.diff = function (t, e, n) {
        var r, i, a;
        if (!this.isValid()) return NaN;
        if (!(r = De(t, this)).isValid()) return NaN;

        switch (i = 6e4 * (r.utcOffset() - this.utcOffset()), e = I(e)) {
          case "year":
            a = qe(this, r) / 12;
            break;

          case "month":
            a = qe(this, r);
            break;

          case "quarter":
            a = qe(this, r) / 3;
            break;

          case "second":
            a = (this - r) / 1e3;
            break;

          case "minute":
            a = (this - r) / 6e4;
            break;

          case "hour":
            a = (this - r) / 36e5;
            break;

          case "day":
            a = (this - r - i) / 864e5;
            break;

          case "week":
            a = (this - r - i) / 6048e5;
            break;

          default:
            a = this - r;
        }

        return n ? a : w(a);
      }, on.endOf = function (t) {
        var e;
        if (void 0 === (t = I(t)) || "millisecond" === t || !this.isValid()) return this;
        var n = this._isUTC ? Ze : Xe;

        switch (t) {
          case "year":
            e = n(this.year() + 1, 0, 1) - 1;
            break;

          case "quarter":
            e = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
            break;

          case "month":
            e = n(this.year(), this.month() + 1, 1) - 1;
            break;

          case "week":
            e = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
            break;

          case "isoWeek":
            e = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
            break;

          case "day":
          case "date":
            e = n(this.year(), this.month(), this.date() + 1) - 1;
            break;

          case "hour":
            e = this._d.valueOf(), e += 36e5 - Ge(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
            break;

          case "minute":
            e = this._d.valueOf(), e += 6e4 - Ge(e, 6e4) - 1;
            break;

          case "second":
            e = this._d.valueOf(), e += 1e3 - Ge(e, 1e3) - 1;
        }

        return this._d.setTime(e), i.updateOffset(this, !0), this;
      }, on.format = function (t) {
        t || (t = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
        var e = $(this, t);
        return this.localeData().postformat(e);
      }, on.from = function (t, e) {
        return this.isValid() && (x(t) && t.isValid() || _e(t).isValid()) ? Re({
          to: this,
          from: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
      }, on.fromNow = function (t) {
        return this.from(_e(), t);
      }, on.to = function (t, e) {
        return this.isValid() && (x(t) && t.isValid() || _e(t).isValid()) ? Re({
          from: this,
          to: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
      }, on.toNow = function (t) {
        return this.to(_e(), t);
      }, on.get = function (t) {
        return N(this[t = I(t)]) ? this[t]() : this;
      }, on.invalidAt = function () {
        return p(this).overflow;
      }, on.isAfter = function (t, e) {
        var n = x(t) ? t : _e(t);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(e).valueOf());
      }, on.isBefore = function (t, e) {
        var n = x(t) ? t : _e(t);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(e).valueOf() < n.valueOf());
      }, on.isBetween = function (t, e, n, r) {
        var i = x(t) ? t : _e(t),
            a = x(e) ? e : _e(e);
        return !!(this.isValid() && i.isValid() && a.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === r[1] ? this.isBefore(a, n) : !this.isAfter(a, n));
      }, on.isSame = function (t, e) {
        var n,
            r = x(t) ? t : _e(t);
        return !(!this.isValid() || !r.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(e).valueOf() <= n && n <= this.clone().endOf(e).valueOf()));
      }, on.isSameOrAfter = function (t, e) {
        return this.isSame(t, e) || this.isAfter(t, e);
      }, on.isSameOrBefore = function (t, e) {
        return this.isSame(t, e) || this.isBefore(t, e);
      }, on.isValid = function () {
        return y(this);
      }, on.lang = $e, on.locale = He, on.localeData = We, on.max = we, on.min = xe, on.parsingFlags = function () {
        return f({}, p(this));
      }, on.set = function (t, e) {
        if ("object" == _typeof(t)) for (var n = function (t) {
          var e = [];

          for (var n in t) {
            e.push({
              unit: n,
              priority: F[n]
            });
          }

          return e.sort(function (t, e) {
            return t.priority - e.priority;
          }), e;
        }(t = R(t)), r = 0; r < n.length; r++) {
          this[n[r].unit](t[n[r].unit]);
        } else if (N(this[t = I(t)])) return this[t](e);
        return this;
      }, on.startOf = function (t) {
        var e;
        if (void 0 === (t = I(t)) || "millisecond" === t || !this.isValid()) return this;
        var n = this._isUTC ? Ze : Xe;

        switch (t) {
          case "year":
            e = n(this.year(), 0, 1);
            break;

          case "quarter":
            e = n(this.year(), this.month() - this.month() % 3, 1);
            break;

          case "month":
            e = n(this.year(), this.month(), 1);
            break;

          case "week":
            e = n(this.year(), this.month(), this.date() - this.weekday());
            break;

          case "isoWeek":
            e = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
            break;

          case "day":
          case "date":
            e = n(this.year(), this.month(), this.date());
            break;

          case "hour":
            e = this._d.valueOf(), e -= Ge(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
            break;

          case "minute":
            e = this._d.valueOf(), e -= Ge(e, 6e4);
            break;

          case "second":
            e = this._d.valueOf(), e -= Ge(e, 1e3);
        }

        return this._d.setTime(e), i.updateOffset(this, !0), this;
      }, on.subtract = Ue, on.toArray = function () {
        var t = this;
        return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()];
      }, on.toObject = function () {
        var t = this;
        return {
          years: t.year(),
          months: t.month(),
          date: t.date(),
          hours: t.hours(),
          minutes: t.minutes(),
          seconds: t.seconds(),
          milliseconds: t.milliseconds()
        };
      }, on.toDate = function () {
        return new Date(this.valueOf());
      }, on.toISOString = function (t) {
        if (!this.isValid()) return null;
        var e = !0 !== t,
            n = e ? this.clone().utc() : this;
        return n.year() < 0 || 9999 < n.year() ? $(n, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : N(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", $(n, "Z")) : $(n, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
      }, on.inspect = function () {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var t = "moment",
            e = "";
        this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
        var n = "[" + t + '("]',
            r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
            i = e + '[")]';
        return this.format(n + r + "-MM-DD[T]HH:mm:ss.SSS" + i);
      }, on.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, on.toString = function () {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }, on.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, on.valueOf = function () {
        return this._d.valueOf() - 6e4 * (this._offset || 0);
      }, on.creationData = function () {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }, on.year = bt, on.isLeapYear = function () {
        return mt(this.year());
      }, on.weekYear = function (t) {
        return Ke.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
      }, on.isoWeekYear = function (t) {
        return Ke.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4);
      }, on.quarter = on.quarters = function (t) {
        return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3);
      }, on.month = At, on.daysInMonth = function () {
        return kt(this.year(), this.month());
      }, on.week = on.weeks = function (t) {
        var e = this.localeData().week(this);
        return null == t ? e : this.add(7 * (t - e), "d");
      }, on.isoWeek = on.isoWeeks = function (t) {
        var e = It(this, 1, 4).week;
        return null == t ? e : this.add(7 * (t - e), "d");
      }, on.weeksInYear = function () {
        var t = this.localeData()._week;

        return Rt(this.year(), t.dow, t.doy);
      }, on.isoWeeksInYear = function () {
        return Rt(this.year(), 1, 4);
      }, on.date = Je, on.day = on.days = function (t) {
        if (!this.isValid()) return null != t ? this : NaN;
        var e,
            n,
            r = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != t ? (e = t, n = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = n.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - r, "d")) : r;
      }, on.weekday = function (t) {
        if (!this.isValid()) return null != t ? this : NaN;
        var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == t ? e : this.add(t - e, "d");
      }, on.isoWeekday = function (t) {
        if (!this.isValid()) return null != t ? this : NaN;
        if (null == t) return this.day() || 7;
        var e,
            n,
            r = (e = t, n = this.localeData(), "string" == typeof e ? n.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e);
        return this.day(this.day() % 7 ? r : r - 7);
      }, on.dayOfYear = function (t) {
        var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == t ? e : this.add(t - e, "d");
      }, on.hour = on.hours = Xt, on.minute = on.minutes = tn, on.second = on.seconds = nn, on.millisecond = on.milliseconds = an, on.utcOffset = function (t, e, n) {
        var r,
            a = this._offset || 0;
        if (!this.isValid()) return null != t ? this : NaN;
        if (null == t) return this._isUTC ? a : Oe(this);

        if ("string" == typeof t) {
          if (null === (t = Ne(st, t))) return this;
        } else Math.abs(t) < 16 && !n && (t *= 60);

        return !this._isUTC && e && (r = Oe(this)), this._offset = t, this._isUTC = !0, null != r && this.add(r, "m"), a !== t && (!e || this._changeInProgress ? Ye(this, Re(t - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this;
      }, on.utc = function (t) {
        return this.utcOffset(0, t);
      }, on.local = function (t) {
        return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(Oe(this), "m")), this;
      }, on.parseZone = function () {
        if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
          var t = Ne(ot, this._i);
          null != t ? this.utcOffset(t) : this.utcOffset(0, !0);
        }
        return this;
      }, on.hasAlignedHourOffset = function (t) {
        return !!this.isValid() && (t = t ? _e(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0);
      }, on.isDST = function () {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }, on.isLocal = function () {
        return !!this.isValid() && !this._isUTC;
      }, on.isUtcOffset = function () {
        return !!this.isValid() && this._isUTC;
      }, on.isUtc = Be, on.isUTC = Be, on.zoneAbbr = function () {
        return this._isUTC ? "UTC" : "";
      }, on.zoneName = function () {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }, on.dates = C("dates accessor is deprecated. Use date instead.", Je), on.months = C("months accessor is deprecated. Use month instead", At), on.years = C("years accessor is deprecated. Use year instead", bt), on.zone = C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (t, e) {
        return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
      }), on.isDSTShifted = C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
        if (!s(this._isDSTShifted)) return this._isDSTShifted;
        var t = {};

        if (v(t, this), (t = ve(t))._a) {
          var e = t._isUTC ? d(t._a) : _e(t._a);
          this._isDSTShifted = this.isValid() && 0 < T(t._a, e.toArray());
        } else this._isDSTShifted = !1;

        return this._isDSTShifted;
      });
      var cn = O.prototype;

      function un(t, e, n, r) {
        var i = re(),
            a = d().set(r, e);
        return i[n](a, t);
      }

      function ln(t, e, n) {
        if (c(t) && (e = t, t = void 0), t = t || "", null != e) return un(t, e, n, "month");
        var r,
            i = [];

        for (r = 0; r < 12; r++) {
          i[r] = un(t, r, n, "month");
        }

        return i;
      }

      function hn(t, e, n, r) {
        "boolean" == typeof t ? c(e) && (n = e, e = void 0) : (e = t, t = !1, c(n = e) && (n = e, e = void 0)), e = e || "";
        var i,
            a = re(),
            o = t ? a._week.dow : 0;
        if (null != n) return un(e, (n + o) % 7, r, "day");
        var s = [];

        for (i = 0; i < 7; i++) {
          s[i] = un(e, (i + o) % 7, r, "day");
        }

        return s;
      }

      cn.calendar = function (t, e, n) {
        var r = this._calendar[t] || this._calendar.sameElse;
        return N(r) ? r.call(e, n) : r;
      }, cn.longDateFormat = function (t) {
        var e = this._longDateFormat[t],
            n = this._longDateFormat[t.toUpperCase()];

        return e || !n ? e : (this._longDateFormat[t] = n.replace(/MMMM|MM|DD|dddd/g, function (t) {
          return t.slice(1);
        }), this._longDateFormat[t]);
      }, cn.invalidDate = function () {
        return this._invalidDate;
      }, cn.ordinal = function (t) {
        return this._ordinal.replace("%d", t);
      }, cn.preparse = sn, cn.postformat = sn, cn.relativeTime = function (t, e, n, r) {
        var i = this._relativeTime[n];
        return N(i) ? i(t, e, n, r) : i.replace(/%d/i, t);
      }, cn.pastFuture = function (t, e) {
        var n = this._relativeTime[0 < t ? "future" : "past"];
        return N(n) ? n(e) : n.replace(/%s/i, e);
      }, cn.set = function (t) {
        var e, n;

        for (n in t) {
          N(e = t[n]) ? this[n] = e : this["_" + n] = e;
        }

        this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
      }, cn.months = function (t, e) {
        return t ? a(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Tt).test(e) ? "format" : "standalone"][t.month()] : a(this._months) ? this._months : this._months.standalone;
      }, cn.monthsShort = function (t, e) {
        return t ? a(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Tt.test(e) ? "format" : "standalone"][t.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
      }, cn.monthsParse = function (t, e, n) {
        var r, i, a;
        if (this._monthsParseExact) return function (t, e, n) {
          var r,
              i,
              a,
              o = t.toLocaleLowerCase();
          if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) {
            a = d([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
          }
          return n ? "MMM" === e ? -1 !== (i = vt.call(this._shortMonthsParse, o)) ? i : null : -1 !== (i = vt.call(this._longMonthsParse, o)) ? i : null : "MMM" === e ? -1 !== (i = vt.call(this._shortMonthsParse, o)) || -1 !== (i = vt.call(this._longMonthsParse, o)) ? i : null : -1 !== (i = vt.call(this._longMonthsParse, o)) || -1 !== (i = vt.call(this._shortMonthsParse, o)) ? i : null;
        }.call(this, t, e, n);

        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
          if (i = d([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && "MMMM" === e && this._longMonthsParse[r].test(t)) return r;
          if (n && "MMM" === e && this._shortMonthsParse[r].test(t)) return r;
          if (!n && this._monthsParse[r].test(t)) return r;
        }
      }, cn.monthsRegex = function (t) {
        return this._monthsParseExact ? (h(this, "_monthsRegex") || Dt.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (h(this, "_monthsRegex") || (this._monthsRegex = Nt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
      }, cn.monthsShortRegex = function (t) {
        return this._monthsParseExact ? (h(this, "_monthsRegex") || Dt.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (h(this, "_monthsShortRegex") || (this._monthsShortRegex = Mt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
      }, cn.week = function (t) {
        return It(t, this._week.dow, this._week.doy).week;
      }, cn.firstDayOfYear = function () {
        return this._week.doy;
      }, cn.firstDayOfWeek = function () {
        return this._week.dow;
      }, cn.weekdays = function (t, e) {
        var n = a(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
        return !0 === t ? Ft(n, this._week.dow) : t ? n[t.day()] : n;
      }, cn.weekdaysMin = function (t) {
        return !0 === t ? Ft(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
      }, cn.weekdaysShort = function (t) {
        return !0 === t ? Ft(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
      }, cn.weekdaysParse = function (t, e, n) {
        var r, i, a;
        if (this._weekdaysParseExact) return function (t, e, n) {
          var r,
              i,
              a,
              o = t.toLocaleLowerCase();
          if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) {
            a = d([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
          }
          return n ? "dddd" === e ? -1 !== (i = vt.call(this._weekdaysParse, o)) ? i : null : "ddd" === e ? -1 !== (i = vt.call(this._shortWeekdaysParse, o)) ? i : null : -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : "dddd" === e ? -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._shortWeekdaysParse, o)) || -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : "ddd" === e ? -1 !== (i = vt.call(this._shortWeekdaysParse, o)) || -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : -1 !== (i = vt.call(this._minWeekdaysParse, o)) || -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._shortWeekdaysParse, o)) ? i : null;
        }.call(this, t, e, n);

        for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
          if (i = d([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && "dddd" === e && this._fullWeekdaysParse[r].test(t)) return r;
          if (n && "ddd" === e && this._shortWeekdaysParse[r].test(t)) return r;
          if (n && "dd" === e && this._minWeekdaysParse[r].test(t)) return r;
          if (!n && this._weekdaysParse[r].test(t)) return r;
        }
      }, cn.weekdaysRegex = function (t) {
        return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Ht.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (h(this, "_weekdaysRegex") || (this._weekdaysRegex = zt), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
      }, cn.weekdaysShortRegex = function (t) {
        return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Ht.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (h(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ut), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
      }, cn.weekdaysMinRegex = function (t) {
        return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || Ht.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (h(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = qt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
      }, cn.isPM = function (t) {
        return "p" === (t + "").toLowerCase().charAt(0);
      }, cn.meridiem = function (t, e, n) {
        return 11 < t ? n ? "pm" : "PM" : n ? "am" : "AM";
      }, ee("en", {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(t) {
          var e = t % 10;
          return t + (1 === k(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th");
        }
      }), i.lang = C("moment.lang is deprecated. Use moment.locale instead.", ee), i.langData = C("moment.langData is deprecated. Use moment.localeData instead.", re);
      var fn = Math.abs;

      function dn(t, e, n, r) {
        var i = Re(e, n);
        return t._milliseconds += r * i._milliseconds, t._days += r * i._days, t._months += r * i._months, t._bubble();
      }

      function pn(t) {
        return t < 0 ? Math.floor(t) : Math.ceil(t);
      }

      function yn(t) {
        return 4800 * t / 146097;
      }

      function gn(t) {
        return 146097 * t / 4800;
      }

      function mn(t) {
        return function () {
          return this.as(t);
        };
      }

      var vn = mn("ms"),
          bn = mn("s"),
          _n = mn("m"),
          xn = mn("h"),
          wn = mn("d"),
          kn = mn("w"),
          Tn = mn("M"),
          En = mn("Q"),
          Cn = mn("y");

      function Sn(t) {
        return function () {
          return this.isValid() ? this._data[t] : NaN;
        };
      }

      var An = Sn("milliseconds"),
          Mn = Sn("seconds"),
          Nn = Sn("minutes"),
          Dn = Sn("hours"),
          On = Sn("days"),
          Bn = Sn("months"),
          Ln = Sn("years"),
          In = Math.round,
          Rn = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11
      },
          Fn = Math.abs;

      function Pn(t) {
        return (0 < t) - (t < 0) || +t;
      }

      function jn() {
        if (!this.isValid()) return this.localeData().invalidDate();
        var t,
            e,
            n = Fn(this._milliseconds) / 1e3,
            r = Fn(this._days),
            i = Fn(this._months);
        e = w((t = w(n / 60)) / 60), n %= 60, t %= 60;
        var a = w(i / 12),
            o = i %= 12,
            s = r,
            c = e,
            u = t,
            l = n ? n.toFixed(3).replace(/\.?0+$/, "") : "",
            h = this.asSeconds();
        if (!h) return "P0D";
        var f = h < 0 ? "-" : "",
            d = Pn(this._months) !== Pn(h) ? "-" : "",
            p = Pn(this._days) !== Pn(h) ? "-" : "",
            y = Pn(this._milliseconds) !== Pn(h) ? "-" : "";
        return f + "P" + (a ? d + a + "Y" : "") + (o ? d + o + "M" : "") + (s ? p + s + "D" : "") + (c || u || l ? "T" : "") + (c ? y + c + "H" : "") + (u ? y + u + "M" : "") + (l ? y + l + "S" : "");
      }

      var Yn = Ee.prototype;
      return Yn.isValid = function () {
        return this._isValid;
      }, Yn.abs = function () {
        var t = this._data;
        return this._milliseconds = fn(this._milliseconds), this._days = fn(this._days), this._months = fn(this._months), t.milliseconds = fn(t.milliseconds), t.seconds = fn(t.seconds), t.minutes = fn(t.minutes), t.hours = fn(t.hours), t.months = fn(t.months), t.years = fn(t.years), this;
      }, Yn.add = function (t, e) {
        return dn(this, t, e, 1);
      }, Yn.subtract = function (t, e) {
        return dn(this, t, e, -1);
      }, Yn.as = function (t) {
        if (!this.isValid()) return NaN;
        var e,
            n,
            r = this._milliseconds;
        if ("month" === (t = I(t)) || "quarter" === t || "year" === t) switch (e = this._days + r / 864e5, n = this._months + yn(e), t) {
          case "month":
            return n;

          case "quarter":
            return n / 3;

          case "year":
            return n / 12;
        } else switch (e = this._days + Math.round(gn(this._months)), t) {
          case "week":
            return e / 7 + r / 6048e5;

          case "day":
            return e + r / 864e5;

          case "hour":
            return 24 * e + r / 36e5;

          case "minute":
            return 1440 * e + r / 6e4;

          case "second":
            return 86400 * e + r / 1e3;

          case "millisecond":
            return Math.floor(864e5 * e) + r;

          default:
            throw new Error("Unknown unit " + t);
        }
      }, Yn.asMilliseconds = vn, Yn.asSeconds = bn, Yn.asMinutes = _n, Yn.asHours = xn, Yn.asDays = wn, Yn.asWeeks = kn, Yn.asMonths = Tn, Yn.asQuarters = En, Yn.asYears = Cn, Yn.valueOf = function () {
        return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * k(this._months / 12) : NaN;
      }, Yn._bubble = function () {
        var t,
            e,
            n,
            r,
            i,
            a = this._milliseconds,
            o = this._days,
            s = this._months,
            c = this._data;
        return 0 <= a && 0 <= o && 0 <= s || a <= 0 && o <= 0 && s <= 0 || (a += 864e5 * pn(gn(s) + o), s = o = 0), c.milliseconds = a % 1e3, t = w(a / 1e3), c.seconds = t % 60, e = w(t / 60), c.minutes = e % 60, n = w(e / 60), c.hours = n % 24, s += i = w(yn(o += w(n / 24))), o -= pn(gn(i)), r = w(s / 12), s %= 12, c.days = o, c.months = s, c.years = r, this;
      }, Yn.clone = function () {
        return Re(this);
      }, Yn.get = function (t) {
        return t = I(t), this.isValid() ? this[t + "s"]() : NaN;
      }, Yn.milliseconds = An, Yn.seconds = Mn, Yn.minutes = Nn, Yn.hours = Dn, Yn.days = On, Yn.weeks = function () {
        return w(this.days() / 7);
      }, Yn.months = Bn, Yn.years = Ln, Yn.humanize = function (t) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var e,
            n,
            r,
            i,
            a,
            o,
            s,
            c,
            u,
            l,
            h = this.localeData(),
            f = (e = !t, n = h, r = Re(this).abs(), i = In(r.as("s")), a = In(r.as("m")), o = In(r.as("h")), s = In(r.as("d")), c = In(r.as("M")), u = In(r.as("y")), (l = i <= Rn.ss && ["s", i] || i < Rn.s && ["ss", i] || a <= 1 && ["m"] || a < Rn.m && ["mm", a] || o <= 1 && ["h"] || o < Rn.h && ["hh", o] || s <= 1 && ["d"] || s < Rn.d && ["dd", s] || c <= 1 && ["M"] || c < Rn.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u])[2] = e, l[3] = 0 < +this, l[4] = n, function (t, e, n, r, i) {
          return i.relativeTime(e || 1, !!n, t, r);
        }.apply(null, l));
        return t && (f = h.pastFuture(+this, f)), h.postformat(f);
      }, Yn.toISOString = jn, Yn.toString = jn, Yn.toJSON = jn, Yn.locale = He, Yn.localeData = We, Yn.toIsoString = C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", jn), Yn.lang = $e, H("X", 0, 0, "unix"), H("x", 0, 0, "valueOf"), lt("x", at), lt("X", /[+-]?\d+(\.\d{1,3})?/), pt("X", function (t, e, n) {
        n._d = new Date(1e3 * parseFloat(t, 10));
      }), pt("x", function (t, e, n) {
        n._d = new Date(k(t));
      }), i.version = "2.24.0", e = _e, i.fn = on, i.min = function () {
        return ke("isBefore", [].slice.call(arguments, 0));
      }, i.max = function () {
        return ke("isAfter", [].slice.call(arguments, 0));
      }, i.now = function () {
        return Date.now ? Date.now() : +new Date();
      }, i.utc = d, i.unix = function (t) {
        return _e(1e3 * t);
      }, i.months = function (t, e) {
        return ln(t, e, "months");
      }, i.isDate = u, i.locale = ee, i.invalid = g, i.duration = Re, i.isMoment = x, i.weekdays = function (t, e, n) {
        return hn(t, e, n, "weekdays");
      }, i.parseZone = function () {
        return _e.apply(null, arguments).parseZone();
      }, i.localeData = re, i.isDuration = Ce, i.monthsShort = function (t, e) {
        return ln(t, e, "monthsShort");
      }, i.weekdaysMin = function (t, e, n) {
        return hn(t, e, n, "weekdaysMin");
      }, i.defineLocale = ne, i.updateLocale = function (t, e) {
        if (null != e) {
          var n,
              r,
              i = Zt;
          null != (r = te(t)) && (i = r._config), (n = new O(e = D(i, e))).parentLocale = Qt[t], Qt[t] = n, ee(t);
        } else null != Qt[t] && (null != Qt[t].parentLocale ? Qt[t] = Qt[t].parentLocale : null != Qt[t] && delete Qt[t]);

        return Qt[t];
      }, i.locales = function () {
        return S(Qt);
      }, i.weekdaysShort = function (t, e, n) {
        return hn(t, e, n, "weekdaysShort");
      }, i.normalizeUnits = I, i.relativeTimeRounding = function (t) {
        return void 0 === t ? In : "function" == typeof t && (In = t, !0);
      }, i.relativeTimeThreshold = function (t, e) {
        return void 0 !== Rn[t] && (void 0 === e ? Rn[t] : (Rn[t] = e, "s" === t && (Rn.ss = e - 1), !0));
      }, i.calendarFormat = function (t, e) {
        var n = t.diff(e, "days", !0);
        return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
      }, i.prototype = on, i.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
      }, i;
    }();
  },
  6470: function _(t) {
    function e(t) {
      if ("string" != typeof t) throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
    }

    function n(t, e) {
      for (var n, r = "", i = 0, a = -1, o = 0, s = 0; s <= t.length; ++s) {
        if (s < t.length) n = t.charCodeAt(s);else {
          if (47 === n) break;
          n = 47;
        }

        if (47 === n) {
          if (a === s - 1 || 1 === o) ;else if (a !== s - 1 && 2 === o) {
            if (r.length < 2 || 2 !== i || 46 !== r.charCodeAt(r.length - 1) || 46 !== r.charCodeAt(r.length - 2)) if (r.length > 2) {
              var c = r.lastIndexOf("/");

              if (c !== r.length - 1) {
                -1 === c ? (r = "", i = 0) : i = (r = r.slice(0, c)).length - 1 - r.lastIndexOf("/"), a = s, o = 0;
                continue;
              }
            } else if (2 === r.length || 1 === r.length) {
              r = "", i = 0, a = s, o = 0;
              continue;
            }
            e && (r.length > 0 ? r += "/.." : r = "..", i = 2);
          } else r.length > 0 ? r += "/" + t.slice(a + 1, s) : r = t.slice(a + 1, s), i = s - a - 1;
          a = s, o = 0;
        } else 46 === n && -1 !== o ? ++o : o = -1;
      }

      return r;
    }

    var r = {
      resolve: function resolve() {
        for (var t, r = "", i = !1, a = arguments.length - 1; a >= -1 && !i; a--) {
          var o;
          a >= 0 ? o = arguments[a] : (void 0 === t && (t = process.cwd()), o = t), e(o), 0 !== o.length && (r = o + "/" + r, i = 47 === o.charCodeAt(0));
        }

        return r = n(r, !i), i ? r.length > 0 ? "/" + r : "/" : r.length > 0 ? r : ".";
      },
      normalize: function normalize(t) {
        if (e(t), 0 === t.length) return ".";
        var r = 47 === t.charCodeAt(0),
            i = 47 === t.charCodeAt(t.length - 1);
        return 0 !== (t = n(t, !r)).length || r || (t = "."), t.length > 0 && i && (t += "/"), r ? "/" + t : t;
      },
      isAbsolute: function isAbsolute(t) {
        return e(t), t.length > 0 && 47 === t.charCodeAt(0);
      },
      join: function join() {
        if (0 === arguments.length) return ".";

        for (var t, n = 0; n < arguments.length; ++n) {
          var i = arguments[n];
          e(i), i.length > 0 && (void 0 === t ? t = i : t += "/" + i);
        }

        return void 0 === t ? "." : r.normalize(t);
      },
      relative: function relative(t, n) {
        if (e(t), e(n), t === n) return "";
        if ((t = r.resolve(t)) === (n = r.resolve(n))) return "";

        for (var i = 1; i < t.length && 47 === t.charCodeAt(i); ++i) {
          ;
        }

        for (var a = t.length, o = a - i, s = 1; s < n.length && 47 === n.charCodeAt(s); ++s) {
          ;
        }

        for (var c = n.length - s, u = o < c ? o : c, l = -1, h = 0; h <= u; ++h) {
          if (h === u) {
            if (c > u) {
              if (47 === n.charCodeAt(s + h)) return n.slice(s + h + 1);
              if (0 === h) return n.slice(s + h);
            } else o > u && (47 === t.charCodeAt(i + h) ? l = h : 0 === h && (l = 0));

            break;
          }

          var f = t.charCodeAt(i + h);
          if (f !== n.charCodeAt(s + h)) break;
          47 === f && (l = h);
        }

        var d = "";

        for (h = i + l + 1; h <= a; ++h) {
          h !== a && 47 !== t.charCodeAt(h) || (0 === d.length ? d += ".." : d += "/..");
        }

        return d.length > 0 ? d + n.slice(s + l) : (s += l, 47 === n.charCodeAt(s) && ++s, n.slice(s));
      },
      _makeLong: function _makeLong(t) {
        return t;
      },
      dirname: function dirname(t) {
        if (e(t), 0 === t.length) return ".";

        for (var n = t.charCodeAt(0), r = 47 === n, i = -1, a = !0, o = t.length - 1; o >= 1; --o) {
          if (47 === (n = t.charCodeAt(o))) {
            if (!a) {
              i = o;
              break;
            }
          } else a = !1;
        }

        return -1 === i ? r ? "/" : "." : r && 1 === i ? "//" : t.slice(0, i);
      },
      basename: function basename(t, n) {
        if (void 0 !== n && "string" != typeof n) throw new TypeError('"ext" argument must be a string');
        e(t);
        var r,
            i = 0,
            a = -1,
            o = !0;

        if (void 0 !== n && n.length > 0 && n.length <= t.length) {
          if (n.length === t.length && n === t) return "";
          var s = n.length - 1,
              c = -1;

          for (r = t.length - 1; r >= 0; --r) {
            var u = t.charCodeAt(r);

            if (47 === u) {
              if (!o) {
                i = r + 1;
                break;
              }
            } else -1 === c && (o = !1, c = r + 1), s >= 0 && (u === n.charCodeAt(s) ? -1 == --s && (a = r) : (s = -1, a = c));
          }

          return i === a ? a = c : -1 === a && (a = t.length), t.slice(i, a);
        }

        for (r = t.length - 1; r >= 0; --r) {
          if (47 === t.charCodeAt(r)) {
            if (!o) {
              i = r + 1;
              break;
            }
          } else -1 === a && (o = !1, a = r + 1);
        }

        return -1 === a ? "" : t.slice(i, a);
      },
      extname: function extname(t) {
        e(t);

        for (var n = -1, r = 0, i = -1, a = !0, o = 0, s = t.length - 1; s >= 0; --s) {
          var c = t.charCodeAt(s);
          if (47 !== c) -1 === i && (a = !1, i = s + 1), 46 === c ? -1 === n ? n = s : 1 !== o && (o = 1) : -1 !== n && (o = -1);else if (!a) {
            r = s + 1;
            break;
          }
        }

        return -1 === n || -1 === i || 0 === o || 1 === o && n === i - 1 && n === r + 1 ? "" : t.slice(n, i);
      },
      format: function format(t) {
        if (null === t || "object" != _typeof(t)) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + _typeof(t));
        return function (t, e) {
          var n = e.dir || e.root,
              r = e.base || (e.name || "") + (e.ext || "");
          return n ? n === e.root ? n + r : n + "/" + r : r;
        }(0, t);
      },
      parse: function parse(t) {
        e(t);
        var n = {
          root: "",
          dir: "",
          base: "",
          ext: "",
          name: ""
        };
        if (0 === t.length) return n;
        var r,
            i = t.charCodeAt(0),
            a = 47 === i;
        a ? (n.root = "/", r = 1) : r = 0;

        for (var o = -1, s = 0, c = -1, u = !0, l = t.length - 1, h = 0; l >= r; --l) {
          if (47 !== (i = t.charCodeAt(l))) -1 === c && (u = !1, c = l + 1), 46 === i ? -1 === o ? o = l : 1 !== h && (h = 1) : -1 !== o && (h = -1);else if (!u) {
            s = l + 1;
            break;
          }
        }

        return -1 === o || -1 === c || 0 === h || 1 === h && o === c - 1 && o === s + 1 ? -1 !== c && (n.base = n.name = 0 === s && a ? t.slice(1, c) : t.slice(s, c)) : (0 === s && a ? (n.name = t.slice(1, o), n.base = t.slice(1, c)) : (n.name = t.slice(s, o), n.base = t.slice(s, c)), n.ext = t.slice(o, c)), s > 0 ? n.dir = t.slice(0, s - 1) : a && (n.dir = "/"), n;
      },
      sep: "/",
      delimiter: ":",
      win32: null,
      posix: null
    };
    r.posix = r, t.exports = r;
  },
  8218: function _() {},
  8009: function _() {},
  5354: function _() {},
  6878: function _() {},
  8183: function _() {},
  1428: function _() {},
  4551: function _() {},
  8800: function _() {},
  1993: function _() {},
  3069: function _() {},
  9143: function _() {}
},
    e = {};

function n(r) {
  var i = e[r];
  if (void 0 !== i) return i.exports;
  var a = e[r] = {
    id: r,
    loaded: !1,
    exports: {}
  };
  return t[r].call(a.exports, a, a.exports, n), a.loaded = !0, a.exports;
}

n.c = e, n.n = function (t) {
  var e = t && t.__esModule ? function () {
    return t["default"];
  } : function () {
    return t;
  };
  return n.d(e, {
    a: e
  }), e;
}, n.d = function (t, e) {
  for (var r in e) {
    n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
      enumerable: !0,
      get: e[r]
    });
  }
}, n.g = function () {
  if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;

  try {
    return this || new Function("return this")();
  } catch (t) {
    if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
  }
}(), n.o = function (t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}, n.r = function (t) {
  "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
    value: "Module"
  }), Object.defineProperty(t, "__esModule", {
    value: !0
  });
}, n.nmd = function (t) {
  return t.paths = [], t.children || (t.children = []), t;
};
var r = n(n.s = 7458).Z; //

var script$9 = {
  name: "VueMermaid",
  props: {
    type: {
      type: String,
      "default": "graph TD"
    },
    nodes: {
      type: Array,
      required: true
    },
    styles: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    config: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    defaultConfig: {
      type: Object,
      "default": function _default() {
        return {
          theme: "default",
          startOnLoad: false,
          securityLevel: "loose"
        };
      }
    },
    stopOnError: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      edges: [{
        type: "default",
        open: "[",
        close: "]"
      }, {
        type: "round",
        open: "(",
        close: ")"
      }, {
        type: "stadium",
        open: "([",
        close: "])"
      }, {
        type: "subroutine",
        open: "[[",
        close: "]]"
      }, {
        type: "cylindrical",
        open: "[(",
        close: ")]"
      }, {
        type: "circle",
        open: "((",
        close: "))"
      }, {
        type: "asymetric",
        open: ">",
        close: "]"
      }, {
        type: "rhombus",
        open: "{",
        close: "}"
      }, {
        type: "hexagon",
        open: "{{",
        close: "}}"
      }, {
        type: "parallelogram",
        open: "[/",
        close: "/]"
      }, {
        type: "parallelogram_alt",
        open: "[\\",
        close: "\\]"
      }, {
        type: "trapezoid",
        open: "[/",
        close: "\\]"
      }, {
        type: "trapezoid_alt",
        open: "[\\",
        close: "/]"
      }]
    };
  },
  mounted: function mounted() {
    this.init();
    this.loadNodes();
  },
  computed: {
    nodeObject: function nodeObject() {
      var nodes = this.nodes;

      if (Array.isArray(nodes) && nodes.length > 0) {
        var arrayToObject = function arrayToObject(arr, keyField) {
          return Object.assign.apply(Object, [{}].concat(_toConsumableArray(arr.map(function (item) {
            return _defineProperty2({}, item[keyField], item);
          }))));
        };

        return arrayToObject(nodes, "id");
      } else {
        return {};
      }
    },
    customStyle: function customStyle() {
      var nodes = this.nodes,
          styles = this.styles;
      var nodeStyles = nodes.filter(function (node) {
        return node.style;
      }).map(function (node) {
        return "style ".concat(node.id, " ").concat(node.style);
      });
      var nodeLinkStyles = nodes.filter(function (node) {
        return node.linkStyle;
      }).map(function (node) {
        return "linkStyle ".concat(node.linkNumber || nodes.indexOf(node), " ").concat(node.linkStyle);
      });
      return nodeStyles.concat(styles).concat(nodeLinkStyles);
    },
    parseCode: function parseCode() {
      var nodes = this.nodes;

      if (Array.isArray(nodes) && nodes.length > 0) {
        var parseCode = this.type + "\n";
        var groupNodes = this.getGroupNodes(nodes);
        var code = parseCode + groupNodes + this.customStyle.join(" \n");
        this.load(code);
        console.log(code);
        return code;
      } else {
        return "";
      }
    }
  },
  methods: {
    getGroupNodes: function getGroupNodes(nodes) {
      var _this60 = this;

      var innerMap = new Map();
      nodes.forEach(function (element) {
        var group = element.group || "";
        var data = innerMap.get(group) || {
          nids: new Set(),
          narr: []
        };
        data.nids.add(element.id);
        data.narr.push(element);
        innerMap.set(group, data);
      });
      return _toConsumableArray(innerMap.entries()).map(function (item) {
        var _item = _slicedToArray(item, 2),
            groupName = _item[0],
            entry = _item[1];

        var nids = entry.nids,
            narr = entry.narr;

        if (groupName !== "") {
          var innerNodes = [];
          var outNodes = [];
          narr.forEach(function (node) {
            if (node.next) {
              innerNodes.push({
                id: node.id,
                text: node.text,
                style: node.style,
                editable: node.editable
              });
              node.next.forEach(function (id) {
                if (nids.has(id)) {
                  innerNodes.push({
                    id: node.id,
                    text: node.text,
                    link: node.link,
                    next: [id]
                  });
                } else {
                  outNodes.push({
                    id: node.id,
                    text: node.text,
                    link: node.link,
                    next: [id]
                  });
                }
              });
            } else {
              innerNodes.push(node);
            }
          });

          var innerNodesStr = _this60.buildNodesStr(innerNodes);

          var outNodeStr = _this60.buildNodesStr(outNodes);

          return "subgraph ".concat(groupName, " \n ").concat(innerNodesStr, " end \n ").concat(outNodeStr);
        } else {
          var nodesStr = _this60.buildNodesStr(narr);

          return nodesStr;
        }
      }).join(" \n");
    },
    buildNodesStr: function buildNodesStr(nodes) {
      var _this61 = this;

      return nodes.map(function (item) {
        if (item.next && item.next.length > 0) {
          return item.next.map(function (n, index) {
            var next = _this61.nodeObject[n] || _this61.nodeObject[n.id];

            if (next != null && typeof next != "undefined") {
              return "".concat(_this61.buildNode(item)).concat(_this61.buildLink(item, index)).concat(_this61.buildNode(next));
            } else {
              //TODO error
              return "".concat(_this61.buildNode(item));
            }
          }).join("\n");
        } else {
          return "".concat(_this61.buildNode(item));
        }
      }).join("\n") + "\n" + nodes.filter(function (item) {
        return item.editable;
      }).map(function (item) {
        return "click ".concat(item.id, " mermaidClick");
      }).join("\n") + "\n" + nodes.filter(function (item) {
        return item.url;
      }).map(function (item) {
        return "click ".concat(item.id, " \"").concat(item.url, "\"");
      }).join("\n") + "\n";
    },
    buildNode: function buildNode(item) {
      var edge = !item.edgeType ? this.edges.find(function (e) {
        return e.type === "default";
      }) : this.edges.find(function (e) {
        return e.type === item.edgeType;
      });
      return "".concat(item.id).concat(edge.open).concat(item.text).concat(edge.close);
    },
    buildLink: function buildLink(item, index) {
      var link = "-->";

      if (item.link) {
        if (Array.isArray(item.link)) {
          if (item.link.length > index) return item.link[index];else return item.link[item.link.length - 1];
        } else {
          return item.link;
        }
      }

      return link;
    },
    loadNodes: function loadNodes() {
      this.load(this.parseCode);
    },
    init: function init() {
      var _t = this;

      window.mermaidClick = function (id) {
        _t.edit(id);
      };

      r.initialize(Object.assign(this.defaultConfig, this.config));
    },
    load: function load(code) {
      if (code) {
        var container = document.getElementById("mermaid");

        if (container) {
          container.removeAttribute("data-processed");
          container.replaceChild(document.createTextNode(code), container.firstChild);

          try {
            r.init(code, container);
          } catch (error) {
            if (this.stopOnError) {
              throw error;
            }
          }
        }
      }
    },
    edit: function edit(id) {
      this.$emit("nodeClick", id);
    }
  }
};
/* script */

var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__$9() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "mermaid",
    attrs: {
      id: "mermaid"
    }
  }, [_vm._v(_vm._s(_vm.parseCode))]);
};

var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;
/* style */

var __vue_inject_styles__$9 = function __vue_inject_styles__$9(inject) {
  if (!inject) return;
  inject("data-v-482ec142_0", {
    source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
    map: {
      "version": 3,
      "sources": [],
      "names": [],
      "mappings": "",
      "file": "vue-mermaid.vue"
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

function install$1(Vue) {
  Vue.component("vue-mermaid", __vue_component__$9);
}

var VueMermaid = {
  install: install$1
}; //

Vue.use(VueMermaid);
var script$8 = Vue.extend({
  name: 'FlowChart',
  props: {
    nodes: {
      type: Array,
      "default": []
    },
    nodeBgColor: {
      type: String,
      "default": "#ffffff"
    },
    nodeColor: {
      type: String,
      "default": "#9BCFFD"
    },
    nodeHoverColor: {
      type: String,
      "default": "#6DB9FA"
    },
    curveType: {
      type: String,
      "default": "linear"
    },
    nodeSpacing: {
      type: Number,
      "default": 20
    },
    rankSpacing: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      data: this.setChartNodes(),
      config: {
        flowchart: {
          curve: this.curveType,
          nodeSpacing: this.nodeSpacing,
          rankSpacing: this.rankSpacing
        }
      }
    };
  },
  methods: {
    setChartNodes: function setChartNodes() {
      var _this62 = this;

      return this.nodes.map(function (node, index) {
        return _objectSpread({
          link: '---',
          edgeType: 'round',
          style: 'fill:#ffffff,stroke:#9BCFFD,stroke-width:1px,color:#9BCFFD',
          linkStyle: index >= _this62.nodes.length - 1 ? '' : 'stroke:#9BCFFD,stroke-width:1px'
        }, node);
      });
    },
    setNodeStyles: function setNodeStyles(object) {
      var isHover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      object.style.fill = this.nodeBgColor;
      object.style.stroke = isHover ? this.nodeHoverColor : this.nodeColor;
      object.style.color = isHover ? this.nodeHoverColor : this.nodeColor;
    }
  },
  mounted: function mounted() {
    var _this63 = this;

    var labelContainers = document.querySelectorAll('.label-container');
    labelContainers.forEach(function (labelContainer) {
      labelContainer.addEventListener('mouseover', function () {
        _this63.setNodeStyles(labelContainer, true);

        labelContainer.nextSibling.querySelector('g').style.color = _this63.nodeHoverColor;
      });
      labelContainer.addEventListener('mouseleave', function () {
        _this63.setNodeStyles(labelContainer, false);

        labelContainer.nextSibling.querySelector('g').style.color = _this63.nodeColor;
      });
    });
    var labels = document.querySelectorAll('.label');
    labels.forEach(function (label) {
      label.addEventListener('mouseover', function () {
        _this63.setNodeStyles(label.previousSibling, true);

        label.querySelector('g').style.color = _this63.nodeHoverColor;
      });
      label.addEventListener('mouseleave', function () {
        _this63.setNodeStyles(label.previousSibling, false);

        label.querySelector('g').style.color = _this63.nodeColor;
      });
    });
  }
});
/* script */

var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__$8() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("vue-mermaid", {
    attrs: {
      nodes: _vm.data,
      config: _vm.config,
      type: "graph LR"
    }
  });
};

var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var script$7 = {
  name: 'ClosableWrapper',
  props: {
    disabled: {
      type: Boolean,
      "default": false
    },
    tag: {
      type: String,
      "default": 'div'
    }
  }
};
/* script */

var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__$7() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.tag, {
    tag: "component",
    staticClass: "closable-wrapper relative"
  }, [!_vm.disabled ? _c("div", {
    staticClass: "close-field-btn absolute hidden box-content w-5 h-5 z-10 -top-3 -left-2 \n         text-blue bg-white text-center text-xl border border-solid border-blue \n         rounded-full cursor-pointer hover:bg-blue-100",
    on: {
      click: function click($event) {
        return _vm.$emit("close");
      }
    }
  }, [_c("div", {
    staticClass: "leading-5"
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;
/* style */

var __vue_inject_styles__$7 = function __vue_inject_styles__$7(inject) {
  if (!inject) return;
  inject("data-v-79ceccdc_0", {
    source: "\n.closable-wrapper:hover .close-field-btn[data-v-79ceccdc] {\n  display: block;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/blocks/ClosableWrapper.vue"],
      "names": [],
      "mappings": ";AA+BA;EACA,cAAA;AACA",
      "file": "ClosableWrapper.vue",
      "sourcesContent": ["<template>\n  <component :is=\"tag\" class=\"closable-wrapper relative\">\n    <div v-if=\"!disabled\"\n         @click=\"$emit('close')\"\n         class=\"close-field-btn absolute hidden box-content w-5 h-5 z-10 -top-3 -left-2 \n           text-blue bg-white text-center text-xl border border-solid border-blue \n           rounded-full cursor-pointer hover:bg-blue-100\"\n    >\n      <div class=\"leading-5\">&times;</div>\n    </div>\n    <slot></slot>\n  </component>\n</template>\n\n<script lang=\"ts\">\nexport default {\n  name: 'ClosableWrapper',\n  props: {\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    tag: {\n      type: String,\n      default: 'div'\n    },\n  }\n}\n</script>\n\n<style scoped>\n.closable-wrapper:hover .close-field-btn {\n  display: block;\n}\n</style>"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$7 = "data-v-79ceccdc";
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

var script$6 = Vue.extend({
  name: 'tab-bar',
  methods: {
    clickedTab: function clickedTab(tab) {
      this.$emit('update:selected', tab);
    }
  },
  props: {
    tabs: {
      type: Array
    },
    selected: {
      type: Object
    }
  }
});
/* script */

var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__$6() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "sb-tab-bar bg-white inline-block border border-solid flex flex-row flex-nowrap items-center overflow-overlay"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c("div", {
      key: tab.key,
      staticClass: "sb-button px-5 py-1 text-sm flex-1",
      "class": {
        "invert border-0": _vm.selected.key !== tab.key,
        "rounded-l-none": index === 0,
        "rounded-r-none": index === _vm.tabs.length - 1
      },
      on: {
        click: function click($event) {
          return _vm.clickedTab(tab);
        }
      }
    }, [_vm._t("label", function () {
      return [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")];
    }, {
      tab: tab
    })], 2);
  }), 0);
};

var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;
/* style */

var __vue_inject_styles__$6 = function __vue_inject_styles__$6(inject) {
  if (!inject) return;
  inject("data-v-785a8b40_0", {
    source: "\n.sb-tab-bar {\n  border-radius: 9px;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/inlines/TabBar.vue"],
      "names": [],
      "mappings": ";AA+CA;EACA,kBAAA;AACA",
      "file": "TabBar.vue",
      "sourcesContent": ["<template>\n  <main class=\"sb-tab-bar bg-white inline-block border border-solid flex flex-row flex-nowrap items-center overflow-overlay\">\n    <div\n      v-for=\"(tab, index) in tabs\"\n      :key=\"tab.key\"\n      class=\"sb-button px-5 py-1 text-sm flex-1\"\n      :class=\"{\n        'invert border-0': selected.key !== tab.key,\n        'rounded-l-none': index === 0,\n        'rounded-r-none': index === tabs.length - 1\n      }\"\n      @click=\"clickedTab(tab)\"\n    >\n      <slot name=\"label\" :tab=\"tab\">\n        {{ tab.label }}\n      </slot>\n    </div>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue, { PropOptions } from \"vue\";\n\nexport interface Tab {\n  label: string;\n  key: string;\n}\n\nexport default Vue.extend({\n  name: 'tab-bar',\n  methods: {\n    clickedTab(tab: Tab) {\n      this.$emit('update:selected', tab)\n    }\n  },\n  props: {\n    tabs: {\n      type: Array\n    } as PropOptions<Array<Tab>>,\n    selected: {\n      type: Object\n    } as PropOptions<Tab | null>\n  }\n});\n</script>\n\n<style lang=\"postcss\">\n  .sb-tab-bar {\n    border-radius: 9px;\n  }\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined); //
//
//
//
//
//


var script$5 = {
  name: "Counter",
  props: {
    duration: {
      type: Number,
      "default": 1000
    },
    frames: {
      type: Number,
      "default": 60
    },
    start: Number,
    end: Number
  },
  data: function data() {
    return {
      label: 0,
      interval: null
    };
  },
  mounted: function mounted() {
    this.runAnimation();
  },
  methods: {
    runAnimation: function runAnimation() {
      var _this64 = this;

      var frame = 0;

      var easeOutQuad = function easeOutQuad(t) {
        return t * (2 - t);
      };

      var isAscending = this.end > this.start;
      this.label = this.start;

      if (this.interval) {
        clearInterval(this.interval);
      }

      this.interval = setInterval(function () {
        frame++;
        var progress = isAscending ? easeOutQuad(frame / _this64.frames) : 1 - easeOutQuad(frame / _this64.frames);
        _this64.label = isAscending ? _this64.start + Math.round((_this64.end - _this64.start) * progress) : _this64.end - Math.round((_this64.end - _this64.start) * progress);

        if (frame >= _this64.frames) {
          clearInterval(_this64.interval);
          _this64.interval = null;
        }
      }, this.duration / this.frames);
    }
  },
  watch: {
    start: function start() {
      this.runAnimation();
    },
    end: function end() {
      this.runAnimation();
    }
  }
};
/* script */

var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__$5() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "counter inline"
  }, [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.label))];
  }, {
    label: _vm.label
  })], 2);
};

var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var script$4 = Vue.extend({
  name: "InputField",
  props: {
    type: {
      type: String,
      "default": 'text'
    },
    value: {
      type: [String, Number],
      "default": null
    },
    placeholder: {
      type: String,
      "default": ""
    },
    maxlength: {
      type: Number,
      "default": null
    },
    min: {
      type: Number,
      "default": -1e7
    },
    max: {
      type: Number,
      "default": 1e7
    },
    step: {
      type: Number,
      "default": 1
    },
    decimalPlaces: {
      type: Number,
      "default": 0
    },
    fixedDecimals: {
      type: Boolean,
      "default": false
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    formatter: {
      type: Function,
      "default": function _default(x) {
        return x;
      }
    }
  },
  data: function data() {
    return {
      isFocused: false
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      return !this.isFocused && this.value != null && String(this.value).trim().length > 0 ? this.formatter(this.type === 'number' && this.fixedDecimals ? Number(this.value).toFixed(this.decimalPlaces) : this.value) : this.value;
    }
  },
  methods: {
    onFocus: function onFocus() {
      this.isFocused = true;
    },
    onBlur: function onBlur(_ref22) {
      var target = _ref22.target;
      this.isFocused = false;
      var value = target.value;
      if (value !== String(this.value)) this.emitValue(value);
    },
    onInput: function onInput(_ref23) {
      var target = _ref23.target;
      var cleanedValue = this.getCleanedValue(target.value);
      this.$refs.input.value = cleanedValue;

      if (this.type === "text" || cleanedValue.split('').reverse().join('')[0] !== '.' && (this.min == null || Number(cleanedValue) >= this.min) && (this.max == null || Number(cleanedValue) <= this.max)) {
        this.emitValue(cleanedValue);
      }
    },
    onIncrement: function onIncrement(event) {
      var _this65 = this;

      if (this.type === 'number' && !event.repeat) this.repeatAction(function () {
        var _this65$step;

        var newValue = Number(_this65.value) + ((_this65$step = _this65.step) !== null && _this65$step !== void 0 ? _this65$step : 1);

        _this65.emitValue(String(_this65.getInRangeValue(newValue)));
      });
    },
    onDecrement: function onDecrement(event) {
      var _this66 = this;

      if (this.type === 'number' && !event.repeat) this.repeatAction(function () {
        var _this66$step;

        var newValue = Number(_this66.value) - ((_this66$step = _this66.step) !== null && _this66$step !== void 0 ? _this66$step : 1);

        _this66.emitValue(String(_this66.getInRangeValue(newValue)));
      });
    },
    repeatAction: function repeatAction(callback) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
      var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      callback();
      var repeatedActionInterval;
      var repeatedActionTimeout = window.setTimeout(function () {
        repeatedActionInterval = window.setInterval(function () {
          callback();
        }, interval);
      }, delay);

      var onMouseOrKeyUp = function onMouseOrKeyUp() {
        clearTimeout(repeatedActionTimeout);
        clearInterval(repeatedActionInterval);
        window.removeEventListener('mouseup', onMouseOrKeyUp);
        window.removeEventListener('keyup', onMouseOrKeyUp);
      };

      window.addEventListener('mouseup', onMouseOrKeyUp);
      window.addEventListener('keyup', onMouseOrKeyUp);
    },
    getCleanedValue: function getCleanedValue(value) {
      var cleanedValue = value;

      if (this.type === 'number') {
        if (this.decimalPlaces > 0) {
          cleanedValue = value.replace(new RegExp('[^0-9.]', 'g'), '');
          var firstPointIndex = String(cleanedValue).indexOf('.');

          if (firstPointIndex === 0) {
            cleanedValue = '0.' + cleanedValue.replace(/[.]/g, '').substr(0, this.decimalPlaces);
          } else if (firstPointIndex > 0) {
            var beforePoint = cleanedValue.slice(0, firstPointIndex);
            var afterPoint = cleanedValue.slice(firstPointIndex + 1).replace(/[.]/g, '');
            cleanedValue = beforePoint + '.' + afterPoint.substr(0, this.decimalPlaces);
          }
        } else {
          cleanedValue = value.replace(/[^0-9]/g, '');
        }

        if ((this.min == null || this.min < 0) && value.charAt(0) === '-') {
          cleanedValue = '-' + cleanedValue;
        }
      }

      return cleanedValue;
    },
    getInRangeValue: function getInRangeValue(value) {
      var val = value; // If the value is out of range (<min or >max), return the closest boundary value

      if (this.type === 'number' && value != null) {
        if (this.min != null && Number(value) < this.min) val = this.min;
        if (this.max != null && Number(value) > this.max) val = this.max;
        return parseFloat(String(Number(val).toFixed(this.decimalPlaces)));
      } else {
        return null;
      }
    },
    emitValue: function emitValue(value) {
      if (this.type === 'number') {
        if (value === '-' || value === '') {
          this.$emit('input', null);
        } else {
          this.$emit('input', this.getInRangeValue(Number(value)));
        }
      } else {
        this.$emit('input', value);
      }
    }
  }
});
/* script */

var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__$4() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "field flex relative sb-input p-0 w-auto overflow-hidden",
    "class": {
      focused: _vm.isFocused,
      disabled: _vm.disabled
    },
    attrs: {
      type: _vm.type
    }
  }, [_c("input", {
    ref: "input",
    staticClass: "sb-input h-full w-full max-w-full border-0 flex-1 truncate",
    attrs: {
      type: "text",
      placeholder: _vm.placeholder,
      maxlength: _vm.maxlength,
      disabled: _vm.disabled
    },
    domProps: {
      value: _vm.formattedValue
    },
    on: {
      focus: _vm.onFocus,
      blur: _vm.onBlur,
      input: _vm.onInput,
      keydown: [function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }

        return _vm.onIncrement.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }

        return _vm.onDecrement.apply(null, arguments);
      }]
    }
  }), _vm._v(" "), _vm.type === "number" ? _c("div", {
    staticClass: "arrows absolute w-6 right-0 top-0 h-full flex flex-col hidden"
  }, [_c("button", {
    staticClass: "border-0 cursor-pointer p-0 text-gray-400 bg-gray-100 hover:bg-gray-200 hover:text-gray-900",
    on: {
      mousedown: _vm.onIncrement
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fas", "caret-up"]
    }
  })], 1), _vm._v(" "), _c("button", {
    staticClass: "border-0 cursor-pointer p-0 text-gray-400 bg-gray-100 hover:bg-gray-200 hover:text-gray-900",
    on: {
      mousedown: _vm.onDecrement
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fas", "caret-down"]
    }
  })], 1)]) : _vm._e()]);
};

var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;
/* style */

var __vue_inject_styles__$4 = function __vue_inject_styles__$4(inject) {
  if (!inject) return;
  inject("data-v-06abaed8_0", {
    source: ".field.focused[type=number] input[data-v-06abaed8], .field:hover[type=number] input[data-v-06abaed8] {\n  padding-right: 30px;\n}\n.field.focused .arrows[data-v-06abaed8], .field:hover .arrows[data-v-06abaed8] {\n  display: flex;\n}\n.field.disabled[data-v-06abaed8] {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  cursor: not-allowed;\n  color: #adadad;\n}\n.field.disabled > input[data-v-06abaed8] {\n  cursor: inherit;\n  color: inherit;\n}\n.arrows button[data-v-06abaed8] {\n  line-height: 50%;\n  flex: 0 0 50%;\n  font-size: 0.7rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.arrows button[data-v-06abaed8]:first-child {\n  border-top-right-radius: 5px;\n}\n.arrows button:first-child > svg[data-v-06abaed8] {\n  margin-bottom: -5px;\n}\n.arrows button[data-v-06abaed8]:last-child {\n  border-bottom-right-radius: 5px;\n}\n.arrows button:last-child > svg[data-v-06abaed8] {\n  margin-top: -5px;\n}\n\n/*# sourceMappingURL=InputField.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/inlines/InputField.vue", "InputField.vue"],
      "names": [],
      "mappings": "AAqMA;EACA,mBAAA;ACpMA;ADsMA;EACA,aAAA;ACpMA;ADuMA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;ACpMA;ADqMA;EACA,eAAA;EACA,cAAA;ACnMA;ADsMA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACnMA;ADoMA;EACA,4BAAA;AClMA;ADmMA;EAAA,mBAAA;AChMA;ADkMA;EACA,+BAAA;AChMA;ADiMA;EAAA,gBAAA;AC9LA;;AAEA,yCAAyC",
      "file": "InputField.vue",
      "sourcesContent": ["<template>\n  <div class=\"field flex relative sb-input p-0 w-auto overflow-hidden\" :class=\"{focused: isFocused, disabled}\" :type=\"type\">\n    <input type=\"text\"\n           :value=\"formattedValue\"\n           :placeholder=\"placeholder\"\n           :maxlength=\"maxlength\"\n           :disabled=\"disabled\"\n           class=\"sb-input h-full w-full max-w-full border-0 flex-1 truncate\"\n           @focus=\"onFocus\"\n           @blur=\"onBlur\"\n           @input=\"onInput\"\n           @keydown.up=\"onIncrement\"\n           @keydown.down=\"onDecrement\"\n           ref=\"input\"\n    />\n    <div v-if=\"type === 'number'\" class=\"arrows absolute w-6 right-0 top-0 h-full flex flex-col hidden\">\n      <button class=\"border-0 cursor-pointer p-0 text-gray-400 bg-gray-100 hover:bg-gray-200 hover:text-gray-900\" @mousedown=\"onIncrement\">\n        <fai :icon=\"['fas', 'caret-up']\" />\n      </button>\n      <button class=\"border-0 cursor-pointer p-0 text-gray-400 bg-gray-100 hover:bg-gray-200 hover:text-gray-900\" @mousedown=\"onDecrement\">\n        <fai :icon=\"['fas', 'caret-down']\" />\n      </button>\n    </div>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue, {PropType} from \"vue\";\n\ntype formatterType = (value: string|number) => string\n\nexport default Vue.extend({\n  name: \"InputField\",\n  props: {\n    type: {\n      type: String,\n      default: 'text'\n    },\n    value: {\n      type:[String, Number],\n      default: null\n    },\n    placeholder: {\n      type: String,\n      default: \"\"\n    },\n    maxlength: {\n      type: Number,\n      default: null\n    },\n    min: {\n      type: Number,\n      default: -1e7\n    },\n    max: {\n      type: Number,\n      default: 1e7\n    },\n    step: {\n      type: Number,\n      default: 1\n    },\n    decimalPlaces: {\n      type: Number,\n      default: 0\n    },\n    fixedDecimals: {\n      type: Boolean,\n      default: false\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    formatter: {\n      type: Function,\n      default: (x: string) => x\n    } as unknown as PropType<formatterType>\n  },\n  data() {\n    return {\n      isFocused: false\n    };\n  },\n  computed: {\n    formattedValue(): string|number {\n      return (!this.isFocused && this.value != null && String(this.value).trim().length > 0)\n        ? this.formatter(\n          this.type === 'number' && this.fixedDecimals \n            ? Number(this.value).toFixed(this.decimalPlaces) \n            : this.value\n        )\n        : this.value\n    },\n  },\n  methods: {\n    onFocus(): void {\n      this.isFocused = true;\n    },\n    onBlur({ target }: Event): void {\n      this.isFocused = false;\n      const value = (target as HTMLInputElement).value\n      if(value !== String(this.value)) this.emitValue(value)\n    },\n    onInput({ target }: Event): void {\n      const cleanedValue: string = this.getCleanedValue( (target as HTMLInputElement).value as string);\n      (this.$refs.input as HTMLInputElement).value = cleanedValue\n      if(\n        this.type===\"text\"\n        || (\n          cleanedValue.split('').reverse().join('')[0] !== '.'\n          && (this.min == null || Number(cleanedValue) >= this.min)\n          && (this.max == null || Number(cleanedValue) <= this.max)\n        )\n      ) {\n        this.emitValue(cleanedValue)\n      }\n    },\n    onIncrement(event:KeyboardEvent): void {\n      if(this.type==='number' && !event.repeat) this.repeatAction(() => {\n        const newValue = Number(this.value) + (this.step ?? 1);\n        this.emitValue(String(this.getInRangeValue(newValue)));\n      });\n    },\n    onDecrement(event:KeyboardEvent): void {\n      if(this.type==='number' && !event.repeat) this.repeatAction(() => {\n        const newValue = Number(this.value) - (this.step ?? 1);\n        this.emitValue(String(this.getInRangeValue(newValue)));\n      });\n    },\n    repeatAction(callback: ()=>void, delay:number=500, interval:number=100): void {\n      callback();\n      let repeatedActionInterval: number;\n      const repeatedActionTimeout = window.setTimeout(() => {\n        repeatedActionInterval = window.setInterval(() => {\n          callback();\n        }, interval)\n      }, delay)\n      const onMouseOrKeyUp = () => {\n        clearTimeout(repeatedActionTimeout)\n        clearInterval(repeatedActionInterval)\n        window.removeEventListener('mouseup', onMouseOrKeyUp)\n        window.removeEventListener('keyup', onMouseOrKeyUp)\n      }\n      window.addEventListener('mouseup', onMouseOrKeyUp)\n      window.addEventListener('keyup', onMouseOrKeyUp)\n    },\n    getCleanedValue(value: string): string {\n      let cleanedValue: string = value;\n      if(this.type === 'number') {\n        if(this.decimalPlaces > 0) {\n          cleanedValue = value.replace(new RegExp('[^0-9.]', 'g'), '');\n          const firstPointIndex = String(cleanedValue).indexOf('.');\n          if(firstPointIndex === 0 ) {\n            cleanedValue = '0.' + cleanedValue.replace(/[.]/g, '').substr(0,this.decimalPlaces);\n          }else if(firstPointIndex > 0 ) {\n            const beforePoint = cleanedValue.slice(0, firstPointIndex);\n            const afterPoint = cleanedValue.slice(firstPointIndex+1).replace(/[.]/g, '');\n            cleanedValue = beforePoint + '.' + afterPoint.substr(0,this.decimalPlaces);\n          }\n        }else{\n          cleanedValue = value.replace(/[^0-9]/g, '');\n        }\n        if((this.min == null || this.min < 0) && value.charAt(0) === '-') {\n          cleanedValue = '-' + cleanedValue;\n        }\n      }\n      return cleanedValue\n    },\n    getInRangeValue(value: number): number|null {\n      let val:number = value;\n      // If the value is out of range (<min or >max), return the closest boundary value\n      if(this.type === 'number' && value != null) {\n        if( this.min != null && Number(value) < this.min ) val = this.min;\n        if( this.max != null && Number(value) > this.max ) val = this.max;\n        return parseFloat(String(Number(val).toFixed(this.decimalPlaces)));\n      }else{\n        return null\n      }\n    },\n    emitValue(value: string): void {\n      if(this.type === 'number') {\n        if(value === '-' || value === '' ) {\n          this.$emit('input', null);\n        }else{\n          this.$emit('input', this.getInRangeValue(Number(value)));\n        }\n      }else{\n        this.$emit('input', value);\n      }\n    },\n  }\n})\n</script>\n\n<style lang=\"scss\" scoped>\n.field.focused, .field:hover {\n  &[type=number] input {\n    padding-right: 30px;\n  }\n  .arrows {\n    display:flex;\n  }\n}\n.field.disabled {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  cursor: not-allowed;\n  color: #adadad;\n  >input {\n    cursor: inherit;\n    color: inherit;\n  }\n}\n.arrows button {\n  line-height: 50%;\n  flex: 0 0 50%;\n  font-size:.7rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:first-child { \n    border-top-right-radius: 5px;\n    > svg { margin-bottom: -5px; }\n  }\n  &:last-child { \n    border-bottom-right-radius: 5px; \n    > svg { margin-top: -5px; }\n  }\n}\n</style>", ".field.focused[type=number] input, .field:hover[type=number] input {\n  padding-right: 30px;\n}\n.field.focused .arrows, .field:hover .arrows {\n  display: flex;\n}\n\n.field.disabled {\n  background-color: #eee;\n  border: 1px solid #adadad;\n  cursor: not-allowed;\n  color: #adadad;\n}\n.field.disabled > input {\n  cursor: inherit;\n  color: inherit;\n}\n\n.arrows button {\n  line-height: 50%;\n  flex: 0 0 50%;\n  font-size: 0.7rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.arrows button:first-child {\n  border-top-right-radius: 5px;\n}\n.arrows button:first-child > svg {\n  margin-bottom: -5px;\n}\n.arrows button:last-child {\n  border-bottom-right-radius: 5px;\n}\n.arrows button:last-child > svg {\n  margin-top: -5px;\n}\n\n/*# sourceMappingURL=InputField.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$4 = "data-v-06abaed8";
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var script$3 = Vue.extend({
  components: {
    ErrorBanner: __vue_component__$k
  },
  name: "SimpleModal",
  props: {
    title: String,
    id: String,
    resolveText: {
      type: String,
      "default": 'done'
    },
    rejectText: {
      type: String,
      "default": 'cancel'
    }
  },
  created: function created() {
    document.body.classList.add('overflow-hidden');
    this.$store.dispatch('SHOWING_MODAL', this.id || this.title);
  },
  destroyed: function destroyed() {
    document.body.classList.remove('overflow-hidden');
  },
  methods: {
    resolve: function resolve() {
      this.$store.dispatch('DISMISSED_MODAL');
      this.$emit('resolved');
    },
    reject: function reject() {
      this.$store.dispatch('DISMISSED_MODAL');
      this.$emit('rejected');
    }
  }
});
/* script */

var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__$3() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("main", {
    staticClass: "simple-modal"
  }, [_c("div", {
    staticClass: "rounded-3xl bg-white p-4 relative border border-solid max-h-full overflow-y-auto"
  }, [_c("header", [_c("span", {
    staticClass: "close",
    on: {
      click: _vm.reject
    }
  }, [_vm._v("×")]), _vm._v(" "), _c("div", {
    staticClass: "text-xl sm:text-3xl text-center mt-3"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c("ErrorBanner"), _vm._v(" "), _c("section", {
    staticClass: "content my-3 sm:my-5"
  }, [_vm._t("default")], 2), _vm._v(" "), _c("footer", {
    staticClass: "flex justify-center mt-5 sm:mt-10 mb-3"
  }, [_vm._t("buttons", function () {
    return [_c("button", {
      staticClass: "sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
      on: {
        click: _vm.resolve
      }
    }, [_vm._v(_vm._s(_vm.resolveText))]), _vm._v(" "), _c("button", {
      staticClass: "sb-button sb-reject text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
      on: {
        click: _vm.reject
      }
    }, [_vm._v(_vm._s(_vm.rejectText))])];
  })], 2)], 1)]);
};

var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;
/* style */

var __vue_inject_styles__$3 = function __vue_inject_styles__$3(inject) {
  if (!inject) return;
  inject("data-v-27b56b85_0", {
    source: "\n.simple-modal[data-v-27b56b85] {\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 100;\n  padding: 40px 0;\n}\n.simple-modal .content[data-v-27b56b85] {\n  min-width: 520px;\n}\n@media screen and (max-width: 640px) {\n.simple-modal .content[data-v-27b56b85] {\n    min-width: 320px;\n}\n}\n.close[data-v-27b56b85] {\n  color: var(--primary-color);\n  cursor: pointer;\n  font-size: 30px;\n  font-weight: 900;\n  line-height: 20px;\n  outline: none;\n  position: absolute;\n  left: 15px;\n  top: 10px;\n}\nfooter > * &[data-v-27b56b85]:not(:last-child) {\n  margin-right: 30px;\n}\n",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/modals/SimpleModal.vue"],
      "names": [],
      "mappings": ";AAoEA;EACA,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;AACA;IACA,gBAAA;AACA;AACA;AAEA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AACA;AAEA;EACA,kBAAA;AACA",
      "file": "SimpleModal.vue",
      "sourcesContent": ["<template>\n  <main class=\"simple-modal\">\n    <div class=\"rounded-3xl bg-white p-4 relative border border-solid max-h-full overflow-y-auto\">\n      <header>\n        <span class=\"close\" @click=\"reject\">&times;</span>\n        <div class=\"text-xl sm:text-3xl text-center mt-3\">{{ title }}</div>\n      </header>\n\n      <ErrorBanner />\n\n      <section class=\"content my-3 sm:my-5\">\n        <slot></slot>\n      </section>\n\n      <footer class=\"flex justify-center mt-5 sm:mt-10 mb-3\">\n        <slot name=\"buttons\">\n          <button class=\"sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\" @click=\"resolve\">{{ resolveText }}</button>\n          <button class=\"sb-button sb-reject text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\" @click=\"reject\">{{ rejectText }}</button>\n        </slot>\n      </footer>\n    </div>\n  </main>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\nimport { ErrorBanner } from \"./../blocks\";\n\nexport default Vue.extend({\n  components: {\n    ErrorBanner\n  },\n  name: \"SimpleModal\",\n  props: {\n    title: String,\n    id: String,\n    resolveText: {\n      type: String,\n      default: 'done'\n    },\n    rejectText: {\n      type: String,\n      default: 'cancel'\n    }\n  },\n  created() {\n    document.body.classList.add('overflow-hidden')\n    this.$store.dispatch('SHOWING_MODAL', this.id || this.title);\n  },\n\n  destroyed() {\n    document.body.classList.remove('overflow-hidden')\n  },\n\n  methods: {\n    resolve() {\n      this.$store.dispatch('DISMISSED_MODAL');\n      this.$emit('resolved');\n    },\n    reject() {\n      this.$store.dispatch('DISMISSED_MODAL');\n      this.$emit('rejected');\n    }\n  }\n})\n</script>\n\n<style scoped lang=\"postcss\">\n  .simple-modal {\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.5);\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    padding: 40px 0;\n  }\n\n  .simple-modal .content {\n    min-width: 520px;\n  }\n\n  @media screen and (max-width: 640px) {\n    .simple-modal .content {\n      min-width: 320px;\n    }\n  }\n\n  .close {\n    color: var(--primary-color);\n    cursor: pointer;\n    font-size: 30px;\n    font-weight: 900;\n    line-height: 20px;\n    outline: none;\n    position: absolute;\n    left: 15px;\n    top: 10px;\n  }\n\n  footer > * &:not(:last-child) {\n    margin-right: 30px;\n  }\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$3 = "data-v-27b56b85";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var script$2 = Vue.extend({
  name: "AddImageModal",
  components: {
    SimpleModal: __vue_component__$3,
    LoadingIcon: __vue_component__$u
  },
  props: {
    selected: String,
    images: Array,
    loading: Boolean
  },
  data: function data() {
    return {
      selectedIndex: -1
    };
  },
  methods: {
    clickedUpload: function clickedUpload() {
      this.fileDialog.click();
    },
    clickedImage: function clickedImage(image, index) {
      this.$emit('update:loading', false);
      this.selectedIndex = index;
      this.$emit('update:selected', image);
    },
    clickedRemove: function clickedRemove() {
      this.$emit('update:loading', true);
      this.selectedIndex = -1;
      this.$emit('removeUpload', this.selected);
    },
    resolved: function resolved() {
      this.$store.dispatch('DISMISSED_MODAL');
      this.$emit('resolved');
    },
    fileChanged: function fileChanged() {
      if (this.fileDialog.files && this.fileDialog.files.length > 0) {
        this.$emit('update:loading', true);
        this.$emit('shouldUpload', this.fileDialog.files[0]);
        this.fileDialog.value = '';
      }
    }
  },
  computed: {
    backgroundURL: function backgroundURL() {
      return "url(\"".concat(this.selected, "\") no-repeat");
    },
    fileDialog: function fileDialog() {
      return this.$refs['file-dialog'];
    }
  }
});
/* script */

var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__$2() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("simple-modal", {
    attrs: {
      title: "add image"
    },
    on: {
      rejected: function rejected($event) {
        return _vm.$emit("rejected", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function fn() {
        return [_c("button", {
          staticClass: "sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
          "class": {
            "sb-disabled": !_vm.selected
          },
          attrs: {
            disabled: !_vm.selected
          },
          on: {
            click: _vm.resolved
          }
        }, [_vm._v("add image")])];
      },
      proxy: true
    }])
  }, [_c("main", {
    staticClass: "add-image-modal max-w-xs sm:max-w-xl m-auto"
  }, [_c("div", {
    staticClass: "border border-solid rounded-xl mx-1 sm:mx-3 overflow-hidden"
  }, [_c("div", {
    staticClass: "add-image-container flex flex-row items-center justify-center relative max-h-60 sm:max-h-96"
  }, [_vm.loading ? _c("loading-icon", {
    staticClass: "text-blue"
  }) : [_vm.selected ? _c("img", {
    staticClass: "self-stretch",
    attrs: {
      src: _vm.selected
    }
  }) : _vm._e(), _vm._v(" "), !_vm.selected ? _c("button", {
    staticClass: "sb-button flex flex-col items-center text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
    on: {
      click: _vm.clickedUpload
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "image"],
      size: "2x"
    }
  }), _vm._v("\n            upload\n          ")], 1) : _vm._e(), _vm._v(" "), _vm.selected ? _c("button", {
    staticClass: "sb-button invert absolute bottom-3.5 py-1 px-3",
    on: {
      click: _vm.clickedRemove
    }
  }, [_vm._v("\n            remove\n          ")]) : _vm._e()]], 2), _vm._v(" "), _c("section", {
    staticClass: "img-section border-0 border-t border-solid flex flex-row flex-wrap overflow-overlay box-content"
  }, _vm._l(_vm.images, function (image, index) {
    return _c("img", {
      key: index,
      staticClass: "sb-thumbnail box-border",
      "class": {
        "border-3 border-solid": _vm.selectedIndex === index
      },
      attrs: {
        src: image
      },
      on: {
        click: function click($event) {
          return _vm.clickedImage(image, index);
        }
      }
    });
  }), 0)]), _vm._v(" "), _c("input", {
    ref: "file-dialog",
    staticClass: "hidden",
    attrs: {
      accept: "image/png,image/gif,image/jpeg",
      type: "file",
      "data-cy": "photo-upload-input"
    },
    on: {
      input: _vm.fileChanged
    }
  })])]);
};

var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__$2(inject) {
  if (!inject) return;
  inject("data-v-2d742e2f_0", {
    source: ".img-section[data-v-2d742e2f] {\n  max-height: 236px;\n}\n@media screen and (max-width: 640px) {\n.img-section[data-v-2d742e2f] {\n    max-height: 233px;\n}\n}\n.add-image-container[data-v-2d742e2f] {\n  height: 390px;\n  margin: 0 10px;\n}\n.sb-thumbnail[data-v-2d742e2f] {\n  width: 78.5px;\n  height: 78.5px;\n}\n@media screen and (max-width: 640px) {\n.sb-thumbnail[data-v-2d742e2f] {\n    width: 77.5px;\n    height: 77.5px;\n}\n}\n\n/*# sourceMappingURL=AddImageModal.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/modals/AddImageModal.vue", "AddImageModal.vue"],
      "names": [],
      "mappings": "AAsHA;EACA,iBAAA;ACrHA;ADsHA;AAFA;IAGA,iBAAA;ACnHE;AACF;ADmHA;EACA,aAAA;EACA,cAAA;AChHA;ADkHA;EACA,aAAA;EACA,cAAA;AC/GA;ADgHA;AAHA;IAIA,aAAA;IACA,cAAA;AC7GE;AACF;;AAEA,4CAA4C",
      "file": "AddImageModal.vue",
      "sourcesContent": ["<template>\n  <simple-modal title=\"add image\" @rejected=\"$emit('rejected', $event)\">\n    <main class=\"add-image-modal max-w-xs sm:max-w-xl m-auto\">\n      <div class=\"border border-solid rounded-xl mx-1 sm:mx-3 overflow-hidden\">\n        <div class=\"add-image-container flex flex-row items-center justify-center relative max-h-60 sm:max-h-96\">\n          <loading-icon v-if='loading' class=\"text-blue\" />\n\n          <template v-else>\n            <img\n                v-if=\"selected\"\n                class=\"self-stretch\"\n                :src=\"selected\"\n            />\n\n            <button\n                v-if=\"!selected\"\n                class=\"sb-button flex flex-col items-center text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\"\n                @click='clickedUpload'\n            >\n              <fai :icon=\"['fal', 'image']\" size=\"2x\"/>\n              upload\n            </button>\n\n            <button\n                v-if=\"selected\"\n                class=\"sb-button invert absolute bottom-3.5 py-1 px-3\"\n                @click='clickedRemove'\n            >\n              remove\n            </button>\n          </template>\n\n        </div>\n\n        <section class='img-section border-0 border-t border-solid flex flex-row flex-wrap overflow-overlay box-content'>\n          <img\n              v-for='(image, index) in images'\n              :key=\"index\"\n              :src=\"image\"\n              class=\"sb-thumbnail box-border\"\n              :class=\"{ 'border-3 border-solid': selectedIndex === index }\"\n              @click=\"clickedImage(image, index)\"\n          />\n        </section>\n      </div>\n\n      <input\n          accept=\"image/png,image/gif,image/jpeg\"\n          class=\"hidden\"\n          ref=\"file-dialog\"\n          type=\"file\"\n          data-cy=\"photo-upload-input\"\n          @input=\"fileChanged\" />\n    </main>\n\n    <template #buttons>\n      <button class=\"sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\" :disabled=\"!selected\" :class=\"{'sb-disabled': !selected}\" @click=\"resolved\">add image</button>\n    </template>\n  </simple-modal>\n</template>\n\n<script lang=\"ts\">\nimport SimpleModal from \"./SimpleModal.vue\"\nimport LoadingIcon from \"./../icons/LoadingIcon.vue\";\n\nimport Vue from \"vue\";\n\nexport default Vue.extend({\n  name: \"AddImageModal\",\n  components: { SimpleModal, LoadingIcon },\n  props: {\n    selected: String,\n    images: Array,\n    loading: Boolean\n  },\n  data: () => {\n    return {\n      selectedIndex: -1\n    }\n  },\n  methods: {\n    clickedUpload() {\n      this.fileDialog.click();\n    },\n    clickedImage(image:any, index:number) {\n      this.$emit('update:loading', false);\n      this.selectedIndex = index;\n      this.$emit('update:selected', image);\n    },\n    clickedRemove() {\n      this.$emit('update:loading', true);\n      this.selectedIndex = -1;\n      this.$emit('removeUpload', this.selected);\n    },\n    resolved() {\n      this.$store.dispatch('DISMISSED_MODAL');\n      this.$emit('resolved');\n    },\n    fileChanged() {\n      if(this.fileDialog.files && this.fileDialog.files.length > 0) {\n        this.$emit('update:loading', true);\n        this.$emit('shouldUpload', this.fileDialog.files[0])\n        this.fileDialog.value = '';\n      }\n    }\n  },\n  computed: {\n    backgroundURL(): string {\n      return `url(\"${this.selected}\") no-repeat`;\n    },\n    fileDialog(): HTMLInputElement {\n      return this.$refs['file-dialog'] as HTMLInputElement;\n    }\n  }\n})\n</script>\n\n<style lang=\"sass\" scoped>\n.img-section\n  max-height: 236px\n  @media screen and (max-width: 640px)\n    max-height: 233px\n.add-image-container\n  height: 390px\n  margin: 0 10px\n\n.sb-thumbnail\n  width: 78.5px\n  height: 78.5px\n  @media screen and (max-width: 640px)\n    width: 77.5px\n    height: 77.5px\n</style>", ".img-section {\n  max-height: 236px;\n}\n@media screen and (max-width: 640px) {\n  .img-section {\n    max-height: 233px;\n  }\n}\n\n.add-image-container {\n  height: 390px;\n  margin: 0 10px;\n}\n\n.sb-thumbnail {\n  width: 78.5px;\n  height: 78.5px;\n}\n@media screen and (max-width: 640px) {\n  .sb-thumbnail {\n    width: 77.5px;\n    height: 77.5px;\n  }\n}\n\n/*# sourceMappingURL=AddImageModal.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = "data-v-2d742e2f";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var AppError = function AppError(error, message) {
  _classCallCheck(this, AppError);

  _defineProperty(this, "dismissed", false);

  _defineProperty(this, "modal", null);

  this.error = error;
  this.message = message;
};

var UnexpectedError = /*#__PURE__*/function (_AppError) {
  _inherits(UnexpectedError, _AppError);

  var _super29 = _createSuper(UnexpectedError);

  function UnexpectedError(error) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'an unexpected error occurred! if this keeps happening please contact us at support@springbig.com';

    _classCallCheck(this, UnexpectedError);

    return _super29.call(this, error, message);
  }

  return UnexpectedError;
}(AppError);

var UserError = /*#__PURE__*/function (_AppError2) {
  _inherits(UserError, _AppError2);

  var _super30 = _createSuper(UserError);

  function UserError() {
    _classCallCheck(this, UserError);

    return _super30.apply(this, arguments);
  }

  return UserError;
}(AppError);

var ValidationError = /*#__PURE__*/function (_AppError3) {
  _inherits(ValidationError, _AppError3);

  var _super31 = _createSuper(ValidationError);

  function ValidationError(message, value, field) {
    var _this67;

    _classCallCheck(this, ValidationError);

    _this67 = _super31.call(this, new Error(message), message);
    _this67.value = value;
    _this67.field = field;
    return _this67;
  }

  return ValidationError;
}(AppError);

var script$1 = Vue.extend({
  name: "AddImagesModal",
  components: {
    SimpleModal: __vue_component__$3,
    LoadingIcon: __vue_component__$u,
    CarouselActions: __vue_component__$h
  },
  props: {
    selected: Array,
    images: Array,
    loading: Boolean,
    disableBtn: {
      type: Boolean,
      required: false,
      "default": false
    }
  },
  methods: {
    clickedUpload: function clickedUpload() {
      this.fileDialog.click();
    },
    clickedImage: function clickedImage(image) {
      var _this68 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this68.$emit('update:selected', _this68.selected.includes(image) ? _this68.selected.filter(function (img) {
                  return img !== image;
                }) : _this68.selected.concat(image));

                _this68.$emit('update:loading', false);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }))();
    },
    resolved: function resolved() {
      this.$store.dispatch('DISMISSED_MODAL');
      this.$emit('resolved');
    },
    fileChanged: function fileChanged() {
      if (this.fileDialog.files && this.fileDialog.files.length > 0) {
        this.$emit('update:loading', true);
        this.$emit('shouldUpload', this.fileDialog.files);
        this.fileDialog.value = '';
      }
    },
    removeSlide: function removeSlide(index) {
      var image = this.selected[index];
      this.$emit('update:selected', this.selected.filter(function (img) {
        return img !== image;
      }));
    },
    showError: function showError(errorText, errorCode) {
      this.$store.dispatch('ADD_ERRORS', [new UserError(new Error(errorCode), errorText)]);
    },
    hideError: function hideError() {
      this.$store.dispatch('DISMISS_ERRORS', {
        type: UserError
      });
    }
  },
  computed: {
    isAvailable: function isAvailable() {
      var _this$selected;

      return !((_this$selected = this.selected) !== null && _this$selected !== void 0 && _this$selected.length);
    },
    fileDialog: function fileDialog() {
      return this.$refs['file-dialog'];
    },
    btnText: function btnText() {
      var _this$selected2;

      return ((_this$selected2 = this.selected) === null || _this$selected2 === void 0 ? void 0 : _this$selected2.length) > 1 ? 'add images' : 'add image';
    }
  }
});
/* script */

var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__$1() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("simple-modal", {
    attrs: {
      title: "add image"
    },
    on: {
      rejected: function rejected($event) {
        return _vm.$emit("rejected", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function fn() {
        return [_c("button", {
          staticClass: "sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
          "class": {
            "sb-disabled": !_vm.selected.length || _vm.disableBtn
          },
          attrs: {
            disabled: !_vm.selected.length || _vm.disableBtn
          },
          on: {
            click: _vm.resolved
          }
        }, [_vm._v(_vm._s(_vm.btnText) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c("main", {
    staticClass: "add-image-modal max-w-xs sm:max-w-xl m-auto"
  }, [_c("div", {
    staticClass: "border border-solid rounded-xl mx-1 sm:mx-3 overflow-hidden"
  }, [_c("div", {
    staticClass: "add-image-container flex flex-row items-center justify-center relative"
  }, [_vm.loading ? _c("loading-icon", {
    staticClass: "text-blue"
  }) : [_vm.selected && _vm.selected.length ? _c("div", {
    staticClass: "content-wrapper w-full h-full"
  }, [_c("div", {
    staticClass: "grid grid-cols-3 h-full"
  }, [_c("div", {
    staticClass: "col-span-2 flex flex-column items-end border-r-1 border-0 border-solid"
  }, [_vm.selected.length ? _c("CarouselActions", {
    staticClass: "w-full",
    attrs: {
      slides: _vm.selected
    },
    on: {
      "remove-slide": _vm.removeSlide
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "col-span-1 flex items-center relative"
  }, [_vm.selected.length ? _c("div", {
    staticClass: "counter absolute top-3 right-3 font-bold"
  }, [_c("div", {
    staticClass: "swiper-pagination static flex items-center"
  })]) : _vm._e(), _vm._v(" "), _c("button", {
    staticClass: "sb-button flex flex-col items-center mx-auto small-size p-0",
    on: {
      click: _vm.clickedUpload
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "image"],
      size: "2x"
    }
  }), _vm._v("\n                  upload\n                ")], 1)])])]) : _vm._e(), _vm._v(" "), _vm.isAvailable ? _c("button", {
    staticClass: "sb-button flex flex-col items-center",
    on: {
      click: _vm.clickedUpload
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "image"],
      size: "2x"
    }
  }), _vm._v("\n            upload\n          ")], 1) : _vm._e()]], 2), _vm._v(" "), _c("section", {
    staticClass: "img-section border-0 border-t border-solid flex flex-row flex-wrap overflow-overlay box-content"
  }, _vm._l(_vm.images, function (image, index) {
    return _c("div", {
      key: index,
      staticClass: "sb-thumbnail box-border bg-cover bg-center cursor-pointer bg-no-repeat relative",
      "class": {
        "border-3 border-solid": _vm.selected && _vm.selected.includes(image)
      },
      style: "background-image: url(" + image + ")",
      on: {
        click: function click($event) {
          return _vm.clickedImage(image, index, $event);
        }
      }
    }, [_vm.selected && _vm.selected.includes(image) ? _c("div", {
      staticClass: "text-lime-700 label-counter text-xs flex items-center justify-center absolute rounded-full leading-normal right-0 top-0"
    }, [_vm._v("\n            " + _vm._s(_vm.selected.indexOf(image) + 1) + "\n          ")]) : _vm._e()]);
  }), 0)]), _vm._v(" "), _c("input", {
    ref: "file-dialog",
    staticClass: "hidden",
    attrs: {
      accept: "image/png,image/gif,image/jpeg",
      multiple: "",
      type: "file",
      "data-cy": "photo-upload-input"
    },
    on: {
      input: _vm.fileChanged
    }
  })])]);
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__$1(inject) {
  if (!inject) return;
  inject("data-v-6b8fec2a_0", {
    source: ".img-section[data-v-6b8fec2a] {\n  max-height: 236px;\n}\n@media screen and (max-width: 640px) {\n.img-section[data-v-6b8fec2a] {\n    max-height: 233px;\n}\n}\n.add-image-container[data-v-6b8fec2a] {\n  height: 400px;\n}\n.sb-thumbnail[data-v-6b8fec2a] {\n  width: 78.5px;\n  height: 78.5px;\n}\n@media screen and (max-width: 640px) {\n.sb-thumbnail[data-v-6b8fec2a] {\n    width: 77.5px;\n    height: 77.5px;\n}\n}\n.sb-thumbnail .label-counter[data-v-6b8fec2a] {\n  width: 20px;\n  height: 20px;\n}\n.sb-button.small-size[data-v-6b8fec2a] {\n  width: 110px;\n}\n.swiper-button-disabled[data-v-6b8fec2a] {\n  display: block !important;\n}\n\n/*# sourceMappingURL=AddImagesModal.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/modals/AddImagesModal.vue", "AddImagesModal.vue"],
      "names": [],
      "mappings": "AA4IA;EACA,iBAAA;AC3IA;AD4IA;AAFA;IAGA,iBAAA;ACzIE;AACF;AD0IA;EACA,aAAA;ACvIA;ADyIA;EACA,aAAA;EACA,cAAA;ACtIA;ADuIA;AAHA;IAIA,aAAA;IACA,cAAA;ACpIE;AACF;ADqIA;EACA,WAAA;EACA,YAAA;ACnIA;ADsIA;EACA,YAAA;ACnIA;ADqIA;EACA,yBAAA;AClIA;;AAEA,6CAA6C",
      "file": "AddImagesModal.vue",
      "sourcesContent": ["<template>\n  <simple-modal title=\"add image\" @rejected=\"$emit('rejected', $event)\">\n    <main class=\"add-image-modal max-w-xs sm:max-w-xl m-auto\">\n      <div class=\"border border-solid rounded-xl mx-1 sm:mx-3 overflow-hidden\">\n        <div class=\"add-image-container flex flex-row items-center justify-center relative\">\n          <loading-icon v-if='loading' class=\"text-blue\"/>\n\n          <template v-else>\n            <div class=\"content-wrapper w-full h-full\"\n                 v-if=\"selected && selected.length\">\n              <div class=\"grid grid-cols-3 h-full\">\n                <div class=\"col-span-2 flex flex-column items-end border-r-1 border-0 border-solid\">\n                  <CarouselActions v-if=\"selected.length\"\n                                   class=\"w-full\"\n                                   @remove-slide=\"removeSlide\"\n                                   :slides=\"selected\"/>\n                </div>\n                <div class=\"col-span-1 flex items-center relative\">\n                  <div class=\"counter absolute top-3 right-3 font-bold\" v-if=\"selected.length\">\n                    <div class=\"swiper-pagination static flex items-center\"></div>\n                  </div>\n                  <button\n                      class=\"sb-button flex flex-col items-center mx-auto small-size p-0\"\n                      @click='clickedUpload'>\n                    <fai :icon=\"['fal', 'image']\" size=\"2x\"/>\n                    upload\n                  </button>\n                </div>\n              </div>\n            </div>\n            <button\n                v-if=\"isAvailable\"\n                class=\"sb-button flex flex-col items-center\"\n                @click='clickedUpload'>\n              <fai :icon=\"['fal', 'image']\" size=\"2x\"/>\n              upload\n            </button>\n          </template>\n        </div>\n        <section\n            class='img-section border-0 border-t border-solid flex flex-row flex-wrap overflow-overlay box-content'>\n          <div v-for='(image, index) in images'\n               :key=\"index\"\n               :style=\"`background-image: url(${image})`\"\n               class=\"sb-thumbnail box-border bg-cover bg-center cursor-pointer bg-no-repeat relative\"\n               :class=\"{ 'border-3 border-solid': selected && selected.includes(image)}\"\n               @click=\"clickedImage(image, index, $event)\">\n            <div\n                class=\"text-lime-700 label-counter text-xs flex items-center justify-center absolute rounded-full leading-normal right-0 top-0\"\n                v-if=\"selected && selected.includes(image)\">\n              {{ selected.indexOf(image) + 1 }}\n            </div>\n          </div>\n        </section>\n      </div>\n\n      <input\n          accept=\"image/png,image/gif,image/jpeg\"\n          class=\"hidden\"\n          ref=\"file-dialog\"\n          multiple\n          type=\"file\"\n          data-cy=\"photo-upload-input\"\n          @input=\"fileChanged\"/>\n    </main>\n    <template #buttons>\n      <button class=\"sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\"\n              :disabled=\"!selected.length || disableBtn\"\n              :class=\"{'sb-disabled': !selected.length || disableBtn}\"\n              @click=\"resolved\">{{ btnText }}\n      </button>\n    </template>\n  </simple-modal>\n</template>\n\n<script lang=\"ts\">\nimport SimpleModal from \"./SimpleModal.vue\"\nimport LoadingIcon from \"./../icons/LoadingIcon.vue\";\nimport CarouselActions from \"../blocks/CarouselActions.vue\";\nimport Vue from \"vue\";\nimport {UserError} from \"@/models\";\n\nexport default Vue.extend({\n  name: \"AddImagesModal\",\n  components: {SimpleModal, LoadingIcon, CarouselActions},\n  props: {\n    selected: Array,\n    images: Array,\n    loading: Boolean,\n    disableBtn: {\n      type: Boolean,\n      required: false,\n      default: false\n    },\n  },\n  methods: {\n    clickedUpload() {\n      this.fileDialog.click();\n    },\n    async clickedImage(image: string) {\n      this.$emit('update:selected', this.selected.includes(image) ? this.selected.filter((img) => img !== image) : this.selected.concat(image));\n      this.$emit('update:loading', false);\n    },\n    resolved() {\n      this.$store.dispatch('DISMISSED_MODAL');\n      this.$emit('resolved');\n    },\n    fileChanged() {\n      if (this.fileDialog.files && this.fileDialog.files.length > 0) {\n        this.$emit('update:loading', true);\n        this.$emit('shouldUpload', this.fileDialog.files)\n        this.fileDialog.value = '';\n      }\n    },\n    removeSlide(index: number) {\n      const image = this.selected[index];\n      this.$emit('update:selected', this.selected.filter((img) => img !== image));\n    },\n    showError(errorText: string, errorCode: string): void {\n      this.$store.dispatch('ADD_ERRORS', [new UserError(new Error(errorCode), errorText)]);\n    },\n    hideError() {\n      this.$store.dispatch('DISMISS_ERRORS', {type: UserError})\n    },\n  },\n  computed: {\n    isAvailable(): boolean {\n      return !this.selected?.length\n    },\n    fileDialog(): HTMLInputElement {\n      return this.$refs['file-dialog'] as HTMLInputElement;\n    },\n    btnText(): string {\n      return this.selected?.length > 1 ? 'add images' : 'add image'\n    }\n  }\n})\n</script>\n\n<style lang=\"sass\" scoped>\n.img-section\n  max-height: 236px\n  @media screen and (max-width: 640px)\n    max-height: 233px\n\n.add-image-container\n  height: 400px\n\n.sb-thumbnail\n  width: 78.5px\n  height: 78.5px\n  @media screen and (max-width: 640px)\n    width: 77.5px\n    height: 77.5px\n\n  .label-counter\n    width: 20px\n    height: 20px\n\n.sb-button\n  &.small-size\n    width: 110px\n\n.swiper-button-disabled\n  display: block !important\n\n</style>", ".img-section {\n  max-height: 236px;\n}\n@media screen and (max-width: 640px) {\n  .img-section {\n    max-height: 233px;\n  }\n}\n\n.add-image-container {\n  height: 400px;\n}\n\n.sb-thumbnail {\n  width: 78.5px;\n  height: 78.5px;\n}\n@media screen and (max-width: 640px) {\n  .sb-thumbnail {\n    width: 77.5px;\n    height: 77.5px;\n  }\n}\n.sb-thumbnail .label-counter {\n  width: 20px;\n  height: 20px;\n}\n\n.sb-button.small-size {\n  width: 110px;\n}\n\n.swiper-button-disabled {\n  display: block !important;\n}\n\n/*# sourceMappingURL=AddImagesModal.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = "data-v-6b8fec2a";
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var script = Vue.extend({
  name: "AddVideoModal",
  components: {
    SimpleModal: __vue_component__$3,
    LoadingIcon: __vue_component__$u,
    CarouselActions: __vue_component__$h
  },
  props: {
    selected: String,
    loading: Boolean
  },
  data: function data() {
    return {
      link: '',
      togglePlayBtn: true
    };
  },
  methods: {
    showError: function showError(errorText, errorCode) {
      this.$store.dispatch('ADD_ERRORS', [new UserError(new Error(errorCode), errorText)]);
    },
    hideError: function hideError() {
      this.$store.dispatch('DISMISS_ERRORS', {
        type: UserError
      });
    },
    validateLinkYT: function validateLinkYT() {
      var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      return this.link.match(p) ? RegExp.$1 : false;
    },
    clickedUpload: function clickedUpload() {
      this.fileDialog.click();
    },
    removeVideo: function removeVideo() {
      this.$emit('update:selected', this.link ? this.link : this.fileDialog.files);
    },
    playVideo: function playVideo() {
      var video = document.getElementById('campaign-video');

      if (video) {
        video.play();
        this.togglePlayBtn = false;
      }
    },
    stopVideo: function stopVideo() {
      var video = document.getElementById('campaign-video');

      if (video) {
        video.pause();
        this.togglePlayBtn = true;
      }
    },
    resolved: function resolved() {
      if (this.link) {
        this.$emit('update:loading', true);
        var link = {
          link: '',
          service: '',
          key: ''
        }; //

        if (this.validateLinkYT()) {
          link = {
            link: this.link,
            service: 'YT',
            key: this.validateLinkYT()
          };
        }

        this.$emit('shouldUploadLink', link);
        this.link = '';
      }

      this.$store.dispatch('DISMISSED_MODAL');
      this.$emit('resolved');
    },
    fileChanged: function fileChanged() {
      if (this.fileDialog.files && this.fileDialog.files.length > 0) {
        this.$emit('update:loading', true);
        this.$emit('shouldUploadVideo', this.fileDialog.files);
        this.fileDialog.value = '';
      }
    }
  },
  computed: {
    fileDialog: function fileDialog() {
      return this.$refs['file-dialog'];
    }
  }
});
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("simple-modal", {
    attrs: {
      title: "add video"
    },
    on: {
      rejected: function rejected($event) {
        return _vm.$emit("rejected", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function fn() {
        return [_c("button", {
          staticClass: "sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12",
          "class": {
            "sb-disabled": !_vm.link && !_vm.selected.length
          },
          attrs: {
            disabled: !_vm.link && !_vm.selected.length
          },
          on: {
            click: _vm.resolved
          }
        }, [_vm._v(" Add video\n    ")])];
      },
      proxy: true
    }])
  }, [_c("main", {
    staticClass: "add-image-modal max-w-xs sm:max-w-xl m-auto"
  }, [_c("div", {
    staticClass: "border h-full border-solid rounded-xl mx-1 sm:mx-6 flex flex-col justify-center"
  }, [!_vm.selected.length ? _c("div", {
    staticClass: "add-image-container flex flex-row items-center justify-center relative px-5"
  }, [_vm.loading ? _c("loading-icon", {
    staticClass: "text-blue"
  }) : [_c("div", {
    staticClass: "flex flex-col justify-center items-center w-full"
  }, [_c("div", {
    staticClass: "block"
  }, [_c("button", {
    staticClass: "sb-button flex flex-col items-center py-1 px-4",
    on: {
      click: _vm.clickedUpload
    }
  }, [_c("fai", {
    attrs: {
      icon: ["fal", "image"],
      size: "2x"
    }
  }), _vm._v("\n                upload\n              ")], 1)]), _vm._v(" "), _c("p", {
    staticClass: "m-0 text-4xl pt-3 pb-4"
  }, [_vm._v("or")]), _vm._v(" "), _c("div", {
    staticClass: "flex flex-col w-full"
  }, [_c("p", {
    staticClass: "m-0"
  }, [_vm._v("enter video URL")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.link,
      expression: "link"
    }],
    staticClass: "border border-solid rounded py-2 px-3 bg-white",
    attrs: {
      type: "text"
    },
    domProps: {
      value: _vm.link
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.link = $event.target.value;
      }, _vm.validateLinkYT]
    }
  })])])]], 2) : _c("div", {
    staticClass: "video w-full relative overflow-hidden rounded-xl flex items-end justify-center pb-2"
  }, [_c("video", {
    staticClass: "absolute top-0 left-0 w-full h-full w-auto h-auto z-0",
    attrs: {
      id: "campaign-video",
      src: _vm.selected
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "absolute play-btn top-1/2 left-1/2",
    on: {
      click: function click($event) {
        _vm.togglePlayBtn ? _vm.playVideo() : _vm.stopVideo();
      }
    }
  }, [_vm.togglePlayBtn ? _c("svg", {
    staticClass: "svg-inline--fa fa-play-circle",
    attrs: {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "far",
      "data-icon": "play-circle",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }
  }, [_c("path", {
    attrs: {
      fill: "currentColor",
      d: "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    }
  })]) : _c("svg", {
    staticClass: "svg-inline--fa fa-pause-circle",
    attrs: {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "far",
      "data-icon": "pause-circle",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }
  }, [_c("path", {
    attrs: {
      fill: "currentColor",
      d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "border border-solid bg-white text-blue rounded py-1 px-4 text-2xl font-normal cursor-pointer relative z-1",
    on: {
      click: _vm.removeVideo
    }
  }, [_vm._v("remove\n        ")])])]), _vm._v(" "), _c("input", {
    ref: "file-dialog",
    staticClass: "hidden",
    attrs: {
      accept: "video/mp4",
      multiple: "",
      type: "file",
      "data-cy": "photo-upload-input"
    },
    on: {
      input: _vm.fileChanged
    }
  })])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-401231d7_0", {
    source: ".video[data-v-401231d7] {\n  height: 400px;\n}\n.video video[data-v-401231d7] {\n  background-size: 100% 100%;\n}\n.video .play-btn[data-v-401231d7] {\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  transition: all 0.5s linear;\n  opacity: 0;\n}\n.video .play-btn[data-v-401231d7]:hover {\n  opacity: 1;\n}\n.fa-play-circle[data-v-401231d7],\n.fa-pause-circle[data-v-401231d7] {\n  width: 100px;\n  height: 100px;\n}\n.fa-play-circle path[data-v-401231d7],\n.fa-pause-circle path[data-v-401231d7] {\n  fill: white;\n}\n\n/*# sourceMappingURL=AddVideoModal.vue.map */",
    map: {
      "version": 3,
      "sources": ["/home/raf/docker_dev/repos/sb-components/src/components/modals/AddVideoModal.vue", "AddVideoModal.vue"],
      "names": [],
      "mappings": "AAuKA;EACA,aAAA;ACtKA;ADwKA;EACA,0BAAA;ACtKA;ADwKA;EACA,gCAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;ACtKA;ADwKA;EACA,UAAA;ACtKA;ADwKA;;EAEA,YAAA;EACA,aAAA;ACrKA;ADuKA;;EAEA,WAAA;ACpKA;;AAEA,4CAA4C",
      "file": "AddVideoModal.vue",
      "sourcesContent": ["<template>\n  <simple-modal title=\"add video\" @rejected=\"$emit('rejected', $event)\">\n    <main class=\"add-image-modal max-w-xs sm:max-w-xl m-auto\">\n      <div class=\"border h-full border-solid rounded-xl mx-1 sm:mx-6 flex flex-col justify-center\">\n        <div v-if=\"!selected.length\"\n             class=\"add-image-container flex flex-row items-center justify-center relative px-5\">\n          <loading-icon v-if='loading' class=\"text-blue\"/>\n          <template v-else>\n            <div class=\"flex flex-col justify-center items-center w-full\">\n              <div class=\"block\">\n                <button class=\"sb-button flex flex-col items-center py-1 px-4\"\n                        @click='clickedUpload'>\n                  <fai :icon=\"['fal', 'image']\" size=\"2x\"/>\n                  upload\n                </button>\n              </div>\n              <p class=\"m-0 text-4xl pt-3 pb-4\">or</p>\n              <div class=\"flex flex-col w-full\">\n                <p class=\"m-0\">enter video URL</p>\n                <input class=\"border border-solid rounded py-2 px-3 bg-white\"\n                       @input=\"validateLinkYT\"\n                       v-model=\"link\"\n                       type=\"text\">\n              </div>\n            </div>\n          </template>\n        </div>\n        <div class=\"video w-full relative overflow-hidden rounded-xl flex items-end justify-center pb-2\" v-else>\n          <video id=\"campaign-video\"\n                 class=\"absolute top-0 left-0 w-full h-full w-auto h-auto z-0\"\n                 :src=\"selected\"/>\n          <div class=\"absolute play-btn top-1/2 left-1/2\"\n               @click=\"togglePlayBtn? playVideo(): stopVideo()\">\n            <svg v-if=\"togglePlayBtn\" aria-hidden=\"true\" focusable=\"false\" data-prefix=\"far\" data-icon=\"play-circle\"\n                 class=\"svg-inline--fa fa-play-circle\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                 viewBox=\"0 0 512 512\">\n              <path fill=\"currentColor\"\n                    d=\"M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z\"></path>\n            </svg>\n            <svg v-else aria-hidden=\"true\" focusable=\"false\" data-prefix=\"far\" data-icon=\"pause-circle\"\n                 class=\"svg-inline--fa fa-pause-circle\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                 viewBox=\"0 0 512 512\">\n              <path fill=\"currentColor\"\n                    d=\"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z\"></path>\n            </svg>\n          </div>\n          <div\n              class=\"border border-solid bg-white text-blue rounded py-1 px-4 text-2xl font-normal cursor-pointer relative z-1\"\n              @click=\"removeVideo\">remove\n          </div>\n        </div>\n      </div>\n      <input\n          accept=\"video/mp4\"\n          class=\"hidden\"\n          ref=\"file-dialog\"\n          multiple\n          type=\"file\"\n          data-cy=\"photo-upload-input\"\n          @input=\"fileChanged\"/>\n    </main>\n    <template #buttons>\n      <button class=\"sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12\"\n              :disabled=\"!link && !selected.length\"\n              :class=\"{'sb-disabled': !link && !selected.length}\"\n              @click=\"resolved\"> Add video\n      </button>\n    </template>\n  </simple-modal>\n</template>\n\n<script lang=\"ts\">\nimport SimpleModal from \"./SimpleModal.vue\"\nimport LoadingIcon from \"./../icons/LoadingIcon.vue\";\nimport CarouselActions from \"../blocks/CarouselActions.vue\";\nimport Vue from \"vue\";\nimport {UserError} from \"@/models\";\n\ninterface ILink {\n  link: String,\n  service: String,\n  key: String | Boolean\n}\n\nexport default Vue.extend({\n  name: \"AddVideoModal\",\n  components: {SimpleModal, LoadingIcon, CarouselActions},\n  props: {\n    selected: String,\n    loading: Boolean\n  },\n  data() {\n    return {\n      link: '',\n      togglePlayBtn: true\n    }\n  },\n  methods: {\n    showError(errorText: string, errorCode: string): void {\n      this.$store.dispatch('ADD_ERRORS', [new UserError(new Error(errorCode), errorText)]);\n    },\n    hideError() {\n      this.$store.dispatch('DISMISS_ERRORS', {type: UserError})\n    },\n    validateLinkYT(): boolean | string {\n      const p = /^(?:https?:\\/\\/)?(?:m\\.|www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:embed\\/|v\\/|watch\\?v=|watch\\?.+&v=))((\\w|-){11})(?:\\S+)?$/;\n      return (this.link.match(p)) ? RegExp.$1 : false;\n    },\n    clickedUpload() {\n      this.fileDialog.click();\n    },\n    removeVideo() {\n      this.$emit('update:selected', this.link ? this.link : this.fileDialog.files);\n    },\n    playVideo() {\n      const video = document.getElementById('campaign-video') as HTMLVideoElement\n      if (video) {\n        video.play()\n        this.togglePlayBtn = false\n      }\n    },\n    stopVideo() {\n      const video = document.getElementById('campaign-video') as HTMLVideoElement\n      if (video) {\n        video.pause()\n        this.togglePlayBtn = true\n      }\n    },\n    resolved() {\n      if (this.link) {\n        this.$emit('update:loading', true);\n        let link: ILink = {\n          link: '',\n          service: '',\n          key: ''\n        }\n        //\n        if (this.validateLinkYT()) {\n          link = {\n            link: this.link,\n            service: 'YT',\n            key: this.validateLinkYT()\n          }\n        }\n        this.$emit('shouldUploadLink', link)\n        this.link = ''\n      }\n      this.$store.dispatch('DISMISSED_MODAL');\n      this.$emit('resolved');\n    },\n    fileChanged() {\n      if (this.fileDialog.files && this.fileDialog.files.length > 0) {\n        this.$emit('update:loading', true);\n        this.$emit('shouldUploadVideo', this.fileDialog.files)\n        this.fileDialog.value = '';\n      }\n    }\n  },\n  computed: {\n    fileDialog(): HTMLInputElement {\n      return this.$refs['file-dialog'] as HTMLInputElement;\n    }\n  }\n})\n</script>\n\n<style lang=\"sass\" scoped>\n.video\n  height: 400px\n\n  video\n    background-size: 100% 100%\n\n  .play-btn\n    transform: translate(-50%, -50%)\n    cursor: pointer\n    transition: all .5s linear\n    opacity: 0\n\n    &:hover\n      opacity: 1\n\n.fa-play-circle,\n.fa-pause-circle\n  width: 100px\n  height: 100px\n\n.fa-play-circle path,\n.fa-pause-circle path\n  fill: white\n</style>", ".video {\n  height: 400px;\n}\n.video video {\n  background-size: 100% 100%;\n}\n.video .play-btn {\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  transition: all 0.5s linear;\n  opacity: 0;\n}\n.video .play-btn:hover {\n  opacity: 1;\n}\n\n.fa-play-circle,\n.fa-pause-circle {\n  width: 100px;\n  height: 100px;\n}\n\n.fa-play-circle path,\n.fa-pause-circle path {\n  fill: white;\n}\n\n/*# sourceMappingURL=AddVideoModal.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-401231d7";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var store = {
  namespaced: false,
  state: {
    route: null,
    errors: [],
    touched: {},
    validators: {},
    validationResults: {},
    values: {},
    modal: null
  },
  actions: {
    UPDATE_ROUTE: function UPDATE_ROUTE(_ref24, to) {
      var commit = _ref24.commit,
          dispatch = _ref24.dispatch;
      dispatch('DISMISS_ERRORS');
      commit('SET_ROUTE', to);
      commit('RESET_VALIDATION_CONFIGURATION');
    },
    DISMISS_ERRORS: function DISMISS_ERRORS(_ref25) {
      var state = _ref25.state;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      state.errors.filter(function (error) {
        return !error.dismissed;
      }).forEach(function (error) {
        error.dismissed = (!options.modal || options.modal === error.modal) && (!options.type || error instanceof options.type) && (!options.path || error.route.path === options.path) && (!options.field || error instanceof ValidationError && error.field === options.field);
      });
    },
    ADD_ERRORS: function ADD_ERRORS(_ref26, errors) {
      var commit = _ref26.commit,
          rootGetters = _ref26.rootGetters;
      var modal = rootGetters.modal;
      var route = rootGetters.route;
      errors.forEach(function (error) {
        error.modal = modal;
        error.route = route;
      });
      commit('ADD_ERRORS', errors);
    },
    CONFIGURE_VALIDATION: function CONFIGURE_VALIDATION(_ref27, options) {
      var commit = _ref27.commit;
      commit('SET_VALIDATORS', options.validators);
      commit('SET_FIELD_VALUES', options.values);
    },
    VALIDATE_ALL_FIELDS: function VALIDATE_ALL_FIELDS(_ref28) {
      var state = _ref28.state,
          dispatch = _ref28.dispatch;
      dispatch('VALIDATE', Object.keys(state.validators));
    },
    VALIDATE: function VALIDATE(_ref29, fields) {
      var state = _ref29.state,
          commit = _ref29.commit,
          dispatch = _ref29.dispatch,
          getters = _ref29.getters;
      var validationErrors = [];
      var validationResults = {};
      var fieldsToRemove = new Set();
      var fieldSet = new Set(fields);
      fields.forEach(function (field) {
        var validator = state.validators[field];

        if (validator !== null && validator !== void 0 && validator.include && (validator === null || validator === void 0 ? void 0 : validator.include.length) > 0) {
          validator === null || validator === void 0 ? void 0 : validator.include.forEach(function (field) {
            return fieldSet.add(field);
          });
        }
      });
      var allFields = Array.from(fieldSet);
      allFields.forEach(function (field) {
        dispatch('DISMISS_ERRORS', {
          type: ValidationError,
          field: field
        });
        var validator = state.validators[field];

        if (!validator) {
          return;
        }

        if (validator.enabled && validator.enabled(state.values, getters) === false) {
          fieldsToRemove.add(field);
        } else {
          var value = state.values[field];
          var assertions = [];
          var firstInvalid;
          validator.assertions.find(function (assert) {
            var result;

            if (_typeof(assert) === 'object' && typeof assert.enabled === 'function') {
              if (assert.enabled(state.values, getters) === false) {
                return false;
              } else {
                result = assert.test(value, state.values, getters);
              }
            } else {
              result = assert(value, state.values, getters);
            }

            assertions.push(result);

            if (!result.valid) {
              firstInvalid = result;
            }

            return result.valid === false;
          });

          if (firstInvalid) {
            validationErrors.push(new ValidationError(firstInvalid.error, value, field));
          }

          validationResults[field] = {
            field: field,
            value: value,
            assertions: assertions,
            valid: !firstInvalid
          };
        }
      });

      if (Object.keys(validationResults).length > 0) {
        commit('ADD_VALIDATION_RESULTS', validationResults);
      }

      if (fieldsToRemove.size > 0) {
        commit('REMOVE_VALIDATION_RESULTS', Array.from(fieldsToRemove));
      }

      if (validationErrors.length > 0) {
        dispatch('ADD_ERRORS', validationErrors);
      }
    },
    TOUCH_ALL_FIELDS: function TOUCH_ALL_FIELDS(_ref30) {
      var state = _ref30.state,
          dispatch = _ref30.dispatch;
      dispatch('TOUCH_FIELDS', Object.keys(state.validators));
    },
    TOUCH_FIELDS: function TOUCH_FIELDS(_ref31, fields) {
      var commit = _ref31.commit,
          state = _ref31.state;
      var untouched = fields.filter(function (field) {
        return !state.touched[field];
      });

      if (untouched.length > 0) {
        commit('TOUCHED_FIELDS', untouched);
      }
    },
    UPDATE_VALUES: function UPDATE_VALUES(_ref32, values) {
      var commit = _ref32.commit;
      commit('SET_FIELD_VALUES', values);
    },
    SHOWING_MODAL: function SHOWING_MODAL(_ref33, modal) {
      var commit = _ref33.commit;
      commit('SET_MODAL', modal);
    },
    DISMISSED_MODAL: function DISMISSED_MODAL(_ref34) {
      var state = _ref34.state,
          dispatch = _ref34.dispatch,
          commit = _ref34.commit;
      dispatch('DISMISS_ERRORS', {
        modal: state.modal
      });
      commit('SET_MODAL', null);
    }
  },
  mutations: {
    ADD_ERRORS: function ADD_ERRORS(state, errors) {
      state.errors = state.errors.concat(errors);
    },
    SET_ROUTE: function SET_ROUTE(state, to) {
      state.route = to;
    },
    SET_MODAL: function SET_MODAL(state, modal) {
      state.modal = modal;
    },
    ADD_VALIDATION_RESULTS: function ADD_VALIDATION_RESULTS(state, validationResults) {
      Object.entries(validationResults).forEach(function (_ref35) {
        var _ref36 = _slicedToArray(_ref35, 2),
            field = _ref36[0],
            result = _ref36[1];

        return Vue.set(state.validationResults, field, result);
      });
    },
    REMOVE_VALIDATION_RESULTS: function REMOVE_VALIDATION_RESULTS(state, fields) {
      var results = state.validationResults;
      fields.forEach(function (field) {
        return delete results[field];
      });
      state.validationResults = results;
    },
    RESET_VALIDATION_CONFIGURATION: function RESET_VALIDATION_CONFIGURATION(state) {
      state.validators = {};
      state.validationResults = {};
      state.values = {};
    },
    SET_VALIDATORS: function SET_VALIDATORS(state, validators) {
      state.validators = validators;
    },
    SET_FIELD_VALUES: function SET_FIELD_VALUES(state, values) {
      Object.entries(values).forEach(function (_ref37) {
        var _ref38 = _slicedToArray(_ref37, 2),
            field = _ref38[0],
            value = _ref38[1];

        return Vue.set(state.values, field, value);
      });
    },
    TOUCHED_FIELDS: function TOUCHED_FIELDS(state, fields) {
      fields.forEach(function (field) {
        return Vue.set(state.touched, field, new Date());
      });
    }
  },
  getters: {
    route: function route(state) {
      return state.route;
    },
    touched: function touched(state) {
      return function (field) {
        return !!state.touched[field];
      };
    },
    anyHasError: function anyHasError(state) {
      return function (fields) {
        return fields.some(function (field) {
          return state.validationResults[field].valid === false;
        });
      };
    },
    hasError: function hasError(state) {
      return function (field) {
        return state.validationResults[field].valid === false;
      };
    },
    touchedAndErrored: function touchedAndErrored(state) {
      return function (field) {
        return state.touched[field] && state.validationResults[field] && state.validationResults[field].valid === false;
      };
    },
    hasSomeError: function hasSomeError(state) {
      return Object.values(state.validationResults).some(function (result) {
        return result.valid === false;
      });
    },
    displayableErrors: function displayableErrors(state, _getters, _rootState, rootGetters) {
      var route = rootGetters.route;
      return state.errors.filter(function (error) {
        return !error.dismissed && error.route.hash === route.hash && error.modal === null && (!(error instanceof ValidationError) || state.touched[error.field]);
      });
    },
    displayableModalErrors: function displayableModalErrors(state, _getters, _rootState, rootGetters) {
      var route = rootGetters.route;
      var modal = rootGetters.modal;
      return state.errors.filter(function (error) {
        return !error.dismissed && error.route.hash === route.hash && error.modal === modal && (!(error instanceof ValidationError) || state.touched[error.field]);
      });
    },
    modal: function modal(state) {
      return state.modal;
    }
  }
};

var beforeEach = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(to, _from, next) {
    var store;
    return regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            store = instance.resolve(tokens.store);
            store.dispatch('UPDATE_ROUTE', to);
            next();

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7);
  }));

  return function beforeEach(_x4, _x5, _x6) {
    return _ref39.apply(this, arguments);
  };
}();
/**
 * Modifies certain methods on the axios instance to implicitly handle errors
 * @param axios Axios instance
 * @returns {ExtendedAxiosInstance} Should behave exactly the same as regular instance with some added config options
 */


function extendAxios(axios) {
  var requestSenders = ['get', 'delete', 'head', 'options'];
  var dataSenders = ['post', 'put', 'patch'];

  var mutateConfig = function mutateConfig(config) {
    if (config && config.passthrough) {
      if (config.passthrough.codes) {
        var validateStatus = config.validateStatus ? config.validateStatus : function (code) {
          return code === 200;
        };

        config.validateStatus = function (status) {
          return validateStatus(status) || config.passthrough.codes.includes(status);
        };
      }
    }

    return config;
  };

  var catchError = function catchError(error) {
    var store = instance.resolve(tokens.store);
    store.dispatch('ADD_ERRORS', [new UnexpectedError(error)]);

    if (instance.isRegistered(tokens.rollbar)) {
      var rollbar = instance.resolve(tokens.rollbar);
      rollbar.error(error);
    }

    throw error; //We don't want to go down the `then` workflow
  };

  requestSenders.forEach(function (key) {
    var anyAxios = axios;
    var func = anyAxios[key];

    anyAxios[key] = function (url, config) {
      var mutatedConfig = mutateConfig(config);
      return func(url, mutatedConfig)["catch"](catchError);
    };
  });
  dataSenders.forEach(function (key) {
    var anyAxios = axios;
    var func = anyAxios[key];

    anyAxios[key] = function (url, data, config) {
      var mutatedConfig = mutateConfig(config);
      return func(url, data, mutatedConfig)["catch"](catchError);
    };
  });
  return axios;
}

var moneyFormatter = function moneyFormatter(value) {
  if (isNaN(Number(value))) return String(value);
  return Number(value) < 0 ? "-$".concat(String(value).slice(1)) : "$".concat(value);
};

var pluralizedSuffixFormatter = function pluralizedSuffixFormatter(value, singular) {
  var plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "".concat(singular, "s");
  return "".concat(value, " ").concat(Math.abs(Number(value)) <= 1 ? singular : plural);
};

var install = function installSpringbigComponents(_) {}; // Create module definition for Vue.use()


export default install;
export { __vue_component__$2 as AddImageModal, __vue_component__$1 as AddImagesModal, __vue_component__ as AddVideoModal, AppError, BackRow, __vue_component__$b as BarChart, __vue_component__$o as Carousel, __vue_component__$h as CarouselActions, __vue_component__$l as CarouselCampaign, __vue_component__$C as Checkbox, ClickOutside, __vue_component__$7 as ClosableWrapper, __vue_component__$g as CollapsibleFixedFooter, __vue_component__$f as CollapsibleSection, __vue_component__$5 as Counter, __vue_component__$a as CustomGridTable, __vue_component__$c as CustomImage, __vue_component__$y as DateRange, DateRangeRow, __vue_component__$q as Dropdown, __vue_component__$j as DropdownWithPreview, __vue_component__$k as ErrorBanner, __vue_component__$8 as FlowChart, __vue_component__$i as FullscreenView, HasError, __vue_component__$4 as InputField, LineBreakRow, __vue_component__$u as LoadingIcon, LoadingRow, MultiSelectRow, __vue_component__$s as Pagination, PaginationRow, ParentRow, __vue_component__$e as ProgressBar, QueryRow, __vue_component__$n as SbCustomTable, __vue_component__$p as SelectDropdown, SelectRow, __vue_component__$3 as SimpleModal, __vue_component__$d as SwipePagination, __vue_component__$6 as TabBar, TextRow, Touch, UnexpectedError, UserError, ValidationError, __vue_component__$m as VideoPlayer, beforeEach, instance as container, extendAxios, moneyFormatter, pluralizedSuffixFormatter, store, tokens };